
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire49d7"];
var parcelRegister = parcelRequire.register;
parcelRegister("8nMC7", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "ProjectPages", () => $f3ca8b7d33e1894e$export$3f8982b128d5aa35);
$parcel$export(module.exports, "default", () => $f3ca8b7d33e1894e$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
parcelRequire("3avtZ");

var $3mYHL = parcelRequire("3mYHL");

var $dxCvy = parcelRequire("dxCvy");

var $9NiTW = parcelRequire("9NiTW");

var $9OXo1 = parcelRequire("9OXo1");

var $l8ruj = parcelRequire("l8ruj");

var $2YP9W = parcelRequire("2YP9W");
var $1bQGJ = parcelRequire("1bQGJ");

var $gCJZc = parcelRequire("gCJZc");
const $f3ca8b7d33e1894e$export$3f8982b128d5aa35 = ()=>{
    const projectContext = (0, $2YP9W.useResource)((0, $dxCvy.projectContextResource));
    const tenantContext = (0, $9OXo1.useTenantContext)();
    if ((0, $3mYHL.isProjectArchivedCondition)(projectContext.data)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3mYHL.RedirectToArchivedPage), null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l8ruj.default), {
        name: "project-pages"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9NiTW.AuthenticationCheck), null, projectContext && // @ts-expect-error - TS2322 - Type 'UseResourceHookResponse<ProjectContext | null>' is not assignable to type 'ProjectContextData'.
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gCJZc.default), {
        projectContext: projectContext,
        tenantContext: tenantContext
    })));
};
var // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
$f3ca8b7d33e1894e$export$2e2bcd8739ae039 = (0, $1bQGJ.withRouter)($f3ca8b7d33e1894e$export$3f8982b128d5aa35);

});
parcelRegister("3mYHL", function(module, exports) {

$parcel$export(module.exports, "isProjectArchivedCondition", () => $90d8776d2c89f4bd$export$34040938aec58f90);
$parcel$export(module.exports, "RedirectToArchivedPage", () => $90d8776d2c89f4bd$export$36db2ddf32573bd8);
$parcel$export(module.exports, "default", () => $90d8776d2c89f4bd$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $dAfqg = parcelRequire("dAfqg");

var $7tQej = parcelRequire("7tQej");

const $90d8776d2c89f4bd$export$34040938aec58f90 = (projectContextData)=>projectContextData && projectContextData.isProjectArchived || false;
const $90d8776d2c89f4bd$var$RedirectIfProjectArchived = ({ projectKey: projectKey })=>{
    if (projectKey === null) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dAfqg.ProjectContextProvider), null, (projectContext)=>$90d8776d2c89f4bd$export$34040938aec58f90(projectContext.data) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7tQej.Redirect), {
            to: (0, $a9bebd574fd66055$export$9a6ccb84170b615b)
        }) : null);
};
const $90d8776d2c89f4bd$export$36db2ddf32573bd8 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7tQej.Redirect), {
        to: (0, $a9bebd574fd66055$export$9a6ccb84170b615b)
    });
var $90d8776d2c89f4bd$export$2e2bcd8739ae039 = $90d8776d2c89f4bd$var$RedirectIfProjectArchived;

});
const $a9bebd574fd66055$export$9a6ccb84170b615b = '/jira/errors/project-archived';


parcelRegister("gCJZc", function(module, exports) {

$parcel$export(module.exports, "default", () => $a143127c7836a0f1$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $9sGI6 = parcelRequire("9sGI6");

var $i27er = parcelRequire("i27er");

var $9dbF6 = parcelRequire("9dbF6");

var $eekRi = parcelRequire("eekRi");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $a143127c7836a0f1$var$Updater = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9dbF6.SubProductUpdater), {
        subProduct: "software"
    });
var $a143127c7836a0f1$export$2e2bcd8739ae039 = (0, $9sGI6.default)((0, $eekRi.default), {
    ProjectPagesApp: $i27er.default,
    Updater: $a143127c7836a0f1$var$Updater
});

});
parcelRegister("i27er", function(module, exports) {

$parcel$export(module.exports, "default", () => $8b6f05020667cb27$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $jD5no = parcelRequire("jD5no");

var $lf2Au = parcelRequire("lf2Au");

var $anRbo = parcelRequire("anRbo");
function $8b6f05020667cb27$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jD5no.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lf2Au.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $anRbo.default), props)));
}

});
parcelRegister("anRbo", function(module, exports) {

$parcel$export(module.exports, "default", () => $269fa58bed268b0d$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $edMU5 = parcelRequire("edMU5");

var $9dZ1c = parcelRequire("9dZ1c");

var $jKL06 = parcelRequire("jKL06");

var $gEFwt = parcelRequire("gEFwt");

var $4Pf62 = parcelRequire("4Pf62");

var $7iJwP = parcelRequire("7iJwP");

var $id7K0 = parcelRequire("id7K0");

var $koVbs = parcelRequire("koVbs");

var $3HwlS = parcelRequire("3HwlS");

var $hqBSi = parcelRequire("hqBSi");

var $7tQej = parcelRequire("7tQej");


var $eGqyh = parcelRequire("eGqyh");

var $jOXuX = parcelRequire("jOXuX");

var $3t5QD = parcelRequire("3t5QD");

var $4R6GH = parcelRequire("4R6GH");

var $1LKmH = parcelRequire("1LKmH");

var $8JoAa = parcelRequire("8JoAa");

var $7WLlg = parcelRequire("7WLlg");

var $3EsqC = parcelRequire("3EsqC");

var $hzuuI = parcelRequire("hzuuI");
const $269fa58bed268b0d$var$getFeatureFlagValue = ()=>({
    });
const $269fa58bed268b0d$var$onFireExposureEvent = ()=>({});
const $269fa58bed268b0d$var$PagesNudgeWrapper = ({ children: children })=>{
    const { ref: ref } = (0, $9dZ1c.useRegisterNudgeTarget)((0, $6784cbc7d62e5d7c$export$f93b83d735f01fa3));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        ref: ref
    }, children), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eGqyh.PagesCreatePageNudge), null));
};
const $269fa58bed268b0d$var$ProjectPagesApp = (props)=>{
    const licensedProducts = (0, $hqBSi.useLicensedProducts)();
    const hasConfluence = !!licensedProducts[(0, $4Pf62.LICENSED_PRODUCTS).CONFLUENCE];
    const hasActivatedConfluenceWithinSevenDays = (0, $1LKmH.useHasConfluenceActivatedWithinDays)(7);
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const featureState = (0, $8JoAa.usePagesFeatureState)(props.projectId);
    const documentTitleText = props.projectName ? `${formatMessage((0, $3EsqC.default).pageTitlePages)} - ${props.projectName}` : formatMessage((0, $3EsqC.default).pageTitlePages);
    const isJWMProduct = props.parentProduct && props.parentProduct === 'JWM';
    /*
         Adding not a JWM product check is a hacky solution for now to solve
         https://jira.atlassian.com/browse/JWMCLOUD-319.
          Long term solution would be to investigate further if we need to add check project-pages-link-enabled property for JWM as well,
         if no then we need to pull out the redirection check from src/packages/confluence/project-pages package to src/packages/spa-apps/project/pages
         so that the change is only limited to JSW and not flowing to other consumers of project pages (like JWM)
     */ if (featureState === (0, $7WLlg.pagesFeatureStates).DISABLED && !isJWMProduct) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7tQej.Redirect), {
        to: `/projects/${props.projectKey}`
    });
    const { PerformanceTracking: PerformanceTracking } = props;
    const getProjectPagesComponent = ()=>{
        const projectPagesComponent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $edMU5.default), {
            ...props,
            // @ts-expect-error - TS2322 - Type 'ReactNode' is not assignable to type 'ReactElement<any, string | JSXElementConstructor<any>>'.
            breadcrumbs: !(0, $3HwlS.getWillShowNav4)() && props.breadcrumbs,
            EmbeddedProductUpdater: (0, $jKL06.default),
            onGetFeatureFlagValue: $269fa58bed268b0d$var$getFeatureFlagValue,
            onFireExposureEvent: $269fa58bed268b0d$var$onFireExposureEvent,
            onFireErrorEvent: (0, $hzuuI.onFireErrorEvent),
            hasConfluence: hasConfluence,
            hasActivatedConfluenceWithinSevenDays: hasActivatedConfluenceWithinSevenDays,
            renderFullHeader: !(0, $3HwlS.getWillShowNav4)(),
            isProjectPagesSporkRebrandingEnabled: true
        });
        return projectPagesComponent;
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7iJwP.default), {
        id: "projectPages",
        packageName: "jiraProjectPages",
        attributes: {
            hasConfluence: hasConfluence
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3t5QD.ConditionalNudgeWrapper), {
        conditionsToApplyWrapper: !(0, $4R6GH.fg)('jira_kuro_8404_remove_pages_nudge') && ((0, $jOXuX.isTailoredOnboardingEnabled)() || (0, $4R6GH.fg)('tailored_onboarding_m2p5_gate')),
        Wrapper: $269fa58bed268b0d$var$PagesNudgeWrapper
    }, (0, $3HwlS.getWillShowNav4)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $id7K0.DocumentTitle), {
        title: documentTitleText
    }), getProjectPagesComponent(), PerformanceTracking ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(PerformanceTracking, {
        loading: featureState === (0, $7WLlg.pagesFeatureStates).LOADING
    }) : null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $id7K0.DocumentTitle), {
        title: documentTitleText
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gEFwt.default), {
        baseUrl: props.baseUrl,
        projectKey: props.projectKey,
        projectName: props.projectName
    }, getProjectPagesComponent(), PerformanceTracking ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(PerformanceTracking, {
        loading: featureState === (0, $7WLlg.pagesFeatureStates).LOADING
    }) : null))));
};
var $269fa58bed268b0d$export$2e2bcd8739ae039 = $269fa58bed268b0d$var$ProjectPagesApp;

});
parcelRegister("edMU5", function(module, exports) {

$parcel$export(module.exports, "default", () => $7dd36ad7d02112c6$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $7Z8iG = parcelRequire("7Z8iG");

var $i5FdW = parcelRequire("i5FdW");

var $bKCvK = parcelRequire("bKCvK");

var $VSDnB = parcelRequire("VSDnB");
parcelRequire("l1d2F");
var $bHpB9 = parcelRequire("bHpB9");

var $2gQ83 = parcelRequire("2gQ83");

var $1DbOn = parcelRequire("1DbOn");

var $32rOA = parcelRequire("32rOA");

var $yKIn9 = parcelRequire("yKIn9");

var $6uXfu = parcelRequire("6uXfu");

var $aIyBL = parcelRequire("aIyBL");

var $bDvnP = parcelRequire("bDvnP");

var $hp80v = parcelRequire("hp80v");

var $1zXyj = parcelRequire("1zXyj");

var $dam7O = parcelRequire("dam7O");

var $gz5Zh = parcelRequire("gz5Zh");

var $2Vlv3 = parcelRequire("2Vlv3");

var $8rAPH = parcelRequire("8rAPH");

var $lHMfu = parcelRequire("lHMfu");

var $fTJXm = parcelRequire("fTJXm");


var $escMm = parcelRequire("escMm");

var $jkADf = parcelRequire("jkADf");


var $bKcHQ = parcelRequire("bKcHQ");
const $7dd36ad7d02112c6$var$i18n = $1DbOn;
const $7dd36ad7d02112c6$var$getCodesFromLocale = (locale)=>{
    const match = /([a-z]*)[_-]?([A-Z]*)/i.exec(locale || '');
    if (!match) throw Error('Unable to get language and country from invalid Locale');
    const [, language, country] = match;
    return {
        language: language.toLowerCase(),
        country: country.toUpperCase()
    };
};
class $7dd36ad7d02112c6$var$ProjectPagesComponent extends (0, $5uXOq.Component) {
    static{
        this.defaultProps = {
            baseUrl: (0, $bDvnP.initialContextState).baseUrl,
            locale: (0, $bDvnP.initialContextState).locale,
            isAdmin: (0, $bDvnP.initialContextState).isAdmin,
            cloudId: (0, $bDvnP.initialContextState).cloudId,
            accountId: (0, $bDvnP.initialContextState).accountId,
            parentProduct: (0, $d29b7f051950917c$export$ae07618062047a87),
            projectKey: (0, $aIyBL.initialProjectState).key,
            projectId: (0, $aIyBL.initialProjectState).id,
            projectType: (0, $aIyBL.initialProjectState).type,
            projectName: (0, $aIyBL.initialProjectState).name,
            environment: 'dev',
            hasConfluence: false,
            hasActivatedConfluenceWithinSevenDays: false
        };
    }
    constructor(props){
        super(props);
        const { baseUrl: baseUrl, locale: locale, isAdmin: isAdmin, isSiteAdmin: isSiteAdmin, cloudId: cloudId, accountId: accountId, projectKey: projectKey, projectId: projectId, projectType: projectType, projectName: projectName, environment: environment, onGetFeatureFlagValue: onGetFeatureFlagValue, onFireExposureEvent: onFireExposureEvent, onFireErrorEvent: onFireErrorEvent, isProjectPagesSporkRebrandingEnabled: isProjectPagesSporkRebrandingEnabled, parentProduct: parentProduct } = props;
        const origin = new (0, $2gQ83.default)({
            product: 'jira'
        });
        this.store = (0, $hp80v.createStore)();
        this.store.dispatch((0, $dam7O.set)({
            baseUrl: baseUrl,
            locale: locale,
            isAdmin: isAdmin,
            isSiteAdmin: isSiteAdmin,
            cloudId: cloudId,
            accountId: accountId,
            confluenceState: (0, $fTJXm.CONFLUENCE_LOADING),
            suggestedKey: (0, $bDvnP.initialContextState).suggestedKey,
            origin: // origin: origin as OriginTracing,
            origin,
            environment: environment || 'dev',
            licenseInformation: undefined,
            projectId: projectId,
            projectType: projectType,
            parentProduct: parentProduct || (0, $d29b7f051950917c$export$ae07618062047a87)
        }));
        this.store.dispatch((0, $1zXyj.set)({
            onGetFeatureFlagValue: onGetFeatureFlagValue,
            onFireExposureEvent: onFireExposureEvent,
            onFireErrorEvent: onFireErrorEvent,
            crossFlow: props.crossFlow
        }));
        this.store.dispatch((0, $2Vlv3.set)({
            key: projectKey,
            id: projectId,
            type: projectType,
            name: projectName
        }));
        this.store.dispatch((0, $gz5Zh.set)({
            isProjectPagesSporkRebrandingEnabled: isProjectPagesSporkRebrandingEnabled || false
        }));
        (0, $yKIn9.initAnalyticsClient)({
            client: {
                environment: environment,
                locale: locale,
                cloudId: cloudId,
                accountId: accountId
            },
            context: {
                containerType: 'project',
                containerId: projectId,
                parent: 'projectPages'
            }
        });
    }
    render() {
        const { accountId: accountId, locale: locale, cloudId: cloudId, breadcrumbs: breadcrumbs, EmbeddedProductUpdater: EmbeddedProductUpdater, projectKey: projectKey, projectName: projectName, projectId: projectId, projectType: projectType, parentProduct: parentProduct, hasConfluence: hasConfluence, hasActivatedConfluenceWithinSevenDays: hasActivatedConfluenceWithinSevenDays, renderFullHeader: renderFullHeader, onFireExposureEvent: onFireExposureEvent, onFireErrorEvent: onFireErrorEvent, theme: theme, isAdmin: isAdmin, environment: environment } = this.props;
        const { language: language, country: country } = $7dd36ad7d02112c6$var$getCodesFromLocale(locale);
        const messages = $7dd36ad7d02112c6$var$i18n[`${language}_${country}`] || $7dd36ad7d02112c6$var$i18n[language];
        const defaultParentProduct = parentProduct ?? (0, $d29b7f051950917c$export$ae07618062047a87);
        (0, $32rOA.default)();
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7Z8iG.Provider), {
            store: this.store,
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $i5FdW.default), {
                locale: language,
                messages: messages,
                defaultLocale: "en",
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $8rAPH.ProjectPagesProvider), {
                    value: {
                        accountId: accountId,
                        cloudId: cloudId,
                        locale: locale,
                        parentProduct: defaultParentProduct,
                        projectKey: projectKey,
                        projectName: projectName,
                        projectId: projectId,
                        projectType: projectType,
                        isAdmin: isAdmin,
                        environment: environment
                    },
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $lHMfu.FeatureFlagsProvider), {
                        value: {
                            fireFeatureExposed: onFireExposureEvent
                        },
                        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bKCvK.FlagsProvider), {
                            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $escMm.ThemeContext).Provider, {
                                value: theme || (0, $escMm.whiteTheme),
                                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $6uXfu.default), {
                                    breadcrumbs: breadcrumbs,
                                    locale: locale,
                                    EmbeddedProductUpdater: EmbeddedProductUpdater,
                                    hasConfluence: hasConfluence,
                                    hasActivatedConfluenceWithinSevenDays: hasActivatedConfluenceWithinSevenDays,
                                    renderFullHeader: renderFullHeader,
                                    onFireExposureEvent: onFireExposureEvent,
                                    onFireErrorEvent: onFireErrorEvent
                                })
                            })
                        })
                    })
                })
            })
        });
    }
}
const $7dd36ad7d02112c6$var$ProjectPagesWithCrossFlow = (0, $bHpB9.withCrossFlow)($7dd36ad7d02112c6$var$ProjectPagesComponent);
var $7dd36ad7d02112c6$export$2e2bcd8739ae039 = (props)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $jkADf.ContextWrapper), {
            sourceType: (0, $6e65040b988c460f$export$f636b5b56f1d624a),
            sourceName: "projectPages",
            containerType: "project",
            containerId: props.projectId ? `${props.projectId}` : undefined,
            attributes: {
                hasConfluence: props.hasConfluence,
                hasActivatedConfluenceWithinSevenDays: props.hasActivatedConfluenceWithinSevenDays,
                projectId: props.projectId,
                sourceComponent: (0, $9d339e91f7cbd39e$export$400f359cf7604d7a),
                sourceContext: (0, $9d339e91f7cbd39e$export$e776c72d9769c47a),
                isGoogleDriveInProjectPagesEnabled: (0, $VSDnB.fg)('platform.google-drive-in-project-pages') || false,
                featureFlags: {
                    ...(0, $bKcHQ.getAllBooleanFeatureFlags)()
                }
            },
            children: /*#__PURE__*/ (0, $2OMIu.jsx)($7dd36ad7d02112c6$var$ProjectPagesWithCrossFlow, {
                ...props
            })
        })
    });

});
parcelRegister("l1d2F", function(module, exports) {

$parcel$export(module.exports, "useCrossFlow", () => (parcelRequire("bHpB9")).useCrossFlow);
$parcel$export(module.exports, "withCrossFlow", () => (parcelRequire("bHpB9")).withCrossFlow);
$parcel$export(module.exports, "Journeys", () => (parcelRequire("bHpB9")).Journeys);
$parcel$export(module.exports, "Reasons", () => (parcelRequire("bHpB9")).Reasons);
$parcel$export(module.exports, "Targets", () => (parcelRequire("jWY5k")).Targets);

var $bHpB9 = parcelRequire("bHpB9");

var $jWY5k = parcelRequire("jWY5k");

});

parcelRegister("1DbOn", function(module, exports) {

$parcel$export(module.exports, "zh", () => (parcelRequire("7wcSu")).default);
$parcel$export(module.exports, "zh_TW", () => (parcelRequire("7XP8O")).default);
$parcel$export(module.exports, "cs", () => (parcelRequire("2CsJu")).default);
$parcel$export(module.exports, "da", () => (parcelRequire("9SWh0")).default);
$parcel$export(module.exports, "nl", () => (parcelRequire("tnTW0")).default);
$parcel$export(module.exports, "et", () => (parcelRequire("kQZO7")).default);
$parcel$export(module.exports, "fi", () => (parcelRequire("kyyPr")).default);
$parcel$export(module.exports, "fr", () => (parcelRequire("ZLUIF")).default);
$parcel$export(module.exports, "de", () => (parcelRequire("36c4y")).default);
$parcel$export(module.exports, "hu", () => (parcelRequire("cP8k0")).default);
$parcel$export(module.exports, "it", () => (parcelRequire("4DQb0")).default);
$parcel$export(module.exports, "ja", () => (parcelRequire("2vw0t")).default);
$parcel$export(module.exports, "ko", () => (parcelRequire("58E51")).default);
$parcel$export(module.exports, "nb", () => (parcelRequire("2qrsf")).default);
$parcel$export(module.exports, "pl", () => (parcelRequire("9Euto")).default);
$parcel$export(module.exports, "pt_BR", () => (parcelRequire("1r9WC")).default);
$parcel$export(module.exports, "pt_PT", () => (parcelRequire("clmK0")).default);
$parcel$export(module.exports, "ru", () => (parcelRequire("9LAI9")).default);
$parcel$export(module.exports, "sk", () => (parcelRequire("afZdi")).default);
$parcel$export(module.exports, "es", () => (parcelRequire("ftGla")).default);
$parcel$export(module.exports, "sv", () => (parcelRequire("fHyKJ")).default);
$parcel$export(module.exports, "th", () => (parcelRequire("k8Cki")).default);
$parcel$export(module.exports, "tr", () => (parcelRequire("2D5sm")).default);
$parcel$export(module.exports, "uk", () => (parcelRequire("abibY")).default);
$parcel$export(module.exports, "vi", () => (parcelRequire("gfrMq")).default);
$parcel$export(module.exports, "en", () => (parcelRequire("e9Pod")).default);
$parcel$export(module.exports, "en_GB", () => (parcelRequire("5d2m0")).default);
$parcel$export(module.exports, "en_ZZ", () => (parcelRequire("5lWKN")).default);
/**
 * NOTE:
 *
 * This file was automatically generated by i18n-tools
 * but it has been deprecated and now must be manually
 * updated.
 */ 
var $7wcSu = parcelRequire("7wcSu");

var $7XP8O = parcelRequire("7XP8O");

var $2CsJu = parcelRequire("2CsJu");

var $9SWh0 = parcelRequire("9SWh0");

var $tnTW0 = parcelRequire("tnTW0");

var $kQZO7 = parcelRequire("kQZO7");

var $kyyPr = parcelRequire("kyyPr");

var $ZLUIF = parcelRequire("ZLUIF");

var $36c4y = parcelRequire("36c4y");

var $cP8k0 = parcelRequire("cP8k0");

var $4DQb0 = parcelRequire("4DQb0");

var $2vw0t = parcelRequire("2vw0t");

var $58E51 = parcelRequire("58E51");

var $2qrsf = parcelRequire("2qrsf");

var $9Euto = parcelRequire("9Euto");

var $1r9WC = parcelRequire("1r9WC");

var $clmK0 = parcelRequire("clmK0");

var $9LAI9 = parcelRequire("9LAI9");

var $afZdi = parcelRequire("afZdi");

var $ftGla = parcelRequire("ftGla");

var $fHyKJ = parcelRequire("fHyKJ");

var $k8Cki = parcelRequire("k8Cki");

var $2D5sm = parcelRequire("2D5sm");

var $abibY = parcelRequire("abibY");

var $gfrMq = parcelRequire("gfrMq");

var $e9Pod = parcelRequire("e9Pod");

var $5d2m0 = parcelRequire("5d2m0");

var $5lWKN = parcelRequire("5lWKN");

});
parcelRegister("7wcSu", function(module, exports) {

$parcel$export(module.exports, "default", () => $1e007c53eaaee2e9$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Chinese (Simplified)
var $1e007c53eaaee2e9$export$2e2bcd8739ae039 = {
    'confluence.project-pages.improvement.provisioning-background.text': "\u6B64\u64CD\u4F5C\u7528\u65F6\u4E0D\u8D85\u8FC7\u4E00\u5206\u949F",
    'confluence.project-pages.improvement.provisioning-background.title': "\u6B63\u5728\u8BBE\u7F6E\u9879\u76EE\u9875\u9762",
    'confluence.project-pages.improvement.provisioning-modal-carousel.controls.dismiss': "\u5173\u95ED",
    'confluence.project-pages.improvement.provisioning-modal-carousel.controls.done': "\u5B8C\u6210",
    'confluence.project-pages.improvement.provisioning-modal-carousel.controls.next': "\u4E0B\u4E00\u9875",
    'project-pages.activating.description': "\u5DF2\u8FDE\u63A5\u7684 Confluence \u7A7A\u95F4\u5C1A\u672A\u51C6\u5907\u5C31\u7EEA\u3002\u5982\u679C\u5237\u65B0\u65E0\u6CD5\u4FEE\u590D\u95EE\u9898\uFF0C\u5219\u8BF7{contactSupport}\u3002",
    'project-pages.activating.heading': "Confluence \u4ECD\u5728\u52A0\u8F7D",
    'project-pages.better-together-templates.meeting-notes.action-items-heading': "\u64CD\u4F5C\u9879\u6709\u54EA\u4E9B\uFF1F",
    'project-pages.better-together-templates.meeting-notes.agenda-item-label': "\u8BAE\u7A0B\u9879\u76EE",
    'project-pages.better-together-templates.meeting-notes.create-a-jira-issue': "\u8F93\u5165\u201C/Jira\u201D\u53EF\u521B\u5EFA\u4E8B\u52A1",
    'project-pages.better-together-templates.meeting-notes.date-label': "\u65E5\u671F",
    'project-pages.better-together-templates.meeting-notes.discussion-topics-heading': "\u8BA8\u8BBA\u4E3B\u9898",
    'project-pages.better-together-templates.meeting-notes.list-people': "\u4F7F\u7528\u4EE5\u4E0B\u65B9\u6CD5\u5217\u51FA\u4EBA\u5458\uFF1A",
    'project-pages.better-together-templates.meeting-notes.mention': "\u63D0\u53CA",
    'project-pages.better-together-templates.meeting-notes.mention-people-to-assign-them': "\u4EBA\u5458\u4EE5\u5C06\u5176\u5206\u914D\u7ED9\u64CD\u4F5C\u9879",
    'project-pages.better-together-templates.meeting-notes.notes-label': "\u5907\u6CE8",
    'project-pages.better-together-templates.meeting-notes.page-title': "\u4F1A\u8BAE\u8BB0\u5F55",
    'project-pages.better-together-templates.meeting-notes.participants-label': "\u53C2\u4E0E\u8005",
    'project-pages.better-together-templates.meeting-notes.project-label': "\u9879\u76EE",
    'project-pages.better-together-templates.product-requirements.create-a-jira-issue': "\u8F93\u5165\u201C/Jira\u201D\u53EF\u521B\u5EFA\u4E8B\u52A1",
    'project-pages.better-together-templates.product-requirements.design-heading': "\u8BBE\u8BA1",
    'project-pages.better-together-templates.product-requirements.embedd-different-data-views': "\u5D4C\u5165 Jira \u9879\u76EE\u4E2D\u7684\u4E0D\u540C\u6570\u636E\u548C\u89C6\u56FE\u3002",
    'project-pages.better-together-templates.product-requirements.heading': "\u6982\u8FF0",
    'project-pages.better-together-templates.product-requirements.how-will-you-know-if-fixed': "\u60A8\u5982\u4F55\u786E\u5B9A\u662F\u5426\u5DF2\u89E3\u51B3\u95EE\u9898\uFF1F",
    'project-pages.better-together-templates.product-requirements.impact-heading': "\u5F71\u54CD",
    'project-pages.better-together-templates.product-requirements.inScopeStatus': "\u8303\u56F4\u5185",
    'project-pages.better-together-templates.product-requirements.insert-design-link': "\u63D2\u5165\u6307\u5411\u60A8\u8BBE\u8BA1\uFF08Figma \u7B49\uFF09\u7684\u94FE\u63A5",
    'project-pages.better-together-templates.product-requirements.jira-issue-heading': "Jira \u4E8B\u52A1",
    'project-pages.better-together-templates.product-requirements.jira-roadmap-heading': "Jira \u8DEF\u7EBF\u56FE",
    'project-pages.better-together-templates.product-requirements.learn-how-with-smart-links': "\u4E86\u89E3\u5982\u4F55\u4F7F\u7528\u667A\u80FD\u94FE\u63A5",
    'project-pages.better-together-templates.product-requirements.list-dashboards': "\u5217\u51FA\u4EEA\u8868\u677F\uFF08Amplitude\u3001Mode \u7B49\uFF09",
    'project-pages.better-together-templates.product-requirements.list-design-considerations': "\u5217\u51FA\u8BBE\u8BA1\u6216\u6784\u5EFA\u6CE8\u610F\u4E8B\u9879",
    'project-pages.better-together-templates.product-requirements.list-people': "\u4F7F\u7528\u4EE5\u4E0B\u65B9\u6CD5\u5217\u51FA\u4EBA\u5458\uFF1A",
    'project-pages.better-together-templates.product-requirements.mention': "\u63D0\u53CA",
    'project-pages.better-together-templates.product-requirements.mention-people-to-assign-them': "\u4EBA\u5458\u4EE5\u5C06\u5176\u5206\u914D\u7ED9\u64CD\u4F5C\u9879",
    'project-pages.better-together-templates.product-requirements.niceToHaveStatus': "\u6700\u597D\u6267\u884C",
    'project-pages.better-together-templates.product-requirements.outOfScopeStatus': "\u8D85\u51FA\u8303\u56F4",
    'project-pages.better-together-templates.product-requirements.page-title': "\u4EA7\u54C1\u9700\u6C42",
    'project-pages.better-together-templates.product-requirements.pro-tip': "\u4E13\u5BB6\u63D0\u793A\uFF1A",
    'project-pages.better-together-templates.product-requirements.problem-label': "\u95EE\u9898",
    'project-pages.better-together-templates.product-requirements.requirement-heading': "\u8981\u6C42",
    'project-pages.better-together-templates.product-requirements.scope-heading': "\u8303\u56F4",
    'project-pages.better-together-templates.product-requirements.success-metric': "\u6210\u529F\u6307\u6807",
    'project-pages.better-together-templates.product-requirements.target-release-date': "\u76EE\u6807\u53D1\u5E03\u65E5\u671F",
    'project-pages.better-together-templates.product-requirements.team-label': "\u56E2\u961F",
    'project-pages.better-together-templates.product-requirements.to-do-list-heading': "\u5F85\u529E\u5217\u8868",
    'project-pages.better-together-templates.product-requirements.what-are-you-trying-to-fix': "\u60A8\u8981\u5C1D\u8BD5\u89E3\u51B3\u4EC0\u4E48\u95EE\u9898\uFF1F",
    'project-pages.better-together-templates.retro-notes.retro-heading': "\u56DE\u987E",
    'project-pages.better-together-templates.retro.action-items-heading': "\u64CD\u4F5C\u9879\u6709\u54EA\u4E9B\uFF1F",
    'project-pages.better-together-templates.retro.create-a-jira-issue': "\u8F93\u5165\u201C/Jira\u201D\u53EF\u521B\u5EFA\u4E8B\u52A1",
    'project-pages.better-together-templates.retro.date-label': "\u65E5\u671F",
    'project-pages.better-together-templates.retro.embed-it-here': "\u5B8C\u6210\u540E\uFF0C\u60A8\u53EF\u4EE5\u5C06\u5176\u5D4C\u5165\u6B64\u5904\u3002",
    'project-pages.better-together-templates.retro.list-people': "\u4F7F\u7528\u4EE5\u4E0B\u65B9\u6CD5\u5217\u51FA\u4EBA\u5458\uFF1A",
    'project-pages.better-together-templates.retro.mention': "\u63D0\u53CA",
    'project-pages.better-together-templates.retro.mention-people-to-assign-them': "\u4EBA\u5458\u4EE5\u5C06\u5176\u5206\u914D\u7ED9\u64CD\u4F5C\u9879",
    'project-pages.better-together-templates.retro.page-title': "\u56DE\u987E",
    'project-pages.better-together-templates.retro.participants-label': "\u53C2\u4E0E\u8005",
    'project-pages.better-together-templates.retro.pro-tip': "\u4E13\u5BB6\u63D0\u793A\uFF1A",
    'project-pages.better-together-templates.retro.project-label': "\u9879\u76EE",
    'project-pages.better-together-templates.retro.this-is-a-whiteboard': "\u8FD9\u662F Confluence \u767D\u677F\u3002",
    'project-pages.better-together-templates.retro.use-a-whiteboard': "\u5C06 Confluence \u767D\u677F\u7528\u4E8E\u56DE\u987E\u3002",
    'project-pages.better-together-templates.retro.use-it-to-vote': "\u60A8\u53EF\u4EE5\u5C06\u5176\u7528\u4E8E\u6295\u7968\u5E76\u4E0E\u60A8\u7684\u56E2\u961F\u5408\u4F5C\u3002",
    'project-pages.button.connect-different-space-or-page.label': "\u66F4\u65B0\u7A7A\u95F4\u6216\u9875\u9762\u56FE\u6807",
    'project-pages.button.connect-different-space-or-page.tooltip': "\u8FDE\u63A5\u5176\u4ED6\u7A7A\u95F4\u6216\u9879\u76EE",
    'project-pages.button.connect-space-or-page.tooltip': "\u8FDE\u63A5\u5230 Confluence",
    'project-pages.button.go-to-connected-live-doc.tooltip': "\u5728 Confluence \u4E2D\u6253\u5F00\u5B9E\u65F6\u6587\u6863",
    'project-pages.button.go-to-connected-page.tooltip': "\u5728 Confluence \u4E2D\u6253\u5F00\u9875\u9762",
    'project-pages.button.go-to-connected-space.tooltip': "\u5728 Confluence \u4E2D\u6253\u5F00\u7A7A\u95F4",
    'project-pages.connect-space-dialog.connection-error': "\u8FDE\u63A5\u5931\u8D25\u3002",
    'project-pages.connect-space-dialog.connection-retry': "\u91CD\u8BD5",
    'project-pages.connect-space-dialog.content.space-or-page-selector.description': "\u9009\u62E9\u8981\u8FDE\u63A5\u81F3\u60A8\u9879\u76EE\u7684\u7A7A\u95F4\u6216\u9879\u76EE\u3002",
    'project-pages.connect-space-dialog.content.space-or-page-selector.placeholder': "\u5728 Confluence \u4E2D\u641C\u7D22",
    'project-pages.connect-space-dialog.content.space-selector.disconnected-templates-description': "\u6B64\u9879\u76EE\u9700\u8FDE\u63A5\u81F3\u4E00\u4E2A\u7A7A\u95F4\uFF0C\u60A8\u624D\u80FD\u521B\u5EFA\u9879\u76EE\u3002\u8BF7\u9009\u62E9\u8981\u8FDE\u63A5\u81F3\u6B64\u9879\u76EE\u7684\u7A7A\u95F4\u3002",
    'project-pages.connect-space-dialog.error-icon': "\u9519\u8BEF\uFF1A",
    'project-pages.connect-space-dialog.footer.cancel': "\u53D6\u6D88",
    'project-pages.connect-space-dialog.footer.connect-space': "\u8FDE\u63A5",
    'project-pages.connect-space-or-page-dialog.header.title': "\u5C06\u9879\u76EE\u8FDE\u63A5\u5230 Confluence",
    'project-pages.connect-space.description': "\u7A7A\u95F4\u7C7B\u4F3C\u6587\u4EF6\u5939 - \u60A8\u53EF\u4EE5\u4F7F\u7528\u5B83\u4EEC\u5C31\u4E0E\u9879\u76EE\u76F8\u5173\u7684\u6240\u6709\u5185\u5BB9\u8FDB\u884C\u521B\u5EFA\u3001\u7EC4\u7EC7\u548C\u534F\u4F5C\u3002",
    'project-pages.connect-space.not-connected.description': "\u82E5\u8981\u4F7F\u7528\u9879\u76EE\u9875\u9762\uFF0C\u8BF7\u8054\u7CFB\u60A8\u7684\u7BA1\u7406\u5458\u6216\u56E2\u961F\u8D1F\u8D23\u4EBA\uFF0C\u5C06 Confluence \u8FDE\u63A5\u5230\u6B64\u9879\u76EE\u3002",
    'project-pages.connect-space.not-connected.heading': "\u672A\u8FDE\u63A5\u5230 Confluence",
    'project-pages.connect-success-flag.description.content': "\u5DF2\u6210\u529F\u8FDE\u63A5 {connectedSpaceOrPageName} \u5185\u5BB9\u3002",
    'project-pages.connection-error.space-or-page-not-found.button': "\u8FDE\u63A5\u5230\u5176\u4ED6\u7A7A\u95F4\u6216\u9875\u9762",
    'project-pages.create-space-dialog.connection-error': "\u8FDE\u63A5\u5931\u8D25\u3002",
    'project-pages.create-space-dialog.connection-retry': "\u91CD\u8BD5",
    'project-pages.create-space-dialog.content.empty-name': "\u8BF7\u4E3A\u7A7A\u95F4\u547D\u540D\u3002",
    'project-pages.create-space-dialog.content.invalid-name': "\u7A7A\u95F4\u540D\u79F0\u81F3\u5C11\u9700\u5305\u542B\u4E00\u4E2A\u5B57\u6BCD\u6216\u6570\u5B57\u3002",
    'project-pages.create-space-dialog.content.placeholder': "\u8F93\u5165\u7A7A\u95F4\u540D\u79F0",
    'project-pages.create-space-dialog.creation-error': "\u7A7A\u95F4\u521B\u5EFA\u5931\u8D25\u3002",
    'project-pages.create-space-dialog.error-icon': "\u9519\u8BEF\uFF1A",
    'project-pages.create-space-dialog.footer.cancel': "\u53D6\u6D88",
    'project-pages.create-space-dialog.footer.create-space': "\u521B\u5EFA",
    'project-pages.create-space-dialog.header.title': "\u521B\u5EFA\u65B0\u7684 Confluence \u7A7A\u95F4",
    'project-pages.cross-join.access-revoked.templates.subtitle': "\u60A8\u65E0\u6CD5\u4F7F\u7528\u9879\u76EE\u9875\u9762\uFF0C\u56E0\u4E3A\u7BA1\u7406\u5458\u5DF2\u62D2\u7EDD\u60A8\u8BBF\u95EE Confluence\u3002\u8BF7\u8054\u7CFB\u7AD9\u70B9\u7BA1\u7406\u5458\u7533\u8BF7\u8BBF\u95EE\u6743\u9650\u3002",
    'project-pages.cross-join.access-revoked.templates.title': "\u60A8\u65E0\u6743\u4F7F\u7528\u9879\u76EE\u9875\u9762",
    'project-pages.cross-join.avatar.view-profile': "\u67E5\u770B\u4E2A\u4EBA\u8D44\u6599",
    'project-pages.cross-join.denied-request.templates.subtitle': "\u60A8\u65E0\u6CD5\u4F7F\u7528\u9879\u76EE\u9875\u9762\uFF0C\u56E0\u4E3A\u7AD9\u70B9\u7BA1\u7406\u5458\u62D2\u7EDD\u4E86\u60A8\u52A0\u5165 Confluence \u7684\u8BF7\u6C42\u3002",
    'project-pages.cross-join.denied-request.templates.title': "\u60A8\u7684\u7BA1\u7406\u5458\u5DF2\u62D2\u7EDD\u60A8\u8BBF\u95EE",
    'project-pages.cross-join.direct-access.button-subtitle.experimental': "\u60A8\u5C06\u83B7\u5F97 Confluence \u7684\u8BBF\u95EE\u6743\u9650\u3002\u7AD9\u70B9\u7BA1\u7406\u5458\u5DF2\u6279\u51C6\u60A8\u52A0\u5165\u3002",
    'project-pages.cross-join.errors.unknown-error.description': "\u5982\u679C\u5237\u65B0\u65E0\u6CD5\u4FEE\u590D\u95EE\u9898\uFF0C\u5219\u8BF7{contactSupport}\u3002",
    'project-pages.cross-join.errors.unknown-error.title': "\u5F53\u524D\u65E0\u6CD5\u663E\u793A\u9879\u76EE\u9875\u9762",
    'project-pages.cross-join.inline-join-product.button': "\u60A8\u5C06\u83B7\u5F97 Confluence \u7684\u8BBF\u95EE\u6743\u9650\u3002\u7AD9\u70B9\u7BA1\u7406\u5458\u5DF2\u6279\u51C6\u60A8\u52A0\u5165\u3002",
    'project-pages.cross-join.inline-join-product.connected.description': "\u5728\u4E00\u4E2A\u96C6\u4E2D\u4F4D\u7F6E\u67E5\u770B\u3001\u7F16\u8F91\u548C\u521B\u5EFA\u6587\u6863",
    'project-pages.cross-join.inline-join-product.connected.title': "\u5728\u9879\u76EE\u9875\u9762\u4E0A\u4E0E\u60A8\u7684\u56E2\u961F\u5F00\u5C55\u534F\u4F5C",
    'project-pages.cross-join.pending-request.templates.subtitle': "\u7AD9\u70B9\u7BA1\u7406\u5458\u5DF2\u6536\u5230\u60A8\u52A0\u5165 Confluence \u7684\u8BF7\u6C42\u3002\u5982\u679C\u60A8\u88AB\u6279\u51C6\u52A0\u5165\uFF0C\u9879\u76EE\u9875\u9762\u5C06\u5F00\u59CB\u8FD0\u884C\uFF0C\u6211\u4EEC\u4E5F\u4F1A\u5411\u60A8\u53D1\u9001\u786E\u8BA4\u7535\u5B50\u90AE\u4EF6\u3002",
    'project-pages.cross-join.pending-request.templates.subtitle.experiment': "\u8BF7\u6C42\u83B7\u5F97\u6279\u51C6\u540E\uFF0C\u60A8\u5C06\u6536\u5230\u4E00\u5C01\u5305\u542B\u201C\u9879\u76EE\u9875\u9762\u201D\u8BBF\u95EE\u6743\u9650\u7684\u7535\u5B50\u90AE\u4EF6\u3002",
    'project-pages.cross-join.pending-request.templates.title': "\u60A8\u5DF2\u8BF7\u6C42\u8BBF\u95EE Confluence",
    'project-pages.cross-join.pending-request.templates.title.experiment': "\u5DF2\u5411\u7BA1\u7406\u5458\u53D1\u9001\u8BBF\u95EE\u8BF7\u6C42",
    'project-pages.cross-join.request-access-without-better-together.connected.description': "\u4E0E\u60A8\u7684\u56E2\u961F\u4E00\u8D77\u67E5\u770B\u3001\u7F16\u8F91\u548C\u521B\u5EFA\u9879\u76EE\u6587\u6863",
    'project-pages.cross-join.request-access.button': "\u8BF7\u6C42\u8BBF\u95EE",
    'project-pages.cross-join.request-access.button-subtitle.experimental': "\u9009\u62E9\u201C\u52A0\u5165\u60A8\u7684\u56E2\u961F\u201D\uFF0C\u5373\u8868\u793A\u60A8\u8BF7\u6C42\u52A0\u5165 Confluence \u5E76\u540C\u610F\u4E0E\u7BA1\u7406\u5458\u5206\u4EAB\u60A8\u7684 Atlassian \u4E2A\u4EBA\u8D44\u6599\u3002",
    'project-pages.cross-join.request-access.button.experimental': "\u52A0\u5165\u60A8\u7684\u56E2\u961F",
    'project-pages.cross-join.request-access.connected.description.experimental': "\u60A8\u7684\u56E2\u961F\u65E0\u9700\u79BB\u5F00 Jira\uFF0C\u5373\u53EF\u4F7F\u7528\u201C\u9879\u76EE\u9875\u9762\u201D\u6765\u8BC4\u8BBA\u3001\u7F16\u8F91\u548C\u534F\u4F5C\u5904\u7406\u9879\u76EE\u6587\u6863\u3002\u52A0\u5165 Confluence \u4EE5\u8BBF\u95EE\u60A8\u56E2\u961F\u7684\u201C\u9879\u76EE\u9875\u9762\u201D\u3002",
    'project-pages.cross-join.request-access.title': "\u9879\u76EE\u9875\u9762\u9700\u8981\u8BBF\u95EE Confluence",
    'project-pages.cross-join.request-access.title.experiment': "\u4E3A\u60A8\u7684\u56E2\u961F\u521B\u5EFA\u5355\u4E00\u4E8B\u5B9E\u6765\u6E90",
    'project-pages.default-contextual-heading': "\u9879\u76EE\u9875\u9762\u7531 Confluence \u63D0\u4F9B\u652F\u6301",
    'project-pages.default-contextual-message': "\u4F7F\u7528 Confluence \u9875\u9762\u5728\u4E00\u4E2A\u4F4D\u7F6E\u521B\u5EFA\u3001\u5171\u4EAB\u548C\u5408\u4F5C\u6240\u6709\u9879\u76EE\u6587\u6863\u3002",
    'project-pages.default-reactivate-CTA': "\u91CD\u65B0\u6FC0\u6D3B Confluence",
    'project-pages.default-trial-CTA': "\u514D\u8D39\u8BD5\u7528 Confluence 30 \u5929",
    'project-pages.draft-saved-flag.action': "\u6253\u5F00\u8349\u7A3F",
    'project-pages.draft-saved-flag.description': "\u5728\u60A8\u53D1\u5E03\u8349\u7A3F\u4E4B\u524D\uFF0C\u60A8\u7684\u8349\u7A3F\u4EC5\u5BF9\u60A8\u81EA\u5DF1\u53EF\u89C1\u3002",
    'project-pages.draft-saved-flag.title': "\u8349\u7A3F\u5DF2\u4FDD\u5B58",
    'project-pages.embedded-pages.create-page-error.close-button': "\u5173\u95ED",
    'project-pages.embedded-pages.create-page-error.description': "\u51FA\u73B0\u95EE\u9898\uFF0C\u65E0\u6CD5\u4E3A\u60A8\u521B\u5EFA\u9875\u9762\u3002",
    'project-pages.embedded-pages.create-page-error.title': "\u65E0\u6CD5\u521B\u5EFA\u9875\u9762",
    'project-pages.embedded-pages.create-page-error.try-again-button': "\u8BF7\u91CD\u8BD5",
    'project-pages.embedded-pages.modal.close.button.hint': "\u5173\u95ED",
    'project-pages.embedded-pages.modal.title.button': "\u5728 Confluence \u4E2D\u6253\u5F00",
    'project-pages.embedded-pages.modal.title.button.hint': "\u5728\u65B0\u6807\u7B7E\u9875\u4E2D\u6253\u5F00",
    'project-pages.errors.unknown-error.description.non-final': "\u5982\u679C\u5237\u65B0\u65E0\u6CD5\u4FEE\u590D\u95EE\u9898\uFF0C\u5219\u8BF7{contactSupport}\u3002",
    'project-pages.errors.unknown-error.title.non-final': "\u5F53\u524D\u65E0\u6CD5\u663E\u793A\u9879\u76EE\u9875\u9762",
    'project-pages.generic-error.button.reload': "\u91CD\u65B0\u52A0\u8F7D\u9875\u9762",
    'project-pages.generic-error.description': "\u51FA\u9519\u4E86\u3002\u8BF7\u7A0D\u540E\u91CD\u8BD5\u3002",
    'project-pages.generic-error.description.non-final': "\u51FA\u9519\u4E86\u3002\u8BF7\u7A0D\u540E\u91CD\u8BD5\u3002",
    'project-pages.generic-error.heading': "\u62B1\u6B49...",
    'project-pages.generic-error.title.non-final': "\u62B1\u6B49...",
    'project-pages.generic-info-flag.description': "\u53D1\u751F\u9519\u8BEF\u3002\u8BF7\u91CD\u8BD5\uFF1B\u5982\u679C\u95EE\u9898\u4ECD\u7136\u5B58\u5728\uFF0C\u8BF7\u8054\u7CFB\u652F\u6301\u56E2\u961F",
    'project-pages.generic-success-flag.description.live-doc': "\u5DF2\u6210\u529F\u8FDE\u63A5 {connectedSpaceOrPageName} \u5B9E\u65F6\u6587\u6863\u3002",
    'project-pages.generic-success-flag.description.page': "\u5DF2\u6210\u529F\u8FDE\u63A5 {connectedSpaceOrPageName} \u9875\u9762\u3002",
    'project-pages.generic-success-flag.description.space': "\u5DF2\u6210\u529F\u8FDE\u63A5 {connectedSpaceOrPageName} \u7A7A\u95F4\u3002",
    'project-pages.generic-success-flag.heading.live-doc': "\u5B9E\u65F6\u6587\u6863\u5DF2\u8FDE\u63A5",
    'project-pages.generic-success-flag.heading.page': "\u9875\u9762\u5DF2\u8FDE\u63A5",
    'project-pages.generic-success-flag.heading.space': "\u7A7A\u95F4\u5DF2\u8FDE\u63A5",
    'project-pages.granular-pages.connect-space-dialog.content.create-space-link.link-text': "\u6216\u8005\u521B\u5EFA\u65B0\u7A7A\u95F4",
    'project-pages.granular-pages.connect-space.button': "\u8FDE\u63A5\u5230 Confluence",
    'project-pages.granular-pages.connect-space.heading': "\u5C06\u6B64\u9879\u76EE\u8FDE\u63A5\u81F3 Confluence \u7A7A\u95F4\u6216\u9879\u76EE",
    'project-pages.improvement.contact-support': "\u8054\u7CFB\u652F\u6301\u56E2\u961F",
    'project-pages.improvement.errors.access-error.description': "\u8BF7\u5C1D\u8BD5\u8054\u7CFB\u7AD9\u70B9\u7BA1\u7406\u5458\u4EE5\u8BF7\u6C42\u8BBF\u95EE\u6743\u9650\u3002",
    'project-pages.improvement.errors.access-error.title': "\u60A8\u65E0\u6743\u67E5\u770B\u9879\u76EE\u9875\u9762",
    'project-pages.improvement.errors.page-tree-unknown-error.description': "\u5C1D\u8BD5\u4ECE\u5DF2\u8FDE\u63A5\u7684 Confluence \u7A7A\u95F4\u663E\u793A\u9875\u9762\u65F6\u51FA\u9519\u3002\u5982\u679C\u5237\u65B0\u65E0\u6CD5\u4FEE\u590D\u95EE\u9898\uFF0C\u5219\u8BF7{contactSupport}\u3002",
    'project-pages.improvement.errors.page-tree-unknown-error.title': "\u663E\u793A\u9879\u76EE\u9875\u9762\u65F6\u51FA\u73B0\u95EE\u9898",
    'project-pages.improvement.errors.space-or-page-not-found.description': "\u5DF2\u5173\u8054\u7684 Confluence \u7A7A\u95F4\u6216\u9875\u9762\u5DF2\u79FB\u52A8\u3001\u5F52\u6863\u6216\u5220\u9664\u3002\u5982\u679C\u91CD\u65B0\u5173\u8054\u65E0\u6CD5\u89E3\u51B3\u95EE\u9898\uFF0C\u8BF7<link>\u8054\u7CFB\u652F\u6301\u56E2\u961F</link>",
    'project-pages.improvement.errors.space-or-page-not-found.title': "\u672A\u627E\u5230\u7A7A\u95F4\u6216\u9875\u9762",
    'project-pages.improvement.errors.unknown-error.description': "\u5982\u679C\u5237\u65B0\u65E0\u6CD5\u4FEE\u590D\u95EE\u9898\uFF0C\u5219\u8BF7{contactSupport}\u3002",
    'project-pages.improvement.errors.unknown-error.title': "\u5F53\u524D\u65E0\u6CD5\u663E\u793A\u9879\u76EE\u9875\u9762",
    'project-pages.improvement.feature1': "\u65E0\u9700\u79BB\u5F00 Jira \u5373\u53EF\u8BBF\u95EE\u548C\u521B\u5EFA\u6587\u6863",
    'project-pages.improvement.feature2': "\u63D0\u4F9B\u7528\u4E8E\u4F1A\u8BAE\u3001\u51B2\u523A\u8BA1\u5212\u7B49\u7684\u6A21\u677F",
    'project-pages.improvement.feature3': "\u5C06\u6587\u6863\u540C\u6B65\u5230 Jira \u4EE5\u8FDB\u884C\u81EA\u52A8\u66F4\u65B0",
    'project-pages.improvement.heading-info': "\u638C\u63E1\u56E2\u961F\u7684\u77E5\u8BC6\uFF0C\u5E76\u6539\u8FDB\u5DE5\u4F5C\u7684\u5B8C\u6210\u65B9\u5F0F\u3002",
    'project-pages.improvement.heading-info-v2': "\u4E3A\u56E2\u961F\u7684\u6240\u6709\u9879\u76EE\u6587\u6863\u521B\u5EFA\u4E00\u4E2A\u7EDF\u4E00\u7684\u5B58\u653E\u5904",
    'project-pages.improvement.learn-more-button': "\u4E86\u89E3\u66F4\u591A",
    'project-pages.improvement.powered-by': "\u6280\u672F\u652F\u6301",
    'project-pages.improvement.powered-by.tooltip': "\u5728\u65B0\u6807\u7B7E\u9875\u4E2D\u6253\u5F00 Confluence",
    'project-pages.improvement.preview-teaser': "\u89E3\u9501\u6A21\u677F\u3001\u9879\u76EE\u9875\u9762\u7B49\u3002",
    'project-pages.improvement.provisioning-info-modal.seamlessly-update-stakeholders.description': "<p>\u901A\u8FC7\u81EA\u52A8\u66F4\u65B0\u72B6\u6001\u6807\u7B7E\u4F7F\u9879\u76EE\u62A5\u544A\u4FDD\u6301\u6700\u65B0\u3002</p><p>\u53EA\u9700\u5728\u6587\u6863\u4E2D\u94FE\u63A5 Jira \u5DE5\u4F5C\u5355\uFF0C\u6587\u6863\u5373\u53EF\u81EA\u52A8\u663E\u793A\u4E0E\u5DE5\u4F5C\u5355\u540C\u6B65\u66F4\u65B0\u7684\u72B6\u6001\u6807\u7B7E\uFF0C\u8FD9\u6837\u60A8\u4FBF\u65E0\u9700\u518D\u82B1\u65F6\u95F4\u521B\u5EFA\u624B\u52A8\u62A5\u544A\u3002</p>",
    'project-pages.improvement.provisioning-info-modal.seamlessly-update-stakeholders.title': "\u65E0\u7F1D\u66F4\u65B0\u5229\u76CA\u76F8\u5173\u8005",
    'project-pages.improvement.provisioning-info-modal.unify-documentation-standards.description': "<p>\u4F7F\u7528\u6211\u4EEC\u7684\u5185\u7F6E\u6A21\u677F\u521B\u5EFA\u4E00\u81F4\u7684\u6587\u6863\u3002\u8FD9\u4E9B\u6A21\u677F\u4E0D\u4EC5\u6613\u4E8E\u4F7F\u7528\uFF0C\u800C\u4E14\u53EF\u6839\u636E\u60A8\u7684\u9700\u6C42\u8FDB\u884C\u81EA\u5B9A\u4E49\u3002</p><p>\u60A8\u4E0D\u5FC5\u79BB\u5F00\u6B63\u5728\u5904\u7406\u7684\u5DE5\u4F5C\uFF0C\u5373\u53EF\u76F4\u63A5\u5728\u9879\u76EE\u9875\u9762\u4E0A\u4F7F\u7528\u6A21\u677F\u3002\u70B9\u51FB<a>\u6B64\u5904</a>\u53EF\u6D4F\u89C8\u6240\u6709\u6A21\u677F\u3002</p>",
    'project-pages.improvement.provisioning-info-modal.unify-documentation-standards.title': "\u7EDF\u4E00\u6587\u6863\u6807\u51C6",
    'project-pages.improvement.provisioning-info-modal.your-project-pages-in-jira.description': "<p>\u901A\u8FC7 Jira \u7684\u201C\u9879\u76EE\u9875\u9762\u201D\u9009\u9879\u5361\u521B\u5EFA\u548C\u7BA1\u7406\u6587\u6863\uFF0C\u4ECE\u800C\u4E3A\u91CD\u8981\u4FE1\u606F\u521B\u5EFA\u5355\u4E00\u6570\u636E\u6E90\u3002</p><p>\u60A8\u77E5\u9053\u9879\u76EE\u9875\u9762\u53EF\u5728 Confluence \u4E0A\u8FD0\u884C\u5417\uFF1FConfluence \u6700\u591A\u53EF\u4F9B 10 \u4F4D\u7528\u6237\u514D\u8D39\u4F7F\u7528\u3002\u8BF7\u5728\u201C\u7BA1\u7406\u5458\u8BBE\u7F6E\u201D\u4E2D\u9080\u8BF7\u56E2\u961F\u7684\u5176\u4ED6\u6210\u5458\u3002</p>",
    'project-pages.improvement.provisioning-info-modal.your-project-pages-in-jira.title': "\u76F4\u63A5\u5728 Jira \u4E2D\u67E5\u770B\u60A8\u7684\u9879\u76EE\u9875\u9762",
    'project-pages.improvement.templates-sidebar.better-together-templates-header': "\u4E0E\u60A8\u7684 Jira \u6570\u636E\u96C6\u6210\u7684\u6A21\u677F",
    'project-pages.improvement.templates.better-together-preview-teaser': "\u5DF2\u4E0E Jira \u6570\u636E\u96C6\u6210",
    'project-pages.improvement.templates.blank-page.description': "\u4ECE\u5934\u5F00\u59CB\u521B\u5EFA\u4E00\u4E2A\u9875\u9762\u3002",
    'project-pages.improvement.templates.blank-page.name': "\u7A7A\u767D\u9875\u9762",
    'project-pages.improvement.templates.decision.description': "\u8BB0\u5F55\u91CD\u8981\u7684\u9879\u76EE\u51B3\u7B56\uFF0C\u5E76\u5411\u60A8\u7684\u56E2\u961F\u4F20\u8FBE\u3002",
    'project-pages.improvement.templates.decision.name': "\u51B3\u7B56",
    'project-pages.improvement.templates.meeting-notes.description': "\u8BBE\u7F6E\u4F1A\u8BAE\u8BAE\u7A0B\u3001\u505A\u8BB0\u5F55\u5E76\u4E0E\u56E2\u961F\u5206\u4EAB\u884C\u52A8\u4E8B\u9879\u3002",
    'project-pages.improvement.templates.meeting-notes.name': "\u4F1A\u8BAE\u8BB0\u5F55",
    'project-pages.improvement.templates.post-expand.more': "\u66F4\u591A\u6A21\u677F",
    'project-pages.improvement.templates.post-expand.more.tooltip': "\u67E5\u770B Confluence \u4E2D\u7684\u6240\u6709\u6A21\u677F",
    'project-pages.improvement.templates.post-expand.subtitle': "\u70ED\u95E8\u6A21\u677F",
    'project-pages.improvement.templates.post-expand.title': "\u521B\u5EFA\u9875\u9762",
    'project-pages.improvement.templates.pre-expand.more': "\u63A2\u7D22\u66F4\u591A\u6A21\u677F",
    'project-pages.improvement.templates.pre-expand.subtitle': "\u5907\u53D7\u4E0E\u60A8\u7C7B\u4F3C\u56E2\u961F\u7684\u9752\u7750",
    'project-pages.improvement.templates.pre-expand.title': "\u9884\u89C8\u6A21\u677F",
    'project-pages.improvement.templates.product-requirements.description': "\u4E3A\u60A8\u7684\u4EA7\u54C1\u6216\u529F\u80FD\u5B9A\u4E49\u3001\u8FFD\u8E2A\u9700\u6C42\uFF0C\u4EE5\u53CA\u786E\u5B9A\u9700\u6C42\u8303\u56F4\u3002",
    'project-pages.improvement.templates.product-requirements.name': "\u4EA7\u54C1\u9700\u6C42",
    'project-pages.improvement.templates.retrospective.description': "\u54EA\u4E9B\u8FDB\u5C55\u987A\u5229\uFF1F\u54EA\u4E9B\u53EF\u4EE5\u6539\u8FDB\uFF1F\u4E0E\u60A8\u7684\u56E2\u961F\u4E00\u8D77\u4E3A\u6539\u8FDB\u8FDB\u884C\u4F17\u5305\u3002",
    'project-pages.improvement.templates.retrospective.name': "\u56DE\u987E",
    'project-pages.improvement.templates.template.disabled-tooltip': "\u8BF7\u5148\u8FDE\u63A5\u4E00\u4E2A Confluence \u7A7A\u95F4",
    'project-pages.improvement.templates.tutorial.content.confluence-templates': "<b>\u8282\u7EA6\u65F6\u95F4\uFF0C\u51CF\u5C11\u624B\u52A8\u4EFB\u52A1</b>\u3002Confluence \u6709\u8BB8\u591A\u9875\u9762<a>\u6A21\u677F</a>\u53EF\u4F9B\u4F7F\u7528\uFF0C\u8BA9\u60A8\u6C38\u8FDC\u4E0D\u5FC5\u4ECE\u96F6\u5F00\u59CB\u3002\u96C6\u4E2D\u7CBE\u529B\u6784\u601D\u6280\u672F\u6587\u6863\u3001\u6545\u969C\u6392\u9664\u6307\u5357\u3001\u9879\u76EE\u8BA1\u5212\u3001\u4EA7\u54C1\u9700\u6C42\u548C\u66F4\u591A\u5185\u5BB9\u3002",
    'project-pages.improvement.templates.tutorial.content.edit-and-format': "<b>\u8F7B\u677E\u7F16\u8F91\u5E76\u8BBE\u7F6E\u683C\u5F0F\u3002</b>\u4F7F\u7528\u9876\u90E8\u7684\u7F16\u8F91\u83DC\u5355\u8C03\u6574\u6807\u51C6\u6587\u672C\u683C\u5F0F\uFF0C\u8F93\u5165 <b>/</b> \u4FBF\u53EF\u8F7B\u677E\u63D2\u5165\u5927\u91CF\u6613\u4E8E\u4F7F\u7528\u7684\u96C6\u6210\u3002\u8F93\u5165\u201C<c>/\u8868\u683C</c>\u201D\u4EE5\u63D2\u5165\u8868\u683C\uFF0C\u6216\u662F\u8F93\u5165\u201C<c>/\u56FE\u7247</c>\u201D\u4EE5\u63D2\u5165\u56FE\u7247\u3002\u60A8\u4E5F\u53EF\u4EE5\u63D2\u5165 Dropbox \u94FE\u63A5 (<c>/dropbox</c>)\u3001Microsoft Office \u5DE5\u5177 (<c>/microsoft</c>) \u6216 Trello \u9762\u677F\u548C\u5361\u7247 (<c>/trello</c>)\u3002",
    'project-pages.improvement.templates.tutorial.content.forward-slash-prompt': "\u8F93\u5165 /\uFF0C\u540E\u63A5\u201C\u8868\u683C\u201D\u6216\u201C\u56FE\u7247\u201D",
    'project-pages.improvement.templates.tutorial.content.getting-started-tips': "\u4EE5\u4E0B\u662F\u4E00\u4E9B\u5165\u95E8\u6280\u5DE7\uFF1A",
    'project-pages.improvement.templates.tutorial.content.handy-links': "\u6613\u4E8E\u4F7F\u7528\u7684\u94FE\u63A5",
    'project-pages.improvement.templates.tutorial.content.jira-and-confluence': "\u642D\u914D\u4F7F\u7528 Jira \u548C Confluence",
    'project-pages.improvement.templates.tutorial.content.jira-charts': "\u4F7F\u7528\u771F\u5B9E\u7684 Jira \u6570\u636E\u5728\u60A8\u7684\u9875\u9762\u4E0A\u521B\u5EFA\u56FE\u8868\u3002\u8F93\u5165 <c>/Jira \u56FE\u8868</c>\u3002",
    'project-pages.improvement.templates.tutorial.content.jira-links': "\u5728\u60A8\u9875\u9762\u4E0A\u7684\u4EFB\u610F\u4F4D\u7F6E\u5173\u8054 Jira \u4E8B\u52A1\u3002\u5728\u60A8\u66F4\u65B0 Jira \u4E8B\u52A1\u65F6\uFF0C\u9875\u9762\u4E0A\u7684\u94FE\u63A5\u4E5F\u4F1A\u5B9E\u65F6\u66F4\u65B0\u3002\u8F93\u5165 <c>/Jira</c>\u3002",
    'project-pages.improvement.templates.tutorial.content.jira-links-issue-term-refresh': "\u5728\u60A8\u9875\u9762\u4E0A\u7684\u4EFB\u610F\u4F4D\u7F6E\u5173\u8054 Jira \u5DE5\u4F5C\u9879\u3002\u5728\u60A8\u66F4\u65B0\u5DE5\u4F5C\u9879\u65F6\uFF0C\u9875\u9762\u4E0A\u7684\u94FE\u63A5\u4E5F\u4F1A\u5B9E\u65F6\u66F4\u65B0\u3002\u8F93\u5165 <c>/Jira</c>\u3002",
    'project-pages.improvement.templates.tutorial.content.jira-links.non-final-issue-term-refresh': "\u5728\u60A8\u9875\u9762\u4E0A\u7684\u4EFB\u610F\u4F4D\u7F6E\u5173\u8054 Jira \u5DE5\u4F5C\u9879\u3002\u5728\u60A8\u66F4\u65B0\u5DE5\u4F5C\u9879\u65F6\uFF0C\u9875\u9762\u4E0A\u7684\u94FE\u63A5\u4E5F\u4F1A\u5B9E\u65F6\u66F4\u65B0\u3002\u8F93\u5165 &quot;<c>/Jira</c>&quot;\u3002",
    'project-pages.improvement.templates.tutorial.content.jira-roadmaps': "\u4F7F\u7528 Jira \u9879\u76EE\u4E3A\u60A8\u7684\u9875\u9762\u5D4C\u5165\u4EA4\u4E92\u5F0F\u8DEF\u7EBF\u56FE\u548C\u65F6\u95F4\u7EBF\u3002\u8F93\u5165 <c>/jira \u8DEF\u7EBF\u56FE</c>\u3002",
    'project-pages.improvement.templates.tutorial.content.jira-timeline': "\u4F7F\u7528 Jira \u9879\u76EE\u4E3A\u60A8\u7684\u9875\u9762\u5D4C\u5165\u65F6\u95F4\u7EBF\u3002\u8F93\u5165 <c>/jira \u65F6\u95F4\u7EBF</c>\u3002",
    'project-pages.improvement.templates.tutorial.content.shipping-speed-statistic': "76% \u7684 Jira Software \u5BA2\u6237\u8868\u793A\uFF0C\u6DFB\u52A0 Confluence \u540E\uFF0C\u4ED6\u4EEC\u53EF\u4EE5\u66F4\u5FEB\u5730\u4EA4\u4ED8\u9879\u76EE\u3002",
    'project-pages.improvement.templates.tutorial.content.shipping-speed-statistic.spork-rebranding': "76% \u7684 Jira \u5BA2\u6237\u8868\u793A\uFF0C\u6DFB\u52A0 Confluence \u540E\uFF0C\u4ED6\u4EEC\u53EF\u4EE5\u66F4\u5FEB\u5730\u4EA4\u4ED8\u9879\u76EE",
    'project-pages.improvement.templates.tutorial.content.spaces-and-pages': "<b>\u4F7F\u7528\u7A7A\u95F4\u548C\u9875\u9762</b>\u3002\u7A7A\u95F4\u662F\u6240\u6709 Confluence \u7AD9\u70B9\u7684\u7EC4\u6210\u90E8\u5206\uFF0C\u540C\u65F6\u4E5F\u662F\u6309\u7C7B\u522B\u6574\u7406\u9875\u9762\u7684\u4E00\u79CD\u65B9\u5F0F\u3002\u60A8\u53EF\u5C06\u7A7A\u95F4\u89C6\u4E3A\u4E0D\u540C\u7684\u6587\u4EF6\u5939\u6216\u9879\u76EE\uFF0C\u800C\u9875\u9762\u5219\u662F\u6536\u7EB3\u5728\u8FD9\u4E9B\u6587\u4EF6\u5939\u6216\u9879\u76EE\u4E2D\u7684\u6587\u6863\u3002<a>\u4E86\u89E3\u6709\u5173\u7A7A\u95F4\u4F7F\u7528\u65B9\u6CD5\u7684\u66F4\u591A\u4FE1\u606F</a>",
    'project-pages.improvement.templates.tutorial.content.try-it-now': "\u7ACB\u5373\u8BD5\u7528",
    'project-pages.improvement.templates.tutorial.description': "\u4E86\u89E3\u5982\u4F55\u7F16\u8F91\u9875\u9762\u3002",
    'project-pages.improvement.templates.tutorial.name': "\u6B22\u8FCE\u8BBF\u95EE\u201C\u9879\u76EE\u9875\u9762\u201D\uFF01",
    'project-pages.improvement.terms-and-conditions-v2': "\u9009\u62E9\u201C\u7ACB\u5373\u8BD5\u7528\u201D\uFF0C\u5373\u8868\u793A\u60A8\u786E\u8BA4\u60A8\u5C06\u6CE8\u518C Confluence\uFF0C\u5E76\u540C\u610F Atlassian <termsLink>Cloud \u670D\u52A1\u6761\u6B3E</termsLink>\u548C<privacyLink>\u9690\u79C1\u653F\u7B56</privacyLink>\u3002",
    'project-pages.improvement.title': "\u9879\u76EE\u9875\u9762",
    'project-pages.improvement.transient-states.empty-state.auto-provisioned-create-page-button': "\u521B\u5EFA\u9875\u9762",
    'project-pages.improvement.transient-states.empty-state.auto-provisioned-description': "\u6211\u4EEC\u5DF2\u6DFB\u52A0 Confluence\uFF0C\u4EE5\u4FBF\u60A8\u5F00\u59CB\u521B\u5EFA\u5E76\u94FE\u63A5\u6240\u6709\u9879\u76EE\u6587\u6863\u3002\u5BF9\u6700\u591A 10 \u540D\u7528\u6237\u514D\u8D39\u3002",
    'project-pages.improvement.transient-states.empty-state.auto-provisioned-learn-more-button': "\u4E86\u89E3\u66F4\u591A",
    'project-pages.improvement.transient-states.empty-state.create-page-button': "\u521B\u5EFA\u60A8\u7684\u9996\u4E2A\u9875\u9762",
    'project-pages.improvement.transient-states.empty-state.description': "\u521B\u5EFA\u4E00\u4E9B\u4F1A\u8BAE\u8BB0\u5F55\u3001\u4EA7\u54C1\u9700\u6C42\u3001\u51B3\u5B9A\u6216\u5176\u4ED6\u5185\u5BB9\u6765\u5145\u5B9E\u8BE5\u7A7A\u95F4\u3002",
    'project-pages.improvement.transient-states.empty-state.title': "\u65E0\u9650\u6F5C\u529B\uFF0C\u5C3D\u5F85\u6316\u6398",
    'project-pages.improvement.try-button': "\u5728 Confluence \u4E2D\u8BD5\u7528\u6B64\u6A21\u677F",
    'project-pages.improvement.try-it-now': "\u7ACB\u5373\u8BD5\u7528",
    'project-pages.improvement.try-lozenge': "\u8BD5\u7528",
    'project-pages.improvement.try-on-demand-button': "\u514D\u8D39\u8BD5\u7528",
    'project-pages.page-deleted-flag.title': "\u9875\u9762\u5DF2\u5220\u9664\u3002",
    'project-pages.page-published-flag.title': "\u60A8\u7684\u9875\u9762\u5DF2\u53D1\u5E03\u3002",
    'project-pages.unknown-error.description': "\u5982\u679C\u5237\u65B0\u65E0\u6CD5\u4FEE\u590D\u95EE\u9898\uFF0C\u5219\u8BF7{contactSupport}\u3002",
    'project-pages.unknown-error.heading': "\u5F53\u524D\u65E0\u6CD5\u663E\u793A\u9879\u76EE\u9875\u9762"
};

});

parcelRegister("7XP8O", function(module, exports) {

$parcel$export(module.exports, "default", () => $3da4e045c51c2530$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Chinese (Traditional)
var $3da4e045c51c2530$export$2e2bcd8739ae039 = {
    'confluence.project-pages.improvement.provisioning-background.text': "\u4E0D\u5230\u4E00\u5206\u9418\u5373\u53EF\u5B8C\u6210",
    'confluence.project-pages.improvement.provisioning-background.title': "\u8A2D\u5B9A\u60A8\u7684\u5C08\u6848\u9801\u9762",
    'confluence.project-pages.improvement.provisioning-modal-carousel.controls.dismiss': "\u95DC\u9589",
    'confluence.project-pages.improvement.provisioning-modal-carousel.controls.done': "\u5B8C\u6210",
    'confluence.project-pages.improvement.provisioning-modal-carousel.controls.next': "\u4E0B\u4E00\u6B65",
    'project-pages.activating.description': "\u9023\u7D50\u7684 Confuence \u7A7A\u9593\u5C1A\u672A\u5C31\u7DD2\u3002\u5982\u679C\u91CD\u65B0\u6574\u7406\u7121\u6CD5\u89E3\u6C7A\u554F\u984C\uFF0C\u8ACB{contactSupport}",
    'project-pages.activating.heading': "Confluence \u9084\u5728\u8F09\u5165\u4E2D",
    'project-pages.better-together-templates.meeting-notes.action-items-heading': "\u4EC0\u9EBC\u662F\u4EA4\u8FA6\u4E8B\u9805\uFF1F",
    'project-pages.better-together-templates.meeting-notes.agenda-item-label': "\u8B70\u7A0B\u9805\u76EE",
    'project-pages.better-together-templates.meeting-notes.create-a-jira-issue': "\u8F38\u5165 /Jira \u4EE5\u5EFA\u7ACB\u8B70\u984C",
    'project-pages.better-together-templates.meeting-notes.date-label': "\u65E5\u671F",
    'project-pages.better-together-templates.meeting-notes.discussion-topics-heading': "\u8A0E\u8AD6\u4E3B\u984C",
    'project-pages.better-together-templates.meeting-notes.list-people': "\u5217\u51FA\u4F7F\u7528\u7684\u4EBA",
    'project-pages.better-together-templates.meeting-notes.mention': "\u63D0\u53CA",
    'project-pages.better-together-templates.meeting-notes.mention-people-to-assign-them': "\u8981\u6307\u6D3E\u81F3\u4EA4\u8FA6\u4E8B\u9805\u7684\u4EBA",
    'project-pages.better-together-templates.meeting-notes.notes-label': "\u9644\u8A3B",
    'project-pages.better-together-templates.meeting-notes.page-title': "\u6703\u8B70\u8A18\u9304",
    'project-pages.better-together-templates.meeting-notes.participants-label': "\u53C3\u8207\u8005",
    'project-pages.better-together-templates.meeting-notes.project-label': "\u5C08\u6848",
    'project-pages.better-together-templates.product-requirements.create-a-jira-issue': "\u8F38\u5165 /Jira \u4EE5\u5EFA\u7ACB\u8B70\u984C",
    'project-pages.better-together-templates.product-requirements.design-heading': "\u8A2D\u8A08",
    'project-pages.better-together-templates.product-requirements.embedd-different-data-views': "\u5D4C\u5165 Jira \u5C08\u6848\u4E2D\u4E0D\u540C\u7684\u8CC7\u6599\u548C\u6AA2\u8996\u756B\u9762\u3002",
    'project-pages.better-together-templates.product-requirements.heading': "\u6982\u89C0",
    'project-pages.better-together-templates.product-requirements.how-will-you-know-if-fixed': "\u5982\u4F55\u77E5\u9053\u662F\u5426\u5DF2\u4FEE\u6B63\uFF1F",
    'project-pages.better-together-templates.product-requirements.impact-heading': "\u5F71\u97FF\u529B",
    'project-pages.better-together-templates.product-requirements.inScopeStatus': "\u7BC4\u570D\u5167",
    'project-pages.better-together-templates.product-requirements.insert-design-link': "\u63D2\u5165\u60A8\u7684\u8A2D\u8A08\u9023\u7D50 (Figma \u7B49\u7B49)",
    'project-pages.better-together-templates.product-requirements.jira-issue-heading': "Jira \u8B70\u984C",
    'project-pages.better-together-templates.product-requirements.jira-roadmap-heading': "Jira \u85CD\u5716",
    'project-pages.better-together-templates.product-requirements.learn-how-with-smart-links': "\u4E86\u89E3\u5982\u4F55\u4F7F\u7528\u667A\u6167\u9023\u7D50",
    'project-pages.better-together-templates.product-requirements.list-dashboards': "\u5217\u51FA\u5100\u8868\u677F (Amplitude\u3001Mode \u7B49\u7B49)",
    'project-pages.better-together-templates.product-requirements.list-design-considerations': "\u5217\u51FA\u8A2D\u8A08\u6216\u5EFA\u7F6E\u8003\u91CF",
    'project-pages.better-together-templates.product-requirements.list-people': "\u5217\u51FA\u4F7F\u7528\u7684\u4EBA",
    'project-pages.better-together-templates.product-requirements.mention': "\u63D0\u53CA",
    'project-pages.better-together-templates.product-requirements.mention-people-to-assign-them': "\u8981\u6307\u6D3E\u81F3\u4EA4\u8FA6\u4E8B\u9805\u7684\u4EBA",
    'project-pages.better-together-templates.product-requirements.niceToHaveStatus': "\u6709\u6642\u9593\u518D\u505A",
    'project-pages.better-together-templates.product-requirements.outOfScopeStatus': "\u8D85\u51FA\u7BC4\u570D",
    'project-pages.better-together-templates.product-requirements.page-title': "\u7522\u54C1\u9700\u6C42",
    'project-pages.better-together-templates.product-requirements.pro-tip': "\u5C08\u696D\u79D8\u8A23\uFF1A",
    'project-pages.better-together-templates.product-requirements.problem-label': "\u554F\u984C",
    'project-pages.better-together-templates.product-requirements.requirement-heading': "\u9700\u6C42",
    'project-pages.better-together-templates.product-requirements.scope-heading': "\u7BC4\u570D",
    'project-pages.better-together-templates.product-requirements.success-metric': "\u6210\u529F\u6307\u6A19",
    'project-pages.better-together-templates.product-requirements.target-release-date': "\u76EE\u6A19\u767C\u5E03\u65E5\u671F",
    'project-pages.better-together-templates.product-requirements.team-label': "\u5718\u968A",
    'project-pages.better-together-templates.product-requirements.to-do-list-heading': "\u5F85\u8FA6\u4E8B\u9805\u6E05\u55AE",
    'project-pages.better-together-templates.product-requirements.what-are-you-trying-to-fix': "\u60A8\u60F3\u8981\u4FEE\u6B63\u4EC0\u9EBC\uFF1F",
    'project-pages.better-together-templates.retro-notes.retro-heading': "\u56DE\u9867",
    'project-pages.better-together-templates.retro.action-items-heading': "\u4EC0\u9EBC\u662F\u4EA4\u8FA6\u4E8B\u9805\uFF1F",
    'project-pages.better-together-templates.retro.create-a-jira-issue': "\u8F38\u5165 /Jira \u4EE5\u5EFA\u7ACB\u8B70\u984C",
    'project-pages.better-together-templates.retro.date-label': "\u65E5\u671F",
    'project-pages.better-together-templates.retro.embed-it-here': "\u5B8C\u6210\u5F8C\uFF0C\u53EF\u4EE5\u5728\u6B64\u8655\u5D4C\u5165\u3002",
    'project-pages.better-together-templates.retro.list-people': "\u5217\u51FA\u4F7F\u7528\u7684\u4EBA",
    'project-pages.better-together-templates.retro.mention': "\u63D0\u53CA",
    'project-pages.better-together-templates.retro.mention-people-to-assign-them': "\u8981\u6307\u6D3E\u81F3\u4EA4\u8FA6\u4E8B\u9805\u7684\u4EBA",
    'project-pages.better-together-templates.retro.page-title': "\u56DE\u9867",
    'project-pages.better-together-templates.retro.participants-label': "\u53C3\u8207\u8005",
    'project-pages.better-together-templates.retro.pro-tip': "\u5C08\u696D\u79D8\u8A23\uFF1A",
    'project-pages.better-together-templates.retro.project-label': "\u5C08\u6848",
    'project-pages.better-together-templates.retro.this-is-a-whiteboard': "\u9019\u662F Confluence \u767D\u677F\u3002",
    'project-pages.better-together-templates.retro.use-a-whiteboard': "\u4F7F\u7528 Confluence \u767D\u677F\u4F86\u9032\u884C\u56DE\u9867\u3002",
    'project-pages.better-together-templates.retro.use-it-to-vote': "\u53EF\u7528\u4F86\u6295\u7968\u4EE5\u53CA\u8207\u5718\u968A\u5354\u4F5C\u3002",
    'project-pages.button.connect-different-space-or-page.label': "\u66F4\u65B0\u7A7A\u9593\u6216\u9801\u9762\u5716\u793A",
    'project-pages.button.connect-different-space-or-page.tooltip': "\u9023\u63A5\u4E0D\u540C\u7684\u7A7A\u9593\u6216\u9805\u76EE",
    'project-pages.button.connect-space-or-page.tooltip': "\u9023\u7D50\u81F3 Confluence",
    'project-pages.button.go-to-connected-live-doc.tooltip': "\u5728 Confluence \u4E2D\u958B\u555F\u5373\u6642\u6587\u4EF6",
    'project-pages.button.go-to-connected-page.tooltip': "\u958B\u555F Confluence \u4E2D\u7684\u9801\u9762",
    'project-pages.button.go-to-connected-space.tooltip': "\u958B\u555F Confluence \u4E2D\u7684\u7A7A\u9593",
    'project-pages.connect-space-dialog.connection-error': "\u9023\u7D50\u5931\u6557\u3002",
    'project-pages.connect-space-dialog.connection-retry': "\u91CD\u8A66",
    'project-pages.connect-space-dialog.content.space-or-page-selector.description': "\u9078\u64C7\u8981\u8207\u5C08\u6848\u9023\u7D50\u7684\u7A7A\u9593\u6216\u9805\u76EE\u3002",
    'project-pages.connect-space-dialog.content.space-or-page-selector.placeholder': "\u641C\u5C0B Confluence",
    'project-pages.connect-space-dialog.content.space-selector.disconnected-templates-description': "\u6B64\u5C08\u6848\u9700\u5148\u9023\u7D50\u81F3\u7A7A\u9593\uFF0C\u624D\u53EF\u5EFA\u7ACB\u9805\u76EE\u3002\u9078\u64C7\u8981\u9023\u7D50\u81F3\u6B64\u5C08\u6848\u7684\u7A7A\u9593\u3002",
    'project-pages.connect-space-dialog.error-icon': "\u932F\u8AA4\uFF1A",
    'project-pages.connect-space-dialog.footer.cancel': "\u53D6\u6D88",
    'project-pages.connect-space-dialog.footer.connect-space': "\u9023\u7D50",
    'project-pages.connect-space-or-page-dialog.header.title': "\u5C07\u5C08\u6848\u8207 Confluence \u9023\u7D50",
    'project-pages.connect-space.description': "\u7A7A\u9593\u5982\u540C\u8CC7\u6599\u593E - \u60A8\u53EF\u4F7F\u7528\u7A7A\u9593\u4F86\u5EFA\u7ACB\u3001\u6574\u7406\u548C\u5354\u4F5C\u8207\u5C08\u6848\u76F8\u95DC\u7684\u6240\u6709\u5167\u5BB9\u3002",
    'project-pages.connect-space.not-connected.description': "\u82E5\u8981\u4F7F\u7528\u5C08\u6848\u9801\u9762\uFF0C\u8ACB\u8981\u6C42\u60A8\u7684\u7BA1\u7406\u54E1\u6216\u5718\u968A\u8CA0\u8CAC\u4EBA\u5C07 Confluence \u9023\u7D50\u5230\u6B64\u5C08\u6848\u3002",
    'project-pages.connect-space.not-connected.heading': "\u672A\u9023\u7D50\u81F3 Confluence",
    'project-pages.connect-success-flag.description.content': "\u5DF2\u6210\u529F\u9023\u7D50 {connectedSpaceOrPageName} \u5167\u5BB9\u3002",
    'project-pages.connection-error.space-or-page-not-found.button': "\u9023\u7D50\u81F3\u4E0D\u540C\u7684\u7A7A\u9593\u6216\u9801\u9762",
    'project-pages.create-space-dialog.connection-error': "\u9023\u7D50\u5931\u6557\u3002",
    'project-pages.create-space-dialog.connection-retry': "\u91CD\u8A66",
    'project-pages.create-space-dialog.content.empty-name': "\u8ACB\u70BA\u60A8\u7684\u7A7A\u9593\u547D\u540D\u3002",
    'project-pages.create-space-dialog.content.invalid-name': "\u7A7A\u9593\u540D\u7A31\u5FC5\u9808\u5305\u542B\u81F3\u5C11\u4E00\u500B\u5B57\u6BCD\u6216\u6578\u5B57\u3002",
    'project-pages.create-space-dialog.content.placeholder': "\u8F38\u5165\u7A7A\u9593\u540D\u7A31",
    'project-pages.create-space-dialog.creation-error': "\u7A7A\u9593\u5EFA\u7ACB\u5931\u6557\u3002",
    'project-pages.create-space-dialog.error-icon': "\u932F\u8AA4\uFF1A",
    'project-pages.create-space-dialog.footer.cancel': "\u53D6\u6D88",
    'project-pages.create-space-dialog.footer.create-space': "\u5EFA\u7ACB",
    'project-pages.create-space-dialog.header.title': "\u5EFA\u7ACB\u65B0\u7684 Confluence \u7A7A\u9593",
    'project-pages.cross-join.access-revoked.templates.subtitle': "\u60A8\u7121\u6CD5\u4F7F\u7528\u5C08\u6848\u9801\u9762\uFF0C\u56E0\u70BA\u7BA1\u7406\u54E1\u5DF2\u62D2\u7D55\u60A8\u5B58\u53D6 Confluence\u3002\u8ACB\u9023\u7D61\u60A8\u7684\u7DB2\u7AD9\u7BA1\u7406\u54E1\u4EE5\u8981\u6C42\u5B58\u53D6\u6B0A\u3002",
    'project-pages.cross-join.access-revoked.templates.title': "\u60A8\u6C92\u6709\u6B0A\u9650\uFF0C\u7121\u6CD5\u4F7F\u7528\u5C08\u6848\u9801\u9762",
    'project-pages.cross-join.avatar.view-profile': "\u6AA2\u8996\u8A2D\u5B9A\u6A94",
    'project-pages.cross-join.denied-request.templates.subtitle': "\u60A8\u7121\u6CD5\u4F7F\u7528\u5C08\u6848\u9801\u9762\uFF0C\u56E0\u70BA\u7DB2\u7AD9\u7BA1\u7406\u54E1\u5DF2\u62D2\u7D55\u60A8\u52A0\u5165 Confluence \u7684\u8981\u6C42\u3002",
    'project-pages.cross-join.denied-request.templates.title': "\u7BA1\u7406\u54E1\u5DF2\u62D2\u7D55\u60A8\u7684\u5B58\u53D6",
    'project-pages.cross-join.direct-access.button-subtitle.experimental': "\u60A8\u5C07\u53D6\u5F97 Confluence \u7684\u5B58\u53D6\u6B0A\u3002\u7DB2\u7AD9\u7BA1\u7406\u54E1\u5DF2\u5C07\u60A8\u6838\u51C6\u3002",
    'project-pages.cross-join.errors.unknown-error.description': "\u5982\u679C\u91CD\u65B0\u6574\u7406\u7121\u6CD5\u4FEE\u6B63\u554F\u984C\uFF0C\u8ACB{contactSupport}\u3002",
    'project-pages.cross-join.errors.unknown-error.title': "\u73FE\u5728\u7121\u6CD5\u986F\u793A\u5C08\u6848\u9801\u9762",
    'project-pages.cross-join.inline-join-product.button': "\u5B58\u53D6 Confluence\u3002\u7DB2\u7AD9\u7BA1\u7406\u54E1\u5DF2\u5C07\u60A8\u6838\u51C6\u3002",
    'project-pages.cross-join.inline-join-product.connected.description': "\u5F9E\u55AE\u4E00\u4F4D\u7F6E\u6AA2\u8996\u3001\u7DE8\u8F2F\u548C\u5EFA\u7ACB\u8AAA\u660E\u6587\u4EF6",
    'project-pages.cross-join.inline-join-product.connected.title': "\u8207\u60A8\u7684\u5718\u968A\u5728\u5C08\u6848\u9801\u9762\u4E0A\u5171\u540C\u4F5C\u696D",
    'project-pages.cross-join.pending-request.templates.subtitle': "\u7DB2\u7AD9\u7BA1\u7406\u54E1\u5DF2\u6536\u5230\u60A8\u8981\u52A0\u5165 Confluence \u7684\u8981\u6C42\u3002\u5982\u679C\u60A8\u5DF2\u7372\u5F97\u52A0\u5165\u7684\u6838\u51C6\uFF0C\u5C08\u6848\u9801\u9762\u6703\u958B\u59CB\u904B\u4F5C\uFF0C\u800C\u6211\u5011\u6703\u5C07\u78BA\u8A8D\u96FB\u5B50\u90F5\u4EF6\u50B3\u9001\u7D66\u60A8\u3002",
    'project-pages.cross-join.pending-request.templates.subtitle.experiment': "\u60A8\u7372\u5F97\u6838\u51C6\u5F8C\uFF0C\u5C07\u6536\u5230\u4E00\u5C01\u96FB\u5B50\u90F5\u4EF6\uFF0C\u5176\u4E2D\u5305\u542B\u300C\u5C08\u6848\u9801\u9762\u300D\u7684\u5B58\u53D6\u6B0A\u3002",
    'project-pages.cross-join.pending-request.templates.title': "\u60A8\u5DF2\u8981\u6C42 Confluence \u7684\u5B58\u53D6\u6B0A",
    'project-pages.cross-join.pending-request.templates.title.experiment': "\u5B58\u53D6\u6B0A\u8981\u6C42\u5DF2\u50B3\u9001\u7D66\u7BA1\u7406\u54E1",
    'project-pages.cross-join.request-access-without-better-together.connected.description': "\u8207\u60A8\u7684\u5718\u968A\u4E00\u8D77\u6AA2\u8996\u3001\u7DE8\u8F2F\u548C\u5EFA\u7ACB\u5C08\u6848\u8AAA\u660E\u6587\u4EF6",
    'project-pages.cross-join.request-access.button': "\u8981\u6C42\u5B58\u53D6\u6B0A",
    'project-pages.cross-join.request-access.button-subtitle.experimental': "\u7576\u60A8\u9078\u53D6\u300C\u52A0\u5165\u60A8\u7684\u5718\u968A\u300D\u6642\uFF0C\u5373\u8868\u793A\u60A8\u8981\u6C42\u52A0\u5165 Confluence\uFF0C\u4E26\u540C\u610F\u8207\u7BA1\u7406\u54E1\u5206\u4EAB\u60A8\u7684 Atlassian \u8A2D\u5B9A\u6A94\u3002",
    'project-pages.cross-join.request-access.button.experimental': "\u52A0\u5165\u60A8\u7684\u5718\u968A",
    'project-pages.cross-join.request-access.connected.description.experimental': "\u60A8\u7684\u5718\u968A\u6B63\u5728\u4F7F\u7528\u300C\u5C08\u6848\u9801\u9762\u300D\uFF0C\u5728\u5C08\u6848\u8AAA\u660E\u6587\u4EF6\u4E0A\u7559\u8A00\u3001\u7DE8\u8F2F\u548C\u5354\u4F5C\uFF0C\u5168\u90FD\u7121\u9808\u96E2\u958B Jira\u3002\u52A0\u5165 Confluence \u5373\u53EF\u5B58\u53D6\u60A8\u5C08\u6848\u7684\u300C\u5C08\u6848\u9801\u9762\u300D\u3002",
    'project-pages.cross-join.request-access.title': "\u5C08\u6848\u9801\u9762\u9700\u8981 Confluence \u7684\u5B58\u53D6\u6B0A",
    'project-pages.cross-join.request-access.title.experiment': "\u70BA\u60A8\u7684\u5718\u968A\u5EFA\u7ACB\u55AE\u4E00\u4E8B\u5BE6\u4F86\u6E90",
    'project-pages.default-contextual-heading': "\u5C08\u6848\u9801\u9762\u7531 Confluence \u6280\u8853\u652F\u63F4",
    'project-pages.default-contextual-message': "Confluence \u9801\u9762\u8B93\u60A8\u80FD\u5728\u540C\u4E00\u500B\u5730\u65B9\u5EFA\u7ACB\u3001\u5206\u4EAB\u4E26\u5354\u4F5C\u60A8\u6240\u6709\u7684\u5C08\u6848\u6587\u4EF6\u3002",
    'project-pages.default-reactivate-CTA': "\u91CD\u65B0\u555F\u7528 Confluence",
    'project-pages.default-trial-CTA': "\u514D\u8CBB\u8A66\u7528 30 \u5929 Confluence",
    'project-pages.draft-saved-flag.action': "\u958B\u555F\u8349\u7A3F",
    'project-pages.draft-saved-flag.description': "\u60A8\u7684\u8349\u7A3F\u5728\u767C\u4F48\u4E4B\u524D\uFF0C\u53EA\u6709\u60A8\u770B\u5F97\u5230\u3002",
    'project-pages.draft-saved-flag.title': "\u5DF2\u5132\u5B58\u8349\u7A3F",
    'project-pages.embedded-pages.create-page-error.close-button': "\u95DC\u9589",
    'project-pages.embedded-pages.create-page-error.description': "\u767C\u751F\u554F\u984C\uFF0C\u6211\u5011\u7121\u6CD5\u70BA\u60A8\u5EFA\u7ACB\u9801\u9762\u3002",
    'project-pages.embedded-pages.create-page-error.title': "\u6211\u5011\u7121\u6CD5\u5EFA\u7ACB\u9801\u9762",
    'project-pages.embedded-pages.create-page-error.try-again-button': "\u518D\u8A66\u4E00\u6B21",
    'project-pages.embedded-pages.modal.close.button.hint': "\u95DC\u9589",
    'project-pages.embedded-pages.modal.title.button': "\u5728 Confluence \u4E2D\u958B\u555F",
    'project-pages.embedded-pages.modal.title.button.hint': "\u5728\u65B0\u7D22\u5F15\u6A19\u7C64\u4E2D\u958B\u555F",
    'project-pages.errors.unknown-error.description.non-final': "\u5982\u679C\u91CD\u65B0\u6574\u7406\u7121\u6CD5\u89E3\u6C7A\u554F\u984C\uFF0C\u8ACB{contactSupport}",
    'project-pages.errors.unknown-error.title.non-final': "\u73FE\u5728\u7121\u6CD5\u986F\u793A\u5C08\u6848\u9801\u9762",
    'project-pages.generic-error.button.reload': "\u91CD\u65B0\u8F09\u5165\u9801\u9762",
    'project-pages.generic-error.description': "\u767C\u751F\u932F\u8AA4\u3002\u8ACB\u7A0D\u5F8C\u518D\u8A66\u4E00\u6B21\u3002",
    'project-pages.generic-error.description.non-final': "\u767C\u751F\u932F\u8AA4\u3002\u8ACB\u7A0D\u5F8C\u518D\u8A66\u4E00\u6B21\u3002",
    'project-pages.generic-error.heading': "\u55EF\uFF0C\u9019\u6709\u9EDE\u5947\u602A...",
    'project-pages.generic-error.title.non-final': "\u55EF\uFF0C\u9019\u6709\u9EDE\u5947\u602A...",
    'project-pages.generic-info-flag.description': "\u767C\u751F\u932F\u8AA4\u3002\u5982\u679C\u554F\u984C\u4ECD\u7136\u5B58\u5728\uFF0C\u8ACB\u518D\u8A66\u4E00\u6B21\u6216\u9023\u7D61\u652F\u63F4\u4EBA\u54E1",
    'project-pages.generic-success-flag.description.live-doc': "\u5DF2\u6210\u529F\u9023\u7D50\u300C{connectedSpaceOrPageName}\u300D\u5373\u6642\u6587\u4EF6\u3002",
    'project-pages.generic-success-flag.description.page': "\u5DF2\u6210\u529F\u9023\u7D50 {connectedSpaceOrPageName} \u9801\u9762\u3002",
    'project-pages.generic-success-flag.description.space': "\u5DF2\u6210\u529F\u8207 {connectedSpaceOrPageName} \u7A7A\u9593\u9023\u7D50\u3002",
    'project-pages.generic-success-flag.heading.live-doc': "\u5DF2\u9023\u7D50\u5373\u6642\u6587\u4EF6",
    'project-pages.generic-success-flag.heading.page': "\u9801\u9762\u5DF2\u9023\u7D50",
    'project-pages.generic-success-flag.heading.space': "\u7A7A\u9593\u5DF2\u9023\u7D50",
    'project-pages.granular-pages.connect-space-dialog.content.create-space-link.link-text': "\u6216\u5EFA\u7ACB\u65B0\u7A7A\u9593",
    'project-pages.granular-pages.connect-space.button': "\u9023\u7D50\u81F3 Confluence",
    'project-pages.granular-pages.connect-space.heading': "\u5C07\u6B64\u5C08\u6848\u9023\u7D50\u81F3 Confluence \u7A7A\u9593\u6216\u9805\u76EE",
    'project-pages.improvement.contact-support': "\u9023\u7D61\u652F\u63F4\u4EBA\u54E1",
    'project-pages.improvement.errors.access-error.description': "\u8ACB\u5617\u8A66\u8207\u7DB2\u7AD9\u7BA1\u7406\u54E1\u9023\u7D61\u4EE5\u8ACB\u6C42\u5B58\u53D6\u6B0A\u3002",
    'project-pages.improvement.errors.access-error.title': "\u60A8\u6C92\u6709\u6AA2\u8996\u5C08\u6848\u9801\u9762\u7684\u6B0A\u9650",
    'project-pages.improvement.errors.page-tree-unknown-error.description': "\u5617\u8A66\u5F9E\u60A8\u9023\u7D50\u7684 Confluence \u7A7A\u9593\u986F\u793A\u9801\u9762\u6642\u767C\u751F\u932F\u8AA4\u3002\u5982\u679C\u91CD\u65B0\u6574\u7406\u7121\u6CD5\u89E3\u6C7A\u554F\u984C\uFF0C\u8ACB{contactSupport}",
    'project-pages.improvement.errors.page-tree-unknown-error.title': "\u986F\u793A\u5C08\u6848\u9801\u9762\u6642\u767C\u751F\u554F\u984C",
    'project-pages.improvement.errors.space-or-page-not-found.description': "\u9023\u7D50\u7684 Confluence \u7A7A\u9593\u6216\u9801\u9762\u5DF2\u79FB\u52D5\u3001\u5C01\u5B58\u6216\u522A\u9664\u3002\u5982\u679C\u91CD\u65B0\u9023\u7D50\u7121\u6CD5\u89E3\u6C7A\u554F\u984C\uFF0C\u8ACB<link>\u9023\u7D61\u652F\u63F4\u5718\u968A</link>",
    'project-pages.improvement.errors.space-or-page-not-found.title': "\u627E\u4E0D\u5230\u7A7A\u9593\u6216\u9801\u9762",
    'project-pages.improvement.errors.unknown-error.description': "\u5982\u679C\u91CD\u65B0\u6574\u7406\u7121\u6CD5\u89E3\u6C7A\u554F\u984C\uFF0C\u8ACB{contactSupport}",
    'project-pages.improvement.errors.unknown-error.title': "\u73FE\u5728\u7121\u6CD5\u986F\u793A\u5C08\u6848\u9801\u9762",
    'project-pages.improvement.feature1': "\u7121\u9700\u96E2\u958B Jira \u5373\u53EF\u5B58\u53D6\u548C\u5EFA\u7ACB\u6587\u4EF6",
    'project-pages.improvement.feature2': "\u9069\u7528\u65BC\u6703\u8B70\u548C\u885D\u523A\u8A08\u756B\u7B49\u7528\u9014\u7684\u7BC4\u672C",
    'project-pages.improvement.feature3': "\u5C07\u6587\u4EF6\u540C\u6B65\u5230 Jira \u4EE5\u81EA\u52D5\u66F4\u65B0",
    'project-pages.improvement.heading-info': "\u638C\u63E1\u60A8\u7684\u5718\u968A\uFF0C\u4E26\u6539\u5584\u5B8C\u6210\u5DE5\u4F5C\u7684\u65B9\u5F0F\u3002",
    'project-pages.improvement.heading-info-v2': "\u70BA\u5718\u968A\u7684\u6240\u6709\u5C08\u6848\u6587\u4EF6\u5EFA\u7ACB\u55AE\u4E00\u4F4D\u7F6E",
    'project-pages.improvement.learn-more-button': "\u4E86\u89E3\u66F4\u591A",
    'project-pages.improvement.powered-by': "\u7531\u4EE5\u4E0B\u6280\u8853\u652F\u63F4\uFF1A",
    'project-pages.improvement.powered-by.tooltip': "\u5728\u65B0\u7684\u7D22\u5F15\u6A19\u7C64\u4E2D\u958B\u555F Confluence",
    'project-pages.improvement.preview-teaser': "\u89E3\u9396\u7BC4\u672C\u3001\u5C08\u6848\u9801\u9762\u7B49\u7B49\u3002",
    'project-pages.improvement.provisioning-info-modal.seamlessly-update-stakeholders.description': "<p>\u900F\u904E\u81EA\u52D5\u66F4\u65B0\u72C0\u614B\u6A19\u7C64\uFF0C\u8B93\u5C08\u6848\u5831\u544A\u4FDD\u6301\u6700\u65B0\u72C0\u614B\u3002</p><p>\u53EA\u9700\u5C07 Jira \u5DE5\u55AE\u9023\u7D50\u5230\u6587\u4EF6\u4E2D\uFF0C\u5C31\u6703\u81EA\u52D5\u986F\u793A\u8207\u5DE5\u55AE\u540C\u6B65\u66F4\u65B0\u7684\u72C0\u614B\u6A19\u7C64\uFF0C\u56E0\u6B64\u60A8\u53EF\u4EE5\u7701\u4E0B\u624B\u52D5\u88FD\u4F5C\u5831\u544A\u7684\u6642\u9593\u3002</p>",
    'project-pages.improvement.provisioning-info-modal.seamlessly-update-stakeholders.title': "\u7ACB\u5373\u544A\u77E5\u76F8\u95DC\u4EBA\u54E1",
    'project-pages.improvement.provisioning-info-modal.unify-documentation-standards.description': "<p>\u4F7F\u7528\u6211\u5011\u7684\u5167\u5EFA\u7BC4\u672C\u5EFA\u7ACB\u4E00\u81F4\u7684\u8AAA\u660E\u6587\u4EF6\u3002\u9019\u4E9B\u7BC4\u672C\u4F7F\u7528\u65B9\u4FBF\uFF0C\u60A8\u53EF\u4EE5\u6839\u64DA\u9700\u6C42\u81EA\u8A02\u3002</p><p>\u60A8\u53EF\u4EE5\u76F4\u63A5\u5F9E\u5C08\u6848\u9801\u9762\u4F7F\u7528\u7BC4\u672C\uFF0C\u56E0\u6B64\u60A8\u4E0D\u5FC5\u96E2\u958B\u6B63\u5728\u5DE5\u4F5C\u7684\u5167\u5BB9\u3002<a>\u6B64\u8655</a>\u53EF\u700F\u89BD\u6240\u6709\u7BC4\u672C\u3002</p>",
    'project-pages.improvement.provisioning-info-modal.unify-documentation-standards.title': "\u7D71\u4E00\u60A8\u7684\u8AAA\u660E\u6587\u4EF6\u6A19\u6E96",
    'project-pages.improvement.provisioning-info-modal.your-project-pages-in-jira.description': "<p>\u5F9E Jira \u4E2D\u7684\u5C08\u6848\u9801\u9762\u5206\u9801\u4E2D\u5EFA\u7ACB\u548C\u7BA1\u7406\u8AAA\u660E\u6587\u4EF6\uFF0C\u4EE5\u5EFA\u7ACB\u91CD\u8981\u8CC7\u8A0A\u7684\u55AE\u4E00\u4E8B\u5BE6\u4F86\u6E90\u3002</p><p>\u60A8\u77E5\u9053\u5C08\u6848\u9801\u9762\u662F\u5728 Confluence \u4E0A\u57F7\u884C\u55CE\uFF1F\u6700\u591A\u53EF\u4F9B 10 \u4F4D\u4F7F\u7528\u8005\u514D\u8CBB\u4F7F\u7528\u3002\u8ACB\u5728\u7BA1\u7406\u54E1\u8A2D\u5B9A\u4E2D\u9080\u8ACB\u5718\u968A\u7684\u5176\u4ED6\u4EBA\u3002</p>",
    'project-pages.improvement.provisioning-info-modal.your-project-pages-in-jira.title': "\u60A8\u7684\u5C08\u6848\u9801\u9762\uFF0C\u5C31\u5728 Jira",
    'project-pages.improvement.templates-sidebar.better-together-templates-header': "\u8207\u60A8\u7684 Jira \u8CC7\u6599\u6574\u5408\u7684\u7BC4\u672C",
    'project-pages.improvement.templates.better-together-preview-teaser': "\u5DF2\u8207 Jira \u8CC7\u6599\u6574\u5408",
    'project-pages.improvement.templates.blank-page.description': "\u5F9E\u982D\u958B\u59CB\u5EFA\u7ACB\u4E00\u500B\u9801\u9762",
    'project-pages.improvement.templates.blank-page.name': "\u7A7A\u767D\u9801\u9762",
    'project-pages.improvement.templates.decision.description': "\u8A18\u9304\u91CD\u8981\u7684\u5C08\u6848\u6C7A\u5B9A\uFF0C\u4E26\u8207\u60A8\u7684\u5718\u968A\u9032\u884C\u6E9D\u901A\u3002",
    'project-pages.improvement.templates.decision.name': "\u6C7A\u5B9A",
    'project-pages.improvement.templates.meeting-notes.description': "\u8A2D\u5B9A\u6703\u8B70\u8B70\u7A0B\u3001\u505A\u7B46\u8A18\uFF0C\u4E26\u5C07\u4EA4\u8FA6\u4E8B\u9805\u5206\u4EAB\u7D66\u60A8\u7684\u5718\u968A\u3002",
    'project-pages.improvement.templates.meeting-notes.name': "\u6703\u8B70\u7B46\u8A18",
    'project-pages.improvement.templates.post-expand.more': "\u66F4\u591A\u7BC4\u672C",
    'project-pages.improvement.templates.post-expand.more.tooltip': "\u6AA2\u8996 Confluence \u4E2D\u6240\u6709\u7684\u7BC4\u672C",
    'project-pages.improvement.templates.post-expand.subtitle': "\u71B1\u9580\u7BC4\u672C",
    'project-pages.improvement.templates.post-expand.title': "\u5EFA\u7ACB\u9801\u9762",
    'project-pages.improvement.templates.pre-expand.more': "\u63A2\u7D22\u66F4\u591A\u7684\u7BC4\u672C",
    'project-pages.improvement.templates.pre-expand.subtitle': "\u53D7\u5230\u50CF\u60A8\u5011\u9019\u6A23\u7684\u5718\u968A\u6B61\u8FCE\u3002",
    'project-pages.improvement.templates.pre-expand.title': "\u9810\u89BD\u7BC4\u672C",
    'project-pages.improvement.templates.product-requirements.description': "\u70BA\u60A8\u7684\u7522\u54C1\u6216\u529F\u80FD\u5B9A\u7FA9\u3001\u8FFD\u8E64\u548C\u9650\u5B9A\u9700\u6C42\u7BC4\u570D\u3002",
    'project-pages.improvement.templates.product-requirements.name': "\u7522\u54C1\u9700\u6C42",
    'project-pages.improvement.templates.retrospective.description': "\u9806\u5229\u55CE\uFF1F\u9084\u6709\u4EC0\u9EBC\u53EF\u4EE5\u6539\u9032\uFF1F\u8207\u60A8\u7684\u5718\u968A\u96C6\u601D\u5EE3\u76CA\u5982\u4F55\u6539\u9032\u3002",
    'project-pages.improvement.templates.retrospective.name': "\u56DE\u9867",
    'project-pages.improvement.templates.template.disabled-tooltip': "\u8ACB\u5148\u8207 Confluence \u7A7A\u9593\u9023\u7D50",
    'project-pages.improvement.templates.tutorial.content.confluence-templates': "<b>\u7BC0\u7701\u6642\u9593\u4E26\u6E1B\u5C11\u624B\u52D5\u4EFB\u52D9</b>\u3002Confluence \u6709\u5F88\u591A\u9801\u9762<a>\u7BC4\u672C</a>\uFF0C\u56E0\u6B64\u60A8\u7121\u9808\u5F9E\u982D\u958B\u59CB\u3002\u6709\u6280\u8853\u6587\u4EF6\u3001\u7591\u96E3\u6392\u89E3\u6307\u5357\u3001\u5C08\u6848\u8A08\u756B\u3001\u7522\u54C1\u9700\u6C42\u7B49\u591A\u7A2E\u7BC4\u672C\u3002",
    'project-pages.improvement.templates.tutorial.content.edit-and-format': "<b>\u8F15\u9B06\u7DE8\u8F2F\u548C\u8A2D\u5B9A\u683C\u5F0F\u3002</b>\u4F7F\u7528\u9802\u7AEF\u7684\u7DE8\u8F2F\u9078\u55AE\u8A2D\u5B9A\u6A19\u6E96\u7684\u6587\u5B57\u683C\u5F0F\uFF0C\u4E26\u900F\u904E\u8F38\u5165 <b>/</b> \u8F15\u9B06\u63D2\u5165\u8A31\u591A\u5BE6\u7528\u7684\u6574\u5408\u529F\u80FD\u3002\u8F38\u5165 <c>/table</c> \u5373\u53EF\u63D2\u5165\u8868\u683C\uFF0C\u8F38\u5165 <c>/image</c> \u5373\u53EF\u63D2\u5165\u5716\u7247\u3002\u60A8\u9084\u53EF\u4EE5\u4F7F\u7528 <c>/dropbox</c> \u63D2\u5165 Dropbox \u9023\u7D50\u3001\u4F7F\u7528 <c>/microsoft</c> \u63D2\u5165 Microsoft office \u5DE5\u5177\uFF0C\u6216\u4F7F\u7528 <c>/trello</c> \u63D2\u5165 Trello \u770B\u677F\u548C\u5361\u7247\u3002",
    'project-pages.improvement.templates.tutorial.content.forward-slash-prompt': "\u8F38\u5165 / \u5F8C\u65B9\u63A5\u8457 \u2018table\u2019 \u6216 \u2018image\u2019",
    'project-pages.improvement.templates.tutorial.content.getting-started-tips': "\u9019\u88E1\u6709\u5E7E\u500B\u63D0\u793A\uFF0C\u53EF\u5354\u52A9\u60A8\u958B\u59CB\uFF1A",
    'project-pages.improvement.templates.tutorial.content.handy-links': "\u5BE6\u7528\u7684\u9023\u7D50",
    'project-pages.improvement.templates.tutorial.content.jira-and-confluence': "\u4E00\u8D77\u4F7F\u7528 Jira \u548C Confluence",
    'project-pages.improvement.templates.tutorial.content.jira-charts': "\u4F7F\u7528\u5BE6\u969B\u7684 Jira \u8CC7\u6599\uFF0C\u5728\u9801\u9762\u4E0A\u5EFA\u7ACB\u5716\u8868\u3002\u8F38\u5165 <c>/Jira charts</c>\u3002",
    'project-pages.improvement.templates.tutorial.content.jira-links': "\u5728\u9801\u9762\u4E0A\u7684\u4EFB\u4F55\u4F4D\u7F6E\u9023\u7D50 Jira \u8B70\u984C\u3002\u7576\u60A8\u66F4\u65B0 Jira \u8B70\u984C\u6642\uFF0C\u9801\u9762\u4E0A\u7684\u9023\u7D50\u5C07\u5373\u6642\u66F4\u65B0\u3002\u8F38\u5165 <c>/Jira</c>\u3002",
    'project-pages.improvement.templates.tutorial.content.jira-links-issue-term-refresh': "\u5C07 Jira \u5DE5\u4F5C\u9805\u76EE\u9023\u7D50\u81F3\u9801\u9762\u4E0A\u7684\u4EFB\u4F55\u4F4D\u7F6E\u3002\u7576\u60A8\u66F4\u65B0\u5DE5\u4F5C\u9805\u76EE\u6642\uFF0C\u9801\u9762\u4E0A\u7684\u9023\u7D50\u5C07\u5373\u6642\u66F4\u65B0\u3002\u8ACB\u8F38\u5165 <c>/Jira</c>\u3002",
    'project-pages.improvement.templates.tutorial.content.jira-links.non-final-issue-term-refresh': "\u5C07 Jira \u5DE5\u4F5C\u9805\u76EE\u9023\u7D50\u81F3\u9801\u9762\u4E0A\u7684\u4EFB\u4F55\u4F4D\u7F6E\u3002\u7576\u60A8\u66F4\u65B0\u5DE5\u4F5C\u9805\u76EE\u6642\uFF0C\u9801\u9762\u4E0A\u7684\u9023\u7D50\u5C07\u5373\u6642\u66F4\u65B0\u3002\u8ACB\u8F38\u5165 <c>/Jira</c>\u3002",
    'project-pages.improvement.templates.tutorial.content.jira-roadmaps': "\u4F7F\u7528 Jira \u5C08\u6848\u70BA\u60A8\u7684\u9801\u9762\u5D4C\u5165\u4E92\u52D5\u5F0F\u7684\u85CD\u5716\u548C\u6642\u9593\u8868\u3002\u8F38\u5165 <c>/jira roadmap</c>\u3002",
    'project-pages.improvement.templates.tutorial.content.jira-timeline': "\u4F7F\u7528 Jira \u5C08\u6848\u70BA\u60A8\u7684\u9801\u9762\u5D4C\u5165\u4E92\u52D5\u5F0F\u6642\u9593\u8EF8\u3002\u8ACB\u8F38\u5165 <c>/jira \u6642\u9593\u8EF8</c>\u3002",
    'project-pages.improvement.templates.tutorial.content.shipping-speed-statistic': "76\uFF05 \u7684 Jira Software \u5BA2\u6236\u8868\u793A\uFF0C\u4ED6\u5011\u5728\u65B0\u589E Confluence \u5F8C\u80FD\u66F4\u5FEB\u4EA4\u4ED8\u5C08\u6848",
    'project-pages.improvement.templates.tutorial.content.shipping-speed-statistic.spork-rebranding': "76\uFF05 \u7684 Jira \u5BA2\u6236\u8868\u793A\uFF0C\u4ED6\u5011\u5728\u65B0\u589E Confluence \u5F8C\u80FD\u66F4\u5FEB\u4EA4\u4ED8\u5C08\u6848",
    'project-pages.improvement.templates.tutorial.content.spaces-and-pages': "<b>\u4F7F\u7528\u7A7A\u9593\u548C\u9801\u9762</b>\u3002\u7A7A\u9593\u662F\u6BCF\u500B Confluence \u7DB2\u7AD9\u7684\u4E00\u90E8\u5206\uFF0C\u4E26\u4E14\u662F\u5C07\u9801\u9762\u7D44\u7E54\u70BA\u985E\u5225\u7684\u4E00\u7A2E\u65B9\u5F0F\u3002\u5C07\u7A7A\u9593\u8996\u70BA\u4E0D\u540C\u7684\u8CC7\u6599\u593E\u6216\u5C08\u6848\uFF0C\u800C\u9801\u9762\u5247\u662F\u5C6C\u65BC\u9019\u4E9B\u8CC7\u6599\u593E\u6216\u5C08\u6848\u4E2D\u7684\u6587\u4EF6\u3002<a>\u9032\u4E00\u6B65\u4E86\u89E3\u5982\u4F55\u4F7F\u7528\u7A7A\u9593</a>",
    'project-pages.improvement.templates.tutorial.content.try-it-now': "\u7ACB\u523B\u8A66\u7528",
    'project-pages.improvement.templates.tutorial.description': "\u4E86\u89E3\u5982\u4F55\u7DE8\u8F2F\u9801\u9762\u3002",
    'project-pages.improvement.templates.tutorial.name': "\u6B61\u8FCE\u4F86\u5230\u300C\u5C08\u6848\u9801\u9762\u300D\uFF01",
    'project-pages.improvement.terms-and-conditions-v2': "\u9078\u53D6\u300C\u7ACB\u5373\u8A66\u7528\u300D\u5373\u8868\u793A\u60A8\u78BA\u8A8D\u5C07\u65BC Confluence \u4E2D\u8A3B\u518A\uFF0C\u4E26\u4E14\u540C\u610F Atlassian<termsLink> Cloud \u670D\u52D9\u689D\u6B3E</termsLink>\u548C<privacyLink>\u96B1\u79C1\u653F\u7B56</privacyLink>\u3002",
    'project-pages.improvement.title': "\u5C08\u6848\u9801\u9762",
    'project-pages.improvement.transient-states.empty-state.auto-provisioned-create-page-button': "\u5EFA\u7ACB\u9801\u9762",
    'project-pages.improvement.transient-states.empty-state.auto-provisioned-description': "\u6211\u5011\u5DF2\u65B0\u589E Confluence\uFF0C\u4EE5\u4FBF\u60A8\u958B\u59CB\u5EFA\u7ACB\u548C\u9023\u7D50\u6240\u6709\u5C08\u6848\u6587\u4EF6\u3002\u6700\u591A\u53EF\u4F9B 10 \u4F4D\u4F7F\u7528\u8005\u514D\u8CBB\u4F7F\u7528\u3002",
    'project-pages.improvement.transient-states.empty-state.auto-provisioned-learn-more-button': "\u4E86\u89E3\u66F4\u591A",
    'project-pages.improvement.transient-states.empty-state.create-page-button': "\u5EFA\u7ACB\u60A8\u7684\u7B2C\u4E00\u500B\u9801\u9762",
    'project-pages.improvement.transient-states.empty-state.description': "\u5EFA\u7ACB\u4E00\u4E9B\u6703\u8B70\u7B46\u8A18\u3001\u7522\u54C1\u8981\u6C42\u3001\u6C7A\u7B56\u6216\u5176\u4ED6\u5167\u5BB9\uFF0C\u4EE5\u67E5\u770B\u6B64\u7A7A\u9593\u662F\u5426\u5DF2\u586B\u6EFF\u3002",
    'project-pages.improvement.transient-states.empty-state.title': "\u9019\u88E1\u76EE\u524D\u4EC0\u9EBC\u90FD\u6C92\u6709\uFF0C\u53EA\u6709\u6F5B\u529B\u7121\u9650",
    'project-pages.improvement.try-button': "\u5728 Confluence \u4E2D\u8A66\u7528\u6B64\u7BC4\u672C",
    'project-pages.improvement.try-it-now': "\u7ACB\u523B\u8A66\u7528",
    'project-pages.improvement.try-lozenge': "\u8A66\u7528",
    'project-pages.improvement.try-on-demand-button': "\u514D\u8CBB\u8A66\u7528",
    'project-pages.page-deleted-flag.title': "\u5DF2\u522A\u9664\u9801\u9762\u3002",
    'project-pages.page-published-flag.title': "\u60A8\u7684\u9801\u9762\u5DF2\u767C\u4F48\u3002",
    'project-pages.unknown-error.description': "\u5982\u679C\u91CD\u65B0\u6574\u7406\u7121\u6CD5\u89E3\u6C7A\u554F\u984C\uFF0C\u8ACB{contactSupport}",
    'project-pages.unknown-error.heading': "\u73FE\u5728\u7121\u6CD5\u986F\u793A\u5C08\u6848\u9801\u9762"
};

});

parcelRegister("2CsJu", function(module, exports) {

$parcel$export(module.exports, "default", () => $7457c99de122645f$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Czech
var $7457c99de122645f$export$2e2bcd8739ae039 = {
    'confluence.project-pages.improvement.provisioning-background.text': "Nem\u011Blo by to trvat ani minutu.",
    'confluence.project-pages.improvement.provisioning-background.title': "Prob\xedh\xe1 nastavov\xe1n\xed va\u0161ich str\xe1nek projektu",
    'confluence.project-pages.improvement.provisioning-modal-carousel.controls.dismiss': "Zav\u0159\xedt",
    'confluence.project-pages.improvement.provisioning-modal-carousel.controls.done': 'Hotovo',
    'confluence.project-pages.improvement.provisioning-modal-carousel.controls.next': "Dal\u0161\xed",
    'project-pages.activating.description': "P\u0159ipojen\xfd prostor Confluence je\u0161t\u011B nen\xed p\u0159ipraven\xfd. {contactSupport}, pokud probl\xe9m nevy\u0159e\u0161\xed obnoven\xed str\xe1nky.",
    'project-pages.activating.heading': "Confluence se st\xe1le na\u010D\xedt\xe1",
    'project-pages.better-together-templates.meeting-notes.action-items-heading': "Jak\xe9 jsou to polo\u017Eky akce?",
    'project-pages.better-together-templates.meeting-notes.agenda-item-label': "Polo\u017Eka agendy",
    'project-pages.better-together-templates.meeting-notes.create-a-jira-issue': "Zadejte /Jira a\xa0vytvo\u0159te po\u017Eadavek.",
    'project-pages.better-together-templates.meeting-notes.date-label': 'Datum',
    'project-pages.better-together-templates.meeting-notes.discussion-topics-heading': "T\xe9mata diskuze",
    'project-pages.better-together-templates.meeting-notes.list-people': "uve\u010Fte lidi pomoc\xed",
    'project-pages.better-together-templates.meeting-notes.mention': "@zm\xednit",
    'project-pages.better-together-templates.meeting-notes.mention-people-to-assign-them': "lidi, abyste je p\u0159i\u0159adili k\xa0polo\u017Ek\xe1m akce.",
    'project-pages.better-together-templates.meeting-notes.notes-label': "Pozn\xe1mky",
    'project-pages.better-together-templates.meeting-notes.page-title': "Z\xe1pis ze sch\u016Fzky",
    'project-pages.better-together-templates.meeting-notes.participants-label': "\xda\u010Dastn\xedci",
    'project-pages.better-together-templates.meeting-notes.project-label': 'Projekt',
    'project-pages.better-together-templates.product-requirements.create-a-jira-issue': "Zadejte /Jira a\xa0vytvo\u0159te po\u017Eadavek.",
    'project-pages.better-together-templates.product-requirements.design-heading': 'Design',
    'project-pages.better-together-templates.product-requirements.embedd-different-data-views': "Vkl\xe1dejte r\u016Fzn\xe1 data a\xa0zobrazen\xed z\xa0projektu Jira.",
    'project-pages.better-together-templates.product-requirements.heading': "P\u0159ehled",
    'project-pages.better-together-templates.product-requirements.how-will-you-know-if-fixed': "Jak zjist\xedte, zda jste to opravili?",
    'project-pages.better-together-templates.product-requirements.impact-heading': 'Dopad',
    'project-pages.better-together-templates.product-requirements.inScopeStatus': "V\xa0rozsahu",
    'project-pages.better-together-templates.product-requirements.insert-design-link': "Vlo\u017Ete odkaz na sv\u016Fj n\xe1vrh (Figma atd.).",
    'project-pages.better-together-templates.product-requirements.jira-issue-heading': "Po\u017Eadavek Jira",
    'project-pages.better-together-templates.product-requirements.jira-roadmap-heading': "Pl\xe1n Jira",
    'project-pages.better-together-templates.product-requirements.learn-how-with-smart-links': "Nau\u010Dte se pou\u017E\xedvat chytr\xe9 odkazy.",
    'project-pages.better-together-templates.product-requirements.list-dashboards': "Uve\u010Fte dashboardy (Amplitude, Mode atd.).",
    'project-pages.better-together-templates.product-requirements.list-design-considerations': "Uve\u010Fte hlediska n\xe1vrhu nebo sestaven\xed.",
    'project-pages.better-together-templates.product-requirements.list-people': "uve\u010Fte lidi, kte\u0159\xed pou\u017E\xedvaj\xed",
    'project-pages.better-together-templates.product-requirements.mention': "zm\xednit",
    'project-pages.better-together-templates.product-requirements.mention-people-to-assign-them': "lidi, abyste je p\u0159i\u0159adili k\xa0polo\u017Ek\xe1m akce.",
    'project-pages.better-together-templates.product-requirements.niceToHaveStatus': "Bylo by dobr\xe9 m\xedt",
    'project-pages.better-together-templates.product-requirements.outOfScopeStatus': 'Mimo rozsah',
    'project-pages.better-together-templates.product-requirements.page-title': "Po\u017Eadavky produktu",
    'project-pages.better-together-templates.product-requirements.pro-tip': 'Profi tip:',
    'project-pages.better-together-templates.product-requirements.problem-label': "Probl\xe9m",
    'project-pages.better-together-templates.product-requirements.requirement-heading': "Po\u017Eadavek",
    'project-pages.better-together-templates.product-requirements.scope-heading': 'Rozsah',
    'project-pages.better-together-templates.product-requirements.success-metric': "Metrika \xfasp\u011Bchu",
    'project-pages.better-together-templates.product-requirements.target-release-date': "C\xedlov\xe9 datum vyd\xe1n\xed",
    'project-pages.better-together-templates.product-requirements.team-label': "T\xfdm",
    'project-pages.better-together-templates.product-requirements.to-do-list-heading': "Seznam \xfakol\u016F",
    'project-pages.better-together-templates.product-requirements.what-are-you-trying-to-fix': "Co se sna\u017E\xedte opravit?",
    'project-pages.better-together-templates.retro-notes.retro-heading': "Retrospektivn\xed",
    'project-pages.better-together-templates.retro.action-items-heading': "Jak\xe9 jsou to polo\u017Eky akce?",
    'project-pages.better-together-templates.retro.create-a-jira-issue': "Zadejte /Jira a\xa0vytvo\u0159te po\u017Eadavek.",
    'project-pages.better-together-templates.retro.date-label': 'Datum',
    'project-pages.better-together-templates.retro.embed-it-here': "Po dokon\u010Den\xed ji m\u016F\u017Eete vlo\u017Eit sem.",
    'project-pages.better-together-templates.retro.list-people': "uve\u010Fte lidi, kte\u0159\xed pomoc\xed",
    'project-pages.better-together-templates.retro.mention': "@zm\xednit",
    'project-pages.better-together-templates.retro.mention-people-to-assign-them': "lidi, abyste je p\u0159i\u0159adili k\xa0polo\u017Ek\xe1m akce.",
    'project-pages.better-together-templates.retro.page-title': "Retrospektivn\xed",
    'project-pages.better-together-templates.retro.participants-label': "\xda\u010Dastn\xedci",
    'project-pages.better-together-templates.retro.pro-tip': 'Profi tip:',
    'project-pages.better-together-templates.retro.project-label': 'Projekt',
    'project-pages.better-together-templates.retro.this-is-a-whiteboard': 'Toto je tabule Confluence.',
    'project-pages.better-together-templates.retro.use-a-whiteboard': "Pou\u017Eijte pro svou retrospektivu tabuli Confluence.",
    'project-pages.better-together-templates.retro.use-it-to-vote': "Pou\u017Eijte ji k\xa0hlasov\xe1n\xed a\xa0spolupr\xe1ci se sv\xfdm t\xfdmem.",
    'project-pages.button.connect-different-space-or-page.label': "Ikona aktualizace prostoru nebo str\xe1nky",
    'project-pages.button.connect-different-space-or-page.tooltip': "P\u0159ipojit jin\xfd prostor nebo polo\u017Eku",
    'project-pages.button.connect-space-or-page.tooltip': "P\u0159ipojit ke Confluence",
    'project-pages.button.go-to-connected-live-doc.tooltip': "Otev\u0159\xedt \u017Eiv\xfd dokument v\xa0Confluence",
    'project-pages.button.go-to-connected-page.tooltip': "Otev\u0159\xedt str\xe1nku v\xa0Confluence",
    'project-pages.button.go-to-connected-space.tooltip': "Otev\u0159\xedt prostor v\xa0Confluence",
    'project-pages.connect-space-dialog.connection-error': "P\u0159ipojen\xed se nezda\u0159ilo.",
    'project-pages.connect-space-dialog.connection-retry': 'Zkusit znovu',
    'project-pages.connect-space-dialog.content.space-or-page-selector.description': "Vyberte prostor nebo polo\u017Eku, kter\xe9 k\xa0tomuto projektu chcete p\u0159ipojit.",
    'project-pages.connect-space-dialog.content.space-or-page-selector.placeholder': "Vyhledat v r\xe1mci Confluence",
    'project-pages.connect-space-dialog.content.space-selector.disconnected-templates-description': "P\u0159ed vytvo\u0159en\xedm polo\u017Eky je nutn\xe9 p\u0159ipojit tento projekt k\xa0prostoru. Vyberte prostor, kter\xfd k tomuto projektu chcete p\u0159ipojit.",
    'project-pages.connect-space-dialog.error-icon': 'Chyba:',
    'project-pages.connect-space-dialog.footer.cancel': "Zru\u0161it",
    'project-pages.connect-space-dialog.footer.connect-space': "P\u0159ipojit",
    'project-pages.connect-space-or-page-dialog.header.title': "P\u0159ipojit projekt ke Confluence",
    'project-pages.connect-space.description': "Prostory jsou jako slo\u017Eky \u2013 m\u016F\u017Eete je vyu\u017E\xedt k vytv\xe1\u0159en\xed obsahu souvisej\xedc\xedho s va\u0161\xedm projektem, jeho organizaci nebo spolupr\xe1ci na n\u011Bm.",
    'project-pages.connect-space.not-connected.description': "Chcete-li pou\u017E\xedvat str\xe1nky projektu, obra\u0165te se na spr\xe1vce nebo vedouc\xedho t\xfdmu a\xa0p\u0159ipojte k\xa0tomuto projektu Confluence.",
    'project-pages.connect-space.not-connected.heading': "Chyb\xed p\u0159ipojen\xed ke Confluence",
    'project-pages.connect-success-flag.description.content': "P\u0159ipojen\xed k\xa0obsahu {connectedSpaceOrPageName} bylo \xfasp\u011B\u0161n\xe9.",
    'project-pages.connection-error.space-or-page-not-found.button': "P\u0159ipojit k\xa0jin\xe9mu prostoru nebo str\xe1nce",
    'project-pages.create-space-dialog.connection-error': "P\u0159ipojen\xed se nezda\u0159ilo.",
    'project-pages.create-space-dialog.connection-retry': 'Zkusit znovu',
    'project-pages.create-space-dialog.content.empty-name': "Zadejte n\xe1zev prostoru.",
    'project-pages.create-space-dialog.content.invalid-name': "N\xe1zev prostoru mus\xed obsahovat alespo\u0148 jedno p\xedsmeno nebo \u010D\xedslici.",
    'project-pages.create-space-dialog.content.placeholder': "Zadejte n\xe1zev prostoru",
    'project-pages.create-space-dialog.creation-error': "Vytvo\u0159en\xed prostoru se nezda\u0159ilo.",
    'project-pages.create-space-dialog.error-icon': 'Chyba:',
    'project-pages.create-space-dialog.footer.cancel': "Zru\u0161it",
    'project-pages.create-space-dialog.footer.create-space': "Vytvo\u0159it",
    'project-pages.create-space-dialog.header.title': "Vytvo\u0159it nov\xfd prostor Confluence",
    'project-pages.cross-join.access-revoked.templates.subtitle': "Projektov\xe9 str\xe1nky nem\u016F\u017Eete pou\u017E\xedvat, proto\u017Ee v\xe1m administr\xe1tor odebral p\u0159\xedstup ke Confluence. Pokud chcete po\u017E\xe1dat o\xa0p\u0159\xedstup, kontaktujte administr\xe1tora webu.",
    'project-pages.cross-join.access-revoked.templates.title': "Nem\xe1te opr\xe1vn\u011Bn\xed pou\u017E\xedvat projektov\xe9 str\xe1nky",
    'project-pages.cross-join.avatar.view-profile': 'Zobrazit profil',
    'project-pages.cross-join.denied-request.templates.subtitle': "Projektov\xe9 str\xe1nky nem\u016F\u017Eete pou\u017E\xedvat, proto\u017Ee administr\xe1tor webu zam\xedtl va\u0161i \u017E\xe1dost o\xa0p\u0159ipojen\xed ke Confluence.",
    'project-pages.cross-join.denied-request.templates.title': "Administr\xe1tor v\xe1m zam\xedtl p\u0159\xedstup",
    'project-pages.cross-join.direct-access.button-subtitle.experimental': "Z\xedsk\xe1te p\u0159\xedstup ke Confluence. Spr\xe1vce webu u\u017E v\xe1s schv\xe1lil.",
    'project-pages.cross-join.errors.unknown-error.description': "{contactSupport}, pokud probl\xe9m nevy\u0159e\u0161\xed obnoven\xed str\xe1nky.",
    'project-pages.cross-join.errors.unknown-error.title': "Projektov\xe9 str\xe1nky moment\xe1ln\u011B nelze zobrazit",
    'project-pages.cross-join.inline-join-product.button': "Z\xedsk\xe1te p\u0159\xedstup ke Confluence. Spr\xe1vce webu u\u017E v\xe1s schv\xe1lil.",
    'project-pages.cross-join.inline-join-product.connected.description': "Prohl\xed\u017Eejte si, upravujte a\xa0vytv\xe1\u0159ejte dokumentaci na jednom m\xedst\u011B.",
    'project-pages.cross-join.inline-join-product.connected.title': "Spolupracujte se sv\xfdm t\xfdmem na str\xe1nk\xe1ch projektu.",
    'project-pages.cross-join.pending-request.templates.subtitle': "Administr\xe1tor webu obdr\u017Eel va\u0161i \u017E\xe1dost o\xa0p\u0159ipojen\xed ke Confluence. Pokud va\u0161e p\u0159ipojen\xed schv\xe1l\xed, za\u010Dnou v\xe1m fungovat projektov\xe9 str\xe1nky a\xa0p\u0159ijde v\xe1m potvrzovac\xed e-mail.",
    'project-pages.cross-join.pending-request.templates.subtitle.experiment': "Po schv\xe1len\xed dostanete e-mail s\xa0p\u0159\xedstupem k\xa0n\xe1stroji Str\xe1nky projektu.",
    'project-pages.cross-join.pending-request.templates.title': "Po\u017E\xe1dali jste o\xa0p\u0159\xedstup ke Confluence",
    'project-pages.cross-join.pending-request.templates.title.experiment': "\u017D\xe1dost o\xa0p\u0159\xedstup byla odesl\xe1na spr\xe1vci",
    'project-pages.cross-join.request-access-without-better-together.connected.description': "Prohl\xed\u017Eejte si, upravujte a\xa0vytv\xe1\u0159ejte projektovou dokumentaci se sv\xfdm t\xfdmem.",
    'project-pages.cross-join.request-access.button': "Po\u017E\xe1dat o\xa0p\u0159\xedstup",
    'project-pages.cross-join.request-access.button-subtitle.experimental': "V\xfdb\u011Brem mo\u017Enosti \u201EP\u0159ipojit k\xa0t\xfdmu\u201C \u017E\xe1d\xe1te o\xa0p\u0159ipojen\xed ke Confluence a\xa0vyjad\u0159ujete souhlas se sd\xedlen\xedm sv\xe9ho profilu Atlassian se spr\xe1vcem.",
    'project-pages.cross-join.request-access.button.experimental': "P\u0159ipojte se ke sv\xe9mu t\xfdmu",
    'project-pages.cross-join.request-access.connected.description.experimental': "\u010Clenov\xe9 va\u0161eho t\xfdmu pou\u017E\xedvaj\xed n\xe1stroj Str\xe1nky projektu ke komentov\xe1n\xed, \xfaprav\xe1m a\xa0spolupr\xe1ci na projektov\xe9 dokumentaci, ani\u017E by museli odch\xe1zet z\xa0Jira. P\u0159ipojte se ke Confluence a\xa0z\xedskejte p\u0159\xedstup k\xa0projektov\xfdm str\xe1nk\xe1m sv\xe9ho t\xfdmu.",
    'project-pages.cross-join.request-access.title': "Projektov\xe9 str\xe1nky vy\u017Eaduj\xed p\u0159\xedstup ke Confluence",
    'project-pages.cross-join.request-access.title.experiment': "Vytvo\u0159te centr\xe1ln\xed zdroj informac\xed pro sv\u016Fj t\xfdm",
    'project-pages.default-contextual-heading': "Str\xe1nky projekt\u016F vyu\u017E\xedvaj\xed technologii Confluence",
    'project-pages.default-contextual-message': "Vytv\xe1\u0159ejte dokumenty k projektu, sd\xedlejte je a spolupracujte na nich na jednom m\xedst\u011B d\xedky str\xe1nk\xe1m Confluence.",
    'project-pages.default-reactivate-CTA': 'Znovu aktivovat Confluence',
    'project-pages.default-trial-CTA': "Vyzkou\u0161ejte Confluence zdarma po dobu 30 dn\xed",
    'project-pages.draft-saved-flag.action': "Otev\u0159\xedt koncept",
    'project-pages.draft-saved-flag.description': "Koncept je pro v\xe1s viditeln\xfd pouze do t\xe9 doby, ne\u017E jej publikujete.",
    'project-pages.draft-saved-flag.title': "Koncept byl ulo\u017Een",
    'project-pages.embedded-pages.create-page-error.close-button': "Zav\u0159\xedt",
    'project-pages.embedded-pages.create-page-error.description': "Vyskytl se probl\xe9m a\xa0str\xe1nku se nepoda\u0159ilo vytvo\u0159it.",
    'project-pages.embedded-pages.create-page-error.title': "Vytvo\u0159en\xed str\xe1nky se nezda\u0159ilo",
    'project-pages.embedded-pages.create-page-error.try-again-button': 'Zkusit znovu',
    'project-pages.embedded-pages.modal.close.button.hint': "Zav\u0159\xedt",
    'project-pages.embedded-pages.modal.title.button': "Otev\u0159\xedt v\xa0Confluence",
    'project-pages.embedded-pages.modal.title.button.hint': "Otev\u0159\xedt na nov\xe9 kart\u011B",
    'project-pages.errors.space-or-page-not-found.title.non-final': "Prostor/str\xe1nku se nepoda\u0159ilo naj\xedt",
    'project-pages.errors.unknown-error.description.non-final': "{contactSupport}, pokud probl\xe9m nevy\u0159e\u0161\xed obnoven\xed str\xe1nky.",
    'project-pages.errors.unknown-error.title.non-final': "Str\xe1nky projektu moment\xe1ln\u011B nelze zobrazit",
    'project-pages.generic-error.button.reload': "Znovu na\u010D\xedst str\xe1nku",
    'project-pages.generic-error.button.reload.non-final': "Znovu na\u010D\xedst str\xe1nku",
    'project-pages.generic-error.description': "N\u011Bco se pokazilo. Zkuste to znovu pozd\u011Bji.",
    'project-pages.generic-error.description.non-final': "N\u011Bco se pokazilo. Zkuste to znovu pozd\u011Bji.",
    'project-pages.generic-error.heading': "Hmm, toto je zvl\xe1\u0161tn\xed\u2026",
    'project-pages.generic-error.title.non-final': "Hmm, toto je zvl\xe1\u0161tn\xed\u2026",
    'project-pages.generic-info-flag.description': "N\u011Bco se pokazilo. Zkuste to znovu pozd\u011Bji nebo kontaktujte podporu, pokud probl\xe9m p\u0159etrv\xe1v\xe1.",
    'project-pages.generic-success-flag.description.live-doc': "P\u0159ipojen\xed k\xa0\u017Eiv\xe9mu dokumentu {connectedSpaceOrPageName} bylo \xfasp\u011B\u0161n\xe9.",
    'project-pages.generic-success-flag.description.page': "P\u0159ipojen\xed ke str\xe1nce {connectedSpaceOrPageName} bylo \xfasp\u011B\u0161n\xe9.",
    'project-pages.generic-success-flag.description.space': "P\u0159ipojen\xed k prostoru {connectedSpaceOrPageName} bylo \xfasp\u011B\u0161n\xe9.",
    'project-pages.generic-success-flag.heading.live-doc': "\u017Div\xfd dokument byl p\u0159ipojen",
    'project-pages.generic-success-flag.heading.page': "Str\xe1nka byla p\u0159ipojena",
    'project-pages.generic-success-flag.heading.space': "Prostor byl p\u0159ipojen",
    'project-pages.granular-pages.connect-space-dialog.content.create-space-link.link-text': "Nebo vytvo\u0159it nov\xfd prostor",
    'project-pages.granular-pages.connect-space.button': "P\u0159ipojit ke Confluence",
    'project-pages.granular-pages.connect-space.button.non-final': "P\u0159ipojit ke Confluence",
    'project-pages.granular-pages.connect-space.heading': "P\u0159ipojte tento projekt k\xa0prostoru nebo polo\u017Ece Confluence",
    'project-pages.improvement.contact-support': 'Kontaktovat podporu',
    'project-pages.improvement.errors.access-error.description': "Zkuste po\u017E\xe1dat o p\u0159\xedstup administr\xe1tora webu",
    'project-pages.improvement.errors.access-error.title': "K zobrazen\xed str\xe1nek projektu nem\xe1te opr\xe1vn\u011Bn\xed",
    'project-pages.improvement.errors.page-tree-unknown-error.description': "P\u0159i pokusu o zobrazen\xed str\xe1nek z va\u0161eho p\u0159ipojen\xe9ho prostoru Confluence se vyskytl probl\xe9m. {contactSupport}, pokud probl\xe9m nevy\u0159e\u0161\xed obnoven\xed str\xe1nky.",
    'project-pages.improvement.errors.page-tree-unknown-error.title': "M\xe1me probl\xe9m se zobrazen\xedm str\xe1nek projektu",
    'project-pages.improvement.errors.space-or-page-not-found.description': "P\u0159ipojen\xfd prostor nebo str\xe1nku Confluence n\u011Bkdo p\u0159esunul, archivoval nebo odstranil. Pokud probl\xe9m nevy\u0159e\u0161\xed op\u011Btovn\xe9 p\u0159ipojen\xed, <link>obra\u0165te se na podporu</link>.",
    'project-pages.improvement.errors.space-or-page-not-found.title': "Prostor/str\xe1nku se nepoda\u0159ilo naj\xedt",
    'project-pages.improvement.errors.unknown-error.description': "{contactSupport}, pokud probl\xe9m nevy\u0159e\u0161\xed obnoven\xed str\xe1nky.",
    'project-pages.improvement.errors.unknown-error.title': "Str\xe1nky projektu moment\xe1ln\u011B nelze zobrazit",
    'project-pages.improvement.feature1': "P\u0159\xedstup a\xa0vytv\xe1\u0159en\xed dokument\u016F bez opu\u0161t\u011Bn\xed Jira",
    'project-pages.improvement.feature2': "\u0160ablony pro sch\u016Fzky, pl\xe1ny sprintu a\xa0dal\u0161\xed sc\xe9n\xe1\u0159e",
    'project-pages.improvement.feature3': "Synchronizace dokument\u016F do Jira a\xa0automatick\xe9 aktualizace",
    'project-pages.improvement.heading-info': "Zachy\u0165te znalosti t\xfdmu a zlep\u0161ete zp\u016Fsob prov\xe1d\u011Bn\xed pr\xe1ce.",
    'project-pages.improvement.heading-info-v2': "Vytvo\u0159te jedno m\xedsto pro v\u0161echny dokumenty projektu va\u0161eho t\xfdmu",
    'project-pages.improvement.learn-more-button': "Zjistit v\xedce",
    'project-pages.improvement.powered-by': "Pou\u017E\xedv\xe1 technologii",
    'project-pages.improvement.powered-by.tooltip': "Otev\u0159\xedt Confluence na nov\xe9 kart\u011B",
    'project-pages.improvement.preview-teaser': "Odemkn\u011Bte \u0161ablony, str\xe1nky projekt\u016F a\xa0dal\u0161\xed.",
    'project-pages.improvement.provisioning-info-modal.seamlessly-update-stakeholders.description': "<p>Udr\u017Eujte sv\xe9 projektov\xe9 sestavy aktu\xe1ln\xed pomoc\xed automaticky aktualizovan\xfdch stavov\xfdch \u0161t\xedtk\u016F.</p> <p>Jednodu\u0161e p\u0159ipojte ticket Jira v\xa0dokumentu a\xa0automaticky se zobraz\xed stavov\xfd \u0161t\xedtek, kter\xfd se aktualizuje synchronizovan\u011B s\xa0ticketem, tak\u017Ee nemus\xedte tr\xe1vit \u010Das ru\u010Dn\xedm vytv\xe1\u0159en\xedm sestav.</p>",
    'project-pages.improvement.provisioning-info-modal.seamlessly-update-stakeholders.title': "Hladce informujte zainteresovan\xe9 osoby",
    'project-pages.improvement.provisioning-info-modal.unify-documentation-standards.description': "<p>Vytv\xe1\u0159ejte konzistentn\xed dokumentaci pomoc\xed na\u0161ich integrovan\xfdch \u0161ablon. Snadno se pou\u017E\xedvaj\xed a\xa0jde je p\u0159izp\u016Fsobit va\u0161im pot\u0159eb\xe1m.</p> <p>\u0160ablony m\u016F\u017Eete pou\u017E\xedvat p\u0159\xedmo ze str\xe1nek projektu, tak\u017Ee nikdy nemus\xedte opou\u0161t\u011Bt to, na \u010Dem pracujete. V\u0161echny \u0161ablony si m\u016F\u017Eete proj\xedt <a>zde</a>.</p>",
    'project-pages.improvement.provisioning-info-modal.unify-documentation-standards.title': "Sjedno\u0165te sv\xe9 standardy dokumentace",
    'project-pages.improvement.provisioning-info-modal.your-project-pages-in-jira.description': "<p>Vytvo\u0159te centr\xe1ln\xed zdroj d\u016Fle\u017Eit\xfdch informac\xed d\xedky vytvo\u0159en\xed a\xa0spr\xe1v\u011B dokumentace prost\u0159ednictv\xedm karty str\xe1nek projektu v\xa0Jira.</p> <p>V\u011Bd\u011Bli jste, \u017Ee str\xe1nky projektu se nach\xe1z\xed v\xa0Confluence? Confluence je zdarma a\u017E pro 10\xa0u\u017Eivatel\u016F. Zbytek t\xfdmu m\u016F\u017Eete pozvat v\xa0nastaven\xed spr\xe1vce.</p>",
    'project-pages.improvement.provisioning-info-modal.your-project-pages-in-jira.title': "Va\u0161e str\xe1nky projektu, p\u0159\xedmo v\xa0Jira",
    'project-pages.improvement.templates-sidebar.better-together-templates-header': "\u0160ablony integrovan\xe9 s\xa0va\u0161imi daty Jira",
    'project-pages.improvement.templates.better-together-preview-teaser': "Integrov\xe1no s\xa0daty Jira",
    'project-pages.improvement.templates.blank-page.description': "Za\u010Dn\u011Bte novou str\xe1nku od za\u010D\xe1tku.",
    'project-pages.improvement.templates.blank-page.name': "Pr\xe1zdn\xe1 str\xe1nka",
    'project-pages.improvement.templates.decision.description': "Zaznamenejte d\u016Fle\u017Eit\xe1 projektov\xe1 rozhodnut\xed a komunikujte je se sv\xfdm t\xfdmem.",
    'project-pages.improvement.templates.decision.name': "Rozhodnut\xed",
    'project-pages.improvement.templates.meeting-notes.description': "Napl\xe1nujte sv\xe9 sch\u016Fzky a sd\xedlejte ak\u010Dn\xed polo\u017Eky se sv\xfdm t\xfdmem.",
    'project-pages.improvement.templates.meeting-notes.name': "Z\xe1pis ze sch\u016Fzky",
    'project-pages.improvement.templates.post-expand.more': "Dal\u0161\xed \u0161ablony",
    'project-pages.improvement.templates.post-expand.more.tooltip': "Zobrazit v\u0161echny \u0161ablony v Confluence",
    'project-pages.improvement.templates.post-expand.subtitle': "Popul\xe1rn\xed \u0161ablony",
    'project-pages.improvement.templates.post-expand.title': "Vytvo\u0159it str\xe1nku",
    'project-pages.improvement.templates.pre-expand.more': "Prozkoumat dal\u0161\xed \u0161ablony",
    'project-pages.improvement.templates.pre-expand.subtitle': "Popul\xe1rn\xed u t\xfdm\u016F podobn\xfdch va\u0161emu",
    'project-pages.improvement.templates.pre-expand.title': "N\xe1hled \u0161ablon",
    'project-pages.improvement.templates.product-requirements.description': "Definujte, sledujte a stanovte rozsah po\u017Eadavk\u016F na v\xe1\u0161 produkt \u010Di funkci.",
    'project-pages.improvement.templates.product-requirements.name': "Po\u017Eadavky produktu",
    'project-pages.improvement.templates.retrospective.description': "Co se v\xe1m l\xedbilo? Co by mohlo j\xedt l\xe9pe? Proberte zlep\u0161en\xed se sv\xfdm t\xfdmem.",
    'project-pages.improvement.templates.retrospective.name': "Retrospektivn\xed",
    'project-pages.improvement.templates.template.disabled-tooltip': "Nejd\u0159\xedve p\u0159ipojte prostor Confluence",
    'project-pages.improvement.templates.tutorial.content.confluence-templates': "<b>U\u0161et\u0159ete \u010Das a\xa0redukujte manu\xe1ln\xed \xfakoly</b>. Confluence m\xe1 mnoho <a>\u0161ablon str\xe1nek</a>, tak\u017Ee nikdy nemus\xedte za\u010D\xednat od nuly. Najdete tu \u0161ablony pro technickou dokumentaci, pr\u016Fvodce \u0159e\u0161en\xedm probl\xe9m\u016F, projektov\xe9 pl\xe1ny, produktov\xe9 po\u017Eadavky a\xa0plno dal\u0161\xedch.",
    'project-pages.improvement.templates.tutorial.content.edit-and-format': "<b>Snadno upravujte a\xa0form\xe1tujte.</b> Pomoc\xed horn\xed nab\xeddky pro \xfapravy m\u016F\u017Eete ur\u010Dit standardn\xed form\xe1tov\xe1n\xed textu a\xa0zad\xe1n\xedm znaku <b>/</b> m\u016F\u017Eete snadno vlo\u017Eit spoustu u\u017Eite\u010Dn\xfdch integrac\xed. Chcete-li vlo\u017Eit tabulku, zadejte text <c>/tabulka</c>, chcete-li vlo\u017Eit obr\xe1zek, zadejte text <c>/obr\xe1zek</c>. M\u016F\u017Eete tak\xe9 vlo\u017Eit odkazy na Dropbox (<c>/dropbox</c>), n\xe1stroje Microsoft Office (<c>/microsoft</c>) nebo n\xe1st\u011Bnky a\xa0karty Trello (<c>/trello</c>).",
    'project-pages.improvement.templates.tutorial.content.forward-slash-prompt': "Zadejte znak / a pot\xe9 text \u201Etabulka\u201C nebo \u201Eobr\xe1zek\u201C.",
    'project-pages.improvement.templates.tutorial.content.getting-started-tips': "Zde je n\u011Bkolik tip\u016F, jak za\u010D\xedt:",
    'project-pages.improvement.templates.tutorial.content.handy-links': "\u0160ikovn\xe9 odkazy",
    'project-pages.improvement.templates.tutorial.content.jira-and-confluence': "Pou\u017E\xedvejte Jira a\xa0Confluence spole\u010Dn\u011B",
    'project-pages.improvement.templates.tutorial.content.jira-charts': "Vytv\xe1\u0159ejte na sv\xfdch str\xe1nk\xe1ch grafy pomoc\xed re\xe1ln\xfdch dat z\xa0Jira. Zadejte text <c>/grafy Jira</c>.",
    'project-pages.improvement.templates.tutorial.content.jira-links': "P\u0159ipojte po\u017Eadavek Jira kamkoli na str\xe1nku. Odkaz na str\xe1nce se p\u0159i aktualizaci po\u017Eadavku Jira v\xa0re\xe1ln\xe9m \u010Dase aktualizuje tak\xe9. Zadejte text <c>/Jira</c>.",
    'project-pages.improvement.templates.tutorial.content.jira-links-issue-term-refresh': "P\u0159ipojte po\u017Eadavek Jira kamkoli na str\xe1nku. Odkaz na str\xe1nce se p\u0159i aktualizaci po\u017Eadavku v\xa0re\xe1ln\xe9m \u010Dase aktualizuje tak\xe9. Zadejte text <c>/Jira</c>.",
    'project-pages.improvement.templates.tutorial.content.jira-links.non-final-issue-term-refresh': "P\u0159ipojte po\u017Eadavek Jira kamkoli na str\xe1nku. Odkaz na str\xe1nce se p\u0159i aktualizaci po\u017Eadavku v\xa0re\xe1ln\xe9m \u010Dase aktualizuje tak\xe9. Zadejte text <c>/Jira</c>.",
    'project-pages.improvement.templates.tutorial.content.jira-roadmaps': "Pomoc\xed projekt\u016F Jira m\u016F\u017Eete na str\xe1nku vlo\u017Eit interaktivn\xed roadmapy a\xa0\u010Dasov\xe9 osy. Zadejte text <c>/jira roadmap</c>.",
    'project-pages.improvement.templates.tutorial.content.jira-timeline': "Pomoc\xed projekt\u016F Jira m\u016F\u017Eete na str\xe1nku vlo\u017Eit interaktivn\xed \u010Dasov\xe9 osy. Zadejte text <c>/\u010Dasov\xe1 osa jira</c>.",
    'project-pages.improvement.templates.tutorial.content.shipping-speed-statistic': "76\xa0% z\xe1kazn\xedk\u016F Jira Software uvedlo, \u017Ee p\u0159id\xe1n\xed Confluence jim pomohlo rychleji dod\xe1vat projekty.",
    'project-pages.improvement.templates.tutorial.content.shipping-speed-statistic.spork-rebranding': "76\xa0% z\xe1kazn\xedk\u016F Jira uvedlo, \u017Ee p\u0159id\xe1n\xed Confluence jim pomohlo rychleji dod\xe1vat projekty.",
    'project-pages.improvement.templates.tutorial.content.spaces-and-pages': "<b>Pou\u017E\xedvejte prostory a\xa0str\xe1nky</b>. Prostory jsou sou\u010D\xe1st\xed ka\u017Ed\xe9ho webu Confluence a\xa0p\u0159edstavuj\xed zp\u016Fsob uspo\u0159\xe1d\xe1n\xed str\xe1nek do kategori\xed. Prostory si m\u016F\u017Eete p\u0159edstavit jako \u0159adu r\u016Fzn\xfdch slo\u017Eek nebo projekt\u016F, zat\xedmco str\xe1nky jsou dokumenty, kter\xe9 do t\u011Bchto slo\u017Eek nebo projekt\u016F pat\u0159\xed. <a>Dal\u0161\xed informace o\xa0tom, jak pou\u017E\xedvat prostory</a>",
    'project-pages.improvement.templates.tutorial.content.try-it-now': "Vyzkou\u0161et nyn\xed",
    'project-pages.improvement.templates.tutorial.description': "P\u0159e\u010Dt\u011Bte si, jak upravit str\xe1nku.",
    'project-pages.improvement.templates.tutorial.name': "V\xedtejte na projektov\xfdch str\xe1nk\xe1ch!",
    'project-pages.improvement.terms-and-conditions-v2': "V\xfdb\u011Brem mo\u017Enosti \u201EVyzkou\u0161et nyn\xed\u201C potvrzujete, \u017Ee budete zaregistrov\xe1ni do Confluence, a\xa0p\u0159ij\xedm\xe1te <termsLink>podm\xednky slu\u017Eby Atlassian Cloud</termsLink> a\xa0<privacyLink>z\xe1sady ochrany osobn\xedch \xfadaj\u016F</privacyLink>.",
    'project-pages.improvement.title': "Str\xe1nky projektu",
    'project-pages.improvement.transient-states.empty-state.auto-provisioned-create-page-button': "Vytvo\u0159it str\xe1nku",
    'project-pages.improvement.transient-states.empty-state.auto-provisioned-description': "P\u0159idali jsme Confluence, abyste mohli za\u010D\xedt vytv\xe1\u0159et a\xa0p\u0159ipojovat v\u0161echny sv\xe9 projektov\xe9 dokumenty. Je to zdarma pro a\u017E 10\xa0u\u017Eivatel\u016F.",
    'project-pages.improvement.transient-states.empty-state.auto-provisioned-learn-more-button': "Dal\u0161\xed informace",
    'project-pages.improvement.transient-states.empty-state.create-page-button': "Vytvo\u0159te svou prvn\xed str\xe1nku",
    'project-pages.improvement.transient-states.empty-state.description': "Tento prostor se zapln\xed, a\u017E za\u010Dnete vytv\xe1\u0159et z\xe1pisy ze sch\u016Fzek, produktov\xe9 po\u017Eadavky, rozhodnut\xed a\xa0dal\u0161\xed obsah.",
    'project-pages.improvement.transient-states.empty-state.title': "Nen\xed tu nic jin\xe9ho ne\u017E potenci\xe1l",
    'project-pages.improvement.try-button': "Vyzkou\u0161et tuto \u0161ablonu v\xa0Confluence",
    'project-pages.improvement.try-it-now': "Vyzkou\u0161et nyn\xed",
    'project-pages.improvement.try-lozenge': "Vyzkou\u0161et",
    'project-pages.improvement.try-on-demand-button': "Vyzkou\u0161et zdarma",
    'project-pages.page-deleted-flag.title': "Str\xe1nka byla odstran\u011Bna.",
    'project-pages.page-published-flag.title': "Va\u0161e str\xe1nka byla publikov\xe1na.",
    'project-pages.title.non-final': "Str\xe1nky projektu",
    'project-pages.unknown-error.description': "{contactSupport}, pokud probl\xe9m nevy\u0159e\u0161\xed obnoven\xed str\xe1nky.",
    'project-pages.unknown-error.heading': "Str\xe1nky projektu moment\xe1ln\u011B nelze zobrazit"
};

});

parcelRegister("9SWh0", function(module, exports) {

$parcel$export(module.exports, "default", () => $9e1ce4458f9d032d$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Danish (Denmark)
var $9e1ce4458f9d032d$export$2e2bcd8739ae039 = {
    'confluence.project-pages.improvement.provisioning-background.text': "Dette b\xf8r tage mindre end et minut",
    'confluence.project-pages.improvement.provisioning-background.title': "Ops\xe6tning af dine projektsider",
    'confluence.project-pages.improvement.provisioning-modal-carousel.controls.dismiss': 'Luk',
    'confluence.project-pages.improvement.provisioning-modal-carousel.controls.done': "F\xe6rdig",
    'confluence.project-pages.improvement.provisioning-modal-carousel.controls.next': "N\xe6ste",
    'project-pages.activating.description': "Det tilknyttede Confluence-omr\xe5de er ikke helt klar endnu. {contactSupport}, hvis problemet ikke l\xf8ses ved at opdatere siden.",
    'project-pages.activating.heading': "Confluence indl\xe6ses stadig",
    'project-pages.better-together-templates.meeting-notes.action-items-heading': 'Hvad er handlingselementerne?',
    'project-pages.better-together-templates.meeting-notes.agenda-item-label': 'Dagsordenspunkt',
    'project-pages.better-together-templates.meeting-notes.create-a-jira-issue': 'Skriv /Jira for at oprette en sag',
    'project-pages.better-together-templates.meeting-notes.date-label': 'Dato',
    'project-pages.better-together-templates.meeting-notes.discussion-topics-heading': 'Diskussionsemner',
    'project-pages.better-together-templates.meeting-notes.list-people': "angiv personer ved hj\xe6lp af",
    'project-pages.better-together-templates.meeting-notes.mention': 'omtal',
    'project-pages.better-together-templates.meeting-notes.mention-people-to-assign-them': 'personer for at tildele dem til et handlingselement',
    'project-pages.better-together-templates.meeting-notes.notes-label': 'Notater',
    'project-pages.better-together-templates.meeting-notes.page-title': "M\xf8denoter",
    'project-pages.better-together-templates.meeting-notes.participants-label': 'Deltagere',
    'project-pages.better-together-templates.meeting-notes.project-label': 'Projekt',
    'project-pages.better-together-templates.product-requirements.create-a-jira-issue': 'Skriv /Jira for at oprette en sag',
    'project-pages.better-together-templates.product-requirements.design-heading': 'Design',
    'project-pages.better-together-templates.product-requirements.embedd-different-data-views': 'Integrer forskellige data og visninger fra dit Jira-projekt.',
    'project-pages.better-together-templates.product-requirements.heading': 'Oversigt',
    'project-pages.better-together-templates.product-requirements.how-will-you-know-if-fixed': 'Hvordan ved du, om du har rettet det?',
    'project-pages.better-together-templates.product-requirements.impact-heading': 'Effekt',
    'project-pages.better-together-templates.product-requirements.inScopeStatus': "Inden for m\xe5ls\xe6tningen",
    'project-pages.better-together-templates.product-requirements.insert-design-link': "Inds\xe6t et link til dit design (Figma osv.)",
    'project-pages.better-together-templates.product-requirements.jira-issue-heading': 'Jira-sag',
    'project-pages.better-together-templates.product-requirements.jira-roadmap-heading': "Jira-k\xf8replan",
    'project-pages.better-together-templates.product-requirements.learn-how-with-smart-links': "L\xe6r hvordan med intelligente links",
    'project-pages.better-together-templates.product-requirements.list-dashboards': 'Liste over dashboards (Amplitude, Mode osv.)',
    'project-pages.better-together-templates.product-requirements.list-design-considerations': 'Listedesign eller build-overvejelser',
    'project-pages.better-together-templates.product-requirements.list-people': "angiv personer ved hj\xe6lp af",
    'project-pages.better-together-templates.product-requirements.mention': 'omtal',
    'project-pages.better-together-templates.product-requirements.mention-people-to-assign-them': 'personer for at tildele dem til et handlingselement',
    'project-pages.better-together-templates.product-requirements.niceToHaveStatus': 'Rart at have',
    'project-pages.better-together-templates.product-requirements.outOfScopeStatus': "Uden for m\xe5ls\xe6tningen",
    'project-pages.better-together-templates.product-requirements.page-title': 'Produktkrav',
    'project-pages.better-together-templates.product-requirements.pro-tip': 'Tip:',
    'project-pages.better-together-templates.product-requirements.problem-label': 'Problem',
    'project-pages.better-together-templates.product-requirements.requirement-heading': 'Krav',
    'project-pages.better-together-templates.product-requirements.scope-heading': 'Omfang',
    'project-pages.better-together-templates.product-requirements.success-metric': "Succesm\xe5ling",
    'project-pages.better-together-templates.product-requirements.target-release-date': 'Planlagt frigivelsesdato',
    'project-pages.better-together-templates.product-requirements.team-label': 'Team',
    'project-pages.better-together-templates.product-requirements.to-do-list-heading': 'Opgaveliste',
    'project-pages.better-together-templates.product-requirements.what-are-you-trying-to-fix': "Hvad pr\xf8ver du at rette?",
    'project-pages.better-together-templates.retro-notes.retro-heading': 'Retrospektiv',
    'project-pages.better-together-templates.retro.action-items-heading': 'Hvad er handlingselementerne?',
    'project-pages.better-together-templates.retro.create-a-jira-issue': 'Skriv /Jira for at oprette en sag',
    'project-pages.better-together-templates.retro.date-label': 'Dato',
    'project-pages.better-together-templates.retro.embed-it-here': "N\xe5r du er f\xe6rdig, kan du integrere det her.",
    'project-pages.better-together-templates.retro.list-people': "angiv personer ved hj\xe6lp af",
    'project-pages.better-together-templates.retro.mention': 'omtal',
    'project-pages.better-together-templates.retro.mention-people-to-assign-them': 'personer for at tildele dem til et handlingselement',
    'project-pages.better-together-templates.retro.page-title': 'Retrospektiv',
    'project-pages.better-together-templates.retro.participants-label': 'Deltagere',
    'project-pages.better-together-templates.retro.pro-tip': 'Tip:',
    'project-pages.better-together-templates.retro.project-label': 'Projekt',
    'project-pages.better-together-templates.retro.this-is-a-whiteboard': 'Dette er et Confluence-whiteboard.',
    'project-pages.better-together-templates.retro.use-a-whiteboard': 'Brug et Confluence-whiteboard til dit retrospektiv.',
    'project-pages.better-together-templates.retro.use-it-to-vote': 'Brug det til at stemme og samarbejde med dit team.',
    'project-pages.button.connect-different-space-or-page.label': "Opdater omr\xe5de eller sideikon",
    'project-pages.button.connect-different-space-or-page.tooltip': "Tilknyt et andet omr\xe5de eller element",
    'project-pages.button.connect-space-or-page.tooltip': 'Opret forbindelse til Confluence',
    'project-pages.button.go-to-connected-live-doc.tooltip': "\xc5bn live doc i Confluence",
    'project-pages.button.go-to-connected-page.tooltip': "\xc5bn side i Confluence",
    'project-pages.button.go-to-connected-space.tooltip': "\xc5bn omr\xe5de i Confluence",
    'project-pages.connect-space-dialog.connection-error': 'Tilknytningen mislykkedes.',
    'project-pages.connect-space-dialog.connection-retry': "Pr\xf8v igen",
    'project-pages.connect-space-dialog.content.space-or-page-selector.description': "V\xe6lg et omr\xe5de eller et element, som skal knyttes til dit projekt.",
    'project-pages.connect-space-dialog.content.space-or-page-selector.placeholder': "S\xf8g i Confluence",
    'project-pages.connect-space-dialog.content.space-selector.disconnected-templates-description': "Dette projekt skal knyttes til et omr\xe5de, f\xf8r du kan oprette et element. V\xe6lg et omr\xe5de, som skal knyttes til dette projekt.",
    'project-pages.connect-space-dialog.error-icon': 'Fejl:',
    'project-pages.connect-space-dialog.footer.cancel': 'Annuller',
    'project-pages.connect-space-dialog.footer.connect-space': 'Forbind',
    'project-pages.connect-space-or-page-dialog.header.title': 'Knyt projekt til Confluence',
    'project-pages.connect-space.description': "Omr\xe5der er ligesom mapper \u2013 du kan bruge dem til at oprette, organisere og samarbejde om al indholdet, der vedr\xf8rer projektet.",
    'project-pages.connect-space.not-connected.description': 'Hvis du vil bruge projektsider, skal du kontakte din administrator eller teamleder for at forbinde Confluence til dette projekt.',
    'project-pages.connect-space.not-connected.heading': 'Ikke forbundet til Confluence',
    'project-pages.connect-success-flag.description.content': 'Tilknytningen til {connectedSpaceOrPageName}-indholdet blev oprettet.',
    'project-pages.connection-error.space-or-page-not-found.button': "Knyt til et andet omr\xe5de eller en anden side",
    'project-pages.create-space-dialog.connection-error': 'Tilknytningen mislykkedes.',
    'project-pages.create-space-dialog.connection-retry': "Pr\xf8v igen",
    'project-pages.create-space-dialog.content.empty-name': "Giv dit omr\xe5de et navn.",
    'project-pages.create-space-dialog.content.invalid-name': "Omr\xe5denavne skal have mindst \xe9t bogstav eller tal.",
    'project-pages.create-space-dialog.content.placeholder': "Indtast et omr\xe5denavn",
    'project-pages.create-space-dialog.creation-error': "Det lykkedes ikke at oprette omr\xe5det.",
    'project-pages.create-space-dialog.error-icon': 'Fejl:',
    'project-pages.create-space-dialog.footer.cancel': 'Annuller',
    'project-pages.create-space-dialog.footer.create-space': 'Opret',
    'project-pages.create-space-dialog.header.title': "Opret nyt Confluence-omr\xe5de",
    'project-pages.cross-join.access-revoked.templates.subtitle': 'Du kan ikke bruge projektsider, fordi administratoren ikke har givet dig adgang til Confluence. Kontakt administratoren for dit websted for at anmode om adgang.',
    'project-pages.cross-join.access-revoked.templates.title': 'Du har ikke tilladelse til at bruge projektsider',
    'project-pages.cross-join.avatar.view-profile': 'Se profil',
    'project-pages.cross-join.denied-request.templates.subtitle': "Du kan ikke bruge projektsider, fordi administratoren for webstedet har afvist din anmodning om at f\xe5 adgang til Confluence.",
    'project-pages.cross-join.denied-request.templates.title': 'Din administrator har afvist at give dig adgang',
    'project-pages.cross-join.direct-access.button-subtitle.experimental': "Du f\xe5r adgang til Confluence. Din sideadministrator har allerede godkendt dig.",
    'project-pages.cross-join.errors.unknown-error.description': "{contactSupport}, hvis det ikke hj\xe6lper at opdatere.",
    'project-pages.cross-join.errors.unknown-error.title': 'Vi kan ikke vise projektsider lige nu',
    'project-pages.cross-join.inline-join-product.button': "Du f\xe5r adgang til Confluence. Din webstedsadministrator har allerede godkendt dig.",
    'project-pages.cross-join.inline-join-product.connected.description': "Se, rediger og opret dokumentation fra \xe9t sted",
    'project-pages.cross-join.inline-join-product.connected.title': "Samarbejd p\xe5 projektsider med dit team",
    'project-pages.cross-join.pending-request.templates.subtitle': "Webstedsadministratoren har modtaget din anmodning om adgang til Confluence. Hvis din anmodning bliver godkendt, begynder projektsider at fungere, og vi sender dig en e-mail med bekr\xe6ftelse.",
    'project-pages.cross-join.pending-request.templates.subtitle.experiment': "Du modtager en e-mail med adgang til projektsider, n\xe5r du er godkendt.",
    'project-pages.cross-join.pending-request.templates.title': 'Du har anmodet om adgang til Confluence',
    'project-pages.cross-join.pending-request.templates.title.experiment': 'Adgangsanmodning sendt til administrator',
    'project-pages.cross-join.request-access-without-better-together.connected.description': 'Se, rediger og opret projektdokumentation med dit team',
    'project-pages.cross-join.request-access.button': 'Anmod om adgang',
    'project-pages.cross-join.request-access.button-subtitle.experimental': 'N\xe5r du v\xe6lger "Bliv en del af teamet", beder du om at deltage i Confluence og accepterer at dele din Atlassian-profil med din administrator.',
    'project-pages.cross-join.request-access.button.experimental': 'Slut dig til dit team',
    'project-pages.cross-join.request-access.connected.description.experimental': "Dit team bruger projektsider til at kommentere, redigere og samarbejde om projektdokumentation uden at forlade Jira. Tilmeld dig Confluence for at f\xe5 adgang til dit teams projektsider.",
    'project-pages.cross-join.request-access.title': "Projektsider kr\xe6ver adgang til Confluence",
    'project-pages.cross-join.request-access.title.experiment': 'Skab en "single source of truth" til dit team',
    'project-pages.default-contextual-heading': 'Projektsider er drevet af Confluence',
    'project-pages.default-contextual-message': "Opret, del og samarbejd om alle dine projektdokumenter p\xe5 \xe9t sted med Confluence-sider.",
    'project-pages.default-reactivate-CTA': 'Genaktiver Confluence',
    'project-pages.default-trial-CTA': "Pr\xf8v Confluence gratis i 30 dage",
    'project-pages.draft-saved-flag.action': "\xc5bn udkast",
    'project-pages.draft-saved-flag.description': 'Dit udkast er kun synligt for dig, indtil du udgiver det.',
    'project-pages.draft-saved-flag.title': 'Udkastet blev gemt',
    'project-pages.embedded-pages.create-page-error.close-button': 'Luk',
    'project-pages.embedded-pages.create-page-error.description': 'Der opstod et problem, og vi kunne ikke oprette en side til dig.',
    'project-pages.embedded-pages.create-page-error.title': 'Vi kunne ikke oprette en side',
    'project-pages.embedded-pages.create-page-error.try-again-button': "Pr\xf8v igen",
    'project-pages.embedded-pages.modal.close.button.hint': 'Luk',
    'project-pages.embedded-pages.modal.title.button': "\xc5bn i Confluence",
    'project-pages.embedded-pages.modal.title.button.hint': "\xc5bn i en ny fane",
    'project-pages.errors.unknown-error.description.non-final': "{contactSupport}, hvis problemet ikke l\xf8ses ved at opdatere siden.",
    'project-pages.errors.unknown-error.title.non-final': 'Vi kan ikke vise projektsider lige nu',
    'project-pages.generic-error.button.reload': "Genindl\xe6s siden",
    'project-pages.generic-error.description': "Noget gik galt. Pr\xf8v igen senere.",
    'project-pages.generic-error.description.non-final': "Noget gik galt. Pr\xf8v igen senere.",
    'project-pages.generic-error.heading': 'Uh, det var akavet ...',
    'project-pages.generic-error.title.non-final': 'Ups, det var pinligt ...',
    'project-pages.generic-info-flag.description': "Der gik noget galt. Pr\xf8v igen, eller kontakt support, hvis problemet forts\xe6tter",
    'project-pages.generic-success-flag.description.live-doc': 'Der blev oprettet forbindelse til live doc {connectedSpaceOrPageName}.',
    'project-pages.generic-success-flag.description.page': 'Tilknytningen til {connectedSpaceOrPageName}-siden blev oprettet.',
    'project-pages.generic-success-flag.description.space': "Tilknytningen til {connectedSpaceOrPageName}-omr\xe5det blev oprettet.",
    'project-pages.generic-success-flag.heading.live-doc': 'Live doc forbundet',
    'project-pages.generic-success-flag.heading.page': 'Siden blev tilknyttet',
    'project-pages.generic-success-flag.heading.space': "Omr\xe5de blev tilknyttet",
    'project-pages.granular-pages.connect-space-dialog.content.create-space-link.link-text': "Eller opret et nyt omr\xe5de",
    'project-pages.granular-pages.connect-space.button': 'Opret forbindelse til Confluence',
    'project-pages.granular-pages.connect-space.heading': "Knyt dette projekt til et Confluence-omr\xe5de eller -element",
    'project-pages.improvement.contact-support': 'Kontakt support',
    'project-pages.improvement.errors.access-error.description': "Pr\xf8v at kontakte sideadministratoren for at f\xe5 adgang.",
    'project-pages.improvement.errors.access-error.title': "Du har ikke tilladelse til at f\xe5 vist projektsider",
    'project-pages.improvement.errors.page-tree-unknown-error.description': "Noget gik galt under fors\xf8get p\xe5 at vise sider fra dit tilknyttede Confluence-omr\xe5de. {contactSupport}, hvis problemet ikke l\xf8ses ved at opdatere siden.",
    'project-pages.improvement.errors.page-tree-unknown-error.title': 'Vi har problemer med at vise projektsider',
    'project-pages.improvement.errors.space-or-page-not-found.description': "Det tilknyttede Confluence-omr\xe5de eller den tilknyttede Confluence-side er blevet flyttet, arkiveret eller slettet. <link>Kontakt support</link>, hvis det ikke l\xf8ser problemet at oprette forbindelse igen",
    'project-pages.improvement.errors.space-or-page-not-found.title': "Omr\xe5det eller siden blev ikke fundet",
    'project-pages.improvement.errors.unknown-error.description': "{contactSupport}, hvis problemet ikke l\xf8ses ved at opdatere siden.",
    'project-pages.improvement.errors.unknown-error.title': 'Vi kan ikke vise projektsider lige nu',
    'project-pages.improvement.feature1': "F\xe5 adgang til og opret dokumenter uden at forlade Jira",
    'project-pages.improvement.feature2': "Skabeloner til m\xf8der, sprintplaner og meget mere",
    'project-pages.improvement.feature3': "Synkroniser dokumenter til Jira, og f\xe5 automatiske opdateringer",
    'project-pages.improvement.heading-info': "Registrer dit teams viden, og forbedr den m\xe5de, hvorp\xe5 I f\xe5r arbejdet fra h\xe5nden.",
    'project-pages.improvement.heading-info-v2': "Opret \xe9t sted til alle teamets projektdokumenter",
    'project-pages.improvement.learn-more-button': "L\xe6s mere",
    'project-pages.improvement.powered-by': 'Drevet af',
    'project-pages.improvement.powered-by.tooltip': "\xc5bn Confluence p\xe5 en ny fane",
    'project-pages.improvement.preview-teaser': "L\xe5s op for skabeloner, projektsider m.m.",
    'project-pages.improvement.provisioning-info-modal.seamlessly-update-stakeholders.description': "<p>Hold dine projektrapporter opdaterede med automatisk opdatering af statusm\xe6rkater.</p> <p>Du skal blot linke til en Jira-supportanmodning i et dokument, s\xe5 vises der automatisk en statusm\xe6rkat, der synkroniseres med supportanmodningen, s\xe5 du ikke beh\xf8ver at bruge tid p\xe5 at oprette manuelle rapporter.</p>",
    'project-pages.improvement.provisioning-info-modal.seamlessly-update-stakeholders.title': 'Opdater dine interessenter uden problemer',
    'project-pages.improvement.provisioning-info-modal.unify-documentation-standards.description': "<p>Opret ensartet dokumentation ved hj\xe6lp af vores indbyggede skabeloner. De er enkle at bruge og kan tilpasses til dine behov.</p> <p>Du kan bruge skabeloner direkte fra projektsider, s\xe5 du aldrig beh\xf8ver at forlade det, du arbejder p\xe5. Gennemse alle skabeloner <a>her</a>.</p>",
    'project-pages.improvement.provisioning-info-modal.unify-documentation-standards.title': 'Saml dine dokumentationsstandarder',
    'project-pages.improvement.provisioning-info-modal.your-project-pages-in-jira.description': '<p>Opret en enkelt kilde til sandhed til vigtige oplysninger ved at oprette og administrere dokumentation fra fanen projektsider i Jira.</p> <p>Vidste du, at projektsider findes i Confluence? Det er gratis for op til 10 brugere. Inviter resten af dit team i administratorindstillinger.</p>',
    'project-pages.improvement.provisioning-info-modal.your-project-pages-in-jira.title': 'Dine projektsider, direkte i Jira',
    'project-pages.improvement.templates-sidebar.better-together-templates-header': 'Skabeloner integreret med dine Jira-data',
    'project-pages.improvement.templates.better-together-preview-teaser': 'Integreret med Jira-data',
    'project-pages.improvement.templates.blank-page.description': 'Start en side fra bunden.',
    'project-pages.improvement.templates.blank-page.name': 'Tom side',
    'project-pages.improvement.templates.decision.description': "Registrer vigtige projektbeslutninger, og dr\xf8ft dem med dit hold.",
    'project-pages.improvement.templates.decision.name': 'Beslutning',
    'project-pages.improvement.templates.meeting-notes.description': "Planl\xe6g dine m\xf8der, og del notater og handlinger med dit team.",
    'project-pages.improvement.templates.meeting-notes.name': "M\xf8denotater",
    'project-pages.improvement.templates.post-expand.more': 'Flere skabeloner',
    'project-pages.improvement.templates.post-expand.more.tooltip': 'Vis alle skabeloner i Confluence',
    'project-pages.improvement.templates.post-expand.subtitle': "Popul\xe6re skabeloner",
    'project-pages.improvement.templates.post-expand.title': 'Opret en side',
    'project-pages.improvement.templates.pre-expand.more': 'Se flere skabeloner',
    'project-pages.improvement.templates.pre-expand.subtitle': "Popul\xe6re hos teams som dit",
    'project-pages.improvement.templates.pre-expand.title': "Forh\xe5ndsvisning af skabeloner",
    'project-pages.improvement.templates.product-requirements.description': "Defin\xe9r, spor og unders\xf8g kravene til dit produkt eller funktion.",
    'project-pages.improvement.templates.product-requirements.name': 'Produktkrav',
    'project-pages.improvement.templates.retrospective.description': "Hvad gik godt? Hvad kunne v\xe6re g\xe5et bedre? Crowdsource forbedringer med dit team.",
    'project-pages.improvement.templates.retrospective.name': 'Retrospektiv',
    'project-pages.improvement.templates.template.disabled-tooltip': "Tilknyt f\xf8rst et Confluence-omr\xe5de",
    'project-pages.improvement.templates.tutorial.content.confluence-templates': "<b>Spar tid, og mindsk m\xe6ngden af manuelle opgaver</b>. Confluence har mange <a>sideskabeloner</a>, s\xe5 du beh\xf8ver aldrig starte helt fra bunden. Der er bl.a. skabeloner til tekniske dokumenter, fejlfindingsvejledninger, projektplaner, produktkrav og meget mere.",
    'project-pages.improvement.templates.tutorial.content.edit-and-format': "<b>Nem redigering og formatering.</b> Brug redigeringsmenuen foroven til standardordformatering, og ved hj\xe6lp af <b>/</b> kan du nemt inds\xe6tte masser af praktiske integrationer. Inds\xe6t en tabel ved at skrive <c>/table</c> eller et billede med <c>/image</c>. Du kan ogs\xe5 inds\xe6tte links til Dropbox <c>/dropbox</c>, Microsoft Office-v\xe6rkt\xf8jer <c>/microsoft</c> eller Trello-tavler og -kort <c>/trello</c>.",
    'project-pages.improvement.templates.tutorial.content.forward-slash-prompt': 'Indtast / efterfulgt af "table" eller "image"',
    'project-pages.improvement.templates.tutorial.content.getting-started-tips': 'Her er et par tip til at komme i gang:',
    'project-pages.improvement.templates.tutorial.content.handy-links': 'Nyttige links',
    'project-pages.improvement.templates.tutorial.content.jira-and-confluence': 'Brug Jira og Confluence sammen',
    'project-pages.improvement.templates.tutorial.content.jira-charts': "Opret diagrammer p\xe5 dine sider ved hj\xe6lp af data fra Jira. Indtast <c>/Jira charts</c>.",
    'project-pages.improvement.templates.tutorial.content.jira-links': "Tilknyt en Jira-sag hvor som helst p\xe5 siden. Linket p\xe5 siden opdateres i realtid, n\xe5r du opdaterer Jira-sagen. Indtast <c>/Jira</c>.",
    'project-pages.improvement.templates.tutorial.content.jira-links-issue-term-refresh': "Tilknyt en Jira-sag hvor som helst p\xe5 siden. Linket p\xe5 siden opdateres i realtid, n\xe5r du opdaterer sagen. Indtast <c>/Jira</c>.",
    'project-pages.improvement.templates.tutorial.content.jira-links.non-final-issue-term-refresh': "Tilknyt en Jira-sag hvor som helst p\xe5 siden. Linket p\xe5 siden opdateres i realtid, n\xe5r du opdaterer sagen. Indtast <c>/Jira</c>.",
    'project-pages.improvement.templates.tutorial.content.jira-roadmaps': "Integrer interaktive k\xf8replaner og tidslinjer for din side ved hj\xe6lp af dine Jira-projekter. Indtast <c>/Jira-k\xf8replan</c>.",
    'project-pages.improvement.templates.tutorial.content.jira-timeline': "Integrer interaktive tidslinjer for din side ved hj\xe6lp af dine Jira-projekter. Skriv <c>/jira-tidslinje</c>.",
    'project-pages.improvement.templates.tutorial.content.shipping-speed-statistic': "76\xa0% af Jira Software-kunder siger, at de sender projekter hurtigere, efter de har tilf\xf8jet Confluence",
    'project-pages.improvement.templates.tutorial.content.shipping-speed-statistic.spork-rebranding': "76\xa0% af Jira-kunder siger, at de sender projekter ud hurtigere, efter de har tilf\xf8jet Confluence",
    'project-pages.improvement.templates.tutorial.content.spaces-and-pages': "<b>Brug af omr\xe5der og sider</b>. Omr\xe5der er en del af hvert Confluence-websted, og de er en m\xe5de at organisere sider i kategorier p\xe5. T\xe6nk p\xe5 omr\xe5der som forskellige mapper eller projekter, og sider er de dokumenter, der h\xf8rer hjemme i disse mapper eller projekter. <a>F\xe5 mere at vide om, hvordan man bruger omr\xe5der</a>",
    'project-pages.improvement.templates.tutorial.content.try-it-now': "Pr\xf8v det nu",
    'project-pages.improvement.templates.tutorial.description': "L\xe6r, hvordan du redigerer en side.",
    'project-pages.improvement.templates.tutorial.name': 'Velkommen til projektsider!',
    'project-pages.improvement.terms-and-conditions-v2': "Ved at klikke p\xe5 &quot;Pr\xf8v det nu&quot; accepterer du at blive tilmeldt Confluence, og du accepterer <termsLink>servicevilk\xe5r</termsLink> og <privacyLink>fortrolighedspolitik</privacyLink> for Atlassian Cloud.",
    'project-pages.improvement.title': 'Projektsider',
    'project-pages.improvement.transient-states.empty-state.auto-provisioned-create-page-button': 'Opret side',
    'project-pages.improvement.transient-states.empty-state.auto-provisioned-description': "Vi har tilf\xf8jet Confluence, s\xe5 du kan begynde at oprette og tilknytte alle dine projektdokumenter. Det er gratis for op til 10 brugere.",
    'project-pages.improvement.transient-states.empty-state.auto-provisioned-learn-more-button': "L\xe6s mere",
    'project-pages.improvement.transient-states.empty-state.create-page-button': "Opret din f\xf8rste side",
    'project-pages.improvement.transient-states.empty-state.description': "Opret m\xf8denoter, produktkrav, beslutninger eller andet indhold for at se omr\xe5det blive fyldt ud.",
    'project-pages.improvement.transient-states.empty-state.title': 'Der er ikke andet end potentiale her',
    'project-pages.improvement.try-button': "Pr\xf8v denne skabelon i Confluence",
    'project-pages.improvement.try-it-now': "Pr\xf8v det nu",
    'project-pages.improvement.try-lozenge': "Pr\xf8v",
    'project-pages.improvement.try-on-demand-button': "Pr\xf8v det gratis",
    'project-pages.page-deleted-flag.title': 'Siden blev slettet.',
    'project-pages.page-published-flag.title': 'Din side er blevet udgivet.',
    'project-pages.unknown-error.description': "{contactSupport}, hvis problemet ikke l\xf8ses ved at opdatere siden.",
    'project-pages.unknown-error.heading': 'Vi kan ikke vise projektsider lige nu'
};

});

parcelRegister("tnTW0", function(module, exports) {

$parcel$export(module.exports, "default", () => $b66bf7474dbb453c$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Dutch (Netherlands)
var $b66bf7474dbb453c$export$2e2bcd8739ae039 = {
    'confluence.project-pages.improvement.provisioning-background.text': 'Dit duurt niet langer dan een minuut',
    'confluence.project-pages.improvement.provisioning-background.title': "Je projectpagina's instellen",
    'confluence.project-pages.improvement.provisioning-modal-carousel.controls.dismiss': 'Negeren',
    'confluence.project-pages.improvement.provisioning-modal-carousel.controls.done': 'Gereed',
    'confluence.project-pages.improvement.provisioning-modal-carousel.controls.next': 'Volgende',
    'project-pages.activating.description': 'De gekoppelde Confluence-space is nog niet gereed. Als vernieuwen de problemen niet verhelpt, {contactSupport}.',
    'project-pages.activating.heading': 'Confluence wordt nog steeds geladen',
    'project-pages.better-together-templates.meeting-notes.action-items-heading': 'Wat zijn de actie-items?',
    'project-pages.better-together-templates.meeting-notes.agenda-item-label': 'Agendapunt',
    'project-pages.better-together-templates.meeting-notes.create-a-jira-issue': 'Typ /Jira om een issue aan te maken',
    'project-pages.better-together-templates.meeting-notes.date-label': 'Datum',
    'project-pages.better-together-templates.meeting-notes.discussion-topics-heading': 'Discussie-onderwerpen',
    'project-pages.better-together-templates.meeting-notes.list-people': 'vermeldt mensen die gebruikmaken van',
    'project-pages.better-together-templates.meeting-notes.mention': 'vermeld',
    'project-pages.better-together-templates.meeting-notes.mention-people-to-assign-them': 'mensen om ze toe te wijzen aan een actie-item',
    'project-pages.better-together-templates.meeting-notes.notes-label': 'Aantekeningen',
    'project-pages.better-together-templates.meeting-notes.page-title': 'Notulen',
    'project-pages.better-together-templates.meeting-notes.participants-label': 'Deelnemers',
    'project-pages.better-together-templates.meeting-notes.project-label': 'Project',
    'project-pages.better-together-templates.product-requirements.create-a-jira-issue': 'Typ /Jira om een issue aan te maken',
    'project-pages.better-together-templates.product-requirements.design-heading': 'Ontwerp',
    'project-pages.better-together-templates.product-requirements.embedd-different-data-views': 'Voeg verschillende gegevens en weergaven van je Jira-project in.',
    'project-pages.better-together-templates.product-requirements.heading': 'Overzicht',
    'project-pages.better-together-templates.product-requirements.how-will-you-know-if-fixed': 'Hoe weet je of het is opgelost?',
    'project-pages.better-together-templates.product-requirements.impact-heading': 'Impact',
    'project-pages.better-together-templates.product-requirements.inScopeStatus': 'In scope',
    'project-pages.better-together-templates.product-requirements.insert-design-link': 'Voeg een link toe naar je ontwerp (Figma, enz.)',
    'project-pages.better-together-templates.product-requirements.jira-issue-heading': 'Jira-issue',
    'project-pages.better-together-templates.product-requirements.jira-roadmap-heading': 'Jira-roadmap',
    'project-pages.better-together-templates.product-requirements.learn-how-with-smart-links': 'Leer hoe met Smart Links',
    'project-pages.better-together-templates.product-requirements.list-dashboards': 'Vermeld dashboards (Amplitude, Modus, enz.)',
    'project-pages.better-together-templates.product-requirements.list-design-considerations': 'Vermeld overwegingen voor ontwerp en build',
    'project-pages.better-together-templates.product-requirements.list-people': 'vermeldt mensen die gebruikmaken van',
    'project-pages.better-together-templates.product-requirements.mention': 'vermeld',
    'project-pages.better-together-templates.product-requirements.mention-people-to-assign-them': 'mensen om ze toe te wijzen aan een actie-item',
    'project-pages.better-together-templates.product-requirements.niceToHaveStatus': 'Handig',
    'project-pages.better-together-templates.product-requirements.outOfScopeStatus': 'Niet in scope',
    'project-pages.better-together-templates.product-requirements.page-title': 'Producteisen',
    'project-pages.better-together-templates.product-requirements.pro-tip': 'Tip:',
    'project-pages.better-together-templates.product-requirements.problem-label': 'Probleem',
    'project-pages.better-together-templates.product-requirements.requirement-heading': 'Vereiste',
    'project-pages.better-together-templates.product-requirements.scope-heading': 'Scope',
    'project-pages.better-together-templates.product-requirements.success-metric': 'Successtatistiek',
    'project-pages.better-together-templates.product-requirements.target-release-date': 'Doelreleasedatum',
    'project-pages.better-together-templates.product-requirements.team-label': 'Team',
    'project-pages.better-together-templates.product-requirements.to-do-list-heading': 'To-dolijst',
    'project-pages.better-together-templates.product-requirements.what-are-you-trying-to-fix': 'Wat probeer je op te lossen?',
    'project-pages.better-together-templates.retro-notes.retro-heading': 'Retrospectief',
    'project-pages.better-together-templates.retro.action-items-heading': 'Wat zijn de actie-items?',
    'project-pages.better-together-templates.retro.create-a-jira-issue': 'Typ /Jira om een issue aan te maken',
    'project-pages.better-together-templates.retro.date-label': 'Datum',
    'project-pages.better-together-templates.retro.embed-it-here': 'Als je klaar bent, kun je het hier insluiten.',
    'project-pages.better-together-templates.retro.list-people': 'vermeldt mensen die gebruikmaken van',
    'project-pages.better-together-templates.retro.mention': 'vermeld',
    'project-pages.better-together-templates.retro.mention-people-to-assign-them': 'mensen om ze toe te wijzen aan een actie-item',
    'project-pages.better-together-templates.retro.page-title': 'Retrospectief',
    'project-pages.better-together-templates.retro.participants-label': 'Deelnemers',
    'project-pages.better-together-templates.retro.pro-tip': 'Tip:',
    'project-pages.better-together-templates.retro.project-label': 'Project',
    'project-pages.better-together-templates.retro.this-is-a-whiteboard': 'Dit is een Confluence-whiteboard.',
    'project-pages.better-together-templates.retro.use-a-whiteboard': 'Gebruik een Confluence-whiteboard voor je retro.',
    'project-pages.better-together-templates.retro.use-it-to-vote': 'Gebruik het om te stemmen en samen te werken met je team.',
    'project-pages.button.connect-different-space-or-page.label': 'Space of paginapictogram bijwerken',
    'project-pages.button.connect-different-space-or-page.tooltip': 'Met een andere space of een ander item verbinding maken',
    'project-pages.button.connect-space-or-page.tooltip': 'Koppelen aan Confluence',
    'project-pages.button.go-to-connected-live-doc.tooltip': 'Open live doc in Confluence',
    'project-pages.button.go-to-connected-page.tooltip': 'Pagina openen in Confluence',
    'project-pages.button.go-to-connected-space.tooltip': 'Space openen in Confluence',
    'project-pages.connect-space-dialog.connection-error': 'Verbinding mislukt.',
    'project-pages.connect-space-dialog.connection-retry': 'Probeer opnieuw',
    'project-pages.connect-space-dialog.content.space-or-page-selector.description': 'Kies een space of item om aan dit project te koppelen.',
    'project-pages.connect-space-dialog.content.space-or-page-selector.placeholder': 'Doorzoek Confluence',
    'project-pages.connect-space-dialog.content.space-selector.disconnected-templates-description': 'Dit project moet gekoppeld zijn aan een space voordat je een item kunt aanmaken. Kies een space om aan dit project te koppelen.',
    'project-pages.connect-space-dialog.error-icon': 'Fout:',
    'project-pages.connect-space-dialog.footer.cancel': 'Annuleren',
    'project-pages.connect-space-dialog.footer.connect-space': 'Koppelen',
    'project-pages.connect-space-or-page-dialog.header.title': 'Project aan Confluence koppelen',
    'project-pages.connect-space.description': 'Spaces zijn net mappen. Je kunt ze gebruiken om er alle content van je projecten in te maken, te organiseren en er in samen te werken.',
    'project-pages.connect-space.not-connected.description': "Als je projectpagina's wilt gebruiken, neem je contact op met je beheerder of teamleider om Confluence aan dit project te koppelen.",
    'project-pages.connect-space.not-connected.heading': 'Niet gekoppeld aan Confluence',
    'project-pages.connect-success-flag.description.content': 'Gekoppeld met inhoud van {connectedSpaceOrPageName}.',
    'project-pages.connection-error.space-or-page-not-found.button': 'Aan een andere space of pagina koppelen',
    'project-pages.create-space-dialog.connection-error': 'Verbinding mislukt.',
    'project-pages.create-space-dialog.connection-retry': 'Probeer opnieuw',
    'project-pages.create-space-dialog.content.empty-name': 'Geef je space een naam.',
    'project-pages.create-space-dialog.content.invalid-name': 'Spacenamen moeten minimaal een letter of cijfer bevatten.',
    'project-pages.create-space-dialog.content.placeholder': 'Voer een naam voor de space in',
    'project-pages.create-space-dialog.creation-error': 'Aanmaken van space mislukt.',
    'project-pages.create-space-dialog.error-icon': 'Fout:',
    'project-pages.create-space-dialog.footer.cancel': 'Annuleren',
    'project-pages.create-space-dialog.footer.create-space': 'Maken',
    'project-pages.create-space-dialog.header.title': 'Maak een nieuwe Confluence-space',
    'project-pages.cross-join.access-revoked.templates.subtitle': 'Je kunt de projectpagina niet gebruiken omdat de beheerder je de toegang tot Confluence heeft geweigerd. Neem contact op met je sitebeheerder om toegang aan te vragen.',
    'project-pages.cross-join.access-revoked.templates.title': "Je hebt geen rechten op het gebruik van projectpagina's",
    'project-pages.cross-join.avatar.view-profile': 'Profiel bekijken',
    'project-pages.cross-join.denied-request.templates.subtitle': "Je kunt geen projectpagina's gebruiken omdat de websitebeheerder je aanvraag voor aanmelding bij Confluence heeft geweigerd.",
    'project-pages.cross-join.denied-request.templates.title': 'Je beheerder heeft de toegang geweigerd',
    'project-pages.cross-join.direct-access.button-subtitle.experimental': 'Je krijgt toegang tot Confluence. Je sitebeheerder heeft je al goedgekeurd.',
    'project-pages.cross-join.errors.unknown-error.description': '{contactSupport} als vernieuwen niet helpt.',
    'project-pages.cross-join.errors.unknown-error.title': "We kunnen projectpagina's op dit moment niet weergeven",
    'project-pages.cross-join.inline-join-product.button': 'Je krijgt toegang tot Confluence. Je sitebeheerder heeft je al goedgekeurd.',
    'project-pages.cross-join.inline-join-product.connected.description': "Documenten bekijken, bewerken en aanmaken vanaf \xe9\xe9n plek",
    'project-pages.cross-join.inline-join-product.connected.title': "Werk met je team samen op projectpagina's",
    'project-pages.cross-join.pending-request.templates.subtitle': "De sitebeheerder heeft je verzoek om aangemeld te worden bij Confluence ontvangen. Als je toestemming hebt gekregen om deel te nemen, treden de projectpagina's in werking en sturen we je een bevestigingsmail.",
    'project-pages.cross-join.pending-request.templates.subtitle.experiment': "Je krijgt een e-mail met toegang tot de projectpagina's zodra je bent goedgekeurd.",
    'project-pages.cross-join.pending-request.templates.title': 'Je hebt toegang tot Confluence aangevraagd',
    'project-pages.cross-join.pending-request.templates.title.experiment': 'Aanvraag om toegang verstuurd naar de Beheerder',
    'project-pages.cross-join.request-access-without-better-together.connected.description': 'Projectdocumenten bekijken, bewerken en aanmaken met je team',
    'project-pages.cross-join.request-access.button': 'Toegang aanvragen',
    'project-pages.cross-join.request-access.button-subtitle.experimental': "Wanneer je 'Lid worden van je team' selecteert, vraag je om lid te worden van Confluence en ga je ermee akkoord je Atlassian-profiel te delen met je beheerder.",
    'project-pages.cross-join.request-access.button.experimental': 'Lid worden van je team',
    'project-pages.cross-join.request-access.connected.description.experimental': "Je team gebruikt Projectpagina's om opmerkingen te plaatsen, te bewerken en samen te werken aan projectdocumentatie zonder Jira te verlaten. Word lid van Confluence om toegang te krijgen tot de projectpagina's van je team.",
    'project-pages.cross-join.request-access.title': "Projectpagina's vereisen toegang tot Confluence",
    'project-pages.cross-join.request-access.title.experiment': "Maak \xe9\xe9n bron van waarheid aan voor je team",
    'project-pages.default-contextual-heading': "Projectpagina's worden mogelijk gemaakt door Confluence",
    'project-pages.default-contextual-message': "Met Confluence-pagina's maak, deel, en werk je op \xe9\xe9n plek samen aan al jouw projectdocumenten.",
    'project-pages.default-reactivate-CTA': 'Confluence opnieuw activeren',
    'project-pages.default-trial-CTA': 'Probeer Confluence 30 dagen gratis',
    'project-pages.draft-saved-flag.action': 'Concept openen',
    'project-pages.draft-saved-flag.description': 'Je concept is alleen zichtbaar voor jou tot je het publiceert.',
    'project-pages.draft-saved-flag.title': 'Concept opgeslagen',
    'project-pages.embedded-pages.create-page-error.close-button': 'Sluiten',
    'project-pages.embedded-pages.create-page-error.description': 'Er was een probleem en we konden geen pagina voor je aanmaken.',
    'project-pages.embedded-pages.create-page-error.title': 'We konden geen pagina aanmaken',
    'project-pages.embedded-pages.create-page-error.try-again-button': 'Opnieuw proberen',
    'project-pages.embedded-pages.modal.close.button.hint': 'Sluiten',
    'project-pages.embedded-pages.modal.title.button': 'Openen in Confluence',
    'project-pages.embedded-pages.modal.title.button.hint': 'Openen in een nieuw tabblad',
    'project-pages.errors.unknown-error.description.non-final': 'Als vernieuwen de problemen niet verhelpt, {contactSupport}.',
    'project-pages.errors.unknown-error.title.non-final': "We kunnen projectpagina's op dit moment niet weergeven",
    'project-pages.generic-error.button.reload': 'Pagina opnieuw laden',
    'project-pages.generic-error.description': 'Er is iets misgegaan. Probeer het later opnieuw.',
    'project-pages.generic-error.description.non-final': 'Er is iets misgegaan. Probeer het later opnieuw.',
    'project-pages.generic-error.heading': 'Hmm, dit is niet zo handig...',
    'project-pages.generic-error.title.non-final': 'Hmm, dit is niet zo handig...',
    'project-pages.generic-info-flag.description': 'Er is iets misgegaan. Probeer het opnieuw of neem contact op met support als het probleem zich blijft voordoen',
    'project-pages.generic-success-flag.description.live-doc': 'Gekoppeld met live doc {connectedSpaceOrPageName}.',
    'project-pages.generic-success-flag.description.page': 'Gekoppeld met {connectedSpaceOrPageName}-pagina.',
    'project-pages.generic-success-flag.description.space': 'Gekoppeld met {connectedSpaceOrPageName}-space.',
    'project-pages.generic-success-flag.heading.live-doc': 'Live doc gekoppeld',
    'project-pages.generic-success-flag.heading.page': 'Pagina gekoppeld',
    'project-pages.generic-success-flag.heading.space': 'Space gekoppeld',
    'project-pages.granular-pages.connect-space-dialog.content.create-space-link.link-text': 'Of een nieuwe space aanmaken',
    'project-pages.granular-pages.connect-space.button': 'Koppelen aan Confluence',
    'project-pages.granular-pages.connect-space.heading': 'Koppel dit project aan een Confluence-space of -item',
    'project-pages.improvement.contact-support': 'Neem contact op met support',
    'project-pages.improvement.errors.access-error.description': 'Neem contact op met de sitebeheerder voor toegang.',
    'project-pages.improvement.errors.access-error.title': "Je hebt geen rechten om projectpagina's weer te geven",
    'project-pages.improvement.errors.page-tree-unknown-error.description': "Er is iets misgegaan bij het weergeven van pagina's van je gekoppelde Confluence-space. Als vernieuwen de problemen niet verhelpt, {contactSupport}.",
    'project-pages.improvement.errors.page-tree-unknown-error.title': "We kunnen de projectpagina's niet weergeven",
    'project-pages.improvement.errors.space-or-page-not-found.description': 'De Confluence-space of -pagina die gekoppeld was, is verplaatst, gearchiveerd of verwijderd. <link>Neem contact op met support</link> als vernieuwen niet helpt',
    'project-pages.improvement.errors.space-or-page-not-found.title': 'Space of pagina niet gevonden',
    'project-pages.improvement.errors.unknown-error.description': 'Als vernieuwen de problemen niet verhelpt, {contactSupport}.',
    'project-pages.improvement.errors.unknown-error.title': "We kunnen projectpagina's op dit moment niet weergeven",
    'project-pages.improvement.feature1': 'Open en maak documenten aan zonder Jira te verlaten',
    'project-pages.improvement.feature2': 'Sjablonen voor vergaderingen, sprintplannen en meer',
    'project-pages.improvement.feature3': 'Synchroniseer documenten naar Jira voor automatische updates',
    'project-pages.improvement.heading-info': 'Leg de kennis van je team vast en verbeter je manier van werken.',
    'project-pages.improvement.heading-info-v2': "Cre\xeber \xe9\xe9n plek voor alle projectdocumenten van je team",
    'project-pages.improvement.learn-more-button': 'Meer informatie',
    'project-pages.improvement.powered-by': 'Mogelijk gemaakt door',
    'project-pages.improvement.powered-by.tooltip': 'Confluence openen op een nieuw tabblad',
    'project-pages.improvement.preview-teaser': "Sjablonen, projectpagina's en meer ontgrendelen.",
    'project-pages.improvement.provisioning-info-modal.seamlessly-update-stakeholders.description': '<p>Houd je projectrapporten up-to-date met statuslabels die automatisch bijgewerkt worden.</p> <p>Koppel een Jira-ticket in een document en deze geeft automatisch een statuslabel weer die tegelijk met het ticket wordt bijgewerkt. Je hoeft dan geen tijd te besteden aan het handmatig aanmaken van rapporten.</p>',
    'project-pages.improvement.provisioning-info-modal.seamlessly-update-stakeholders.title': 'Werk je belanghebbenden moeiteloos bij',
    'project-pages.improvement.provisioning-info-modal.unify-documentation-standards.description': "<p>Maak consistente documentatie aan door onze ingebouwde sjablonen te gebruiken. Deze zijn gebruiksvriendelijk en kunnen aan je behoeften aangepast worden.</p> <p>Je kunt sjablonen rechtstreeks op projectpagina's gebruiken, zodat je dat waar je aan werkt, nooit hoeft achter te laten. Blader <a>hier</a> door alle sjablonen.</p>",
    'project-pages.improvement.provisioning-info-modal.unify-documentation-standards.title': 'Verenig je documentatienormen',
    'project-pages.improvement.provisioning-info-modal.your-project-pages-in-jira.description': "<p>Zorg voor \xe9\xe9n bron van waarheid voor belangrijke informatie door documentatie aan te maken en te beheren vanaf het tabblad projectpagina's in Jira.</p> <p>Wist je dat projectpagina's op Confluence draaien? Het is gratis voor maximaal 10 gebruikers. Nodig de rest van je team uit in de beheerdersinstellingen.</p>",
    'project-pages.improvement.provisioning-info-modal.your-project-pages-in-jira.title': "Je projectpagina's, rechtstreeks in Jira",
    'project-pages.improvement.templates-sidebar.better-together-templates-header': "Sjablonen die zijn ge\xefntegreerd met je Jira-gegevens",
    'project-pages.improvement.templates.better-together-preview-teaser': "Ge\xefntegreerd met Jira-gegevens",
    'project-pages.improvement.templates.blank-page.description': 'Begin met een nieuwe pagina.',
    'project-pages.improvement.templates.blank-page.name': 'Lege pagina',
    'project-pages.improvement.templates.decision.description': 'Sla belangrijke projectbeslissingen op en communiceer deze met je team.',
    'project-pages.improvement.templates.decision.name': 'Beslissing',
    'project-pages.improvement.templates.meeting-notes.description': 'Plan je afspraken en deel notities en acties met je team.',
    'project-pages.improvement.templates.meeting-notes.name': 'Notulen',
    'project-pages.improvement.templates.post-expand.more': 'Meer sjablonen',
    'project-pages.improvement.templates.post-expand.more.tooltip': 'Bekijk alle sjablonen in Confluence',
    'project-pages.improvement.templates.post-expand.subtitle': 'Populaire sjablonen',
    'project-pages.improvement.templates.post-expand.title': 'Maak een pagina aan',
    'project-pages.improvement.templates.pre-expand.more': 'Bekijk meer sjablonen',
    'project-pages.improvement.templates.pre-expand.subtitle': 'Populair bij andere teams',
    'project-pages.improvement.templates.pre-expand.title': 'Voorbeeldsjablonen',
    'project-pages.improvement.templates.product-requirements.description': 'Definieer, volg en beoordeel vereisten van je product of feature.',
    'project-pages.improvement.templates.product-requirements.name': 'Producteisen',
    'project-pages.improvement.templates.retrospective.description': 'Wat ging er goed? Wat had beter gekund? Crowdsource verbeteringen met je team.',
    'project-pages.improvement.templates.retrospective.name': 'Retrospectief',
    'project-pages.improvement.templates.template.disabled-tooltip': 'Koppel eerst een Confluence-space',
    'project-pages.improvement.templates.tutorial.content.confluence-templates': '<b>Bespaar tijd en doe minder handmatig</b>. Confluence heeft heel veel <a>paginasjablonen</a> dus je hoeft niet vanaf nul te beginnen. Denk aan technische documenten, handleidingen voor het oplossen van problemen, projectplannen, productvereisten en meer.',
    'project-pages.improvement.templates.tutorial.content.edit-and-format': '<b>Eenvoudig bewerken en formatteren.</b> Gebruik het bovenste bewerkingsmenu voor standaard woordopmaak. En door <b>/</b> te typen kun je gemakkelijk veel handige integraties invoegen. Voeg een tabel in door <c>/table</c> te typen of voeg een afbeelding in met <c>/image</c>. Je kunt ook Dropbox-links <c>/dropbox</c>, Microsoft 365-tools <c>/microsoft</c> of Trello-borden en -kaarten <c>/trello</c> invoegen.',
    'project-pages.improvement.templates.tutorial.content.forward-slash-prompt': "Type / gevolgd door 'tabel' of 'afbeelding'",
    'project-pages.improvement.templates.tutorial.content.getting-started-tips': 'Hier zijn een aantal tips om aan de slag te gaan:',
    'project-pages.improvement.templates.tutorial.content.handy-links': 'Handige links',
    'project-pages.improvement.templates.tutorial.content.jira-and-confluence': 'Jira en Confluence samen gebruiken',
    'project-pages.improvement.templates.tutorial.content.jira-charts': "Maak grafieken op je pagina's met echte gegevens uit Jira Typ <c>/Jira-grafieken</c>.",
    'project-pages.improvement.templates.tutorial.content.jira-links': 'Link waar je maar wilt een Jira-issue op je pagina. De link op de pagina zal in realtime bijgewerkt worden wanneer je de Jira-issue bijwerkt. Typ <c>/Jira</c>.',
    'project-pages.improvement.templates.tutorial.content.jira-links-issue-term-refresh': 'Koppel een Jira-werkitem aan een willekeurige plek op je pagina. De link op de pagina wordt in realtime bijgewerkt als je het werkitem bijwerkt. Typ <c>/Jira</c>.',
    'project-pages.improvement.templates.tutorial.content.jira-links.non-final-issue-term-refresh': 'Koppel een Jira-werkitem aan een willekeurige plek op je pagina. De link op de pagina wordt in realtime bijgewerkt als je het werkitem bijwerkt. Typ <c>/Jira</c>.',
    'project-pages.improvement.templates.tutorial.content.jira-roadmaps': 'Sluit interactieve roadmaps en tijdlijnen in op je pagina met behulp van je Jira-projecten. Typ <c>/jira-roadmap</c>.',
    'project-pages.improvement.templates.tutorial.content.jira-timeline': 'Sluit interactieve tijdlijnen in op je pagina met behulp van je Jira-projecten. Typ <c>/jira-tijdlijn</c>.',
    'project-pages.improvement.templates.tutorial.content.shipping-speed-statistic': '76% van de Jira Software-klanten zegt projecten sneller te leveren dankzij Confluence',
    'project-pages.improvement.templates.tutorial.content.shipping-speed-statistic.spork-rebranding': '76% van de Jira-klanten zegt dat ze projecten sneller kunnen leveren nadat ze Confluence hebben toegevoegd',
    'project-pages.improvement.templates.tutorial.content.spaces-and-pages': "<b>Spaces en pagina's gebruiken</b>. Spaces maken deel uit van elke Confluence-site en zijn een manier om pagina's in categorie\xebn in te delen. Zie spaces als verschillende mappen of projecten, en pagina's zijn de documenten die in die mappen of projecten thuishoren. <a>Meer informatie over het gebruik van spaces</a>",
    'project-pages.improvement.templates.tutorial.content.try-it-now': 'Probeer het nu',
    'project-pages.improvement.templates.tutorial.description': 'Meer informatie over hoe je een pagina bewerkt.',
    'project-pages.improvement.templates.tutorial.name': "Welkom bij de Projectpagina's!",
    'project-pages.improvement.terms-and-conditions-v2': "Door op 'Nu proberen' te klikken, stem je ermee in dat je wordt ingeschreven in Confluence en ga je akkoord met de <termsLink>Servicevoorwaarden</termsLink> en het <privacyLink>Privacybeleid</privacyLink> van Atlassian Cloud.",
    'project-pages.improvement.title': "Projectpagina's",
    'project-pages.improvement.transient-states.empty-state.auto-provisioned-create-page-button': 'Pagina aanmaken',
    'project-pages.improvement.transient-states.empty-state.auto-provisioned-description': 'We hebben Confluence toegevoegd, zodat je kunt beginnen met het aanmaken en koppelen van al je projectdocumenten. Het is gratis voor maximaal 10 gebruikers.',
    'project-pages.improvement.transient-states.empty-state.auto-provisioned-learn-more-button': 'Meer informatie',
    'project-pages.improvement.transient-states.empty-state.create-page-button': 'Maak je eerste pagina aan',
    'project-pages.improvement.transient-states.empty-state.description': 'Maak vergadernotulen aan, stel productvereisten op, neem beslissingen of maak andere content aan, om deze space op te vullen.',
    'project-pages.improvement.transient-states.empty-state.title': 'Hier zijn alleen maar mogelijkheden',
    'project-pages.improvement.try-button': 'Probeer dit sjabloon in Confluence',
    'project-pages.improvement.try-it-now': 'Nu proberen',
    'project-pages.improvement.try-lozenge': 'Probeer',
    'project-pages.improvement.try-on-demand-button': 'Gratis uitproberen',
    'project-pages.page-deleted-flag.title': 'Pagina verwijderd.',
    'project-pages.page-published-flag.title': 'Je pagina is gepubliceerd.',
    'project-pages.unknown-error.description': 'Als vernieuwen de problemen niet verhelpt, {contactSupport}.',
    'project-pages.unknown-error.heading': "We kunnen projectpagina's op dit moment niet weergeven"
};

});

parcelRegister("kQZO7", function(module, exports) {

$parcel$export(module.exports, "default", () => $9fa50d942fb88159$export$2e2bcd8739ae039);
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Estonian
var $9fa50d942fb88159$export$2e2bcd8739ae039 = {
    'project-pages.connect-space-dialog.connection-error': "\xdchenduse loomine eba\xf5nnestus.",
    'project-pages.connect-space-dialog.connection-retry': 'Proovi uuesti',
    'project-pages.connect-space-dialog.content.space-selector.disconnected-templates-description': "Enne lehe loomist peab projekt olema \xfchendatud ruumiga. Projektiga \xfchenduse loomiseks valige ruum.",
    'project-pages.connect-space-dialog.error-icon': 'Viga:',
    'project-pages.connect-space-dialog.footer.cancel': "T\xfchista",
    'project-pages.connect-space-dialog.footer.connect-space': "\xdchenda",
    'project-pages.connect-space.description': "Ruumid on nagu kaustad \u2013 saate neid kasutada oma projektiga seotud sisu loomiseks ja sorteerimiseks ning koost\xf6\xf6 tegemiseks.",
    'project-pages.create-space-dialog.connection-error': "\xdchenduse loomine eba\xf5nnestus.",
    'project-pages.create-space-dialog.connection-retry': 'Proovi uuesti',
    'project-pages.create-space-dialog.content.empty-name': 'Andke ruumile nimi.',
    'project-pages.create-space-dialog.content.invalid-name': "Ruumi nimes peab olema v\xe4hemalt \xfcks t\xe4ht v\xf5i number.",
    'project-pages.create-space-dialog.content.placeholder': 'Sisestage ruumi nimi',
    'project-pages.create-space-dialog.creation-error': "Ruumi loomine eba\xf5nnestus.",
    'project-pages.create-space-dialog.error-icon': 'Viga:',
    'project-pages.create-space-dialog.footer.cancel': "T\xfchista",
    'project-pages.create-space-dialog.footer.create-space': 'Loo',
    'project-pages.create-space-dialog.header.title': "Uue Confluence\u2019i ruumi loomine",
    'project-pages.default-contextual-message': "Confluence\u2019i lehtede abil saate \xfches kohas k\xf5iki projektidokumente koostada ja jagada ning nende kallal koost\xf6\xf6d teha.",
    'project-pages.default-reactivate-CTA': 'Aktiveerige Confluence uuesti',
    'project-pages.default-trial-CTA': "Proovige Confluence\u2019i 30 p\xe4eva tasuta",
    'project-pages.generic-error.button.reload': "Lehek\xfclje uuesti laadimine",
    'project-pages.generic-error.description': "Midagi l\xe4ks valesti. Proovige hiljem uuesti.",
    'project-pages.generic-error.heading': 'Oih, piinlik lugu ...'
};

});

parcelRegister("kyyPr", function(module, exports) {

$parcel$export(module.exports, "default", () => $158b6bb89b07ced2$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Finnish
var $158b6bb89b07ced2$export$2e2bcd8739ae039 = {
    'confluence.project-pages.improvement.provisioning-background.text': "T\xe4m\xe4 vie alle minuutin",
    'confluence.project-pages.improvement.provisioning-background.title': "M\xe4\xe4ritet\xe4\xe4n projektisivuja",
    'confluence.project-pages.improvement.provisioning-modal-carousel.controls.dismiss': 'Ohita',
    'confluence.project-pages.improvement.provisioning-modal-carousel.controls.done': 'Valmis',
    'confluence.project-pages.improvement.provisioning-modal-carousel.controls.next': 'Seuraava',
    'project-pages.activating.description': "Yhdistetty Confluence-ty\xf6tila ei ole ihan viel\xe4 valmis. {contactSupport}, jos sivun p\xe4ivitt\xe4minen ei korjaa asiaa.",
    'project-pages.activating.heading': "Confluence latautuu viel\xe4",
    'project-pages.better-together-templates.meeting-notes.action-items-heading': "Mit\xe4 teht\xe4v\xe4t ovat?",
    'project-pages.better-together-templates.meeting-notes.agenda-item-label': 'Esityslistan kohde',
    'project-pages.better-together-templates.meeting-notes.create-a-jira-issue': 'Luo asia kirjoittamalla /Jira',
    'project-pages.better-together-templates.meeting-notes.date-label': "P\xe4iv\xe4m\xe4\xe4r\xe4",
    'project-pages.better-together-templates.meeting-notes.discussion-topics-heading': 'Keskusteluaiheet',
    'project-pages.better-together-templates.meeting-notes.list-people': "luettele henkil\xf6it\xe4 toiminnolla",
    'project-pages.better-together-templates.meeting-notes.mention': 'mainitse',
    'project-pages.better-together-templates.meeting-notes.mention-people-to-assign-them': "henkil\xf6it\xe4, jotta voit m\xe4\xe4r\xe4t\xe4 heille teht\xe4vi\xe4",
    'project-pages.better-together-templates.meeting-notes.notes-label': 'Huomautukset',
    'project-pages.better-together-templates.meeting-notes.page-title': 'Kokousmuistio',
    'project-pages.better-together-templates.meeting-notes.participants-label': 'Osallistujat',
    'project-pages.better-together-templates.meeting-notes.project-label': 'Projekti',
    'project-pages.better-together-templates.product-requirements.create-a-jira-issue': 'Luo asia kirjoittamalla /Jira',
    'project-pages.better-together-templates.product-requirements.design-heading': 'Suunnittelu',
    'project-pages.better-together-templates.product-requirements.embedd-different-data-views': "Upota erilaisia tietoja ja n\xe4kymi\xe4 Jira-projektista.",
    'project-pages.better-together-templates.product-requirements.heading': 'Yleiskatsaus',
    'project-pages.better-together-templates.product-requirements.how-will-you-know-if-fixed': "Mist\xe4 tiet\xe4\xe4, ett\xe4 se on korjattu?",
    'project-pages.better-together-templates.product-requirements.impact-heading': 'Vaikutus',
    'project-pages.better-together-templates.product-requirements.inScopeStatus': "Sis\xe4ltyy laajuuteen",
    'project-pages.better-together-templates.product-requirements.insert-design-link': "Lis\xe4\xe4 linkki suunnitteluusi (Figma jne.)",
    'project-pages.better-together-templates.product-requirements.jira-issue-heading': 'Jira-asia',
    'project-pages.better-together-templates.product-requirements.jira-roadmap-heading': 'Jira-etenemissuunnitelma',
    'project-pages.better-together-templates.product-requirements.learn-how-with-smart-links': "Lue lis\xe4\xe4 Smart Linkeist\xe4",
    'project-pages.better-together-templates.product-requirements.list-dashboards': 'Luettele etusivuja (Amplitude, Mode jne.)',
    'project-pages.better-together-templates.product-requirements.list-design-considerations': "Luettele, mit\xe4 suunnittelua tai koontia varten tulee mietti\xe4",
    'project-pages.better-together-templates.product-requirements.list-people': "luettele henkil\xf6it\xe4 toiminnolla",
    'project-pages.better-together-templates.product-requirements.mention': 'mainitse',
    'project-pages.better-together-templates.product-requirements.mention-people-to-assign-them': "henkil\xf6it\xe4, jotta voit m\xe4\xe4r\xe4t\xe4 heille teht\xe4vi\xe4",
    'project-pages.better-together-templates.product-requirements.niceToHaveStatus': 'Toiveet',
    'project-pages.better-together-templates.product-requirements.outOfScopeStatus': 'Laajuuden ulkopuolella',
    'project-pages.better-together-templates.product-requirements.page-title': 'Tuotevaatimukset',
    'project-pages.better-together-templates.product-requirements.pro-tip': 'Erikoisvinkki:',
    'project-pages.better-together-templates.product-requirements.problem-label': 'Ongelma',
    'project-pages.better-together-templates.product-requirements.requirement-heading': 'Vaatimus',
    'project-pages.better-together-templates.product-requirements.scope-heading': 'Laajuus',
    'project-pages.better-together-templates.product-requirements.success-metric': 'Menestymisen mittari',
    'project-pages.better-together-templates.product-requirements.target-release-date': "Tavoiteltu julkaisup\xe4iv\xe4m\xe4\xe4r\xe4",
    'project-pages.better-together-templates.product-requirements.team-label': 'Tiimi',
    'project-pages.better-together-templates.product-requirements.to-do-list-heading': "Teht\xe4v\xe4lista",
    'project-pages.better-together-templates.product-requirements.what-are-you-trying-to-fix': "Mit\xe4 yrit\xe4t korjata?",
    'project-pages.better-together-templates.retro-notes.retro-heading': 'Retrospektiivi',
    'project-pages.better-together-templates.retro.action-items-heading': "Mit\xe4 teht\xe4v\xe4t ovat?",
    'project-pages.better-together-templates.retro.create-a-jira-issue': 'Luo asia kirjoittamalla /Jira',
    'project-pages.better-together-templates.retro.date-label': "P\xe4iv\xe4m\xe4\xe4r\xe4",
    'project-pages.better-together-templates.retro.embed-it-here': "Kun olet valmis, voit upottaa sen t\xe4h\xe4n.",
    'project-pages.better-together-templates.retro.list-people': "luettele henkil\xf6it\xe4 toiminnolla",
    'project-pages.better-together-templates.retro.mention': 'mainitse',
    'project-pages.better-together-templates.retro.mention-people-to-assign-them': "henkil\xf6it\xe4, jotta voit m\xe4\xe4r\xe4t\xe4 heille teht\xe4vi\xe4",
    'project-pages.better-together-templates.retro.page-title': 'Retrospektiivi',
    'project-pages.better-together-templates.retro.participants-label': 'Osallistujat',
    'project-pages.better-together-templates.retro.pro-tip': 'Erikoisvinkki:',
    'project-pages.better-together-templates.retro.project-label': 'Projekti',
    'project-pages.better-together-templates.retro.this-is-a-whiteboard': "T\xe4m\xe4 on Confluence-valkotaulu.",
    'project-pages.better-together-templates.retro.use-a-whiteboard': "K\xe4yt\xe4 Confluence-valkotaulua retrospektiiviin.",
    'project-pages.better-together-templates.retro.use-it-to-vote': "Sit\xe4 voi k\xe4ytt\xe4\xe4 \xe4\xe4nestyksiin ja yhteisty\xf6n tekemiseen tiimin kanssa.",
    'project-pages.button.connect-different-space-or-page.label': "P\xe4ivit\xe4 ty\xf6tila tai sivu -kuvake",
    'project-pages.button.connect-different-space-or-page.tooltip': "Yhdist\xe4 eri ty\xf6tilaan tai kohteeseen",
    'project-pages.button.connect-space-or-page.tooltip': "Yhdist\xe4 Confluenceen",
    'project-pages.button.go-to-connected-live-doc.tooltip': 'Avaa reaaliaikainen asiakirja Confluencessa',
    'project-pages.button.go-to-connected-page.tooltip': 'Avaa sivu Confluencessa',
    'project-pages.button.go-to-connected-space.tooltip': "Avaa ty\xf6tila Confluencessa",
    'project-pages.connect-space-dialog.connection-error': "Yhteys ep\xe4onnistui.",
    'project-pages.connect-space-dialog.connection-retry': "Yrit\xe4 uudelleen",
    'project-pages.connect-space-dialog.content.space-or-page-selector.description': "Valitse projektiisi yhdistett\xe4v\xe4 ty\xf6tila tai kohde.",
    'project-pages.connect-space-dialog.content.space-or-page-selector.placeholder': 'Hae Confluencesta',
    'project-pages.connect-space-dialog.content.space-selector.disconnected-templates-description': "T\xe4m\xe4 projekti t\xe4ytyy yhdist\xe4\xe4 ty\xf6tilaan, ennen kuin voit luoda kohteen. Valitse ty\xf6tila, joka yhdistet\xe4\xe4n t\xe4h\xe4n projektiin.",
    'project-pages.connect-space-dialog.error-icon': 'Virhe:',
    'project-pages.connect-space-dialog.footer.cancel': 'Peruuta',
    'project-pages.connect-space-dialog.footer.connect-space': "Yhdist\xe4",
    'project-pages.connect-space-or-page-dialog.header.title': "Yhdist\xe4 projekti Confluenceen",
    'project-pages.connect-space.description': "Ty\xf6tilat ovat kuin kansioita \u2013 niit\xe4 voi k\xe4ytt\xe4\xe4, kun haluat luoda, j\xe4rjest\xe4\xe4 ja ty\xf6st\xe4\xe4 yhdess\xe4 kaikkea projektiisi liittyv\xe4\xe4 sis\xe4lt\xf6\xe4.",
    'project-pages.connect-space.not-connected.description': "Jotta voit k\xe4ytt\xe4\xe4 projektisivuja, ota yhteytt\xe4 yll\xe4pit\xe4j\xe4\xe4si tai tiimisi vet\xe4j\xe4\xe4n Confluencen yhdist\xe4miseksi t\xe4h\xe4n projektiin.",
    'project-pages.connect-space.not-connected.heading': 'Ei yhdistetty Confluenceen',
    'project-pages.connect-success-flag.description.content': "Yhdistetty sis\xe4ll\xf6n {connectedSpaceOrPageName} kanssa.",
    'project-pages.connection-error.space-or-page-not-found.button': "Yhdist\xe4 eri ty\xf6tilaan tai sivuun",
    'project-pages.create-space-dialog.connection-error': "Yhteys ep\xe4onnistui.",
    'project-pages.create-space-dialog.connection-retry': "Yrit\xe4 uudelleen",
    'project-pages.create-space-dialog.content.empty-name': "Nime\xe4 ty\xf6tilasi.",
    'project-pages.create-space-dialog.content.invalid-name': "Ty\xf6tilan nimess\xe4 on oltava v\xe4hint\xe4\xe4n yksi kirjain tai numero.",
    'project-pages.create-space-dialog.content.placeholder': "Sy\xf6t\xe4 ty\xf6tilan nimi",
    'project-pages.create-space-dialog.creation-error': "Ty\xf6tilan luonti ep\xe4onnistui.",
    'project-pages.create-space-dialog.error-icon': 'Virhe:',
    'project-pages.create-space-dialog.footer.cancel': 'Peruuta',
    'project-pages.create-space-dialog.footer.create-space': 'Luo',
    'project-pages.create-space-dialog.header.title': "Luo uusi Confluence-ty\xf6tila",
    'project-pages.cross-join.access-revoked.templates.subtitle': "Et voi k\xe4ytt\xe4\xe4 projektin sivuja, koska yll\xe4pit\xe4j\xe4 on ev\xe4nnyt p\xe4\xe4sysi Confluenceen. Ota yhteytt\xe4 sivustosi yll\xe4pit\xe4j\xe4\xe4n p\xe4\xe4syn pyyt\xe4mist\xe4 varten.",
    'project-pages.cross-join.access-revoked.templates.title': "Sinulla ei ole oikeutta k\xe4ytt\xe4\xe4 projektin sivuja",
    'project-pages.cross-join.avatar.view-profile': "N\xe4yt\xe4 profiili",
    'project-pages.cross-join.denied-request.templates.subtitle': "Et voi k\xe4ytt\xe4\xe4 projektin sivuja, koska sivuston yll\xe4pit\xe4j\xe4 hylk\xe4si pyynt\xf6si liitty\xe4 Confluenceen.",
    'project-pages.cross-join.denied-request.templates.title': "Yll\xe4pit\xe4j\xe4si on ev\xe4nnyt p\xe4\xe4sysi",
    'project-pages.cross-join.direct-access.button-subtitle.experimental': "Saat Confluencen k\xe4ytt\xf6oikeuden. Sivustosi yll\xe4pit\xe4j\xe4 on jo hyv\xe4ksynyt sinut.",
    'project-pages.cross-join.errors.unknown-error.description': "{contactSupport}, jos sivun p\xe4ivitt\xe4minen ei korjaa asiaa.",
    'project-pages.cross-join.errors.unknown-error.title': "Projektisivuja ei voi n\xe4ytt\xe4\xe4 juuri nyt",
    'project-pages.cross-join.inline-join-product.button': "Saat Confluencen k\xe4ytt\xf6oikeuden. Sivustosi yll\xe4pit\xe4j\xe4 on jo hyv\xe4ksynyt sinut.",
    'project-pages.cross-join.inline-join-product.connected.description': "Tarkastele, muokkaa ja luo dokumentteja yhdess\xe4 paikassa",
    'project-pages.cross-join.inline-join-product.connected.title': "Ty\xf6st\xe4 projektisivuja yhdess\xe4 tiimisi kanssa",
    'project-pages.cross-join.pending-request.templates.subtitle': "Sivuston yll\xe4pit\xe4j\xe4 on vastaanottanut pyynt\xf6si liitty\xe4 Confluenceen. Jos liittymispyynt\xf6si hyv\xe4ksyt\xe4\xe4n, projektisivut alkavat toimia ja l\xe4het\xe4mme sinulle vahvistuss\xe4hk\xf6postin.",
    'project-pages.cross-join.pending-request.templates.subtitle.experiment': "Saat s\xe4hk\xf6postiviestin, jossa on p\xe4\xe4sy projektisivuille, kun sinut on hyv\xe4ksytty.",
    'project-pages.cross-join.pending-request.templates.title': "Olet pyyt\xe4nyt p\xe4\xe4sy\xe4 Confluenceen",
    'project-pages.cross-join.pending-request.templates.title.experiment': "K\xe4ytt\xf6oikeuspyynt\xf6 l\xe4hetetty yll\xe4pit\xe4j\xe4lle",
    'project-pages.cross-join.request-access-without-better-together.connected.description': "Tarkastele, muokkaa ja luo projektidokumentteja yhdess\xe4 tiimisi kanssa",
    'project-pages.cross-join.request-access.button': "Pyyd\xe4 p\xe4\xe4sy\xe4",
    'project-pages.cross-join.request-access.button-subtitle.experimental': "Valitsemalla Liity tiimiisi pyyd\xe4t liittymist\xe4 Confluenceen ja hyv\xe4ksyt sen, ett\xe4 Atlassian-profiilisi jaetaan yll\xe4pit\xe4j\xe4lle.",
    'project-pages.cross-join.request-access.button.experimental': 'Liity tiimiisi',
    'project-pages.cross-join.request-access.connected.description.experimental': "Tiimisi k\xe4ytt\xe4\xe4 projektisivuja kommentointiin, muokkaamiseen ja yhteisty\xf6n tekoon projektidokumentaatiossa poistumatta Jirasta. Liity Confluenceen, niin p\xe4\xe4set tiimisi projektisivuille.",
    'project-pages.cross-join.request-access.title': "Projektisivut vaativat p\xe4\xe4syn Confluenceen",
    'project-pages.cross-join.request-access.title.experiment': "Luo yksi tiedonl\xe4hde tiimillesi",
    'project-pages.default-contextual-heading': 'Projektisivuista vastaa Confluence',
    'project-pages.default-contextual-message': "Luo, jaa ja ty\xf6st\xe4 yhdess\xe4 kaikkia projektiasiakirjojasi yhdess\xe4 paikassa Confluence-sivujen avulla.",
    'project-pages.default-reactivate-CTA': 'Aktivoi Confluence uudelleen',
    'project-pages.default-trial-CTA': "Kokeile Confluencea ilmaiseksi 30 p\xe4iv\xe4n ajan",
    'project-pages.draft-saved-flag.action': 'Avaa luonnos',
    'project-pages.draft-saved-flag.description': "Luonnoksesi n\xe4kyy vain siihen asti, kunnes julkaiset sen.",
    'project-pages.draft-saved-flag.title': 'Luonnos tallennettu',
    'project-pages.embedded-pages.create-page-error.close-button': 'Sulje',
    'project-pages.embedded-pages.create-page-error.description': "Tapahtui virhe, eik\xe4 sivun luominen onnistunut.",
    'project-pages.embedded-pages.create-page-error.title': 'Sivun luominen ei onnistunut',
    'project-pages.embedded-pages.create-page-error.try-again-button': "Yrit\xe4 uudelleen",
    'project-pages.embedded-pages.modal.close.button.hint': 'Sulje',
    'project-pages.embedded-pages.modal.title.button': 'Avaa Confluencessa',
    'project-pages.embedded-pages.modal.title.button.hint': "Avaa uudelle v\xe4lilehdelle",
    'project-pages.errors.unknown-error.description.non-final': "{contactSupport}, jos sivun p\xe4ivitt\xe4minen ei korjaa asiaa.",
    'project-pages.errors.unknown-error.title.non-final': "Projektisivuja ei voi n\xe4ytt\xe4\xe4 juuri nyt",
    'project-pages.generic-error.button.reload': 'Lataa sivu uudelleen',
    'project-pages.generic-error.description': "Jotain meni pieleen. Yrit\xe4 my\xf6hemmin uudelleen.",
    'project-pages.generic-error.description.non-final': "Jotain meni pieleen. Yrit\xe4 my\xf6hemmin uudelleen.",
    'project-pages.generic-error.heading': "Nyt k\xe4vi nolosti.",
    'project-pages.generic-error.title.non-final': "Nyt k\xe4vi nolosti.",
    'project-pages.generic-info-flag.description': "Jokin meni vikaan. Yrit\xe4 uudelleen tai ota yhteys tukeen, jos ongelma jatkuu",
    'project-pages.generic-success-flag.description.live-doc': 'Yhdistetty reaaliaikaisen asiakirjan {connectedSpaceOrPageName} kanssa.',
    'project-pages.generic-success-flag.description.page': 'Yhdistetty onnistuneesti sivun {connectedSpaceOrPageName} kanssa.',
    'project-pages.generic-success-flag.description.space': "Yhdistetty onnistuneesti ty\xf6tilan {connectedSpaceOrPageName} kanssa.",
    'project-pages.generic-success-flag.heading.live-doc': 'Reaaliaikainen asiakirja yhdistetty',
    'project-pages.generic-success-flag.heading.page': 'Sivu yhdistetty',
    'project-pages.generic-success-flag.heading.space': "Ty\xf6tila yhdistetty",
    'project-pages.granular-pages.connect-space-dialog.content.create-space-link.link-text': "Tai luo uusi ty\xf6tila",
    'project-pages.granular-pages.connect-space.button': "Yhdist\xe4 Confluenceen",
    'project-pages.granular-pages.connect-space.heading': "Yhdist\xe4 t\xe4m\xe4 projekti Confluence-ty\xf6tilaan tai \u2011kohteeseen",
    'project-pages.improvement.contact-support': "Ota yhteytt\xe4 tukeen",
    'project-pages.improvement.errors.access-error.description': "Kokeile pyyt\xe4\xe4 k\xe4ytt\xf6oikeutta sivuston yll\xe4pit\xe4j\xe4lt\xe4.",
    'project-pages.improvement.errors.access-error.title': 'Sinulla ei ole lupaa tarkastella projektisivuja',
    'project-pages.improvement.errors.page-tree-unknown-error.description': "Jokin meni vikaan, kun yhdistetyn Confluence-ty\xf6tilan sivuja yritettiin n\xe4ytt\xe4\xe4. {contactSupport}, jos sivun p\xe4ivitt\xe4minen ei korjaa asiaa.",
    'project-pages.improvement.errors.page-tree-unknown-error.title': "Projektisivujen n\xe4ytt\xe4misess\xe4 on ongelmia",
    'project-pages.improvement.errors.space-or-page-not-found.description': "Yhdistetty Confluence-ty\xf6tila tai \u2011sivu on siirretty, arkistoitu tai poistettu. <link>Ota yhteytt\xe4 tukeen</link>, jos uudelleen yhdist\xe4minen ei korjaa asiaa",
    'project-pages.improvement.errors.space-or-page-not-found.title': "Ty\xf6tilaa tai sivua ei l\xf6ytynyt",
    'project-pages.improvement.errors.unknown-error.description': "{contactSupport}, jos sivun p\xe4ivitt\xe4minen ei korjaa asiaa.",
    'project-pages.improvement.errors.unknown-error.title': "Projektisivuja ei voi n\xe4ytt\xe4\xe4 juuri nyt",
    'project-pages.improvement.feature1': "K\xe4yt\xe4 ja luo asiakirjoja poistumatta Jirasta",
    'project-pages.improvement.feature2': 'Sivupohjat muun muassa kokouksiin ja sprinttisuunnitelmiin',
    'project-pages.improvement.feature3': "Synkronoi asiakirjat Jiraan automaattisia p\xe4ivityksi\xe4 varten",
    'project-pages.improvement.heading-info': "Taltioi tiimisi tiet\xe4mys ja paranna tapaa, jolla ty\xf6t vied\xe4\xe4n loppuun.",
    'project-pages.improvement.heading-info-v2': 'Luo yksi paikka kaikille tiimisi projektiasiakirjoille',
    'project-pages.improvement.learn-more-button': "Lue lis\xe4\xe4",
    'project-pages.improvement.powered-by': 'Palvelun tarjoaa',
    'project-pages.improvement.powered-by.tooltip': "Avaa Confluence uudella v\xe4lilehdell\xe4",
    'project-pages.improvement.preview-teaser': "Avaa k\xe4ytt\xf6\xf6n sivupohjia, projektisivuja ja paljon muuta.",
    'project-pages.improvement.provisioning-info-modal.seamlessly-update-stakeholders.description': "<p>Pid\xe4 projektiraportit ajan tasalla automaattisesti p\xe4ivittyvien tilatunnisteiden avulla.</p> <p>Yhdist\xe4 Jira-tukipyynt\xf6 asiakirjaan, niin tilatunniste n\xe4ytet\xe4\xe4n automaattisesti. Tunniste p\xe4ivittyy synkronoituna tukipyynn\xf6n kanssa, joten sinun ei tarvitse k\xe4ytt\xe4\xe4 aikaasi manuaalisten raporttien luomiseen.</p>",
    'project-pages.improvement.provisioning-info-modal.seamlessly-update-stakeholders.title': "P\xe4ivit\xe4 sidosryhm\xe4t saumattomasti",
    'project-pages.improvement.provisioning-info-modal.unify-documentation-standards.description': "<p>Luo johdonmukainen dokumentaatio k\xe4ytt\xe4m\xe4ll\xe4 sis\xe4\xe4nrakennettuja sivupohjia. Ne ovat helppok\xe4ytt\xf6isi\xe4 ja muokattavissa tarpeisiisi.</p> <p>Voit k\xe4ytt\xe4\xe4 sivupohjia suoraan projektisivuilta, joten sinun ei tarvitse koskaan j\xe4tt\xe4\xe4 ty\xf6t\xe4si. Selaa kaikkia sivupohjia <a>t\xe4\xe4ll\xe4</a>.</p>",
    'project-pages.improvement.provisioning-info-modal.unify-documentation-standards.title': "Yhdist\xe4 dokumentointistandardit",
    'project-pages.improvement.provisioning-info-modal.your-project-pages-in-jira.description': "<p>Luo yksi ainoa tiedonl\xe4hde t\xe4rkeille tiedoille luomalla ja hallitsemalla dokumentaatiota Jiran projektisivuv\xe4lilehdelt\xe4.</p> <p>Tiesitk\xf6, ett\xe4 projektisivut toimivat Confluencessa? Se on ilmainen jopa 10 k\xe4ytt\xe4j\xe4lle. Kutsu muu tiimisi yll\xe4pit\xe4j\xe4n asetuksissa.</p>",
    'project-pages.improvement.provisioning-info-modal.your-project-pages-in-jira.title': 'Omat projektisivut suoraan Jirassa',
    'project-pages.improvement.templates-sidebar.better-together-templates-header': 'Sivupohjat, joihin Jira-tietosi on integroitu',
    'project-pages.improvement.templates.better-together-preview-teaser': 'Jira-tiedot integroitu',
    'project-pages.improvement.templates.blank-page.description': "Aloita sivu tyhj\xe4st\xe4.",
    'project-pages.improvement.templates.blank-page.name': "Tyhj\xe4 sivu",
    'project-pages.improvement.templates.decision.description': "Tallenna t\xe4rke\xe4t projektien p\xe4\xe4t\xf6kset ja tiedota niist\xe4 tiimillesi.",
    'project-pages.improvement.templates.decision.name': "P\xe4\xe4t\xf6s",
    'project-pages.improvement.templates.meeting-notes.description': 'Suunnittele tapaamiset ja jaa muistiinpanoja tiimisi kanssa.',
    'project-pages.improvement.templates.meeting-notes.name': 'Kokousmuistiinpanot',
    'project-pages.improvement.templates.post-expand.more': "Lis\xe4\xe4 sivupohjia",
    'project-pages.improvement.templates.post-expand.more.tooltip': "N\xe4yt\xe4 kaikki sivupohjat Confluencessa",
    'project-pages.improvement.templates.post-expand.subtitle': 'Suositut sivupohjat',
    'project-pages.improvement.templates.post-expand.title': 'Luo sivu',
    'project-pages.improvement.templates.pre-expand.more': 'Tutki muita sivupohjia',
    'project-pages.improvement.templates.pre-expand.subtitle': 'Suositut omasi kaltaisten tiimien parissa',
    'project-pages.improvement.templates.pre-expand.title': 'Sivupohjien esikatselu',
    'project-pages.improvement.templates.product-requirements.description': "M\xe4\xe4rittele ja rajaa vaatimukset tuotteelle tai ominaisuudelle sek\xe4 seuraa niit\xe4.",
    'project-pages.improvement.templates.product-requirements.name': 'Tuote-edellytykset',
    'project-pages.improvement.templates.retrospective.description': "Mik\xe4 sujui hyvin? Mik\xe4 olisi voinut sujua paremmin? Keskustele tiimisi kanssa.",
    'project-pages.improvement.templates.retrospective.name': 'Retrospektiivi',
    'project-pages.improvement.templates.template.disabled-tooltip': "Yhdist\xe4 ensin Confluence-ty\xf6tila",
    'project-pages.improvement.templates.tutorial.content.confluence-templates': "<b>S\xe4\xe4st\xe4 aikaa ja v\xe4henn\xe4 manuaalisia teht\xe4vi\xe4</b>. Confluencessa on paljon <a>sivupohjia</a>, jotta sinun ei tarvitse aloittaa tyhj\xe4st\xe4. N\xe4ihin kuuluvat muun muassa tekniset asiakirjat, vianm\xe4\xe4ritysoppaat, projektisuunnitelmat ja tuotevaatimukset.",
    'project-pages.improvement.templates.tutorial.content.edit-and-format': "<b>Muokkaa ja muotoile helposti.</b> K\xe4yt\xe4 yl\xe4muokkausvalikkoa vakiomuotoiluun ja hy\xf6dynn\xe4 useita k\xe4tevi\xe4 integrointeja kirjoittamalla <b>/</b>. Lis\xe4\xe4 taulukko kirjoittamalla <c>/taulukko</c> tai kuva kirjoittamalla <c>/kuva</c>. Voit my\xf6s lis\xe4t\xe4 Dropbox-linkin kirjoittamalla <c>/dropbox</c>, Microsoft Office -ty\xf6kaluja kirjoittamalla <c>/microsoft</c> tai Trello-tauluja ja -kortteja kirjoittamalla <c>/trello</c>.",
    'project-pages.improvement.templates.tutorial.content.forward-slash-prompt': 'Kirjoita / ja sen j\xe4lkeen "taulukko" tai "kuva"',
    'project-pages.improvement.templates.tutorial.content.getting-started-tips': "T\xe4ss\xe4 on pari vinkki\xe4, joilla p\xe4\xe4set alkuun:",
    'project-pages.improvement.templates.tutorial.content.handy-links': "K\xe4tevi\xe4 linkkej\xe4",
    'project-pages.improvement.templates.tutorial.content.jira-and-confluence': "K\xe4yt\xe4 Jiraa ja Confluencea yhdess\xe4",
    'project-pages.improvement.templates.tutorial.content.jira-charts': 'Luo sivuillesi kaavioita Jirasta saatujen tietojen pohjalta. Kirjoita <c>/Jira-kaaviot</c>.',
    'project-pages.improvement.templates.tutorial.content.jira-links': "Yhdist\xe4 Jira-asia minne tahansa sivullesi. Sivun linkki p\xe4ivittyy reaaliajassa, kun p\xe4ivit\xe4t Jira-asiaa. Kirjoita <c>/Jira</c>.",
    'project-pages.improvement.templates.tutorial.content.jira-links-issue-term-refresh': "Linkit\xe4 Jira-ty\xf6teht\xe4v\xe4 minne tahansa sivullesi. Sivun linkki p\xe4ivittyy reaaliajassa, kun p\xe4ivit\xe4t ty\xf6teht\xe4v\xe4\xe4. Kirjoita <c>/Jira</c>.",
    'project-pages.improvement.templates.tutorial.content.jira-links.non-final-issue-term-refresh': "Linkit\xe4 Jira-ty\xf6teht\xe4v\xe4 minne tahansa sivullasi. Sivun linkki p\xe4ivittyy reaaliajassa, kun p\xe4ivit\xe4t ty\xf6teht\xe4v\xe4\xe4. Kirjoita <c>/Jira</c>.",
    'project-pages.improvement.templates.tutorial.content.jira-roadmaps': "Upota interaktiivisia etenemissuunnitelmia ja aikajanoja sivuusi k\xe4ytt\xe4m\xe4ll\xe4 Jira-projektejasi. Kirjoita <c>/jira-etenemissuunnitelma</c>.",
    'project-pages.improvement.templates.tutorial.content.jira-timeline': "Upota interaktiivisia aikajanoja sivuusi k\xe4ytt\xe4m\xe4ll\xe4 Jira-projektejasi. Kirjoita <c>/jira-aikajana</c>.",
    'project-pages.improvement.templates.tutorial.content.shipping-speed-statistic': "76\xa0% Jira Software -asiakkaista kertoi toimittaneensa projekteja nopeammin Confluencen lis\xe4\xe4misen j\xe4lkeen",
    'project-pages.improvement.templates.tutorial.content.shipping-speed-statistic.spork-rebranding': "76\xa0% Jira-asiakkaista kertoi toimittaneensa projekteja nopeammin Confluencen lis\xe4\xe4misen j\xe4lkeen",
    'project-pages.improvement.templates.tutorial.content.spaces-and-pages': "<b>Ty\xf6tilojen ja sivujen k\xe4ytt\xf6</b>. Ty\xf6tilat ovat osa jokaista Confluence-sivustoa, ja niiden avulla voi luokitella sivuja. Ty\xf6tilat ovat ik\xe4\xe4n kuin kansioita tai projekteja, ja sivut ovat kuin niiden sis\xe4lt\xe4mi\xe4 asiakirjoja. <a>Lue lis\xe4\xe4 ty\xf6tilojen k\xe4yt\xf6st\xe4</a>",
    'project-pages.improvement.templates.tutorial.content.try-it-now': 'Kokeile nyt',
    'project-pages.improvement.templates.tutorial.description': 'Lue, kuinka sivua voi muokata.',
    'project-pages.improvement.templates.tutorial.name': 'Tervetuloa projektisivuille!',
    'project-pages.improvement.terms-and-conditions-v2': "Valitsemalla &quot;Kokeile nyt&quot; hyv\xe4ksyt rekister\xf6itymisen Confluenceen sek\xe4 Atlassian Cloudin <termsLink>palveluehdot</termsLink> ja <privacyLink>tietosuojak\xe4yt\xe4nn\xf6n</privacyLink>.",
    'project-pages.improvement.title': 'Projektisivut',
    'project-pages.improvement.transient-states.empty-state.auto-provisioned-create-page-button': 'Luo sivu',
    'project-pages.improvement.transient-states.empty-state.auto-provisioned-description': "Lis\xe4simme Confluencen, jotta voit ryhty\xe4 luomaan ja yhdist\xe4m\xe4\xe4n kaikkia projektisi asiakirjoja. Se on maksuton jopa 10 k\xe4ytt\xe4j\xe4lle.",
    'project-pages.improvement.transient-states.empty-state.auto-provisioned-learn-more-button': "Lue lis\xe4\xe4",
    'project-pages.improvement.transient-states.empty-state.create-page-button': "Luo ensimm\xe4inen sivusi",
    'project-pages.improvement.transient-states.empty-state.description': "T\xe4yt\xe4 t\xe4m\xe4 ty\xf6tila luomalla kokousmuistioita, tuotevaatimuksia, p\xe4\xe4t\xf6ksi\xe4 tai muuta sis\xe4lt\xf6\xe4.",
    'project-pages.improvement.transient-states.empty-state.title': "T\xe4\xe4lt\xe4 l\xf6ytyy pelkk\xe4\xe4 potentiaalia",
    'project-pages.improvement.try-button': "Kokeile t\xe4t\xe4 sivupohjaa Confluencessa",
    'project-pages.improvement.try-it-now': 'Kokeile nyt',
    'project-pages.improvement.try-lozenge': 'Kokeile',
    'project-pages.improvement.try-on-demand-button': 'Kokeile ilmaiseksi',
    'project-pages.page-deleted-flag.title': 'Sivu poistettu.',
    'project-pages.page-published-flag.title': 'Sivusi on julkaistu.',
    'project-pages.unknown-error.description': "{contactSupport}, jos sivun p\xe4ivitt\xe4minen ei korjaa asiaa.",
    'project-pages.unknown-error.heading': "Projektisivuja ei voi n\xe4ytt\xe4\xe4 juuri nyt"
};

});

parcelRegister("ZLUIF", function(module, exports) {

$parcel$export(module.exports, "default", () => $56705fb0e28e59aa$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //French (France)
var $56705fb0e28e59aa$export$2e2bcd8739ae039 = {
    'confluence.project-pages.improvement.provisioning-background.text': "L'op\xe9ration devrait prendre moins d'une minute",
    'confluence.project-pages.improvement.provisioning-background.title': 'Configuration de vos pages de projet',
    'confluence.project-pages.improvement.provisioning-modal-carousel.controls.dismiss': 'Ignorer',
    'confluence.project-pages.improvement.provisioning-modal-carousel.controls.done': "Termin\xe9",
    'confluence.project-pages.improvement.provisioning-modal-carousel.controls.next': 'Suivant',
    'project-pages.activating.description': "L'espace\xa0Confuence connect\xe9 n'est pas encore tout \xe0 fait pr\xeat. {contactSupport} si l'actualisation ne corrige pas le probl\xe8me.",
    'project-pages.activating.heading': 'Chargement de Confluence toujours en cours',
    'project-pages.better-together-templates.meeting-notes.action-items-heading': "\xc9l\xe9ments d'action utilisables",
    'project-pages.better-together-templates.meeting-notes.agenda-item-label': "Point \xe0 l'ordre du jour",
    'project-pages.better-together-templates.meeting-notes.create-a-jira-issue': "Saisissez /Jira pour cr\xe9er un ticket",
    'project-pages.better-together-templates.meeting-notes.date-label': 'Date',
    'project-pages.better-together-templates.meeting-notes.discussion-topics-heading': 'Sujets de discussion',
    'project-pages.better-together-templates.meeting-notes.list-people': "r\xe9pertoriez des personnes en faisant une",
    'project-pages.better-together-templates.meeting-notes.mention': 'mention',
    'project-pages.better-together-templates.meeting-notes.mention-people-to-assign-them': "permet d'assigner des personnes \xe0 un \xe9l\xe9ment d'action",
    'project-pages.better-together-templates.meeting-notes.notes-label': 'Notes',
    'project-pages.better-together-templates.meeting-notes.page-title': "Notes de r\xe9union",
    'project-pages.better-together-templates.meeting-notes.participants-label': 'Participants',
    'project-pages.better-together-templates.meeting-notes.project-label': 'Projet',
    'project-pages.better-together-templates.product-requirements.create-a-jira-issue': "Saisissez /Jira pour cr\xe9er un ticket",
    'project-pages.better-together-templates.product-requirements.design-heading': 'Design',
    'project-pages.better-together-templates.product-requirements.embedd-different-data-views': "Int\xe9grez diff\xe9rentes donn\xe9es et vues de votre projet\xa0Jira.",
    'project-pages.better-together-templates.product-requirements.heading': "Vue d'ensemble",
    'project-pages.better-together-templates.product-requirements.how-will-you-know-if-fixed': "Comment saurez-vous que vous avez corrig\xe9 le probl\xe8me\xa0?",
    'project-pages.better-together-templates.product-requirements.impact-heading': 'Impact',
    'project-pages.better-together-templates.product-requirements.inScopeStatus': "Dans le p\xe9rim\xe8tre",
    'project-pages.better-together-templates.product-requirements.insert-design-link': "Ins\xe9rez un lien vers votre design (Figma, etc.)",
    'project-pages.better-together-templates.product-requirements.jira-issue-heading': "Ticket\xa0Jira",
    'project-pages.better-together-templates.product-requirements.jira-roadmap-heading': "Feuille de route\xa0Jira",
    'project-pages.better-together-templates.product-requirements.learn-how-with-smart-links': "D\xe9couvrir comment utiliser les liens intelligents",
    'project-pages.better-together-templates.product-requirements.list-dashboards': "R\xe9pertoriez les tableaux de bord (Amplitude, Mode, etc.)",
    'project-pages.better-together-templates.product-requirements.list-design-considerations': "Indiquez les points \xe0 consid\xe9rer pour le design ou le build",
    'project-pages.better-together-templates.product-requirements.list-people': "r\xe9pertoriez des personnes en faisant une",
    'project-pages.better-together-templates.product-requirements.mention': 'mention',
    'project-pages.better-together-templates.product-requirements.mention-people-to-assign-them': "permet d'assigner des personnes \xe0 un \xe9l\xe9ment d'action",
    'project-pages.better-together-templates.product-requirements.niceToHaveStatus': 'Souhaitable',
    'project-pages.better-together-templates.product-requirements.outOfScopeStatus': "Hors p\xe9rim\xe8tre",
    'project-pages.better-together-templates.product-requirements.page-title': 'Exigences produit',
    'project-pages.better-together-templates.product-requirements.pro-tip': "Conseil de pro\xa0:",
    'project-pages.better-together-templates.product-requirements.problem-label': "Probl\xe8me",
    'project-pages.better-together-templates.product-requirements.requirement-heading': 'Exigence',
    'project-pages.better-together-templates.product-requirements.scope-heading': "P\xe9rim\xe8tre",
    'project-pages.better-together-templates.product-requirements.success-metric': "M\xe9trique de r\xe9ussite",
    'project-pages.better-together-templates.product-requirements.target-release-date': 'Date de livraison cible',
    'project-pages.better-together-templates.product-requirements.team-label': "\xc9quipe",
    'project-pages.better-together-templates.product-requirements.to-do-list-heading': "Liste de t\xe2ches \xe0 faire",
    'project-pages.better-together-templates.product-requirements.what-are-you-trying-to-fix': "Quel probl\xe8me cherchez-vous \xe0 corriger\xa0?",
    'project-pages.better-together-templates.retro-notes.retro-heading': "R\xe9trospective",
    'project-pages.better-together-templates.retro.action-items-heading': "Les \xe9l\xe9ments d'action, qu'est-ce que c'est\xa0?",
    'project-pages.better-together-templates.retro.create-a-jira-issue': "Saisissez /Jira pour cr\xe9er un ticket",
    'project-pages.better-together-templates.retro.date-label': 'Date',
    'project-pages.better-together-templates.retro.embed-it-here': "Une fois que vous avez termin\xe9, vous pouvez l'int\xe9grer ici.",
    'project-pages.better-together-templates.retro.list-people': "r\xe9pertoriez des personnes en faisant une",
    'project-pages.better-together-templates.retro.mention': 'mention',
    'project-pages.better-together-templates.retro.mention-people-to-assign-them': "permet d'assigner des personnes \xe0 un \xe9l\xe9ment d'action",
    'project-pages.better-together-templates.retro.page-title': "R\xe9trospective",
    'project-pages.better-together-templates.retro.participants-label': 'Participants',
    'project-pages.better-together-templates.retro.pro-tip': "Conseil de pro\xa0:",
    'project-pages.better-together-templates.retro.project-label': 'Projet',
    'project-pages.better-together-templates.retro.this-is-a-whiteboard': "Il s'agit d'un tableau blanc\xa0Confluence.",
    'project-pages.better-together-templates.retro.use-a-whiteboard': "Utilisez un tableau blanc\xa0Confluence pour votre r\xe9trospective.",
    'project-pages.better-together-templates.retro.use-it-to-vote': "Vous pouvez l'utiliser pour voter et pour collaborer avec votre \xe9quipe.",
    'project-pages.button.connect-different-space-or-page.label': "Mettez \xe0 jour l'ic\xf4ne de l'espace ou de la page",
    'project-pages.button.connect-different-space-or-page.tooltip': "Connecter \xe0 un autre espace ou \xe9l\xe9ment",
    'project-pages.button.connect-space-or-page.tooltip': "Connecter \xe0 Confluence",
    'project-pages.button.go-to-connected-live-doc.tooltip': 'Ouvrir le document live dans Confluence',
    'project-pages.button.go-to-connected-page.tooltip': 'Ouvrir la page dans Confluence',
    'project-pages.button.go-to-connected-space.tooltip': "Ouvrir l'espace dans Confluence",
    'project-pages.connect-space-dialog.connection-error': "\xc9chec de la connexion.",
    'project-pages.connect-space-dialog.connection-retry': "R\xe9essayer",
    'project-pages.connect-space-dialog.content.space-or-page-selector.description': "Choisissez un espace ou un \xe9l\xe9ment auquel connecter votre projet.",
    'project-pages.connect-space-dialog.content.space-or-page-selector.placeholder': 'Rechercher sur Confluence',
    'project-pages.connect-space-dialog.content.space-selector.disconnected-templates-description': "Ce projet doit \xeatre connect\xe9 \xe0 un espace avant que vous puissiez cr\xe9er un \xe9l\xe9ment. Choisissez un espace auquel connecter ce projet.",
    'project-pages.connect-space-dialog.error-icon': "Erreur\xa0:",
    'project-pages.connect-space-dialog.footer.cancel': 'Annuler',
    'project-pages.connect-space-dialog.footer.connect-space': 'Connecter',
    'project-pages.connect-space-or-page-dialog.header.title': "Connecter le projet \xe0 Confluence",
    'project-pages.connect-space.description': "Les espaces sont comme des dossiers\xa0: vous pouvez les utiliser afin de cr\xe9er du contenu associ\xe9 \xe0 votre projet, de l'organiser et de collaborer \xe0 sa mise en \u0153uvre.",
    'project-pages.connect-space.not-connected.description': "Pour utiliser les pages de projet, contactez votre administrateur ou votre chef d'\xe9quipe afin de connecter Confluence \xe0 ce projet.",
    'project-pages.connect-space.not-connected.heading': "Non connect\xe9es \xe0 Confluence",
    'project-pages.connect-success-flag.description.content': "Connexion r\xe9ussie au contenu {connectedSpaceOrPageName}.",
    'project-pages.connection-error.space-or-page-not-found.button': "Connecter \xe0 un autre espace ou une autre page",
    'project-pages.create-space-dialog.connection-error': "\xc9chec de la connexion.",
    'project-pages.create-space-dialog.connection-retry': "R\xe9essayer",
    'project-pages.create-space-dialog.content.empty-name': "Donnez un nom \xe0 votre espace.",
    'project-pages.create-space-dialog.content.invalid-name': "Les noms d'espaces doivent contenir au moins une lettre ou un chiffre.",
    'project-pages.create-space-dialog.content.placeholder': "Saisissez un nom d'espace",
    'project-pages.create-space-dialog.creation-error': "\xc9chec de cr\xe9ation de l'espace.",
    'project-pages.create-space-dialog.error-icon': "Erreur\xa0:",
    'project-pages.create-space-dialog.footer.cancel': 'Annuler',
    'project-pages.create-space-dialog.footer.create-space': "Cr\xe9er",
    'project-pages.create-space-dialog.header.title': "Cr\xe9er un espace Confluence",
    'project-pages.cross-join.access-revoked.templates.subtitle': "Vous ne pouvez pas utiliser les pages de projet, car l'administrateur vous a refus\xe9 l'acc\xe8s \xe0 Confluence. Contactez votre administrateur de site pour demander l'acc\xe8s.",
    'project-pages.cross-join.access-revoked.templates.title': "Vous n'\xeates pas autoris\xe9 \xe0 utiliser les pages de projet",
    'project-pages.cross-join.avatar.view-profile': 'Afficher le profil',
    'project-pages.cross-join.denied-request.templates.subtitle': "Vous ne pouvez pas utiliser les pages de projet, car l'administrateur de site a rejet\xe9 votre demande de rejoindre Confluence.",
    'project-pages.cross-join.denied-request.templates.title': "Votre administrateur vous a refus\xe9 l'acc\xe8s",
    'project-pages.cross-join.direct-access.button-subtitle.experimental': "Vous allez obtenir l'acc\xe8s \xe0 Confluence. L'administrateur de votre site a d\xe9j\xe0 approuv\xe9 votre acc\xe8s.",
    'project-pages.cross-join.errors.unknown-error.description': "{contactSupport} si l'actualisation ne corrige pas le probl\xe8me.",
    'project-pages.cross-join.errors.unknown-error.title': "Impossible d'afficher les pages de projet pour l'instant",
    'project-pages.cross-join.inline-join-product.button': "Vous aurez acc\xe8s \xe0 Confluence. L'administrateur de votre site a d\xe9j\xe0 approuv\xe9 votre acc\xe8s.",
    'project-pages.cross-join.inline-join-product.connected.description': "Affichez, modifiez et cr\xe9ez de la documentation depuis un seul et m\xeame endroit",
    'project-pages.cross-join.inline-join-product.connected.title': "Collaborez sur des pages de projet avec votre \xe9quipe",
    'project-pages.cross-join.pending-request.templates.subtitle': "Votre administrateur de site a re\xe7u votre demande de rejoindre Confluence. Si cette demande est accept\xe9e, les pages de projet seront accessibles, et vous recevrez un e-mail de confirmation.",
    'project-pages.cross-join.pending-request.templates.subtitle.experiment': "Lorsque votre demande aura \xe9t\xe9 approuv\xe9e, vous recevrez un e-mail contenant un acc\xe8s aux pages de projet.",
    'project-pages.cross-join.pending-request.templates.title': "Vous avez demand\xe9 un acc\xe8s \xe0 Confluence",
    'project-pages.cross-join.pending-request.templates.title.experiment': "Demande d'acc\xe8s envoy\xe9e \xe0 l'administrateur",
    'project-pages.cross-join.request-access-without-better-together.connected.description': "Consultez, modifiez et cr\xe9ez la documentation du projet avec votre \xe9quipe",
    'project-pages.cross-join.request-access.button': "Demander l'acc\xe8s",
    'project-pages.cross-join.request-access.button-subtitle.experimental': "Lorsque vous s\xe9lectionnez \xab\xa0Rejoindre votre \xe9quipe\xa0\xbb, vous demandez un acc\xe8s \xe0 Confluence et acceptez de partager votre profil\xa0Atlassian avec votre administrateur.",
    'project-pages.cross-join.request-access.button.experimental': "Rejoindre votre \xe9quipe",
    'project-pages.cross-join.request-access.connected.description.experimental': "Votre \xe9quipe utilise des pages de projet pour commenter la documentation de votre projet, la modifier et collaborer dessus, sans quitter Jira. Rejoignez Confluence pour acc\xe9der aux pages de projet de votre \xe9quipe.",
    'project-pages.cross-join.request-access.title': "Les pages de projet n\xe9cessitent un acc\xe8s \xe0 Confluence",
    'project-pages.cross-join.request-access.title.experiment': "Cr\xe9er une source de r\xe9f\xe9rence unique pour votre \xe9quipe",
    'project-pages.default-contextual-heading': "Les pages des projets sont optimis\xe9es par Confluence",
    'project-pages.default-contextual-message': "Gr\xe2ce aux pages Confluence, vous pouvez cr\xe9er et partager tous les documents de vos projets ou collaborer pour les mener \xe0 bien \xe0 un seul et m\xeame endroit.",
    'project-pages.default-reactivate-CTA': "R\xe9activer Confluence",
    'project-pages.default-trial-CTA': "Essayez Confluence gratuitement pendant 30\xa0jours",
    'project-pages.draft-saved-flag.action': 'Ouvrir le brouillon',
    'project-pages.draft-saved-flag.description': "Votre brouillon est uniquement visible par vous jusqu'\xe0 sa publication.",
    'project-pages.draft-saved-flag.title': "Brouillon enregistr\xe9",
    'project-pages.embedded-pages.create-page-error.close-button': 'Fermer',
    'project-pages.embedded-pages.create-page-error.description': "Un probl\xe8me est survenu, et nous n'avons pas pu cr\xe9er une page pour vous.",
    'project-pages.embedded-pages.create-page-error.title': "Impossible de cr\xe9er une page",
    'project-pages.embedded-pages.create-page-error.try-again-button': "R\xe9essayez",
    'project-pages.embedded-pages.modal.close.button.hint': 'Fermer',
    'project-pages.embedded-pages.modal.title.button': 'Ouvrir dans Confluence',
    'project-pages.embedded-pages.modal.title.button.hint': 'Ouvrir dans un nouvel onglet',
    'project-pages.errors.unknown-error.description.non-final': "{contactSupport} si l'actualisation ne corrige pas le probl\xe8me.",
    'project-pages.errors.unknown-error.title.non-final': "Impossible d'afficher les pages de projet pour l'instant",
    'project-pages.generic-error.button.reload': 'Recharger la page',
    'project-pages.generic-error.description': "Une erreur s'est produite. R\xe9essayez ult\xe9rieurement.",
    'project-pages.generic-error.description.non-final': "Une erreur s'est produite. R\xe9essayez ult\xe9rieurement.",
    'project-pages.generic-error.heading': "Ah, c'est bizarre\u2026",
    'project-pages.generic-error.title.non-final': "Ah, c'est bizarre\u2026",
    'project-pages.generic-info-flag.description': "Une erreur s'est produite. Veuillez r\xe9essayer ou contacter le support si ce probl\xe8me persiste.",
    'project-pages.generic-success-flag.description.live-doc': "Connexion r\xe9ussie au document live {connectedSpaceOrPageName}.",
    'project-pages.generic-success-flag.description.page': "Connexion r\xe9ussie \xe0 la page {connectedSpaceOrPageName}.",
    'project-pages.generic-success-flag.description.space': "Connexion r\xe9ussie \xe0 l'espace {connectedSpaceOrPageName}.",
    'project-pages.generic-success-flag.heading.live-doc': "Document live connect\xe9",
    'project-pages.generic-success-flag.heading.page': "Page connect\xe9e",
    'project-pages.generic-success-flag.heading.space': "Connect\xe9 \xe0 l'espace",
    'project-pages.granular-pages.connect-space-dialog.content.create-space-link.link-text': "Ou cr\xe9er un espace",
    'project-pages.granular-pages.connect-space.button': "Connecter \xe0 Confluence",
    'project-pages.granular-pages.connect-space.heading': "Connectez ce projet \xe0 un espace ou \xe0 un \xe9l\xe9ment\xa0Confluence",
    'project-pages.improvement.contact-support': 'Contacter le support',
    'project-pages.improvement.errors.access-error.description': "Essayez de contacter l'administrateur de site pour demander un acc\xe8s.",
    'project-pages.improvement.errors.access-error.title': "Vous n'\xeates pas autoris\xe9 \xe0 afficher les pages de projet",
    'project-pages.improvement.errors.page-tree-unknown-error.description': "Une erreur s'est produite lors de la tentative d'affichage des pages de votre espace\xa0Confluence connect\xe9. {contactSupport} si l'actualisation ne corrige pas le probl\xe8me.",
    'project-pages.improvement.errors.page-tree-unknown-error.title': "Nous ne parvenons pas \xe0 afficher les pages de projet",
    'project-pages.improvement.errors.space-or-page-not-found.description': "L'espace\xa0Confluence (ou la page) qui \xe9tait connect\xe9 a \xe9t\xe9 d\xe9plac\xe9, archiv\xe9 ou supprim\xe9. <link>Contactez le support</link> si une reconnexion ne r\xe9sout pas le probl\xe8me.",
    'project-pages.improvement.errors.space-or-page-not-found.title': 'Espace ou page introuvable',
    'project-pages.improvement.errors.unknown-error.description': "{contactSupport} si l'actualisation ne corrige pas le probl\xe8me.",
    'project-pages.improvement.errors.unknown-error.title': "Impossible d'afficher les pages de projet pour l'instant",
    'project-pages.improvement.feature1': "Acc\xe9dez \xe0 des documents et cr\xe9ez-en sans quitter Jira",
    'project-pages.improvement.feature2': "Des mod\xe8les pour les r\xe9unions, les plans de sprint et bien plus encore",
    'project-pages.improvement.feature3': "Synchronisez des documents avec Jira pour les mises \xe0 jour automatiques",
    'project-pages.improvement.heading-info': "Capturez les connaissances de votre \xe9quipe et am\xe9liorez votre m\xe9thode de travail.",
    'project-pages.improvement.heading-info-v2': "Cr\xe9ez un emplacement unique pour tous les documents de projet de votre \xe9quipe",
    'project-pages.improvement.learn-more-button': 'En savoir plus',
    'project-pages.improvement.powered-by': "Optimis\xe9 par",
    'project-pages.improvement.powered-by.tooltip': 'Ouvrir Confluence dans un nouvel onglet',
    'project-pages.improvement.preview-teaser': "D\xe9bloquez les mod\xe8les, les pages de projets, et bien plus.",
    'project-pages.improvement.provisioning-info-modal.seamlessly-update-stakeholders.description': "<p>Tenez les rapports de vos projets \xe0 jour gr\xe2ce \xe0 la mise \xe0 jour automatique des \xe9tiquettes d'\xe9tat.</p> <p>Liez simplement un ticket\xa0Jira \xe0 un document pour qu'il affiche automatiquement une \xe9tiquette d'\xe9tat qui sera mise \xe0 jour en m\xeame temps que le ticket. Ainsi, vous ne devrez pas cr\xe9er de rapports manuels.</p>",
    'project-pages.improvement.provisioning-info-modal.seamlessly-update-stakeholders.title': "Tenez vos parties prenantes inform\xe9es en toute transparence",
    'project-pages.improvement.provisioning-info-modal.unify-documentation-standards.description': "<p>Cr\xe9ez une documentation coh\xe9rente \xe0 l'aide de nos mod\xe8les int\xe9gr\xe9s. Ils sont simples \xe0 utiliser et personnalisables selon vos besoins.</p> <p>Vous pouvez utiliser des mod\xe8les directement depuis les pages de projet, afin de ne jamais devoir interrompre votre travail. Parcourez tous les mod\xe8les <a>ici</a>.</p>",
    'project-pages.improvement.provisioning-info-modal.unify-documentation-standards.title': 'Unifiez vos normes de documentation',
    'project-pages.improvement.provisioning-info-modal.your-project-pages-in-jira.description': "<p>Cr\xe9ez une source de r\xe9f\xe9rence unique pour les informations importantes en cr\xe9ant et en g\xe9rant la documentation depuis l'onglet des pages de projet dans Jira.</p> <p>Saviez-vous que les pages de projet s'ex\xe9cutent sur Confluence\xa0? C'est gratuit pour un maximum de 10\xa0utilisateurs. Invitez le reste de votre \xe9quipe dans les param\xe8tres d'administration.</p>",
    'project-pages.improvement.provisioning-info-modal.your-project-pages-in-jira.title': 'Vos pages de projet, directement dans Jira',
    'project-pages.improvement.templates-sidebar.better-together-templates-header': "Mod\xe8les int\xe9gr\xe9s \xe0 vos donn\xe9es\xa0Jira",
    'project-pages.improvement.templates.better-together-preview-teaser': "Int\xe9gr\xe9 aux donn\xe9es\xa0Jira",
    'project-pages.improvement.templates.blank-page.description': "Cr\xe9ez une page en partant de rien.",
    'project-pages.improvement.templates.blank-page.name': 'Page vide',
    'project-pages.improvement.templates.decision.description': "Enregistrez les d\xe9cisions importantes li\xe9es \xe0 votre projet et communiquez-les \xe0 votre \xe9quipe.",
    'project-pages.improvement.templates.decision.name': "D\xe9cision",
    'project-pages.improvement.templates.meeting-notes.description': "Planifiez vos r\xe9unions et communiquez les notes et les actions \xe0 votre \xe9quipe.",
    'project-pages.improvement.templates.meeting-notes.name': "Notes de r\xe9union",
    'project-pages.improvement.templates.post-expand.more': "Plus de mod\xe8les",
    'project-pages.improvement.templates.post-expand.more.tooltip': "Affichez tous les mod\xe8les dans Confluence",
    'project-pages.improvement.templates.post-expand.subtitle': "Mod\xe8les populaires",
    'project-pages.improvement.templates.post-expand.title': "Cr\xe9er une page",
    'project-pages.improvement.templates.pre-expand.more': "D\xe9couvrir plus de mod\xe8les",
    'project-pages.improvement.templates.pre-expand.subtitle': "Populaires aupr\xe8s d'\xe9quipes comme la v\xf4tre",
    'project-pages.improvement.templates.pre-expand.title': "Pr\xe9visualiser les mod\xe8les",
    'project-pages.improvement.templates.product-requirements.description': "D\xe9finissez, suivez et d\xe9limitez les exigences de votre produit ou de votre fonctionnalit\xe9.",
    'project-pages.improvement.templates.product-requirements.name': 'Exigences produit',
    'project-pages.improvement.templates.retrospective.description': "Qu\u2019est-ce qui a bien fonctionn\xe9\xa0? Qu\u2019est-ce qui aurait pu mieux se passer\xa0? Crowdsourcez des am\xe9liorations avec votre \xe9quipe.",
    'project-pages.improvement.templates.retrospective.name': "R\xe9trospective",
    'project-pages.improvement.templates.template.disabled-tooltip': "Connectez d'abord un espace\xa0Confluence",
    'project-pages.improvement.templates.tutorial.content.confluence-templates': "<b>Gagnez du temps et r\xe9duisez les t\xe2ches manuelles.</b> Confluence comprend de nombreux <a>mod\xe8les</a> de pages. Ainsi, vous ne devez jamais partir de rien. Pensez aux documents techniques, aux guides de d\xe9pannage, aux plans de projet, aux exigences produit, et bien plus encore.",
    'project-pages.improvement.templates.tutorial.content.edit-and-format': "<b>Modifiez et formatez facilement vos documents.</b> Utilisez le menu sup\xe9rieur de modification pour le formatage\xa0Word standard. En saisissant <b>/</b>, vous pouvez facilement ins\xe9rer de nombreuses int\xe9grations pratiques. Ins\xe9rez un tableau avec <c>/tableau</c> ou une image avec <c>/image</c>. Vous pouvez aussi ins\xe9rer des liens\xa0Dropbox avec <c>/dropbox</c>, des outils Microsoft\xa0Office avec <c>/microsoft</c>, ou des tableaux et des cartes\xa0Trello avec <c>/trello</c>.",
    'project-pages.improvement.templates.tutorial.content.forward-slash-prompt': "Saisissez / suivi de \xab\xa0tableau\xa0\xbb ou \xab\xa0image\xa0\xbb",
    'project-pages.improvement.templates.tutorial.content.getting-started-tips': "Voici quelques conseils pour vous lancer\xa0:",
    'project-pages.improvement.templates.tutorial.content.handy-links': 'Liens pratiques',
    'project-pages.improvement.templates.tutorial.content.jira-and-confluence': 'Utilisation conjointe de Jira et de Confluence',
    'project-pages.improvement.templates.tutorial.content.jira-charts': "Cr\xe9ez des graphiques sur vos pages \xe0 l'aide de donn\xe9es\xa0Jira r\xe9elles. Saisissez <c>/graphiques\xa0Jira</c>.",
    'project-pages.improvement.templates.tutorial.content.jira-links': "Liez un ticket\xa0Jira n'importe o\xf9 sur votre page. Le lien sur la page se mettra \xe0 jour en temps r\xe9el \xe0 mesure que vous actualisez le ticket\xa0Jira. Saisissez <c>/Jira</c>.",
    'project-pages.improvement.templates.tutorial.content.jira-links-issue-term-refresh': "Liez un ticket\xa0Jira n'importe o\xf9 sur votre page. Le lien sur la page se mettra \xe0 jour en temps r\xe9el \xe0 mesure que vous actualisez le ticket. Saisissez <c>/Jira</c>.",
    'project-pages.improvement.templates.tutorial.content.jira-links.non-final-issue-term-refresh': "Liez un ticket\xa0Jira n'importe o\xf9 sur votre page. Le lien sur la page se mettra \xe0 jour en temps r\xe9el \xe0 mesure que vous actualisez le ticket. Saisissez <c>/Jira</c>.",
    'project-pages.improvement.templates.tutorial.content.jira-roadmaps': "Int\xe9grez des feuilles de route et des chronologies interactives pour votre page \xe0 l'aide de vos projets\xa0Jira. Saisissez <c>/feuille de route jira</c>.",
    'project-pages.improvement.templates.tutorial.content.jira-timeline': "Int\xe9grez des chronologies interactives pour votre page \xe0 l'aide de vos projets\xa0Jira. Saisissez <c>/feuille de route jira</c>.",
    'project-pages.improvement.templates.tutorial.content.shipping-speed-statistic': "76\xa0% des clients Jira\xa0Software d\xe9clarent avoir acc\xe9l\xe9r\xe9 leur livraison de projets apr\xe8s avoir ajout\xe9 Confluence",
    'project-pages.improvement.templates.tutorial.content.shipping-speed-statistic.spork-rebranding': "76\xa0% des clients\xa0Jira d\xe9clarent avoir acc\xe9l\xe9r\xe9 la livraison de projets apr\xe8s avoir ajout\xe9 Confluence",
    'project-pages.improvement.templates.tutorial.content.spaces-and-pages': "<b>Utilisation des espaces et des pages</b>. Les espaces font partie de chaque site\xa0Confluence et permettent d'organiser les pages en cat\xe9gories. Consid\xe9rez-les comme diff\xe9rents dossiers ou projets. Les pages sont les documents qui figurent dans ces dossiers ou projets. <a>En savoir plus sur l'utilisation des espaces</a>",
    'project-pages.improvement.templates.tutorial.content.try-it-now': 'Essayer maintenant',
    'project-pages.improvement.templates.tutorial.description': "D\xe9couvrez comment modifier une page.",
    'project-pages.improvement.templates.tutorial.name': "Bienvenue dans les pages de projet\xa0!",
    'project-pages.improvement.terms-and-conditions-v2': "En s\xe9lectionnant \xab\xa0Essayer maintenant\xa0\xbb, vous acceptez d'\xeatre inscrit \xe0 Confluence et vous acceptez les <termsLink>Conditions d'utilisation d'Atlassian\xa0Cloud</termsLink> et la <privacyLink>Politique de confidentialit\xe9</privacyLink>.",
    'project-pages.improvement.title': 'Pages de projet',
    'project-pages.improvement.transient-states.empty-state.auto-provisioned-create-page-button': "Cr\xe9er une page",
    'project-pages.improvement.transient-states.empty-state.auto-provisioned-description': "Nous avons ajout\xe9 Confluence pour que vous puissiez commencer \xe0 cr\xe9er et \xe0 lier tous les documents de votre projet. L'outil est gratuit jusqu'\xe0 10\xa0utilisateurs.",
    'project-pages.improvement.transient-states.empty-state.auto-provisioned-learn-more-button': 'En savoir plus',
    'project-pages.improvement.transient-states.empty-state.create-page-button': "Cr\xe9er votre premi\xe8re page",
    'project-pages.improvement.transient-states.empty-state.description': "Cr\xe9ez des notes de r\xe9union, des exigences produit, des d\xe9cisions, ou tout autre contenu pour voir cet espace se remplir.",
    'project-pages.improvement.transient-states.empty-state.title': "Il n'y a rien ici hormis du potentiel",
    'project-pages.improvement.try-button': "Essayer ce mod\xe8le dans Confluence",
    'project-pages.improvement.try-it-now': 'Essayer maintenant',
    'project-pages.improvement.try-lozenge': 'Essayer',
    'project-pages.improvement.try-on-demand-button': 'Essayer gratuitement',
    'project-pages.page-deleted-flag.title': "Page supprim\xe9e.",
    'project-pages.page-published-flag.title': "Votre page a \xe9t\xe9 publi\xe9e.",
    'project-pages.unknown-error.description': "{contactSupport} si l'actualisation ne corrige pas le probl\xe8me.",
    'project-pages.unknown-error.heading': "Impossible d'afficher les pages de projet pour l'instant"
};

});

parcelRegister("36c4y", function(module, exports) {

$parcel$export(module.exports, "default", () => $0215764e58d6c9ba$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //German (Germany)
var $0215764e58d6c9ba$export$2e2bcd8739ae039 = {
    'confluence.project-pages.improvement.provisioning-background.text': 'Dieser Vorgang sollte weniger als eine Minute dauern.',
    'confluence.project-pages.improvement.provisioning-background.title': 'Ihre Projektseiten werden eingerichtet',
    'confluence.project-pages.improvement.provisioning-modal-carousel.controls.dismiss': 'Verwerfen',
    'confluence.project-pages.improvement.provisioning-modal-carousel.controls.done': 'Fertig',
    'confluence.project-pages.improvement.provisioning-modal-carousel.controls.next': 'Weiter',
    'project-pages.activating.description': 'Der verbundene Confluence-Bereich ist noch nicht bereit. {contactSupport}, wenn das Problem durch Aktualisieren der Seite nicht behoben wird.',
    'project-pages.activating.heading': 'Confluence wird noch geladen',
    'project-pages.better-together-templates.meeting-notes.action-items-heading': 'Was sind die Aufgaben?',
    'project-pages.better-together-templates.meeting-notes.agenda-item-label': 'Agenda-Element',
    'project-pages.better-together-templates.meeting-notes.create-a-jira-issue': '"/Jira" eingeben, um einen Vorgang zu erstellen',
    'project-pages.better-together-templates.meeting-notes.date-label': 'Datum',
    'project-pages.better-together-templates.meeting-notes.discussion-topics-heading': 'Diskussionsthemen',
    'project-pages.better-together-templates.meeting-notes.list-people': 'Personen auflisten mit',
    'project-pages.better-together-templates.meeting-notes.mention': "Erw\xe4hnung",
    'project-pages.better-together-templates.meeting-notes.mention-people-to-assign-them': 'nutzen, um Personen einer Aufgabe zuzuweisen',
    'project-pages.better-together-templates.meeting-notes.notes-label': 'Notizen',
    'project-pages.better-together-templates.meeting-notes.page-title': 'Besprechungsnotizen',
    'project-pages.better-together-templates.meeting-notes.participants-label': 'Teilnehmer',
    'project-pages.better-together-templates.meeting-notes.project-label': 'Projekt',
    'project-pages.better-together-templates.product-requirements.create-a-jira-issue': '"/Jira" eingeben, um einen Vorgang zu erstellen',
    'project-pages.better-together-templates.product-requirements.design-heading': 'Design',
    'project-pages.better-together-templates.product-requirements.embedd-different-data-views': 'Betten Sie unterschiedliche Daten und Ansichten aus Ihrem Jira-Projekt ein.',
    'project-pages.better-together-templates.product-requirements.heading': "\xdcberblick",
    'project-pages.better-together-templates.product-requirements.how-will-you-know-if-fixed': "Woher wissen Sie, ob das Problem gel\xf6st wurde?",
    'project-pages.better-together-templates.product-requirements.impact-heading': 'Auswirkung',
    'project-pages.better-together-templates.product-requirements.inScopeStatus': 'Im Projektumfang',
    'project-pages.better-together-templates.product-requirements.insert-design-link': "Link f\xfcr Ihr Design (Figma, usw.) einf\xfcgen",
    'project-pages.better-together-templates.product-requirements.jira-issue-heading': 'Jira-Vorgang',
    'project-pages.better-together-templates.product-requirements.jira-roadmap-heading': 'Jira-Roadmap',
    'project-pages.better-together-templates.product-requirements.learn-how-with-smart-links': 'So funktioniert das mit intelligenten Links',
    'project-pages.better-together-templates.product-requirements.list-dashboards': 'Dashboards (Amplitude, Mode, usw.) auflisten',
    'project-pages.better-together-templates.product-requirements.list-design-considerations': "\xdcberlegungen zum Design oder Entwurf auflisten",
    'project-pages.better-together-templates.product-requirements.list-people': 'Personen auflisten mit',
    'project-pages.better-together-templates.product-requirements.mention': "Erw\xe4hnung",
    'project-pages.better-together-templates.product-requirements.mention-people-to-assign-them': 'nutzen, um Personen einer Aufgabe zuzuweisen',
    'project-pages.better-together-templates.product-requirements.niceToHaveStatus': 'Nicht unbedingt erforderlich',
    'project-pages.better-together-templates.product-requirements.outOfScopeStatus': "Au\xdferhalb des Projektumfangs",
    'project-pages.better-together-templates.product-requirements.page-title': 'Produktanforderungen',
    'project-pages.better-together-templates.product-requirements.pro-tip': 'Profitipp:',
    'project-pages.better-together-templates.product-requirements.problem-label': 'Problem',
    'project-pages.better-together-templates.product-requirements.requirement-heading': 'Anforderung',
    'project-pages.better-together-templates.product-requirements.scope-heading': 'Umfang',
    'project-pages.better-together-templates.product-requirements.success-metric': 'Erfolgsmetrik',
    'project-pages.better-together-templates.product-requirements.target-release-date': 'Anvisiertes Release-Datum',
    'project-pages.better-together-templates.product-requirements.team-label': 'Team',
    'project-pages.better-together-templates.product-requirements.to-do-list-heading': 'To-Do-Liste',
    'project-pages.better-together-templates.product-requirements.what-are-you-trying-to-fix': "Welches Problem m\xf6chten Sie beheben?",
    'project-pages.better-together-templates.retro-notes.retro-heading': 'Retrospektive',
    'project-pages.better-together-templates.retro.action-items-heading': 'Was sind die Aufgaben?',
    'project-pages.better-together-templates.retro.create-a-jira-issue': '"/Jira" eingeben, um einen Vorgang zu erstellen',
    'project-pages.better-together-templates.retro.date-label': 'Datum',
    'project-pages.better-together-templates.retro.embed-it-here': "Sobald Sie fertig sind, k\xf6nnen Sie es hier einbetten.",
    'project-pages.better-together-templates.retro.list-people': 'Personen auflisten mit',
    'project-pages.better-together-templates.retro.mention': "Erw\xe4hnung",
    'project-pages.better-together-templates.retro.mention-people-to-assign-them': 'nutzen, um Personen einer Aufgabe zuzuweisen',
    'project-pages.better-together-templates.retro.page-title': 'Retrospektive',
    'project-pages.better-together-templates.retro.participants-label': 'Teilnehmer',
    'project-pages.better-together-templates.retro.pro-tip': 'Profitipp:',
    'project-pages.better-together-templates.retro.project-label': 'Projekt',
    'project-pages.better-together-templates.retro.this-is-a-whiteboard': 'Dies ist ein Confluence-Whiteboard.',
    'project-pages.better-together-templates.retro.use-a-whiteboard': "Verwenden Sie ein Confluence-Whiteboard f\xfcr Ihre Retrospektive.",
    'project-pages.better-together-templates.retro.use-it-to-vote': "Nutzen Sie es f\xfcr Abstimmungen und die Zusammenarbeit mit Ihrem Team.",
    'project-pages.button.connect-different-space-or-page.label': 'Bereich- oder Seitensymbol aktualisieren',
    'project-pages.button.connect-different-space-or-page.tooltip': "Anderen Bereich oder anderes Element verkn\xfcpfen",
    'project-pages.button.connect-space-or-page.tooltip': 'Mit Confluence verbinden',
    'project-pages.button.go-to-connected-live-doc.tooltip': "Live-Dokument in Confluence \xf6ffnen",
    'project-pages.button.go-to-connected-page.tooltip': "Seite in Confluence \xf6ffnen",
    'project-pages.button.go-to-connected-space.tooltip': "Bereich in Confluence \xf6ffnen",
    'project-pages.connect-space-dialog.connection-error': 'Verbindung fehlgeschlagen.',
    'project-pages.connect-space-dialog.connection-retry': 'Erneut versuchen',
    'project-pages.connect-space-dialog.content.space-or-page-selector.description': "W\xe4hlen Sie einen Bereich oder ein Element zum Verkn\xfcpfen mit Ihrem Projekt aus.",
    'project-pages.connect-space-dialog.content.space-or-page-selector.placeholder': 'Confluence durchsuchen',
    'project-pages.connect-space-dialog.content.space-selector.disconnected-templates-description': "Dieses Projekt muss mit einem Bereich verkn\xfcpft werden, bevor Sie ein Element erstellen k\xf6nnen. W\xe4hlen Sie einen Bereich zum Verkn\xfcpfen mit Ihrem Projekt aus.",
    'project-pages.connect-space-dialog.error-icon': 'Fehler:',
    'project-pages.connect-space-dialog.footer.cancel': 'Abbrechen',
    'project-pages.connect-space-dialog.footer.connect-space': 'Verbinden',
    'project-pages.connect-space-or-page-dialog.header.title': 'Projekt mit Confluence verbinden',
    'project-pages.connect-space.description': "Bereiche sind wie Ordner \u2013 Sie k\xf6nnen sie zum Erstellen, Organisieren und Zusammenarbeiten bei allen Inhalten, die mit Ihrem Projekt zusammenh\xe4ngen, verwenden.",
    'project-pages.connect-space.not-connected.description': "Um Projektseiten verwenden zu k\xf6nnen, bitten Sie Ihren Administrator oder die Teamleitung, Confluence mit diesem Projekt zu verbinden.",
    'project-pages.connect-space.not-connected.heading': 'Nicht mit Confluence verbunden',
    'project-pages.connect-success-flag.description.content': 'Erfolgreich mit Inhalt {connectedSpaceOrPageName} verbunden.',
    'project-pages.connection-error.space-or-page-not-found.button': 'Mit anderem Bereich oder anderer Seite verbinden',
    'project-pages.create-space-dialog.connection-error': 'Verbindung fehlgeschlagen.',
    'project-pages.create-space-dialog.connection-retry': 'Erneut versuchen',
    'project-pages.create-space-dialog.content.empty-name': 'Bitte geben Sie Ihrem Bereich einen Namen.',
    'project-pages.create-space-dialog.content.invalid-name': "Bereichsnamen m\xfcssen mindestens einen Buchstaben oder eine Ziffer enthalten.",
    'project-pages.create-space-dialog.content.placeholder': 'Bereichsnamen eingeben',
    'project-pages.create-space-dialog.creation-error': 'Bereich konnte nicht erstellt werden.',
    'project-pages.create-space-dialog.error-icon': 'Fehler:',
    'project-pages.create-space-dialog.footer.cancel': 'Abbrechen',
    'project-pages.create-space-dialog.footer.create-space': 'Erstellen',
    'project-pages.create-space-dialog.header.title': 'Neuen Confluence-Bereich erstellen',
    'project-pages.cross-join.access-revoked.templates.subtitle': "Sie k\xf6nnen keine Projektseiten verwenden, weil der Administrator Ihnen den Zugriff auf Confluence verweigert hat. Wenden Sie sich an Ihren Site-Administrator, um Zugriff anzufordern.",
    'project-pages.cross-join.access-revoked.templates.title': 'Sie sind nicht berechtigt, Projektseiten zu verwenden.',
    'project-pages.cross-join.avatar.view-profile': 'Profil anzeigen',
    'project-pages.cross-join.denied-request.templates.subtitle': "Sie k\xf6nnen keine Projektseiten verwenden, weil der Site-Administrator Ihre Anfrage zum Beitritt zu Confluence verweigert hat.",
    'project-pages.cross-join.denied-request.templates.title': 'Ihr Administrator hat Ihnen den Zugriff verweigert',
    'project-pages.cross-join.direct-access.button-subtitle.experimental': 'Sie erhalten Zugriff auf Confluence. Ihr Site-Administrator hat dies bereits genehmigt.',
    'project-pages.cross-join.errors.unknown-error.description': '{contactSupport}, wenn das Problem durch Aktualisieren der Seite nicht behoben wird.',
    'project-pages.cross-join.errors.unknown-error.title': "Projektseiten k\xf6nnen derzeit nicht angezeigt werden",
    'project-pages.cross-join.inline-join-product.button': 'Sie erhalten Zugriff auf Confluence. Ihr Site-Administrator hat dies bereits genehmigt.',
    'project-pages.cross-join.inline-join-product.connected.description': 'Dokumentation von einem zentralen Ort aus anzeigen, bearbeiten und erstellen',
    'project-pages.cross-join.inline-join-product.connected.title': 'Mit Ihrem Team an Projektseiten zusammenarbeiten',
    'project-pages.cross-join.pending-request.templates.subtitle': "Der Site-Administrator hat Ihre Anfrage zum Beitritt zu Confluence erhalten. Sobald Ihnen der Beitritt genehmigt wurde, k\xf6nnen Sie Projektseiten verwenden, und wir senden Ihnen eine Best\xe4tigungs-E-Mail.",
    'project-pages.cross-join.pending-request.templates.subtitle.experiment': 'Sobald der Zugriff genehmigt wurde, erhalten Sie eine E-Mail mit Zugang zu den Projektseiten.',
    'project-pages.cross-join.pending-request.templates.title': 'Sie haben Zugriff auf Confluence angefordert',
    'project-pages.cross-join.pending-request.templates.title.experiment': 'Zugriffsanfrage an Administrator gesendet',
    'project-pages.cross-join.request-access-without-better-together.connected.description': 'Projektdokumentation mit Ihrem Team ansehen, bearbeiten und erstellen',
    'project-pages.cross-join.request-access.button': 'Zugriff anfordern',
    'project-pages.cross-join.request-access.button-subtitle.experimental': 'Wenn Sie "Ihrem Team beitreten" ausw\xe4hlen, bitten Sie darum, Confluence beizutreten, und stimmen der Freigabe Ihres Atlassian-Profils f\xfcr Ihren Administrator zu.',
    'project-pages.cross-join.request-access.button.experimental': 'Ihrem Team beitreten',
    'project-pages.cross-join.request-access.connected.description.experimental': "Ihr Team verwendet Projektseiten, um Projektdokumentationen zu kommentieren, zu bearbeiten und daran zusammenzuarbeiten, ohne dabei Jira verlassen zu m\xfcssen. Treten Sie Confluence bei, um auf die Projektseiten Ihres Teams zuzugreifen.",
    'project-pages.cross-join.request-access.title': 'Projektseiten erfordern Zugriff auf Confluence',
    'project-pages.cross-join.request-access.title.experiment': "Eine zentrale Informationsquelle f\xfcr Ihr Team erstellen",
    'project-pages.default-contextual-heading': 'Projektseiten werden bereitgestellt von Confluence',
    'project-pages.default-contextual-message': "Confluence-Seiten machen das Erstellen, Teilen und Zusammenarbeiten bei all Ihren Projektdokumenten an einem Ort m\xf6glich.",
    'project-pages.default-reactivate-CTA': 'Confluence erneut aktivieren',
    'project-pages.default-trial-CTA': "Confluence 30\xa0Tage kostenlos testen",
    'project-pages.draft-saved-flag.action': "Entwurf \xf6ffnen",
    'project-pages.draft-saved-flag.description': "Ihr Entwurf ist f\xfcr andere erst sichtbar, wenn Sie ihn ver\xf6ffentlichen.",
    'project-pages.draft-saved-flag.title': 'Entwurf gespeichert',
    'project-pages.embedded-pages.create-page-error.close-button': "Schlie\xdfen",
    'project-pages.embedded-pages.create-page-error.description': 'Es ist ein Problem aufgetreten, sodass die Seite nicht erstellt werden konnte.',
    'project-pages.embedded-pages.create-page-error.title': 'Seite konnte nicht erstellt werden',
    'project-pages.embedded-pages.create-page-error.try-again-button': 'Versuchen Sie es erneut.',
    'project-pages.embedded-pages.modal.close.button.hint': "Schlie\xdfen",
    'project-pages.embedded-pages.modal.title.button': "In Confluence \xf6ffnen",
    'project-pages.embedded-pages.modal.title.button.hint': "In neuer Registerkarte \xf6ffnen",
    'project-pages.errors.unknown-error.description.non-final': '{contactSupport}, wenn das Problem durch Aktualisieren der Seite nicht behoben wird.',
    'project-pages.errors.unknown-error.title.non-final': "Projektseiten k\xf6nnen derzeit nicht angezeigt werden",
    'project-pages.generic-error.button.reload': 'Seite neu laden',
    'project-pages.generic-error.description': "Da hat etwas nicht geklappt. Bitte versuchen Sie es sp\xe4ter erneut.",
    'project-pages.generic-error.description.non-final': "Da hat etwas nicht geklappt. Bitte versuchen Sie es sp\xe4ter erneut.",
    'project-pages.generic-error.heading': 'Oh nein!',
    'project-pages.generic-error.title.non-final': "Das ist seltsam\xa0\u2026",
    'project-pages.generic-info-flag.description': 'Etwas ist schiefgelaufen. Bitte versuchen Sie es erneut oder wenden Sie sich an den Support, wenn das Problem weiterhin besteht.',
    'project-pages.generic-success-flag.description.live-doc': "Erfolgreich mit dem Live-Dokument {connectedSpaceOrPageName} verkn\xfcpft.",
    'project-pages.generic-success-flag.description.page': 'Erfolgreich mit Seite {connectedSpaceOrPageName} verbunden.',
    'project-pages.generic-success-flag.description.space': 'Erfolgreich mit Bereich {connectedSpaceOrPageName} verbunden.',
    'project-pages.generic-success-flag.heading.live-doc': "Live-Dokument verkn\xfcpft",
    'project-pages.generic-success-flag.heading.page': 'Seite verbunden',
    'project-pages.generic-success-flag.heading.space': 'Bereich verbunden',
    'project-pages.granular-pages.connect-space-dialog.content.create-space-link.link-text': 'Oder erstellen Sie einen neuen Bereich',
    'project-pages.granular-pages.connect-space.button': 'Mit Confluence verbinden',
    'project-pages.granular-pages.connect-space.heading': "Dieses Projekt mit einem Confluence-Bereich oder -Element verkn\xfcpfen",
    'project-pages.improvement.contact-support': 'Support kontaktieren',
    'project-pages.improvement.errors.access-error.description': 'Kontaktieren Sie den Site-Administrator, um Zugriff zu erhalten.',
    'project-pages.improvement.errors.access-error.title': 'Sie sind nicht berechtigt, Projektseiten anzuzeigen',
    'project-pages.improvement.errors.page-tree-unknown-error.description': 'Bei der Anzeige der Seiten von Ihrem verbundenen Confluence-Bereich ist ein Fehler aufgetreten. {contactSupport}, wenn das Problem durch Aktualisieren der Seite nicht behoben wird.',
    'project-pages.improvement.errors.page-tree-unknown-error.title': "Es k\xf6nnen keine Projektseiten angezeigt werden",
    'project-pages.improvement.errors.space-or-page-not-found.description': "Der verbundene Confluence-Bereich oder die verbundene Confluence-Seite wurde verschoben, archiviert oder gel\xf6scht. <link>Wenden Sie sich an den Support</link>, falls die erneute Verbindung das Problem nicht behebt.",
    'project-pages.improvement.errors.space-or-page-not-found.title': 'Bereich oder Seite nicht gefunden',
    'project-pages.improvement.errors.unknown-error.description': '{contactSupport}, wenn das Problem durch Aktualisieren der Seite nicht behoben wird.',
    'project-pages.improvement.errors.unknown-error.title': "Projektseiten k\xf6nnen derzeit nicht angezeigt werden",
    'project-pages.improvement.feature1': 'Dokumente erstellen und darauf zugreifen, ohne Jira zu verlassen',
    'project-pages.improvement.feature2': "Vorlagen f\xfcr Meetings, Sprintpl\xe4ne und mehr",
    'project-pages.improvement.feature3': "Dokumente f\xfcr automatische Updates mit Jira synchronisieren",
    'project-pages.improvement.heading-info': 'Protokollieren Sie das Wissen Ihres Teams und verbessern Sie die Art und Weise, Aufgaben zu erledigen.',
    'project-pages.improvement.heading-info-v2': "Schaffen Sie einen Ort f\xfcr alle Projektdokumente Ihres Teams",
    'project-pages.improvement.learn-more-button': 'Mehr erfahren',
    'project-pages.improvement.powered-by': 'Bereitgestellt von',
    'project-pages.improvement.powered-by.tooltip': "Confluence in einer neuen Registerkarte \xf6ffnen",
    'project-pages.improvement.preview-teaser': 'Profitieren Sie von Vorlagen, Projektseiten und mehr',
    'project-pages.improvement.provisioning-info-modal.seamlessly-update-stakeholders.description': "<p>Halten Sie Ihre Projektberichte mit automatisch aktualisierten Statusstichw\xf6rtern aktuell.</p> <p>Verkn\xfcpfen Sie einfach ein Jira-Ticket in einem Dokument und automatisch wird ein Statusstichwort angezeigt, das synchron mit dem Ticket aktualisiert wird. So m\xfcssen Sie Ihre Zeit nicht mit dem Erstellen manueller Berichte verbringen.</p>",
    'project-pages.improvement.provisioning-info-modal.seamlessly-update-stakeholders.title': "Nahtloses Update f\xfcr Ihre Stakeholder",
    'project-pages.improvement.provisioning-info-modal.unify-documentation-standards.description': "<p>Erstellen Sie eine konsistente Dokumentation mithilfe unserer integrierten Vorlagen. Sie k\xf6nnen ganz einfach verwendet und an Ihre Anforderungen angepasst werden.</p> <p>Sie k\xf6nnen Vorlagen direkt \xfcber Projektseiten verwenden. So m\xfcssen Sie Ihre aktuelle Arbeit nicht verlassen. <a>Hier</a> k\xf6nnen Sie alle Vorlagen durchsuchen.</p>",
    'project-pages.improvement.provisioning-info-modal.unify-documentation-standards.title': 'Ihre Dokumentationsstandards vereinheitlichen',
    'project-pages.improvement.provisioning-info-modal.your-project-pages-in-jira.description': "<p>Erstellen Sie eine zentrale Informationsquelle f\xfcr wichtige Informationen, indem Sie die Dokumentation \xfcber die Registerkarte &quot;Projektseiten&quot; in Jira erstellen und verwalten.</p> <p>Haben Sie gewusst, dass die Option &quot;Projektseiten&quot; in Confluence ausgef\xfchrt werden kann? Sie ist kostenlos f\xfcr bis zu 10\xa0Benutzer. Laden Sie den Rest Ihres Teams in Ihren Administratoreinstellungen ein.</p>",
    'project-pages.improvement.provisioning-info-modal.your-project-pages-in-jira.title': 'Ihre Projektseiten, direkt in Jira',
    'project-pages.improvement.templates-sidebar.better-together-templates-header': 'Vorlagen mit Ihren Jira-Daten',
    'project-pages.improvement.templates.better-together-preview-teaser': 'Mit Jira-Daten',
    'project-pages.improvement.templates.blank-page.description': 'Starten Sie mit einer ganz neuen Seite.',
    'project-pages.improvement.templates.blank-page.name': 'Leere Seite',
    'project-pages.improvement.templates.decision.description': 'Zeichnen Sie wichtige Projektentscheidungen auf und teilen Sie sie Ihrem Team mit.',
    'project-pages.improvement.templates.decision.name': 'Entscheidung',
    'project-pages.improvement.templates.meeting-notes.description': 'Planen Sie Besprechungen und teilen Sie Notizen und Aktionen mit Ihrem Team.',
    'project-pages.improvement.templates.meeting-notes.name': 'Besprechungsnotizen',
    'project-pages.improvement.templates.post-expand.more': 'Weitere Vorlagen',
    'project-pages.improvement.templates.post-expand.more.tooltip': 'Alle Vorlagen in Confluence anzeigen',
    'project-pages.improvement.templates.post-expand.subtitle': 'Beliebte Vorlagen',
    'project-pages.improvement.templates.post-expand.title': 'Eine Seite erstellen',
    'project-pages.improvement.templates.pre-expand.more': 'Weitere Vorlagen entdecken',
    'project-pages.improvement.templates.pre-expand.subtitle': "Bei \xe4hnlichen Teams beliebt",
    'project-pages.improvement.templates.pre-expand.title': 'Vorschau der Vorlagen anzeigen',
    'project-pages.improvement.templates.product-requirements.description': "Definieren und \xfcberwachen Sie die Anforderungen f\xfcr Ihr Produkt oder Ihre Funktion, und bestimmen Sie den Umfang.",
    'project-pages.improvement.templates.product-requirements.name': 'Produktanforderungen',
    'project-pages.improvement.templates.retrospective.description': "Was ist gut gelaufen? Was h\xe4tte besser laufen k\xf6nnen? Stellen Sie gemeinsam mit Ihrem Team Verbesserungen heraus.",
    'project-pages.improvement.templates.retrospective.name': 'Retrospektive',
    'project-pages.improvement.templates.template.disabled-tooltip': 'Verbinden Sie zuerst einen Confluence-Bereich.',
    'project-pages.improvement.templates.tutorial.content.confluence-templates': "<b>Zeitersparnis und weniger manuelle Aufgaben:</b> In Confluence sind eine Vielzahl an <a>Seitenvorlagen</a> verf\xfcgbar. Sie m\xfcssen also nie ganz bei Null beginnen. Sie finden zum Beispiel Vorlagen f\xfcr technische Dokumente, Leitf\xe4den zur Fehlerbehebung, Projektpl\xe4ne, Produktanforderungen und mehr.",
    'project-pages.improvement.templates.tutorial.content.edit-and-format': "<b>M\xfchelose Bearbeitung und Formatierung:</b> \xdcber das obere Bearbeitungsmen\xfc stehen Ihnen Standard-Formatierungsoptionen zur Verf\xfcgung und mit <b>/</b> k\xf6nnen Sie viele praktische Integrationen einf\xfcgen. F\xfcgen Sie eine Tabelle ein, indem Sie <c>/tabelle</c> eingeben oder ein Bild mit <c>/bild</c>. Dar\xfcber hinaus k\xf6nnen Sie Dropbox-Links mit <c>/dropbox</c>, Microsoft Office-Tools mit <c>/microsoft</c> oder Trello-Boards und Karten mit <c>/trello</c> einf\xfcgen.",
    'project-pages.improvement.templates.tutorial.content.forward-slash-prompt': 'Geben Sie / ein und anschlie\xdfend "tabelle" oder "bild".',
    'project-pages.improvement.templates.tutorial.content.getting-started-tips': "Hier ein paar Tipps f\xfcr den Einstieg:",
    'project-pages.improvement.templates.tutorial.content.handy-links': 'Praktische Links',
    'project-pages.improvement.templates.tutorial.content.jira-and-confluence': 'Jira und Confluence gemeinsam nutzen',
    'project-pages.improvement.templates.tutorial.content.jira-charts': 'Erstellen Sie auf Ihren Seiten Diagramme mit Echtzeit-Daten aus Jira. Geben Sie <c>/Jira-Diagramme</c> ein.',
    'project-pages.improvement.templates.tutorial.content.jira-links': "Verkn\xfcpfen Sie einen Jira-Vorgang an einer beliebigen Stelle auf Ihrer Seite. Der Link auf der Seite wird in Echtzeit aktualisiert, wenn Sie den Jira-Vorgang aktualisieren. Geben Sie <c>/Jira</c> ein.",
    'project-pages.improvement.templates.tutorial.content.jira-links-issue-term-refresh': "Verkn\xfcpfen Sie einen Jira-Vorgang an einer beliebigen Stelle auf Ihrer Seite. Der Link auf der Seite wird in Echtzeit aktualisiert, wenn Sie den Jira-Vorgang aktualisieren. Geben Sie <c>/Jira</c> ein.",
    'project-pages.improvement.templates.tutorial.content.jira-links.non-final-issue-term-refresh': "Verkn\xfcpfen Sie einen Jira-Vorgang an einer beliebigen Stelle auf Ihrer Seite. Der Link auf der Seite wird in Echtzeit aktualisiert, wenn Sie den Jira-Vorgang aktualisieren. Geben Sie <c>/Jira</c> ein.",
    'project-pages.improvement.templates.tutorial.content.jira-roadmaps': "Betten Sie mithilfe Ihrer Jira-Projekte interaktive Roadmaps und Zeitleisten f\xfcr Ihre Seite ein. Geben Sie <c>/jira roadmap</c> ein.",
    'project-pages.improvement.templates.tutorial.content.jira-timeline': "Betten Sie mithilfe Ihrer Jira-Projekte interaktive Zeitleisten f\xfcr Ihre Seite ein. Geben Sie <c>/Jira-Zeitleiste</c> ein.",
    'project-pages.improvement.templates.tutorial.content.shipping-speed-statistic': "76\xa0% aller Jira Software-Kunden gaben an, dass sie die Projektauslieferung beschleunigen konnten, nachdem sie Confluence hinzugef\xfcgt hatten.",
    'project-pages.improvement.templates.tutorial.content.shipping-speed-statistic.spork-rebranding': "76\xa0% aller Jira-Kunden gaben an, dass sie die Projektauslieferung beschleunigen konnten, nachdem sie Confluence hinzugef\xfcgt hatten.",
    'project-pages.improvement.templates.tutorial.content.spaces-and-pages': "<b>Verwendung von Bereichen und Seiten:</b> Bereiche sind Teil jeder Confluence-Site. Sie erm\xf6glichen die Unterteilung von Seiten in Kategorien. Bereiche sind sozusagen verschiedene Ordner oder Projekte, w\xe4hrend Seiten die Dokumente in diesen Ordnern oder Projekten sind. <a>Weitere Informationen zur Verwendung von Bereichen</a>",
    'project-pages.improvement.templates.tutorial.content.try-it-now': 'Jetzt testen',
    'project-pages.improvement.templates.tutorial.description': 'Erfahren Sie, wie Sie eine Seite bearbeiten.',
    'project-pages.improvement.templates.tutorial.name': 'Willkommen auf den Projektseiten!',
    'project-pages.improvement.terms-and-conditions-v2': "Indem Sie &quot;Jetzt testen&quot; ausw\xe4hlen, best\xe4tigen Sie, dass Sie bei Confluence registriert werden, und stimmen den <termsLink>Nutzungsbedingungen</termsLink> und der <privacyLink>Datenschutzrichtlinie</privacyLink> f\xfcr Atlassian Cloud zu.",
    'project-pages.improvement.title': 'Projektseiten',
    'project-pages.improvement.transient-states.empty-state.auto-provisioned-create-page-button': 'Seite erstellen',
    'project-pages.improvement.transient-states.empty-state.auto-provisioned-description': "Wir haben Confluence hinzugef\xfcgt, damit Sie Projektdokumente erstellen und diese verkn\xfcpfen k\xf6nnen. Dies ist f\xfcr bis zu 10\xa0Benutzer kostenlos.",
    'project-pages.improvement.transient-states.empty-state.auto-provisioned-learn-more-button': 'Mehr erfahren',
    'project-pages.improvement.transient-states.empty-state.create-page-button': 'Ihre erste Seite erstellen',
    'project-pages.improvement.transient-states.empty-state.description': "Erstellen Sie Besprechungsnotizen, Produktanforderungen, Entscheidungen und andere Inhalte, damit dieser Bereich sich f\xfcllt.",
    'project-pages.improvement.transient-states.empty-state.title': 'Hier gibt es nichts als Potenzial',
    'project-pages.improvement.try-button': 'Diese Vorlage in Confluence ausprobieren',
    'project-pages.improvement.try-it-now': 'Jetzt testen',
    'project-pages.improvement.try-lozenge': 'Testen',
    'project-pages.improvement.try-on-demand-button': 'Kostenlos testen',
    'project-pages.page-deleted-flag.title': "Seite gel\xf6scht",
    'project-pages.page-published-flag.title': "Ihre Seite wurde ver\xf6ffentlicht",
    'project-pages.unknown-error.description': '{contactSupport}, wenn das Problem durch Aktualisieren der Seite nicht behoben wird.',
    'project-pages.unknown-error.heading': "Projektseiten k\xf6nnen derzeit nicht angezeigt werden"
};

});

parcelRegister("cP8k0", function(module, exports) {

$parcel$export(module.exports, "default", () => $c2870032415416bc$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Hungarian
var $c2870032415416bc$export$2e2bcd8739ae039 = {
    'confluence.project-pages.improvement.provisioning-background.text': "Ez legfeljebb egy percet vesz ig\xe9nybe",
    'confluence.project-pages.improvement.provisioning-background.title': "A projektoldalak be\xe1ll\xedt\xe1sa folyamatban van",
    'confluence.project-pages.improvement.provisioning-modal-carousel.controls.dismiss': "Elvet\xe9s",
    'confluence.project-pages.improvement.provisioning-modal-carousel.controls.done': "K\xe9sz",
    'confluence.project-pages.improvement.provisioning-modal-carousel.controls.next': "Tov\xe1bb",
    'project-pages.activating.description': "A csatlakoztatott Confluence-munkat\xe9r m\xe9g nincs teljesen k\xe9sz. {contactSupport}, ha a friss\xedt\xe9s nem jav\xedtja ki a probl\xe9m\xe1kat.",
    'project-pages.activating.heading': "A Confluence bet\xf6lt\xe9se m\xe9g folyamatban van",
    'project-pages.better-together-templates.meeting-notes.action-items-heading': "Mik a m\u0171veletelemek?",
    'project-pages.better-together-templates.meeting-notes.agenda-item-label': 'Napirendi pont',
    'project-pages.better-together-templates.meeting-notes.create-a-jira-issue': "A /Jira beg\xe9pel\xe9s\xe9vel l\xe9trehozhatsz egy \xfcgyet",
    'project-pages.better-together-templates.meeting-notes.date-label': "D\xe1tum",
    'project-pages.better-together-templates.meeting-notes.discussion-topics-heading': "A megbesz\xe9l\xe9s t\xe9mak\xf6rei",
    'project-pages.better-together-templates.meeting-notes.list-people': "a k\xf6vetkez\u0151vel sorolhatsz fel szem\xe9lyeket:",
    'project-pages.better-together-templates.meeting-notes.mention': "eml\xedt\xe9s",
    'project-pages.better-together-templates.meeting-notes.mention-people-to-assign-them': "\u2013 megeml\xedthetsz szem\xe9lyeket, hogy hozz\xe1rendeld \u0151ket egy m\u0171veletelemhez",
    'project-pages.better-together-templates.meeting-notes.notes-label': 'Jegyzetek',
    'project-pages.better-together-templates.meeting-notes.page-title': "Megbesz\xe9l\xe9s feljegyz\xe9sei",
    'project-pages.better-together-templates.meeting-notes.participants-label': "R\xe9sztvev\u0151k",
    'project-pages.better-together-templates.meeting-notes.project-label': 'Projekt',
    'project-pages.better-together-templates.product-requirements.create-a-jira-issue': "A /Jira beg\xe9pel\xe9s\xe9vel l\xe9trehozhatsz egy \xfcgyet",
    'project-pages.better-together-templates.product-requirements.design-heading': "Tervez\xe9s",
    'project-pages.better-together-templates.product-requirements.embedd-different-data-views': "K\xfcl\xf6nb\xf6z\u0151 adatokat \xe9s n\xe9zeteket \xe1gyazhatsz be a Jira-projektedb\u0151l.",
    'project-pages.better-together-templates.product-requirements.heading': "\xc1ttekint\xe9s",
    'project-pages.better-together-templates.product-requirements.how-will-you-know-if-fixed': "Honnan tudod majd, hogy siker\xfclt megjav\xedtani?",
    'project-pages.better-together-templates.product-requirements.impact-heading': "Hat\xe1s",
    'project-pages.better-together-templates.product-requirements.inScopeStatus': "Hat\xe1sk\xf6r\xf6n bel\xfcl",
    'project-pages.better-together-templates.product-requirements.insert-design-link': "Sz\xfarj be egy linket a tervedhez (Figma stb.)",
    'project-pages.better-together-templates.product-requirements.jira-issue-heading': "Jira-\xfcgy",
    'project-pages.better-together-templates.product-requirements.jira-roadmap-heading': "Jira-\xfatvonalterv",
    'project-pages.better-together-templates.product-requirements.learn-how-with-smart-links': "Tov\xe1bbi inform\xe1ci\xf3 az okoslinkek haszn\xe1lat\xe1r\xf3l",
    'project-pages.better-together-templates.product-requirements.list-dashboards': "Sorold fel az ir\xe1ny\xedt\xf3pultokat (Amplitude, Mode stb.)",
    'project-pages.better-together-templates.product-requirements.list-design-considerations': "A tervez\xe9sre \xe9s buildre vonatkoz\xf3 szempontok felsorol\xe1sa",
    'project-pages.better-together-templates.product-requirements.list-people': "a k\xf6vetkez\u0151vel sorolhatsz fel szem\xe9lyeket:",
    'project-pages.better-together-templates.product-requirements.mention': "eml\xedt\xe9s",
    'project-pages.better-together-templates.product-requirements.mention-people-to-assign-them': "\u2013 megeml\xedthetsz szem\xe9lyeket, hogy hozz\xe1rendeld \u0151ket egy m\u0171veletelemhez",
    'project-pages.better-together-templates.product-requirements.niceToHaveStatus': "J\xf3, ha van",
    'project-pages.better-together-templates.product-requirements.outOfScopeStatus': "Hat\xe1sk\xf6r\xf6n k\xedv\xfcl",
    'project-pages.better-together-templates.product-requirements.page-title': "Term\xe9kk\xf6vetelm\xe9nyek",
    'project-pages.better-together-templates.product-requirements.pro-tip': 'Profi tipp:',
    'project-pages.better-together-templates.product-requirements.problem-label': "Probl\xe9ma",
    'project-pages.better-together-templates.product-requirements.requirement-heading': "K\xf6vetelm\xe9nyek",
    'project-pages.better-together-templates.product-requirements.scope-heading': "Hat\xe1sk\xf6r",
    'project-pages.better-together-templates.product-requirements.success-metric': "Sikermetrik\xe1k",
    'project-pages.better-together-templates.product-requirements.target-release-date': "Megc\xe9lzott kiad\xe1si d\xe1tum",
    'project-pages.better-together-templates.product-requirements.team-label': 'Csapat',
    'project-pages.better-together-templates.product-requirements.to-do-list-heading': "Tennival\xf3k",
    'project-pages.better-together-templates.product-requirements.what-are-you-trying-to-fix': "Mit pr\xf3b\xe1lsz megjav\xedtani?",
    'project-pages.better-together-templates.retro-notes.retro-heading': "Visszatekint\xe9s",
    'project-pages.better-together-templates.retro.action-items-heading': "Mik a m\u0171veletelemek?",
    'project-pages.better-together-templates.retro.create-a-jira-issue': "A /Jira beg\xe9pel\xe9s\xe9vel l\xe9trehozhatsz egy \xfcgyet",
    'project-pages.better-together-templates.retro.date-label': "D\xe1tum",
    'project-pages.better-together-templates.retro.embed-it-here': "Ha elk\xe9sz\xfclt\xe9l, be\xe1gyazhatod ide.",
    'project-pages.better-together-templates.retro.list-people': "a k\xf6vetkez\u0151vel sorolhatsz fel szem\xe9lyeket:",
    'project-pages.better-together-templates.retro.mention': "eml\xedt\xe9s",
    'project-pages.better-together-templates.retro.mention-people-to-assign-them': "\u2013 megeml\xedthetsz szem\xe9lyeket, hogy hozz\xe1rendeld \u0151ket egy m\u0171veletelemhez",
    'project-pages.better-together-templates.retro.page-title': "Visszatekint\xe9s",
    'project-pages.better-together-templates.retro.participants-label': "R\xe9sztvev\u0151k",
    'project-pages.better-together-templates.retro.pro-tip': 'Profi tipp:',
    'project-pages.better-together-templates.retro.project-label': 'Projekt',
    'project-pages.better-together-templates.retro.this-is-a-whiteboard': "Ez egy Confluence-rajzt\xe1bla.",
    'project-pages.better-together-templates.retro.use-a-whiteboard': "A visszatekint\xe9sedhez haszn\xe1lhatsz Confluence-rajzt\xe1bl\xe1t is.",
    'project-pages.better-together-templates.retro.use-it-to-vote': "Seg\xedts\xe9g\xe9vel szavazhattok \xe9s egy\xfcttm\u0171k\xf6dhettek a csapatoddal.",
    'project-pages.button.connect-different-space-or-page.label': "Munkat\xe9r vagy oldal ikonj\xe1nak m\xf3dos\xedt\xe1sa",
    'project-pages.button.connect-different-space-or-page.tooltip': "M\xe1sik munkat\xe9r vagy t\xe9tel csatlakoztat\xe1sa",
    'project-pages.button.connect-space-or-page.tooltip': "Csatlakoz\xe1s a Confluence-hez",
    'project-pages.button.go-to-connected-live-doc.tooltip': "\xc9l\u0151 dokumentum megnyit\xe1sa a Confluence-ben",
    'project-pages.button.go-to-connected-page.tooltip': "Oldal megnyit\xe1sa a Confluence-ben",
    'project-pages.button.go-to-connected-space.tooltip': "Munkat\xe9r megnyit\xe1sa a Confluence-ben",
    'project-pages.connect-space-dialog.connection-error': "A csatlakoztat\xe1s nem siker\xfclt.",
    'project-pages.connect-space-dialog.connection-retry': "\xdajra",
    'project-pages.connect-space-dialog.content.space-or-page-selector.description': "V\xe1laszd ki a projekthez csatlakoztatni k\xedv\xe1nt munkateret vagy t\xe9telt.",
    'project-pages.connect-space-dialog.content.space-or-page-selector.placeholder': "Keres\xe9s a Confluence-ben",
    'project-pages.connect-space-dialog.content.space-selector.disconnected-templates-description': "Ha t\xe9telt szeretn\xe9l l\xe9trehozni, ezt a projektet egy munkat\xe9rhez kell kapcsolnod. V\xe1laszd ki a projekthez csatlakoztatand\xf3 munkateret.",
    'project-pages.connect-space-dialog.error-icon': 'Hiba:',
    'project-pages.connect-space-dialog.footer.cancel': "M\xe9gse",
    'project-pages.connect-space-dialog.footer.connect-space': "Csatlakoztat\xe1s",
    'project-pages.connect-space-or-page-dialog.header.title': "Projekt csatlakoztat\xe1sa a Confluence-hez",
    'project-pages.connect-space.description': "A munkaterek a mapp\xe1khoz hasonl\xedtanak \u2013 l\xe9trehozhatod \xe9s rendszerezheted a projekteddel kapcsolatos tartalmakat, \xe9s egy\xfcttm\u0171k\xf6dhetsz benn\xfck.",
    'project-pages.connect-space.not-connected.description': "A projektoldalak haszn\xe1lat\xe1hoz vedd fel a kapcsolatot az adminisztr\xe1toroddal vagy csapatvezet\u0151ddel, hogy kapcsolja hozz\xe1 a Confluence-t a projekthez.",
    'project-pages.connect-space.not-connected.heading': 'Nincs csatlakoztatva a Confluence-hez',
    'project-pages.connect-success-flag.description.content': 'Sikeresen csatlakoztatva {connectedSpaceOrPageName} tartalomhoz.',
    'project-pages.connection-error.space-or-page-not-found.button': "Csatlakoztat\xe1s egy m\xe1sik munkat\xe9rhez vagy oldalhoz",
    'project-pages.create-space-dialog.connection-error': "A csatlakoztat\xe1s nem siker\xfclt.",
    'project-pages.create-space-dialog.connection-retry': "\xdajra",
    'project-pages.create-space-dialog.content.empty-name': 'Adj nevet a munkaterednek.',
    'project-pages.create-space-dialog.content.invalid-name': "A munkat\xe9r nev\xe9nek legal\xe1bb egy bet\u0171b\u0151l vagy sz\xe1mb\xf3l kell \xe1llnia.",
    'project-pages.create-space-dialog.content.placeholder': "Add meg a munkat\xe9r nev\xe9t",
    'project-pages.create-space-dialog.creation-error': "A munkat\xe9r l\xe9trehoz\xe1sa nem siker\xfclt.",
    'project-pages.create-space-dialog.error-icon': 'Hiba:',
    'project-pages.create-space-dialog.footer.cancel': "M\xe9gse",
    'project-pages.create-space-dialog.footer.create-space': "L\xe9trehoz\xe1s",
    'project-pages.create-space-dialog.header.title': "\xdaj Confluence-munkat\xe9r l\xe9trehoz\xe1sa",
    'project-pages.cross-join.access-revoked.templates.subtitle': "Nem haszn\xe1lhatsz projektoldalakat, mert az admint\xf3l nem kapt\xe1l hozz\xe1f\xe9r\xe9st a Confluence-hez. Fordulj a webhely-adminisztr\xe1torodhoz, \xe9s k\xe9rj t\u0151le hozz\xe1f\xe9r\xe9st.",
    'project-pages.cross-join.access-revoked.templates.title': "Nincs jogosults\xe1god a projektoldalak haszn\xe1lat\xe1ra",
    'project-pages.cross-join.avatar.view-profile': "Profil megtekint\xe9se",
    'project-pages.cross-join.denied-request.templates.subtitle': "Nem haszn\xe1lhatsz projektoldalakat, mert a webhely-adminisztr\xe1tor elutas\xedtotta a Confluence-hez val\xf3 csatlakoz\xe1sra ir\xe1nyul\xf3 k\xe9relmedet.",
    'project-pages.cross-join.denied-request.templates.title': "Az admin elutas\xedtotta a hozz\xe1f\xe9r\xe9si k\xe9relmedet",
    'project-pages.cross-join.direct-access.button-subtitle.experimental': "Hozz\xe1f\xe9r\xe9st kapsz a Confluence-hez. A webhely-adminisztr\xe1torod m\xe1r j\xf3v\xe1hagyta a k\xe9relmet.",
    'project-pages.cross-join.errors.unknown-error.description': "{contactSupport}, ha a friss\xedt\xe9s nem jav\xedtja ki a probl\xe9m\xe1kat.",
    'project-pages.cross-join.errors.unknown-error.title': "Jelenleg nem tudjuk megjelen\xedteni a projektoldalakat",
    'project-pages.cross-join.inline-join-product.button': "Hozz\xe1f\xe9r\xe9st kapsz a Confluence-hez. A webhely-adminisztr\xe1torod m\xe1r j\xf3v\xe1hagyta a k\xe9relmet.",
    'project-pages.cross-join.inline-join-product.connected.description': "Dokument\xe1ci\xf3 megtekint\xe9se, szerkeszt\xe9se \xe9s l\xe9trehoz\xe1sa egyetlen helyr\u0151l",
    'project-pages.cross-join.inline-join-product.connected.title': "Egy\xfcttm\u0171k\xf6dhetsz a projekt oldalain a csapatoddal",
    'project-pages.cross-join.pending-request.templates.subtitle': "A webhely-adminisztr\xe1tor megkapta a Confluence-hez val\xf3 csatlakoz\xe1si k\xe9relmedet. Ha j\xf3v\xe1hagyja, a projektoldalak m\u0171k\xf6dni fognak, \xe9s kapni fogsz t\u0151l\xfcnk egy visszaigazol\xf3 e-mailt.",
    'project-pages.cross-join.pending-request.templates.subtitle.experiment': "E-mailben \xe9rtes\xedteni fogunk a Projektoldalakhoz val\xf3 hozz\xe1f\xe9r\xe9sr\u0151l, ha j\xf3v\xe1hagyt\xe1k a k\xe9relmet.",
    'project-pages.cross-join.pending-request.templates.title': "Hozz\xe1f\xe9r\xe9st k\xe9rt\xe9l a Confluence-hez",
    'project-pages.cross-join.pending-request.templates.title.experiment': "Hozz\xe1f\xe9r\xe9si k\xe9relem elk\xfcldve az adminisztr\xe1tornak",
    'project-pages.cross-join.request-access-without-better-together.connected.description': "Projektdokument\xe1ci\xf3 megtekint\xe9se, szerkeszt\xe9se \xe9s l\xe9trehoz\xe1sa a csapattal k\xf6z\xf6sen",
    'project-pages.cross-join.request-access.button': "Hozz\xe1f\xe9r\xe9s k\xe9r\xe9se",
    'project-pages.cross-join.request-access.button-subtitle.experimental': "A \u201ECsatlakoz\xe1s a csapathoz\u201D kiv\xe1laszt\xe1s\xe1val jelezheted, hogy csatlakozni szeretn\xe9l a Confluence-hez, \xe9s hozz\xe1j\xe1rulsz ahhoz, hogy a rendszer megossza az adminisztr\xe1toroddal az Atlassian-profilodat.",
    'project-pages.cross-join.request-access.button.experimental': 'Csatlakozom a csapatomhoz',
    'project-pages.cross-join.request-access.connected.description.experimental': "A csapatod tagjai a Projektoldalakat haszn\xe1lj\xe1k, hogy a Jira elhagy\xe1sa n\xe9lk\xfcl \xedrjanak megjegyz\xe9seket, hajtsanak v\xe9gre szerkeszt\xe9seket \xe9s egy\xfcttm\u0171k\xf6djenek a projektdokument\xe1ci\xf3kban. Csatlakozz a Confluence-hez, hogy hozz\xe1f\xe9rhess a csapatod Projektoldalaihoz.",
    'project-pages.cross-join.request-access.title': "A projektoldalak haszn\xe1lata \xe9rdek\xe9ben hozz\xe1f\xe9r\xe9s sz\xfcks\xe9ges a Confluence-hez",
    'project-pages.cross-join.request-access.title.experiment': "Hozz l\xe9tre egy egys\xe9ges inform\xe1ci\xf3forr\xe1st a csapatod sz\xe1m\xe1ra",
    'project-pages.default-contextual-heading': "A projektoldalakat a Confluence t\xe1mogatja",
    'project-pages.default-contextual-message': "L\xe9trehoz\xe1s, megoszt\xe1s \xe9s egy\xfcttm\u0171k\xf6d\xe9s minden projektdokumentumodon egy helyen, a Confluence-oldalakkal.",
    'project-pages.default-reactivate-CTA': "A Confluence \xfajraaktiv\xe1l\xe1sa",
    'project-pages.default-trial-CTA': "Pr\xf3b\xe1ld ki a Confluence szoftvert ingyenesen 30 napig",
    'project-pages.draft-saved-flag.action': "Piszkozat megnyit\xe1sa",
    'project-pages.draft-saved-flag.description': "Am\xedg k\xf6zz\xe9 nem teszed, addig a piszkozat csak sz\xe1modra l\xe1that\xf3.",
    'project-pages.draft-saved-flag.title': 'Piszkozat mentve',
    'project-pages.embedded-pages.create-page-error.close-button': "Bez\xe1r\xe1s",
    'project-pages.embedded-pages.create-page-error.description': "Hiba t\xf6rt\xe9nt, \xe9s nem siker\xfclt l\xe9trehozni az oldaladat.",
    'project-pages.embedded-pages.create-page-error.title': "Nem siker\xfclt l\xe9trehozni az oldalt",
    'project-pages.embedded-pages.create-page-error.try-again-button': "Pr\xf3b\xe1ld \xfajra",
    'project-pages.embedded-pages.modal.close.button.hint': "Bez\xe1r\xe1s",
    'project-pages.embedded-pages.modal.title.button': "Megnyit\xe1s a Confluence-ben",
    'project-pages.embedded-pages.modal.title.button.hint': "Megnyit\xe1s \xfaj lapon",
    'project-pages.errors.unknown-error.description.non-final': "{contactSupport}, ha a friss\xedt\xe9s nem jav\xedtja ki a probl\xe9m\xe1kat.",
    'project-pages.errors.unknown-error.title.non-final': "Jelenleg nem tudjuk megjelen\xedteni a projektoldalakat",
    'project-pages.generic-error.button.reload': "Oldal \xfajrat\xf6lt\xe9se",
    'project-pages.generic-error.description': "Hiba t\xf6rt\xe9nt. Pr\xf3b\xe1ld meg \xfajra k\xe9s\u0151bb.",
    'project-pages.generic-error.description.non-final': "Hiba t\xf6rt\xe9nt. Pr\xf3b\xe1ld meg \xfajra k\xe9s\u0151bb.",
    'project-pages.generic-error.heading': "Eln\xe9z\xe9st k\xe9r\xfcnk!",
    'project-pages.generic-error.title.non-final': "Eln\xe9z\xe9st k\xe9r\xfcnk!",
    'project-pages.generic-info-flag.description': "Hiba t\xf6rt\xe9nt. Pr\xf3b\xe1ld \xfajra, vagy fordulj az \xfcgyf\xe9lszolg\xe1lathoz, ha a probl\xe9ma tov\xe1bbra is fenn\xe1ll.",
    'project-pages.generic-success-flag.description.live-doc': "Sikeresen csatlakoztatva a(z) {connectedSpaceOrPageName} \xe9l\u0151 dokumentumhoz.",
    'project-pages.generic-success-flag.description.page': 'Sikeresen csatlakoztatva a(z) {connectedSpaceOrPageName} oldalhoz.',
    'project-pages.generic-success-flag.description.space': 'Sikeresen csatlakoztattad a munkateret ({connectedSpaceOrPageName}).',
    'project-pages.generic-success-flag.heading.live-doc': "\xc9l\u0151 dokumentum csatlakoztatva",
    'project-pages.generic-success-flag.heading.page': 'Oldal csatlakoztatva',
    'project-pages.generic-success-flag.heading.space': "Munkat\xe9r csatlakoztatva",
    'project-pages.granular-pages.connect-space-dialog.content.create-space-link.link-text': "Vagy hozz l\xe9tre \xfaj munkateret",
    'project-pages.granular-pages.connect-space.button': "Csatlakoz\xe1s a Confluence-hez",
    'project-pages.granular-pages.connect-space.heading': "A projekt csatlakoztat\xe1sa egy Confluence-munkat\xe9rhez vagy -t\xe9telhez",
    'project-pages.improvement.contact-support': "\xdcgyf\xe9lszolg\xe1lat",
    'project-pages.improvement.errors.access-error.description': "Ha hozz\xe1f\xe9r\xe9st szeretn\xe9l k\xe9rni, vedd fel a kapcsolatot a webhely adminj\xe1val.",
    'project-pages.improvement.errors.access-error.title': "Nincs jogosults\xe1god a projektoldalak megtekint\xe9s\xe9re",
    'project-pages.improvement.errors.page-tree-unknown-error.description': "Hiba t\xf6rt\xe9nt a csatlakoztatott Confluence-munkat\xe9r oldalainak megjelen\xedt\xe9sekor. {contactSupport}, ha a friss\xedt\xe9s nem jav\xedtja ki a probl\xe9m\xe1kat.",
    'project-pages.improvement.errors.page-tree-unknown-error.title': "Probl\xe9m\xe1ba \xfctk\xf6zt\xfcnk a projektoldalak megjelen\xedt\xe9sekor",
    'project-pages.improvement.errors.space-or-page-not-found.description': "A csatlakoztatott Confluence-munkateret vagy -oldalt \xe1thelyezt\xe9k, archiv\xe1lt\xe1k vagy t\xf6r\xf6lt\xe9k. <link>Vedd fel a kapcsolatot a t\xe1mogat\xe1ssal</link>, ha az \xfajracsatlakoztat\xe1s nem oldja meg a probl\xe9m\xe1t",
    'project-pages.improvement.errors.space-or-page-not-found.title': "A munkat\xe9r vagy oldal nem tal\xe1lhat\xf3",
    'project-pages.improvement.errors.unknown-error.description': "{contactSupport}, ha a friss\xedt\xe9s nem jav\xedtja ki a probl\xe9m\xe1kat.",
    'project-pages.improvement.errors.unknown-error.title': "Jelenleg nem tudjuk megjelen\xedteni a projektoldalakat",
    'project-pages.improvement.feature1': "Dokumentumok el\xe9r\xe9se \xe9s l\xe9trehoz\xe1sa a Jira elhagy\xe1sa n\xe9lk\xfcl",
    'project-pages.improvement.feature2': "Sablonok az \xe9rtekezletekhez, sprinttervek \xe9s sok m\xe1s",
    'project-pages.improvement.feature3': "Dokumentumok szinkroniz\xe1l\xe1sa a Jir\xe1val az automatikus friss\xedt\xe9sekhez",
    'project-pages.improvement.heading-info': "R\xf6gz\xedtsd csapatod tud\xe1s\xe1t, \xe9s fejleszd a munka elv\xe9gz\xe9s\xe9re haszn\xe1lhat\xf3 m\xf3dszereket.",
    'project-pages.improvement.heading-info-v2': "Hozz l\xe9tre egy k\xf6zponti helyet a csapatod \xf6sszes projektdokumentum\xe1nak",
    'project-pages.improvement.learn-more-button': "Tov\xe1bbi inform\xe1ci\xf3",
    'project-pages.improvement.powered-by': "Szolg\xe1ltat\xf3:",
    'project-pages.improvement.powered-by.tooltip': "A Confluence megnyit\xe1sa \xfaj lapon",
    'project-pages.improvement.preview-teaser': "Sablonok, projektoldalak \xe9s egyebek felold\xe1sa.",
    'project-pages.improvement.provisioning-info-modal.seamlessly-update-stakeholders.description': "<p>Az \xe1llapotc\xedmk\xe9k automatikus friss\xedt\xe9s\xe9vel naprak\xe9szen tarthatod a projektjelent\xe9seidet.</p> <p>Egyszer\u0171en kapcsolj \xf6ssze egy Jira-jegyet egy dokumentumban, \xe9s automatikusan megjelenik az \xe1llapotc\xedmke, amely a jeggyel szinkronban friss\xfcl, \xedgy nem kell id\u0151t pazarolnod manu\xe1lis jelent\xe9sek l\xe9trehoz\xe1s\xe1ra.</p>",
    'project-pages.improvement.provisioning-info-modal.seamlessly-update-stakeholders.title': "Az \xe9rdekelt felek g\xf6rd\xfcl\xe9keny \xe9rtes\xedt\xe9se",
    'project-pages.improvement.provisioning-info-modal.unify-documentation-standards.description': "<p>A be\xe9p\xedtett sablonjainkkal konzisztens dokument\xe1ci\xf3kat hozhatsz l\xe9tre. K\xf6nnyen haszn\xe1lhat\xf3k, r\xe1ad\xe1sul szem\xe9lyre szabhatod \u0151ket az ig\xe9nyeidnek megfelel\u0151en.</p> <p>A sablonokat haszn\xe1lhatod k\xf6zvetlen\xfcl a projektoldalakr\xf3l, \xedgy soha nem kell elhagynod az aktu\xe1lis munk\xe1dat. <a>Itt</a> b\xf6ng\xe9szhetsz az \xf6sszes sablon k\xf6z\xf6tt.</p>",
    'project-pages.improvement.provisioning-info-modal.unify-documentation-standards.title': "Egys\xe9ges\xedtsd a dokument\xe1ci\xf3s standardjaidat",
    'project-pages.improvement.provisioning-info-modal.your-project-pages-in-jira.description': "<p>A Jira projektoldalak lapj\xe1r\xf3l a dokument\xe1ci\xf3k l\xe9trehoz\xe1s\xe1val \xe9s kezel\xe9s\xe9vel \xf6ssze\xe1ll\xedthatsz egy egys\xe9ges forr\xe1st a fontos inform\xe1ci\xf3k sz\xe1m\xe1ra.</p> <p>Tudtad, hogy a projektoldalak fel\xfclet a Confluence-ben fut? A haszn\xe1lata 10 felhaszn\xe1l\xf3ig ingyenes. A csapatod t\xf6bbi r\xe9sz\xe9t az adminisztr\xe1ci\xf3s be\xe1ll\xedt\xe1sokban h\xedvhatod meg.</p>",
    'project-pages.improvement.provisioning-info-modal.your-project-pages-in-jira.title': "A projektoldalaid k\xf6zvetlen\xfcl a Jir\xe1ban",
    'project-pages.improvement.templates-sidebar.better-together-templates-header': "A Jira-adataiddal integr\xe1lt sablonok",
    'project-pages.improvement.templates.better-together-preview-teaser': "Integr\xe1lva a Jira-adatokkal",
    'project-pages.improvement.templates.blank-page.description': "Oldal k\xe9sz\xedt\xe9se null\xe1r\xf3l.",
    'project-pages.improvement.templates.blank-page.name': "\xdcres oldal",
    'project-pages.improvement.templates.decision.description': "R\xf6gz\xedtsd a fontosabb projektd\xf6nt\xe9seket, \xe9s besz\xe9ld meg \u0151ket a csapatoddal.",
    'project-pages.improvement.templates.decision.name': "D\xf6nt\xe9s",
    'project-pages.improvement.templates.meeting-notes.description': "Megtervezheted az \xe9rtekezleteket, jegyzetelhetsz \xe9s megoszthatod a teend\u0151ket a csapatoddal.",
    'project-pages.improvement.templates.meeting-notes.name': "Megbesz\xe9l\xe9s feljegyz\xe9sei",
    'project-pages.improvement.templates.post-expand.more': "Tov\xe1bbi sablonok",
    'project-pages.improvement.templates.post-expand.more.tooltip': "Az \xf6sszes sablon megtekint\xe9se a Confluence-ben",
    'project-pages.improvement.templates.post-expand.subtitle': "N\xe9pszer\u0171 sablonok",
    'project-pages.improvement.templates.post-expand.title': "Oldal l\xe9trehoz\xe1sa",
    'project-pages.improvement.templates.pre-expand.more': "Tov\xe1bbi sablonok felfedez\xe9se",
    'project-pages.improvement.templates.pre-expand.subtitle': "N\xe9pszer\u0171 a ti\xe9dhez hasonl\xf3 csapatok k\xf6r\xe9ben",
    'project-pages.improvement.templates.pre-expand.title': "Sablonok el\u0151n\xe9zet\xe9nek megtekint\xe9se",
    'project-pages.improvement.templates.product-requirements.description': "Defini\xe1ld, k\xf6vesd \xe9s tedd \xe1ttekinthet\u0151v\xe9 a term\xe9ked vagy funkci\xf3d k\xf6vetelm\xe9nyeit.",
    'project-pages.improvement.templates.product-requirements.name': "Term\xe9kk\xf6vetelm\xe9nyek",
    'project-pages.improvement.templates.retrospective.description': "Mi az, ami j\xf3l alakult? Mi mehetett volna jobban? A csapatoddal k\xf6z\xf6sen tal\xe1ljatok ki fejleszt\xe9si lehet\u0151s\xe9geket.",
    'project-pages.improvement.templates.retrospective.name': "Visszatekint\xe9s",
    'project-pages.improvement.templates.template.disabled-tooltip': "El\u0151sz\xf6r csatlakoztass egy Confluence-munkateret",
    'project-pages.improvement.templates.tutorial.content.confluence-templates': "<b>Takar\xedts meg id\u0151t, \xe9s cs\xf6kkentsd a manu\xe1lis feladatok sz\xe1m\xe1t</b>. A Confluence rengeteg <a>oldalsablonnal</a> rendelkezik, \xedgy soha nem kell null\xe1r\xf3l kezdened. Ilyenekre gondolj: sablonok m\u0171szaki dokumentumokhoz, hibaelh\xe1r\xedt\xf3 \xfatmutat\xf3khoz, projekttervekhez, term\xe9kk\xf6vetelm\xe9nyekhez \xe9s sok m\xe1shoz.",
    'project-pages.improvement.templates.tutorial.content.edit-and-format': "<b>K\xf6nnyed\xe9n szerkeszthet\u0151 \xe9s form\xe1zhat\xf3.</b> A fenti szerkeszt\u0151men\xfc seg\xedts\xe9g\xe9vel elv\xe9gezheted a standard Word-form\xe1z\xe1sokat, a <b>/</b> be\xedr\xe1s\xe1val pedig egyszer\u0171en besz\xfarhatsz sok praktikus integr\xe1ci\xf3t. T\xe1bl\xe1zatot a <c>/t\xe1bl\xe1zat</c>, k\xe9pet pedig a <c>/k\xe9p</c> be\xedr\xe1s\xe1val sz\xfarhatsz be. A <c>/dropbox</c> be\xedr\xe1s\xe1val Dropbox linkeket, a <c>/microsoft</c> paranccsal Microsoft Office-eszk\xf6z\xf6ket, a <c>/trello</c> beg\xe9pel\xe9s\xe9vel pedig Trello-t\xe1bl\xe1kat \xe9s -k\xe1rty\xe1kat sz\xfarhatsz be.",
    'project-pages.improvement.templates.tutorial.content.forward-slash-prompt': "\xcdrd be a / jelet, majd a \u201Et\xe1bl\xe1zat\u201C vagy a \u201Ek\xe9p\u201C sz\xf3t",
    'project-pages.improvement.templates.tutorial.content.getting-started-tips': "\xcdme n\xe9h\xe1ny tipp a kezd\xe9shez:",
    'project-pages.improvement.templates.tutorial.content.handy-links': 'Praktikus linkek',
    'project-pages.improvement.templates.tutorial.content.jira-and-confluence': "Haszn\xe1ld egy\xfctt a Jir\xe1t \xe9s a Confluence-t",
    'project-pages.improvement.templates.tutorial.content.jira-charts': "Hozz l\xe9tre diagramokat az oldalaidon val\xf3s Jira-adatok alapj\xe1n. \xcdrd be, hogy <c>/Jira diagramok</c>.",
    'project-pages.improvement.templates.tutorial.content.jira-links': "Linkelj egy Jira-\xfcgyet b\xe1rhol az oldaladon. Az oldal linkje val\xf3s id\u0151ben friss\xfcl, ahogy friss\xedted a Jira-\xfcgyet. \xcdrd be, hogy <c>/Jira</c>.",
    'project-pages.improvement.templates.tutorial.content.jira-links-issue-term-refresh': "Linkelj egy Jira-\xfcgyet b\xe1rhol az oldaladon. Az oldalon tal\xe1lhat\xf3 link val\xf3s id\u0151ben friss\xfcl, ahogy friss\xedted az \xfcgyet. \xcdrd be, hogy <c>/Jira</c>.",
    'project-pages.improvement.templates.tutorial.content.jira-links.non-final-issue-term-refresh': "Linkelj egy Jira-\xfcgyet b\xe1rhol az oldaladon. Az oldalon tal\xe1lhat\xf3 link val\xf3s id\u0151ben friss\xfcl, ahogy friss\xedted az \xfcgyet. \xcdrd be, hogy <c>/Jira</c>.",
    'project-pages.improvement.templates.tutorial.content.jira-roadmaps': "\xc1gyazz be interakt\xedv \xfatvonalterveket \xe9s id\u0151vonalakat az oldaladra a Jira Projects haszn\xe1lat\xe1val. \xcdrd be, hogy <c>/jira \xfatvonalterv</c>.",
    'project-pages.improvement.templates.tutorial.content.jira-timeline': "\xc1gyazz be interakt\xedv id\u0151vonalakat az oldaladra a Jira-projektek haszn\xe1lat\xe1val. G\xe9peld be a <c>/jira id\u0151vonal</c> kifejez\xe9st.",
    'project-pages.improvement.templates.tutorial.content.shipping-speed-statistic': "A Jira Software haszn\xe1l\xf3inak 76%-a \xe1ll\xedtja, hogy a Confluence bevezet\xe9se \xf3ta gyorsabban tudja sz\xe1ll\xedtani a projekteket",
    'project-pages.improvement.templates.tutorial.content.shipping-speed-statistic.spork-rebranding': "A Jira-\xfcgyfelek 76%-a \xe1ll\xedtja, hogy a Confluence bevezet\xe9se \xf3ta gyorsabban tudja sz\xe1ll\xedtani a projekteket",
    'project-pages.improvement.templates.tutorial.content.spaces-and-pages': "<b>Munkaterek \xe9s oldalak haszn\xe1lata</b>. A munkaterek minden Confluence-webhely r\xe9szei, \xe9s kiv\xe1l\xf3 m\xf3dszert jelentenek az oldalak kateg\xf3ri\xe1kba rendez\xe9s\xe9re. Gondolj \xfagy a munkaterekre, mint k\xfcl\xf6nb\xf6z\u0151 mapp\xe1kra vagy projektekre, az oldalak pedig a mapp\xe1kba vagy projektekbe tartoz\xf3 dokumentumok. <a>Tov\xe1bbi inform\xe1ci\xf3 a munkaterek haszn\xe1lat\xe1r\xf3l</a>",
    'project-pages.improvement.templates.tutorial.content.try-it-now': "Pr\xf3b\xe1ld ki most",
    'project-pages.improvement.templates.tutorial.description': 'Ismerd meg, hogyan kell szerkeszteni egy oldalt.',
    'project-pages.improvement.templates.tutorial.name': "\xdcdv\xf6zl\xfcnk a Projektoldalakon!",
    'project-pages.improvement.terms-and-conditions-v2': "A \u201EPr\xf3b\xe1ld ki most\u201D gombra kattintva regisztr\xe1lsz a Confluence szolg\xe1ltat\xe1sra, \xe9s elfogadod az Atlassian <termsLink>Cloud \xc1ltal\xe1nos Szolg\xe1ltat\xe1si Felt\xe9teleit</termsLink> \xe9s <privacyLink>adatv\xe9delmi ir\xe1nyelveit</privacyLink>.",
    'project-pages.improvement.title': 'Projektoldalak',
    'project-pages.improvement.transient-states.empty-state.auto-provisioned-create-page-button': "Oldal l\xe9trehoz\xe1sa",
    'project-pages.improvement.transient-states.empty-state.auto-provisioned-description': "Hozz\xe1adtuk a Confluence-t, \xedgy hozz\xe1kezdhetsz, hogy l\xe9trehozd \xe9s \xf6sszekapcsold az \xf6sszes projektdokumentumot. 10 felhaszn\xe1l\xf3ig ingyenes.",
    'project-pages.improvement.transient-states.empty-state.auto-provisioned-learn-more-button': "Tov\xe1bbi inform\xe1ci\xf3",
    'project-pages.improvement.transient-states.empty-state.create-page-button': "Hozd l\xe9tre az els\u0151 oldaladat",
    'project-pages.improvement.transient-states.empty-state.description': "Hozz l\xe9tre megbesz\xe9l\xe9sfeljegyz\xe9seket, term\xe9kk\xf6vetelm\xe9nyeket, d\xf6nt\xe9seket vagy m\xe1s tartalmakat, amelyekkel megt\xf6ltheted ezt a munkateret.",
    'project-pages.improvement.transient-states.empty-state.title': "Ez a hely tele van lehet\u0151s\xe9ggel",
    'project-pages.improvement.try-button': "Pr\xf3b\xe1ld ki ezt a sablont a Confluence-ben",
    'project-pages.improvement.try-it-now': "Pr\xf3b\xe1ld ki most",
    'project-pages.improvement.try-lozenge': "Pr\xf3b\xe1ld ki",
    'project-pages.improvement.try-on-demand-button': "Pr\xf3b\xe1ld ki ingyen",
    'project-pages.page-deleted-flag.title': "Oldal t\xf6r\xf6lve.",
    'project-pages.page-published-flag.title': "Az oldaladat k\xf6zz\xe9tett\xfck.",
    'project-pages.unknown-error.description': "{contactSupport}, ha a friss\xedt\xe9s nem jav\xedtja ki a probl\xe9m\xe1kat.",
    'project-pages.unknown-error.heading': "Jelenleg nem tudjuk megjelen\xedteni a projektoldalakat"
};

});

parcelRegister("4DQb0", function(module, exports) {

$parcel$export(module.exports, "default", () => $2e2399e42b50ed87$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Italian (Italy)
var $2e2399e42b50ed87$export$2e2bcd8739ae039 = {
    'confluence.project-pages.improvement.provisioning-background.text': "L'operazione dovrebbe richiedere meno di un minuto",
    'confluence.project-pages.improvement.provisioning-background.title': 'Configurazione delle pagine del progetto in corso',
    'confluence.project-pages.improvement.provisioning-modal-carousel.controls.dismiss': 'Chiudi',
    'confluence.project-pages.improvement.provisioning-modal-carousel.controls.done': 'Fine',
    'confluence.project-pages.improvement.provisioning-modal-carousel.controls.next': 'Avanti',
    'project-pages.activating.description': "Lo spazio Confluence connesso non \xe8 ancora pronto. {contactSupport} se il problema non si risolve con un aggiornamento.",
    'project-pages.activating.heading': "Confluence \xe8 ancora in fase di caricamento",
    'project-pages.better-together-templates.meeting-notes.action-items-heading': 'Che cosa sono gli elementi di azione?',
    'project-pages.better-together-templates.meeting-notes.agenda-item-label': "Punto all'ordine del giorno",
    'project-pages.better-together-templates.meeting-notes.create-a-jira-issue': 'Digita /Jira per creare un ticket',
    'project-pages.better-together-templates.meeting-notes.date-label': 'Data',
    'project-pages.better-together-templates.meeting-notes.discussion-topics-heading': 'Temi di discussione',
    'project-pages.better-together-templates.meeting-notes.list-people': 'elenca le persone che usano',
    'project-pages.better-together-templates.meeting-notes.mention': 'menziona',
    'project-pages.better-together-templates.meeting-notes.mention-people-to-assign-them': 'le persone per assegnarle a un elemento di azione',
    'project-pages.better-together-templates.meeting-notes.notes-label': 'Note',
    'project-pages.better-together-templates.meeting-notes.page-title': 'Note della riunione',
    'project-pages.better-together-templates.meeting-notes.participants-label': 'Partecipanti',
    'project-pages.better-together-templates.meeting-notes.project-label': 'Progetto',
    'project-pages.better-together-templates.product-requirements.create-a-jira-issue': 'Digita /Jira per creare un ticket',
    'project-pages.better-together-templates.product-requirements.design-heading': 'Design',
    'project-pages.better-together-templates.product-requirements.embedd-different-data-views': 'Incorpora dati e visualizzazioni diversi del tuo progetto Jira.',
    'project-pages.better-together-templates.product-requirements.heading': 'Panoramica',
    'project-pages.better-together-templates.product-requirements.how-will-you-know-if-fixed': 'Come saprai di averlo corretto?',
    'project-pages.better-together-templates.product-requirements.impact-heading': 'Impatto',
    'project-pages.better-together-templates.product-requirements.inScopeStatus': "Interno all'ambito",
    'project-pages.better-together-templates.product-requirements.insert-design-link': "Inserisci un link al tuo design (Figma e cos\xec via)",
    'project-pages.better-together-templates.product-requirements.jira-issue-heading': 'Ticket Jira',
    'project-pages.better-together-templates.product-requirements.jira-roadmap-heading': 'Roadmap di Jira',
    'project-pages.better-together-templates.product-requirements.learn-how-with-smart-links': 'Scopri come con i link intelligenti',
    'project-pages.better-together-templates.product-requirements.list-dashboards': "Elenca le dashboard (Amplitude, Mode e cos\xec via)",
    'project-pages.better-together-templates.product-requirements.list-design-considerations': 'Elenca le considerazioni sul design o sulla realizzazione',
    'project-pages.better-together-templates.product-requirements.list-people': 'elenca le persone che usano',
    'project-pages.better-together-templates.product-requirements.mention': 'menziona',
    'project-pages.better-together-templates.product-requirements.mention-people-to-assign-them': 'le persone per assegnarle a un elemento di azione',
    'project-pages.better-together-templates.product-requirements.niceToHaveStatus': 'Utile',
    'project-pages.better-together-templates.product-requirements.outOfScopeStatus': "Esterno all'ambito",
    'project-pages.better-together-templates.product-requirements.page-title': 'Requisiti del prodotto',
    'project-pages.better-together-templates.product-requirements.pro-tip': 'Suggerimento avanzato:',
    'project-pages.better-together-templates.product-requirements.problem-label': 'Problema',
    'project-pages.better-together-templates.product-requirements.requirement-heading': 'Requisito',
    'project-pages.better-together-templates.product-requirements.scope-heading': 'Ambito',
    'project-pages.better-together-templates.product-requirements.success-metric': 'Metrica del successo',
    'project-pages.better-together-templates.product-requirements.target-release-date': 'Data di rilascio stabilita',
    'project-pages.better-together-templates.product-requirements.team-label': 'Team',
    'project-pages.better-together-templates.product-requirements.to-do-list-heading': 'Elenco delle cose da fare',
    'project-pages.better-together-templates.product-requirements.what-are-you-trying-to-fix': 'Che cosa stai cercando di correggere?',
    'project-pages.better-together-templates.retro-notes.retro-heading': 'Retrospettiva',
    'project-pages.better-together-templates.retro.action-items-heading': 'Che cosa sono gli elementi di azione?',
    'project-pages.better-together-templates.retro.create-a-jira-issue': 'Digita /Jira per creare un ticket',
    'project-pages.better-together-templates.retro.date-label': 'Data',
    'project-pages.better-together-templates.retro.embed-it-here': 'Al termine potrai incorporarla qui.',
    'project-pages.better-together-templates.retro.list-people': 'elenca le persone che usano',
    'project-pages.better-together-templates.retro.mention': 'menziona',
    'project-pages.better-together-templates.retro.mention-people-to-assign-them': 'le persone per assegnarle a un elemento di azione',
    'project-pages.better-together-templates.retro.page-title': 'Retrospettiva',
    'project-pages.better-together-templates.retro.participants-label': 'Partecipanti',
    'project-pages.better-together-templates.retro.pro-tip': 'Suggerimento avanzato:',
    'project-pages.better-together-templates.retro.project-label': 'Progetto',
    'project-pages.better-together-templates.retro.this-is-a-whiteboard': "Questa \xe8 una lavagna Confluence.",
    'project-pages.better-together-templates.retro.use-a-whiteboard': 'Usa una lavagna Confluence per la tua retrospettiva.',
    'project-pages.better-together-templates.retro.use-it-to-vote': 'Usala per votare e collaborare con il tuo team.',
    'project-pages.button.connect-different-space-or-page.label': "Aggiorna l'icona dello spazio o della pagina",
    'project-pages.button.connect-different-space-or-page.tooltip': 'Connetti uno spazio o un elemento diverso',
    'project-pages.button.connect-space-or-page.tooltip': 'Connetti a Confluence',
    'project-pages.button.go-to-connected-live-doc.tooltip': 'Apri il documento dinamico in Confluence',
    'project-pages.button.go-to-connected-page.tooltip': 'Apri la pagina in Confluence',
    'project-pages.button.go-to-connected-space.tooltip': 'Apri lo spazio in Confluence',
    'project-pages.connect-space-dialog.connection-error': 'Connessione non riuscita.',
    'project-pages.connect-space-dialog.connection-retry': 'Riprova',
    'project-pages.connect-space-dialog.content.space-or-page-selector.description': 'Scegli uno spazio o un elemento da connettere al tuo progetto.',
    'project-pages.connect-space-dialog.content.space-or-page-selector.placeholder': 'Cerca Confluence',
    'project-pages.connect-space-dialog.content.space-selector.disconnected-templates-description': 'Questo progetto deve essere connesso a uno spazio prima che sia possibile creare un elemento. Scegli uno spazio da connettere al progetto.',
    'project-pages.connect-space-dialog.error-icon': 'Errore:',
    'project-pages.connect-space-dialog.footer.cancel': 'Annulla',
    'project-pages.connect-space-dialog.footer.connect-space': 'Collega',
    'project-pages.connect-space-or-page-dialog.header.title': 'Connetti progetto a Confluence',
    'project-pages.connect-space.description': 'Gli spazi sono come cartelle: puoi utilizzarli per creare, organizzare e collaborare a tutti i contenuti correlati al tuo progetto.',
    'project-pages.connect-space.not-connected.description': "Per utilizzare le pagine di progetto, contatta l'amministratore o il team leader per connettere Confluence a questo progetto.",
    'project-pages.connect-space.not-connected.heading': 'Non connesso a Confluence',
    'project-pages.connect-success-flag.description.content': 'Connessione con il contenuto {connectedSpaceOrPageName} riuscita.',
    'project-pages.connection-error.space-or-page-not-found.button': 'Connetti a uno spazio o pagina diverso',
    'project-pages.create-space-dialog.connection-error': 'Connessione non riuscita.',
    'project-pages.create-space-dialog.connection-retry': 'Riprova',
    'project-pages.create-space-dialog.content.empty-name': 'Assegna un nome al tuo spazio.',
    'project-pages.create-space-dialog.content.invalid-name': 'I nomi degli spazi devono contenere almeno una lettera o un numero.',
    'project-pages.create-space-dialog.content.placeholder': 'Inserisci un nome per lo spazio',
    'project-pages.create-space-dialog.creation-error': 'Connessione dello spazio non riuscita.',
    'project-pages.create-space-dialog.error-icon': 'Errore:',
    'project-pages.create-space-dialog.footer.cancel': 'Annulla',
    'project-pages.create-space-dialog.footer.create-space': 'Crea',
    'project-pages.create-space-dialog.header.title': 'Crea nuovo spazio Confluence',
    'project-pages.cross-join.access-revoked.templates.subtitle': "Non puoi utilizzare le pagine del progetto perch\xe9 l'amministratore ti ha negato l'accesso a Confluence. Contatta l'amministratore del sito per richiedere l'accesso.",
    'project-pages.cross-join.access-revoked.templates.title': 'Non sei autorizzato a usare le pagine del progetto',
    'project-pages.cross-join.avatar.view-profile': 'Visualizza profilo',
    'project-pages.cross-join.denied-request.templates.subtitle': "Non puoi utilizzare le pagine del progetto perch\xe9 l'amministratore del sito ha rifiutato la tua richiesta di unirti a Confluence.",
    'project-pages.cross-join.denied-request.templates.title': "Il tuo amministratore ti ha negato l'accesso",
    'project-pages.cross-join.direct-access.button-subtitle.experimental': "Otterrai l'accesso a Confluence. L'amministratore del sito ha gi\xe0 approvato l'accesso.",
    'project-pages.cross-join.errors.unknown-error.description': "{contactSupport} se con l'aggiornamento non risolvi il problema.",
    'project-pages.cross-join.errors.unknown-error.title': "Al momento non \xe8 possibile visualizzare le pagine del progetto",
    'project-pages.cross-join.inline-join-product.button': "Otterrai l'accesso a Confluence. L'amministratore del tuo sito ha gi\xe0 approvato il tuo accesso.",
    'project-pages.cross-join.inline-join-product.connected.description': "Visualizza, modifica e crea la documentazione da un'unica posizione",
    'project-pages.cross-join.inline-join-product.connected.title': 'Collabora alle pagine del progetto con il tuo team',
    'project-pages.cross-join.pending-request.templates.subtitle': "L'amministratore del sito ha ricevuto la tua richiesta di unirti a Confluence. Se la tua unione viene approvata, le pagine del progetto inizieranno a essere utilizzabili e riceverai un'e-mail di conferma.",
    'project-pages.cross-join.pending-request.templates.subtitle.experiment': "Riceverai un messaggio e-mail con l'accesso alle pagine del progetto non appena la richiesta sar\xe0 stata approvata",
    'project-pages.cross-join.pending-request.templates.title': "Hai richiesto l'accesso a Confluence",
    'project-pages.cross-join.pending-request.templates.title.experiment': "Richiesta di accesso inviata all'amministratore",
    'project-pages.cross-join.request-access-without-better-together.connected.description': 'Visualizza, modifica e crea la documentazione del progetto con il tuo team',
    'project-pages.cross-join.request-access.button': 'Richiedi accesso',
    'project-pages.cross-join.request-access.button-subtitle.experimental': 'Quando selezioni "Unisciti al team", ti sar\xe0 chiesto di entrare a far parte di Confluence e dovrai accettare di condividere il tuo profilo Atlassian con il tuo amministratore.',
    'project-pages.cross-join.request-access.button.experimental': 'Unisciti al tuo team',
    'project-pages.cross-join.request-access.connected.description.experimental': 'Il tuo team usa le pagine del progetto per commentare, modificare e collaborare alla documentazione del progetto senza lasciare Jira. Unisciti a Confluence per accedere alle pagine del progetto del tuo team.',
    'project-pages.cross-join.request-access.title': "Le pagine del progetto richiedono l'accesso a Confluence",
    'project-pages.cross-join.request-access.title.experiment': "Crea un'unica origine di riferimento per il tuo team",
    'project-pages.default-contextual-heading': 'Le pagine di progetto usano la tecnologia di Confluence',
    'project-pages.default-contextual-message': "Crea, condividi e collabora a tutti i documenti del tuo progetto da un'unica posizione con le pagine Confluence.",
    'project-pages.default-reactivate-CTA': 'Riattiva Confluence',
    'project-pages.default-trial-CTA': 'Prova gratuitamente Confluence per 30 giorni',
    'project-pages.draft-saved-flag.action': 'Apri bozza',
    'project-pages.draft-saved-flag.description': "La bozza \xe8 visibile solo finch\xe9 non la pubblichi.",
    'project-pages.draft-saved-flag.title': 'Bozza salvata',
    'project-pages.embedded-pages.create-page-error.close-button': 'Chiudi',
    'project-pages.embedded-pages.create-page-error.description': "Si \xe8 verificato un problema e non \xe8 stato possibile creare una pagina.",
    'project-pages.embedded-pages.create-page-error.title': 'Impossibile creare una pagina',
    'project-pages.embedded-pages.create-page-error.try-again-button': 'Riprova',
    'project-pages.embedded-pages.modal.close.button.hint': 'Chiudi',
    'project-pages.embedded-pages.modal.title.button': 'Apri in Confluence',
    'project-pages.embedded-pages.modal.title.button.hint': 'Apri in una nuova scheda',
    'project-pages.errors.unknown-error.description.non-final': '{contactSupport} se il problema non si risolve con un aggiornamento.',
    'project-pages.errors.unknown-error.title.non-final': "Al momento non \xe8 possibile visualizzare le pagine del progetto",
    'project-pages.generic-error.button.reload': 'Ricarica la pagina',
    'project-pages.generic-error.description': "Si \xe8 verificato un errore. Riprova pi\xf9 tardi.",
    'project-pages.generic-error.description.non-final': "Si \xe8 verificato un errore. Riprova pi\xf9 tardi.",
    'project-pages.generic-error.heading': "\xc8 imbarazzante...",
    'project-pages.generic-error.title.non-final': "\xc8 imbarazzante...",
    'project-pages.generic-info-flag.description': "Si \xe8 verificato un problema. Riprova o, se il problema persiste, contatta l'assistenza",
    'project-pages.generic-success-flag.description.live-doc': 'Connessione al documento dinamico {connectedSpaceOrPageName} riuscita.',
    'project-pages.generic-success-flag.description.page': 'Connessione con la pagina {connectedSpaceOrPageName} riuscita.',
    'project-pages.generic-success-flag.description.space': 'Collegamento con lo spazio {connectedSpaceOrPageName} riuscito.',
    'project-pages.generic-success-flag.heading.live-doc': 'Documento dinamico connesso',
    'project-pages.generic-success-flag.heading.page': 'Pagina connessa',
    'project-pages.generic-success-flag.heading.space': 'Spazio collegato',
    'project-pages.granular-pages.connect-space-dialog.content.create-space-link.link-text': 'O crea un nuovo spazio',
    'project-pages.granular-pages.connect-space.button': 'Connetti a Confluence',
    'project-pages.granular-pages.connect-space.heading': 'Connetti questo progetto a un elemento o uno spazio Confluence',
    'project-pages.improvement.contact-support': "Contatta l'assistenza",
    'project-pages.improvement.errors.access-error.description': "Prova a contattare l'amministratore del sito per richiedere l'accesso.",
    'project-pages.improvement.errors.access-error.title': 'Non sei autorizzato a visualizzare le pagine del progetto',
    'project-pages.improvement.errors.page-tree-unknown-error.description': "Si \xe8 verificato un problema durante il tentativo di visualizzare le pagine dello spazio Confluence connesso. {contactSupport} se il problema non si risolve con un aggiornamento.",
    'project-pages.improvement.errors.page-tree-unknown-error.title': 'Si sono verificati problemi durante la visualizzazione delle pagine del progetto',
    'project-pages.improvement.errors.space-or-page-not-found.description': "Lo spazio o la pagina Confluence connesso \xe8 stato spostato, archiviato o eliminato. <link>Contatta l'assistenza</link> se la riconnessione non risolve il problema",
    'project-pages.improvement.errors.space-or-page-not-found.title': 'Spazio o pagina non trovati',
    'project-pages.improvement.errors.unknown-error.description': '{contactSupport} se il problema non si risolve con un aggiornamento.',
    'project-pages.improvement.errors.unknown-error.title': "Al momento non \xe8 possibile visualizzare le pagine del progetto",
    'project-pages.improvement.feature1': 'Crea e accedi ai documenti senza uscire da Jira',
    'project-pages.improvement.feature2': 'Modelli per riunioni, programmi di sprint e altro ancora',
    'project-pages.improvement.feature3': 'Sincronizza i documenti con Jira per gli aggiornamenti automatici',
    'project-pages.improvement.heading-info': 'Raccogli le conoscenze del tuo team e migliora lo svolgimento del lavoro.',
    'project-pages.improvement.heading-info-v2': 'Crea un posto per tutti i documenti di progetto del tuo team',
    'project-pages.improvement.learn-more-button': 'Maggiori informazioni',
    'project-pages.improvement.powered-by': 'Offerto da',
    'project-pages.improvement.powered-by.tooltip': 'Apri Confluence in una nuova scheda',
    'project-pages.improvement.preview-teaser': 'Sblocca modelli, pagine di progetto e altro ancora.',
    'project-pages.improvement.provisioning-info-modal.seamlessly-update-stakeholders.description': "<p>Mantieni aggiornati i report del progetto utilizzando le etichette di stato che si aggiornano automaticamente.</p> <p>Basta collegare un ticket Jira a un documento per visualizzare automaticamente un'etichetta di stato che si aggiorna in sincronia con il ticket, cos\xec da non perdere tempo a creare report manuali.</p>",
    'project-pages.improvement.provisioning-info-modal.seamlessly-update-stakeholders.title': "Aggiorna senza difficolt\xe0 i tuoi stakeholder",
    'project-pages.improvement.provisioning-info-modal.unify-documentation-standards.description': '<p>Crea una documentazione coerente utilizzando i nostri modelli integrati. Sono semplici da usare e personalizzabili secondo le tue esigenze.</p> <p>Puoi usare i modelli direttamente dalle pagine del progetto, in modo da non dover mai interrompere il lavoro in corso. Sfoglia tutti i modelli <a>qui</a>.</p>',
    'project-pages.improvement.provisioning-info-modal.unify-documentation-standards.title': 'Unifica gli standard relativi alla documentazione',
    'project-pages.improvement.provisioning-info-modal.your-project-pages-in-jira.description': "<p>Crea un'origine di riferimento unica per le informazioni importanti generando e gestendo la documentazione dalla scheda delle pagine del progetto in Jira.</p> <p>Sapevi che le pagine del progetto sono utilizzabili in Confluence? \xc8 gratuito per un massimo di 10 utenti. Invita il resto del tuo team dalle impostazioni di amministrazione.</p>",
    'project-pages.improvement.provisioning-info-modal.your-project-pages-in-jira.title': 'Le tue pagine del progetto, direttamente in Jira',
    'project-pages.improvement.templates-sidebar.better-together-templates-header': 'Modelli integrati con i tuoi dati Jira',
    'project-pages.improvement.templates.better-together-preview-teaser': 'Integrato con i dati Jira',
    'project-pages.improvement.templates.blank-page.description': 'Costruisci una pagina da zero.',
    'project-pages.improvement.templates.blank-page.name': 'Pagina vuota',
    'project-pages.improvement.templates.decision.description': 'Registra le decisioni importanti per il progetto e comunicale al tuo team.',
    'project-pages.improvement.templates.decision.name': 'Decisione',
    'project-pages.improvement.templates.meeting-notes.description': 'Pianifica i tuoi incontri, prendi appunti e condividi le azioni con il tuo team.',
    'project-pages.improvement.templates.meeting-notes.name': 'Note della riunione',
    'project-pages.improvement.templates.post-expand.more': 'Altri modelli',
    'project-pages.improvement.templates.post-expand.more.tooltip': 'Visualizza tutti i modelli in Confluence',
    'project-pages.improvement.templates.post-expand.subtitle': "Modelli pi\xf9 richiesti",
    'project-pages.improvement.templates.post-expand.title': 'Crea una pagina',
    'project-pages.improvement.templates.pre-expand.more': 'Scopri altri modelli',
    'project-pages.improvement.templates.pre-expand.subtitle': "I pi\xf9 richiesti tra i team come il tuo",
    'project-pages.improvement.templates.pre-expand.title': 'Visualizza anteprima modelli',
    'project-pages.improvement.templates.product-requirements.description': 'Definisci, monitora e delimita i requisiti per il tuo prodotto o la tua funzione.',
    'project-pages.improvement.templates.product-requirements.name': 'Requisiti del prodotto',
    'project-pages.improvement.templates.retrospective.description': "Che cosa \xe8 andato bene? Che cosa sarebbe potuto andare meglio? Gestisci i miglioramenti in crowdsourcing con il tuo team.",
    'project-pages.improvement.templates.retrospective.name': 'Retrospettiva',
    'project-pages.improvement.templates.template.disabled-tooltip': 'Connetti prima uno spazio Confluence',
    'project-pages.improvement.templates.tutorial.content.confluence-templates': '<b>Risparmia tempo e riduci i task manuali</b>. Confluence dispone di molti <a>modelli</a> di pagina che ti eviteranno di dover cominciare da zero. Pensa ai documenti tecnici, alle guide alla risoluzione dei problemi, ai piani di progetto, ai requisiti dei prodotti e altro ancora.',
    'project-pages.improvement.templates.tutorial.content.edit-and-format': "<b>Modifica e formatta con facilit\xe0.</b> Usa il menu di modifica in alto per la formattazione standard del testo e digita <b>/</b> per inserire facilmente diverse integrazioni utili. Inserisci una tabella digitando <c>/tabella</c> o un'immagine digitando <c>/immagine</c>. Puoi anche inserire link a Dropbox con <c>/dropbox</c>, agli strumenti di Microsoft Office con <c>/microsoft</c> o a bacheche e schede di Trello con <c>/trello</c>.",
    'project-pages.improvement.templates.tutorial.content.forward-slash-prompt': 'Digita / seguito da "tabella" o "immagine"',
    'project-pages.improvement.templates.tutorial.content.getting-started-tips': 'Ecco alcuni suggerimenti per iniziare:',
    'project-pages.improvement.templates.tutorial.content.handy-links': 'Link pratici',
    'project-pages.improvement.templates.tutorial.content.jira-and-confluence': 'Usa Jira e Confluence insieme',
    'project-pages.improvement.templates.tutorial.content.jira-charts': 'Crea grafici nelle pagine utilizzando dati autentici di Jira. Digita <c>/grafici Jira</c>.',
    'project-pages.improvement.templates.tutorial.content.jira-links': "Collega un ticket Jira in qualsiasi punto della pagina. Il link sulla pagina sar\xe0 aggiornato in tempo reale quando aggiornerai il ticket Jira. Digita <c>/Jira</c>.",
    'project-pages.improvement.templates.tutorial.content.jira-links-issue-term-refresh': "Collega un ticket Jira in qualsiasi punto della pagina. Il link sulla pagina sar\xe0 aggiornato in tempo reale quando aggiornerai il ticket. Digita <c>/Jira</c>.",
    'project-pages.improvement.templates.tutorial.content.jira-links.non-final-issue-term-refresh': "Collega un ticket Jira in qualsiasi punto della pagina. Il link sulla pagina sar\xe0 aggiornato in tempo reale quando aggiornerai il ticket. Digita <c>/Jira</c>.",
    'project-pages.improvement.templates.tutorial.content.jira-roadmaps': 'Incorpora roadmap e timeline interattive nella pagina utilizzando i progetti Jira. Digita <c>/roadmap jira</c>.',
    'project-pages.improvement.templates.tutorial.content.jira-timeline': 'Incorpora le timeline interattive nella pagina utilizzando i progetti Jira. Digita <c>/timeline jira</c>.',
    'project-pages.improvement.templates.tutorial.content.shipping-speed-statistic': 'Il 76% dei clienti di Jira Software afferma di aver velocizzato il rilascio dei progetti grazie a Confluence',
    'project-pages.improvement.templates.tutorial.content.shipping-speed-statistic.spork-rebranding': 'Il 76% dei clienti Jira afferma di aver velocizzato il rilascio dei progetti grazie a Confluence',
    'project-pages.improvement.templates.tutorial.content.spaces-and-pages': "<b>Uso di spazi e pagine</b>. Gli spazi sono parte di ogni sito Confluence e rappresentano un mezzo per organizzare le pagine in categorie. Pensa agli spazi come a cartelle o progetti diversi; le pagine sono i documenti che appartengono a tali cartelle o progetti. <a>Scopri di pi\xf9 sull'uso degli spazi</a>",
    'project-pages.improvement.templates.tutorial.content.try-it-now': 'Prova subito',
    'project-pages.improvement.templates.tutorial.description': 'Scopri come modificare una pagina.',
    'project-pages.improvement.templates.tutorial.name': 'Ti diamo il benvenuto nelle pagine del progetto.',
    'project-pages.improvement.terms-and-conditions-v2': "Selezionando &quot;Prova ora&quot;, prendi atto che sarai iscritto a Confluence e accetti le <termsLink>Condizioni d'uso di Atlassian Cloud</termsLink> e l'<privacyLink>Informativa sulla privacy</privacyLink> di Atlassian.",
    'project-pages.improvement.title': 'Pagine di progetto',
    'project-pages.improvement.transient-states.empty-state.auto-provisioned-create-page-button': 'Crea pagina',
    'project-pages.improvement.transient-states.empty-state.auto-provisioned-description': "Abbiamo aggiunto Confluence in modo che tu possa iniziare a creare e collegare tutti i documenti del tuo progetto. \xc8 gratuito per un massimo di 10 utenti.",
    'project-pages.improvement.transient-states.empty-state.auto-provisioned-learn-more-button': 'Maggiori informazioni',
    'project-pages.improvement.transient-states.empty-state.create-page-button': 'Crea la tua prima pagina',
    'project-pages.improvement.transient-states.empty-state.description': 'Crea note della riunione, requisiti di prodotto, decisioni e altri contenuti per riempire questo spazio.',
    'project-pages.improvement.transient-states.empty-state.title': "Qui non c'\xe8 altro che il potenziale",
    'project-pages.improvement.try-button': 'Prova questo modello in Confluence',
    'project-pages.improvement.try-it-now': 'Provalo subito',
    'project-pages.improvement.try-lozenge': 'prova',
    'project-pages.improvement.try-on-demand-button': 'Provalo gratis',
    'project-pages.page-deleted-flag.title': 'Pagina eliminata.',
    'project-pages.page-published-flag.title': "La tua pagina \xe8 stata pubblicata.",
    'project-pages.unknown-error.description': '{contactSupport} se il problema non si risolve con un aggiornamento.',
    'project-pages.unknown-error.heading': "Al momento non \xe8 possibile visualizzare le pagine del progetto"
};

});

parcelRegister("2vw0t", function(module, exports) {

$parcel$export(module.exports, "default", () => $9ce3022a7d5bf2e1$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Japanese
var $9ce3022a7d5bf2e1$export$2e2bcd8739ae039 = {
    'confluence.project-pages.improvement.provisioning-background.text': "\u3053\u308C\u306F 1 \u5206\u672A\u6E80\u3067\u5B8C\u4E86\u3057\u307E\u3059",
    'confluence.project-pages.improvement.provisioning-background.title': "\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8 \u30DA\u30FC\u30B8\u3092\u30BB\u30C3\u30C8\u30A2\u30C3\u30D7\u3059\u308B",
    'confluence.project-pages.improvement.provisioning-modal-carousel.controls.dismiss': "\u9589\u3058\u308B",
    'confluence.project-pages.improvement.provisioning-modal-carousel.controls.done': "\u5B8C\u4E86",
    'confluence.project-pages.improvement.provisioning-modal-carousel.controls.next': "\u6B21\u3078",
    'project-pages.activating.description': "\u63A5\u7D9A\u3055\u308C\u305F Confluence \u30B9\u30DA\u30FC\u30B9\u306F\u307E\u3060\u6E96\u5099\u304C\u3067\u304D\u3066\u3044\u307E\u305B\u3093\u3002\u518D\u8AAD\u307F\u8FBC\u307F\u3057\u3066\u3082\u89E3\u6C7A\u3057\u306A\u3044\u5834\u5408\u306F\u3001{contactSupport}\u3002",
    'project-pages.activating.heading': "Confluence \u306F\u307E\u3060\u8AAD\u307F\u8FBC\u307F\u4E2D\u3067\u3059",
    'project-pages.better-together-templates.meeting-notes.action-items-heading': "\u30A2\u30AF\u30B7\u30E7\u30F3 \u30A2\u30A4\u30C6\u30E0\u3068\u306F",
    'project-pages.better-together-templates.meeting-notes.agenda-item-label': "\u8B70\u984C\u9805\u76EE",
    'project-pages.better-together-templates.meeting-notes.create-a-jira-issue': "\u300C/Jira\u300D\u3068\u5165\u529B\u3057\u3066\u8AB2\u984C\u3092\u4F5C\u6210",
    'project-pages.better-together-templates.meeting-notes.date-label': "\u65E5\u4ED8",
    'project-pages.better-together-templates.meeting-notes.discussion-topics-heading': "\u8B70\u984C",
    'project-pages.better-together-templates.meeting-notes.list-people': "\u30E6\u30FC\u30B6\u30FC\u3092\u30EA\u30B9\u30C8\u3059\u308B\u306B\u306F",
    'project-pages.better-together-templates.meeting-notes.mention': "\u30E1\u30F3\u30B7\u30E7\u30F3",
    'project-pages.better-together-templates.meeting-notes.mention-people-to-assign-them': "\u30A2\u30AF\u30B7\u30E7\u30F3 \u30A2\u30A4\u30C6\u30E0\u3092\u30E6\u30FC\u30B6\u30FC\u306B\u5272\u308A\u5F53\u3066",
    'project-pages.better-together-templates.meeting-notes.notes-label': "\u30E1\u30E2",
    'project-pages.better-together-templates.meeting-notes.page-title': "\u30DF\u30FC\u30C6\u30A3\u30F3\u30B0\u8B70\u4E8B\u9332",
    'project-pages.better-together-templates.meeting-notes.participants-label': "\u53C2\u52A0\u8005",
    'project-pages.better-together-templates.meeting-notes.project-label': "\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8",
    'project-pages.better-together-templates.product-requirements.create-a-jira-issue': "\u300C/Jira\u300D\u3068\u5165\u529B\u3057\u3066\u8AB2\u984C\u3092\u4F5C\u6210",
    'project-pages.better-together-templates.product-requirements.design-heading': "\u30C7\u30B6\u30A4\u30F3",
    'project-pages.better-together-templates.product-requirements.embedd-different-data-views': "Jira \u30D7\u30ED\u30B8\u30A7\u30AF\u30C8\u304B\u3089\u3001\u3055\u307E\u3056\u307E\u306A\u30C7\u30FC\u30BF\u3068\u30D3\u30E5\u30FC\u3092\u57CB\u3081\u8FBC\u3080\u3053\u3068\u304C\u3067\u304D\u307E\u3059\u3002",
    'project-pages.better-together-templates.product-requirements.heading': "\u6982\u8981",
    'project-pages.better-together-templates.product-requirements.how-will-you-know-if-fixed': "\u554F\u984C\u304C\u4FEE\u6B63\u3055\u308C\u305F\u3053\u3068\u3092\u3069\u306E\u3088\u3046\u306B\u78BA\u8A8D\u3067\u304D\u307E\u3059\u304B?",
    'project-pages.better-together-templates.product-requirements.impact-heading': "\u52B9\u679C",
    'project-pages.better-together-templates.product-requirements.inScopeStatus': "\u30B9\u30B3\u30FC\u30D7\u5185",
    'project-pages.better-together-templates.product-requirements.insert-design-link': "\u30C7\u30B6\u30A4\u30F3\u3078\u306E\u30EA\u30F3\u30AF\u3092\u633F\u5165 (Figma \u306A\u3069)",
    'project-pages.better-together-templates.product-requirements.jira-issue-heading': "Jira \u8AB2\u984C",
    'project-pages.better-together-templates.product-requirements.jira-roadmap-heading': "Jira \u30ED\u30FC\u30C9\u30DE\u30C3\u30D7",
    'project-pages.better-together-templates.product-requirements.learn-how-with-smart-links': "\u30B9\u30DE\u30FC\u30C8 \u30EA\u30F3\u30AF\u306E\u4F7F\u3044\u65B9\u306E\u8A73\u7D30",
    'project-pages.better-together-templates.product-requirements.list-dashboards': "\u30C0\u30C3\u30B7\u30E5\u30DC\u30FC\u30C9\u3092\u30EA\u30B9\u30C8 (Amplitude\u3001Mode \u306A\u3069)",
    'project-pages.better-together-templates.product-requirements.list-design-considerations': "\u30C7\u30B6\u30A4\u30F3\u307E\u305F\u306F\u30D3\u30EB\u30C9\u306B\u95A2\u3059\u308B\u8003\u616E\u4E8B\u9805\u3092\u30EA\u30B9\u30C8",
    'project-pages.better-together-templates.product-requirements.list-people': "\u30E6\u30FC\u30B6\u30FC\u3092\u30EA\u30B9\u30C8\u3059\u308B\u306B\u306F",
    'project-pages.better-together-templates.product-requirements.mention': "\u30E1\u30F3\u30B7\u30E7\u30F3",
    'project-pages.better-together-templates.product-requirements.mention-people-to-assign-them': "\u30A2\u30AF\u30B7\u30E7\u30F3 \u30A2\u30A4\u30C6\u30E0\u3092\u30E6\u30FC\u30B6\u30FC\u306B\u5272\u308A\u5F53\u3066",
    'project-pages.better-together-templates.product-requirements.niceToHaveStatus': "\u3067\u304D\u308C\u3070\u5BFE\u5FDC",
    'project-pages.better-together-templates.product-requirements.outOfScopeStatus': "\u30B9\u30B3\u30FC\u30D7\u5916",
    'project-pages.better-together-templates.product-requirements.page-title': "\u88FD\u54C1\u8981\u4EF6",
    'project-pages.better-together-templates.product-requirements.pro-tip': "\u30D7\u30ED\u304B\u3089\u306E\u30D2\u30F3\u30C8:",
    'project-pages.better-together-templates.product-requirements.problem-label': "\u554F\u984C",
    'project-pages.better-together-templates.product-requirements.requirement-heading': "\u8981\u4EF6",
    'project-pages.better-together-templates.product-requirements.scope-heading': "\u30B9\u30B3\u30FC\u30D7",
    'project-pages.better-together-templates.product-requirements.success-metric': "\u6210\u529F\u306E\u30E1\u30C8\u30EA\u30C3\u30AF",
    'project-pages.better-together-templates.product-requirements.target-release-date': "\u76EE\u6A19\u30EA\u30EA\u30FC\u30B9\u65E5",
    'project-pages.better-together-templates.product-requirements.team-label': "\u30C1\u30FC\u30E0",
    'project-pages.better-together-templates.product-requirements.to-do-list-heading': "To Do \u30EA\u30B9\u30C8",
    'project-pages.better-together-templates.product-requirements.what-are-you-trying-to-fix': "\u4F55\u3092\u4FEE\u6B63\u3057\u3088\u3046\u3068\u3057\u3066\u3044\u307E\u3059\u304B?",
    'project-pages.better-together-templates.retro-notes.retro-heading': "\u3075\u308A\u304B\u3048\u308A",
    'project-pages.better-together-templates.retro.action-items-heading': "\u4ECA\u5F8C\u306E\u30A2\u30AF\u30B7\u30E7\u30F3 \u30A2\u30A4\u30C6\u30E0",
    'project-pages.better-together-templates.retro.create-a-jira-issue': "\u300C/Jira\u300D\u3068\u5165\u529B\u3057\u3066\u8AB2\u984C\u3092\u4F5C\u6210",
    'project-pages.better-together-templates.retro.date-label': "\u65E5\u4ED8",
    'project-pages.better-together-templates.retro.embed-it-here': "\u5B8C\u4E86\u3057\u305F\u3089\u3001\u3053\u3053\u306B\u57CB\u3081\u8FBC\u3080\u3053\u3068\u304C\u3067\u304D\u307E\u3059\u3002",
    'project-pages.better-together-templates.retro.list-people': "\u30E6\u30FC\u30B6\u30FC\u3092\u30EA\u30B9\u30C8\u3059\u308B\u306B\u306F",
    'project-pages.better-together-templates.retro.mention': "\u30E1\u30F3\u30B7\u30E7\u30F3",
    'project-pages.better-together-templates.retro.mention-people-to-assign-them': "\u30A2\u30AF\u30B7\u30E7\u30F3 \u30A2\u30A4\u30C6\u30E0\u3092\u30E6\u30FC\u30B6\u30FC\u306B\u5272\u308A\u5F53\u3066",
    'project-pages.better-together-templates.retro.page-title': "\u3075\u308A\u304B\u3048\u308A",
    'project-pages.better-together-templates.retro.participants-label': "\u53C2\u52A0\u8005",
    'project-pages.better-together-templates.retro.pro-tip': "\u30D7\u30ED\u304B\u3089\u306E\u30D2\u30F3\u30C8:",
    'project-pages.better-together-templates.retro.project-label': "\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8",
    'project-pages.better-together-templates.retro.this-is-a-whiteboard': "\u3053\u308C\u306F Confluence \u30DB\u30EF\u30A4\u30C8\u30DC\u30FC\u30C9\u3067\u3059\u3002",
    'project-pages.better-together-templates.retro.use-a-whiteboard': "\u3075\u308A\u304B\u3048\u308A\u306B Confluence \u30DB\u30EF\u30A4\u30C8\u30DC\u30FC\u30C9\u3092\u4F7F\u7528\u3057\u307E\u3057\u3087\u3046\u3002",
    'project-pages.better-together-templates.retro.use-it-to-vote': "\u30C1\u30FC\u30E0\u3067\u306E\u6295\u7968\u3084\u30B3\u30E9\u30DC\u30EC\u30FC\u30B7\u30E7\u30F3\u306B\u4F7F\u7528\u3067\u304D\u307E\u3059\u3002",
    'project-pages.button.connect-different-space-or-page.label': "\u30B9\u30DA\u30FC\u30B9\u307E\u305F\u306F\u30DA\u30FC\u30B8\u306E\u30A2\u30A4\u30B3\u30F3\u3092\u66F4\u65B0",
    'project-pages.button.connect-different-space-or-page.tooltip': "\u5225\u306E\u30B9\u30DA\u30FC\u30B9\u307E\u305F\u306F\u30A2\u30A4\u30C6\u30E0\u3092\u63A5\u7D9A",
    'project-pages.button.connect-space-or-page.tooltip': "Confluence \u306B\u63A5\u7D9A\u3059\u308B",
    'project-pages.button.go-to-connected-live-doc.tooltip': "Confluence \u3067\u30EA\u30A2\u30EB\u30BF\u30A4\u30E0\u6587\u66F8\u3092\u958B\u304F",
    'project-pages.button.go-to-connected-page.tooltip': "Confluence \u3067\u30DA\u30FC\u30B8\u3092\u958B\u304F",
    'project-pages.button.go-to-connected-space.tooltip': "Confluence \u3067\u30B9\u30DA\u30FC\u30B9\u3092\u958B\u304F",
    'project-pages.connect-space-dialog.connection-error': "\u63A5\u7D9A\u306B\u5931\u6557\u3057\u307E\u3057\u305F\u3002",
    'project-pages.connect-space-dialog.connection-retry': "\u518D\u8A66\u884C",
    'project-pages.connect-space-dialog.content.space-or-page-selector.description': "\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8\u306B\u63A5\u7D9A\u3059\u308B\u30B9\u30DA\u30FC\u30B9\u307E\u305F\u306F\u30A2\u30A4\u30C6\u30E0\u3092\u9078\u629E\u3057\u307E\u3059\u3002",
    'project-pages.connect-space-dialog.content.space-or-page-selector.placeholder': "Confluence \u3092\u691C\u7D22",
    'project-pages.connect-space-dialog.content.space-selector.disconnected-templates-description': "\u30A2\u30A4\u30C6\u30E0\u3092\u4F5C\u6210\u3059\u308B\u306B\u306F\u3001\u3053\u306E\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8\u3092\u30B9\u30DA\u30FC\u30B9\u306B\u63A5\u7D9A\u3059\u308B\u5FC5\u8981\u304C\u3042\u308A\u307E\u3059\u3002\u3053\u306E\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8\u306B\u63A5\u7D9A\u3059\u308B\u30B9\u30DA\u30FC\u30B9\u3092\u9078\u629E\u3057\u3066\u304F\u3060\u3055\u3044\u3002",
    'project-pages.connect-space-dialog.error-icon': "\u30A8\u30E9\u30FC: ",
    'project-pages.connect-space-dialog.footer.cancel': "\u30AD\u30E3\u30F3\u30BB\u30EB",
    'project-pages.connect-space-dialog.footer.connect-space': "\u63A5\u7D9A",
    'project-pages.connect-space-or-page-dialog.header.title': "Confluence \u306B\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8\u3092\u63A5\u7D9A",
    'project-pages.connect-space.description': "\u30B9\u30DA\u30FC\u30B9\u306F\u30D5\u30A9\u30EB\u30C0\u306E\u3088\u3046\u306A\u3082\u306E\u3067\u3059\u3002\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8\u306B\u95A2\u9023\u3059\u308B\u3042\u3089\u3086\u308B\u30B3\u30F3\u30C6\u30F3\u30C4\u306E\u4F5C\u6210\u3001\u6574\u7406\u3001\u30B3\u30E9\u30DC\u30EC\u30FC\u30B7\u30E7\u30F3\u306B\u4F7F\u7528\u3067\u304D\u307E\u3059\u3002",
    'project-pages.connect-space.not-connected.description': "\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8 \u30DA\u30FC\u30B8\u3092\u4F7F\u7528\u3059\u308B\u306B\u306F\u3001\u7BA1\u7406\u8005\u307E\u305F\u306F\u30C1\u30FC\u30E0 \u30EA\u30FC\u30C9\u306B\u3054\u4F9D\u983C\u306E\u3046\u3048\u3001Confluence \u3092\u3053\u306E\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8\u306B\u63A5\u7D9A\u3057\u3066\u304F\u3060\u3055\u3044\u3002",
    'project-pages.connect-space.not-connected.heading': "Confluence \u306B\u63A5\u7D9A\u3055\u308C\u3066\u3044\u307E\u305B\u3093\u3002",
    'project-pages.connect-success-flag.description.content': "{connectedSpaceOrPageName} \u306E\u30B3\u30F3\u30C6\u30F3\u30C4\u3068\u306E\u63A5\u7D9A\u306B\u6210\u529F\u3057\u307E\u3057\u305F\u3002",
    'project-pages.connection-error.space-or-page-not-found.button': "\u5225\u306E\u30B9\u30DA\u30FC\u30B9\u307E\u305F\u306F\u30DA\u30FC\u30B8\u306B\u63A5\u7D9A",
    'project-pages.create-space-dialog.connection-error': "\u63A5\u7D9A\u306B\u5931\u6557\u3057\u307E\u3057\u305F\u3002",
    'project-pages.create-space-dialog.connection-retry': "\u518D\u8A66\u884C",
    'project-pages.create-space-dialog.content.empty-name': "\u30B9\u30DA\u30FC\u30B9\u306B\u540D\u524D\u3092\u4ED8\u3051\u3066\u304F\u3060\u3055\u3044\u3002",
    'project-pages.create-space-dialog.content.invalid-name': "\u30B9\u30DA\u30FC\u30B9\u540D\u306B\u306F\u82F1\u6570\u5B57\u3092 1 \u5B57\u4EE5\u4E0A\u4F7F\u7528\u3059\u308B\u5FC5\u8981\u304C\u3042\u308A\u307E\u3059\u3002",
    'project-pages.create-space-dialog.content.placeholder': "\u30B9\u30DA\u30FC\u30B9\u540D\u3092\u5165\u529B",
    'project-pages.create-space-dialog.creation-error': "\u30B9\u30DA\u30FC\u30B9\u306E\u4F5C\u6210\u306B\u5931\u6557\u3057\u307E\u3057\u305F\u3002",
    'project-pages.create-space-dialog.error-icon': "\u30A8\u30E9\u30FC: ",
    'project-pages.create-space-dialog.footer.cancel': "\u30AD\u30E3\u30F3\u30BB\u30EB",
    'project-pages.create-space-dialog.footer.create-space': "\u4F5C\u6210",
    'project-pages.create-space-dialog.header.title': "\u65B0\u3057\u3044 Confluence \u30B9\u30DA\u30FC\u30B9\u3092\u4F5C\u6210",
    'project-pages.cross-join.access-revoked.templates.subtitle': "\u7BA1\u7406\u8005\u304C Confluence \u3078\u306E\u30A2\u30AF\u30BB\u30B9\u3092\u62D2\u5426\u3057\u305F\u305F\u3081\u3001\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8\u30DA\u30FC\u30B8\u306F\u4F7F\u7528\u3067\u304D\u307E\u305B\u3093\u3002\u30A2\u30AF\u30BB\u30B9\u3092\u30EA\u30AF\u30A8\u30B9\u30C8\u3059\u308B\u306B\u306F\u3001\u30B5\u30A4\u30C8\u7BA1\u7406\u8005\u306B\u304A\u554F\u3044\u5408\u308F\u305B\u304F\u3060\u3055\u3044\u3002",
    'project-pages.cross-join.access-revoked.templates.title': "\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8 \u30DA\u30FC\u30B8\u3092\u4F7F\u7528\u3059\u308B\u6A29\u9650\u304C\u3042\u308A\u307E\u305B\u3093",
    'project-pages.cross-join.avatar.view-profile': "\u30D7\u30ED\u30D5\u30A3\u30FC\u30EB\u3092\u8868\u793A",
    'project-pages.cross-join.denied-request.templates.subtitle': "\u30B5\u30A4\u30C8\u7BA1\u7406\u8005\u304C Confluence \u3078\u306E\u53C2\u52A0\u30EA\u30AF\u30A8\u30B9\u30C8\u3092\u62D2\u5426\u3057\u305F\u305F\u3081\u3001\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8 \u30DA\u30FC\u30B8\u3092\u4F7F\u7528\u3067\u304D\u307E\u305B\u3093\u3002",
    'project-pages.cross-join.denied-request.templates.title': "\u7BA1\u7406\u8005\u304C\u30A2\u30AF\u30BB\u30B9\u3092\u62D2\u5426\u3057\u307E\u3057\u305F",
    'project-pages.cross-join.direct-access.button-subtitle.experimental': "Confluence \u306B\u30A2\u30AF\u30BB\u30B9\u3067\u304D\u307E\u3059\u3002\u30B5\u30A4\u30C8\u7BA1\u7406\u8005\u306F\u3059\u3067\u306B\u3042\u306A\u305F\u3092\u627F\u8A8D\u3057\u3066\u3044\u307E\u3059\u3002",
    'project-pages.cross-join.errors.unknown-error.description': "\u518D\u8AAD\u307F\u8FBC\u307F\u3057\u3066\u3082\u89E3\u6C7A\u3057\u306A\u3044\u5834\u5408\u306F\u3001{contactSupport}\u3002",
    'project-pages.cross-join.errors.unknown-error.title': "\u73FE\u5728\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8 \u30DA\u30FC\u30B8\u3092\u8868\u793A\u3067\u304D\u307E\u305B\u3093",
    'project-pages.cross-join.inline-join-product.button': "Confluence \u306B\u30A2\u30AF\u30BB\u30B9\u3067\u304D\u307E\u3059\u3002\u30B5\u30A4\u30C8\u7BA1\u7406\u8005\u306F\u3059\u3067\u306B\u3042\u306A\u305F\u3092\u627F\u8A8D\u3057\u3066\u3044\u307E\u3059\u3002",
    'project-pages.cross-join.inline-join-product.connected.description': "\u30C9\u30AD\u30E5\u30E1\u30F3\u30C8\u3092 1 \u304B\u6240\u304B\u3089\u8868\u793A\u3001\u7DE8\u96C6\u3001\u4F5C\u6210\u3057\u307E\u3059\u3002",
    'project-pages.cross-join.inline-join-product.connected.title': "\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8 \u30DA\u30FC\u30B8\u3067\u30C1\u30FC\u30E0\u3068\u30B3\u30E9\u30DC\u30EC\u30FC\u30B7\u30E7\u30F3\u3059\u308B",
    'project-pages.cross-join.pending-request.templates.subtitle': "\u30B5\u30A4\u30C8\u7BA1\u7406\u8005\u304C Confluence \u3078\u306E\u53C2\u52A0\u30EA\u30AF\u30A8\u30B9\u30C8\u3092\u53D7\u3051\u53D6\u308A\u307E\u3057\u305F\u3002\u53C2\u52A0\u304C\u627F\u8A8D\u3055\u308C\u308B\u3068\u3001\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8 \u30DA\u30FC\u30B8\u304C\u8D77\u52D5\u3057\u3001\u78BA\u8A8D\u30E1\u30FC\u30EB\u304C\u9001\u4FE1\u3055\u308C\u307E\u3059\u3002",
    'project-pages.cross-join.pending-request.templates.subtitle.experiment': "\u627F\u8A8D\u3055\u308C\u305F\u3089\u3001\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8 \u30DA\u30FC\u30B8\u306B\u30A2\u30AF\u30BB\u30B9\u3059\u308B\u305F\u3081\u306E\u30E1\u30FC\u30EB\u304C\u5C4A\u304D\u307E\u3059\u3002",
    'project-pages.cross-join.pending-request.templates.title': "Confluence \u3078\u306E\u30A2\u30AF\u30BB\u30B9\u3092\u30EA\u30AF\u30A8\u30B9\u30C8\u3057\u307E\u3057\u305F",
    'project-pages.cross-join.pending-request.templates.title.experiment': "\u30A2\u30AF\u30BB\u30B9 \u30EA\u30AF\u30A8\u30B9\u30C8\u304C\u7BA1\u7406\u8005\u306B\u9001\u4FE1\u3055\u308C\u307E\u3057\u305F",
    'project-pages.cross-join.request-access-without-better-together.connected.description': "\u30C1\u30FC\u30E0\u3067\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8 \u30C9\u30AD\u30E5\u30E1\u30F3\u30C8\u3092\u8868\u793A\u3001\u7DE8\u96C6\u3001\u4F5C\u6210\u3057\u307E\u3059\u3002",
    'project-pages.cross-join.request-access.button': "\u30A2\u30AF\u30BB\u30B9\u3092\u30EA\u30AF\u30A8\u30B9\u30C8",
    'project-pages.cross-join.request-access.button-subtitle.experimental': "[\u30C1\u30FC\u30E0\u306B\u53C2\u52A0] \u3092\u9078\u629E\u3059\u308B\u3068\u3001Confluence \u3078\u306E\u53C2\u52A0\u3092\u7533\u8ACB\u3057\u307E\u3059\u3002\u3053\u308C\u306B\u3088\u308A\u3001\u81EA\u8EAB\u306E\u30A2\u30C8\u30E9\u30B7\u30A2\u30F3 \u30D7\u30ED\u30D5\u30A1\u30A4\u30EB\u3092\u7BA1\u7406\u8005\u3068\u5171\u6709\u3059\u308B\u3053\u3068\u306B\u540C\u610F\u3059\u308B\u3082\u306E\u3068\u3057\u307E\u3059\u3002",
    'project-pages.cross-join.request-access.button.experimental': "\u30C1\u30FC\u30E0\u306B\u53C2\u52A0",
    'project-pages.cross-join.request-access.connected.description.experimental': "\u3042\u306A\u305F\u306E\u30C1\u30FC\u30E0\u306F\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8 \u30DA\u30FC\u30B8\u3092\u4F7F\u7528\u3057\u3066\u3001Jira \u3092\u96E2\u308C\u308B\u3053\u3068\u306A\u304F\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8 \u30C9\u30AD\u30E5\u30E1\u30F3\u30C8\u3067\u306E\u30B3\u30E1\u30F3\u30C8\u4F5C\u6210\u3001\u7DE8\u96C6\u3001\u30B3\u30E9\u30DC\u30EC\u30FC\u30B7\u30E7\u30F3\u3092\u884C\u3063\u3066\u3044\u307E\u3059\u3002Confluence \u306B\u53C2\u52A0\u3057\u3066\u3001\u30C1\u30FC\u30E0\u306E\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8 \u30DA\u30FC\u30B8\u306B\u30A2\u30AF\u30BB\u30B9\u3057\u307E\u3057\u3087\u3046\u3002",
    'project-pages.cross-join.request-access.title': "\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8 \u30DA\u30FC\u30B8\u306B\u306F Confluence \u3078\u306E\u30A2\u30AF\u30BB\u30B9\u304C\u5FC5\u8981\u3067\u3059",
    'project-pages.cross-join.request-access.title.experiment': "\u30C1\u30FC\u30E0\u7528\u306B\u4FE1\u983C\u3067\u304D\u308B\u552F\u4E00\u306E\u60C5\u5831\u6E90\u3092\u4F5C\u6210\u3059\u308B",
    'project-pages.default-contextual-heading': "\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8 \u30DA\u30FC\u30B8\u306F Confluence \u306E\u6A5F\u80FD\u3092\u5229\u7528\u3057\u3066\u3044\u307E\u3059\u3002",
    'project-pages.default-contextual-message': "Confluence \u30DA\u30FC\u30B8\u3092\u4F7F\u3048\u3070\u3001\u3042\u3089\u3086\u308B\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8\u6587\u66F8\u306E\u4F5C\u6210\u3001\u5171\u6709\u3001\u30B3\u30E9\u30DC\u30EC\u30FC\u30B7\u30E7\u30F3\u3092\u4E00\u304B\u6240\u306B\u307E\u3068\u3081\u308B\u3053\u3068\u304C\u3067\u304D\u307E\u3059\u3002",
    'project-pages.default-reactivate-CTA': "Confluence \u3092\u518D\u6709\u52B9\u5316",
    'project-pages.default-trial-CTA': "Confluence \u3092\u7121\u6599\u3067 30 \u65E5\u9593\u304A\u8A66\u3057\u304F\u3060\u3055\u3044",
    'project-pages.draft-saved-flag.action': "\u30C9\u30E9\u30D5\u30C8\u3092\u958B\u304F",
    'project-pages.draft-saved-flag.description': "\u30C9\u30E9\u30D5\u30C8\u306F\u3001\u516C\u958B\u3059\u308B\u307E\u3067\u4ED6\u306E\u30E6\u30FC\u30B6\u30FC\u306B\u8868\u793A\u3055\u308C\u307E\u305B\u3093\u3002",
    'project-pages.draft-saved-flag.title': "\u30C9\u30E9\u30D5\u30C8\u304C\u4FDD\u5B58\u3055\u308C\u307E\u3057\u305F",
    'project-pages.embedded-pages.create-page-error.close-button': "\u9589\u3058\u308B",
    'project-pages.embedded-pages.create-page-error.description': "\u554F\u984C\u304C\u767A\u751F\u3057\u305F\u305F\u3081\u3001\u30DA\u30FC\u30B8\u3092\u4F5C\u6210\u3067\u304D\u307E\u305B\u3093\u3067\u3057\u305F\u3002",
    'project-pages.embedded-pages.create-page-error.title': "\u30DA\u30FC\u30B8\u3092\u4F5C\u6210\u3067\u304D\u307E\u305B\u3093\u3067\u3057\u305F\u3002",
    'project-pages.embedded-pages.create-page-error.try-again-button': "\u518D\u8A66\u884C",
    'project-pages.embedded-pages.modal.close.button.hint': "\u9589\u3058\u308B",
    'project-pages.embedded-pages.modal.title.button': "Confluence \u3067\u958B\u304F",
    'project-pages.embedded-pages.modal.title.button.hint': "\u65B0\u3057\u3044\u30BF\u30D6\u3067\u958B\u304F",
    'project-pages.errors.unknown-error.description.non-final': "\u518D\u8AAD\u307F\u8FBC\u307F\u3057\u3066\u3082\u89E3\u6C7A\u3057\u306A\u3044\u5834\u5408\u306F\u3001{contactSupport}\u3002",
    'project-pages.errors.unknown-error.title.non-final': "\u73FE\u5728\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8 \u30DA\u30FC\u30B8\u3092\u8868\u793A\u3067\u304D\u307E\u305B\u3093",
    'project-pages.generic-error.button.reload': "\u30DA\u30FC\u30B8\u3092\u66F4\u65B0",
    'project-pages.generic-error.description': "\u554F\u984C\u304C\u767A\u751F\u3057\u307E\u3057\u305F\u3002\u3057\u3070\u3089\u304F\u3057\u3066\u304B\u3089\u3082\u3046\u4E00\u5EA6\u8A66\u3057\u3066\u304F\u3060\u3055\u3044\u3002",
    'project-pages.generic-error.description.non-final': "\u554F\u984C\u304C\u767A\u751F\u3057\u307E\u3057\u305F\u3002\u3057\u3070\u3089\u304F\u3057\u3066\u304B\u3089\u3082\u3046\u4E00\u5EA6\u8A66\u3057\u3066\u304F\u3060\u3055\u3044\u3002",
    'project-pages.generic-error.heading': "\u6B63\u5E38\u306B\u6A5F\u80FD\u3057\u3066\u3044\u307E\u305B\u3093\u3002",
    'project-pages.generic-error.title.non-final': "\u6B63\u5E38\u306B\u6A5F\u80FD\u3057\u3066\u3044\u307E\u305B\u3093\u3002",
    'project-pages.generic-info-flag.description': "\u554F\u984C\u304C\u767A\u751F\u3057\u307E\u3057\u305F\u3002\u3082\u3046\u4E00\u5EA6\u304A\u8A66\u3057\u306E\u3046\u3048\u3001\u554F\u984C\u304C\u89E3\u6C7A\u3057\u306A\u3044\u5834\u5408\u306F\u30B5\u30DD\u30FC\u30C8\u306B\u304A\u554F\u3044\u5408\u308F\u305B\u304F\u3060\u3055\u3044\u3002",
    'project-pages.generic-success-flag.description.live-doc': '\u30EA\u30A2\u30EB\u30BF\u30A4\u30E0\u6587\u66F8 "{connectedSpaceOrPageName}" \u3068\u6B63\u5E38\u306B\u63A5\u7D9A\u3057\u307E\u3057\u305F\u3002',
    'project-pages.generic-success-flag.description.page': "{connectedSpaceOrPageName} \u30DA\u30FC\u30B8\u3068\u63A5\u7D9A\u3057\u307E\u3057\u305F\u3002",
    'project-pages.generic-success-flag.description.space': "{connectedSpaceOrPageName} \u30B9\u30DA\u30FC\u30B9\u3068\u63A5\u7D9A\u3057\u307E\u3057\u305F\u3002",
    'project-pages.generic-success-flag.heading.live-doc': "\u30EA\u30A2\u30EB\u30BF\u30A4\u30E0\u6587\u66F8\u304C\u63A5\u7D9A\u3055\u308C\u307E\u3057\u305F",
    'project-pages.generic-success-flag.heading.page': "\u30DA\u30FC\u30B8\u3092\u63A5\u7D9A\u3057\u307E\u3057\u305F",
    'project-pages.generic-success-flag.heading.space': "\u30B9\u30DA\u30FC\u30B9\u3092\u63A5\u7D9A\u3057\u307E\u3057\u305F",
    'project-pages.granular-pages.connect-space-dialog.content.create-space-link.link-text': "\u307E\u305F\u306F\u65B0\u3057\u3044\u30B9\u30DA\u30FC\u30B9\u3092\u4F5C\u6210",
    'project-pages.granular-pages.connect-space.button': "Confluence \u306B\u63A5\u7D9A\u3059\u308B",
    'project-pages.granular-pages.connect-space.heading': "\u3053\u306E\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8\u3092 Confluence \u30B9\u30DA\u30FC\u30B9\u307E\u305F\u306F\u30A2\u30A4\u30C6\u30E0\u306B\u63A5\u7D9A\u3057\u3066\u304F\u3060\u3055\u3044",
    'project-pages.improvement.contact-support': "\u30B5\u30DD\u30FC\u30C8\u306B\u554F\u3044\u5408\u308F\u305B",
    'project-pages.improvement.errors.access-error.description': "\u30B5\u30A4\u30C8\u7BA1\u7406\u8005\u306B\u30A2\u30AF\u30BB\u30B9\u6A29\u306B\u3064\u3044\u3066\u554F\u3044\u5408\u308F\u305B\u3066\u304F\u3060\u3055\u3044\u3002",
    'project-pages.improvement.errors.access-error.title': "\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8 \u30DA\u30FC\u30B8\u3092\u8868\u793A\u3059\u308B\u6A29\u9650\u304C\u3042\u308A\u307E\u305B\u3093\u3002",
    'project-pages.improvement.errors.page-tree-unknown-error.description': "\u63A5\u7D9A\u3055\u308C\u305F Confluence \u30B9\u30DA\u30FC\u30B9\u306E\u30DA\u30FC\u30B8\u306E\u8868\u793A\u4E2D\u306B\u30A8\u30E9\u30FC\u304C\u767A\u751F\u3057\u307E\u3057\u305F\u3002\u518D\u8AAD\u307F\u8FBC\u307F\u3057\u3066\u3082\u89E3\u6C7A\u3057\u306A\u3044\u5834\u5408\u306F\u3001{contactSupport}\u3002",
    'project-pages.improvement.errors.page-tree-unknown-error.title': "\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8 \u30DA\u30FC\u30B8\u306E\u8868\u793A\u3067\u554F\u984C\u304C\u767A\u751F\u3057\u3066\u3044\u307E\u3059",
    'project-pages.improvement.errors.space-or-page-not-found.description': "\u63A5\u7D9A\u3057\u305F Confluence \u30B9\u30DA\u30FC\u30B9\u307E\u305F\u306F\u30DA\u30FC\u30B8\u306F\u3001\u79FB\u52D5\u3001\u30A2\u30FC\u30AB\u30A4\u30D6\u3001\u307E\u305F\u306F\u524A\u9664\u3055\u308C\u3066\u3044\u307E\u3059\u3002\u518D\u63A5\u7D9A\u3057\u3066\u3082\u554F\u984C\u304C\u89E3\u6C7A\u3057\u306A\u3044\u5834\u5408\u306F\u3001<link>\u30B5\u30DD\u30FC\u30C8\u306B\u304A\u554F\u3044\u5408\u308F\u305B\u304F\u3060\u3055\u3044</link>",
    'project-pages.improvement.errors.space-or-page-not-found.title': "\u30B9\u30DA\u30FC\u30B9\u307E\u305F\u306F\u30DA\u30FC\u30B8\u304C\u898B\u3064\u304B\u308A\u307E\u305B\u3093",
    'project-pages.improvement.errors.unknown-error.description': "\u518D\u8AAD\u307F\u8FBC\u307F\u3057\u3066\u3082\u89E3\u6C7A\u3057\u306A\u3044\u5834\u5408\u306F\u3001{contactSupport}\u3002",
    'project-pages.improvement.errors.unknown-error.title': "\u73FE\u5728\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8 \u30DA\u30FC\u30B8\u3092\u8868\u793A\u3067\u304D\u307E\u305B\u3093",
    'project-pages.improvement.feature1': "Jira \u3092\u96E2\u308C\u308B\u3053\u3068\u306A\u304F\u30C9\u30AD\u30E5\u30E1\u30F3\u30C8\u306B\u30A2\u30AF\u30BB\u30B9\u3057\u3001\u4F5C\u6210\u3059\u308B",
    'project-pages.improvement.feature2': "\u30DF\u30FC\u30C6\u30A3\u30F3\u30B0\u3084\u30B9\u30D7\u30EA\u30F3\u30C8\u8A08\u753B\u306A\u3069\u306E\u30C6\u30F3\u30D7\u30EC\u30FC\u30C8",
    'project-pages.improvement.feature3': "\u30C9\u30AD\u30E5\u30E1\u30F3\u30C8\u3092 Jira \u306B\u540C\u671F\u3057\u3066\u81EA\u52D5\u66F4\u65B0\u3059\u308B",
    'project-pages.improvement.heading-info': "\u30C1\u30FC\u30E0\u306E\u77E5\u8B58\u3092\u96C6\u3081\u3001\u696D\u52D9\u306E\u9032\u3081\u65B9\u3092\u6539\u5584\u3057\u307E\u3059\u3002",
    'project-pages.improvement.heading-info-v2': "\u30C1\u30FC\u30E0\u306E\u3059\u3079\u3066\u306E\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8 \u30C9\u30AD\u30E5\u30E1\u30F3\u30C8\u3092\u307E\u3068\u3081\u308B\u5834\u6240\u3092\u4F5C\u6210\u3059\u308B",
    'project-pages.improvement.learn-more-button': "\u8A73\u7D30",
    'project-pages.improvement.powered-by': "\u4F7F\u7528\u30BD\u30EA\u30E5\u30FC\u30B7\u30E7\u30F3: ",
    'project-pages.improvement.powered-by.tooltip': "Confluence \u3092\u65B0\u3057\u3044\u30BF\u30D6\u3067\u958B\u304F",
    'project-pages.improvement.preview-teaser': "\u30C6\u30F3\u30D7\u30EC\u30FC\u30C8\u3001\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8 \u30DA\u30FC\u30B8\u306A\u3069\u306E\u30ED\u30C3\u30AF\u3092\u89E3\u9664\u3057\u307E\u3059\u3002",
    'project-pages.improvement.provisioning-info-modal.seamlessly-update-stakeholders.description': "<p>\u30B9\u30C6\u30FC\u30BF\u30B9 \u30E9\u30D9\u30EB\u3092\u81EA\u52D5\u66F4\u65B0\u3057\u3066\u3001\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8 \u30EC\u30DD\u30FC\u30C8\u3092\u6700\u65B0\u306E\u72B6\u614B\u306B\u4FDD\u3061\u307E\u3057\u3087\u3046\u3002</p><p>\u30C9\u30AD\u30E5\u30E1\u30F3\u30C8\u5185\u3067 Jira \u30C1\u30B1\u30C3\u30C8\u3092\u30EA\u30F3\u30AF\u3059\u308B\u3060\u3051\u3067\u3001\u30C1\u30B1\u30C3\u30C8\u3068\u540C\u671F\u3057\u3066\u66F4\u65B0\u3055\u308C\u308B\u30B9\u30C6\u30FC\u30BF\u30B9 \u30E9\u30D9\u30EB\u304C\u81EA\u52D5\u7684\u306B\u8868\u793A\u3055\u308C\u307E\u3059\u3002\u3053\u308C\u306B\u3088\u308A\u3001\u6642\u9593\u3092\u304B\u3051\u3066\u624B\u52D5\u30EC\u30DD\u30FC\u30C8\u3092\u4F5C\u6210\u3059\u308B\u5FC5\u8981\u304C\u306A\u304F\u306A\u308A\u307E\u3059\u3002</p>",
    'project-pages.improvement.provisioning-info-modal.seamlessly-update-stakeholders.title': "\u95A2\u4FC2\u8005\u306B\u30B7\u30FC\u30E0\u30EC\u30B9\u306B\u6700\u65B0\u60C5\u5831\u3092\u4F1D\u3048\u308B",
    'project-pages.improvement.provisioning-info-modal.unify-documentation-standards.description': "<p>\u7D44\u307F\u8FBC\u307F\u306E\u30C6\u30F3\u30D7\u30EC\u30FC\u30C8\u3092\u4F7F\u7528\u3057\u3066\u3001\u4E00\u8CAB\u6027\u306E\u3042\u308B\u30C9\u30AD\u30E5\u30E1\u30F3\u30C8\u3092\u4F5C\u6210\u3057\u307E\u3057\u3087\u3046\u3002\u30C6\u30F3\u30D7\u30EC\u30FC\u30C8\u306F\u30B7\u30F3\u30D7\u30EB\u3067\u4F7F\u3044\u3084\u3059\u304F\u3001\u30CB\u30FC\u30BA\u306B\u5408\u308F\u305B\u3066\u30AB\u30B9\u30BF\u30DE\u30A4\u30BA\u3067\u304D\u307E\u3059\u3002</p><p>\u30C6\u30F3\u30D7\u30EC\u30FC\u30C8\u306F\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8 \u30DA\u30FC\u30B8\u304B\u3089\u76F4\u63A5\u4F7F\u7528\u3067\u304D\u308B\u306E\u3067\u3001\u4F5C\u696D\u4E2D\u306E\u30DA\u30FC\u30B8\u304B\u3089\u96E2\u308C\u308B\u5FC5\u8981\u304C\u3042\u308A\u307E\u305B\u3093\u3002<a>\u3053\u3061\u3089</a>\u304B\u3089\u3059\u3079\u3066\u306E\u30C6\u30F3\u30D7\u30EC\u30FC\u30C8\u3092\u53C2\u7167\u3067\u304D\u307E\u3059\u3002</p>",
    'project-pages.improvement.provisioning-info-modal.unify-documentation-standards.title': "\u30C9\u30AD\u30E5\u30E1\u30F3\u30C8\u6A19\u6E96\u3092\u7D71\u5408\u3059\u308B",
    'project-pages.improvement.provisioning-info-modal.your-project-pages-in-jira.description': "<p>Jira \u306E [\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8 \u30DA\u30FC\u30B8] \u30BF\u30D6\u3067\u30C9\u30AD\u30E5\u30E1\u30F3\u30C8\u3092\u4F5C\u6210\u3057\u3066\u91CD\u8981\u306A\u60C5\u5831\u3092\u307E\u3068\u3081\u3001\u4FE1\u983C\u3067\u304D\u308B\u552F\u4E00\u306E\u60C5\u5831\u6E90\u3068\u3057\u3066\u904B\u7528\u3057\u307E\u3057\u3087\u3046\u3002</p><p>\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8 \u30DA\u30FC\u30B8\u306F Confluence \u3067\u52D5\u4F5C\u3059\u308B\u3053\u3068\u3092\u3054\u5B58\u3058\u3067\u3057\u305F\u304B? \u6700\u5927 10 \u30E6\u30FC\u30B6\u30FC\u307E\u3067\u7121\u6599\u3067\u3054\u5229\u7528\u306B\u306A\u308C\u307E\u3059\u3002\u305C\u3072\u7BA1\u7406\u8005\u8A2D\u5B9A\u3067\u30C1\u30FC\u30E0\u306E\u4ED6\u306E\u30E1\u30F3\u30D0\u30FC\u3092\u62DB\u5F85\u3057\u3066\u304F\u3060\u3055\u3044\u3002</p>",
    'project-pages.improvement.provisioning-info-modal.your-project-pages-in-jira.title': "\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8 \u30DA\u30FC\u30B8\u3092 Jira \u3067\u76F4\u63A5\u5229\u7528",
    'project-pages.improvement.templates-sidebar.better-together-templates-header': "Jira \u30C7\u30FC\u30BF\u3068\u7D71\u5408\u3055\u308C\u305F\u30C6\u30F3\u30D7\u30EC\u30FC\u30C8",
    'project-pages.improvement.templates.better-together-preview-teaser': "Jira \u30C7\u30FC\u30BF\u3068\u7D71\u5408\u3055\u308C\u3066\u3044\u307E\u3059",
    'project-pages.improvement.templates.blank-page.description': "\u6700\u521D\u304B\u3089\u30DA\u30FC\u30B8\u3092\u958B\u59CB\u3057\u307E\u3059\u3002",
    'project-pages.improvement.templates.blank-page.name': "\u767D\u7D19\u30DA\u30FC\u30B8",
    'project-pages.improvement.templates.decision.description': "\u91CD\u8981\u306A\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8\u6C7A\u5B9A\u4E8B\u9805\u3092\u8A18\u9332\u3057\u3001\u305D\u308C\u306B\u3064\u3044\u3066\u30C1\u30FC\u30E0\u5185\u3067\u3084\u308A\u53D6\u308A\u3067\u304D\u307E\u3059\u3002",
    'project-pages.improvement.templates.decision.name': "\u6C7A\u5B9A\u4E8B\u9805",
    'project-pages.improvement.templates.meeting-notes.description': "\u30DF\u30FC\u30C6\u30A3\u30F3\u30B0\u3092\u8A08\u753B\u3057\u3066\u8B70\u4E8B\u9332\u3084\u30A2\u30AF\u30B7\u30E7\u30F3 \u30A2\u30A4\u30C6\u30E0\u3092\u30C1\u30FC\u30E0\u3067\u5171\u6709\u3067\u304D\u307E\u3059\u3002",
    'project-pages.improvement.templates.meeting-notes.name': "\u30DF\u30FC\u30C6\u30A3\u30F3\u30B0\u8B70\u4E8B\u9332",
    'project-pages.improvement.templates.post-expand.more': "\u305D\u306E\u4ED6\u306E\u30C6\u30F3\u30D7\u30EC\u30FC\u30C8",
    'project-pages.improvement.templates.post-expand.more.tooltip': "Confluence \u306E\u3059\u3079\u3066\u306E\u30C6\u30F3\u30D7\u30EC\u30FC\u30C8\u3092\u8868\u793A",
    'project-pages.improvement.templates.post-expand.subtitle': "\u4EBA\u6C17\u306E\u30C6\u30F3\u30D7\u30EC\u30FC\u30C8",
    'project-pages.improvement.templates.post-expand.title': "\u30DA\u30FC\u30B8\u3092\u4F5C\u6210",
    'project-pages.improvement.templates.pre-expand.more': "\u4ED6\u306E\u30C6\u30F3\u30D7\u30EC\u30FC\u30C8\u3092\u78BA\u8A8D\u3059\u308B",
    'project-pages.improvement.templates.pre-expand.subtitle': "\u4F3C\u305F\u3088\u3046\u306A\u30C1\u30FC\u30E0\u306B\u4EBA\u6C17\u306E\u30C6\u30F3\u30D7\u30EC\u30FC\u30C8",
    'project-pages.improvement.templates.pre-expand.title': "\u30C6\u30F3\u30D7\u30EC\u30FC\u30C8\u3092\u30D7\u30EC\u30D3\u30E5\u30FC",
    'project-pages.improvement.templates.product-requirements.description': "\u88FD\u54C1\u3084\u6A5F\u80FD\u306E\u8981\u4EF6\u306E\u5B9A\u7FA9\u3001\u8FFD\u8DE1\u3001\u7BC4\u56F2\u8A2D\u5B9A\u3092\u884C\u3044\u307E\u3059\u3002",
    'project-pages.improvement.templates.product-requirements.name': "\u88FD\u54C1\u8981\u4EF6",
    'project-pages.improvement.templates.retrospective.description': "\u3069\u306E\u70B9\u304C\u3046\u307E\u304F\u3044\u304D\u307E\u3057\u305F\u304B?\u6539\u5584\u70B9\u306F\u4F55\u3067\u3059\u304B?\u30C1\u30FC\u30E0\u5185\u3067\u306E\u30AF\u30E9\u30A6\u30C9\u30BD\u30FC\u30B7\u30F3\u30B0\u5229\u7528\u306E\u6539\u5584\u70B9\u3092\u51FA\u3057\u5408\u3044\u307E\u3059\u3002",
    'project-pages.improvement.templates.retrospective.name': "\u3075\u308A\u304B\u3048\u308A",
    'project-pages.improvement.templates.template.disabled-tooltip': "\u307E\u305A Confluence \u30B9\u30DA\u30FC\u30B9\u3092\u63A5\u7D9A\u3057\u307E\u3059",
    'project-pages.improvement.templates.tutorial.content.confluence-templates': "<b>\u6642\u9593\u3092\u77ED\u7E2E\u3057\u3066\u3001\u624B\u52D5\u30BF\u30B9\u30AF\u3092\u524A\u6E1B\u3067\u304D\u307E\u3059</b>\u3002Confluence \u306B\u306F\u591A\u6570\u306E\u30DA\u30FC\u30B8 <a>\u30C6\u30F3\u30D7\u30EC\u30FC\u30C8</a>\u304C\u7528\u610F\u3055\u308C\u3066\u3044\u308B\u305F\u3081\u3001\u6700\u521D\u304B\u3089\u4F5C\u6210\u3059\u308B\u624B\u9593\u3092\u7701\u3051\u307E\u3059\u3002\u30C6\u30AF\u30CB\u30AB\u30EB \u30C9\u30AD\u30E5\u30E1\u30F3\u30C8\u3001\u30C8\u30E9\u30D6\u30EB\u30B7\u30E5\u30FC\u30C6\u30A3\u30F3\u30B0 \u30AC\u30A4\u30C9\u3001\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8\u8A08\u753B\u3001\u88FD\u54C1\u8981\u4EF6\u306A\u3069\u306B\u3064\u3044\u3066\u8003\u3048\u3066\u307F\u3066\u304F\u3060\u3055\u3044\u3002",
    'project-pages.improvement.templates.tutorial.content.edit-and-format': "<b>\u7DE8\u96C6\u3084\u66F8\u5F0F\u8A2D\u5B9A\u304C\u7C21\u5358\u306B\u3067\u304D\u307E\u3059</b>\u3002\u6700\u4E0A\u90E8\u306E\u7DE8\u96C6\u30E1\u30CB\u30E5\u30FC\u3092\u6A19\u6E96\u7684\u306A\u66F8\u5F0F\u8A2D\u5B9A\u306B\u4F7F\u7528\u3067\u304D\u307E\u3059\u3002\u300C<b>/</b>\u300D\u3068\u5165\u529B\u3059\u308B\u3068\u591A\u6570\u306E\u4FBF\u5229\u306A\u7D71\u5408\u6A5F\u80FD\u3092\u7C21\u5358\u306B\u633F\u5165\u3067\u304D\u307E\u3059\u3002\u300C<c>/\u30C6\u30FC\u30D6\u30EB</c>\u300D\u3068\u5165\u529B\u3059\u308B\u3068\u30C6\u30FC\u30D6\u30EB\u3092\u3001\u300C<c>/\u753B\u50CF</c>\u300D\u3068\u5165\u529B\u3059\u308B\u3068\u753B\u50CF\u3092\u633F\u5165\u3067\u304D\u307E\u3059\u3002\u307E\u305F\u300C<c>/dropbox</c>\u300D\u3067 Dropbox \u306E\u30EA\u30F3\u30AF\u3092\u3001\u300C<c>/microsoft</c>\u300D\u3067 Microsoft Office \u30C4\u30FC\u30EB\u3092\u3001\u300C<c>/trello</c>\u300D\u3067 Trello \u306E\u30DC\u30FC\u30C9\u3084\u30AB\u30FC\u30C9\u3092\u633F\u5165\u3067\u304D\u307E\u3059\u3002",
    'project-pages.improvement.templates.tutorial.content.forward-slash-prompt': "\u300C/\u300D\u306E\u5F8C\u306B\u300Ctable\u300D\u307E\u305F\u306F\u300Cimage\u300D\u3092\u5165\u529B",
    'project-pages.improvement.templates.tutorial.content.getting-started-tips': "\u958B\u59CB\u3059\u308B\u306B\u3042\u305F\u308A\u5F79\u7ACB\u3064\u30D2\u30F3\u30C8\u3092\u3044\u304F\u3064\u304B\u7528\u610F\u3057\u307E\u3057\u305F\u3002",
    'project-pages.improvement.templates.tutorial.content.handy-links': "\u4FBF\u5229\u306A\u30EA\u30F3\u30AF",
    'project-pages.improvement.templates.tutorial.content.jira-and-confluence': "Jira \u3068 Confluence \u3092\u4F75\u7528\u3059\u308B",
    'project-pages.improvement.templates.tutorial.content.jira-charts': "\u5B9F\u969B\u306E Jira \u30C7\u30FC\u30BF\u3092\u4F7F\u7528\u3057\u3066\u30DA\u30FC\u30B8\u306B\u30C1\u30E3\u30FC\u30C8\u3092\u4F5C\u6210\u3057\u307E\u3059\u3002\u300C<c>/Jira charts</c>\u300D\u3068\u5165\u529B\u3057\u307E\u3059\u3002",
    'project-pages.improvement.templates.tutorial.content.jira-links': "\u30DA\u30FC\u30B8\u4E0A\u306E\u4EFB\u610F\u306E\u5834\u6240\u306B Jira \u8AB2\u984C\u3092\u30EA\u30F3\u30AF\u3057\u307E\u3059\u3002\u30DA\u30FC\u30B8\u4E0A\u306E\u30EA\u30F3\u30AF\u306F\u3001Jira \u8AB2\u984C\u3092\u66F4\u65B0\u3059\u308B\u3068\u30EA\u30A2\u30EB\u30BF\u30A4\u30E0\u3067\u66F4\u65B0\u3055\u308C\u307E\u3059\u3002\u300C<c>/Jira</c>\u300D\u3068\u5165\u529B\u3057\u307E\u3059\u3002",
    'project-pages.improvement.templates.tutorial.content.jira-links-issue-term-refresh': "\u30DA\u30FC\u30B8\u4E0A\u306E\u4EFB\u610F\u306E\u5834\u6240\u306B Jira \u4F5C\u696D\u9805\u76EE\u3092\u30EA\u30F3\u30AF\u3057\u307E\u3059\u3002\u30DA\u30FC\u30B8\u4E0A\u306E\u30EA\u30F3\u30AF\u306F\u3001\u4F5C\u696D\u9805\u76EE\u3092\u66F4\u65B0\u3059\u308B\u3068\u30EA\u30A2\u30EB\u30BF\u30A4\u30E0\u3067\u66F4\u65B0\u3055\u308C\u307E\u3059\u3002\u300C<c>/Jira</c>\u300D\u3068\u5165\u529B\u3057\u307E\u3059\u3002",
    'project-pages.improvement.templates.tutorial.content.jira-links.non-final-issue-term-refresh': "\u30DA\u30FC\u30B8\u4E0A\u306E\u4EFB\u610F\u306E\u5834\u6240\u306B Jira \u4F5C\u696D\u9805\u76EE\u3092\u30EA\u30F3\u30AF\u3057\u307E\u3059\u3002\u30DA\u30FC\u30B8\u4E0A\u306E\u30EA\u30F3\u30AF\u306F\u3001\u4F5C\u696D\u9805\u76EE\u3092\u66F4\u65B0\u3059\u308B\u3068\u30EA\u30A2\u30EB\u30BF\u30A4\u30E0\u3067\u66F4\u65B0\u3055\u308C\u307E\u3059\u3002\u300C<c>/Jira</c>\u300D\u3068\u5165\u529B\u3057\u307E\u3059\u3002",
    'project-pages.improvement.templates.tutorial.content.jira-roadmaps': "Jira \u30D7\u30ED\u30B8\u30A7\u30AF\u30C8\u306B\u3088\u3063\u3066\u3001\u30A4\u30F3\u30BF\u30E9\u30AF\u30C6\u30A3\u30D6\u306A\u30ED\u30FC\u30C9\u30DE\u30C3\u30D7\u3084\u30BF\u30A4\u30E0\u30E9\u30A4\u30F3\u3092\u30DA\u30FC\u30B8\u306B\u57CB\u3081\u8FBC\u307F\u307E\u3059\u3002\u300C<c>/jira roadmap</c>\u300D\u3068\u5165\u529B\u3057\u307E\u3059\u3002",
    'project-pages.improvement.templates.tutorial.content.jira-timeline': "Jira \u30D7\u30ED\u30B8\u30A7\u30AF\u30C8\u306B\u3088\u3063\u3066\u3001\u30A4\u30F3\u30BF\u30E9\u30AF\u30C6\u30A3\u30D6\u306A\u30BF\u30A4\u30E0\u30E9\u30A4\u30F3\u3092\u30DA\u30FC\u30B8\u306B\u57CB\u3081\u8FBC\u307F\u307E\u3059\u3002\u300C<c>/jira \u30BF\u30A4\u30E0\u30E9\u30A4\u30F3</c>\u300D\u3068\u5165\u529B\u3057\u307E\u3059\u3002",
    'project-pages.improvement.templates.tutorial.content.shipping-speed-statistic': "Jira Software \u3092\u3054\u5229\u7528\u306E\u304A\u5BA2\u69D8\u306E\u3046\u3061 76% \u304C\u3001Confluence \u3092\u8FFD\u52A0\u3057\u3066\u304B\u3089\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8\u306E\u30EA\u30EA\u30FC\u30B9\u304C\u65E9\u304F\u306A\u3063\u305F\u3068\u8A71\u3057\u3066\u3044\u307E\u3059\u3002",
    'project-pages.improvement.templates.tutorial.content.shipping-speed-statistic.spork-rebranding': "Jira \u3092\u3054\u5229\u7528\u306E\u304A\u5BA2\u69D8\u306E\u3046\u3061 76% \u304C\u3001Confluence \u3092\u8FFD\u52A0\u3057\u3066\u304B\u3089\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8\u306E\u30EA\u30EA\u30FC\u30B9\u304C\u65E9\u304F\u306A\u3063\u305F\u3068\u8A71\u3057\u3066\u3044\u307E\u3059",
    'project-pages.improvement.templates.tutorial.content.spaces-and-pages': "<b>\u30B9\u30DA\u30FC\u30B9\u3068\u30DA\u30FC\u30B8\u3092\u4F7F\u7528\u3057\u307E\u3059</b>\u3002\u30B9\u30DA\u30FC\u30B9\u306F\u3042\u3089\u3086\u308B Confluence \u30B5\u30A4\u30C8\u306E\u4E00\u90E8\u3067\u3042\u308A\u3001\u30DA\u30FC\u30B8\u3092\u30AB\u30C6\u30B4\u30EA\u306B\u6574\u7406\u3059\u308B\u65B9\u6CD5\u3067\u3082\u3042\u308A\u307E\u3059\u3002\u30B9\u30DA\u30FC\u30B9\u3092\u5225\u3005\u306E\u30D5\u30A9\u30EB\u30C0\u30FC\u307E\u305F\u306F\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8\u3068\u8003\u3048\u308B\u3068\u3001\u30DA\u30FC\u30B8\u306F\u305D\u306E\u30D5\u30A9\u30EB\u30C0\u30FC\u3084\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8\u306B\u5C5E\u3059\u308B\u30C9\u30AD\u30E5\u30E1\u30F3\u30C8\u3067\u3059\u3002<a>\u30B9\u30DA\u30FC\u30B9\u306E\u4F7F\u7528\u65B9\u6CD5\u306B\u95A2\u3059\u308B\u8A73\u7D30\u306B\u3064\u3044\u3066\u3054\u78BA\u8A8D\u304F\u3060\u3055\u3044\u3002</a>",
    'project-pages.improvement.templates.tutorial.content.try-it-now': "\u4ECA\u3059\u3050\u8A66\u3059",
    'project-pages.improvement.templates.tutorial.description': "\u30DA\u30FC\u30B8\u306E\u7DE8\u96C6\u65B9\u6CD5\u3092\u3054\u78BA\u8A8D\u304F\u3060\u3055\u3044\u3002",
    'project-pages.improvement.templates.tutorial.name': "\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8 \u30DA\u30FC\u30B8\u306B\u3088\u3046\u3053\u305D! ",
    'project-pages.improvement.terms-and-conditions-v2': "[\u4ECA\u3059\u3050\u8A66\u3059] \u3092\u9078\u629E\u3059\u308B\u3068\u3001Confluence \u3078\u306E\u767B\u9332\u3092\u627F\u8A8D\u3057\u3001Atlassian <termsLink>Cloud \u5229\u7528\u898F\u7D04</termsLink>\u304A\u3088\u3073<privacyLink>\u30D7\u30E9\u30A4\u30D0\u30B7\u30FC \u30DD\u30EA\u30B7\u30FC</privacyLink>\u306B\u540C\u610F\u3057\u305F\u3053\u3068\u306B\u306A\u308A\u307E\u3059\u3002",
    'project-pages.improvement.title': "\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8 \u30DA\u30FC\u30B8",
    'project-pages.improvement.transient-states.empty-state.auto-provisioned-create-page-button': "\u30DA\u30FC\u30B8\u3092\u4F5C\u6210",
    'project-pages.improvement.transient-states.empty-state.auto-provisioned-description': "Confluence \u304C\u8FFD\u52A0\u3055\u308C\u305F\u306E\u3067\u3001\u3059\u3079\u3066\u306E\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8 \u30C9\u30AD\u30E5\u30E1\u30F3\u30C8\u306E\u4F5C\u6210\u3068\u30EA\u30F3\u30AF\u3092\u958B\u59CB\u3067\u304D\u307E\u3059\u3002\u6700\u5927 10 \u30E6\u30FC\u30B6\u30FC\u307E\u3067\u7121\u6599\u3067\u3059\u3002",
    'project-pages.improvement.transient-states.empty-state.auto-provisioned-learn-more-button': "\u8A73\u7D30",
    'project-pages.improvement.transient-states.empty-state.create-page-button': "\u6700\u521D\u306E\u30DA\u30FC\u30B8\u3092\u4F5C\u6210",
    'project-pages.improvement.transient-states.empty-state.description': "\u30DF\u30FC\u30C6\u30A3\u30F3\u30B0\u8B70\u4E8B\u9332\u3001\u88FD\u54C1\u8981\u4EF6\u3001\u6C7A\u5B9A\u4E8B\u9805\u3084\u305D\u306E\u4ED6\u306E\u30B3\u30F3\u30C6\u30F3\u30C4\u3092\u4F5C\u6210\u3057\u3066\u3001\u3053\u306E\u30B9\u30DA\u30FC\u30B9\u3092\u57CB\u3081\u307E\u3057\u3087\u3046\u3002",
    'project-pages.improvement.transient-states.empty-state.title': "\u3053\u3053\u306B\u306F\u307E\u3060\u3001\u30DA\u30FC\u30B8\u304C\u3042\u308A\u307E\u305B\u3093\u3002",
    'project-pages.improvement.try-button': "Confluence \u3067\u3053\u306E\u30C6\u30F3\u30D7\u30EC\u30FC\u30C8\u3092\u8A66\u3059",
    'project-pages.improvement.try-it-now': "\u4ECA\u3059\u3050\u8A66\u3059",
    'project-pages.improvement.try-lozenge': "\u8A66\u3059",
    'project-pages.improvement.try-on-demand-button': "\u7121\u6599\u30C8\u30E9\u30A4\u30A2\u30EB",
    'project-pages.page-deleted-flag.title': "\u30DA\u30FC\u30B8\u304C\u524A\u9664\u3055\u308C\u307E\u3057\u305F\u3002",
    'project-pages.page-published-flag.title': "\u30DA\u30FC\u30B8\u304C\u516C\u958B\u3055\u308C\u307E\u3057\u305F\u3002",
    'project-pages.unknown-error.description': "\u518D\u8AAD\u307F\u8FBC\u307F\u3057\u3066\u3082\u89E3\u6C7A\u3057\u306A\u3044\u5834\u5408\u306F\u3001{contactSupport}\u3002",
    'project-pages.unknown-error.heading': "\u73FE\u5728\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8 \u30DA\u30FC\u30B8\u3092\u8868\u793A\u3067\u304D\u307E\u305B\u3093"
};

});

parcelRegister("58E51", function(module, exports) {

$parcel$export(module.exports, "default", () => $db17fd52ed8f36c4$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Korean
var $db17fd52ed8f36c4$export$2e2bcd8739ae039 = {
    'confluence.project-pages.improvement.provisioning-background.text': "\uC774 \uC791\uC5C5\uC740 1\uBD84 \uC774\uB0B4\uC5D0 \uC644\uB8CC\uB429\uB2C8\uB2E4",
    'confluence.project-pages.improvement.provisioning-background.title': "\uD504\uB85C\uC81D\uD2B8 \uD398\uC774\uC9C0 \uC124\uC815 \uC911",
    'confluence.project-pages.improvement.provisioning-modal-carousel.controls.dismiss': "\uD574\uC81C",
    'confluence.project-pages.improvement.provisioning-modal-carousel.controls.done': "\uC644\uB8CC",
    'confluence.project-pages.improvement.provisioning-modal-carousel.controls.next': "\uB2E4\uC74C",
    'project-pages.activating.description': "\uC5F0\uACB0\uB41C Confluence \uC2A4\uD398\uC774\uC2A4\uAC00 \uC544\uC9C1 \uC900\uBE44\uB418\uC9C0 \uC54A\uC558\uC2B5\uB2C8\uB2E4. \uC0C8\uB85C \uACE0\uCCD0\uB3C4 \uBB38\uC81C\uAC00 \uD574\uACB0\uB418\uC9C0 \uC54A\uC73C\uBA74 {contactSupport}.",
    'project-pages.activating.heading': "Confluence\uAC00 \uC544\uC9C1 \uB85C\uB4DC \uC911\uC785\uB2C8\uB2E4",
    'project-pages.better-together-templates.meeting-notes.action-items-heading': "\uC791\uC5C5 \uD56D\uBAA9\uC740 \uBB34\uC5C7\uC785\uB2C8\uAE4C?",
    'project-pages.better-together-templates.meeting-notes.agenda-item-label': "\uC5B4\uC820\uB354 \uD56D\uBAA9",
    'project-pages.better-together-templates.meeting-notes.create-a-jira-issue': "/Jira\uB97C \uC785\uB825\uD558\uC5EC \uC774\uC288 \uB9CC\uB4E4\uAE30",
    'project-pages.better-together-templates.meeting-notes.date-label': "\uB0A0\uC9DC",
    'project-pages.better-together-templates.meeting-notes.discussion-topics-heading': "\uB17C\uC758 \uC8FC\uC81C",
    'project-pages.better-together-templates.meeting-notes.list-people': "\uB2E4\uC74C\uC73C\uB85C \uC0AC\uC6A9\uC790\uB97C \uBAA9\uB85D\uC5D0 \uCD94\uAC00:",
    'project-pages.better-together-templates.meeting-notes.mention': "\uBA58\uC158",
    'project-pages.better-together-templates.meeting-notes.mention-people-to-assign-them': "\uD558\uC5EC \uC0AC\uC6A9\uC790\uB97C \uC791\uC5C5 \uD56D\uBAA9\uC5D0 \uD560\uB2F9",
    'project-pages.better-together-templates.meeting-notes.notes-label': "\uBA54\uBAA8",
    'project-pages.better-together-templates.meeting-notes.page-title': "\uBBF8\uD305 \uBA54\uBAA8",
    'project-pages.better-together-templates.meeting-notes.participants-label': "\uCC38\uC5EC\uC790",
    'project-pages.better-together-templates.meeting-notes.project-label': "\uD504\uB85C\uC81D\uD2B8",
    'project-pages.better-together-templates.product-requirements.create-a-jira-issue': "/Jira\uB97C \uC785\uB825\uD558\uC5EC \uC774\uC288 \uB9CC\uB4E4\uAE30",
    'project-pages.better-together-templates.product-requirements.design-heading': "\uB514\uC790\uC778",
    'project-pages.better-together-templates.product-requirements.embedd-different-data-views': "Jira \uD504\uB85C\uC81D\uD2B8\uC758 \uB2E4\uC591\uD55C \uB370\uC774\uD130 \uBC0F \uBCF4\uAE30\uB97C \uD3EC\uD568\uD558\uC138\uC694.",
    'project-pages.better-together-templates.product-requirements.heading': "\uAC1C\uC694",
    'project-pages.better-together-templates.product-requirements.how-will-you-know-if-fixed': "\uBB38\uC81C\uB97C \uD574\uACB0\uD588\uB294\uC9C0 \uC5B4\uB5BB\uAC8C \uC54C \uC218 \uC788\uC2B5\uB2C8\uAE4C?",
    'project-pages.better-together-templates.product-requirements.impact-heading': "\uC601\uD5A5",
    'project-pages.better-together-templates.product-requirements.inScopeStatus': "\uBC94\uC704 \uB0B4",
    'project-pages.better-together-templates.product-requirements.insert-design-link': "\uB514\uC790\uC778\uC5D0 \uB9C1\uD06C \uC0BD\uC785(Figma \uB4F1)",
    'project-pages.better-together-templates.product-requirements.jira-issue-heading': "Jira \uC774\uC288",
    'project-pages.better-together-templates.product-requirements.jira-roadmap-heading': "Jira \uB85C\uB4DC\uB9F5",
    'project-pages.better-together-templates.product-requirements.learn-how-with-smart-links': "\uC2A4\uB9C8\uD2B8 \uB9C1\uD06C\uB85C \uC0AC\uC6A9 \uBC29\uBC95 \uC54C\uC544\uBCF4\uAE30",
    'project-pages.better-together-templates.product-requirements.list-dashboards': "\uB300\uC2DC\uBCF4\uB4DC\uB97C \uBAA9\uB85D\uC5D0 \uCD94\uAC00(Amplitude, Mode \uB4F1)",
    'project-pages.better-together-templates.product-requirements.list-design-considerations': "\uB514\uC790\uC778 \uB610\uB294 \uBE4C\uB4DC \uACE0\uB824 \uC0AC\uD56D\uC744 \uBAA9\uB85D\uC5D0 \uCD94\uAC00",
    'project-pages.better-together-templates.product-requirements.list-people': "\uB2E4\uC74C\uC73C\uB85C \uC0AC\uC6A9\uC790\uB97C \uBAA9\uB85D\uC5D0 \uCD94\uAC00:",
    'project-pages.better-together-templates.product-requirements.mention': "\uBA58\uC158",
    'project-pages.better-together-templates.product-requirements.mention-people-to-assign-them': "\uD558\uC5EC \uC0AC\uC6A9\uC790\uB97C \uC791\uC5C5 \uD56D\uBAA9\uC5D0 \uD560\uB2F9",
    'project-pages.better-together-templates.product-requirements.niceToHaveStatus': "\uAD8C\uC7A5 \uC0AC\uD56D",
    'project-pages.better-together-templates.product-requirements.outOfScopeStatus': "\uBC94\uC704 \uC678",
    'project-pages.better-together-templates.product-requirements.page-title': "\uC81C\uD488 \uC694\uAD6C \uC0AC\uD56D",
    'project-pages.better-together-templates.product-requirements.pro-tip': "\uC804\uBB38\uAC00 \uD301:",
    'project-pages.better-together-templates.product-requirements.problem-label': "\uBB38\uC81C",
    'project-pages.better-together-templates.product-requirements.requirement-heading': "\uC694\uAD6C \uC0AC\uD56D",
    'project-pages.better-together-templates.product-requirements.scope-heading': "\uBC94\uC704",
    'project-pages.better-together-templates.product-requirements.success-metric': "\uC131\uACF5 \uBA54\uD2B8\uB9AD",
    'project-pages.better-together-templates.product-requirements.target-release-date': "\uBAA9\uD45C \uB9B4\uB9AC\uC2A4 \uB0A0\uC9DC",
    'project-pages.better-together-templates.product-requirements.team-label': "\uD300",
    'project-pages.better-together-templates.product-requirements.to-do-list-heading': "\uD560 \uC77C \uBAA9\uB85D",
    'project-pages.better-together-templates.product-requirements.what-are-you-trying-to-fix': "\uD574\uACB0\uD558\uB824\uB294 \uBB38\uC81C\uAC00 \uBB34\uC5C7\uC785\uB2C8\uAE4C?",
    'project-pages.better-together-templates.retro-notes.retro-heading': "\uD68C\uACE0",
    'project-pages.better-together-templates.retro.action-items-heading': "\uC791\uC5C5 \uD56D\uBAA9\uC740 \uBB34\uC5C7\uC785\uB2C8\uAE4C?",
    'project-pages.better-together-templates.retro.create-a-jira-issue': "/Jira\uB97C \uC785\uB825\uD558\uC5EC \uC774\uC288 \uB9CC\uB4E4\uAE30",
    'project-pages.better-together-templates.retro.date-label': "\uB0A0\uC9DC",
    'project-pages.better-together-templates.retro.embed-it-here': "\uBAA8\uB450 \uB9C8\uCCE4\uC73C\uBA74 \uC5EC\uAE30\uC5D0 \uD3EC\uD568\uD560 \uC218 \uC788\uC2B5\uB2C8\uB2E4.",
    'project-pages.better-together-templates.retro.list-people': "\uB2E4\uC74C\uC73C\uB85C \uC0AC\uC6A9\uC790\uB97C \uBAA9\uB85D\uC5D0 \uCD94\uAC00:",
    'project-pages.better-together-templates.retro.mention': "\uBA58\uC158",
    'project-pages.better-together-templates.retro.mention-people-to-assign-them': "\uD558\uC5EC \uC0AC\uC6A9\uC790\uB97C \uC791\uC5C5 \uD56D\uBAA9\uC5D0 \uD560\uB2F9",
    'project-pages.better-together-templates.retro.page-title': "\uD68C\uACE0",
    'project-pages.better-together-templates.retro.participants-label': "\uCC38\uC5EC\uC790",
    'project-pages.better-together-templates.retro.pro-tip': "\uC804\uBB38\uAC00 \uD301:",
    'project-pages.better-together-templates.retro.project-label': "\uD504\uB85C\uC81D\uD2B8",
    'project-pages.better-together-templates.retro.this-is-a-whiteboard': "Confluence \uD654\uC774\uD2B8\uBCF4\uB4DC\uC785\uB2C8\uB2E4.",
    'project-pages.better-together-templates.retro.use-a-whiteboard': "\uD68C\uACE0\uC5D0 Confluence \uD654\uC774\uD2B8\uBCF4\uB4DC\uB97C \uC0AC\uC6A9\uD558\uC138\uC694.",
    'project-pages.better-together-templates.retro.use-it-to-vote': "\uD22C\uD45C\uD558\uACE0 \uD300\uACFC \uACF5\uB3D9 \uC791\uC5C5\uD558\uB294 \uB370 \uC0AC\uC6A9\uD558\uC138\uC694.",
    'project-pages.button.connect-different-space-or-page.label': "\uC2A4\uD398\uC774\uC2A4 \uB610\uB294 \uD398\uC774\uC9C0 \uC5C5\uB370\uC774\uD2B8 \uC544\uC774\uCF58",
    'project-pages.button.connect-different-space-or-page.tooltip': "\uB2E4\uB978 \uC2A4\uD398\uC774\uC2A4 \uB610\uB294 \uD56D\uBAA9 \uC5F0\uACB0",
    'project-pages.button.connect-space-or-page.tooltip': "Confluence\uC5D0 \uC5F0\uACB0",
    'project-pages.button.go-to-connected-live-doc.tooltip': "Confluence\uC5D0\uC11C \uB77C\uC774\uBE0C \uBB38\uC11C \uC5F4\uAE30",
    'project-pages.button.go-to-connected-page.tooltip': "Confluence\uC5D0\uC11C \uD398\uC774\uC9C0 \uC5F4\uAE30",
    'project-pages.button.go-to-connected-space.tooltip': "Confluence\uC5D0\uC11C \uC2A4\uD398\uC774\uC2A4 \uC5F4\uAE30",
    'project-pages.connect-space-dialog.connection-error': "\uC5F0\uACB0\uC5D0 \uC2E4\uD328\uD588\uC2B5\uB2C8\uB2E4.",
    'project-pages.connect-space-dialog.connection-retry': "\uB2E4\uC2DC \uC2DC\uB3C4",
    'project-pages.connect-space-dialog.content.space-or-page-selector.description': "\uD504\uB85C\uC81D\uD2B8\uC5D0 \uC5F0\uACB0\uD560 \uC2A4\uD398\uC774\uC2A4 \uB610\uB294 \uD56D\uBAA9\uC744 \uC120\uD0DD\uD569\uB2C8\uB2E4.",
    'project-pages.connect-space-dialog.content.space-or-page-selector.placeholder': "Confluence \uAC80\uC0C9",
    'project-pages.connect-space-dialog.content.space-selector.disconnected-templates-description': "\uD56D\uBAA9\uC744 \uB9CC\uB4E4\uB824\uBA74 \uBA3C\uC800 \uC774 \uD504\uB85C\uC81D\uD2B8\uB97C \uC2A4\uD398\uC774\uC2A4\uC5D0 \uC5F0\uACB0\uD574\uC57C \uD569\uB2C8\uB2E4. \uC774 \uD504\uB85C\uC81D\uD2B8\uC5D0 \uC5F0\uACB0\uD560 \uC2A4\uD398\uC774\uC2A4\uB97C \uC120\uD0DD\uD558\uC138\uC694.",
    'project-pages.connect-space-dialog.error-icon': "\uC624\uB958:",
    'project-pages.connect-space-dialog.footer.cancel': "\uCDE8\uC18C",
    'project-pages.connect-space-dialog.footer.connect-space': "\uC5F0\uACB0",
    'project-pages.connect-space-or-page-dialog.header.title': "Confluence\uC5D0 \uD504\uB85C\uC81D\uD2B8 \uC5F0\uACB0",
    'project-pages.connect-space.description': "\uC2A4\uD398\uC774\uC2A4\uB294 \uD3F4\uB354\uCC98\uB7FC \uD504\uB85C\uC81D\uD2B8\uC640 \uAD00\uB828\uB41C \uBAA8\uB4E0 \uB0B4\uC6A9\uC744 \uB9CC\uB4E4\uACE0 \uC815\uB9AC\uD558\uACE0 \uACF5\uB3D9 \uC791\uC5C5\uD558\uB294 \uB370 \uC0AC\uC6A9\uD560 \uC218 \uC788\uC2B5\uB2C8\uB2E4.",
    'project-pages.connect-space.not-connected.description': "\uD504\uB85C\uC81D\uD2B8 \uD398\uC774\uC9C0\uB97C \uC0AC\uC6A9\uD558\uB824\uBA74 \uAD00\uB9AC\uC790\uB098 \uD300 \uB9AC\uB354\uC5D0\uAC8C \uBB38\uC758\uD558\uC5EC Confluence\uB97C \uC774 \uD504\uB85C\uC81D\uD2B8\uC5D0 \uC5F0\uACB0\uD558\uC138\uC694.",
    'project-pages.connect-space.not-connected.heading': "Confluence\uC5D0 \uC5F0\uACB0\uB418\uC9C0 \uC54A\uC74C",
    'project-pages.connect-success-flag.description.content': "{connectedSpaceOrPageName}\uAC1C\uC758 \uCF58\uD150\uCE20\uC5D0 \uC5F0\uACB0\uD588\uC2B5\uB2C8\uB2E4.",
    'project-pages.connection-error.space-or-page-not-found.button': "\uB2E4\uB978 \uC2A4\uD398\uC774\uC2A4 \uB610\uB294 \uD398\uC774\uC9C0\uC5D0 \uC5F0\uACB0",
    'project-pages.create-space-dialog.connection-error': "\uC5F0\uACB0\uC5D0 \uC2E4\uD328\uD588\uC2B5\uB2C8\uB2E4.",
    'project-pages.create-space-dialog.connection-retry': "\uB2E4\uC2DC \uC2DC\uB3C4",
    'project-pages.create-space-dialog.content.empty-name': "\uC2A4\uD398\uC774\uC2A4\uC758 \uC774\uB984\uC744 \uC9C0\uC815\uD558\uC138\uC694.",
    'project-pages.create-space-dialog.content.invalid-name': "\uC2A4\uD398\uC774\uC2A4 \uC774\uB984\uC5D0\uB294 \uD558\uB098 \uC774\uC0C1\uC758 \uBB38\uC790 \uB610\uB294 \uC22B\uC790\uAC00 \uD544\uC694\uD569\uB2C8\uB2E4.",
    'project-pages.create-space-dialog.content.placeholder': "\uC2A4\uD398\uC774\uC2A4 \uC774\uB984 \uC785\uB825",
    'project-pages.create-space-dialog.creation-error': "\uC2A4\uD398\uC774\uC2A4\uB97C \uB9CC\uB4E4\uC9C0 \uBABB\uD588\uC2B5\uB2C8\uB2E4.",
    'project-pages.create-space-dialog.error-icon': "\uC624\uB958:",
    'project-pages.create-space-dialog.footer.cancel': "\uCDE8\uC18C",
    'project-pages.create-space-dialog.footer.create-space': "\uB9CC\uB4E4\uAE30",
    'project-pages.create-space-dialog.header.title': "\uC0C8 Confluence \uC2A4\uD398\uC774\uC2A4 \uB9CC\uB4E4\uAE30",
    'project-pages.cross-join.access-revoked.templates.subtitle': "\uAD00\uB9AC\uC790\uAC00 Confluence\uC5D0 \uB300\uD55C \uC561\uC138\uC2A4 \uBD80\uC5EC\uB97C \uAC70\uBD80\uD588\uAE30 \uB54C\uBB38\uC5D0 \uD504\uB85C\uC81D\uD2B8 \uD398\uC774\uC9C0\uB97C \uC0AC\uC6A9\uD560 \uC218 \uC5C6\uC2B5\uB2C8\uB2E4. \uC561\uC138\uC2A4\uB97C \uC694\uCCAD\uD558\uB824\uBA74 \uC0AC\uC774\uD2B8 \uAD00\uB9AC\uC790\uC5D0\uAC8C \uBB38\uC758\uD558\uC138\uC694.",
    'project-pages.cross-join.access-revoked.templates.title': "\uD504\uB85C\uC81D\uD2B8 \uD398\uC774\uC9C0\uB97C \uC0AC\uC6A9\uD560 \uAD8C\uD55C\uC774 \uC5C6\uC2B5\uB2C8\uB2E4",
    'project-pages.cross-join.avatar.view-profile': "\uD504\uB85C\uD544 \uBCF4\uAE30",
    'project-pages.cross-join.denied-request.templates.subtitle': "\uC0AC\uC774\uD2B8 \uAD00\uB9AC\uC790\uAC00 Confluence \uCC38\uC5EC\uC5D0 \uB300\uD55C \uC694\uCCAD\uC744 \uAC70\uBD80\uD588\uAE30 \uB54C\uBB38\uC5D0 \uD504\uB85C\uC81D\uD2B8 \uD398\uC774\uC9C0\uB97C \uC0AC\uC6A9\uD560 \uC218 \uC5C6\uC2B5\uB2C8\uB2E4.",
    'project-pages.cross-join.denied-request.templates.title': "\uAD00\uB9AC\uC790\uAC00 \uC561\uC138\uC2A4 \uC694\uCCAD\uC744 \uAC70\uBD80\uD588\uC2B5\uB2C8\uB2E4",
    'project-pages.cross-join.direct-access.button-subtitle.experimental': "Confluence\uC5D0 \uC561\uC138\uC2A4\uD560 \uC218 \uC788\uC2B5\uB2C8\uB2E4. \uC0AC\uC774\uD2B8 \uAD00\uB9AC\uC790\uAC00 \uC774\uBBF8 \uC0AC\uC6A9\uC790\uB97C \uC2B9\uC778\uD588\uC2B5\uB2C8\uB2E4.",
    'project-pages.cross-join.errors.unknown-error.description': "\uC0C8\uB85C \uACE0\uCCD0\uB3C4 \uBB38\uC81C\uAC00 \uD574\uACB0\uB418\uC9C0 \uC54A\uC73C\uBA74 {contactSupport}.",
    'project-pages.cross-join.errors.unknown-error.title': "\uC9C0\uAE08\uC740 \uD504\uB85C\uC81D\uD2B8 \uD398\uC774\uC9C0\uB97C \uD45C\uC2DC\uD560 \uC218 \uC5C6\uC2B5\uB2C8\uB2E4",
    'project-pages.cross-join.inline-join-product.button': "Confluence\uC5D0 \uB300\uD55C \uC561\uC138\uC2A4 \uAD8C\uD55C\uC744 \uC5BB\uAC8C \uB429\uB2C8\uB2E4. \uC0AC\uC774\uD2B8 \uAD00\uB9AC\uC790\uAC00 \uC774\uBBF8 \uC0AC\uC6A9\uC790\uB97C \uC2B9\uC778\uD588\uC2B5\uB2C8\uB2E4.",
    'project-pages.cross-join.inline-join-product.connected.description': "\uD55C\uACF3\uC5D0\uC11C \uC124\uBA85\uC11C\uB97C \uBCF4\uACE0, \uD3B8\uC9D1\uD558\uACE0, \uB9CC\uB4DC\uC138\uC694",
    'project-pages.cross-join.inline-join-product.connected.title': "\uD504\uB85C\uC81D\uD2B8 \uD398\uC774\uC9C0\uC5D0\uC11C \uD300\uACFC \uACF5\uB3D9 \uC791\uC5C5\uD558\uC138\uC694",
    'project-pages.cross-join.pending-request.templates.subtitle': "\uC0AC\uC774\uD2B8 \uAD00\uB9AC\uC790\uAC00 Confluence \uCC38\uC5EC \uC694\uCCAD\uC744 \uBC1B\uC558\uC2B5\uB2C8\uB2E4. \uCC38\uC5EC\uAC00 \uC2B9\uC778\uB41C \uACBD\uC6B0, \uD504\uB85C\uC81D\uD2B8 \uD398\uC774\uC9C0 \uC0AC\uC6A9\uC774 \uC2DC\uC791\uB418\uBA70 \uD655\uC778 \uC774\uBA54\uC77C\uC744 \uBCF4\uB0B4\uB4DC\uB9BD\uB2C8\uB2E4.",
    'project-pages.cross-join.pending-request.templates.subtitle.experiment': "\uC2B9\uC778\uB418\uBA74 \uD504\uB85C\uC81D\uD2B8 \uD398\uC774\uC9C0\uC5D0 \uC561\uC138\uC2A4\uD560 \uC218 \uC788\uB294 \uC774\uBA54\uC77C\uC744 \uBC1B\uAC8C \uB429\uB2C8\uB2E4.",
    'project-pages.cross-join.pending-request.templates.title': "Confleunce\uC5D0 \uB300\uD55C \uC561\uC138\uC2A4\uB97C \uC694\uCCAD\uD588\uC2B5\uB2C8\uB2E4",
    'project-pages.cross-join.pending-request.templates.title.experiment': "\uAD00\uB9AC\uC790\uC5D0\uAC8C \uC561\uC138\uC2A4 \uC694\uCCAD\uC744 \uBCF4\uB0C4",
    'project-pages.cross-join.request-access-without-better-together.connected.description': "\uD300\uACFC \uD568\uAED8 \uD504\uB85C\uC81D\uD2B8 \uC124\uBA85\uC11C\uB97C \uBCF4\uACE0, \uD3B8\uC9D1\uD558\uACE0, \uB9CC\uB4DC\uC138\uC694",
    'project-pages.cross-join.request-access.button': "\uC561\uC138\uC2A4 \uC694\uCCAD",
    'project-pages.cross-join.request-access.button-subtitle.experimental': "'\uD300\uC5D0 \uCC38\uAC00'\uB97C \uC120\uD0DD\uD558\uBA74 Confluence \uCC38\uAC00\uB97C \uC694\uCCAD\uD558\uACE0 Atlassian \uD504\uB85C\uD544\uC744 \uAD00\uB9AC\uC790\uC640 \uACF5\uC720\uD558\uB294 \uB370 \uB3D9\uC758\uD558\uAC8C \uB429\uB2C8\uB2E4.",
    'project-pages.cross-join.request-access.button.experimental': "\uD300\uC5D0 \uCC38\uAC00",
    'project-pages.cross-join.request-access.connected.description.experimental': "\uD300\uC774 \uD504\uB85C\uC81D\uD2B8 \uD398\uC774\uC9C0\uB97C \uC0AC\uC6A9\uD558\uC5EC Jira\uB97C \uB098\uAC00\uC9C0 \uC54A\uACE0\uB3C4 \uD504\uB85C\uC81D\uD2B8 \uC124\uBA85\uC11C\uC5D0 \uB313\uAE00\uC744 \uCD94\uAC00\uD558\uACE0 \uD504\uB85C\uC81D\uD2B8 \uC124\uBA85\uC11C\uB97C \uD3B8\uC9D1\uD558\uACE0 \uACF5\uB3D9 \uC791\uC5C5\uD558\uACE0 \uC788\uC2B5\uB2C8\uB2E4. Confluence\uC5D0 \uCC38\uAC00\uD558\uC5EC \uD300\uC758 \uD504\uB85C\uC81D\uD2B8 \uD398\uC774\uC9C0\uC5D0 \uC561\uC138\uC2A4\uD558\uC138\uC694.",
    'project-pages.cross-join.request-access.title': "\uD504\uB85C\uC81D\uD2B8 \uD398\uC774\uC9C0\uC5D0 Confluence \uC561\uC138\uC2A4 \uAD8C\uD55C \uD544\uC694",
    'project-pages.cross-join.request-access.title.experiment': "\uD300\uC744 \uC704\uD55C \uB2E8\uC77C \uC815\uBCF4 \uCD9C\uCC98 \uB9CC\uB4E4\uAE30",
    'project-pages.default-contextual-heading': "\uD504\uB85C\uC81D\uD2B8 \uD398\uC774\uC9C0\uB294 Confluence\uC5D0\uC11C \uC81C\uACF5",
    'project-pages.default-contextual-message': "Confluence \uD398\uC774\uC9C0\uB85C \uBAA8\uB4E0 \uD504\uB85C\uC81D\uD2B8 \uBB38\uC11C\uB97C \uD55C\uACF3\uC5D0\uC11C \uB9CC\uB4E4\uACE0 \uACF5\uC720\uD558\uACE0 \uACF5\uB3D9 \uC791\uC5C5\uD558\uC138\uC694.",
    'project-pages.default-reactivate-CTA': "Confluence \uB2E4\uC2DC \uD65C\uC131\uD654",
    'project-pages.default-trial-CTA': "Confluence 30\uC77C \uD3C9\uAC00\uD310\uC744 \uC0AC\uC6A9\uD574\uBCF4\uC138\uC694.",
    'project-pages.draft-saved-flag.action': "\uCD08\uC548 \uC5F4\uAE30",
    'project-pages.draft-saved-flag.description': "\uCD08\uC548\uC740 \uAC8C\uC2DC\uD558\uAE30 \uC804\uAE4C\uC9C0 \uC790\uC2E0\uB9CC \uBCFC \uC218 \uC788\uC2B5\uB2C8\uB2E4.",
    'project-pages.draft-saved-flag.title': "\uCD08\uC548 \uC800\uC7A5\uB428",
    'project-pages.embedded-pages.create-page-error.close-button': "\uB2EB\uAE30",
    'project-pages.embedded-pages.create-page-error.description': "\uBB38\uC81C\uAC00 \uBC1C\uC0DD\uD558\uC5EC \uD398\uC774\uC9C0\uB97C \uB9CC\uB4E4 \uC218 \uC5C6\uC2B5\uB2C8\uB2E4.",
    'project-pages.embedded-pages.create-page-error.title': "\uD398\uC774\uC9C0\uB97C \uB9CC\uB4E4 \uC218 \uC5C6\uC2B5\uB2C8\uB2E4",
    'project-pages.embedded-pages.create-page-error.try-again-button': "\uB2E4\uC2DC \uC2DC\uB3C4",
    'project-pages.embedded-pages.modal.close.button.hint': "\uB2EB\uAE30",
    'project-pages.embedded-pages.modal.title.button': "Confluence\uC5D0\uC11C \uC5F4\uAE30",
    'project-pages.embedded-pages.modal.title.button.hint': "\uC0C8 \uD0ED\uC5D0\uC11C \uC5F4\uAE30",
    'project-pages.errors.unknown-error.description.non-final': "\uC0C8\uB85C \uACE0\uCCD0\uB3C4 \uBB38\uC81C\uAC00 \uD574\uACB0\uB418\uC9C0 \uC54A\uC73C\uBA74 {contactSupport}.",
    'project-pages.errors.unknown-error.title.non-final': "\uC9C0\uAE08\uC740 \uD504\uB85C\uC81D\uD2B8 \uD398\uC774\uC9C0\uB97C \uD45C\uC2DC\uD560 \uC218 \uC5C6\uC2B5\uB2C8\uB2E4",
    'project-pages.generic-error.button.reload': "\uD398\uC774\uC9C0 \uB2E4\uC2DC \uB85C\uB4DC",
    'project-pages.generic-error.description': "\uBB38\uC81C\uAC00 \uBC1C\uC0DD\uD588\uC2B5\uB2C8\uB2E4. \uB098\uC911\uC5D0 \uB2E4\uC2DC \uC2DC\uB3C4\uD558\uC138\uC694.",
    'project-pages.generic-error.description.non-final': "\uBB38\uC81C\uAC00 \uBC1C\uC0DD\uD588\uC2B5\uB2C8\uB2E4. \uB098\uC911\uC5D0 \uB2E4\uC2DC \uC2DC\uB3C4\uD558\uC138\uC694.",
    'project-pages.generic-error.heading': "\uC8C4\uC1A1\uD569\uB2C8\uB2E4.",
    'project-pages.generic-error.title.non-final': "\uC8C4\uC1A1\uD569\uB2C8\uB2E4.",
    'project-pages.generic-info-flag.description': "\uBB38\uC81C\uAC00 \uBC1C\uC0DD\uD588\uC2B5\uB2C8\uB2E4. \uB2E4\uC2DC \uC2DC\uB3C4\uD558\uAC70\uB098 \uBB38\uC81C\uAC00 \uC9C0\uC18D\uB418\uBA74 \uC9C0\uC6D0 \uD300\uC5D0 \uBB38\uC758\uD558\uC138\uC694",
    'project-pages.generic-success-flag.description.live-doc': "{connectedSpaceOrPageName} \uB77C\uC774\uBE0C \uBB38\uC11C\uC5D0 \uC5F0\uACB0\uB418\uC5C8\uC2B5\uB2C8\uB2E4.",
    'project-pages.generic-success-flag.description.page': "{connectedSpaceOrPageName} \uD398\uC774\uC9C0\uC5D0 \uC5F0\uACB0\uB418\uC5C8\uC2B5\uB2C8\uB2E4.",
    'project-pages.generic-success-flag.description.space': "{connectedSpaceOrPageName} \uC2A4\uD398\uC774\uC2A4\uC5D0 \uC5F0\uACB0\uB418\uC5C8\uC2B5\uB2C8\uB2E4.",
    'project-pages.generic-success-flag.heading.live-doc': "\uB77C\uC774\uBE0C \uBB38\uC11C \uC5F0\uACB0\uB428",
    'project-pages.generic-success-flag.heading.page': "\uD398\uC774\uC9C0 \uC5F0\uACB0\uB428",
    'project-pages.generic-success-flag.heading.space': "\uC2A4\uD398\uC774\uC2A4\uC5D0 \uC5F0\uACB0\uB428",
    'project-pages.granular-pages.connect-space-dialog.content.create-space-link.link-text': "\uB610\uB294 \uC0C8 \uC2A4\uD398\uC774\uC2A4 \uB9CC\uB4E4\uAE30",
    'project-pages.granular-pages.connect-space.button': "Confluence\uC5D0 \uC5F0\uACB0",
    'project-pages.granular-pages.connect-space.heading': "\uC774 \uD504\uB85C\uC81D\uD2B8\uB97C Confluence \uC2A4\uD398\uC774\uC2A4 \uB610\uB294 \uD56D\uBAA9\uC5D0 \uC5F0\uACB0",
    'project-pages.improvement.contact-support': "\uC9C0\uC6D0\uD300\uC5D0 \uBB38\uC758",
    'project-pages.improvement.errors.access-error.description': "\uC0AC\uC774\uD2B8 \uAD00\uB9AC\uC790\uC5D0\uAC8C \uBB38\uC758\uD558\uC5EC \uC561\uC138\uC2A4 \uAD8C\uD55C\uC744 \uC694\uCCAD\uD558\uC138\uC694.",
    'project-pages.improvement.errors.access-error.title': "\uD504\uB85C\uC81D\uD2B8 \uD398\uC774\uC9C0\uB97C \uBCFC \uAD8C\uD55C\uC774 \uC5C6\uC2B5\uB2C8\uB2E4",
    'project-pages.improvement.errors.page-tree-unknown-error.description': "\uC5F0\uACB0\uB41C Confluence \uC2A4\uD398\uC774\uC2A4\uC5D0 \uD398\uC774\uC9C0\uB97C \uD45C\uC2DC\uD558\uB824\uB294 \uC911\uC5D0 \uC624\uB958\uAC00 \uBC1C\uC0DD\uD588\uC2B5\uB2C8\uB2E4. \uC0C8\uB85C \uACE0\uCCD0\uB3C4 \uBB38\uC81C\uAC00 \uD574\uACB0\uB418\uC9C0 \uC54A\uC73C\uBA74 {contactSupport}.",
    'project-pages.improvement.errors.page-tree-unknown-error.title': "\uD504\uB85C\uC81D\uD2B8 \uD398\uC774\uC9C0\uB97C \uD45C\uC2DC\uD558\uB294 \uB3D9\uC548 \uBB38\uC81C\uAC00 \uBC1C\uC0DD\uD588\uC2B5\uB2C8\uB2E4",
    'project-pages.improvement.errors.space-or-page-not-found.description': "\uC5F0\uACB0\uD588\uB358 Confluence \uC2A4\uD398\uC774\uC2A4 \uB610\uB294 \uD398\uC774\uC9C0\uAC00 \uC774\uB3D9, \uBCF4\uAD00 \uB610\uB294 \uC0AD\uC81C\uB418\uC5C8\uC2B5\uB2C8\uB2E4. \uB2E4\uC2DC \uC5F0\uACB0\uD574\uB3C4 \uBB38\uC81C\uAC00 \uD574\uACB0\uB418\uC9C0 \uC54A\uC73C\uBA74 <link>\uC9C0\uC6D0 \uD300\uC5D0 \uBB38\uC758</link>\uD558\uC138\uC694",
    'project-pages.improvement.errors.space-or-page-not-found.title': "\uC2A4\uD398\uC774\uC2A4 \uB610\uB294 \uD398\uC774\uC9C0\uB97C \uCC3E\uC744 \uC218 \uC5C6\uC74C",
    'project-pages.improvement.errors.unknown-error.description': "\uC0C8\uB85C \uACE0\uCCD0\uB3C4 \uBB38\uC81C\uAC00 \uD574\uACB0\uB418\uC9C0 \uC54A\uC73C\uBA74 {contactSupport}.",
    'project-pages.improvement.errors.unknown-error.title': "\uC9C0\uAE08\uC740 \uD504\uB85C\uC81D\uD2B8 \uD398\uC774\uC9C0\uB97C \uD45C\uC2DC\uD560 \uC218 \uC5C6\uC2B5\uB2C8\uB2E4",
    'project-pages.improvement.feature1': "Jira\uC5D0\uC11C \uB098\uAC00\uC9C0 \uC54A\uACE0 \uBB38\uC11C\uC5D0 \uC561\uC138\uC2A4 \uBC0F \uBB38\uC11C \uB9CC\uB4E4\uAE30",
    'project-pages.improvement.feature2': "\uBBF8\uD305, \uC2A4\uD504\uB9B0\uD2B8 \uACC4\uD68D \uB4F1\uC744 \uC704\uD55C \uD15C\uD50C\uB9BF",
    'project-pages.improvement.feature3': "\uC790\uB3D9 \uC5C5\uB370\uC774\uD2B8\uB97C \uC704\uD574 Jira\uC5D0 \uBB38\uC11C\uB97C \uB3D9\uAE30\uD654",
    'project-pages.improvement.heading-info': "\uD300\uC758 \uC9C0\uC2DD\uC744 \uCEA1\uCC98\uD558\uACE0 \uC77C\uD558\uB294 \uBC29\uC2DD\uC744 \uAC1C\uC120\uD558\uC138\uC694.",
    'project-pages.improvement.heading-info-v2': "\uD300\uC758 \uBAA8\uB4E0 \uD504\uB85C\uC81D\uD2B8 \uBB38\uC11C\uB97C \uC704\uD55C \uD558\uB098\uC758 \uACF5\uAC04\uC744 \uB9CC\uB4DC\uC138\uC694",
    'project-pages.improvement.learn-more-button': "\uC790\uC138\uD788 \uC54C\uC544\uBCF4\uAE30",
    'project-pages.improvement.powered-by': "\uC81C\uACF5:",
    'project-pages.improvement.powered-by.tooltip': "\uC0C8 \uD0ED\uC5D0\uC11C Confluence \uC5F4\uAE30",
    'project-pages.improvement.preview-teaser': "\uD15C\uD50C\uB9BF, \uD504\uB85C\uC81D\uD2B8 \uD398\uC774\uC9C0 \uB4F1\uC744 \uC7A0\uAE08 \uD574\uC81C\uD558\uC138\uC694.",
    'project-pages.improvement.provisioning-info-modal.seamlessly-update-stakeholders.description': "<p>\uC790\uB3D9 \uC5C5\uB370\uC774\uD2B8\uB418\uB294 \uC0C1\uD0DC \uB808\uC774\uBE14\uB85C \uD504\uB85C\uC81D\uD2B8 \uBCF4\uACE0\uC11C\uB97C \uCD5C\uC2E0 \uC0C1\uD0DC\uB85C \uC720\uC9C0\uD558\uC138\uC694.</p> <p>\uBB38\uC11C\uC5D0 Jira \uD2F0\uCF13\uC744 \uC5F0\uACB0\uD558\uAE30\uB9CC \uD558\uBA74 \uD2F0\uCF13\uACFC \uB3D9\uAE30\uD654\uD558\uC5EC \uC5C5\uB370\uC774\uD2B8\uB418\uB294 \uC0C1\uD0DC \uB808\uC774\uBE14\uC774 \uC790\uB3D9\uC73C\uB85C \uD45C\uC2DC\uB418\uBBC0\uB85C \uC218\uB3D9\uC73C\uB85C \uBCF4\uACE0\uC11C\uB97C \uB9CC\uB4DC\uB294 \uB370 \uC2DC\uAC04\uC744 \uB4E4\uC77C \uD544\uC694\uAC00 \uC5C6\uC2B5\uB2C8\uB2E4.</p>",
    'project-pages.improvement.provisioning-info-modal.seamlessly-update-stakeholders.title': "\uC774\uD574 \uAD00\uACC4\uC790\uC5D0\uAC8C \uC6D0\uD65C\uD558\uAC8C \uC5C5\uB370\uC774\uD2B8",
    'project-pages.improvement.provisioning-info-modal.unify-documentation-standards.description': "<p>\uAE30\uBCF8 \uC81C\uACF5\uB418\uB294 \uD15C\uD50C\uB9BF\uC744 \uC0AC\uC6A9\uD558\uC5EC \uC77C\uAD00\uC131 \uC788\uB294 \uBB38\uC11C\uB97C \uB9CC\uB4DC\uC138\uC694. \uC0AC\uC6A9\uD558\uAE30 \uC27D\uACE0 \uD544\uC694\uC5D0 \uB530\uB77C \uC0AC\uC6A9\uC790 \uC9C0\uC815\uD560 \uC218 \uC788\uC2B5\uB2C8\uB2E4.</p> <p>\uD504\uB85C\uC81D\uD2B8 \uD398\uC774\uC9C0\uC5D0\uC11C \uBC14\uB85C \uD15C\uD50C\uB9BF\uC744 \uC0AC\uC6A9\uD560 \uC218 \uC788\uC73C\uBBC0\uB85C \uD604\uC7AC \uC791\uC5C5\uC744 \uC885\uB8CC\uD560 \uD544\uC694\uAC00 \uC5C6\uC2B5\uB2C8\uB2E4. <a>\uC5EC\uAE30</a>\uC5D0\uC11C \uBAA8\uB4E0 \uD15C\uD50C\uB9BF\uC744 \uCC3E\uC544\uBCF4\uC138\uC694.</p>",
    'project-pages.improvement.provisioning-info-modal.unify-documentation-standards.title': "\uBB38\uC11C\uD654 \uD45C\uC900 \uD1B5\uD569",
    'project-pages.improvement.provisioning-info-modal.your-project-pages-in-jira.description': "<p>Jira\uC758 \uD504\uB85C\uC81D\uD2B8 \uD398\uC774\uC9C0 \uD0ED\uC5D0\uC11C \uC124\uBA85\uC11C\uB97C \uB9CC\uB4E4\uACE0 \uAD00\uB9AC\uD558\uC5EC \uC911\uC694\uD55C \uC815\uBCF4\uC5D0 \uB300\uD55C \uB2E8\uC77C \uC815\uBCF4 \uCD9C\uCC98\uB97C \uB9CC\uB4DC\uC138\uC694.</p> <p>\uD504\uB85C\uC81D\uD2B8 \uD398\uC774\uC9C0\uAC00 Confluence\uC5D0\uC11C \uC2E4\uD589\uB41C\uB2E4\uB294 \uC0AC\uC2E4\uC744 \uC54C\uACE0 \uACC4\uC168\uC2B5\uB2C8\uAE4C? \uCD5C\uB300 10\uBA85\uC758 \uC0AC\uC6A9\uC790\uAE4C\uC9C0 \uBB34\uB8CC\uC785\uB2C8\uB2E4. \uAD00\uB9AC\uC790 \uC124\uC815\uC5D0\uC11C \uB2E4\uB978 \uD300\uC6D0\uC744 \uCD08\uB300\uD558\uC138\uC694.</p>",
    'project-pages.improvement.provisioning-info-modal.your-project-pages-in-jira.title': "\uD504\uB85C\uC81D\uD2B8 \uD398\uC774\uC9C0\uB97C Jira\uC5D0\uC11C \uBC14\uB85C \uD655\uC778",
    'project-pages.improvement.templates-sidebar.better-together-templates-header': "Jira \uB370\uC774\uD130\uC640 \uD1B5\uD569\uB41C \uD15C\uD50C\uB9BF",
    'project-pages.improvement.templates.better-together-preview-teaser': "Jira \uB370\uC774\uD130\uC640 \uD1B5\uD569\uB428",
    'project-pages.improvement.templates.blank-page.description': "\uCC98\uC74C\uBD80\uD130 \uD398\uC774\uC9C0\uB97C \uC2DC\uC791\uD558\uC138\uC694.",
    'project-pages.improvement.templates.blank-page.name': "\uBE48 \uD398\uC774\uC9C0",
    'project-pages.improvement.templates.decision.description': "\uC911\uC694\uD55C \uD504\uB85C\uC81D\uD2B8 \uACB0\uC815\uC744 \uAE30\uB85D\uD558\uACE0 \uAE30\uB85D\uD55C \uB0B4\uC6A9\uC744 \uD300\uC5D0 \uC804\uB2EC\uD558\uC138\uC694.",
    'project-pages.improvement.templates.decision.name': "\uACB0\uC815",
    'project-pages.improvement.templates.meeting-notes.description': "\uD68C\uC758 \uC5B4\uC820\uB354\uB97C \uC815\uD558\uACE0 \uBA54\uBAA8\uD558\uACE0 \uD300\uC5D0\uAC8C \uC791\uC5C5 \uD56D\uBAA9\uC744 \uACF5\uC720\uD558\uC138\uC694.",
    'project-pages.improvement.templates.meeting-notes.name': "\uBBF8\uD305 \uBA54\uBAA8",
    'project-pages.improvement.templates.post-expand.more': "\uB354 \uB9CE\uC740 \uD15C\uD50C\uB9BF",
    'project-pages.improvement.templates.post-expand.more.tooltip': "Confluence\uC5D0\uC11C \uBAA8\uB4E0 \uD15C\uD50C\uB9BF \uBCF4\uAE30",
    'project-pages.improvement.templates.post-expand.subtitle': "\uC778\uAE30 \uD15C\uD50C\uB9BF",
    'project-pages.improvement.templates.post-expand.title': "\uD398\uC774\uC9C0 \uB9CC\uB4E4\uAE30",
    'project-pages.improvement.templates.pre-expand.more': "\uB354 \uB9CE\uC740 \uD15C\uD50C\uB9BF \uD0D0\uC0C9",
    'project-pages.improvement.templates.pre-expand.subtitle': "\uB098\uC758 \uD300\uACFC \uBE44\uC2B7\uD55C \uD300\uC5D0\uC11C \uC778\uAE30",
    'project-pages.improvement.templates.pre-expand.title': "\uD15C\uD50C\uB9BF \uBBF8\uB9AC\uBCF4\uAE30",
    'project-pages.improvement.templates.product-requirements.description': "\uC81C\uD488 \uB610\uB294 \uAE30\uB2A5\uC5D0 \uB300\uD55C \uC694\uAD6C \uC0AC\uD56D\uC744 \uC815\uC758\uD558\uACE0 \uCD94\uC801\uD558\uACE0 \uBC94\uC704\uB97C \uC9C0\uC815\uD569\uB2C8\uB2E4.",
    'project-pages.improvement.templates.product-requirements.name': "\uC81C\uD488 \uC694\uAD6C\uC0AC\uD56D",
    'project-pages.improvement.templates.retrospective.description': "\uC88B\uC558\uB358 \uC810\uC740 \uBB34\uC5C7\uC785\uB2C8\uAE4C? \uAC1C\uC120\uD560 \uC810\uC740 \uBB34\uC5C7\uC785\uB2C8\uAE4C? \uD300\uACFC \uD568\uAED8 \uAC1C\uC120 \uC0AC\uD56D\uC744 \uD06C\uB77C\uC6B0\uB4DC\uC18C\uC2F1",
    'project-pages.improvement.templates.retrospective.name': "\uD68C\uACE0\uB85D",
    'project-pages.improvement.templates.template.disabled-tooltip': "\uC6B0\uC120 Confluence \uC2A4\uD398\uC774\uC2A4\uC5D0 \uC5F0\uACB0\uD558\uC138\uC694",
    'project-pages.improvement.templates.tutorial.content.confluence-templates': "<b>\uC2DC\uAC04\uC744 \uC808\uC57D\uD558\uACE0 \uC218\uB3D9 \uC791\uC5C5\uC744 \uC904\uC774\uC138\uC694</b>. Confluence\uC5D0\uB294 \uC644\uC804\uD788 \uCC98\uC74C\uBD80\uD130 \uC2DC\uC791\uD560 \uD544\uC694\uAC00 \uC5C6\uB3C4\uB85D \uB2E4\uC591\uD55C \uD398\uC774\uC9C0 <a>\uD15C\uD50C\uB9BF</a>\uC774 \uC788\uC2B5\uB2C8\uB2E4. \uAE30\uC220 \uBB38\uC11C, \uBB38\uC81C \uD574\uACB0 \uAC00\uC774\uB4DC, \uD504\uB85C\uC81D\uD2B8 \uACC4\uD68D, \uC81C\uD488 \uC694\uAD6C \uC0AC\uD56D \uB4F1\uC5D0 \uB300\uD574 \uC0DD\uAC01\uD574 \uBCF4\uC138\uC694.",
    'project-pages.improvement.templates.tutorial.content.edit-and-format': "<b>\uD3B8\uC9D1\uACFC \uC11C\uC2DD \uC9C0\uC815\uC774 \uC27D\uC2B5\uB2C8\uB2E4.</b> \uC77C\uBC18\uC801\uC778 \uB2E8\uC5B4 \uC11C\uC2DD \uC9C0\uC815\uC740 \uC0C1\uB2E8 \uD3B8\uC9D1 \uBA54\uB274\uB97C \uC0AC\uC6A9\uD558\uACE0 <b>/</b>\uB97C \uC785\uB825\uD558\uBA74 \uD3B8\uB9AC\uD55C \uC5EC\uB7EC \uD1B5\uD569 \uAE30\uB2A5\uC744 \uC27D\uAC8C \uC0BD\uC785\uD560 \uC218 \uC788\uC2B5\uB2C8\uB2E4. <c>/\uD45C</c>\uB97C \uC785\uB825\uD558\uC5EC \uD45C\uB97C \uC0BD\uC785\uD558\uAC70\uB098 <c>/\uC774\uBBF8\uC9C0</c>\uB97C \uC785\uB825\uD558\uC5EC \uC774\uBBF8\uC9C0\uB97C \uC0BD\uC785\uD558\uC138\uC694. <c>/dropbox</c>\uB85C Dropbox \uB9C1\uD06C\uB97C, <c>/microsoft</c>\uB85C Microsoft office \uB3C4\uAD6C\uB97C \uB610\uB294 <c>/trello</c>\uB85C Trello \uBCF4\uB4DC \uBC0F \uCE74\uB4DC\uB97C \uC0BD\uC785\uD560 \uC218\uB3C4 \uC788\uC2B5\uB2C8\uB2E4.",
    'project-pages.improvement.templates.tutorial.content.forward-slash-prompt': "/ \uB4A4\uC5D0 '\uD45C' \uB610\uB294 '\uC774\uBBF8\uC9C0'\uB97C \uC785\uB825\uD558\uC138\uC694",
    'project-pages.improvement.templates.tutorial.content.getting-started-tips': "\uC2DC\uC791\uD558\uAE30 \uC704\uD55C \uBA87 \uAC00\uC9C0 \uD301\uC740 \uB2E4\uC74C\uACFC \uAC19\uC2B5\uB2C8\uB2E4.",
    'project-pages.improvement.templates.tutorial.content.handy-links': "\uD3B8\uB9AC\uD55C \uB9C1\uD06C",
    'project-pages.improvement.templates.tutorial.content.jira-and-confluence': "Jira \uBC0F Confluence \uD568\uAED8 \uC0AC\uC6A9\uD558\uAE30",
    'project-pages.improvement.templates.tutorial.content.jira-charts': "\uC2E4\uC81C Jira \uB370\uC774\uD130\uB97C \uC0AC\uC6A9\uD558\uC5EC \uD398\uC774\uC9C0\uC5D0 \uCC28\uD2B8\uB97C \uB9CC\uB4DC\uC138\uC694. <c>/Jira \uCC28\uD2B8</c>\uB97C \uC785\uB825\uD558\uC138\uC694.",
    'project-pages.improvement.templates.tutorial.content.jira-links': "Jira \uC774\uC288\uB97C \uD398\uC774\uC9C0\uC758 \uC6D0\uD558\uB294 \uC704\uCE58\uC5D0 \uC5F0\uACB0\uD558\uC138\uC694. Jira \uC774\uC288\uB97C \uC5C5\uB370\uC774\uD2B8\uD558\uBA74 \uD398\uC774\uC9C0\uC758 \uB9C1\uD06C\uAC00 \uC2E4\uC2DC\uAC04\uC73C\uB85C \uC5C5\uB370\uC774\uD2B8\uB429\uB2C8\uB2E4. <c>/Jira</c>\uB97C \uC785\uB825\uD558\uC138\uC694.",
    'project-pages.improvement.templates.tutorial.content.jira-links-issue-term-refresh': "Jira \uC5C5\uBB34 \uD56D\uBAA9\uC744 \uD398\uC774\uC9C0\uC758 \uC6D0\uD558\uB294 \uC704\uCE58\uC5D0 \uC5F0\uACB0\uD558\uC138\uC694. \uC5C5\uBB34 \uD56D\uBAA9\uC744 \uC5C5\uB370\uC774\uD2B8\uD558\uBA74 \uD398\uC774\uC9C0\uC758 \uB9C1\uD06C\uAC00 \uC2E4\uC2DC\uAC04\uC73C\uB85C \uC5C5\uB370\uC774\uD2B8\uB429\uB2C8\uB2E4. <c>/Jira</c>\uB97C \uC785\uB825\uD558\uC138\uC694.",
    'project-pages.improvement.templates.tutorial.content.jira-links.non-final-issue-term-refresh': "Jira \uC5C5\uBB34 \uD56D\uBAA9\uC744 \uD398\uC774\uC9C0\uC758 \uC6D0\uD558\uB294 \uACF3\uC5D0 \uC5F0\uACB0\uD558\uC138\uC694. \uC5C5\uBB34 \uD56D\uBAA9\uC744 \uC5C5\uB370\uC774\uD2B8\uD558\uBA74 \uD398\uC774\uC9C0\uC758 \uB9C1\uD06C\uAC00 \uC2E4\uC2DC\uAC04\uC73C\uB85C \uC5C5\uB370\uC774\uD2B8\uB429\uB2C8\uB2E4. <c>/Jira</c>\uB97C \uC785\uB825\uD558\uC138\uC694.",
    'project-pages.improvement.templates.tutorial.content.jira-roadmaps': "Jira \uD504\uB85C\uC81D\uD2B8\uB97C \uC0AC\uC6A9\uD558\uC5EC \uD398\uC774\uC9C0\uC5D0 \uB300\uD654\uD615 \uB85C\uB4DC\uB9F5\uACFC \uD0C0\uC784\uB77C\uC778\uC744 \uD3EC\uD568\uD558\uC138\uC694. <c>/Jira \uB85C\uB4DC\uB9F5</c>\uC744 \uC785\uB825\uD558\uC138\uC694.",
    'project-pages.improvement.templates.tutorial.content.jira-timeline': "Jira \uD504\uB85C\uC81D\uD2B8\uB97C \uC0AC\uC6A9\uD558\uC5EC \uD398\uC774\uC9C0\uC5D0 \uB300\uD654\uD615 \uD0C0\uC784\uB77C\uC778\uC744 \uD3EC\uD568\uD558\uC138\uC694. <c>/jira \uD0C0\uC784\uB77C\uC778</c>\uC744 \uC785\uB825\uD558\uC138\uC694.",
    'project-pages.improvement.templates.tutorial.content.shipping-speed-statistic': "Jira Software \uACE0\uAC1D\uC758 76%\uAC00 Confluence\uB97C \uCD94\uAC00\uD55C \uD6C4 \uD504\uB85C\uC81D\uD2B8 \uCD9C\uC2DC \uAE30\uAC04\uC774 \uB2E8\uCD95\uB418\uC5C8\uB2E4\uACE0 \uC751\uB2F5\uD588\uC2B5\uB2C8\uB2E4",
    'project-pages.improvement.templates.tutorial.content.shipping-speed-statistic.spork-rebranding': "Jira \uACE0\uAC1D\uC758 76%\uAC00 Confluence\uB97C \uCD94\uAC00\uD55C \uD6C4 \uD504\uB85C\uC81D\uD2B8 \uC81C\uACF5 \uAE30\uAC04\uC774 \uB2E8\uCD95\uB418\uC5C8\uB2E4\uACE0 \uC751\uB2F5\uD588\uC2B5\uB2C8\uB2E4",
    'project-pages.improvement.templates.tutorial.content.spaces-and-pages': "<b>\uC2A4\uD398\uC774\uC2A4 \uBC0F \uD398\uC774\uC9C0 \uC0AC\uC6A9\uD558\uAE30</b>. \uC2A4\uD398\uC774\uC2A4\uB294 \uBAA8\uB4E0 Confluence \uC0AC\uC774\uD2B8\uC5D0 \uC18D\uD574 \uC788\uC73C\uBA70 \uD398\uC774\uC9C0\uB97C \uBC94\uC8FC\uBCC4\uB85C \uCCB4\uACC4\uD654\uD558\uB294 \uBC29\uBC95\uC785\uB2C8\uB2E4. \uC2A4\uD398\uC774\uC2A4\uB294 \uC5EC\uB7EC \uD3F4\uB354 \uB610\uB294 \uD504\uB85C\uC81D\uD2B8\uC774\uBA70 \uD398\uC774\uC9C0\uB294 \uADF8 \uD3F4\uB354 \uB610\uB294 \uD504\uB85C\uC81D\uD2B8 \uC548\uC758 \uBB38\uC11C\uB77C\uACE0 \uC0DD\uAC01\uD558\uC138\uC694. <a>\uC2A4\uD398\uC774\uC2A4 \uC0AC\uC6A9 \uBC29\uBC95 \uC790\uC138\uD788 \uC54C\uC544\uBCF4\uAE30</a>",
    'project-pages.improvement.templates.tutorial.content.try-it-now': "\uC9C0\uAE08 \uC0AC\uC6A9\uD574\uBCF4\uAE30",
    'project-pages.improvement.templates.tutorial.description': "\uD398\uC774\uC9C0\uB97C \uD3B8\uC9D1\uD558\uB294 \uBC29\uBC95\uC744 \uC54C\uC544\uBCF4\uC138\uC694.",
    'project-pages.improvement.templates.tutorial.name': "\uD504\uB85C\uC81D\uD2B8 \uD398\uC774\uC9C0\uC5D0 \uC624\uC2E0 \uAC83\uC744 \uD658\uC601\uD569\uB2C8\uB2E4!",
    'project-pages.improvement.terms-and-conditions-v2': "&quot;\uC9C0\uAE08 \uC0AC\uC6A9\uD574 \uBCF4\uAE30&quot;\uB97C \uC120\uD0DD\uD558\uBA74 Confluence\uC5D0 \uB4F1\uB85D\uD55C\uB2E4\uB294 \uAC83\uC744 \uD655\uC778\uD558\uACE0 Atlassian <termsLink>Cloud \uC11C\uBE44\uC2A4 \uC57D\uAD00</termsLink> \uBC0F <privacyLink>\uAC1C\uC778 \uC815\uBCF4 \uBCF4\uD638 \uC815\uCC45</privacyLink>\uC5D0 \uB3D9\uC758\uD558\uAC8C \uB429\uB2C8\uB2E4.",
    'project-pages.improvement.title': "\uD504\uB85C\uC81D\uD2B8 \uD398\uC774\uC9C0",
    'project-pages.improvement.transient-states.empty-state.auto-provisioned-create-page-button': "\uD398\uC774\uC9C0 \uB9CC\uB4E4\uAE30",
    'project-pages.improvement.transient-states.empty-state.auto-provisioned-description': "\uBAA8\uB4E0 \uD504\uB85C\uC81D\uD2B8 \uBB38\uC11C\uB97C \uB9CC\uB4E4\uACE0 \uC5F0\uACB0\uD560 \uC218 \uC788\uB3C4\uB85D Confluence\uB97C \uCD94\uAC00\uD588\uC2B5\uB2C8\uB2E4. \uCD5C\uB300 10\uBA85\uC758 \uC0AC\uC6A9\uC790\uAE4C\uC9C0 \uBB34\uB8CC\uC785\uB2C8\uB2E4.",
    'project-pages.improvement.transient-states.empty-state.auto-provisioned-learn-more-button': "\uC790\uC138\uD788 \uC54C\uC544\uBCF4\uAE30",
    'project-pages.improvement.transient-states.empty-state.create-page-button': "\uCCAB \uD398\uC774\uC9C0 \uB9CC\uB4E4\uAE30",
    'project-pages.improvement.transient-states.empty-state.description': "\uBBF8\uD305 \uBA54\uBAA8, \uC81C\uD488 \uC694\uAD6C \uC0AC\uD56D, \uACB0\uC815 \uC0AC\uD56D \uB610\uB294 \uAE30\uD0C0 \uCF58\uD150\uCE20\uB97C \uB9CC\uB4E4\uC5B4 \uC774 \uC2A4\uD398\uC774\uC2A4\uB97C \uCC44\uC6CC\uBCF4\uC138\uC694.",
    'project-pages.improvement.transient-states.empty-state.title': "\uC774\uACF3\uC740 \uC7A0\uC7AC\uB825\uC73C\uB85C \uAC00\uB4DD\uD569\uB2C8\uB2E4.",
    'project-pages.improvement.try-button': "Confluence\uC5D0\uC11C \uC774 \uD15C\uD50C\uB9BF \uC0AC\uC6A9\uD574 \uBCF4\uAE30",
    'project-pages.improvement.try-it-now': "\uC9C0\uAE08 \uC0AC\uC6A9\uD574 \uBCF4\uAE30",
    'project-pages.improvement.try-lozenge': "\uC0AC\uC6A9\uD574 \uBCF4\uAE30",
    'project-pages.improvement.try-on-demand-button': "\uBB34\uB8CC\uB85C \uC0AC\uC6A9\uD574 \uBCF4\uAE30",
    'project-pages.page-deleted-flag.title': "\uD398\uC774\uC9C0\uB97C \uC0AD\uC81C\uD588\uC2B5\uB2C8\uB2E4.",
    'project-pages.page-published-flag.title': "\uD398\uC774\uC9C0\uB97C \uAC8C\uC2DC\uD588\uC2B5\uB2C8\uB2E4.",
    'project-pages.unknown-error.description': "\uC0C8\uB85C \uACE0\uCCD0\uB3C4 \uBB38\uC81C\uAC00 \uD574\uACB0\uB418\uC9C0 \uC54A\uC73C\uBA74 {contactSupport}.",
    'project-pages.unknown-error.heading': "\uC9C0\uAE08\uC740 \uD504\uB85C\uC81D\uD2B8 \uD398\uC774\uC9C0\uB97C \uD45C\uC2DC\uD560 \uC218 \uC5C6\uC2B5\uB2C8\uB2E4"
};

});

parcelRegister("2qrsf", function(module, exports) {

$parcel$export(module.exports, "default", () => $572de127d6985815$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Norwegian (Bokmål)
var $572de127d6985815$export$2e2bcd8739ae039 = {
    'confluence.project-pages.improvement.provisioning-background.text': "Dette b\xf8r ta mindre enn ett minutt",
    'confluence.project-pages.improvement.provisioning-background.title': 'Konfigurerer prosjektsidene dine',
    'confluence.project-pages.improvement.provisioning-modal-carousel.controls.dismiss': 'Avvis',
    'confluence.project-pages.improvement.provisioning-modal-carousel.controls.done': 'Ferdig',
    'confluence.project-pages.improvement.provisioning-modal-carousel.controls.next': 'Neste',
    'project-pages.activating.description': "Det tilkoblede Confluence-omr\xe5det er ikke helt klart enn\xe5. {contactSupport} hvis det ikke hjelper \xe5 oppdatere.",
    'project-pages.activating.heading': 'Confluence lastes fortsatt',
    'project-pages.better-together-templates.meeting-notes.action-items-heading': 'Hva er handlingselementene?',
    'project-pages.better-together-templates.meeting-notes.agenda-item-label': "Element p\xe5 dagsordenen",
    'project-pages.better-together-templates.meeting-notes.create-a-jira-issue': "Skriv /Jira for \xe5 opprette en sak",
    'project-pages.better-together-templates.meeting-notes.date-label': 'Dato',
    'project-pages.better-together-templates.meeting-notes.discussion-topics-heading': 'Emner for diskusjon',
    'project-pages.better-together-templates.meeting-notes.list-people': "f\xf8r opp personer med",
    'project-pages.better-together-templates.meeting-notes.mention': 'omtal',
    'project-pages.better-together-templates.meeting-notes.mention-people-to-assign-them': "personer for \xe5 tilordne dem et handlingselement",
    'project-pages.better-together-templates.meeting-notes.notes-label': 'Merknader',
    'project-pages.better-together-templates.meeting-notes.page-title': "M\xf8tenotater",
    'project-pages.better-together-templates.meeting-notes.participants-label': 'Deltakere',
    'project-pages.better-together-templates.meeting-notes.project-label': 'Prosjekt',
    'project-pages.better-together-templates.product-requirements.create-a-jira-issue': "Skriv /Jira for \xe5 opprette en sak",
    'project-pages.better-together-templates.product-requirements.design-heading': 'Design',
    'project-pages.better-together-templates.product-requirements.embedd-different-data-views': 'Bygg inn ulike data og visninger fra Jira-prosjektet ditt.',
    'project-pages.better-together-templates.product-requirements.heading': 'Oversikt',
    'project-pages.better-together-templates.product-requirements.how-will-you-know-if-fixed': 'Hvordan vet du at du har rettet det?',
    'project-pages.better-together-templates.product-requirements.impact-heading': 'Innvirkning',
    'project-pages.better-together-templates.product-requirements.inScopeStatus': 'Innenfor omfang',
    'project-pages.better-together-templates.product-requirements.insert-design-link': 'Sett inn en kobling til designet (Figma osv.)',
    'project-pages.better-together-templates.product-requirements.jira-issue-heading': 'Jira-sak',
    'project-pages.better-together-templates.product-requirements.jira-roadmap-heading': 'Jira-veikart',
    'project-pages.better-together-templates.product-requirements.learn-how-with-smart-links': 'Finn ut hvordan med smartkoblinger',
    'project-pages.better-together-templates.product-requirements.list-dashboards': "F\xf8r opp oversikter (Amplitude, Modus osv.)",
    'project-pages.better-together-templates.product-requirements.list-design-considerations': "F\xf8r opp design- eller utviklingshensyn",
    'project-pages.better-together-templates.product-requirements.list-people': "f\xf8r opp personer med",
    'project-pages.better-together-templates.product-requirements.mention': 'omtal',
    'project-pages.better-together-templates.product-requirements.mention-people-to-assign-them': "personer for \xe5 tilordne dem et handlingselement",
    'project-pages.better-together-templates.product-requirements.niceToHaveStatus': "Kjekt \xe5 ha",
    'project-pages.better-together-templates.product-requirements.outOfScopeStatus': 'Utenfor omfang',
    'project-pages.better-together-templates.product-requirements.page-title': 'Produktkrav',
    'project-pages.better-together-templates.product-requirements.pro-tip': 'Profftips:',
    'project-pages.better-together-templates.product-requirements.problem-label': 'Problem',
    'project-pages.better-together-templates.product-requirements.requirement-heading': 'Krav',
    'project-pages.better-together-templates.product-requirements.scope-heading': 'Omfang',
    'project-pages.better-together-templates.product-requirements.success-metric': 'Suksessberegning',
    'project-pages.better-together-templates.product-requirements.target-release-date': "Dato for m\xe5lutgivelse",
    'project-pages.better-together-templates.product-requirements.team-label': 'Team',
    'project-pages.better-together-templates.product-requirements.to-do-list-heading': "Gj\xf8rem\xe5lsliste",
    'project-pages.better-together-templates.product-requirements.what-are-you-trying-to-fix': "Hva pr\xf8ver du \xe5 rette?",
    'project-pages.better-together-templates.retro-notes.retro-heading': 'Tilbakeblikk',
    'project-pages.better-together-templates.retro.action-items-heading': 'Hva er handlingselementene?',
    'project-pages.better-together-templates.retro.create-a-jira-issue': "Skriv /Jira for \xe5 opprette en sak",
    'project-pages.better-together-templates.retro.date-label': 'Dato',
    'project-pages.better-together-templates.retro.embed-it-here': "N\xe5r du er ferdig, kan du bygge den inn her.",
    'project-pages.better-together-templates.retro.list-people': "f\xf8r opp personer med",
    'project-pages.better-together-templates.retro.mention': 'omtal',
    'project-pages.better-together-templates.retro.mention-people-to-assign-them': "personer for \xe5 tilordne dem et handlingselement",
    'project-pages.better-together-templates.retro.page-title': 'Retrospektiv',
    'project-pages.better-together-templates.retro.participants-label': 'Deltakere',
    'project-pages.better-together-templates.retro.pro-tip': 'Profftips:',
    'project-pages.better-together-templates.retro.project-label': 'Prosjekt',
    'project-pages.better-together-templates.retro.this-is-a-whiteboard': 'Dette er en Confluence-tavle.',
    'project-pages.better-together-templates.retro.use-a-whiteboard': 'Bruk en Confluence-tavle for tilbakeblikket ditt.',
    'project-pages.better-together-templates.retro.use-it-to-vote': "Bruk den til \xe5 stemme og samarbeide med teamet ditt.",
    'project-pages.button.connect-different-space-or-page.label': "Oppdater omr\xe5de- eller sideikon",
    'project-pages.button.connect-different-space-or-page.tooltip': "Koble til et annet omr\xe5de eller element",
    'project-pages.button.connect-space-or-page.tooltip': 'Koble til Confluence',
    'project-pages.button.go-to-connected-live-doc.tooltip': "\xc5pne sanntidsdokumentet i Confluence",
    'project-pages.button.go-to-connected-page.tooltip': "\xc5pne siden i Confluence",
    'project-pages.button.go-to-connected-space.tooltip': "\xc5pne omr\xe5det i Confluence",
    'project-pages.connect-space-dialog.connection-error': 'Tilkobling mislykket.',
    'project-pages.connect-space-dialog.connection-retry': "Pr\xf8v igjen",
    'project-pages.connect-space-dialog.content.space-or-page-selector.description': "Velg et omr\xe5de eller element du vil koble til prosjektet.",
    'project-pages.connect-space-dialog.content.space-or-page-selector.placeholder': "S\xf8k gjennom Confluence",
    'project-pages.connect-space-dialog.content.space-selector.disconnected-templates-description': "Dette prosjektet m\xe5 kobles til et omr\xe5de f\xf8r du kan opprette et element. Velg et omr\xe5de som dette prosjektet skal kobles til.",
    'project-pages.connect-space-dialog.error-icon': 'Feil:',
    'project-pages.connect-space-dialog.footer.cancel': 'Avbryt',
    'project-pages.connect-space-dialog.footer.connect-space': 'Koble til',
    'project-pages.connect-space-or-page-dialog.header.title': 'Koble prosjektet til Confluence',
    'project-pages.connect-space.description': "Omr\xe5der er som mapper \u2013 du kan bruke dem til \xe5 opprette, organisere og samarbeide p\xe5 alt innhold relatert til prosjektet.",
    'project-pages.connect-space.not-connected.description': "Hvis du vil bruke prosjektsider, kontakter du administratoren eller teamlederen din for \xe5 koble Confluence til dette prosjektet.",
    'project-pages.connect-space.not-connected.heading': 'Ikke koblet til Confluence',
    'project-pages.connect-success-flag.description.content': 'Du er koblet til {connectedSpaceOrPageName}-innholdet.',
    'project-pages.connection-error.space-or-page-not-found.button': "Koble til et annet omr\xe5de eller en annen side",
    'project-pages.create-space-dialog.connection-error': 'Tilkobling mislykket.',
    'project-pages.create-space-dialog.connection-retry': "Pr\xf8v igjen",
    'project-pages.create-space-dialog.content.empty-name': "Angi et navn p\xe5 omr\xe5det.",
    'project-pages.create-space-dialog.content.invalid-name': "Omr\xe5denavn m\xe5 best\xe5 av minst ett tall eller en bokstav.",
    'project-pages.create-space-dialog.content.placeholder': "Oppgi et omr\xe5denavn",
    'project-pages.create-space-dialog.creation-error': "Kunne ikke opprette omr\xe5de.",
    'project-pages.create-space-dialog.error-icon': 'Feil:',
    'project-pages.create-space-dialog.footer.cancel': 'Avbryt',
    'project-pages.create-space-dialog.footer.create-space': 'Opprett',
    'project-pages.create-space-dialog.header.title': "Opprett nytt Confluence-omr\xe5de",
    'project-pages.cross-join.access-revoked.templates.subtitle': "Du kan ikke bruke prosjektsider fordi administratoren har nektet deg tilgang til Confluence. Kontakt nettstedsadministratoren for \xe5 be om tilgang.",
    'project-pages.cross-join.access-revoked.templates.title': "Du har ikke tillatelse til \xe5 bruke prosjektsider",
    'project-pages.cross-join.avatar.view-profile': 'Se profil',
    'project-pages.cross-join.denied-request.templates.subtitle': "Du kan ikke bruke prosjektsider fordi nettstedsadministratoren avviste foresp\xf8rselen din om \xe5 bli med Confluence.",
    'project-pages.cross-join.denied-request.templates.title': 'Administratoren har nektet deg tilgang',
    'project-pages.cross-join.direct-access.button-subtitle.experimental': "Du f\xe5r tilgang til Confluence. Nettstedsadministratoren har allerede godkjent deg.",
    'project-pages.cross-join.errors.unknown-error.description': "{contactSupport} hvis det ikke hjelper \xe5 oppdatere siden.",
    'project-pages.cross-join.errors.unknown-error.title': "Vi kan ikke vise prosjektsider akkurat n\xe5",
    'project-pages.cross-join.inline-join-product.button': "Du f\xe5r tilgang til Confluence. Nettstedsadministratoren har allerede godkjent deg.",
    'project-pages.cross-join.inline-join-product.connected.description': 'Vis, rediger og opprett dokumentasjon fra ett sted',
    'project-pages.cross-join.inline-join-product.connected.title': "Samarbeid p\xe5 prosjektsider med teamet ditt",
    'project-pages.cross-join.pending-request.templates.subtitle': "Nettstedsadministratoren har mottatt foresp\xf8rselen din om \xe5 bli med i Confluence. Hvis du blir godkjent for \xe5 bli med, vil prosjektsidene begynne \xe5 fungere, og vi sender deg en e-postbekreftelse.",
    'project-pages.cross-join.pending-request.templates.subtitle.experiment': "Du f\xe5r en e-post med tilgang til Prosjektsider n\xe5r du er godkjent.",
    'project-pages.cross-join.pending-request.templates.title': 'Du har bedt om tilgang til Confluence',
    'project-pages.cross-join.pending-request.templates.title.experiment': "Tilgangsforesp\xf8rselen ble sendt til administratoren",
    'project-pages.cross-join.request-access-without-better-together.connected.description': 'Se, rediger og opprett prosjektdokumentasjon med teamet ditt',
    'project-pages.cross-join.request-access.button': 'Be om tilgang',
    'project-pages.cross-join.request-access.button-subtitle.experimental': "N\xe5r du velger \xabBli med i teamet ditt\xbb, ber du om \xe5 bli med i Confluence og godtar \xe5 dele Atlassian-profilen din med administratoren din.",
    'project-pages.cross-join.request-access.button.experimental': 'Bli med i teamet ditt',
    'project-pages.cross-join.request-access.connected.description.experimental': "Teamet ditt bruker Prosjektsider til \xe5 kommentere, redigere og samarbeide om prosjektdokumentasjon uten \xe5 forlate Jira. Bli med i Confluence for \xe5 f\xe5 tilgang til teamets prosjektsider.",
    'project-pages.cross-join.request-access.title': 'Prosjektsider krever tilgang til Confluence',
    'project-pages.cross-join.request-access.title.experiment': "Opprett \xe9n enkelt informasjonskilde for teamet ditt",
    'project-pages.default-contextual-heading': 'Prosjektsider er drevet av Confluence',
    'project-pages.default-contextual-message': "Opprett, del og samarbeid p\xe5 alle prosjektdokumenter p\xe5 ett sted med Confluence-sider.",
    'project-pages.default-reactivate-CTA': "Aktiver Confluence p\xe5 nytt",
    'project-pages.default-trial-CTA': "Pr\xf8v Confluence gratis i 30 dager",
    'project-pages.draft-saved-flag.action': "\xc5pne utkast",
    'project-pages.draft-saved-flag.description': 'Utkastet ditt er bare synlig for deg, frem til du publiserer det.',
    'project-pages.draft-saved-flag.title': 'Utkastet er lagret',
    'project-pages.embedded-pages.create-page-error.close-button': 'Lukk',
    'project-pages.embedded-pages.create-page-error.description': 'Det oppstod et problem, og vi kan ikke opprette en side for deg.',
    'project-pages.embedded-pages.create-page-error.title': 'Vi kan ikke opprette en side',
    'project-pages.embedded-pages.create-page-error.try-again-button': "Pr\xf8v p\xe5 nytt",
    'project-pages.embedded-pages.modal.close.button.hint': 'Lukk',
    'project-pages.embedded-pages.modal.title.button': "\xc5pne i Confluence",
    'project-pages.embedded-pages.modal.title.button.hint': "\xc5pne i en ny fane",
    'project-pages.errors.unknown-error.description.non-final': "{contactSupport} hvis det ikke hjelper \xe5 oppdatere siden.",
    'project-pages.errors.unknown-error.title.non-final': "Vi kan ikke vise prosjektsider akkurat n\xe5",
    'project-pages.generic-error.button.reload': 'Oppdater siden',
    'project-pages.generic-error.description': "Det oppstod en feil. Pr\xf8v igjen senere.",
    'project-pages.generic-error.description.non-final': "Det oppstod en feil. Pr\xf8v igjen senere.",
    'project-pages.generic-error.heading': "Vel, dette er pinlig \u2026",
    'project-pages.generic-error.title.non-final': "Vel, dette er pinlig\xa0\u2026",
    'project-pages.generic-info-flag.description': "Noe gikk galt. Pr\xf8v p\xe5 nytt, eller kontakt st\xf8tte hvis problemet vedvarer",
    'project-pages.generic-success-flag.description.live-doc': 'Du er koblet til sanntidsdokumentet {connectedSpaceOrPageName}.',
    'project-pages.generic-success-flag.description.page': 'Du er koblet til {connectedSpaceOrPageName}-siden.',
    'project-pages.generic-success-flag.description.space': "Du er koblet til omr\xe5det {connectedSpaceOrPageName}.",
    'project-pages.generic-success-flag.heading.live-doc': 'Sanntidsdokumentet er koblet til',
    'project-pages.generic-success-flag.heading.page': 'Siden er tilkoblet',
    'project-pages.generic-success-flag.heading.space': "Omr\xe5det er tilkoblet",
    'project-pages.granular-pages.connect-space-dialog.content.create-space-link.link-text': "Eller opprett et nytt omr\xe5de",
    'project-pages.granular-pages.connect-space.button': 'Koble til Confluence',
    'project-pages.granular-pages.connect-space.heading': "Koble dette prosjektet til et Confluence-omr\xe5de eller -element",
    'project-pages.improvement.contact-support': "Kontakt brukerst\xf8tte",
    'project-pages.improvement.errors.access-error.description': "Ta kontakt med nettstedadministrator for \xe5 be om tilgang.",
    'project-pages.improvement.errors.access-error.title': "Du har ikke tillatelse til \xe5 se prosjektsider",
    'project-pages.improvement.errors.page-tree-unknown-error.description': "Noe gikk galt under fors\xf8ket p\xe5 \xe5 vise sider fra det tilkoblede Confluence-omr\xe5det. {contactSupport} hvis det ikke hjelper \xe5 oppdatere siden.",
    'project-pages.improvement.errors.page-tree-unknown-error.title': "Vi har problemer med \xe5 vise prosjektsider",
    'project-pages.improvement.errors.space-or-page-not-found.description': "Confluence-omr\xe5det eller -siden som ble koblet til, er flyttet, arkivert eller slettet. <link>Kontakt brukerst\xf8tte</link> hvis du ikke kan l\xf8se dette ved \xe5 koble til p\xe5 nytt",
    'project-pages.improvement.errors.space-or-page-not-found.title': "Finner ikke omr\xe5de eller side",
    'project-pages.improvement.errors.unknown-error.description': "{contactSupport} hvis det ikke hjelper \xe5 oppdatere siden.",
    'project-pages.improvement.errors.unknown-error.title': "Vi kan ikke vise prosjektsider akkurat n\xe5",
    'project-pages.improvement.feature1': "\xc5pne og opprett dokumenter uten \xe5 g\xe5 ut av Jira",
    'project-pages.improvement.feature2': "Maler for m\xf8ter, sprintplaner og mer",
    'project-pages.improvement.feature3': 'Synkroniser dokumenter til Jira for automatiske oppdateringer',
    'project-pages.improvement.heading-info': "Registrer teamets kunnskap og forbedre m\xe5ten du f\xe5r arbeidet utf\xf8rt p\xe5.",
    'project-pages.improvement.heading-info-v2': 'Opprett ett sted for alle teamets prosjektdokumenter',
    'project-pages.improvement.learn-more-button': 'Finn ut mer',
    'project-pages.improvement.powered-by': 'Levert av',
    'project-pages.improvement.powered-by.tooltip': "\xc5pne Confluence i en ny fane",
    'project-pages.improvement.preview-teaser': "L\xe5s opp maler, prosjektsider med mer.",
    'project-pages.improvement.provisioning-info-modal.seamlessly-update-stakeholders.description': "<p>Hold prosjektrapportene oppdaterte med statusetiketter som oppdateres automatisk.</p> <p>Bare koble til en Jira-st\xf8tteforesp\xf8rsel i et dokument, s\xe5 viser den automatisk en statusetikett som oppdateres synkront med st\xf8tteforesp\xf8rselen. Da trenger du ikke bruke tid p\xe5 manuelle rapporter.</p>",
    'project-pages.improvement.provisioning-info-modal.seamlessly-update-stakeholders.title': 'Oppdater interessentene uten problemer',
    'project-pages.improvement.provisioning-info-modal.unify-documentation-standards.description': "<p>Opprett konsekvent dokumentasjon ved \xe5 bruke de innebygde malene v\xe5re. De er lette \xe5 bruke og tilpasse etter behov.</p> <p>Du kan bruke maler direkte fra prosjektsider slik at du aldri trenger \xe5 forlate det du jobber p\xe5. Du kan se gjennom alle malene <a>her</a>.</p>",
    'project-pages.improvement.provisioning-info-modal.unify-documentation-standards.title': 'Foren dokumentasjonsstandardene',
    'project-pages.improvement.provisioning-info-modal.your-project-pages-in-jira.description': "<p>Opprett en enkelt informasjonskilde for viktig informasjon ved \xe5 opprette og administrere dokumentasjon fra fanene i prosjektsidene i Jira.</p> <p>Visste du at prosjektsider kj\xf8res med Confluence? Det er gratis for opptil ti brukere. Inviter resten av teamet i administratorinnstillingene.</p>",
    'project-pages.improvement.provisioning-info-modal.your-project-pages-in-jira.title': 'Prosjektsidene dine, direkte i Jira',
    'project-pages.improvement.templates-sidebar.better-together-templates-header': 'Maler integrert med Jira-dataene dine',
    'project-pages.improvement.templates.better-together-preview-teaser': 'Integrert med Jira-data',
    'project-pages.improvement.templates.blank-page.description': 'Start en side fra bunnen av.',
    'project-pages.improvement.templates.blank-page.name': 'Tom side',
    'project-pages.improvement.templates.decision.description': "F\xf8r opp viktige prosjektbeslutninger og formidle dem til teamet.",
    'project-pages.improvement.templates.decision.name': 'Beslutning',
    'project-pages.improvement.templates.meeting-notes.description': "Planlegg m\xf8ter, og del notater og handlingselementer med teamet.",
    'project-pages.improvement.templates.meeting-notes.name': "M\xf8tenotater",
    'project-pages.improvement.templates.post-expand.more': 'Flere maler',
    'project-pages.improvement.templates.post-expand.more.tooltip': 'Vis alle malene i Confluence',
    'project-pages.improvement.templates.post-expand.subtitle': "Popul\xe6re maler",
    'project-pages.improvement.templates.post-expand.title': 'Opprett en side',
    'project-pages.improvement.templates.pre-expand.more': 'Utforsk flere maler',
    'project-pages.improvement.templates.pre-expand.subtitle': "Popul\xe6re hos lignende team",
    'project-pages.improvement.templates.pre-expand.title': "Forh\xe5ndsvisning av maler",
    'project-pages.improvement.templates.product-requirements.description': 'Definer, spor og avgrens kravene for produktet eller funksjonen.',
    'project-pages.improvement.templates.product-requirements.name': 'Produktkrav',
    'project-pages.improvement.templates.retrospective.description': "Hva gikk bra? Hva kunne ha g\xe5tt bedre? Crowdsource forbedringer med teamet.",
    'project-pages.improvement.templates.retrospective.name': 'Retrospektiv',
    'project-pages.improvement.templates.template.disabled-tooltip': "Koble til et Confluence-omr\xe5de f\xf8rst",
    'project-pages.improvement.templates.tutorial.content.confluence-templates': "<b>Spar tid og reduser manuelle oppgaver</b>. Confluence har mange <a>sidemaler</a>, slik at du aldri trenger \xe5 starte fra bunnen av. Du finner maler for tekniske dokumenter, feils\xf8kingsveiledninger, prosjektplaner, produktkrav og mer.",
    'project-pages.improvement.templates.tutorial.content.edit-and-format': "<b>De er enkle \xe5 redigere og formatere.</b> Bruk redigeringsmenyen \xf8verst til standard tekstformatering, og du kan enkelt sette inn mange hendige integreringer ved \xe5 skrive inn <b>/</b>. Sett inn en tabell ved \xe5 skrive <c>/tabell</c> eller et bilde med <c>/bilde</c>. Du kan ogs\xe5 sette inn Dropbox-koblinger <c>/dropbox</c>, Microsoft Office-verkt\xf8y <c>/microsoft</c> eller Trello-tavler og kort <c>/trello</c>.",
    'project-pages.improvement.templates.tutorial.content.forward-slash-prompt': 'Skriv inn / etterfulgt av tabell eller bilde',
    'project-pages.improvement.templates.tutorial.content.getting-started-tips': "Her er et par tips for \xe5 komme i gang:",
    'project-pages.improvement.templates.tutorial.content.handy-links': 'Hendige koblinger',
    'project-pages.improvement.templates.tutorial.content.jira-and-confluence': 'Bruk Jira og Confluence sammen',
    'project-pages.improvement.templates.tutorial.content.jira-charts': "Opprett diagrammer p\xe5 sidene dine ved hjelp av Jira-data. Skriv inn <c>/Jira-diagrammer</c>.",
    'project-pages.improvement.templates.tutorial.content.jira-links': "Sett inn en kobling til en Jira-sak hvor som helst p\xe5 siden. Koblingen p\xe5 siden blir oppdatert i sanntid etter hvert som du oppdaterer Jira-saken. Skriv inn <c>/Jira</c>.",
    'project-pages.improvement.templates.tutorial.content.jira-links-issue-term-refresh': "Sett inn en kobling til en Jira-arbeidsoppgave hvor som helst p\xe5 siden. Koblingen p\xe5 siden blir oppdatert i sanntid etter hvert som du oppdaterer arbeidsoppgaven. Skriv inn <c>/Jira</c>.",
    'project-pages.improvement.templates.tutorial.content.jira-links.non-final-issue-term-refresh': "Sett inn en kobling til en Jira-arbeidsoppgave hvor som helst p\xe5 siden. Koblingen p\xe5 siden blir oppdatert i sanntid etter hvert som du oppdaterer arbeidsoppgaven. Skriv inn <c>/Jira</c>.",
    'project-pages.improvement.templates.tutorial.content.jira-roadmaps': "Bygg inn interaktive veikart og tidslinjer for siden din ved \xe5 bruke Jira-prosjektene dine. Skriv inn <c>/jira-veikart</c>.",
    'project-pages.improvement.templates.tutorial.content.jira-timeline': "Bygg inn interaktive tidslinjer for siden ved \xe5 bruke Jira-prosjekter. Skriv inn <c>/jira-tidslinje</c>.",
    'project-pages.improvement.templates.tutorial.content.shipping-speed-statistic': "76\xa0% av Jira Software-kundene sa at de leverte prosjekter raskere etter \xe5 ha lagt til Confluence",
    'project-pages.improvement.templates.tutorial.content.shipping-speed-statistic.spork-rebranding': "76\xa0% av Jira-kundene sa at de leverte prosjekter raskere etter \xe5 ha lagt til Confluence",
    'project-pages.improvement.templates.tutorial.content.spaces-and-pages': "<b>Bruk omr\xe5der og sider</b>. Omr\xe5der er en del av hvert Confluence-nettsted og er en m\xe5te \xe5 organisere sider i kategorier p\xe5. Tenk p\xe5 omr\xe5der som forskjellige mapper eller prosjekter, og sider som dokumentene som h\xf8rer hjemme i disse mappene eller prosjektene. <a>Finn ut mer om hvordan du bruker omr\xe5der</a>",
    'project-pages.improvement.templates.tutorial.content.try-it-now': "Pr\xf8v det n\xe5",
    'project-pages.improvement.templates.tutorial.description': 'Finn ut hvordan du redigerer en side.',
    'project-pages.improvement.templates.tutorial.name': 'Velkommen til Prosjektsider!',
    'project-pages.improvement.terms-and-conditions-v2': "N\xe5r du velger \xabPr\xf8v det n\xe5\xbb, bekrefter du at du blir registrert i Confluence og godtar Atlassian <termsLink>Clouds tjenestevilk\xe5r</termsLink> og <privacyLink>personvernerkl\xe6ring</privacyLink>.",
    'project-pages.improvement.title': 'Prosjektsider',
    'project-pages.improvement.transient-states.empty-state.auto-provisioned-create-page-button': 'Opprett side',
    'project-pages.improvement.transient-states.empty-state.auto-provisioned-description': "Vi har lagt til Confluence slik at du kan begynne \xe5 opprette og koble sammen alle prosjektdokumentene dine. Det er gratis for opptil ti brukere.",
    'project-pages.improvement.transient-states.empty-state.auto-provisioned-learn-more-button': 'Finn ut mer',
    'project-pages.improvement.transient-states.empty-state.create-page-button': "Opprett din f\xf8rste side",
    'project-pages.improvement.transient-states.empty-state.description': "Opprett m\xf8tenotater, produktkrav, beslutninger eller annet innhold for \xe5 fylle opp dette omr\xe5det.",
    'project-pages.improvement.transient-states.empty-state.title': 'Her finnes det ingenting annet enn potensial',
    'project-pages.improvement.try-button': "Pr\xf8v denne malen i Confluence",
    'project-pages.improvement.try-it-now': "Pr\xf8v det n\xe5",
    'project-pages.improvement.try-lozenge': "Pr\xf8v",
    'project-pages.improvement.try-on-demand-button': "Pr\xf8v det gratis",
    'project-pages.page-deleted-flag.title': 'Siden er slettet.',
    'project-pages.page-published-flag.title': 'Siden din er publisert.',
    'project-pages.unknown-error.description': "{contactSupport} hvis det ikke hjelper \xe5 oppdatere.",
    'project-pages.unknown-error.heading': "Vi kan ikke vise prosjektsider akkurat n\xe5"
};

});

parcelRegister("9Euto", function(module, exports) {

$parcel$export(module.exports, "default", () => $c786cc76e142f55b$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Polish (Poland)
var $c786cc76e142f55b$export$2e2bcd8739ae039 = {
    'confluence.project-pages.improvement.provisioning-background.text': "Powinno to\xa0zaj\u0105\u0107 mniej ni\u017C minut\u0119",
    'confluence.project-pages.improvement.provisioning-background.title': "Konfigurowanie stron projekt\xf3w",
    'confluence.project-pages.improvement.provisioning-modal-carousel.controls.dismiss': 'Zamknij',
    'confluence.project-pages.improvement.provisioning-modal-carousel.controls.done': 'Gotowe',
    'confluence.project-pages.improvement.provisioning-modal-carousel.controls.next': 'Dalej',
    'project-pages.activating.description': "Po\u0142\u0105czona przestrze\u0144 Confuence nie jest jeszcze gotowa. {contactSupport}, je\u015Bli od\u015Bwie\u017Cenie nie rozwi\u0105\u017Ce problemu.",
    'project-pages.activating.heading': "Confluence wci\u0105\u017C si\u0119 \u0142aduje",
    'project-pages.better-together-templates.meeting-notes.action-items-heading': "Czym s\u0105 czynno\u015Bci do wykonania?",
    'project-pages.better-together-templates.meeting-notes.agenda-item-label': 'Element planu spotkania',
    'project-pages.better-together-templates.meeting-notes.create-a-jira-issue': "Wpisz /Jira, aby utworzy\u0107 zg\u0142oszenie",
    'project-pages.better-together-templates.meeting-notes.date-label': 'Data',
    'project-pages.better-together-templates.meeting-notes.discussion-topics-heading': 'Tematy dyskusji',
    'project-pages.better-together-templates.meeting-notes.list-people': "wymie\u0144 osoby u\u017Cywaj\u0105ce",
    'project-pages.better-together-templates.meeting-notes.mention': 'wzmianka',
    'project-pages.better-together-templates.meeting-notes.mention-people-to-assign-them': "osoby lub os\xf3b, aby przypisa\u0107 je do czynno\u015Bci do wykonania",
    'project-pages.better-together-templates.meeting-notes.notes-label': 'Uwagi',
    'project-pages.better-together-templates.meeting-notes.page-title': 'Notatki ze spotkania',
    'project-pages.better-together-templates.meeting-notes.participants-label': 'Uczestnicy',
    'project-pages.better-together-templates.meeting-notes.project-label': 'Projekt',
    'project-pages.better-together-templates.product-requirements.create-a-jira-issue': "Wpisz /Jira, aby utworzy\u0107 zg\u0142oszenie",
    'project-pages.better-together-templates.product-requirements.design-heading': 'Projekt',
    'project-pages.better-together-templates.product-requirements.embedd-different-data-views': "Osadzaj r\xf3\u017Cne dane i\xa0widoki z\xa0projektu Jira.",
    'project-pages.better-together-templates.product-requirements.heading': "Przegl\u0105d",
    'project-pages.better-together-templates.product-requirements.how-will-you-know-if-fixed': "Jak stwierdzi\u0107, \u017Ce problem zosta\u0142 rozwi\u0105zany?",
    'project-pages.better-together-templates.product-requirements.impact-heading': "Wp\u0142yw",
    'project-pages.better-together-templates.product-requirements.inScopeStatus': "W\xa0zakresie",
    'project-pages.better-together-templates.product-requirements.insert-design-link': "Wstaw \u0142\u0105cze do projektu (Figma itp.)",
    'project-pages.better-together-templates.product-requirements.jira-issue-heading': "Zg\u0142oszenie Jira",
    'project-pages.better-together-templates.product-requirements.jira-roadmap-heading': 'Harmonogram Jira',
    'project-pages.better-together-templates.product-requirements.learn-how-with-smart-links': "Dowiedz si\u0119 jak dzi\u0119ki inteligentnym \u0142\u0105czom",
    'project-pages.better-together-templates.product-requirements.list-dashboards': "Wymie\u0144 pulpity (Amplitude, Mode itp.)",
    'project-pages.better-together-templates.product-requirements.list-design-considerations': "Wymie\u0144 kwestie dotycz\u0105ce projektu lub kompilacji",
    'project-pages.better-together-templates.product-requirements.list-people': "wymie\u0144 osoby u\u017Cywaj\u0105ce",
    'project-pages.better-together-templates.product-requirements.mention': 'wzmianki',
    'project-pages.better-together-templates.product-requirements.mention-people-to-assign-them': "osoby, aby przypisa\u0107 je do czynno\u015Bci do wykonania",
    'project-pages.better-together-templates.product-requirements.niceToHaveStatus': 'Mile widziane',
    'project-pages.better-together-templates.product-requirements.outOfScopeStatus': 'Poza zakresem',
    'project-pages.better-together-templates.product-requirements.page-title': "Wymagania dotycz\u0105ce produktu",
    'project-pages.better-together-templates.product-requirements.pro-tip': "Wskaz\xf3wka:",
    'project-pages.better-together-templates.product-requirements.problem-label': 'Problem',
    'project-pages.better-together-templates.product-requirements.requirement-heading': 'Wymaganie',
    'project-pages.better-together-templates.product-requirements.scope-heading': 'Zakres',
    'project-pages.better-together-templates.product-requirements.success-metric': "Wska\u017Anik sukcesu",
    'project-pages.better-together-templates.product-requirements.target-release-date': 'Docelowa data wydania',
    'project-pages.better-together-templates.product-requirements.team-label': "Zesp\xf3\u0142",
    'project-pages.better-together-templates.product-requirements.to-do-list-heading': "Lista zada\u0144 do\xa0wykonania",
    'project-pages.better-together-templates.product-requirements.what-are-you-trying-to-fix': "Co pr\xf3bujesz rozwi\u0105za\u0107?",
    'project-pages.better-together-templates.retro-notes.retro-heading': 'Retrospektywa',
    'project-pages.better-together-templates.retro.action-items-heading': "Czym s\u0105 czynno\u015Bci do wykonania?",
    'project-pages.better-together-templates.retro.create-a-jira-issue': "Wpisz /Jira, aby utworzy\u0107 zg\u0142oszenie",
    'project-pages.better-together-templates.retro.date-label': 'Data',
    'project-pages.better-together-templates.retro.embed-it-here': "Po zako\u0144czeniu mo\u017Cesz osadzi\u0107 tutaj.",
    'project-pages.better-together-templates.retro.list-people': "wymie\u0144 osoby u\u017Cywaj\u0105ce",
    'project-pages.better-together-templates.retro.mention': 'wzmianka',
    'project-pages.better-together-templates.retro.mention-people-to-assign-them': "osoby, aby przypisa\u0107 je do czynno\u015Bci do wykonania",
    'project-pages.better-together-templates.retro.page-title': 'Retrospektywa',
    'project-pages.better-together-templates.retro.participants-label': 'Uczestnicy',
    'project-pages.better-together-templates.retro.pro-tip': "Wskaz\xf3wka:",
    'project-pages.better-together-templates.retro.project-label': 'Projekt',
    'project-pages.better-together-templates.retro.this-is-a-whiteboard': 'To jest tablica Confluence.',
    'project-pages.better-together-templates.retro.use-a-whiteboard': "U\u017Cyj tablicy Confluence w\xa0celu przeprowadzenia retrospektywy.",
    'project-pages.better-together-templates.retro.use-it-to-vote': "U\u017Cyj jej, aby g\u0142osowa\u0107 i\xa0wsp\xf3\u0142pracowa\u0107 ze swoim zespo\u0142em.",
    'project-pages.button.connect-different-space-or-page.label': 'Ikona aktualizacji przestrzeni lub strony',
    'project-pages.button.connect-different-space-or-page.tooltip': "Po\u0142\u0105cz inn\u0105 przestrze\u0144 lub element",
    'project-pages.button.connect-space-or-page.tooltip': "Po\u0142\u0105cz z Confluence",
    'project-pages.button.go-to-connected-live-doc.tooltip': "Otw\xf3rz dokument online w\xa0Confluence",
    'project-pages.button.go-to-connected-page.tooltip': "Otw\xf3rz stron\u0119 w Confluence",
    'project-pages.button.go-to-connected-space.tooltip': "Otw\xf3rz przestrze\u0144 w Confluence",
    'project-pages.connect-space-dialog.connection-error': "Po\u0142\u0105czenie si\u0119 nie powiod\u0142o.",
    'project-pages.connect-space-dialog.connection-retry': "Spr\xf3buj ponownie",
    'project-pages.connect-space-dialog.content.space-or-page-selector.description': "Wybierz przestrze\u0144 lub element do po\u0142\u0105czenia z\xa0Twoim projektem.",
    'project-pages.connect-space-dialog.content.space-or-page-selector.placeholder': 'Szukaj w Confluence',
    'project-pages.connect-space-dialog.content.space-selector.disconnected-templates-description': "Przed utworzeniem elementu nale\u017Cy po\u0142\u0105czy\u0107 ten projekt z\xa0przestrzeni\u0105. Wybierz przestrze\u0144 do po\u0142\u0105czenia z\xa0tym projektem.",
    'project-pages.connect-space-dialog.error-icon': "B\u0142\u0105d:",
    'project-pages.connect-space-dialog.footer.cancel': 'Anuluj',
    'project-pages.connect-space-dialog.footer.connect-space': "Po\u0142\u0105cz",
    'project-pages.connect-space-or-page-dialog.header.title': "\u0141\u0105czenie projektu z Confluence",
    'project-pages.connect-space.description': "Przestrzenie s\u0105 jak foldery \u2014 mo\u017Cna w nich tworzy\u0107 tre\u015Bci zwi\u0105zane z projektem, organizowa\u0107 je i wsp\xf3\u0142pracowa\u0107 w ich ramach.",
    'project-pages.connect-space.not-connected.description': "Aby skorzysta\u0107 ze stron projektu, skontaktuj si\u0119 z administratorem lub kierownikiem zespo\u0142u w celu po\u0142\u0105czenia Confluence z tym projektem.",
    'project-pages.connect-space.not-connected.heading': "Nie po\u0142\u0105czono z Confluence",
    'project-pages.connect-success-flag.description.content': "Po\u0142\u0105czenie z\xa0tre\u015Bci\u0105 {connectedSpaceOrPageName} powiod\u0142o si\u0119.",
    'project-pages.connection-error.space-or-page-not-found.button': "Po\u0142\u0105cz z inn\u0105 przestrzeni\u0105 lub stron\u0105",
    'project-pages.create-space-dialog.connection-error': "Po\u0142\u0105czenie si\u0119 nie powiod\u0142o.",
    'project-pages.create-space-dialog.connection-retry': "Spr\xf3buj ponownie",
    'project-pages.create-space-dialog.content.empty-name': "Wprowad\u017A nazw\u0119 przestrzeni.",
    'project-pages.create-space-dialog.content.invalid-name': "Nazwa przestrzeni musi zawiera\u0107 przynajmniej jedn\u0105 liter\u0119 lub cyfr\u0119.",
    'project-pages.create-space-dialog.content.placeholder': "Wprowad\u017A nazw\u0119 przestrzeni",
    'project-pages.create-space-dialog.creation-error': "Tworzenie przestrzeni nie powiod\u0142o si\u0119.",
    'project-pages.create-space-dialog.error-icon': "B\u0142\u0105d:",
    'project-pages.create-space-dialog.footer.cancel': 'Anuluj',
    'project-pages.create-space-dialog.footer.create-space': "Utw\xf3rz",
    'project-pages.create-space-dialog.header.title': "Utw\xf3rz now\u0105 przestrze\u0144 Confluence",
    'project-pages.cross-join.access-revoked.templates.subtitle': "Nie mo\u017Cesz korzysta\u0107 ze stron projektu, poniewa\u017C administrator odm\xf3wi\u0142 Ci dost\u0119pu do Confluence. Skontaktuj si\u0119 z administratorem witryny, aby uzyska\u0107 dost\u0119p.",
    'project-pages.cross-join.access-revoked.templates.title': "Nie masz uprawnie\u0144 do korzystania ze stron projektu",
    'project-pages.cross-join.avatar.view-profile': "Wy\u015Bwietl profil",
    'project-pages.cross-join.denied-request.templates.subtitle': "Nie mo\u017Cesz korzysta\u0107 ze stron projektu, poniewa\u017C administrator witryny odrzuci\u0142 Tw\xf3j wniosek o do\u0142\u0105czenie do Confluence.",
    'project-pages.cross-join.denied-request.templates.title': "Administrator odm\xf3wi\u0142 Ci dost\u0119pu",
    'project-pages.cross-join.direct-access.button-subtitle.experimental': "Uzyskasz dost\u0119p do\xa0Confluence. Administrator witryny ju\u017C zatwierdzi\u0142 do\u0142\u0105czenie.",
    'project-pages.cross-join.errors.unknown-error.description': "{contactSupport}, je\u015Bli od\u015Bwie\u017Cenie nie rozwi\u0105\u017Ce problemu.",
    'project-pages.cross-join.errors.unknown-error.title': "Obecnie nie mo\u017Cna wy\u015Bwietli\u0107 stron projektu",
    'project-pages.cross-join.inline-join-product.button': "Uzyskasz dost\u0119p do Confluence. Administrator witryny ju\u017C zatwierdzi\u0142 do\u0142\u0105czenie.",
    'project-pages.cross-join.inline-join-product.connected.description': "Wy\u015Bwietlaj, edytuj i tw\xf3rz dokumentacj\u0119 w jednym miejscu",
    'project-pages.cross-join.inline-join-product.connected.title': "Wsp\xf3\u0142pracuj nad stronami projektu ze swoim zespo\u0142em",
    'project-pages.cross-join.pending-request.templates.subtitle': "Administrator witryny otrzyma\u0142 Tw\xf3j wniosek o do\u0142\u0105czenie do Confluence. Po jego zatwierdzeniu strony projektu zaczn\u0105 dzia\u0142a\u0107 i otrzymasz wiadomo\u015B\u0107 e-mail z potwierdzeniem.",
    'project-pages.cross-join.pending-request.templates.subtitle.experiment': "Po\xa0zatwierdzeniu otrzymasz wiadomo\u015B\u0107 e-mail z\xa0danymi dost\u0119powymi do\xa0stron projekt\xf3w.",
    'project-pages.cross-join.pending-request.templates.title': "Wys\u0142ano wniosek o dost\u0119p do Confluence",
    'project-pages.cross-join.pending-request.templates.title.experiment': "Wys\u0142ano do\xa0administratora wniosek o\xa0dost\u0119p",
    'project-pages.cross-join.request-access-without-better-together.connected.description': "Wy\u015Bwietlaj, edytuj i tw\xf3rz dokumentacj\u0119 projektu wraz z zespo\u0142em",
    'project-pages.cross-join.request-access.button': "Popro\u015B o dost\u0119p",
    'project-pages.cross-join.request-access.button-subtitle.experimental': "Wybieraj\u0105c opcj\u0119 \u201EDo\u0142\u0105cz do\xa0zespo\u0142u\u201D, prosisz o\xa0do\u0142\u0105czenie do\xa0Confluence i\xa0wyra\u017Casz zgod\u0119 na\xa0udost\u0119pnienie profilu Atlassian swojemu administratorowi.",
    'project-pages.cross-join.request-access.button.experimental': "Do\u0142\u0105cz do\xa0swojego zespo\u0142u",
    'project-pages.cross-join.request-access.connected.description.experimental': "Tw\xf3j zesp\xf3\u0142 korzysta ze\xa0stron projektu w\xa0celu komentowania, edytowania i\xa0wsp\xf3\u0142pracy nad dokumentacj\u0105 projektow\u0105 bez wychodzenia z\xa0Jiry. Do\u0142\u0105cz do\xa0Confluence, aby zyska\u0107 dost\u0119p do\xa0stron projektu Twojego zespo\u0142u.",
    'project-pages.cross-join.request-access.title': "Strony projektu wymagaj\u0105 dost\u0119pu do Confluence",
    'project-pages.cross-join.request-access.title.experiment': "Stw\xf3rz pojedyncze \u017Ar\xf3d\u0142o rzetelnych informacji dla swojego zespo\u0142u",
    'project-pages.default-contextual-heading': "Strony projektu s\u0105 obs\u0142ugiwane przez Confluence",
    'project-pages.default-contextual-message': "Tw\xf3rz dokumenty projektu, udost\u0119pniaj je i wsp\xf3\u0142pracuj \u2014 wszystko z jednego miejsca na stronach Confluence.",
    'project-pages.default-reactivate-CTA': 'Ponownie aktywuj Confluence',
    'project-pages.default-trial-CTA': "Wypr\xf3buj Confluence bezp\u0142atnie przez 30 dni",
    'project-pages.draft-saved-flag.action': "Otw\xf3rz wersj\u0119 robocz\u0105",
    'project-pages.draft-saved-flag.description': "Twoja wersja robocza b\u0119dzie widoczna tylko dla Ciebie, dop\xf3ki jej nie opublikujesz.",
    'project-pages.draft-saved-flag.title': "Zapisano wersj\u0119 robocz\u0105",
    'project-pages.embedded-pages.create-page-error.close-button': 'Zamknij',
    'project-pages.embedded-pages.create-page-error.description': "Wyst\u0105pi\u0142 problem i nie mo\u017Cemy utworzy\u0107 strony.",
    'project-pages.embedded-pages.create-page-error.title': "Nie mo\u017Cna utworzy\u0107 strony",
    'project-pages.embedded-pages.create-page-error.try-again-button': "Spr\xf3buj ponownie",
    'project-pages.embedded-pages.modal.close.button.hint': 'Zamknij',
    'project-pages.embedded-pages.modal.title.button': "Otw\xf3rz w Confluence",
    'project-pages.embedded-pages.modal.title.button.hint': "Otw\xf3rz w nowej karcie",
    'project-pages.errors.unknown-error.description.non-final': "{contactSupport}, je\u015Bli od\u015Bwie\u017Cenie nie usunie problemu.",
    'project-pages.errors.unknown-error.title.non-final': "Nie mo\u017Cna teraz wy\u015Bwietli\u0107 stron projektu",
    'project-pages.generic-error.button.reload': "Za\u0142aduj stron\u0119 ponownie",
    'project-pages.generic-error.description': "Co\u015B posz\u0142o nie tak. Spr\xf3buj ponownie p\xf3\u017Aniej.",
    'project-pages.generic-error.description.non-final': "Co\u015B posz\u0142o nie tak. Spr\xf3buj ponownie p\xf3\u017Aniej.",
    'project-pages.generic-error.heading': "To dziwne\u2026",
    'project-pages.generic-error.title.non-final': "To dziwne\u2026",
    'project-pages.generic-info-flag.description': "Co\u015B posz\u0142o nie tak. Spr\xf3buj ponownie albo skontaktuj si\u0119 z\xa0dzia\u0142em wsparcia, je\u017Celi problem nie ust\u0105pi.",
    'project-pages.generic-success-flag.description.live-doc': "Po\u0142\u0105czenie z\xa0dokumentem online {connectedSpaceOrPageName} powiod\u0142o si\u0119.",
    'project-pages.generic-success-flag.description.page': "Po\u0142\u0105czenie ze stron\u0105 {connectedSpaceOrPageName} powiod\u0142o si\u0119.",
    'project-pages.generic-success-flag.description.space': "Po\u0142\u0105czenie z przestrzeni\u0105 {connectedSpaceOrPageName} powiod\u0142o si\u0119.",
    'project-pages.generic-success-flag.heading.live-doc': "Po\u0142\u0105czono dokument online",
    'project-pages.generic-success-flag.heading.page': "Strona po\u0142\u0105czona",
    'project-pages.generic-success-flag.heading.space': "Przestrze\u0144 po\u0142\u0105czona",
    'project-pages.granular-pages.connect-space-dialog.content.create-space-link.link-text': "Lub utw\xf3rz now\u0105 przestrze\u0144",
    'project-pages.granular-pages.connect-space.button': "Po\u0142\u0105cz z Confluence",
    'project-pages.granular-pages.connect-space.heading': "\u0141\u0105czenie tego projektu z\xa0przestrzeni\u0105 lub elementem Confluence",
    'project-pages.improvement.contact-support': "Skontaktuj si\u0119 z zespo\u0142em wsparcia",
    'project-pages.improvement.errors.access-error.description': "Spr\xf3buj skontaktowa\u0107 si\u0119 z administratorem witryny, aby poprosi\u0107 o dost\u0119p.",
    'project-pages.improvement.errors.access-error.title': "Nie masz uprawnie\u0144 do przegl\u0105dania stron projektu",
    'project-pages.improvement.errors.page-tree-unknown-error.description': "Co\u015B posz\u0142o nie tak podczas pr\xf3by wy\u015Bwietlenia stron z po\u0142\u0105czonej przestrzeni Confluence. {contactSupport}, je\u015Bli od\u015Bwie\u017Cenie nie usunie problemu.",
    'project-pages.improvement.errors.page-tree-unknown-error.title': "Wyst\u0119puj\u0105 problemy z wy\u015Bwietlaniem stron projektu",
    'project-pages.improvement.errors.space-or-page-not-found.description': "Po\u0142\u0105czona przestrze\u0144 lub strona Confluence zosta\u0142a przeniesiona, zarchiwizowana lub usuni\u0119ta. <link>Skontaktuj si\u0119 z\xa0dzia\u0142em wsparcia</link>, je\u015Bli ponowne po\u0142\u0105czenie nie rozwi\u0105\u017Ce problemu.",
    'project-pages.improvement.errors.space-or-page-not-found.title': 'Nie znaleziono przestrzeni lub strony',
    'project-pages.improvement.errors.unknown-error.description': "{contactSupport}, je\u015Bli od\u015Bwie\u017Cenie nie naprawi problemu.",
    'project-pages.improvement.errors.unknown-error.title': "Obecnie nie mo\u017Cna wy\u015Bwietli\u0107 stron projektu",
    'project-pages.improvement.feature1': "Dost\u0119p do\xa0dokument\xf3w i\xa0ich tworzenie bez opuszczania systemu Jira",
    'project-pages.improvement.feature2': "Szablony spotka\u0144, plan\xf3w sprint\xf3w i\xa0wiele innych",
    'project-pages.improvement.feature3': "Synchronizacja dokument\xf3w z\xa0systemem Jira na\xa0potrzeby automatycznych aktualizacji",
    'project-pages.improvement.heading-info': "Zgromad\u017A wiedz\u0119 zespo\u0142u i usprawnij spos\xf3b pracy.",
    'project-pages.improvement.heading-info-v2': "Utw\xf3rz jedno miejsce dla wszystkich dokument\xf3w projektowych zespo\u0142u",
    'project-pages.improvement.learn-more-button': "Dowiedz si\u0119 wi\u0119cej",
    'project-pages.improvement.powered-by': "Obs\u0142ugiwane przez",
    'project-pages.improvement.powered-by.tooltip': "Otw\xf3rz Confluence w nowej karcie",
    'project-pages.improvement.preview-teaser': 'Odblokuj szablony, strony projektu i wiele innych.',
    'project-pages.improvement.provisioning-info-modal.seamlessly-update-stakeholders.description': "<p>Dzi\u0119ki automatycznie aktualizowanym etykietom statusu raporty z\xa0projekt\xf3w s\u0105\xa0zawsze aktualne.</p> <p>Po prostu dodaj \u0142\u0105cze do\xa0zg\u0142oszenia Jira w\xa0dokumencie, aby automatycznie wy\u015Bwietla\u0107 etykiet\u0119 statusu aktualizowan\u0105 razem ze\xa0zg\u0142oszeniem, dzi\u0119ki czemu nie trzeba traci\u0107 czasu na\xa0r\u0119czne tworzenie raport\xf3w.</p>",
    'project-pages.improvement.provisioning-info-modal.seamlessly-update-stakeholders.title': "Bezproblemowe informowanie na\xa0bie\u017C\u0105co interesariuszy",
    'project-pages.improvement.provisioning-info-modal.unify-documentation-standards.description': "<p>Tw\xf3rz sp\xf3jn\u0105 dokumentacj\u0119, korzystaj\u0105c z\xa0naszych wbudowanych szablon\xf3w. S\u0105 one proste w\xa0u\u017Cyciu i\xa0mo\u017Cna je\xa0dostosowa\u0107 do\xa0w\u0142asnych potrzeb.</p> <p>Mo\u017Cesz u\u017Cywa\u0107 szablon\xf3w bezpo\u015Brednio z\xa0poziomu stron projekt\xf3w, wi\u0119c nie musisz odrywa\u0107 si\u0119 od\xa0tego, nad czym pracujesz. Przegl\u0105daj wszystkie szablony <a>tutaj</a>.</p>",
    'project-pages.improvement.provisioning-info-modal.unify-documentation-standards.title': "Ujednolicenie standard\xf3w dokumentacji",
    'project-pages.improvement.provisioning-info-modal.your-project-pages-in-jira.description': "<p>Zapewnij pojedyncze \u017Ar\xf3d\u0142o wa\u017Cnych informacji, tworz\u0105c dokumentacj\u0119 i\xa0zarz\u0105dzaj\u0105c ni\u0105 na\xa0karcie Strony projektu w\xa0systemie Jira.</p> <p>Czy wiesz, \u017Ce\xa0strony projekt\xf3w dzia\u0142aj\u0105 w\xa0Confluence? Jest to\xa0bezp\u0142atne rozwi\u0105zanie dla maksymalnie 10\xa0u\u017Cytkownik\xf3w. Zapro\u015B reszt\u0119 swojego zespo\u0142u w\xa0ustawieniach administratora.</p>",
    'project-pages.improvement.provisioning-info-modal.your-project-pages-in-jira.title': "Twoje strony projekt\xf3w, bezpo\u015Brednio w\xa0systemie Jira",
    'project-pages.improvement.templates-sidebar.better-together-templates-header': "Szablony zintegrowane z\xa0danymi Jiry",
    'project-pages.improvement.templates.better-together-preview-teaser': "Integracja z\xa0danymi Jiry",
    'project-pages.improvement.templates.blank-page.description': 'Rozpocznij od pustej strony.',
    'project-pages.improvement.templates.blank-page.name': 'Pusta strona',
    'project-pages.improvement.templates.decision.description': "Rejestruj wa\u017Cne decyzje dotycz\u0105ce projektu i przekazuj je zespo\u0142owi.",
    'project-pages.improvement.templates.decision.name': 'Decyzja',
    'project-pages.improvement.templates.meeting-notes.description': "Okre\u015Blaj plany spotka\u0144, r\xf3b notatki i udost\u0119pniaj zespo\u0142owi zadania do wykonania.",
    'project-pages.improvement.templates.meeting-notes.name': 'Notatki ze spotkania',
    'project-pages.improvement.templates.post-expand.more': "Wi\u0119cej szablon\xf3w",
    'project-pages.improvement.templates.post-expand.more.tooltip': "Wy\u015Bwietl wszystkie szablony w Confluence",
    'project-pages.improvement.templates.post-expand.subtitle': 'Popularne szablony',
    'project-pages.improvement.templates.post-expand.title': "Utw\xf3rz stron\u0119",
    'project-pages.improvement.templates.pre-expand.more': "Poznaj wi\u0119cej szablon\xf3w",
    'project-pages.improvement.templates.pre-expand.subtitle': "Popularne w zespo\u0142ach takich jak Tw\xf3j",
    'project-pages.improvement.templates.pre-expand.title': "Wy\u015Bwietl podgl\u0105d szablon\xf3w",
    'project-pages.improvement.templates.product-requirements.description': "Definiuj i \u015Bled\u017A wymagania dotycz\u0105ce produktu lub funkcji oraz ustalaj ich zakres.",
    'project-pages.improvement.templates.product-requirements.name': "Wymagania dotycz\u0105ce produktu",
    'project-pages.improvement.templates.retrospective.description': "Co zrobili\u015Bmy dobrze? Co powinni\u015Bmy zrobi\u0107 lepiej? Okre\u015Bl usprawnienia z Twoim zespo\u0142em, korzystaj\u0105c z metody crowdsourcingu.",
    'project-pages.improvement.templates.retrospective.name': 'Retrospektywa',
    'project-pages.improvement.templates.template.disabled-tooltip': "Najpierw po\u0142\u0105cz przestrze\u0144 Confluence",
    'project-pages.improvement.templates.tutorial.content.confluence-templates': "<b>Oszcz\u0119dzaj czas, ograniczaj\u0105c r\u0119czne wykonywanie zada\u0144</b>. Confluence zawiera wiele <a>szablon\xf3w</a> stron, dzi\u0119ki czemu nigdy nie musisz zaczyna\u0107 od zera. Pomy\u015Bl o dokumentacji technicznej, przewodnikach rozwi\u0105zywania problem\xf3w, planach projekt\xf3w, wymaganiach dotycz\u0105cych produkt\xf3w i wielu innych dokumentach.",
    'project-pages.improvement.templates.tutorial.content.edit-and-format': "<b>\u0141atwa edycja i proste formatowanie</b>. G\xf3rne menu edycji pozwala korzysta\u0107 ze standardowych funkcji formatowania tekstu, a wpisuj\u0105c symbol <b>/</b>, mo\u017Cesz z \u0142atwo\u015Bci\u0105 wstawi\u0107 mn\xf3stwo por\u0119cznych integracji. Polecenie <c>/tabela</c> pozwoli wstawi\u0107 tabel\u0119, a polecenie <c>/obraz</c> \u2014 obraz. Mo\u017Cesz r\xf3wnie\u017C wstawi\u0107 \u0142\u0105cza Dropbox za pomoc\u0105 polecenia <c>/dropbox</c>, narz\u0119dzia Microsoft Office <c>/microsoft</c> lub tablice i karty Trello za pomoc\u0105 polecenia <c>/trello</c>.",
    'project-pages.improvement.templates.tutorial.content.forward-slash-prompt': "Wystarczy wpisa\u0107 symbol uko\u015Bnika /, a nast\u0119pnie odpowiednie s\u0142owo, takie jak tabela lub obraz",
    'project-pages.improvement.templates.tutorial.content.getting-started-tips': "Poni\u017Cej przedstawiamy kilka porad na pocz\u0105tek:",
    'project-pages.improvement.templates.tutorial.content.handy-links': "Por\u0119czne \u0142\u0105cza",
    'project-pages.improvement.templates.tutorial.content.jira-and-confluence': "Korzystaj z rozwi\u0105za\u0144 Jira i Confluence w kombinacji",
    'project-pages.improvement.templates.tutorial.content.jira-charts': "Utw\xf3rz na swoich stronach wykresy, korzystaj\u0105c z rzeczywistych danych Jira. Wpisz polecenie <c>/wykresy Jira</c>.",
    'project-pages.improvement.templates.tutorial.content.jira-links': "Utw\xf3rz \u0142\u0105cze do zg\u0142oszenia Jira w dowolnym miejscu na stronie. \u0141\u0105cze na stronie b\u0119dzie aktualizowane w czasie rzeczywistym w miar\u0119 aktualizacji zg\u0142oszenia w systemie Jira. Wpisz polecenie <c>/Jira</c>.",
    'project-pages.improvement.templates.tutorial.content.jira-links-issue-term-refresh': "Utw\xf3rz \u0142\u0105cze do zg\u0142oszenia Jira w\xa0dowolnym miejscu na stronie. \u0141\u0105cze na stronie b\u0119dzie aktualizowane w\xa0czasie rzeczywistym w\xa0miar\u0119 aktualizacji zg\u0142oszenia. Wpisz polecenie <c>/Jira</c>.",
    'project-pages.improvement.templates.tutorial.content.jira-links.non-final-issue-term-refresh': "Utw\xf3rz \u0142\u0105cze do zg\u0142oszenia Jira w\xa0dowolnym miejscu na stronie. \u0141\u0105cze na stronie b\u0119dzie aktualizowane w\xa0czasie rzeczywistym w\xa0miar\u0119 aktualizacji zg\u0142oszenia. Wpisz polecenie <c>/Jira</c>.",
    'project-pages.improvement.templates.tutorial.content.jira-roadmaps': "Korzystaj\u0105c z Projekt\xf3w Jira, osad\u017A na swojej stronie interaktywne harmonogramy i osie czasu. Wpisz polecenie <c>/harmonogram jira</c>.",
    'project-pages.improvement.templates.tutorial.content.jira-timeline': "Korzystaj\u0105c z projekt\xf3w Jira, osad\u017A na swojej stronie interaktywne osie czasu. Wpisz <c>/o\u015B czasu jira</c>.",
    'project-pages.improvement.templates.tutorial.content.shipping-speed-statistic': "76% klient\xf3w korzystaj\u0105cych z Jira Software stwierdzi\u0142o, \u017Ce realizowa\u0142o projekty szybciej po dodaniu integracji z Confluence",
    'project-pages.improvement.templates.tutorial.content.shipping-speed-statistic.spork-rebranding': "76%\xa0klient\xf3w korzystaj\u0105cych z\xa0systemu Jira stwierdzi\u0142o, \u017Ce\xa0realizowa\u0142o projekty szybciej po\xa0dodaniu integracji z\xa0Confluence",
    'project-pages.improvement.templates.tutorial.content.spaces-and-pages': "<b>Korzystanie z przestrzeni i stron</b>. Przestrzenie s\u0105 cz\u0119\u015Bci\u0105 ka\u017Cdej witryny Confluence i sposobem na uporz\u0105dkowanie stron w kategorie. Wyobra\u017A sobie przestrzenie jako r\xf3\u017Cne foldery lub projekty, a strony, jako znajduj\u0105ce si\u0119 w nich dokumenty. <a>Dowiedz si\u0119 wi\u0119cej o sposobie korzystania z tych przestrzeni</a>",
    'project-pages.improvement.templates.tutorial.content.try-it-now': "Wypr\xf3buj teraz",
    'project-pages.improvement.templates.tutorial.description': "Dowiedz si\u0119, jak edytowa\u0107 stron\u0119.",
    'project-pages.improvement.templates.tutorial.name': 'Witamy na stronach projektu!',
    'project-pages.improvement.terms-and-conditions-v2': "Klikaj\u0105c przycisk \u201EWypr\xf3buj teraz\u201D, potwierdzasz rejestracje w\xa0Confluence i\xa0akceptujesz <termsLink>Warunki \u015Bwiadczenia us\u0142ug Cloud</termsLink> oraz <privacyLink>Polityk\u0119 prywatno\u015Bci</privacyLink> Atlassian.",
    'project-pages.improvement.title': "Strony projekt\xf3w",
    'project-pages.improvement.transient-states.empty-state.auto-provisioned-create-page-button': "Utw\xf3rz stron\u0119",
    'project-pages.improvement.transient-states.empty-state.auto-provisioned-description': "Dodali\u015Bmy Confluence, wi\u0119c mo\u017Cesz zacz\u0105\u0107 tworzy\u0107 ca\u0142\u0105 dokumentacj\u0119 i po\u0142\u0105czy\u0107 j\u0105 ze swoim projektem. Wersja jest bezp\u0142atna dla maksymalnie 10 u\u017Cytkownik\xf3w.",
    'project-pages.improvement.transient-states.empty-state.auto-provisioned-learn-more-button': "Dowiedz si\u0119 wi\u0119cej",
    'project-pages.improvement.transient-states.empty-state.create-page-button': "Utw\xf3rz swoj\u0105 pierwsz\u0105 stron\u0119",
    'project-pages.improvement.transient-states.empty-state.description': "Utw\xf3rz notatki ze spotka\u0144, wymagania produktowe, decyzje lub inne tre\u015Bci, aby wype\u0142ni\u0107 t\u0119 przestrze\u0144.",
    'project-pages.improvement.transient-states.empty-state.title': "Nie ma tu nic opr\xf3cz potencja\u0142u",
    'project-pages.improvement.try-button': "Wypr\xf3buj ten szablon w Confluence",
    'project-pages.improvement.try-it-now': "Wypr\xf3buj teraz",
    'project-pages.improvement.try-lozenge': "Wypr\xf3buj",
    'project-pages.improvement.try-on-demand-button': "Wypr\xf3buj bezp\u0142atnie",
    'project-pages.page-deleted-flag.title': "Usuni\u0119to stron\u0119.",
    'project-pages.page-published-flag.title': "Twoja strona zosta\u0142a opublikowana.",
    'project-pages.unknown-error.description': "{contactSupport}, je\u015Bli od\u015Bwie\u017Cenie nie naprawi problemu.",
    'project-pages.unknown-error.heading': "Nie mo\u017Cna teraz wy\u015Bwietli\u0107 stron projektu"
};

});

parcelRegister("1r9WC", function(module, exports) {

$parcel$export(module.exports, "default", () => $1f6f7f0d55b8e82d$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Portuguese (Brazil)
var $1f6f7f0d55b8e82d$export$2e2bcd8739ae039 = {
    'confluence.project-pages.improvement.provisioning-background.text': 'Deve levar menos de um minuto',
    'confluence.project-pages.improvement.provisioning-background.title': "Como configurar p\xe1ginas de projeto",
    'confluence.project-pages.improvement.provisioning-modal-carousel.controls.dismiss': 'Ignorar',
    'confluence.project-pages.improvement.provisioning-modal-carousel.controls.done': "Conclu\xeddo",
    'confluence.project-pages.improvement.provisioning-modal-carousel.controls.next': "Pr\xf3ximo",
    'project-pages.activating.description': "O espa\xe7o conectado do Confluence ainda n\xe3o est\xe1 pronto por completo. {contactSupport} se a atualiza\xe7\xe3o n\xe3o funcionar.",
    'project-pages.activating.heading': "O Confluence ainda est\xe1 carregando",
    'project-pages.better-together-templates.meeting-notes.action-items-heading': "Quais s\xe3o os itens de a\xe7\xe3o?",
    'project-pages.better-together-templates.meeting-notes.agenda-item-label': 'Item de agenda',
    'project-pages.better-together-templates.meeting-notes.create-a-jira-issue': 'Digite /Jira para criar um item',
    'project-pages.better-together-templates.meeting-notes.date-label': 'Data',
    'project-pages.better-together-templates.meeting-notes.discussion-topics-heading': "T\xf3picos de discuss\xe3o",
    'project-pages.better-together-templates.meeting-notes.list-people': 'listar pessoas usando',
    'project-pages.better-together-templates.meeting-notes.mention': 'mencionar',
    'project-pages.better-together-templates.meeting-notes.mention-people-to-assign-them': "pessoas para atribuir a um item de a\xe7\xe3o",
    'project-pages.better-together-templates.meeting-notes.notes-label': 'Notas',
    'project-pages.better-together-templates.meeting-notes.page-title': "Anota\xe7\xf5es de reuni\xe3o",
    'project-pages.better-together-templates.meeting-notes.participants-label': 'Participantes',
    'project-pages.better-together-templates.meeting-notes.project-label': 'Projeto',
    'project-pages.better-together-templates.product-requirements.create-a-jira-issue': 'Digite /Jira para criar um item',
    'project-pages.better-together-templates.product-requirements.design-heading': 'Design',
    'project-pages.better-together-templates.product-requirements.embedd-different-data-views': "incorpore diferentes dados e visualiza\xe7\xf5es do seu projeto Jira.",
    'project-pages.better-together-templates.product-requirements.heading': "Vis\xe3o geral",
    'project-pages.better-together-templates.product-requirements.how-will-you-know-if-fixed': "Como voc\xea vai saber se foi corrigido?",
    'project-pages.better-together-templates.product-requirements.impact-heading': 'Impacto',
    'project-pages.better-together-templates.product-requirements.inScopeStatus': 'No escopo',
    'project-pages.better-together-templates.product-requirements.insert-design-link': 'Insira um link para seu design (Figma, etc)',
    'project-pages.better-together-templates.product-requirements.jira-issue-heading': 'Item do Jira',
    'project-pages.better-together-templates.product-requirements.jira-roadmap-heading': 'Roteiro do Jira',
    'project-pages.better-together-templates.product-requirements.learn-how-with-smart-links': 'Saiba como fazer isso com links inteligentes',
    'project-pages.better-together-templates.product-requirements.list-dashboards': "Listar pain\xe9is (amplitude, modo, etc.)",
    'project-pages.better-together-templates.product-requirements.list-design-considerations': "Listar considera\xe7\xf5es sobre design ou cria\xe7\xe3o",
    'project-pages.better-together-templates.product-requirements.list-people': 'listar pessoas usando',
    'project-pages.better-together-templates.product-requirements.mention': 'mencionar',
    'project-pages.better-together-templates.product-requirements.mention-people-to-assign-them': "pessoas para atribuir a um item de a\xe7\xe3o",
    'project-pages.better-together-templates.product-requirements.niceToHaveStatus': "\xc9 bom ter",
    'project-pages.better-together-templates.product-requirements.outOfScopeStatus': 'Fora do escopo',
    'project-pages.better-together-templates.product-requirements.page-title': 'Requisitos do produto',
    'project-pages.better-together-templates.product-requirements.pro-tip': 'Dica profissional:',
    'project-pages.better-together-templates.product-requirements.problem-label': 'Problema',
    'project-pages.better-together-templates.product-requirements.requirement-heading': 'Requisitos',
    'project-pages.better-together-templates.product-requirements.scope-heading': 'Escopo',
    'project-pages.better-together-templates.product-requirements.success-metric': "M\xe9trica de sucesso",
    'project-pages.better-together-templates.product-requirements.target-release-date': "Data de lan\xe7amento pretendida",
    'project-pages.better-together-templates.product-requirements.team-label': 'Equipe',
    'project-pages.better-together-templates.product-requirements.to-do-list-heading': 'Lista de coisas a fazer',
    'project-pages.better-together-templates.product-requirements.what-are-you-trying-to-fix': "O que voc\xea est\xe1 tentando corrigir?",
    'project-pages.better-together-templates.retro-notes.retro-heading': 'Retrospectiva',
    'project-pages.better-together-templates.retro.action-items-heading': "Quais s\xe3o os itens de a\xe7\xe3o?",
    'project-pages.better-together-templates.retro.create-a-jira-issue': 'Digite /Jira para criar um item',
    'project-pages.better-together-templates.retro.date-label': 'Data',
    'project-pages.better-together-templates.retro.embed-it-here': "Depois de terminar, voc\xea pode adicionar aqui.",
    'project-pages.better-together-templates.retro.list-people': 'listar pessoas usando',
    'project-pages.better-together-templates.retro.mention': 'mencionar',
    'project-pages.better-together-templates.retro.mention-people-to-assign-them': "pessoas para atribuir a um item de a\xe7\xe3o",
    'project-pages.better-together-templates.retro.page-title': 'Retrospectiva',
    'project-pages.better-together-templates.retro.participants-label': 'Participantes',
    'project-pages.better-together-templates.retro.pro-tip': 'Dica profissional:',
    'project-pages.better-together-templates.retro.project-label': 'Projeto',
    'project-pages.better-together-templates.retro.this-is-a-whiteboard': "Este \xe9 um quadro branco do Confluence.",
    'project-pages.better-together-templates.retro.use-a-whiteboard': 'Use um quadro branco do Confluence para sua retrospectiva.',
    'project-pages.better-together-templates.retro.use-it-to-vote': 'Use para votar e colaborar com sua equipe.',
    'project-pages.button.connect-different-space-or-page.label': "Atualizar o espa\xe7o ou \xedcone da p\xe1gina",
    'project-pages.button.connect-different-space-or-page.tooltip': "Conectar um espa\xe7o ou item diferente",
    'project-pages.button.connect-space-or-page.tooltip': 'Conectar ao Confluence',
    'project-pages.button.go-to-connected-live-doc.tooltip': "Abrir um documento din\xe2mico no Confluence",
    'project-pages.button.go-to-connected-page.tooltip': "Abrir p\xe1gina no Confluence",
    'project-pages.button.go-to-connected-space.tooltip': "Abrir espa\xe7o no Confluence",
    'project-pages.connect-space-dialog.connection-error': "Falha na conex\xe3o.",
    'project-pages.connect-space-dialog.connection-retry': 'Tentar novamente',
    'project-pages.connect-space-dialog.content.space-or-page-selector.description': "Escolha um espa\xe7o ou item para conectar ao seu projeto.",
    'project-pages.connect-space-dialog.content.space-or-page-selector.placeholder': 'Pesquisar no Confluence',
    'project-pages.connect-space-dialog.content.space-selector.disconnected-templates-description': "Esse projeto precisa ser conectado a um espa\xe7o antes que voc\xea possa criar um item. Escolha um espa\xe7o para conectar a este projeto.",
    'project-pages.connect-space-dialog.error-icon': 'Erro:',
    'project-pages.connect-space-dialog.footer.cancel': 'Cancelar',
    'project-pages.connect-space-dialog.footer.connect-space': 'Conectar',
    'project-pages.connect-space-or-page-dialog.header.title': 'Conecte o projeto ao Confluence',
    'project-pages.connect-space.description': "Espa\xe7os s\xe3o como pastas: podem ser usados para criar, organizar e colaborar em todo o conte\xfado relacionado ao seu projeto.",
    'project-pages.connect-space.not-connected.description': "Para utilizar p\xe1ginas de projeto, entre em contato com o administrador ou l\xedder da equipe para conectar o Confluence a esse projeto.",
    'project-pages.connect-space.not-connected.heading': "N\xe3o conectado ao Confluence",
    'project-pages.connect-success-flag.description.content': "Conectado ao conte\xfado {connectedSpaceOrPageName}.",
    'project-pages.connection-error.space-or-page-not-found.button': "Conecte a um espa\xe7o ou p\xe1gina diferente",
    'project-pages.create-space-dialog.connection-error': "Falha na conex\xe3o.",
    'project-pages.create-space-dialog.connection-retry': 'Tentar novamente',
    'project-pages.create-space-dialog.content.empty-name': "D\xea um nome para o seu espa\xe7o.",
    'project-pages.create-space-dialog.content.invalid-name': "Os nomes de espa\xe7os exigem pelo menos uma letra ou um n\xfamero.",
    'project-pages.create-space-dialog.content.placeholder': "Digite um nome de espa\xe7o",
    'project-pages.create-space-dialog.creation-error': "Falha ao criar o espa\xe7o.",
    'project-pages.create-space-dialog.error-icon': 'Erro:',
    'project-pages.create-space-dialog.footer.cancel': 'Cancelar',
    'project-pages.create-space-dialog.footer.create-space': 'Criar',
    'project-pages.create-space-dialog.header.title': "Criar novo espa\xe7o do Confluence",
    'project-pages.cross-join.access-revoked.templates.subtitle': "N\xe3o \xe9 poss\xedvel usar p\xe1ginas do projeto porque o administrador negou acesso ao Confluence. Entre em contato com o administrador do site para solicitar acesso.",
    'project-pages.cross-join.access-revoked.templates.title': "Voc\xea n\xe3o tem permiss\xf5es para usar p\xe1ginas do projeto",
    'project-pages.cross-join.avatar.view-profile': 'Visualizar perfil',
    'project-pages.cross-join.denied-request.templates.subtitle': "N\xe3o \xe9 poss\xedvel usar p\xe1ginas do projeto porque o administrador do site negou a solicita\xe7\xe3o para entrar no Confluence.",
    'project-pages.cross-join.denied-request.templates.title': 'O administrador negou o acesso',
    'project-pages.cross-join.direct-access.button-subtitle.experimental': "Voc\xea vai receber acesso ao Confluence. O administrador do seu site j\xe1 aprovou voc\xea.",
    'project-pages.cross-join.errors.unknown-error.description': "{contactSupport} se a atualiza\xe7\xe3o n\xe3o funcionar.",
    'project-pages.cross-join.errors.unknown-error.title': "N\xe3o \xe9 poss\xedvel exibir as p\xe1ginas do projeto agora",
    'project-pages.cross-join.inline-join-product.button': "Voc\xea vai ter acesso ao Confluence. O administrador do seu site j\xe1 aprovou voc\xea.",
    'project-pages.cross-join.inline-join-product.connected.description': "Veja, edite e crie documenta\xe7\xe3o em um \xfanico local",
    'project-pages.cross-join.inline-join-product.connected.title': "Colabore nas p\xe1ginas do projeto com sua equipe",
    'project-pages.cross-join.pending-request.templates.subtitle': "O administrador do site recebeu sua solicita\xe7\xe3o para entrar no Confluence. Se ela for aprovada, as p\xe1ginas do projeto v\xe3o come\xe7ar a funcionar e voc\xea vai receber um e-mail de confirma\xe7\xe3o.",
    'project-pages.cross-join.pending-request.templates.subtitle.experiment': "Ap\xf3s a aprova\xe7\xe3o, voc\xea vai receber um e-mail com acesso \xe0s P\xe1ginas do projeto.",
    'project-pages.cross-join.pending-request.templates.title': "Voc\xea solicitou acesso ao Confluence",
    'project-pages.cross-join.pending-request.templates.title.experiment': "Solicita\xe7\xe3o de acesso enviada ao administrador",
    'project-pages.cross-join.request-access-without-better-together.connected.description': "Veja, edite e crie documenta\xe7\xe3o do projeto com sua equipe",
    'project-pages.cross-join.request-access.button': 'Solicitar acesso',
    'project-pages.cross-join.request-access.button-subtitle.experimental': 'Ao selecionar "Entrar na equipe", voc\xea est\xe1 pedindo para entrar no Confluence e autoriza o compartilhamento do perfil na Atlassian com o administrador.',
    'project-pages.cross-join.request-access.button.experimental': 'Entrar na equipe',
    'project-pages.cross-join.request-access.connected.description.experimental': "A equipe est\xe1 usando P\xe1ginas do projeto para comentar, editar e colaborar na documenta\xe7\xe3o do projeto sem sair do Jira. Entre no Confluence para acessar as P\xe1ginas do projeto da equipe.",
    'project-pages.cross-join.request-access.title': "As p\xe1ginas do projeto exigem acesso ao Confluence",
    'project-pages.cross-join.request-access.title.experiment': "Crie uma s\xf3 fonte \xfanica de informa\xe7\xf5es para a equipe",
    'project-pages.default-contextual-heading': "As p\xe1ginas de projeto s\xe3o desenvolvidas no Confluence",
    'project-pages.default-contextual-message': "Crie, compartilhe e colabore em todos os documentos de seu projeto em um \xfanico lugar, com as p\xe1ginas do Confluence.",
    'project-pages.default-reactivate-CTA': 'Reativar Confluence',
    'project-pages.default-trial-CTA': "Experimente o Confluence gr\xe1tis por 30 dias",
    'project-pages.draft-saved-flag.action': 'Abrir rascunho',
    'project-pages.draft-saved-flag.description': "O rascunho s\xf3 fica vis\xedvel at\xe9 ser publicado.",
    'project-pages.draft-saved-flag.title': 'Rascunho salvo',
    'project-pages.embedded-pages.create-page-error.close-button': 'Fechar',
    'project-pages.embedded-pages.create-page-error.description': "Um problema surgiu e n\xe3o foi poss\xedvel criar uma p\xe1gina para voc\xea.",
    'project-pages.embedded-pages.create-page-error.title': "N\xe3o foi poss\xedvel criar uma p\xe1gina",
    'project-pages.embedded-pages.create-page-error.try-again-button': 'Tentar novamente',
    'project-pages.embedded-pages.modal.close.button.hint': 'Fechar',
    'project-pages.embedded-pages.modal.title.button': 'Abrir no Confluence',
    'project-pages.embedded-pages.modal.title.button.hint': 'Abrir em uma nova guia',
    'project-pages.errors.unknown-error.description.non-final': "{contactSupport} se a atualiza\xe7\xe3o n\xe3o funcionar.",
    'project-pages.errors.unknown-error.title.non-final': "N\xe3o \xe9 poss\xedvel exibir as p\xe1ginas do projeto agora",
    'project-pages.generic-error.button.reload': "Recarregar p\xe1gina",
    'project-pages.generic-error.description': 'Algo deu errado. Tente novamente mais tarde.',
    'project-pages.generic-error.description.non-final': 'Algo deu errado. Tente novamente mais tarde.',
    'project-pages.generic-error.heading': "Poxa, isso est\xe1 estranho...",
    'project-pages.generic-error.title.non-final': "Poxa, isso est\xe1 estranho...",
    'project-pages.generic-info-flag.description': 'Algo deu errado. Tente de novo ou fale com o suporte se o problema persistir',
    'project-pages.generic-success-flag.description.live-doc': "Conectado ao documento din\xe2mico {connectedSpaceOrPageName}.",
    'project-pages.generic-success-flag.description.page': "P\xe1gina {connectedSpaceOrPageName} conectada com sucesso.",
    'project-pages.generic-success-flag.description.space': "Espa\xe7o {connectedSpaceOrPageName} conectado com sucesso.",
    'project-pages.generic-success-flag.heading.live-doc': "Documento din\xe2mico conectado",
    'project-pages.generic-success-flag.heading.page': "P\xe1gina conectada",
    'project-pages.generic-success-flag.heading.space': "Espa\xe7o conectado",
    'project-pages.granular-pages.connect-space-dialog.content.create-space-link.link-text': "Ou crie um novo espa\xe7o",
    'project-pages.granular-pages.connect-space.button': 'Conectar ao Confluence',
    'project-pages.granular-pages.connect-space.heading': "Conecte este projeto a um espa\xe7o ou item do Confluence",
    'project-pages.improvement.contact-support': 'Entre em contato com o suporte',
    'project-pages.improvement.errors.access-error.description': 'Tente entrar em contato com o administrador do site para pedir acesso.',
    'project-pages.improvement.errors.access-error.title': "Voc\xea n\xe3o tem permiss\xe3o para visualizar as p\xe1ginas do projeto",
    'project-pages.improvement.errors.page-tree-unknown-error.description': "Ocorreu um erro durante a tentativa de exibir p\xe1ginas do seu espa\xe7o conectado do Confluence. {contactSupport} se a atualiza\xe7\xe3o n\xe3o funcionar.",
    'project-pages.improvement.errors.page-tree-unknown-error.title': "A gente est\xe1 com problemas para exibir as p\xe1ginas do projeto",
    'project-pages.improvement.errors.space-or-page-not-found.description': "O espa\xe7o ou p\xe1gina do Confluence que estava conectado foi movido, arquivado ou exclu\xeddo. <link>Entre em contato com o suporte</link> se a reconex\xe3o n\xe3o corrigir as coisas",
    'project-pages.improvement.errors.space-or-page-not-found.title': "Espa\xe7o ou p\xe1gina n\xe3o encontrados",
    'project-pages.improvement.errors.unknown-error.description': "{contactSupport} se a atualiza\xe7\xe3o n\xe3o funcionar.",
    'project-pages.improvement.errors.unknown-error.title': "N\xe3o \xe9 poss\xedvel exibir as p\xe1ginas do projeto agora",
    'project-pages.improvement.feature1': 'Acesse e crie documentos sem sair do Jira',
    'project-pages.improvement.feature2': "Templates para reuni\xf5es, planos de sprint e mais",
    'project-pages.improvement.feature3': "Sincronize documentos com o Jira para receber atualiza\xe7\xf5es autom\xe1ticas",
    'project-pages.improvement.heading-info': 'Registre o conhecimento da equipe e melhore a forma de trabalhar.',
    'project-pages.improvement.heading-info-v2': 'Crie um lugar para todos os documentos de projeto da equipe',
    'project-pages.improvement.learn-more-button': 'Saiba mais',
    'project-pages.improvement.powered-by': "Distribu\xeddo por",
    'project-pages.improvement.powered-by.tooltip': 'Abrir o Confluence em uma nova guia',
    'project-pages.improvement.preview-teaser': "Descubra templates, p\xe1ginas de projeto e muito mais.",
    'project-pages.improvement.provisioning-info-modal.seamlessly-update-stakeholders.description': "<p>Mantenha os relat\xf3rios de projeto atualizados com a atualiza\xe7\xe3o autom\xe1tica de etiquetas de status.</p> <p>Basta vincular um ticket do Jira em um documento que ele vai exibir uma etiqueta de status autom\xe1tica com atualiza\xe7\xe3o em sincronia com o ticket. Assim, voc\xea n\xe3o precisa gastar tempo criando relat\xf3rios manuais.</p>",
    'project-pages.improvement.provisioning-info-modal.seamlessly-update-stakeholders.title': 'Atualize as partes interessadas com continuidade',
    'project-pages.improvement.provisioning-info-modal.unify-documentation-standards.description': "<p>Crie uma documenta\xe7\xe3o consistente usando os templates integrados. Eles s\xe3o f\xe1ceis de usar e podem ser personalizados.</p> <p>Voc\xea pode usar templates direto das p\xe1ginas do projeto para nunca ter que sair de onde est\xe1 trabalhando. Veja todos os templates <a>aqui</a>.</p>",
    'project-pages.improvement.provisioning-info-modal.unify-documentation-standards.title': "Unifique os padr\xf5es de documenta\xe7\xe3o",
    'project-pages.improvement.provisioning-info-modal.your-project-pages-in-jira.description': "<p>Elabore e gerencie a documenta\xe7\xe3o na guia de p\xe1ginas do projeto no Jira para criar uma fonte \xfanica de verdade para informa\xe7\xf5es importantes.</p> <p>Voc\xea sabia que as p\xe1ginas do projeto s\xe3o executadas no Confluence? \xc9 gr\xe1tis para at\xe9 10 usu\xe1rios. Convide o resto da equipe nas configura\xe7\xf5es do administrador.</p>",
    'project-pages.improvement.provisioning-info-modal.your-project-pages-in-jira.title': "As p\xe1ginas do projeto, direto no Jira",
    'project-pages.improvement.templates-sidebar.better-together-templates-header': 'Templates integrados aos seus dados do Jira',
    'project-pages.improvement.templates.better-together-preview-teaser': 'Integrado com dados do Jira',
    'project-pages.improvement.templates.blank-page.description': "Comece uma p\xe1gina do zero.",
    'project-pages.improvement.templates.blank-page.name': "P\xe1gina em branco",
    'project-pages.improvement.templates.decision.description': "Registre decis\xf5es importantes do projeto e compartilhe com a equipe.",
    'project-pages.improvement.templates.decision.name': "Decis\xe3o",
    'project-pages.improvement.templates.meeting-notes.description': "Defina pautas para reuni\xf5es, fa\xe7a anota\xe7\xf5es e compartilhe itens de a\xe7\xe3o com a equipe.",
    'project-pages.improvement.templates.meeting-notes.name': "Anota\xe7\xf5es de reuni\xe3o",
    'project-pages.improvement.templates.post-expand.more': 'Mais templates',
    'project-pages.improvement.templates.post-expand.more.tooltip': 'Ver todos os templates no Confluence',
    'project-pages.improvement.templates.post-expand.subtitle': 'Templates populares',
    'project-pages.improvement.templates.post-expand.title': "Criar uma p\xe1gina",
    'project-pages.improvement.templates.pre-expand.more': 'Explore mais templates',
    'project-pages.improvement.templates.pre-expand.subtitle': 'Popular com equipes como a sua',
    'project-pages.improvement.templates.pre-expand.title': 'Visualizar templates',
    'project-pages.improvement.templates.product-requirements.description': "Defina e monitore os requisitos e seu escopo para seu produto ou fun\xe7\xe3o.",
    'project-pages.improvement.templates.product-requirements.name': 'Requisitos do produto',
    'project-pages.improvement.templates.retrospective.description': "O que estava bom? O que poderia ter sido melhor? Re\xfana melhorias por meio de crowdsourcing com a equipe.",
    'project-pages.improvement.templates.retrospective.name': 'Retrospectiva',
    'project-pages.improvement.templates.template.disabled-tooltip': "Conecte um espa\xe7o do Confluence primeiro",
    'project-pages.improvement.templates.tutorial.content.confluence-templates': "<b>Economize tempo e reduza as tarefas manuais</b>. O Confluence tem v\xe1rios <a>templates</a> de p\xe1gina, ent\xe3o voc\xea nunca precisa come\xe7ar do zero. S\xe3o documentos t\xe9cnicos, guias de solu\xe7\xe3o de problemas, planos de projetos, requisitos do produto e muito mais.",
    'project-pages.improvement.templates.tutorial.content.edit-and-format': "<b>Edite e formate com facilidade.</b> Use o menu de edi\xe7\xe3o superior para formata\xe7\xe3o padr\xe3o de palavras e digite <b>/</b> para inserir v\xe1rias integra\xe7\xf5es \xfateis com facilidade. Insira uma tabela digitando <c>/tabela</c> ou uma imagem com <c>/imagem.</c> Voc\xea tamb\xe9m pode inserir links do Dropbox <c>/dropbox</c>, ferramentas do Microsoft Office <c>/microsoft</c> ou quadros e cart\xf5es do Trello <c>/trello</c>.",
    'project-pages.improvement.templates.tutorial.content.forward-slash-prompt': "Digite / seguido por 'tabela' ou 'imagem'",
    'project-pages.improvement.templates.tutorial.content.getting-started-tips': "Veja algumas dicas para voc\xea come\xe7ar:",
    'project-pages.improvement.templates.tutorial.content.handy-links': "Links \xfateis",
    'project-pages.improvement.templates.tutorial.content.jira-and-confluence': 'Use o Jira e o Confluence juntos',
    'project-pages.improvement.templates.tutorial.content.jira-charts': "Crie gr\xe1ficos nas p\xe1ginas usando dados reais do Jira. Digite <c>/gr\xe1ficos do Jira</c>.",
    'project-pages.improvement.templates.tutorial.content.jira-links': "Vincule um item do Jira em qualquer lugar da p\xe1gina. O link na p\xe1gina \xe9 atualizado em tempo real, conforme voc\xea atualiza o item do Jira. Digite <c>/Jira</c>.",
    'project-pages.improvement.templates.tutorial.content.jira-links-issue-term-refresh': "Vincule um ticket do Jira em qualquer lugar da sua p\xe1gina. O link na p\xe1gina vai ser atualizado em tempo real, conforme voc\xea atualiza o ticket. Digite <c>/Jira</c>.",
    'project-pages.improvement.templates.tutorial.content.jira-links.non-final-issue-term-refresh': "Vincule um ticket do Jira em qualquer lugar da sua p\xe1gina. O link na p\xe1gina vai ser atualizado em tempo real, conforme voc\xea atualiza o ticket. Digite <c>/Jira</c>.",
    'project-pages.improvement.templates.tutorial.content.jira-roadmaps': "Insira roteiros e cronogramas interativos na p\xe1gina usando projetos do Jira. Digite <c>/roteiro do jira</c>.",
    'project-pages.improvement.templates.tutorial.content.jira-timeline': "Incorpore linhas do tempo interativas na p\xe1gina usando os projetos do Jira. Digite <c>/jira timeline</c>.",
    'project-pages.improvement.templates.tutorial.content.shipping-speed-statistic': "76% dos clientes do Jira Software disseram que la\xe7aram projetos com mais rapidez depois de adicionarem o Confluence",
    'project-pages.improvement.templates.tutorial.content.shipping-speed-statistic.spork-rebranding': "76% dos clientes do Jira afirmam terem lan\xe7ado projetos com mais rapidez depois de adicionar o Confluence",
    'project-pages.improvement.templates.tutorial.content.spaces-and-pages': "<b>Uso de espa\xe7os e p\xe1ginas</b>. Os espa\xe7os fazem parte de todos os sites do Confluence e permitem organizar as p\xe1ginas em categorias. Pense nos espa\xe7os como diferentes pastas ou projetos. As p\xe1ginas s\xe3o os documentos que pertencem a essas pastas ou projetos. <a>Saiba mais sobre como usar espa\xe7os</a>",
    'project-pages.improvement.templates.tutorial.content.try-it-now': 'Experimente agora',
    'project-pages.improvement.templates.tutorial.description': "Saiba como editar uma p\xe1gina.",
    'project-pages.improvement.templates.tutorial.name': "Bem-vindo(a) \xe0s p\xe1ginas do projeto!",
    'project-pages.improvement.terms-and-conditions-v2': "Ao clicar em &quot;Testar agora&quot;, voc\xea reconhece a inscri\xe7\xe3o no Confluence e concorda com os <termsLink>Termos de Servi\xe7o</termsLink> e a <privacyLink>Pol\xedtica de Privacidade</privacyLink> do Atlassian Cloud.",
    'project-pages.improvement.title': "P\xe1ginas de projeto",
    'project-pages.improvement.transient-states.empty-state.auto-provisioned-create-page-button': "Criar p\xe1gina",
    'project-pages.improvement.transient-states.empty-state.auto-provisioned-description': "Adicionamos o Confluence para que voc\xea possa come\xe7ar a criar e vincular todos os documentos do projeto. \xc9 gratuito para at\xe9 10 usu\xe1rios.",
    'project-pages.improvement.transient-states.empty-state.auto-provisioned-learn-more-button': 'Saiba mais',
    'project-pages.improvement.transient-states.empty-state.create-page-button': "Criar sua primeira p\xe1gina",
    'project-pages.improvement.transient-states.empty-state.description': "Crie algumas anota\xe7\xf5es de reuni\xe3o, requisitos de produtos, decis\xf5es ou outros assuntos para ver este espa\xe7o ser preenchido.",
    'project-pages.improvement.transient-states.empty-state.title': "N\xe3o tem nada aqui, s\xf3 potencial",
    'project-pages.improvement.try-button': 'Experimente este template no Confluence',
    'project-pages.improvement.try-it-now': 'Testar agora',
    'project-pages.improvement.try-lozenge': 'avaliar',
    'project-pages.improvement.try-on-demand-button': "Teste gr\xe1tis",
    'project-pages.page-deleted-flag.title': "P\xe1gina exclu\xedda.",
    'project-pages.page-published-flag.title': "A p\xe1gina foi publicada.",
    'project-pages.unknown-error.description': "{contactSupport} se a atualiza\xe7\xe3o n\xe3o funcionar.",
    'project-pages.unknown-error.heading': "N\xe3o \xe9 poss\xedvel exibir as p\xe1ginas do projeto agora"
};

});

parcelRegister("clmK0", function(module, exports) {

$parcel$export(module.exports, "default", () => $046cd3810280fbe3$export$2e2bcd8739ae039);
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Portuguese (Portugal)
var $046cd3810280fbe3$export$2e2bcd8739ae039 = {
    'project-pages.connect-space-dialog.connection-error': "Falha da liga\xe7\xe3o.",
    'project-pages.connect-space-dialog.connection-retry': 'Tentar novamente',
    'project-pages.connect-space-dialog.content.space-selector.disconnected-templates-description': "Este projeto tem de estar ligado a um espa\xe7o antes de o utilizador poder criar uma p\xe1gina. Selecione um espa\xe7o para ligar a este projeto.",
    'project-pages.connect-space-dialog.error-icon': 'Erro:',
    'project-pages.connect-space-dialog.footer.cancel': 'Cancelar',
    'project-pages.connect-space-dialog.footer.connect-space': 'Ligar',
    'project-pages.connect-space.description': "Os espa\xe7os s\xe3o como pastas, pode utiliz\xe1-los para criar, organizar e colaborar em todo o conte\xfado relacionado com o seu projeto.",
    'project-pages.create-space-dialog.connection-error': "Falha da liga\xe7\xe3o.",
    'project-pages.create-space-dialog.connection-retry': 'Tentar novamente',
    'project-pages.create-space-dialog.content.empty-name': "Atribua um nome ao seu espa\xe7o.",
    'project-pages.create-space-dialog.content.invalid-name': "Os nomes de espa\xe7o t\xeam de incluir pelo menos uma letra ou n\xfamero.",
    'project-pages.create-space-dialog.content.placeholder': "Introduza um nome de espa\xe7o",
    'project-pages.create-space-dialog.creation-error': "Falha ao criar o espa\xe7o.",
    'project-pages.create-space-dialog.error-icon': 'Erro:',
    'project-pages.create-space-dialog.footer.cancel': 'Cancelar',
    'project-pages.create-space-dialog.footer.create-space': 'Criar',
    'project-pages.create-space-dialog.header.title': "Criar novo espa\xe7o do Confluence",
    'project-pages.default-contextual-message': "Crie, partilhe e colabore nos documentos do seu projeto num s\xf3 local, com as p\xe1ginas Confluence.",
    'project-pages.default-reactivate-CTA': 'Reativar o Confluence',
    'project-pages.default-trial-CTA': "Experimente o Confluence gr\xe1tis durante 30 dias",
    'project-pages.generic-error.button.reload': "Recarregar p\xe1gina",
    'project-pages.generic-error.description': 'Ocorreu um erro. Tente novamente mais tarde.',
    'project-pages.generic-error.heading': "Bem, isto \xe9 constrangedor..."
};

});

parcelRegister("9LAI9", function(module, exports) {

$parcel$export(module.exports, "default", () => $01af1f3343b92b2a$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Russian
var $01af1f3343b92b2a$export$2e2bcd8739ae039 = {
    'confluence.project-pages.improvement.provisioning-background.text': "\u042D\u0442\u043E \u0437\u0430\u0439\u043C\u0435\u0442 \u043C\u0435\u043D\u0435\u0435 \u043C\u0438\u043D\u0443\u0442\u044B",
    'confluence.project-pages.improvement.provisioning-background.title': "\u041D\u0430\u0441\u0442\u0440\u043E\u0439\u043A\u0430 \u0441\u0442\u0440\u0430\u043D\u0438\u0446 \u043F\u0440\u043E\u0435\u043A\u0442\u0430",
    'confluence.project-pages.improvement.provisioning-modal-carousel.controls.dismiss': "\u0417\u0430\u043A\u0440\u044B\u0442\u044C",
    'confluence.project-pages.improvement.provisioning-modal-carousel.controls.done': "\u0413\u043E\u0442\u043E\u0432\u043E",
    'confluence.project-pages.improvement.provisioning-modal-carousel.controls.next': "\u0414\u0430\u043B\u0435\u0435",
    'project-pages.activating.description': "\u041F\u043E\u0434\u043A\u043B\u044E\u0447\u0435\u043D\u043D\u044B\u0439 \u0440\u0430\u0437\u0434\u0435\u043B Confluence \u043F\u043E\u043A\u0430 \u043D\u0435 \u0433\u043E\u0442\u043E\u0432. \u0415\u0441\u043B\u0438 \u043E\u0431\u043D\u043E\u0432\u043B\u0435\u043D\u0438\u0435 \u043D\u0435 \u0440\u0435\u0448\u0430\u0435\u0442 \u043F\u0440\u043E\u0431\u043B\u0435\u043C\u0443, {contactSupport}.",
    'project-pages.activating.heading': "Confluence \u0432\u0441\u0435 \u0435\u0449\u0435 \u0437\u0430\u0433\u0440\u0443\u0436\u0430\u0435\u0442\u0441\u044F",
    'project-pages.better-together-templates.meeting-notes.action-items-heading': "\u041A\u0430\u043A\u0438\u0435 \u0437\u0430\u0434\u0430\u0447\u0438 \u043D\u0443\u0436\u043D\u043E \u0432\u044B\u043F\u043E\u043B\u043D\u0438\u0442\u044C?",
    'project-pages.better-together-templates.meeting-notes.agenda-item-label': "\u0412\u043E\u043F\u0440\u043E\u0441 \u043A \u043E\u0431\u0441\u0443\u0436\u0434\u0435\u043D\u0438\u044E",
    'project-pages.better-together-templates.meeting-notes.create-a-jira-issue': "\u0412\u0432\u0435\u0434\u0438\u0442\u0435 /Jira, \u0447\u0442\u043E\u0431\u044B \u0441\u043E\u0437\u0434\u0430\u0442\u044C \u0437\u0430\u0434\u0430\u0447\u0443",
    'project-pages.better-together-templates.meeting-notes.date-label': "\u0414\u0430\u0442\u0430",
    'project-pages.better-together-templates.meeting-notes.discussion-topics-heading': "\u0422\u0435\u043C\u044B \u0434\u043B\u044F \u043E\u0431\u0441\u0443\u0436\u0434\u0435\u043D\u0438\u044F",
    'project-pages.better-together-templates.meeting-notes.list-people': "\u043F\u0435\u0440\u0435\u0447\u0438\u0441\u043B\u0438\u0442\u0435 \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u0435\u0439, \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u0443\u044F",
    'project-pages.better-together-templates.meeting-notes.mention': "\u0443\u043F\u043E\u043C\u044F\u043D\u0438\u0442\u0435",
    'project-pages.better-together-templates.meeting-notes.mention-people-to-assign-them': "\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u0435\u0439, \u0447\u0442\u043E\u0431\u044B \u043D\u0430\u0437\u043D\u0430\u0447\u0438\u0442\u044C \u0438\u043C \u0437\u0430\u0434\u0430\u0447\u0443",
    'project-pages.better-together-templates.meeting-notes.notes-label': "\u041F\u0440\u0438\u043C\u0435\u0447\u0430\u043D\u0438\u044F",
    'project-pages.better-together-templates.meeting-notes.page-title': "\u041F\u0440\u043E\u0442\u043E\u043A\u043E\u043B \u0441\u043E\u0431\u0440\u0430\u043D\u0438\u044F",
    'project-pages.better-together-templates.meeting-notes.participants-label': "\u0423\u0447\u0430\u0441\u0442\u043D\u0438\u043A\u0438",
    'project-pages.better-together-templates.meeting-notes.project-label': "\u041F\u0440\u043E\u0435\u043A\u0442",
    'project-pages.better-together-templates.product-requirements.create-a-jira-issue': "\u0412\u0432\u0435\u0434\u0438\u0442\u0435 /Jira, \u0447\u0442\u043E\u0431\u044B \u0441\u043E\u0437\u0434\u0430\u0442\u044C \u0437\u0430\u0434\u0430\u0447\u0443",
    'project-pages.better-together-templates.product-requirements.design-heading': "\u0414\u0438\u0437\u0430\u0439\u043D",
    'project-pages.better-together-templates.product-requirements.embedd-different-data-views': "\u0412\u0441\u0442\u0440\u0430\u0438\u0432\u0430\u0439\u0442\u0435 \u0440\u0430\u0437\u043B\u0438\u0447\u043D\u044B\u0435 \u0434\u0430\u043D\u043D\u044B\u0435 \u0438 \u043F\u0440\u0435\u0434\u0441\u0442\u0430\u0432\u043B\u0435\u043D\u0438\u044F \u0438\u0437 \u043F\u0440\u043E\u0435\u043A\u0442\u0430 Jira.",
    'project-pages.better-together-templates.product-requirements.heading': "\u041E\u0431\u0437\u043E\u0440",
    'project-pages.better-together-templates.product-requirements.how-will-you-know-if-fixed': "\u041A\u0430\u043A \u0432\u044B \u043F\u043E\u0439\u043C\u0435\u0442\u0435, \u0447\u0442\u043E \u0443\u0441\u0442\u0440\u0430\u043D\u0438\u043B\u0438 \u043F\u0440\u043E\u0431\u043B\u0435\u043C\u0443?",
    'project-pages.better-together-templates.product-requirements.impact-heading': "\u0412\u043B\u0438\u044F\u043D\u0438\u0435",
    'project-pages.better-together-templates.product-requirements.inScopeStatus': "\u0412\u0445\u043E\u0434\u0438\u0442 \u0432 \u043E\u0431\u043B\u0430\u0441\u0442\u044C",
    'project-pages.better-together-templates.product-requirements.insert-design-link': "\u0412\u0441\u0442\u0430\u0432\u044C\u0442\u0435 \u0441\u0441\u044B\u043B\u043A\u0443 \u043D\u0430 \u0434\u0438\u0437\u0430\u0439\u043D (Figma \u0438 \u0434\u0440.)",
    'project-pages.better-together-templates.product-requirements.jira-issue-heading': "\u0417\u0430\u0434\u0430\u0447\u0430 Jira",
    'project-pages.better-together-templates.product-requirements.jira-roadmap-heading': "\u0414\u043E\u0440\u043E\u0436\u043D\u0430\u044F \u043A\u0430\u0440\u0442\u0430 Jira",
    'project-pages.better-together-templates.product-requirements.learn-how-with-smart-links': "\u0423\u0437\u043D\u0430\u0439\u0442\u0435, \u043A\u0430\u043A \u044D\u0442\u043E \u0441\u0434\u0435\u043B\u0430\u0442\u044C \u0441 \u043F\u043E\u043C\u043E\u0449\u044C\u044E \u0438\u043D\u0442\u0435\u043B\u043B\u0435\u043A\u0442\u0443\u0430\u043B\u044C\u043D\u044B\u0445 \u0441\u0441\u044B\u043B\u043E\u043A",
    'project-pages.better-together-templates.product-requirements.list-dashboards': "\u041F\u0435\u0440\u0435\u0447\u0438\u0441\u043B\u0438\u0442\u0435 \u0434\u0430\u0448\u0431\u043E\u0430\u0440\u0434\u044B (Amplitude, Mode \u0438 \u0434\u0440.)",
    'project-pages.better-together-templates.product-requirements.list-design-considerations': "\u0421\u043E\u0441\u0442\u0430\u0432\u044C\u0442\u0435 \u0441\u043F\u0438\u0441\u043E\u043A \u0440\u0435\u043A\u043E\u043C\u0435\u043D\u0434\u0430\u0446\u0438\u0439 \u043F\u043E \u0434\u0438\u0437\u0430\u0439\u043D\u0443 \u0438\u043B\u0438 \u0440\u0430\u0437\u0440\u0430\u0431\u043E\u0442\u043A\u0435",
    'project-pages.better-together-templates.product-requirements.list-people': "\u043F\u0435\u0440\u0435\u0447\u0438\u0441\u043B\u0438\u0442\u0435 \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u0435\u0439, \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u0443\u044F",
    'project-pages.better-together-templates.product-requirements.mention': "\u0443\u043F\u043E\u043C\u044F\u043D\u0438\u0442\u0435",
    'project-pages.better-together-templates.product-requirements.mention-people-to-assign-them': "\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u0435\u0439, \u0447\u0442\u043E\u0431\u044B \u043D\u0430\u0437\u043D\u0430\u0447\u0438\u0442\u044C \u0438\u043C \u0437\u0430\u0434\u0430\u0447\u0443",
    'project-pages.better-together-templates.product-requirements.niceToHaveStatus': "\u0416\u0435\u043B\u0430\u0442\u0435\u043B\u044C\u043D\u043E",
    'project-pages.better-together-templates.product-requirements.outOfScopeStatus': "\u041D\u0435 \u0432\u0445\u043E\u0434\u0438\u0442 \u0432 \u043E\u0431\u043B\u0430\u0441\u0442\u044C",
    'project-pages.better-together-templates.product-requirements.page-title': "\u0422\u0440\u0435\u0431\u043E\u0432\u0430\u043D\u0438\u044F \u043A \u043F\u0440\u043E\u0434\u0443\u043A\u0442\u0443",
    'project-pages.better-together-templates.product-requirements.pro-tip': "\u041F\u0440\u043E\u0444\u0435\u0441\u0441\u0438\u043E\u043D\u0430\u043B\u044C\u043D\u044B\u0439 \u0441\u043E\u0432\u0435\u0442.",
    'project-pages.better-together-templates.product-requirements.problem-label': "\u041F\u0440\u043E\u0431\u043B\u0435\u043C\u0430",
    'project-pages.better-together-templates.product-requirements.requirement-heading': "\u0422\u0440\u0435\u0431\u043E\u0432\u0430\u043D\u0438\u0435",
    'project-pages.better-together-templates.product-requirements.scope-heading': "\u041E\u0431\u043B\u0430\u0441\u0442\u044C \u043F\u0440\u043E\u0435\u043A\u0442\u0430",
    'project-pages.better-together-templates.product-requirements.success-metric': "\u041F\u043E\u043A\u0430\u0437\u0430\u0442\u0435\u043B\u044C \u0443\u0441\u043F\u0435\u0445\u0430",
    'project-pages.better-together-templates.product-requirements.target-release-date': "\u0426\u0435\u043B\u0435\u0432\u0430\u044F \u0434\u0430\u0442\u0430 \u0440\u0435\u043B\u0438\u0437\u0430",
    'project-pages.better-together-templates.product-requirements.team-label': "\u041A\u043E\u043C\u0430\u043D\u0434\u0430",
    'project-pages.better-together-templates.product-requirements.to-do-list-heading': "\u0421\u043F\u0438\u0441\u043E\u043A \u0437\u0430\u0434\u0430\u0447",
    'project-pages.better-together-templates.product-requirements.what-are-you-trying-to-fix': "\u041A\u0430\u043A\u0443\u044E \u043F\u0440\u043E\u0431\u043B\u0435\u043C\u0443 \u0432\u044B \u043F\u044B\u0442\u0430\u0435\u0442\u0435\u0441\u044C \u0443\u0441\u0442\u0440\u0430\u043D\u0438\u0442\u044C?",
    'project-pages.better-together-templates.retro-notes.retro-heading': "\u0420\u0435\u0442\u0440\u043E\u0441\u043F\u0435\u043A\u0442\u0438\u0432\u0430",
    'project-pages.better-together-templates.retro.action-items-heading': "\u041A\u0430\u043A\u0438\u0435 \u0437\u0430\u0434\u0430\u0447\u0438 \u043D\u0443\u0436\u043D\u043E \u0432\u044B\u043F\u043E\u043B\u043D\u0438\u0442\u044C?",
    'project-pages.better-together-templates.retro.create-a-jira-issue': "\u0412\u0432\u0435\u0434\u0438\u0442\u0435 /Jira, \u0447\u0442\u043E\u0431\u044B \u0441\u043E\u0437\u0434\u0430\u0442\u044C \u0437\u0430\u0434\u0430\u0447\u0443",
    'project-pages.better-together-templates.retro.date-label': "\u0414\u0430\u0442\u0430",
    'project-pages.better-together-templates.retro.embed-it-here': "\u041A\u043E\u0433\u0434\u0430 \u0432\u044B \u0437\u0430\u043A\u043E\u043D\u0447\u0438\u0442\u0435, \u043C\u043E\u0436\u0435\u0442\u0435 \u0432\u0441\u0442\u0440\u043E\u0438\u0442\u044C \u0435\u0435 \u0441\u044E\u0434\u0430.",
    'project-pages.better-together-templates.retro.list-people': "\u043F\u0435\u0440\u0435\u0447\u0438\u0441\u043B\u0438\u0442\u0435 \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u0435\u0439, \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u0443\u044F",
    'project-pages.better-together-templates.retro.mention': "\u0443\u043F\u043E\u043C\u044F\u043D\u0438\u0442\u0435",
    'project-pages.better-together-templates.retro.mention-people-to-assign-them': "\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u0435\u0439, \u0447\u0442\u043E\u0431\u044B \u043D\u0430\u0437\u043D\u0430\u0447\u0438\u0442\u044C \u0438\u043C \u0437\u0430\u0434\u0430\u0447\u0443",
    'project-pages.better-together-templates.retro.page-title': "\u0420\u0435\u0442\u0440\u043E\u0441\u043F\u0435\u043A\u0442\u0438\u0432\u0430",
    'project-pages.better-together-templates.retro.participants-label': "\u0423\u0447\u0430\u0441\u0442\u043D\u0438\u043A\u0438",
    'project-pages.better-together-templates.retro.pro-tip': "\u041F\u0440\u043E\u0444\u0435\u0441\u0441\u0438\u043E\u043D\u0430\u043B\u044C\u043D\u044B\u0439 \u0441\u043E\u0432\u0435\u0442.",
    'project-pages.better-together-templates.retro.project-label': "\u041F\u0440\u043E\u0435\u043A\u0442",
    'project-pages.better-together-templates.retro.this-is-a-whiteboard': "\u042D\u0442\u043E \u0434\u043E\u0441\u043A\u0430 Confluence.",
    'project-pages.better-together-templates.retro.use-a-whiteboard': "\u0418\u0441\u043F\u043E\u043B\u044C\u0437\u0443\u0439\u0442\u0435 \u0434\u043E\u0441\u043A\u0443 Confluence \u0434\u043B\u044F \u0440\u0435\u0442\u0440\u043E\u0441\u043F\u0435\u043A\u0442\u0438\u0432\u044B.",
    'project-pages.better-together-templates.retro.use-it-to-vote': "\u0418\u0441\u043F\u043E\u043B\u044C\u0437\u0443\u0439\u0442\u0435 \u0435\u0435 \u0434\u043B\u044F \u0433\u043E\u043B\u043E\u0441\u043E\u0432\u0430\u043D\u0438\u044F \u0438 \u0441\u043E\u0432\u043C\u0435\u0441\u0442\u043D\u043E\u0439 \u0440\u0430\u0431\u043E\u0442\u044B \u0441\u043E \u0441\u0432\u043E\u0435\u0439 \u043A\u043E\u043C\u0430\u043D\u0434\u043E\u0439.",
    'project-pages.button.connect-different-space-or-page.label': "\u041E\u0431\u043D\u043E\u0432\u0438\u0442\u044C \u0437\u043D\u0430\u0447\u043E\u043A \u0440\u0430\u0437\u0434\u0435\u043B\u0430 \u0438\u043B\u0438 \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u044B",
    'project-pages.button.connect-different-space-or-page.tooltip': "\u041F\u043E\u0434\u043A\u043B\u044E\u0447\u0438\u0442\u044C \u0434\u0440\u0443\u0433\u043E\u0439 \u0440\u0430\u0437\u0434\u0435\u043B \u0438\u043B\u0438 \u044D\u043B\u0435\u043C\u0435\u043D\u0442",
    'project-pages.button.connect-space-or-page.tooltip': "\u041F\u043E\u0434\u043A\u043B\u044E\u0447\u0438\u0442\u044C \u043A Confluence",
    'project-pages.button.go-to-connected-live-doc.tooltip': "\u041E\u0442\u043A\u0440\u044B\u0442\u044C \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442 \u0432 \u0440\u0435\u0436\u0438\u043C\u0435 \u0440\u0435\u0430\u043B\u044C\u043D\u043E\u0433\u043E \u0432\u0440\u0435\u043C\u0435\u043D\u0438 \u0432 Confluence",
    'project-pages.button.go-to-connected-page.tooltip': "\u041E\u0442\u043A\u0440\u044B\u0442\u044C \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0443 \u0432 Confluence",
    'project-pages.button.go-to-connected-space.tooltip': "\u041E\u0442\u043A\u0440\u044B\u0442\u044C \u0440\u0430\u0437\u0434\u0435\u043B \u0432 Confluence",
    'project-pages.connect-space-dialog.connection-error': "\u041E\u0448\u0438\u0431\u043A\u0430 \u043F\u0440\u0438 \u043F\u043E\u0434\u043A\u043B\u044E\u0447\u0435\u043D\u0438\u0438.",
    'project-pages.connect-space-dialog.connection-retry': "\u041F\u043E\u0432\u0442\u043E\u0440\u0438\u0442\u044C",
    'project-pages.connect-space-dialog.content.space-or-page-selector.description': "\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u0440\u0430\u0437\u0434\u0435\u043B \u0438\u043B\u0438 \u044D\u043B\u0435\u043C\u0435\u043D\u0442 \u0434\u043B\u044F \u043F\u043E\u0434\u043A\u043B\u044E\u0447\u0435\u043D\u0438\u044F \u043A \u043F\u0440\u043E\u0435\u043A\u0442\u0443.",
    'project-pages.connect-space-dialog.content.space-or-page-selector.placeholder': "\u041F\u043E\u0438\u0441\u043A \u0432 Confluence",
    'project-pages.connect-space-dialog.content.space-selector.disconnected-templates-description': "\u0427\u0442\u043E\u0431\u044B \u0441\u043E\u0437\u0434\u0430\u0442\u044C \u044D\u043B\u0435\u043C\u0435\u043D\u0442, \u043D\u0443\u0436\u043D\u043E \u043F\u043E\u0434\u043A\u043B\u044E\u0447\u0438\u0442\u044C \u043F\u0440\u043E\u0435\u043A\u0442 \u043A \u043E\u0434\u043D\u043E\u043C\u0443 \u0438\u0437 \u0440\u0430\u0437\u0434\u0435\u043B\u043E\u0432. \u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u0440\u0430\u0437\u0434\u0435\u043B \u0434\u043B\u044F \u043F\u043E\u0434\u043A\u043B\u044E\u0447\u0435\u043D\u0438\u044F \u043A \u044D\u0442\u043E\u043C\u0443 \u043F\u0440\u043E\u0435\u043A\u0442\u0443.",
    'project-pages.connect-space-dialog.error-icon': "\u041E\u0448\u0438\u0431\u043A\u0430:",
    'project-pages.connect-space-dialog.footer.cancel': "\u041E\u0442\u043C\u0435\u043D\u0430",
    'project-pages.connect-space-dialog.footer.connect-space': "\u041F\u043E\u0434\u043A\u043B\u044E\u0447\u0438\u0442\u044C",
    'project-pages.connect-space-or-page-dialog.header.title': "\u041F\u043E\u0434\u043A\u043B\u044E\u0447\u0435\u043D\u0438\u0435 \u043F\u0440\u043E\u0435\u043A\u0442\u0430 \u043A Confluence",
    'project-pages.connect-space.description': "\u0420\u0430\u0437\u0434\u0435\u043B\u044B \u0430\u043D\u0430\u043B\u043E\u0433\u0438\u0447\u043D\u044B \u043F\u0430\u043F\u043A\u0430\u043C: \u0438\u0445 \u043C\u043E\u0436\u043D\u043E \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u044C \u0434\u043B\u044F \u0441\u043E\u0437\u0434\u0430\u043D\u0438\u044F, \u0441\u0438\u0441\u0442\u0435\u043C\u0430\u0442\u0438\u0437\u0430\u0446\u0438\u0438 \u0438 \u0441\u043E\u0432\u043C\u0435\u0441\u0442\u043D\u043E\u0433\u043E \u0440\u0435\u0434\u0430\u043A\u0442\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u044F \u043B\u044E\u0431\u043E\u0433\u043E \u043A\u043E\u043D\u0442\u0435\u043D\u0442\u0430, \u0441\u0432\u044F\u0437\u0430\u043D\u043D\u043E\u0433\u043E \u0441 \u043F\u0440\u043E\u0435\u043A\u0442\u043E\u043C.",
    'project-pages.connect-space.not-connected.description': "\u0414\u043B\u044F \u0440\u0430\u0431\u043E\u0442\u044B \u0441\u043E \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0430\u043C\u0438 \u043F\u0440\u043E\u0435\u043A\u0442\u0430 \u043F\u043E\u043F\u0440\u043E\u0441\u0438\u0442\u0435 \u0430\u0434\u043C\u0438\u043D\u0438\u0441\u0442\u0440\u0430\u0442\u043E\u0440\u0430 \u0438\u043B\u0438 \u0440\u0443\u043A\u043E\u0432\u043E\u0434\u0438\u0442\u0435\u043B\u044F \u043A\u043E\u043C\u0430\u043D\u0434\u044B \u043F\u043E\u0434\u043A\u043B\u044E\u0447\u0438\u0442\u044C \u0435\u0433\u043E \u043A Confluence.",
    'project-pages.connect-space.not-connected.heading': "\u041D\u0435 \u043F\u043E\u0434\u043A\u043B\u044E\u0447\u0435\u043D\u043E \u043A Confluence",
    'project-pages.connect-success-flag.description.content': "\u0421\u0432\u044F\u0437\u044C \u0441 \u043A\u043E\u043D\u0442\u0435\u043D\u0442\u043E\u043C {connectedSpaceOrPageName} \u0443\u0441\u0442\u0430\u043D\u043E\u0432\u043B\u0435\u043D\u0430.",
    'project-pages.connection-error.space-or-page-not-found.button': "\u041F\u043E\u0434\u043A\u043B\u044E\u0447\u0438\u0442\u044C \u043A \u0434\u0440\u0443\u0433\u043E\u043C\u0443 \u0440\u0430\u0437\u0434\u0435\u043B\u0443 \u0438\u043B\u0438 \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0435",
    'project-pages.create-space-dialog.connection-error': "\u041E\u0448\u0438\u0431\u043A\u0430 \u043F\u0440\u0438 \u043F\u043E\u0434\u043A\u043B\u044E\u0447\u0435\u043D\u0438\u0438.",
    'project-pages.create-space-dialog.connection-retry': "\u041F\u043E\u0432\u0442\u043E\u0440\u0438\u0442\u044C",
    'project-pages.create-space-dialog.content.empty-name': "\u0423\u043A\u0430\u0436\u0438\u0442\u0435 \u0438\u043C\u044F \u0440\u0430\u0437\u0434\u0435\u043B\u0430.",
    'project-pages.create-space-dialog.content.invalid-name': "\u0418\u043C\u044F \u0440\u0430\u0437\u0434\u0435\u043B\u0430 \u0434\u043E\u043B\u0436\u043D\u043E \u0441\u043E\u0441\u0442\u043E\u044F\u0442\u044C \u043A\u0430\u043A \u043C\u0438\u043D\u0438\u043C\u0443\u043C \u0438\u0437 \u043E\u0434\u043D\u043E\u0439 \u0431\u0443\u043A\u0432\u044B \u0438\u043B\u0438 \u0446\u0438\u0444\u0440\u044B.",
    'project-pages.create-space-dialog.content.placeholder': "\u0412\u0432\u0435\u0434\u0438\u0442\u0435 \u0438\u043C\u044F \u0440\u0430\u0437\u0434\u0435\u043B\u0430",
    'project-pages.create-space-dialog.creation-error': "\u041E\u0448\u0438\u0431\u043A\u0430 \u0441\u043E\u0437\u0434\u0430\u043D\u0438\u044F \u0440\u0430\u0437\u0434\u0435\u043B\u0430.",
    'project-pages.create-space-dialog.error-icon': "\u041E\u0448\u0438\u0431\u043A\u0430:",
    'project-pages.create-space-dialog.footer.cancel': "\u041E\u0442\u043C\u0435\u043D\u0430",
    'project-pages.create-space-dialog.footer.create-space': "\u0421\u043E\u0437\u0434\u0430\u0442\u044C",
    'project-pages.create-space-dialog.header.title': "\u0421\u043E\u0437\u0434\u0430\u043D\u0438\u0435 \u043D\u043E\u0432\u043E\u0433\u043E \u0440\u0430\u0437\u0434\u0435\u043B\u0430 Confluence",
    'project-pages.cross-join.access-revoked.templates.subtitle': "\u0412\u044B \u043D\u0435 \u043C\u043E\u0436\u0435\u0442\u0435 \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u044C \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u044B \u043F\u0440\u043E\u0435\u043A\u0442\u0430, \u043F\u043E\u0441\u043A\u043E\u043B\u044C\u043A\u0443 \u0430\u0434\u043C\u0438\u043D\u0438\u0441\u0442\u0440\u0430\u0442\u043E\u0440 \u043E\u0442\u043A\u0430\u0437\u0430\u043B \u0432\u0430\u043C \u0432 \u0434\u043E\u0441\u0442\u0443\u043F\u0435 \u043A Confluence. \u041E\u0431\u0440\u0430\u0442\u0438\u0442\u0435\u0441\u044C \u043A \u0430\u0434\u043C\u0438\u043D\u0438\u0441\u0442\u0440\u0430\u0442\u043E\u0440\u0443, \u0447\u0442\u043E\u0431\u044B \u0437\u0430\u043F\u0440\u043E\u0441\u0438\u0442\u044C \u0434\u043E\u0441\u0442\u0443\u043F.",
    'project-pages.cross-join.access-revoked.templates.title': "\u0423 \u0432\u0430\u0441 \u043D\u0435\u0434\u043E\u0441\u0442\u0430\u0442\u043E\u0447\u043D\u043E \u043F\u0440\u0430\u0432 \u0434\u043B\u044F \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u044F \u0441\u0442\u0440\u0430\u043D\u0438\u0446 \u043F\u0440\u043E\u0435\u043A\u0442\u0430",
    'project-pages.cross-join.avatar.view-profile': "\u041F\u043E\u0441\u043C\u043E\u0442\u0440\u0435\u0442\u044C \u043F\u0440\u043E\u0444\u0438\u043B\u044C",
    'project-pages.cross-join.denied-request.templates.subtitle': "\u0412\u044B \u043D\u0435 \u043C\u043E\u0436\u0435\u0442\u0435 \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u044C \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u044B \u043F\u0440\u043E\u0435\u043A\u0442\u0430, \u043F\u043E\u0441\u043A\u043E\u043B\u044C\u043A\u0443 \u0430\u0434\u043C\u0438\u043D\u0438\u0441\u0442\u0440\u0430\u0442\u043E\u0440 \u0441\u0430\u0439\u0442\u0430 \u043E\u0442\u043A\u043B\u043E\u043D\u0438\u043B \u0432\u0430\u0448 \u0437\u0430\u043F\u0440\u043E\u0441 \u043D\u0430 \u043F\u0440\u0438\u0441\u043E\u0435\u0434\u0438\u043D\u0435\u043D\u0438\u0435 \u043A Confluence.",
    'project-pages.cross-join.denied-request.templates.title': "\u0410\u0434\u043C\u0438\u043D\u0438\u0441\u0442\u0440\u0430\u0442\u043E\u0440 \u043E\u0442\u043A\u0430\u0437\u0430\u043B \u0432\u0430\u043C \u0432 \u0434\u043E\u0441\u0442\u0443\u043F\u0435",
    'project-pages.cross-join.direct-access.button-subtitle.experimental': "\u0412\u044B \u043F\u043E\u043B\u0443\u0447\u0438\u0442\u0435 \u0434\u043E\u0441\u0442\u0443\u043F \u043A Confluence. \u0410\u0434\u043C\u0438\u043D\u0438\u0441\u0442\u0440\u0430\u0442\u043E\u0440 \u0441\u0430\u0439\u0442\u0430 \u0443\u0436\u0435 \u043F\u043E\u0434\u0442\u0432\u0435\u0440\u0434\u0438\u043B \u0432\u0430\u0448 \u0437\u0430\u043F\u0440\u043E\u0441.",
    'project-pages.cross-join.errors.unknown-error.description': "\u0415\u0441\u043B\u0438 \u043E\u0431\u043D\u043E\u0432\u043B\u0435\u043D\u0438\u0435 \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u044B \u043D\u0435 \u043F\u043E\u043C\u043E\u0433\u0430\u0435\u0442, {contactSupport}.",
    'project-pages.cross-join.errors.unknown-error.title': "\u0412 \u043D\u0430\u0441\u0442\u043E\u044F\u0449\u0438\u0439 \u043C\u043E\u043C\u0435\u043D\u0442 \u043D\u0435 \u0443\u0434\u0430\u0435\u0442\u0441\u044F \u043E\u0442\u043E\u0431\u0440\u0430\u0437\u0438\u0442\u044C \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u044B \u043F\u0440\u043E\u0435\u043A\u0442\u0430",
    'project-pages.cross-join.inline-join-product.button': "\u0412\u044B \u043F\u043E\u043B\u0443\u0447\u0438\u0442\u0435 \u0434\u043E\u0441\u0442\u0443\u043F \u043A Confluence. \u0410\u0434\u043C\u0438\u043D\u0438\u0441\u0442\u0440\u0430\u0442\u043E\u0440 \u0441\u0430\u0439\u0442\u0430 \u0443\u0436\u0435 \u043F\u043E\u0434\u0442\u0432\u0435\u0440\u0434\u0438\u043B \u0435\u0433\u043E \u0434\u043B\u044F \u0432\u0430\u0441.",
    'project-pages.cross-join.inline-join-product.connected.description': "\u041F\u0440\u043E\u0441\u043C\u0430\u0442\u0440\u0438\u0432\u0430\u0439\u0442\u0435, \u0440\u0435\u0434\u0430\u043A\u0442\u0438\u0440\u0443\u0439\u0442\u0435 \u0438 \u0441\u043E\u0437\u0434\u0430\u0432\u0430\u0439\u0442\u0435 \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0430\u0446\u0438\u044E \u0432 \u043E\u0434\u043D\u043E\u043C \u043C\u0435\u0441\u0442\u0435",
    'project-pages.cross-join.inline-join-product.connected.title': "\u0412\u0435\u0434\u0438\u0442\u0435 \u0441\u043E\u0432\u043C\u0435\u0441\u0442\u043D\u0443\u044E \u0440\u0430\u0431\u043E\u0442\u0443 \u0441 \u043A\u043E\u043C\u0430\u043D\u0434\u043E\u0439 \u043D\u0430\u0434 \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0430\u043C\u0438 \u043F\u0440\u043E\u0435\u043A\u0442\u0430",
    'project-pages.cross-join.pending-request.templates.subtitle': "\u0410\u0434\u043C\u0438\u043D\u0438\u0441\u0442\u0440\u0430\u0442\u043E\u0440 \u0441\u0430\u0439\u0442\u0430 \u043F\u043E\u043B\u0443\u0447\u0438\u043B \u0432\u0430\u0448 \u0437\u0430\u043F\u0440\u043E\u0441 \u043D\u0430 \u043F\u0440\u0438\u0441\u043E\u0435\u0434\u0438\u043D\u0435\u043D\u0438\u0435 \u043A Confluence. \u0415\u0441\u043B\u0438 \u043E\u043D \u0431\u0443\u0434\u0435\u0442 \u0443\u0442\u0432\u0435\u0440\u0436\u0434\u0435\u043D, \u0432\u044B \u0441\u043C\u043E\u0436\u0435\u0442\u0435 \u043D\u0430\u0447\u0430\u0442\u044C \u0440\u0430\u0431\u043E\u0442\u0443 \u043D\u0430 \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0430\u0445 \u043F\u0440\u043E\u0435\u043A\u0442\u0430 \u0438 \u043F\u043E\u043B\u0443\u0447\u0438\u0442\u0435 \u043F\u043E\u0434\u0442\u0432\u0435\u0440\u0436\u0434\u0435\u043D\u0438\u0435 \u043F\u043E \u044D\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u043E\u0439 \u043F\u043E\u0447\u0442\u0435.",
    'project-pages.cross-join.pending-request.templates.subtitle.experiment': "\u041F\u043E\u0441\u043B\u0435 \u043F\u043E\u0434\u0442\u0432\u0435\u0440\u0436\u0434\u0435\u043D\u0438\u044F \u0432\u044B \u043F\u043E\u043B\u0443\u0447\u0438\u0442\u0435 \u044D\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u043E\u0435 \u043F\u0438\u0441\u044C\u043C\u043E \u0434\u043B\u044F \u0434\u043E\u0441\u0442\u0443\u043F\u0430 \u043A \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0430\u043C \u043F\u0440\u043E\u0435\u043A\u0442\u043E\u0432.",
    'project-pages.cross-join.pending-request.templates.title': "\u0412\u044B \u0437\u0430\u043F\u0440\u043E\u0441\u0438\u043B\u0438 \u0434\u043E\u0441\u0442\u0443\u043F \u043A Confluence",
    'project-pages.cross-join.pending-request.templates.title.experiment': "\u0417\u0430\u043F\u0440\u043E\u0441 \u0434\u043E\u0441\u0442\u0443\u043F\u0430 \u043E\u0442\u043F\u0440\u0430\u0432\u043B\u0435\u043D \u0430\u0434\u043C\u0438\u043D\u0438\u0441\u0442\u0440\u0430\u0442\u043E\u0440\u0443",
    'project-pages.cross-join.request-access-without-better-together.connected.description': "\u041F\u0440\u043E\u0441\u043C\u0430\u0442\u0440\u0438\u0432\u0430\u0439\u0442\u0435, \u0440\u0435\u0434\u0430\u043A\u0442\u0438\u0440\u0443\u0439\u0442\u0435 \u0438 \u0441\u043E\u0437\u0434\u0430\u0432\u0430\u0439\u0442\u0435 \u043F\u0440\u043E\u0435\u043A\u0442\u043D\u0443\u044E \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0430\u0446\u0438\u044E \u0432\u043C\u0435\u0441\u0442\u0435 \u0441 \u043A\u043E\u043C\u0430\u043D\u0434\u043E\u0439",
    'project-pages.cross-join.request-access.button': "\u0417\u0430\u043F\u0440\u043E\u0441\u0438\u0442\u044C \u0434\u043E\u0441\u0442\u0443\u043F",
    'project-pages.cross-join.request-access.button-subtitle.experimental': "\u041D\u0430\u0436\u0438\u043C\u0430\u044F \u043A\u043D\u043E\u043F\u043A\u0443 \xab\u041F\u0440\u0438\u0441\u043E\u0435\u0434\u0438\u043D\u0438\u0442\u044C\u0441\u044F \u043A \u043A\u043E\u043C\u0430\u043D\u0434\u0435\xbb, \u0432\u044B \u043F\u0440\u043E\u0441\u0438\u0442\u0435 \u0440\u0430\u0437\u0440\u0435\u0448\u0435\u043D\u0438\u044F \u043F\u0440\u0438\u0441\u043E\u0435\u0434\u0438\u043D\u0438\u0442\u044C\u0441\u044F \u043A Confluence \u0438 \u0441\u043E\u0433\u043B\u0430\u0448\u0430\u0435\u0442\u0435\u0441\u044C \u043F\u043E\u0434\u0435\u043B\u0438\u0442\u044C\u0441\u044F \u0441\u0432\u043E\u0438\u043C \u043F\u0440\u043E\u0444\u0438\u043B\u0435\u043C Atlassian \u0441 \u0430\u0434\u043C\u0438\u043D\u0438\u0441\u0442\u0440\u0430\u0442\u043E\u0440\u043E\u043C.",
    'project-pages.cross-join.request-access.button.experimental': "\u041F\u0440\u0438\u0441\u043E\u0435\u0434\u0438\u043D\u0438\u0442\u044C\u0441\u044F \u043A \u043A\u043E\u043C\u0430\u043D\u0434\u0435",
    'project-pages.cross-join.request-access.connected.description.experimental': "\u0412\u0430\u0448\u0430 \u043A\u043E\u043C\u0430\u043D\u0434\u0430 \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u0443\u0435\u0442 \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u044B \u043F\u0440\u043E\u0435\u043A\u0442\u043E\u0432, \u0447\u0442\u043E\u0431\u044B \u043A\u043E\u043C\u043C\u0435\u043D\u0442\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u0438 \u0440\u0435\u0434\u0430\u043A\u0442\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0430\u0446\u0438\u044E \u043F\u043E \u043F\u0440\u043E\u0435\u043A\u0442\u0430\u043C, \u0430 \u0442\u0430\u043A\u0436\u0435 \u0441\u043E\u0432\u043C\u0435\u0441\u0442\u043D\u043E \u0440\u0430\u0431\u043E\u0442\u0430\u0442\u044C \u043D\u0430\u0434 \u043D\u0435\u0439 \u043F\u0440\u044F\u043C\u043E \u0432 Jira. \u041F\u0440\u0438\u0441\u043E\u0435\u0434\u0438\u043D\u044F\u0439\u0442\u0435\u0441\u044C \u043A Confluence, \u0447\u0442\u043E\u0431\u044B \u043F\u043E\u043B\u0443\u0447\u0438\u0442\u044C \u0434\u043E\u0441\u0442\u0443\u043F \u043A \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0430\u043C \u043F\u0440\u043E\u0435\u043A\u0442\u043E\u0432 \u0432\u0430\u0448\u0435\u0439 \u043A\u043E\u043C\u0430\u043D\u0434\u044B.",
    'project-pages.cross-join.request-access.title': "\u0414\u043B\u044F \u0440\u0430\u0431\u043E\u0442\u044B \u043D\u0430 \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0430\u0445 \u043F\u0440\u043E\u0435\u043A\u0442\u0430 \u0442\u0440\u0435\u0431\u0443\u0435\u0442\u0441\u044F \u0434\u043E\u0441\u0442\u0443\u043F \u043A Confluence",
    'project-pages.cross-join.request-access.title.experiment': "\u0421\u043E\u0437\u0434\u0430\u0439\u0442\u0435 \u0435\u0434\u0438\u043D\u044B\u0439 \u0434\u043E\u0441\u0442\u043E\u0432\u0435\u0440\u043D\u044B\u0439 \u0438\u0441\u0442\u043E\u0447\u043D\u0438\u043A \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u0438 \u0434\u043B\u044F \u043A\u043E\u043C\u0430\u043D\u0434\u044B",
    'project-pages.default-contextual-heading': "\u0421\u0442\u0440\u0430\u043D\u0438\u0446\u044B \u043F\u0440\u043E\u0435\u043A\u0442\u043E\u0432 \u043D\u0430 \u043E\u0441\u043D\u043E\u0432\u0435 Confluence",
    'project-pages.default-contextual-message': "\u0421\u043E\u0437\u0434\u0430\u0432\u0430\u0439\u0442\u0435 \u043F\u0440\u043E\u0435\u043A\u0442\u043D\u044B\u0435 \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u044B, \u0434\u0435\u043B\u0438\u0442\u0435\u0441\u044C \u0438\u043C\u0438 \u0438 \u043E\u0440\u0433\u0430\u043D\u0438\u0437\u043E\u0432\u044B\u0432\u0430\u0439\u0442\u0435 \u0441\u043E\u0432\u043C\u0435\u0441\u0442\u043D\u0443\u044E \u0440\u0430\u0431\u043E\u0442\u0443 \u0432 \u043E\u0434\u043D\u043E\u043C \u043C\u0435\u0441\u0442\u0435 \u0441 \u043F\u043E\u043C\u043E\u0449\u044C\u044E \u0441\u0442\u0440\u0430\u043D\u0438\u0446 Confluence.",
    'project-pages.default-reactivate-CTA': "\u041F\u043E\u0432\u0442\u043E\u0440\u043D\u043E \u0430\u043A\u0442\u0438\u0432\u0438\u0440\u0443\u0439\u0442\u0435 Confluence",
    'project-pages.default-trial-CTA': "\u041F\u043E\u043F\u0440\u043E\u0431\u0443\u0439\u0442\u0435 Confluence \u0431\u0435\u0441\u043F\u043B\u0430\u0442\u043D\u043E \u0432 \u0442\u0435\u0447\u0435\u043D\u0438\u0435 30\xa0\u0434\u043D\u0435\u0439",
    'project-pages.draft-saved-flag.action': "\u041E\u0442\u043A\u0440\u044B\u0442\u044C \u0447\u0435\u0440\u043D\u043E\u0432\u0438\u043A",
    'project-pages.draft-saved-flag.description': "\u0414\u043E \u043F\u0443\u0431\u043B\u0438\u043A\u0430\u0446\u0438\u0438 \u0447\u0435\u0440\u043D\u043E\u0432\u0438\u043A \u0432\u0438\u0434\u0435\u043D \u0442\u043E\u043B\u044C\u043A\u043E \u0432\u0430\u043C.",
    'project-pages.draft-saved-flag.title': "\u0427\u0435\u0440\u043D\u043E\u0432\u0438\u043A \u0441\u043E\u0445\u0440\u0430\u043D\u0435\u043D",
    'project-pages.embedded-pages.create-page-error.close-button': "\u0417\u0430\u043A\u0440\u044B\u0442\u044C",
    'project-pages.embedded-pages.create-page-error.description': "\u041F\u0440\u043E\u0438\u0437\u043E\u0448\u043B\u0430 \u043E\u0448\u0438\u0431\u043A\u0430. \u041D\u0435 \u0443\u0434\u0430\u043B\u043E\u0441\u044C \u0441\u043E\u0437\u0434\u0430\u0442\u044C \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0443.",
    'project-pages.embedded-pages.create-page-error.title': "\u041D\u0435 \u0443\u0434\u0430\u043B\u043E\u0441\u044C \u0441\u043E\u0437\u0434\u0430\u0442\u044C \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0443",
    'project-pages.embedded-pages.create-page-error.try-again-button': "\u041F\u043E\u0432\u0442\u043E\u0440\u0438\u0442\u044C \u043F\u043E\u043F\u044B\u0442\u043A\u0443",
    'project-pages.embedded-pages.modal.close.button.hint': "\u0417\u0430\u043A\u0440\u044B\u0442\u044C",
    'project-pages.embedded-pages.modal.title.button': "\u041E\u0442\u043A\u0440\u044B\u0442\u044C \u0432 Confluence",
    'project-pages.embedded-pages.modal.title.button.hint': "\u041E\u0442\u043A\u0440\u044B\u0442\u044C \u043D\u0430 \u043D\u043E\u0432\u043E\u0439 \u0432\u043A\u043B\u0430\u0434\u043A\u0435",
    'project-pages.errors.unknown-error.description.non-final': "\u0415\u0441\u043B\u0438 \u043E\u0431\u043D\u043E\u0432\u043B\u0435\u043D\u0438\u0435 \u043D\u0435 \u0440\u0435\u0448\u0430\u0435\u0442 \u043F\u0440\u043E\u0431\u043B\u0435\u043C\u0443, {contactSupport}.",
    'project-pages.errors.unknown-error.title.non-final': "\u0412 \u043D\u0430\u0441\u0442\u043E\u044F\u0449\u0438\u0439 \u043C\u043E\u043C\u0435\u043D\u0442 \u043D\u0435 \u0443\u0434\u0430\u0435\u0442\u0441\u044F \u043E\u0442\u043E\u0431\u0440\u0430\u0437\u0438\u0442\u044C \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u044B \u043F\u0440\u043E\u0435\u043A\u0442\u0430",
    'project-pages.generic-error.button.reload': "\u041F\u0435\u0440\u0435\u0437\u0430\u0433\u0440\u0443\u0437\u0438\u0442\u044C \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0443",
    'project-pages.generic-error.description': "\u041F\u0440\u043E\u0438\u0437\u043E\u0448\u043B\u0430 \u043E\u0448\u0438\u0431\u043A\u0430. \u041F\u043E\u0432\u0442\u043E\u0440\u0438\u0442\u0435 \u043F\u043E\u043F\u044B\u0442\u043A\u0443 \u043F\u043E\u0437\u0436\u0435.",
    'project-pages.generic-error.description.non-final': "\u041F\u0440\u043E\u0438\u0437\u043E\u0448\u043B\u0430 \u043E\u0448\u0438\u0431\u043A\u0430. \u041F\u043E\u0432\u0442\u043E\u0440\u0438\u0442\u0435 \u043F\u043E\u043F\u044B\u0442\u043A\u0443 \u043F\u043E\u0437\u0436\u0435.",
    'project-pages.generic-error.heading': "\u041D\u0430\u043C \u0442\u0430\u043A \u043D\u0435\u043B\u043E\u0432\u043A\u043E...",
    'project-pages.generic-error.title.non-final': "\u041D\u0430\u043C \u0442\u0430\u043A \u043D\u0435\u043B\u043E\u0432\u043A\u043E...",
    'project-pages.generic-info-flag.description': "\u041F\u0440\u043E\u0438\u0437\u043E\u0448\u043B\u0430 \u043E\u0448\u0438\u0431\u043A\u0430. \u041F\u043E\u0432\u0442\u043E\u0440\u0438\u0442\u0435 \u043F\u043E\u043F\u044B\u0442\u043A\u0443. \u0415\u0441\u043B\u0438 \u043F\u0440\u043E\u0431\u043B\u0435\u043C\u0430 \u043D\u0435 \u0438\u0441\u0447\u0435\u0437\u043D\u0435\u0442, \u043E\u0431\u0440\u0430\u0442\u0438\u0442\u0435\u0441\u044C \u0432 \u0441\u043B\u0443\u0436\u0431\u0443 \u043F\u043E\u0434\u0434\u0435\u0440\u0436\u043A\u0438.",
    'project-pages.generic-success-flag.description.live-doc': "\u0421\u0432\u044F\u0437\u044C \u0441 \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u043E\u043C \xab{connectedSpaceOrPageName}\xbb \u0432 \u0440\u0435\u0436\u0438\u043C\u0435 \u0440\u0435\u0430\u043B\u044C\u043D\u043E\u0433\u043E \u0432\u0440\u0435\u043C\u0435\u043D\u0438 \u0443\u0441\u0442\u0430\u043D\u043E\u0432\u043B\u0435\u043D\u0430.",
    'project-pages.generic-success-flag.description.page': "\u0421\u0432\u044F\u0437\u044C \u0441\u043E \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0435\u0439 {connectedSpaceOrPageName} \u0443\u0441\u0442\u0430\u043D\u043E\u0432\u043B\u0435\u043D\u0430.",
    'project-pages.generic-success-flag.description.space': "\u0421\u0432\u044F\u0437\u044C \u0441 \u0440\u0430\u0437\u0434\u0435\u043B\u043E\u043C {connectedSpaceOrPageName} \u0443\u0441\u0442\u0430\u043D\u043E\u0432\u043B\u0435\u043D\u0430.",
    'project-pages.generic-success-flag.heading.live-doc': "\u0421\u0432\u044F\u0437\u044C \u0441 \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u043E\u043C \u0432 \u0440\u0435\u0436\u0438\u043C\u0435 \u0440\u0435\u0430\u043B\u044C\u043D\u043E\u0433\u043E \u0432\u0440\u0435\u043C\u0435\u043D\u0438 \u0443\u0441\u0442\u0430\u043D\u043E\u0432\u043B\u0435\u043D\u0430",
    'project-pages.generic-success-flag.heading.page': "\u0421\u0442\u0440\u0430\u043D\u0438\u0446\u0430 \u043F\u043E\u0434\u043A\u043B\u044E\u0447\u0435\u043D\u0430",
    'project-pages.generic-success-flag.heading.space': "\u0420\u0430\u0437\u0434\u0435\u043B \u043F\u043E\u0434\u043A\u043B\u044E\u0447\u0435\u043D",
    'project-pages.granular-pages.connect-space-dialog.content.create-space-link.link-text': "\u0418\u043B\u0438 \u0441\u043E\u0437\u0434\u0430\u0442\u044C \u043D\u043E\u0432\u044B\u0439 \u0440\u0430\u0437\u0434\u0435\u043B",
    'project-pages.granular-pages.connect-space.button': "\u041F\u043E\u0434\u043A\u043B\u044E\u0447\u0438\u0442\u044C \u043A Confluence",
    'project-pages.granular-pages.connect-space.heading': "\u041F\u043E\u0434\u043A\u043B\u044E\u0447\u0438\u0442\u0435 \u043F\u0440\u043E\u0435\u043A\u0442 \u043A \u0440\u0430\u0437\u0434\u0435\u043B\u0443 \u0438\u043B\u0438 \u044D\u043B\u0435\u043C\u0435\u043D\u0442\u0443 Confluence",
    'project-pages.improvement.contact-support': "\u041E\u0431\u0440\u0430\u0442\u0438\u0442\u0435\u0441\u044C \u0432 \u0441\u043B\u0443\u0436\u0431\u0443 \u043F\u043E\u0434\u0434\u0435\u0440\u0436\u043A\u0438",
    'project-pages.improvement.errors.access-error.description': "\u0414\u043B\u044F \u043F\u043E\u043B\u0443\u0447\u0435\u043D\u0438\u044F \u0434\u043E\u0441\u0442\u0443\u043F\u0430 \u043F\u043E\u043F\u0440\u043E\u0431\u0443\u0439\u0442\u0435 \u043E\u0431\u0440\u0430\u0442\u0438\u0442\u044C\u0441\u044F \u043A \u0430\u0434\u043C\u0438\u043D\u0438\u0441\u0442\u0440\u0430\u0442\u043E\u0440\u0443 \u0441\u0430\u0439\u0442\u0430.",
    'project-pages.improvement.errors.access-error.title': "\u0423 \u0432\u0430\u0441 \u043D\u0435\u0442 \u043F\u0440\u0430\u0432 \u0434\u043B\u044F \u043F\u0440\u043E\u0441\u043C\u043E\u0442\u0440\u0430 \u0441\u0442\u0440\u0430\u043D\u0438\u0446 \u044D\u0442\u043E\u0433\u043E \u043F\u0440\u043E\u0435\u043A\u0442\u0430",
    'project-pages.improvement.errors.page-tree-unknown-error.description': "\u041F\u0440\u0438 \u043F\u043E\u043F\u044B\u0442\u043A\u0435 \u043E\u0442\u043E\u0431\u0440\u0430\u0437\u0438\u0442\u044C \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u044B \u0438\u0437 \u043F\u043E\u0434\u043A\u043B\u044E\u0447\u0435\u043D\u043D\u043E\u0433\u043E \u0440\u0430\u0437\u0434\u0435\u043B\u0430 Confluence \u043F\u0440\u043E\u0438\u0437\u043E\u0448\u043B\u0430 \u043E\u0448\u0438\u0431\u043A\u0430. \u0415\u0441\u043B\u0438 \u043E\u0431\u043D\u043E\u0432\u043B\u0435\u043D\u0438\u0435 \u043D\u0435 \u0440\u0435\u0448\u0430\u0435\u0442 \u043F\u0440\u043E\u0431\u043B\u0435\u043C\u0443, {contactSupport}.",
    'project-pages.improvement.errors.page-tree-unknown-error.title': "\u0412\u043E\u0437\u043D\u0438\u043A\u043B\u0430 \u043F\u0440\u043E\u0431\u043B\u0435\u043C\u0430 \u0441 \u043E\u0442\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u0438\u0435\u043C \u0441\u0442\u0440\u0430\u043D\u0438\u0446 \u043F\u0440\u043E\u0435\u043A\u0442\u0430",
    'project-pages.improvement.errors.space-or-page-not-found.description': "\u041F\u043E\u0434\u043A\u043B\u044E\u0447\u0435\u043D\u043D\u044B\u0439 \u0440\u0430\u0437\u0434\u0435\u043B \u0438\u043B\u0438 \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0430 Confluence \u0431\u044B\u043B\u0438 \u043F\u0435\u0440\u0435\u043C\u0435\u0449\u0435\u043D\u044B, \u0437\u0430\u0430\u0440\u0445\u0438\u0432\u0438\u0440\u043E\u0432\u0430\u043D\u044B \u0438\u043B\u0438 \u0443\u0434\u0430\u043B\u0435\u043D\u044B. \u0415\u0441\u043B\u0438 \u043F\u043E\u0432\u0442\u043E\u0440\u043D\u043E\u0435 \u043F\u043E\u0434\u043A\u043B\u044E\u0447\u0435\u043D\u0438\u0435 \u043D\u0435 \u0440\u0435\u0448\u0438\u0442 \u043F\u0440\u043E\u0431\u043B\u0435\u043C\u0443, <link>\u043E\u0431\u0440\u0430\u0442\u0438\u0442\u0435\u0441\u044C \u0432 \u0441\u043B\u0443\u0436\u0431\u0443 \u043F\u043E\u0434\u0434\u0435\u0440\u0436\u043A\u0438</link>",
    'project-pages.improvement.errors.space-or-page-not-found.title': "\u0420\u0430\u0437\u0434\u0435\u043B \u0438\u043B\u0438 \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0430 \u043D\u0435 \u043D\u0430\u0439\u0434\u0435\u043D\u044B",
    'project-pages.improvement.errors.unknown-error.description': "\u0415\u0441\u043B\u0438 \u043E\u0431\u043D\u043E\u0432\u043B\u0435\u043D\u0438\u0435 \u043D\u0435 \u0440\u0435\u0448\u0430\u0435\u0442 \u043F\u0440\u043E\u0431\u043B\u0435\u043C\u0443, {contactSupport}.",
    'project-pages.improvement.errors.unknown-error.title': "\u0412 \u043D\u0430\u0441\u0442\u043E\u044F\u0449\u0438\u0439 \u043C\u043E\u043C\u0435\u043D\u0442 \u043D\u0435 \u0443\u0434\u0430\u0435\u0442\u0441\u044F \u043E\u0442\u043E\u0431\u0440\u0430\u0437\u0438\u0442\u044C \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u044B \u043F\u0440\u043E\u0435\u043A\u0442\u0430",
    'project-pages.improvement.feature1': "\u041F\u0440\u043E\u0441\u043C\u043E\u0442\u0440 \u0438 \u0441\u043E\u0437\u0434\u0430\u043D\u0438\u0435 \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u043E\u0432 \u043F\u0440\u044F\u043C\u043E \u0432 Jira",
    'project-pages.improvement.feature2': "\u0428\u0430\u0431\u043B\u043E\u043D\u044B \u0441\u043E\u0431\u0440\u0430\u043D\u0438\u0439, \u043F\u043B\u0430\u043D\u044B \u0441\u043F\u0440\u0438\u043D\u0442\u043E\u0432 \u0438 \u0434\u0440\u0443\u0433\u0438\u0435 \u0432\u043E\u0437\u043C\u043E\u0436\u043D\u043E\u0441\u0442\u0438",
    'project-pages.improvement.feature3': "\u0421\u0438\u043D\u0445\u0440\u043E\u043D\u0438\u0437\u0430\u0446\u0438\u044F \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u043E\u0432 \u0441 Jira \u0434\u043B\u044F \u0430\u0432\u0442\u043E\u043C\u0430\u0442\u0438\u0447\u0435\u0441\u043A\u043E\u0433\u043E \u043E\u0431\u043D\u043E\u0432\u043B\u0435\u043D\u0438\u044F",
    'project-pages.improvement.heading-info': "\u041D\u0430\u043A\u0430\u043F\u043B\u0438\u0432\u0430\u0439\u0442\u0435 \u0437\u043D\u0430\u043D\u0438\u044F \u043A\u043E\u043C\u0430\u043D\u0434\u044B \u0438 \u0441\u043F\u0440\u0430\u0432\u043B\u044F\u0439\u0442\u0435\u0441\u044C \u0441 \u0440\u0430\u0431\u043E\u0442\u043E\u0439 \u0432\u0441\u0435 \u043B\u0443\u0447\u0448\u0435.",
    'project-pages.improvement.heading-info-v2': "\u0421\u043E\u0437\u0434\u0430\u0439\u0442\u0435 \u0435\u0434\u0438\u043D\u043E\u0435 \u043C\u0435\u0441\u0442\u043E \u0434\u043B\u044F \u0432\u0441\u0435\u0439 \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0430\u0446\u0438\u0438 \u043A\u043E\u043C\u0430\u043D\u0434\u044B \u043F\u043E \u043F\u0440\u043E\u0435\u043A\u0442\u0443",
    'project-pages.improvement.learn-more-button': "\u041F\u043E\u0434\u0440\u043E\u0431\u043D\u0435\u0435",
    'project-pages.improvement.powered-by': "\u041F\u0440\u0438 \u043F\u043E\u0434\u0434\u0435\u0440\u0436\u043A\u0435",
    'project-pages.improvement.powered-by.tooltip': "\u041E\u0442\u043A\u0440\u044B\u0442\u044C Confluence \u043D\u0430 \u043D\u043E\u0432\u043E\u0439 \u0432\u043A\u043B\u0430\u0434\u043A\u0435",
    'project-pages.improvement.preview-teaser': "\u041D\u0430\u0447\u043D\u0438\u0442\u0435 \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u044C \u0448\u0430\u0431\u043B\u043E\u043D\u044B, \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u044B \u043F\u0440\u043E\u0435\u043A\u0442\u043E\u0432 \u0438 \u043C\u043D\u043E\u0433\u043E\u0435 \u0434\u0440\u0443\u0433\u043E\u0435.",
    'project-pages.improvement.provisioning-info-modal.seamlessly-update-stakeholders.description': "<p>\u041F\u043E\u0434\u0434\u0435\u0440\u0436\u0438\u0432\u0430\u0439\u0442\u0435 \u043E\u0442\u0447\u0435\u0442\u044B \u043F\u043E \u043F\u0440\u043E\u0435\u043A\u0442\u0430\u043C \u0432 \u0430\u043A\u0442\u0443\u0430\u043B\u044C\u043D\u043E\u043C \u0441\u043E\u0441\u0442\u043E\u044F\u043D\u0438\u0438 \u0441 \u043F\u043E\u043C\u043E\u0449\u044C\u044E \u0430\u0432\u0442\u043E\u043C\u0430\u0442\u0438\u0447\u0435\u0441\u043A\u0438 \u043E\u0431\u043D\u043E\u0432\u043B\u044F\u0435\u043C\u044B\u0445 \u043C\u0435\u0442\u043E\u043A \u0441\u0442\u0430\u0442\u0443\u0441\u0430.</p> <p>\u041F\u0440\u043E\u0441\u0442\u043E \u0441\u0432\u044F\u0436\u0438\u0442\u0435 \u0437\u0430\u044F\u0432\u043A\u0443 Jira \u0441 \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u043E\u043C, \u0438 \u0432 \u043D\u0435\u043C \u0430\u0432\u0442\u043E\u043C\u0430\u0442\u0438\u0447\u0435\u0441\u043A\u0438 \u043F\u043E\u044F\u0432\u0438\u0442\u0441\u044F \u043C\u0435\u0442\u043A\u0430 \u0441\u0442\u0430\u0442\u0443\u0441\u0430, \u043A\u043E\u0442\u043E\u0440\u0430\u044F \u0431\u0443\u0434\u0435\u0442 \u043E\u0431\u043D\u043E\u0432\u043B\u044F\u0442\u044C\u0441\u044F \u0441\u0438\u043D\u0445\u0440\u043E\u043D\u043D\u043E \u0441 \u0437\u0430\u044F\u0432\u043A\u043E\u0439, \u0442\u0430\u043A \u0447\u0442\u043E \u0432\u0430\u043C \u043D\u0435 \u043F\u0440\u0438\u0434\u0435\u0442\u0441\u044F \u0442\u0440\u0430\u0442\u0438\u0442\u044C \u0432\u0440\u0435\u043C\u044F \u043D\u0430 \u0441\u043E\u0437\u0434\u0430\u043D\u0438\u0435 \u043E\u0442\u0447\u0435\u0442\u043E\u0432 \u0432\u0440\u0443\u0447\u043D\u0443\u044E.</p>",
    'project-pages.improvement.provisioning-info-modal.seamlessly-update-stakeholders.title': "\u041F\u043E\u0441\u0442\u043E\u044F\u043D\u043D\u043E \u0434\u0435\u0440\u0436\u0438\u0442\u0435 \u0437\u0430\u0438\u043D\u0442\u0435\u0440\u0435\u0441\u043E\u0432\u0430\u043D\u043D\u044B\u0445 \u043B\u0438\u0446 \u0432 \u043A\u0443\u0440\u0441\u0435 \u0441\u043E\u0431\u044B\u0442\u0438\u0439",
    'project-pages.improvement.provisioning-info-modal.unify-documentation-standards.description': "<p>\u0421\u043E\u0437\u0434\u0430\u0432\u0430\u0439\u0442\u0435 \u0435\u0434\u0438\u043D\u043E\u043E\u0431\u0440\u0430\u0437\u043D\u0443\u044E \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0430\u0446\u0438\u044E \u0441 \u043F\u043E\u043C\u043E\u0449\u044C\u044E \u0443\u0434\u043E\u0431\u043D\u044B\u0445 \u0432\u0441\u0442\u0440\u043E\u0435\u043D\u043D\u044B\u0445 \u0448\u0430\u0431\u043B\u043E\u043D\u043E\u0432, \u043A\u043E\u0442\u043E\u0440\u044B\u0435 \u043C\u043E\u0436\u043D\u043E \u043D\u0430\u0441\u0442\u0440\u043E\u0438\u0442\u044C \u043F\u043E\u0434 \u0432\u0430\u0448\u0438 \u043F\u043E\u0442\u0440\u0435\u0431\u043D\u043E\u0441\u0442\u0438.</p> <p>\u0428\u0430\u0431\u043B\u043E\u043D\u044B \u043C\u043E\u0436\u043D\u043E \u043F\u0440\u0438\u043C\u0435\u043D\u044F\u0442\u044C \u043F\u0440\u044F\u043C\u043E \u043D\u0430 \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0430\u0445 \u043F\u0440\u043E\u0435\u043A\u0442\u0430, \u043D\u0435 \u043E\u0442\u0440\u044B\u0432\u0430\u044F\u0441\u044C \u043E\u0442 \u0440\u0430\u0431\u043E\u0442\u044B. \u0412\u0441\u0435 \u0448\u0430\u0431\u043B\u043E\u043D\u044B \u0441\u043C. <a>\u0437\u0434\u0435\u0441\u044C</a>.</p>",
    'project-pages.improvement.provisioning-info-modal.unify-documentation-standards.title': "\u0418\u0441\u043F\u043E\u043B\u044C\u0437\u0443\u0439\u0442\u0435 \u0435\u0434\u0438\u043D\u044B\u0435 \u0441\u0442\u0430\u043D\u0434\u0430\u0440\u0442\u044B \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u044F",
    'project-pages.improvement.provisioning-info-modal.your-project-pages-in-jira.description': "<p>\u0421\u043E\u0437\u0434\u0430\u0432\u0430\u0439\u0442\u0435 \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0430\u0446\u0438\u044E \u0438 \u0443\u043F\u0440\u0430\u0432\u043B\u044F\u0439\u0442\u0435 \u0435\u044E \u043D\u0430 \u0432\u043A\u043B\u0430\u0434\u043A\u0435 \u0441\u0442\u0440\u0430\u043D\u0438\u0446 \u043F\u0440\u043E\u0435\u043A\u0442\u0430 \u0432 Jira. \u042D\u0442\u043E \u043F\u043E\u0437\u0432\u043E\u043B\u0438\u0442 \u0432\u043D\u0435\u0434\u0440\u0438\u0442\u044C \u0435\u0434\u0438\u043D\u044B\u0439 \u0434\u043E\u0441\u0442\u043E\u0432\u0435\u0440\u043D\u044B\u0439 \u0438\u0441\u0442\u043E\u0447\u043D\u0438\u043A \u0432\u0430\u0436\u043D\u043E\u0439 \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u0438.</p> <p>\u0417\u043D\u0430\u0435\u0442\u0435 \u043B\u0438 \u0432\u044B, \u0447\u0442\u043E \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u044B \u043F\u0440\u043E\u0435\u043A\u0442\u0430 \u0440\u0430\u0431\u043E\u0442\u0430\u044E\u0442 \u0432 Confluence? \u041F\u043E\u0434\u0434\u0435\u0440\u0436\u0438\u0432\u0430\u0435\u0442\u0441\u044F \u0434\u043E 10\xa0\u0431\u0435\u0441\u043F\u043B\u0430\u0442\u043D\u044B\u0445 \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u0435\u0439. \u041F\u0440\u0438\u0433\u043B\u0430\u0441\u0438\u0442\u0435 \u043E\u0441\u0442\u0430\u043B\u044C\u043D\u044B\u0445 \u0443\u0447\u0430\u0441\u0442\u043D\u0438\u043A\u043E\u0432 \u043A\u043E\u043C\u0430\u043D\u0434\u044B \u0432 \u043D\u0430\u0441\u0442\u0440\u043E\u0439\u043A\u0430\u0445 \u0430\u0434\u043C\u0438\u043D\u0438\u0441\u0442\u0440\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u044F.</p>",
    'project-pages.improvement.provisioning-info-modal.your-project-pages-in-jira.title': "\u0420\u0430\u0431\u043E\u0442\u0430 \u0441\u043E \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0430\u043C\u0438 \u043F\u0440\u043E\u0435\u043A\u0442\u0430 \u043F\u0440\u044F\u043C\u043E \u0432 Jira",
    'project-pages.improvement.templates-sidebar.better-together-templates-header': "\u0428\u0430\u0431\u043B\u043E\u043D\u044B, \u0438\u043D\u0442\u0435\u0433\u0440\u0438\u0440\u043E\u0432\u0430\u043D\u043D\u044B\u0435 \u0441 \u0434\u0430\u043D\u043D\u044B\u043C\u0438 Jira",
    'project-pages.improvement.templates.better-together-preview-teaser': "\u0418\u043D\u0442\u0435\u0433\u0440\u0438\u0440\u043E\u0432\u0430\u043D\u043E \u0441 \u0434\u0430\u043D\u043D\u044B\u043C\u0438 Jira",
    'project-pages.improvement.templates.blank-page.description': "\u0421\u043E\u0437\u0434\u0430\u0439\u0442\u0435 \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0443 \u0441 \u0447\u0438\u0441\u0442\u043E\u0433\u043E \u043B\u0438\u0441\u0442\u0430.",
    'project-pages.improvement.templates.blank-page.name': "\u041F\u0443\u0441\u0442\u0430\u044F \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0430",
    'project-pages.improvement.templates.decision.description': "\u0417\u0430\u043F\u0438\u0448\u0438\u0442\u0435 \u0432\u0430\u0436\u043D\u044B\u0435 \u0440\u0435\u0448\u0435\u043D\u0438\u044F \u043F\u043E \u043F\u0440\u043E\u0435\u043A\u0442\u0443 \u0438 \u043E\u0431\u0441\u0443\u0434\u0438\u0442\u0435 \u0438\u0445 \u0441\u043E \u0441\u0432\u043E\u0435\u0439 \u043A\u043E\u043C\u0430\u043D\u0434\u043E\u0439.",
    'project-pages.improvement.templates.decision.name': "\u0420\u0435\u0448\u0435\u043D\u0438\u0435",
    'project-pages.improvement.templates.meeting-notes.description': "\u041F\u043B\u0430\u043D\u0438\u0440\u0443\u0439\u0442\u0435 \u0432\u0441\u0442\u0440\u0435\u0447\u0438, \u0434\u0435\u043B\u0430\u0439\u0442\u0435 \u0437\u0430\u043C\u0435\u0442\u043A\u0438 \u0438 \u0434\u0435\u043B\u0438\u0442\u0435\u0441\u044C \u0437\u0430\u0434\u0430\u043D\u0438\u044F\u043C\u0438 \u0441 \u043A\u043E\u043C\u0430\u043D\u0434\u043E\u0439.",
    'project-pages.improvement.templates.meeting-notes.name': "\u041F\u0440\u043E\u0442\u043E\u043A\u043E\u043B\u044B \u0441\u043E\u0431\u0440\u0430\u043D\u0438\u0439",
    'project-pages.improvement.templates.post-expand.more': "\u0414\u0440\u0443\u0433\u0438\u0435 \u0448\u0430\u0431\u043B\u043E\u043D\u044B",
    'project-pages.improvement.templates.post-expand.more.tooltip': "\u041F\u043E\u0441\u043C\u043E\u0442\u0440\u0435\u0442\u044C \u0432\u0441\u0435 \u0448\u0430\u0431\u043B\u043E\u043D\u044B \u0432 Confluence",
    'project-pages.improvement.templates.post-expand.subtitle': "\u041F\u043E\u043F\u0443\u043B\u044F\u0440\u043D\u044B\u0435 \u0448\u0430\u0431\u043B\u043E\u043D\u044B",
    'project-pages.improvement.templates.post-expand.title': "\u0421\u043E\u0437\u0434\u0430\u0442\u044C \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0443",
    'project-pages.improvement.templates.pre-expand.more': "\u0421\u043C\u043E\u0442\u0440\u0435\u0442\u044C \u0434\u0440\u0443\u0433\u0438\u0435 \u0448\u0430\u0431\u043B\u043E\u043D\u044B",
    'project-pages.improvement.templates.pre-expand.subtitle': "\u041F\u043E\u043F\u0443\u043B\u044F\u0440\u043D\u043E \u0443 \u0430\u043D\u0430\u043B\u043E\u0433\u0438\u0447\u043D\u044B\u0445 \u043A\u043E\u043C\u0430\u043D\u0434",
    'project-pages.improvement.templates.pre-expand.title': "\u041F\u0440\u0435\u0434\u0432\u0430\u0440\u0438\u0442\u0435\u043B\u044C\u043D\u044B\u0439 \u043F\u0440\u043E\u0441\u043C\u043E\u0442\u0440 \u0448\u0430\u0431\u043B\u043E\u043D\u043E\u0432",
    'project-pages.improvement.templates.product-requirements.description': "\u041E\u043F\u0440\u0435\u0434\u0435\u043B\u0435\u043D\u0438\u0435, \u043E\u0442\u0441\u043B\u0435\u0436\u0438\u0432\u0430\u043D\u0438\u0435 \u0438 \u043E\u0446\u0435\u043D\u043A\u0430 \u043E\u0431\u044A\u0435\u043C\u0430 \u0442\u0440\u0435\u0431\u043E\u0432\u0430\u043D\u0438\u0439 \u0434\u043B\u044F \u043F\u0440\u043E\u0434\u0443\u043A\u0442\u0430 \u0438\u043B\u0438 \u0444\u0443\u043D\u043A\u0446\u0438\u0438.",
    'project-pages.improvement.templates.product-requirements.name': "\u0422\u0440\u0435\u0431\u043E\u0432\u0430\u043D\u0438\u044F \u043A \u043F\u0440\u043E\u0434\u0443\u043A\u0442\u0443",
    'project-pages.improvement.templates.retrospective.description': "\u0427\u0442\u043E \u0443\u0436\u0435 \u0441\u0434\u0435\u043B\u0430\u043D\u043E? \u0427\u0442\u043E \u043C\u043E\u0436\u043D\u043E \u0443\u043B\u0443\u0447\u0448\u0438\u0442\u044C? \u0421\u043E\u0432\u043C\u0435\u0441\u0442\u043D\u0430\u044F \u0440\u0430\u0431\u043E\u0442\u0430 \u0432\u0430\u0448\u0435\u0439 \u043A\u043E\u043C\u0430\u043D\u0434\u044B \u043D\u0430\u0434 \u0443\u043B\u0443\u0447\u0448\u0435\u043D\u0438\u044F\u043C\u0438.",
    'project-pages.improvement.templates.retrospective.name': "\u0420\u0435\u0442\u0440\u043E\u0441\u043F\u0435\u043A\u0442\u0438\u0432\u0430",
    'project-pages.improvement.templates.template.disabled-tooltip': "\u0421\u043D\u0430\u0447\u0430\u043B\u0430 \u043F\u043E\u0434\u043A\u043B\u044E\u0447\u0438\u0442\u0435 \u0440\u0430\u0437\u0434\u0435\u043B Confluence",
    'project-pages.improvement.templates.tutorial.content.confluence-templates': "<b>\u042D\u043A\u043E\u043D\u043E\u043C\u0438\u044F \u0432\u0440\u0435\u043C\u0435\u043D\u0438 \u0438 \u0441\u043E\u043A\u0440\u0430\u0449\u0435\u043D\u0438\u0435 \u043A\u043E\u043B\u0438\u0447\u0435\u0441\u0442\u0432\u0430 \u0432\u044B\u043F\u043E\u043B\u043D\u044F\u0435\u043C\u044B\u0445 \u0432\u0440\u0443\u0447\u043D\u0443\u044E \u0437\u0430\u0434\u0430\u0447</b>. \u0412 Confluence \u0435\u0441\u0442\u044C \u043C\u043D\u043E\u0436\u0435\u0441\u0442\u0432\u043E <a>\u0448\u0430\u0431\u043B\u043E\u043D\u043E\u0432</a> \u0441\u0442\u0440\u0430\u043D\u0438\u0446, \u043F\u043E\u044D\u0442\u043E\u043C\u0443 \u0432\u0430\u043C \u043D\u0438\u043A\u043E\u0433\u0434\u0430 \u043D\u0435 \u043F\u0440\u0438\u0434\u0435\u0442\u0441\u044F \u043D\u0430\u0447\u0438\u043D\u0430\u0442\u044C \u0440\u0430\u0431\u043E\u0442\u0443 \u0441 \u0447\u0438\u0441\u0442\u043E\u0433\u043E \u043B\u0438\u0441\u0442\u0430. \u0414\u043E\u0441\u0442\u0443\u043F\u043D\u044B \u0448\u0430\u0431\u043B\u043E\u043D\u044B \u0434\u043B\u044F \u0442\u0435\u0445\u043D\u0438\u0447\u0435\u0441\u043A\u043E\u0439 \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0430\u0446\u0438\u0438, \u0440\u0443\u043A\u043E\u0432\u043E\u0434\u0441\u0442\u0432 \u043F\u043E \u0443\u0441\u0442\u0440\u0430\u043D\u0435\u043D\u0438\u044E \u043D\u0435\u043F\u043E\u043B\u0430\u0434\u043E\u043A, \u043F\u043B\u0430\u043D\u043E\u0432 \u043F\u0440\u043E\u0435\u043A\u0442\u043E\u0432, \u0442\u0440\u0435\u0431\u043E\u0432\u0430\u043D\u0438\u0439 \u043A \u043F\u0440\u043E\u0434\u0443\u043A\u0442\u0430\u043C \u0438 \u043C\u043D\u043E\u0433\u043E\u0433\u043E \u0434\u0440\u0443\u0433\u043E\u0433\u043E.",
    'project-pages.improvement.templates.tutorial.content.edit-and-format': "<b>\u0423\u0434\u043E\u0431\u043D\u043E\u0435 \u0440\u0435\u0434\u0430\u043A\u0442\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u0435 \u0438 \u0444\u043E\u0440\u043C\u0430\u0442\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u0435.</b> \u0414\u043B\u044F \u0441\u0442\u0430\u043D\u0434\u0430\u0440\u0442\u043D\u043E\u0433\u043E \u0444\u043E\u0440\u043C\u0430\u0442\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u044F \u0442\u0435\u043A\u0441\u0442\u0430 \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u0443\u0435\u0442\u0441\u044F \u0432\u0435\u0440\u0445\u043D\u0435\u0435 \u043C\u0435\u043D\u044E \u0440\u0435\u0434\u0430\u043A\u0442\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u044F, \u0430 \u0441 \u043F\u043E\u043C\u043E\u0449\u044C\u044E \u043A\u043E\u043C\u0430\u043D\u0434\u044B <b>/</b> \u043C\u043E\u0436\u043D\u043E \u043B\u0435\u0433\u043A\u043E \u0432\u0441\u0442\u0430\u0432\u0438\u0442\u044C \u043C\u043D\u043E\u0436\u0435\u0441\u0442\u0432\u043E \u0443\u0434\u043E\u0431\u043D\u044B\u0445 \u0438\u043D\u0442\u0435\u0433\u0440\u0430\u0446\u0438\u0439. \u0414\u043B\u044F \u0432\u0441\u0442\u0430\u0432\u043A\u0438 \u0442\u0430\u0431\u043B\u0438\u0446\u044B \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u0443\u0439\u0442\u0435 \u043A\u043E\u043C\u0430\u043D\u0434\u0443 <c>/\u0442\u0430\u0431\u043B\u0438\u0446\u0430</c>, \u0434\u043B\u044F \u0432\u0441\u0442\u0430\u0432\u043A\u0438 \u0438\u0437\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u0438\u044F\xa0\u2014 <c>/\u0438\u0437\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u0438\u0435</c>. \u041C\u043E\u0436\u043D\u043E \u0442\u0430\u043A\u0436\u0435 \u0432\u0441\u0442\u0430\u0432\u043B\u044F\u0442\u044C \u0441\u0441\u044B\u043B\u043A\u0438 Dropbox (<c>/dropbox</c>), \u0438\u043D\u0441\u0442\u0440\u0443\u043C\u0435\u043D\u0442\u044B Microsoft Office (<c>/microsoft</c>) \u0438\u043B\u0438 \u0434\u043E\u0441\u043A\u0438 \u0438 \u043A\u0430\u0440\u0442\u043E\u0447\u043A\u0438 Trello (<c>/trello</c>).",
    'project-pages.improvement.templates.tutorial.content.forward-slash-prompt': "\u0412\u0435\u0434\u0438\u0442\u0435 \xab/\xbb, \u0430 \u0437\u0430\u0442\u0435\u043C \xab\u0442\u0430\u0431\u043B\u0438\u0446\u0430\xbb \u0438\u043B\u0438 \xab\u0438\u0437\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u0438\u0435\xbb",
    'project-pages.improvement.templates.tutorial.content.getting-started-tips': "\u0412\u043E\u0442 \u043D\u0435\u0441\u043A\u043E\u043B\u044C\u043A\u043E \u0441\u043E\u0432\u0435\u0442\u043E\u0432, \u043A\u043E\u0442\u043E\u0440\u044B\u0435 \u043F\u043E\u043C\u043E\u0433\u0443\u0442 \u0432\u0430\u043C \u043D\u0430\u0447\u0430\u0442\u044C \u0440\u0430\u0431\u043E\u0442\u0443.",
    'project-pages.improvement.templates.tutorial.content.handy-links': "\u0423\u0434\u043E\u0431\u043D\u044B\u0435 \u0441\u0441\u044B\u043B\u043A\u0438",
    'project-pages.improvement.templates.tutorial.content.jira-and-confluence': "\u0421\u043E\u0432\u043C\u0435\u0441\u0442\u043D\u043E\u0435 \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u0435 Jira \u0438 Confluence",
    'project-pages.improvement.templates.tutorial.content.jira-charts': "\u0421\u043E\u0437\u0434\u0430\u0432\u0430\u0439\u0442\u0435 \u0433\u0440\u0430\u0444\u0438\u043A\u0438 \u043D\u0430 \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0430\u0445, \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u0443\u044F \u0440\u0435\u0430\u043B\u044C\u043D\u044B\u0435 \u0434\u0430\u043D\u043D\u044B\u0435 Jira. \u0412\u0432\u0435\u0434\u0438\u0442\u0435 <c>/\u0433\u0440\u0430\u0444\u0438\u043A\u0438 Jira</c>.",
    'project-pages.improvement.templates.tutorial.content.jira-links': "\u0421\u043E\u0437\u0434\u0430\u0432\u0430\u0439\u0442\u0435 \u0441\u0441\u044B\u043B\u043A\u0438 \u043D\u0430 \u0437\u0430\u0434\u0430\u0447\u0438 Jira \u0432 \u043B\u044E\u0431\u043E\u043C \u043C\u0435\u0441\u0442\u0435 \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u044B. \u041F\u0440\u0438 \u043E\u0431\u043D\u043E\u0432\u043B\u0435\u043D\u0438\u0438 \u0437\u0430\u0434\u0430\u0447\u0438 Jira \u0441\u0441\u044B\u043B\u043A\u0430 \u043D\u0430 \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0435 \u0431\u0443\u0434\u0435\u0442 \u043E\u0431\u043D\u043E\u0432\u043B\u044F\u0442\u044C\u0441\u044F \u0432 \u0440\u0435\u0436\u0438\u043C\u0435 \u0440\u0435\u0430\u043B\u044C\u043D\u043E\u0433\u043E \u0432\u0440\u0435\u043C\u0435\u043D\u0438. \u0412\u0432\u0435\u0434\u0438\u0442\u0435 <c>/Jira</c>.",
    'project-pages.improvement.templates.tutorial.content.jira-links-issue-term-refresh': "\u0421\u043E\u0437\u0434\u0430\u0432\u0430\u0439\u0442\u0435 \u0441\u0441\u044B\u043B\u043A\u0438 \u043D\u0430 \u0437\u0430\u0434\u0430\u0447\u0438 Jira \u0432 \u043B\u044E\u0431\u043E\u043C \u043C\u0435\u0441\u0442\u0435 \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u044B. \u041F\u0440\u0438 \u043E\u0431\u043D\u043E\u0432\u043B\u0435\u043D\u0438\u0438 \u0437\u0430\u0434\u0430\u0447\u0438 \u0441\u0441\u044B\u043B\u043A\u0430 \u043D\u0430 \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0435 \u0431\u0443\u0434\u0435\u0442 \u043E\u0431\u043D\u043E\u0432\u043B\u044F\u0442\u044C\u0441\u044F \u0432 \u0440\u0435\u0430\u043B\u044C\u043D\u043E\u043C \u0432\u0440\u0435\u043C\u0435\u043D\u0438. \u0412\u0432\u0435\u0434\u0438\u0442\u0435 <c>/Jira</c>.",
    'project-pages.improvement.templates.tutorial.content.jira-links.non-final-issue-term-refresh': "\u0421\u043E\u0437\u0434\u0430\u0432\u0430\u0439\u0442\u0435 \u0441\u0441\u044B\u043B\u043A\u0438 \u043D\u0430 \u0437\u0430\u0434\u0430\u0447\u0438 Jira \u0432 \u043B\u044E\u0431\u043E\u043C \u043C\u0435\u0441\u0442\u0435 \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u044B. \u041F\u0440\u0438 \u043E\u0431\u043D\u043E\u0432\u043B\u0435\u043D\u0438\u0438 \u0437\u0430\u0434\u0430\u0447\u0438 \u0441\u0441\u044B\u043B\u043A\u0430 \u043D\u0430 \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0435 \u0431\u0443\u0434\u0435\u0442 \u043E\u0431\u043D\u043E\u0432\u043B\u044F\u0442\u044C\u0441\u044F \u0432 \u0440\u0435\u0430\u043B\u044C\u043D\u043E\u043C \u0432\u0440\u0435\u043C\u0435\u043D\u0438. \u0412\u0432\u0435\u0434\u0438\u0442\u0435 <c>/Jira</c>.",
    'project-pages.improvement.templates.tutorial.content.jira-roadmaps': "\u0412\u0441\u0442\u0440\u0430\u0438\u0432\u0430\u0439\u0442\u0435 \u043D\u0430 \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0443 \u0438\u043D\u0442\u0435\u0440\u0430\u043A\u0442\u0438\u0432\u043D\u044B\u0435 \u0434\u043E\u0440\u043E\u0436\u043D\u044B\u0435 \u043A\u0430\u0440\u0442\u044B \u0438 \u0445\u0440\u043E\u043D\u043E\u043B\u043E\u0433\u0438\u0438, \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u0443\u044F \u043F\u0440\u043E\u0435\u043A\u0442\u044B Jira. \u0412\u0432\u0435\u0434\u0438\u0442\u0435 <c>/\u0434\u043E\u0440\u043E\u0436\u043D\u0430\u044F \u043A\u0430\u0440\u0442\u0430 jira</c>.",
    'project-pages.improvement.templates.tutorial.content.jira-timeline': "\u0412\u0441\u0442\u0440\u0430\u0438\u0432\u0430\u0439\u0442\u0435 \u043D\u0430 \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0443 \u0438\u043D\u0442\u0435\u0440\u0430\u043A\u0442\u0438\u0432\u043D\u044B\u0435 \u0445\u0440\u043E\u043D\u043E\u043B\u043E\u0433\u0438\u0438, \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u0443\u044F \u043F\u0440\u043E\u0435\u043A\u0442\u044B Jira. \u0412\u0432\u0435\u0434\u0438\u0442\u0435 <c>/\u0445\u0440\u043E\u043D\u043E\u043B\u043E\u0433\u0438\u044F Jira</c>.",
    'project-pages.improvement.templates.tutorial.content.shipping-speed-statistic': "76\xa0% \u043A\u043B\u0438\u0435\u043D\u0442\u043E\u0432 Jira Software \u043E\u0442\u043C\u0435\u0442\u0438\u043B\u0438, \u0447\u0442\u043E \u043F\u043E\u0441\u043B\u0435 \u0434\u043E\u0431\u0430\u0432\u043B\u0435\u043D\u0438\u044F Confluence \u043F\u043E\u0441\u0442\u0430\u0432\u043A\u0430 \u043F\u0440\u043E\u0435\u043A\u0442\u043E\u0432 \u0443\u0441\u043A\u043E\u0440\u0438\u043B\u0430\u0441\u044C.",
    'project-pages.improvement.templates.tutorial.content.shipping-speed-statistic.spork-rebranding': "76\xa0% \u043A\u043B\u0438\u0435\u043D\u0442\u043E\u0432 Jira \u043E\u0442\u043C\u0435\u0442\u0438\u043B\u0438, \u0447\u0442\u043E \u043F\u043E\u0441\u043B\u0435 \u0434\u043E\u0431\u0430\u0432\u043B\u0435\u043D\u0438\u044F Confluence \u043F\u043E\u0441\u0442\u0430\u0432\u043A\u0430 \u043F\u0440\u043E\u0435\u043A\u0442\u043E\u0432 \u0443\u0441\u043A\u043E\u0440\u0438\u043B\u0430\u0441\u044C",
    'project-pages.improvement.templates.tutorial.content.spaces-and-pages': "<b>\u0418\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u0435 \u0440\u0430\u0437\u0434\u0435\u043B\u043E\u0432 \u0438 \u0441\u0442\u0440\u0430\u043D\u0438\u0446</b>. \u0420\u0430\u0437\u0434\u0435\u043B\u044B\xa0\u2014 \u043D\u0435\u043E\u0442\u044A\u0435\u043C\u043B\u0435\u043C\u0430\u044F \u0447\u0430\u0441\u0442\u044C \u043A\u0430\u0436\u0434\u043E\u0433\u043E \u0441\u0430\u0439\u0442\u0430 Confluence. \u041E\u043D\u0438 \u043F\u043E\u043C\u043E\u0433\u0430\u044E\u0442 \u0433\u0440\u0443\u043F\u043F\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u044B \u043F\u043E \u043A\u0430\u0442\u0435\u0433\u043E\u0440\u0438\u044F\u043C. \u0420\u0430\u0437\u0434\u0435\u043B\u044B \u043C\u043E\u0436\u043D\u043E \u0440\u0430\u0441\u0441\u043C\u0430\u0442\u0440\u0438\u0432\u0430\u0442\u044C \u043A\u0430\u043A \u043F\u0430\u043F\u043A\u0438 \u0438\u043B\u0438 \u043F\u0440\u043E\u0435\u043A\u0442\u044B, \u0430 \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u044B\xa0\u2014 \u043A\u0430\u043A \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u044B, \u043A\u043E\u0442\u043E\u0440\u044B\u0435 \u043D\u0430\u0445\u043E\u0434\u044F\u0442\u0441\u044F \u0432 \u044D\u0442\u0438\u0445 \u043F\u0430\u043F\u043A\u0430\u0445 \u0438\u043B\u0438 \u043F\u0440\u043E\u0435\u043A\u0442\u0430\u0445. <a>\u041F\u043E\u0434\u0440\u043E\u0431\u043D\u0435\u0435 \u043E\u0431 \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u0438 \u0440\u0430\u0437\u0434\u0435\u043B\u043E\u0432</a>",
    'project-pages.improvement.templates.tutorial.content.try-it-now': "\u041F\u043E\u043F\u0440\u043E\u0431\u043E\u0432\u0430\u0442\u044C",
    'project-pages.improvement.templates.tutorial.description': "\u0423\u0437\u043D\u0430\u0439\u0442\u0435, \u043A\u0430\u043A \u0440\u0435\u0434\u0430\u043A\u0442\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0443.",
    'project-pages.improvement.templates.tutorial.name': "\u0414\u043E\u0431\u0440\u043E \u043F\u043E\u0436\u0430\u043B\u043E\u0432\u0430\u0442\u044C \u043D\u0430 \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u044B \u043F\u0440\u043E\u0435\u043A\u0442\u0430!",
    'project-pages.improvement.terms-and-conditions-v2': "\u041D\u0430\u0436\u0438\u043C\u0430\u044F \u043A\u043D\u043E\u043F\u043A\u0443 \xab\u041F\u043E\u043F\u0440\u043E\u0431\u043E\u0432\u0430\u0442\u044C \u0441\u0435\u0439\u0447\u0430\u0441\xbb, \u0432\u044B \u043F\u043E\u0434\u0442\u0432\u0435\u0440\u0436\u0434\u0430\u0435\u0442\u0435 \u0441\u043E\u0433\u043B\u0430\u0441\u0438\u0435 \u043D\u0430 \u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u044E \u0432 Confluence, \u043F\u0440\u0438\u043D\u0438\u043C\u0430\u0435\u0442\u0435 <termsLink>\u0423\u0441\u043B\u043E\u0432\u0438\u044F \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u044F \u043F\u0440\u043E\u0434\u0443\u043A\u0442\u043E\u0432 Atlassian Cloud</termsLink> \u0438 \u0441\u043E\u0433\u043B\u0430\u0448\u0430\u0435\u0442\u0435\u0441\u044C \u0441 <privacyLink>\u041F\u043E\u043B\u0438\u0442\u0438\u043A\u043E\u0439 \u043A\u043E\u043D\u0444\u0438\u0434\u0435\u043D\u0446\u0438\u0430\u043B\u044C\u043D\u043E\u0441\u0442\u0438 Atlassian</privacyLink>.",
    'project-pages.improvement.title': "\u0421\u0442\u0440\u0430\u043D\u0438\u0446\u044B \u043F\u0440\u043E\u0435\u043A\u0442\u0430",
    'project-pages.improvement.transient-states.empty-state.auto-provisioned-create-page-button': "\u0421\u043E\u0437\u0434\u0430\u0442\u044C \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0443",
    'project-pages.improvement.transient-states.empty-state.auto-provisioned-description': "\u041C\u044B \u0434\u043E\u0431\u0430\u0432\u0438\u043B\u0438 Confluence, \u0447\u0442\u043E\u0431\u044B \u0432\u044B \u043C\u043E\u0433\u043B\u0438 \u0441\u043E\u0437\u0434\u0430\u0432\u0430\u0442\u044C \u043B\u044E\u0431\u044B\u0435 \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u044B \u0438 \u0441\u0432\u044F\u0437\u044B\u0432\u0430\u0442\u044C \u0438\u0445 \u0441 \u043F\u0440\u043E\u0435\u043A\u0442\u0430\u043C\u0438. \u0414\u043E 10\xa0\u0431\u0435\u0441\u043F\u043B\u0430\u0442\u043D\u044B\u0445 \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u0435\u0439.",
    'project-pages.improvement.transient-states.empty-state.auto-provisioned-learn-more-button': "\u041F\u043E\u0434\u0440\u043E\u0431\u043D\u0435\u0435",
    'project-pages.improvement.transient-states.empty-state.create-page-button': "\u0421\u043E\u0437\u0434\u0430\u0439\u0442\u0435 \u043F\u0435\u0440\u0432\u0443\u044E \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0443",
    'project-pages.improvement.transient-states.empty-state.description': "\u0421\u043E\u0437\u0434\u0430\u0432\u0430\u0439\u0442\u0435 \u043F\u0440\u043E\u0442\u043E\u043A\u043E\u043B\u044B \u0441\u043E\u0431\u0440\u0430\u043D\u0438\u0439, \u0442\u0440\u0435\u0431\u043E\u0432\u0430\u043D\u0438\u044F \u043A \u043F\u0440\u043E\u0434\u0443\u043A\u0442\u0443, \u0440\u0435\u0448\u0435\u043D\u0438\u044F \u0438\u043B\u0438 \u0434\u0440\u0443\u0433\u043E\u0439 \u043A\u043E\u043D\u0442\u0435\u043D\u0442, \u0447\u0442\u043E\u0431\u044B \u043D\u0430\u043F\u043E\u043B\u043D\u0438\u0442\u044C \u044D\u0442\u043E\u0442 \u0440\u0430\u0437\u0434\u0435\u043B.",
    'project-pages.improvement.transient-states.empty-state.title': "\u0417\u0434\u0435\u0441\u044C \u043D\u0435\u0442 \u043D\u0438\u0447\u0435\u0433\u043E, \u043A\u0440\u043E\u043C\u0435 \u043F\u043E\u0442\u0435\u043D\u0446\u0438\u0430\u043B\u0430",
    'project-pages.improvement.try-button': "\u041F\u043E\u043F\u0440\u043E\u0431\u0443\u0439\u0442\u0435 \u044D\u0442\u043E\u0442 \u0448\u0430\u0431\u043B\u043E\u043D \u0432 Confluence",
    'project-pages.improvement.try-it-now': "\u041F\u043E\u043F\u0440\u043E\u0431\u043E\u0432\u0430\u0442\u044C",
    'project-pages.improvement.try-lozenge': "\u041F\u043E\u043F\u0440\u043E\u0431\u043E\u0432\u0430\u0442\u044C",
    'project-pages.improvement.try-on-demand-button': "\u041F\u043E\u043F\u0440\u043E\u0431\u043E\u0432\u0430\u0442\u044C \u0431\u0435\u0441\u043F\u043B\u0430\u0442\u043D\u043E",
    'project-pages.page-deleted-flag.title': "\u0421\u0442\u0440\u0430\u043D\u0438\u0446\u0430 \u0443\u0434\u0430\u043B\u0435\u043D\u0430.",
    'project-pages.page-published-flag.title': "\u0412\u0430\u0448\u0430 \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0430 \u043E\u043F\u0443\u0431\u043B\u0438\u043A\u043E\u0432\u0430\u043D\u0430.",
    'project-pages.unknown-error.description': "\u0415\u0441\u043B\u0438 \u043E\u0431\u043D\u043E\u0432\u043B\u0435\u043D\u0438\u0435 \u043D\u0435 \u0440\u0435\u0448\u0430\u0435\u0442 \u043F\u0440\u043E\u0431\u043B\u0435\u043C\u0443, {contactSupport}.",
    'project-pages.unknown-error.heading': "\u0412 \u043D\u0430\u0441\u0442\u043E\u044F\u0449\u0438\u0439 \u043C\u043E\u043C\u0435\u043D\u0442 \u043D\u0435 \u0443\u0434\u0430\u0435\u0442\u0441\u044F \u043E\u0442\u043E\u0431\u0440\u0430\u0437\u0438\u0442\u044C \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u044B \u043F\u0440\u043E\u0435\u043A\u0442\u0430"
};

});

parcelRegister("afZdi", function(module, exports) {

$parcel$export(module.exports, "default", () => $bb5d773a06fe7e98$export$2e2bcd8739ae039);
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Slovak
var $bb5d773a06fe7e98$export$2e2bcd8739ae039 = {
    'project-pages.connect-space-dialog.connection-error': 'Pripojenie zlyhalo.',
    'project-pages.connect-space-dialog.connection-retry': "Opakova\u0165",
    'project-pages.connect-space-dialog.content.space-selector.disconnected-templates-description': "Pred vytvoren\xedm str\xe1nky je nutn\xe9 prepoji\u0165 tento projekt s priestorom. Vyberte priestor, ktor\xfd s t\xfdmto projektom chcete prepoji\u0165.",
    'project-pages.connect-space-dialog.error-icon': 'Chyba:',
    'project-pages.connect-space-dialog.footer.cancel': "Zru\u0161i\u0165",
    'project-pages.connect-space-dialog.footer.connect-space': "Pripoji\u0165",
    'project-pages.connect-space.description': "Priestory s\xfa ako prie\u010Dinky. M\xf4\u017Eete ich pou\u017E\xedva\u0165 na vytv\xe1ranie obsahu s\xfavisiaceho s va\u0161\xedm projektom, jeho organizovanie alebo spolupr\xe1cu na \u0148om.",
    'project-pages.create-space-dialog.connection-error': 'Pripojenie zlyhalo.',
    'project-pages.create-space-dialog.connection-retry': "Opakova\u0165",
    'project-pages.create-space-dialog.content.empty-name': 'Pomenujte svoj priestor.',
    'project-pages.create-space-dialog.content.invalid-name': "N\xe1zvy priestorov musia obsahova\u0165 aspo\u0148 jedno p\xedsmeno alebo \u010D\xedslicu.",
    'project-pages.create-space-dialog.content.placeholder': "Zadajte n\xe1zov priestoru",
    'project-pages.create-space-dialog.creation-error': 'Vytvorenie priestoru sa nepodarilo.',
    'project-pages.create-space-dialog.error-icon': 'Chyba:',
    'project-pages.create-space-dialog.footer.cancel': "Zru\u0161i\u0165",
    'project-pages.create-space-dialog.footer.create-space': "Vytvori\u0165",
    'project-pages.create-space-dialog.header.title': "Vytvori\u0165 nov\xfd priestor Confluence",
    'project-pages.default-contextual-message': "Vytv\xe1rajte dokumenty k projektu, zdie\u013Eajte ich a spolupracujte na nich na jednom mieste so str\xe1nkami Confluence.",
    'project-pages.default-reactivate-CTA': "Znovu aktivova\u0165 Confluence",
    'project-pages.default-trial-CTA': "Vysk\xfa\u0161ajte si aplik\xe1ciu Confluence bezplatne na 30 dn\xed",
    'project-pages.generic-error.button.reload': "Znova na\u010D\xedtajte str\xe1nku",
    'project-pages.generic-error.description': "Nie\u010Do sa pokazilo. Sk\xfaste to znova nesk\xf4r.",
    'project-pages.generic-error.heading': "Ejha, toto je tr\xe1pne..."
};

});

parcelRegister("ftGla", function(module, exports) {

$parcel$export(module.exports, "default", () => $84a38dd0de561560$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Spanish (International)
var $84a38dd0de561560$export$2e2bcd8739ae039 = {
    'confluence.project-pages.improvement.provisioning-background.text': "Esto deber\xeda llevar menos de un minuto",
    'confluence.project-pages.improvement.provisioning-background.title': "Configurando las p\xe1ginas de tu proyecto",
    'confluence.project-pages.improvement.provisioning-modal-carousel.controls.dismiss': 'Descartar',
    'confluence.project-pages.improvement.provisioning-modal-carousel.controls.done': 'Listo',
    'confluence.project-pages.improvement.provisioning-modal-carousel.controls.next': 'Siguiente',
    'project-pages.activating.description': "El espacio conectado de Confluence a\xfan no est\xe1 listo. {contactSupport} si la opci\xf3n de actualizar no soluciona el problema.",
    'project-pages.activating.heading': 'Confluence sigue cargando',
    'project-pages.better-together-templates.meeting-notes.action-items-heading': "\xbfCu\xe1les son los elementos de acci\xf3n?",
    'project-pages.better-together-templates.meeting-notes.agenda-item-label': 'Elemento de la agenda',
    'project-pages.better-together-templates.meeting-notes.create-a-jira-issue': 'Escribir /Jira para crear una incidencia',
    'project-pages.better-together-templates.meeting-notes.date-label': 'Fecha',
    'project-pages.better-together-templates.meeting-notes.discussion-topics-heading': 'Temas de debate',
    'project-pages.better-together-templates.meeting-notes.list-people': 'enumera a las personas con',
    'project-pages.better-together-templates.meeting-notes.mention': "menci\xf3n",
    'project-pages.better-together-templates.meeting-notes.mention-people-to-assign-them': "a personas para asignarles a un elemento de acci\xf3n",
    'project-pages.better-together-templates.meeting-notes.notes-label': 'Notas',
    'project-pages.better-together-templates.meeting-notes.page-title': "Notas de la reuni\xf3n",
    'project-pages.better-together-templates.meeting-notes.participants-label': 'Participantes',
    'project-pages.better-together-templates.meeting-notes.project-label': 'Proyecto',
    'project-pages.better-together-templates.product-requirements.create-a-jira-issue': 'Escribir /Jira para crear una incidencia',
    'project-pages.better-together-templates.product-requirements.design-heading': "Dise\xf1o",
    'project-pages.better-together-templates.product-requirements.embedd-different-data-views': 'Inserta diferentes datos y vistas de tu proyecto de Jira.',
    'project-pages.better-together-templates.product-requirements.heading': 'Resumen',
    'project-pages.better-together-templates.product-requirements.how-will-you-know-if-fixed': "\xbfC\xf3mo sabr\xe1s si lo has corregido?",
    'project-pages.better-together-templates.product-requirements.impact-heading': 'Impacto',
    'project-pages.better-together-templates.product-requirements.inScopeStatus': 'Dentro del alcance',
    'project-pages.better-together-templates.product-requirements.insert-design-link': "Insertar un enlace al dise\xf1o (Figma, etc.)",
    'project-pages.better-together-templates.product-requirements.jira-issue-heading': 'Incidencia de Jira',
    'project-pages.better-together-templates.product-requirements.jira-roadmap-heading': 'Hoja de ruta de Jira',
    'project-pages.better-together-templates.product-requirements.learn-how-with-smart-links': "Descubrir c\xf3mo con enlaces inteligentes",
    'project-pages.better-together-templates.product-requirements.list-dashboards': 'Enumerar paneles (amplitud, modo, etc.)',
    'project-pages.better-together-templates.product-requirements.list-design-considerations': "Enumera las consideraciones de dise\xf1o o creaci\xf3n",
    'project-pages.better-together-templates.product-requirements.list-people': 'enumera a las personas con',
    'project-pages.better-together-templates.product-requirements.mention': "menci\xf3n",
    'project-pages.better-together-templates.product-requirements.mention-people-to-assign-them': "a personas para asignarles a un elemento de acci\xf3n",
    'project-pages.better-together-templates.product-requirements.niceToHaveStatus': 'Deseables',
    'project-pages.better-together-templates.product-requirements.outOfScopeStatus': 'Fuera del alcance',
    'project-pages.better-together-templates.product-requirements.page-title': 'Requisitos del producto',
    'project-pages.better-together-templates.product-requirements.pro-tip': 'Consejo de experto:',
    'project-pages.better-together-templates.product-requirements.problem-label': 'Problema',
    'project-pages.better-together-templates.product-requirements.requirement-heading': 'Requisito',
    'project-pages.better-together-templates.product-requirements.scope-heading': 'Alcance',
    'project-pages.better-together-templates.product-requirements.success-metric': "M\xe9trica de \xe9xito",
    'project-pages.better-together-templates.product-requirements.target-release-date': "Fecha prevista de publicaci\xf3n",
    'project-pages.better-together-templates.product-requirements.team-label': 'Equipo',
    'project-pages.better-together-templates.product-requirements.to-do-list-heading': 'Lista de tareas pendientes',
    'project-pages.better-together-templates.product-requirements.what-are-you-trying-to-fix': "\xbfQu\xe9 quieres corregir?",
    'project-pages.better-together-templates.retro-notes.retro-heading': 'Retrospectiva',
    'project-pages.better-together-templates.retro.action-items-heading': "\xbfCu\xe1les son los elementos de acci\xf3n?",
    'project-pages.better-together-templates.retro.create-a-jira-issue': 'Escribir /Jira para crear una incidencia',
    'project-pages.better-together-templates.retro.date-label': 'Fecha',
    'project-pages.better-together-templates.retro.embed-it-here': "Cuando hayas terminado, puedes insertarla aqu\xed.",
    'project-pages.better-together-templates.retro.list-people': 'enumera a las personas con',
    'project-pages.better-together-templates.retro.mention': "menci\xf3n",
    'project-pages.better-together-templates.retro.mention-people-to-assign-them': "a personas para asignarles a un elemento de acci\xf3n",
    'project-pages.better-together-templates.retro.page-title': 'Retrospectiva',
    'project-pages.better-together-templates.retro.participants-label': 'Participantes',
    'project-pages.better-together-templates.retro.pro-tip': 'Consejo de experto:',
    'project-pages.better-together-templates.retro.project-label': 'Proyecto',
    'project-pages.better-together-templates.retro.this-is-a-whiteboard': 'Esto es una pizarra de Confluence.',
    'project-pages.better-together-templates.retro.use-a-whiteboard': 'Utiliza una pizarra de Confluence para tu retrospectiva.',
    'project-pages.better-together-templates.retro.use-it-to-vote': "Util\xedzala para votar y colaborar con tu equipo.",
    'project-pages.button.connect-different-space-or-page.label': "Actualizar icono de p\xe1gina o espacio",
    'project-pages.button.connect-different-space-or-page.tooltip': 'Conectarse a un espacio o elemento diferente',
    'project-pages.button.connect-space-or-page.tooltip': 'Conectarse a Confluence',
    'project-pages.button.go-to-connected-live-doc.tooltip': 'Abrir un doc en vivo en Confluence',
    'project-pages.button.go-to-connected-page.tooltip': "Abrir p\xe1gina en Confluence",
    'project-pages.button.go-to-connected-space.tooltip': 'Abrir espacio en Confluence',
    'project-pages.connect-space-dialog.connection-error': "Se ha producido un error en la conexi\xf3n.",
    'project-pages.connect-space-dialog.connection-retry': 'Reintentar',
    'project-pages.connect-space-dialog.content.space-or-page-selector.description': 'Elige un espacio o un elemento para conectarlo a tu proyecto.',
    'project-pages.connect-space-dialog.content.space-or-page-selector.placeholder': 'Buscar en Confluence',
    'project-pages.connect-space-dialog.content.space-selector.disconnected-templates-description': 'Este proyecto debe estar conectado a un espacio antes de crear un elemento. Elige un espacio para conectarlo a este proyecto.',
    'project-pages.connect-space-dialog.error-icon': 'Error:',
    'project-pages.connect-space-dialog.footer.cancel': 'Cancelar',
    'project-pages.connect-space-dialog.footer.connect-space': 'Conectar',
    'project-pages.connect-space-or-page-dialog.header.title': 'Conectar proyecto a Confluence',
    'project-pages.connect-space.description': "Los espacios son como carpetas: puedes usarlos para crear y organizar todo el contenido relacionado con tu proyecto, as\xed como para colaborar en este.",
    'project-pages.connect-space.not-connected.description': "Para usar las p\xe1ginas del proyecto, ponte en contacto con tu administrador o con el responsable de tu equipo para que conecte Confluence con este proyecto.",
    'project-pages.connect-space.not-connected.heading': 'No conectada a Confluence',
    'project-pages.connect-success-flag.description.content': "Conectado con \xe9xito con el contenido {connectedSpaceOrPageName}.",
    'project-pages.connection-error.space-or-page-not-found.button': "Conectarse a un espacio o p\xe1gina diferente",
    'project-pages.create-space-dialog.connection-error': "Se ha producido un error en la conexi\xf3n.",
    'project-pages.create-space-dialog.connection-retry': 'Reintentar',
    'project-pages.create-space-dialog.content.empty-name': 'Pon un nombre a tu espacio.',
    'project-pages.create-space-dialog.content.invalid-name': "Los nombres de espacio deben tener, al menos, una letra o un n\xfamero.",
    'project-pages.create-space-dialog.content.placeholder': 'Introduce un nombre de espacio',
    'project-pages.create-space-dialog.creation-error': 'No se ha podido crear el espacio.',
    'project-pages.create-space-dialog.error-icon': 'Error:',
    'project-pages.create-space-dialog.footer.cancel': 'Cancelar',
    'project-pages.create-space-dialog.footer.create-space': 'Crear',
    'project-pages.create-space-dialog.header.title': 'Crea un espacio de Confluence nuevo',
    'project-pages.cross-join.access-revoked.templates.subtitle': "No puedes usar las p\xe1ginas del proyecto porque el administrador te ha negado el acceso a Confluence. Ponte en contacto con el administrador del sitio para solicitar acceso.",
    'project-pages.cross-join.access-revoked.templates.title': "No tienes permisos para usar las p\xe1ginas del proyecto",
    'project-pages.cross-join.avatar.view-profile': 'Ver perfil',
    'project-pages.cross-join.denied-request.templates.subtitle': "No puedes usar las p\xe1ginas del proyecto porque el administrador del sitio rechaz\xf3 tu solicitud para unirte a Confluence.",
    'project-pages.cross-join.denied-request.templates.title': 'El administrador te ha negado el acceso',
    'project-pages.cross-join.direct-access.button-subtitle.experimental': "Conseguir\xe1s acceder a Confluence. El administrador del sitio ya ha aprobado tu acceso.",
    'project-pages.cross-join.errors.unknown-error.description': "{contactSupport} si la opci\xf3n de actualizar no soluciona el problema.",
    'project-pages.cross-join.errors.unknown-error.title': "No se pueden mostrar las p\xe1ginas del proyecto ahora mismo",
    'project-pages.cross-join.inline-join-product.button': "Conseguir\xe1s acceder a Confluence. El administrador del sitio ya ha aprobado tu acceso.",
    'project-pages.cross-join.inline-join-product.connected.description': "Consulta, edita y crea documentaci\xf3n desde un \xfanico lugar",
    'project-pages.cross-join.inline-join-product.connected.title': "Colaborar en p\xe1ginas del proyecto con tu equipo",
    'project-pages.cross-join.pending-request.templates.subtitle': "El administrador del sitio ha recibido tu solicitud para unirte a Confluence. Si la aprueba, las p\xe1ginas del proyecto comenzar\xe1n a funcionar y te enviaremos un mensaje de correo electr\xf3nico de confirmaci\xf3n.",
    'project-pages.cross-join.pending-request.templates.subtitle.experiment': "Recibir\xe1s un correo electr\xf3nico con acceso a las p\xe1ginas de proyectos cuando se apruebe la solicitud.",
    'project-pages.cross-join.pending-request.templates.title': 'Has solicitado acceso a Confluence',
    'project-pages.cross-join.pending-request.templates.title.experiment': 'Solicitud de acceso enviada al administrador',
    'project-pages.cross-join.request-access-without-better-together.connected.description': "Consulta, edita y crea documentaci\xf3n del proyecto con tu equipo",
    'project-pages.cross-join.request-access.button': 'Solicitar acceso',
    'project-pages.cross-join.request-access.button-subtitle.experimental': "Cuando seleccionas \xdanete a tu equipo, pides unirte a Confluence y aceptas compartir tu perfil de Atlassian con tu administrador.",
    'project-pages.cross-join.request-access.button.experimental': 'Unirme al equipo',
    'project-pages.cross-join.request-access.connected.description.experimental': "Tu equipo usa las p\xe1ginas de proyectos para comentar, editar y colaborar en la documentaci\xf3n del proyecto sin salir de Jira. \xdanete a Confluence para acceder a las p\xe1ginas del proyecto de tu equipo.",
    'project-pages.cross-join.request-access.title': "Las p\xe1ginas del proyecto requieren acceso a Confluence",
    'project-pages.cross-join.request-access.title.experiment': "Crea una fuente \xfanica de informaci\xf3n fiable para tu equipo",
    'project-pages.default-contextual-heading': "Las p\xe1ginas de los proyectos se basan en la tecnolog\xeda de Confluence",
    'project-pages.default-contextual-message': "Crea y comparte todos los documentos de tu proyecto en un \xfanico lugar y colabora en ellos con las p\xe1ginas de Confluence.",
    'project-pages.default-reactivate-CTA': 'Reactivar Confluence',
    'project-pages.default-trial-CTA': "Prueba Confluence de manera gratuita durante 30\xa0d\xedas",
    'project-pages.draft-saved-flag.action': 'Abrir borrador',
    'project-pages.draft-saved-flag.description': "Solo t\xfa puedes ver el borrador hasta que lo publiques.",
    'project-pages.draft-saved-flag.title': 'Borrador guardado',
    'project-pages.embedded-pages.create-page-error.close-button': 'Cerrar',
    'project-pages.embedded-pages.create-page-error.description': "Ha habido un problema y no te hemos podido crear una p\xe1gina.",
    'project-pages.embedded-pages.create-page-error.title': "No hemos podido crear una p\xe1gina",
    'project-pages.embedded-pages.create-page-error.try-again-button': 'Volver a intentarlo',
    'project-pages.embedded-pages.modal.close.button.hint': 'Cerrar',
    'project-pages.embedded-pages.modal.title.button': 'Abrir en Confluence',
    'project-pages.embedded-pages.modal.title.button.hint': "Abrir en una nueva pesta\xf1a",
    'project-pages.errors.space-or-page-not-found.title.non-final': "Espacio o p\xe1gina no encontrados",
    'project-pages.errors.unknown-error.description.non-final': "{contactSupport} si la opci\xf3n de actualizar no soluciona el problema.",
    'project-pages.errors.unknown-error.title.non-final': "No se pueden mostrar las p\xe1ginas del proyecto ahora mismo",
    'project-pages.generic-error.button.reload': "Recargar p\xe1gina",
    'project-pages.generic-error.button.reload.non-final': "Recargar p\xe1gina",
    'project-pages.generic-error.description': "Algo ha ido mal. Int\xe9ntalo de nuevo m\xe1s tarde.",
    'project-pages.generic-error.description.non-final': "Algo ha ido mal. Int\xe9ntalo de nuevo m\xe1s tarde.",
    'project-pages.generic-error.heading': 'Bueno, esto es un poco embarazoso...',
    'project-pages.generic-error.title.non-final': 'Bueno, esto es un poco embarazoso...',
    'project-pages.generic-info-flag.description': "Algo ha ido mal. Int\xe9ntalo de nuevo o ponte en contacto con el servicio de soporte si la incidencia contin\xfaa.",
    'project-pages.generic-success-flag.description.live-doc': 'Se ha conectado correctamente con el doc en vivo {connectedSpaceOrPageName}.',
    'project-pages.generic-success-flag.description.page': "Te has conectado correctamente con la p\xe1gina {connectedSpaceOrPageName}.",
    'project-pages.generic-success-flag.description.space': 'Te has conectado correctamente con el espacio {connectedSpaceOrPageName}.',
    'project-pages.generic-success-flag.heading.live-doc': 'Doc en vivo conectado',
    'project-pages.generic-success-flag.heading.page': "P\xe1gina conectada",
    'project-pages.generic-success-flag.heading.space': 'Espacio conectado',
    'project-pages.granular-pages.connect-space-dialog.content.create-space-link.link-text': 'O crear un espacio nuevo',
    'project-pages.granular-pages.connect-space.button': 'Conectarse a Confluence',
    'project-pages.granular-pages.connect-space.button.non-final': 'Conectarse a Confluence',
    'project-pages.granular-pages.connect-space.heading': 'Conecta este proyecto a un espacio o elemento de Confluence',
    'project-pages.improvement.contact-support': 'Contacta con el servicio de soporte',
    'project-pages.improvement.errors.access-error.description': 'Intenta ponerte en contacto con el administrador del sitio para pedirle acceso.',
    'project-pages.improvement.errors.access-error.title': "No tienes permiso para ver las p\xe1ginas del proyecto",
    'project-pages.improvement.errors.page-tree-unknown-error.description': "Se ha producido un error al intentar mostrar las p\xe1ginas desde el espacio conectado de Confluence. {contactSupport} si la opci\xf3n de actualizar no soluciona el problema.",
    'project-pages.improvement.errors.page-tree-unknown-error.title': "Tenemos problemas para mostrar las p\xe1ginas del proyecto",
    'project-pages.improvement.errors.space-or-page-not-found.description': "El espacio o la p\xe1gina de Confluence que estaba conectado se ha movido, archivado o eliminado. <link>Ponte en contacto con el servicio de asistencia</link> si volver a conectarte no soluciona las cosas",
    'project-pages.improvement.errors.space-or-page-not-found.title': "Espacio o p\xe1gina no encontrados",
    'project-pages.improvement.errors.unknown-error.description': "{contactSupport} si la opci\xf3n de actualizar no soluciona el problema.",
    'project-pages.improvement.errors.unknown-error.title': "No se pueden mostrar las p\xe1ginas del proyecto ahora mismo",
    'project-pages.improvement.feature1': 'Crear documentos y acceder a ellos sin salir de Jira',
    'project-pages.improvement.feature2': "Plantillas para reuniones, planes de sprints y mucho m\xe1s",
    'project-pages.improvement.feature3': "Sincronizar documentos en Jira para las actualizaciones autom\xe1ticas",
    'project-pages.improvement.heading-info': 'Capta el conocimiento de tu equipo y mejora la forma de hacer el trabajo.',
    'project-pages.improvement.heading-info-v2': 'Crea un espacio para todos los documentos de los proyectos de tu equipo',
    'project-pages.improvement.learn-more-button': "M\xe1s informaci\xf3n",
    'project-pages.improvement.powered-by': "Con tecnolog\xeda de",
    'project-pages.improvement.powered-by.tooltip': "Abrir Confluence en una pesta\xf1a nueva",
    'project-pages.improvement.preview-teaser': "Desbloquear plantillas, p\xe1ginas de proyectos y mucho m\xe1s.",
    'project-pages.improvement.provisioning-info-modal.seamlessly-update-stakeholders.description': "<p>Mant\xe9n los informes de tus proyectos actualizados con etiquetas de estado que se actualizan autom\xe1ticamente.</p> <p>Solo tienes que vincular un ticket de Jira a un documento y se mostrar\xe1 autom\xe1ticamente una etiqueta de estado que se actualizar\xe1 de forma sincronizada con el ticket, de modo que no tendr\xe1s que perder tiempo creando informes manuales.</p>",
    'project-pages.improvement.provisioning-info-modal.seamlessly-update-stakeholders.title': "Actualiza a la perfecci\xf3n las partes interesadas",
    'project-pages.improvement.provisioning-info-modal.unify-documentation-standards.description': "<p>Crea una documentaci\xf3n coherente con nuestras plantillas integradas. Son f\xe1ciles de usar y se pueden personalizar seg\xfan tus necesidades.</p> <p>Puedes usar las plantillas directamente desde las p\xe1ginas del proyecto, as\xed no tendr\xe1s que dejar nunca lo que tengas entre manos. Explora todas las plantillas <a>aqu\xed</a>.</p>",
    'project-pages.improvement.provisioning-info-modal.unify-documentation-standards.title': "Unifica tus est\xe1ndares de documentaci\xf3n",
    'project-pages.improvement.provisioning-info-modal.your-project-pages-in-jira.description': "<p>Crea una fuente \xfanica de informaci\xf3n importante creando y gestionando la documentaci\xf3n desde la pesta\xf1a de p\xe1ginas de proyectos de Jira.</p> <p>\xbfSab\xedas que las p\xe1ginas de proyectos funcionan en Confluence? Es gratis para un m\xe1ximo de 10\xa0usuarios. Invita al resto de tu equipo a la configuraci\xf3n de administraci\xf3n.</p>",
    'project-pages.improvement.provisioning-info-modal.your-project-pages-in-jira.title': "Tus p\xe1ginas de proyectos directamente en Jira",
    'project-pages.improvement.templates-sidebar.better-together-templates-header': 'Plantillas integradas con tus datos de Jira',
    'project-pages.improvement.templates.better-together-preview-teaser': 'Integrada con los datos de Jira',
    'project-pages.improvement.templates.blank-page.description': "Inicia una p\xe1gina desde cero.",
    'project-pages.improvement.templates.blank-page.name': "P\xe1gina en blanco",
    'project-pages.improvement.templates.decision.description': "Registra las decisiones importantes del proyecto y comun\xedcalas a tu equipo.",
    'project-pages.improvement.templates.decision.name': "Decisi\xf3n",
    'project-pages.improvement.templates.meeting-notes.description': 'Planifica tus reuniones, toma notas y comparte acciones con tu equipo.',
    'project-pages.improvement.templates.meeting-notes.name': 'Notas',
    'project-pages.improvement.templates.post-expand.more': "M\xe1s plantillas",
    'project-pages.improvement.templates.post-expand.more.tooltip': 'Ver todas las plantillas en Confluence',
    'project-pages.improvement.templates.post-expand.subtitle': 'Plantillas populares',
    'project-pages.improvement.templates.post-expand.title': "Crear una p\xe1gina",
    'project-pages.improvement.templates.pre-expand.more': "Explorar m\xe1s plantillas",
    'project-pages.improvement.templates.pre-expand.subtitle': 'Popular en equipos como el tuyo',
    'project-pages.improvement.templates.pre-expand.title': 'Previsualizar plantillas',
    'project-pages.improvement.templates.product-requirements.description': "Define, haz un seguimiento y determina el alcance de los requisitos de tu producto o funci\xf3n.",
    'project-pages.improvement.templates.product-requirements.name': 'Requisitos del producto',
    'project-pages.improvement.templates.retrospective.description': "\xbfQu\xe9 ha funcionado correctamente? \xbfQu\xe9 podr\xeda haber salido mejor? Colabora de forma abierta con tu equipo para sugerir mejoras.",
    'project-pages.improvement.templates.retrospective.name': 'Retrospectiva',
    'project-pages.improvement.templates.template.disabled-tooltip': 'Conecta un espacio de Confluence primero',
    'project-pages.improvement.templates.tutorial.content.confluence-templates': "<b>Ahorro de tiempo y reducci\xf3n de tareas manuales</b> Confluence cuenta con muchas <a>plantillas</a> de p\xe1ginas, por lo que nunca tendr\xe1s que empezar de cero. Podr\xe1s crear documentos t\xe9cnicos, gu\xedas de soluci\xf3n de problemas, planes de proyectos, requisitos de productos y mucho m\xe1s.",
    'project-pages.improvement.templates.tutorial.content.edit-and-format': "<b>Edici\xf3n y formato sencillos</b> Usa el men\xfa de edici\xf3n superior para dar formato est\xe1ndar a las palabras o escribe <b>/</b> para insertar f\xe1cilmente todo tipo de integraciones. Inserta una tabla escribiendo <c>/tabla</c> o una imagen con <c>/imagen</c>. Tambi\xe9n puedes insertar enlaces de Dropbox (<c>/dropbox</c>), herramientas de Microsoft Office (<c>/microsoft</c>) o tableros y tarjetas de Trello (<c>/trello</c>).",
    'project-pages.improvement.templates.tutorial.content.forward-slash-prompt': 'Escribe / seguido de "tabla" o "imagen"',
    'project-pages.improvement.templates.tutorial.content.getting-started-tips': "Aqu\xed tienes un par de consejos para empezar:",
    'project-pages.improvement.templates.tutorial.content.handy-links': "Enlaces pr\xe1cticos",
    'project-pages.improvement.templates.tutorial.content.jira-and-confluence': 'Utiliza Jira y Confluence conjuntamente',
    'project-pages.improvement.templates.tutorial.content.jira-charts': "Crea gr\xe1ficos en tus p\xe1ginas con datos reales de Jira. Escribe <c>/gr\xe1ficos de Jira</c>.",
    'project-pages.improvement.templates.tutorial.content.jira-links': "Vincula una incidencia de Jira en cualquier parte de tu p\xe1gina. El enlace de la p\xe1gina se actualizar\xe1 en tiempo real a medida que actualices la incidencia de Jira. Escribe <c>/Jira</c>.",
    'project-pages.improvement.templates.tutorial.content.jira-links-issue-term-refresh': "Vincula una actividad de Jira en cualquier parte de tu p\xe1gina. El enlace de la p\xe1gina se actualizar\xe1 en tiempo real a medida que actualices la actividad. Escribe <c>/Jira</c>.",
    'project-pages.improvement.templates.tutorial.content.jira-links.non-final-issue-term-refresh': "Vincula una actividad de Jira en cualquier parte de tu p\xe1gina. El enlace de la p\xe1gina se actualizar\xe1 en tiempo real a medida que actualices la actividad. Escribe <c>/Jira</c>.",
    'project-pages.improvement.templates.tutorial.content.jira-roadmaps': "Inserta hojas de ruta y cronogramas interactivos en tu p\xe1gina con tus proyectos de Jira. Escribe <c>/hoja de ruta de Jira</c>.",
    'project-pages.improvement.templates.tutorial.content.jira-timeline': "Inserta cronogramas interactivos en tu p\xe1gina con tus proyectos de Jira. Escribe <c>/cronograma de jira</c>.",
    'project-pages.improvement.templates.tutorial.content.shipping-speed-statistic': "El 76\xa0% de los clientes de Jira Software afirman que lanzaron los proyectos m\xe1s r\xe1pido tras a\xf1adir Confluence",
    'project-pages.improvement.templates.tutorial.content.shipping-speed-statistic.spork-rebranding': "El 76\xa0% de los clientes de Jira afirman que lanzaron los proyectos m\xe1s r\xe1pido tras a\xf1adir Confluence",
    'project-pages.improvement.templates.tutorial.content.spaces-and-pages': "<b>Uso de espacios y p\xe1ginas</b> Los espacios forman parte de todos los sitios de Confluence y son una forma de organizar las p\xe1ginas por categor\xedas. Los espacios son como carpetas o proyectos diferentes, y las p\xe1ginas son los documentos que pertenecen a esas carpetas o proyectos. <a>M\xe1s informaci\xf3n sobre c\xf3mo usar los espacios</a>",
    'project-pages.improvement.templates.tutorial.content.try-it-now': 'Probar ahora',
    'project-pages.improvement.templates.tutorial.description': "Aprende a editar una p\xe1gina.",
    'project-pages.improvement.templates.tutorial.name': "\xa1Estas son las p\xe1ginas de Proyecto!",
    'project-pages.improvement.terms-and-conditions-v2': "Al seleccionar &quot;Probar ahora&quot;, admites que te inscribir\xe1s en Confluence y aceptas las <termsLink>Condiciones de servicio</termsLink> y la <privacyLink>Pol\xedtica de privacidad</privacyLink> de Atlassian Cloud.",
    'project-pages.improvement.title': "P\xe1ginas de proyectos",
    'project-pages.improvement.transient-states.empty-state.auto-provisioned-create-page-button': "Crear p\xe1gina",
    'project-pages.improvement.transient-states.empty-state.auto-provisioned-description': "Hemos a\xf1adido Confluence para que puedas empezar a crear y vincular todos los documentos de tu proyecto. Es gratis para un m\xe1ximo de 10\xa0usuarios.",
    'project-pages.improvement.transient-states.empty-state.auto-provisioned-learn-more-button': "M\xe1s informaci\xf3n",
    'project-pages.improvement.transient-states.empty-state.create-page-button': "Crea tu primera p\xe1gina",
    'project-pages.improvement.transient-states.empty-state.description': 'Crea notas, requisitos de productos, decisiones u otros contenidos para llenar este espacio.',
    'project-pages.improvement.transient-states.empty-state.title': "Aqu\xed solo hay potencial",
    'project-pages.improvement.try-button': 'Probar este plantilla en Confluence',
    'project-pages.improvement.try-it-now': 'Probar ahora',
    'project-pages.improvement.try-lozenge': "Pru\xe9balo",
    'project-pages.improvement.try-on-demand-button': 'Probar gratis',
    'project-pages.page-deleted-flag.title': "P\xe1gina eliminada.",
    'project-pages.page-published-flag.title': "Tu p\xe1gina se ha publicado.",
    'project-pages.title.non-final': "P\xe1ginas de proyectos",
    'project-pages.unknown-error.description': "{contactSupport} si la opci\xf3n de actualizar no soluciona el problema.",
    'project-pages.unknown-error.heading': "No se pueden mostrar las p\xe1ginas del proyecto ahora mismo"
};

});

parcelRegister("fHyKJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $5b747e8c4083dffc$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Swedish
var $5b747e8c4083dffc$export$2e2bcd8739ae039 = {
    'confluence.project-pages.improvement.provisioning-background.text': "Detta b\xf6r ta mindre \xe4n en minut",
    'confluence.project-pages.improvement.provisioning-background.title': 'Konfigurera dina projektsidor',
    'confluence.project-pages.improvement.provisioning-modal-carousel.controls.dismiss': "Avf\xe4rda",
    'confluence.project-pages.improvement.provisioning-modal-carousel.controls.done': 'Klar',
    'confluence.project-pages.improvement.provisioning-modal-carousel.controls.next': "N\xe4sta",
    'project-pages.activating.description': "Det anslutna Confluence-utrymmet \xe4r inte riktigt redo \xe4n. {contactSupport} om det inte hj\xe4lper att uppdatera.",
    'project-pages.activating.heading': "Confluence l\xe4ses fortfarande in",
    'project-pages.better-together-templates.meeting-notes.action-items-heading': "Vilka \xe4r \xe5tg\xe4rderna?",
    'project-pages.better-together-templates.meeting-notes.agenda-item-label': 'Dagordningspunkt',
    'project-pages.better-together-templates.meeting-notes.create-a-jira-issue': "Skriv /Jira f\xf6r att skapa ett \xe4rende",
    'project-pages.better-together-templates.meeting-notes.date-label': 'Datum',
    'project-pages.better-together-templates.meeting-notes.discussion-topics-heading': "\xc4mnen f\xf6r diskussion",
    'project-pages.better-together-templates.meeting-notes.list-people': "lista personer som anv\xe4nder",
    'project-pages.better-together-templates.meeting-notes.mention': "omn\xe4mn",
    'project-pages.better-together-templates.meeting-notes.mention-people-to-assign-them': "personer f\xf6r att tilldela dem till en \xe5tg\xe4rd",
    'project-pages.better-together-templates.meeting-notes.notes-label': 'Anteckningar',
    'project-pages.better-together-templates.meeting-notes.page-title': "M\xf6tesanteckningar",
    'project-pages.better-together-templates.meeting-notes.participants-label': 'Deltagare',
    'project-pages.better-together-templates.meeting-notes.project-label': 'Projekt',
    'project-pages.better-together-templates.product-requirements.create-a-jira-issue': "Skriv /Jira f\xf6r att skapa ett \xe4rende",
    'project-pages.better-together-templates.product-requirements.design-heading': 'Design',
    'project-pages.better-together-templates.product-requirements.embedd-different-data-views': "B\xe4dda in olika data och vyer fr\xe5n ditt Jira-projekt.",
    'project-pages.better-together-templates.product-requirements.heading': "\xd6verblick",
    'project-pages.better-together-templates.product-requirements.how-will-you-know-if-fixed': "Hur vet du om du har \xe5tg\xe4rdat det?",
    'project-pages.better-together-templates.product-requirements.impact-heading': "P\xe5verkan",
    'project-pages.better-together-templates.product-requirements.inScopeStatus': 'Omfattas',
    'project-pages.better-together-templates.product-requirements.insert-design-link': "Infoga en l\xe4nk till din design (Figma, osv.)",
    'project-pages.better-together-templates.product-requirements.jira-issue-heading': "Jira-\xe4rende",
    'project-pages.better-together-templates.product-requirements.jira-roadmap-heading': "Jira-\xf6versikt",
    'project-pages.better-together-templates.product-requirements.learn-how-with-smart-links': "L\xe4s mer om smarta l\xe4nkar",
    'project-pages.better-together-templates.product-requirements.list-dashboards': "Lista dashboards (Amplitude, l\xe4ge osv.)",
    'project-pages.better-together-templates.product-requirements.list-design-considerations': "Lista design- eller versions\xf6verv\xe4ganden",
    'project-pages.better-together-templates.product-requirements.list-people': "lista personer som anv\xe4nder",
    'project-pages.better-together-templates.product-requirements.mention': "omn\xe4mn",
    'project-pages.better-together-templates.product-requirements.mention-people-to-assign-them': "personer f\xf6r att tilldela dem till en \xe5tg\xe4rd",
    'project-pages.better-together-templates.product-requirements.niceToHaveStatus': 'Bra att ha',
    'project-pages.better-together-templates.product-requirements.outOfScopeStatus': 'Omfattas ej',
    'project-pages.better-together-templates.product-requirements.page-title': 'Produktkrav',
    'project-pages.better-together-templates.product-requirements.pro-tip': 'Proffstips:',
    'project-pages.better-together-templates.product-requirements.problem-label': 'Problem',
    'project-pages.better-together-templates.product-requirements.requirement-heading': 'Krav',
    'project-pages.better-together-templates.product-requirements.scope-heading': 'Omfattning',
    'project-pages.better-together-templates.product-requirements.success-metric': "Framg\xe5ngsstatistik",
    'project-pages.better-together-templates.product-requirements.target-release-date': "M\xe5llanseringsdatum",
    'project-pages.better-together-templates.product-requirements.team-label': 'Team',
    'project-pages.better-together-templates.product-requirements.to-do-list-heading': "Att g\xf6ra-lista",
    'project-pages.better-together-templates.product-requirements.what-are-you-trying-to-fix': "Vad f\xf6rs\xf6ker du \xe5tg\xe4rda?",
    'project-pages.better-together-templates.retro-notes.retro-heading': 'Retrospektiv',
    'project-pages.better-together-templates.retro.action-items-heading': "Vilka \xe4r \xe5tg\xe4rderna?",
    'project-pages.better-together-templates.retro.create-a-jira-issue': "Skriv /Jira f\xf6r att skapa ett \xe4rende",
    'project-pages.better-together-templates.retro.date-label': 'Datum',
    'project-pages.better-together-templates.retro.embed-it-here': "N\xe4r du \xe4r klar kan du b\xe4dda in det h\xe4r.",
    'project-pages.better-together-templates.retro.list-people': "lista personer som anv\xe4nder",
    'project-pages.better-together-templates.retro.mention': "omn\xe4mn",
    'project-pages.better-together-templates.retro.mention-people-to-assign-them': "personer f\xf6r att tilldela dem till en \xe5tg\xe4rd",
    'project-pages.better-together-templates.retro.page-title': 'Retrospektiv',
    'project-pages.better-together-templates.retro.participants-label': 'Deltagare',
    'project-pages.better-together-templates.retro.pro-tip': 'Proffstips:',
    'project-pages.better-together-templates.retro.project-label': 'Projekt',
    'project-pages.better-together-templates.retro.this-is-a-whiteboard': "Det h\xe4r \xe4r en Confluence-whiteboardtavla.",
    'project-pages.better-together-templates.retro.use-a-whiteboard': "Anv\xe4nd en Confluence-whiteboardtavla f\xf6r din retro.",
    'project-pages.better-together-templates.retro.use-it-to-vote': "Anv\xe4nd den f\xf6r att r\xf6sta och samarbeta med ditt team.",
    'project-pages.button.connect-different-space-or-page.label': "Uppdatera ikon f\xf6r utrymme eller sida",
    'project-pages.button.connect-different-space-or-page.tooltip': 'Anslut ett annat utrymme eller objekt',
    'project-pages.button.connect-space-or-page.tooltip': 'Anslut till Confluence',
    'project-pages.button.go-to-connected-live-doc.tooltip': "\xd6ppna live doc i Confluence",
    'project-pages.button.go-to-connected-page.tooltip': "\xd6ppna sida i Confluence",
    'project-pages.button.go-to-connected-space.tooltip': "\xd6ppna utrymme i Confluence",
    'project-pages.connect-space-dialog.connection-error': 'Anslutningen misslyckades.',
    'project-pages.connect-space-dialog.connection-retry': "F\xf6rs\xf6k igen",
    'project-pages.connect-space-dialog.content.space-or-page-selector.description': "V\xe4lj ett utrymme eller ett objekt som du vill ansluta till ditt projekt.",
    'project-pages.connect-space-dialog.content.space-or-page-selector.placeholder': "S\xf6k Confluence",
    'project-pages.connect-space-dialog.content.space-selector.disconnected-templates-description': "Det h\xe4r projektet beh\xf6ver vara anslutet till ett utrymme innan du kan skapa en uppgift. V\xe4lj ett utrymme som du vill ansluta till det h\xe4r projektet.",
    'project-pages.connect-space-dialog.error-icon': 'Fel:',
    'project-pages.connect-space-dialog.footer.cancel': 'Avbryt',
    'project-pages.connect-space-dialog.footer.connect-space': 'Anslut',
    'project-pages.connect-space-or-page-dialog.header.title': 'Anslut ett projekt till Confluence',
    'project-pages.connect-space.description': "Utrymmen \xe4r som mappar: du kan anv\xe4nda dem f\xf6r att skapa, organisera och samarbeta p\xe5 allt inneh\xe5ll med anknytning till projektet.",
    'project-pages.connect-space.not-connected.description': "Om du vill anv\xe4nda projektsidor kontaktar du din administrat\xf6r eller teamledare f\xf6r att ansluta Confluence till projektet.",
    'project-pages.connect-space.not-connected.heading': 'Inte anslutet till Confluence',
    'project-pages.connect-success-flag.description.content': "Anslutning har uppr\xe4ttats till {connectedSpaceOrPageName}-inneh\xe5ll.",
    'project-pages.connection-error.space-or-page-not-found.button': 'Anslut till ett annat utrymme eller en annan sida',
    'project-pages.create-space-dialog.connection-error': 'Anslutningen misslyckades.',
    'project-pages.create-space-dialog.connection-retry': "F\xf6rs\xf6k igen",
    'project-pages.create-space-dialog.content.empty-name': 'Ge ditt utrymme ett namn.',
    'project-pages.create-space-dialog.content.invalid-name': "Utrymmesnamn m\xe5ste best\xe5 av minst en bokstav eller siffra.",
    'project-pages.create-space-dialog.content.placeholder': 'Ange ett utrymmesnamn',
    'project-pages.create-space-dialog.creation-error': 'Det gick inte skapa utrymme.',
    'project-pages.create-space-dialog.error-icon': 'Fel:',
    'project-pages.create-space-dialog.footer.cancel': 'Avbryt',
    'project-pages.create-space-dialog.footer.create-space': 'Skapa',
    'project-pages.create-space-dialog.header.title': 'Skapa nytt Confluence-utrymme',
    'project-pages.cross-join.access-revoked.templates.subtitle': "Du kan inte anv\xe4nda projektsidor eftersom administrat\xf6ren har nekat dig \xe5tkomst till Confluence. Kontakta webbplatsadministrat\xf6ren f\xf6r att beg\xe4ra \xe5tkomst.",
    'project-pages.cross-join.access-revoked.templates.title': "Du har inte beh\xf6righet att anv\xe4nda projektsidor",
    'project-pages.cross-join.avatar.view-profile': 'Visa profil',
    'project-pages.cross-join.denied-request.templates.subtitle': "Du kan inte anv\xe4nda projektsidor eftersom webbplatsadministrat\xf6ren nekade din beg\xe4ran om att g\xe5 med i Confluence.",
    'project-pages.cross-join.denied-request.templates.title': "Din administrat\xf6r har nekat dig \xe5tkomst",
    'project-pages.cross-join.direct-access.button-subtitle.experimental': "Du f\xe5r \xe5tkomst till Confluence. Din webbplatsadministrat\xf6r har redan godk\xe4nt dig.",
    'project-pages.cross-join.errors.unknown-error.description': "{contactSupport} om det inte hj\xe4lper att uppdatera.",
    'project-pages.cross-join.errors.unknown-error.title': 'Vi kan inte visa projektsidorna just nu',
    'project-pages.cross-join.inline-join-product.button': "Du f\xe5r \xe5tkomst till Confluence. Din webbplatsadministrat\xf6r har redan godk\xe4nt dig.",
    'project-pages.cross-join.inline-join-product.connected.description': "Visa, redigera och skapa dokumentation fr\xe5n en och samma plats",
    'project-pages.cross-join.inline-join-product.connected.title': "Samarbeta med ditt team p\xe5 projektsidor",
    'project-pages.cross-join.pending-request.templates.subtitle': "Webbplatsadministrat\xf6ren har f\xe5tt din beg\xe4ran att g\xe5 med i Confluence. Om du \xe4r godk\xe4nd att g\xe5 med kommer projektsidorna att b\xf6rja fungera och vi skickar ett bekr\xe4ftelsemeddelande till dig.",
    'project-pages.cross-join.pending-request.templates.subtitle.experiment': "Du f\xe5r ett e-postmeddelande med \xe5tkomst till projektsidor n\xe4r du har godk\xe4nts.",
    'project-pages.cross-join.pending-request.templates.title': "Du har beg\xe4rt \xe5tkomst till Confluence",
    'project-pages.cross-join.pending-request.templates.title.experiment': "\xc5tkomstf\xf6rfr\xe5gan har skickats till administrat\xf6r",
    'project-pages.cross-join.request-access-without-better-together.connected.description': 'Visa, redigera och skapa projektdokumentation med ditt team',
    'project-pages.cross-join.request-access.button': "Beg\xe4r \xe5tkomst",
    'project-pages.cross-join.request-access.button-subtitle.experimental': "N\xe4r du v\xe4ljer \u201DG\xe5 med i ditt team\u201D ber du om att g\xe5 med i Confluence och samtycker till att dela din Atlassian-profil med administrat\xf6ren.",
    'project-pages.cross-join.request-access.button.experimental': 'Anslut till ditt team',
    'project-pages.cross-join.request-access.connected.description.experimental': "Ditt team anv\xe4nder projektsidor f\xf6r att kommentera, redigera och samarbeta kring projektdokumentation utan att l\xe4mna Jira. G\xe5 med i Confluence f\xf6r att komma \xe5t ditt teams projektsidor.",
    'project-pages.cross-join.request-access.title': "Projektsidor kr\xe4ver \xe5tkomst till Confluence",
    'project-pages.cross-join.request-access.title.experiment': "Skapa en enda sanningsk\xe4lla f\xf6r ditt team",
    'project-pages.default-contextual-heading': 'Projektsidor drivs av Confluence',
    'project-pages.default-contextual-message': "Skapa, dela och samarbeta i alla projektdokument p\xe5 ett st\xe4lle med Confluence-sidor.",
    'project-pages.default-reactivate-CTA': "\xc5teraktivera Confluence",
    'project-pages.default-trial-CTA': 'Prova Confluence gratis i 30 dagar',
    'project-pages.draft-saved-flag.action': "\xd6ppna utkast",
    'project-pages.draft-saved-flag.description': 'Du ser bara ditt utkast tills du publicerar det.',
    'project-pages.draft-saved-flag.title': 'Utkastet har sparats',
    'project-pages.embedded-pages.create-page-error.close-button': "St\xe4ng",
    'project-pages.embedded-pages.create-page-error.description': "Det uppstod ett problem och vi kunde inte skapa en sida \xe5t dig.",
    'project-pages.embedded-pages.create-page-error.title': 'Vi kunde inte skapa en sida',
    'project-pages.embedded-pages.create-page-error.try-again-button': "F\xf6rs\xf6k igen",
    'project-pages.embedded-pages.modal.close.button.hint': "St\xe4ng",
    'project-pages.embedded-pages.modal.title.button': "\xd6ppna i Confluence",
    'project-pages.embedded-pages.modal.title.button.hint': "\xd6ppna p\xe5 ny flik",
    'project-pages.errors.unknown-error.description.non-final': "{contactSupport} om det inte hj\xe4lper att uppdatera.",
    'project-pages.errors.unknown-error.title.non-final': 'Vi kan inte visa projektsidorna just nu',
    'project-pages.generic-error.button.reload': 'Uppdatera sida',
    'project-pages.generic-error.description': "Ett fel intr\xe4ffade. F\xf6rs\xf6k igen senare.",
    'project-pages.generic-error.description.non-final': "Ett fel intr\xe4ffade. F\xf6rs\xf6k igen senare.",
    'project-pages.generic-error.heading': 'Det var konstigt ...',
    'project-pages.generic-error.title.non-final': 'Det var konstigt ...',
    'project-pages.generic-info-flag.description': "N\xe5got gick fel. F\xf6rs\xf6k igen eller kontakta support om problemet kvarst\xe5r",
    'project-pages.generic-success-flag.description.live-doc': 'Har anslutit med live doc {connectedSpaceOrPageName}.',
    'project-pages.generic-success-flag.description.page': "Anslutning har uppr\xe4ttats till sidan {connectedSpaceOrPageName}.",
    'project-pages.generic-success-flag.description.space': "Anslutning har uppr\xe4ttats till utrymmet {connectedSpaceOrPageName}.",
    'project-pages.generic-success-flag.heading.live-doc': 'Live doc har anslutits',
    'project-pages.generic-success-flag.heading.page': 'Sidan har anslutits',
    'project-pages.generic-success-flag.heading.space': 'Utrymme har anslutits',
    'project-pages.granular-pages.connect-space-dialog.content.create-space-link.link-text': 'Eller skapa ett nytt utrymme',
    'project-pages.granular-pages.connect-space.button': 'Anslut till Confluence',
    'project-pages.granular-pages.connect-space.heading': 'Anslut projektet till ett Confluence-utrymme eller -objekt',
    'project-pages.improvement.contact-support': 'Kontakta supporten',
    'project-pages.improvement.errors.access-error.description': "Prova att kontakta webbplatsadministrat\xf6ren f\xf6r att be om \xe5tkomst.",
    'project-pages.improvement.errors.access-error.title': "Du har inte beh\xf6righet att visa projektsidorna",
    'project-pages.improvement.errors.page-tree-unknown-error.description': "N\xe5got gick fel n\xe4r vi f\xf6rs\xf6kte visa sidorna fr\xe5n ditt anslutna Confluence-utrymme. {contactSupport} om det inte hj\xe4lper att uppdatera.",
    'project-pages.improvement.errors.page-tree-unknown-error.title': 'Vi kan inte visa projektsidorna',
    'project-pages.improvement.errors.space-or-page-not-found.description': "Confluence-utrymmet eller -sidan som var ansluten har flyttats, arkiverats eller raderats. <link>Kontakta support</link> om det inte hj\xe4lper att ansluta p\xe5 nytt.",
    'project-pages.improvement.errors.space-or-page-not-found.title': 'Utrymme eller sida hittades inte',
    'project-pages.improvement.errors.unknown-error.description': "{contactSupport} om det inte hj\xe4lper att uppdatera.",
    'project-pages.improvement.errors.unknown-error.title': 'Vi kan inte visa projektsidorna just nu',
    'project-pages.improvement.feature1': "Kom \xe5t och skapa dokument utan att l\xe4mna Jira",
    'project-pages.improvement.feature2': "Mallar f\xf6r m\xf6ten, sprintplaner och mer",
    'project-pages.improvement.feature3': "Synkronisera dokument till Jira f\xf6r automatiska uppdateringar",
    'project-pages.improvement.heading-info': "F\xe5nga upp ditt teams kunskaper och f\xf6rb\xe4ttra hur arbete utf\xf6rs.",
    'project-pages.improvement.heading-info-v2': "Skapa en plats f\xf6r teamets samtliga projektdokument",
    'project-pages.improvement.learn-more-button': "L\xe4s mer",
    'project-pages.improvement.powered-by': 'Drivs av',
    'project-pages.improvement.powered-by.tooltip': "\xd6ppna Confluence i en ny flik",
    'project-pages.improvement.preview-teaser': "Kom \xe5t mallar, projektsidor och mycket mer.",
    'project-pages.improvement.provisioning-info-modal.seamlessly-update-stakeholders.description': "<p>H\xe5ll dina projektrapporter uppdaterade med statusetiketter som uppdateras automatiskt.</p> <p>N\xe4r du l\xe4nkar ett Jira-\xe4rende i ett dokument visar det automatiskt en statusetikett som uppdateras n\xe4r \xe4rendet uppdateras. P\xe5 s\xe5 s\xe4tt beh\xf6ver du inte l\xe4gga tid p\xe5 att skapa manuella rapporter.</p>",
    'project-pages.improvement.provisioning-info-modal.seamlessly-update-stakeholders.title': 'Uppdatera effektivt dina intressenter',
    'project-pages.improvement.provisioning-info-modal.unify-documentation-standards.description': "<p>Skapa konsekvent dokumentation med hj\xe4lp av v\xe5ra inbyggda mallar. De \xe4r enkla att anv\xe4nda och kan anpassas efter dina behov.</p> <p>Du kan anv\xe4nda mallar direkt fr\xe5n projektsidor. Du beh\xf6ver inte l\xe4mna projektet f\xf6r att h\xe4mta dem. Bl\xe4ddra bland alla mallar <a>h\xe4r</a>.</p>",
    'project-pages.improvement.provisioning-info-modal.unify-documentation-standards.title': 'Skapa en enhetlig dokumentationsstandard',
    'project-pages.improvement.provisioning-info-modal.your-project-pages-in-jira.description': "<p>Skapa en enda sanningsk\xe4lla f\xf6r viktig information genom att skapa och hantera dokumentation fr\xe5n fliken projektsidor i Jira.</p> <p>Visste du att projektsidor k\xf6rs p\xe5 Confluence? Det \xe4r kostnadsfritt f\xf6r upp till 10 anv\xe4ndare. Bjud in resten av teamet i administrat\xf6rsinst\xe4llningarna.</p>",
    'project-pages.improvement.provisioning-info-modal.your-project-pages-in-jira.title': 'Dina projektsidor, direkt i Jira.',
    'project-pages.improvement.templates-sidebar.better-together-templates-header': 'Mallar som integrerats med dina Jira-data',
    'project-pages.improvement.templates.better-together-preview-teaser': 'Integrerad med Jira-data',
    'project-pages.improvement.templates.blank-page.description': "B\xf6rja med en tom sida.",
    'project-pages.improvement.templates.blank-page.name': 'Blank sida',
    'project-pages.improvement.templates.decision.description': "Protokollf\xf6r viktiga projektbeslut och kommunicera dem med ditt team.",
    'project-pages.improvement.templates.decision.name': 'Beslut',
    'project-pages.improvement.templates.meeting-notes.description': "Planera dina m\xf6ten, f\xf6r anteckningar och dela \xe5tg\xe4rder med ditt team.",
    'project-pages.improvement.templates.meeting-notes.name': "M\xf6tesanteckningar",
    'project-pages.improvement.templates.post-expand.more': 'Fler mallar',
    'project-pages.improvement.templates.post-expand.more.tooltip': 'Visa alla mallar i Confluence',
    'project-pages.improvement.templates.post-expand.subtitle': "Popul\xe4ra mallar",
    'project-pages.improvement.templates.post-expand.title': 'Skapa en sida',
    'project-pages.improvement.templates.pre-expand.more': 'Utforska fler mallar',
    'project-pages.improvement.templates.pre-expand.subtitle': "Popul\xe4ra f\xf6r team som ditt",
    'project-pages.improvement.templates.pre-expand.title': "F\xf6rhandsgranska mallar",
    'project-pages.improvement.templates.product-requirements.description': "Definiera, sp\xe5ra och avgr\xe4nsa krav f\xf6r din produkt eller funktion.",
    'project-pages.improvement.templates.product-requirements.name': 'Produktkrav',
    'project-pages.improvement.templates.retrospective.description': "Vad gick bra? Vad kunde ha g\xe5tt b\xe4ttre? Crowdsourca f\xf6rb\xe4ttringar med ditt team.",
    'project-pages.improvement.templates.retrospective.name': 'Retrospektiv',
    'project-pages.improvement.templates.template.disabled-tooltip': "Anslut ett Confluence-utrymme f\xf6rst",
    'project-pages.improvement.templates.tutorial.content.confluence-templates': "<b>Spara tid och minska m\xe4ngden manuella uppgifter</b> Confluence har m\xe5nga <a>sidmallar</a>, s\xe5 du beh\xf6ver aldrig b\xf6rja fr\xe5n b\xf6rjan. Allt fr\xe5n tekniska dokument, fels\xf6kningsguider, projektplaner och produktkrav till mycket mer.",
    'project-pages.improvement.templates.tutorial.content.edit-and-format': "<b>Redigera och formatera med l\xe4tthet.</b> Anv\xe4nd den \xf6vre redigeringsmenyn f\xf6r standardordformatering och genom att skriva <b>/</b> kan du enkelt infoga en massa anv\xe4ndbara integrationer. Infoga en tabell genom att skriva <c>/table</c> eller en bild med <c>/image</c>. Du kan \xe4ven infoga Dropbox-l\xe4nkar <c>/dropbox</c>, Microsoft Office-verktyg <c>/microsoft</c> eller Trello-tavlor och -kort <c>/trello</c>.",
    'project-pages.improvement.templates.tutorial.content.forward-slash-prompt': "Skriv / f\xf6ljt av \u201Dtable\u201D eller \u201Dimage\u201D",
    'project-pages.improvement.templates.tutorial.content.getting-started-tips': "H\xe4r f\xf6ljer n\xe5gra tips f\xf6r att komma ig\xe5ng:",
    'project-pages.improvement.templates.tutorial.content.handy-links': "Anv\xe4ndbara l\xe4nkar",
    'project-pages.improvement.templates.tutorial.content.jira-and-confluence': "Anv\xe4nd Jira och Confluence tillsammans",
    'project-pages.improvement.templates.tutorial.content.jira-charts': "Skapa diagram p\xe5 dina sidor med faktiska Jira-data. Skriv <c>/Jira charts</c>.",
    'project-pages.improvement.templates.tutorial.content.jira-links': "L\xe4nka ett Jira-\xe4rende p\xe5 valfri plats p\xe5 sidan. L\xe4nken p\xe5 sidan uppdateras i realtid samtidigt som Jira-\xe4rendet uppdateras. Skriv <c>/Jira</c>",
    'project-pages.improvement.templates.tutorial.content.jira-links-issue-term-refresh': "L\xe4nka en Jira-arbetsuppgift p\xe5 valfri plats p\xe5 sidan. L\xe4nken p\xe5 sidan uppdateras i realtid samtidigt som arbetsuppgiften uppdateras. Skriv <c>/Jira</c>.",
    'project-pages.improvement.templates.tutorial.content.jira-links.non-final-issue-term-refresh': "L\xe4nka en Jira-arbetsuppgift p\xe5 valfri plats p\xe5 sidan. L\xe4nken p\xe5 sidan uppdateras i realtid samtidigt som arbetsuppgiften uppdateras. Skriv <c>/Jira</c>.",
    'project-pages.improvement.templates.tutorial.content.jira-roadmaps': "B\xe4dda in interaktiva \xf6versikter och tidslinjer p\xe5 sidan med hj\xe4lp av dina Jira-projekt. Skriv <c>/jira roadmap</c>.",
    'project-pages.improvement.templates.tutorial.content.jira-timeline': "B\xe4dda in interaktiva tidslinjer p\xe5 sidan med hj\xe4lp av dina Jira-projekt. Skriv <c>/jira tidslinje</c>.",
    'project-pages.improvement.templates.tutorial.content.shipping-speed-statistic': "76\xa0% av Jira Software-kunder uppgav att de levererar projekt snabbare efter att ha lagt till Confluence",
    'project-pages.improvement.templates.tutorial.content.shipping-speed-statistic.spork-rebranding': "76\xa0% av Jira-kunder uppgav att de levererar projekt snabbare efter att ha lagt till Confluence",
    'project-pages.improvement.templates.tutorial.content.spaces-and-pages': "<b>Anv\xe4nda utrymmen och sidor</b>. Utrymmen \xe4r en del av varje Confluence-plats och ett bra s\xe4tt att organisera sidor i olika kategorier. T\xe4nk p\xe5 utrymmen som olika mappar eller projekt och sidor som de dokument som h\xf6r hemma i mapparna eller projekten. <a>L\xe4s mer om hur du anv\xe4nder utrymmen</a>",
    'project-pages.improvement.templates.tutorial.content.try-it-now': 'Testa nu',
    'project-pages.improvement.templates.tutorial.description': "L\xe4r dig hur du redigerar en sida.",
    'project-pages.improvement.templates.tutorial.name': "V\xe4lkommen till projektsidor!",
    'project-pages.improvement.terms-and-conditions-v2': "Genom att klicka p\xe5 Prova nu bekr\xe4ftar du att du registreras i Confluence och samtycker till <termsLink>anv\xe4ndarvillkoren</termsLink> och <privacyLink>sekretesspolicyn</privacyLink> f\xf6r Atlassian Cloud.",
    'project-pages.improvement.title': 'Projektsidor',
    'project-pages.improvement.transient-states.empty-state.auto-provisioned-create-page-button': 'Skapa sida',
    'project-pages.improvement.transient-states.empty-state.auto-provisioned-description': "Vi har lagt till Confluence s\xe5 att du kan b\xf6rja skapa och l\xe4nka alla dina projektdokument. Det \xe4r gratis f\xf6r upp till 10 anv\xe4ndare.",
    'project-pages.improvement.transient-states.empty-state.auto-provisioned-learn-more-button': "L\xe4s mer",
    'project-pages.improvement.transient-states.empty-state.create-page-button': "Skapa din f\xf6rsta sida",
    'project-pages.improvement.transient-states.empty-state.description': "Skapa m\xf6tesanteckningar, produktkrav, beslut eller annat inneh\xe5ll f\xf6r att fylla utrymmet.",
    'project-pages.improvement.transient-states.empty-state.title': "H\xe4r finns inget annat \xe4n potential",
    'project-pages.improvement.try-button': 'Prova mallen i Confluence',
    'project-pages.improvement.try-it-now': 'Testa nu',
    'project-pages.improvement.try-lozenge': 'Testa',
    'project-pages.improvement.try-on-demand-button': 'Prova gratis',
    'project-pages.page-deleted-flag.title': 'Sidan har raderats.',
    'project-pages.page-published-flag.title': 'Din sida har publicerats.',
    'project-pages.unknown-error.description': "{contactSupport} om det inte hj\xe4lper att uppdatera.",
    'project-pages.unknown-error.heading': 'Vi kan inte visa projektsidorna just nu'
};

});

parcelRegister("k8Cki", function(module, exports) {

$parcel$export(module.exports, "default", () => $86d745ea153a5e95$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Thai (Thailand)
var $86d745ea153a5e95$export$2e2bcd8739ae039 = {
    'confluence.project-pages.improvement.provisioning-background.text': "\u0E01\u0E32\u0E23\u0E14\u0E33\u0E40\u0E19\u0E34\u0E19\u0E01\u0E32\u0E23\u0E19\u0E35\u0E49\u0E08\u0E30\u0E43\u0E0A\u0E49\u0E40\u0E27\u0E25\u0E32\u0E44\u0E21\u0E48\u0E16\u0E36\u0E07\u0E2B\u0E19\u0E36\u0E48\u0E07\u0E19\u0E32\u0E17\u0E35",
    'confluence.project-pages.improvement.provisioning-background.title': "\u0E01\u0E33\u0E25\u0E31\u0E07\u0E15\u0E31\u0E49\u0E07\u0E04\u0E48\u0E32\u0E2B\u0E19\u0E49\u0E32\u0E42\u0E1B\u0E23\u0E40\u0E08\u0E01\u0E15\u0E4C\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13",
    'confluence.project-pages.improvement.provisioning-modal-carousel.controls.dismiss': "\u0E22\u0E01\u0E40\u0E25\u0E34\u0E01",
    'confluence.project-pages.improvement.provisioning-modal-carousel.controls.done': "\u0E40\u0E2A\u0E23\u0E47\u0E08\u0E41\u0E25\u0E49\u0E27",
    'confluence.project-pages.improvement.provisioning-modal-carousel.controls.next': "\u0E16\u0E31\u0E14\u0E44\u0E1B",
    'project-pages.activating.description': "\u0E1E\u0E37\u0E49\u0E19\u0E17\u0E35\u0E48 Confuence \u0E17\u0E35\u0E48\u0E40\u0E0A\u0E37\u0E48\u0E2D\u0E21\u0E15\u0E48\u0E2D\u0E41\u0E25\u0E49\u0E27\u0E22\u0E31\u0E07\u0E44\u0E21\u0E48\u0E04\u0E48\u0E2D\u0E22\u0E1E\u0E23\u0E49\u0E2D\u0E21\u0E43\u0E0A\u0E49\u0E07\u0E32\u0E19 {contactSupport} \u0E2B\u0E32\u0E01\u0E01\u0E32\u0E23\u0E23\u0E35\u0E40\u0E1F\u0E23\u0E0A\u0E22\u0E31\u0E07\u0E44\u0E21\u0E48\u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E41\u0E01\u0E49\u0E44\u0E02\u0E1B\u0E31\u0E0D\u0E2B\u0E32\u0E44\u0E14\u0E49",
    'project-pages.activating.heading': "Confluence \u0E22\u0E31\u0E07\u0E01\u0E33\u0E25\u0E31\u0E07\u0E42\u0E2B\u0E25\u0E14\u0E2D\u0E22\u0E39\u0E48",
    'project-pages.better-together-templates.meeting-notes.action-items-heading': "\u0E23\u0E32\u0E22\u0E01\u0E32\u0E23\u0E14\u0E33\u0E40\u0E19\u0E34\u0E19\u0E01\u0E32\u0E23\u0E21\u0E35\u0E2D\u0E30\u0E44\u0E23\u0E1A\u0E49\u0E32\u0E07",
    'project-pages.better-together-templates.meeting-notes.agenda-item-label': "\u0E23\u0E32\u0E22\u0E01\u0E32\u0E23\u0E27\u0E32\u0E23\u0E30\u0E01\u0E32\u0E23\u0E1B\u0E23\u0E30\u0E0A\u0E38\u0E21",
    'project-pages.better-together-templates.meeting-notes.create-a-jira-issue': "\u0E1E\u0E34\u0E21\u0E1E\u0E4C /Jira \u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E2A\u0E23\u0E49\u0E32\u0E07\u0E1B\u0E31\u0E0D\u0E2B\u0E32",
    'project-pages.better-together-templates.meeting-notes.date-label': "\u0E27\u0E31\u0E19\u0E17\u0E35\u0E48",
    'project-pages.better-together-templates.meeting-notes.discussion-topics-heading': "\u0E2B\u0E31\u0E27\u0E02\u0E49\u0E2D\u0E01\u0E32\u0E23\u0E2A\u0E19\u0E17\u0E19\u0E32",
    'project-pages.better-together-templates.meeting-notes.list-people': "\u0E41\u0E2A\u0E14\u0E07\u0E23\u0E32\u0E22\u0E0A\u0E37\u0E48\u0E2D\u0E42\u0E14\u0E22\u0E43\u0E0A\u0E49",
    'project-pages.better-together-templates.meeting-notes.mention': "\u0E01\u0E25\u0E48\u0E32\u0E27\u0E16\u0E36\u0E07",
    'project-pages.better-together-templates.meeting-notes.mention-people-to-assign-them': "\u0E1A\u0E38\u0E04\u0E04\u0E25\u0E17\u0E35\u0E48\u0E08\u0E30\u0E21\u0E2D\u0E1A\u0E2B\u0E21\u0E32\u0E22\u0E23\u0E32\u0E22\u0E01\u0E32\u0E23\u0E14\u0E33\u0E40\u0E19\u0E34\u0E19\u0E01\u0E32\u0E23\u0E43\u0E2B\u0E49\u0E1E\u0E27\u0E01\u0E40\u0E02\u0E32",
    'project-pages.better-together-templates.meeting-notes.notes-label': "\u0E1A\u0E31\u0E19\u0E17\u0E36\u0E01",
    'project-pages.better-together-templates.meeting-notes.page-title': "\u0E1A\u0E31\u0E19\u0E17\u0E36\u0E01\u0E01\u0E32\u0E23\u0E1B\u0E23\u0E30\u0E0A\u0E38\u0E21",
    'project-pages.better-together-templates.meeting-notes.participants-label': "\u0E1C\u0E39\u0E49\u0E40\u0E02\u0E49\u0E32\u0E23\u0E48\u0E27\u0E21",
    'project-pages.better-together-templates.meeting-notes.project-label': "\u0E42\u0E1B\u0E23\u0E40\u0E08\u0E01\u0E15\u0E4C",
    'project-pages.better-together-templates.product-requirements.create-a-jira-issue': "\u0E1E\u0E34\u0E21\u0E1E\u0E4C /Jira \u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E2A\u0E23\u0E49\u0E32\u0E07\u0E1B\u0E31\u0E0D\u0E2B\u0E32",
    'project-pages.better-together-templates.product-requirements.design-heading': "\u0E01\u0E32\u0E23\u0E2D\u0E2D\u0E01\u0E41\u0E1A\u0E1A",
    'project-pages.better-together-templates.product-requirements.embedd-different-data-views': "\u0E1D\u0E31\u0E07\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E41\u0E25\u0E30\u0E21\u0E38\u0E21\u0E21\u0E2D\u0E07\u0E15\u0E48\u0E32\u0E07 \u0E46 \u0E08\u0E32\u0E01\u0E42\u0E1B\u0E23\u0E40\u0E08\u0E01\u0E15\u0E4C Jira \u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13",
    'project-pages.better-together-templates.product-requirements.heading': "\u0E20\u0E32\u0E1E\u0E23\u0E27\u0E21",
    'project-pages.better-together-templates.product-requirements.how-will-you-know-if-fixed': "\u0E04\u0E38\u0E13\u0E08\u0E30\u0E23\u0E39\u0E49\u0E44\u0E14\u0E49\u0E2D\u0E22\u0E48\u0E32\u0E07\u0E44\u0E23\u0E27\u0E48\u0E32\u0E04\u0E38\u0E13\u0E44\u0E14\u0E49\u0E41\u0E01\u0E49\u0E44\u0E02\u0E1B\u0E31\u0E0D\u0E2B\u0E32\u0E41\u0E25\u0E49\u0E27",
    'project-pages.better-together-templates.product-requirements.impact-heading': "\u0E1C\u0E25\u0E01\u0E23\u0E30\u0E17\u0E1A",
    'project-pages.better-together-templates.product-requirements.inScopeStatus': "\u0E2D\u0E22\u0E39\u0E48\u0E43\u0E19\u0E02\u0E2D\u0E1A\u0E40\u0E02\u0E15",
    'project-pages.better-together-templates.product-requirements.insert-design-link': "\u0E41\u0E17\u0E23\u0E01\u0E25\u0E34\u0E07\u0E01\u0E4C\u0E44\u0E1B\u0E22\u0E31\u0E07\u0E01\u0E32\u0E23\u0E2D\u0E2D\u0E01\u0E41\u0E1A\u0E1A\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13 (\u0E40\u0E0A\u0E48\u0E19 Figma)",
    'project-pages.better-together-templates.product-requirements.jira-issue-heading': "\u0E1B\u0E31\u0E0D\u0E2B\u0E32 Jira",
    'project-pages.better-together-templates.product-requirements.jira-roadmap-heading': "\u0E41\u0E1C\u0E19\u0E07\u0E32\u0E19 Jira",
    'project-pages.better-together-templates.product-requirements.learn-how-with-smart-links': "\u0E40\u0E23\u0E35\u0E22\u0E19\u0E23\u0E39\u0E49\u0E27\u0E34\u0E18\u0E35\u0E01\u0E32\u0E23\u0E14\u0E49\u0E27\u0E22\u0E2A\u0E21\u0E32\u0E23\u0E4C\u0E17\u0E25\u0E34\u0E07\u0E01\u0E4C (\u0E25\u0E34\u0E07\u0E01\u0E4C\u0E2D\u0E31\u0E08\u0E09\u0E23\u0E34\u0E22\u0E30)",
    'project-pages.better-together-templates.product-requirements.list-dashboards': "\u0E41\u0E2A\u0E14\u0E07\u0E23\u0E32\u0E22\u0E01\u0E32\u0E23\u0E41\u0E14\u0E0A\u0E1A\u0E2D\u0E23\u0E4C\u0E14 (\u0E41\u0E2D\u0E21\u0E1E\u0E25\u0E34\u0E08\u0E39\u0E14, \u0E42\u0E2B\u0E21\u0E14 \u0E40\u0E1B\u0E47\u0E19\u0E15\u0E49\u0E19)",
    'project-pages.better-together-templates.product-requirements.list-design-considerations': "\u0E41\u0E2A\u0E14\u0E07\u0E23\u0E32\u0E22\u0E01\u0E32\u0E23\u0E01\u0E32\u0E23\u0E2D\u0E2D\u0E01\u0E41\u0E1A\u0E1A\u0E2B\u0E23\u0E37\u0E2D\u0E2A\u0E23\u0E49\u0E32\u0E07\u0E02\u0E49\u0E2D\u0E04\u0E27\u0E23\u0E1E\u0E34\u0E08\u0E32\u0E23\u0E13\u0E32",
    'project-pages.better-together-templates.product-requirements.list-people': "\u0E41\u0E2A\u0E14\u0E07\u0E23\u0E32\u0E22\u0E0A\u0E37\u0E48\u0E2D\u0E42\u0E14\u0E22\u0E43\u0E0A\u0E49",
    'project-pages.better-together-templates.product-requirements.mention': "\u0E01\u0E25\u0E48\u0E32\u0E27\u0E16\u0E36\u0E07",
    'project-pages.better-together-templates.product-requirements.mention-people-to-assign-them': "\u0E1A\u0E38\u0E04\u0E04\u0E25\u0E17\u0E35\u0E48\u0E08\u0E30\u0E21\u0E2D\u0E1A\u0E2B\u0E21\u0E32\u0E22\u0E23\u0E32\u0E22\u0E01\u0E32\u0E23\u0E14\u0E33\u0E40\u0E19\u0E34\u0E19\u0E01\u0E32\u0E23\u0E43\u0E2B\u0E49\u0E1E\u0E27\u0E01\u0E40\u0E02\u0E32",
    'project-pages.better-together-templates.product-requirements.niceToHaveStatus': "\u0E04\u0E27\u0E23\u0E2D\u0E22\u0E39\u0E48\u0E43\u0E19\u0E02\u0E2D\u0E1A\u0E40\u0E02\u0E15",
    'project-pages.better-together-templates.product-requirements.outOfScopeStatus': "\u0E19\u0E2D\u0E01\u0E02\u0E2D\u0E1A\u0E40\u0E02\u0E15",
    'project-pages.better-together-templates.product-requirements.page-title': "\u0E02\u0E49\u0E2D\u0E01\u0E33\u0E2B\u0E19\u0E14\u0E1C\u0E25\u0E34\u0E15\u0E20\u0E31\u0E13\u0E11\u0E4C",
    'project-pages.better-together-templates.product-requirements.pro-tip': "\u0E40\u0E04\u0E25\u0E47\u0E14\u0E25\u0E31\u0E1A\u0E08\u0E32\u0E01\u0E21\u0E37\u0E2D\u0E2D\u0E32\u0E0A\u0E35\u0E1E:",
    'project-pages.better-together-templates.product-requirements.problem-label': "\u0E1B\u0E31\u0E0D\u0E2B\u0E32",
    'project-pages.better-together-templates.product-requirements.requirement-heading': "\u0E02\u0E49\u0E2D\u0E01\u0E33\u0E2B\u0E19\u0E14",
    'project-pages.better-together-templates.product-requirements.scope-heading': "\u0E02\u0E2D\u0E1A\u0E40\u0E02\u0E15",
    'project-pages.better-together-templates.product-requirements.success-metric': "\u0E40\u0E21\u0E15\u0E23\u0E34\u0E01\u0E04\u0E27\u0E32\u0E21\u0E2A\u0E33\u0E40\u0E23\u0E47\u0E08",
    'project-pages.better-together-templates.product-requirements.target-release-date': "\u0E27\u0E31\u0E19\u0E17\u0E35\u0E48\u0E1B\u0E25\u0E48\u0E2D\u0E22\u0E15\u0E31\u0E27\u0E23\u0E38\u0E48\u0E19\u0E17\u0E35\u0E48\u0E01\u0E33\u0E2B\u0E19\u0E14",
    'project-pages.better-together-templates.product-requirements.team-label': "\u0E17\u0E35\u0E21",
    'project-pages.better-together-templates.product-requirements.to-do-list-heading': "\u0E23\u0E32\u0E22\u0E01\u0E32\u0E23\u0E2A\u0E34\u0E48\u0E07\u0E17\u0E35\u0E48\u0E08\u0E30\u0E17\u0E33",
    'project-pages.better-together-templates.product-requirements.what-are-you-trying-to-fix': "\u0E04\u0E38\u0E13\u0E15\u0E49\u0E2D\u0E07\u0E01\u0E32\u0E23\u0E41\u0E01\u0E49\u0E44\u0E02\u0E2D\u0E30\u0E44\u0E23",
    'project-pages.better-together-templates.retro-notes.retro-heading': "\u0E01\u0E32\u0E23\u0E1B\u0E23\u0E30\u0E0A\u0E38\u0E21\u0E2A\u0E23\u0E38\u0E1B",
    'project-pages.better-together-templates.retro.action-items-heading': "\u0E23\u0E32\u0E22\u0E01\u0E32\u0E23\u0E14\u0E33\u0E40\u0E19\u0E34\u0E19\u0E01\u0E32\u0E23\u0E21\u0E35\u0E2D\u0E30\u0E44\u0E23\u0E1A\u0E49\u0E32\u0E07",
    'project-pages.better-together-templates.retro.create-a-jira-issue': "\u0E1E\u0E34\u0E21\u0E1E\u0E4C /Jira \u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E2A\u0E23\u0E49\u0E32\u0E07\u0E1B\u0E31\u0E0D\u0E2B\u0E32",
    'project-pages.better-together-templates.retro.date-label': "\u0E27\u0E31\u0E19\u0E17\u0E35\u0E48",
    'project-pages.better-together-templates.retro.embed-it-here': "\u0E40\u0E21\u0E37\u0E48\u0E2D\u0E40\u0E2A\u0E23\u0E47\u0E08\u0E41\u0E25\u0E49\u0E27 \u0E04\u0E38\u0E13\u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E1D\u0E31\u0E07\u0E44\u0E14\u0E49\u0E17\u0E35\u0E48\u0E19\u0E35\u0E48",
    'project-pages.better-together-templates.retro.list-people': "\u0E41\u0E2A\u0E14\u0E07\u0E23\u0E32\u0E22\u0E0A\u0E37\u0E48\u0E2D\u0E42\u0E14\u0E22\u0E43\u0E0A\u0E49",
    'project-pages.better-together-templates.retro.mention': "\u0E01\u0E25\u0E48\u0E32\u0E27\u0E16\u0E36\u0E07",
    'project-pages.better-together-templates.retro.mention-people-to-assign-them': "\u0E1A\u0E38\u0E04\u0E04\u0E25\u0E17\u0E35\u0E48\u0E08\u0E30\u0E21\u0E2D\u0E1A\u0E2B\u0E21\u0E32\u0E22\u0E23\u0E32\u0E22\u0E01\u0E32\u0E23\u0E14\u0E33\u0E40\u0E19\u0E34\u0E19\u0E01\u0E32\u0E23\u0E43\u0E2B\u0E49\u0E1E\u0E27\u0E01\u0E40\u0E02\u0E32",
    'project-pages.better-together-templates.retro.page-title': "\u0E01\u0E32\u0E23\u0E1B\u0E23\u0E30\u0E0A\u0E38\u0E21\u0E2A\u0E23\u0E38\u0E1B",
    'project-pages.better-together-templates.retro.participants-label': "\u0E1C\u0E39\u0E49\u0E40\u0E02\u0E49\u0E32\u0E23\u0E48\u0E27\u0E21",
    'project-pages.better-together-templates.retro.pro-tip': "\u0E40\u0E04\u0E25\u0E47\u0E14\u0E25\u0E31\u0E1A\u0E08\u0E32\u0E01\u0E21\u0E37\u0E2D\u0E2D\u0E32\u0E0A\u0E35\u0E1E:",
    'project-pages.better-together-templates.retro.project-label': "\u0E42\u0E1B\u0E23\u0E40\u0E08\u0E01\u0E15\u0E4C",
    'project-pages.better-together-templates.retro.this-is-a-whiteboard': "\u0E19\u0E35\u0E48\u0E04\u0E37\u0E2D\u0E44\u0E27\u0E17\u0E4C\u0E1A\u0E2D\u0E23\u0E4C\u0E14 Confluence",
    'project-pages.better-together-templates.retro.use-a-whiteboard': "\u0E43\u0E0A\u0E49\u0E44\u0E27\u0E17\u0E4C\u0E1A\u0E2D\u0E23\u0E4C\u0E14\u0E02\u0E2D\u0E07 Confluence \u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E01\u0E32\u0E23\u0E1B\u0E23\u0E30\u0E0A\u0E38\u0E21\u0E2A\u0E23\u0E38\u0E1B\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13",
    'project-pages.better-together-templates.retro.use-it-to-vote': "\u0E43\u0E0A\u0E49\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E42\u0E2B\u0E27\u0E15\u0E41\u0E25\u0E30\u0E17\u0E33\u0E07\u0E32\u0E19\u0E23\u0E48\u0E27\u0E21\u0E01\u0E31\u0E19\u0E01\u0E31\u0E1A\u0E17\u0E35\u0E21\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13",
    'project-pages.button.connect-different-space-or-page.label': "\u0E2D\u0E31\u0E1B\u0E40\u0E14\u0E15\u0E1E\u0E37\u0E49\u0E19\u0E17\u0E35\u0E48\u0E2B\u0E23\u0E37\u0E2D\u0E44\u0E2D\u0E04\u0E2D\u0E19\u0E2B\u0E19\u0E49\u0E32\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25",
    'project-pages.button.connect-different-space-or-page.tooltip': "\u0E40\u0E0A\u0E37\u0E48\u0E2D\u0E21\u0E15\u0E48\u0E2D\u0E1E\u0E37\u0E49\u0E19\u0E17\u0E35\u0E48\u0E2B\u0E23\u0E37\u0E2D\u0E23\u0E32\u0E22\u0E01\u0E32\u0E23\u0E2D\u0E37\u0E48\u0E19",
    'project-pages.button.connect-space-or-page.tooltip': "\u0E40\u0E0A\u0E37\u0E48\u0E2D\u0E21\u0E15\u0E48\u0E2D Confluence",
    'project-pages.button.go-to-connected-live-doc.tooltip': "\u0E40\u0E1B\u0E34\u0E14\u0E40\u0E2D\u0E01\u0E2A\u0E32\u0E23\u0E17\u0E33\u0E07\u0E32\u0E19\u0E41\u0E25\u0E30\u0E41\u0E01\u0E49\u0E44\u0E02\u0E2A\u0E14\u0E43\u0E19 Confluence",
    'project-pages.button.go-to-connected-page.tooltip': "\u0E2B\u0E19\u0E49\u0E32\u0E17\u0E35\u0E48\u0E40\u0E1B\u0E34\u0E14\u0E43\u0E19 Confluence",
    'project-pages.button.go-to-connected-space.tooltip': "\u0E1E\u0E37\u0E49\u0E19\u0E17\u0E35\u0E48\u0E40\u0E1B\u0E34\u0E14\u0E43\u0E19 Confluence",
    'project-pages.connect-space-dialog.connection-error': "\u0E01\u0E32\u0E23\u0E40\u0E0A\u0E37\u0E48\u0E2D\u0E21\u0E15\u0E48\u0E2D\u0E25\u0E49\u0E21\u0E40\u0E2B\u0E25\u0E27",
    'project-pages.connect-space-dialog.connection-retry': "\u0E25\u0E2D\u0E07\u0E2D\u0E35\u0E01\u0E04\u0E23\u0E31\u0E49\u0E07",
    'project-pages.connect-space-dialog.content.space-or-page-selector.description': "\u0E40\u0E25\u0E37\u0E2D\u0E01\u0E1E\u0E37\u0E49\u0E19\u0E17\u0E35\u0E48\u0E2B\u0E23\u0E37\u0E2D\u0E23\u0E32\u0E22\u0E01\u0E32\u0E23\u0E17\u0E35\u0E48\u0E08\u0E30\u0E40\u0E0A\u0E37\u0E48\u0E2D\u0E21\u0E15\u0E48\u0E2D\u0E01\u0E31\u0E1A\u0E42\u0E1B\u0E23\u0E40\u0E08\u0E01\u0E15\u0E4C\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13",
    'project-pages.connect-space-dialog.content.space-or-page-selector.placeholder': "\u0E04\u0E49\u0E19\u0E2B\u0E32 Confluence",
    'project-pages.connect-space-dialog.content.space-selector.disconnected-templates-description': "\u0E08\u0E33\u0E40\u0E1B\u0E47\u0E19\u0E15\u0E49\u0E2D\u0E07\u0E40\u0E0A\u0E37\u0E48\u0E2D\u0E21\u0E15\u0E48\u0E2D\u0E42\u0E1B\u0E23\u0E40\u0E08\u0E01\u0E15\u0E4C\u0E19\u0E35\u0E49\u0E01\u0E31\u0E1A\u0E1E\u0E37\u0E49\u0E19\u0E17\u0E35\u0E48\u0E01\u0E48\u0E2D\u0E19\u0E04\u0E38\u0E13\u0E08\u0E36\u0E07\u0E08\u0E30\u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E2A\u0E23\u0E49\u0E32\u0E07\u0E23\u0E32\u0E22\u0E01\u0E32\u0E23\u0E44\u0E14\u0E49 \u0E40\u0E25\u0E37\u0E2D\u0E01\u0E1E\u0E37\u0E49\u0E19\u0E17\u0E35\u0E48\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E40\u0E0A\u0E37\u0E48\u0E2D\u0E21\u0E15\u0E48\u0E2D\u0E01\u0E31\u0E1A\u0E42\u0E1B\u0E23\u0E40\u0E08\u0E01\u0E15\u0E4C\u0E19\u0E35\u0E49",
    'project-pages.connect-space-dialog.error-icon': "\u0E02\u0E49\u0E2D\u0E1C\u0E34\u0E14\u0E1E\u0E25\u0E32\u0E14:",
    'project-pages.connect-space-dialog.footer.cancel': "\u0E22\u0E01\u0E40\u0E25\u0E34\u0E01",
    'project-pages.connect-space-dialog.footer.connect-space': "\u0E40\u0E0A\u0E37\u0E48\u0E2D\u0E21\u0E15\u0E48\u0E2D",
    'project-pages.connect-space-or-page-dialog.header.title': "\u0E40\u0E0A\u0E37\u0E48\u0E2D\u0E21\u0E15\u0E48\u0E2D\u0E42\u0E1B\u0E23\u0E40\u0E08\u0E01\u0E15\u0E4C\u0E44\u0E1B\u0E22\u0E31\u0E07 Confluence",
    'project-pages.connect-space.description': "\u0E1E\u0E37\u0E49\u0E19\u0E17\u0E35\u0E48\u0E27\u0E48\u0E32\u0E07\u0E40\u0E1B\u0E23\u0E35\u0E22\u0E1A\u0E40\u0E2A\u0E21\u0E37\u0E2D\u0E19\u0E42\u0E1F\u0E25\u0E40\u0E14\u0E2D\u0E23\u0E4C \u0E17\u0E35\u0E48\u0E04\u0E38\u0E13\u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E43\u0E0A\u0E49\u0E07\u0E32\u0E19\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E2A\u0E23\u0E49\u0E32\u0E07 \u0E08\u0E31\u0E14\u0E40\u0E23\u0E35\u0E22\u0E07 \u0E41\u0E25\u0E30\u0E17\u0E33\u0E07\u0E32\u0E19\u0E23\u0E48\u0E27\u0E21\u0E01\u0E31\u0E19\u0E1A\u0E19\u0E40\u0E19\u0E37\u0E49\u0E2D\u0E2B\u0E32\u0E17\u0E31\u0E49\u0E07\u0E2B\u0E21\u0E14\u0E17\u0E35\u0E48\u0E40\u0E01\u0E35\u0E48\u0E22\u0E27\u0E02\u0E49\u0E2D\u0E07\u0E01\u0E31\u0E1A\u0E42\u0E1B\u0E23\u0E40\u0E08\u0E01\u0E15\u0E4C\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13",
    'project-pages.connect-space.not-connected.description': "\u0E2B\u0E32\u0E01\u0E15\u0E49\u0E2D\u0E07\u0E01\u0E32\u0E23\u0E43\u0E0A\u0E49\u0E2B\u0E19\u0E49\u0E32\u0E42\u0E1B\u0E23\u0E40\u0E08\u0E01\u0E15\u0E4C\u0E19\u0E35\u0E49 \u0E42\u0E1B\u0E23\u0E14\u0E15\u0E34\u0E14\u0E15\u0E48\u0E2D\u0E1C\u0E39\u0E49\u0E14\u0E39\u0E41\u0E25\u0E2B\u0E23\u0E37\u0E2D\u0E2B\u0E31\u0E27\u0E2B\u0E19\u0E49\u0E32\u0E17\u0E35\u0E21\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E40\u0E0A\u0E37\u0E48\u0E2D\u0E21\u0E15\u0E48\u0E2D Confluence \u0E01\u0E31\u0E1A\u0E42\u0E1B\u0E23\u0E40\u0E08\u0E01\u0E15\u0E4C\u0E19\u0E35\u0E49",
    'project-pages.connect-space.not-connected.heading': "\u0E44\u0E21\u0E48\u0E21\u0E35\u0E01\u0E32\u0E23\u0E40\u0E0A\u0E37\u0E48\u0E2D\u0E21\u0E15\u0E48\u0E2D\u0E01\u0E31\u0E1A Confluence",
    'project-pages.connect-success-flag.description.content': "\u0E40\u0E0A\u0E37\u0E48\u0E2D\u0E21\u0E15\u0E48\u0E2D\u0E01\u0E31\u0E1A\u0E40\u0E19\u0E37\u0E49\u0E2D\u0E2B\u0E32 {connectedSpaceOrPageName} \u0E2A\u0E33\u0E40\u0E23\u0E47\u0E08\u0E41\u0E25\u0E49\u0E27",
    'project-pages.connection-error.space-or-page-not-found.button': "\u0E40\u0E0A\u0E37\u0E48\u0E2D\u0E21\u0E15\u0E48\u0E2D\u0E1E\u0E37\u0E49\u0E19\u0E17\u0E35\u0E48\u0E2B\u0E23\u0E37\u0E2D\u0E2B\u0E19\u0E49\u0E32\u0E2D\u0E37\u0E48\u0E19",
    'project-pages.create-space-dialog.connection-error': "\u0E01\u0E32\u0E23\u0E40\u0E0A\u0E37\u0E48\u0E2D\u0E21\u0E15\u0E48\u0E2D\u0E25\u0E49\u0E21\u0E40\u0E2B\u0E25\u0E27",
    'project-pages.create-space-dialog.connection-retry': "\u0E25\u0E2D\u0E07\u0E2D\u0E35\u0E01\u0E04\u0E23\u0E31\u0E49\u0E07",
    'project-pages.create-space-dialog.content.empty-name': "\u0E42\u0E1B\u0E23\u0E14\u0E15\u0E31\u0E49\u0E07\u0E0A\u0E37\u0E48\u0E2D\u0E43\u0E2B\u0E49\u0E1E\u0E37\u0E49\u0E19\u0E17\u0E35\u0E48\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13",
    'project-pages.create-space-dialog.content.invalid-name': "\u0E0A\u0E37\u0E48\u0E2D\u0E1E\u0E37\u0E49\u0E19\u0E17\u0E35\u0E48\u0E08\u0E33\u0E40\u0E1B\u0E47\u0E19\u0E15\u0E49\u0E2D\u0E07\u0E21\u0E35\u0E15\u0E31\u0E27\u0E2D\u0E31\u0E01\u0E29\u0E23\u0E2B\u0E23\u0E37\u0E2D\u0E15\u0E31\u0E27\u0E40\u0E25\u0E02\u0E2D\u0E22\u0E48\u0E32\u0E07\u0E19\u0E49\u0E2D\u0E22\u0E2B\u0E19\u0E36\u0E48\u0E07\u0E15\u0E31\u0E27",
    'project-pages.create-space-dialog.content.placeholder': "\u0E1B\u0E49\u0E2D\u0E19\u0E0A\u0E37\u0E48\u0E2D\u0E1E\u0E37\u0E49\u0E19\u0E17\u0E35\u0E48",
    'project-pages.create-space-dialog.creation-error': "\u0E01\u0E32\u0E23\u0E2A\u0E23\u0E49\u0E32\u0E07\u0E1E\u0E37\u0E49\u0E19\u0E17\u0E35\u0E48\u0E25\u0E49\u0E21\u0E40\u0E2B\u0E25\u0E27",
    'project-pages.create-space-dialog.error-icon': "\u0E02\u0E49\u0E2D\u0E1C\u0E34\u0E14\u0E1E\u0E25\u0E32\u0E14:",
    'project-pages.create-space-dialog.footer.cancel': "\u0E22\u0E01\u0E40\u0E25\u0E34\u0E01",
    'project-pages.create-space-dialog.footer.create-space': "\u0E2A\u0E23\u0E49\u0E32\u0E07",
    'project-pages.create-space-dialog.header.title': "\u0E2A\u0E23\u0E49\u0E32\u0E07\u0E1E\u0E37\u0E49\u0E19\u0E17\u0E35\u0E48 Confluence \u0E43\u0E2B\u0E21\u0E48",
    'project-pages.cross-join.access-revoked.templates.subtitle': "\u0E04\u0E38\u0E13\u0E44\u0E21\u0E48\u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E43\u0E0A\u0E49\u0E2B\u0E19\u0E49\u0E32\u0E42\u0E1B\u0E23\u0E40\u0E08\u0E01\u0E15\u0E4C\u0E44\u0E14\u0E49\u0E40\u0E19\u0E37\u0E48\u0E2D\u0E07\u0E08\u0E32\u0E01\u0E1C\u0E39\u0E49\u0E14\u0E39\u0E41\u0E25\u0E23\u0E30\u0E1A\u0E1A\u0E1B\u0E0F\u0E34\u0E40\u0E2A\u0E18\u0E43\u0E2B\u0E49\u0E04\u0E38\u0E13\u0E40\u0E02\u0E49\u0E32\u0E16\u0E36\u0E07 Confluence \u0E15\u0E34\u0E14\u0E15\u0E48\u0E2D\u0E1C\u0E39\u0E49\u0E14\u0E39\u0E41\u0E25\u0E23\u0E30\u0E1A\u0E1A\u0E02\u0E2D\u0E07\u0E40\u0E27\u0E47\u0E1A\u0E44\u0E0B\u0E15\u0E4C\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E2A\u0E48\u0E07\u0E04\u0E33\u0E02\u0E2D\u0E43\u0E19\u0E01\u0E32\u0E23\u0E40\u0E02\u0E49\u0E32\u0E16\u0E36\u0E07",
    'project-pages.cross-join.access-revoked.templates.title': "\u0E04\u0E38\u0E13\u0E44\u0E21\u0E48\u0E21\u0E35\u0E2A\u0E34\u0E17\u0E18\u0E34\u0E4C\u0E43\u0E19\u0E01\u0E32\u0E23\u0E43\u0E0A\u0E49\u0E2B\u0E19\u0E49\u0E32\u0E42\u0E1B\u0E23\u0E40\u0E08\u0E01\u0E15\u0E4C",
    'project-pages.cross-join.avatar.view-profile': "\u0E14\u0E39\u0E42\u0E1B\u0E23\u0E44\u0E1F\u0E25\u0E4C",
    'project-pages.cross-join.denied-request.templates.subtitle': "\u0E04\u0E38\u0E13\u0E44\u0E21\u0E48\u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E43\u0E0A\u0E49\u0E2B\u0E19\u0E49\u0E32\u0E42\u0E1B\u0E23\u0E40\u0E08\u0E01\u0E15\u0E4C\u0E44\u0E14\u0E49\u0E40\u0E19\u0E37\u0E48\u0E2D\u0E07\u0E08\u0E32\u0E01\u0E1C\u0E39\u0E49\u0E14\u0E39\u0E41\u0E25\u0E23\u0E30\u0E1A\u0E1A\u0E02\u0E2D\u0E07\u0E40\u0E27\u0E47\u0E1A\u0E44\u0E0B\u0E15\u0E4C\u0E1B\u0E0F\u0E34\u0E40\u0E2A\u0E18\u0E04\u0E33\u0E02\u0E2D\u0E43\u0E19\u0E01\u0E32\u0E23\u0E40\u0E02\u0E49\u0E32\u0E23\u0E48\u0E27\u0E21 Confluence \u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13",
    'project-pages.cross-join.denied-request.templates.title': "\u0E1C\u0E39\u0E49\u0E14\u0E39\u0E41\u0E25\u0E23\u0E30\u0E1A\u0E1A\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E44\u0E14\u0E49\u0E1B\u0E0F\u0E34\u0E40\u0E2A\u0E18\u0E04\u0E33\u0E02\u0E2D\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13",
    'project-pages.cross-join.direct-access.button-subtitle.experimental': "\u0E04\u0E38\u0E13\u0E08\u0E30\u0E44\u0E14\u0E49\u0E23\u0E31\u0E1A\u0E2A\u0E34\u0E17\u0E18\u0E34\u0E4C\u0E01\u0E32\u0E23\u0E40\u0E02\u0E49\u0E32\u0E16\u0E36\u0E07 Confluence \u0E1C\u0E39\u0E49\u0E14\u0E39\u0E41\u0E25\u0E40\u0E27\u0E47\u0E1A\u0E44\u0E0B\u0E15\u0E4C\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E44\u0E14\u0E49\u0E2D\u0E19\u0E38\u0E21\u0E31\u0E15\u0E34\u0E04\u0E38\u0E13\u0E41\u0E25\u0E49\u0E27",
    'project-pages.cross-join.errors.unknown-error.description': "{contactSupport} \u0E2B\u0E32\u0E01\u0E01\u0E32\u0E23\u0E23\u0E35\u0E40\u0E1F\u0E23\u0E0A\u0E22\u0E31\u0E07\u0E44\u0E21\u0E48\u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E41\u0E01\u0E49\u0E44\u0E02\u0E1B\u0E31\u0E0D\u0E2B\u0E32\u0E44\u0E14\u0E49",
    'project-pages.cross-join.errors.unknown-error.title': "\u0E40\u0E23\u0E32\u0E44\u0E21\u0E48\u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E41\u0E2A\u0E14\u0E07\u0E2B\u0E19\u0E49\u0E32\u0E42\u0E1B\u0E23\u0E40\u0E08\u0E01\u0E15\u0E4C\u0E44\u0E14\u0E49\u0E43\u0E19\u0E02\u0E13\u0E30\u0E19\u0E35\u0E49",
    'project-pages.cross-join.inline-join-product.button': "\u0E04\u0E38\u0E13\u0E08\u0E30\u0E44\u0E14\u0E49\u0E23\u0E31\u0E1A\u0E2A\u0E34\u0E17\u0E18\u0E34\u0E4C\u0E01\u0E32\u0E23\u0E40\u0E02\u0E49\u0E32\u0E16\u0E36\u0E07 Confluence \u0E1C\u0E39\u0E49\u0E14\u0E39\u0E41\u0E25\u0E40\u0E27\u0E47\u0E1A\u0E44\u0E0B\u0E15\u0E4C\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E44\u0E14\u0E49\u0E2D\u0E19\u0E38\u0E21\u0E31\u0E15\u0E34\u0E04\u0E38\u0E13\u0E41\u0E25\u0E49\u0E27",
    'project-pages.cross-join.inline-join-product.connected.description': "\u0E14\u0E39 \u0E41\u0E01\u0E49\u0E44\u0E02 \u0E41\u0E25\u0E30\u0E08\u0E31\u0E14\u0E17\u0E33\u0E40\u0E2D\u0E01\u0E2A\u0E32\u0E23\u0E1B\u0E23\u0E30\u0E01\u0E2D\u0E1A\u0E08\u0E32\u0E01\u0E17\u0E35\u0E48\u0E40\u0E14\u0E35\u0E22\u0E27",
    'project-pages.cross-join.inline-join-product.connected.title': "\u0E17\u0E33\u0E07\u0E32\u0E19\u0E23\u0E48\u0E27\u0E21\u0E01\u0E31\u0E19\u0E1A\u0E19\u0E2B\u0E19\u0E49\u0E32\u0E42\u0E1B\u0E23\u0E40\u0E08\u0E01\u0E15\u0E4C\u0E01\u0E31\u0E1A\u0E17\u0E35\u0E21\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13",
    'project-pages.cross-join.pending-request.templates.subtitle': "\u0E1C\u0E39\u0E49\u0E14\u0E39\u0E41\u0E25\u0E23\u0E30\u0E1A\u0E1A\u0E02\u0E2D\u0E07\u0E40\u0E27\u0E47\u0E1A\u0E44\u0E0B\u0E15\u0E4C\u0E44\u0E14\u0E49\u0E23\u0E31\u0E1A\u0E04\u0E33\u0E02\u0E2D\u0E43\u0E19\u0E01\u0E32\u0E23\u0E40\u0E02\u0E49\u0E32\u0E23\u0E48\u0E27\u0E21 Confluence \u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13 \u0E2B\u0E32\u0E01\u0E04\u0E38\u0E13\u0E44\u0E14\u0E49\u0E23\u0E31\u0E1A\u0E01\u0E32\u0E23\u0E2D\u0E19\u0E38\u0E21\u0E31\u0E15\u0E34\u0E43\u0E2B\u0E49\u0E40\u0E02\u0E49\u0E32\u0E23\u0E48\u0E27\u0E21\u0E41\u0E25\u0E49\u0E27 \u0E2B\u0E19\u0E49\u0E32\u0E42\u0E1B\u0E23\u0E40\u0E08\u0E01\u0E15\u0E4C\u0E08\u0E30\u0E40\u0E23\u0E34\u0E48\u0E21\u0E17\u0E33\u0E07\u0E32\u0E19\u0E41\u0E25\u0E30\u0E40\u0E23\u0E32\u0E08\u0E30\u0E2A\u0E48\u0E07\u0E2D\u0E35\u0E40\u0E21\u0E25\u0E22\u0E37\u0E19\u0E22\u0E31\u0E19\u0E43\u0E2B\u0E49\u0E04\u0E38\u0E13",
    'project-pages.cross-join.pending-request.templates.subtitle.experiment': '\u0E04\u0E38\u0E13\u0E08\u0E30\u0E44\u0E14\u0E49\u0E23\u0E31\u0E1A\u0E2D\u0E35\u0E40\u0E21\u0E25\u0E1E\u0E23\u0E49\u0E2D\u0E21\u0E2A\u0E34\u0E17\u0E18\u0E34\u0E4C\u0E40\u0E02\u0E49\u0E32\u0E16\u0E36\u0E07 "\u0E2B\u0E19\u0E49\u0E32\u0E42\u0E1B\u0E23\u0E40\u0E08\u0E01\u0E15\u0E4C" \u0E40\u0E21\u0E37\u0E48\u0E2D\u0E04\u0E38\u0E13\u0E44\u0E14\u0E49\u0E23\u0E31\u0E1A\u0E01\u0E32\u0E23\u0E2D\u0E19\u0E38\u0E21\u0E31\u0E15\u0E34\u0E41\u0E25\u0E49\u0E27',
    'project-pages.cross-join.pending-request.templates.title': "\u0E04\u0E38\u0E13\u0E44\u0E14\u0E49\u0E2A\u0E48\u0E07\u0E04\u0E33\u0E02\u0E2D\u0E01\u0E32\u0E23\u0E40\u0E02\u0E49\u0E32\u0E16\u0E36\u0E07 Confluence \u0E41\u0E25\u0E49\u0E27",
    'project-pages.cross-join.pending-request.templates.title.experiment': "\u0E2A\u0E48\u0E07\u0E04\u0E33\u0E02\u0E2D\u0E01\u0E32\u0E23\u0E40\u0E02\u0E49\u0E32\u0E16\u0E36\u0E07\u0E44\u0E1B\u0E22\u0E31\u0E07\u0E1C\u0E39\u0E49\u0E14\u0E39\u0E41\u0E25\u0E23\u0E30\u0E1A\u0E1A\u0E41\u0E25\u0E49\u0E27",
    'project-pages.cross-join.request-access-without-better-together.connected.description': "\u0E14\u0E39 \u0E41\u0E01\u0E49\u0E44\u0E02 \u0E41\u0E25\u0E30\u0E08\u0E31\u0E14\u0E17\u0E33\u0E40\u0E2D\u0E01\u0E2A\u0E32\u0E23\u0E1B\u0E23\u0E30\u0E01\u0E2D\u0E1A\u0E42\u0E1B\u0E23\u0E40\u0E08\u0E01\u0E15\u0E4C\u0E01\u0E31\u0E1A\u0E17\u0E35\u0E21\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13",
    'project-pages.cross-join.request-access.button': "\u0E2A\u0E48\u0E07\u0E04\u0E33\u0E02\u0E2D\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E40\u0E02\u0E49\u0E32\u0E16\u0E36\u0E07",
    'project-pages.cross-join.request-access.button-subtitle.experimental': "\u0E40\u0E21\u0E37\u0E48\u0E2D\u0E04\u0E38\u0E13\u0E40\u0E25\u0E37\u0E2D\u0E01 '\u0E40\u0E02\u0E49\u0E32\u0E23\u0E48\u0E27\u0E21\u0E17\u0E35\u0E21\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13' \u0E04\u0E38\u0E13\u0E01\u0E33\u0E25\u0E31\u0E07\u0E02\u0E2D\u0E40\u0E02\u0E49\u0E32\u0E23\u0E48\u0E27\u0E21 Confluence \u0E41\u0E25\u0E30\u0E22\u0E34\u0E19\u0E22\u0E2D\u0E21\u0E17\u0E35\u0E48\u0E08\u0E30\u0E41\u0E1A\u0E48\u0E07\u0E1B\u0E31\u0E19\u0E42\u0E1B\u0E23\u0E44\u0E1F\u0E25\u0E4C Atlassian \u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E01\u0E31\u0E1A\u0E1C\u0E39\u0E49\u0E14\u0E39\u0E41\u0E25\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13",
    'project-pages.cross-join.request-access.button.experimental': "\u0E40\u0E02\u0E49\u0E32\u0E23\u0E48\u0E27\u0E21\u0E17\u0E35\u0E21\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13",
    'project-pages.cross-join.request-access.connected.description.experimental': '\u0E17\u0E35\u0E21\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E01\u0E33\u0E25\u0E31\u0E07\u0E43\u0E0A\u0E49 "\u0E2B\u0E19\u0E49\u0E32\u0E42\u0E1B\u0E23\u0E40\u0E08\u0E01\u0E15\u0E4C" \u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E41\u0E2A\u0E14\u0E07\u0E04\u0E27\u0E32\u0E21\u0E04\u0E34\u0E14\u0E40\u0E2B\u0E47\u0E19 \u0E41\u0E01\u0E49\u0E44\u0E02 \u0E41\u0E25\u0E30\u0E17\u0E33\u0E07\u0E32\u0E19\u0E23\u0E48\u0E27\u0E21\u0E01\u0E31\u0E19\u0E1A\u0E19\u0E40\u0E2D\u0E01\u0E2A\u0E32\u0E23\u0E1B\u0E23\u0E30\u0E01\u0E2D\u0E1A\u0E42\u0E1B\u0E23\u0E40\u0E08\u0E01\u0E15\u0E4C\u0E42\u0E14\u0E22\u0E44\u0E21\u0E48\u0E15\u0E49\u0E2D\u0E07\u0E2D\u0E2D\u0E01\u0E08\u0E32\u0E01 Jira \u0E40\u0E02\u0E49\u0E32\u0E23\u0E48\u0E27\u0E21 Confluence \u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E40\u0E02\u0E49\u0E32\u0E16\u0E36\u0E07 "\u0E2B\u0E19\u0E49\u0E32\u0E42\u0E1B\u0E23\u0E40\u0E08\u0E01\u0E15\u0E4C" \u0E02\u0E2D\u0E07\u0E17\u0E35\u0E21\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13',
    'project-pages.cross-join.request-access.title': "\u0E2B\u0E19\u0E49\u0E32\u0E42\u0E1B\u0E23\u0E40\u0E08\u0E01\u0E15\u0E4C\u0E15\u0E49\u0E2D\u0E07\u0E01\u0E32\u0E23\u0E2A\u0E34\u0E17\u0E18\u0E34\u0E4C\u0E01\u0E32\u0E23\u0E40\u0E02\u0E49\u0E32\u0E16\u0E36\u0E07 Confluence",
    'project-pages.cross-join.request-access.title.experiment': "\u0E2A\u0E23\u0E49\u0E32\u0E07\u0E41\u0E2B\u0E25\u0E48\u0E07\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E08\u0E23\u0E34\u0E07\u0E40\u0E1E\u0E35\u0E22\u0E07\u0E41\u0E2B\u0E25\u0E48\u0E07\u0E40\u0E14\u0E35\u0E22\u0E27\u0E2A\u0E33\u0E2B\u0E23\u0E31\u0E1A\u0E17\u0E35\u0E21\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13",
    'project-pages.default-contextual-heading': "\u0E2A\u0E19\u0E31\u0E1A\u0E2A\u0E19\u0E38\u0E19\u0E2B\u0E19\u0E49\u0E32\u0E42\u0E04\u0E23\u0E07\u0E01\u0E32\u0E23\u0E42\u0E14\u0E22 Confluence",
    'project-pages.default-contextual-message': "\u0E2A\u0E23\u0E49\u0E32\u0E07 \u0E41\u0E0A\u0E23\u0E4C \u0E41\u0E25\u0E30\u0E17\u0E33\u0E07\u0E32\u0E19\u0E23\u0E48\u0E27\u0E21\u0E01\u0E31\u0E19\u0E1A\u0E19\u0E40\u0E2D\u0E01\u0E2A\u0E32\u0E23\u0E42\u0E1B\u0E23\u0E40\u0E08\u0E01\u0E15\u0E4C\u0E17\u0E31\u0E49\u0E07\u0E2B\u0E21\u0E14\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E43\u0E19\u0E17\u0E35\u0E48\u0E40\u0E14\u0E35\u0E22\u0E27\u0E14\u0E49\u0E27\u0E22\u0E2B\u0E19\u0E49\u0E32 Confluence",
    'project-pages.default-reactivate-CTA': "\u0E40\u0E1B\u0E34\u0E14\u0E43\u0E0A\u0E49\u0E07\u0E32\u0E19 Confluence \u0E2D\u0E35\u0E01\u0E04\u0E23\u0E31\u0E49\u0E07",
    'project-pages.default-trial-CTA': "\u0E17\u0E14\u0E25\u0E2D\u0E07\u0E43\u0E0A\u0E49 Confluence \u0E1F\u0E23\u0E35 30 \u0E27\u0E31\u0E19",
    'project-pages.draft-saved-flag.action': "\u0E40\u0E1B\u0E34\u0E14\u0E41\u0E1A\u0E1A\u0E23\u0E48\u0E32\u0E07",
    'project-pages.draft-saved-flag.description': "\u0E04\u0E38\u0E13\u0E40\u0E1B\u0E47\u0E19\u0E04\u0E19\u0E40\u0E14\u0E35\u0E22\u0E27\u0E17\u0E35\u0E48\u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E14\u0E39\u0E41\u0E1A\u0E1A\u0E23\u0E48\u0E32\u0E07\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E44\u0E14\u0E49\u0E08\u0E19\u0E01\u0E27\u0E48\u0E32\u0E04\u0E38\u0E13\u0E08\u0E30\u0E40\u0E1C\u0E22\u0E41\u0E1E\u0E23\u0E48\u0E2D\u0E2D\u0E01\u0E2A\u0E39\u0E48\u0E2A\u0E32\u0E18\u0E32\u0E23\u0E13\u0E30",
    'project-pages.draft-saved-flag.title': "\u0E1A\u0E31\u0E19\u0E17\u0E36\u0E01\u0E41\u0E1A\u0E1A\u0E23\u0E48\u0E32\u0E07\u0E41\u0E25\u0E49\u0E27",
    'project-pages.embedded-pages.create-page-error.close-button': "\u0E1B\u0E34\u0E14",
    'project-pages.embedded-pages.create-page-error.description': "\u0E21\u0E35\u0E1B\u0E31\u0E0D\u0E2B\u0E32\u0E40\u0E01\u0E34\u0E14\u0E02\u0E36\u0E49\u0E19\u0E41\u0E25\u0E30\u0E40\u0E23\u0E32\u0E44\u0E21\u0E48\u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E2A\u0E23\u0E49\u0E32\u0E07\u0E2B\u0E19\u0E49\u0E32\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E43\u0E2B\u0E49\u0E01\u0E31\u0E1A\u0E04\u0E38\u0E13\u0E44\u0E14\u0E49",
    'project-pages.embedded-pages.create-page-error.title': "\u0E40\u0E23\u0E32\u0E44\u0E21\u0E48\u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E2A\u0E23\u0E49\u0E32\u0E07\u0E2B\u0E19\u0E49\u0E32\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E44\u0E14\u0E49",
    'project-pages.embedded-pages.create-page-error.try-again-button': "\u0E25\u0E2D\u0E07\u0E2D\u0E35\u0E01\u0E04\u0E23\u0E31\u0E49\u0E07",
    'project-pages.embedded-pages.modal.close.button.hint': "\u0E1B\u0E34\u0E14",
    'project-pages.embedded-pages.modal.title.button': "\u0E40\u0E1B\u0E34\u0E14\u0E43\u0E19 Confluence",
    'project-pages.embedded-pages.modal.title.button.hint': "\u0E40\u0E1B\u0E34\u0E14\u0E43\u0E19\u0E41\u0E16\u0E1A\u0E43\u0E2B\u0E21\u0E48",
    'project-pages.errors.unknown-error.description.non-final': "{contactSupport} \u0E2B\u0E32\u0E01\u0E01\u0E32\u0E23\u0E23\u0E35\u0E40\u0E1F\u0E23\u0E0A\u0E22\u0E31\u0E07\u0E44\u0E21\u0E48\u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E41\u0E01\u0E49\u0E44\u0E02\u0E1B\u0E31\u0E0D\u0E2B\u0E32\u0E44\u0E14\u0E49",
    'project-pages.errors.unknown-error.title.non-final': "\u0E40\u0E23\u0E32\u0E44\u0E21\u0E48\u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E41\u0E2A\u0E14\u0E07\u0E2B\u0E19\u0E49\u0E32\u0E42\u0E1B\u0E23\u0E40\u0E08\u0E01\u0E15\u0E4C\u0E44\u0E14\u0E49\u0E43\u0E19\u0E02\u0E13\u0E30\u0E19\u0E35\u0E49",
    'project-pages.generic-error.button.reload': "\u0E42\u0E2B\u0E25\u0E14\u0E2B\u0E19\u0E49\u0E32\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E2D\u0E35\u0E01\u0E04\u0E23\u0E31\u0E49\u0E07",
    'project-pages.generic-error.description': "\u0E40\u0E01\u0E34\u0E14\u0E02\u0E49\u0E2D\u0E1C\u0E34\u0E14\u0E1E\u0E25\u0E32\u0E14\u0E1A\u0E32\u0E07\u0E2D\u0E22\u0E48\u0E32\u0E07 \u0E42\u0E1B\u0E23\u0E14\u0E25\u0E2D\u0E07\u0E2D\u0E35\u0E01\u0E04\u0E23\u0E31\u0E49\u0E07\u0E43\u0E19\u0E20\u0E32\u0E22\u0E2B\u0E25\u0E31\u0E07",
    'project-pages.generic-error.description.non-final': "\u0E40\u0E01\u0E34\u0E14\u0E02\u0E49\u0E2D\u0E1C\u0E34\u0E14\u0E1E\u0E25\u0E32\u0E14\u0E1A\u0E32\u0E07\u0E2D\u0E22\u0E48\u0E32\u0E07 \u0E42\u0E1B\u0E23\u0E14\u0E25\u0E2D\u0E07\u0E2D\u0E35\u0E01\u0E04\u0E23\u0E31\u0E49\u0E07\u0E43\u0E19\u0E20\u0E32\u0E22\u0E2B\u0E25\u0E31\u0E07",
    'project-pages.generic-error.heading': "\u0E41\u0E22\u0E48\u0E08\u0E31\u0E07",
    'project-pages.generic-error.title.non-final': "\u0E41\u0E22\u0E48\u0E08\u0E31\u0E07",
    'project-pages.generic-info-flag.description': "\u0E21\u0E35\u0E02\u0E49\u0E2D\u0E1C\u0E34\u0E14\u0E1E\u0E25\u0E32\u0E14\u0E1A\u0E32\u0E07\u0E1B\u0E23\u0E30\u0E01\u0E32\u0E23 \u0E42\u0E1B\u0E23\u0E14\u0E25\u0E2D\u0E07\u0E2D\u0E35\u0E01\u0E04\u0E23\u0E31\u0E49\u0E07\u0E2B\u0E23\u0E37\u0E2D\u0E15\u0E34\u0E14\u0E15\u0E48\u0E2D\u0E1D\u0E48\u0E32\u0E22\u0E2A\u0E19\u0E31\u0E1A\u0E2A\u0E19\u0E38\u0E19\u0E2B\u0E32\u0E01\u0E1B\u0E31\u0E0D\u0E2B\u0E32\u0E22\u0E31\u0E07\u0E04\u0E07\u0E21\u0E35\u0E2D\u0E22\u0E39\u0E48",
    'project-pages.generic-success-flag.description.live-doc': "\u0E40\u0E0A\u0E37\u0E48\u0E2D\u0E21\u0E15\u0E48\u0E2D\u0E01\u0E31\u0E1A\u0E40\u0E2D\u0E01\u0E2A\u0E32\u0E23\u0E17\u0E33\u0E07\u0E32\u0E19\u0E41\u0E25\u0E30\u0E41\u0E01\u0E49\u0E44\u0E02\u0E2A\u0E14 {connectedSpaceOrPageName} \u0E40\u0E23\u0E35\u0E22\u0E1A\u0E23\u0E49\u0E2D\u0E22\u0E41\u0E25\u0E49\u0E27",
    'project-pages.generic-success-flag.description.page': "\u0E40\u0E0A\u0E37\u0E48\u0E2D\u0E21\u0E15\u0E48\u0E2D\u0E2B\u0E19\u0E49\u0E32\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25 {connectedSpaceOrPageName} \u0E2A\u0E33\u0E40\u0E23\u0E47\u0E08\u0E41\u0E25\u0E49\u0E27",
    'project-pages.generic-success-flag.description.space': "\u0E40\u0E0A\u0E37\u0E48\u0E2D\u0E21\u0E15\u0E48\u0E2D\u0E01\u0E31\u0E1A\u0E1E\u0E37\u0E49\u0E19\u0E17\u0E35\u0E48 {connectedSpaceOrPageName} \u0E2A\u0E33\u0E40\u0E23\u0E47\u0E08\u0E41\u0E25\u0E49\u0E27",
    'project-pages.generic-success-flag.heading.live-doc': "\u0E40\u0E0A\u0E37\u0E48\u0E2D\u0E21\u0E15\u0E48\u0E2D\u0E40\u0E2D\u0E01\u0E2A\u0E32\u0E23\u0E17\u0E33\u0E07\u0E32\u0E19\u0E41\u0E25\u0E30\u0E41\u0E01\u0E49\u0E44\u0E02\u0E2A\u0E14\u0E41\u0E25\u0E49\u0E27",
    'project-pages.generic-success-flag.heading.page': "\u0E40\u0E0A\u0E37\u0E48\u0E2D\u0E21\u0E15\u0E48\u0E2D\u0E2B\u0E19\u0E49\u0E32\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E41\u0E25\u0E49\u0E27",
    'project-pages.generic-success-flag.heading.space': "\u0E40\u0E0A\u0E37\u0E48\u0E2D\u0E21\u0E15\u0E48\u0E2D\u0E1E\u0E37\u0E49\u0E19\u0E17\u0E35\u0E48\u0E41\u0E25\u0E49\u0E27",
    'project-pages.granular-pages.connect-space-dialog.content.create-space-link.link-text': "\u0E2B\u0E23\u0E37\u0E2D\u0E2A\u0E23\u0E49\u0E32\u0E07\u0E1E\u0E37\u0E49\u0E19\u0E17\u0E35\u0E48\u0E43\u0E2B\u0E21\u0E48",
    'project-pages.granular-pages.connect-space.button': "\u0E40\u0E0A\u0E37\u0E48\u0E2D\u0E21\u0E15\u0E48\u0E2D Confluence",
    'project-pages.granular-pages.connect-space.heading': "\u0E40\u0E0A\u0E37\u0E48\u0E2D\u0E21\u0E15\u0E48\u0E2D\u0E42\u0E1B\u0E23\u0E40\u0E08\u0E01\u0E15\u0E4C\u0E19\u0E35\u0E49\u0E01\u0E31\u0E1A\u0E1E\u0E37\u0E49\u0E19\u0E17\u0E35\u0E48 Confluence \u0E2B\u0E23\u0E37\u0E2D\u0E23\u0E32\u0E22\u0E01\u0E32\u0E23",
    'project-pages.improvement.contact-support': "\u0E15\u0E34\u0E14\u0E15\u0E48\u0E2D\u0E1D\u0E48\u0E32\u0E22\u0E2A\u0E19\u0E31\u0E1A\u0E2A\u0E19\u0E38\u0E19",
    'project-pages.improvement.errors.access-error.description': "\u0E25\u0E2D\u0E07\u0E15\u0E34\u0E14\u0E15\u0E48\u0E2D\u0E1C\u0E39\u0E49\u0E14\u0E39\u0E41\u0E25\u0E23\u0E30\u0E1A\u0E1A\u0E40\u0E27\u0E47\u0E1A\u0E44\u0E0B\u0E15\u0E4C\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E02\u0E2D\u0E2A\u0E34\u0E17\u0E18\u0E34\u0E4C\u0E01\u0E32\u0E23\u0E40\u0E02\u0E49\u0E32\u0E16\u0E36\u0E07",
    'project-pages.improvement.errors.access-error.title': "\u0E04\u0E38\u0E13\u0E44\u0E21\u0E48\u0E21\u0E35\u0E2A\u0E34\u0E17\u0E18\u0E34\u0E4C\u0E43\u0E19\u0E01\u0E32\u0E23\u0E14\u0E39\u0E2B\u0E19\u0E49\u0E32\u0E42\u0E1B\u0E23\u0E40\u0E08\u0E01\u0E15\u0E4C",
    'project-pages.improvement.errors.page-tree-unknown-error.description': "\u0E40\u0E01\u0E34\u0E14\u0E02\u0E49\u0E2D\u0E1C\u0E34\u0E14\u0E1E\u0E25\u0E32\u0E14\u0E1A\u0E32\u0E07\u0E1B\u0E23\u0E30\u0E01\u0E32\u0E23\u0E02\u0E13\u0E30\u0E01\u0E33\u0E25\u0E31\u0E07\u0E1E\u0E22\u0E32\u0E22\u0E32\u0E21\u0E41\u0E2A\u0E14\u0E07\u0E2B\u0E19\u0E49\u0E32\u0E08\u0E32\u0E01\u0E1E\u0E37\u0E49\u0E19\u0E17\u0E35\u0E48 Confluence \u0E17\u0E35\u0E48\u0E40\u0E0A\u0E37\u0E48\u0E2D\u0E21\u0E15\u0E48\u0E2D\u0E41\u0E25\u0E49\u0E27\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13 {contactSupport} \u0E2B\u0E32\u0E01\u0E01\u0E32\u0E23\u0E23\u0E35\u0E40\u0E1F\u0E23\u0E0A\u0E22\u0E31\u0E07\u0E44\u0E21\u0E48\u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E41\u0E01\u0E49\u0E44\u0E02\u0E1B\u0E31\u0E0D\u0E2B\u0E32\u0E44\u0E14\u0E49",
    'project-pages.improvement.errors.page-tree-unknown-error.title': "\u0E40\u0E23\u0E32\u0E01\u0E33\u0E25\u0E31\u0E07\u0E21\u0E35\u0E1B\u0E31\u0E0D\u0E2B\u0E32\u0E43\u0E19\u0E01\u0E32\u0E23\u0E41\u0E2A\u0E14\u0E07\u0E2B\u0E19\u0E49\u0E32\u0E42\u0E1B\u0E23\u0E40\u0E08\u0E01\u0E15\u0E4C",
    'project-pages.improvement.errors.space-or-page-not-found.description': "\u0E1E\u0E37\u0E49\u0E19\u0E17\u0E35\u0E48 Confluence \u0E2B\u0E23\u0E37\u0E2D\u0E2B\u0E19\u0E49\u0E32\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E17\u0E35\u0E48\u0E40\u0E0A\u0E37\u0E48\u0E2D\u0E21\u0E15\u0E48\u0E2D\u0E44\u0E14\u0E49\u0E16\u0E39\u0E01\u0E22\u0E49\u0E32\u0E22 \u0E40\u0E01\u0E47\u0E1A \u0E2B\u0E23\u0E37\u0E2D\u0E25\u0E1A\u0E44\u0E1B\u0E41\u0E25\u0E49\u0E27 <link>\u0E42\u0E1B\u0E23\u0E14\u0E15\u0E34\u0E14\u0E15\u0E48\u0E2D\u0E1D\u0E48\u0E32\u0E22\u0E2A\u0E19\u0E31\u0E1A\u0E2A\u0E19\u0E38\u0E19</link> \u0E2B\u0E32\u0E01\u0E27\u0E48\u0E32\u0E01\u0E32\u0E23\u0E40\u0E0A\u0E37\u0E48\u0E2D\u0E21\u0E15\u0E48\u0E2D\u0E43\u0E2B\u0E21\u0E48\u0E44\u0E21\u0E48\u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E41\u0E01\u0E49\u0E44\u0E02\u0E1B\u0E31\u0E0D\u0E2B\u0E32\u0E44\u0E14\u0E49",
    'project-pages.improvement.errors.space-or-page-not-found.title': "\u0E44\u0E21\u0E48\u0E1E\u0E1A\u0E1E\u0E37\u0E49\u0E19\u0E17\u0E35\u0E48\u0E2B\u0E23\u0E37\u0E2D\u0E2B\u0E19\u0E49\u0E32\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25",
    'project-pages.improvement.errors.unknown-error.description': "{contactSupport} \u0E2B\u0E32\u0E01\u0E01\u0E32\u0E23\u0E23\u0E35\u0E40\u0E1F\u0E23\u0E0A\u0E22\u0E31\u0E07\u0E44\u0E21\u0E48\u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E41\u0E01\u0E49\u0E44\u0E02\u0E1B\u0E31\u0E0D\u0E2B\u0E32\u0E44\u0E14\u0E49",
    'project-pages.improvement.errors.unknown-error.title': "\u0E40\u0E23\u0E32\u0E44\u0E21\u0E48\u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E41\u0E2A\u0E14\u0E07\u0E2B\u0E19\u0E49\u0E32\u0E42\u0E1B\u0E23\u0E40\u0E08\u0E01\u0E15\u0E4C\u0E44\u0E14\u0E49\u0E43\u0E19\u0E02\u0E13\u0E30\u0E19\u0E35\u0E49",
    'project-pages.improvement.feature1': "\u0E40\u0E02\u0E49\u0E32\u0E16\u0E36\u0E07\u0E41\u0E25\u0E30\u0E2A\u0E23\u0E49\u0E32\u0E07\u0E40\u0E2D\u0E01\u0E2A\u0E32\u0E23\u0E42\u0E14\u0E22\u0E44\u0E21\u0E48\u0E15\u0E49\u0E2D\u0E07\u0E2D\u0E2D\u0E01\u0E08\u0E32\u0E01 Jira",
    'project-pages.improvement.feature2': "\u0E41\u0E21\u0E48\u0E41\u0E1A\u0E1A\u0E2A\u0E33\u0E2B\u0E23\u0E31\u0E1A\u0E01\u0E32\u0E23\u0E1B\u0E23\u0E30\u0E0A\u0E38\u0E21 \u0E41\u0E1C\u0E19\u0E04\u0E27\u0E32\u0E21\u0E40\u0E23\u0E47\u0E27\u0E43\u0E19\u0E01\u0E32\u0E23\u0E17\u0E33\u0E07\u0E32\u0E19 \u0E41\u0E25\u0E30\u0E2D\u0E35\u0E01\u0E21\u0E32\u0E01\u0E21\u0E32\u0E22",
    'project-pages.improvement.feature3': "\u0E0B\u0E34\u0E07\u0E04\u0E4C\u0E40\u0E2D\u0E01\u0E2A\u0E32\u0E23\u0E44\u0E1B\u0E22\u0E31\u0E07 Jira \u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E01\u0E32\u0E23\u0E2D\u0E31\u0E1B\u0E40\u0E14\u0E15\u0E2D\u0E31\u0E15\u0E42\u0E19\u0E21\u0E31\u0E15\u0E34",
    'project-pages.improvement.heading-info': "\u0E40\u0E01\u0E47\u0E1A\u0E23\u0E27\u0E21\u0E04\u0E27\u0E32\u0E21\u0E23\u0E39\u0E49\u0E02\u0E2D\u0E07\u0E17\u0E35\u0E21\u0E41\u0E25\u0E30\u0E1B\u0E23\u0E31\u0E1A\u0E1B\u0E23\u0E38\u0E07\u0E27\u0E34\u0E18\u0E35\u0E01\u0E32\u0E23\u0E17\u0E33\u0E07\u0E32\u0E19\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E43\u0E2B\u0E49\u0E2A\u0E33\u0E40\u0E23\u0E47\u0E08\u0E25\u0E38\u0E25\u0E48\u0E27\u0E07\u0E44\u0E14\u0E49\u0E2D\u0E22\u0E48\u0E32\u0E07\u0E21\u0E35\u0E1B\u0E23\u0E30\u0E2A\u0E34\u0E17\u0E18\u0E34\u0E20\u0E32\u0E1E",
    'project-pages.improvement.heading-info-v2': "\u0E2A\u0E23\u0E49\u0E32\u0E07\u0E17\u0E35\u0E48\u0E2A\u0E33\u0E2B\u0E23\u0E31\u0E1A\u0E23\u0E27\u0E1A\u0E23\u0E27\u0E21\u0E40\u0E2D\u0E01\u0E2A\u0E32\u0E23\u0E02\u0E2D\u0E07\u0E42\u0E1B\u0E23\u0E40\u0E08\u0E01\u0E15\u0E4C\u0E17\u0E31\u0E49\u0E07\u0E2B\u0E21\u0E14\u0E02\u0E2D\u0E07\u0E17\u0E35\u0E21\u0E44\u0E27\u0E49\u0E43\u0E19\u0E17\u0E35\u0E48\u0E40\u0E14\u0E35\u0E22\u0E27",
    'project-pages.improvement.learn-more-button': "\u0E40\u0E23\u0E35\u0E22\u0E19\u0E23\u0E39\u0E49\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E40\u0E15\u0E34\u0E21",
    'project-pages.improvement.powered-by': "\u0E2A\u0E19\u0E31\u0E1A\u0E2A\u0E19\u0E38\u0E19\u0E42\u0E14\u0E22",
    'project-pages.improvement.powered-by.tooltip': "\u0E40\u0E1B\u0E34\u0E14 Confluence \u0E43\u0E19\u0E41\u0E16\u0E1A\u0E43\u0E2B\u0E21\u0E48",
    'project-pages.improvement.preview-teaser': "\u0E1B\u0E25\u0E14\u0E25\u0E47\u0E2D\u0E01\u0E41\u0E21\u0E48\u0E41\u0E1A\u0E1A, \u0E2B\u0E19\u0E49\u0E32\u0E42\u0E1B\u0E23\u0E40\u0E08\u0E01\u0E15\u0E4C \u0E41\u0E25\u0E30\u0E2D\u0E37\u0E48\u0E19 \u0E46",
    'project-pages.improvement.provisioning-info-modal.seamlessly-update-stakeholders.description': "<p>\u0E2D\u0E31\u0E1B\u0E40\u0E14\u0E15\u0E23\u0E32\u0E22\u0E07\u0E32\u0E19\u0E42\u0E1B\u0E23\u0E40\u0E08\u0E01\u0E15\u0E4C\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E2D\u0E22\u0E39\u0E48\u0E40\u0E2A\u0E21\u0E2D\u0E14\u0E49\u0E27\u0E22\u0E01\u0E32\u0E23\u0E2D\u0E31\u0E1B\u0E40\u0E14\u0E15\u0E1B\u0E49\u0E32\u0E22\u0E01\u0E33\u0E01\u0E31\u0E1A\u0E2A\u0E16\u0E32\u0E19\u0E30\u0E42\u0E14\u0E22\u0E2D\u0E31\u0E15\u0E42\u0E19\u0E21\u0E31\u0E15\u0E34</p> <p>\u0E40\u0E1E\u0E35\u0E22\u0E07\u0E25\u0E34\u0E07\u0E01\u0E4C\u0E04\u0E33\u0E2A\u0E31\u0E48\u0E07 Jira \u0E43\u0E19\u0E40\u0E2D\u0E01\u0E2A\u0E32\u0E23 \u0E08\u0E32\u0E01\u0E19\u0E31\u0E49\u0E19\u0E23\u0E30\u0E1A\u0E1A\u0E08\u0E30\u0E41\u0E2A\u0E14\u0E07\u0E1B\u0E49\u0E32\u0E22\u0E01\u0E33\u0E01\u0E31\u0E1A\u0E2A\u0E16\u0E32\u0E19\u0E30\u0E17\u0E35\u0E48\u0E2D\u0E31\u0E1B\u0E40\u0E14\u0E15\u0E42\u0E14\u0E22\u0E0B\u0E34\u0E07\u0E04\u0E4C\u0E01\u0E31\u0E1A\u0E04\u0E33\u0E2A\u0E31\u0E48\u0E07 \u0E04\u0E38\u0E13\u0E08\u0E36\u0E07\u0E44\u0E21\u0E48\u0E15\u0E49\u0E2D\u0E07\u0E43\u0E0A\u0E49\u0E40\u0E27\u0E25\u0E32\u0E43\u0E19\u0E01\u0E32\u0E23\u0E2A\u0E23\u0E49\u0E32\u0E07\u0E23\u0E32\u0E22\u0E07\u0E32\u0E19\u0E14\u0E49\u0E27\u0E22\u0E15\u0E31\u0E27\u0E40\u0E2D\u0E07</p>",
    'project-pages.improvement.provisioning-info-modal.seamlessly-update-stakeholders.title': "\u0E2D\u0E31\u0E1B\u0E40\u0E14\u0E15\u0E1C\u0E39\u0E49\u0E21\u0E35\u0E2A\u0E48\u0E27\u0E19\u0E44\u0E14\u0E49\u0E2A\u0E48\u0E27\u0E19\u0E40\u0E2A\u0E35\u0E22\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E44\u0E14\u0E49\u0E2D\u0E22\u0E48\u0E32\u0E07\u0E23\u0E32\u0E1A\u0E23\u0E37\u0E48\u0E19",
    'project-pages.improvement.provisioning-info-modal.unify-documentation-standards.description': "<p>\u0E2A\u0E23\u0E49\u0E32\u0E07\u0E40\u0E2D\u0E01\u0E2A\u0E32\u0E23\u0E1B\u0E23\u0E30\u0E01\u0E2D\u0E1A\u0E17\u0E35\u0E48\u0E2A\u0E2D\u0E14\u0E04\u0E25\u0E49\u0E2D\u0E07\u0E01\u0E31\u0E19\u0E42\u0E14\u0E22\u0E01\u0E32\u0E23\u0E43\u0E0A\u0E49\u0E41\u0E21\u0E48\u0E41\u0E1A\u0E1A\u0E43\u0E19\u0E15\u0E31\u0E27\u0E02\u0E2D\u0E07\u0E40\u0E23\u0E32 \u0E0B\u0E36\u0E48\u0E07\u0E43\u0E0A\u0E49\u0E07\u0E32\u0E19\u0E07\u0E48\u0E32\u0E22\u0E41\u0E25\u0E30\u0E1B\u0E23\u0E31\u0E1A\u0E41\u0E15\u0E48\u0E07\u0E44\u0E14\u0E49\u0E15\u0E32\u0E21\u0E04\u0E27\u0E32\u0E21\u0E15\u0E49\u0E2D\u0E07\u0E01\u0E32\u0E23\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13</p> <p>\u0E04\u0E38\u0E13\u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E43\u0E0A\u0E49\u0E41\u0E21\u0E48\u0E41\u0E1A\u0E1A\u0E44\u0E14\u0E49\u0E42\u0E14\u0E22\u0E15\u0E23\u0E07\u0E08\u0E32\u0E01\u0E2B\u0E19\u0E49\u0E32\u0E42\u0E1B\u0E23\u0E40\u0E08\u0E01\u0E15\u0E4C \u0E04\u0E38\u0E13\u0E08\u0E36\u0E07\u0E44\u0E21\u0E48\u0E08\u0E33\u0E40\u0E1B\u0E47\u0E19\u0E15\u0E49\u0E2D\u0E07\u0E2D\u0E2D\u0E01\u0E08\u0E32\u0E01\u0E2B\u0E19\u0E49\u0E32\u0E17\u0E35\u0E48\u0E04\u0E38\u0E13\u0E17\u0E33\u0E07\u0E32\u0E19\u0E2D\u0E22\u0E39\u0E48 \u0E40\u0E23\u0E35\u0E22\u0E01\u0E14\u0E39\u0E41\u0E21\u0E48\u0E41\u0E1A\u0E1A\u0E17\u0E31\u0E49\u0E07\u0E2B\u0E21\u0E14\u0E44\u0E14\u0E49<a>\u0E17\u0E35\u0E48\u0E19\u0E35\u0E48</a></p>",
    'project-pages.improvement.provisioning-info-modal.unify-documentation-standards.title': "\u0E23\u0E27\u0E21\u0E21\u0E32\u0E15\u0E23\u0E10\u0E32\u0E19\u0E40\u0E2D\u0E01\u0E2A\u0E32\u0E23\u0E1B\u0E23\u0E30\u0E01\u0E2D\u0E1A\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E44\u0E27\u0E49\u0E14\u0E49\u0E27\u0E22\u0E01\u0E31\u0E19",
    'project-pages.improvement.provisioning-info-modal.your-project-pages-in-jira.description': "<p>\u0E2A\u0E23\u0E49\u0E32\u0E07\u0E41\u0E2B\u0E25\u0E48\u0E07\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E08\u0E23\u0E34\u0E07\u0E40\u0E1E\u0E35\u0E22\u0E07\u0E41\u0E2B\u0E25\u0E48\u0E07\u0E40\u0E14\u0E35\u0E22\u0E27\u0E2A\u0E33\u0E2B\u0E23\u0E31\u0E1A\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E2A\u0E33\u0E04\u0E31\u0E0D \u0E42\u0E14\u0E22\u0E01\u0E32\u0E23\u0E2A\u0E23\u0E49\u0E32\u0E07\u0E41\u0E25\u0E30\u0E08\u0E31\u0E14\u0E01\u0E32\u0E23\u0E40\u0E2D\u0E01\u0E2A\u0E32\u0E23\u0E1B\u0E23\u0E30\u0E01\u0E2D\u0E1A\u0E08\u0E32\u0E01\u0E41\u0E17\u0E47\u0E1A\u0E2B\u0E19\u0E49\u0E32\u0E42\u0E1B\u0E23\u0E40\u0E08\u0E01\u0E15\u0E4C\u0E43\u0E19 Jira</p> <p>\u0E04\u0E38\u0E13\u0E23\u0E39\u0E49\u0E2B\u0E23\u0E37\u0E2D\u0E44\u0E21\u0E48\u0E27\u0E48\u0E32 \u0E2B\u0E19\u0E49\u0E32\u0E42\u0E1B\u0E23\u0E40\u0E08\u0E01\u0E15\u0E4C\u0E17\u0E33\u0E07\u0E32\u0E19\u0E1A\u0E19 Confluence \u0E42\u0E14\u0E22\u0E43\u0E0A\u0E49\u0E44\u0E14\u0E49\u0E1F\u0E23\u0E35\u0E2A\u0E33\u0E2B\u0E23\u0E31\u0E1A\u0E1C\u0E39\u0E49\u0E43\u0E0A\u0E49\u0E16\u0E36\u0E07 10 \u0E23\u0E32\u0E22 \u0E40\u0E0A\u0E34\u0E0D\u0E2A\u0E21\u0E32\u0E0A\u0E34\u0E01\u0E43\u0E19\u0E17\u0E35\u0E21\u0E17\u0E35\u0E48\u0E40\u0E2B\u0E25\u0E37\u0E2D\u0E43\u0E19\u0E01\u0E32\u0E23\u0E15\u0E31\u0E49\u0E07\u0E04\u0E48\u0E32\u0E1C\u0E39\u0E49\u0E14\u0E39\u0E41\u0E25</p>",
    'project-pages.improvement.provisioning-info-modal.your-project-pages-in-jira.title': "\u0E2B\u0E19\u0E49\u0E32\u0E42\u0E1B\u0E23\u0E40\u0E08\u0E01\u0E15\u0E4C\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E42\u0E14\u0E22\u0E15\u0E23\u0E07\u0E43\u0E19 Jira",
    'project-pages.improvement.templates-sidebar.better-together-templates-header': "\u0E41\u0E21\u0E48\u0E41\u0E1A\u0E1A\u0E17\u0E35\u0E48\u0E23\u0E27\u0E21\u0E1C\u0E2A\u0E32\u0E19\u0E01\u0E31\u0E1A\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25 Jira \u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13",
    'project-pages.improvement.templates.better-together-preview-teaser': "\u0E23\u0E27\u0E21\u0E1C\u0E2A\u0E32\u0E19\u0E01\u0E31\u0E1A\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25 Jira \u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13",
    'project-pages.improvement.templates.blank-page.description': "\u0E40\u0E23\u0E34\u0E48\u0E21\u0E15\u0E49\u0E19\u0E2A\u0E23\u0E49\u0E32\u0E07\u0E2B\u0E19\u0E49\u0E32\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E08\u0E32\u0E01\u0E28\u0E39\u0E19\u0E22\u0E4C",
    'project-pages.improvement.templates.blank-page.name': "\u0E2B\u0E19\u0E49\u0E32\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E27\u0E48\u0E32\u0E07",
    'project-pages.improvement.templates.decision.description': "\u0E1A\u0E31\u0E19\u0E17\u0E36\u0E01\u0E01\u0E32\u0E23\u0E15\u0E31\u0E14\u0E2A\u0E34\u0E19\u0E43\u0E08\u0E40\u0E01\u0E35\u0E48\u0E22\u0E27\u0E01\u0E31\u0E1A\u0E42\u0E1B\u0E23\u0E40\u0E08\u0E01\u0E15\u0E4C\u0E17\u0E35\u0E48\u0E2A\u0E33\u0E04\u0E31\u0E0D\u0E41\u0E25\u0E30\u0E2A\u0E37\u0E48\u0E2D\u0E2A\u0E32\u0E23\u0E01\u0E31\u0E1A\u0E17\u0E35\u0E21\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13",
    'project-pages.improvement.templates.decision.name': "\u0E01\u0E32\u0E23\u0E15\u0E31\u0E14\u0E2A\u0E34\u0E19\u0E43\u0E08",
    'project-pages.improvement.templates.meeting-notes.description': "\u0E2A\u0E23\u0E49\u0E32\u0E07\u0E27\u0E32\u0E23\u0E30\u0E01\u0E32\u0E23\u0E1B\u0E23\u0E30\u0E0A\u0E38\u0E21 \u0E08\u0E14\u0E1A\u0E31\u0E19\u0E17\u0E36\u0E01 \u0E41\u0E25\u0E30\u0E41\u0E0A\u0E23\u0E4C\u0E23\u0E32\u0E22\u0E01\u0E32\u0E23\u0E01\u0E32\u0E23\u0E14\u0E33\u0E40\u0E19\u0E34\u0E19\u0E01\u0E32\u0E23\u0E15\u0E48\u0E32\u0E07 \u0E46 \u0E01\u0E31\u0E1A\u0E17\u0E35\u0E21\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13",
    'project-pages.improvement.templates.meeting-notes.name': "\u0E1A\u0E31\u0E19\u0E17\u0E36\u0E01\u0E01\u0E32\u0E23\u0E1B\u0E23\u0E30\u0E0A\u0E38\u0E21",
    'project-pages.improvement.templates.post-expand.more': "\u0E41\u0E21\u0E48\u0E41\u0E1A\u0E1A\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E40\u0E15\u0E34\u0E21",
    'project-pages.improvement.templates.post-expand.more.tooltip': "\u0E14\u0E39\u0E41\u0E21\u0E48\u0E41\u0E1A\u0E1A\u0E43\u0E19 Confluence",
    'project-pages.improvement.templates.post-expand.subtitle': "\u0E41\u0E21\u0E48\u0E41\u0E1A\u0E1A\u0E22\u0E2D\u0E14\u0E19\u0E34\u0E22\u0E21",
    'project-pages.improvement.templates.post-expand.title': "\u0E2A\u0E23\u0E49\u0E32\u0E07\u0E2B\u0E19\u0E49\u0E32\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25",
    'project-pages.improvement.templates.pre-expand.more': "\u0E14\u0E39\u0E41\u0E21\u0E48\u0E41\u0E1A\u0E1A\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E40\u0E15\u0E34\u0E21",
    'project-pages.improvement.templates.pre-expand.subtitle': "\u0E40\u0E1B\u0E47\u0E19\u0E17\u0E35\u0E48\u0E19\u0E34\u0E22\u0E21\u0E2A\u0E33\u0E2B\u0E23\u0E31\u0E1A\u0E17\u0E35\u0E21\u0E40\u0E0A\u0E48\u0E19\u0E04\u0E38\u0E13",
    'project-pages.improvement.templates.pre-expand.title': "\u0E14\u0E39\u0E15\u0E31\u0E27\u0E2D\u0E22\u0E48\u0E32\u0E07\u0E41\u0E21\u0E48\u0E41\u0E1A\u0E1A",
    'project-pages.improvement.templates.product-requirements.description': "\u0E23\u0E30\u0E1A\u0E38 \u0E15\u0E34\u0E14\u0E15\u0E32\u0E21 \u0E41\u0E25\u0E30\u0E01\u0E33\u0E2B\u0E19\u0E14\u0E02\u0E2D\u0E1A\u0E40\u0E02\u0E15\u0E02\u0E49\u0E2D\u0E01\u0E33\u0E2B\u0E19\u0E14\u0E2A\u0E33\u0E2B\u0E23\u0E31\u0E1A\u0E1C\u0E25\u0E34\u0E15\u0E20\u0E31\u0E13\u0E11\u0E4C\u0E2B\u0E23\u0E37\u0E2D\u0E04\u0E38\u0E13\u0E2A\u0E21\u0E1A\u0E31\u0E15\u0E34\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13",
    'project-pages.improvement.templates.product-requirements.name': "\u0E02\u0E49\u0E2D\u0E01\u0E33\u0E2B\u0E19\u0E14\u0E1C\u0E25\u0E34\u0E15\u0E20\u0E31\u0E13\u0E11\u0E4C",
    'project-pages.improvement.templates.retrospective.description': "\u0E17\u0E35\u0E48\u0E1C\u0E48\u0E32\u0E19\u0E21\u0E32\u0E40\u0E1B\u0E47\u0E19\u0E2D\u0E22\u0E48\u0E32\u0E07\u0E44\u0E23\u0E1A\u0E49\u0E32\u0E07 \u0E2A\u0E34\u0E48\u0E07\u0E43\u0E14\u0E17\u0E35\u0E48\u0E04\u0E38\u0E13\u0E04\u0E34\u0E14\u0E27\u0E48\u0E32\u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E17\u0E33\u0E44\u0E14\u0E49\u0E14\u0E35\u0E01\u0E27\u0E48\u0E32\u0E19\u0E35\u0E49 \u0E23\u0E30\u0E14\u0E21\u0E01\u0E33\u0E25\u0E31\u0E07\u0E43\u0E19\u0E01\u0E32\u0E23\u0E1E\u0E31\u0E12\u0E19\u0E32\u0E01\u0E31\u0E1A\u0E17\u0E35\u0E21\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13",
    'project-pages.improvement.templates.retrospective.name': "\u0E01\u0E32\u0E23\u0E1B\u0E23\u0E30\u0E0A\u0E38\u0E21\u0E2A\u0E23\u0E38\u0E1B",
    'project-pages.improvement.templates.template.disabled-tooltip': "\u0E40\u0E0A\u0E37\u0E48\u0E2D\u0E21\u0E15\u0E48\u0E2D\u0E1E\u0E37\u0E49\u0E19\u0E17\u0E35\u0E48 Confluence \u0E01\u0E48\u0E2D\u0E19\u0E40\u0E1B\u0E47\u0E19\u0E2D\u0E31\u0E19\u0E14\u0E31\u0E1A\u0E41\u0E23\u0E01",
    'project-pages.improvement.templates.tutorial.content.confluence-templates': "<b>\u0E1B\u0E23\u0E30\u0E2B\u0E22\u0E31\u0E14\u0E40\u0E27\u0E25\u0E32\u0E41\u0E25\u0E30\u0E25\u0E14\u0E07\u0E32\u0E19\u0E17\u0E35\u0E48\u0E15\u0E49\u0E2D\u0E07\u0E17\u0E33\u0E14\u0E49\u0E27\u0E22\u0E15\u0E31\u0E27\u0E40\u0E2D\u0E07\u0E25\u0E07\u0E44\u0E14\u0E49</b> Confluence \u0E21\u0E35<a>\u0E41\u0E21\u0E48\u0E41\u0E1A\u0E1A</a>\u0E02\u0E2D\u0E07\u0E2B\u0E19\u0E49\u0E32\u0E15\u0E48\u0E32\u0E07 \u0E46 \u0E21\u0E32\u0E01\u0E21\u0E32\u0E22 \u0E04\u0E38\u0E13\u0E08\u0E36\u0E07\u0E44\u0E21\u0E48\u0E08\u0E33\u0E40\u0E1B\u0E47\u0E19\u0E15\u0E49\u0E2D\u0E07\u0E40\u0E23\u0E34\u0E48\u0E21\u0E15\u0E49\u0E19\u0E43\u0E2B\u0E21\u0E48\u0E17\u0E31\u0E49\u0E07\u0E2B\u0E21\u0E14\u0E14\u0E49\u0E27\u0E22\u0E15\u0E31\u0E27\u0E40\u0E2D\u0E07 \u0E44\u0E21\u0E48\u0E27\u0E48\u0E32\u0E08\u0E30\u0E40\u0E1B\u0E47\u0E19\u0E40\u0E2D\u0E01\u0E2A\u0E32\u0E23\u0E17\u0E32\u0E07\u0E40\u0E17\u0E04\u0E19\u0E34\u0E04 \u0E04\u0E39\u0E48\u0E21\u0E37\u0E2D\u0E01\u0E32\u0E23\u0E41\u0E01\u0E49\u0E44\u0E02\u0E1B\u0E31\u0E0D\u0E2B\u0E32 \u0E41\u0E1C\u0E19\u0E42\u0E04\u0E23\u0E07\u0E01\u0E32\u0E23 \u0E02\u0E49\u0E2D\u0E01\u0E33\u0E2B\u0E19\u0E14\u0E02\u0E2D\u0E07\u0E1C\u0E25\u0E34\u0E15\u0E20\u0E31\u0E13\u0E11\u0E4C \u0E41\u0E25\u0E30\u0E2D\u0E37\u0E48\u0E19 \u0E46",
    'project-pages.improvement.templates.tutorial.content.edit-and-format': "<b>\u0E41\u0E01\u0E49\u0E44\u0E02\u0E41\u0E25\u0E30\u0E08\u0E31\u0E14\u0E23\u0E39\u0E1B\u0E41\u0E1A\u0E1A\u0E44\u0E14\u0E49\u0E07\u0E48\u0E32\u0E22 \u0E46</b> \u0E43\u0E0A\u0E49\u0E40\u0E21\u0E19\u0E39\u0E01\u0E32\u0E23\u0E41\u0E01\u0E49\u0E44\u0E02\u0E14\u0E49\u0E32\u0E19\u0E1A\u0E19\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E01\u0E32\u0E23\u0E08\u0E31\u0E14\u0E23\u0E39\u0E1B\u0E41\u0E1A\u0E1A\u0E21\u0E32\u0E15\u0E23\u0E10\u0E32\u0E19 \u0E41\u0E25\u0E30\u0E14\u0E49\u0E27\u0E22\u0E01\u0E32\u0E23\u0E1E\u0E34\u0E21\u0E1E\u0E4C <b>/</b> \u0E04\u0E38\u0E13\u0E01\u0E47\u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E41\u0E17\u0E23\u0E01\u0E01\u0E32\u0E23\u0E1A\u0E39\u0E23\u0E13\u0E32\u0E01\u0E32\u0E23\u0E17\u0E35\u0E48\u0E21\u0E35\u0E1B\u0E23\u0E30\u0E42\u0E22\u0E0A\u0E19\u0E4C\u0E21\u0E32\u0E01\u0E21\u0E32\u0E22\u0E44\u0E14\u0E49\u0E07\u0E48\u0E32\u0E22 \u0E46 \u0E41\u0E17\u0E23\u0E01\u0E15\u0E32\u0E23\u0E32\u0E07\u0E42\u0E14\u0E22\u0E01\u0E32\u0E23\u0E1E\u0E34\u0E21\u0E1E\u0E4C <c>/\u0E15\u0E32\u0E23\u0E32\u0E07</c> \u0E2B\u0E23\u0E37\u0E2D\u0E23\u0E39\u0E1B\u0E20\u0E32\u0E1E\u0E14\u0E49\u0E27\u0E22 <c>/\u0E23\u0E39\u0E1B\u0E20\u0E32\u0E1E</c> \u0E19\u0E2D\u0E01\u0E08\u0E32\u0E01\u0E19\u0E35\u0E49 \u0E04\u0E38\u0E13\u0E22\u0E31\u0E07\u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E41\u0E17\u0E23\u0E01\u0E25\u0E34\u0E07\u0E01\u0E4C Dropbox <c>/dropbox</c>, \u0E40\u0E04\u0E23\u0E37\u0E48\u0E2D\u0E07\u0E21\u0E37\u0E2D Microsoft Office <c>/microsoft</c> \u0E2B\u0E23\u0E37\u0E2D\u0E1A\u0E2D\u0E23\u0E4C\u0E14\u0E41\u0E25\u0E30\u0E01\u0E32\u0E23\u0E4C\u0E14 Trello <c>/trello</c> \u0E44\u0E14\u0E49\u0E2D\u0E35\u0E01\u0E14\u0E49\u0E27\u0E22",
    'project-pages.improvement.templates.tutorial.content.forward-slash-prompt': "\u0E1E\u0E34\u0E21\u0E1E\u0E4C / \u0E15\u0E32\u0E21\u0E14\u0E49\u0E27\u0E22 \u2018\u0E15\u0E32\u0E23\u0E32\u0E07\u2019 \u0E2B\u0E23\u0E37\u0E2D \u2018\u0E23\u0E39\u0E1B\u0E20\u0E32\u0E1E\u2019",
    'project-pages.improvement.templates.tutorial.content.getting-started-tips': "\u0E19\u0E35\u0E48\u0E04\u0E37\u0E2D\u0E40\u0E04\u0E25\u0E47\u0E14\u0E25\u0E31\u0E1A\u0E2A\u0E2D\u0E07\u0E1B\u0E23\u0E30\u0E01\u0E32\u0E23\u0E43\u0E19\u0E01\u0E32\u0E23\u0E40\u0E23\u0E34\u0E48\u0E21\u0E15\u0E49\u0E19\u0E43\u0E0A\u0E49\u0E07\u0E32\u0E19:",
    'project-pages.improvement.templates.tutorial.content.handy-links': "\u0E25\u0E34\u0E07\u0E01\u0E4C\u0E17\u0E35\u0E48\u0E21\u0E35\u0E1B\u0E23\u0E30\u0E42\u0E22\u0E0A\u0E19\u0E4C",
    'project-pages.improvement.templates.tutorial.content.jira-and-confluence': "\u0E43\u0E0A\u0E49 Jira \u0E41\u0E25\u0E30 Confluence \u0E23\u0E48\u0E27\u0E21\u0E01\u0E31\u0E19",
    'project-pages.improvement.templates.tutorial.content.jira-charts': "\u0E08\u0E31\u0E14\u0E17\u0E33\u0E41\u0E1C\u0E19\u0E20\u0E39\u0E21\u0E34\u0E1A\u0E19\u0E2B\u0E19\u0E49\u0E32\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E42\u0E14\u0E22\u0E43\u0E0A\u0E49\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E08\u0E23\u0E34\u0E07\u0E02\u0E2D\u0E07 Jira \u0E1E\u0E34\u0E21\u0E1E\u0E4C <c>/\u0E41\u0E1C\u0E19\u0E20\u0E39\u0E21\u0E34 Jira</c>",
    'project-pages.improvement.templates.tutorial.content.jira-links': "\u0E40\u0E0A\u0E37\u0E48\u0E2D\u0E21\u0E42\u0E22\u0E07\u0E1B\u0E31\u0E0D\u0E2B\u0E32 Jira \u0E17\u0E35\u0E48\u0E43\u0E14\u0E01\u0E47\u0E44\u0E14\u0E49\u0E1A\u0E19\u0E2B\u0E19\u0E49\u0E32\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13 \u0E25\u0E34\u0E07\u0E01\u0E4C\u0E1A\u0E19\u0E2B\u0E19\u0E49\u0E32\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E08\u0E30\u0E2D\u0E31\u0E1B\u0E40\u0E14\u0E15\u0E41\u0E1A\u0E1A\u0E40\u0E23\u0E35\u0E22\u0E25\u0E44\u0E17\u0E21\u0E4C \u0E40\u0E21\u0E37\u0E48\u0E2D\u0E04\u0E38\u0E13\u0E2D\u0E31\u0E1B\u0E40\u0E14\u0E15\u0E1B\u0E31\u0E0D\u0E2B\u0E32 Jira \u0E1E\u0E34\u0E21\u0E1E\u0E4C <c>/Jira</c>",
    'project-pages.improvement.templates.tutorial.content.jira-links-issue-term-refresh': "\u0E40\u0E0A\u0E37\u0E48\u0E2D\u0E21\u0E42\u0E22\u0E07\u0E23\u0E32\u0E22\u0E01\u0E32\u0E23\u0E15\u0E31\u0E4B\u0E27 Jira \u0E44\u0E27\u0E49\u0E17\u0E35\u0E48\u0E43\u0E14\u0E01\u0E47\u0E44\u0E14\u0E49\u0E1A\u0E19\u0E2B\u0E19\u0E49\u0E32\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13 \u0E25\u0E34\u0E07\u0E01\u0E4C\u0E1A\u0E19\u0E2B\u0E19\u0E49\u0E32\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E08\u0E30\u0E2D\u0E31\u0E1B\u0E40\u0E14\u0E15\u0E41\u0E1A\u0E1A\u0E40\u0E23\u0E35\u0E22\u0E25\u0E44\u0E17\u0E21\u0E4C \u0E40\u0E21\u0E37\u0E48\u0E2D\u0E04\u0E38\u0E13\u0E2D\u0E31\u0E1B\u0E40\u0E14\u0E15\u0E23\u0E32\u0E22\u0E01\u0E32\u0E23\u0E15\u0E31\u0E4B\u0E27 \u0E1E\u0E34\u0E21\u0E1E\u0E4C <c>/Jira</c>",
    'project-pages.improvement.templates.tutorial.content.jira-links.non-final-issue-term-refresh': "\u0E40\u0E0A\u0E37\u0E48\u0E2D\u0E21\u0E42\u0E22\u0E07\u0E15\u0E31\u0E4B\u0E27\u0E02\u0E2D\u0E07 Jira \u0E44\u0E27\u0E49\u0E17\u0E35\u0E48\u0E43\u0E14\u0E01\u0E47\u0E44\u0E14\u0E49\u0E1A\u0E19\u0E2B\u0E19\u0E49\u0E32\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13 \u0E25\u0E34\u0E07\u0E01\u0E4C\u0E1A\u0E19\u0E2B\u0E19\u0E49\u0E32\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E08\u0E30\u0E2D\u0E31\u0E1B\u0E40\u0E14\u0E15\u0E41\u0E1A\u0E1A\u0E40\u0E23\u0E35\u0E22\u0E25\u0E44\u0E17\u0E21\u0E4C \u0E40\u0E21\u0E37\u0E48\u0E2D\u0E04\u0E38\u0E13\u0E2D\u0E31\u0E1B\u0E40\u0E14\u0E15\u0E15\u0E31\u0E4B\u0E27 \u0E1E\u0E34\u0E21\u0E1E\u0E4C /Jira<c></c>",
    'project-pages.improvement.templates.tutorial.content.jira-roadmaps': "\u0E1D\u0E31\u0E07\u0E41\u0E1C\u0E19\u0E07\u0E32\u0E19\u0E41\u0E1A\u0E1A\u0E2D\u0E34\u0E19\u0E40\u0E17\u0E2D\u0E23\u0E4C\u0E41\u0E2D\u0E04\u0E17\u0E35\u0E1F\u0E41\u0E25\u0E30\u0E44\u0E17\u0E21\u0E4C\u0E44\u0E25\u0E19\u0E4C\u0E2A\u0E33\u0E2B\u0E23\u0E31\u0E1A\u0E2B\u0E19\u0E49\u0E32\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E42\u0E14\u0E22\u0E43\u0E0A\u0E49\u0E42\u0E04\u0E23\u0E07\u0E01\u0E32\u0E23 Jira \u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13 \u0E1E\u0E34\u0E21\u0E1E\u0E4C <c>/\u0E41\u0E1C\u0E19\u0E07\u0E32\u0E19 Jira</c>",
    'project-pages.improvement.templates.tutorial.content.jira-timeline': "\u0E1D\u0E31\u0E07\u0E40\u0E2A\u0E49\u0E19\u0E40\u0E27\u0E25\u0E32 (\u0E44\u0E17\u0E21\u0E4C\u0E44\u0E25\u0E19\u0E4C) \u0E41\u0E1A\u0E1A\u0E2D\u0E34\u0E19\u0E40\u0E17\u0E2D\u0E23\u0E4C\u0E41\u0E2D\u0E04\u0E17\u0E35\u0E1F\u0E2A\u0E33\u0E2B\u0E23\u0E31\u0E1A\u0E2B\u0E19\u0E49\u0E32\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E42\u0E14\u0E22\u0E43\u0E0A\u0E49\u0E42\u0E04\u0E23\u0E07\u0E01\u0E32\u0E23 Jira \u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13 \u0E1E\u0E34\u0E21\u0E1E\u0E4C <c>/jira timeline</c>",
    'project-pages.improvement.templates.tutorial.content.shipping-speed-statistic': "76% \u0E02\u0E2D\u0E07\u0E25\u0E39\u0E01\u0E04\u0E49\u0E32 Jira Software \u0E01\u0E25\u0E48\u0E32\u0E27\u0E27\u0E48\u0E32\u0E1E\u0E27\u0E01\u0E40\u0E02\u0E32\u0E2A\u0E48\u0E07\u0E21\u0E2D\u0E1A\u0E42\u0E1B\u0E23\u0E40\u0E08\u0E01\u0E15\u0E4C\u0E44\u0E14\u0E49\u0E40\u0E23\u0E47\u0E27\u0E02\u0E36\u0E49\u0E19\u0E2B\u0E25\u0E31\u0E07\u0E08\u0E32\u0E01\u0E40\u0E1E\u0E34\u0E48\u0E21 Confluence",
    'project-pages.improvement.templates.tutorial.content.shipping-speed-statistic.spork-rebranding': "76% \u0E02\u0E2D\u0E07\u0E25\u0E39\u0E01\u0E04\u0E49\u0E32 Jira \u0E01\u0E25\u0E48\u0E32\u0E27\u0E27\u0E48\u0E32\u0E1E\u0E27\u0E01\u0E40\u0E02\u0E32\u0E2A\u0E48\u0E07\u0E21\u0E2D\u0E1A\u0E42\u0E1B\u0E23\u0E40\u0E08\u0E01\u0E15\u0E4C\u0E44\u0E14\u0E49\u0E40\u0E23\u0E47\u0E27\u0E02\u0E36\u0E49\u0E19\u0E2B\u0E25\u0E31\u0E07\u0E08\u0E32\u0E01\u0E40\u0E1E\u0E34\u0E48\u0E21 Confluence",
    'project-pages.improvement.templates.tutorial.content.spaces-and-pages': "<b>\u0E01\u0E32\u0E23\u0E43\u0E0A\u0E49\u0E1E\u0E37\u0E49\u0E19\u0E17\u0E35\u0E48\u0E41\u0E25\u0E30\u0E2B\u0E19\u0E49\u0E32\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25</b> \u0E1E\u0E37\u0E49\u0E19\u0E17\u0E35\u0E48\u0E04\u0E37\u0E2D\u0E2A\u0E48\u0E27\u0E19\u0E2B\u0E19\u0E36\u0E48\u0E07\u0E02\u0E2D\u0E07\u0E44\u0E0B\u0E15\u0E4C Confluence \u0E41\u0E25\u0E30\u0E40\u0E1B\u0E47\u0E19\u0E27\u0E34\u0E18\u0E35\u0E2B\u0E19\u0E36\u0E48\u0E07\u0E43\u0E19\u0E01\u0E32\u0E23\u0E08\u0E31\u0E14\u0E41\u0E1A\u0E48\u0E07\u0E2B\u0E19\u0E49\u0E32\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E2D\u0E2D\u0E01\u0E40\u0E1B\u0E47\u0E19\u0E2B\u0E21\u0E27\u0E14\u0E2B\u0E21\u0E39\u0E48\u0E15\u0E48\u0E32\u0E07 \u0E46 \u0E43\u0E2B\u0E49\u0E04\u0E34\u0E14\u0E27\u0E48\u0E32\u0E1E\u0E37\u0E49\u0E19\u0E17\u0E35\u0E48\u0E40\u0E1B\u0E47\u0E19\u0E42\u0E1F\u0E25\u0E40\u0E14\u0E2D\u0E23\u0E4C\u0E2B\u0E23\u0E37\u0E2D\u0E42\u0E1B\u0E23\u0E40\u0E08\u0E01\u0E15\u0E4C\u0E15\u0E48\u0E32\u0E07 \u0E46 \u0E41\u0E25\u0E30\u0E2B\u0E19\u0E49\u0E32\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E40\u0E1B\u0E47\u0E19\u0E40\u0E2D\u0E01\u0E2A\u0E32\u0E23\u0E17\u0E35\u0E48\u0E2D\u0E22\u0E39\u0E48\u0E43\u0E19\u0E42\u0E1F\u0E25\u0E40\u0E14\u0E2D\u0E23\u0E4C\u0E2B\u0E23\u0E37\u0E2D\u0E42\u0E1B\u0E23\u0E40\u0E08\u0E01\u0E15\u0E4C\u0E40\u0E2B\u0E25\u0E48\u0E32\u0E19\u0E31\u0E49\u0E19 <a>\u0E40\u0E23\u0E35\u0E22\u0E19\u0E23\u0E39\u0E49\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E40\u0E15\u0E34\u0E21\u0E40\u0E01\u0E35\u0E48\u0E22\u0E27\u0E01\u0E31\u0E1A\u0E27\u0E34\u0E18\u0E35\u0E01\u0E32\u0E23\u0E43\u0E0A\u0E49\u0E1E\u0E37\u0E49\u0E19\u0E17\u0E35\u0E48</a>",
    'project-pages.improvement.templates.tutorial.content.try-it-now': "\u0E17\u0E14\u0E25\u0E2D\u0E07\u0E43\u0E0A\u0E49\u0E15\u0E2D\u0E19\u0E19\u0E35\u0E49",
    'project-pages.improvement.templates.tutorial.description': "\u0E40\u0E23\u0E35\u0E22\u0E19\u0E23\u0E39\u0E49\u0E27\u0E34\u0E18\u0E35\u0E01\u0E32\u0E23\u0E41\u0E01\u0E49\u0E44\u0E02\u0E2B\u0E19\u0E49\u0E32\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25",
    'project-pages.improvement.templates.tutorial.name': "\u0E22\u0E34\u0E19\u0E14\u0E35\u0E15\u0E49\u0E2D\u0E19\u0E23\u0E31\u0E1A\u0E2A\u0E39\u0E48\u0E2B\u0E19\u0E49\u0E32\u0E42\u0E1B\u0E23\u0E40\u0E08\u0E01\u0E15\u0E4C!",
    'project-pages.improvement.terms-and-conditions-v2': "\u0E40\u0E21\u0E37\u0E48\u0E2D\u0E40\u0E25\u0E37\u0E2D\u0E01 '\u0E25\u0E2D\u0E07\u0E43\u0E0A\u0E49\u0E40\u0E25\u0E22' \u0E2B\u0E21\u0E32\u0E22\u0E16\u0E36\u0E07\u0E04\u0E38\u0E13\u0E22\u0E2D\u0E21\u0E23\u0E31\u0E1A\u0E27\u0E48\u0E32\u0E04\u0E38\u0E13\u0E08\u0E30\u0E44\u0E14\u0E49\u0E23\u0E31\u0E1A\u0E01\u0E32\u0E23\u0E25\u0E07\u0E17\u0E30\u0E40\u0E1A\u0E35\u0E22\u0E19\u0E43\u0E19 Confluence \u0E41\u0E25\u0E30\u0E22\u0E2D\u0E21\u0E23\u0E31\u0E1A<termsLink>\u0E02\u0E49\u0E2D\u0E01\u0E33\u0E2B\u0E19\u0E14\u0E01\u0E32\u0E23\u0E43\u0E0A\u0E49\u0E1A\u0E23\u0E34\u0E01\u0E32\u0E23</termsLink> Atlassian Cloud \u0E41\u0E25\u0E30<privacyLink>\u0E19\u0E42\u0E22\u0E1A\u0E32\u0E22\u0E04\u0E27\u0E32\u0E21\u0E40\u0E1B\u0E47\u0E19\u0E2A\u0E48\u0E27\u0E19\u0E15\u0E31\u0E27</privacyLink>",
    'project-pages.improvement.title': "\u0E2B\u0E19\u0E49\u0E32\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E42\u0E1B\u0E23\u0E40\u0E08\u0E01\u0E15\u0E4C",
    'project-pages.improvement.transient-states.empty-state.auto-provisioned-create-page-button': "\u0E2A\u0E23\u0E49\u0E32\u0E07\u0E2B\u0E19\u0E49\u0E32\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25",
    'project-pages.improvement.transient-states.empty-state.auto-provisioned-description': "\u0E40\u0E23\u0E32\u0E44\u0E14\u0E49\u0E40\u0E1E\u0E34\u0E48\u0E21 Confluence \u0E41\u0E25\u0E49\u0E27\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E43\u0E2B\u0E49\u0E04\u0E38\u0E13\u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E40\u0E23\u0E34\u0E48\u0E21\u0E2A\u0E23\u0E49\u0E32\u0E07\u0E41\u0E25\u0E30\u0E40\u0E0A\u0E37\u0E48\u0E2D\u0E21\u0E42\u0E22\u0E07\u0E40\u0E2D\u0E01\u0E2A\u0E32\u0E23\u0E42\u0E1B\u0E23\u0E40\u0E08\u0E01\u0E15\u0E4C\u0E17\u0E31\u0E49\u0E07\u0E2B\u0E21\u0E14\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E44\u0E14\u0E49 \u0E1F\u0E23\u0E35\u0E2A\u0E33\u0E2B\u0E23\u0E31\u0E1A\u0E1C\u0E39\u0E49\u0E43\u0E0A\u0E49\u0E16\u0E36\u0E07 10 \u0E23\u0E32\u0E22",
    'project-pages.improvement.transient-states.empty-state.auto-provisioned-learn-more-button': "\u0E40\u0E23\u0E35\u0E22\u0E19\u0E23\u0E39\u0E49\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E40\u0E15\u0E34\u0E21",
    'project-pages.improvement.transient-states.empty-state.create-page-button': "\u0E2A\u0E23\u0E49\u0E32\u0E07\u0E2B\u0E19\u0E49\u0E32\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E41\u0E23\u0E01\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13",
    'project-pages.improvement.transient-states.empty-state.description': "\u0E2A\u0E23\u0E49\u0E32\u0E07\u0E1A\u0E31\u0E19\u0E17\u0E36\u0E01\u0E01\u0E32\u0E23\u0E1B\u0E23\u0E30\u0E0A\u0E38\u0E21 \u0E04\u0E27\u0E32\u0E21\u0E15\u0E49\u0E2D\u0E07\u0E01\u0E32\u0E23\u0E14\u0E49\u0E32\u0E19\u0E1C\u0E25\u0E34\u0E15\u0E20\u0E31\u0E13\u0E11\u0E4C \u0E01\u0E32\u0E23\u0E15\u0E31\u0E14\u0E2A\u0E34\u0E19\u0E43\u0E08 \u0E2B\u0E23\u0E37\u0E2D\u0E40\u0E19\u0E37\u0E49\u0E2D\u0E2B\u0E32\u0E2D\u0E37\u0E48\u0E19 \u0E46 \u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E14\u0E39\u0E01\u0E32\u0E23\u0E40\u0E15\u0E34\u0E21\u0E40\u0E15\u0E47\u0E21\u0E40\u0E19\u0E37\u0E49\u0E2D\u0E2B\u0E32\u0E43\u0E19\u0E1E\u0E37\u0E49\u0E19\u0E17\u0E35\u0E48\u0E19\u0E35\u0E49",
    'project-pages.improvement.transient-states.empty-state.title': "\u0E17\u0E35\u0E48\u0E19\u0E35\u0E48\u0E44\u0E21\u0E48\u0E21\u0E35\u0E2D\u0E30\u0E44\u0E23\u0E19\u0E2D\u0E01\u0E08\u0E32\u0E01\u0E04\u0E27\u0E32\u0E21\u0E40\u0E1B\u0E47\u0E19\u0E44\u0E1B\u0E44\u0E14\u0E49",
    'project-pages.improvement.try-button': "\u0E25\u0E2D\u0E07\u0E43\u0E0A\u0E49\u0E41\u0E21\u0E48\u0E41\u0E1A\u0E1A\u0E19\u0E35\u0E49\u0E43\u0E19 Confluence",
    'project-pages.improvement.try-it-now': "\u0E25\u0E2D\u0E07\u0E43\u0E0A\u0E49\u0E40\u0E25\u0E22",
    'project-pages.improvement.try-lozenge': "\u0E25\u0E2D\u0E07\u0E43\u0E0A\u0E49",
    'project-pages.improvement.try-on-demand-button': "\u0E25\u0E2D\u0E07\u0E43\u0E0A\u0E49\u0E1F\u0E23\u0E35",
    'project-pages.page-deleted-flag.title': "\u0E25\u0E1A\u0E2B\u0E19\u0E49\u0E32\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E41\u0E25\u0E49\u0E27",
    'project-pages.page-published-flag.title': "\u0E40\u0E1C\u0E22\u0E41\u0E1E\u0E23\u0E48\u0E2B\u0E19\u0E49\u0E32\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E41\u0E25\u0E49\u0E27",
    'project-pages.unknown-error.description': "{contactSupport} \u0E2B\u0E32\u0E01\u0E01\u0E32\u0E23\u0E23\u0E35\u0E40\u0E1F\u0E23\u0E0A\u0E22\u0E31\u0E07\u0E44\u0E21\u0E48\u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E41\u0E01\u0E49\u0E44\u0E02\u0E1B\u0E31\u0E0D\u0E2B\u0E32\u0E44\u0E14\u0E49",
    'project-pages.unknown-error.heading': "\u0E40\u0E23\u0E32\u0E44\u0E21\u0E48\u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E41\u0E2A\u0E14\u0E07\u0E2B\u0E19\u0E49\u0E32\u0E42\u0E1B\u0E23\u0E40\u0E08\u0E01\u0E15\u0E4C\u0E44\u0E14\u0E49\u0E43\u0E19\u0E02\u0E13\u0E30\u0E19\u0E35\u0E49"
};

});

parcelRegister("2D5sm", function(module, exports) {

$parcel$export(module.exports, "default", () => $e873c8d76cbddf45$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Turkish (Turkey)
var $e873c8d76cbddf45$export$2e2bcd8739ae039 = {
    'confluence.project-pages.improvement.provisioning-background.text': "Bu i\u015Flem bir dakikadan k\u0131sa s\xfcrer",
    'confluence.project-pages.improvement.provisioning-background.title': "Proje Sayfalar\u0131n\u0131z olu\u015Fturuluyor",
    'confluence.project-pages.improvement.provisioning-modal-carousel.controls.dismiss': 'Kapat',
    'confluence.project-pages.improvement.provisioning-modal-carousel.controls.done': "Tamamland\u0131",
    'confluence.project-pages.improvement.provisioning-modal-carousel.controls.next': "\u0130leri",
    'project-pages.activating.description': "Ba\u011Flanan Confluence alan\u0131 hen\xfcz haz\u0131r de\u011Fil. Sayfay\u0131 yenilemeniz sorunu \xe7\xf6zmezse {contactSupport}.",
    'project-pages.activating.heading': "Confluence h\xe2l\xe2 y\xfckleniyor",
    'project-pages.better-together-templates.meeting-notes.action-items-heading': "Yap\u0131lacak i\u015Flemler nelerdir?",
    'project-pages.better-together-templates.meeting-notes.agenda-item-label': "G\xfcndem \xf6\u011Fesi",
    'project-pages.better-together-templates.meeting-notes.create-a-jira-issue': "Konu olu\u015Fturmak i\xe7in /Jira yaz\u0131n",
    'project-pages.better-together-templates.meeting-notes.date-label': 'Tarih',
    'project-pages.better-together-templates.meeting-notes.discussion-topics-heading': "Tart\u0131\u015Fma konular\u0131",
    'project-pages.better-together-templates.meeting-notes.list-people': "\u015Funu kullanarak ki\u015Fileri listeleyin:",
    'project-pages.better-together-templates.meeting-notes.mention': 'bahsetme',
    'project-pages.better-together-templates.meeting-notes.mention-people-to-assign-them': "ile ki\u015Filerden bahsederek yap\u0131lacak i\u015Flemlere atay\u0131n",
    'project-pages.better-together-templates.meeting-notes.notes-label': 'Notlar',
    'project-pages.better-together-templates.meeting-notes.page-title': "Toplant\u0131 notlar\u0131",
    'project-pages.better-together-templates.meeting-notes.participants-label': "Kat\u0131l\u0131mc\u0131lar",
    'project-pages.better-together-templates.meeting-notes.project-label': 'Proje',
    'project-pages.better-together-templates.product-requirements.create-a-jira-issue': "Konu olu\u015Fturmak i\xe7in /Jira yaz\u0131n",
    'project-pages.better-together-templates.product-requirements.design-heading': "Tasar\u0131m",
    'project-pages.better-together-templates.product-requirements.embedd-different-data-views': "Jira projenizden farkl\u0131 verileri ve g\xf6r\xfcn\xfcmleri ekleyin.",
    'project-pages.better-together-templates.product-requirements.heading': "Genel bak\u0131\u015F",
    'project-pages.better-together-templates.product-requirements.how-will-you-know-if-fixed': "Bunun d\xfczeltilip d\xfczeltilmedi\u011Fi nas\u0131l anlayacaks\u0131n\u0131z?",
    'project-pages.better-together-templates.product-requirements.impact-heading': 'Etki',
    'project-pages.better-together-templates.product-requirements.inScopeStatus': 'Kapsamda',
    'project-pages.better-together-templates.product-requirements.insert-design-link': "Tasar\u0131m\u0131n\u0131z\u0131n ba\u011Flant\u0131s\u0131n\u0131 ekleyin (Figma vb.)",
    'project-pages.better-together-templates.product-requirements.jira-issue-heading': 'Jira konusu',
    'project-pages.better-together-templates.product-requirements.jira-roadmap-heading': "Jira yol haritas\u0131",
    'project-pages.better-together-templates.product-requirements.learn-how-with-smart-links': "Ak\u0131ll\u0131 ba\u011Flant\u0131larla nas\u0131l yapaca\u011F\u0131n\u0131z\u0131 \xf6\u011Frenin",
    'project-pages.better-together-templates.product-requirements.list-dashboards': "G\xf6sterge panolar\u0131n\u0131 listeleyin (Amplitude, Mode vb.)",
    'project-pages.better-together-templates.product-requirements.list-design-considerations': "Tasar\u0131m veya derleme ile ilgili g\xf6z \xf6n\xfcnde bulundurulacaklar\u0131 listeleyin",
    'project-pages.better-together-templates.product-requirements.list-people': "\u015Funu kullanarak ki\u015Fileri listeleyin:",
    'project-pages.better-together-templates.product-requirements.mention': 'bahsetme',
    'project-pages.better-together-templates.product-requirements.mention-people-to-assign-them': "ile ki\u015Filerden bahsederek yap\u0131lacak i\u015Flemlere atay\u0131n",
    'project-pages.better-together-templates.product-requirements.niceToHaveStatus': "\u0130\u015Fe yarayacaklar",
    'project-pages.better-together-templates.product-requirements.outOfScopeStatus': "Kapsam d\u0131\u015F\u0131",
    'project-pages.better-together-templates.product-requirements.page-title': "\xdcr\xfcn gereklilikleri",
    'project-pages.better-together-templates.product-requirements.pro-tip': 'Uzman ipucu:',
    'project-pages.better-together-templates.product-requirements.problem-label': 'Sorun',
    'project-pages.better-together-templates.product-requirements.requirement-heading': 'Gereklilik',
    'project-pages.better-together-templates.product-requirements.scope-heading': 'Kapsam',
    'project-pages.better-together-templates.product-requirements.success-metric': "Ba\u015Far\u0131 metri\u011Fi",
    'project-pages.better-together-templates.product-requirements.target-release-date': "Hedeflenen yay\u0131n tarihi",
    'project-pages.better-together-templates.product-requirements.team-label': "Tak\u0131m",
    'project-pages.better-together-templates.product-requirements.to-do-list-heading': "Yap\u0131lacaklar listesi",
    'project-pages.better-together-templates.product-requirements.what-are-you-trying-to-fix': "Neyi d\xfczeltmeye \xe7al\u0131\u015F\u0131yorsunuz?",
    'project-pages.better-together-templates.retro-notes.retro-heading': 'Retrospektif',
    'project-pages.better-together-templates.retro.action-items-heading': "Yap\u0131lacak i\u015Flemler nelerdir?",
    'project-pages.better-together-templates.retro.create-a-jira-issue': "Konu olu\u015Fturmak i\xe7in /Jira yaz\u0131n",
    'project-pages.better-together-templates.retro.date-label': 'Tarih',
    'project-pages.better-together-templates.retro.embed-it-here': "Tamamlad\u0131\u011F\u0131n\u0131zda buraya ekleyebilirsiniz.",
    'project-pages.better-together-templates.retro.list-people': "\u015Funu kullanarak ki\u015Fileri listeleyin:",
    'project-pages.better-together-templates.retro.mention': 'bahsetme',
    'project-pages.better-together-templates.retro.mention-people-to-assign-them': "ile ki\u015Filerden bahsederek yap\u0131lacak i\u015Flemlere atay\u0131n",
    'project-pages.better-together-templates.retro.page-title': 'Retrospektif',
    'project-pages.better-together-templates.retro.participants-label': "Kat\u0131l\u0131mc\u0131lar",
    'project-pages.better-together-templates.retro.pro-tip': 'Uzman ipucu:',
    'project-pages.better-together-templates.retro.project-label': 'Proje',
    'project-pages.better-together-templates.retro.this-is-a-whiteboard': "Bu bir Confluence beyaz tahtas\u0131.",
    'project-pages.better-together-templates.retro.use-a-whiteboard': "Retrospektifiniz i\xe7in Confluence beyaz tahtas\u0131 kullan\u0131n.",
    'project-pages.better-together-templates.retro.use-it-to-vote': "Oylama yapmak ve tak\u0131m\u0131n\u0131zla i\u015F birli\u011Fi yapmak i\xe7in bu beyaz tahtat\u0131 kullan\u0131n.",
    'project-pages.button.connect-different-space-or-page.label': "Alan veya sayfa simgesini g\xfcncelle",
    'project-pages.button.connect-different-space-or-page.tooltip': "Ba\u015Fka bir alan\u0131 veya \xf6\u011Feyi ba\u011Flay\u0131n",
    'project-pages.button.connect-space-or-page.tooltip': "Confluence'a ba\u011Flan",
    'project-pages.button.go-to-connected-live-doc.tooltip': "Canl\u0131 belgeyi Confluence'ta a\xe7\u0131n",
    'project-pages.button.go-to-connected-page.tooltip': "Sayfay\u0131 Confluence'ta a\xe7\u0131n",
    'project-pages.button.go-to-connected-space.tooltip': "Alan\u0131 Confluence'ta a\xe7\u0131n",
    'project-pages.connect-space-dialog.connection-error': "Ba\u011Flant\u0131 ba\u015Far\u0131s\u0131z oldu.",
    'project-pages.connect-space-dialog.connection-retry': 'Yeniden Dene',
    'project-pages.connect-space-dialog.content.space-or-page-selector.description': "Projenize ba\u011Flamak istedi\u011Finiz alan\u0131 veya \xf6\u011Feyi se\xe7in.",
    'project-pages.connect-space-dialog.content.space-or-page-selector.placeholder': "Confluence'ta ara",
    'project-pages.connect-space-dialog.content.space-selector.disconnected-templates-description': "\xd6\u011Fe olu\u015Fturabilmeniz i\xe7in bu projenin bir alana ba\u011Flanmas\u0131 gerekiyor. Bu projeye ba\u011Flamak i\xe7in bir alan se\xe7in.",
    'project-pages.connect-space-dialog.error-icon': 'Hata:',
    'project-pages.connect-space-dialog.footer.cancel': "\u0130ptal",
    'project-pages.connect-space-dialog.footer.connect-space': "Ba\u011Fla",
    'project-pages.connect-space-or-page-dialog.header.title': "Projeyi Confluence'a ba\u011Flay\u0131n",
    'project-pages.connect-space.description': "Alanlar, klas\xf6rlere benzer. Projenizle ilgili t\xfcm i\xe7erikleri olu\u015Fturmak, d\xfczenlemek ve bu i\xe7eriklerde i\u015F birli\u011Fi yapmak i\xe7in alanlar\u0131 kullanabilirsiniz.",
    'project-pages.connect-space.not-connected.description': "Proje sayfalar\u0131n\u0131 kullanmak i\xe7in y\xf6neticinizle veya tak\u0131m liderinizle ileti\u015Fime ge\xe7erek Confluence'\u0131 bu projeye ba\u011Flamas\u0131n\u0131 isteyin.",
    'project-pages.connect-space.not-connected.heading': "Confluence'a ba\u011Flanmam\u0131\u015F",
    'project-pages.connect-success-flag.description.content': "{connectedSpaceOrPageName} i\xe7eri\u011Fine ba\u015Far\u0131yla ba\u011Fland\u0131.",
    'project-pages.connection-error.space-or-page-not-found.button': "Ba\u015Fka bir alana veya sayfaya ba\u011Flay\u0131n",
    'project-pages.create-space-dialog.connection-error': "Ba\u011Flant\u0131 ba\u015Far\u0131s\u0131z oldu.",
    'project-pages.create-space-dialog.connection-retry': 'Yeniden Dene',
    'project-pages.create-space-dialog.content.empty-name': "L\xfctfen alan\u0131n\u0131za bir ad verin.",
    'project-pages.create-space-dialog.content.invalid-name': "Alan adlar\u0131n\u0131n en az bir harf veya rakamdan olu\u015Fmas\u0131 gerekir.",
    'project-pages.create-space-dialog.content.placeholder': "Bir alan ad\u0131 girin",
    'project-pages.create-space-dialog.creation-error': "Alan olu\u015Fturulamad\u0131.",
    'project-pages.create-space-dialog.error-icon': 'Hata:',
    'project-pages.create-space-dialog.footer.cancel': "\u0130ptal",
    'project-pages.create-space-dialog.footer.create-space': "Olu\u015Ftur",
    'project-pages.create-space-dialog.header.title': "Yeni Confluence alan\u0131 olu\u015Fturun",
    'project-pages.cross-join.access-revoked.templates.subtitle': "Y\xf6netici size Confluence eri\u015Fim izni vermedi\u011Fi i\xe7in proje sayfalar\u0131n\u0131 kullanamazs\u0131n\u0131z. Eri\u015Fim talep etmek i\xe7in site y\xf6neticinizle ileti\u015Fime ge\xe7in.",
    'project-pages.cross-join.access-revoked.templates.title': "Proje sayfalar\u0131n\u0131 kullanma izniniz yok",
    'project-pages.cross-join.avatar.view-profile': "Profili g\xf6r\xfcnt\xfcle",
    'project-pages.cross-join.denied-request.templates.subtitle': "Site y\xf6neticisi Confluence'a kat\u0131lma talebinizi reddetti\u011Fi i\xe7in proje sayfalar\u0131n\u0131 kullanamazs\u0131n\u0131z.",
    'project-pages.cross-join.denied-request.templates.title': "Y\xf6neticiniz size eri\u015Fim izni vermedi",
    'project-pages.cross-join.direct-access.button-subtitle.experimental': "Confluence'a eri\u015Fim elde edeceksiniz. Site y\xf6neticiniz sizi onaylad\u0131.",
    'project-pages.cross-join.errors.unknown-error.description': "Sayfay\u0131 yenilemeniz sorunu \xe7\xf6zmezse {contactSupport}.",
    'project-pages.cross-join.errors.unknown-error.title': "\u015Eu anda proje sayfalar\u0131 g\xf6r\xfcnt\xfclenemiyor",
    'project-pages.cross-join.inline-join-product.button': "Confluence'a eri\u015Fim elde edeceksiniz. Site y\xf6neticiniz sizi onaylad\u0131.",
    'project-pages.cross-join.inline-join-product.connected.description': "Tek yerden belge g\xf6r\xfcnt\xfcleyin, d\xfczenleyin ve olu\u015Fturun",
    'project-pages.cross-join.inline-join-product.connected.title': "Tak\u0131m\u0131n\u0131zla proje sayfalar\u0131nda i\u015F birli\u011Fi yap\u0131n",
    'project-pages.cross-join.pending-request.templates.subtitle': "Site y\xf6neticisi, Confluence'a kat\u0131lma talebinizi ald\u0131. Kat\u0131l\u0131m\u0131n\u0131z onaylan\u0131rsa proje sayfalar\u0131 \xe7al\u0131\u015Fmaya ba\u015Flar ve size bir onay e-postas\u0131 g\xf6nderilir.",
    'project-pages.cross-join.pending-request.templates.subtitle.experiment': "Onayland\u0131\u011F\u0131n\u0131zda Proje Sayfalar\u0131na eri\u015Fim i\xe7eren bir e-posta al\u0131rs\u0131n\u0131z.",
    'project-pages.cross-join.pending-request.templates.title': "Confluence'a eri\u015Fim talep ettiniz",
    'project-pages.cross-join.pending-request.templates.title.experiment': "Y\xf6neticiye eri\u015Fim talebi g\xf6nderildi",
    'project-pages.cross-join.request-access-without-better-together.connected.description': "Proje belgelerini tak\u0131m\u0131n\u0131zla birlikte g\xf6r\xfcnt\xfcleyin, d\xfczenleyin ve olu\u015Fturun",
    'project-pages.cross-join.request-access.button': "Eri\u015Fim talep edin",
    'project-pages.cross-join.request-access.button-subtitle.experimental': '"Tak\u0131m\u0131n\u0131za Kat\u0131l\u0131n"\u0131 se\xe7ti\u011Finizde Confluence\'a kat\u0131lmay\u0131 ister ve Atlassian profilinizin y\xf6neticinizle payla\u015F\u0131lmas\u0131n\u0131 kabul edersiniz.',
    'project-pages.cross-join.request-access.button.experimental': "Tak\u0131m\u0131n\u0131za kat\u0131l\u0131n",
    'project-pages.cross-join.request-access.connected.description.experimental': "Tak\u0131m\u0131n\u0131z Jira'dan ayr\u0131lmadan proje belgelerinde yorum yapmak, d\xfczenlemek ve i\u015F birli\u011Fi yapmak i\xe7in Proje Sayfalar\u0131 \xf6zelli\u011Fini kullan\u0131yor. Tak\u0131m\u0131n\u0131z\u0131n Proje Sayfalar\u0131na eri\u015Fmek i\xe7in Confluence'a kat\u0131l\u0131n.",
    'project-pages.cross-join.request-access.title': "Proje sayfalar\u0131n\u0131 kullanabilmeniz i\xe7in Confluence eri\u015Fimi gereklidir",
    'project-pages.cross-join.request-access.title.experiment': "Tak\u0131m\u0131n\u0131z i\xe7in bir bilgi kayna\u011F\u0131 olu\u015Fturun",
    'project-pages.default-contextual-heading': "Proje sayfalar\u0131 Confluence taraf\u0131ndan desteklenir",
    'project-pages.default-contextual-message': "Confluence sayfalar\u0131 sayesinde t\xfcm proje belgelerinizi tek bir yerde olu\u015Fturup payla\u015F\u0131n ve bu belgeler \xfczerinde i\u015F birli\u011Fi yap\u0131n.",
    'project-pages.default-reactivate-CTA': "Confluence'\u0131 Yeniden Etkinle\u015Ftirin",
    'project-pages.default-trial-CTA': "Confluence'\u0131 30 g\xfcn \xfccretsiz deneyin",
    'project-pages.draft-saved-flag.action': "Tasla\u011F\u0131 a\xe7\u0131n",
    'project-pages.draft-saved-flag.description': "Tasla\u011F\u0131n\u0131z\u0131 yay\u0131nlayana kadar yaln\u0131zca siz g\xf6rebilirsiniz.",
    'project-pages.draft-saved-flag.title': 'Taslak kaydedildi',
    'project-pages.embedded-pages.create-page-error.close-button': 'Kapat',
    'project-pages.embedded-pages.create-page-error.description': "Bir sorun ya\u015Fand\u0131 ve sayfa olu\u015Fturulamad\u0131.",
    'project-pages.embedded-pages.create-page-error.title': "Sayfa olu\u015Fturulamad\u0131",
    'project-pages.embedded-pages.create-page-error.try-again-button': 'Yeniden dene',
    'project-pages.embedded-pages.modal.close.button.hint': 'Kapat',
    'project-pages.embedded-pages.modal.title.button': "Confluence'ta a\xe7",
    'project-pages.embedded-pages.modal.title.button.hint': "Yeni sekmede a\xe7",
    'project-pages.errors.unknown-error.description.non-final': "Sayfay\u0131 yenilemeniz sorunu \xe7\xf6zmezse {contactSupport}.",
    'project-pages.errors.unknown-error.title.non-final': "\u015Eu anda proje sayfalar\u0131 g\xf6r\xfcnt\xfclenemiyor",
    'project-pages.generic-error.button.reload': "Sayfay\u0131 yeniden y\xfckle",
    'project-pages.generic-error.description': "Bir hata olu\u015Ftu. L\xfctfen daha sonra yeniden deneyin.",
    'project-pages.generic-error.description.non-final': "Bir hata olu\u015Ftu. L\xfctfen daha sonra yeniden deneyin.",
    'project-pages.generic-error.heading': 'Bir sorun var...',
    'project-pages.generic-error.title.non-final': 'Bir sorun var...',
    'project-pages.generic-info-flag.description': "Bir hata olu\u015Ftu. Sorun devam ederse l\xfctfen yeniden deneyin veya destek ekibiyle ileti\u015Fime ge\xe7in",
    'project-pages.generic-success-flag.description.live-doc': "{connectedSpaceOrPageName} canl\u0131 belgesine ba\u015Far\u0131yla ba\u011Fland\u0131.",
    'project-pages.generic-success-flag.description.page': "{connectedSpaceOrPageName} sayfas\u0131na ba\u015Far\u0131yla ba\u011Fland\u0131.",
    'project-pages.generic-success-flag.description.space': "{connectedSpaceOrPageName} alan\u0131na ba\u015Far\u0131yla ba\u011Fland\u0131.",
    'project-pages.generic-success-flag.heading.live-doc': "Canl\u0131 belge ba\u011Fland\u0131",
    'project-pages.generic-success-flag.heading.page': "Sayfa ba\u011Fland\u0131",
    'project-pages.generic-success-flag.heading.space': "Alan ba\u011Fland\u0131",
    'project-pages.granular-pages.connect-space-dialog.content.create-space-link.link-text': "Veya yeni bir alan olu\u015Fturun",
    'project-pages.granular-pages.connect-space.button': "Confluence'a ba\u011Flan",
    'project-pages.granular-pages.connect-space.heading': "Bu projeyi bir Confluence alan\u0131na veya \xf6\u011Fesine ba\u011Flay\u0131n",
    'project-pages.improvement.contact-support': "Destek ekibiyle ileti\u015Fime ge\xe7in",
    'project-pages.improvement.errors.access-error.description': "Eri\u015Fim talep etmek i\xe7in site y\xf6neticisiyle ileti\u015Fime ge\xe7in.",
    'project-pages.improvement.errors.access-error.title': "Proje sayfalar\u0131n\u0131 g\xf6r\xfcnt\xfcleme izniniz yok",
    'project-pages.improvement.errors.page-tree-unknown-error.description': "Ba\u011Flanan Confluence alan\u0131n\u0131zdaki sayfalar g\xf6r\xfcnt\xfclenirken bir sorun ya\u015Fand\u0131. Sayfay\u0131 yenilemeniz sorunu \xe7\xf6zmezse {contactSupport}.",
    'project-pages.improvement.errors.page-tree-unknown-error.title': "Proje sayfalar\u0131 g\xf6r\xfcnt\xfclenirken bir sorunla kar\u015F\u0131la\u015F\u0131ld\u0131",
    'project-pages.improvement.errors.space-or-page-not-found.description': "Ba\u011Flanan Confluence alan\u0131 veya sayfas\u0131 ta\u015F\u0131nm\u0131\u015F, ar\u015Fivlenmi\u015F veya silinmi\u015F. Yeniden ba\u011Flanman\u0131z sorunu \xe7\xf6zmezse <link>destek ekibiyle ileti\u015Fime ge\xe7in</link>",
    'project-pages.improvement.errors.space-or-page-not-found.title': "Alan veya sayfa bulunamad\u0131",
    'project-pages.improvement.errors.unknown-error.description': "Sayfay\u0131 yenilemeniz sorunu \xe7\xf6zmezse {contactSupport}.",
    'project-pages.improvement.errors.unknown-error.title': "\u015Eu anda proje sayfalar\u0131 g\xf6r\xfcnt\xfclenemiyor",
    'project-pages.improvement.feature1': "Jira'dan ayr\u0131lmadan belgelere eri\u015Fin ve belgeler olu\u015Fturun",
    'project-pages.improvement.feature2': "Toplant\u0131lar, sprint planlar\u0131 ve daha fazlas\u0131 i\xe7in \u015Fablonlar",
    'project-pages.improvement.feature3': "Otomatik g\xfcncellemeler i\xe7in belgeleri Jira'ya senkronize edin",
    'project-pages.improvement.heading-info': "Tak\u0131m\u0131n\u0131z\u0131n bilgilerinden yararlan\u0131n ve i\u015Flerin y\xfcr\xfct\xfclme s\xfcrecini iyile\u015Ftirin.",
    'project-pages.improvement.heading-info-v2': "Tak\u0131m\u0131n\u0131z\u0131n t\xfcm proje belgeleri i\xe7in tek bir yer olu\u015Fturun",
    'project-pages.improvement.learn-more-button': 'Daha fazla bilgi edinin',
    'project-pages.improvement.powered-by': "Sa\u011Flayan:",
    'project-pages.improvement.powered-by.tooltip': "Confluence'\u0131 yeni sekmede a\xe7ar",
    'project-pages.improvement.preview-teaser': "\u015Eablonlardan, proje sayfalar\u0131ndan ve \xe7ok daha fazlas\u0131ndan yararlan\u0131n.",
    'project-pages.improvement.provisioning-info-modal.seamlessly-update-stakeholders.description': "<p>Otomatik olarak g\xfcncellenen durum etiketleriyle proje raporlar\u0131n\u0131z\u0131 g\xfcncel tutun.</p> <p>Bir belgedeki Jira biletini ba\u011Flad\u0131\u011F\u0131n\u0131zda otomatik olarak biletle senkronize \u015Fekilde g\xfcncellenen bir durum etiketi g\xf6sterilir. B\xf6ylece raporlar\u0131 manuel olarak olu\u015Fturmakla zaman kaybetmezsiniz.</p>",
    'project-pages.improvement.provisioning-info-modal.seamlessly-update-stakeholders.title': "Payda\u015Flara sorunsuzca g\xfcncelleme g\xf6nderin",
    'project-pages.improvement.provisioning-info-modal.unify-documentation-standards.description': "<p>Yerle\u015Fik \u015Fablonlar\u0131m\u0131z\u0131 kullanarak tutarl\u0131 belgeler olu\u015Fturun. Bu \u015Fablonlar kolay kullan\u0131l\u0131r ve ihtiya\xe7lar\u0131n\u0131za g\xf6re \xf6zelle\u015Ftirilebilir.</p> <p>\u015Eablonlar\u0131 do\u011Frudan proje sayfalar\u0131ndan kullanabilirsiniz, b\xf6ylece \xfczerinde \xe7al\u0131\u015Ft\u0131\u011F\u0131n\u0131z sayfadan ayr\u0131lman\u0131z gerekmez. <a>Buradan</a> t\xfcm \u015Fablonlara g\xf6z at\u0131n.</p>",
    'project-pages.improvement.provisioning-info-modal.unify-documentation-standards.title': "Belgeleme standartlar\u0131n\u0131z\u0131 b\xfct\xfcnle\u015Ftirin",
    'project-pages.improvement.provisioning-info-modal.your-project-pages-in-jira.description': "<p>Jira'da proje sayfalar\u0131 sekmesinden belgeler olu\u015Fturarak ve bunlar\u0131 y\xf6neterek \xf6nemli bilgiler i\xe7in g\xfcvenilir bir kaynak olu\u015Fturun.</p> <p>Proje sayfalar\u0131n\u0131z\u0131n Confluence'ta da \xe7al\u0131\u015Ft\u0131\u011F\u0131n\u0131 biliyor muydunuz? \xdcstelik 10 kullan\u0131c\u0131ya kadar \xfccretsiz. Y\xf6netici ayarlar\u0131ndan tak\u0131m\u0131n\u0131z\u0131n kalan\u0131n\u0131 davet edin.</p>",
    'project-pages.improvement.provisioning-info-modal.your-project-pages-in-jira.title': "Proje sayfalar\u0131n\u0131z, do\u011Frudan Jira'da",
    'project-pages.improvement.templates-sidebar.better-together-templates-header': "Jira verilerinizle entegre edilen \u015Fablonlar",
    'project-pages.improvement.templates.better-together-preview-teaser': 'Jira verileri ile entegre',
    'project-pages.improvement.templates.blank-page.description': "En ba\u015Ftan bir sayfa olu\u015Fturun.",
    'project-pages.improvement.templates.blank-page.name': "Bo\u015F sayfa",
    'project-pages.improvement.templates.decision.description': "Projeyle ilgili \xf6nemli kararlar\u0131 kaydedin ve bunlar\u0131 tak\u0131m\u0131n\u0131zla g\xf6r\xfc\u015F\xfcn.",
    'project-pages.improvement.templates.decision.name': 'Karar',
    'project-pages.improvement.templates.meeting-notes.description': "Toplant\u0131 g\xfcndemleri olu\u015Fturun, not tutun ve yap\u0131lacaklar listelerini tak\u0131m\u0131n\u0131zla payla\u015F\u0131n.",
    'project-pages.improvement.templates.meeting-notes.name': "Toplant\u0131 notlar\u0131",
    'project-pages.improvement.templates.post-expand.more': "Daha fazla \u015Fablon",
    'project-pages.improvement.templates.post-expand.more.tooltip': "Confluence'taki t\xfcm \u015Fablonlar\u0131 g\xf6r\xfcnt\xfcleyin",
    'project-pages.improvement.templates.post-expand.subtitle': "Pop\xfcler \u015Fablonlar",
    'project-pages.improvement.templates.post-expand.title': "Sayfa olu\u015Fturun",
    'project-pages.improvement.templates.pre-expand.more': "Daha fazla \u015Fablon ke\u015Ffedin",
    'project-pages.improvement.templates.pre-expand.subtitle': "Sizinkine benzer tak\u0131mlar\u0131n s\u0131k kulland\u0131\u011F\u0131 \u015Fablonlar",
    'project-pages.improvement.templates.pre-expand.title': "\u015Eablon \xf6nizlemeleri",
    'project-pages.improvement.templates.product-requirements.description': "\xdcr\xfcn\xfcn\xfcz\xfcn veya \xf6zelli\u011Fin gerekliliklerini tan\u0131mlay\u0131n, izleyin veya kapsama al\u0131n.",
    'project-pages.improvement.templates.product-requirements.name': "\xdcr\xfcn gereklilikleri",
    'project-pages.improvement.templates.retrospective.description': "Ba\u015Far\u0131l\u0131 noktalar nelerdi? Neler geli\u015Ftirilebilirdi? Geli\u015Fmeleri tak\u0131m\u0131n\u0131zla payla\u015F\u0131n.",
    'project-pages.improvement.templates.retrospective.name': 'Retrospektif',
    'project-pages.improvement.templates.template.disabled-tooltip': "\u0130lk olarak bir Confluence alan\u0131 ba\u011Flay\u0131n",
    'project-pages.improvement.templates.tutorial.content.confluence-templates': "<b>Zamandan tasarruf edin ve manuel g\xf6revleri azalt\u0131n</b>. Confluence'ta \xe7ok say\u0131da sayfa <a>\u015Fablonu</a> var, yani hi\xe7bir zaman s\u0131f\u0131rdan ba\u015Flamak zorunda de\u011Filsiniz. Teknik belgeler, sorun giderme k\u0131lavuzlar\u0131, proje planlar\u0131, \xfcr\xfcn gereksinimleri ve daha fazlas\u0131 i\xe7in \u015Fablonlar mevcut.",
    'project-pages.improvement.templates.tutorial.content.edit-and-format': "<b>Kolayl\u0131kla d\xfczenleyin ve bi\xe7imlendirin.</b> Standart s\xf6zc\xfck bi\xe7imlendirmesi i\xe7in en \xfcstteki d\xfczenleme men\xfcs\xfcn\xfc kullanabilir ve <b>/</b> yazarak \xe7ok say\u0131da kullan\u0131\u015Fl\u0131 entegrasyonu kolayl\u0131kla ekleyebilirsiniz. <c>/tablo</c> yazarak tablo ya da <c>/g\xf6rsel</c> yazarak bir g\xf6rsel ekleyebilirsiniz. Bunun yan\u0131 s\u0131ra <c>/dropbox</c> yazarak Dropbox ba\u011Flant\u0131lar\u0131, <c>/microsoft</c> yazarak Microsoft Office ara\xe7lar\u0131n\u0131 veya <c>/trello</c> yazarak Trello panolar\u0131 ve kartlar\u0131n\u0131 ekleyebilirsiniz.",
    'project-pages.improvement.templates.tutorial.content.forward-slash-prompt': '/ ve ard\u0131ndan "tablo" veya "g\xf6rsel" yaz\u0131n',
    'project-pages.improvement.templates.tutorial.content.getting-started-tips': "Ba\u015Flaman\u0131za yard\u0131mc\u0131 olacak birka\xe7 ipucu:",
    'project-pages.improvement.templates.tutorial.content.handy-links': "Kullan\u0131\u015Fl\u0131 ba\u011Flant\u0131lar",
    'project-pages.improvement.templates.tutorial.content.jira-and-confluence': "Jira ve Confluence'\u0131 birlikte kullan\u0131n",
    'project-pages.improvement.templates.tutorial.content.jira-charts': "Ger\xe7ek Jira verilerini kullanarak sayfalar\u0131n\u0131zda grafikler olu\u015Fturun <c>/Jira grafikleri</c> yaz\u0131n.",
    'project-pages.improvement.templates.tutorial.content.jira-links': "Sayfan\u0131zda herhangi bir yere Jira konusu ba\u011Flay\u0131n. Sayfadaki ba\u011Flant\u0131, Jira konusu g\xfcncellendik\xe7e ger\xe7ek zamanl\u0131 olarak g\xfcncellenir. <c>/Jira</c> yaz\u0131n.",
    'project-pages.improvement.templates.tutorial.content.jira-links-issue-term-refresh': "Sayfan\u0131zda herhangi bir yere Jira bileti ba\u011Flay\u0131n. Sayfadaki ba\u011Flant\u0131, Jira bileti g\xfcncellendik\xe7e ger\xe7ek zamanl\u0131 olarak g\xfcncellenir. <c>/Jira</c> yaz\u0131n.",
    'project-pages.improvement.templates.tutorial.content.jira-links.non-final-issue-term-refresh': "Sayfan\u0131zda herhangi bir yere Jira bileti ba\u011Flay\u0131n. Sayfadaki ba\u011Flant\u0131, Jira bileti g\xfcncellendik\xe7e ger\xe7ek zamanl\u0131 olarak g\xfcncellenir. <c>/Jira</c> yaz\u0131n.",
    'project-pages.improvement.templates.tutorial.content.jira-roadmaps': "Jira Projelerinizi kullanarak sayfan\u0131za etkile\u015Fimli yol haritalar\u0131 ve zaman \xe7izelgeleri ekleyin. <c>/Jira yol haritas\u0131</c> yaz\u0131n.",
    'project-pages.improvement.templates.tutorial.content.jira-timeline': "Jira Projelerinizi kullanarak sayfan\u0131za etkile\u015Fimli zaman \xe7izelgeleri ekleyin. <c>/jira zaman \xe7izelgesi</c> yaz\u0131n.",
    'project-pages.improvement.templates.tutorial.content.shipping-speed-statistic': "Jira Software m\xfc\u015Fterilerinin %76's\u0131, Confluence'\u0131 ekledikten sonra projeleri daha h\u0131zl\u0131 tamamlad\u0131klar\u0131n\u0131 s\xf6yl\xfcyor",
    'project-pages.improvement.templates.tutorial.content.shipping-speed-statistic.spork-rebranding': "Jira m\xfc\u015Fterilerinin %76's\u0131, Confluence'\u0131 ekledikten sonra projeleri daha h\u0131zl\u0131 tamamlad\u0131klar\u0131n\u0131 s\xf6yl\xfcyor",
    'project-pages.improvement.templates.tutorial.content.spaces-and-pages': "<b>Alan ve sayfa kullan\u0131m\u0131</b>. Alanlar t\xfcm Confluence sitelerinin bir par\xe7as\u0131d\u0131r ve sayfalar\u0131 kategoriler halinde d\xfczenlemenin bir yolunu sunar. Alanlar\u0131 farkl\u0131 klas\xf6r veya projeler gibi d\xfc\u015F\xfcn\xfcn, sayfalarsa bu klas\xf6r ya da projelere ait belgelerdir. <a>Alanlar\u0131 nas\u0131l kullanaca\u011F\u0131n\u0131z hakk\u0131nda daha fazla bilgi edinin</a>",
    'project-pages.improvement.templates.tutorial.content.try-it-now': 'Hemen deneyin',
    'project-pages.improvement.templates.tutorial.description': "Bir sayfay\u0131 nas\u0131l d\xfczenleyece\u011Finizi \xf6\u011Frenin.",
    'project-pages.improvement.templates.tutorial.name': "Proje Sayfalar\u0131na Ho\u015F Geldiniz!",
    'project-pages.improvement.terms-and-conditions-v2': "&quot;\u015Eimdi dene&quot; se\xe7ene\u011Fini belirleyerek Confluence'a kaydolaca\u011F\u0131n\u0131z\u0131 ve Atlassian <termsLink>Cloud Hizmet Ko\u015Fullar\u0131n\u0131</termsLink> ve <privacyLink>Gizlilik Politikas\u0131n\u0131</privacyLink> kabul edece\u011Finizi onaylam\u0131\u015F olursunuz.",
    'project-pages.improvement.title': "Proje sayfalar\u0131",
    'project-pages.improvement.transient-states.empty-state.auto-provisioned-create-page-button': "Sayfa olu\u015Ftur",
    'project-pages.improvement.transient-states.empty-state.auto-provisioned-description': "Confluence'\u0131 ekledik, proje belgeleri olu\u015Fturup ba\u011Flamaya ba\u015Flayabilirsiniz. 10 kullan\u0131c\u0131ya kadar \xfccretsiz.",
    'project-pages.improvement.transient-states.empty-state.auto-provisioned-learn-more-button': 'Daha fazla bilgi edinin',
    'project-pages.improvement.transient-states.empty-state.create-page-button': "\u0130lk sayfan\u0131z\u0131 olu\u015Fturun",
    'project-pages.improvement.transient-states.empty-state.description': "Bu alan\u0131 doldurmak i\xe7in toplant\u0131 notlar\u0131, \xfcr\xfcn gereklilikleri, kararlar veya ba\u015Fka i\xe7erikler olu\u015Fturun.",
    'project-pages.improvement.transient-states.empty-state.title': "Bu sayfada hen\xfcz i\xe7erik yok",
    'project-pages.improvement.try-button': "Bu \u015Fablonu Confluence'ta deneyin",
    'project-pages.improvement.try-it-now': 'Hemen deneyin',
    'project-pages.improvement.try-lozenge': 'Deneyin',
    'project-pages.improvement.try-on-demand-button': "\xdccretsiz dene",
    'project-pages.page-deleted-flag.title': 'Sayfa silindi.',
    'project-pages.page-published-flag.title': "Sayfan\u0131z yay\u0131nland\u0131.",
    'project-pages.unknown-error.description': "Sayfay\u0131 yenilemeniz sorunu \xe7\xf6zmezse {contactSupport}.",
    'project-pages.unknown-error.heading': "\u015Eu anda proje sayfalar\u0131 g\xf6r\xfcnt\xfclenemiyor"
};

});

parcelRegister("abibY", function(module, exports) {

$parcel$export(module.exports, "default", () => $f751dd63b4aad5ea$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Ukrainian (Ukraine)
var $f751dd63b4aad5ea$export$2e2bcd8739ae039 = {
    'confluence.project-pages.improvement.provisioning-background.text': "\u041F\u0440\u043E\u0446\u0435\u0441 \u0437\u0430\u0439\u043C\u0430\u0454 \u043C\u0435\u043D\u0448\u0435 \u0445\u0432\u0438\u043B\u0438\u043D\u0438",
    'confluence.project-pages.improvement.provisioning-background.title': "\u041D\u0430\u043B\u0430\u0448\u0442\u0443\u0432\u0430\u043D\u043D\u044F Project Pages",
    'confluence.project-pages.improvement.provisioning-modal-carousel.controls.dismiss': "\u0417\u0430\u043A\u0440\u0438\u0442\u0438",
    'confluence.project-pages.improvement.provisioning-modal-carousel.controls.done': "\u0413\u043E\u0442\u043E\u0432\u043E",
    'confluence.project-pages.improvement.provisioning-modal-carousel.controls.next': "\u0414\u0430\u043B\u0456",
    'project-pages.activating.description': "\u041F\u0456\u0434\u043A\u043B\u044E\u0447\u0435\u043D\u0438\u0439 \u0440\u043E\u0437\u0434\u0456\u043B Confuence \u0449\u0435 \u043D\u0435 \u0433\u043E\u0442\u043E\u0432\u0438\u0439. \u042F\u043A\u0449\u043E \u043E\u043D\u043E\u0432\u043B\u0435\u043D\u043D\u044F \u0441\u0442\u043E\u0440\u0456\u043D\u043A\u0438 \u043D\u0435 \u0432\u0438\u0440\u0456\u0448\u0443\u0454 \u043F\u0440\u043E\u0431\u043B\u0435\u043C\u0443, {contactSupport}.",
    'project-pages.activating.heading': "Confluence \u0449\u0435 \u0437\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0443\u0454\u0442\u044C\u0441\u044F",
    'project-pages.better-together-templates.meeting-notes.action-items-heading': "\u042F\u043A\u0456 \u043F\u0443\u043D\u043A\u0442\u0438 \u0437\u0430\u0432\u0434\u0430\u043D\u043D\u044F?",
    'project-pages.better-together-templates.meeting-notes.agenda-item-label': "\u041F\u0443\u043D\u043A\u0442 \u043F\u043E\u0440\u044F\u0434\u043A\u0443 \u0434\u0435\u043D\u043D\u043E\u0433\u043E",
    'project-pages.better-together-templates.meeting-notes.create-a-jira-issue': "\u0412\u0432\u0435\u0434\u0456\u0442\u044C \xab/Jira\xbb, \u0449\u043E\u0431 \u0441\u0442\u0432\u043E\u0440\u0438\u0442\u0438 \u0437\u0430\u0432\u0434\u0430\u043D\u043D\u044F",
    'project-pages.better-together-templates.meeting-notes.date-label': "\u0414\u0430\u0442\u0430",
    'project-pages.better-together-templates.meeting-notes.discussion-topics-heading': "\u0422\u0435\u043C\u0438 \u0434\u043B\u044F \u043E\u0431\u0433\u043E\u0432\u043E\u0440\u0435\u043D\u043D\u044F",
    'project-pages.better-together-templates.meeting-notes.list-people': "\u0441\u043A\u043B\u0430\u0434\u0456\u0442\u044C \u0441\u043F\u0438\u0441\u043E\u043A \u043B\u044E\u0434\u0435\u0439 \u0437\u0430 \u0434\u043E\u043F\u043E\u043C\u043E\u0433\u043E\u044E",
    'project-pages.better-together-templates.meeting-notes.mention': "\u0417\u0433\u0430\u0434\u0430\u0439\u0442\u0435",
    'project-pages.better-together-templates.meeting-notes.mention-people-to-assign-them': "\u043B\u044E\u0434\u0435\u0439, \u0449\u043E\u0431 \u043F\u0440\u0438\u0437\u043D\u0430\u0447\u0438\u0442\u0438 \u0457\u0445 \u0434\u043B\u044F \u0432\u0438\u043A\u043E\u043D\u0430\u043D\u043D\u044F \u043F\u0443\u043D\u043A\u0442\u0443 \u0437\u0430\u0432\u0434\u0430\u043D\u043D\u044F.",
    'project-pages.better-together-templates.meeting-notes.notes-label': "\u041F\u0440\u0438\u043C\u0456\u0442\u043A\u0438",
    'project-pages.better-together-templates.meeting-notes.page-title': "\u041F\u0440\u0438\u043C\u0456\u0442\u043A\u0438 \u0434\u043E \u043D\u0430\u0440\u0430\u0434\u0438",
    'project-pages.better-together-templates.meeting-notes.participants-label': "\u0423\u0447\u0430\u0441\u043D\u0438\u043A\u0438",
    'project-pages.better-together-templates.meeting-notes.project-label': "\u041F\u0440\u043E\u0454\u043A\u0442",
    'project-pages.better-together-templates.product-requirements.create-a-jira-issue': "\u0412\u0432\u0435\u0434\u0456\u0442\u044C \xab/Jira\xbb, \u0449\u043E\u0431 \u0441\u0442\u0432\u043E\u0440\u0438\u0442\u0438 \u0437\u0430\u0432\u0434\u0430\u043D\u043D\u044F.",
    'project-pages.better-together-templates.product-requirements.design-heading': "\u0414\u0438\u0437\u0430\u0439\u043D",
    'project-pages.better-together-templates.product-requirements.embedd-different-data-views': "\u0412\u0431\u0443\u0434\u043E\u0432\u0443\u0439\u0442\u0435 \u0440\u0456\u0437\u043D\u0456 \u0434\u0430\u043D\u0456 \u0439 \u043F\u043E\u0434\u0430\u043D\u043D\u044F \u0437 \u0432\u0430\u0448\u043E\u0433\u043E \u043F\u0440\u043E\u0454\u043A\u0442\u0443 Jira.",
    'project-pages.better-together-templates.product-requirements.heading': "\u041E\u0433\u043B\u044F\u0434",
    'project-pages.better-together-templates.product-requirements.how-will-you-know-if-fixed': "\u042F\u043A \u0432\u0438 \u0434\u0456\u0437\u043D\u0430\u0454\u0442\u0435\u0441\u044F, \u0449\u043E \u043F\u0440\u043E\u0431\u043B\u0435\u043C\u0443 \u0443\u0441\u0443\u043D\u0443\u0442\u043E?",
    'project-pages.better-together-templates.product-requirements.impact-heading': "\u0412\u043F\u043B\u0438\u0432",
    'project-pages.better-together-templates.product-requirements.inScopeStatus': "\u0412\u0445\u043E\u0434\u0438\u0442\u044C \u0432 \u043E\u0431\u043B\u0430\u0441\u0442\u044C",
    'project-pages.better-together-templates.product-requirements.insert-design-link': "\u0412\u0441\u0442\u0430\u0432\u0442\u0435 \u043F\u043E\u0441\u0438\u043B\u0430\u043D\u043D\u044F \u043D\u0430 \u0432\u0430\u0448 \u0434\u0438\u0437\u0430\u0439\u043D (Figma \u0442\u043E\u0449\u043E)",
    'project-pages.better-together-templates.product-requirements.jira-issue-heading': "\u0417\u0430\u0432\u0434\u0430\u043D\u043D\u044F \u0432 Jira",
    'project-pages.better-together-templates.product-requirements.jira-roadmap-heading': "\u041F\u043B\u0430\u043D \u0440\u043E\u0437\u0440\u043E\u0431\u043A\u0438 Jira",
    'project-pages.better-together-templates.product-requirements.learn-how-with-smart-links': "\u0414\u043E\u043A\u043B\u0430\u0434\u043D\u0456\u0448\u0435 \u043F\u0440\u043E \u0432\u0431\u0443\u0434\u043E\u0432\u0443\u0432\u0430\u043D\u043D\u044F \u0437\u0430 \u0434\u043E\u043F\u043E\u043C\u043E\u0433\u043E\u044E \u0441\u043C\u0430\u0440\u0442-\u043F\u043E\u0441\u0438\u043B\u0430\u043D\u044C",
    'project-pages.better-together-templates.product-requirements.list-dashboards': "\u0421\u043A\u043B\u0430\u0434\u0456\u0442\u044C \u0441\u043F\u0438\u0441\u043E\u043A \u043F\u0430\u043D\u0435\u043B\u0435\u0439 (Amplitude, Mode \u0442\u043E\u0449\u043E)",
    'project-pages.better-together-templates.product-requirements.list-design-considerations': "\u0421\u043A\u043B\u0430\u0434\u0456\u0442\u044C \u0441\u043F\u0438\u0441\u043E\u043A \u043C\u0456\u0440\u043A\u0443\u0432\u0430\u043D\u044C \u0449\u043E\u0434\u043E \u0437\u0431\u0456\u0440\u043A\u0438",
    'project-pages.better-together-templates.product-requirements.list-people': "\u0441\u043A\u043B\u0430\u0434\u0456\u0442\u044C \u0441\u043F\u0438\u0441\u043E\u043A \u043B\u044E\u0434\u0435\u0439 \u0437\u0430 \u0434\u043E\u043F\u043E\u043C\u043E\u0433\u043E\u044E",
    'project-pages.better-together-templates.product-requirements.mention': "\u0417\u0433\u0430\u0434\u0430\u0439\u0442\u0435",
    'project-pages.better-together-templates.product-requirements.mention-people-to-assign-them': "\u043B\u044E\u0434\u0435\u0439, \u0449\u043E\u0431 \u043F\u0440\u0438\u0437\u043D\u0430\u0447\u0438\u0442\u0438 \u0457\u043C \u043F\u0443\u043D\u043A\u0442 \u0437\u0430\u0432\u0434\u0430\u043D\u043D\u044F.",
    'project-pages.better-together-templates.product-requirements.niceToHaveStatus': "\u0411\u0430\u0436\u0430\u043D\u043E \u0437\u0430\u0441\u0442\u043E\u0441\u0443\u0432\u0430\u0442\u0438",
    'project-pages.better-together-templates.product-requirements.outOfScopeStatus': "\u041D\u0435 \u0432\u0445\u043E\u0434\u0438\u0442\u044C \u0432 \u043E\u0431\u043B\u0430\u0441\u0442\u044C",
    'project-pages.better-together-templates.product-requirements.page-title': "\u0412\u0438\u043C\u043E\u0433\u0438 \u0434\u043E \u043F\u0440\u043E\u0434\u0443\u043A\u0442\u0443",
    'project-pages.better-together-templates.product-requirements.pro-tip': "\u041F\u043E\u0440\u0430\u0434\u0430 \u0432\u0456\u0434 \u043F\u0440\u043E\u0444\u0456:",
    'project-pages.better-together-templates.product-requirements.problem-label': "\u041F\u0440\u043E\u0431\u043B\u0435\u043C\u0430",
    'project-pages.better-together-templates.product-requirements.requirement-heading': "\u0412\u0438\u043C\u043E\u0433\u0430",
    'project-pages.better-together-templates.product-requirements.scope-heading': "\u041E\u0431\u043B\u0430\u0441\u0442\u044C",
    'project-pages.better-together-templates.product-requirements.success-metric': "\u041F\u043E\u043A\u0430\u0437\u043D\u0438\u043A \u0443\u0441\u043F\u0456\u0445\u0443",
    'project-pages.better-together-templates.product-requirements.target-release-date': "\u0426\u0456\u043B\u044C\u043E\u0432\u0430 \u0434\u0430\u0442\u0430 \u0432\u0438\u043F\u0443\u0441\u043A\u0443",
    'project-pages.better-together-templates.product-requirements.team-label': "\u041A\u043E\u043C\u0430\u043D\u0434\u0430",
    'project-pages.better-together-templates.product-requirements.to-do-list-heading': "\u0421\u043F\u0438\u0441\u043E\u043A \u0437\u0430\u0434\u0430\u0447",
    'project-pages.better-together-templates.product-requirements.what-are-you-trying-to-fix': "\u0429\u043E \u0432\u0438 \u043D\u0430\u043C\u0430\u0433\u0430\u0454\u0442\u0435\u0441\u044F \u0432\u0438\u043F\u0440\u0430\u0432\u0438\u0442\u0438?",
    'project-pages.better-together-templates.retro-notes.retro-heading': "\u0420\u0435\u0442\u0440\u043E\u0441\u043F\u0435\u043A\u0442\u0438\u0432\u0430",
    'project-pages.better-together-templates.retro.action-items-heading': "\u0429\u043E \u0442\u0430\u043A\u0435 \u043F\u0443\u043D\u043A\u0442\u0438 \u0437\u0430\u0432\u0434\u0430\u043D\u043D\u044F?",
    'project-pages.better-together-templates.retro.create-a-jira-issue': "\u0412\u0432\u0435\u0434\u0456\u0442\u044C \xab/Jira\xbb, \u0449\u043E\u0431 \u0441\u0442\u0432\u043E\u0440\u0438\u0442\u0438 \u0437\u0430\u0432\u0434\u0430\u043D\u043D\u044F.",
    'project-pages.better-together-templates.retro.date-label': "\u0414\u0430\u0442\u0430",
    'project-pages.better-together-templates.retro.embed-it-here': "\u0429\u043E\u0439\u043D\u043E \u0432\u0438 \u0437\u0430\u043A\u0456\u043D\u0447\u0438\u0442\u0435, \u043C\u043E\u0436\u0435\u0442\u0435 \u0432\u0431\u0443\u0434\u0443\u0432\u0430\u0442\u0438 \u0434\u043E\u0448\u043A\u0443 \u0442\u0443\u0442.",
    'project-pages.better-together-templates.retro.list-people': "\u0441\u043A\u043B\u0430\u0434\u0456\u0442\u044C \u0441\u043F\u0438\u0441\u043E\u043A \u043B\u044E\u0434\u0435\u0439 \u0437\u0430 \u0434\u043E\u043F\u043E\u043C\u043E\u0433\u043E\u044E",
    'project-pages.better-together-templates.retro.mention': "\u0417\u0433\u0430\u0434\u0430\u0439\u0442\u0435",
    'project-pages.better-together-templates.retro.mention-people-to-assign-them': "\u043B\u044E\u0434\u0435\u0439, \u0449\u043E\u0431 \u043F\u0440\u0438\u0437\u043D\u0430\u0447\u0438\u0442\u0438 \u0457\u043C \u043F\u0443\u043D\u043A\u0442 \u0437\u0430\u0432\u0434\u0430\u043D\u043D\u044F.",
    'project-pages.better-together-templates.retro.page-title': "\u0420\u0435\u0442\u0440\u043E\u0441\u043F\u0435\u043A\u0442\u0438\u0432\u0430",
    'project-pages.better-together-templates.retro.participants-label': "\u0423\u0447\u0430\u0441\u043D\u0438\u043A\u0438",
    'project-pages.better-together-templates.retro.pro-tip': "\u041F\u043E\u0440\u0430\u0434\u0430 \u0432\u0456\u0434 \u043F\u0440\u043E\u0444\u0456:",
    'project-pages.better-together-templates.retro.project-label': "\u041F\u0440\u043E\u0454\u043A\u0442",
    'project-pages.better-together-templates.retro.this-is-a-whiteboard': "\u041F\u0435\u0440\u0435\u0434 \u0432\u0430\u043C\u0438 \u0434\u043E\u0448\u043A\u0430 Confluence.",
    'project-pages.better-together-templates.retro.use-a-whiteboard': "\u0412\u0438\u043A\u043E\u0440\u0438\u0441\u0442\u0430\u0439\u0442\u0435 \u0434\u043E\u0448\u043A\u0443 Confluence \u0434\u043B\u044F \u0440\u0435\u0442\u0440\u043E\u0441\u043F\u0435\u043A\u0442\u0438\u0432\u0438.",
    'project-pages.better-together-templates.retro.use-it-to-vote': "\u0412\u0438\u043A\u043E\u0440\u0438\u0441\u0442\u043E\u0432\u0443\u0439\u0442\u0435 \u0457\u0457, \u0449\u043E\u0431 \u0433\u043E\u043B\u043E\u0441\u0443\u0432\u0430\u0442\u0438 \u0439 \u0441\u043F\u0456\u0432\u043F\u0440\u0430\u0446\u044E\u0432\u0430\u0442\u0438 \u0437\u0456 \u0441\u0432\u043E\u0454\u044E \u043A\u043E\u043C\u0430\u043D\u0434\u043E\u044E.",
    'project-pages.button.connect-different-space-or-page.label': "\u0417\u043D\u0430\u0447\u043E\u043A \u043E\u043D\u043E\u0432\u043B\u0435\u043D\u043D\u044F \u0440\u043E\u0437\u0434\u0456\u043B\u0443 \u0430\u0431\u043E \u0441\u0442\u043E\u0440\u0456\u043D\u043A\u0438",
    'project-pages.button.connect-different-space-or-page.tooltip': "\u041F\u0456\u0434\u043A\u043B\u044E\u0447\u0438\u0442\u0438 \u0456\u043D\u0448\u0438\u0439 \u0440\u043E\u0437\u0434\u0456\u043B \u0430\u0431\u043E \u043F\u0443\u043D\u043A\u0442",
    'project-pages.button.connect-space-or-page.tooltip': "\u041F\u0456\u0434\u043A\u043B\u044E\u0447\u0438\u0442\u0438\u0441\u044F \u0434\u043E Confluence",
    'project-pages.button.go-to-connected-live-doc.tooltip': "\u0412\u0456\u0434\u043A\u0440\u0438\u0442\u0438 \u0456\u043D\u0442\u0435\u0440\u0430\u043A\u0442\u0438\u0432\u043D\u0456 \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0438 \u0432 Confluence",
    'project-pages.button.go-to-connected-page.tooltip': "\u0412\u0456\u0434\u043A\u0440\u0438\u0439\u0442\u0435 \u0446\u044E \u0441\u0442\u043E\u0440\u0456\u043D\u043A\u0443 \u0432 Confluence",
    'project-pages.button.go-to-connected-space.tooltip': "\u0412\u0456\u0434\u043A\u0440\u0438\u0439\u0442\u0435 \u0446\u0435\u0439 \u0440\u043E\u0437\u0434\u0456\u043B \u0443 Confluence",
    'project-pages.connect-space-dialog.connection-error': "\u041F\u043E\u043C\u0438\u043B\u043A\u0430 \u043F\u0456\u0434\u043A\u043B\u044E\u0447\u0435\u043D\u043D\u044F.",
    'project-pages.connect-space-dialog.connection-retry': "\u041F\u043E\u0432\u0442\u043E\u0440\u0438\u0442\u0438 \u0441\u043F\u0440\u043E\u0431\u0443",
    'project-pages.connect-space-dialog.content.space-or-page-selector.description': "\u0412\u0438\u0431\u0435\u0440\u0456\u0442\u044C \u0440\u043E\u0437\u0434\u0456\u043B \u0447\u0438 \u0435\u043B\u0435\u043C\u0435\u043D\u0442, \u0449\u043E \u043F\u043E\u0442\u0440\u0456\u0431\u043D\u043E \u043F\u0456\u0434\u043A\u043B\u044E\u0447\u0438\u0442\u0438 \u0434\u043E \u0446\u044C\u043E\u0433\u043E \u043F\u0440\u043E\u0454\u043A\u0442\u0443.",
    'project-pages.connect-space-dialog.content.space-or-page-selector.placeholder': "\u041F\u043E\u0448\u0443\u043A \u0443 Confluence",
    'project-pages.connect-space-dialog.content.space-selector.disconnected-templates-description': "\u0426\u0435\u0439 \u043F\u0440\u043E\u0454\u043A\u0442 \u043D\u0435\u043E\u0431\u0445\u0456\u0434\u043D\u043E \u043F\u0456\u0434\u043A\u043B\u044E\u0447\u0438\u0442\u0438 \u0434\u043E \u0440\u043E\u0437\u0434\u0456\u043B\u0443, \u043F\u0435\u0440\u0448 \u043D\u0456\u0436 \u043C\u043E\u0436\u043D\u0430 \u0431\u0443\u0434\u0435 \u0441\u0442\u0432\u043E\u0440\u0438\u0442\u0438 \u0435\u043B\u0435\u043C\u0435\u043D\u0442. \u0412\u0438\u0431\u0435\u0440\u0456\u0442\u044C \u0440\u043E\u0437\u0434\u0456\u043B, \u044F\u043A\u0438\u0439 \u043F\u043E\u0442\u0440\u0456\u0431\u043D\u043E \u043F\u0456\u0434\u043A\u043B\u044E\u0447\u0438\u0442\u0438 \u0434\u043E \u0446\u044C\u043E\u0433\u043E \u043F\u0440\u043E\u0454\u043A\u0442\u0443.",
    'project-pages.connect-space-dialog.error-icon': "\u041F\u043E\u043C\u0438\u043B\u043A\u0430:",
    'project-pages.connect-space-dialog.footer.cancel': "\u0421\u043A\u0430\u0441\u0443\u0432\u0430\u0442\u0438",
    'project-pages.connect-space-dialog.footer.connect-space': "\u041F\u0456\u0434\u043A\u043B\u044E\u0447\u0435\u043D\u043D\u044F",
    'project-pages.connect-space-or-page-dialog.header.title': "\u041F\u0456\u0434\u043A\u043B\u044E\u0447\u0456\u0442\u044C \u043F\u0440\u043E\u0454\u043A\u0442 \u0434\u043E Confluence",
    'project-pages.connect-space.description': "\u0420\u043E\u0437\u0434\u0456\u043B\u0438 \u043F\u043E\u0434\u0456\u0431\u043D\u0456 \u0434\u043E \u043F\u0430\u043F\u043E\u043A\xa0\u2014 \u0457\u0445 \u043C\u043E\u0436\u043D\u0430 \u0432\u0438\u043A\u043E\u0440\u0438\u0441\u0442\u043E\u0432\u0443\u0432\u0430\u0442\u0438 \u0434\u043B\u044F \u0441\u0442\u0432\u043E\u0440\u0435\u043D\u043D\u044F \u0442\u0430 \u0432\u043F\u043E\u0440\u044F\u0434\u043A\u0443\u0432\u0430\u043D\u043D\u044F \u043A\u043E\u043D\u0442\u0435\u043D\u0442\u0443, \u043F\u043E\u0432\u2019\u044F\u0437\u0430\u043D\u043E\u0433\u043E \u0437 \u043F\u0440\u043E\u0454\u043A\u0442\u043E\u043C, \u0430 \u0442\u0430\u043A\u043E\u0436 \u0441\u043F\u0456\u043B\u044C\u043D\u043E\u0457 \u0440\u043E\u0431\u043E\u0442\u0438 \u043D\u0430\u0434 \u043D\u0438\u043C.",
    'project-pages.connect-space.not-connected.description': "\u0429\u043E\u0431 \u0432\u0438\u043A\u043E\u0440\u0438\u0441\u0442\u043E\u0432\u0443\u0432\u0430\u0442\u0438 \u0441\u0442\u043E\u0440\u0456\u043D\u043A\u0438 \u043F\u0440\u043E\u0454\u043A\u0442\u0443, \u0437\u0432\u2019\u044F\u0436\u0456\u0442\u044C\u0441\u044F \u0437\u0456 \u0441\u0432\u043E\u0457\u043C \u0430\u0434\u043C\u0456\u043D\u0456\u0441\u0442\u0440\u0430\u0442\u043E\u0440\u043E\u043C \u0430\u0431\u043E \u043A\u043E\u043C\u0430\u043D\u0434\u043E\u044E, \u0449\u043E\u0431 \u043F\u0456\u0434\u043A\u043B\u044E\u0447\u0438\u0442\u0438 Confluence \u0434\u043E \u0446\u044C\u043E\u0433\u043E \u043F\u0440\u043E\u0454\u043A\u0442\u0443.",
    'project-pages.connect-space.not-connected.heading': "\u041D\u0435 \u043F\u0456\u0434\u043A\u043B\u044E\u0447\u0435\u043D\u043E \u0434\u043E Confluence",
    'project-pages.connect-success-flag.description.content': "\u0423\u0441\u0442\u0430\u043D\u043E\u0432\u043B\u0435\u043D\u043E \u043F\u0456\u0434\u043A\u043B\u044E\u0447\u0435\u043D\u043D\u044F \u0434\u043E {connectedSpaceOrPageName}.",
    'project-pages.connection-error.space-or-page-not-found.button': "\u041F\u0456\u0434\u043A\u043B\u044E\u0447\u0435\u043D\u043D\u044F \u0434\u043E \u0456\u043D\u0448\u0438\u0445 \u0440\u043E\u0437\u0434\u0456\u043B\u0443 \u0447\u0438 \u0441\u0442\u043E\u0440\u0456\u043D\u043A\u0438",
    'project-pages.create-space-dialog.connection-error': "\u041F\u043E\u043C\u0438\u043B\u043A\u0430 \u043F\u0456\u0434\u043A\u043B\u044E\u0447\u0435\u043D\u043D\u044F.",
    'project-pages.create-space-dialog.connection-retry': "\u041F\u043E\u0432\u0442\u043E\u0440\u0438\u0442\u0438 \u0441\u043F\u0440\u043E\u0431\u0443",
    'project-pages.create-space-dialog.content.empty-name': "\u0414\u043E\u0434\u0430\u0439\u0442\u0435 \u043D\u0430\u0437\u0432\u0443 \u0440\u043E\u0437\u0434\u0456\u043B\u0443.",
    'project-pages.create-space-dialog.content.invalid-name': "\u0423 \u043D\u0430\u0437\u0432\u0456 \u0440\u043E\u0437\u0434\u0456\u043B\u0443 \u043C\u0430\u0454 \u0431\u0443\u0442\u0438 \u043F\u0440\u0438\u043D\u0430\u0439\u043C\u043D\u0456 \u043E\u0434\u043D\u0430 \u043B\u0456\u0442\u0435\u0440\u0430 \u0430\u0431\u043E \u0446\u0438\u0444\u0440\u0430.",
    'project-pages.create-space-dialog.content.placeholder': "\u0412\u0432\u0435\u0434\u0456\u0442\u044C \u043D\u0430\u0437\u0432\u0443 \u0440\u043E\u0437\u0434\u0456\u043B\u0443",
    'project-pages.create-space-dialog.creation-error': "\u041F\u043E\u043C\u0438\u043B\u043A\u0430 \u0441\u0442\u0432\u043E\u0440\u0435\u043D\u043D\u044F \u0440\u043E\u0437\u0434\u0456\u043B\u0443.",
    'project-pages.create-space-dialog.error-icon': "\u041F\u043E\u043C\u0438\u043B\u043A\u0430:",
    'project-pages.create-space-dialog.footer.cancel': "\u0421\u043A\u0430\u0441\u0443\u0432\u0430\u0442\u0438",
    'project-pages.create-space-dialog.footer.create-space': "\u0421\u0442\u0432\u043E\u0440\u0438\u0442\u0438",
    'project-pages.create-space-dialog.header.title': "\u0421\u0442\u0432\u043E\u0440\u0435\u043D\u043D\u044F \u0440\u043E\u0437\u0434\u0456\u043B\u0443 Confluence",
    'project-pages.cross-join.access-revoked.templates.subtitle': "\u0412\u0438 \u043D\u0435 \u043C\u043E\u0436\u0435\u0442\u0435 \u0432\u0438\u043A\u043E\u0440\u0438\u0441\u0442\u043E\u0432\u0443\u0432\u0430\u0442\u0438 \u0441\u0442\u043E\u0440\u0456\u043D\u043A\u0438 \u043F\u0440\u043E\u0454\u043A\u0442\u0443, \u0442\u043E\u043C\u0443 \u0449\u043E \u0430\u0434\u043C\u0456\u043D\u0456\u0441\u0442\u0440\u0430\u0442\u043E\u0440 \u043E\u0431\u043C\u0435\u0436\u0438\u0432 \u0432\u0430\u043C \u0434\u043E\u0441\u0442\u0443\u043F \u0434\u043E Confluence. \u041F\u043E\u043F\u0440\u043E\u0441\u0456\u0442\u044C \u0430\u0434\u043C\u0456\u043D\u0456\u0441\u0442\u0440\u0430\u0442\u043E\u0440\u0430 \u043D\u0430\u0434\u0430\u0442\u0438 \u0434\u043E\u0441\u0442\u0443\u043F.",
    'project-pages.cross-join.access-revoked.templates.title': "\u0423 \u0432\u0430\u0441 \u043D\u0435\u043C\u0430\u0454 \u0434\u043E\u0437\u0432\u043E\u043B\u0443 \u043D\u0430 \u0432\u0438\u043A\u043E\u0440\u0438\u0441\u0442\u0430\u043D\u043D\u044F \u0441\u0442\u043E\u0440\u0456\u043D\u043E\u043A \u043F\u0440\u043E\u0454\u043A\u0442\u0443",
    'project-pages.cross-join.avatar.view-profile': "\u041F\u0435\u0440\u0435\u0433\u043B\u044F\u043D\u0443\u0442\u0438 \u043F\u0440\u043E\u0444\u0456\u043B\u044C",
    'project-pages.cross-join.denied-request.templates.subtitle': "\u0412\u0438 \u043D\u0435 \u043C\u043E\u0436\u0435\u0442\u0435 \u0432\u0438\u043A\u043E\u0440\u0438\u0441\u0442\u043E\u0432\u0443\u0432\u0430\u0442\u0438 \u0441\u0442\u043E\u0440\u0456\u043D\u043A\u0438 \u043F\u0440\u043E\u0454\u043A\u0442\u0443, \u0442\u043E\u043C\u0443 \u0449\u043E \u0430\u0434\u043C\u0456\u043D\u0456\u0441\u0442\u0440\u0430\u0442\u043E\u0440 \u0441\u0430\u0439\u0442\u0443 \u0432\u0456\u0434\u0445\u0438\u043B\u0438\u0432 \u0432\u0430\u0448 \u0437\u0430\u043F\u0438\u0442 \u043D\u0430 \u043F\u0440\u0438\u0454\u0434\u043D\u0430\u043D\u043D\u044F \u0434\u043E Confluence.",
    'project-pages.cross-join.denied-request.templates.title': "\u0412\u0430\u0448 \u0430\u0434\u043C\u0456\u043D\u0456\u0441\u0442\u0440\u0430\u0442\u043E\u0440 \u0432\u0456\u0434\u0445\u0438\u043B\u0438\u0432 \u0437\u0430\u043F\u0438\u0442 \u043D\u0430 \u0434\u043E\u0441\u0442\u0443\u043F",
    'project-pages.cross-join.direct-access.button-subtitle.experimental': "\u0412\u0438 \u043E\u0442\u0440\u0438\u043C\u0430\u0454\u0442\u0435 \u0434\u043E\u0441\u0442\u0443\u043F \u0434\u043E Confluence. \u0410\u0434\u043C\u0456\u043D\u0456\u0441\u0442\u0440\u0430\u0442\u043E\u0440 \u0432\u0430\u0448\u043E\u0433\u043E \u0441\u0430\u0439\u0442\u0443 \u0432\u0436\u0435 \u0441\u0445\u0432\u0430\u043B\u0438\u0432 \u0432\u0430\u0441.",
    'project-pages.cross-join.errors.unknown-error.description': "\u042F\u043A\u0449\u043E \u043E\u043D\u043E\u0432\u043B\u0435\u043D\u043D\u044F \u0441\u0442\u043E\u0440\u0456\u043D\u043A\u0438 \u043D\u0435 \u0432\u0438\u0440\u0456\u0448\u0443\u0454 \u043F\u0440\u043E\u0431\u043B\u0435\u043C\u0443, {contactSupport}.",
    'project-pages.cross-join.errors.unknown-error.title': "\u041D\u0430\u0440\u0430\u0437\u0456 \u0441\u0442\u043E\u0440\u0456\u043D\u043A\u0438 \u043F\u0440\u043E\u0454\u043A\u0442\u0443 \u043D\u0435\u0434\u043E\u0441\u0442\u0443\u043F\u043D\u0456",
    'project-pages.cross-join.inline-join-product.button': "\u0412\u0438 \u043E\u0442\u0440\u0438\u043C\u0430\u0454\u0442\u0435 \u0434\u043E\u0441\u0442\u0443\u043F \u0434\u043E Confluence. \u0410\u0434\u043C\u0456\u043D\u0456\u0441\u0442\u0440\u0430\u0442\u043E\u0440 \u0432\u0430\u0448\u043E\u0433\u043E \u0441\u0430\u0439\u0442\u0443 \u0432\u0436\u0435 \u0441\u0445\u0432\u0430\u043B\u0438\u0432 \u0432\u0430\u0441.",
    'project-pages.cross-join.inline-join-product.connected.description': "\u0426\u0435\u043D\u0442\u0440\u0430\u043B\u0456\u0437\u043E\u0432\u0430\u043D\u043E \u043F\u0435\u0440\u0435\u0433\u043B\u044F\u0434\u0430\u0439\u0442\u0435, \u0440\u0435\u0434\u0430\u0433\u0443\u0439\u0442\u0435 \u0442\u0430 \u0441\u0442\u0432\u043E\u0440\u044E\u0439\u0442\u0435 \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0438",
    'project-pages.cross-join.inline-join-product.connected.title': "\u041F\u0440\u0430\u0446\u044E\u0439\u0442\u0435 \u0432 \u043A\u043E\u043C\u0430\u043D\u0434\u0456 \u043D\u0430\u0434 \u0441\u0442\u043E\u0440\u0456\u043D\u043A\u0430\u043C\u0438 \u043F\u0440\u043E\u0454\u043A\u0442\u0443",
    'project-pages.cross-join.pending-request.templates.subtitle': "\u0410\u0434\u043C\u0456\u043D\u0456\u0441\u0442\u0440\u0430\u0442\u043E\u0440 \u0441\u0430\u0439\u0442\u0443 \u043E\u0442\u0440\u0438\u043C\u0430\u0432 \u0432\u0430\u0448 \u0437\u0430\u043F\u0438\u0442 \u043D\u0430 \u043F\u0440\u0438\u0454\u0434\u043D\u0430\u043D\u043D\u044F \u0434\u043E Confluence. \u042F\u043A\u0449\u043E \u0432\u0456\u043D \u043D\u0430\u0434\u0430\u0441\u0442\u044C \u0432\u0430\u043C \u0434\u043E\u0437\u0432\u0456\u043B \u043D\u0430 \u043F\u0440\u0438\u0454\u0434\u043D\u0430\u043D\u043D\u044F, \u0441\u0442\u043E\u0440\u0456\u043D\u043A\u0438 \u043F\u0440\u043E\u0454\u043A\u0442\u0443 \u0430\u043A\u0442\u0438\u0432\u0443\u044E\u0442\u044C\u0441\u044F \u0442\u0430 \u043C\u0438 \u043D\u0430\u0434\u0456\u0448\u043B\u0435\u043C\u043E \u0432\u0430\u043C \u043B\u0438\u0441\u0442\u0430 \u0437 \u043F\u0456\u0434\u0442\u0432\u0435\u0440\u0434\u0436\u0435\u043D\u043D\u044F\u043C.",
    'project-pages.cross-join.pending-request.templates.subtitle.experiment': "\u041F\u0456\u0441\u043B\u044F \u0441\u0445\u0432\u0430\u043B\u0435\u043D\u043D\u044F \u0432\u0438 \u043E\u0442\u0440\u0438\u043C\u0430\u0454\u0442\u0435 \u0435\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u043E\u0433\u043E \u043B\u0438\u0441\u0442\u0430 \u0437 \u0434\u043E\u0441\u0442\u0443\u043F\u043E\u043C \u0434\u043E \u0441\u0442\u043E\u0440\u0456\u043D\u043E\u043A \u043F\u0440\u043E\u0454\u043A\u0442\u0443.",
    'project-pages.cross-join.pending-request.templates.title': "\u0412\u0438 \u043D\u0430\u0434\u0456\u0441\u043B\u0430\u043B\u0438 \u0437\u0430\u043F\u0438\u0442 \u043D\u0430 \u0434\u043E\u0441\u0442\u0443\u043F \u0434\u043E Confluence",
    'project-pages.cross-join.pending-request.templates.title.experiment': "\u0417\u0430\u043F\u0438\u0442 \u043D\u0430 \u0434\u043E\u0441\u0442\u0443\u043F \u043D\u0430\u0434\u0456\u0441\u043B\u0430\u043D\u043E \u0430\u0434\u043C\u0456\u043D\u0456\u0441\u0442\u0440\u0430\u0442\u043E\u0440\u0443",
    'project-pages.cross-join.request-access-without-better-together.connected.description': "\u041F\u0435\u0440\u0435\u0433\u043B\u044F\u0434\u0430\u0439\u0442\u0435, \u0440\u0435\u0434\u0430\u0433\u0443\u0439\u0442\u0435 \u0442\u0430 \u0441\u0442\u0432\u043E\u0440\u044E\u0439\u0442\u0435 \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0438 \u043F\u0440\u043E\u0454\u043A\u0442\u0443 \u0432 \u043A\u043E\u043C\u0430\u043D\u0434\u0456",
    'project-pages.cross-join.request-access.button': "\u041D\u0430\u0434\u0456\u0441\u043B\u0430\u0442\u0438 \u0437\u0430\u043F\u0438\u0442 \u043D\u0430 \u0434\u043E\u0441\u0442\u0443\u043F",
    'project-pages.cross-join.request-access.button-subtitle.experimental': "\u041D\u0430\u0442\u0438\u0441\u043A\u0430\u044E\u0447\u0438 \u043A\u043D\u043E\u043F\u043A\u0443 \xab\u041F\u0440\u0438\u0454\u0434\u043D\u0430\u0442\u0438\u0441\u044F \u0434\u043E \u043A\u043E\u043C\u0430\u043D\u0434\u0438\xbb, \u0432\u0438 \u043F\u0440\u043E\u0441\u0438\u0442\u0435 \u0434\u043E\u0437\u0432\u043E\u043B\u0443 \u043F\u0440\u0438\u0454\u0434\u043D\u0430\u0442\u0438\u0441\u044F \u0434\u043E Confluence \u0456 \u043F\u043E\u0433\u043E\u0434\u0436\u0443\u0454\u0442\u0435\u0441\u044F \u043F\u043E\u0434\u0456\u043B\u0438\u0442\u0438\u0441\u044F \u0441\u0432\u043E\u0457\u043C \u043F\u0440\u043E\u0444\u0456\u043B\u0435\u043C Atlassian \u0456\u0437 \u0432\u0430\u0448\u0438\u043C \u0430\u0434\u043C\u0456\u043D\u0456\u0441\u0442\u0440\u0430\u0442\u043E\u0440\u043E\u043C.",
    'project-pages.cross-join.request-access.button.experimental': "\u041F\u0440\u0438\u0454\u0434\u043D\u0430\u0442\u0438\u0441\u044F \u0434\u043E \u043A\u043E\u043C\u0430\u043D\u0434\u0438",
    'project-pages.cross-join.request-access.connected.description.experimental': "\u0412\u0430\u0448\u0430 \u043A\u043E\u043C\u0430\u043D\u0434\u0430 \u0432\u0438\u043A\u043E\u0440\u0438\u0441\u0442\u043E\u0432\u0443\u0454 \u0441\u0442\u043E\u0440\u0456\u043D\u043A\u0438 \u043F\u0440\u043E\u0454\u043A\u0442\u0456\u0432, \u0449\u043E\u0431 \u043A\u043E\u043C\u0435\u043D\u0442\u0443\u0432\u0430\u0442\u0438 \u0439 \u0440\u0435\u0434\u0430\u0433\u0443\u0432\u0430\u0442\u0438 \u043F\u0440\u043E\u0454\u043A\u0442\u043D\u0443 \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0430\u0446\u0456\u044E, \u0430 \u0442\u0430\u043A\u043E\u0436 \u0440\u0430\u0437\u043E\u043C \u043F\u0440\u0430\u0446\u044E\u0432\u0430\u0442\u0438 \u043D\u0430\u0434 \u043D\u0435\u044E \u0431\u0435\u0437\u043F\u043E\u0441\u0435\u0440\u0435\u0434\u043D\u044C\u043E \u0432 Jira. \u041F\u0440\u0438\u0454\u0434\u043D\u0443\u0439\u0442\u0435\u0441\u044F \u0434\u043E Confluence, \u0449\u043E\u0431 \u043E\u0442\u0440\u0438\u043C\u0430\u0442\u0438 \u0434\u043E\u0441\u0442\u0443\u043F \u0434\u043E \u0441\u0442\u043E\u0440\u0456\u043D\u043E\u043A \u043A\u043E\u043C\u0430\u043D\u0434\u043D\u0438\u0445 \u043F\u0440\u043E\u0454\u043A\u0442\u0456\u0432.",
    'project-pages.cross-join.request-access.title': "\u0414\u043B\u044F \u0440\u043E\u0431\u043E\u0442\u0438 \u0437\u0456 \u0441\u0442\u043E\u0440\u0456\u043D\u043A\u0430\u043C\u0438 \u043F\u0440\u043E\u0454\u043A\u0442\u0456\u0432 \u043F\u043E\u0442\u0440\u0456\u0431\u043D\u043E \u043C\u0430\u0442\u0438 \u0434\u043E\u0441\u0442\u0443\u043F \u0434\u043E Confluence",
    'project-pages.cross-join.request-access.title.experiment': "\u0421\u0442\u0432\u043E\u0440\u0456\u0442\u044C \u0454\u0434\u0438\u043D\u0435 \u0434\u0436\u0435\u0440\u0435\u043B\u043E \u0434\u043E\u0441\u0442\u043E\u0432\u0456\u0440\u043D\u0438\u0445 \u0434\u0430\u043D\u0438\u0445 \u0434\u043B\u044F \u0441\u0432\u043E\u0454\u0457 \u043A\u043E\u043C\u0430\u043D\u0434\u0438",
    'project-pages.default-contextual-heading': "\u0421\u0442\u043E\u0440\u0456\u043D\u043A\u0438 \u043F\u0440\u043E\u0454\u043A\u0442\u0456\u0432 \u0441\u0442\u0432\u043E\u0440\u0435\u043D\u043E \u043D\u0430 \u043F\u043B\u0430\u0442\u0444\u043E\u0440\u043C\u0456 Confluence",
    'project-pages.default-contextual-message': "\u0426\u0435\u043D\u0442\u0440\u0430\u043B\u0456\u0437\u043E\u0432\u0430\u043D\u043E \u0441\u0442\u0432\u043E\u0440\u044E\u0439\u0442\u0435 \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0438 \u0434\u043B\u044F \u043F\u0440\u043E\u0454\u043A\u0442\u0443, \u0434\u0456\u043B\u0456\u0442\u044C\u0441\u044F \u043D\u0438\u043C\u0438 \u0442\u0430 \u043F\u0440\u0430\u0446\u044E\u0439\u0442\u0435 \u043D\u0430\u0434 \u043D\u0438\u043C\u0438 \u0441\u043F\u0456\u043B\u044C\u043D\u043E \u0437 \u0456\u043D\u0448\u0438\u043C\u0438 \u0437\u0430 \u0434\u043E\u043F\u043E\u043C\u043E\u0433\u043E\u044E \u0441\u0442\u043E\u0440\u0456\u043D\u043E\u043A Confluence.",
    'project-pages.default-reactivate-CTA': "\u041F\u043E\u0432\u0442\u043E\u0440\u043D\u043E \u0430\u043A\u0442\u0438\u0432\u0443\u0432\u0430\u0442\u0438 Confluence",
    'project-pages.default-trial-CTA': "\u0421\u043F\u0440\u043E\u0431\u0443\u0439\u0442\u0435 Confluence \u0431\u0435\u0437\u043A\u043E\u0448\u0442\u043E\u0432\u043D\u043E \u043F\u0440\u043E\u0442\u044F\u0433\u043E\u043C 30\xa0\u0434\u043D\u0456\u0432",
    'project-pages.draft-saved-flag.action': "\u0412\u0456\u0434\u043A\u0440\u0438\u0442\u0438 \u0447\u0435\u0440\u043D\u0435\u0442\u043A\u0443",
    'project-pages.draft-saved-flag.description': "\u0414\u043E\u043A\u0438 \u0432\u0438 \u043D\u0435 \u043E\u043F\u0443\u0431\u043B\u0456\u043A\u0443\u0454\u0442\u0435 \u0447\u0435\u0440\u043D\u0435\u0442\u043A\u0443, \u0457\u0457 \u0437\u043C\u043E\u0436\u0435\u0442\u0435 \u0431\u0430\u0447\u0438\u0442\u0438 \u043B\u0438\u0448\u0435 \u0432\u0438.",
    'project-pages.draft-saved-flag.title': "\u0427\u0435\u0440\u043D\u0435\u0442\u043A\u0443 \u0437\u0431\u0435\u0440\u0435\u0436\u0435\u043D\u043E",
    'project-pages.embedded-pages.create-page-error.close-button': "\u0417\u0430\u043A\u0440\u0438\u0442\u0438",
    'project-pages.embedded-pages.create-page-error.description': "\u0412\u0438\u043D\u0438\u043A\u043B\u0430 \u043F\u0440\u043E\u0431\u043B\u0435\u043C\u0430. \u041C\u0438 \u043D\u0435 \u0437\u043C\u043E\u0433\u043B\u0438 \u0441\u0442\u0432\u043E\u0440\u0438\u0442\u0438 \u0434\u043B\u044F \u0432\u0430\u0441 \u0441\u0442\u043E\u0440\u0456\u043D\u043A\u0443.",
    'project-pages.embedded-pages.create-page-error.title': "\u041D\u0435 \u0432\u0434\u0430\u043B\u043E\u0441\u044F \u0441\u0442\u0432\u043E\u0440\u0438\u0442\u0438 \u0441\u0442\u043E\u0440\u0456\u043D\u043A\u0443",
    'project-pages.embedded-pages.create-page-error.try-again-button': "\u041F\u043E\u0432\u0442\u043E\u0440\u0456\u0442\u044C \u0441\u043F\u0440\u043E\u0431\u0443",
    'project-pages.embedded-pages.modal.close.button.hint': "\u0417\u0430\u043A\u0440\u0438\u0442\u0438",
    'project-pages.embedded-pages.modal.title.button': "\u0412\u0456\u0434\u043A\u0440\u0438\u0442\u0438 \u0432 Confluence",
    'project-pages.embedded-pages.modal.title.button.hint': "\u0412\u0456\u0434\u043A\u0440\u0438\u0442\u0438 \u0432 \u043D\u043E\u0432\u0456\u0439 \u0432\u043A\u043B\u0430\u0434\u0446\u0456",
    'project-pages.errors.unknown-error.description.non-final': "\u042F\u043A\u0449\u043E \u043E\u043D\u043E\u0432\u043B\u0435\u043D\u043D\u044F \u0441\u0442\u043E\u0440\u0456\u043D\u043A\u0438 \u043D\u0435 \u0432\u0438\u0440\u0456\u0448\u0443\u0454 \u043F\u0440\u043E\u0431\u043B\u0435\u043C\u0443, {contactSupport}.",
    'project-pages.errors.unknown-error.title.non-final': "\u0417\u0430\u0440\u0430\u0437 \u043C\u0438 \u043D\u0435 \u043C\u043E\u0436\u0435\u043C\u043E \u0432\u0456\u0434\u043E\u0431\u0440\u0430\u0437\u0438\u0442\u0438 \u0441\u0442\u043E\u0440\u0456\u043D\u043A\u0438 \u043F\u0440\u043E\u0435\u043A\u0442\u0443.",
    'project-pages.generic-error.button.reload': "\u041F\u0435\u0440\u0435\u0437\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0438\u0442\u0438 \u0441\u0442\u043E\u0440\u0456\u043D\u043A\u0443",
    'project-pages.generic-error.description': "\u0421\u0442\u0430\u043B\u0430\u0441\u044F \u043F\u043E\u043C\u0438\u043B\u043A\u0430. \u041F\u043E\u0432\u0442\u043E\u0440\u0456\u0442\u044C \u0441\u043F\u0440\u043E\u0431\u0443 \u043F\u0456\u0437\u043D\u0456\u0448\u0435.",
    'project-pages.generic-error.description.non-final': "\u0421\u0442\u0430\u043B\u0430\u0441\u044F \u043F\u043E\u043C\u0438\u043B\u043A\u0430. \u041F\u043E\u0432\u0442\u043E\u0440\u0456\u0442\u044C \u0441\u043F\u0440\u043E\u0431\u0443 \u043F\u0456\u0437\u043D\u0456\u0448\u0435.",
    'project-pages.generic-error.heading': "\u0429\u043E\u0441\u044C \u043F\u0456\u0448\u043B\u043E \u043D\u0435 \u0437\u0430 \u043F\u043B\u0430\u043D\u043E\u043C...",
    'project-pages.generic-error.title.non-final': "\u0429\u043E\u0441\u044C \u043F\u0456\u0448\u043B\u043E \u043D\u0435 \u0437\u0430 \u043F\u043B\u0430\u043D\u043E\u043C...",
    'project-pages.generic-info-flag.description': "\u0421\u0442\u0430\u043B\u0430\u0441\u044F \u043F\u043E\u043C\u0438\u043B\u043A\u0430. \u041F\u043E\u0432\u0442\u043E\u0440\u0456\u0442\u044C \u0441\u043F\u0440\u043E\u0431\u0443 \u0430\u0431\u043E \u0437\u0432\u0435\u0440\u043D\u0456\u0442\u044C\u0441\u044F \u0434\u043E \u0441\u043B\u0443\u0436\u0431\u0438 \u043F\u0456\u0434\u0442\u0440\u0438\u043C\u043A\u0438, \u044F\u043A\u0449\u043E \u043F\u0440\u043E\u0431\u043B\u0435\u043C\u0430 \u043D\u0435 \u0437\u043D\u0438\u043A\u043D\u0435",
    'project-pages.generic-success-flag.description.live-doc': "\u0423\u0441\u0442\u0430\u043D\u043E\u0432\u043B\u0435\u043D\u043E \u043F\u0456\u0434\u043A\u043B\u044E\u0447\u0435\u043D\u043D\u044F \u0434\u043E \u0456\u043D\u0442\u0435\u0440\u0430\u043A\u0442\u0438\u0432\u043D\u0438\u0445 \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0456\u0432 ({connectedSpaceOrPageName}).",
    'project-pages.generic-success-flag.description.page': "\u0423\u0441\u0442\u0430\u043D\u043E\u0432\u043B\u0435\u043D\u043E \u043F\u0456\u0434\u043A\u043B\u044E\u0447\u0435\u043D\u043D\u044F \u0434\u043E \u0441\u0442\u043E\u0440\u0456\u043D\u043A\u0438 {connectedSpaceOrPageName}.",
    'project-pages.generic-success-flag.description.space': "\u0423\u0441\u0442\u0430\u043D\u043E\u0432\u043B\u0435\u043D\u043E \u043F\u0456\u0434\u043A\u043B\u044E\u0447\u0435\u043D\u043D\u044F \u0434\u043E \u0440\u043E\u0437\u0434\u0456\u043B\u0443 {connectedSpaceOrPageName}.",
    'project-pages.generic-success-flag.heading.live-doc': "\u0406\u043D\u0442\u0435\u0440\u0430\u043A\u0442\u0438\u0432\u043D\u0456 \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0438 \u043F\u0456\u0434\u043A\u043B\u044E\u0447\u0435\u043D\u043E",
    'project-pages.generic-success-flag.heading.page': "\u0421\u0442\u043E\u0440\u0456\u043D\u043A\u0443 \u043F\u0456\u0434\u043A\u043B\u044E\u0447\u0435\u043D\u043E",
    'project-pages.generic-success-flag.heading.space': "\u0420\u043E\u0437\u0434\u0456\u043B \u043F\u0456\u0434\u043A\u043B\u044E\u0447\u0435\u043D\u043E",
    'project-pages.granular-pages.connect-space-dialog.content.create-space-link.link-text': "\u0430\u0431\u043E \u0441\u0442\u0432\u043E\u0440\u0456\u0442\u044C \u043D\u043E\u0432\u0438\u0439 \u0440\u043E\u0437\u0434\u0456\u043B",
    'project-pages.granular-pages.connect-space.button': "\u041F\u0456\u0434\u043A\u043B\u044E\u0447\u0438\u0442\u0438\u0441\u044F \u0434\u043E Confluence",
    'project-pages.granular-pages.connect-space.heading': "\u041F\u0456\u0434\u043A\u043B\u044E\u0447\u0456\u0442\u044C \u0446\u0435\u0439 \u043F\u0440\u043E\u0454\u043A\u0442 \u0434\u043E \u0440\u043E\u0437\u0434\u0456\u043B\u0443 \u0447\u0438 \u0435\u043B\u0435\u043C\u0435\u043D\u0442\u0430 Confluence",
    'project-pages.improvement.contact-support': "\u0437\u0432\u0435\u0440\u043D\u0456\u0442\u044C\u0441\u044F \u0443 \u0441\u043B\u0443\u0436\u0431\u0443 \u043F\u0456\u0434\u0442\u0440\u0438\u043C\u043A\u0438",
    'project-pages.improvement.errors.access-error.description': "\u0417\u0430\u043F\u0438\u0442\u0430\u0439\u0442\u0435 \u0434\u043E\u0441\u0442\u0443\u043F \u0443 \u0430\u0434\u043C\u0456\u043D\u0456\u0441\u0442\u0440\u0430\u0442\u043E\u0440\u0430 \u0441\u0430\u0439\u0442\u0443.",
    'project-pages.improvement.errors.access-error.title': "\u0423 \u0432\u0430\u0441 \u043D\u0435\u043C\u0430\u0454 \u0434\u043E\u0437\u0432\u043E\u043B\u0443 \u043D\u0430 \u043F\u0435\u0440\u0435\u0433\u043B\u044F\u0434 \u0441\u0442\u043E\u0440\u0456\u043D\u043E\u043A \u043F\u0440\u043E\u0435\u043A\u0442\u0443.",
    'project-pages.improvement.errors.page-tree-unknown-error.description': "\u041D\u0435 \u0432\u0434\u0430\u043B\u043E\u0441\u044F \u0432\u0456\u0434\u043E\u0431\u0440\u0430\u0437\u0438\u0442\u0438 \u0441\u0442\u043E\u0440\u0456\u043D\u043A\u0438 \u0432\u0456\u0434 \u043F\u0456\u0434\u043A\u043B\u044E\u0447\u0435\u043D\u043E\u0433\u043E \u0440\u043E\u0437\u0434\u0456\u043B\u0443 Confluence. \u042F\u043A\u0449\u043E \u043E\u043D\u043E\u0432\u043B\u0435\u043D\u043D\u044F \u0441\u0442\u043E\u0440\u0456\u043D\u043A\u0438 \u043D\u0435 \u0432\u0438\u0440\u0456\u0448\u0443\u0454 \u043F\u0440\u043E\u0431\u043B\u0435\u043C\u0443, {contactSupport}.",
    'project-pages.improvement.errors.page-tree-unknown-error.title': "\u041D\u0435 \u0432\u0434\u0430\u043B\u043E\u0441\u044F \u0432\u0456\u0434\u043E\u0431\u0440\u0430\u0437\u0438\u0442\u0438 \u0441\u0442\u043E\u0440\u0456\u043D\u043A\u0438 \u043F\u0440\u043E\u0435\u043A\u0442\u0443.",
    'project-pages.improvement.errors.space-or-page-not-found.description': "\u041F\u0456\u0434\u043A\u043B\u044E\u0447\u0435\u043D\u0456 \u0440\u043E\u0437\u0434\u0456\u043B \u0430\u0431\u043E \u0441\u0442\u043E\u0440\u0456\u043D\u043A\u0443 Confluence \u043F\u0435\u0440\u0435\u043C\u0456\u0449\u0435\u043D\u043E, \u0437\u0430\u0430\u0440\u0445\u0456\u0432\u043E\u0432\u0430\u043D\u043E \u0430\u0431\u043E \u0432\u0438\u0434\u0430\u043B\u0435\u043D\u043E. \u042F\u043A\u0449\u043E \u043F\u043E\u0432\u0442\u043E\u0440\u043D\u0435 \u043F\u0456\u0434\u043A\u043B\u044E\u0447\u0435\u043D\u043D\u044F \u043D\u0435 \u0434\u043E\u043F\u043E\u043C\u043E\u0436\u0435, <link>\u0437\u0432\u0435\u0440\u043D\u0456\u0442\u044C\u0441\u044F \u0434\u043E \u0441\u043B\u0443\u0436\u0431\u0438 \u043F\u0456\u0434\u0442\u0440\u0438\u043C\u043A\u0438</link>.",
    'project-pages.improvement.errors.space-or-page-not-found.title': "\u0420\u043E\u0437\u0434\u0456\u043B \u0430\u0431\u043E \u0441\u0442\u043E\u0440\u0456\u043D\u043A\u0443 \u043D\u0435 \u0437\u043D\u0430\u0439\u0434\u0435\u043D\u043E",
    'project-pages.improvement.errors.unknown-error.description': "\u042F\u043A\u0449\u043E \u043E\u043D\u043E\u0432\u043B\u0435\u043D\u043D\u044F \u0441\u0442\u043E\u0440\u0456\u043D\u043A\u0438 \u043D\u0435 \u0432\u0438\u0440\u0456\u0448\u0443\u0454 \u043F\u0440\u043E\u0431\u043B\u0435\u043C\u0443, {contactSupport}.",
    'project-pages.improvement.errors.unknown-error.title': "\u0417\u0430\u0440\u0430\u0437 \u043C\u0438 \u043D\u0435 \u043C\u043E\u0436\u0435\u043C\u043E \u0432\u0456\u0434\u043E\u0431\u0440\u0430\u0437\u0438\u0442\u0438 \u0441\u0442\u043E\u0440\u0456\u043D\u043A\u0438 \u043F\u0440\u043E\u0435\u043A\u0442\u0443.",
    'project-pages.improvement.feature1': "\u0414\u043E\u0441\u0442\u0443\u043F \u0434\u043E \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0456\u0432 \u0456 \u0457\u0445 \u0441\u0442\u0432\u043E\u0440\u0435\u043D\u043D\u044F \u0431\u0435\u0437 \u0432\u0438\u0445\u043E\u0434\u0443 \u0437 Jira.",
    'project-pages.improvement.feature2': "\u0428\u0430\u0431\u043B\u043E\u043D\u0438, \u043F\u043B\u0430\u043D\u0438 \u0441\u043F\u0440\u0438\u043D\u0442\u0443 \u0442\u043E\u0449\u043E.",
    'project-pages.improvement.feature3': "\u0421\u0438\u043D\u0445\u0440\u043E\u043D\u0456\u0437\u0430\u0446\u0456\u044F \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0456\u0432 \u0456\u0437 Jira \u0434\u043B\u044F \u0430\u0432\u0442\u043E\u043C\u0430\u0442\u0438\u0447\u043D\u043E\u0433\u043E \u043E\u043D\u043E\u0432\u043B\u0435\u043D\u043D\u044F.",
    'project-pages.improvement.heading-info': "\u041D\u0430\u043A\u043E\u043F\u0438\u0447\u0443\u0439\u0442\u0435 \u0437\u043D\u0430\u043D\u043D\u044F \u0442\u0430 \u0434\u043E\u0441\u0432\u0456\u0434 \u0441\u0432\u043E\u0454\u0457 \u043A\u043E\u043C\u0430\u043D\u0434\u0438 \u0439 \u043F\u043E\u043A\u0440\u0430\u0449\u0443\u0439\u0442\u0435 \u043C\u0435\u0442\u043E\u0434\u0438 \u0440\u043E\u0431\u043E\u0442\u0438.",
    'project-pages.improvement.heading-info-v2': "\u0421\u0442\u0432\u043E\u0440\u0456\u0442\u044C \u0454\u0434\u0438\u043D\u0435 \u0440\u043E\u0437\u0442\u0430\u0448\u0443\u0432\u0430\u043D\u043D\u044F \u0434\u043B\u044F \u0432\u0441\u0456\u0454\u0457 \u043F\u0440\u043E\u0454\u043A\u0442\u043D\u043E\u0457 \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0430\u0446\u0456\u0457 \u0432\u0430\u0448\u043E\u0457 \u043A\u043E\u043C\u0430\u043D\u0434\u0438",
    'project-pages.improvement.learn-more-button': "\u0414\u043E\u043A\u043B\u0430\u0434\u043D\u0456\u0448\u0435",
    'project-pages.improvement.powered-by': "\u041D\u0430 \u043F\u043B\u0430\u0442\u0444\u043E\u0440\u043C\u0456",
    'project-pages.improvement.powered-by.tooltip': "\u0412\u0456\u0434\u043A\u0440\u0438\u0442\u0438 Confluence \u043D\u0430 \u043D\u043E\u0432\u0456\u0439 \u0432\u043A\u043B\u0430\u0434\u0446\u0456",
    'project-pages.improvement.preview-teaser': "\u0420\u043E\u0437\u0431\u043B\u043E\u043A\u0443\u0439\u0442\u0435 \u0434\u043E\u0441\u0442\u0443\u043F \u0434\u043E \u0448\u0430\u0431\u043B\u043E\u043D\u0456\u0432, \u0441\u0442\u043E\u0440\u0456\u043D\u043E\u043A \u043F\u0440\u043E\u0435\u043A\u0442\u0456\u0432 \u0442\u043E\u0449\u043E.",
    'project-pages.improvement.provisioning-info-modal.seamlessly-update-stakeholders.description': "<p>\u0421\u0442\u0435\u0436\u0442\u0435 \u0437\u0430 \u0430\u043A\u0442\u0443\u0430\u043B\u044C\u043D\u0456\u0441\u0442\u044E \u0437\u0432\u0456\u0442\u0456\u0432 \u0434\u043E \u043F\u0440\u043E\u0454\u043A\u0442\u0456\u0432 \u0437\u0430\u0432\u0434\u044F\u043A\u0438 \u043C\u0456\u0442\u043A\u0430\u043C \u0441\u0442\u0430\u0442\u0443\u0441\u0443, \u0449\u043E \u043E\u043D\u043E\u0432\u043B\u044E\u044E\u0442\u044C\u0441\u044F \u0430\u0432\u0442\u043E\u043C\u0430\u0442\u0438\u0447\u043D\u043E.</p> <p>\u041F\u0440\u043E\u0441\u0442\u043E \u0434\u043E\u0434\u0430\u0439\u0442\u0435 \u043F\u043E\u0441\u0438\u043B\u0430\u043D\u043D\u044F \u043D\u0430 \u0437\u0430\u044F\u0432\u043A\u0443 Jira \u0432 \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0456, \u0456 \u0432 \u043D\u044C\u043E\u043C\u0443 \u0430\u0432\u0442\u043E\u043C\u0430\u0442\u0438\u0447\u043D\u043E \u0432\u0456\u0434\u043E\u0431\u0440\u0430\u0437\u0438\u0442\u044C\u0441\u044F \u043C\u0456\u0442\u043A\u0430 \u0441\u0442\u0430\u0442\u0443\u0441\u0443, \u044F\u043A\u0430 \u043E\u043D\u043E\u0432\u043B\u044E\u0432\u0430\u0442\u0438\u043C\u0435\u0442\u044C\u0441\u044F \u0441\u0438\u043D\u0445\u0440\u043E\u043D\u043D\u043E \u0456\u0437 \u0437\u0430\u044F\u0432\u043A\u043E\u044E, \u0442\u043E\u0436 \u0432\u0430\u043C \u043D\u0435 \u0434\u043E\u0432\u0435\u0434\u0435\u0442\u044C\u0441\u044F \u0432\u0438\u0442\u0440\u0430\u0447\u0430\u0442\u0438 \u0447\u0430\u0441 \u043D\u0430 \u0441\u0442\u0432\u043E\u0440\u0435\u043D\u043D\u044F \u0437\u0432\u0456\u0442\u0456\u0432 \u0432\u0440\u0443\u0447\u043D\u0443.</p>",
    'project-pages.improvement.provisioning-info-modal.seamlessly-update-stakeholders.title': "\u0417 \u043B\u0435\u0433\u043A\u0456\u0441\u0442\u044E \u0442\u0440\u0438\u043C\u0430\u0439\u0442\u0435 \u043F\u0430\u0440\u0442\u043D\u0435\u0440\u0456\u0432 \u0443 \u043A\u0443\u0440\u0441\u0456 \u043F\u043E\u0434\u0456\u0439",
    'project-pages.improvement.provisioning-info-modal.unify-documentation-standards.description': "<p>\u0421\u0442\u0432\u043E\u0440\u044E\u0439\u0442\u0435 \u043F\u043E\u0441\u043B\u0456\u0434\u043E\u0432\u043D\u0443 \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0430\u0446\u0456\u044E \u0437\u0430 \u0434\u043E\u043F\u043E\u043C\u043E\u0433\u043E\u044E \u043D\u0430\u0448\u0438\u0445 \u0432\u0431\u0443\u0434\u043E\u0432\u0430\u043D\u0438\u0445 \u0448\u0430\u0431\u043B\u043E\u043D\u0456\u0432. \u0412\u043E\u043D\u0438 \u043F\u0440\u043E\u0441\u0442\u0456 \u0443 \u0432\u0438\u043A\u043E\u0440\u0438\u0441\u0442\u0430\u043D\u043D\u0456 \u0439 \u043B\u0435\u0433\u043A\u043E \u043D\u0430\u043B\u0430\u0448\u0442\u043E\u0432\u0443\u044E\u0442\u044C\u0441\u044F \u0432\u0456\u0434\u043F\u043E\u0432\u0456\u0434\u043D\u043E \u0434\u043E \u0432\u0430\u0448\u0438\u0445 \u043F\u043E\u0442\u0440\u0435\u0431.</p> <p>\u0412\u0438 \u043C\u043E\u0436\u0435\u0442\u0435 \u0432\u0438\u043A\u043E\u0440\u0438\u0441\u0442\u043E\u0432\u0443\u0432\u0430\u0442\u0438 \u0448\u0430\u0431\u043B\u043E\u043D\u0438 \u0431\u0435\u0437\u043F\u043E\u0441\u0435\u0440\u0435\u0434\u043D\u044C\u043E \u043D\u0430 \u0441\u0442\u043E\u0440\u0456\u043D\u043A\u0430\u0445 \u043F\u0440\u043E\u0454\u043A\u0442\u0456\u0432, \u0442\u043E\u043C\u0443 \u0432\u0430\u043C \u043D\u0456\u043A\u043E\u043B\u0438 \u043D\u0435 \u0434\u043E\u0432\u0435\u0434\u0435\u0442\u044C\u0441\u044F \u0437\u0430\u043B\u0438\u0448\u0430\u0442\u0438 \u043F\u043E\u0442\u043E\u0447\u043D\u0456 \u0441\u043F\u0440\u0430\u0432\u0438. \u041F\u0435\u0440\u0435\u0433\u043B\u044F\u043D\u044C\u0442\u0435 \u0432\u0441\u0456 \u0448\u0430\u0431\u043B\u043E\u043D\u0438 <a>\u0442\u0443\u0442</a>.</p>",
    'project-pages.improvement.provisioning-info-modal.unify-documentation-standards.title': "\u0423\u043D\u0456\u0444\u0456\u043A\u0443\u0439\u0442\u0435 \u0432\u043B\u0430\u0441\u043D\u0456 \u0441\u0442\u0430\u043D\u0434\u0430\u0440\u0442\u0438 \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0430\u0446\u0456\u0457",
    'project-pages.improvement.provisioning-info-modal.your-project-pages-in-jira.description': "<p>\u041E\u0442\u0440\u0438\u043C\u0430\u0439\u0442\u0435 \u0454\u0434\u0438\u043D\u0435 \u0434\u0436\u0435\u0440\u0435\u043B\u043E \u0434\u043E\u0441\u0442\u043E\u0432\u0456\u0440\u043D\u0438\u0445 \u0434\u0430\u043D\u0438\u0445 \u0434\u043B\u044F \u0432\u0430\u0436\u043B\u0438\u0432\u043E\u0457 \u0456\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0456\u0457: \u043F\u0440\u043E\u0441\u0442\u043E \u0441\u0442\u0432\u043E\u0440\u044E\u0439\u0442\u0435 \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0430\u0446\u0456\u044E \u0442\u0430 \u043A\u0435\u0440\u0443\u0439\u0442\u0435 \u043D\u0435\u044E \u043D\u0430 \u0432\u043A\u043B\u0430\u0434\u0446\u0456 \u0441\u0442\u043E\u0440\u0456\u043D\u043E\u043A \u043F\u0440\u043E\u0435\u043A\u0442\u0443 \u0432 Jira.</p> <p>\u0427\u0438 \u0437\u043D\u0430\u043B\u0438 \u0432\u0438, \u0449\u043E \u0437\u0456 \u0441\u0442\u043E\u0440\u0456\u043D\u043A\u0430\u043C\u0438 \u043F\u0440\u043E\u0454\u043A\u0442\u0456\u0432 \u043C\u043E\u0436\u043D\u0430 \u043F\u0440\u0430\u0446\u044E\u0432\u0430\u0442\u0438 \u0432 Confluence? \u0426\u044F \u0444\u0443\u043D\u043A\u0446\u0456\u044F \u0431\u0435\u0437\u043A\u043E\u0448\u0442\u043E\u0432\u043D\u0430 \u0434\u043B\u044F 10\xa0\u043A\u043E\u0440\u0438\u0441\u0442\u0443\u0432\u0430\u0447\u0456\u0432. \u0417\u0430\u043F\u0440\u043E\u0441\u0456\u0442\u044C \u0440\u0435\u0448\u0442\u0443 \u0432\u0430\u0448\u043E\u0457 \u043A\u043E\u043C\u0430\u043D\u0434\u0438 \u0432 \u0440\u043E\u0437\u0434\u0456\u043B\u0456 \u043D\u0430\u043B\u0430\u0448\u0442\u0443\u0432\u0430\u043D\u044C \u0430\u0434\u043C\u0456\u043D\u0456\u0441\u0442\u0440\u0430\u0442\u043E\u0440\u0430.</p>",
    'project-pages.improvement.provisioning-info-modal.your-project-pages-in-jira.title': "\u0421\u0442\u043E\u0440\u0456\u043D\u043A\u0438 \u0432\u0430\u0448\u0438\u0445 \u043F\u0440\u043E\u0454\u043A\u0442\u0456\u0432 \u0431\u0435\u0437\u043F\u043E\u0441\u0435\u0440\u0435\u0434\u043D\u044C\u043E \u0432 Jira",
    'project-pages.improvement.templates-sidebar.better-together-templates-header': "\u0428\u0430\u0431\u043B\u043E\u043D\u0438, \u0456\u043D\u0442\u0435\u0433\u0440\u043E\u0432\u0430\u043D\u0456 \u0437 \u0432\u0430\u0448\u0438\u043C\u0438 \u0434\u0430\u043D\u0438\u043C\u0438 Jira",
    'project-pages.improvement.templates.better-together-preview-teaser': "\u0406\u043D\u0442\u0435\u0433\u0440\u043E\u0432\u0430\u043D\u043E \u0437 \u0434\u0430\u043D\u0438\u043C\u0438 Jira",
    'project-pages.improvement.templates.blank-page.description': "\u0421\u0442\u0432\u043E\u0440\u0456\u0442\u044C \u0441\u0442\u043E\u0440\u0456\u043D\u043A\u0443 \u0437 \u043D\u0443\u043B\u044F.",
    'project-pages.improvement.templates.blank-page.name': "\u0427\u0438\u0441\u0442\u0430 \u0441\u0442\u043E\u0440\u0456\u043D\u043A\u0430",
    'project-pages.improvement.templates.decision.description': "\u0417\u0430\u043F\u0438\u0441\u0443\u0439\u0442\u0435 \u0432\u0430\u0436\u043B\u0438\u0432\u0456 \u0440\u0456\u0448\u0435\u043D\u043D\u044F \u0449\u043E\u0434\u043E \u043F\u0440\u043E\u0435\u043A\u0442\u0443 \u0439 \u043E\u0431\u0433\u043E\u0432\u043E\u0440\u044E\u0439\u0442\u0435 \u0457\u0445 \u0456\u0437 \u043A\u043E\u043C\u0430\u043D\u0434\u043E\u044E.",
    'project-pages.improvement.templates.decision.name': "\u0420\u0456\u0448\u0435\u043D\u043D\u044F",
    'project-pages.improvement.templates.meeting-notes.description': "\u041F\u043B\u0430\u043D\u0443\u0439\u0442\u0435 \u0437\u0443\u0441\u0442\u0440\u0456\u0447\u0456, \u0437\u0430\u043F\u0438\u0441\u0443\u0439\u0442\u0435 \u0456\u0434\u0435\u0457 \u0439 \u043E\u0431\u0433\u043E\u0432\u043E\u0440\u044E\u0439\u0442\u0435 \u0437\u0430\u0432\u0434\u0430\u043D\u043D\u044F \u0437 \u043A\u043E\u043C\u0430\u043D\u0434\u043E\u044E.",
    'project-pages.improvement.templates.meeting-notes.name': "\u041F\u0440\u0438\u043C\u0456\u0442\u043A\u0438 \u043F\u0440\u043E \u0437\u0443\u0441\u0442\u0440\u0456\u0447",
    'project-pages.improvement.templates.post-expand.more': "\u0411\u0456\u043B\u044C\u0448\u0435 \u0448\u0430\u0431\u043B\u043E\u043D\u0456\u0432",
    'project-pages.improvement.templates.post-expand.more.tooltip': "\u041F\u0435\u0440\u0435\u0433\u043B\u044F\u043D\u0443\u0442\u0438 \u0432\u0441\u0456 \u0448\u0430\u0431\u043B\u043E\u043D\u0438 \u0432 Confluence",
    'project-pages.improvement.templates.post-expand.subtitle': "\u041F\u043E\u043F\u0443\u043B\u044F\u0440\u043D\u0456 \u0448\u0430\u0431\u043B\u043E\u043D\u0438",
    'project-pages.improvement.templates.post-expand.title': "\u0421\u0442\u0432\u043E\u0440\u0435\u043D\u043D\u044F \u0441\u0442\u043E\u0440\u0456\u043D\u043A\u0438",
    'project-pages.improvement.templates.pre-expand.more': "\u0414\u0456\u0437\u043D\u0430\u0442\u0438\u0441\u044F \u0431\u0456\u043B\u044C\u0448\u0435 \u043F\u0440\u043E \u0448\u0430\u0431\u043B\u043E\u043D\u0438",
    'project-pages.improvement.templates.pre-expand.subtitle': "\u041F\u043E\u043F\u0443\u043B\u044F\u0440\u043D\u0456 \u0441\u0435\u0440\u0435\u0434 \u0441\u0445\u043E\u0436\u0438\u0445 \u043D\u0430 \u0432\u0430\u0448\u0443 \u043A\u043E\u043C\u0430\u043D\u0434",
    'project-pages.improvement.templates.pre-expand.title': "\u041F\u043E\u043F\u0435\u0440\u0435\u0434\u043D\u0456\u0439 \u043F\u0435\u0440\u0435\u0433\u043B\u044F\u0434 \u0448\u0430\u0431\u043B\u043E\u043D\u0456\u0432",
    'project-pages.improvement.templates.product-requirements.description': "\u0412\u0438\u0437\u043D\u0430\u0447\u0430\u0439\u0442\u0435, \u0432\u0456\u0434\u0441\u0442\u0435\u0436\u0443\u0439\u0442\u0435 \u0439 \u043E\u0446\u0456\u043D\u044E\u0439\u0442\u0435 \u043E\u0431\u0441\u044F\u0433 \u0432\u0438\u043C\u043E\u0433 \u0434\u043E \u043F\u0440\u043E\u0434\u0443\u043A\u0442\u0443 \u0447\u0438 \u0444\u0443\u043D\u043A\u0446\u0456\u0457.",
    'project-pages.improvement.templates.product-requirements.name': "\u0412\u0438\u043C\u043E\u0433\u0438 \u0434\u043E \u043F\u0440\u043E\u0434\u0443\u043A\u0442\u0443",
    'project-pages.improvement.templates.retrospective.description': "\u0429\u043E \u043F\u0440\u043E\u0439\u0448\u043B\u043E \u0432\u0434\u0430\u043B\u043E? \u0410 \u0449\u043E \u043C\u043E\u0436\u043D\u0430 \u0431\u0443\u043B\u043E \u0431 \u0432\u0434\u043E\u0441\u043A\u043E\u043D\u0430\u043B\u0438\u0442\u0438? \u0421\u043F\u0456\u043B\u044C\u043D\u0456 \u0437\u0443\u0441\u0438\u043B\u043B\u044F \u043A\u043E\u043C\u0430\u043D\u0434\u0438 \u0434\u043B\u044F \u043F\u043E\u043A\u0440\u0430\u0449\u0435\u043D\u043D\u044F \u0440\u043E\u0431\u043E\u0442\u0438.",
    'project-pages.improvement.templates.retrospective.name': "\u0420\u0435\u0442\u0440\u043E\u0441\u043F\u0435\u043A\u0442\u0438\u0432\u0430",
    'project-pages.improvement.templates.template.disabled-tooltip': "\u0421\u043F\u043E\u0447\u0430\u0442\u043A\u0443 \u043F\u0456\u0434\u043A\u043B\u044E\u0447\u0456\u0442\u044C \u0440\u043E\u0437\u0434\u0456\u043B Confluence",
    'project-pages.improvement.templates.tutorial.content.confluence-templates': "<b>\u0417\u0430\u043E\u0449\u0430\u0434\u0436\u0443\u0439\u0442\u0435 \u0447\u0430\u0441 \u0456 \u043C\u0456\u043D\u0456\u043C\u0456\u0437\u0443\u0439\u0442\u0435 \u0440\u0443\u0447\u043D\u0443 \u0440\u043E\u0431\u043E\u0442\u0443</b>. \u0423 Confluence \u0431\u0430\u0433\u0430\u0442\u043E <a>\u0448\u0430\u0431\u043B\u043E\u043D\u0456\u0432</a> \u0441\u0442\u043E\u0440\u0456\u043D\u043E\u043A, \u0442\u043E\u0436 \u0432\u0430\u043C \u043D\u0435 \u0434\u043E\u0432\u0435\u0434\u0435\u0442\u044C\u0441\u044F \u043F\u043E\u0447\u0438\u043D\u0430\u0442\u0438 \u0437 \u043D\u0443\u043B\u044F. \u0421\u0442\u0432\u043E\u0440\u044E\u0439\u0442\u0435 \u0442\u0435\u0445\u043D\u0456\u0447\u043D\u0456 \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0438, \u043F\u043E\u0441\u0456\u0431\u043D\u0438\u043A\u0438 \u0437 \u0443\u0441\u0443\u043D\u0435\u043D\u043D\u044F \u043D\u0435\u043F\u043E\u043B\u0430\u0434\u043E\u043A, \u043F\u043B\u0430\u043D\u0438 \u0434\u043B\u044F \u043F\u0440\u043E\u0454\u043A\u0442\u0456\u0432, \u0432\u0438\u043C\u043E\u0433\u0438 \u0434\u043E \u043F\u0440\u043E\u0434\u0443\u043A\u0442\u0443 \u0442\u043E\u0449\u043E.",
    'project-pages.improvement.templates.tutorial.content.edit-and-format': "<b>\u0417 \u043B\u0435\u0433\u043A\u0456\u0441\u0442\u044E \u0440\u0435\u0434\u0430\u0433\u0443\u0439\u0442\u0435 \u0439 \u0444\u043E\u0440\u043C\u0430\u0442\u0443\u0439\u0442\u0435 \u0442\u0435\u043A\u0441\u0442.</b> \u0417\u0430\u0441\u0442\u043E\u0441\u043E\u0432\u0443\u0439\u0442\u0435 \u0441\u0442\u0430\u043D\u0434\u0430\u0440\u0442\u043D\u0435 \u0444\u043E\u0440\u043C\u0430\u0442\u0443\u0432\u0430\u043D\u043D\u044F Word \u0437\u0430 \u0434\u043E\u043F\u043E\u043C\u043E\u0433\u043E\u044E \u043C\u0435\u043D\u044E \u0440\u0435\u0434\u0430\u0433\u0443\u0432\u0430\u043D\u043D\u044F \u0430\u0431\u043E \u0432\u0438\u043A\u043E\u0440\u0438\u0441\u0442\u043E\u0432\u0443\u0439\u0442\u0435 <b>/</b>, \u0449\u043E\u0431 \u0430\u043A\u0442\u0438\u0432\u0443\u0432\u0430\u0442\u0438 \u0431\u0435\u0437\u043B\u0456\u0447 \u043A\u043E\u0440\u0438\u0441\u043D\u0438\u0445 \u0456\u043D\u0442\u0435\u0433\u0440\u0430\u0446\u0456\u0439. \u0429\u043E\u0431 \u0432\u0441\u0442\u0430\u0432\u0438\u0442\u0438 \u0442\u0430\u0431\u043B\u0438\u0446\u044E, \u0432\u0432\u0435\u0434\u0456\u0442\u044C <c>/\u0442\u0430\u0431\u043B\u0438\u0446\u044F</c>, \u0430 \u044F\u043A\u0449\u043E \u043F\u043E\u0442\u0440\u0456\u0431\u043D\u043E \u0434\u043E\u0434\u0430\u0442\u0438 \u0437\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u043D\u044F \u2014 <c>/\u0437\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u043D\u044F</c>. \u0422\u0430\u043A\u043E\u0436 \u043C\u043E\u0436\u043D\u0430 \u0432\u0441\u0442\u0430\u0432\u0438\u0442\u0438 \u043F\u043E\u0441\u0438\u043B\u0430\u043D\u043D\u044F Dropbox (<c>/dropbox</c>), \u0456\u043D\u0441\u0442\u0440\u0443\u043C\u0435\u043D\u0442\u0438 Microsoft Office (<c>/microsoft</c>) \u0430\u0431\u043E \u0434\u043E\u0448\u043A\u0438 \u0442\u0430 \u043A\u0430\u0440\u0442\u043A\u0438 Trello (<c>/trello</c>).",
    'project-pages.improvement.templates.tutorial.content.forward-slash-prompt': "\u0412\u0432\u0435\u0434\u0456\u0442\u044C /, \u0430 \u043F\u043E\u0442\u0456\u043C \u0434\u043E\u0434\u0430\u0439\u0442\u0435 \u0441\u043B\u043E\u0432\u043E \xab\u0442\u0430\u0431\u043B\u0438\u0446\u044F\xbb \u0430\u0431\u043E \xab\u0437\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u043D\u044F\xbb",
    'project-pages.improvement.templates.tutorial.content.getting-started-tips': "\u041E\u0441\u044C \u043A\u0456\u043B\u044C\u043A\u0430 \u043F\u043E\u0440\u0430\u0434 \u0434\u043B\u044F \u043F\u043E\u0447\u0430\u0442\u043A\u0443 \u0440\u043E\u0431\u043E\u0442\u0438:",
    'project-pages.improvement.templates.tutorial.content.handy-links': "\u041A\u043E\u0440\u0438\u0441\u043D\u0456 \u043F\u043E\u0441\u0438\u043B\u0430\u043D\u043D\u044F",
    'project-pages.improvement.templates.tutorial.content.jira-and-confluence': "\u0412\u0438\u043A\u043E\u0440\u0438\u0441\u0442\u043E\u0432\u0443\u0439\u0442\u0435 Jira \u0442\u0430 Confluence \u0440\u0430\u0437\u043E\u043C",
    'project-pages.improvement.templates.tutorial.content.jira-charts': "\u0421\u0442\u0432\u043E\u0440\u044E\u0439\u0442\u0435 \u0434\u0456\u0430\u0433\u0440\u0430\u043C\u0438 \u043D\u0430 \u0441\u0442\u043E\u0440\u0456\u043D\u043A\u0430\u0445 \u0437\u0430 \u0434\u043E\u043F\u043E\u043C\u043E\u0433\u043E\u044E \u0434\u0430\u043D\u0438\u0445, \u044F\u043A\u0456 \u043D\u0430\u0434\u0445\u043E\u0434\u044F\u0442\u044C \u0432\u0456\u0434 Jira \u0432 \u0440\u0435\u0430\u043B\u044C\u043D\u043E\u043C\u0443 \u0447\u0430\u0441\u0456. \u0412\u0432\u0435\u0434\u0456\u0442\u044C <c>/\u0434\u0456\u0430\u0433\u0440\u0430\u043C\u0438 Jira</c>.",
    'project-pages.improvement.templates.tutorial.content.jira-links': "\u041F\u043E\u0432\u2019\u044F\u0437\u0443\u0439\u0442\u0435 \u0437\u0430\u0432\u0434\u0430\u043D\u043D\u044F \u0432 Jira \u0437 \u0431\u0443\u0434\u044C-\u044F\u043A\u0438\u043C \u0435\u043B\u0435\u043C\u0435\u043D\u0442\u043E\u043C \u0441\u0442\u043E\u0440\u0456\u043D\u043A\u0438. \u041F\u043E\u0441\u0438\u043B\u0430\u043D\u043D\u044F \u043D\u0430 \u0441\u0442\u043E\u0440\u0456\u043D\u0446\u0456 \u043E\u043D\u043E\u0432\u043B\u044E\u0432\u0430\u0442\u0438\u043C\u0435\u0442\u044C\u0441\u044F \u0432 \u0440\u0435\u0430\u043B\u044C\u043D\u043E\u043C\u0443 \u0447\u0430\u0441\u0456 \u0434\u043B\u044F \u0432\u0456\u0434\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u043D\u044F \u0437\u043C\u0456\u043D, \u044F\u043A\u0456 \u0432\u0438 \u0432\u043D\u043E\u0441\u0438\u0442\u0435 \u0432 \u0437\u0430\u0432\u0434\u0430\u043D\u043D\u044F Jira. \u0412\u0432\u0435\u0434\u0456\u0442\u044C <c>/Jira</c>.",
    'project-pages.improvement.templates.tutorial.content.jira-links-issue-term-refresh': "\u041F\u043E\u0432\u2019\u044F\u0437\u0443\u0439\u0442\u0435 \u0435\u043B\u0435\u043C\u0435\u043D\u0442 \u0437\u0430\u0432\u0434\u0430\u043D\u043D\u044F \u0432 Jira \u0437 \u0431\u0443\u0434\u044C-\u044F\u043A\u0438\u043C \u043E\u0431\u2019\u0454\u043A\u0442\u043E\u043C \u043D\u0430 \u0441\u0442\u043E\u0440\u0456\u043D\u0446\u0456. \u041F\u043E\u0441\u0438\u043B\u0430\u043D\u043D\u044F \u043D\u0430 \u0441\u0442\u043E\u0440\u0456\u043D\u0446\u0456 \u043E\u043D\u043E\u0432\u043B\u044E\u0432\u0430\u0442\u0438\u043C\u0435\u0442\u044C\u0441\u044F \u0432 \u0440\u0435\u0430\u043B\u044C\u043D\u043E\u043C\u0443 \u0447\u0430\u0441\u0456 \u0434\u043B\u044F \u0432\u0456\u0434\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u043D\u044F \u0437\u043C\u0456\u043D, \u044F\u043A\u0456 \u0432\u0438 \u0432\u043D\u043E\u0441\u0438\u0442\u0435 \u0432 \u0435\u043B\u0435\u043C\u0435\u043D\u0442 \u0437\u0430\u0432\u0434\u0430\u043D\u043D\u044F Jira. \u0412\u0432\u0435\u0434\u0456\u0442\u044C <c>/Jira</c>.",
    'project-pages.improvement.templates.tutorial.content.jira-links.non-final-issue-term-refresh': "\u041F\u043E\u0432\u2019\u044F\u0437\u0443\u0439\u0442\u0435 \u0435\u043B\u0435\u043C\u0435\u043D\u0442 \u0437\u0430\u0432\u0434\u0430\u043D\u043D\u044F \u0432 Jira \u0437 \u0431\u0443\u0434\u044C-\u044F\u043A\u0438\u043C \u043E\u0431\u2019\u0454\u043A\u0442\u043E\u043C \u043D\u0430 \u0441\u0442\u043E\u0440\u0456\u043D\u0446\u0456. \u041F\u043E\u0441\u0438\u043B\u0430\u043D\u043D\u044F \u043D\u0430 \u0441\u0442\u043E\u0440\u0456\u043D\u0446\u0456 \u043E\u043D\u043E\u0432\u043B\u044E\u0432\u0430\u0442\u0438\u043C\u0435\u0442\u044C\u0441\u044F \u0432 \u0440\u0435\u0430\u043B\u044C\u043D\u043E\u043C\u0443 \u0447\u0430\u0441\u0456 \u0432\u0456\u0434\u043F\u043E\u0432\u0456\u0434\u043D\u043E \u0434\u043E \u0437\u043C\u0456\u043D, \u044F\u043A\u0456 \u0432\u0438 \u0432\u043D\u043E\u0441\u0438\u0442\u0435 \u0432 \u0435\u043B\u0435\u043C\u0435\u043D\u0442 \u0437\u0430\u0432\u0434\u0430\u043D\u043D\u044F. \u0412\u0432\u0435\u0434\u0456\u0442\u044C <c>/Jira</c>.",
    'project-pages.improvement.templates.tutorial.content.jira-roadmaps': "\u0412\u0431\u0443\u0434\u043E\u0432\u0443\u0439\u0442\u0435 \u043D\u0430 \u0441\u0442\u043E\u0440\u0456\u043D\u043A\u0443 \u0456\u043D\u0442\u0435\u0440\u0430\u043A\u0442\u0438\u0432\u043D\u0456 \u043F\u043B\u0430\u043D\u0438 \u0440\u043E\u0437\u0440\u043E\u0431\u043A\u0438 \u0430\u0431\u043E \u0447\u0430\u0441\u043E\u0432\u0456 \u0448\u043A\u0430\u043B\u0438 \u0437\u0430 \u0434\u043E\u043F\u043E\u043C\u043E\u0433\u043E\u044E \u043F\u0440\u043E\u0454\u043A\u0442\u0456\u0432 Jira. \u0412\u0432\u0435\u0434\u0456\u0442\u044C <c>/\u043F\u043B\u0430\u043D \u0440\u043E\u0437\u0440\u043E\u0431\u043A\u0438 Jira</c>.",
    'project-pages.improvement.templates.tutorial.content.jira-timeline': "\u0412\u0431\u0443\u0434\u043E\u0432\u0443\u0439\u0442\u0435 \u043D\u0430 \u0441\u0442\u043E\u0440\u0456\u043D\u043A\u0443 \u0456\u043D\u0442\u0435\u0440\u0430\u043A\u0442\u0438\u0432\u043D\u0456 \u0447\u0430\u0441\u043E\u0432\u0456 \u0448\u043A\u0430\u043B\u0438 \u0437\u0430 \u0434\u043E\u043F\u043E\u043C\u043E\u0433\u043E\u044E \u043F\u0440\u043E\u0454\u043A\u0442\u0456\u0432 Jira. \u0412\u0432\u0435\u0434\u0456\u0442\u044C <c>/jira timeline</c>.",
    'project-pages.improvement.templates.tutorial.content.shipping-speed-statistic': "76\xa0% \u043A\u043B\u0456\u0454\u043D\u0442\u0456\u0432 Jira Software \u0437\u0430\u0443\u0432\u0430\u0436\u0438\u043B\u0438, \u0449\u043E \u043F\u0456\u0441\u043B\u044F \u0434\u043E\u0434\u0430\u0432\u0430\u043D\u043D\u044F Confluence \u043F\u0440\u043E\u0446\u0435\u0441 \u0437\u0434\u0430\u0447\u0456 \u043F\u0440\u043E\u0454\u043A\u0442\u0456\u0432 \u043F\u0440\u0438\u0448\u0432\u0438\u0434\u0448\u0438\u0432\u0441\u044F",
    'project-pages.improvement.templates.tutorial.content.shipping-speed-statistic.spork-rebranding': "76\xa0% \u043A\u043B\u0456\u0454\u043D\u0442\u0456\u0432 Jira \u0437\u0430\u0443\u0432\u0430\u0436\u0438\u043B\u0438, \u0449\u043E \u043F\u0456\u0441\u043B\u044F \u0434\u043E\u0434\u0430\u0432\u0430\u043D\u043D\u044F Confluence \u043F\u0440\u043E\u0446\u0435\u0441 \u0437\u0434\u0430\u0447\u0456 \u043F\u0440\u043E\u0454\u043A\u0442\u0456\u0432 \u043F\u0440\u0438\u0448\u0432\u0438\u0434\u0448\u0438\u0432\u0441\u044F",
    'project-pages.improvement.templates.tutorial.content.spaces-and-pages': "<b>\u0412\u0438\u043A\u043E\u0440\u0438\u0441\u0442\u0430\u043D\u043D\u044F \u0440\u043E\u0437\u0434\u0456\u043B\u0456\u0432 \u0456 \u0441\u0442\u043E\u0440\u0456\u043D\u043E\u043A</b>. \u0411\u0443\u0434\u044C-\u044F\u043A\u0438\u0439 \u0441\u0430\u0439\u0442 Confluence \u0441\u043A\u043B\u0430\u0434\u0430\u0454\u0442\u044C\u0441\u044F \u0437 \u0440\u043E\u0437\u0434\u0456\u043B\u0456\u0432, \u0449\u043E \u0434\u0430\u044E\u0442\u044C \u0437\u043C\u043E\u0433\u0443 \u0437\u0440\u0443\u0447\u043D\u043E \u0432\u043F\u043E\u0440\u044F\u0434\u043A\u043E\u0432\u0443\u0432\u0430\u0442\u0438 \u0441\u0442\u043E\u0440\u0456\u043D\u043A\u0438 \u0437\u0430 \u043A\u0430\u0442\u0435\u0433\u043E\u0440\u0456\u044F\u043C\u0438. \u0420\u043E\u0437\u0434\u0456\u043B\u0438 \u043C\u043E\u0436\u043D\u0430 \u043F\u043E\u0440\u0456\u0432\u043D\u044F\u0442\u0438 \u0437 \u0440\u0456\u0437\u043D\u0438\u043C\u0438 \u043F\u0430\u043F\u043A\u0430\u043C\u0438 \u0430\u0431\u043E \u043F\u0440\u043E\u0454\u043A\u0442\u0430\u043C\u0438, \u0430 \u0441\u0442\u043E\u0440\u0456\u043D\u043A\u0438\xa0\u2014 \u0437 \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0430\u043C\u0438, \u0449\u043E \u0432\u0445\u043E\u0434\u044F\u0442\u044C \u0434\u043E \u0446\u0438\u0445 \u043F\u0430\u043F\u043E\u043A \u0430\u0431\u043E \u043F\u0440\u043E\u0454\u043A\u0442\u0456\u0432. <a>\u0414\u043E\u043A\u043B\u0430\u0434\u043D\u0456\u0448\u0435 \u043F\u0440\u043E \u0432\u0438\u043A\u043E\u0440\u0438\u0441\u0442\u0430\u043D\u043D\u044F \u0440\u043E\u0437\u0434\u0456\u043B\u0456\u0432</a>",
    'project-pages.improvement.templates.tutorial.content.try-it-now': "\u041F\u043E\u0432\u0442\u043E\u0440\u0438\u0442\u0438 \u0441\u043F\u0440\u043E\u0431\u0443",
    'project-pages.improvement.templates.tutorial.description': "\u0414\u0456\u0437\u043D\u0430\u0439\u0442\u0435\u0441\u044F, \u044F\u043A \u0440\u0435\u0434\u0430\u0433\u0443\u0432\u0430\u0442\u0438 \u0441\u0442\u043E\u0440\u0456\u043D\u043A\u0443.",
    'project-pages.improvement.templates.tutorial.name': "\u041B\u0430\u0441\u043A\u0430\u0432\u043E \u043F\u0440\u043E\u0441\u0438\u043C\u043E \u0434\u043E Project Pages!",
    'project-pages.improvement.terms-and-conditions-v2': "\u041D\u0430\u0442\u0438\u0441\u043D\u0443\u0432\u0448\u0438 \u043A\u043D\u043E\u043F\u043A\u0443 \xab\u0421\u043F\u0440\u043E\u0431\u0443\u0432\u0430\u0442\u0438\xbb, \u0432\u0438 \u043F\u0456\u0434\u0442\u0432\u0435\u0440\u0434\u0436\u0443\u0454\u0442\u0435 \u0437\u0433\u043E\u0434\u0443 \u043D\u0430 \u0440\u0435\u0454\u0441\u0442\u0440\u0430\u0446\u0456\u044E \u0432 Confluence \u0456 \u043F\u0440\u0438\u0439\u043C\u0430\u0454\u0442\u0435 <termsLink>\u0423\u043C\u043E\u0432\u0438 \u0432\u0438\u043A\u043E\u0440\u0438\u0441\u0442\u0430\u043D\u043D\u044F \u0445\u043C\u0430\u0440\u043D\u0438\u0445 \u0441\u043B\u0443\u0436\u0431</termsLink> \u0456 <privacyLink>\u041F\u043E\u043B\u0456\u0442\u0438\u043A\u0443 \u043A\u043E\u043D\u0444\u0456\u0434\u0435\u043D\u0446\u0456\u0439\u043D\u043E\u0441\u0442\u0456</privacyLink> Atlassian.",
    'project-pages.improvement.title': "\u0421\u0442\u043E\u0440\u0456\u043D\u043A\u0438 \u043F\u0440\u043E\u0435\u043A\u0442\u0443",
    'project-pages.improvement.transient-states.empty-state.auto-provisioned-create-page-button': "\u0421\u0442\u0432\u043E\u0440\u0438\u0442\u0438 \u0441\u0442\u043E\u0440\u0456\u043D\u043A\u0443",
    'project-pages.improvement.transient-states.empty-state.auto-provisioned-description': "\u041C\u0438 \u0434\u043E\u0434\u0430\u043B\u0438 Confluence, \u0442\u043E\u0436 \u0432\u0438 \u043C\u043E\u0436\u0435\u0442\u0435 \u0441\u0442\u0432\u043E\u0440\u044E\u0432\u0430\u0442\u0438 \u0442\u0430 \u043F\u043E\u0432\u2019\u044F\u0437\u0443\u0432\u0430\u0442\u0438 \u0432\u0441\u0456 \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0438 \u0432 \u043C\u0435\u0436\u0430\u0445 \u0432\u0456\u0434\u043F\u043E\u0432\u0456\u0434\u043D\u0438\u0445 \u043F\u0440\u043E\u0454\u043A\u0442\u0456\u0432. \u0426\u0435 \u0431\u0435\u0437\u043A\u043E\u0448\u0442\u043E\u0432\u043D\u043E \u0434\u043B\u044F 10\xa0\u043A\u043E\u0440\u0438\u0441\u0442\u0443\u0432\u0430\u0447\u0456\u0432.",
    'project-pages.improvement.transient-states.empty-state.auto-provisioned-learn-more-button': "\u0414\u043E\u043A\u043B\u0430\u0434\u043D\u0456\u0448\u0435",
    'project-pages.improvement.transient-states.empty-state.create-page-button': "\u0421\u0442\u0432\u043E\u0440\u0456\u0442\u044C \u0441\u0432\u043E\u044E \u043F\u0435\u0440\u0448\u0443 \u0441\u0442\u043E\u0440\u0456\u043D\u043A\u0443",
    'project-pages.improvement.transient-states.empty-state.description': "\u0429\u043E\u0431 \u0437\u0430\u043F\u043E\u0432\u043D\u0438\u0442\u0438 \u0446\u0435\u0439 \u0440\u043E\u0437\u0434\u0456\u043B, \u0434\u043E\u0434\u0430\u0439\u0442\u0435 \u0432 \u043D\u044C\u043E\u0433\u043E \u043F\u0440\u0438\u043C\u0456\u0442\u043A\u0438 \u0434\u043E \u043D\u0430\u0440\u0430\u0434\u0438, \u0432\u0438\u043C\u043E\u0433\u0438 \u0434\u043E \u043F\u0440\u043E\u0434\u0443\u043A\u0442\u0443, \u0440\u0456\u0448\u0435\u043D\u043D\u044F \u0447\u0438 \u0456\u043D\u0448\u0438\u0439 \u0432\u043C\u0456\u0441\u0442.",
    'project-pages.improvement.transient-states.empty-state.title': "\u0422\u0443\u0442 \u0431\u0430\u0433\u0430\u0442\u043E \u043C\u043E\u0436\u043B\u0438\u0432\u043E\u0441\u0442\u0435\u0439",
    'project-pages.improvement.try-button': "\u0421\u043F\u0440\u043E\u0431\u0443\u0432\u0430\u0442\u0438 \u0446\u0435\u0439 \u0448\u0430\u0431\u043B\u043E\u043D \u0443 Confluence",
    'project-pages.improvement.try-it-now': "\u041F\u043E\u0432\u0442\u043E\u0440\u0438\u0442\u0438 \u0441\u043F\u0440\u043E\u0431\u0443",
    'project-pages.improvement.try-lozenge': "\u0421\u043F\u0440\u043E\u0431\u0443\u0439\u0442\u0435 \u043D\u043E\u0432\u0435",
    'project-pages.improvement.try-on-demand-button': "\u0421\u043F\u0440\u043E\u0431\u0443\u0432\u0430\u0442\u0438 \u0431\u0435\u0437\u043A\u043E\u0448\u0442\u043E\u0432\u043D\u043E",
    'project-pages.page-deleted-flag.title': "\u0421\u0442\u043E\u0440\u0456\u043D\u043A\u0443 \u0432\u0438\u0434\u0430\u043B\u0435\u043D\u043E.",
    'project-pages.page-published-flag.title': "\u0421\u0442\u043E\u0440\u0456\u043D\u043A\u0443 \u043E\u043F\u0443\u0431\u043B\u0456\u043A\u043E\u0432\u0430\u043D\u043E.",
    'project-pages.unknown-error.description': "\u042F\u043A\u0449\u043E \u043E\u043D\u043E\u0432\u043B\u0435\u043D\u043D\u044F \u0441\u0442\u043E\u0440\u0456\u043D\u043A\u0438 \u043D\u0435 \u0432\u0438\u0440\u0456\u0448\u0443\u0454 \u043F\u0440\u043E\u0431\u043B\u0435\u043C\u0443, {contactSupport}.",
    'project-pages.unknown-error.heading': "\u0417\u0430\u0440\u0430\u0437 \u043C\u0438 \u043D\u0435 \u043C\u043E\u0436\u0435\u043C\u043E \u0432\u0456\u0434\u043E\u0431\u0440\u0430\u0437\u0438\u0442\u0438 \u0441\u0442\u043E\u0440\u0456\u043D\u043A\u0438 \u043F\u0440\u043E\u0435\u043A\u0442\u0443."
};

});

parcelRegister("gfrMq", function(module, exports) {

$parcel$export(module.exports, "default", () => $60b63baa763e5f1b$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Vietnamese (Vietnam)
var $60b63baa763e5f1b$export$2e2bcd8739ae039 = {
    'confluence.project-pages.improvement.provisioning-background.text': "Qu\xe1 tr\xecnh n\xe0y s\u1EBD m\u1EA5t ch\u01B0a \u0111\u1EBFn 1 ph\xfat",
    'confluence.project-pages.improvement.provisioning-background.title': "\u0110ang thi\u1EBFt l\u1EADp c\xe1c trang d\u1EF1 \xe1n",
    'confluence.project-pages.improvement.provisioning-modal-carousel.controls.dismiss': "B\u1ECF qua",
    'confluence.project-pages.improvement.provisioning-modal-carousel.controls.done': "\u0110\xe3 xong",
    'confluence.project-pages.improvement.provisioning-modal-carousel.controls.next': "Ti\u1EBFp theo",
    'project-pages.activating.description': "V\xf9ng Confuence \u0111\xe3 k\u1EBFt n\u1ED1i v\u1EABn ch\u01B0a s\u1EB5n s\xe0ng. {contactSupport} n\u1EBFu thao t\xe1c l\xe0m m\u1EDBi kh\xf4ng kh\u1EAFc ph\u1EE5c \u0111\u01B0\u1EE3c m\u1ECDi th\u1EE9.",
    'project-pages.activating.heading': "Confluence v\u1EABn \u0111ang t\u1EA3i",
    'project-pages.better-together-templates.meeting-notes.action-items-heading': "M\u1EE5c h\xe0nh \u0111\u1ED9ng l\xe0 g\xec?",
    'project-pages.better-together-templates.meeting-notes.agenda-item-label': "M\u1EE5c ch\u01B0\u01A1ng tr\xecnh",
    'project-pages.better-together-templates.meeting-notes.create-a-jira-issue': "Nh\u1EADp /Jira \u0111\u1EC3 t\u1EA1o v\u1EA5n \u0111\u1EC1",
    'project-pages.better-together-templates.meeting-notes.date-label': "Ng\xe0y",
    'project-pages.better-together-templates.meeting-notes.discussion-topics-heading': "Ch\u1EE7 \u0111\u1EC1 th\u1EA3o lu\u1EADn",
    'project-pages.better-together-templates.meeting-notes.list-people': "li\u1EC7t k\xea m\u1ECDi ng\u01B0\u1EDDi b\u1EB1ng c\xe1ch",
    'project-pages.better-together-templates.meeting-notes.mention': "nh\u1EAFc \u0111\u1EBFn",
    'project-pages.better-together-templates.meeting-notes.mention-people-to-assign-them': "m\u1ECDi ng\u01B0\u1EDDi \u0111\u1EC3 ch\u1EC9 \u0111\u1ECBnh h\u1ECD cho m\u1EE5c h\xe0nh \u0111\u1ED9ng",
    'project-pages.better-together-templates.meeting-notes.notes-label': "Ghi ch\xfa",
    'project-pages.better-together-templates.meeting-notes.page-title': "Bi\xean b\u1EA3n h\u1ECDp",
    'project-pages.better-together-templates.meeting-notes.participants-label': "Ng\u01B0\u1EDDi tham gia",
    'project-pages.better-together-templates.meeting-notes.project-label': "D\u1EF1 \xe1n",
    'project-pages.better-together-templates.product-requirements.create-a-jira-issue': "Nh\u1EADp /Jira \u0111\u1EC3 t\u1EA1o v\u1EA5n \u0111\u1EC1",
    'project-pages.better-together-templates.product-requirements.design-heading': "Thi\u1EBFt k\u1EBF",
    'project-pages.better-together-templates.product-requirements.embedd-different-data-views': "Nh\xfang d\u1EEF li\u1EC7u v\xe0 ch\u1EBF \u0111\u1ED9 xem v\u1EA5n \u0111\u1EC1 kh\xe1c nhau t\u1EEB d\u1EF1 \xe1n Jira c\u1EE7a b\u1EA1n.",
    'project-pages.better-together-templates.product-requirements.heading': "T\u1ED5ng quan",
    'project-pages.better-together-templates.product-requirements.how-will-you-know-if-fixed': "L\xe0m sao \u0111\u1EC3 bi\u1EBFt b\u1EA1n \u0111\xe3 s\u1EEDa \u0111\u01B0\u1EE3c l\u1ED7i hay ch\u01B0a?",
    'project-pages.better-together-templates.product-requirements.impact-heading': "T\xe1c \u0111\u1ED9ng",
    'project-pages.better-together-templates.product-requirements.inScopeStatus': "Trong ph\u1EA1m vi",
    'project-pages.better-together-templates.product-requirements.insert-design-link': "Ch\xe8n li\xean k\u1EBFt v\xe0o thi\u1EBFt k\u1EBF c\u1EE7a b\u1EA1n (Figma, v.v.)",
    'project-pages.better-together-templates.product-requirements.jira-issue-heading': "V\u1EA5n \u0111\u1EC1 tr\xean Jira",
    'project-pages.better-together-templates.product-requirements.jira-roadmap-heading': "L\u1ECBch tr\xecnh d\u1EF1 \xe1n Jira",
    'project-pages.better-together-templates.product-requirements.learn-how-with-smart-links': "T\xecm hi\u1EC3u c\xe1ch l\xe0m v\u1EDBi c\xe1c li\xean k\u1EBFt th\xf4ng minh",
    'project-pages.better-together-templates.product-requirements.list-dashboards': "Li\u1EC7t k\xea b\u1EA3ng th\xf4ng tin (Amplitude, Mode, v.v.)",
    'project-pages.better-together-templates.product-requirements.list-design-considerations': "Li\u1EC7t k\xea c\xe1c c\xe2n nh\u1EAFc v\u1EC1 thi\u1EBFt k\u1EBF ho\u1EB7c b\u1EA3n d\u1EF1ng",
    'project-pages.better-together-templates.product-requirements.list-people': "li\u1EC7t k\xea m\u1ECDi ng\u01B0\u1EDDi b\u1EB1ng c\xe1ch",
    'project-pages.better-together-templates.product-requirements.mention': "nh\u1EAFc \u0111\u1EBFn",
    'project-pages.better-together-templates.product-requirements.mention-people-to-assign-them': "m\u1ECDi ng\u01B0\u1EDDi \u0111\u1EC3 ch\u1EC9 \u0111\u1ECBnh h\u1ECD cho m\u1EE5c h\xe0nh \u0111\u1ED9ng",
    'project-pages.better-together-templates.product-requirements.niceToHaveStatus': "N\u1EBFu c\xf3 th\xec t\u1ED1t",
    'project-pages.better-together-templates.product-requirements.outOfScopeStatus': "Ngo\xe0i ph\u1EA1m vi",
    'project-pages.better-together-templates.product-requirements.page-title': "Y\xeau c\u1EA7u s\u1EA3n ph\u1EA9m",
    'project-pages.better-together-templates.product-requirements.pro-tip': "M\u1EB9o hay:",
    'project-pages.better-together-templates.product-requirements.problem-label': "V\u1EA5n \u0111\u1EC1",
    'project-pages.better-together-templates.product-requirements.requirement-heading': "Y\xeau c\u1EA7u",
    'project-pages.better-together-templates.product-requirements.scope-heading': "Ph\u1EA1m vi",
    'project-pages.better-together-templates.product-requirements.success-metric': "Ch\u1EC9 s\u1ED1 th\xe0nh c\xf4ng",
    'project-pages.better-together-templates.product-requirements.target-release-date': "Ng\xe0y ph\xe1t h\xe0nh m\u1EE5c ti\xeau",
    'project-pages.better-together-templates.product-requirements.team-label': "\u0110\u1ED9i ng\u0169",
    'project-pages.better-together-templates.product-requirements.to-do-list-heading': "Danh s\xe1ch vi\u1EC7c c\u1EA7n l\xe0m",
    'project-pages.better-together-templates.product-requirements.what-are-you-trying-to-fix': "B\u1EA1n \u0111ang c\u1ED1 g\u1EAFng s\u1EEDa l\u1ED7i g\xec?",
    'project-pages.better-together-templates.retro-notes.retro-heading': "C\u1EA3i ti\u1EBFn",
    'project-pages.better-together-templates.retro.action-items-heading': "M\u1EE5c h\xe0nh \u0111\u1ED9ng l\xe0 g\xec?",
    'project-pages.better-together-templates.retro.create-a-jira-issue': "Nh\u1EADp /Jira \u0111\u1EC3 t\u1EA1o v\u1EA5n \u0111\u1EC1",
    'project-pages.better-together-templates.retro.date-label': "Ng\xe0y",
    'project-pages.better-together-templates.retro.embed-it-here': "Sau khi ho\xe0n th\xe0nh, b\u1EA1n c\xf3 th\u1EC3 nh\xfang v\xe0o \u0111\xe2y.",
    'project-pages.better-together-templates.retro.list-people': "li\u1EC7t k\xea m\u1ECDi ng\u01B0\u1EDDi b\u1EB1ng c\xe1ch",
    'project-pages.better-together-templates.retro.mention': "nh\u1EAFc \u0111\u1EBFn",
    'project-pages.better-together-templates.retro.mention-people-to-assign-them': "m\u1ECDi ng\u01B0\u1EDDi \u0111\u1EC3 ch\u1EC9 \u0111\u1ECBnh h\u1ECD cho m\u1EE5c h\xe0nh \u0111\u1ED9ng",
    'project-pages.better-together-templates.retro.page-title': "C\u1EA3i ti\u1EBFn",
    'project-pages.better-together-templates.retro.participants-label': "Ng\u01B0\u1EDDi tham gia",
    'project-pages.better-together-templates.retro.pro-tip': "M\u1EB9o chuy\xean nghi\u1EC7p:",
    'project-pages.better-together-templates.retro.project-label': "D\u1EF1 \xe1n",
    'project-pages.better-together-templates.retro.this-is-a-whiteboard': "\u0110\xe2y l\xe0 b\u1EA3ng tr\u1EAFng c\u1EE7a Confluence.",
    'project-pages.better-together-templates.retro.use-a-whiteboard': "S\u1EED d\u1EE5ng b\u1EA3ng tr\u1EAFng Confluence cho retro c\u1EE7a b\u1EA1n.",
    'project-pages.better-together-templates.retro.use-it-to-vote': "S\u1EED d\u1EE5ng b\u1EA3ng tr\u1EAFng \u0111\u1EC3 b\xecnh ch\u1ECDn v\xe0 c\u1ED9ng t\xe1c v\u1EDBi \u0111\u1ED9i ng\u0169 c\u1EE7a b\u1EA1n.",
    'project-pages.button.connect-different-space-or-page.label': "Bi\u1EC3u t\u01B0\u1EE3ng c\u1EADp nh\u1EADt v\xf9ng ho\u1EB7c trang",
    'project-pages.button.connect-different-space-or-page.tooltip': "K\u1EBFt n\u1ED1i kh\xf4ng gian ho\u1EB7c m\u1EE5c kh\xe1c",
    'project-pages.button.connect-space-or-page.tooltip': "K\u1EBFt n\u1ED1i v\u1EDBi Confluence",
    'project-pages.button.go-to-connected-live-doc.tooltip': "M\u1EDF t\xe0i li\u1EC7u tr\u1EF1c tuy\u1EBFn trong Confluence",
    'project-pages.button.go-to-connected-page.tooltip': "M\u1EDF trang trong Confluence",
    'project-pages.button.go-to-connected-space.tooltip': "M\u1EDF kh\xf4ng gian trong Confluence",
    'project-pages.connect-space-dialog.connection-error': "Kh\xf4ng th\u1EC3 k\u1EBFt n\u1ED1i.",
    'project-pages.connect-space-dialog.connection-retry': "Th\u1EED l\u1EA1i",
    'project-pages.connect-space-dialog.content.space-or-page-selector.description': "Ch\u1ECDn kh\xf4ng gian ho\u1EB7c m\u1EE5c c\u1EA7n k\u1EBFt n\u1ED1i v\u1EDBi d\u1EF1 \xe1n c\u1EE7a b\u1EA1n.",
    'project-pages.connect-space-dialog.content.space-or-page-selector.placeholder': "T\xecm ki\u1EBFm Confluence",
    'project-pages.connect-space-dialog.content.space-selector.disconnected-templates-description': "Tr\u01B0\u1EDBc ti\xean, b\u1EA1n s\u1EBD c\u1EA7n k\u1EBFt n\u1ED1i d\u1EF1 \xe1n n\xe0y v\u1EDBi kh\xf4ng gian r\u1ED3i m\u1EDBi c\xf3 th\u1EC3 t\u1EA1o m\u1EE5c. Ch\u1ECDn kh\xf4ng gian c\u1EA7n k\u1EBFt n\u1ED1i v\u1EDBi d\u1EF1 \xe1n n\xe0y.",
    'project-pages.connect-space-dialog.error-icon': "L\u1ED7i:",
    'project-pages.connect-space-dialog.footer.cancel': "H\u1EE7y",
    'project-pages.connect-space-dialog.footer.connect-space': "K\u1EBFt n\u1ED1i",
    'project-pages.connect-space-or-page-dialog.header.title': "K\u1EBFt n\u1ED1i d\u1EF1 \xe1n v\u1EDBi Confluence",
    'project-pages.connect-space.description': "V\xf9ng gi\u1ED1ng nh\u01B0 th\u01B0 m\u1EE5c - b\u1EA1n c\xf3 th\u1EC3 s\u1EED d\u1EE5ng ch\xfang \u0111\u1EC3 t\u1EA1o, s\u1EAFp x\u1EBFp v\xe0 c\u1ED9ng t\xe1c cho t\u1EA5t c\u1EA3 n\u1ED9i dung li\xean quan \u0111\u1EBFn d\u1EF1 \xe1n c\u1EE7a b\u1EA1n.",
    'project-pages.connect-space.not-connected.description': "\u0110\u1EC3 s\u1EED d\u1EE5ng trang d\u1EF1 \xe1n, h\xe3y li\xean h\u1EC7 v\u1EDBi qu\u1EA3n tr\u1ECB vi\xean ho\u1EB7c tr\u01B0\u1EDFng nh\xf3m c\u1EE7a b\u1EA1n \u0111\u1EC3 k\u1EBFt n\u1ED1i Confluence v\u1EDBi d\u1EF1 \xe1n n\xe0y.",
    'project-pages.connect-space.not-connected.heading': "Kh\xf4ng \u0111\u01B0\u1EE3c k\u1EBFt n\u1ED1i v\u1EDBi Confluence",
    'project-pages.connect-success-flag.description.content': "\u0110\xe3 k\u1EBFt n\u1ED1i th\xe0nh c\xf4ng v\u1EDBi n\u1ED9i dung {connectedSpaceOrPageName}.",
    'project-pages.connection-error.space-or-page-not-found.button': "K\u1EBFt n\u1ED1i v\u1EDBi m\u1ED9t kh\xf4ng gian ho\u1EB7c trang kh\xe1c",
    'project-pages.create-space-dialog.connection-error': "Kh\xf4ng th\u1EC3 k\u1EBFt n\u1ED1i.",
    'project-pages.create-space-dialog.connection-retry': "Th\u1EED l\u1EA1i",
    'project-pages.create-space-dialog.content.empty-name': "Vui l\xf2ng \u0111\u1EB7t t\xean cho v\xf9ng c\u1EE7a b\u1EA1n.",
    'project-pages.create-space-dialog.content.invalid-name': "T\xean v\xf9ng c\u1EA7n ch\u1EE9a t\u1ED1i thi\u1EC3u m\u1ED9t ch\u1EEF c\xe1i ho\u1EB7c ch\u1EEF s\u1ED1.",
    'project-pages.create-space-dialog.content.placeholder': "Nh\u1EADp t\xean v\xf9ng",
    'project-pages.create-space-dialog.creation-error': "Kh\xf4ng th\u1EC3 t\u1EA1o v\xf9ng.",
    'project-pages.create-space-dialog.error-icon': "L\u1ED7i:",
    'project-pages.create-space-dialog.footer.cancel': "H\u1EE7y",
    'project-pages.create-space-dialog.footer.create-space': "T\u1EA1o",
    'project-pages.create-space-dialog.header.title': "T\u1EA1o v\xf9ng Confluence m\u1EDBi",
    'project-pages.cross-join.access-revoked.templates.subtitle': "B\u1EA1n kh\xf4ng th\u1EC3 s\u1EED d\u1EE5ng c\xe1c trang d\u1EF1 \xe1n v\xec qu\u1EA3n tr\u1ECB vi\xean \u0111\xe3 t\u1EEB ch\u1ED1i y\xeau c\u1EA7u truy c\u1EADp v\xe0o Confluence c\u1EE7a b\u1EA1n. H\xe3y li\xean h\u1EC7 v\u1EDBi qu\u1EA3n tr\u1ECB vi\xean trang web c\u1EE7a b\u1EA1n \u0111\u1EC3 y\xeau c\u1EA7u c\u1EA5p quy\u1EC1n truy c\u1EADp.",
    'project-pages.cross-join.access-revoked.templates.title': "B\u1EA1n kh\xf4ng c\xf3 quy\u1EC1n s\u1EED d\u1EE5ng c\xe1c trang d\u1EF1 \xe1n",
    'project-pages.cross-join.avatar.view-profile': "Xem h\u1ED3 s\u01A1",
    'project-pages.cross-join.denied-request.templates.subtitle': "B\u1EA1n kh\xf4ng th\u1EC3 s\u1EED d\u1EE5ng c\xe1c trang d\u1EF1 \xe1n v\xec qu\u1EA3n tr\u1ECB vi\xean trang web \u0111\xe3 t\u1EEB ch\u1ED1i y\xeau c\u1EA7u tham gia Confluence c\u1EE7a b\u1EA1n.",
    'project-pages.cross-join.denied-request.templates.title': "Qu\u1EA3n tr\u1ECB vi\xean c\u1EE7a b\u1EA1n \u0111\xe3 t\u1EEB ch\u1ED1i y\xeau c\u1EA7u truy c\u1EADp c\u1EE7a b\u1EA1n",
    'project-pages.cross-join.direct-access.button-subtitle.experimental': "B\u1EA1n s\u1EBD c\xf3 quy\u1EC1n truy c\u1EADp v\xe0o Confluence. Qu\u1EA3n tr\u1ECB vi\xean trang web \u0111\xe3 ph\xea duy\u1EC7t b\u1EA1n.",
    'project-pages.cross-join.errors.unknown-error.description': "{contactSupport} n\u1EBFu thao t\xe1c l\xe0m m\u1EDBi kh\xf4ng kh\u1EAFc ph\u1EE5c \u0111\u01B0\u1EE3c v\u1EA5n \u0111\u1EC1.",
    'project-pages.cross-join.errors.unknown-error.title': "Ch\xfang t\xf4i kh\xf4ng th\u1EC3 hi\u1EC3n th\u1ECB c\xe1c trang d\u1EF1 \xe1n ngay b\xe2y gi\u1EDD",
    'project-pages.cross-join.inline-join-product.button': "B\u1EA1n s\u1EBD c\xf3 quy\u1EC1n truy c\u1EADp v\xe0o Confluence. Qu\u1EA3n tr\u1ECB vi\xean trang web \u0111\xe3 ch\u1EA5p thu\u1EADn b\u1EA1n.",
    'project-pages.cross-join.inline-join-product.connected.description': "Xem, ch\u1EC9nh s\u1EEDa v\xe0 t\u1EA1o t\xe0i li\u1EC7u t\u1EEB c\xf9ng m\u1ED9t n\u01A1i",
    'project-pages.cross-join.inline-join-product.connected.title': "C\u1ED9ng t\xe1c v\u1EDBi nh\xf3m c\u1EE7a b\u1EA1n tr\xean c\xe1c trang d\u1EF1 \xe1n",
    'project-pages.cross-join.pending-request.templates.subtitle': "Qu\u1EA3n tr\u1ECB vi\xean trang web \u0111\xe3 nh\u1EADn \u0111\u01B0\u1EE3c y\xeau c\u1EA7u tham gia Confluence c\u1EE7a b\u1EA1n. N\u1EBFu b\u1EA1n \u0111\u01B0\u1EE3c ch\u1EA5p thu\u1EADn tham gia, c\xe1c trang d\u1EF1 \xe1n s\u1EBD b\u1EAFt \u0111\u1EA7u ho\u1EA1t \u0111\u1ED9ng v\xe0 ch\xfang t\xf4i s\u1EBD g\u1EEDi cho b\u1EA1n email x\xe1c nh\u1EADn.",
    'project-pages.cross-join.pending-request.templates.subtitle.experiment': "B\u1EA1n s\u1EBD nh\u1EADn \u0111\u01B0\u1EE3c email k\xe8m quy\u1EC1n truy c\u1EADp v\xe0o Trang d\u1EF1 \xe1n sau khi b\u1EA1n \u0111\u01B0\u1EE3c ph\xea duy\u1EC7t.",
    'project-pages.cross-join.pending-request.templates.title': "B\u1EA1n \u0111\xe3 y\xeau c\u1EA7u c\u1EA5p quy\u1EC1n truy c\u1EADp v\xe0o Confluence",
    'project-pages.cross-join.pending-request.templates.title.experiment': "\u0110\xe3 g\u1EEDi y\xeau c\u1EA7u c\u1EA5p quy\u1EC1n truy c\u1EADp t\u1EDBi Qu\u1EA3n tr\u1ECB vi\xean",
    'project-pages.cross-join.request-access-without-better-together.connected.description': "Xem, ch\u1EC9nh s\u1EEDa v\xe0 t\u1EA1o t\xe0i li\u1EC7u d\u1EF1 \xe1n v\u1EDBi nh\xf3m c\u1EE7a b\u1EA1n",
    'project-pages.cross-join.request-access.button': "Y\xeau c\u1EA7u c\u1EA5p quy\u1EC1n truy c\u1EADp",
    'project-pages.cross-join.request-access.button-subtitle.experimental': 'Ch\u1ECDn "Tham gia \u0111\u1ED9i ng\u0169" ngh\u0129a l\xe0 b\u1EA1n \u0111ang y\xeau c\u1EA7u tham gia Confluence v\xe0 \u0111\u1ED3ng \xfd chia s\u1EBB h\u1ED3 s\u01A1 Atlassian c\u1EE7a b\u1EA1n v\u1EDBi qu\u1EA3n tr\u1ECB vi\xean.',
    'project-pages.cross-join.request-access.button.experimental': "Tham gia \u0111\u1ED9i ng\u0169",
    'project-pages.cross-join.request-access.connected.description.experimental': "\u0110\u1ED9i ng\u0169 c\u1EE7a b\u1EA1n \u0111ang s\u1EED d\u1EE5ng Trang d\u1EF1 \xe1n \u0111\u1EC3 nh\u1EADn x\xe9t, s\u1EEDa v\xe0 c\u1ED9ng t\xe1c tr\xean t\xe0i li\u1EC7u d\u1EF1 \xe1n m\xe0 kh\xf4ng c\u1EA7n r\u1EDDi kh\u1ECFi Jira. Tham gia Confluence \u0111\u1EC3 truy c\u1EADp Trang d\u1EF1 \xe1n c\u1EE7a \u0111\u1ED9i ng\u0169.",
    'project-pages.cross-join.request-access.title': "C\u1EA7n c\xf3 quy\u1EC1n truy c\u1EADp v\xe0o Confluence \u0111\u1EC3 s\u1EED d\u1EE5ng c\xe1c trang d\u1EF1 \xe1n",
    'project-pages.cross-join.request-access.title.experiment': "T\u1EA1o m\u1ED9t ngu\u1ED3n th\xf4ng tin duy nh\u1EA5t cho \u0111\u1ED9i ng\u0169 c\u1EE7a b\u1EA1n",
    'project-pages.default-contextual-heading': "C\xe1c trang d\u1EF1 \xe1n \u0111\u01B0\u1EE3c h\u1ED7 tr\u1EE3 b\u1EDFi Confluence",
    'project-pages.default-contextual-message': "T\u1EA1o, chia s\u1EBB v\xe0 c\u1ED9ng t\xe1c tr\xean t\u1EA5t c\u1EA3 c\xe1c t\xe0i li\u1EC7u c\u1EE7a d\u1EF1 \xe1n \u1EDF m\u1ED9t n\u01A1i t\u1EADp trung duy nh\u1EA5t, v\u1EDBi trang Confluence.",
    'project-pages.default-reactivate-CTA': "H\u1EE7y k\xedch ho\u1EA1t Confluence",
    'project-pages.default-trial-CTA': "D\xf9ng th\u1EED Confluence mi\u1EC5n ph\xed trong 30 ng\xe0y",
    'project-pages.draft-saved-flag.action': "M\u1EDF b\u1EA3n nh\xe1p",
    'project-pages.draft-saved-flag.description': "B\u1EA3n nh\xe1p ch\u01B0a \u0111\u0103ng s\u1EBD ch\u1EC9 hi\u1EC3n th\u1ECB v\u1EDBi b\u1EA1n.",
    'project-pages.draft-saved-flag.title': "\u0110\xe3 l\u01B0u b\u1EA3n nh\xe1p",
    'project-pages.embedded-pages.create-page-error.close-button': "\u0110\xf3ng",
    'project-pages.embedded-pages.create-page-error.description': "\u0110\xe3 x\u1EA3y ra s\u1EF1 c\u1ED1 v\xe0 ch\xfang t\xf4i kh\xf4ng th\u1EC3 t\u1EA1o trang cho b\u1EA1n.",
    'project-pages.embedded-pages.create-page-error.title': "Ch\xfang t\xf4i kh\xf4ng th\u1EC3 t\u1EA1o trang",
    'project-pages.embedded-pages.create-page-error.try-again-button': "Th\u1EED l\u1EA1i",
    'project-pages.embedded-pages.modal.close.button.hint': "\u0110\xf3ng",
    'project-pages.embedded-pages.modal.title.button': "M\u1EDF trong Confluence",
    'project-pages.embedded-pages.modal.title.button.hint': "M\u1EDF trong tab m\u1EDBi",
    'project-pages.errors.unknown-error.description.non-final': "{contactSupport} n\u1EBFu thao t\xe1c l\xe0m m\u1EDBi kh\xf4ng kh\u1EAFc ph\u1EE5c \u0111\u01B0\u1EE3c m\u1ECDi th\u1EE9.",
    'project-pages.errors.unknown-error.title.non-final': "Ch\xfang t\xf4i kh\xf4ng th\u1EC3 hi\u1EC3n th\u1ECB c\xe1c trang d\u1EF1 \xe1n ngay b\xe2y gi\u1EDD",
    'project-pages.generic-error.button.reload': "T\u1EA3i l\u1EA1i trang",
    'project-pages.generic-error.description': "\u0110\xe3 x\u1EA3y ra l\u1ED7i. Vui l\xf2ng th\u1EED l\u1EA1i sau.",
    'project-pages.generic-error.description.non-final': "\u0110\xe3 x\u1EA3y ra l\u1ED7i. Vui l\xf2ng th\u1EED l\u1EA1i sau.",
    'project-pages.generic-error.heading': "Ch\xe0, th\u1EADt l\xe0 l\u1EA1...",
    'project-pages.generic-error.title.non-final': "Ch\xe0, th\u1EADt l\xe0 l\u1EA1...",
    'project-pages.generic-info-flag.description': "\u0110\xe3 x\u1EA3y ra l\u1ED7i. Vui l\xf2ng th\u1EED l\u1EA1i ho\u1EB7c li\xean h\u1EC7 v\u1EDBi b\u1ED9 ph\u1EADn h\u1ED7 tr\u1EE3 n\u1EBFu s\u1EF1 c\u1ED1 v\u1EABn ti\u1EBFp di\u1EC5n",
    'project-pages.generic-success-flag.description.live-doc': "\u0110\xe3 k\u1EBFt n\u1ED1i th\xe0nh c\xf4ng v\u1EDBi t\xe0i li\u1EC7u tr\u1EF1c tuy\u1EBFn {connectedSpaceOrPageName}.",
    'project-pages.generic-success-flag.description.page': "\u0110\xe3 k\u1EBFt n\u1ED1i th\xe0nh c\xf4ng v\u1EDBi trang {connectedSpaceOrPageName}.",
    'project-pages.generic-success-flag.description.space': "\u0110\xe3 k\u1EBFt n\u1ED1i th\xe0nh c\xf4ng v\u1EDBi v\xf9ng {connectedSpaceOrPageName}.",
    'project-pages.generic-success-flag.heading.live-doc': "\u0110\xe3 k\u1EBFt n\u1ED1i t\xe0i li\u1EC7u tr\u1EF1c tuy\u1EBFn",
    'project-pages.generic-success-flag.heading.page': "Trang \u0111\xe3 k\u1EBFt n\u1ED1i",
    'project-pages.generic-success-flag.heading.space': "\u0110\xe3 k\u1EBFt n\u1ED1i v\xf9ng",
    'project-pages.granular-pages.connect-space-dialog.content.create-space-link.link-text': "Ho\u1EB7c t\u1EA1o m\u1ED9t kh\xf4ng gian m\u1EDBi",
    'project-pages.granular-pages.connect-space.button': "K\u1EBFt n\u1ED1i v\u1EDBi Confluence",
    'project-pages.granular-pages.connect-space.heading': "K\u1EBFt n\u1ED1i d\u1EF1 \xe1n n\xe0y v\u1EDBi kh\xf4ng gian ho\u1EB7c m\u1EE5c Confluence",
    'project-pages.improvement.contact-support': "Li\xean h\u1EC7 v\u1EDBi b\u1ED9 ph\u1EADn h\u1ED7 tr\u1EE3",
    'project-pages.improvement.errors.access-error.description': "H\xe3y th\u1EED li\xean h\u1EC7 v\u1EDBi qu\u1EA3n tr\u1ECB vi\xean trang web \u0111\u1EC3 c\xf3 quy\u1EC1n truy c\u1EADp.",
    'project-pages.improvement.errors.access-error.title': "B\u1EA1n kh\xf4ng c\xf3 quy\u1EC1n xem c\xe1c trang d\u1EF1 \xe1n",
    'project-pages.improvement.errors.page-tree-unknown-error.description': "\u0110\xe3 x\u1EA3y ra l\u1ED7i khi c\u1ED1 g\u1EAFng hi\u1EC3n th\u1ECB c\xe1c trang t\u1EEB v\xf9ng Confluence \u0111\xe3 k\u1EBFt n\u1ED1i c\u1EE7a b\u1EA1n. {contactSupport} n\u1EBFu thao t\xe1c l\xe0m m\u1EDBi kh\xf4ng kh\u1EAFc ph\u1EE5c \u0111\u01B0\u1EE3c m\u1ECDi th\u1EE9.",
    'project-pages.improvement.errors.page-tree-unknown-error.title': "Ch\xfang t\xf4i \u0111\xe3 g\u1EB7p s\u1EF1 c\u1ED1 khi hi\u1EC3n th\u1ECB c\xe1c trang d\u1EF1 \xe1n",
    'project-pages.improvement.errors.space-or-page-not-found.description': "Kh\xf4ng gian ho\u1EB7c trang Confluence \u0111\u01B0\u1EE3c k\u1EBFt n\u1ED1i \u0111\xe3 b\u1ECB chuy\u1EC3n \u0111i, l\u01B0u tr\u1EEF ho\u1EB7c x\xf3a. <link>Li\xean h\u1EC7 v\u1EDBi b\u1ED9 ph\u1EADn h\u1ED7 tr\u1EE3</link> n\u1EBFu thao t\xe1c k\u1EBFt n\u1ED1i l\u1EA1i kh\xf4ng kh\u1EAFc ph\u1EE5c \u0111\u01B0\u1EE3c s\u1EF1 c\u1ED1",
    'project-pages.improvement.errors.space-or-page-not-found.title': "Kh\xf4ng t\xecm th\u1EA5y kh\xf4ng gian ho\u1EB7c trang",
    'project-pages.improvement.errors.unknown-error.description': "{contactSupport} n\u1EBFu thao t\xe1c l\xe0m m\u1EDBi kh\xf4ng kh\u1EAFc ph\u1EE5c \u0111\u01B0\u1EE3c m\u1ECDi th\u1EE9.",
    'project-pages.improvement.errors.unknown-error.title': "Ch\xfang t\xf4i kh\xf4ng th\u1EC3 hi\u1EC3n th\u1ECB c\xe1c trang d\u1EF1 \xe1n ngay b\xe2y gi\u1EDD",
    'project-pages.improvement.feature1': "Truy c\u1EADp v\xe0 t\u1EA1o t\xe0i li\u1EC7u m\xe0 kh\xf4ng c\u1EA7n r\u1EDDi kh\u1ECFi Jira",
    'project-pages.improvement.feature2': "M\u1EABu cho cu\u1ED9c h\u1ECDp, k\u1EBF ho\u1EA1ch sprint, v.v.",
    'project-pages.improvement.feature3': "\u0110\u1ED3ng b\u1ED9 t\xe0i li\u1EC7u l\xean Jira \u0111\u1EC3 n\u1ED9i dung \u0111\u01B0\u1EE3c t\u1EF1 \u0111\u1ED9ng c\u1EADp nh\u1EADt",
    'project-pages.improvement.heading-info': "Th\u1EA5u hi\u1EC3u \u0111\u01B0\u1EE3c nh\xf3m c\u1EE7a b\u1EA1n v\xe0 c\u1EA3i thi\u1EC7n c\xe1ch b\u1EA1n ho\xe0n th\xe0nh c\xf4ng vi\u1EC7c.",
    'project-pages.improvement.heading-info-v2': "T\u1EA1o m\u1ED9t kh\xf4ng gian chung ch\u1EE9a m\u1ECDi t\xe0i li\u1EC7u d\u1EF1 \xe1n c\u1EE7a \u0111\u1ED9i ng\u0169.",
    'project-pages.improvement.learn-more-button': "T\xecm hi\u1EC3u th\xeam",
    'project-pages.improvement.powered-by': "\u0110\u01B0\u1EE3c h\u1ED7 tr\u1EE3 b\u1EDFi",
    'project-pages.improvement.powered-by.tooltip': "M\u1EDF Confluence trong tab m\u1EDBi",
    'project-pages.improvement.preview-teaser': "M\u1EDF kh\xf3a bi\u1EC3u m\u1EABu, c\xe1c trang d\u1EF1 \xe1n v\xe0 nhi\u1EC1u l\u1EF1a ch\u1ECDn kh\xe1c.",
    'project-pages.improvement.provisioning-info-modal.seamlessly-update-stakeholders.description': "<p>C\u1EADp nh\u1EADt c\xe1c b\xe1o c\xe1o d\u1EF1 \xe1n c\u1EE7a b\u1EA1n v\u1EDBi nh\xe3n tr\u1EA1ng th\xe1i t\u1EF1 \u0111\u1ED9ng c\u1EADp nh\u1EADt.</p> <p>Ch\u1EC9 c\u1EA7n li\xean k\u1EBFt phi\u1EBFu Jira trong t\xe0i li\u1EC7u v\xe0 phi\u1EBFu s\u1EBD t\u1EF1 \u0111\u1ED9ng hi\u1EC3n th\u1ECB nh\xe3n tr\u1EA1ng th\xe1i \u0111\u01B0\u1EE3c c\u1EADp nh\u1EADt \u0111\u1ED3ng b\u1ED9 v\u1EDBi phi\u1EBFu. V\xec v\u1EADy, b\u1EA1n kh\xf4ng ph\u1EA3i m\u1EA5t th\u1EDDi gian t\u1EA1o b\xe1o c\xe1o th\u1EE7 c\xf4ng.</p>",
    'project-pages.improvement.provisioning-info-modal.seamlessly-update-stakeholders.title': "C\u1EADp nh\u1EADt li\u1EC1n m\u1EA1ch c\xe1c b\xean li\xean quan",
    'project-pages.improvement.provisioning-info-modal.unify-documentation-standards.description': "<p>T\u1EA1o t\xe0i li\u1EC7u nh\u1EA5t qu\xe1n b\u1EB1ng c\xe1ch s\u1EED d\u1EE5ng c\xe1c m\u1EABu t\xedch h\u1EE3p s\u1EB5n c\u1EE7a ch\xfang t\xf4i. C\xe1c m\u1EABu n\xe0y r\u1EA5t d\u1EC5 s\u1EED d\u1EE5ng v\xe0 c\xf3 th\u1EC3 t\xf9y ch\u1EC9nh theo nhu c\u1EA7u c\u1EE7a b\u1EA1n.</p> <p>V\xec c\xf3 th\u1EC3 s\u1EED d\u1EE5ng m\u1EABu tr\u1EF1c ti\u1EBFp t\u1EEB c\xe1c trang d\u1EF1 \xe1n n\xean b\u1EA1n kh\xf4ng bao gi\u1EDD ph\u1EA3i b\u1ECF d\u1EDF d\u1EF1 \xe1n m\xecnh \u0111ang l\xe0m. Duy\u1EC7t t\xecm t\u1EA5t c\u1EA3 c\xe1c m\u1EABu <a>t\u1EA1i \u0111\xe2y</a>.</p>",
    'project-pages.improvement.provisioning-info-modal.unify-documentation-standards.title': "Th\u1ED1ng nh\u1EA5t c\xe1c ti\xeau chu\u1EA9n v\u1EC1 t\xe0i li\u1EC7u",
    'project-pages.improvement.provisioning-info-modal.your-project-pages-in-jira.description': "<p>T\u1EA1o m\u1ED9t ngu\u1ED3n th\xf4ng tin duy nh\u1EA5t cho th\xf4ng tin quan tr\u1ECDng b\u1EB1ng c\xe1ch t\u1EA1o v\xe0 qu\u1EA3n l\xfd t\xe0i li\u1EC7u t\u1EEB tab c\xe1c trang d\u1EF1 \xe1n trong Jira.</p> <p>B\u1EA1n c\xf3 bi\u1EBFt r\u1EB1ng c\xe1c trang d\u1EF1 \xe1n ch\u1EA1y tr\xean Confluence? Confluence mi\u1EC5n ph\xed cho t\u1ED1i \u0111a 10 ng\u01B0\u1EDDi d\xf9ng. M\u1EDDi nh\u1EEFng th\xe0nh vi\xean c\xf2n l\u1EA1i trong nh\xf3m c\u1EE7a b\u1EA1n th\xf4ng qua c\xe0i \u0111\u1EB7t qu\u1EA3n tr\u1ECB vi\xean.</p>",
    'project-pages.improvement.provisioning-info-modal.your-project-pages-in-jira.title': "C\xe1c trang d\u1EF1 \xe1n c\u1EE7a b\u1EA1n, ngay trong Jira",
    'project-pages.improvement.templates-sidebar.better-together-templates-header': "C\xe1c m\u1EABu t\xedch h\u1EE3p v\u1EDBi d\u1EEF li\u1EC7u Jira c\u1EE7a b\u1EA1n",
    'project-pages.improvement.templates.better-together-preview-teaser': "T\xedch h\u1EE3p v\u1EDBi d\u1EEF li\u1EC7u Jira",
    'project-pages.improvement.templates.blank-page.description': "B\u1EAFt \u0111\u1EA7u m\u1ED9t trang ngay t\u1EEB \u0111\u1EA7u.",
    'project-pages.improvement.templates.blank-page.name': "Trang tr\u1ED1ng",
    'project-pages.improvement.templates.decision.description': "Ghi l\u1EA1i c\xe1c quy\u1EBFt \u0111\u1ECBnh quan tr\u1ECDng v\u1EC1 d\u1EF1 \xe1n v\xe0 trao \u0111\u1ED5i ch\xfang v\u1EDBi nh\xf3m c\u1EE7a b\u1EA1n.",
    'project-pages.improvement.templates.decision.name': "Quy\u1EBFt \u0111\u1ECBnh",
    'project-pages.improvement.templates.meeting-notes.description': "\u0110\u1EB7t ch\u01B0\u01A1ng tr\xecnh h\u1ECDp, ghi ch\xfa v\xe0 chia s\u1EBB c\xe1c m\u1EE5c h\xe0nh \u0111\u1ED9ng v\u1EDBi nh\xf3m.",
    'project-pages.improvement.templates.meeting-notes.name': "Bi\xean b\u1EA3n cu\u1ED9c h\u1ECDp",
    'project-pages.improvement.templates.post-expand.more': "C\xe1c m\u1EABu kh\xe1c",
    'project-pages.improvement.templates.post-expand.more.tooltip': "Xem t\u1EA5t c\u1EA3 c\xe1c m\u1EABu trong Confluence",
    'project-pages.improvement.templates.post-expand.subtitle': "C\xe1c m\u1EABu ph\u1ED5 bi\u1EBFn",
    'project-pages.improvement.templates.post-expand.title': "T\u1EA1o trang",
    'project-pages.improvement.templates.pre-expand.more': "Kh\xe1m ph\xe1 c\xe1c m\u1EABu kh\xe1c",
    'project-pages.improvement.templates.pre-expand.subtitle': "Quen thu\u1ED9c v\u1EDBi c\xe1c nh\xf3m nh\u01B0 nh\xf3m c\u1EE7a b\u1EA1n",
    'project-pages.improvement.templates.pre-expand.title': "Xem tr\u01B0\u1EDBc m\u1EABu",
    'project-pages.improvement.templates.product-requirements.description': "X\xe1c \u0111\u1ECBnh, theo d\xf5i v\xe0 xem x\xe9t c\xe1c y\xeau c\u1EA7u \u0111\u1ED1i v\u1EDBi s\u1EA3n ph\u1EA9m ho\u1EB7c t\xednh n\u0103ng c\u1EE7a b\u1EA1n.",
    'project-pages.improvement.templates.product-requirements.name': "Y\xeau c\u1EA7u s\u1EA3n ph\u1EA9m",
    'project-pages.improvement.templates.retrospective.description': "Ph\u1EA7n n\xe0o \u0111\xe3 t\u1ED1t r\u1ED3i? Ph\u1EA7n n\xe0o c\xf2n c\xf3 th\u1EC3 c\u1EA3i thi\u1EC7n? C\u1EA3i thi\u1EC7n ngu\u1ED3n l\u1EF1c c\u1ED9ng \u0111\u1ED3ng v\u1EDBi nh\xf3m c\u1EE7a b\u1EA1n.",
    'project-pages.improvement.templates.retrospective.name': "Xem l\u1EA1i",
    'project-pages.improvement.templates.template.disabled-tooltip': "Tr\u01B0\u1EDBc ti\xean, h\xe3y k\u1EBFt n\u1ED1i v\u1EDBi m\u1ED9t v\xf9ng Confluence",
    'project-pages.improvement.templates.tutorial.content.confluence-templates': "<b>Ti\u1EBFt ki\u1EC7m th\u1EDDi gian v\xe0 gi\u1EA3m s\u1ED1 t\xe1c v\u1EE5 c\u1EA7n th\u1EF1c hi\u1EC7n th\u1EE7 c\xf4ng</b>. Confluence c\xf3 v\xf4 v\xe0n <a>m\u1EABu</a> trang n\xean b\u1EA1n kh\xf4ng bao gi\u1EDD ph\u1EA3i b\u1EAFt \u0111\u1EA7u t\u1EEB \u0111\u1EA7u. C\xe1c m\u1EABu n\xe0y bao g\u1ED3m t\xe0i li\u1EC7u k\u1EF9 thu\u1EADt, h\u01B0\u1EDBng d\u1EABn kh\u1EAFc ph\u1EE5c s\u1EF1 c\u1ED1, k\u1EBF ho\u1EA1ch d\u1EF1 \xe1n, y\xeau c\u1EA7u v\u1EC1 s\u1EA3n ph\u1EA9m, v.v.",
    'project-pages.improvement.templates.tutorial.content.edit-and-format': "<b>D\u1EC5 d\xe0ng s\u1EEDa v\xe0 \u0111\u1ECBnh d\u1EA1ng.</b> Truy c\u1EADp menu s\u1EEDa \u1EDF ph\xeda tr\xean c\xf9ng \u0111\u1EC3 s\u1EED d\u1EE5ng t\xednh n\u0103ng \u0111\u1ECBnh d\u1EA1ng v\u0103n b\u1EA3n ti\xeau chu\u1EA9n v\xe0 nh\u1EADp <b>/</b> \u0111\u1EC3 d\u1EC5 d\xe0ng ch\xe8n nhi\u1EC1u th\xe0nh ph\u1EA7n t\xedch h\u1EE3p ti\u1EC7n d\u1EE5ng. Nh\u1EADp <c>/b\u1EA3ng</c> \u0111\u1EC3 ch\xe8n b\u1EA3ng ho\u1EB7c nh\u1EADp <c>/\u1EA3nh</c> \u0111\u1EC3 ch\xe8n \u1EA3nh. B\u1EA1n c\u0169ng c\xf3 th\u1EC3 ch\xe8n li\xean k\u1EBFt \u0111\u1EBFn Dropbox <c>/dropbox</c>, c\xf4ng c\u1EE5 v\u0103n ph\xf2ng c\u1EE7a Microsoft <c>/microsoft</c> ho\u1EB7c b\u1EA3ng v\xe0 th\u1EBB c\u1EE7a Trello <c>/trello</c>.",
    'project-pages.improvement.templates.tutorial.content.forward-slash-prompt': 'Nh\u1EADp / r\u1ED3i nh\u1EADp "b\u1EA3ng" ho\u1EB7c "\u1EA3nh"',
    'project-pages.improvement.templates.tutorial.content.getting-started-tips': "Sau \u0111\xe2y l\xe0 m\u1ED9t s\u1ED1 m\u1EB9o gi\xfap b\u1EA1n b\u1EAFt \u0111\u1EA7u:",
    'project-pages.improvement.templates.tutorial.content.handy-links': "Li\xean k\u1EBFt ti\u1EC7n d\u1EE5ng",
    'project-pages.improvement.templates.tutorial.content.jira-and-confluence': "S\u1EED d\u1EE5ng Jira k\u1EBFt h\u1EE3p c\xf9ng Confluence",
    'project-pages.improvement.templates.tutorial.content.jira-charts': "T\u1EA1o bi\u1EC3u \u0111\u1ED3 tr\xean c\xe1c trang c\u1EE7a b\u1EA1n b\u1EB1ng d\u1EEF li\u1EC7u th\u1EF1c t\u1EEB Jira. Nh\u1EADp <c>/bi\u1EC3u \u0111\u1ED3 Jira</c>.",
    'project-pages.improvement.templates.tutorial.content.jira-links': "Li\xean k\u1EBFt \u0111\u1EBFn v\u1EA5n \u0111\u1EC1 tr\xean Jira \u1EDF v\u1ECB tr\xed b\u1EA5t k\u1EF3 tr\xean trang. Li\xean k\u1EBFt tr\xean trang s\u1EBD c\u1EADp nh\u1EADt trong th\u1EDDi gian th\u1EF1c khi b\u1EA1n c\u1EADp nh\u1EADt v\u1EA5n \u0111\u1EC1 tr\xean Jira. Nh\u1EADp <c>/Jira</c>.",
    'project-pages.improvement.templates.tutorial.content.jira-links-issue-term-refresh': "Li\xean k\u1EBFt \u0111\u1EBFn h\u1EA1ng m\u1EE5c c\xf4ng vi\u1EC7c Jira \u1EDF v\u1ECB tr\xed b\u1EA5t k\u1EF3 tr\xean trang. Li\xean k\u1EBFt tr\xean trang s\u1EBD c\u1EADp nh\u1EADt trong th\u1EDDi gian th\u1EF1c khi b\u1EA1n c\u1EADp nh\u1EADt h\u1EA1ng m\u1EE5c c\xf4ng vi\u1EC7c tr\xean Jira. Nh\u1EADp <c>/Jira</c>.",
    'project-pages.improvement.templates.tutorial.content.jira-links.non-final-issue-term-refresh': "Li\xean k\u1EBFt \u0111\u1EBFn h\u1EA1ng m\u1EE5c c\xf4ng vi\u1EC7c Jira \u1EDF v\u1ECB tr\xed b\u1EA5t k\u1EF3 tr\xean trang. Li\xean k\u1EBFt tr\xean trang s\u1EBD c\u1EADp nh\u1EADt trong th\u1EDDi gian th\u1EF1c khi b\u1EA1n c\u1EADp nh\u1EADt h\u1EA1ng m\u1EE5c c\xf4ng vi\u1EC7c. Nh\u1EADp <c>/Jira</c>.",
    'project-pages.improvement.templates.tutorial.content.jira-roadmaps': "\u0110\u01B0a l\u1ECBch tr\xecnh d\u1EF1 \xe1n v\xe0 l\u1ECBch tr\xecnh mang t\xednh t\u01B0\u01A1ng t\xe1c v\xe0o trang th\xf4ng qua c\xe1c D\u1EF1 \xe1n Jira. Nh\u1EADp <c>/l\u1ECBch tr\xecnh d\u1EF1 \xe1n jira</c>.",
    'project-pages.improvement.templates.tutorial.content.jira-timeline': "\u0110\u01B0a l\u1ECBch tr\xecnh mang t\xednh t\u01B0\u01A1ng t\xe1c v\xe0o trang th\xf4ng qua c\xe1c D\u1EF1 \xe1n Jira. Nh\u1EADp <c>/jira timeline</c>.",
    'project-pages.improvement.templates.tutorial.content.shipping-speed-statistic': "76% kh\xe1ch h\xe0ng s\u1EED d\u1EE5ng Jira Software cho bi\u1EBFt h\u1ECD b\xe0n giao d\u1EF1 \xe1n nhanh h\u01A1n sau khi th\xeam Confluence",
    'project-pages.improvement.templates.tutorial.content.shipping-speed-statistic.spork-rebranding': "76% kh\xe1ch h\xe0ng s\u1EED d\u1EE5ng Jira cho bi\u1EBFt h\u1ECD b\xe0n giao d\u1EF1 \xe1n nhanh h\u01A1n sau khi th\xeam Confluence",
    'project-pages.improvement.templates.tutorial.content.spaces-and-pages': "<b>S\u1EED d\u1EE5ng c\xe1c trang v\xe0 kh\xf4ng gian</b>. Kh\xf4ng gian l\xe0 m\u1ED9t ph\u1EA7n c\xf3 m\u1EB7t tr\xean m\u1ECDi trang Confluence nh\u1EB1m gi\xfap s\u1EAFp x\u1EBFp c\xe1c trang theo danh m\u1EE5c. B\u1EA1n c\xf3 th\u1EC3 coi kh\xf4ng gian l\xe0 c\xe1c th\u01B0 m\u1EE5c ho\u1EB7c d\u1EF1 \xe1n kh\xe1c nhau, c\xf2n trang l\xe0 t\xe0i li\u1EC7u thu\u1ED9c v\u1EC1 c\xe1c th\u01B0 m\u1EE5c ho\u1EB7c d\u1EF1 \xe1n \u0111\xf3. <a>T\xecm hi\u1EC3u th\xeam v\u1EC1 c\xe1ch s\u1EED d\u1EE5ng kh\xf4ng gian</a>",
    'project-pages.improvement.templates.tutorial.content.try-it-now': "Th\u1EED ngay",
    'project-pages.improvement.templates.tutorial.description': "T\xecm hi\u1EC3u c\xe1ch s\u1EEDa m\u1ED9t trang.",
    'project-pages.improvement.templates.tutorial.name': "Ch\xe0o m\u1EEBng b\u1EA1n \u0111\u1EBFn v\u1EDBi c\xe1c trang D\u1EF1 \xe1n!",
    'project-pages.improvement.terms-and-conditions-v2': "Ch\u1ECDn &quot;D\xf9ng th\u1EED ngay&quot; c\xf3 ngh\u0129a l\xe0 b\u1EA1n c\xf4ng nh\u1EADn r\u1EB1ng b\u1EA1n s\u1EBD \u0111\u01B0\u1EE3c \u0111\u0103ng k\xfd tham gia Confluence c\u0169ng nh\u01B0 \u0111\u1ED3ng \xfd v\u1EDBi <termsLink>\u0110i\u1EC1u kho\u1EA3n d\u1ECBch v\u1EE5</termsLink> v\xe0 <privacyLink>Ch\xednh s\xe1ch quy\u1EC1n ri\xeang t\u01B0</privacyLink> c\u1EE7a Atlassian Cloud.",
    'project-pages.improvement.title': "C\xe1c trang d\u1EF1 \xe1n",
    'project-pages.improvement.transient-states.empty-state.auto-provisioned-create-page-button': "T\u1EA1o trang",
    'project-pages.improvement.transient-states.empty-state.auto-provisioned-description': "Ch\xfang t\xf4i \u0111\xe3 th\xeam Confluence \u0111\u1EC3 b\u1EA1n c\xf3 th\u1EC3 b\u1EAFt \u0111\u1EA7u t\u1EA1o v\xe0 li\xean k\u1EBFt t\u1EA5t c\u1EA3 t\xe0i li\u1EC7u d\u1EF1 \xe1n c\u1EE7a b\u1EA1n. Mi\u1EC5n ph\xed cho t\u1ED1i \u0111a 10 ng\u01B0\u1EDDi d\xf9ng.",
    'project-pages.improvement.transient-states.empty-state.auto-provisioned-learn-more-button': "T\xecm hi\u1EC3u th\xeam",
    'project-pages.improvement.transient-states.empty-state.create-page-button': "T\u1EA1o trang \u0111\u1EA7u ti\xean",
    'project-pages.improvement.transient-states.empty-state.description': "T\u1EA1o v\xe0i ghi ch\xfa cu\u1ED9c h\u1ECDp, y\xeau c\u1EA7u s\u1EA3n ph\u1EA9m, quy\u1EBFt \u0111\u1ECBnh ho\u1EB7c n\u1ED9i dung kh\xe1c \u0111\u1EC3 th\u1EA5y v\xf9ng n\xe0y l\u1EA5p \u0111\u1EA7y.",
    'project-pages.improvement.transient-states.empty-state.title': "Kh\xf4ng c\xf3 g\xec \u1EDF \u0111\xe2y ngo\xe0i ti\u1EC1m n\u0103ng",
    'project-pages.improvement.try-button': "Th\u1EED bi\u1EC3u m\u1EABu n\xe0y trong Confluence",
    'project-pages.improvement.try-it-now': "D\xf9ng th\u1EED ngay",
    'project-pages.improvement.try-lozenge': "Th\u1EED",
    'project-pages.improvement.try-on-demand-button': "D\xf9ng th\u1EED mi\u1EC5n ph\xed",
    'project-pages.page-deleted-flag.title': "\u0110\xe3 x\xf3a trang.",
    'project-pages.page-published-flag.title': "\u0110\xe3 \u0111\u0103ng trang c\u1EE7a b\u1EA1n.",
    'project-pages.unknown-error.description': "{contactSupport} n\u1EBFu thao t\xe1c l\xe0m m\u1EDBi kh\xf4ng kh\u1EAFc ph\u1EE5c \u0111\u01B0\u1EE3c m\u1ECDi th\u1EE9.",
    'project-pages.unknown-error.heading': "Ch\xfang t\xf4i kh\xf4ng th\u1EC3 hi\u1EC3n th\u1ECB c\xe1c trang d\u1EF1 \xe1n ngay b\xe2y gi\u1EDD"
};

});

parcelRegister("e9Pod", function(module, exports) {

$parcel$export(module.exports, "default", () => $95ba72ec2b58d0d0$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //
var $95ba72ec2b58d0d0$export$2e2bcd8739ae039 = {
    'confluence.project-pages.improvement.provisioning-background.text': 'This should take less than a minute',
    'confluence.project-pages.improvement.provisioning-background.title': 'Setting up your Project Pages',
    'confluence.project-pages.improvement.provisioning-modal-carousel.controls.dismiss': 'Dismiss',
    'confluence.project-pages.improvement.provisioning-modal-carousel.controls.done': 'Done',
    'confluence.project-pages.improvement.provisioning-modal-carousel.controls.next': 'Next',
    'embedded-content-tree.button.connect-different-source.label.non-final': 'Update space or page icon',
    'embedded-content-tree.button.connect-different-source.tooltip.non-final': 'Connect different space or page',
    'embedded-content-tree.button.connect-to-confluence.tooltip.non-final': 'Connect to Confluence',
    'embedded-content-tree.button.go-to-connected-page.tooltip.non-final': 'Open page in Confluence',
    'embedded-content-tree.button.go-to-connected-space.tooltip.non-final': 'Open space in Confluence',
    'embedded-content-tree.column.contributors.non-final': 'Contributors',
    'embedded-content-tree.column.last-modified.non-final': 'Last modified',
    'embedded-content-tree.column.title.non-final': 'Name',
    'embedded-content-tree.could-not-load-contributors.non-final': "Couldn't load contributors",
    'embedded-content-tree.could-not-load.non-final': "Couldn't load",
    'embedded-content-tree.create-child-page.non-final': 'Create a child page',
    'embedded-content-tree.create-page.non-final': 'Create page',
    'embedded-content-tree.drafts-toggle.label.non-final': 'Show drafts',
    'embedded-content-tree.edit-in-confluence.non-final': 'Edit in Confluence',
    'embedded-content-tree.edit.non-final': 'Edit',
    'embedded-content-tree.empty.description.non-final': 'Create some meeting notes, product requirements, decisions, or other content to see this space fill up.',
    'embedded-content-tree.empty.title.non-final': "There's nothing here but potential",
    'embedded-content-tree.error.description.non-final': "We can't show you these pages. Please try again later.",
    'embedded-content-tree.error.row.non-final': 'Unable to load pages.',
    'embedded-content-tree.error.title.non-final': 'Well, this is awkward...',
    'embedded-content-tree.friendly-when-created.non-final': 'Created',
    'embedded-content-tree.friendly-when-updated.non-final': 'Updated',
    'embedded-content-tree.view-profile.non-final': 'View profile',
    'project-pages.activating.description': "The connected Confuence space isn\u2019t quite ready yet. {contactSupport} if refreshing doesn\u2019t fix things.",
    'project-pages.activating.heading': 'Confluence is still loading',
    'project-pages.better-together-templates.meeting-notes.action-items-heading': 'What are the action items?',
    'project-pages.better-together-templates.meeting-notes.agenda-item-label': 'Agenda item',
    'project-pages.better-together-templates.meeting-notes.create-a-jira-issue': 'Type /Jira to create an issue',
    'project-pages.better-together-templates.meeting-notes.date-label': 'Date',
    'project-pages.better-together-templates.meeting-notes.discussion-topics-heading': 'Discussion topics',
    'project-pages.better-together-templates.meeting-notes.list-people': 'list people using',
    'project-pages.better-together-templates.meeting-notes.mention': 'mention',
    'project-pages.better-together-templates.meeting-notes.mention-people-to-assign-them': 'people to assign them to an action item',
    'project-pages.better-together-templates.meeting-notes.notes-label': 'Notes',
    'project-pages.better-together-templates.meeting-notes.page-title': 'Meeting notes',
    'project-pages.better-together-templates.meeting-notes.participants-label': 'Participants',
    'project-pages.better-together-templates.meeting-notes.project-label': 'Project',
    'project-pages.better-together-templates.product-requirements.create-a-jira-issue': 'Type /Jira to create an issue',
    'project-pages.better-together-templates.product-requirements.design-heading': 'Design',
    'project-pages.better-together-templates.product-requirements.embedd-different-data-views': 'Embed different data and views from your Jira project.',
    'project-pages.better-together-templates.product-requirements.heading': 'Overview',
    'project-pages.better-together-templates.product-requirements.how-will-you-know-if-fixed': "How will you know if you've fixed it?",
    'project-pages.better-together-templates.product-requirements.impact-heading': 'Impact',
    'project-pages.better-together-templates.product-requirements.inScopeStatus': 'In scope',
    'project-pages.better-together-templates.product-requirements.insert-design-link': 'Insert a link to your design (Figma, etc)',
    'project-pages.better-together-templates.product-requirements.jira-issue-heading': 'Jira issue',
    'project-pages.better-together-templates.product-requirements.jira-roadmap-heading': 'Jira roadmap',
    'project-pages.better-together-templates.product-requirements.learn-how-with-smart-links': 'Learn how with smart links',
    'project-pages.better-together-templates.product-requirements.list-dashboards': 'List dashboards (Amplitude, Mode, etc)',
    'project-pages.better-together-templates.product-requirements.list-design-considerations': 'List design or build considerations',
    'project-pages.better-together-templates.product-requirements.list-people': 'list people using',
    'project-pages.better-together-templates.product-requirements.mention': 'mention',
    'project-pages.better-together-templates.product-requirements.mention-people-to-assign-them': 'people to assign them to an action item',
    'project-pages.better-together-templates.product-requirements.niceToHaveStatus': 'Nice to have',
    'project-pages.better-together-templates.product-requirements.outOfScopeStatus': 'Out of scope',
    'project-pages.better-together-templates.product-requirements.page-title': 'Product requirements',
    'project-pages.better-together-templates.product-requirements.pro-tip': 'Pro tip:',
    'project-pages.better-together-templates.product-requirements.problem-label': 'Problem',
    'project-pages.better-together-templates.product-requirements.requirement-heading': 'Requirement',
    'project-pages.better-together-templates.product-requirements.scope-heading': 'Scope',
    'project-pages.better-together-templates.product-requirements.success-metric': 'Success metric',
    'project-pages.better-together-templates.product-requirements.target-release-date': 'Target release date',
    'project-pages.better-together-templates.product-requirements.team-label': 'Team',
    'project-pages.better-together-templates.product-requirements.to-do-list-heading': 'To-do list',
    'project-pages.better-together-templates.product-requirements.what-are-you-trying-to-fix': 'What are you trying to fix?',
    'project-pages.better-together-templates.retro-notes.retro-heading': 'Retrospective',
    'project-pages.better-together-templates.retro.action-items-heading': 'What are the action items?',
    'project-pages.better-together-templates.retro.create-a-jira-issue': 'Type /Jira to create an issue',
    'project-pages.better-together-templates.retro.date-label': 'Date',
    'project-pages.better-together-templates.retro.embed-it-here': "Once you\u2019re done you can embed it here.",
    'project-pages.better-together-templates.retro.list-people': 'list people using',
    'project-pages.better-together-templates.retro.mention': 'mention',
    'project-pages.better-together-templates.retro.mention-people-to-assign-them': 'people to assign them to an action item',
    'project-pages.better-together-templates.retro.page-title': 'Retrospective',
    'project-pages.better-together-templates.retro.participants-label': 'Participants',
    'project-pages.better-together-templates.retro.pro-tip': 'Pro tip:',
    'project-pages.better-together-templates.retro.project-label': 'Project',
    'project-pages.better-together-templates.retro.this-is-a-whiteboard': 'This is a Confluence whiteboard.',
    'project-pages.better-together-templates.retro.use-a-whiteboard': 'Use a Confluence whiteboard for your retro.',
    'project-pages.better-together-templates.retro.use-it-to-vote': 'Use it to vote and collaborate with your team.',
    'project-pages.button.connect-different-space-or-page.label': 'Update space or page icon',
    'project-pages.button.connect-different-space-or-page.tooltip': 'Connect different space or item',
    'project-pages.button.connect-space-or-page.tooltip': 'Connect to Confluence',
    'project-pages.button.go-to-connected-live-doc.tooltip': 'Open live doc in Confluence',
    'project-pages.button.go-to-connected-page.tooltip': 'Open page in Confluence',
    'project-pages.button.go-to-connected-space.tooltip': 'Open space in Confluence',
    'project-pages.connect-space-dialog.connection-error': 'Connection failed.',
    'project-pages.connect-space-dialog.connection-retry': 'Retry',
    'project-pages.connect-space-dialog.content.space-or-page-selector.description': 'Choose a space or item to connect to your project.',
    'project-pages.connect-space-dialog.content.space-or-page-selector.placeholder': 'Search Confluence',
    'project-pages.connect-space-dialog.content.space-or-page-selector.search-label': 'Search confluence space or page',
    'project-pages.connect-space-dialog.content.space-selector.disconnected-templates-description': 'This project needs to be connected to a space before you can create an item. Choose a space to connect to this project.',
    'project-pages.connect-space-dialog.error-icon': 'Error:',
    'project-pages.connect-space-dialog.footer.cancel': 'Cancel',
    'project-pages.connect-space-dialog.footer.connect-space': 'Connect',
    'project-pages.connect-space-or-page-dialog.header.title': 'Connect project to Confluence',
    'project-pages.connect-space.button.non-final': 'Connect to Confluence',
    'project-pages.connect-space.description': 'Spaces are like folders - you can use them to create, organize, and collaborate on all the content related to your project.',
    'project-pages.connect-space.description.non-final': 'Spaces are like folders - you can use them to create, organize, and collaborate on all the content related to your project.',
    'project-pages.connect-space.not-connected.description': 'To use project pages, contact your admin or team lead to connect Confluence to this project.',
    'project-pages.connect-space.not-connected.description.non-final': 'To use project pages, contact your admin or team lead to connect Confluence to this project.',
    'project-pages.connect-space.not-connected.heading': 'Not connected to Confluence',
    'project-pages.connect-space.not-connected.heading.non-final': 'Unable to connect to Confluence',
    'project-pages.connect-success-flag.description.content': 'Successfully connected with {connectedSpaceOrPageName} content.',
    'project-pages.connection-error.space-or-page-not-found.button': 'Connect to a different space or page',
    'project-pages.contact-support.non-final': 'Contact support',
    'project-pages.create-space-dialog.connection-error': 'Connection failed.',
    'project-pages.create-space-dialog.connection-retry': 'Retry',
    'project-pages.create-space-dialog.content.empty-name': 'Please give your space a name.',
    'project-pages.create-space-dialog.content.invalid-name': 'Space names require at least one letter or number.',
    'project-pages.create-space-dialog.content.placeholder': 'Enter a space name',
    'project-pages.create-space-dialog.creation-error': 'Space creation failed.',
    'project-pages.create-space-dialog.error-icon': 'Error:',
    'project-pages.create-space-dialog.footer.cancel': 'Cancel',
    'project-pages.create-space-dialog.footer.create-space': 'Create',
    'project-pages.create-space-dialog.header.title': 'Create new Confluence space',
    'project-pages.cross-join.access-revoked.templates.subtitle': 'You cannot use project pages because the admin has denied you access to Confluence. Contact your site admin to request access.',
    'project-pages.cross-join.access-revoked.templates.title': "You don't have permissions to use project pages",
    'project-pages.cross-join.avatar.view-profile': 'View profile',
    'project-pages.cross-join.denied-request.templates.subtitle': "You can't use project pages because the site admin denied your request to join Confluence.",
    'project-pages.cross-join.denied-request.templates.title': 'Your admin has denied you access',
    'project-pages.cross-join.direct-access.button-subtitle.experimental': "You'll get access to Confluence. Your site admin has already approved you.",
    'project-pages.cross-join.errors.unknown-error.description': "{contactSupport} if refreshing doesn't fix things.",
    'project-pages.cross-join.errors.unknown-error.title': "We can't display project pages right now",
    'project-pages.cross-join.inline-join-product.button': "You\u2019ll get access to Confluence. Your site admin has already approved you.",
    'project-pages.cross-join.inline-join-product.connected.description': 'View, edit and create documentation from a single place',
    'project-pages.cross-join.inline-join-product.connected.title': 'Collaborate on project pages with your team',
    'project-pages.cross-join.pending-request.templates.subtitle': "The site admin has received your request to join Confluence. If you're approved to join, project pages will start working and we'll send you a confirmation email.",
    'project-pages.cross-join.pending-request.templates.subtitle.experiment': "You'll get an email with access to Project Pages once you\u2019re approved.",
    'project-pages.cross-join.pending-request.templates.title': "You've requested access to Confluence",
    'project-pages.cross-join.pending-request.templates.title.experiment': 'Access request sent to Admin',
    'project-pages.cross-join.request-access-without-better-together.connected.description': 'View, edit and create project documentation with your team',
    'project-pages.cross-join.request-access.button': 'Request access',
    'project-pages.cross-join.request-access.button-subtitle.experimental': "When you select 'Join Your Team', you're asking to join Confluence and agree to share your Atlassian profile with your admin.",
    'project-pages.cross-join.request-access.button.experimental': 'Join your team',
    'project-pages.cross-join.request-access.connected.description.experimental': "Your team is using Project Pages to comment, edit, and collaborate on project documentation without leaving Jira. Join Confluence to access your team\u2019s Project Pages.",
    'project-pages.cross-join.request-access.title': 'Project pages require access to Confluence',
    'project-pages.cross-join.request-access.title.experiment': 'Create a single source of truth for your team',
    'project-pages.default-contextual-heading': 'Project pages are powered by Confluence',
    'project-pages.default-contextual-message': 'Create, share, and collaborate on all your project docs in one place, with Confluence pages.',
    'project-pages.default-reactivate-CTA': 'Reactivate Confluence',
    'project-pages.default-trial-CTA': 'Try Confluence free for 30 days',
    'project-pages.draft-saved-flag.action': 'Open draft',
    'project-pages.draft-saved-flag.description': 'Your draft is only visible to you until you publish it.',
    'project-pages.draft-saved-flag.title': 'Draft saved',
    'project-pages.embedded-pages.create-page-error.close-button': 'Close',
    'project-pages.embedded-pages.create-page-error.description': "There was a problem and we couldn\u2019t create a page for you.",
    'project-pages.embedded-pages.create-page-error.title': "We couldn\u2019t create a page",
    'project-pages.embedded-pages.create-page-error.try-again-button': 'Try again',
    'project-pages.embedded-pages.modal.close.button.hint': 'Close',
    'project-pages.embedded-pages.modal.title.button': 'Open in Confluence',
    'project-pages.embedded-pages.modal.title.button.hint': 'Open in a new tab',
    'project-pages.errors.access-error.title.non-final': "You don\u2019t have permission to view project pages",
    'project-pages.errors.connection-error.space-or-page-not-found.button.non-final': 'Connect to a different space or page',
    'project-pages.errors.page-tree-unknown-error.description.non-final': "Something went wrong while trying to display pages from your connected Confluence space. {contactSupport} if refreshing doesn\u2019t fix things.",
    'project-pages.errors.page-tree-unknown-error.title.non-final': "We\u2019re having trouble displaying project pages",
    'project-pages.errors.space-or-page-not-found.description.non-final': "The Confluence space or page that was connected has been moved, archived, or deleted. <link>Contact support</link> if re-connecting doesn't fix things",
    'project-pages.errors.space-or-page-not-found.title.non-final': 'Space or page not found',
    'project-pages.errors.unknown-error.description.non-final': "{contactSupport} if refreshing doesn\u2019t fix things.",
    'project-pages.errors.unknown-error.title.non-final': "We can\u2019t display project pages right now",
    'project-pages.generic-error.button.reload': 'Reload page',
    'project-pages.generic-error.button.reload.non-final': 'Reload page',
    'project-pages.generic-error.description': 'Something went wrong. Please try again later.',
    'project-pages.generic-error.description.non-final': 'Something went wrong. Please try again later.',
    'project-pages.generic-error.heading': 'Well, this is awkward...',
    'project-pages.generic-error.title.non-final': 'Well, this is awkward...',
    'project-pages.generic-info-flag.description': 'Something went wrong. Please try again or contact support if the issue persists',
    'project-pages.generic-success-flag.description.live-doc': 'Successfully connected with {connectedSpaceOrPageName} live doc.',
    'project-pages.generic-success-flag.description.page': 'Successfully connected with {connectedSpaceOrPageName} page.',
    'project-pages.generic-success-flag.description.space': 'Successfully connected with {connectedSpaceOrPageName} space.',
    'project-pages.generic-success-flag.heading.live-doc': 'Live doc connected',
    'project-pages.generic-success-flag.heading.page': 'Page connected',
    'project-pages.generic-success-flag.heading.space': 'Space connected',
    'project-pages.granular-pages.connect-space-dialog.content.create-space-link.link-text': 'Or create a new space',
    'project-pages.granular-pages.connect-space.button': 'Connect to Confluence',
    'project-pages.granular-pages.connect-space.button.non-final': 'Connect to Confluence',
    'project-pages.granular-pages.connect-space.heading': 'Connect this project to a Confluence space or item',
    'project-pages.granular-pages.connect-space.heading.non-final': 'Connect this project to a Confluence space or item',
    'project-pages.improvement.contact-support': 'Contact support',
    'project-pages.improvement.errors.access-error.description': 'Try contacting the site admin to ask for access.',
    'project-pages.improvement.errors.access-error.title': "You don\u2019t have permission to view project pages",
    'project-pages.improvement.errors.page-tree-unknown-error.description': "Something went wrong while trying to display pages from your connected Confluence space. {contactSupport} if refreshing doesn\u2019t fix things.",
    'project-pages.improvement.errors.page-tree-unknown-error.title': "We\u2019re having trouble displaying project pages",
    'project-pages.improvement.errors.space-or-page-not-found.description': "The Confluence space or page that was connected has been moved, archived, or deleted. <link>Contact support</link> if re-connecting doesn't fix things",
    'project-pages.improvement.errors.space-or-page-not-found.title': 'Space or page not found',
    'project-pages.improvement.errors.unknown-error.description': "{contactSupport} if refreshing doesn\u2019t fix things.",
    'project-pages.improvement.errors.unknown-error.title': "We can\u2019t display project pages right now",
    'project-pages.improvement.feature1': 'Access and create documents without leaving Jira',
    'project-pages.improvement.feature1.non-final': 'Access and create documents without leaving Jira',
    'project-pages.improvement.feature2': 'Templates for meetings, sprint plans, and more',
    'project-pages.improvement.feature2.non-final': 'Templates for meetings, sprint plans, and more',
    'project-pages.improvement.feature3': 'Sync documents to Jira for automatic updates',
    'project-pages.improvement.feature3.non-final': 'Sync documents to Jira for automatic updates',
    'project-pages.improvement.heading-info': "Capture your team's knowledge and improve the way you get work done.",
    'project-pages.improvement.heading-info-v2': "Create one place for all your team's project documents",
    'project-pages.improvement.heading-info-v2.non-final': "Create one place for all your team's project documents",
    'project-pages.improvement.heading-info.non-final': "Capture your team's knowledge and improve the way you get work done.",
    'project-pages.improvement.learn-more-button': 'Learn more',
    'project-pages.improvement.learn-more-button.non-final': 'Learn more',
    'project-pages.improvement.powered-by': 'Powered by',
    'project-pages.improvement.powered-by.non-final': 'Powered by',
    'project-pages.improvement.powered-by.tooltip': 'Open Confluence in a new tab',
    'project-pages.improvement.powered-by.tooltip.non-final': 'Open Confluence in a new tab',
    'project-pages.improvement.preview-teaser': 'Unlock templates, project pages, and more.',
    'project-pages.improvement.preview-teaser.non-final': 'Unlock templates, project pages, and more.',
    'project-pages.improvement.provisioning-info-modal.seamlessly-update-stakeholders.description': "<p>Keep your project reports up-to-date with auto-updating status labels.</p> <p>Simply link a Jira ticket in a doc and it will automatically display a status label that updates in sync with the ticket, so you don't have to spend your time creating manual reports.</p>",
    'project-pages.improvement.provisioning-info-modal.seamlessly-update-stakeholders.title': 'Seamlessly update your stakeholders',
    'project-pages.improvement.provisioning-info-modal.unify-documentation-standards.description': "<p>Create consistent documentation by using our built-in templates. They are simple to use and customizable for your needs.</p> <p>You can use templates directly from project pages, so you never have to leave what you're working on. Browse all templates <a>here</a>.</p>",
    'project-pages.improvement.provisioning-info-modal.unify-documentation-standards.title': 'Unify your documentation standards',
    'project-pages.improvement.provisioning-info-modal.your-project-pages-in-jira.description': "<p>Create a single source of truth for important information by creating and managing documentation from the project pages tab in Jira.</p> <p>Did you know project pages runs on Confluence? It's free for up to 10 users. Invite the rest of your team in admin settings.</p>",
    'project-pages.improvement.provisioning-info-modal.your-project-pages-in-jira.title': 'Your project pages, directly in Jira',
    'project-pages.improvement.templates-sidebar.better-together-templates-header': 'Templates integrated with your Jira data',
    'project-pages.improvement.templates.better-together-preview-teaser': 'Integrated with Jira data',
    'project-pages.improvement.templates.blank-page.description': 'Start a page from scratch.',
    'project-pages.improvement.templates.blank-page.description.non-final': 'Start a page from scratch.',
    'project-pages.improvement.templates.blank-page.name': 'Blank page',
    'project-pages.improvement.templates.blank-page.name.non-final': 'Blank page',
    'project-pages.improvement.templates.decision.description': 'Record important project decisions and communicate them with your team.',
    'project-pages.improvement.templates.decision.description.non-final': 'Record important project decisions and communicate them with your team.',
    'project-pages.improvement.templates.decision.name': 'Decision',
    'project-pages.improvement.templates.decision.name.non-final': 'Decision',
    'project-pages.improvement.templates.meeting-notes.description': 'Set meeting agendas, take notes, and share action items with your team.',
    'project-pages.improvement.templates.meeting-notes.description.non-final': 'Set meeting agendas, take notes, and share action items with your team.',
    'project-pages.improvement.templates.meeting-notes.name': 'Meeting notes',
    'project-pages.improvement.templates.meeting-notes.name.non-final': 'Meeting notes',
    'project-pages.improvement.templates.post-expand.more': 'More templates',
    'project-pages.improvement.templates.post-expand.more.non-final': 'More templates',
    'project-pages.improvement.templates.post-expand.more.tooltip': 'View all templates in Confluence',
    'project-pages.improvement.templates.post-expand.more.tooltip.non-final': 'View all templates in Confluence',
    'project-pages.improvement.templates.post-expand.subtitle': 'Popular templates',
    'project-pages.improvement.templates.post-expand.subtitle.non-final': 'Popular templates',
    'project-pages.improvement.templates.post-expand.title': 'Create a page',
    'project-pages.improvement.templates.post-expand.title.non-final': 'Create a page',
    'project-pages.improvement.templates.pre-expand.more': 'Explore more templates',
    'project-pages.improvement.templates.pre-expand.more.non-final': 'Explore more templates',
    'project-pages.improvement.templates.pre-expand.subtitle': 'Popular with teams like yours',
    'project-pages.improvement.templates.pre-expand.subtitle.non-final': 'Popular with teams like yours',
    'project-pages.improvement.templates.pre-expand.title': 'Preview templates',
    'project-pages.improvement.templates.pre-expand.title.non-final': 'Preview templates',
    'project-pages.improvement.templates.product-requirements.description': 'Define, track and scope requirements for your product or feature.',
    'project-pages.improvement.templates.product-requirements.description.non-final': 'Define, track and scope requirements for your product or feature.',
    'project-pages.improvement.templates.product-requirements.name': 'Product requirements',
    'project-pages.improvement.templates.product-requirements.name.non-final': 'Product requirements',
    'project-pages.improvement.templates.retrospective.description': 'What went well? What could have gone better? Crowdsource improvements with your team.',
    'project-pages.improvement.templates.retrospective.description.non-final': 'What went well? What could have gone better? Crowdsource improvements with your team.',
    'project-pages.improvement.templates.retrospective.name': 'Retrospective',
    'project-pages.improvement.templates.retrospective.name.non-final': 'Retrospective',
    'project-pages.improvement.templates.template.disabled-tooltip': 'Connect a Confluence space first',
    'project-pages.improvement.templates.template.disabled-tooltip.non-final': 'Connect a Confluence space first',
    'project-pages.improvement.templates.tutorial.content.confluence-templates': '<b>Save time and reduce manual tasks</b>. Confluence has lots of page <a>templates</a>, so you never have to start from scratch. Think technical documents, troubleshooting guides, project plans, product requirements, and more.',
    'project-pages.improvement.templates.tutorial.content.confluence-templates.non-final': '<b>Save time and reduce manual tasks</b>. Confluence has lots of page <a>templates</a>, so you never have to start from scratch. Think technical documents, troubleshooting guides, project plans, product requirements, and more.',
    'project-pages.improvement.templates.tutorial.content.edit-and-format': '<b>Easily edit and format.</b> Use the top editing menu for standard word formatting, and by typing <b>/</b> you can easily insert lots of handy integrations. Insert a table by typing <c>/table</c> or an image with <c>/image</c>. You can also insert Dropbox links <c>/dropbox</c>, Microsoft office tools <c>/microsoft</c>, or Trello boards and cards <c>/trello</c>.',
    'project-pages.improvement.templates.tutorial.content.edit-and-format.non-final': '<b>Easily edit and format.</b> Use the top editing menu for standard word formatting, and by typing <b>/</b> you can easily insert lots of handy integrations. Insert a table by typing <c>/table</c> or an image with <c>/image</c>. You can also insert Dropbox links <c>/dropbox</c>, Microsoft office tools <c>/microsoft</c>, or Trello boards and cards <c>/trello</c>.',
    'project-pages.improvement.templates.tutorial.content.forward-slash-prompt': "Type / followed by \u2018table\u2019 or \u2018image\u2019",
    'project-pages.improvement.templates.tutorial.content.forward-slash-prompt.non-final': "Type / followed by \u2018table\u2019 or \u2018image\u2019",
    'project-pages.improvement.templates.tutorial.content.getting-started-tips': 'Here are a couple of tips to get you started:',
    'project-pages.improvement.templates.tutorial.content.getting-started-tips.non-final': 'Here are a couple of tips to get you started:',
    'project-pages.improvement.templates.tutorial.content.handy-links': 'Handy links',
    'project-pages.improvement.templates.tutorial.content.handy-links.non-final': 'Handy links',
    'project-pages.improvement.templates.tutorial.content.jira-and-confluence': 'Use Jira and Confluence together',
    'project-pages.improvement.templates.tutorial.content.jira-and-confluence.non-final': 'Use Jira and Confluence together',
    'project-pages.improvement.templates.tutorial.content.jira-charts': 'Create charts on your pages using real Jira data. Type <c>/Jira charts</c>.',
    'project-pages.improvement.templates.tutorial.content.jira-charts.non-final': 'Create charts on your pages using real Jira data. Type <c>/Jira charts</c>.',
    'project-pages.improvement.templates.tutorial.content.jira-links': 'Link a Jira issue anywhere on your page. The link on the page will update in real-time, as you update the Jira issue. Type <c>/Jira</c>.',
    'project-pages.improvement.templates.tutorial.content.jira-links-issue-term-refresh': 'Link a Jira work item anywhere on your page. The link on the page will update in real-time, as you update the work item. Type <c>/Jira</c>.',
    'project-pages.improvement.templates.tutorial.content.jira-links.non-final': 'Link a Jira issue anywhere on your page. The link on the page will update in real-time, as you update the Jira issue. Type <c>/Jira</c>.',
    'project-pages.improvement.templates.tutorial.content.jira-links.non-final-issue-term-refresh': 'Link a Jira work item anywhere on your page. The link on the page will update in real-time, as you update the work item. Type <c>/Jira</c>.',
    'project-pages.improvement.templates.tutorial.content.jira-roadmaps': 'Embed interactive roadmaps and timelines for your page using your Jira Projects. Type <c>/jira roadmap</c>.',
    'project-pages.improvement.templates.tutorial.content.jira-roadmaps.non-final': 'Embed interactive roadmaps and timelines for your page using your Jira Projects. Type <c>/jira roadmap</c>.',
    'project-pages.improvement.templates.tutorial.content.jira-timeline': 'Embed interactive timelines for your page using your Jira Projects. Type <c>/jira timeline</c>.',
    'project-pages.improvement.templates.tutorial.content.jira-timeline.non-final': 'Embed interactive timelines for your page using your Jira Projects. Type <c>/jira timeline</c>.',
    'project-pages.improvement.templates.tutorial.content.shipping-speed-statistic': '76% of Jira Software customers said they shipped projects faster after adding Confluence',
    'project-pages.improvement.templates.tutorial.content.shipping-speed-statistic.non-final': '76% of Jira Software customers said they shipped projects faster after adding Confluence',
    'project-pages.improvement.templates.tutorial.content.shipping-speed-statistic.spork-rebranding': '76% of Jira customers said they shipped projects faster after adding Confluence',
    'project-pages.improvement.templates.tutorial.content.shipping-speed-statistic.spork-rebranding.non-final': '76% of Jira customers said they shipped projects faster after adding Confluence',
    'project-pages.improvement.templates.tutorial.content.spaces-and-pages': '<b>Using spaces and pages</b>. Spaces are part of every Confluence site and are a way of organizing pages into categories. Think of spaces as different folders or projects, and pages are the documents that belong in those folders or projects. <a>Learn more about how to use spaces</a>',
    'project-pages.improvement.templates.tutorial.content.spaces-and-pages.non-final': '<b>Using spaces and pages</b>. Spaces are part of every Confluence site and are a way of organizing pages into categories. Think of spaces as different folders or projects, and pages are the documents that belong in those folders or projects. <a>Learn more about how to use spaces</a>',
    'project-pages.improvement.templates.tutorial.content.try-it-now': 'Try it now',
    'project-pages.improvement.templates.tutorial.content.try-it-now.non-final': 'Try it now',
    'project-pages.improvement.templates.tutorial.description': 'Learn how to edit a page.',
    'project-pages.improvement.templates.tutorial.description.non-final': 'Learn how to edit a page.',
    'project-pages.improvement.templates.tutorial.name': 'Welcome to Project Pages!',
    'project-pages.improvement.templates.tutorial.name.non-final': 'Welcome to Project Pages!',
    'project-pages.improvement.terms-and-conditions-v2': "By selecting 'Try it now' you acknowledge you will be enrolled in Confluence and agree to the Atlassian <termsLink>Cloud Terms of Service</termsLink> and <privacyLink>Privacy Policy</privacyLink>.",
    'project-pages.improvement.terms-and-conditions-v2.non-final': "By selecting 'Try it now' you acknowledge you will be enrolled in Confluence and agree to the Atlassian <termsLink>Cloud Terms of Service</termsLink> and <privacyLink>Privacy Policy</privacyLink>.",
    'project-pages.improvement.title': 'Project pages',
    'project-pages.improvement.title.non-final': 'Project pages',
    'project-pages.improvement.transient-states.empty-state.auto-provisioned-create-page-button': 'Create page',
    'project-pages.improvement.transient-states.empty-state.auto-provisioned-description': "We\u2019ve added Confluence so you can start creating and linking all your project documents. It\u2019s free for up to 10 users.",
    'project-pages.improvement.transient-states.empty-state.auto-provisioned-learn-more-button': 'Learn more',
    'project-pages.improvement.transient-states.empty-state.create-page-button': 'Create your first page',
    'project-pages.improvement.transient-states.empty-state.description': 'Create some meeting notes, product requirements, decisions, or other content to see this space fill up.',
    'project-pages.improvement.transient-states.empty-state.title': "There\u2019s nothing here but potential",
    'project-pages.improvement.try-button': 'Try this template in Confluence',
    'project-pages.improvement.try-button.non-final': 'Try this template in Confluence',
    'project-pages.improvement.try-it-now': 'Try it now',
    'project-pages.improvement.try-it-now.non-final': 'Try it now',
    'project-pages.improvement.try-lozenge': 'try',
    'project-pages.improvement.try-lozenge.non-final': 'try',
    'project-pages.improvement.try-on-demand-button': 'Try it free',
    'project-pages.improvement.try-on-demand-button.non-final': 'Try it free',
    'project-pages.join-confluence-screens.denied-access-title.non-final': 'Denied Access Screen',
    'project-pages.join-confluence-screens.direct-join-title.non-final': 'Direct Join Screen',
    'project-pages.join-confluence-screens.pending-request-title.non-final': 'Pending Request Screen',
    'project-pages.join-confluence-screens.request-access-title.non-final': 'Request Access Screen',
    'project-pages.join-confluence-screens.revoked-access-title.non-final': 'Revoked Access Screen',
    'project-pages.join-confluence-screens.title.non-final': 'Join Confluence Page',
    'project-pages.landing-page.feature1.non-final': 'Access and create documents without leaving Jira',
    'project-pages.landing-page.feature2.non-final': 'Templates for meetings, sprint plans, and more',
    'project-pages.landing-page.feature3.non-final': 'Sync documents to Jira for automatic updates',
    'project-pages.landing-page.illustration.title.non-final': 'Project pages',
    'project-pages.landing-page.terms-and-conditions.non-final': "By selecting 'Try it now' you acknowledge you will be enrolled in Confluence and agree to the Atlassian <termsLink>Cloud Terms of Service</termsLink> and <privacyLink>Privacy Policy</privacyLink>.",
    'project-pages.landing-page.title.non-final': 'Welcome to Project Pages',
    'project-pages.landing-page.try-now-btn.non-final': 'Try it now',
    'project-pages.page-deleted-flag.title': 'Page deleted.',
    'project-pages.page-published-flag.title': 'Your page has been published.',
    'project-pages.space-connectsuccess-flag.title.space.non-final': 'Content connected',
    'project-pages.title.non-final': 'Project pages',
    'project-pages.unknown-error.description': "{contactSupport} if refreshing doesn\u2019t fix things.",
    'project-pages.unknown-error.heading': "We can\u2019t display project pages right now"
};

});

parcelRegister("5d2m0", function(module, exports) {

$parcel$export(module.exports, "default", () => $061ce7e3e2613251$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //English (United Kingdom)
var $061ce7e3e2613251$export$2e2bcd8739ae039 = {
    'confluence.project-pages.improvement.provisioning-background.text': 'This should take less than a minute',
    'confluence.project-pages.improvement.provisioning-background.title': 'Setting up your Project Pages',
    'confluence.project-pages.improvement.provisioning-modal-carousel.controls.dismiss': 'Dismiss',
    'confluence.project-pages.improvement.provisioning-modal-carousel.controls.done': 'Done',
    'confluence.project-pages.improvement.provisioning-modal-carousel.controls.next': 'Next',
    'embedded-content-tree.button.connect-different-source.label.non-final': 'Update space or page icon',
    'embedded-content-tree.button.connect-different-source.tooltip.non-final': 'Connect different space or page',
    'embedded-content-tree.button.connect-to-confluence.tooltip.non-final': 'Connect to Confluence',
    'embedded-content-tree.button.go-to-connected-page.tooltip.non-final': 'Open page in Confluence',
    'embedded-content-tree.button.go-to-connected-space.tooltip.non-final': 'Open space in Confluence',
    'embedded-content-tree.column.contributors.non-final': 'Contributors',
    'embedded-content-tree.column.last-modified.non-final': 'Last modified',
    'embedded-content-tree.column.title.non-final': 'Name',
    'embedded-content-tree.could-not-load-contributors.non-final': "Couldn't load contributors",
    'embedded-content-tree.could-not-load.non-final': "Couldn't load",
    'embedded-content-tree.create-child-page.non-final': 'Create a child page',
    'embedded-content-tree.create-page.non-final': 'Create page',
    'embedded-content-tree.drafts-toggle.label.non-final': 'Show drafts',
    'embedded-content-tree.edit-in-confluence.non-final': 'Edit in Confluence',
    'embedded-content-tree.edit.non-final': 'Edit',
    'embedded-content-tree.empty.description.non-final': 'Create some meeting notes, product requirements, decisions, or other content to see this space fill up.',
    'embedded-content-tree.empty.title.non-final': "There's nothing here but potential",
    'embedded-content-tree.error.description.non-final': "We can't show you these pages. Please try again later.",
    'embedded-content-tree.error.row.non-final': 'Unable to load pages.',
    'embedded-content-tree.error.title.non-final': 'Well, this is awkward...',
    'embedded-content-tree.friendly-when-created.non-final': 'Created',
    'embedded-content-tree.friendly-when-updated.non-final': 'Updated',
    'embedded-content-tree.view-profile.non-final': 'View profile',
    'project-pages.activating.description': "The connected Confuence space isn\u2019t quite ready yet. {contactSupport} if refreshing doesn\u2019t fix things.",
    'project-pages.activating.heading': 'Confluence is still loading',
    'project-pages.better-together-templates.meeting-notes.action-items-heading': 'What are the action items?',
    'project-pages.better-together-templates.meeting-notes.agenda-item-label': 'Agenda item',
    'project-pages.better-together-templates.meeting-notes.create-a-jira-issue': 'Type /Jira to create an issue',
    'project-pages.better-together-templates.meeting-notes.date-label': 'Date',
    'project-pages.better-together-templates.meeting-notes.discussion-topics-heading': 'Discussion topics',
    'project-pages.better-together-templates.meeting-notes.list-people': 'list people using',
    'project-pages.better-together-templates.meeting-notes.mention': 'mention',
    'project-pages.better-together-templates.meeting-notes.mention-people-to-assign-them': 'people to assign them to an action item',
    'project-pages.better-together-templates.meeting-notes.notes-label': 'Notes',
    'project-pages.better-together-templates.meeting-notes.page-title': 'Meeting notes',
    'project-pages.better-together-templates.meeting-notes.participants-label': 'Participants',
    'project-pages.better-together-templates.meeting-notes.project-label': 'Project',
    'project-pages.better-together-templates.product-requirements.create-a-jira-issue': 'Type /Jira to create an issue',
    'project-pages.better-together-templates.product-requirements.design-heading': 'Design',
    'project-pages.better-together-templates.product-requirements.embedd-different-data-views': 'Embed different data and views from your Jira project.',
    'project-pages.better-together-templates.product-requirements.heading': 'Overview',
    'project-pages.better-together-templates.product-requirements.how-will-you-know-if-fixed': "How will you know if you've fixed it?",
    'project-pages.better-together-templates.product-requirements.impact-heading': 'Impact',
    'project-pages.better-together-templates.product-requirements.inScopeStatus': 'In scope',
    'project-pages.better-together-templates.product-requirements.insert-design-link': 'Insert a link to your design (Figma, etc)',
    'project-pages.better-together-templates.product-requirements.jira-issue-heading': 'Jira issue',
    'project-pages.better-together-templates.product-requirements.jira-roadmap-heading': 'Jira roadmap',
    'project-pages.better-together-templates.product-requirements.learn-how-with-smart-links': 'Learn how with smart links',
    'project-pages.better-together-templates.product-requirements.list-dashboards': 'List dashboards (Amplitude, Mode, etc)',
    'project-pages.better-together-templates.product-requirements.list-design-considerations': 'List design or build considerations',
    'project-pages.better-together-templates.product-requirements.list-people': 'list people using',
    'project-pages.better-together-templates.product-requirements.mention': 'mention',
    'project-pages.better-together-templates.product-requirements.mention-people-to-assign-them': 'people to assign them to an action item',
    'project-pages.better-together-templates.product-requirements.niceToHaveStatus': 'Nice to have',
    'project-pages.better-together-templates.product-requirements.outOfScopeStatus': 'Out of scope',
    'project-pages.better-together-templates.product-requirements.page-title': 'Product requirements',
    'project-pages.better-together-templates.product-requirements.pro-tip': 'Pro tip:',
    'project-pages.better-together-templates.product-requirements.problem-label': 'Problem',
    'project-pages.better-together-templates.product-requirements.requirement-heading': 'Requirement',
    'project-pages.better-together-templates.product-requirements.scope-heading': 'Scope',
    'project-pages.better-together-templates.product-requirements.success-metric': 'Success metric',
    'project-pages.better-together-templates.product-requirements.target-release-date': 'Target release date',
    'project-pages.better-together-templates.product-requirements.team-label': 'Team',
    'project-pages.better-together-templates.product-requirements.to-do-list-heading': 'To-do list',
    'project-pages.better-together-templates.product-requirements.what-are-you-trying-to-fix': 'What are you trying to fix?',
    'project-pages.better-together-templates.retro-notes.retro-heading': 'Retrospective',
    'project-pages.better-together-templates.retro.action-items-heading': 'What are the action items?',
    'project-pages.better-together-templates.retro.create-a-jira-issue': 'Type /Jira to create an issue',
    'project-pages.better-together-templates.retro.date-label': 'Date',
    'project-pages.better-together-templates.retro.embed-it-here': "Once you\u2019re done you can embed it here.",
    'project-pages.better-together-templates.retro.list-people': 'list people using',
    'project-pages.better-together-templates.retro.mention': 'mention',
    'project-pages.better-together-templates.retro.mention-people-to-assign-them': 'people to assign them to an action item',
    'project-pages.better-together-templates.retro.page-title': 'Retrospective',
    'project-pages.better-together-templates.retro.participants-label': 'Participants',
    'project-pages.better-together-templates.retro.pro-tip': 'Pro tip:',
    'project-pages.better-together-templates.retro.project-label': 'Project',
    'project-pages.better-together-templates.retro.this-is-a-whiteboard': 'This is a Confluence whiteboard.',
    'project-pages.better-together-templates.retro.use-a-whiteboard': 'Use a Confluence whiteboard for your retro.',
    'project-pages.better-together-templates.retro.use-it-to-vote': 'Use it to vote and collaborate with your team.',
    'project-pages.button.connect-different-space-or-page.label': 'Update space or page icon',
    'project-pages.button.connect-different-space-or-page.tooltip': 'Connect different space or item',
    'project-pages.button.connect-space-or-page.tooltip': 'Connect to Confluence',
    'project-pages.button.go-to-connected-live-doc.tooltip': 'Open live doc in Confluence',
    'project-pages.button.go-to-connected-page.tooltip': 'Open page in Confluence',
    'project-pages.button.go-to-connected-space.tooltip': 'Open space in Confluence',
    'project-pages.connect-space-dialog.connection-error': 'Connection failed.',
    'project-pages.connect-space-dialog.connection-retry': 'Retry',
    'project-pages.connect-space-dialog.content.space-or-page-selector.description': 'Choose a space or item to connect to your project.',
    'project-pages.connect-space-dialog.content.space-or-page-selector.placeholder': 'Search Confluence',
    'project-pages.connect-space-dialog.content.space-or-page-selector.search-label': 'Search confluence space or page',
    'project-pages.connect-space-dialog.content.space-selector.disconnected-templates-description': 'This project needs to be connected to a space before you can create an item. Choose a space to connect to this project.',
    'project-pages.connect-space-dialog.error-icon': 'Error:',
    'project-pages.connect-space-dialog.footer.cancel': 'Cancel',
    'project-pages.connect-space-dialog.footer.connect-space': 'Connect',
    'project-pages.connect-space-or-page-dialog.header.title': 'Connect project to Confluence',
    'project-pages.connect-space.button.non-final': 'Connect to Confluence',
    'project-pages.connect-space.description': 'Spaces are like folders - you can use them to create, organise, and collaborate on all the content related to your project.',
    'project-pages.connect-space.description.non-final': 'Spaces are like folders - you can use them to create, organise, and collaborate on all the content related to your project.',
    'project-pages.connect-space.not-connected.description': 'To use project pages, contact your admin or team lead to connect Confluence to this project.',
    'project-pages.connect-space.not-connected.description.non-final': 'To use project pages, contact your admin or team lead to connect Confluence to this project.',
    'project-pages.connect-space.not-connected.heading': 'Not connected to Confluence',
    'project-pages.connect-space.not-connected.heading.non-final': 'Unable to connect to Confluence',
    'project-pages.connect-success-flag.description.content': 'Successfully connected with {connectedSpaceOrPageName} content.',
    'project-pages.connection-error.space-or-page-not-found.button': 'Connect to a different space or page',
    'project-pages.contact-support.non-final': 'Contact support',
    'project-pages.create-space-dialog.connection-error': 'Connection failed.',
    'project-pages.create-space-dialog.connection-retry': 'Retry',
    'project-pages.create-space-dialog.content.empty-name': 'Please give your space a name.',
    'project-pages.create-space-dialog.content.invalid-name': 'Space names require at least one letter or number.',
    'project-pages.create-space-dialog.content.placeholder': 'Enter a space name',
    'project-pages.create-space-dialog.creation-error': 'Space creation failed.',
    'project-pages.create-space-dialog.error-icon': 'Error:',
    'project-pages.create-space-dialog.footer.cancel': 'Cancel',
    'project-pages.create-space-dialog.footer.create-space': 'Create',
    'project-pages.create-space-dialog.header.title': 'Create new Confluence space',
    'project-pages.cross-join.access-revoked.templates.subtitle': 'You cannot use project pages because the admin has denied you access to Confluence. Contact your site admin to request access.',
    'project-pages.cross-join.access-revoked.templates.title': "You don't have permissions to use project pages",
    'project-pages.cross-join.avatar.view-profile': 'View profile',
    'project-pages.cross-join.denied-request.templates.subtitle': "You can't use project pages because the site admin denied your request to join Confluence.",
    'project-pages.cross-join.denied-request.templates.title': 'Your admin has denied you access',
    'project-pages.cross-join.direct-access.button-subtitle.experimental': "You'll get access to Confluence. Your site admin has already approved you.",
    'project-pages.cross-join.errors.unknown-error.description': "{contactSupport} if refreshing doesn't fix things.",
    'project-pages.cross-join.errors.unknown-error.title': "We can't display project pages right now",
    'project-pages.cross-join.inline-join-product.button': "You\u2019ll get access to Confluence. Your site admin has already approved you.",
    'project-pages.cross-join.inline-join-product.connected.description': 'View, edit and create documentation from a single place',
    'project-pages.cross-join.inline-join-product.connected.title': 'Collaborate on project pages with your team',
    'project-pages.cross-join.pending-request.templates.subtitle': "The site admin has received your request to join Confluence. If you're approved to join, project pages will start working and we'll send you a confirmation email.",
    'project-pages.cross-join.pending-request.templates.subtitle.experiment': "You'll get an email with access to Project Pages once you\u2019re approved.",
    'project-pages.cross-join.pending-request.templates.title': "You've requested access to Confluence",
    'project-pages.cross-join.pending-request.templates.title.experiment': 'Access request sent to Admin',
    'project-pages.cross-join.request-access-without-better-together.connected.description': 'View, edit and create project documentation with your team',
    'project-pages.cross-join.request-access.button': 'Request access',
    'project-pages.cross-join.request-access.button-subtitle.experimental': "When you select 'Join Your Team', you're asking to join Confluence and agree to share your Atlassian profile with your admin.",
    'project-pages.cross-join.request-access.button.experimental': 'Join your team',
    'project-pages.cross-join.request-access.connected.description.experimental': "Your team is using Project Pages to comment, edit, and collaborate on project documentation without leaving Jira. Join Confluence to access your team\u2019s Project Pages.",
    'project-pages.cross-join.request-access.title': 'Project pages require access to Confluence',
    'project-pages.cross-join.request-access.title.experiment': 'Create a single source of truth for your team',
    'project-pages.default-contextual-heading': 'Project pages are powered by Confluence',
    'project-pages.default-contextual-message': 'Create, share, and collaborate on all your project docs in one place, with Confluence pages.',
    'project-pages.default-reactivate-CTA': 'Reactivate Confluence',
    'project-pages.default-trial-CTA': 'Try Confluence free for 30 days',
    'project-pages.draft-saved-flag.action': 'Open draft',
    'project-pages.draft-saved-flag.description': 'Your draft is only visible to you until you publish it.',
    'project-pages.draft-saved-flag.title': 'Draft saved',
    'project-pages.embedded-pages.create-page-error.close-button': 'Close',
    'project-pages.embedded-pages.create-page-error.description': "There was a problem and we couldn\u2019t create a page for you.",
    'project-pages.embedded-pages.create-page-error.title': "We couldn\u2019t create a page",
    'project-pages.embedded-pages.create-page-error.try-again-button': 'Try again',
    'project-pages.embedded-pages.modal.close.button.hint': 'Close',
    'project-pages.embedded-pages.modal.title.button': 'Open in Confluence',
    'project-pages.embedded-pages.modal.title.button.hint': 'Open in a new tab',
    'project-pages.errors.access-error.title.non-final': "You don\u2019t have permission to view project pages",
    'project-pages.errors.connection-error.space-or-page-not-found.button.non-final': 'Connect to a different space or page',
    'project-pages.errors.page-tree-unknown-error.description.non-final': "Something went wrong while trying to display pages from your connected Confluence space. {contactSupport} if refreshing doesn\u2019t fix things.",
    'project-pages.errors.page-tree-unknown-error.title.non-final': "We\u2019re having trouble displaying project pages",
    'project-pages.errors.space-or-page-not-found.description.non-final': "The Confluence space or page that was connected has been moved, archived, or deleted. <link>Contact support</link> if re-connecting doesn't fix things",
    'project-pages.errors.space-or-page-not-found.title.non-final': 'Space or page not found',
    'project-pages.errors.unknown-error.description.non-final': "{contactSupport} if refreshing doesn\u2019t fix things.",
    'project-pages.errors.unknown-error.title.non-final': "We can\u2019t display project pages right now",
    'project-pages.generic-error.button.reload': 'Reload page',
    'project-pages.generic-error.button.reload.non-final': 'Reload page',
    'project-pages.generic-error.description': 'Something went wrong. Please try again later.',
    'project-pages.generic-error.description.non-final': 'Something went wrong. Please try again later.',
    'project-pages.generic-error.heading': 'Well, this is awkward...',
    'project-pages.generic-error.title.non-final': 'Well, this is awkward...',
    'project-pages.generic-info-flag.description': 'Something went wrong. Please try again or contact support if the issue persists',
    'project-pages.generic-success-flag.description.live-doc': 'Successfully connected with {connectedSpaceOrPageName} live doc.',
    'project-pages.generic-success-flag.description.page': 'Successfully connected with {connectedSpaceOrPageName} page.',
    'project-pages.generic-success-flag.description.space': 'Successfully connected with {connectedSpaceOrPageName} space.',
    'project-pages.generic-success-flag.heading.live-doc': 'Live doc connected',
    'project-pages.generic-success-flag.heading.page': 'Page connected',
    'project-pages.generic-success-flag.heading.space': 'Space connected',
    'project-pages.granular-pages.connect-space-dialog.content.create-space-link.link-text': 'Or create a new space',
    'project-pages.granular-pages.connect-space.button': 'Connect to Confluence',
    'project-pages.granular-pages.connect-space.button.non-final': 'Connect to Confluence',
    'project-pages.granular-pages.connect-space.heading': 'Connect this project to a Confluence space or item',
    'project-pages.granular-pages.connect-space.heading.non-final': 'Connect this project to a Confluence space or item',
    'project-pages.improvement.contact-support': 'Contact support',
    'project-pages.improvement.errors.access-error.description': 'Try contacting the site admin to ask for access.',
    'project-pages.improvement.errors.access-error.title': "You don\u2019t have permission to view project pages",
    'project-pages.improvement.errors.page-tree-unknown-error.description': "Something went wrong while trying to display pages from your connected Confluence space. {contactSupport} if refreshing doesn\u2019t fix things.",
    'project-pages.improvement.errors.page-tree-unknown-error.title': "We\u2019re having trouble displaying project pages",
    'project-pages.improvement.errors.space-or-page-not-found.description': "The Confluence space or page that was connected has been moved, archived, or deleted. <link>Contact support</link> if re-connecting doesn't fix things",
    'project-pages.improvement.errors.space-or-page-not-found.title': 'Space or page not found',
    'project-pages.improvement.errors.unknown-error.description': "{contactSupport} if refreshing doesn\u2019t fix things.",
    'project-pages.improvement.errors.unknown-error.title': "We can\u2019t display project pages right now",
    'project-pages.improvement.feature1': 'Access and create documents without leaving Jira',
    'project-pages.improvement.feature1.non-final': 'Access and create documents without leaving Jira',
    'project-pages.improvement.feature2': 'Templates for meetings, sprint plans, and more',
    'project-pages.improvement.feature2.non-final': 'Templates for meetings, sprint plans, and more',
    'project-pages.improvement.feature3': 'Sync documents to Jira for automatic updates',
    'project-pages.improvement.feature3.non-final': 'Sync documents to Jira for automatic updates',
    'project-pages.improvement.heading-info': "Capture your team's knowledge and improve the way you get work done.",
    'project-pages.improvement.heading-info-v2': "Create one place for all your team's project documents",
    'project-pages.improvement.heading-info-v2.non-final': "Create one place for all your team's project documents",
    'project-pages.improvement.heading-info.non-final': "Capture your team's knowledge and improve the way you get work done.",
    'project-pages.improvement.learn-more-button': 'Learn more',
    'project-pages.improvement.learn-more-button.non-final': 'Learn more',
    'project-pages.improvement.powered-by': 'Powered by',
    'project-pages.improvement.powered-by.non-final': 'Powered by',
    'project-pages.improvement.powered-by.tooltip': 'Open Confluence in a new tab',
    'project-pages.improvement.powered-by.tooltip.non-final': 'Open Confluence in a new tab',
    'project-pages.improvement.preview-teaser': 'Unlock templates, project pages, and more.',
    'project-pages.improvement.preview-teaser.non-final': 'Unlock templates, project pages, and more.',
    'project-pages.improvement.provisioning-info-modal.seamlessly-update-stakeholders.description': "<p>Keep your project reports up-to-date with auto-updating status labels.</p> <p>Simply link a Jira ticket in a doc and it will automatically display a status label that updates in sync with the ticket, so you don't have to spend your time creating manual reports.</p>",
    'project-pages.improvement.provisioning-info-modal.seamlessly-update-stakeholders.title': 'Seamlessly update your stakeholders',
    'project-pages.improvement.provisioning-info-modal.unify-documentation-standards.description': "<p>Create consistent documentation by using our built-in templates. They are simple to use and customisable for your needs.</p> <p>You can use templates directly from project pages, so you never have to leave what you're working on. Browse all templates <a>here</a>.</p>",
    'project-pages.improvement.provisioning-info-modal.unify-documentation-standards.title': 'Unify your documentation standards',
    'project-pages.improvement.provisioning-info-modal.your-project-pages-in-jira.description': "<p>Create a single source of truth for important information by creating and managing documentation from the project pages tab in Jira.</p> <p>Did you know project pages runs on Confluence? It's free for up to 10 users. Invite the rest of your team in admin settings.</p>",
    'project-pages.improvement.provisioning-info-modal.your-project-pages-in-jira.title': 'Your project pages, directly in Jira',
    'project-pages.improvement.templates-sidebar.better-together-templates-header': 'Templates integrated with your Jira data',
    'project-pages.improvement.templates.better-together-preview-teaser': 'Integrated with Jira data',
    'project-pages.improvement.templates.blank-page.description': 'Start a page from scratch.',
    'project-pages.improvement.templates.blank-page.description.non-final': 'Start a page from scratch.',
    'project-pages.improvement.templates.blank-page.name': 'Blank page',
    'project-pages.improvement.templates.blank-page.name.non-final': 'Blank page',
    'project-pages.improvement.templates.decision.description': 'Record important project decisions and communicate them with your team.',
    'project-pages.improvement.templates.decision.description.non-final': 'Record important project decisions and communicate them with your team.',
    'project-pages.improvement.templates.decision.name': 'Decision',
    'project-pages.improvement.templates.decision.name.non-final': 'Decision',
    'project-pages.improvement.templates.meeting-notes.description': 'Set meeting agendas, take notes, and share action items with your team.',
    'project-pages.improvement.templates.meeting-notes.description.non-final': 'Set meeting agendas, take notes, and share action items with your team.',
    'project-pages.improvement.templates.meeting-notes.name': 'Meeting notes',
    'project-pages.improvement.templates.meeting-notes.name.non-final': 'Meeting notes',
    'project-pages.improvement.templates.post-expand.more': 'More templates',
    'project-pages.improvement.templates.post-expand.more.non-final': 'More templates',
    'project-pages.improvement.templates.post-expand.more.tooltip': 'View all templates in Confluence',
    'project-pages.improvement.templates.post-expand.more.tooltip.non-final': 'View all templates in Confluence',
    'project-pages.improvement.templates.post-expand.subtitle': 'Popular templates',
    'project-pages.improvement.templates.post-expand.subtitle.non-final': 'Popular templates',
    'project-pages.improvement.templates.post-expand.title': 'Create a page',
    'project-pages.improvement.templates.post-expand.title.non-final': 'Create a page',
    'project-pages.improvement.templates.pre-expand.more': 'Explore more templates',
    'project-pages.improvement.templates.pre-expand.more.non-final': 'Explore more templates',
    'project-pages.improvement.templates.pre-expand.subtitle': 'Popular with teams like yours',
    'project-pages.improvement.templates.pre-expand.subtitle.non-final': 'Popular with teams like yours',
    'project-pages.improvement.templates.pre-expand.title': 'Preview templates',
    'project-pages.improvement.templates.pre-expand.title.non-final': 'Preview templates',
    'project-pages.improvement.templates.product-requirements.description': 'Define, track and scope requirements for your product or feature.',
    'project-pages.improvement.templates.product-requirements.description.non-final': 'Define, track and scope requirements for your product or feature.',
    'project-pages.improvement.templates.product-requirements.name': 'Product requirements',
    'project-pages.improvement.templates.product-requirements.name.non-final': 'Product requirements',
    'project-pages.improvement.templates.retrospective.description': 'What went well? What could have gone better? Crowdsource improvements with your team.',
    'project-pages.improvement.templates.retrospective.description.non-final': 'What went well? What could have gone better? Crowdsource improvements with your team.',
    'project-pages.improvement.templates.retrospective.name': 'Retrospective',
    'project-pages.improvement.templates.retrospective.name.non-final': 'Retrospective',
    'project-pages.improvement.templates.template.disabled-tooltip': 'Connect a Confluence space first',
    'project-pages.improvement.templates.template.disabled-tooltip.non-final': 'Connect a Confluence space first',
    'project-pages.improvement.templates.tutorial.content.confluence-templates': '<b>Save time and reduce manual tasks</b>. Confluence has lots of page <a>templates</a>, so you never have to start from scratch. Think technical documents, troubleshooting guides, project plans, product requirements, and more.',
    'project-pages.improvement.templates.tutorial.content.confluence-templates.non-final': '<b>Save time and reduce manual tasks</b>. Confluence has lots of page <a>templates</a>, so you never have to start from scratch. Think technical documents, troubleshooting guides, project plans, product requirements, and more.',
    'project-pages.improvement.templates.tutorial.content.edit-and-format': '<b>Easily edit and format.</b> Use the top editing menu for standard word formatting, and by typing <b>/</b> you can easily insert lots of handy integrations. Insert a table by typing <c>/table</c> or an image with <c>/image</c>. You can also insert Dropbox links <c>/dropbox</c>, Microsoft office tools <c>/microsoft</c>, or Trello boards and cards <c>/trello</c>.',
    'project-pages.improvement.templates.tutorial.content.edit-and-format.non-final': '<b>Easily edit and format.</b> Use the top editing menu for standard word formatting, and by typing <b>/</b> you can easily insert lots of handy integrations. Insert a table by typing <c>/table</c> or an image with <c>/image</c>. You can also insert Dropbox links <c>/dropbox</c>, Microsoft office tools <c>/microsoft</c>, or Trello boards and cards <c>/trello</c>.',
    'project-pages.improvement.templates.tutorial.content.forward-slash-prompt': "Type / followed by \u2018table\u2019 or \u2018image\u2019",
    'project-pages.improvement.templates.tutorial.content.forward-slash-prompt.non-final': "Type / followed by \u2018table\u2019 or \u2018image\u2019",
    'project-pages.improvement.templates.tutorial.content.getting-started-tips': 'Here are a couple of tips to get you started:',
    'project-pages.improvement.templates.tutorial.content.getting-started-tips.non-final': 'Here are a couple of tips to get you started:',
    'project-pages.improvement.templates.tutorial.content.handy-links': 'Handy links',
    'project-pages.improvement.templates.tutorial.content.handy-links.non-final': 'Handy links',
    'project-pages.improvement.templates.tutorial.content.jira-and-confluence': 'Use Jira and Confluence together',
    'project-pages.improvement.templates.tutorial.content.jira-and-confluence.non-final': 'Use Jira and Confluence together',
    'project-pages.improvement.templates.tutorial.content.jira-charts': 'Create charts on your pages using real Jira data. Type <c>/Jira charts</c>.',
    'project-pages.improvement.templates.tutorial.content.jira-charts.non-final': 'Create charts on your pages using real Jira data. Type <c>/Jira charts</c>.',
    'project-pages.improvement.templates.tutorial.content.jira-links': 'Link a Jira issue anywhere on your page. The link on the page will update in real-time, as you update the Jira issue. Type <c>/Jira</c>.',
    'project-pages.improvement.templates.tutorial.content.jira-links-issue-term-refresh': 'Link a Jira work item anywhere on your page. The link on the page will update in real-time, as you update the work item. Type <c>/Jira</c>.',
    'project-pages.improvement.templates.tutorial.content.jira-links.non-final': 'Link a Jira issue anywhere on your page. The link on the page will update in real-time, as you update the Jira issue. Type <c>/Jira</c>.',
    'project-pages.improvement.templates.tutorial.content.jira-links.non-final-issue-term-refresh': 'Link a Jira work item anywhere on your page. The link on the page will update in real-time, as you update the work item. Type <c>/Jira</c>.',
    'project-pages.improvement.templates.tutorial.content.jira-roadmaps': 'Embed interactive roadmaps and timelines for your page using your Jira Projects. Type <c>/jira roadmap</c>.',
    'project-pages.improvement.templates.tutorial.content.jira-roadmaps.non-final': 'Embed interactive roadmaps and timelines for your page using your Jira Projects. Type <c>/jira roadmap</c>.',
    'project-pages.improvement.templates.tutorial.content.jira-timeline': 'Embed interactive timelines for your page using your Jira Projects. Type <c>/jira timeline</c>.',
    'project-pages.improvement.templates.tutorial.content.jira-timeline.non-final': 'Embed interactive timelines for your page using your Jira Projects. Type <c>/jira timeline</c>.',
    'project-pages.improvement.templates.tutorial.content.shipping-speed-statistic': '76% of Jira Software customers said they shipped projects faster after adding Confluence',
    'project-pages.improvement.templates.tutorial.content.shipping-speed-statistic.non-final': '76% of Jira Software customers said they shipped projects faster after adding Confluence',
    'project-pages.improvement.templates.tutorial.content.shipping-speed-statistic.spork-rebranding': '76% of Jira customers said they shipped projects faster after adding Confluence',
    'project-pages.improvement.templates.tutorial.content.shipping-speed-statistic.spork-rebranding.non-final': '76% of Jira customers said they shipped projects faster after adding Confluence',
    'project-pages.improvement.templates.tutorial.content.spaces-and-pages': '<b>Using spaces and pages</b>. Spaces are part of every Confluence site and are a way of organising pages into categories. Think of spaces as different folders or projects, and pages are the documents that belong in those folders or projects. <a>Learn more about how to use spaces</a>',
    'project-pages.improvement.templates.tutorial.content.spaces-and-pages.non-final': '<b>Using spaces and pages</b>. Spaces are part of every Confluence site and are a way of organising pages into categories. Think of spaces as different folders or projects, and pages are the documents that belong in those folders or projects. <a>Learn more about how to use spaces</a>',
    'project-pages.improvement.templates.tutorial.content.try-it-now': 'Try it now',
    'project-pages.improvement.templates.tutorial.content.try-it-now.non-final': 'Try it now',
    'project-pages.improvement.templates.tutorial.description': 'Learn how to edit a page.',
    'project-pages.improvement.templates.tutorial.description.non-final': 'Learn how to edit a page.',
    'project-pages.improvement.templates.tutorial.name': 'Welcome to Project Pages!',
    'project-pages.improvement.templates.tutorial.name.non-final': 'Welcome to Project Pages!',
    'project-pages.improvement.terms-and-conditions-v2': "By selecting 'Try it now' you acknowledge you will be enrolled in Confluence and agree to the Atlassian <termsLink>Cloud Terms of Service</termsLink> and <privacyLink>Privacy Policy</privacyLink>.",
    'project-pages.improvement.terms-and-conditions-v2.non-final': "By selecting 'Try it now' you acknowledge you will be enrolled in Confluence and agree to the Atlassian <termsLink>Cloud Terms of Service</termsLink> and <privacyLink>Privacy Policy</privacyLink>.",
    'project-pages.improvement.title': 'Project pages',
    'project-pages.improvement.title.non-final': 'Project pages',
    'project-pages.improvement.transient-states.empty-state.auto-provisioned-create-page-button': 'Create page',
    'project-pages.improvement.transient-states.empty-state.auto-provisioned-description': "We\u2019ve added Confluence so you can start creating and linking all your project documents. It\u2019s free for up to 10 users.",
    'project-pages.improvement.transient-states.empty-state.auto-provisioned-learn-more-button': 'Learn more',
    'project-pages.improvement.transient-states.empty-state.create-page-button': 'Create your first page',
    'project-pages.improvement.transient-states.empty-state.description': 'Create some meeting notes, product requirements, decisions, or other content to see this space fill up.',
    'project-pages.improvement.transient-states.empty-state.title': "There\u2019s nothing here but potential",
    'project-pages.improvement.try-button': 'Try this template in Confluence',
    'project-pages.improvement.try-button.non-final': 'Try this template in Confluence',
    'project-pages.improvement.try-it-now': 'Try it now',
    'project-pages.improvement.try-it-now.non-final': 'Try it now',
    'project-pages.improvement.try-lozenge': 'try',
    'project-pages.improvement.try-lozenge.non-final': 'try',
    'project-pages.improvement.try-on-demand-button': 'Try it free',
    'project-pages.improvement.try-on-demand-button.non-final': 'Try it free',
    'project-pages.join-confluence-screens.denied-access-title.non-final': 'Denied Access Screen',
    'project-pages.join-confluence-screens.direct-join-title.non-final': 'Direct Join Screen',
    'project-pages.join-confluence-screens.pending-request-title.non-final': 'Pending Request Screen',
    'project-pages.join-confluence-screens.request-access-title.non-final': 'Request Access Screen',
    'project-pages.join-confluence-screens.revoked-access-title.non-final': 'Revoked Access Screen',
    'project-pages.join-confluence-screens.title.non-final': 'Join Confluence Page',
    'project-pages.landing-page.feature1.non-final': 'Access and create documents without leaving Jira',
    'project-pages.landing-page.feature2.non-final': 'Templates for meetings, sprint plans, and more',
    'project-pages.landing-page.feature3.non-final': 'Sync documents to Jira for automatic updates',
    'project-pages.landing-page.illustration.title.non-final': 'Project pages',
    'project-pages.landing-page.terms-and-conditions.non-final': "By selecting 'Try it now' you acknowledge you will be enrolled in Confluence and agree to the Atlassian <termsLink>Cloud Terms of Service</termsLink> and <privacyLink>Privacy Policy</privacyLink>.",
    'project-pages.landing-page.title.non-final': 'Welcome to Project Pages',
    'project-pages.landing-page.try-now-btn.non-final': 'Try it now',
    'project-pages.page-deleted-flag.title': 'Page deleted.',
    'project-pages.page-published-flag.title': 'Your page has been published.',
    'project-pages.space-connectsuccess-flag.title.space.non-final': 'Content connected',
    'project-pages.title.non-final': 'Project pages',
    'project-pages.unknown-error.description': "{contactSupport} if refreshing doesn\u2019t fix things.",
    'project-pages.unknown-error.heading': "We can\u2019t display project pages right now"
};

});

parcelRegister("5lWKN", function(module, exports) {

$parcel$export(module.exports, "default", () => $27da5fe29cae10f5$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //
var $27da5fe29cae10f5$export$2e2bcd8739ae039 = {
    'confluence.project-pages.improvement.provisioning-background.text': "\u2063\u2062This should take less than a minute\x8d\u206A\u206B\u206D\u206D\u206E\u206C\u061C\u206F\x8d\u206C\u206C\x8d\u206D\u200C\u206E\x9d\u206D\u206F\u206E\u200C\u206A\u206D\u206A\x81\x8d\u206F\u200D\u206A\u206F\u200C\u206D\u2063\u2064",
    'confluence.project-pages.improvement.provisioning-background.title': "\u2063\u2062Setting up your Project Pages\u206D\u206F\x90\u206C\x9d\u206D\u200D\u206A\u061C\u206B\u206A\u206D\x90\u206B\u200D\u206E\x90\u206D\u061C\u2060\u206D\u2060\u200D\x90\x81\u206F\x90\u2061\u206B\u206E\u206D\u2060\u2063\u2064",
    'confluence.project-pages.improvement.provisioning-modal-carousel.controls.dismiss': "\u2063\u2062Dismiss\x9d\u200C\u2060\u200D\x90\u206A\x9d\u206A\u206C\u206F\x81\u200C\u200C\u206E\x8f\u206B\u206C\x8d\u206C\x9d\u206A\x9d\u200C\u206C\x9d\u206D\x8d\u2061\u206C\x90\x90\u206B\u2063\u2064",
    'confluence.project-pages.improvement.provisioning-modal-carousel.controls.done': "\u2063\u2062Done\x9d\u206E\u061C\u206D\x81\u2061\u200D\u061C\u206D\x81\u200D\x9d\u206C\u061C\x9d\x8d\u206E\u200D\u206E\x81\u206D\u206F\x8d\u061C\u206C\u206A\u206A\u200C\x9d\x8f\u200C\x9d\u2063\u2064",
    'confluence.project-pages.improvement.provisioning-modal-carousel.controls.next': "\u2063\u2062Next\u061C\u206C\u206A\u200D\u200D\u200D\u200D\u206E\u206B\u206F\u206D\x9d\u206D\u206C\x8f\u061C\u2061\x90\u206B\u206B\u206C\u206E\u206A\u2061\u206A\u206C\u2060\x8d\u2060\u200D\u206C\u200D\u2063\u2064",
    'embedded-content-tree.button.connect-different-source.label.non-final': "\u2063\u2062Update space or page icon\u206C\u206E\u200C\u206E\x81\u206F\u200C\u200C\u2061\u200C\u206B\u2061\u2061\x8f\u206B\u206B\x8d\u206A\u206B\u206D\x81\x9d\u061C\x8d\u206D\x81\u206A\u200C\u206B\x8d\u206B\x8d\u2063\u2064",
    'embedded-content-tree.button.connect-different-source.tooltip.non-final': "\u2063\u2062Connect different space or page\x9d\x81\u206C\u200D\u206B\u2060\u206B\u206A\u206A\u2061\u206D\u206C\u200C\u206E\u206E\x8d\x81\x9d\u2061\u206F\u206E\u206F\u206F\u206B\u061C\u200D\u206C\u200C\u206E\u206D\x8f\u206D\u2063\u2064",
    'embedded-content-tree.button.connect-to-confluence.tooltip.non-final': "\u2063\u2062Connect to Confluence\u206A\x90\x9d\u2061\u206E\u206F\u200C\x9d\u206D\u206A\u2061\u206E\u061C\u206C\u2060\u206A\u206A\u206E\u200D\u206D\u206A\u206D\u206B\u206E\u206A\u206A\u206A\u206D\u200D\u200D\u061C\x8d\u2063\u2064",
    'embedded-content-tree.button.go-to-connected-page.tooltip.non-final': "\u2063\u2062Open page in Confluence\x8d\u206B\x81\x9d\u206D\u206B\u206D\u206B\x9d\u206A\u2060\u206E\u206A\u206C\u206D\u200D\u206E\u200D\u2061\x81\u206F\x8d\u2061\x8d\u206A\x90\u206E\u061C\u061C\x8d\x81\u200D\u2063\u2064",
    'embedded-content-tree.button.go-to-connected-space.tooltip.non-final': "\u2063\u2062Open space in Confluence\u206D\u206A\u206E\x8d\u206A\u2060\x90\u206B\u2060\u200D\u206B\u200C\u200C\u206C\u200C\u206E\u206E\u200D\x8f\x8f\u061C\u206E\u061C\x9d\u206F\u061C\x81\x8f\u206F\x9d\u2060\u2060\u2063\u2064",
    'embedded-content-tree.column.contributors.non-final': "\u2063\u2062Contributors\u2060\u206D\x90\u206C\x90\x90\x8d\u2061\u206B\x90\u061C\u206B\u206C\u206D\u2060\x81\u206B\u206D\u2060\u2061\u206D\x90\u200D\x81\u206F\u2061\u206E\u206B\x9d\u200D\u2061\u206B\u2063\u2064",
    'embedded-content-tree.column.last-modified.non-final': "\u2063\u2062Last modified\x9d\x90\u206D\u206E\u200C\u206B\x9d\u200D\x8f\u2060\x81\u206B\u206D\u206E\u2061\u206F\x9d\x9d\u200D\x90\u2060\u206A\u206E\x9d\u2060\u206B\u206A\u206F\u2061\x81\u206C\x9d\u2063\u2064",
    'embedded-content-tree.column.title.non-final': "\u2063\u2062Name\u206A\u2060\u206A\u200D\u200D\u2060\x90\x8d\x8f\u206E\u200D\u2060\u206C\u061C\x8d\x8d\u200D\u061C\u2061\u200C\u206C\x81\u206D\u206F\u206A\x8d\x8d\x8d\u206F\u206B\u061C\x9d\u2063\u2064",
    'embedded-content-tree.could-not-load-contributors.non-final': "\u2063\u2062Couldn't load contributors\u200D\u2061\x8d\x81\x9d\u206A\u206E\x81\u206C\u200D\u2060\x8d\u2061\u2060\x8d\u061C\x8f\u206B\u061C\x8d\x8d\u206F\x8d\x9d\x8f\x9d\u206E\x9d\u061C\u061C\u206A\u206E\u2063\u2064",
    'embedded-content-tree.could-not-load.non-final': "\u2063\u2062Couldn't load\x9d\x8d\u206C\u200D\x90\u206D\u061C\x8f\u206A\x9d\x8f\u206C\u206D\x90\x90\u200D\u200C\u200C\u2060\x90\u200D\x9d\u2061\u206B\u200C\u061C\x8f\u206B\u206F\u200D\u2060\x8d\u2063\u2064",
    'embedded-content-tree.create-child-page.non-final': "\u2063\u2062Create a child page\u206C\u206C\u2060\u200D\u206B\x8d\u206F\u200D\u2060\u206B\u206D\u206C\u200D\x90\x8f\x8f\u2061\u206D\u206C\u200D\u2060\x8d\u061C\u061C\x8f\u206E\u206C\u206C\u2060\u206B\u206F\u200C\u2063\u2064",
    'embedded-content-tree.create-page.non-final': "\u2063\u2062Create page\x9d\u206C\x81\u206F\u2060\u206C\u200D\x81\u200D\u206E\u200D\u2061\u206F\x90\x81\u206B\u061C\x90\u206F\x9d\x81\u061C\u206D\u2061\x8d\u206F\u206B\u206D\u206A\u206E\x8f\u206F\u2063\u2064",
    'embedded-content-tree.drafts-toggle.label.non-final': "\u2063\u2062Show drafts\x8f\u2061\u200C\x8f\x9d\u200D\u206D\x9d\u206A\u061C\u061C\u200D\x90\x8f\u206E\u2061\u206A\u200D\u206A\u206C\u200D\x8d\u200C\u200D\u206E\x8f\u206C\u206F\u2060\u206D\u206C\x8f\u2063\u2064",
    'embedded-content-tree.edit-in-confluence.non-final': "\u2063\u2062Edit in Confluence\x90\u061C\x81\u200D\x81\u206A\x8d\x90\x81\u206F\x8f\u206D\u206C\x8d\u206A\u206B\x8f\u061C\u2060\u2060\u2061\x8d\u200C\x90\u206C\x81\u200C\u206C\u061C\x8d\u206E\u2061\u2063\u2064",
    'embedded-content-tree.edit.non-final': "\u2063\u2062Edit\u206A\x8d\u206D\u200D\u206A\u200D\u206D\u2061\u2061\u2061\u2060\u206E\x8d\x8f\u206D\u206A\u206E\u2061\u206C\x9d\u2060\u200C\x8f\u2060\u206C\u206C\u061C\u206D\x81\x90\u200D\u206A\u2063\u2064",
    'embedded-content-tree.empty.description.non-final': "\u2063\u2062Create some meeting notes, product requirements, decisions, or other content to see this space fill up.\x8f\u206E\u206A\x8f\u2060\u206A\u200C\u061C\u061C\u206B\u206C\u206B\u2061\x81\x9d\u206A\u206B\u2061\u200C\u206F\u206C\u200D\u2060\u061C\u206D\u061C\x90\x8f\u2060\u200D\u206C\x8d\u2063\u2064",
    'embedded-content-tree.empty.title.non-final': "\u2063\u2062There's nothing here but potential\u206B\u206E\u2060\u206C\u200D\x8d\x9d\x9d\x9d\u2061\x8f\u206C\u206B\u061C\u061C\u206D\u200D\u206D\x90\u2061\u206C\x9d\x9d\x8f\u206E\u200C\u200C\u200D\x8f\u206E\u2061\u206E\u2063\u2064",
    'embedded-content-tree.error.description.non-final': "\u2063\u2062We can't show you these pages. Please try again later.\u206E\u206F\u206B\u200D\x9d\u061C\u206E\u206D\u206E\u2061\x8f\x90\u061C\u061C\u2061\u2060\u206F\x8d\u206B\x8f\u206B\u061C\x90\x81\u2061\u206D\u206B\x9d\u206E\u206A\u206C\x81\u2063\u2064",
    'embedded-content-tree.error.row.non-final': "\u2063\u2062Unable to load pages.\x8d\u206C\u206C\u206D\x9d\u200D\u061C\u206C\x9d\u206C\u206B\u206C\x81\u200C\x81\u206B\u2060\u2061\u2061\x90\x9d\u206A\u061C\u2061\u206E\u206D\u200D\u206A\u2061\u206E\u061C\u206F\u2063\u2064",
    'embedded-content-tree.error.title.non-final': "\u2063\u2062Well, this is awkward...\u206C\x90\u206A\u2060\u061C\x9d\x90\u061C\u200D\u206C\x8f\u206B\u061C\u2061\x90\u2060\x9d\u206A\u2061\u200D\u200C\u206D\u061C\u2060\x90\u206D\u206A\x90\u206B\u206F\x9d\u206D\u2063\u2064",
    'embedded-content-tree.friendly-when-created.non-final': "\u2063\u2062Created\u200C\u2061\u206E\u200D\x90\u2061\x81\u2061\x8d\u2060\u2061\u200D\x8f\x90\x8d\x8f\u061C\x81\x8d\x81\u200D\x90\u206E\x8d\x81\u2060\u206E\u200C\x90\x8f\u061C\u200D\u2063\u2064",
    'embedded-content-tree.friendly-when-updated.non-final': "\u2063\u2062Updated\u206F\u206C\x81\u200D\u2061\u206B\u206B\u206D\u061C\u200D\x8f\x9d\u206A\u200C\x8f\u061C\u061C\x90\x90\x9d\u206B\u200C\x90\u061C\u2061\x9d\x8d\u2060\u2060\u200D\u200D\x81\u2063\u2064",
    'embedded-content-tree.view-profile.non-final': "\u2063\u2062View profile\x90\u200C\x8f\u206A\x9d\x8f\x90\x8d\u206C\u2060\x90\u2061\x90\x90\x9d\x90\x8d\u206F\x90\x8d\u200C\u2061\u200C\u206C\u206B\u206A\u206C\x8f\u206A\u206E\u206A\u206A\u2063\u2064",
    'project-pages.activating.description': "\u2063\u2062The connected Confuence space isn\u2019t quite ready yet. {contactSupport} if refreshing doesn\u2019t fix things.\x90\x9d\u206D\x81\u206C\u206C\u206A\u206E\u2060\x90\x8d\u206F\u200D\u200D\u061C\u061C\x90\x81\u206A\u206A\u200D\x81\u200D\x8d\u200C\u206C\u200D\x8d\u061C\x9d\x9d\u206F\u2063\u2064",
    'project-pages.activating.heading': "\u2063\u2062Confluence is still loading\x8f\u2061\x90\x90\u206B\x9d\x9d\u206F\x8f\u206B\u200C\u200C\u206A\u061C\x81\u206C\u206C\u206D\u061C\u061C\u061C\u2060\u206F\u206A\u206E\u206E\u206D\u206D\u206E\u206C\u200C\x8d\u2063\u2064",
    'project-pages.better-together-templates.meeting-notes.action-items-heading': "\u2063\u2062What are the action items?\u206C\u2060\u200C\u200C\x9d\u200D\x8f\u206E\u206D\x9d\x90\u206E\u2060\u061C\x81\u206E\u206B\u200D\u206E\u200C\u061C\u200D\u206A\x8d\x81\x81\u206D\u200C\u206F\x90\u206E\u200D\u2063\u2064",
    'project-pages.better-together-templates.meeting-notes.agenda-item-label': "\u2063\u2062Agenda item\x90\u200C\x81\u200C\u200D\x81\u2060\u2060\u2060\u200D\u2060\x8d\u206D\u200D\u200D\u206C\x8d\x90\u206D\u200D\x9d\u200D\u2061\u206C\u2060\u206F\u206B\u2060\u2061\x81\u200D\x8d\u2063\u2064",
    'project-pages.better-together-templates.meeting-notes.create-a-jira-issue': "\u2063\u2062Type /Jira to create an issue\u200D\u206B\x8d\u200C\u206A\x8f\u206C\u206B\u206E\u2060\u206F\x8f\u206C\u206B\x9d\x90\u206A\u206A\u200C\u206D\u061C\u200D\u206C\u200C\u061C\x8d\u2060\u200D\u206A\x9d\u206A\u206C\u2063\u2064",
    'project-pages.better-together-templates.meeting-notes.date-label': "\u2063\u2062Date\x9d\u2060\u061C\u206D\u206A\u2061\u2060\u200C\x9d\u206D\u2060\x8d\u206B\u206D\x8f\x90\u200C\u206D\x8d\x81\u206C\u206D\x81\u061C\u206C\u200C\u206E\u206E\u2060\u061C\u206F\u061C\u2063\u2064",
    'project-pages.better-together-templates.meeting-notes.discussion-topics-heading': "\u2063\u2062Discussion topics\u206C\u206B\u206A\u061C\x90\u206E\u2061\u200C\x81\u2060\u2061\x9d\u206A\x9d\x8f\u206B\x8d\u200D\x81\x8f\u2061\u206B\x8f\u206E\u061C\u206D\u2061\x81\x90\u206F\u200C\u200D\u2063\u2064",
    'project-pages.better-together-templates.meeting-notes.list-people': "\u2063\u2062list people using\u061C\u206F\x90\u2061\u200D\u200C\u061C\u2060\x8f\u200D\x9d\x8f\u061C\x81\x9d\x90\x8d\x81\x8f\u2060\x81\u2061\x9d\x90\x8f\u2060\u206C\x9d\u2060\u206C\x8d\u2060\u2063\u2064",
    'project-pages.better-together-templates.meeting-notes.mention': "\u2063\u2062mention\u206B\u2061\u206A\u206F\u2060\u200C\u206D\u061C\u206D\u2061\u206B\x81\u206B\x8f\u206C\u206C\u206F\x81\x90\u200D\x81\u200D\u2060\u2060\u206B\u206D\x8f\x9d\x8d\u206D\u206D\u206D\u2063\u2064",
    'project-pages.better-together-templates.meeting-notes.mention-people-to-assign-them': "\u2063\u2062people to assign them to an action item\u2060\u206A\x8d\u2061\u200D\u206F\x90\u200C\x8d\x90\u206F\x90\x81\u206F\u206D\u206C\x90\u206E\x8d\u200D\u206F\x8d\u200D\u206C\u206A\u206D\x8d\u2061\u206E\u206C\x90\u206E\u2063\u2064",
    'project-pages.better-together-templates.meeting-notes.notes-label': "\u2063\u2062Notes\u2060\u206A\u206A\u206A\u206E\x90\u206A\u2060\x81\u2060\u206C\x81\u206B\u206C\u206A\u206D\u206A\x81\x90\x90\u2061\u206E\u200C\u2061\u206F\x90\u206B\x8d\u206B\u200D\u200C\u200D\u2063\u2064",
    'project-pages.better-together-templates.meeting-notes.page-title': "\u2063\u2062Meeting notes\u206D\x90\x90\x9d\u200C\x81\x81\u206D\x8d\x81\u2060\u206E\x90\u206D\u206D\x90\u206B\u206D\x90\u206D\u206D\u200C\u206A\u200D\u206E\u200D\x8d\u200C\x8f\x81\u206C\u206D\u2063\u2064",
    'project-pages.better-together-templates.meeting-notes.participants-label': "\u2063\u2062Participants\u2061\x9d\x8f\x81\x8f\u206C\x8d\u061C\x90\u061C\u206D\u061C\u206C\u206F\u206D\x9d\x90\u206E\x8f\u2061\u2061\u206A\u206B\u206D\x90\u206F\x90\u206E\u206E\u2061\u2060\u206F\u2063\u2064",
    'project-pages.better-together-templates.meeting-notes.project-label': "\u2063\u2062Project\u200D\x8f\x9d\u206B\u2060\x9d\x81\u2061\u206D\x90\u2061\x81\u206C\u061C\u061C\x81\u206D\u200D\u206F\u2060\u206A\u2060\u200D\x9d\x9d\u200D\x90\u206D\u061C\x8d\u200D\x90\u2063\u2064",
    'project-pages.better-together-templates.product-requirements.create-a-jira-issue': "\u2063\u2062Type /Jira to create an issue\x90\x8d\u2060\u206B\x8d\u200C\u206B\u200D\x8f\x90\u206C\u2061\x8f\u2060\u206C\u206E\u061C\x9d\u206C\u206B\u206F\u061C\u200D\u061C\x8f\u206F\u2060\u061C\u200D\x9d\u206B\x8f\u2063\u2064",
    'project-pages.better-together-templates.product-requirements.design-heading': "\u2063\u2062Design\x8d\u2060\u2060\u200C\u200D\u206D\u206E\u206E\u200C\u061C\x9d\u200C\u206F\u200C\x9d\u206E\u2061\u2060\u200C\x90\u200D\x8d\u206C\u206A\x9d\u206A\u206B\u206C\u200C\u206E\x9d\u206E\u2063\u2064",
    'project-pages.better-together-templates.product-requirements.embedd-different-data-views': "\u2063\u2062Embed different data and views from your Jira project.\u206C\u206B\u206E\u206A\x8d\u061C\x8f\u206A\u200C\x90\x9d\u206C\u206C\u206E\u206A\u2060\x9d\u206F\u2061\u206B\x9d\x9d\x81\x90\u206E\x90\u200D\x90\x9d\u200C\u2060\u206D\u2063\u2064",
    'project-pages.better-together-templates.product-requirements.heading': "\u2063\u2062Overview\u206D\x8f\x9d\x81\u200D\x90\x90\x8f\x9d\u206D\u2061\u200D\x9d\x90\x8f\u061C\u2061\u206F\u2061\x90\u206F\u2060\x8d\u206E\u200C\u061C\u061C\u200C\u2060\u206C\x81\u061C\u2063\u2064",
    'project-pages.better-together-templates.product-requirements.how-will-you-know-if-fixed': "\u2063\u2062How will you know if you've fixed it?\x81\u061C\u206B\u206E\u2061\u206F\u2061\u206B\u206E\u200D\u206F\u206A\x8f\x81\x9d\x8f\u206C\u2061\u2061\u2060\u206C\x90\x90\u206F\u206C\u206A\u2060\x8d\x8d\u206D\u206B\x90\u2063\u2064",
    'project-pages.better-together-templates.product-requirements.impact-heading': "\u2063\u2062Impact\u206F\u200C\x9d\u2060\u2060\x81\u206A\u2060\u206B\u206D\u2061\u206C\u200C\u206E\x8d\u206F\u206A\u061C\x9d\x8d\x8d\u2061\x8d\u206C\u061C\x81\u206C\u200D\x8d\x90\u206E\u061C\u2063\u2064",
    'project-pages.better-together-templates.product-requirements.inScopeStatus': "\u2063\u2062In scope\u2060\u206D\u206F\u206C\u200D\u200D\x8f\x90\u061C\x81\u2060\u206F\u200D\u206D\u200C\x8d\u206E\u061C\x81\u061C\x81\u061C\x8d\u206C\u206D\x9d\x90\u206F\x8f\u206F\u206E\x8f\u2063\u2064",
    'project-pages.better-together-templates.product-requirements.insert-design-link': "\u2063\u2062Insert a link to your design (Figma, etc)\u2061\x8f\u206C\x8f\u206A\u2061\u206A\u206E\x8f\u206E\x8d\u061C\u200C\u206C\u200C\x9d\u206F\u206F\x8d\u206B\x9d\u200D\u200D\u2061\u200D\x9d\u206E\x90\x81\u206C\u206E\x90\u2063\u2064",
    'project-pages.better-together-templates.product-requirements.jira-issue-heading': "\u2063\u2062Jira issue\x8f\u061C\u2061\u200C\x9d\u200C\u206C\u206E\u2060\x9d\x90\u206A\x8d\u206F\u206E\u206F\u200C\u206E\u206E\u2061\u2061\u206F\u2060\x90\x8d\u2060\u206B\u2061\u206B\x9d\u206E\u061C\u2063\u2064",
    'project-pages.better-together-templates.product-requirements.jira-roadmap-heading': "\u2063\u2062Jira roadmap\x90\u206E\u2061\x9d\x8f\u206D\u206E\u061C\u206D\u206D\u206C\u206D\u206B\u2061\u206D\x90\x9d\x81\u061C\u200C\x8f\u206D\u2061\u2060\u200C\u200C\u200C\u206A\u061C\u206E\u206A\u200D\u2063\u2064",
    'project-pages.better-together-templates.product-requirements.learn-how-with-smart-links': "\u2063\u2062Learn how with smart links\x90\u206C\u206C\u206D\u206F\u206F\u206D\u206B\u200D\x8d\u200D\x90\x90\x90\u206D\u206A\u200D\u206E\u2061\u206F\u206D\u061C\u206E\x9d\u206C\x8d\u206C\u200C\u206C\x9d\x81\x8d\u2063\u2064",
    'project-pages.better-together-templates.product-requirements.list-dashboards': "\u2063\u2062List dashboards (Amplitude, Mode, etc)\x90\x8f\x90\x8f\u206C\u206A\u200C\x9d\x90\x9d\x81\u206D\x90\x90\x81\u200C\u200D\x9d\u206D\x81\u061C\u200D\x81\x8f\u206E\x90\u206E\u206A\u061C\x90\x8f\x81\u2063\u2064",
    'project-pages.better-together-templates.product-requirements.list-design-considerations': "\u2063\u2062List design or build considerations\x9d\x8f\x90\x90\x8f\u2061\u206E\x8d\x9d\u200C\u200C\u206F\u206D\u200D\u206B\x90\u206A\u2060\u206D\x90\x8f\x8d\u206D\u2061\u206F\x8d\x8d\x9d\x8d\u2061\u206B\u206B\u2063\u2064",
    'project-pages.better-together-templates.product-requirements.list-people': "\u2063\u2062list people using\u200D\x9d\u206D\u206F\u206F\u2060\x81\u200C\u2061\u2060\u2060\u200D\u061C\u2061\u206C\u206C\u206C\u206D\u206D\x9d\u206E\u206C\x90\u206D\x9d\u061C\x81\u200D\u206F\x90\u061C\u200C\u2063\u2064",
    'project-pages.better-together-templates.product-requirements.mention': "\u2063\u2062mention\u2061\x8d\u200D\u206D\u206A\x81\u206B\x81\x81\u061C\u206D\u206B\u206E\u206B\u200C\u206A\x81\u061C\u206A\u206A\x90\u2061\u206F\u2061\x9d\u206C\u200C\u2060\u061C\x8f\u206F\u061C\u2063\u2064",
    'project-pages.better-together-templates.product-requirements.mention-people-to-assign-them': "\u2063\u2062people to assign them to an action item\x8f\u200D\x8d\u206D\x8d\u206F\x90\u2061\u200D\u2060\u200D\u2061\u206D\x81\u206F\u206C\u206F\u206E\u206A\u206B\u2060\u200C\u2061\x90\u206C\x90\u206E\x81\u206E\x90\u206E\u206D\u2063\u2064",
    'project-pages.better-together-templates.product-requirements.niceToHaveStatus': "\u2063\u2062Nice to have\x81\u2061\u2061\u2060\x9d\x81\u2060\u061C\x81\u206A\x8d\u2060\u2061\x90\u2060\u200C\u206D\x81\u200C\u061C\u206E\x90\u200D\u206A\u206F\x90\x8f\u2060\u200D\u2061\u200C\u206E\u2063\u2064",
    'project-pages.better-together-templates.product-requirements.outOfScopeStatus': "\u2063\u2062Out of scope\x90\u206A\u206F\u206F\u2061\u2060\x9d\x9d\x90\u200D\u206F\u206C\u200C\x9d\u200D\u206E\x81\x90\u206A\u200C\u206B\x8d\u061C\u061C\x8d\u200C\x90\u206E\x90\u206E\x81\u206F\u2063\u2064",
    'project-pages.better-together-templates.product-requirements.page-title': "\u2063\u2062Product requirements\x8d\x90\u206A\u2061\x9d\u2061\u206F\x81\u2061\u206D\u206D\u206F\x90\x81\u206E\u2061\u2061\u2060\u061C\u206F\u206C\u200D\u206F\u200C\u200D\u206C\x9d\u200D\x8f\x90\u2061\u206A\u2063\u2064",
    'project-pages.better-together-templates.product-requirements.pro-tip': "\u2063\u2062Pro tip:\u206B\u200D\x8f\u206C\u061C\u200D\x8f\u206A\u206E\u200D\u206B\u206A\u206A\x8d\u206C\u206C\u200C\u206E\u2060\x9d\x8d\u2060\u206A\x9d\u2060\u206C\x81\u206A\u061C\u206C\x90\u206E\u2063\u2064",
    'project-pages.better-together-templates.product-requirements.problem-label': "\u2063\u2062Problem\u206A\u206E\u206A\u200D\u2061\u200D\u2060\u2060\u200C\u200D\x9d\x81\x8f\x81\u206F\u206C\x90\u206E\x9d\u2061\u200D\u200C\u2060\x90\x9d\u206A\x8f\x90\u206E\x81\x81\x81\u2063\u2064",
    'project-pages.better-together-templates.product-requirements.requirement-heading': "\u2063\u2062Requirement\x9d\u206D\u200C\u206E\x8d\u2061\u206A\u206E\u206C\u2061\u2061\u206E\u061C\u200D\x8d\u200D\u200D\x90\u2061\x90\x81\u206F\u206B\u206A\u200C\u206B\u206E\u206C\x8d\u200C\u206D\u206A\u2063\u2064",
    'project-pages.better-together-templates.product-requirements.scope-heading': "\u2063\u2062Scope\u061C\u200C\x9d\u206D\u2061\u206D\x8d\u206F\x90\x9d\x8f\x90\u206E\u206F\x81\x9d\u061C\u206D\u061C\u206E\x9d\u200D\x9d\x8d\u206E\u200C\x81\x81\u200C\u2061\x9d\x9d\u2063\u2064",
    'project-pages.better-together-templates.product-requirements.success-metric': "\u2063\u2062Success metric\u206B\u206A\u200C\u200C\u206D\u2060\u206B\u206D\x8d\x90\x8f\u2061\x8f\u200C\x8f\u206D\u200D\u200C\u206F\u061C\x90\x8d\u2060\u200D\u2060\x9d\u061C\u206E\u206C\x90\x8f\u206D\u2063\u2064",
    'project-pages.better-together-templates.product-requirements.target-release-date': "\u2063\u2062Target release date\x8d\u061C\u200C\x9d\u206E\u206B\u2060\u206E\u206B\u206C\x9d\x8f\u061C\u200D\x8d\u206A\u206F\u206A\u200D\x8d\x8d\x8d\u2061\u2061\u2060\u206E\u200D\x81\u206E\x9d\x8d\u061C\u2063\u2064",
    'project-pages.better-together-templates.product-requirements.team-label': "\u2063\u2062Team\u200C\x8d\u206A\u200C\u206C\u206C\u206F\u206F\u206D\u206D\u206E\u206F\x81\u200C\u206E\u206A\u200C\u200D\x81\u200C\x81\x9d\u2060\x8f\u2060\x81\x8d\u206C\u206F\u206B\x8f\x8f\u2063\u2064",
    'project-pages.better-together-templates.product-requirements.to-do-list-heading': "\u2063\u2062To-do list\x8d\u206D\x8f\x8f\u2061\u206C\x81\u206F\u206C\u206E\u206C\u200C\u2061\x8d\u206F\u2060\x8d\u206A\u061C\u2061\x8d\x9d\x8d\u2061\u206D\u2060\x9d\u061C\u206B\u061C\x81\u061C\u2063\u2064",
    'project-pages.better-together-templates.product-requirements.what-are-you-trying-to-fix': "\u2063\u2062What are you trying to fix?\u2060\u206B\x90\x8f\u206A\u206D\x8d\x9d\u206D\u061C\u061C\x9d\u206B\u206C\x9d\u2061\u200C\u206F\x9d\u206B\x90\u206F\u200D\x8d\u061C\u206E\u206D\x9d\x81\u206D\x9d\u206E\u2063\u2064",
    'project-pages.better-together-templates.retro-notes.retro-heading': "\u2063\u2062Retrospective\u206C\u200C\u206D\x9d\x81\u206A\u200D\x8d\u2060\u206D\x81\u2061\u061C\u2060\u206D\x8f\u206B\x81\x81\u206E\u206D\x8d\x81\u206A\u206E\x90\u206B\u061C\u2061\u206A\u206B\u061C\u2063\u2064",
    'project-pages.better-together-templates.retro.action-items-heading': "\u2063\u2062What are the action items?\u206D\u206F\x8f\u206C\u200D\x8d\u206D\u2061\u206D\x8f\u2061\u206C\u206F\x9d\x9d\u206D\x8f\u200C\x8f\x8f\u206C\u2061\u206E\u206D\u206B\u206A\x8d\u206A\x90\u206B\x8d\u2061\u2063\u2064",
    'project-pages.better-together-templates.retro.create-a-jira-issue': "\u2063\u2062Type /Jira to create an issue\u2061\u206A\u2060\x8d\u2060\u2060\x81\u206E\u206D\u206E\u206E\u200C\u206B\u206C\x9d\x90\x81\x8d\x81\x8f\x8f\u206D\u206D\u200C\u206F\u200C\u206E\u206A\x90\u200D\u206A\u206C\u2063\u2064",
    'project-pages.better-together-templates.retro.date-label': "\u2063\u2062Date\u206A\x81\x8d\u206C\u2060\u206A\u206D\u206B\x90\u206C\x9d\u206D\x90\u206E\u206F\x8d\u2060\u061C\u200D\x90\x9d\u200C\u206E\x8d\u206C\x9d\u206A\u061C\u061C\x8d\u206F\u2060\u2063\u2064",
    'project-pages.better-together-templates.retro.embed-it-here': "\u2063\u2062Once you\u2019re done you can embed it here.\u2061\u206F\x81\u2061\u2060\x9d\u206C\u206B\u061C\x90\u206A\u206C\x90\x90\x8d\u206B\u206C\u206D\x81\x81\u061C\u2060\u206D\u206C\x9d\x8f\u206B\u061C\x8d\u200D\u2061\u206B\u2063\u2064",
    'project-pages.better-together-templates.retro.list-people': "\u2063\u2062list people using\u206D\u200D\u061C\u2061\x8f\x8f\u206A\u206B\x8f\u206E\x9d\u206A\u206A\u200D\x8f\u206B\x81\u200C\u206E\u2061\u206A\u206F\x90\u200C\x8f\x8d\u2060\x8f\u200D\x90\u206F\u206C\u2063\u2064",
    'project-pages.better-together-templates.retro.mention': "\u2063\u2062mention\x81\x9d\x9d\u2061\u061C\u206A\u200C\u200D\u200C\u206B\x9d\x90\x8d\x90\x81\u200D\u061C\x9d\u2061\x8d\u206B\x8f\x81\u206A\u206F\u061C\u206C\u206C\x90\x81\x9d\u206E\u2063\u2064",
    'project-pages.better-together-templates.retro.mention-people-to-assign-them': "\u2063\u2062people to assign them to an action item\u200D\x8d\u206E\u200D\u206C\u206E\x90\u2060\x8d\u206A\u206B\u206F\u200D\x8f\u206F\u206B\x81\u2060\x90\u206C\u061C\x90\u206E\x8f\x9d\u206B\u206C\u2061\u206B\u206E\x81\x8f\u2063\u2064",
    'project-pages.better-together-templates.retro.page-title': "\u2063\u2062Retrospective\x8f\u206F\u2060\u2060\x90\u200D\u206A\x8f\u061C\u206E\u206D\u206B\u206E\u206D\x81\x9d\u206D\x81\u061C\u2061\u206C\x8f\u206F\u206F\u200C\u061C\x90\u206D\u200D\x8f\u200D\u2060\u2063\u2064",
    'project-pages.better-together-templates.retro.participants-label': "\u2063\u2062Participants\u206D\u200C\u206A\u206C\x81\u2061\x81\u206B\u206E\u200D\x8f\u206D\u206C\u206F\u200D\u206B\u200D\x8d\u200D\u206A\x81\u2061\u206E\u200C\x8f\u206E\u200D\u206F\u200C\u200C\x81\u061C\u2063\u2064",
    'project-pages.better-together-templates.retro.pro-tip': "\u2063\u2062Pro tip:\u206D\u206A\x8d\u206B\u200D\u206D\x9d\u206D\x90\x90\x81\u206C\u200D\u2061\u206D\u2060\x8f\u206E\u206F\x8f\x8f\x8d\x9d\x8f\x9d\u206F\u206D\u206B\u2061\u061C\x9d\u206B\u2063\u2064",
    'project-pages.better-together-templates.retro.project-label': "\u2063\u2062Project\x8d\u2060\u2061\u2060\u206F\u2061\x8f\x9d\x90\x90\u200C\u206F\u2061\x8d\x81\u2060\x9d\u206B\u206C\u206F\u206B\x90\u206E\u206E\u200D\u061C\u2061\x8f\u061C\u206D\x90\u206D\u2063\u2064",
    'project-pages.better-together-templates.retro.this-is-a-whiteboard': "\u2063\u2062This is a Confluence whiteboard.\u2060\x8f\u206D\u200C\u206B\u2061\u206F\x90\u2061\u206C\u061C\u061C\x8f\u2061\u061C\x90\x90\u206E\x8d\u206F\u206D\u200C\x9d\x81\u200C\u206B\u206E\u206C\u200D\x8d\u206A\u200C\u2063\u2064",
    'project-pages.better-together-templates.retro.use-a-whiteboard': "\u2063\u2062Use a Confluence whiteboard for your retro.\x8f\u206A\u061C\u2060\u2061\u206A\u200C\u200C\u2061\x8d\u206E\x8f\u206C\u061C\u061C\u200D\u206F\u206D\x90\u206E\u206F\u200C\u206A\u200C\u2060\x81\x8f\x90\x9d\x90\u2061\u206D\u2063\u2064",
    'project-pages.better-together-templates.retro.use-it-to-vote': "\u2063\u2062Use it to vote and collaborate with your team.\u206C\x90\u2061\u206D\u2060\u206A\x8f\u2061\u206E\u200D\u206D\u2060\u206B\x8d\u206D\u200D\x8d\u206D\u206C\u206A\x9d\u206E\u200D\u061C\u206D\u2061\x9d\u206E\u206C\u206E\u206E\u206B\u2063\u2064",
    'project-pages.button.connect-different-space-or-page.label': "\u2063\u2062Update space or page icon\u206B\u206E\x81\x81\u061C\u200C\u206B\u206D\x81\x81\u206E\x90\x8f\u206D\x8d\x8d\x8f\u206A\u206A\u206E\u206E\x90\u206E\u206D\u061C\u206A\u206E\u2060\u2061\u206C\u2060\x8f\u2063\u2064",
    'project-pages.button.connect-different-space-or-page.tooltip': "\u2063\u2062Connect different space or item\x9d\u061C\u206E\u061C\u200D\x90\x8f\u206C\u2060\x8d\u200D\u206D\u206A\u206F\u206D\x90\u206E\u2060\u206F\x8d\x9d\u206B\u206C\u200D\u206C\u206E\u206E\u2060\u206D\x9d\u206C\u061C\u2063\u2064",
    'project-pages.button.connect-space-or-page.tooltip': "\u2063\u2062Connect to Confluence\u206F\u2060\u206F\x81\u2061\u206B\x9d\x90\x9d\x81\u206A\x8f\u200C\u2060\u206A\u206E\u206B\u206A\u206C\u206B\x8d\u2061\u206C\x9d\x8f\u200C\u206C\u206D\u200C\u206D\u206D\u206C\u2063\u2064",
    'project-pages.button.go-to-connected-live-doc.tooltip': "\u2063\u2062Open live doc in Confluence\u206B\x8f\u061C\x8d\u206A\x90\x8d\x9d\x8d\u200D\x9d\u206E\u2061\u206B\u061C\u206D\u206C\x8f\u200C\u2060\u2061\u206A\x9d\u061C\u061C\u206A\u206D\x8d\u206A\x8d\u2060\x81\u2063\u2064",
    'project-pages.button.go-to-connected-page.tooltip': "\u2063\u2062Open page in Confluence\u061C\u061C\u200C\u200C\u206A\x8f\u206A\u2061\x90\u206E\u206B\u206A\x8f\u200D\u206D\u206F\u2060\u061C\x90\u206B\x8f\u206F\u206B\u061C\u206B\u206E\u206A\x9d\u206C\u200D\u206F\u206F\u2063\u2064",
    'project-pages.button.go-to-connected-space.tooltip': "\u2063\u2062Open space in Confluence\u2061\u200D\u200C\x90\u206A\u2060\u200C\u200C\x90\u2060\x90\x90\x8f\x8d\x8d\x8f\x81\u200C\x90\u206C\u200C\u2061\u206A\u206E\u206B\u200C\u206A\u206A\u200C\x8f\x8d\x9d\u2063\u2064",
    'project-pages.connect-space-dialog.connection-error': "\u2063\u2062Connection failed.\u2060\x8d\u200C\u200C\u061C\u061C\u2061\x8f\u206F\u206F\u061C\x9d\u206B\u206B\u206A\x90\x90\u206E\u206F\u200D\u2061\x81\u206D\x90\u200C\u206B\x8d\x8d\x90\x90\u206F\u206C\u2063\u2064",
    'project-pages.connect-space-dialog.connection-retry': "\u2063\u2062Retry\u206C\u2061\u206E\x9d\u200C\x9d\x8d\x8d\u200C\u200C\u200D\x8f\x81\x9d\u206B\u206D\u206E\x90\u206F\u206D\u206A\x8d\u2060\u206A\u206A\x9d\u206C\u2061\u2060\u061C\x8f\u061C\u2063\u2064",
    'project-pages.connect-space-dialog.content.space-or-page-selector.description': "\u2063\u2062Choose a space or item to connect to your project.\u2060\u200D\u2061\u206B\x90\u206F\u200C\u206C\u2060\x8f\x9d\x90\u206C\u2060\x81\x81\x8d\u206D\u206E\u206A\u206B\u206C\u206C\u061C\x8d\x9d\x81\u206A\u206A\x8f\u2061\x90\u2063\u2064",
    'project-pages.connect-space-dialog.content.space-or-page-selector.placeholder': "\u2063\u2062Search Confluence\u200C\u206A\x9d\x9d\u2060\u206D\x8d\u206C\u2060\x90\x90\x90\u200C\u206B\u2060\u206A\u206C\x8d\u206C\u206D\u206A\u206C\u2060\u2061\u200D\u206C\x8d\u206D\u206A\u206B\x9d\x9d\u2063\u2064",
    'project-pages.connect-space-dialog.content.space-selector.disconnected-templates-description': "\u2063\u2062This project needs to be connected to a space before you can create an item. Choose a space to connect to this project.\u200C\u206D\u200D\u2061\u206B\x81\x8f\u200C\u2060\x81\x9d\u206E\u2060\u061C\u206B\u206B\x81\u206F\u2060\x81\u206F\u206B\u200D\x81\u206C\x8d\x81\x8d\u206C\u061C\u206E\x8d\u2063\u2064",
    'project-pages.connect-space-dialog.error-icon': "\u2063\u2062Error:\u206D\u206A\x81\x81\u206C\x8f\u206E\u206A\u2061\u206D\x8f\u206E\u2061\u061C\u206C\u2061\u2061\u206B\u206D\u200D\x90\x81\u206B\u2061\x8d\u206C\x81\u206E\u206F\x90\u206E\u206B\u2063\u2064",
    'project-pages.connect-space-dialog.footer.cancel': "\u2063\u2062Cancel\u206C\x8f\u206D\x81\u206E\u206B\u206E\x8d\x81\x9d\u061C\u206D\x8f\x9d\u206C\x8f\x9d\u206A\u206F\x8d\u061C\x8f\x81\u206C\u200D\x81\u2061\u2061\u206B\x90\u206C\u061C\u2063\u2064",
    'project-pages.connect-space-dialog.footer.connect-space': "\u2063\u2062Connect\x9d\x9d\x90\u200C\x8d\u206E\u206A\u206C\u200D\u206F\u206D\x8d\u200C\u206B\u206C\u206E\u2061\u061C\u206F\u206C\u061C\u200C\x8f\u206F\u200D\u206D\u061C\x8f\u206B\u2060\u206B\u206E\u2063\u2064",
    'project-pages.connect-space-or-page-dialog.header.title': "\u2063\u2062Connect project to Confluence\x81\u061C\u061C\x81\x81\x90\u206C\u2060\u200C\u206D\u206D\u200D\x9d\x9d\u200D\x81\u2060\u200D\u206C\u206D\u206D\u2060\x9d\x81\u206E\u206A\u2061\u2061\u206A\u200D\x8d\x8d\u2063\u2064",
    'project-pages.connect-space.button.non-final': "\u2063\u2062Connect to Confluence\u206E\x90\x8f\u206B\x81\u200C\u2060\u2060\u206A\u206D\u200D\x90\u206A\x81\x8d\x8d\u061C\u061C\u061C\u206F\u206D\u200C\u206A\u206A\u206D\u206B\x9d\x8d\u206F\u2060\x8f\u206D\u2063\u2064",
    'project-pages.connect-space.description': "\u2063\u2062Spaces are like folders - you can use them to create, organize, and collaborate on all the content related to your project.\u206B\u061C\u206F\u200C\u206F\x90\x90\x8d\u206C\u200D\x8f\u206B\u200D\u206D\u206B\u206E\u206F\u206B\u2060\u2060\x81\x8d\u206C\u206D\u206B\u206B\u206F\x81\u206C\u061C\u206C\u206F\u2063\u2064",
    'project-pages.connect-space.description.non-final': "\u2063\u2062Spaces are like folders - you can use them to create, organize, and collaborate on all the content related to your project.\u206C\x8f\x8f\u206D\u2060\u2060\u206A\u200D\u206D\u206A\u206B\u206C\x81\u206E\u200C\x81\u200C\x81\x81\x8f\u206A\u200D\u200C\u200D\u061C\x8f\x90\x9d\u206E\u206C\u206A\u2061\u2063\u2064",
    'project-pages.connect-space.not-connected.description': "\u2063\u2062To use project pages, contact your admin or team lead to connect Confluence to this project.\u200C\u200C\u061C\u2060\u2061\x8d\u206B\u206E\u206C\u206F\u206E\x90\u206E\u200D\x8d\x8f\x81\x90\x90\x9d\u2061\x8f\u200D\x81\u2060\u2060\u206E\u206E\u2061\x9d\u206A\u200C\u2063\u2064",
    'project-pages.connect-space.not-connected.description.non-final': "\u2063\u2062To use project pages, contact your admin or team lead to connect Confluence to this project.\u206B\u206D\u2061\x8d\x90\x90\u206D\u206B\x81\u206B\x81\x8d\u206D\u2060\u2060\u206D\u206F\u206E\u206C\u2060\x8d\u206C\u206D\u2060\u206F\x9d\x90\u2061\u206B\u206E\u061C\u200D\u2063\u2064",
    'project-pages.connect-space.not-connected.heading': "\u2063\u2062Not connected to Confluence\x90\x90\u206F\x8d\x9d\u206D\u206F\u206A\u206E\x90\u206E\x9d\u206E\u200C\u200C\u2061\u200D\u206C\u206E\x81\x81\u206B\u206B\u2061\u200C\u2061\x8f\u206A\u200C\x9d\x8f\u206A\u2063\u2064",
    'project-pages.connect-space.not-connected.heading.non-final': "\u2063\u2062Unable to connect to Confluence\u206C\x8d\u206E\x9d\u206A\u206B\x9d\u2060\u206A\x8f\u206D\u206D\x81\x8d\u206A\u206B\u206A\u200C\x81\u206B\u200C\x8d\u061C\u2060\u206B\u200C\u206C\u206D\u206F\u206A\u206A\u200D\u2063\u2064",
    'project-pages.connect-success-flag.description.content': "\u2063\u2062Successfully connected with {connectedSpaceOrPageName} content.\u206D\x9d\x81\u206B\x90\x8d\u200C\u206A\x9d\u2060\x9d\u206D\x81\u200C\u200C\x9d\u061C\x90\u206F\x8d\u206F\x81\u200C\u206F\u2060\u206E\x9d\u206E\u206F\u206D\u206B\u206D\u2063\u2064",
    'project-pages.connection-error.space-or-page-not-found.button': "\u2063\u2062Connect to a different space or page\u200D\x9d\u2060\u061C\x8d\u061C\x8d\u206F\u061C\u061C\u2060\u206E\x9d\u206F\u206E\u200D\u200C\x8f\u206E\u206A\u206C\x9d\x81\u206B\x90\x8d\u061C\u206B\u206A\u206D\u206E\u206E\u2063\u2064",
    'project-pages.contact-support.non-final': "\u2063\u2062Contact support\x8f\u206E\u206E\u200D\u200C\u061C\x81\x8f\x81\u206B\u206C\u2061\u206A\u200C\u206A\x9d\u206F\x8f\u200C\x8d\u200C\u061C\x8f\u2061\x9d\u206C\u2060\u2060\u206A\u206F\x8d\u200D\u2063\u2064",
    'project-pages.create-space-dialog.connection-error': "\u2063\u2062Connection failed.\u206E\u206E\u206D\x8f\x8d\x9d\u206B\u206C\u206D\u206A\u200C\u200C\u200D\x8d\x81\u206A\u206D\u206B\u206F\u206F\u061C\u200D\u061C\u200C\u206A\u061C\x8f\u200D\u200C\u206B\x8d\u200C\u2063\u2064",
    'project-pages.create-space-dialog.connection-retry': "\u2063\u2062Retry\u206A\u206A\x8f\u200D\x90\x9d\x8d\x9d\x8f\x9d\u061C\u206C\u206C\u206C\u2060\x81\u206A\x9d\x9d\u206F\u206B\u206A\u200C\u200D\x8f\u2061\u2060\u2060\x8f\u200C\u206B\x8d\u2063\u2064",
    'project-pages.create-space-dialog.content.empty-name': "\u2063\u2062Please give your space a name.\x9d\u206D\u200C\x8d\u206C\x90\u206F\u206F\u2060\u206E\u2061\u206E\u206E\u206F\x81\u200C\u206A\x8d\u206D\x90\u206A\x8f\u206E\x8d\u061C\u206B\u206B\x8f\u061C\u206A\u206D\u2060\u2063\u2064",
    'project-pages.create-space-dialog.content.invalid-name': "\u2063\u2062Space names require at least one letter or number.\x8d\x8d\u206D\x81\u206E\u206B\x81\x90\u206A\u206C\u200D\x9d\u206C\u2061\u206E\u206C\u206D\u061C\x8f\u206C\u2061\x8d\x81\u061C\x9d\u200C\u061C\u206C\x8f\x9d\u206B\u2060\u2063\u2064",
    'project-pages.create-space-dialog.content.placeholder': "\u2063\u2062Enter a space name\u2061\u206F\u206A\u200C\u206B\x9d\x90\u206D\u2060\x81\u206F\u061C\x8f\u061C\u206B\u206F\x81\x81\u206D\u206F\u206C\u206E\u206A\u200C\u200C\u206C\u206C\u206E\x90\u061C\u206D\x8f\u2063\u2064",
    'project-pages.create-space-dialog.creation-error': "\u2063\u2062Space creation failed.\u206A\u061C\u2061\u206D\u2061\u206D\u206C\u2060\u206E\u206D\x81\x81\u2060\u200D\u061C\u206C\u206A\x8f\u206E\u206F\u206D\u206C\u200D\u061C\u206F\u200C\u206B\u206E\x8f\x9d\x90\u061C\u2063\u2064",
    'project-pages.create-space-dialog.error-icon': "\u2063\u2062Error:\u206B\u061C\u206C\u206E\x8d\u2061\u200D\u206E\u206E\x8f\u206B\u200C\u200D\u206F\u206D\x8d\u206B\u206E\x8d\u2061\u2061\u206F\u061C\u200D\u200D\u061C\u061C\x81\u2061\u206A\u2061\x8f\u2063\u2064",
    'project-pages.create-space-dialog.footer.cancel': "\u2063\u2062Cancel\u206E\u206D\x90\u200D\u200D\u200C\x90\u206D\u206C\u206F\x9d\u200D\x90\u200D\u206A\u206A\u206C\u206F\u206A\u206C\x81\u206C\u061C\x8f\x9d\x90\u206C\x90\x8f\u206A\u206F\u206B\u2063\u2064",
    'project-pages.create-space-dialog.footer.create-space': "\u2063\u2062Create\x90\x90\x8d\u206B\u200C\x81\x8d\u2061\x9d\x90\u206A\x90\u206F\x9d\x9d\u206D\u200C\x8f\u2061\u206B\u061C\u206B\x8f\x8d\x90\x81\u206E\x8d\x8d\u2060\u200D\u206F\u2063\u2064",
    'project-pages.create-space-dialog.header.title': "\u2063\u2062Create new Confluence space\u206E\u2061\x90\u061C\u206D\x8f\u2060\u206A\x81\x9d\u061C\u206E\u206A\x81\u206B\u061C\x90\u061C\u200C\u206A\u206F\u206A\x8f\x81\x90\x9d\u206A\u206E\x9d\x8f\x9d\x81\u2063\u2064",
    'project-pages.cross-join.access-revoked.templates.subtitle': "\u2063\u2062You cannot use project pages because the admin has denied you access to Confluence. Contact your site admin to request access.\x9d\u2061\x90\u061C\u206A\x81\u206B\u206B\u206A\x81\x81\x81\u206C\u200D\u206A\u2061\u206B\u206C\u2061\u206D\u206A\u2060\u200D\u200D\x9d\u206A\u2060\x90\u061C\u2060\u061C\u200D\u2063\u2064",
    'project-pages.cross-join.access-revoked.templates.title': "\u2063\u2062You don't have permissions to use project pages\x9d\u206F\x90\x9d\u200D\x90\u206E\u206E\u206D\u061C\u206E\u206E\x90\u206F\x8f\u200C\x8f\x90\u206A\u200D\u200D\u206F\x8f\u206F\u206A\u206F\x9d\x90\u206E\u200D\u206F\u200D\u2063\u2064",
    'project-pages.cross-join.avatar.view-profile': "\u2063\u2062View profile\u206B\u206B\x9d\u206E\u2060\u206C\u2061\x90\u2061\u206F\u206F\u206F\u2061\x9d\u200D\u2060\u206D\x81\u2061\u206C\x9d\u2061\u200D\x8f\u206E\u2061\x8d\u206E\x9d\x81\x81\u206A\u2063\u2064",
    'project-pages.cross-join.denied-request.templates.subtitle': "\u2063\u2062You can't use project pages because the site admin denied your request to join Confluence.\x8d\u200D\u061C\x81\u206F\u206E\u206F\u061C\u061C\u200C\x8d\u206C\u206F\x9d\u206C\x8d\u206F\u061C\u200D\u206A\x9d\x9d\u206C\x90\x8d\u206A\u061C\x90\u200D\x9d\x9d\u200D\u2063\u2064",
    'project-pages.cross-join.denied-request.templates.title': "\u2063\u2062Your admin has denied you access\u2060\u206F\x8f\u2060\x9d\u2060\u206E\u2060\u206C\u206E\u206C\u206C\u200D\u206F\u206E\x90\u206E\x8f\u206E\x8f\u206A\x9d\x90\u061C\u206C\u061C\u206D\u200C\u2060\u200C\x90\u206D\u2063\u2064",
    'project-pages.cross-join.direct-access.button-subtitle.experimental': "\u2063\u2062You'll get access to Confluence. Your site admin has already approved you.\u206F\u206C\u200D\u200C\u206E\x90\u200C\u206A\x90\u2060\u200D\u206E\x8f\u206C\u2060\u200D\u200C\u200D\x8f\u206A\x81\x90\u206E\u206C\u206B\u206E\u206B\x81\u200D\u2061\u200C\u206A\u2063\u2064",
    'project-pages.cross-join.errors.unknown-error.description': "\u2063\u2062{contactSupport} if refreshing doesn't fix things.\u206C\u2060\x9d\u206E\u206E\u206D\u200C\x81\u206F\x9d\x90\u2060\x9d\u206B\u206B\x9d\u2061\x8f\x8d\u206D\u061C\u061C\x9d\x90\u206E\u206D\u206E\x81\x8f\x90\u206A\u2060\u2063\u2064",
    'project-pages.cross-join.errors.unknown-error.title': "\u2063\u2062We can't display project pages right now\u206A\x8d\u2061\x9d\u2061\u2060\u061C\x90\u206B\x81\u206E\x81\u200C\u200C\u206D\u206E\x81\x8f\u206B\x8f\u206C\x9d\x8f\u206C\x81\u206E\x8d\u061C\u206F\x9d\x8d\u206A\u2063\u2064",
    'project-pages.cross-join.inline-join-product.button': "\u2063\u2062You\u2019ll get access to Confluence. Your site admin has already approved you.\u206E\u061C\x81\u2061\u206A\x8f\u2061\u206A\u061C\u206E\x8d\x81\u206A\u2061\u2060\u2061\x8f\u206C\u206B\x8d\u200C\x90\u200D\u061C\u061C\x9d\u206B\u2061\u200D\x8f\u206B\x8f\u2063\u2064",
    'project-pages.cross-join.inline-join-product.connected.description': "\u2063\u2062View, edit and create documentation from a single place\u206B\u200C\u206B\u061C\u206F\x9d\x81\x90\u200C\u206E\x81\u206F\u206F\x8d\u206C\x90\u206B\u200D\u206A\u061C\u206D\x8d\u061C\x81\x90\x81\u2060\x8d\u2060\u061C\x81\x9d\u2063\u2064",
    'project-pages.cross-join.inline-join-product.connected.title': "\u2063\u2062Collaborate on project pages with your team\u2060\u206C\u206E\u206E\x8d\u206B\u200D\u206A\u2061\u206D\u061C\x90\u206F\u2060\x8f\u200C\u061C\x8f\x9d\x8d\u061C\x90\u200D\u200C\u2060\u2060\u206B\u2060\u206D\u2060\u206C\u206F\u2063\u2064",
    'project-pages.cross-join.pending-request.templates.subtitle': "\u2063\u2062The site admin has received your request to join Confluence. If you're approved to join, project pages will start working and we'll send you a confirmation email.\u206D\u206D\u200D\u2061\u200C\u206D\u2060\x81\u061C\x8f\u200C\u206D\u206F\u206A\x8d\u206B\u2061\x90\x8f\u200C\x81\u061C\u206C\u206A\u206C\x8d\x8d\u2061\u206B\u206A\x90\u206A\u2063\u2064",
    'project-pages.cross-join.pending-request.templates.subtitle.experiment': "\u2063\u2062You'll get an email with access to Project Pages once you\u2019re approved.\u200D\x8d\u206F\u200C\u206F\u206D\u206B\u061C\u206C\x9d\x8d\u2060\x8d\u061C\x81\u206D\u2060\u206C\u206A\u206B\u2060\x9d\u200D\u2061\u206C\x8d\x8d\u206A\u2061\u200C\u206F\u206A\u2063\u2064",
    'project-pages.cross-join.pending-request.templates.title': "\u2063\u2062You've requested access to Confluence\x81\u206C\u206D\u206A\u2061\x90\u2060\u206D\u200D\x8f\u200D\u206A\u206F\u206A\x8d\u200C\u206E\x81\u206B\u206D\u206E\x8f\x8d\u206B\u206D\x81\u206A\u2060\u200C\x90\x8d\u061C\u2063\u2064",
    'project-pages.cross-join.pending-request.templates.title.experiment': "\u2063\u2062Access request sent to Admin\u206D\u061C\x81\u206C\u200C\u200C\u200C\x8d\u061C\u200D\u206B\x8f\x90\u206D\x8d\u206B\u206F\u206D\u061C\u200C\u206D\u206B\x90\u061C\x9d\u2061\x8d\x81\u206B\x8d\u206F\u2061\u2063\u2064",
    'project-pages.cross-join.request-access-without-better-together.connected.description': "\u2063\u2062View, edit and create project documentation with your team\u206C\u2060\x9d\u200C\u061C\u206A\u206E\u206F\u206E\u200D\u206D\u2061\u206C\u206C\x9d\x8d\u206E\u061C\u061C\u206C\u206E\x8f\u061C\u206A\u206B\x8d\u2061\x8f\u2060\u206F\u206E\u206F\u2063\u2064",
    'project-pages.cross-join.request-access.button': "\u2063\u2062Request access\u2060\x9d\x9d\u206C\u206F\u061C\u200C\u2061\u206B\u206E\x81\x90\u206E\u206B\u2061\u206D\x8d\u061C\x90\x90\x90\u206B\x9d\u2060\x8f\x9d\u2060\u206C\u200C\u206E\u206C\x9d\u2063\u2064",
    'project-pages.cross-join.request-access.button-subtitle.experimental': "\u2063\u2062When you select 'Join Your Team', you're asking to join Confluence and agree to share your Atlassian profile with your admin.\x8d\x9d\u2061\x90\u2061\u2060\u206F\u2061\u061C\u206E\u2060\u061C\u061C\u206C\u206B\u206D\u206A\x8f\u206D\u206A\u206D\u206E\u200D\u206C\u206A\u206B\x81\x8f\u206D\u2061\u206D\u206D\u2063\u2064",
    'project-pages.cross-join.request-access.button.experimental': "\u2063\u2062Join your team\x9d\u200C\x8f\x8d\u206E\u2060\u206C\u206A\u206B\u206A\x9d\u200D\x9d\x90\u2061\u2060\u2060\u2061\u206F\u206C\u206B\x8f\x90\x81\u200D\u206F\x8f\u206B\u206B\u206B\u2060\x8d\u2063\u2064",
    'project-pages.cross-join.request-access.connected.description.experimental': "\u2063\u2062Your team is using Project Pages to comment, edit, and collaborate on project documentation without leaving Jira. Join Confluence to access your team\u2019s Project Pages.\x9d\x81\u2060\u061C\u206B\x9d\x8f\u206C\u200C\u2060\x9d\x81\u206A\u061C\x81\u206C\u206D\u2060\x9d\u200D\u061C\u206F\u200C\u206F\x8f\u061C\x90\u2061\u061C\u206C\u061C\u206B\u2063\u2064",
    'project-pages.cross-join.request-access.title': "\u2063\u2062Project pages require access to Confluence\u200C\u206E\u206B\u200D\x8d\u200D\u206B\x90\u206E\u206B\u206E\u200C\x90\u206C\u206D\u206F\u061C\u200C\u2061\x8d\x8f\u206F\u206E\u061C\x9d\x8d\x81\u206A\u200D\x90\u206D\x8f\u2063\u2064",
    'project-pages.cross-join.request-access.title.experiment': "\u2063\u2062Create a single source of truth for your team\x90\x8f\u206D\u206A\x8f\x81\u200C\u206B\x8f\u206F\u2061\x8d\x90\u061C\u061C\x81\u206D\u061C\u206C\u200C\u2060\u2061\u206D\x8f\u200D\x8d\u206D\u206A\x8d\u2060\u200D\u2061\u2063\u2064",
    'project-pages.default-contextual-heading': "\u2063\u2062Project pages are powered by Confluence\u2061\u061C\u206A\u061C\x90\u206A\x81\u206D\u200C\x8d\u206F\x81\x90\u200C\u206E\u200D\u2060\u2061\u200D\u206C\u200C\x8f\u206F\u206F\u206F\u2060\u2061\u2061\u2060\u206D\u061C\u206F\u2063\u2064",
    'project-pages.default-contextual-message': "\u2063\u2062Create, share, and collaborate on all your project docs in one place, with Confluence pages.\u206A\x8d\x8f\u206D\u206A\u2060\u206A\u061C\x9d\x8f\x8d\x8f\u206A\x8d\u2061\u061C\u206D\x90\u206E\u206E\x81\u206B\u2060\u206E\x8d\x90\u206A\x90\x8f\x9d\x8d\u200D\u2063\u2064",
    'project-pages.default-reactivate-CTA': "\u2063\u2062Reactivate Confluence\u206C\u061C\x9d\u206F\u206B\u206A\u206C\x90\u2060\u200C\u061C\u200C\u061C\u206B\x81\u206E\x8f\u200D\u206C\u206A\u200D\u2060\u206D\u2060\u200C\u2060\u200D\u206C\u206D\x90\u200C\u206E\u2063\u2064",
    'project-pages.default-trial-CTA': "\u2063\u2062Try Confluence free for 30 days\x8d\u206C\u200C\u206B\u2060\u206B\x9d\u200D\u200C\u2061\x90\x8d\u061C\u206C\x81\x8d\u206E\u206E\u206B\u206D\x81\u206B\u206D\u206E\x8d\u206F\u206F\x90\x81\u200D\x9d\u206E\u2063\u2064",
    'project-pages.draft-saved-flag.action': "\u2063\u2062Open draft\u200C\x8d\u206F\u2061\u206B\x81\u206F\u206C\u200D\u206D\u200C\u2061\u206B\x81\x8f\x9d\u206E\u206F\u206F\x8d\u2061\u2061\u206F\x8f\u206D\u061C\u206B\u061C\u206B\x81\x9d\u200C\u2063\u2064",
    'project-pages.draft-saved-flag.description': "\u2063\u2062Your draft is only visible to you until you publish it.\u2060\x9d\u206C\u200D\u206E\u206C\u2060\x90\u061C\u206D\u200D\u200D\u200D\u200D\x8d\u200D\x81\u200C\u206F\u206E\u2060\u200D\u2060\x8d\u206D\u206F\u206D\x9d\x90\u206F\u061C\u206E\u2063\u2064",
    'project-pages.draft-saved-flag.title': "\u2063\u2062Draft saved\u206E\x81\u2060\u206E\u2061\x9d\x8f\x8d\u061C\u200C\u061C\x8d\u2061\x9d\u2061\u206F\u206E\u206A\x81\u061C\u2061\u200D\x8f\x8f\x90\u206F\x90\u206A\u206C\u206A\u206F\u061C\u2063\u2064",
    'project-pages.embedded-pages.create-page-error.close-button': "\u2063\u2062Close\x9d\u206F\u200C\u206D\x8f\u206D\u206F\u061C\u206C\u2061\u206D\x8f\u2061\u061C\u206D\x8f\u206C\u206D\x90\u206F\u206C\u206A\u206E\u200D\u200D\u206A\u206B\u2061\u206B\x8f\x81\u206B\u2063\u2064",
    'project-pages.embedded-pages.create-page-error.description': "\u2063\u2062There was a problem and we couldn\u2019t create a page for you.\x8d\u206F\x81\u200C\x81\x9d\u206E\u200D\x8f\u206F\u2060\x8f\x8f\u206D\u2061\u206E\u200C\x9d\u2061\u206F\u061C\u206F\x90\u2061\u206E\x8d\u206A\x90\u206B\x90\u2060\x8d\u2063\u2064",
    'project-pages.embedded-pages.create-page-error.title': "\u2063\u2062We couldn\u2019t create a page\u206B\x90\x8f\u206D\u206A\x8f\u206B\x9d\u206E\x81\u206A\u206B\u061C\u2060\u206A\u200D\u206D\x90\x8f\u206A\u200D\u2060\u206C\u206B\u206E\u206B\u206D\x8f\u206A\u206F\u206D\u206D\u2063\u2064",
    'project-pages.embedded-pages.create-page-error.try-again-button': "\u2063\u2062Try again\u206C\x8f\u061C\u206C\u200C\u206A\u200C\x81\u206B\x8d\u206C\u206D\u206D\u206A\u206E\x9d\u206D\u206F\u206D\x9d\u206F\u206A\u206E\u206E\x9d\u2061\u061C\u206A\u200C\u206E\x9d\x81\u2063\u2064",
    'project-pages.embedded-pages.modal.close.button.hint': "\u2063\u2062Close\u200C\x9d\u200D\u206A\x8f\x81\u206E\x90\u206C\u200C\u2060\u206E\u200D\u2061\u061C\x81\u2060\x9d\u206A\u2061\u2061\x9d\u200D\u206B\u206A\u206B\x8d\u200C\u206A\u2060\u061C\u206A\u2063\u2064",
    'project-pages.embedded-pages.modal.title.button': "\u2063\u2062Open in Confluence\x9d\u2060\x8d\u206B\x8d\u206A\u206C\u206C\u206E\x8f\u2061\u2061\u206C\x8d\u2061\u206B\u206C\u061C\u200D\x9d\x9d\u2060\u061C\x81\u2061\u200D\x9d\u206C\x8d\x9d\u206E\u206E\u2063\u2064",
    'project-pages.embedded-pages.modal.title.button.hint': "\u2063\u2062Open in a new tab\u206C\x9d\u061C\x90\u061C\x81\u206E\u2060\u206B\u200D\x9d\x8d\x81\u206D\x9d\x9d\x8d\u2061\u206F\x9d\u206A\u061C\u206C\x9d\u206F\u206D\u206B\u206D\u206F\u206C\u206A\u2061\u2063\u2064",
    'project-pages.errors.access-error.title.non-final': "\u2063\u2062You don\u2019t have permission to view project pages\u200C\u206C\x9d\x81\u206C\x8f\u206A\u206E\u200D\x9d\u200D\u206E\x90\u206E\u206D\u206B\u206A\u206D\x9d\u206E\u200C\x9d\x8f\u206A\x8f\u206E\u206C\u2060\u200C\u206A\u206D\u206C\u2063\u2064",
    'project-pages.errors.connection-error.space-or-page-not-found.button.non-final': "\u2063\u2062Connect to a different space or page\u206E\u206A\x90\u206F\u206A\u206A\x90\u2060\x81\u2061\x81\x8f\u206D\x8f\u206E\x8d\u2060\u061C\u200C\u2061\u200D\u206D\x8d\u061C\u206A\x9d\x8f\u206F\u061C\x90\x90\u200C\u2063\u2064",
    'project-pages.errors.page-tree-unknown-error.description.non-final': "\u2063\u2062Something went wrong while trying to display pages from your connected Confluence space. {contactSupport} if refreshing doesn\u2019t fix things.\u2061\x81\u2061\u206E\u2061\u2061\u206C\u206E\x8d\x81\x8f\x81\u206E\u206B\x8d\u2061\u200D\u200D\x8d\x81\u206D\x81\x8f\u206D\u206D\u2060\x81\x8f\u206A\u206C\u2061\u200D\u2063\u2064",
    'project-pages.errors.page-tree-unknown-error.title.non-final': "\u2063\u2062We\u2019re having trouble displaying project pages\u206E\x90\x81\u206E\u206C\x81\x8f\x8f\x81\x9d\x90\u206B\x90\u206A\u2061\u206F\u206C\u206B\x81\u206F\x8f\u206E\u206D\u206B\u2061\u206C\u206C\u206F\x81\x90\u061C\u206E\u2063\u2064",
    'project-pages.errors.space-or-page-not-found.description.non-final': "\u2063\u2062The Confluence space or page that was connected has been moved, archived, or deleted. <link>Contact support</link> if re-connecting doesn't fix things\u206D\x8d\u061C\x8d\u200C\x90\u061C\u206B\x81\u206B\u2060\u206E\u206E\x8d\u061C\u061C\x9d\x90\u2061\u061C\u206B\u2061\x81\u206E\u061C\u2061\u200D\x90\u061C\u206F\u2061\x8f\u2063\u2064",
    'project-pages.errors.space-or-page-not-found.title.non-final': "\u2063\u2062Space or page not found\u061C\u206E\x90\x90\u061C\x90\u2060\x90\u2060\u206F\u206C\x81\u2061\u2060\x8d\u206C\u206D\u206C\x8d\u2061\u206E\x8d\x90\u200C\u206E\u2060\u206D\x8d\u206F\u206F\u206E\u200D\u2063\u2064",
    'project-pages.errors.unknown-error.description.non-final': "\u2063\u2062{contactSupport} if refreshing doesn\u2019t fix things.\u200C\x81\u2060\u061C\x81\x8d\x8f\u2061\u2061\u206D\x81\u206E\x9d\x9d\x8d\x8d\x8f\u206F\u061C\u206E\u206C\x90\u200C\u206B\x90\u206B\u200D\u206A\x90\x81\x8f\u206B\u2063\u2064",
    'project-pages.errors.unknown-error.title.non-final': "\u2063\u2062We can\u2019t display project pages right now\u061C\u206C\x81\u206A\x8f\u206B\x81\u206A\u206F\x8f\u2061\u206D\u2060\u206B\u206C\u206F\u206B\u206C\u206F\u206C\u061C\u2061\u200C\x81\u200C\x9d\u206C\u206D\u2060\u206E\x9d\u206B\u2063\u2064",
    'project-pages.generic-error.button.reload': "\u2063\u2062Reload page\x9d\u206C\x81\u206D\u206D\u206B\u061C\x8f\x8f\u2061\u2060\x81\x81\u206F\u2061\u206D\x81\u200C\u200C\x81\x8d\x90\u206B\u206A\x81\u2061\u206D\u200D\u2061\u206A\u206D\u2060\u2063\u2064",
    'project-pages.generic-error.button.reload.non-final': "\u2063\u2062Reload page\u206A\x90\x9d\u061C\u206F\u206D\u061C\u206A\x8f\u206F\u206C\u200C\u206D\u206F\u206B\u200D\u206D\x8d\u206B\u200D\x9d\u206F\u2061\u206C\u2060\x8f\u2060\x90\u206B\u206F\u200D\u206D\u2063\u2064",
    'project-pages.generic-error.description': "\u2063\u2062Something went wrong. Please try again later.\x9d\u2061\u200D\u206B\u200D\u200D\x90\u206C\u200D\x8d\x8d\x8f\x81\x8f\u200C\x8d\u206F\u2061\u2060\x8f\u2061\u061C\u206C\u206D\u206E\u206B\u206F\x9d\x81\u2060\x81\u200D\u2063\u2064",
    'project-pages.generic-error.description.non-final': "\u2063\u2062Something went wrong. Please try again later.\u2060\x8d\x90\u206E\u061C\u206F\x9d\u2060\x8f\u206F\u206E\x9d\u206A\u206F\u206A\x81\u200D\u206F\x90\u206E\u2060\u206B\x8f\x8f\u206E\u206C\u2060\x90\u206A\u200C\x9d\u206C\u2063\u2064",
    'project-pages.generic-error.heading': "\u2063\u2062Well, this is awkward...\x9d\u061C\x81\u206A\x8f\u206E\x8d\u206A\u2061\u206E\u206F\u2060\x9d\u200C\u2060\u206E\u061C\u200C\u206F\x90\u2061\u200D\u200C\u206B\u206B\u2061\u206A\x8d\u061C\u206C\u206A\u061C\u2063\u2064",
    'project-pages.generic-error.title.non-final': "\u2063\u2062Well, this is awkward...\x90\u200D\u206D\x90\u206D\x9d\u200D\u200C\u206D\u200D\u200C\x8f\u206A\u2060\u206D\x8f\u206D\x90\u2061\u206C\u200D\u061C\x8d\u061C\u206E\x90\u2061\u2060\u200D\u206E\u200D\x81\u2063\u2064",
    'project-pages.generic-info-flag.description': "\u2063\u2062Something went wrong. Please try again or contact support if the issue persists\x90\u200C\x90\u206C\u200C\x81\u206D\u206D\u200D\u206A\u200D\x9d\u206E\u2061\x90\u206A\u2060\u206F\u206B\u2061\u061C\u206E\u206A\u200C\x90\u206E\u206C\u200C\x9d\x8d\x90\u206C\u2063\u2064",
    'project-pages.generic-success-flag.description.live-doc': "\u2063\u2062Successfully connected with {connectedSpaceOrPageName} live doc.\x90\u061C\u2060\u206F\u200C\u206F\u206F\x90\u200D\u206E\u2060\u206E\u206F\x8f\u200C\x9d\u206A\u2060\u2060\u206C\u206F\x81\u206D\x81\x8d\u206B\u2060\x9d\u206F\u206C\u061C\u200C\u2063\u2064",
    'project-pages.generic-success-flag.description.page': "\u2063\u2062Successfully connected with {connectedSpaceOrPageName} page.\x9d\x81\u200D\u206A\u206E\x81\x90\u200D\x81\x81\u206A\u200C\u200C\u206A\x90\u200D\u206E\u200D\u206D\u200C\x9d\u061C\u206B\u206C\u061C\u2060\u206C\u061C\u2060\u206E\u200D\u206E\u2063\u2064",
    'project-pages.generic-success-flag.description.space': "\u2063\u2062Successfully connected with {connectedSpaceOrPageName} space.\u200C\u206A\x81\x8f\u206B\u200D\u206A\x9d\u206A\x90\u2061\u206C\u2061\u206E\u200D\x9d\u206D\x81\x9d\u206E\u200D\u206B\u206C\x90\x8f\u2060\x8f\x81\u061C\u2061\u2060\u200D\u2063\u2064",
    'project-pages.generic-success-flag.heading.live-doc': "\u2063\u2062Live doc connected\u206A\u206B\u206B\x9d\x81\u200D\u206B\u206E\u206A\x90\u206C\u2060\u061C\x9d\u2060\u206B\x8d\x8f\u2060\u061C\x9d\u206B\x8d\x8f\x9d\u206D\x8d\u206B\u206C\u206E\u2061\u200C\u2063\u2064",
    'project-pages.generic-success-flag.heading.page': "\u2063\u2062Page connected\u206F\u206A\u206D\u200C\x9d\u2060\u206F\u2061\u206D\x8d\u200D\x8d\x81\u2060\x90\u061C\u2061\x9d\u2061\u206B\x81\x9d\x8d\u200C\u206B\u200C\u206C\u2061\x81\x8f\u200D\x9d\u2063\u2064",
    'project-pages.generic-success-flag.heading.space': "\u2063\u2062Space connected\u206C\u206B\u2060\u206A\u061C\u2061\u206C\x81\u206F\x81\u206F\x9d\u206D\x90\u206F\x81\u200C\x8d\u206F\u200C\x8f\u206E\x8d\u206A\x8f\x81\u061C\u206D\x8d\u200C\x90\u2061\u2063\u2064",
    'project-pages.granular-pages.connect-space-dialog.content.create-space-link.link-text': "\u2063\u2062Or create a new space\u061C\x8d\u206C\x81\u061C\u206C\x90\x81\u206C\u206F\x90\u206F\u200D\u206D\u200C\u061C\x9d\x90\u2060\u2060\x8f\u200D\u206C\x9d\x90\u2061\u2060\u200D\u206B\u206E\u200C\u200D\u2063\u2064",
    'project-pages.granular-pages.connect-space.button': "\u2063\u2062Connect to Confluence\x81\u200D\u206A\u2060\x8d\x9d\x8f\u206E\u206D\u206E\u206D\x90\x8d\u206D\x8f\x90\x81\u200D\u2060\u200D\x81\u061C\u206D\u200D\u206B\x9d\u200D\x81\u200C\u206E\u2060\u061C\u2063\u2064",
    'project-pages.granular-pages.connect-space.button.non-final': "\u2063\u2062Connect to Confluence\u206A\u2060\x9d\x9d\x90\u206A\u206A\u206D\x8f\u206C\u206F\u200D\u206A\x81\u200C\u200C\u2060\u2060\u2061\x8d\x8f\u200D\u206A\u206D\x90\u200C\u206B\x8d\u206D\u206F\x81\x81\u2063\u2064",
    'project-pages.granular-pages.connect-space.heading': "\u2063\u2062Connect this project to a Confluence space or item\x90\u206C\u206C\u2061\x9d\x8f\x8d\u2061\x90\u2060\u2060\u206F\x9d\u206E\u2061\x9d\x9d\x8d\u200C\u206F\x8f\u200C\u206F\u206F\u2060\u206B\u061C\u2060\u206F\u2061\u206A\u200C\u2063\u2064",
    'project-pages.granular-pages.connect-space.heading.non-final': "\u2063\u2062Connect this project to a Confluence space or item\u206C\u206C\u206A\x90\u206E\u206C\x9d\u206D\u061C\u206E\x8f\x8f\u206A\u206C\u206A\u206A\u206A\x8f\u206E\u206E\x90\u200D\u061C\u200D\u206B\u200C\u206E\x81\x8d\u200C\u061C\x9d\u2063\u2064",
    'project-pages.improvement.contact-support': "\u2063\u2062Contact support\u200C\u206E\x81\u206C\x90\u206C\x8f\u200C\u200C\u206F\u2060\u206F\u2060\x90\u206A\x81\u200C\u200D\u206A\u206D\u206B\u200D\x8d\x9d\x81\x8f\u206F\u206A\u206F\x8d\u206C\u206B\u2063\u2064",
    'project-pages.improvement.errors.access-error.description': "\u2063\u2062Try contacting the site admin to ask for access.\x9d\u061C\x8d\u206A\x81\u200D\u2060\u206C\u206B\x90\u2060\u206F\u061C\u206B\u206C\u2061\x8d\u206F\x8f\u2061\x8f\u2060\u2061\u2061\x90\u206D\u206D\x81\u206D\x9d\u206A\u206F\u2063\u2064",
    'project-pages.improvement.errors.access-error.title': "\u2063\u2062You don\u2019t have permission to view project pages\u061C\u206C\u206E\x90\x8d\u200D\u206F\u2061\u206A\x90\u206A\u200D\u200C\u206F\x8f\x90\u2060\u2061\u2061\x8d\x9d\x90\u206E\u2061\x90\u206C\x9d\u206B\u206E\x9d\u206B\u206C\u2063\u2064",
    'project-pages.improvement.errors.page-tree-unknown-error.description': "\u2063\u2062Something went wrong while trying to display pages from your connected Confluence space. {contactSupport} if refreshing doesn\u2019t fix things.\u2061\u206F\u206D\u061C\u061C\u2061\u206E\x9d\u200D\u206B\u206B\u2060\x90\u206A\u2061\x81\u206C\u206E\u206D\x81\u206A\u2061\u200D\u200C\u2061\x90\u206F\u206D\u206D\u2060\u2061\x9d\u2063\u2064",
    'project-pages.improvement.errors.page-tree-unknown-error.title': "\u2063\u2062We\u2019re having trouble displaying project pages\u061C\u200C\u206C\u200C\u2060\u061C\u2060\x90\u061C\x8f\u2061\x8f\u061C\u2061\u200D\u2060\u2060\u206F\x8f\x8f\x8f\u206B\x90\u206F\x8f\u206D\u206A\u206D\u206F\u200D\x81\x81\u2063\u2064",
    'project-pages.improvement.errors.space-or-page-not-found.description': "\u2063\u2062The Confluence space or page that was connected has been moved, archived, or deleted. <link>Contact support</link> if re-connecting doesn't fix things\u206A\u200C\x8d\x81\x8d\u206A\x8d\x9d\x90\u206F\x9d\u206C\u061C\u206E\u206D\x8f\u206C\x90\u200C\u206A\u206A\x90\u2061\u206F\u061C\u206A\u200C\x8f\u200D\u206C\u206B\x90\u2063\u2064",
    'project-pages.improvement.errors.space-or-page-not-found.title': "\u2063\u2062Space or page not found\u200C\u206F\x90\x81\u200D\u206D\u206A\x8d\u206B\x90\u206A\u200C\u206B\u206A\x8f\u2061\u206C\u206D\x9d\u206A\u200C\u200D\x8d\u206F\u206A\u206B\u206F\x9d\u206D\u206C\u061C\u206A\u2063\u2064",
    'project-pages.improvement.errors.unknown-error.description': "\u2063\u2062{contactSupport} if refreshing doesn\u2019t fix things.\x9d\u200D\u2060\x8f\x8f\u200C\x8f\u061C\x9d\u206F\u206C\u206A\u200C\u200C\u2060\u2060\u061C\u206F\u200D\u2060\u206A\u206D\x9d\u2061\x90\u206C\u206C\u206F\u206F\u061C\x8d\x81\u2063\u2064",
    'project-pages.improvement.errors.unknown-error.title': "\u2063\u2062We can\u2019t display project pages right now\x9d\u206C\u206F\u2060\u206F\x81\x8d\x8d\u206A\u206D\u061C\u061C\u206B\u2061\u2061\x9d\u206F\u206A\x9d\x9d\u061C\x90\u061C\u206D\u206B\u206B\u206C\u200D\u061C\x81\u206B\u206D\u2063\u2064",
    'project-pages.improvement.feature1': "\u2063\u2062Access and create documents without leaving Jira\u206C\x8d\x8f\u200D\u200C\u206A\u206E\u206E\u200C\u200D\u206F\u061C\x9d\u206F\u206D\x81\u206A\u206F\u206E\u206B\u206D\u206C\u206C\u061C\x81\x81\u2060\u200C\x8f\u206D\u200D\u206B\u2063\u2064",
    'project-pages.improvement.feature1.non-final': "\u2063\u2062Access and create documents without leaving Jira\u206A\x8d\x8f\u2061\u200C\x8f\u2060\x81\x8f\u2061\u206F\x90\u206D\u206D\u061C\u206E\x81\u200C\u061C\x8f\u206B\u206C\x8f\u2060\u206B\u2060\u206A\u200C\u2061\u206D\u206D\u200D\u2063\u2064",
    'project-pages.improvement.feature2': "\u2063\u2062Templates for meetings, sprint plans, and more\x81\u061C\u206F\x81\x8f\u061C\u200D\u206B\u206E\x90\x8d\x8f\u206C\u206A\u206A\x90\u061C\x90\u200C\u206D\u200D\u206A\u2060\x9d\x81\x81\x81\u206E\u206F\x8f\x81\u206C\u2063\u2064",
    'project-pages.improvement.feature2.non-final': "\u2063\u2062Templates for meetings, sprint plans, and more\u206A\u200D\u200D\x81\x8f\u206C\u200D\u2060\u061C\u206C\u206D\x81\x90\x9d\x90\u206C\u200D\x9d\x9d\x9d\u200D\x8d\u061C\u206E\u206B\x8d\u206B\u200C\x90\u206E\x9d\u206A\u2063\u2064",
    'project-pages.improvement.feature3': "\u2063\u2062Sync documents to Jira for automatic updates\u206F\u206B\u200D\u2060\u206A\x8f\u200C\u206F\u200D\u206F\u206D\x90\u206C\u206F\x8f\u206E\u200C\x90\x90\x81\u200C\x90\u206F\u206C\x90\u206F\u200D\x9d\u206B\u061C\u206D\u2060\u2063\u2064",
    'project-pages.improvement.feature3.non-final': "\u2063\u2062Sync documents to Jira for automatic updates\x8d\x9d\u2060\u206F\u200D\u206B\u206B\u206C\u2061\x8f\u206C\u206B\u206E\x8f\x8f\x8d\x81\x8f\u206E\x9d\u206F\x81\u206E\x81\u206F\u206E\u206D\u206C\x9d\u200D\u2060\x8f\u2063\u2064",
    'project-pages.improvement.heading-info': "\u2063\u2062Capture your team's knowledge and improve the way you get work done.\x8d\u206E\u206F\x8d\x8f\u206F\x81\x90\x9d\u200C\u206A\u206A\x90\u206F\u2061\u206A\u206F\u206A\x90\x8f\x9d\u206E\u200C\u2061\x9d\u206F\u206F\u200C\u206D\u2060\x8d\u061C\u2063\u2064",
    'project-pages.improvement.heading-info-v2': "\u2063\u2062Create one place for all your team's project documents\u206E\u206D\u206D\u206D\u2060\u200C\u206F\u206A\x9d\u206B\u200C\u206E\x9d\u206B\u200D\u2060\u206F\u206E\u206B\u2060\u206C\u200D\u200D\u206E\x81\u206F\u200D\x9d\x8d\x8f\u061C\u200D\u2063\u2064",
    'project-pages.improvement.heading-info-v2.non-final': "\u2063\u2062Create one place for all your team's project documents\x8f\u206D\u2060\u206B\u206B\u061C\u206F\u2060\u061C\x81\x8f\u206A\x9d\u206A\u206B\u206D\u200C\u206D\u200C\u206D\u061C\x81\u206B\u200C\u200D\x81\x81\u206C\u206C\u206F\u206B\x8f\u2063\u2064",
    'project-pages.improvement.heading-info.non-final': "\u2063\u2062Capture your team's knowledge and improve the way you get work done.\x8d\x9d\u206E\u061C\x8f\x8d\u206D\u206A\x90\x90\u061C\u206A\x81\u206B\x8f\u206D\u2060\x9d\x90\u200C\u206C\u206B\u206B\u206F\x9d\x81\u200D\x8f\x90\u061C\u206A\u206C\u2063\u2064",
    'project-pages.improvement.learn-more-button': "\u2063\u2062Learn more\x81\u206B\u206D\x9d\u206C\u206B\u061C\u206B\u061C\x81\u206C\u206E\u206C\x81\x8d\u2061\x9d\u206F\x8d\u200C\u206F\x8f\x90\u206A\x9d\x8f\x8f\x81\u200C\u206F\u200D\x8f\u2063\u2064",
    'project-pages.improvement.learn-more-button.non-final': "\u2063\u2062Learn more\x8d\x90\u206A\u2061\u200C\x8f\x90\u2061\u2061\u206E\x81\u206D\u2060\u200C\u206A\u206E\u206F\u2060\x8f\u200C\u206D\u206B\u206E\u200C\u206C\u2061\x8f\u206F\x9d\x8d\x8d\x8d\u2063\u2064",
    'project-pages.improvement.powered-by': "\u2063\u2062Powered by\u206E\u206D\u206B\u061C\u206D\x90\x8f\u200D\x8f\u206D\u200D\u206C\x8f\x81\x81\u206D\u2060\x81\u206A\u206B\x9d\u206A\u200D\u206C\u2060\u2061\u206A\x90\x81\x9d\u200D\u206D\u2063\u2064",
    'project-pages.improvement.powered-by.non-final': "\u2063\u2062Powered by\u200D\u206F\u2061\u2061\u206D\u200C\u2061\u206B\u206A\u206F\u200C\u206B\u206E\u206B\u200D\u206F\x81\x90\u206B\x8d\u206D\x8d\x8f\x81\u206B\x81\u061C\u206B\x8f\u206C\u206E\u206F\u2063\u2064",
    'project-pages.improvement.powered-by.tooltip': "\u2063\u2062Open Confluence in a new tab\u200D\u2061\u2060\u206F\x90\u2060\u206C\u206C\u200C\x8d\x90\u200D\u200D\x90\x8f\u2061\x90\u206A\u200D\u206C\u206B\u2060\u206F\x8f\u200D\u200C\u206B\u061C\u2061\x8f\u206C\x81\u2063\u2064",
    'project-pages.improvement.powered-by.tooltip.non-final': "\u2063\u2062Open Confluence in a new tab\x9d\x8d\u061C\x81\x9d\u061C\u061C\u206A\x9d\x81\u200C\u2060\x8f\u200D\u061C\x81\u2060\u206B\u206B\u206C\u206F\u206E\u200C\x90\u206D\u206F\x8d\u2060\u206C\u061C\u206D\x8d\u2063\u2064",
    'project-pages.improvement.preview-teaser': "\u2063\u2062Unlock templates, project pages, and more.\u206C\u200D\u2061\u061C\x8d\u206A\u200D\u206D\u2061\u200C\x81\x8d\u206A\x8d\u206A\u200C\u206A\u2060\x8d\u206E\x9d\u2060\u200D\u206D\u061C\u2061\u206E\u2060\u206A\u2061\u206A\u200D\u2063\u2064",
    'project-pages.improvement.preview-teaser.non-final': "\u2063\u2062Unlock templates, project pages, and more.\x9d\x8f\u206F\x81\u2061\x8d\u2060\u206A\u2060\u061C\x81\u206B\u200C\x81\x8d\u206F\u206E\u2061\u206B\u206C\u200D\u2060\u061C\u206F\u200D\u206E\x90\u206D\x8f\u2061\u206A\u2061\u2063\u2064",
    'project-pages.improvement.provisioning-info-modal.seamlessly-update-stakeholders.description': "\u2063\u2062<p>Keep your project reports up-to-date with auto-updating status labels.</p> <p>Simply link a Jira ticket in a doc and it will automatically display a status label that updates in sync with the ticket, so you don't have to spend your time creating manual reports.</p>\u061C\u206F\x8d\u206E\u206B\u206D\x9d\u061C\x81\u206C\x81\x8f\u200D\u200C\u206D\u061C\u2060\x8f\u061C\u206A\u061C\u200D\u061C\u200D\u206B\u200D\x8d\u206E\x81\x8d\u206B\u206C\u2063\u2064",
    'project-pages.improvement.provisioning-info-modal.seamlessly-update-stakeholders.title': "\u2063\u2062Seamlessly update your stakeholders\u2060\x90\x9d\u206A\u206C\u2061\x81\u2061\x81\x8f\u206C\x8d\u206A\u206C\u206C\u061C\u206E\u061C\u2061\x90\x8f\u206E\u200D\u206C\x8f\x8f\u061C\u206B\u200D\u2060\u2060\u061C\u2063\u2064",
    'project-pages.improvement.provisioning-info-modal.unify-documentation-standards.description': "\u2063\u2062<p>Create consistent documentation by using our built-in templates. They are simple to use and customizable for your needs.</p> <p>You can use templates directly from project pages, so you never have to leave what you're working on. Browse all templates <a>here</a>.</p>\u206D\x81\x9d\u200D\u206B\u2060\u206F\u206D\x8d\u206E\x8d\u206B\u206F\x9d\x81\u206C\u200D\u206A\u206D\x90\x90\u200D\u206B\u206D\x8f\x8d\x81\u206B\u2060\u206B\u206C\u206D\u2063\u2064",
    'project-pages.improvement.provisioning-info-modal.unify-documentation-standards.title': "\u2063\u2062Unify your documentation standards\u206B\u200C\u200D\x8d\u206E\u200D\x8f\x8d\u061C\u206C\x8f\u2061\u206E\u206F\x9d\u206C\x9d\x9d\x8f\u206C\x81\x9d\u2060\x9d\x8d\u2060\x8f\u2060\u206A\x90\u206C\x9d\u2063\u2064",
    'project-pages.improvement.provisioning-info-modal.your-project-pages-in-jira.description': "\u2063\u2062<p>Create a single source of truth for important information by creating and managing documentation from the project pages tab in Jira.</p> <p>Did you know project pages runs on Confluence? It's free for up to 10 users. Invite the rest of your team in admin settings.</p>\x9d\u206B\x8f\u2061\x9d\u061C\x9d\u206D\u206F\u2061\u206B\u206B\x9d\u206A\u200C\u200D\u206C\x8d\x8f\u206A\x8d\x90\x81\u206A\u2061\x81\u206F\u2060\x8d\u200D\u206E\u206E\u2063\u2064",
    'project-pages.improvement.provisioning-info-modal.your-project-pages-in-jira.title': "\u2063\u2062Your project pages, directly in Jira\u2061\u206A\u206F\u206D\x90\u206F\x81\x8f\u206D\u206B\u206D\u2061\u206F\u061C\x8f\u206D\u206A\u206B\x81\x81\u206F\x8d\x8d\u206E\x8f\x8d\x8d\u206F\u061C\u206C\u206A\u2061\u2063\u2064",
    'project-pages.improvement.templates-sidebar.better-together-templates-header': "\u2063\u2062Templates integrated with your Jira data\u206C\u206E\u2061\x9d\u206E\x81\u206C\x8d\u2061\u206E\u061C\x90\u206B\u206C\u2061\u206B\x9d\u206D\u206F\u206A\u061C\u206A\u2060\u206D\u200D\u206E\u206F\x81\u206E\u2061\u206B\x9d\u2063\u2064",
    'project-pages.improvement.templates.better-together-preview-teaser': "\u2063\u2062Integrated with Jira data\u200C\u206E\u206D\u2060\x8f\u2060\x8f\u206D\u206E\u2060\u2061\u200D\u200C\x9d\u2060\x8f\u206B\x90\u206B\x90\u061C\u200D\u206D\u061C\x8d\x8d\u200D\x8f\u206E\u061C\u206D\x8f\u2063\u2064",
    'project-pages.improvement.templates.blank-page.description': "\u2063\u2062Start a page from scratch.\u206C\u200C\x90\u2061\u061C\u206B\u2060\u206A\x8f\u206C\u061C\u206D\u206B\u206C\u206E\x90\u200D\u2060\x81\u206E\x90\u206D\u200D\u200C\u206F\x81\u206C\x9d\u2060\x9d\x9d\x81\u2063\u2064",
    'project-pages.improvement.templates.blank-page.description.non-final': "\u2063\u2062Start a page from scratch.\u061C\u061C\x81\u2060\u206A\u061C\u2061\x81\x81\u200D\u206A\u200D\x8d\u206E\u206E\x90\u206A\u200C\u200D\u206E\u2061\x81\u206F\u200C\u2061\u206C\u206C\x81\u200C\u206E\x8d\u206A\u2063\u2064",
    'project-pages.improvement.templates.blank-page.name': "\u2063\u2062Blank page\u200C\u206C\u206D\x8d\u2060\u206D\x81\u206F\u206B\u206F\u206E\u061C\u2061\u206A\u206D\u206C\u206E\u200C\u206F\u2061\u2061\u200C\u206E\x8d\u206F\u206E\u206B\u2060\u200D\x8f\x8d\u200C\u2063\u2064",
    'project-pages.improvement.templates.blank-page.name.non-final': "\u2063\u2062Blank page\u206B\x8f\u206B\u206E\u206D\x90\u2061\x8f\u061C\u061C\x8d\u206A\x8f\x9d\x8f\u206D\x90\u061C\x9d\u206E\u200C\u206B\u200C\u200C\u2060\u200D\u2061\u206A\u061C\u2060\x81\u206F\u2063\u2064",
    'project-pages.improvement.templates.decision.description': "\u2063\u2062Record important project decisions and communicate them with your team.\x8d\u200D\u206B\x8d\u200C\u206C\u061C\x90\u206F\u206D\u206F\x90\u061C\u061C\x8f\u2060\u206D\u2060\x8f\u206D\u2060\u206E\x8f\u206A\x81\u206B\u206E\u206E\u2060\x8d\u061C\u206D\u2063\u2064",
    'project-pages.improvement.templates.decision.description.non-final': "\u2063\u2062Record important project decisions and communicate them with your team.\x81\x8d\x8d\x81\u2060\u206F\x9d\u206A\u200D\u206D\x9d\x9d\u206D\x8f\u2060\u200C\u061C\x8f\u200D\u2060\u2061\u2060\x81\u061C\u206F\x8f\u2060\u206F\u061C\u200D\u206F\x8d\u2063\u2064",
    'project-pages.improvement.templates.decision.name': "\u2063\u2062Decision\x8d\u2060\u206E\u2061\x81\u200D\x9d\u206B\x81\u200D\u200D\u200C\u206F\x8f\u200C\x9d\u2061\u206C\x81\u206D\u206A\x90\u2061\u2061\u206D\u061C\u206C\u206A\x81\u206E\x8d\x81\u2063\u2064",
    'project-pages.improvement.templates.decision.name.non-final': "\u2063\u2062Decision\x90\u200C\u206E\u206E\u206F\x9d\u2060\u206A\x8d\u2060\u206E\u2060\u200D\u200C\x9d\u206B\u206E\x9d\x8f\u2060\u2061\u206A\u206D\u200D\u206D\u206A\x9d\x8d\u206B\u206F\x8d\u200C\u2063\u2064",
    'project-pages.improvement.templates.meeting-notes.description': "\u2063\u2062Set meeting agendas, take notes, and share action items with your team.\u2060\u206C\u206D\u206C\x8f\u200C\u206B\x8d\x90\u206C\u206D\u206C\u206A\u206F\u206D\u061C\x81\u206C\u200D\u200D\x8d\u206D\x9d\u061C\u206B\x90\x8d\u200C\u206A\u2061\x8d\x8f\u2063\u2064",
    'project-pages.improvement.templates.meeting-notes.description.non-final': "\u2063\u2062Set meeting agendas, take notes, and share action items with your team.\x9d\u2060\u206B\x8d\u200C\u200C\x90\x81\u206B\u061C\x8d\x90\u200D\x9d\u2060\u2061\u2060\u061C\u206E\u2061\u200D\u200D\u206B\u206F\u206D\u2060\u061C\u2060\u206C\u200D\x90\x9d\u2063\u2064",
    'project-pages.improvement.templates.meeting-notes.name': "\u2063\u2062Meeting notes\u206A\u2060\u206C\u2061\x8f\u2061\x90\u200C\u206E\u206F\u206A\u206D\x81\u2060\x9d\u2061\u200C\x8d\u206A\x8f\u206D\u206E\u206C\x9d\u206F\x8d\x9d\x9d\u2061\u200C\u200D\x9d\u2063\u2064",
    'project-pages.improvement.templates.meeting-notes.name.non-final': "\u2063\u2062Meeting notes\u061C\u206E\x8f\u206E\u061C\u2061\u200C\x8f\u206A\x90\x81\u206E\u200C\u200C\u061C\u206B\x81\u2060\u206A\u206D\x90\x81\x9d\u206F\x8d\u206A\u200C\u061C\x8d\u200D\x8d\x8d\u2063\u2064",
    'project-pages.improvement.templates.post-expand.more': "\u2063\u2062More templates\u206F\x90\u206A\u206B\u061C\x8d\u206C\u206D\u206C\u200D\x90\u206C\u2060\u200C\u206A\u2060\u206F\u206D\x90\u2061\x90\x90\x81\u200D\x9d\u206E\x9d\u206D\x81\u206E\u200C\u061C\u2063\u2064",
    'project-pages.improvement.templates.post-expand.more.non-final': "\u2063\u2062More templates\u206A\u206A\u2060\u2060\x8d\u206F\u061C\u206F\u2061\u206F\u206E\x9d\x90\u206D\u200D\u200D\x8f\u2060\u2060\u061C\x90\x90\u200C\u200C\u200D\u200C\u206C\u206D\x8f\x9d\u206F\x8f\u2063\u2064",
    'project-pages.improvement.templates.post-expand.more.tooltip': "\u2063\u2062View all templates in Confluence\u200C\u200C\x8f\u2061\u2060\x9d\u200D\x8d\x9d\x8d\u200C\u206D\u2061\x90\x9d\x8d\u200D\u206D\x81\u206F\u200C\u206E\u200D\x90\u206D\u206A\u206A\u200C\u200C\x8d\u200D\u206B\u2063\u2064",
    'project-pages.improvement.templates.post-expand.more.tooltip.non-final': "\u2063\u2062View all templates in Confluence\x81\u206A\u206F\u200D\u206C\u200D\u206F\u206F\u061C\x90\x90\u2060\u206A\x8f\x8f\x81\u206D\x90\u206A\x8f\x81\u206F\x8d\x8d\x90\u206F\u2061\u206B\u200D\u206F\x8f\u200C\u2063\u2064",
    'project-pages.improvement.templates.post-expand.subtitle': "\u2063\u2062Popular templates\x81\u2060\x81\u206E\x9d\x90\u2060\u206C\u2061\u206A\u206A\u206B\u2060\x8d\u061C\x90\u061C\u206C\x90\x9d\u061C\x81\x8d\u206D\u200D\x81\x9d\u2061\u2060\u206A\u2061\x8f\u2063\u2064",
    'project-pages.improvement.templates.post-expand.subtitle.non-final': "\u2063\u2062Popular templates\u2061\u206C\u2060\x90\u206E\u206D\u200C\x90\u200C\x8d\x8d\u206F\u2060\u200C\u2060\u206C\u2061\x90\u061C\u200D\u200C\x8f\u200C\u200D\x9d\x8f\u2060\u200D\u206D\u206D\u061C\x8f\u2063\u2064",
    'project-pages.improvement.templates.post-expand.title': "\u2063\u2062Create a page\x8f\x8f\u200D\u2061\x81\u206B\u2061\u2060\u200D\u206D\u2061\u206D\u206C\x90\u206B\u2061\x81\u2061\u206C\x9d\u206C\x81\u206C\u200C\u200D\x9d\u200D\x8d\u206B\x8d\x90\x90\u2063\u2064",
    'project-pages.improvement.templates.post-expand.title.non-final': "\u2063\u2062Create a page\x81\u200C\u2060\u206F\u206C\u2060\u206B\u061C\u206F\u206D\u206A\u200C\u2061\u206E\x8f\u206C\u206E\u206E\x8d\x90\u2061\u206E\u206B\x90\x9d\x81\x81\u200C\x90\x81\u2061\u206A\u2063\u2064",
    'project-pages.improvement.templates.pre-expand.more': "\u2063\u2062Explore more templates\u206C\u200D\u2061\x8d\u206F\u206F\x8f\x8f\u206A\u061C\x9d\u206E\x81\u2061\u2061\x9d\u200C\u206B\u061C\u061C\x81\x8d\u200C\x8f\u2060\u200D\x81\x81\u200D\u206B\u2060\x8d\u2063\u2064",
    'project-pages.improvement.templates.pre-expand.more.non-final': "\u2063\u2062Explore more templates\u206A\u206C\x90\u2061\x8d\u2061\u200C\u2060\u2060\u206C\u200D\u206E\x9d\u206B\u2060\u061C\x90\u061C\u200C\u2061\x81\u061C\u2061\x90\u206D\x8d\x8f\u206D\x90\u206D\x8f\u206F\u2063\u2064",
    'project-pages.improvement.templates.pre-expand.subtitle': "\u2063\u2062Popular with teams like yours\u206E\u206C\x8f\x9d\u206B\x8f\u2060\u206F\x81\u206A\u206D\x90\x81\x81\u2061\u206B\u2060\x8f\x90\u2061\u206D\u206B\x9d\u2060\x8d\u206B\x90\x81\x81\u206E\u206E\u2061\u2063\u2064",
    'project-pages.improvement.templates.pre-expand.subtitle.non-final': "\u2063\u2062Popular with teams like yours\x90\x90\u2060\u206B\u206A\u206E\u206F\u206D\u206A\x90\u061C\u206F\u200C\x81\u061C\u2061\x8f\u061C\u206F\u200D\u206C\u206B\u206F\u206D\u061C\u200D\x8f\u206B\u2060\u061C\x9d\x90\u2063\u2064",
    'project-pages.improvement.templates.pre-expand.title': "\u2063\u2062Preview templates\u206B\u206B\u206A\u206C\u200C\x81\u206A\u206A\u200C\u206E\u206A\u206E\x81\u206D\u206E\u206F\u206C\u206A\x90\x81\x8d\u2061\u2061\u200C\u206D\u206D\u061C\x8d\u206E\u2060\u206C\u206D\u2063\u2064",
    'project-pages.improvement.templates.pre-expand.title.non-final': "\u2063\u2062Preview templates\u2060\u206B\u061C\x8d\u206A\x8f\u206A\x9d\u2060\u206D\u206E\u200D\u200C\u2061\u061C\u061C\u206A\x90\u2060\u206C\u206C\x9d\u206B\u206C\x90\u206E\x90\u206C\x8f\x8f\u206E\x8f\u2063\u2064",
    'project-pages.improvement.templates.product-requirements.description': "\u2063\u2062Define, track and scope requirements for your product or feature.\u206E\u206F\x8d\u200C\x81\u206E\u2060\x9d\x8d\u061C\u200C\u061C\u2060\u206B\u061C\x90\u2060\x9d\x8d\u206F\x9d\u206D\u200D\u061C\u061C\u206C\u206F\x81\x81\u206D\u206D\u206D\u2063\u2064",
    'project-pages.improvement.templates.product-requirements.description.non-final': "\u2063\u2062Define, track and scope requirements for your product or feature.\u206A\x8d\u206C\u200D\x9d\u2060\x81\u200D\x8d\u2060\u200D\x8f\x81\x9d\u206E\u206D\u206D\u206E\u200D\u206F\u2060\x8d\x8f\u206B\u2061\u206F\u206C\x9d\u061C\u206A\u061C\u206C\u2063\u2064",
    'project-pages.improvement.templates.product-requirements.name': "\u2063\u2062Product requirements\u206E\u206D\u206F\x90\x9d\u061C\x8f\x81\x8f\u206C\u206A\u206C\u206F\x90\u206B\u200C\u206E\u206C\u206A\u206C\u200C\u206A\u2061\u2061\u061C\u2061\u200D\u200D\x8d\u200D\u206C\u200D\u2063\u2064",
    'project-pages.improvement.templates.product-requirements.name.non-final': "\u2063\u2062Product requirements\u200D\u206A\u2060\u206A\u206C\x9d\u2060\u206A\u206D\x8f\x90\u2060\x81\x81\u2060\u206C\x81\u200C\u200D\u206D\x9d\x8d\u206F\u200C\u2060\x8d\x8f\u206A\u061C\u2061\u206F\u200D\u2063\u2064",
    'project-pages.improvement.templates.retrospective.description': "\u2063\u2062What went well? What could have gone better? Crowdsource improvements with your team.\u200C\x8d\u206D\u206C\u206F\u200C\x8d\u200D\u206C\x81\u206A\x9d\u206A\u200D\u206E\u206D\u2060\x90\u2061\u2061\u206E\u200D\u206B\u206E\x9d\u206D\u206C\u206A\u2060\x8f\u206E\x9d\u2063\u2064",
    'project-pages.improvement.templates.retrospective.description.non-final': "\u2063\u2062What went well? What could have gone better? Crowdsource improvements with your team.\x9d\u206B\x8f\u206A\x8f\u200C\u206C\u061C\u200D\u200D\u206C\u206F\x81\x8d\u206E\u206D\u2061\u200D\x8d\u206B\u206B\u206B\u200D\x90\x90\x90\x90\u2061\u206A\x8f\u2060\u2060\u2063\u2064",
    'project-pages.improvement.templates.retrospective.name': "\u2063\u2062Retrospective\u061C\u2061\u200C\x8d\u206B\u206F\u200D\u061C\x90\x8d\u206F\x8f\x90\u061C\u200D\u2060\u206F\u2060\u206F\u206E\x81\u206F\x8d\u200C\x90\x81\u206B\u206B\x8d\u206A\u206F\u200D\u2063\u2064",
    'project-pages.improvement.templates.retrospective.name.non-final': "\u2063\u2062Retrospective\x8f\u206F\x90\x81\u200C\u2060\u200C\x8f\u200C\x8d\x8f\u206C\u206B\u200D\u200D\u061C\u206C\u206F\u200C\u206B\u206E\x81\u200D\x81\u2060\u206D\u206E\u206A\x81\u206D\x9d\u2061\u2063\u2064",
    'project-pages.improvement.templates.template.disabled-tooltip': "\u2063\u2062Connect a Confluence space first\u206D\u061C\x8d\u206C\u206C\x8f\x8f\u206D\u206D\u206E\u200C\u061C\u206B\u206F\x9d\x90\u200D\x8d\u2061\u206D\u2061\u2060\u206C\x8d\u2061\u200D\x8f\u200D\x8d\u206D\x81\x81\u2063\u2064",
    'project-pages.improvement.templates.template.disabled-tooltip.non-final': "\u2063\u2062Connect a Confluence space first\x81\u2061\x8f\u061C\u2061\x8d\u206C\u206B\u2061\u2061\u200C\u206C\u200D\u200D\u206A\u206A\u206D\u2060\u2061\u2061\u200C\x8f\u206B\u206E\u206B\u206F\u206A\u206F\x90\u206A\u206F\u206E\u2063\u2064",
    'project-pages.improvement.templates.tutorial.content.confluence-templates': "\u2063\u2062<b>Save time and reduce manual tasks</b>. Confluence has lots of page <a>templates</a>, so you never have to start from scratch. Think technical documents, troubleshooting guides, project plans, product requirements, and more.\u206C\x9d\u2060\u2060\x81\x81\u206B\u206F\x81\u206A\u200D\u2061\u206E\u200D\x81\u206C\u2061\x90\u206D\x8d\x9d\u206C\u206A\u206F\x9d\u200C\x9d\x90\u206A\u200D\u200C\u206F\u2063\u2064",
    'project-pages.improvement.templates.tutorial.content.confluence-templates.non-final': "\u2063\u2062<b>Save time and reduce manual tasks</b>. Confluence has lots of page <a>templates</a>, so you never have to start from scratch. Think technical documents, troubleshooting guides, project plans, product requirements, and more.\x81\u200D\u206A\u2060\u200D\u061C\x8d\x9d\x81\u206F\x90\x8f\u200C\u206D\x9d\u2060\u206B\u200D\u061C\x8d\x90\x90\u206F\u200C\u061C\u206F\u206B\u206A\u2061\u200C\x8f\u200D\u2063\u2064",
    'project-pages.improvement.templates.tutorial.content.edit-and-format': "\u2063\u2062<b>Easily edit and format.</b> Use the top editing menu for standard word formatting, and by typing <b>/</b> you can easily insert lots of handy integrations. Insert a table by typing <c>/table</c> or an image with <c>/image</c>. You can also insert Dropbox links <c>/dropbox</c>, Microsoft office tools <c>/microsoft</c>, or Trello boards and cards <c>/trello</c>.\u206D\x90\x9d\u206C\u061C\x8f\x81\u206E\u200C\u061C\u206A\u206E\u206F\u206B\x9d\u206E\x9d\u206A\u2060\u200D\u200C\x8f\u206B\x81\x90\x9d\u200D\u2061\u206C\x90\u206C\u206A\u2063\u2064",
    'project-pages.improvement.templates.tutorial.content.edit-and-format.non-final': "\u2063\u2062<b>Easily edit and format.</b> Use the top editing menu for standard word formatting, and by typing <b>/</b> you can easily insert lots of handy integrations. Insert a table by typing <c>/table</c> or an image with <c>/image</c>. You can also insert Dropbox links <c>/dropbox</c>, Microsoft office tools <c>/microsoft</c>, or Trello boards and cards <c>/trello</c>.\u206F\u200C\u2061\u2061\u206F\u2060\u200C\u206A\x81\u2061\u206B\u2061\u206F\x8d\u206E\u206B\x8d\u206D\u206B\x8d\u206B\u061C\x90\u206B\u2061\x90\x8d\x9d\u206C\u206F\x8f\u2061\u2063\u2064",
    'project-pages.improvement.templates.tutorial.content.forward-slash-prompt': "\u2063\u2062Type / followed by \u2018table\u2019 or \u2018image\u2019\x8f\u206E\x8f\x90\u206C\x8d\u2061\x81\u061C\u200C\u2061\u206F\u200C\u200D\u206F\u2061\u206E\x8f\u206C\x8f\u206A\u206F\u2061\x81\u206B\x8f\x9d\u206D\u206B\x9d\u206E\u206E\u2063\u2064",
    'project-pages.improvement.templates.tutorial.content.forward-slash-prompt.non-final': "\u2063\u2062Type / followed by \u2018table\u2019 or \u2018image\u2019\x8f\u061C\u206B\u200C\u206D\u206E\u200C\x9d\u206F\u206F\u061C\x81\u2060\u200D\u206D\x8d\u206D\u2061\u206F\u206F\u206A\u200D\x8d\u206A\u206A\u206B\u206B\x81\u200C\x8d\x8f\u200D\u2063\u2064",
    'project-pages.improvement.templates.tutorial.content.getting-started-tips': "\u2063\u2062Here are a couple of tips to get you started:\u206A\x90\x8f\x9d\x81\u200D\u200D\u2060\u2060\u200C\u2060\u206A\x8d\x8d\u206B\x9d\u206D\x81\x81\u206D\u200D\u2060\u206E\x8f\x9d\u200C\u061C\u206C\u200C\u206C\x8d\u206F\u2063\u2064",
    'project-pages.improvement.templates.tutorial.content.getting-started-tips.non-final': "\u2063\u2062Here are a couple of tips to get you started:\x90\u2060\x8f\u200D\x8f\u2061\x90\u206E\u2060\u061C\x9d\x90\u206D\u200D\u206E\x90\x90\u206C\u061C\x9d\u206D\u206E\u206D\u200C\u200C\u206B\u206B\u200C\x81\u206A\u206E\u200D\u2063\u2064",
    'project-pages.improvement.templates.tutorial.content.handy-links': "\u2063\u2062Handy links\u206F\u206B\x8f\u2061\u2061\u206A\u2060\x8d\u206A\x8f\u2060\u206C\u206B\u206D\u2060\x90\x8d\x8f\x90\x90\u206D\u206D\u2060\u206B\x90\x9d\x81\u206D\u2060\u2060\u200D\x9d\u2063\u2064",
    'project-pages.improvement.templates.tutorial.content.handy-links.non-final': "\u2063\u2062Handy links\u206C\u2060\u206F\x9d\u2061\u2061\u200C\u061C\u200D\x90\u206C\u206F\u2060\u061C\u206D\u206E\u061C\u206D\u200C\u206A\u200D\u206E\u206C\u206A\u206E\u206E\u206D\u206D\u2061\u206A\x8d\u200C\u2063\u2064",
    'project-pages.improvement.templates.tutorial.content.jira-and-confluence': "\u2063\u2062Use Jira and Confluence together\u206F\x90\u206A\u2060\u206A\x9d\u206F\u206A\x90\x8f\x81\u2061\u2060\u206D\u200C\x90\u206E\u206A\x90\x81\u206A\x81\u206B\u206D\u206A\u200C\u200C\u206C\u061C\x90\u206A\u206E\u2063\u2064",
    'project-pages.improvement.templates.tutorial.content.jira-and-confluence.non-final': "\u2063\u2062Use Jira and Confluence together\u206E\u206D\u2061\u206B\x8d\x81\x81\u206C\u200C\u2061\u206B\u200C\u206B\x8d\u206B\x81\x90\u2060\u206C\x8d\u2060\u061C\x81\u206B\x8f\u206F\x90\u206C\u2061\u061C\u206E\u200D\u2063\u2064",
    'project-pages.improvement.templates.tutorial.content.jira-charts': "\u2063\u2062Create charts on your pages using real Jira data. Type <c>/Jira charts</c>.\u206D\x9d\u2060\x9d\u206C\u206E\x9d\u206A\u200D\u206B\x9d\u206D\u206D\u2061\u200D\x8d\x8d\u200C\u206F\u206C\u206E\u2060\u206C\u2061\u200D\x9d\x81\u061C\u200C\u061C\u200D\u2061\u2063\u2064",
    'project-pages.improvement.templates.tutorial.content.jira-charts.non-final': "\u2063\u2062Create charts on your pages using real Jira data. Type <c>/Jira charts</c>.\u206E\u206A\x90\u206E\u206A\u2061\u206C\u200C\x8f\x8f\u206E\u206F\u206C\u206F\u200D\x81\x81\u206A\x8f\u2060\u2061\u206F\u206B\u200C\u200D\u206E\u2061\x90\u206A\u200C\u200C\u206D\u2063\u2064",
    'project-pages.improvement.templates.tutorial.content.jira-links': "\u2063\u2062Link a Jira issue anywhere on your page. The link on the page will update in real-time, as you update the Jira issue. Type <c>/Jira</c>.\u200D\u206E\u200D\x81\u2061\x8d\u200D\u200C\u200C\u206D\u200C\x90\u206C\u061C\u206D\u200D\x8d\u206E\x90\u200C\u206F\u206C\u2061\u2061\u206B\u061C\x81\x8f\u2061\u206A\u2060\x81\u2063\u2064",
    'project-pages.improvement.templates.tutorial.content.jira-links-issue-term-refresh': "\u2063\u2062Link a Jira work item anywhere on your page. The link on the page will update in real-time, as you update the work item. Type <c>/Jira</c>.\u2060\u206D\u206C\x8d\x8f\x90\x90\u206C\u061C\u206C\u200C\x90\u206D\u200D\x8f\u2061\u2060\u206D\u200C\u2060\u206E\x9d\u206F\u206A\u206D\u206E\u206C\x90\u200D\u061C\u061C\u206B\u2063\u2064",
    'project-pages.improvement.templates.tutorial.content.jira-links.non-final': "\u2063\u2062Link a Jira issue anywhere on your page. The link on the page will update in real-time, as you update the Jira issue. Type <c>/Jira</c>.\x81\x8d\u206A\u200D\u206F\u200C\u206B\x8d\u2061\u206F\u200C\u206D\u2061\u206F\u061C\u206D\x81\u2061\u206B\u200D\u2061\u206D\u206D\u2060\u200D\x90\u2060\x9d\u206A\u206C\u061C\u2061\u2063\u2064",
    'project-pages.improvement.templates.tutorial.content.jira-links.non-final-issue-term-refresh': "\u2063\u2062Link a Jira work item anywhere on your page. The link on the page will update in real-time, as you update the work item. Type <c>/Jira</c>.\x8d\u061C\u2060\u200D\u206A\x90\x8f\u206C\x8f\u206C\x9d\u206D\u061C\x8f\u200D\x81\u2061\x90\u2060\u206A\u206D\u2061\u200D\u206D\x8f\x9d\u200D\u206A\u2061\u200C\x8d\u061C\u2063\u2064",
    'project-pages.improvement.templates.tutorial.content.jira-roadmaps': "\u2063\u2062Embed interactive roadmaps and timelines for your page using your Jira Projects. Type <c>/jira roadmap</c>.\u206D\u206F\x8f\u206F\u206B\x81\u206E\u2061\x8f\u061C\u206D\x8f\u200D\u206D\u061C\u206E\x9d\u206C\u2061\u206E\u206F\u200D\u206B\u200C\u206A\u206B\u206E\x8d\u200D\x90\u206C\u206A\u2063\u2064",
    'project-pages.improvement.templates.tutorial.content.jira-roadmaps.non-final': "\u2063\u2062Embed interactive roadmaps and timelines for your page using your Jira Projects. Type <c>/jira roadmap</c>.\u206E\u206A\u2061\u061C\u200C\u2060\u206D\u200C\u206F\u061C\u206B\u061C\u200D\u200C\u200C\u206D\u206D\x90\u200D\u206C\u206F\u2061\x9d\u061C\u206D\x90\x8d\u2061\u206D\u206B\u206E\x8f\u2063\u2064",
    'project-pages.improvement.templates.tutorial.content.jira-timeline': "\u2063\u2062Embed interactive timelines for your page using your Jira Projects. Type <c>/jira timeline</c>.\u206C\u206E\x8d\x81\u206A\x90\x8f\x81\x8d\u206D\u2060\u206E\x81\u2061\u206F\u206F\u200C\u200D\u2061\u200C\u2060\x9d\u206E\u206B\u200C\u2060\u200C\x8f\u200D\x8d\x8d\u206A\u2063\u2064",
    'project-pages.improvement.templates.tutorial.content.jira-timeline.non-final': "\u2063\u2062Embed interactive timelines for your page using your Jira Projects. Type <c>/jira timeline</c>.\u061C\u206B\u206D\u2061\u206B\u206A\u206A\x9d\u061C\u206F\u200D\u2061\u2060\u206B\u206E\u2061\u206F\u061C\u061C\u2060\x8f\x90\u200D\u206B\u200D\u2061\x8f\u2061\x8d\x8f\u200C\u206E\u2063\u2064",
    'project-pages.improvement.templates.tutorial.content.shipping-speed-statistic': "\u2063\u206276% of Jira Software customers said they shipped projects faster after adding Confluence\x81\u206E\x8d\u206B\u206C\u206B\u206B\x81\u200D\u200C\x9d\x8d\u206D\x90\u206E\u200C\u200C\x8d\u2061\x90\x8f\u061C\u206B\x8f\x81\x90\x90\x90\u206B\u200C\x90\u206B\u2063\u2064",
    'project-pages.improvement.templates.tutorial.content.shipping-speed-statistic.non-final': "\u2063\u206276% of Jira Software customers said they shipped projects faster after adding Confluence\u206D\x81\u206D\u2061\x90\u2060\u206E\u206B\u200D\u2061\u061C\u2061\u200D\x8f\u206A\x8f\u061C\u200D\x81\u061C\u200D\u206E\x90\u2060\x81\u206D\u206D\u206F\u206F\x9d\u200C\u206B\u2063\u2064",
    'project-pages.improvement.templates.tutorial.content.shipping-speed-statistic.spork-rebranding': "\u2063\u206276% of Jira customers said they shipped projects faster after adding Confluence\u206E\u206E\x9d\u206D\u206D\u206B\x81\x8f\u061C\u200C\x81\u206C\u200D\x90\x8d\u2061\u061C\x8d\x9d\x8f\u206E\x8d\u200D\u200D\u206D\u061C\x8d\u061C\u2061\u061C\x8f\u206B\u2063\u2064",
    'project-pages.improvement.templates.tutorial.content.shipping-speed-statistic.spork-rebranding.non-final': "\u2063\u206276% of Jira customers said they shipped projects faster after adding Confluence\u2060\u206B\u206C\x8d\x90\u206B\u200C\x8f\u206C\u200C\x8d\u206E\x9d\u206B\u206D\u061C\u206C\x81\x8f\u200D\u200D\u206E\u200D\x9d\u206C\u206D\u200D\x9d\u206B\u206F\u061C\u206B\u2063\u2064",
    'project-pages.improvement.templates.tutorial.content.spaces-and-pages': "\u2063\u2062<b>Using spaces and pages</b>. Spaces are part of every Confluence site and are a way of organizing pages into categories. Think of spaces as different folders or projects, and pages are the documents that belong in those folders or projects. <a>Learn more about how to use spaces</a>\u206C\x90\u206C\u206B\u2061\u206C\u200D\x8d\u206E\u200C\x90\u206F\u206F\u206C\x8f\u206D\u206E\x90\u2061\u206B\u206F\x90\x81\u200D\u2060\x81\u206D\u061C\u061C\u200C\u2060\u206F\u2063\u2064",
    'project-pages.improvement.templates.tutorial.content.spaces-and-pages.non-final': "\u2063\u2062<b>Using spaces and pages</b>. Spaces are part of every Confluence site and are a way of organizing pages into categories. Think of spaces as different folders or projects, and pages are the documents that belong in those folders or projects. <a>Learn more about how to use spaces</a>\x9d\x90\x8d\u2060\u206F\u061C\u206D\x8f\u206F\u206C\u206A\u206D\u061C\x81\u200C\u206C\u2060\u061C\u061C\x9d\u200D\u206D\u200D\x81\x81\u200C\u2061\x8d\u061C\u206E\u206C\x9d\u2063\u2064",
    'project-pages.improvement.templates.tutorial.content.try-it-now': "\u2063\u2062Try it now\x81\u2060\u206B\u206E\u061C\u2061\u206A\u200D\u061C\x81\u200D\u206B\x81\u206A\x81\u206B\u206F\x8d\u2061\x90\u206D\x8f\u206B\u2061\u206A\u2060\u206E\u2061\u2060\u206A\u2061\u200D\u2063\u2064",
    'project-pages.improvement.templates.tutorial.content.try-it-now.non-final': "\u2063\u2062Try it now\u200C\u061C\u206D\u206C\u206A\x8f\x9d\x8f\x8d\u206F\u200D\x8d\x8d\u206F\x81\x8f\x9d\u2060\x9d\u2061\u2061\u206E\x9d\u206E\x81\u2061\u2060\u206A\x8f\u200D\u206A\u206F\u2063\u2064",
    'project-pages.improvement.templates.tutorial.description': "\u2063\u2062Learn how to edit a page.\u200D\x90\u206C\u2061\u206D\x81\u2060\x9d\x8f\u206D\x90\u206A\u200D\u206D\u061C\u206A\u2060\x81\u061C\u061C\u061C\x8d\u2060\x8f\u200D\u206B\x8d\u206E\u206D\x81\x81\u200C\u2063\u2064",
    'project-pages.improvement.templates.tutorial.description.non-final': "\u2063\u2062Learn how to edit a page.\u206F\x9d\u206F\u206A\x9d\u206B\u061C\x90\x90\u2060\u200D\u206E\u206E\u2060\x81\u061C\u206F\u200C\x8f\x9d\u2060\u2061\u206C\u206F\u200D\u200C\u206D\u206C\u061C\x81\u206B\u2060\u2063\u2064",
    'project-pages.improvement.templates.tutorial.name': "\u2063\u2062Welcome to Project Pages!\u200C\u206D\u2061\x90\u200C\x8f\x90\u061C\u206A\u2060\u206E\u206A\u206C\x81\u200D\x81\u206F\u206D\u061C\u206A\u206E\x9d\u200D\u206C\x81\x81\x9d\x81\x8d\u061C\u206C\u2061\u2063\u2064",
    'project-pages.improvement.templates.tutorial.name.non-final': "\u2063\u2062Welcome to Project Pages!\x81\u206C\x81\u206E\x8d\u2061\u200C\u206B\u206F\x8f\u206C\x8f\u206F\x8d\u2061\x9d\x90\u206A\u200D\x9d\x81\u200D\x9d\u206E\u206C\x81\u206B\u206C\x90\u206F\x81\u206D\u2063\u2064",
    'project-pages.improvement.terms-and-conditions-v2': "\u2063\u2062By selecting 'Try it now' you acknowledge you will be enrolled in Confluence and agree to the Atlassian <termsLink>Cloud Terms of Service</termsLink> and <privacyLink>Privacy Policy</privacyLink>.\u206A\u2061\u206E\x81\u2061\u2061\u061C\x81\x81\u2060\u206A\x90\u206E\x9d\u206A\x8f\u206C\u206B\u206F\u206C\u200C\x8d\x8f\x9d\u061C\u206D\u206E\u206E\x9d\x90\u206E\u200C\u2063\u2064",
    'project-pages.improvement.terms-and-conditions-v2.non-final': "\u2063\u2062By selecting 'Try it now' you acknowledge you will be enrolled in Confluence and agree to the Atlassian <termsLink>Cloud Terms of Service</termsLink> and <privacyLink>Privacy Policy</privacyLink>.\u206C\x9d\u200C\u206E\x8d\u206B\u206D\u200D\u2061\x90\u061C\u206B\u200D\u200C\u2061\u200D\u200D\u2060\x8d\u206C\x9d\u206B\x8d\u206C\x8f\x8d\x9d\u206A\x8f\x90\u206C\u200D\u2063\u2064",
    'project-pages.improvement.title': "\u2063\u2062Project pages\u206B\u206C\u2061\u206E\u206A\u206F\u206D\u206B\u200C\u206B\u2060\u206B\x8f\u206A\x81\u206F\u206B\u206C\u206A\u200C\u206B\x8d\u200C\u200D\u061C\u2060\u206C\u2060\x9d\u206D\u2061\u200D\u2063\u2064",
    'project-pages.improvement.title.non-final': "\u2063\u2062Project pages\u061C\u206D\x81\u2060\u200C\x81\u206E\x8f\u206E\u206E\u206F\u200C\u2061\u061C\u061C\u206C\u2061\x90\x9d\u2060\u200C\u200C\u206C\u206D\x90\u206F\x8f\u206B\u206D\x9d\u206A\u206C\u2063\u2064",
    'project-pages.improvement.transient-states.empty-state.auto-provisioned-create-page-button': "\u2063\u2062Create page\u200D\u061C\x8d\u206C\u206A\u206F\x90\u061C\x81\x90\u200C\u206B\u206E\x8d\x90\u2061\u2061\u200C\u2061\u200D\u206E\u206E\u2061\x81\u2060\x8d\u206D\u206E\u206F\u061C\x8f\x90\u2063\u2064",
    'project-pages.improvement.transient-states.empty-state.auto-provisioned-description': "\u2063\u2062We\u2019ve added Confluence so you can start creating and linking all your project documents. It\u2019s free for up to 10 users.\u2061\x81\u206B\x8d\u206E\u2061\u206C\u206B\u206D\u200D\x90\u206A\x8d\x8f\u206E\x8d\u206E\u206D\u200C\u206C\x81\u200C\u206A\u206F\x8f\u200D\u200C\x90\u206F\x8d\u200D\x8f\u2063\u2064",
    'project-pages.improvement.transient-states.empty-state.auto-provisioned-learn-more-button': "\u2063\u2062Learn more\u200D\u206F\u206E\u206B\x8d\x81\x9d\x9d\x81\x9d\u206D\x9d\u206F\x8d\x81\u200D\u200C\u206A\u206C\u200D\x8d\u200D\x9d\u206B\u206F\u2060\u206D\u206D\u206B\x90\u206C\u200C\u2063\u2064",
    'project-pages.improvement.transient-states.empty-state.create-page-button': "\u2063\u2062Create your first page\x90\u200D\u206A\u061C\x81\u061C\u200D\u206D\x9d\u206F\u206B\u206C\u200D\u200D\u206B\x8d\x8f\u206C\u206D\u061C\u2060\x8f\x81\u2061\x8f\u2061\x8f\u2061\x90\u206E\x9d\u061C\u2063\u2064",
    'project-pages.improvement.transient-states.empty-state.description': "\u2063\u2062Create some meeting notes, product requirements, decisions, or other content to see this space fill up.\u200C\x9d\u206A\u061C\u2061\u206F\u2061\u206F\x8f\u206D\x9d\u2061\u206F\u2061\u206F\u2060\u2060\u2060\x8d\u200C\x81\x8d\u206C\u2060\u206E\u200D\x90\x9d\x81\x90\u206C\u206B\u2063\u2064",
    'project-pages.improvement.transient-states.empty-state.title': "\u2063\u2062There\u2019s nothing here but potential\u206A\u206D\u206C\u206C\u206C\u206B\u206B\u206D\x8d\x90\u200C\u206D\x8d\u061C\x90\x9d\u2061\x90\x90\u206C\x8f\u061C\u206C\u206C\u206B\u200C\u206C\x90\u206A\u200D\u206B\x9d\u2063\u2064",
    'project-pages.improvement.try-button': "\u2063\u2062Try this template in Confluence\u206B\u2060\x90\x90\u200D\u206A\u206F\x8d\u206F\u206F\u2060\u061C\u206F\u2060\x9d\x8f\x81\x8d\u200C\x81\x81\u2060\u2060\u206B\u206F\u200D\u061C\u206A\u200D\u206F\u200C\u206B\u2063\u2064",
    'project-pages.improvement.try-button.non-final': "\u2063\u2062Try this template in Confluence\u206E\x81\u206B\u061C\u200D\x81\u2061\u206E\u206B\u206F\u2060\u206D\u206C\x8d\u2060\x9d\u206F\u206B\u206B\x9d\u206A\u206E\u200D\u206E\u206E\u206E\x8f\u206C\u206B\x8f\u206E\x9d\u2063\u2064",
    'project-pages.improvement.try-it-now': "\u2063\u2062Try it now\x81\u2060\u206B\x90\x9d\x81\x81\x9d\u200D\u206A\u2060\u206F\u200D\u200D\u206D\u061C\u2061\x9d\u206B\u206F\u200D\u2061\x9d\u206F\u206D\x9d\x8f\x8f\u200C\x9d\u206D\u200D\u2063\u2064",
    'project-pages.improvement.try-it-now.non-final': "\u2063\u2062Try it now\u206D\u206A\u2060\u200C\x8f\u061C\u2061\x81\x81\x81\x8f\u206A\u206B\u206F\x8d\x81\u206B\u061C\x81\x8f\u206F\u206E\x8d\u206C\u206B\u206C\x90\u206B\u206F\x9d\u206B\u2060\u2063\u2064",
    'project-pages.improvement.try-lozenge': "\u2063\u2062try\u206A\x9d\u200C\u206F\u061C\x8f\u206C\x90\u206B\u061C\u206E\u2061\u206F\x81\u206B\x8d\u2061\u2061\u206A\x8f\u2061\u200C\x90\x81\u2061\x8d\u061C\u206E\u206E\u206D\u200D\u2061\u2063\u2064",
    'project-pages.improvement.try-lozenge.non-final': "\u2063\u2062try\x81\u206B\x8f\x8f\u206A\u206B\x81\u061C\u200C\u206B\u200D\x8f\u206C\u061C\u200D\u200C\u206D\u206A\u061C\u200C\u061C\x8f\u206C\u206A\u206F\u2061\u061C\x8f\u206C\x9d\u206A\u206E\u2063\u2064",
    'project-pages.improvement.try-on-demand-button': "\u2063\u2062Try it free\u206E\u206D\x8d\u206C\x90\u061C\x8f\u206C\u206E\u206A\u206C\x81\u200C\u206B\x9d\x8f\u2061\x9d\u2061\u206A\u206E\u206D\u206E\u206D\u200C\u061C\u206D\u206F\x90\x9d\u2061\x8d\u2063\u2064",
    'project-pages.improvement.try-on-demand-button.non-final': "\u2063\u2062Try it free\x8d\u206D\u206E\u200D\u206E\u206F\u206D\x9d\u061C\u200D\x8d\u206E\x90\u206E\u2061\u206F\u061C\u206B\u206E\u206D\u2061\u206E\u206B\u206E\x81\x81\u200C\u206E\u206A\u2060\x9d\u206D\u2063\u2064",
    'project-pages.join-confluence-screens.denied-access-title.non-final': "\u2063\u2062Denied Access Screen\x8d\x8f\u206C\u200C\u206D\u2060\u2061\u2060\u2060\u2061\u200C\u2061\u206E\u061C\u206B\u206A\u2060\x81\u206D\u206B\u206C\u2060\u206B\u206F\x81\u206C\x9d\x8f\x90\x90\u200D\u206A\u2063\u2064",
    'project-pages.join-confluence-screens.direct-join-title.non-final': "\u2063\u2062Direct Join Screen\u061C\x8d\x90\u2061\u206E\u206A\x90\u206F\u200C\u2061\x9d\x90\u061C\x81\u061C\x90\u206F\u2060\u061C\u206A\u206D\u200D\u200C\u200D\x8f\u206C\u206D\x8f\u200D\x9d\u061C\x81\u2063\u2064",
    'project-pages.join-confluence-screens.pending-request-title.non-final': "\u2063\u2062Pending Request Screen\u206F\x8d\x81\u200C\u200C\u2060\u206A\x8f\u200C\x8f\u206B\u2060\u206F\u206B\u206B\u200D\u206E\u200C\u206D\x8f\u2060\u2060\u206B\x81\u200D\x9d\u206E\u206A\u061C\u2060\x90\u206D\u2063\u2064",
    'project-pages.join-confluence-screens.request-access-title.non-final': "\u2063\u2062Request Access Screen\u2061\u206E\u200D\u061C\x8d\u2061\u206F\u2061\u206C\x8d\u200D\x81\u061C\u200D\u061C\u200C\x90\u206D\u2060\x90\x9d\u206F\u206D\u206F\x8d\u200D\u206D\u206C\u200C\x8d\u206B\u2060\u2063\u2064",
    'project-pages.join-confluence-screens.revoked-access-title.non-final': "\u2063\u2062Revoked Access Screen\x8d\u200C\u206E\x9d\u206D\x8f\u206E\x8d\u061C\u061C\u206A\u206A\u200C\u206D\u206D\u206A\u206A\u2060\x8d\u206C\u2060\u206E\x9d\x8d\u206C\u206D\u206E\u2060\u200C\u200C\u061C\u2060\u2063\u2064",
    'project-pages.join-confluence-screens.title.non-final': "\u2063\u2062Join Confluence Page\x9d\u200D\x90\u2061\u206E\u206C\u206F\x8f\x8f\u2061\u206C\u200D\u206C\u206A\u206D\x9d\x81\u061C\u2060\u206E\u2061\u206A\x81\u206A\u206E\u206A\x90\u206D\x9d\u206B\u200C\u206C\u2063\u2064",
    'project-pages.landing-page.feature1.non-final': "\u2063\u2062Access and create documents without leaving Jira\x90\u2061\u206F\u206D\u206F\u2061\x8d\u206F\u2060\x90\x8d\u061C\x9d\x8d\u061C\u206E\u200C\u206A\u200C\u200D\x9d\u2060\x9d\u200D\u206D\u206D\u206B\u206A\x9d\u206F\u200C\u206A\u2063\u2064",
    'project-pages.landing-page.feature2.non-final': "\u2063\u2062Templates for meetings, sprint plans, and more\u206C\x8d\x8d\u206A\u200D\u200D\x9d\u061C\u2061\u206D\u206A\x8d\u200D\x8d\u206B\x8f\u206D\u206D\x90\u206E\x8f\u061C\x90\u2061\u061C\x8d\u200D\x8f\x90\u206F\u206B\u206E\u2063\u2064",
    'project-pages.landing-page.feature3.non-final': "\u2063\u2062Sync documents to Jira for automatic updates\x90\u206F\u061C\x9d\x8f\u2061\u200D\u206F\u206B\x81\u206A\u206F\x9d\u2061\x81\u2060\u206B\u206B\u206F\u206B\u2060\u2060\u206D\u206F\u2061\u206B\x90\u206B\u2060\u2060\u200C\u200C\u2063\u2064",
    'project-pages.landing-page.illustration.title.non-final': "\u2063\u2062Project pages\u2061\u061C\u2060\u206E\u200D\u206D\x9d\u206F\u2061\u061C\u200D\u206D\x81\u206A\u206B\u200C\u206D\u061C\u200D\u206E\u206C\u200D\x81\u206E\u2061\u200C\u206D\u206D\u206B\u2061\u206D\x81\u2063\u2064",
    'project-pages.landing-page.terms-and-conditions.non-final': "\u2063\u2062By selecting 'Try it now' you acknowledge you will be enrolled in Confluence and agree to the Atlassian <termsLink>Cloud Terms of Service</termsLink> and <privacyLink>Privacy Policy</privacyLink>.\u2061\u2060\u200C\u200C\u061C\u2060\u206B\u206F\u206A\x81\x8d\x8f\u200D\x81\u200C\u200C\u200D\u061C\x8d\x9d\u206F\u206E\x9d\x9d\u206E\u206E\u200D\u206A\x9d\u2061\x81\u206C\u2063\u2064",
    'project-pages.landing-page.title.non-final': "\u2063\u2062Welcome to Project Pages\u200D\u061C\u2060\u206B\u200D\u200C\u2060\u2060\x9d\u206D\u206E\u200D\u206E\u206A\x81\u206C\u200D\u2060\u200D\x8f\u200D\u206A\u200C\u200C\u061C\u200C\x90\u206B\u2061\x8f\u061C\u206C\u2063\u2064",
    'project-pages.landing-page.try-now-btn.non-final': "\u2063\u2062Try it now\u206E\u206F\u200D\u2061\u206E\u200D\u206C\u206F\u2060\x90\u206F\u206A\x81\x8f\u206B\x8d\x90\x90\x8d\u206E\u206F\u206B\u206A\u206A\u206E\x8d\u206A\u206C\u2060\u200C\x9d\x81\u2063\u2064",
    'project-pages.page-deleted-flag.title': "\u2063\u2062Page deleted.\u206E\u200D\u206A\x90\u200C\u061C\x9d\u206E\u206E\u206E\u2060\u206C\u200D\u061C\u206A\x90\x9d\x9d\x9d\u2060\u200C\u206D\x90\u206E\u200C\u206F\u206F\u206B\u200C\x90\u2061\u206F\u2063\u2064",
    'project-pages.page-published-flag.title': "\u2063\u2062Your page has been published.\u200C\x9d\u206F\x90\u2060\u061C\u206F\u2060\x8f\u2061\x8f\u206E\u200C\u206D\u2060\x8d\x8d\u200C\u200C\x9d\u061C\u206F\u061C\x81\u206B\u2061\u2060\u206D\u206D\u061C\u206C\u061C\u2063\u2064",
    'project-pages.space-connectsuccess-flag.title.space.non-final': "\u2063\u2062Content connected\u2060\u206A\x8f\u206B\u206C\u206E\u206B\u061C\x9d\x81\u061C\x8f\u200C\u206F\u206A\u206C\u206A\x81\u206E\u206A\x8d\u061C\x81\x90\u206C\u2060\x81\x90\u200C\x8d\x9d\u200D\u2063\u2064",
    'project-pages.title.non-final': "\u2063\u2062Project pages\u206A\x90\u206C\x81\x9d\x9d\x8d\u200C\x81\u206A\x8d\u206F\u206E\u2061\u200D\x8f\x81\x9d\u2060\u206F\x81\u206A\x8d\u061C\u206A\x9d\u200C\u206D\x81\x81\u061C\u206C\u2063\u2064",
    'project-pages.unknown-error.description': "\u2063\u2062{contactSupport} if refreshing doesn\u2019t fix things.\x81\u2061\u206D\x81\x8d\x9d\u2061\u206F\u061C\u2061\x8d\x90\u206D\x90\u061C\u206A\u206A\u206E\x8d\u2060\u206A\u2061\u206D\x9d\x90\x8f\x81\u206C\u206D\u206C\u206D\u2060\u2063\u2064",
    'project-pages.unknown-error.heading': "\u2063\u2062We can\u2019t display project pages right now\u206A\u206B\u206A\u200C\u2061\u206E\u200C\u2060\x8d\u206A\x9d\u206C\x90\x9d\u206C\u206F\u200C\x8d\u206B\u206C\x8f\u206C\u206C\u061C\u206F\x81\u2061\x81\x81\u061C\x9d\u206D\u2063\u2064"
};

});


parcelRegister("32rOA", function(module, exports) {

$parcel$export(module.exports, "default", () => $7cb74b3d3883754d$export$2e2bcd8739ae039);
var $7cb74b3d3883754d$export$2e2bcd8739ae039 = ()=>{
    // TODO: Clean up
    return;
};

});

parcelRegister("yKIn9", function(module, exports) {

$parcel$export(module.exports, "sendTrackAnalyticsEvent", () => $d8551cc3643d371b$export$2876719c0f567f52);
$parcel$export(module.exports, "sendOperationalAnalyticsEvent", () => $d8551cc3643d371b$export$e16236c4f06d26b8);
$parcel$export(module.exports, "initAnalyticsClient", () => $d8551cc3643d371b$export$5021d68a48726232);
$parcel$export(module.exports, "getAnalyticsWebClient", () => $d8551cc3643d371b$export$e9ba7ef9458d1a4a);

var $chc6P = parcelRequire("chc6P");

var $buAWB = parcelRequire("buAWB");
var $iZhen = parcelRequire("iZhen");
let $d8551cc3643d371b$var$rootContext = {};
let $d8551cc3643d371b$var$analyticsClient;
const $d8551cc3643d371b$var$joinCamelCase = (base, value)=>{
    const camelCasedValues = (0, (/*@__PURE__*/$parcel$interopDefault($chc6P)))([
        value
    ], (v)=>v.split('.')).map((v)=>v.replace(/^./, (c)=>c.toUpperCase()));
    return [
        base,
        ...camelCasedValues
    ].join('');
};
const $d8551cc3643d371b$var$createEvent = ({ objectType: objectType, objectId: objectId, source: source, action: action, actionSubject: actionSubject, attributes: attributes, tags: tags })=>({
        containerType: $d8551cc3643d371b$var$rootContext.containerType,
        containerId: $d8551cc3643d371b$var$rootContext.containerId,
        objectType: objectType,
        objectId: objectId,
        source: $d8551cc3643d371b$var$joinCamelCase($d8551cc3643d371b$var$rootContext.parent, source),
        actionSubject: actionSubject,
        action: action,
        actionSubjectId: $d8551cc3643d371b$var$joinCamelCase(action, actionSubject),
        attributes: attributes,
        tags: tags
    });
const $d8551cc3643d371b$var$sendEvent = ({ type: type, payload: payload })=>{
    switch(type){
        case (0, $iZhen.eventType).UI:
            $d8551cc3643d371b$var$analyticsClient.sendUIEvent(payload);
            break;
        case (0, $iZhen.eventType).TRACK:
            $d8551cc3643d371b$var$analyticsClient.sendTrackEvent(payload);
            break;
        case (0, $iZhen.eventType).OPERATIONAL:
            $d8551cc3643d371b$var$analyticsClient.sendOperationalEvent(payload);
            break;
        case (0, $iZhen.eventType).SCREEN:
            $d8551cc3643d371b$var$analyticsClient.sendScreenEvent(payload.name, null, payload.attributes);
            break;
        default:
    }
};
const $d8551cc3643d371b$export$2876719c0f567f52 = (eventData)=>{
    const analyticsEvent = $d8551cc3643d371b$var$createEvent(eventData);
    $d8551cc3643d371b$var$sendEvent({
        type: (0, $iZhen.eventType).TRACK,
        payload: analyticsEvent
    });
};
const $d8551cc3643d371b$export$e16236c4f06d26b8 = (eventData)=>{
    const analyticsEvent = $d8551cc3643d371b$var$createEvent(eventData);
    $d8551cc3643d371b$var$sendEvent({
        type: (0, $iZhen.eventType).OPERATIONAL,
        payload: analyticsEvent
    });
};
const $d8551cc3643d371b$export$5021d68a48726232 = ({ client: { environment: environment, locale: locale, cloudId: cloudId, accountId: accountId }, context: context })=>{
    $d8551cc3643d371b$var$analyticsClient = new (0, $buAWB.default)({
        env: environment === 'prod' ? (0, $iZhen.envType).PROD : (0, $iZhen.envType).DEV,
        product: 'jira',
        version: '1.0.0',
        locale: locale
    });
    $d8551cc3643d371b$var$analyticsClient.setTenantInfo((0, $iZhen.tenantType).CLOUD_ID, cloudId);
    $d8551cc3643d371b$var$analyticsClient.setUserInfo((0, $iZhen.userType).ATLASSIAN_ACCOUNT, accountId);
    $d8551cc3643d371b$var$rootContext = context;
};
const $d8551cc3643d371b$export$e9ba7ef9458d1a4a = ()=>$d8551cc3643d371b$var$analyticsClient;

});

parcelRegister("6uXfu", function(module, exports) {

$parcel$export(module.exports, "default", () => $bf32c0a4613d2397$export$2e2bcd8739ae039);

var $7Z8iG = parcelRequire("7Z8iG");

var $aPZf4 = parcelRequire("aPZf4");

var $eg01Z = parcelRequire("eg01Z");

var $9MB7L = parcelRequire("9MB7L");

var $9ucmj = parcelRequire("9ucmj");

var $cEp5g = parcelRequire("cEp5g");

var $4DJ1q = parcelRequire("4DJ1q");

var $4NQC3 = parcelRequire("4NQC3");

var $gCyAx = parcelRequire("gCyAx");

var $4K3sB = parcelRequire("4K3sB");

var $5SIjY = parcelRequire("5SIjY");

var $2WCIv = parcelRequire("2WCIv");

var $eSbRM = parcelRequire("eSbRM");

var $dYeSR = parcelRequire("dYeSR");

var $dwh31 = parcelRequire("dwh31");

var $hdZcc = parcelRequire("hdZcc");

var $7cesL = parcelRequire("7cesL");

var $hFWlI = parcelRequire("hFWlI");

var $8pKu0 = parcelRequire("8pKu0");
const $bf32c0a4613d2397$export$c31df4bd766f9c35 = (state, { hasConfluence: hasConfluence, hasActivatedConfluenceWithinSevenDays: hasActivatedConfluenceWithinSevenDays })=>({
        ConnectSpaceDialog: $4DJ1q.default,
        CreateSpaceDialog: $4NQC3.default,
        MoreMenu: $dYeSR.default,
        ConnectSpace: $4K3sB.default,
        ConfluenceTree: $5SIjY.default,
        ServerError: $2WCIv.default,
        ConfluenceActivating: $gCyAx.default,
        PagesHeading: $dwh31.default,
        Flags: $eSbRM.default,
        EmbeddedConfluenceDialog: $hdZcc.EmbeddedConfluenceDialog,
        confluenceLicenseStatus: (0, $9ucmj.getConfluenceLicenseStatus)(state),
        confluenceState: (0, $9MB7L.getConfluenceState)(state),
        hasAccessToConfluence: (0, $9ucmj.getIsPostExpand)(state, hasConfluence),
        hasActivatedConfluenceWithinSevenDays: hasActivatedConfluenceWithinSevenDays,
        origin: (0, $9MB7L.getOrigin)(state),
        cloudId: (0, $9MB7L.getCloudId)(state),
        projectSpaceKey: (0, $cEp5g.getProjectSpaceKey)(state),
        projectSpacePageTitleHasBeenFetched: state.confluence.connectedSpace.projectSpacePageTitleHasBeenFetched,
        accountId: (0, $9MB7L.getAccountId)(state),
        siteTraits: (0, $hFWlI.getSiteTraits)(state),
        projectSpaceId: (0, $cEp5g.getProjectSpaceId)(state),
        doesUserHaveConfluenceAccess: (0, $8pKu0.doesUserHaveConfluenceAccess)(state)
    });
const $bf32c0a4613d2397$export$9e6a17cf56877796 = (dispatch)=>({
        triggerShowConnectSpaceDialog: ()=>{
            dispatch((0, $aPZf4.showConnectSpaceDialog)());
            dispatch((0, $aPZf4.fetchConfluenceSpaces)());
        },
        triggerHideConnectSpaceDialog: ()=>dispatch((0, $aPZf4.hideConnectSpaceDialog)()),
        triggerErrorFlag: ()=>dispatch((0, $aPZf4.showError)()),
        triggerInitializeView: ()=>{
            dispatch((0, $eg01Z.initializeView)());
        }
    });
var $bf32c0a4613d2397$export$2e2bcd8739ae039 = (0, $7Z8iG.connect)($bf32c0a4613d2397$export$c31df4bd766f9c35, $bf32c0a4613d2397$export$9e6a17cf56877796)((0, $7cesL.default));

});
parcelRegister("aPZf4", function(module, exports) {

$parcel$export(module.exports, "CHANGE_SPACE_NAME", () => $72c52226d41c2550$export$975d476978f4be6d);
$parcel$export(module.exports, "changeSpaceName", () => $72c52226d41c2550$export$3e1566633c96b95);
$parcel$export(module.exports, "CHECK_PRODUCTS_LICENCE_STATE", () => $72c52226d41c2550$export$e3e0aa9fa72a9172);
$parcel$export(module.exports, "checkProductsLicenceState", () => $72c52226d41c2550$export$758ea8f67c1b6038);
$parcel$export(module.exports, "CHECK_CONFLUENCE_USER_PERMISSIONS", () => $72c52226d41c2550$export$498ddfccd74f6b2e);
$parcel$export(module.exports, "checkConfluenceUserPermissions", () => $72c52226d41c2550$export$e645a900e228e518);
$parcel$export(module.exports, "UPDATE_CONFLUENCE_USER_ACCESS", () => $72c52226d41c2550$export$5ae85edd40fea59);
$parcel$export(module.exports, "updateConfluenceUserAccess", () => $72c52226d41c2550$export$190a933252181349);
$parcel$export(module.exports, "CONNECT_CONFLUENCE_SPACE", () => $72c52226d41c2550$export$98f58cdac80fc749);
$parcel$export(module.exports, "connectConfluenceSpace", () => $72c52226d41c2550$export$30ea72c711e481ce);
$parcel$export(module.exports, "FETCH_CONNECTED_SPACE_BLUEPRINTS", () => $72c52226d41c2550$export$477de93d41065628);
$parcel$export(module.exports, "fetchConnectedSpaceBlueprints", () => $72c52226d41c2550$export$c9e2bdc7b72fcdd1);
$parcel$export(module.exports, "CHECK_CONFLUENCE_ACCESS_WITH_RETRY", () => $72c52226d41c2550$export$70014928e1a39ffa);
$parcel$export(module.exports, "checkConfluenceAccessWithRetry", () => $72c52226d41c2550$export$76137a25f6d06d6c);
$parcel$export(module.exports, "RESET_CONNECTED_SPACE", () => $72c52226d41c2550$export$aa2e879d6392e0ba);
$parcel$export(module.exports, "resetConnectedSpace", () => $72c52226d41c2550$export$89f1e56d63058051);
$parcel$export(module.exports, "FETCH_CONNECTED_SPACE_BLUEPRINTS_ERROR", () => $72c52226d41c2550$export$5ba9db9ab3024aed);
$parcel$export(module.exports, "fetchConnectedSpaceBlueprintsError", () => $72c52226d41c2550$export$ca0d39c192dc7e82);
$parcel$export(module.exports, "FETCH_CONFLUENCE_SPACES", () => $72c52226d41c2550$export$d5ff56be054b9a75);
$parcel$export(module.exports, "fetchConfluenceSpaces", () => $72c52226d41c2550$export$919c2c6ec09a9e2);
$parcel$export(module.exports, "FETCH_CONFLUENCE_SPACES_ERROR", () => $72c52226d41c2550$export$9b2363ba0c628e02);
$parcel$export(module.exports, "fetchConfluenceSpacesError", () => $72c52226d41c2550$export$356782d51ee2d59b);
$parcel$export(module.exports, "GENERATE_SPACE_KEY", () => $72c52226d41c2550$export$ef3af75fc9a7bae5);
$parcel$export(module.exports, "generateSpaceKey", () => $72c52226d41c2550$export$a7109cd91ae8e809);
$parcel$export(module.exports, "GET_PROJECT_SPACE_LINK", () => $72c52226d41c2550$export$cbecd83851a98ad6);
$parcel$export(module.exports, "getProjectSpaceLink", () => $72c52226d41c2550$export$1b6f4b19aebf4179);
$parcel$export(module.exports, "GET_PROJECT_SPACE_LINK_ERROR", () => $72c52226d41c2550$export$b5274c19dade5a70);
$parcel$export(module.exports, "getProjectSpaceLinkError", () => $72c52226d41c2550$export$5e3ded0c0b0d9c89);
$parcel$export(module.exports, "HIDE_CONNECT_SPACE_DIALOG", () => $72c52226d41c2550$export$e28b20bc070fc43b);
$parcel$export(module.exports, "hideConnectSpaceDialog", () => $72c52226d41c2550$export$71590f212f9d75e8);
$parcel$export(module.exports, "HIDE_CREATE_SPACE_DIALOG", () => $72c52226d41c2550$export$180bd051e24ee787);
$parcel$export(module.exports, "NO_VALID_KEY", () => $72c52226d41c2550$export$e8286506c58654e7);
$parcel$export(module.exports, "noValidKey", () => $72c52226d41c2550$export$1f5ff8c210c74c43);
$parcel$export(module.exports, "NO_VALID_KEY_FAILURE", () => $72c52226d41c2550$export$435625977ffffaa0);
$parcel$export(module.exports, "noValidKeyFailure", () => $72c52226d41c2550$export$451f6f5389f13654);
$parcel$export(module.exports, "PUT_PROJECT_SPACE_LINK", () => $72c52226d41c2550$export$e3d116cfcae27c34);
$parcel$export(module.exports, "putProjectSpaceLink", () => $72c52226d41c2550$export$dfc1b065e2e5ad09);
$parcel$export(module.exports, "PUT_PROJECT_SPACE_LINK_ERROR", () => $72c52226d41c2550$export$460b0974c0bd7b54);
$parcel$export(module.exports, "putProjectSpaceLinkError", () => $72c52226d41c2550$export$bd0e95966c45b296);
$parcel$export(module.exports, "REDIRECT_TO_CONFLUENCE_CREATE_ERROR", () => $72c52226d41c2550$export$13fb952efbb55e5e);
$parcel$export(module.exports, "SET_FIRST_SPACE_CREATED_FLAG", () => $72c52226d41c2550$export$272c7ebed0cbae54);
$parcel$export(module.exports, "setFirstSpaceCreatedFlag", () => $72c52226d41c2550$export$549bff0573523370);
$parcel$export(module.exports, "SET_SELECTED_SPACE", () => $72c52226d41c2550$export$5bba470e3809ed4);
$parcel$export(module.exports, "setSelectedSpace", () => $72c52226d41c2550$export$cfcf789129734d0c);
$parcel$export(module.exports, "SHOW_CONNECT_SPACE_DIALOG", () => $72c52226d41c2550$export$ee02c3bec5d74835);
$parcel$export(module.exports, "showConnectSpaceDialog", () => $72c52226d41c2550$export$2a60bfdeb4e71f1);
$parcel$export(module.exports, "SHOW_CREATE_SPACE_DIALOG", () => $72c52226d41c2550$export$2aeaf697b0878e2b);
$parcel$export(module.exports, "showCreateSpaceDialog", () => $72c52226d41c2550$export$6ac9be769bc6d43a);
$parcel$export(module.exports, "INVOKE_CROSS_FLOW", () => $72c52226d41c2550$export$829393f05adb1a58);
$parcel$export(module.exports, "SHOW_XFLOW_DIALOG_ERROR", () => $72c52226d41c2550$export$37b19eb01a9ffb47);
$parcel$export(module.exports, "showXflowDialogError", () => $72c52226d41c2550$export$9619e8c6e7ff9f87);
$parcel$export(module.exports, "TOGGLE_SPACE_NAME_INVALID", () => $72c52226d41c2550$export$d7025623a892f5e7);
$parcel$export(module.exports, "toggleSpaceNameInvalid", () => $72c52226d41c2550$export$72e6f4914f4db320);
$parcel$export(module.exports, "UPDATE_CONNECTED_SPACE_BLUEPRINTS", () => $72c52226d41c2550$export$35546514045d3ef6);
$parcel$export(module.exports, "updateConnectedSpaceBlueprints", () => $72c52226d41c2550$export$868df370576ed7b9);
$parcel$export(module.exports, "UPDATE_CONFLUENCE_SPACES", () => $72c52226d41c2550$export$3add0fd96e0a0f94);
$parcel$export(module.exports, "updateConfluenceSpaces", () => $72c52226d41c2550$export$af25752520107849);
$parcel$export(module.exports, "UPDATE_CONFLUENCE_STATE", () => $72c52226d41c2550$export$642f8c42c3174bb3);
$parcel$export(module.exports, "UPDATE_CONFLUENCE_EDITION", () => $72c52226d41c2550$export$4945c781e256866);
$parcel$export(module.exports, "UPDATE_JSW_EDITION", () => $72c52226d41c2550$export$d249ebe59cef7fd0);
$parcel$export(module.exports, "updateConfluenceState", () => $72c52226d41c2550$export$f0daa551fdf516de);
$parcel$export(module.exports, "updateConfluenceEdition", () => $72c52226d41c2550$export$fcd065f821290c09);
$parcel$export(module.exports, "updateJswEdition", () => $72c52226d41c2550$export$843be94842235022);
$parcel$export(module.exports, "UPDATE_PROJECT_SPACE_LINK", () => $72c52226d41c2550$export$b5f26e81b011310);
$parcel$export(module.exports, "updateProjectSpaceLink", () => $72c52226d41c2550$export$9d63c755cd3b59d4);
$parcel$export(module.exports, "UPDATE_SPACE_NAME", () => $72c52226d41c2550$export$c774daa37662a6e2);
$parcel$export(module.exports, "updateSpaceName", () => $72c52226d41c2550$export$f5c0413e2566c026);
$parcel$export(module.exports, "UPDATE_SUGGESTED_KEY", () => $72c52226d41c2550$export$910d1d3b9b49d47f);
$parcel$export(module.exports, "updateSuggestedKey", () => $72c52226d41c2550$export$5bf0de5eee5cf319);
$parcel$export(module.exports, "SUCCESSFULLY_CONNECTED_SPACE", () => $72c52226d41c2550$export$56a6b0eafd2ee646);
$parcel$export(module.exports, "successfullyConnectedSpace", () => $72c52226d41c2550$export$5fe667e6e7e6ce92);
$parcel$export(module.exports, "SHOW_ACTIVATION_ERROR_FLAG", () => $72c52226d41c2550$export$c6f909e212a85e8);
$parcel$export(module.exports, "showActivationErrorFlag", () => $72c52226d41c2550$export$aa7e0797d3fa2965);
$parcel$export(module.exports, "SHOW_ERROR", () => $72c52226d41c2550$export$5973607600a0786d);
$parcel$export(module.exports, "showError", () => $72c52226d41c2550$export$3879b24e8245693d);
$parcel$export(module.exports, "DISMISS_SUCCESS_FLAG", () => $72c52226d41c2550$export$2dd037467821974b);
$parcel$export(module.exports, "dismissSuccessFlag", () => $72c52226d41c2550$export$f6370a49e43e0576);
$parcel$export(module.exports, "DISMISS_ERROR", () => $72c52226d41c2550$export$3cd97e75ca3b9296);
$parcel$export(module.exports, "dismissError", () => $72c52226d41c2550$export$c1844e841b0106f7);
$parcel$export(module.exports, "DISMISS_ACTIVATION_ERROR_FLAG", () => $72c52226d41c2550$export$960a68c7ad7aa3a);
$parcel$export(module.exports, "dismissActivationErrorFlag", () => $72c52226d41c2550$export$d336837fff09d47f);
$parcel$export(module.exports, "SUCCESSFULLY_REQUESTED_ACCESS", () => $72c52226d41c2550$export$cfc13953d69f0001);
$parcel$export(module.exports, "FETCH_CONFLUENCE_ACCESS_REQUEST_CAPABILITIES", () => $72c52226d41c2550$export$996348d031105c73);
$parcel$export(module.exports, "fetchConfluenceAccessRequestCapabilities", () => $72c52226d41c2550$export$448a117797b4db5f);
$parcel$export(module.exports, "INLINE_JOIN_CONFLUENCE", () => $72c52226d41c2550$export$75e62da1cc0402ef);
$parcel$export(module.exports, "inlineJoinConfluence", () => $72c52226d41c2550$export$62909a668caf4055);
$parcel$export(module.exports, "INLINE_JOIN_FAILED", () => $72c52226d41c2550$export$db3820748244cc8b);
$parcel$export(module.exports, "inlineJoinConfluenceFailed", () => $72c52226d41c2550$export$15ba59499cf4c67);
$parcel$export(module.exports, "UPDATE_CONFLUENCE_ACCESS_REQUEST_CAPABILITIES", () => $72c52226d41c2550$export$18cedb2141f6d92b);
$parcel$export(module.exports, "updateConfluenceAccessRequestCapabilities", () => $72c52226d41c2550$export$d9296536f93a8e55);
$parcel$export(module.exports, "FETCH_CONFLUENCE_COLLABORATORS", () => $72c52226d41c2550$export$b354c67a4077ba9c);
$parcel$export(module.exports, "fetchConfluenceCollaborators", () => $72c52226d41c2550$export$7a04b158659a6a5e);
$parcel$export(module.exports, "UPDATE_CONFLUENCE_COLLABORATORS", () => $72c52226d41c2550$export$868df1522dd01363);
$parcel$export(module.exports, "updateConfluenceCollaborators", () => $72c52226d41c2550$export$1f606a1ee0a12a77);
$parcel$export(module.exports, "FETCH_CONNECTED_SPACE_OR_PAGE_TITLE", () => $72c52226d41c2550$export$6a5d0396986b2002);
$parcel$export(module.exports, "fetchConnectedSpaceOrPageTitle", () => $72c52226d41c2550$export$2682af34eb3aa1e3);
$parcel$export(module.exports, "FETCH_CONNECTED_SPACE", () => $72c52226d41c2550$export$c044983cd2f9624c);
$parcel$export(module.exports, "fetchConnectedSpace", () => $72c52226d41c2550$export$b18ea8549fbce2f);
$parcel$export(module.exports, "UPDATE_CONFLUENCE_SPACE_CONNECTION_STATE", () => $72c52226d41c2550$export$bcdcc308c5deb22f);
$parcel$export(module.exports, "updateConfluenceSpaceConnectionState", () => $72c52226d41c2550$export$e5b6b4f53362d4fc);
$parcel$export(module.exports, "UPDATE_CONNECTED_SPACE_OR_PAGE_CONTENT", () => $72c52226d41c2550$export$b4e21ab2a8049f3a);
$parcel$export(module.exports, "updateConnectedSpaceOrPageContent", () => $72c52226d41c2550$export$721e32cdead77c18);
$parcel$export(module.exports, "FETCH_JIRA_PROJECT_PERMISSIONS", () => $72c52226d41c2550$export$99a8dcf38de45a88);
$parcel$export(module.exports, "fetchJiraProjectPermissions", () => $72c52226d41c2550$export$2a09832034358a97);
const $72c52226d41c2550$export$975d476978f4be6d = 'CHANGE_SPACE_NAME';
const $72c52226d41c2550$export$3e1566633c96b95 = (name)=>({
        type: $72c52226d41c2550$export$975d476978f4be6d,
        name: name
    });
const $72c52226d41c2550$export$e3e0aa9fa72a9172 = 'CHECK_PRODUCTS_LICENCE_STATE';
const $72c52226d41c2550$export$758ea8f67c1b6038 = ()=>({
        type: $72c52226d41c2550$export$e3e0aa9fa72a9172
    });
const $72c52226d41c2550$export$498ddfccd74f6b2e = 'CHECK_CONFLUENCE_USER_PERMISSIONS';
const $72c52226d41c2550$export$e645a900e228e518 = ()=>({
        type: $72c52226d41c2550$export$498ddfccd74f6b2e
    });
const $72c52226d41c2550$export$5ae85edd40fea59 = 'UPDATE_CONFLUENCE_USER_ACCESS';
const $72c52226d41c2550$export$190a933252181349 = (userAccess)=>({
        type: $72c52226d41c2550$export$5ae85edd40fea59,
        access: userAccess
    });
const $72c52226d41c2550$export$98f58cdac80fc749 = 'CONNECT_CONFLUENCE_SPACE';
const $72c52226d41c2550$export$30ea72c711e481ce = ()=>({
        type: $72c52226d41c2550$export$98f58cdac80fc749
    });
const $72c52226d41c2550$export$477de93d41065628 = 'FETCH_CONNECTED_SPACE_BLUEPRINTS';
const $72c52226d41c2550$export$c9e2bdc7b72fcdd1 = ()=>({
        type: $72c52226d41c2550$export$477de93d41065628
    });
const $72c52226d41c2550$export$70014928e1a39ffa = 'CHECK_CONFLUENCE_ACCESS_WITH_RETRY';
const $72c52226d41c2550$export$76137a25f6d06d6c = ()=>({
        type: $72c52226d41c2550$export$70014928e1a39ffa
    });
const $72c52226d41c2550$export$aa2e879d6392e0ba = 'RESET_CONNECTED_SPACE';
const $72c52226d41c2550$export$89f1e56d63058051 = ()=>({
        type: $72c52226d41c2550$export$aa2e879d6392e0ba
    });
const $72c52226d41c2550$export$5ba9db9ab3024aed = 'FETCH_CONNECTED_SPACE_BLUEPRINTS_ERROR';
const $72c52226d41c2550$export$ca0d39c192dc7e82 = ()=>({
        type: $72c52226d41c2550$export$5ba9db9ab3024aed
    });
const $72c52226d41c2550$export$d5ff56be054b9a75 = 'FETCH_CONFLUENCE_SPACES';
const $72c52226d41c2550$export$919c2c6ec09a9e2 = ()=>({
        type: $72c52226d41c2550$export$d5ff56be054b9a75
    });
const $72c52226d41c2550$export$9b2363ba0c628e02 = 'FETCH_CONFLUENCE_SPACES_ERROR';
const $72c52226d41c2550$export$356782d51ee2d59b = ()=>({
        type: $72c52226d41c2550$export$9b2363ba0c628e02
    });
const $72c52226d41c2550$export$ef3af75fc9a7bae5 = 'GENERATE_SPACE_KEY';
const $72c52226d41c2550$export$a7109cd91ae8e809 = (name)=>({
        type: $72c52226d41c2550$export$ef3af75fc9a7bae5,
        name: name
    });
const $72c52226d41c2550$export$cbecd83851a98ad6 = 'GET_PROJECT_SPACE_LINK';
const $72c52226d41c2550$export$1b6f4b19aebf4179 = (projectId)=>({
        type: $72c52226d41c2550$export$cbecd83851a98ad6,
        projectId: projectId
    });
const $72c52226d41c2550$export$b5274c19dade5a70 = 'GET_PROJECT_SPACE_LINK_ERROR';
const $72c52226d41c2550$export$5e3ded0c0b0d9c89 = ()=>({
        type: $72c52226d41c2550$export$b5274c19dade5a70
    });
const $72c52226d41c2550$export$e28b20bc070fc43b = 'HIDE_CONNECT_SPACE_DIALOG';
const $72c52226d41c2550$export$71590f212f9d75e8 = ()=>({
        type: $72c52226d41c2550$export$e28b20bc070fc43b
    });
const $72c52226d41c2550$export$180bd051e24ee787 = 'HIDE_CREATE_SPACE_DIALOG';
const $72c52226d41c2550$export$d6d601929e7da41d = ()=>({
        type: $72c52226d41c2550$export$180bd051e24ee787
    });
const $72c52226d41c2550$export$e8286506c58654e7 = 'NO_VALID_KEY';
const $72c52226d41c2550$export$1f5ff8c210c74c43 = ()=>({
        type: $72c52226d41c2550$export$e8286506c58654e7
    });
const $72c52226d41c2550$export$435625977ffffaa0 = 'NO_VALID_KEY_FAILURE';
const $72c52226d41c2550$export$451f6f5389f13654 = ()=>({
        type: $72c52226d41c2550$export$435625977ffffaa0
    });
const $72c52226d41c2550$export$e3d116cfcae27c34 = 'PUT_PROJECT_SPACE_LINK';
const $72c52226d41c2550$export$dfc1b065e2e5ad09 = ({ spaceId: spaceId, spaceKey: spaceKey, spaceUrl: spaceUrl, projectKey: projectKey, projectId: projectId, linkedPageId: linkedPageId, linkedPageTitle: linkedPageTitle, autoCreated: autoCreated, connectedSpaceId: connectedSpaceId, connectedPageId: connectedPageId })=>({
        type: $72c52226d41c2550$export$e3d116cfcae27c34,
        spaceId: spaceId,
        spaceKey: spaceKey,
        spaceUrl: spaceUrl,
        projectKey: projectKey,
        projectId: projectId,
        linkedPageId: linkedPageId,
        linkedPageTitle: linkedPageTitle,
        autoCreated: autoCreated,
        connectedSpaceId: connectedSpaceId,
        connectedPageId: connectedPageId
    });
const $72c52226d41c2550$export$460b0974c0bd7b54 = 'PUT_PROJECT_SPACE_LINK_ERROR';
const $72c52226d41c2550$export$bd0e95966c45b296 = ()=>({
        type: $72c52226d41c2550$export$460b0974c0bd7b54
    });
const $72c52226d41c2550$export$13fb952efbb55e5e = 'REDIRECT_TO_CONFLUENCE_CREATE_ERROR';
const $72c52226d41c2550$export$839bcd5570d94176 = ()=>({
        type: $72c52226d41c2550$export$13fb952efbb55e5e
    });
const $72c52226d41c2550$export$272c7ebed0cbae54 = 'SET_FIRST_SPACE_CREATED_FLAG';
const $72c52226d41c2550$export$549bff0573523370 = ()=>({
        type: $72c52226d41c2550$export$272c7ebed0cbae54
    });
const $72c52226d41c2550$export$5bba470e3809ed4 = 'SET_SELECTED_SPACE';
const $72c52226d41c2550$export$cfcf789129734d0c = (payload)=>({
        type: $72c52226d41c2550$export$5bba470e3809ed4,
        payload: payload
    });
const $72c52226d41c2550$export$ee02c3bec5d74835 = 'SHOW_CONNECT_SPACE_DIALOG';
const $72c52226d41c2550$export$2a60bfdeb4e71f1 = (disconnectedTemplatesClick = false)=>({
        type: $72c52226d41c2550$export$ee02c3bec5d74835,
        disconnectedTemplatesClick: disconnectedTemplatesClick
    });
const $72c52226d41c2550$export$2aeaf697b0878e2b = 'SHOW_CREATE_SPACE_DIALOG';
const $72c52226d41c2550$export$6ac9be769bc6d43a = ()=>({
        type: $72c52226d41c2550$export$2aeaf697b0878e2b
    });
const $72c52226d41c2550$export$829393f05adb1a58 = 'INVOKE_CROSS_FLOW';
const $72c52226d41c2550$export$3852642f4bf51096 = (contextInfo)=>({
        type: $72c52226d41c2550$export$829393f05adb1a58,
        contextInfo: contextInfo
    });
const $72c52226d41c2550$export$37b19eb01a9ffb47 = 'SHOW_XFLOW_DIALOG_ERROR';
const $72c52226d41c2550$export$9619e8c6e7ff9f87 = ()=>({
        type: $72c52226d41c2550$export$37b19eb01a9ffb47
    });
const $72c52226d41c2550$export$d7025623a892f5e7 = 'TOGGLE_SPACE_NAME_INVALID';
const $72c52226d41c2550$export$72e6f4914f4db320 = (userEnteredSpaceNameInvalid)=>({
        type: $72c52226d41c2550$export$d7025623a892f5e7,
        userEnteredSpaceNameInvalid: userEnteredSpaceNameInvalid
    });
const $72c52226d41c2550$export$35546514045d3ef6 = 'UPDATE_CONNECTED_SPACE_BLUEPRINTS';
const $72c52226d41c2550$export$868df370576ed7b9 = (blueprints)=>({
        type: $72c52226d41c2550$export$35546514045d3ef6,
        payload: blueprints
    });
const $72c52226d41c2550$export$3add0fd96e0a0f94 = 'UPDATE_CONFLUENCE_SPACES';
const $72c52226d41c2550$export$af25752520107849 = (confluenceSpaces)=>({
        type: $72c52226d41c2550$export$3add0fd96e0a0f94,
        payload: confluenceSpaces
    });
const $72c52226d41c2550$export$642f8c42c3174bb3 = 'UPDATE_CONFLUENCE_STATE';
const $72c52226d41c2550$export$4945c781e256866 = 'UPDATE_CONFLUENCE_EDITION';
const $72c52226d41c2550$export$d249ebe59cef7fd0 = 'UPDATE_JSW_EDITION';
const $72c52226d41c2550$export$f0daa551fdf516de = (confluenceState)=>({
        type: $72c52226d41c2550$export$642f8c42c3174bb3,
        payload: confluenceState
    });
const $72c52226d41c2550$export$fcd065f821290c09 = (confluenceEdition)=>({
        type: $72c52226d41c2550$export$4945c781e256866,
        payload: confluenceEdition
    });
const $72c52226d41c2550$export$843be94842235022 = (jswEdition)=>({
        type: $72c52226d41c2550$export$d249ebe59cef7fd0,
        payload: jswEdition
    });
const $72c52226d41c2550$export$b5f26e81b011310 = 'UPDATE_PROJECT_SPACE_LINK';
const $72c52226d41c2550$export$9d63c755cd3b59d4 = (spaceKey, linkedPageId)=>({
        type: $72c52226d41c2550$export$b5f26e81b011310,
        spaceKey: spaceKey,
        linkedPageId: linkedPageId
    });
const $72c52226d41c2550$export$c774daa37662a6e2 = 'UPDATE_SPACE_NAME';
const $72c52226d41c2550$export$f5c0413e2566c026 = (userEnteredSpaceName)=>({
        type: $72c52226d41c2550$export$c774daa37662a6e2,
        userEnteredSpaceName: userEnteredSpaceName
    });
const $72c52226d41c2550$export$910d1d3b9b49d47f = 'UPDATE_SUGGESTED_KEY';
const $72c52226d41c2550$export$5bf0de5eee5cf319 = (key)=>({
        type: $72c52226d41c2550$export$910d1d3b9b49d47f,
        key: key
    });
const $72c52226d41c2550$export$56a6b0eafd2ee646 = 'SUCCESSFULLY_CONNECTED_SPACE';
const $72c52226d41c2550$export$5fe667e6e7e6ce92 = (connectedSpaceName, isConnectedToPage, isConnectedToLiveDoc)=>({
        type: $72c52226d41c2550$export$56a6b0eafd2ee646,
        connectedSpaceName: connectedSpaceName,
        isConnectedToPage: isConnectedToPage,
        isConnectedToLiveDoc: isConnectedToLiveDoc
    });
const $72c52226d41c2550$export$c6f909e212a85e8 = 'SHOW_ACTIVATION_ERROR_FLAG';
const $72c52226d41c2550$export$aa7e0797d3fa2965 = ()=>({
        type: $72c52226d41c2550$export$c6f909e212a85e8
    });
const $72c52226d41c2550$export$5973607600a0786d = 'SHOW_ERROR';
const $72c52226d41c2550$export$3879b24e8245693d = ()=>({
        type: $72c52226d41c2550$export$5973607600a0786d
    });
const $72c52226d41c2550$export$2dd037467821974b = 'DISMISS_SUCCESS_FLAG';
const $72c52226d41c2550$export$f6370a49e43e0576 = ()=>({
        type: $72c52226d41c2550$export$2dd037467821974b
    });
const $72c52226d41c2550$export$3cd97e75ca3b9296 = 'DISMISS_ERROR';
const $72c52226d41c2550$export$c1844e841b0106f7 = ()=>({
        type: $72c52226d41c2550$export$3cd97e75ca3b9296
    });
const $72c52226d41c2550$export$960a68c7ad7aa3a = 'DISMISS_ACTIVATION_ERROR_FLAG';
const $72c52226d41c2550$export$d336837fff09d47f = ()=>({
        type: $72c52226d41c2550$export$960a68c7ad7aa3a
    });
const $72c52226d41c2550$export$cfc13953d69f0001 = 'SUCCESSFULLY_REQUESTED_ACCESS';
const $72c52226d41c2550$export$e1dc4a56133b3011 = (payload)=>({
        type: $72c52226d41c2550$export$cfc13953d69f0001,
        payload: payload
    });
const $72c52226d41c2550$export$996348d031105c73 = 'FETCH_CONFLUENCE_ACCESS_REQUEST_CAPABILITIES';
const $72c52226d41c2550$export$448a117797b4db5f = ()=>({
        type: $72c52226d41c2550$export$996348d031105c73
    });
const $72c52226d41c2550$export$75e62da1cc0402ef = 'INLINE_JOIN_CONFLUENCE';
const $72c52226d41c2550$export$62909a668caf4055 = ()=>({
        type: $72c52226d41c2550$export$75e62da1cc0402ef
    });
const $72c52226d41c2550$export$db3820748244cc8b = 'INLINE_JOIN_FAILED';
const $72c52226d41c2550$export$15ba59499cf4c67 = ()=>({
        type: $72c52226d41c2550$export$db3820748244cc8b
    });
const $72c52226d41c2550$export$18cedb2141f6d92b = 'UPDATE_CONFLUENCE_ACCESS_REQUEST_CAPABILITIES';
const $72c52226d41c2550$export$d9296536f93a8e55 = (capability)=>({
        type: $72c52226d41c2550$export$18cedb2141f6d92b,
        capability: capability
    });
const $72c52226d41c2550$export$b354c67a4077ba9c = 'FETCH_CONFLUENCE_COLLABORATORS';
const $72c52226d41c2550$export$7a04b158659a6a5e = ()=>({
        type: $72c52226d41c2550$export$b354c67a4077ba9c
    });
const $72c52226d41c2550$export$868df1522dd01363 = 'UPDATE_CONFLUENCE_COLLABORATORS';
const $72c52226d41c2550$export$1f606a1ee0a12a77 = (users)=>({
        type: $72c52226d41c2550$export$868df1522dd01363,
        users: users
    });
const $72c52226d41c2550$export$6a5d0396986b2002 = 'FETCH_CONNECTED_SPACE_OR_PAGE_TITLE';
const $72c52226d41c2550$export$2682af34eb3aa1e3 = ()=>({
        type: $72c52226d41c2550$export$6a5d0396986b2002
    });
const $72c52226d41c2550$export$c044983cd2f9624c = 'FETCH_CONNECTED_SPACE';
const $72c52226d41c2550$export$b18ea8549fbce2f = (spaceKey)=>({
        type: $72c52226d41c2550$export$c044983cd2f9624c,
        spaceKey: spaceKey
    });
const $72c52226d41c2550$export$bcdcc308c5deb22f = 'UPDATE_CONFLUENCE_SPACE_CONNECTION_STATE';
const $72c52226d41c2550$export$e5b6b4f53362d4fc = (connectionState)=>({
        type: $72c52226d41c2550$export$bcdcc308c5deb22f,
        connectionState: connectionState
    });
const $72c52226d41c2550$export$b4e21ab2a8049f3a = 'UPDATE_CONNECTED_SPACE_OR_PAGE_CONTENT';
const $72c52226d41c2550$export$721e32cdead77c18 = ({ spaceId: spaceId, title: title, isConnectedToPage: isConnectedToPage, isConnectedToLiveDoc: isConnectedToLiveDoc, url: url, projectSpacePageTitleHasBeenFetched: projectSpacePageTitleHasBeenFetched, iconUrl: iconUrl, pageId: pageId })=>({
        spaceId: spaceId,
        type: $72c52226d41c2550$export$b4e21ab2a8049f3a,
        title: title,
        url: url,
        isConnectedToPage: isConnectedToPage,
        isConnectedToLiveDoc: isConnectedToLiveDoc,
        projectSpacePageTitleHasBeenFetched: projectSpacePageTitleHasBeenFetched,
        iconUrl: iconUrl,
        pageId: pageId
    });
const $72c52226d41c2550$export$99a8dcf38de45a88 = 'FETCH_JIRA_PROJECT_PERMISSIONS';
const $72c52226d41c2550$export$2a09832034358a97 = ()=>({
        type: $72c52226d41c2550$export$99a8dcf38de45a88
    });

});

parcelRegister("eg01Z", function(module, exports) {

$parcel$export(module.exports, "INITIALIZE_VIEW", () => $f222d414869b0d82$export$6ff5d8ee39b8d7c7);
$parcel$export(module.exports, "initializeView", () => $f222d414869b0d82$export$28b89ff8ea962a50);
const $f222d414869b0d82$export$6ff5d8ee39b8d7c7 = 'INITIALIZE_VIEW';
const $f222d414869b0d82$export$28b89ff8ea962a50 = ()=>({
        type: $f222d414869b0d82$export$6ff5d8ee39b8d7c7
    });

});

parcelRegister("9MB7L", function(module, exports) {

$parcel$export(module.exports, "isSiteAdmin", () => $e8a754dd9a53b772$export$3937e302382c1add);
$parcel$export(module.exports, "getCloudId", () => $e8a754dd9a53b772$export$fdd2c0ba94025c3c);
$parcel$export(module.exports, "getAccountId", () => $e8a754dd9a53b772$export$c1e0336bde96e2dc);
$parcel$export(module.exports, "getOrigin", () => $e8a754dd9a53b772$export$5a759dc7a1cfb72a);
$parcel$export(module.exports, "getConfluenceState", () => $e8a754dd9a53b772$export$34d7071b87580de5);
$parcel$export(module.exports, "getSuggestedKey", () => $e8a754dd9a53b772$export$a9b8464ee6c5051e);
$parcel$export(module.exports, "getParentProduct", () => $e8a754dd9a53b772$export$e873edb2560a07ef);

var $fTJXm = parcelRequire("fTJXm");
const $e8a754dd9a53b772$export$31553aaa555c1514 = (state)=>state.context;
const $e8a754dd9a53b772$export$f654b28f82155665 = (state)=>state.context.baseUrl;
const $e8a754dd9a53b772$export$180605366c04f0cd = (state)=>state.context.locale;
const $e8a754dd9a53b772$export$fc970ed23da99565 = (state)=>state.context.isAdmin;
const $e8a754dd9a53b772$export$3937e302382c1add = (state)=>state.context.isSiteAdmin;
const $e8a754dd9a53b772$export$fdd2c0ba94025c3c = (state)=>state.context.cloudId;
const $e8a754dd9a53b772$export$c1e0336bde96e2dc = (state)=>state.context.accountId;
const $e8a754dd9a53b772$export$5a759dc7a1cfb72a = (state)=>state?.context?.origin || null;
const $e8a754dd9a53b772$export$34d7071b87580de5 = (state)=>state.context.confluenceState;
const $e8a754dd9a53b772$export$a9b8464ee6c5051e = (state)=>state.context.suggestedKey;
const $e8a754dd9a53b772$export$a22e881e6bf2a030 = (state)=>$e8a754dd9a53b772$export$34d7071b87580de5(state) === (0, $fTJXm.CONFLUENCE_ACTIVE);
const $e8a754dd9a53b772$export$57570b1603cf6adb = (state)=>state.context.environment;
const $e8a754dd9a53b772$export$e3b2eefe2a608e05 = (state)=>state.context.licenseInformation;
const $e8a754dd9a53b772$export$e873edb2560a07ef = (state)=>state.context.parentProduct;

});
parcelRegister("fTJXm", function(module, exports) {

$parcel$export(module.exports, "CONFLUENCE_LOADING", () => $14b8e6615aec21e2$export$33e529db1eae9509);
$parcel$export(module.exports, "CONFLUENCE_INACTIVE", () => $14b8e6615aec21e2$export$d678d0da8cb40d2d);
$parcel$export(module.exports, "CONFLUENCE_DEACTIVATED", () => $14b8e6615aec21e2$export$9ef8869caad736a1);
$parcel$export(module.exports, "CONFLUENCE_ACTIVE", () => $14b8e6615aec21e2$export$4542e1f28f48047);
$parcel$export(module.exports, "CONFLUENCE_ACTIVATING", () => $14b8e6615aec21e2$export$701136fece9e2d4e);
$parcel$export(module.exports, "CONFLUENCE_EXPIRED", () => $14b8e6615aec21e2$export$110475fcfacac90b);
$parcel$export(module.exports, "CONFLUENCE_ERROR", () => $14b8e6615aec21e2$export$ce51dd384a6f10ed);
$parcel$export(module.exports, "ProductKeys", () => $14b8e6615aec21e2$export$ef2c0ffddaaaf76c);
const $14b8e6615aec21e2$export$33e529db1eae9509 = 'CONFLUENCE_LOADING';
const $14b8e6615aec21e2$export$d678d0da8cb40d2d = 'CONFLUENCE_INACTIVE';
const $14b8e6615aec21e2$export$9ef8869caad736a1 = 'CONFLUENCE_DEACTIVATED';
const $14b8e6615aec21e2$export$4542e1f28f48047 = 'CONFLUENCE_ACTIVE';
const $14b8e6615aec21e2$export$701136fece9e2d4e = 'CONFLUENCE_ACTIVATING';
const $14b8e6615aec21e2$export$110475fcfacac90b = 'CONFLUENCE_EXPIRED';
const $14b8e6615aec21e2$export$ce51dd384a6f10ed = 'CONFLUENCE_ERROR';
const $14b8e6615aec21e2$export$e69af2c4378638a2 = 'free';
const $14b8e6615aec21e2$export$7bc7dd5faba7ad6b = 'standard';
const $14b8e6615aec21e2$export$3fd0bbb8c68dc4c7 = 'premium';
const $14b8e6615aec21e2$export$88ff5aec29d74e90 = 'enterprise';
var $14b8e6615aec21e2$export$869044b313ebefcc = /*#__PURE__*/ function(ProductLicensingState) {
    ProductLicensingState["ACTIVE"] = "ACTIVE";
    ProductLicensingState["ACTIVATING"] = "ACTIVATING";
    ProductLicensingState["INACTIVE"] = "INACTIVE";
    ProductLicensingState["DEACTIVATED"] = "DEACTIVATED";
    return ProductLicensingState;
}({});
var $14b8e6615aec21e2$export$ef2c0ffddaaaf76c = /*#__PURE__*/ function(ProductKeys) {
    ProductKeys["CONFLUENCE"] = "confluence.ondemand";
    ProductKeys["JIRA_CORE"] = "jira-core.ondemand";
    ProductKeys["JIRA_SERVICE_DESK"] = "jira-servicedesk.ondemand";
    ProductKeys["JIRA_SOFTWARE"] = "jira-software.ondemand";
    ProductKeys["TRELLO"] = "trello";
    ProductKeys["OPSGENIE"] = "opsgenie";
    ProductKeys["BITBUCKET"] = "bitbucket.ondemand";
    ProductKeys["STATUSPAGE"] = "statuspage";
    ProductKeys["TOWNSQUARE"] = "townsquare";
    return ProductKeys;
}({});

});


parcelRegister("9ucmj", function(module, exports) {

$parcel$export(module.exports, "isSpaceHomePageNull", () => $257ece7de478cf1a$export$646f21b73f12650);
$parcel$export(module.exports, "isPageHomePageNull", () => $257ece7de478cf1a$export$3a390e14f9c6d2ae);
$parcel$export(module.exports, "getConfluenceLicenseStatus", () => $257ece7de478cf1a$export$18a481a6de61c404);
$parcel$export(module.exports, "getIsPostExpand", () => $257ece7de478cf1a$export$35f86e486ebae26b);

var $jhbRM = parcelRequire("jhbRM");


var $8pKu0 = parcelRequire("8pKu0");

var $9MB7L = parcelRequire("9MB7L");

var $fTJXm = parcelRequire("fTJXm");

const $257ece7de478cf1a$export$67214a67db0792b3 = (state)=>state.context.confluenceState === (0, $fTJXm.CONFLUENCE_INACTIVE) || state.context.confluenceState === (0, $fTJXm.CONFLUENCE_DEACTIVATED);
const $257ece7de478cf1a$export$1406596cde1d72d8 = (state)=>state.context.confluenceState === (0, $fTJXm.CONFLUENCE_ACTIVATING);
const $257ece7de478cf1a$export$14f7f59d0be6078b = (state)=>state.context.confluenceState === (0, $fTJXm.CONFLUENCE_ACTIVE) && state.confluence.connectedSpace.connectionState === (0, $49cd111a962d9af5$export$4c83162cd5864fb8);
const $257ece7de478cf1a$export$646f21b73f12650 = (state)=>state.context.confluenceState === (0, $fTJXm.CONFLUENCE_ACTIVE) && state.confluence.connectedSpace.connectionState === (0, $49cd111a962d9af5$export$1a9cf3a686991f62) && state.confluence.connectedSpace.projectSpacePageTitleHasBeenFetched && state.confluence.connectedSpace.projectSpacePageTitle === null && state.confluence.connectedSpace.projectPageLinkedId === null;
const $257ece7de478cf1a$export$3a390e14f9c6d2ae = (state)=>state.context.confluenceState === (0, $fTJXm.CONFLUENCE_ACTIVE) && state.confluence.connectedSpace.connectionState === (0, $49cd111a962d9af5$export$1a9cf3a686991f62) && state.confluence.connectedSpace.projectSpacePageTitleHasBeenFetched && state.confluence.connectedSpace.projectSpacePageTitle === null && state.confluence.connectedSpace.projectPageLinkedId !== null;
const $257ece7de478cf1a$export$c67fbce9d0b9ccb6 = (state)=>state.confluence.connectedSpace.connectionState === (0, $49cd111a962d9af5$export$1a9cf3a686991f62) && state.context.confluenceState === (0, $fTJXm.CONFLUENCE_ACTIVE);
const $257ece7de478cf1a$export$3ed197ee58985de5 = (state)=>state.context.confluenceState === (0, $fTJXm.CONFLUENCE_ERROR) || state.context.confluenceState === (0, $fTJXm.CONFLUENCE_EXPIRED);
const $257ece7de478cf1a$export$f153181262b16ee6 = (state)=>state.confluence.connectedSpace.connectionState === (0, $49cd111a962d9af5$export$103bedf43ba882db);
const $257ece7de478cf1a$export$18a481a6de61c404 = (state)=>{
    const activationStatus = (0, $jhbRM.getActivationStatus)(state);
    if (activationStatus === 'activating') return 0, $0988c9725597fab5$export$ed9dbaba8445f424;
    if ($257ece7de478cf1a$export$67214a67db0792b3(state)) return 0, $0988c9725597fab5$export$beb27109f0387267;
    const userHasConfluenceAccess = (0, $8pKu0.doesUserHaveConfluenceAccess)(state);
    if (userHasConfluenceAccess === undefined) // until we know whether a user has access to confluence, don't try to render anything
    return 0, $0988c9725597fab5$export$bde25b564fc94248;
    else if (userHasConfluenceAccess === false) return 0, $0988c9725597fab5$export$52022723d6fe5666;
    if ($257ece7de478cf1a$export$1406596cde1d72d8(state)) return 0, $0988c9725597fab5$export$22ad4d38ecffca72;
    if ($257ece7de478cf1a$export$14f7f59d0be6078b(state)) return 0, $0988c9725597fab5$export$e74e627186613bef;
    if ($257ece7de478cf1a$export$646f21b73f12650(state)) return 0, $0988c9725597fab5$export$f603e10769c22ef6;
    if ($257ece7de478cf1a$export$3a390e14f9c6d2ae(state)) return 0, $0988c9725597fab5$export$396960dbbf8fe6e1;
    if ($257ece7de478cf1a$export$c67fbce9d0b9ccb6(state)) return 0, $0988c9725597fab5$export$2f82131be5023f37;
    if ($257ece7de478cf1a$export$3ed197ee58985de5(state)) return 0, $0988c9725597fab5$export$65d0a606bcce00e6;
    if ($257ece7de478cf1a$export$f153181262b16ee6(state)) return 0, $0988c9725597fab5$export$98cc058279f6e82f;
    return 0, $0988c9725597fab5$export$5a0e72a8258542bd;
};
const $257ece7de478cf1a$export$7d65532d8ecf8068 = (state)=>state.ui;
const $257ece7de478cf1a$export$35f86e486ebae26b = (state, hasConfluence)=>{
    // if confluence state gives us a clear answer, use that
    switch((0, $9MB7L.getConfluenceState)(state)){
        case 0, $fTJXm.CONFLUENCE_ACTIVE:
        case 0, $fTJXm.CONFLUENCE_ACTIVATING:
            return true;
        case 0, $fTJXm.CONFLUENCE_DEACTIVATED:
        case 0, $fTJXm.CONFLUENCE_EXPIRED:
        case 0, $fTJXm.CONFLUENCE_INACTIVE:
            return false;
        default:
            // otherwise (state = loading or error), rely on the supplied prop from Jira
            return hasConfluence;
    }
};

});
parcelRegister("jhbRM", function(module, exports) {

$parcel$export(module.exports, "getActivationStatus", () => $6ef2f31de4e3ce70$export$f83700fde4ece7e8);
$parcel$export(module.exports, "getActivationMethod", () => $6ef2f31de4e3ce70$export$47a02b64ca588fb8);
$parcel$export(module.exports, "isActivationMethodDetermined", () => $6ef2f31de4e3ce70$export$bbb567931044e99d);
$parcel$export(module.exports, "activationStatusRetryCount", () => $6ef2f31de4e3ce70$export$f3454041f580301a);
$parcel$export(module.exports, "isConfluenceActivationCompleteForPreselectedTemplate", () => $6ef2f31de4e3ce70$export$b7cdb7448850d3b5);

var $cEp5g = parcelRequire("cEp5g");

var $hlqmZ = parcelRequire("hlqmZ");

const $6ef2f31de4e3ce70$export$87e04069ced1cebb = (state)=>state.activation;
const $6ef2f31de4e3ce70$export$f83700fde4ece7e8 = (state)=>$6ef2f31de4e3ce70$export$87e04069ced1cebb(state).status;
const $6ef2f31de4e3ce70$export$47a02b64ca588fb8 = (state)=>{
    switch($6ef2f31de4e3ce70$export$f83700fde4ece7e8(state)){
        case 'activating':
        case 'allowed':
            return 'integrated';
        case 'not-started':
            return 'loading';
        case 'completed':
        case 'error':
        case 'not-allowed':
        default:
            return 'modal';
    }
};
const $6ef2f31de4e3ce70$export$bbb567931044e99d = (state)=>$6ef2f31de4e3ce70$export$47a02b64ca588fb8(state) !== 'loading';
const $6ef2f31de4e3ce70$export$f3454041f580301a = (state)=>$6ef2f31de4e3ce70$export$87e04069ced1cebb(state).retryCount;
const $6ef2f31de4e3ce70$export$9bab1e2e467860a = (state)=>state.activation.userInitiated;
const $6ef2f31de4e3ce70$export$b7cdb7448850d3b5 = (state)=>{
    const status = $6ef2f31de4e3ce70$export$f83700fde4ece7e8(state);
    const userInitiated = $6ef2f31de4e3ce70$export$9bab1e2e467860a(state);
    const spaceKey = (0, $cEp5g.getProjectSpaceKey)(state);
    const templatesToShow = (0, $hlqmZ.getTemplatesToShow)(state);
    return status === 'completed' && userInitiated && spaceKey !== null && templatesToShow === (0, $fb9ca2652bc018ab$export$3cbf6ffeca115be3);
};

});
parcelRegister("cEp5g", function(module, exports) {

$parcel$export(module.exports, "getConnectedSpace", () => $2831d1b27a710dfd$export$ac45ebe2b54867fe);
$parcel$export(module.exports, "getBlueprintsState", () => $2831d1b27a710dfd$export$4c6a4429feb04f4f);
$parcel$export(module.exports, "getBlueprints", () => $2831d1b27a710dfd$export$1dca7dd1d5604f2c);
$parcel$export(module.exports, "getConnectionState", () => $2831d1b27a710dfd$export$93a0230e8a62bcf5);
$parcel$export(module.exports, "getProjectSpaceKey", () => $2831d1b27a710dfd$export$31514e1d1dc386f7);
$parcel$export(module.exports, "getConnectedSpaceOrPageTitle", () => $2831d1b27a710dfd$export$a76f36600fd6d921);
$parcel$export(module.exports, "getConnectedSpaceOrPageUrl", () => $2831d1b27a710dfd$export$979c567300794ce3);
$parcel$export(module.exports, "getProjectPageLinkedId", () => $2831d1b27a710dfd$export$cf793c89a0c16d51);
$parcel$export(module.exports, "getIsConnectedToPage", () => $2831d1b27a710dfd$export$8062d4f2391d5856);
$parcel$export(module.exports, "getIsConnectedToLiveDoc", () => $2831d1b27a710dfd$export$bf500071ffebcb1f);
$parcel$export(module.exports, "getProjectSpaceIcon", () => $2831d1b27a710dfd$export$853da650555a02bc);
$parcel$export(module.exports, "getProjectSpaceId", () => $2831d1b27a710dfd$export$cbf857d98845c8ab);
$parcel$export(module.exports, "getProjectSpacePageTitleHasBeenFetched", () => $2831d1b27a710dfd$export$486075bda46e01fa);
$parcel$export(module.exports, "isSpaceConnected", () => $2831d1b27a710dfd$export$ed44960edb45ecd);
$parcel$export(module.exports, "getConfluenceEdition", () => $2831d1b27a710dfd$export$777a279710b4717f);
$parcel$export(module.exports, "getJswEdition", () => $2831d1b27a710dfd$export$3b594b2bb25495df);

var $hlqmZ = parcelRequire("hlqmZ");


const $2831d1b27a710dfd$export$ac45ebe2b54867fe = (state)=>state.confluence.connectedSpace;
const $2831d1b27a710dfd$export$4c6a4429feb04f4f = (state)=>state.confluence.connectedSpace.blueprintsState;
const $2831d1b27a710dfd$export$1dca7dd1d5604f2c = (state)=>(0, $hlqmZ.getTemplatesToShow)(state) === (0, $fb9ca2652bc018ab$export$3cbf6ffeca115be3) ? state.confluence.connectedSpace.blueprints || (0, $hlqmZ.getDefaultBlueprints)(state) : (0, $hlqmZ.getDefaultBlueprints)(state);
const $2831d1b27a710dfd$export$93a0230e8a62bcf5 = (state)=>state.confluence.connectedSpace.connectionState;
const $2831d1b27a710dfd$export$31514e1d1dc386f7 = (state)=>state.confluence.connectedSpace.projectSpaceKey;
const $2831d1b27a710dfd$export$a76f36600fd6d921 = (state)=>state.confluence.connectedSpace.projectSpacePageTitle;
const $2831d1b27a710dfd$export$979c567300794ce3 = (state)=>state.confluence.connectedSpace.projectSpacePageUrl;
const $2831d1b27a710dfd$export$cf793c89a0c16d51 = (state)=>state.confluence.connectedSpace.projectPageLinkedId;
const $2831d1b27a710dfd$export$8062d4f2391d5856 = (state)=>state.confluence.connectedSpace.projectIsConnectedToPage;
const $2831d1b27a710dfd$export$bf500071ffebcb1f = (state)=>state.confluence.connectedSpace.projectIsConnectedToLiveDoc;
const $2831d1b27a710dfd$export$853da650555a02bc = (state)=>state.confluence.connectedSpace.projectSpaceIcon;
const $2831d1b27a710dfd$export$cbf857d98845c8ab = (state)=>state.confluence.connectedSpace.projectSpaceId;
const $2831d1b27a710dfd$export$486075bda46e01fa = (state)=>state.confluence.connectedSpace.projectSpacePageTitleHasBeenFetched;
const $2831d1b27a710dfd$export$ed44960edb45ecd = (state)=>$2831d1b27a710dfd$export$93a0230e8a62bcf5(state) === (0, $49cd111a962d9af5$export$1a9cf3a686991f62);
const $2831d1b27a710dfd$export$777a279710b4717f = (state)=>state.context.confluenceEdition;
const $2831d1b27a710dfd$export$3b594b2bb25495df = (state)=>state.context.jswEdition;

});
parcelRegister("hlqmZ", function(module, exports) {

$parcel$export(module.exports, "getDefaultBlueprints", () => $fa5eb3adb965b7df$export$db52c73ad41e40f7);
$parcel$export(module.exports, "getTemplatesToShow", () => $fa5eb3adb965b7df$export$d6086b2ac208694f);
$parcel$export(module.exports, "areTemplatesEnabled", () => $fa5eb3adb965b7df$export$152293483cf81db3);


var $fTJXm = parcelRequire("fTJXm");


var $9ucmj = parcelRequire("9ucmj");

const $fa5eb3adb965b7df$var$forceTemplatesDisabled = (state)=>(0, $9ucmj.getConfluenceLicenseStatus)(state) === (0, $0988c9725597fab5$export$52022723d6fe5666);
const $fa5eb3adb965b7df$export$db52c73ad41e40f7 = (state)=>state.ui.blueprints.defaultBlueprints;
const $fa5eb3adb965b7df$export$d6086b2ac208694f = (state)=>{
    if (state.context.confluenceState === (0, $fTJXm.CONFLUENCE_LOADING) || state.confluence.connectedSpace.connectionState === (0, $49cd111a962d9af5$export$26d55645375ca9a) || state.confluence.connectedSpace.blueprintsState === (0, $49cd111a962d9af5$export$26d55645375ca9a)) return 0, $fb9ca2652bc018ab$export$2050e0d4d0f39e8a;
    if (state.confluence.connectedSpace.blueprintsState === (0, $49cd111a962d9af5$export$c6813a8d51f77eaf)) return 0, $fb9ca2652bc018ab$export$3cbf6ffeca115be3;
    return 0, $fb9ca2652bc018ab$export$2050e0d4d0f39e8a;
};
const $fa5eb3adb965b7df$export$152293483cf81db3 = (state)=>state.context.confluenceState === (0, $fTJXm.CONFLUENCE_INACTIVE) || state.context.confluenceState === (0, $fTJXm.CONFLUENCE_DEACTIVATED) || state.confluence.connectedSpace.blueprintsState === (0, $49cd111a962d9af5$export$c6813a8d51f77eaf) || state.context.confluenceState === (0, $fTJXm.CONFLUENCE_ACTIVE) && state.confluence.connectedSpace.connectionState === (0, $49cd111a962d9af5$export$4c83162cd5864fb8) && !$fa5eb3adb965b7df$var$forceTemplatesDisabled;

});
const $49cd111a962d9af5$export$c6813a8d51f77eaf = 'OK';
const $49cd111a962d9af5$export$26d55645375ca9a = 'LOADING';
const $49cd111a962d9af5$export$a3269a3914b007e3 = 'FORBIDDEN';
const $49cd111a962d9af5$export$1cc76b53f23597de = 'DELETED';
const $49cd111a962d9af5$export$103bedf43ba882db = 'ERROR';
const $49cd111a962d9af5$export$1a9cf3a686991f62 = 'CONNECTED';
const $49cd111a962d9af5$export$4c83162cd5864fb8 = 'NOT_CONNECTED';
const $49cd111a962d9af5$export$78244dbb77cfa6b6 = 'UNKNOWN';

const $fb9ca2652bc018ab$export$3cbf6ffeca115be3 = 'TEMPLATES_REAL_LIST';
const $fb9ca2652bc018ab$export$2050e0d4d0f39e8a = 'TEMPLATES_DEFAULT_LIST';

const $0988c9725597fab5$export$5a0e72a8258542bd = 'CONFTREE_PLACEHOLDER';
const $0988c9725597fab5$export$beb27109f0387267 = 'CONFTREE_CROSS_SELL';
const $0988c9725597fab5$export$22ad4d38ecffca72 = 'CONFTREE_CONFLUENCE_ACTIVATING';
const $0988c9725597fab5$export$e74e627186613bef = 'CONFTREE_CONNECT_SPACE';
const $0988c9725597fab5$export$2f82131be5023f37 = 'CONFTREE_DISPLAY_PAGETREE';
const $0988c9725597fab5$export$65d0a606bcce00e6 = 'CONFTREE_ERROR';
const $0988c9725597fab5$export$52022723d6fe5666 = 'CONFTREE_NO_ACCESS_TEASER';
const $0988c9725597fab5$export$bde25b564fc94248 = 'CONFTREE_ACCESS_LOADING';
const $0988c9725597fab5$export$f603e10769c22ef6 = 'CONFTREE_SPACE_NOT_FOUND';
const $0988c9725597fab5$export$396960dbbf8fe6e1 = 'CONFTREE_PAGE_NOT_FOUND';
const $0988c9725597fab5$export$98cc058279f6e82f = 'CONFLUENCE_CONNECTION_BROKEN';
const $0988c9725597fab5$export$ed9dbaba8445f424 = 'CONFTREE_CONFLUENCE_ACTIVATING_ONDEMAND';




parcelRegister("8pKu0", function(module, exports) {

$parcel$export(module.exports, "doesUserHaveConfluenceAccess", () => $d3e96bf7ac8b44aa$export$6206363f18b5406c);

const $d3e96bf7ac8b44aa$export$6206363f18b5406c = (state)=>state.confluence.user.access !== (0, $4af2e72ebaa388c6$export$26d55645375ca9a) && state.confluence.user.access !== (0, $4af2e72ebaa388c6$export$78244dbb77cfa6b6) ? state.confluence.user.access !== (0, $4af2e72ebaa388c6$export$a3269a3914b007e3) : undefined;

});
const $4af2e72ebaa388c6$export$78244dbb77cfa6b6 = 'UNKNOWN';
const $4af2e72ebaa388c6$export$26d55645375ca9a = 'LOADING';
const $4af2e72ebaa388c6$export$c6813a8d51f77eaf = 'OK';
const $4af2e72ebaa388c6$export$a3269a3914b007e3 = 'FORBIDDEN';



parcelRegister("4DJ1q", function(module, exports) {

$parcel$export(module.exports, "default", () => $91e58c59f9a96e36$export$2e2bcd8739ae039);

var $7Z8iG = parcelRequire("7Z8iG");

var $2ja74 = parcelRequire("2ja74");

var $7kdXN = parcelRequire("7kdXN");

var $f5mRw = parcelRequire("f5mRw");

var $bTJtJ = parcelRequire("bTJtJ");

var $cMf5W = parcelRequire("cMf5W");
const $91e58c59f9a96e36$var$mapStateToProps = (state)=>({
        Header: $bTJtJ.default,
        Content: $7kdXN.default,
        Footer: $f5mRw.default,
        isOpen: (0, $2ja74.isConnectSpaceDialogOpen)(state)
    });
var $91e58c59f9a96e36$export$2e2bcd8739ae039 = (0, $7Z8iG.connect)($91e58c59f9a96e36$var$mapStateToProps)((0, $cMf5W.default));

});
parcelRegister("2ja74", function(module, exports) {

$parcel$export(module.exports, "getConnectSpaceDialogErrorState", () => $1e36b6bea0d45d6d$export$c73f884b9b688b51);
$parcel$export(module.exports, "getSelectedSpace", () => $1e36b6bea0d45d6d$export$8c50b65fa38d42d1);
$parcel$export(module.exports, "isConnectingSpace", () => $1e36b6bea0d45d6d$export$b070128a7b7bf204);
$parcel$export(module.exports, "isConnectSpaceDialogOpen", () => $1e36b6bea0d45d6d$export$d0660dc76452a62b);
$parcel$export(module.exports, "isSubmitAllowed", () => $1e36b6bea0d45d6d$export$77e706a05fb8b3f5);
$parcel$export(module.exports, "isDisconnectedTemplatesClick", () => $1e36b6bea0d45d6d$export$4eb4b37d0696f31f);
const $1e36b6bea0d45d6d$export$c73f884b9b688b51 = (state)=>state.ui.connectSpaceDialog.connectSpaceDialogErrorState;
const $1e36b6bea0d45d6d$export$8c50b65fa38d42d1 = (state)=>state.ui.connectSpaceDialog.selectedSpace;
const $1e36b6bea0d45d6d$export$b070128a7b7bf204 = (state)=>state.ui.connectSpaceDialog.connectingSpace;
const $1e36b6bea0d45d6d$export$d0660dc76452a62b = (state)=>state.ui.connectSpaceDialog.connectSpaceDialogOpen;
const $1e36b6bea0d45d6d$export$77e706a05fb8b3f5 = (state)=>state.ui.connectSpaceDialog.selectedSpace !== null;
const $1e36b6bea0d45d6d$export$4eb4b37d0696f31f = (state)=>state.ui.connectSpaceDialog.disconnectedTemplatesClick;

});

parcelRegister("7kdXN", function(module, exports) {

$parcel$export(module.exports, "default", () => $c55e701e75227f1d$export$2e2bcd8739ae039);

var $7Z8iG = parcelRequire("7Z8iG");

var $aPZf4 = parcelRequire("aPZf4");

var $5Fk2n = parcelRequire("5Fk2n");

var $3ztJE = parcelRequire("3ztJE");

var $6oKBx = parcelRequire("6oKBx");
const $c55e701e75227f1d$var$mapStateToProps = ()=>({
        SpacePicker: // @ts-ignore - Type '(value: SpacePickerOptionValue, analyticsEvent: UIAnalyticsEvent) => void' is not assignable to type '(value: SpacePickerOptionValue) => void'
        // This was added when enrolling `@atlassiansox/project-pages` into JFE local consumption
        $3ztJE.default,
        CreateSpaceLink: $5Fk2n.default
    });
const $c55e701e75227f1d$var$dispatch = (dispatch)=>({
        onSpaceSelected: (value)=>dispatch((0, $aPZf4.setSelectedSpace)(value)),
        onCreateSpace: ()=>dispatch((0, $aPZf4.showCreateSpaceDialog)())
    });
var $c55e701e75227f1d$export$2e2bcd8739ae039 = (0, $7Z8iG.connect)($c55e701e75227f1d$var$mapStateToProps, $c55e701e75227f1d$var$dispatch)((0, $6oKBx.default));

});
parcelRegister("5Fk2n", function(module, exports) {

$parcel$export(module.exports, "default", () => $ddc171241ff4f59f$export$2e2bcd8739ae039);

var $7Z8iG = parcelRequire("7Z8iG");

var $2ja74 = parcelRequire("2ja74");

var $1albu = parcelRequire("1albu");
var $ddc171241ff4f59f$export$2e2bcd8739ae039 = (0, $7Z8iG.connect)((state)=>({
        isConnectingSpace: (0, $2ja74.isConnectingSpace)(state)
    }), {})((0, $1albu.default));

});
parcelRegister("1albu", function(module, exports) {

$parcel$export(module.exports, "default", () => $7651a18606260fe4$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $8RXs9 = parcelRequire("8RXs9");

var $fVnbM = parcelRequire("fVnbM");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $fSs6o = parcelRequire("fSs6o");
const $7651a18606260fe4$var$containerStyles = (0, $8CUq3.xcss)({
    marginTop: 'space.100'
});
class $7651a18606260fe4$var$CreateSpaceLink extends (0, $5uXOq.PureComponent) {
    render() {
        const { intl: { formatMessage: formatMessage }, onCreateSpace: onCreateSpace, isConnectingSpace: isConnectingSpace } = this.props;
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dC5iT.default), {
            xcss: $7651a18606260fe4$var$containerStyles,
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fVnbM.default), {
                spacing: "none",
                // TODO: (from codemod) "link" and "subtle-link" appearances are only available in LinkButton, please either provide a href prop then migrate to LinkButton, or remove the appearance from the default button.
                appearance: "link",
                onClick: (_event, analyticsEvent)=>onCreateSpace(analyticsEvent),
                isDisabled: isConnectingSpace,
                "data-test-id": "confluence-project-pages.post-expand.connect-or-update-space-modal.create-space-link",
                children: formatMessage((0, $fSs6o.default).linkText)
            })
        });
    }
}
var $7651a18606260fe4$export$2e2bcd8739ae039 = (0, $8RXs9.default)($7651a18606260fe4$var$CreateSpaceLink);

});
parcelRegister("fSs6o", function(module, exports) {

$parcel$export(module.exports, "default", () => $46858a4cb39193f1$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $46858a4cb39193f1$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    linkText: {
        id: 'project-pages.granular-pages.connect-space-dialog.content.create-space-link.link-text',
        defaultMessage: 'Or create a new space',
        description: ''
    }
});

});



parcelRegister("3ztJE", function(module, exports) {

$parcel$export(module.exports, "default", () => $8c70c20847dc9280$export$2e2bcd8739ae039);

var $7Z8iG = parcelRequire("7Z8iG");

var $2ja74 = parcelRequire("2ja74");

var $1L2wm = parcelRequire("1L2wm");

var $9MB7L = parcelRequire("9MB7L");

var $6L3iv = parcelRequire("6L3iv");
var $8c70c20847dc9280$export$2e2bcd8739ae039 = (0, $7Z8iG.connect)((state)=>({
        isConnectingSpace: (0, $2ja74.isConnectingSpace)(state),
        isDisconnectedTemplatesClick: (0, $2ja74.isDisconnectedTemplatesClick)(state),
        cloudId: (0, $9MB7L.getCloudId)(state),
        projectId: (0, $6L3iv.getProjectId)(state),
        projectType: (0, $6L3iv.getProjectType)(state)
    }), {})((0, $1L2wm.default));

});
parcelRegister("1L2wm", function(module, exports) {

$parcel$export(module.exports, "default", () => $24430cc87db88eb7$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $8RXs9 = parcelRequire("8RXs9");

var $iCBcG = parcelRequire("iCBcG");

var $d7FF4 = parcelRequire("d7FF4");
var $bChGW = parcelRequire("bChGW");

var $k5uoT = parcelRequire("k5uoT");

var $i373d = parcelRequire("i373d");

var $crB07 = parcelRequire("crB07");

var $VSDnB = parcelRequire("VSDnB");

var $bBMvo = parcelRequire("bBMvo");

var $lCxMA = parcelRequire("lCxMA");

var $gMHWX = parcelRequire("gMHWX");
const $24430cc87db88eb7$var$Option = ({ children: children, ...props })=>//@ts-ignore react-select
    /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $bChGW.components).Option, {
        ...props,
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $i373d.IconWrapper), {
                children: props.value?.isPage ? props.value?.isLiveDoc && (0, $VSDnB.fg)('confluence_live_pages_enabled_in_jira') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $crB07.LiveDocIcon), {}) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $crB07.PageIcon), {}) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $crB07.SpaceIcon), {
                    iconPath: props.value?.iconPath
                })
            }),
            children
        ]
    });
const $24430cc87db88eb7$var$mapPageAndSpaceOptions = (spaceSearch, pageSearch)=>{
    const spaceOptions = spaceSearch?.scopes?.[0]?.results?.map(({ title: title, space: space, baseUrl: baseUrl, url: url, id: id })=>({
            label: title,
            value: {
                spaceId: Number(id),
                spaceKey: space?.key,
                spaceName: title,
                spaceUrl: `${baseUrl}${url}`,
                iconPath: `${baseUrl}${space?.icon?.path}`,
                isPage: false,
                isLiveDoc: false
            }
        }));
    const pageOptions = pageSearch?.results?.map(({ title: title, space: space, subType: subType, id: id, _links: _links })=>({
            label: title,
            value: {
                spaceId: space.id,
                spaceKey: space.key,
                spaceName: space.name,
                linkedPageId: id,
                linkedPageTitle: title,
                isPage: true,
                isLiveDoc: subType === 'live',
                linkedPageUrl: `${pageSearch._links?.base}${_links?.webui}`
            }
        }));
    return [
        {
            label: 'Spaces',
            options: spaceOptions
        },
        {
            label: 'Items',
            options: pageOptions
        }
    ];
};
const $24430cc87db88eb7$var$SPACES_MAX_RESULTS = 5;
const $24430cc87db88eb7$var$SpacePicker = ({ intl: { formatMessage: formatMessage }, onSelected: onSelected, isDisconnectedTemplatesClick: isDisconnectedTemplatesClick, isConnectingSpace: isConnectingSpace, cloudId: cloudId, projectId: projectId, projectType: projectType })=>{
    const [defaultOptions, setDefaultOptions] = (0, $5uXOq.useState)(true);
    const [defaultOptionsAreLoaded, setDefaultOptionsAreLoaded] = (0, $5uXOq.useState)(false);
    const fetchPageAndSpaceOptions = async (inputValue)=>{
        const pageSearch = await (0, $bBMvo.searchConfluencePages)(inputValue, projectId, projectType);
        let spaceSearch = await (0, $bBMvo.searchConfluenceSpaces)({
            cloudId: cloudId,
            limit: $24430cc87db88eb7$var$SPACES_MAX_RESULTS,
            searchString: inputValue
        });
        const options = $24430cc87db88eb7$var$mapPageAndSpaceOptions(spaceSearch, pageSearch);
        if (!defaultOptionsAreLoaded && !inputValue) {
            // Save initial results to return them when no input is passed
            setDefaultOptionsAreLoaded(true);
            setDefaultOptions(options);
        }
        return options;
    };
    const debouncedOptions = (0, (/*@__PURE__*/$parcel$interopDefault($iCBcG)))(fetchPageAndSpaceOptions, 300);
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $i373d.Container), {
        "data-test-id": "confluence-project-pages.post-expand.connect-or-update-space-modal.space-picker",
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $i373d.Instructions), {
                children: isDisconnectedTemplatesClick ? formatMessage((0, $lCxMA.default)['disconnected-templates-description']) : formatMessage((0, $lCxMA.default).description)
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $d7FF4.default), {
                // When AsyncSelect defaultOptions prop is set to `false`, `loadOptions` is called on render to populate defaultOptions.
                defaultOptions: defaultOptions,
                loadOptions: debouncedOptions,
                isSearchable: true,
                placeholder: formatMessage((0, $lCxMA.default).placeholder),
                isDisabled: isConnectingSpace,
                menuPortalTarget: document.body,
                label: formatMessage((0, $lCxMA.default).searchLabel),
                styles: {
                    menuPortal: (base)=>({
                            ...base,
                            zIndex: (0, $k5uoT.layers).modal()
                        }),
                    option: (base)=>({
                            ...base,
                            display: 'flex',
                            alignItems: 'center',
                            cursor: 'pointer'
                        })
                },
                components: {
                    Option: $24430cc87db88eb7$var$Option
                },
                onChange: (result, { action: action })=>{
                    if (result && action === 'select-option') {
                        const { value: value } = result;
                        onSelected(value);
                    }
                }
            })
        ]
    });
};
var $24430cc87db88eb7$export$2e2bcd8739ae039 = (0, $gMHWX.AnalyticsEventToProps)('spacePicker', {
    onSelected: 'selected'
})((0, $8RXs9.default)($24430cc87db88eb7$var$SpacePicker));

});
parcelRegister("iCBcG", function(module, exports) {
'use strict';
/* global setTimeout, clearTimeout */ module.exports = function debounce(fn) {
    var wait = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var lastCallAt = void 0;
    var deferred = void 0;
    var timer = void 0;
    var pendingArgs = [];
    return function debounced() {
        var currentWait = $d8e8a274648ab511$var$getWait(wait);
        var currentTime = new Date().getTime();
        var isCold = !lastCallAt || currentTime - lastCallAt > currentWait;
        lastCallAt = currentTime;
        for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        if (isCold && options.leading) return options.accumulate ? Promise.resolve(fn.call(this, [
            args
        ])).then(function(result) {
            return result[0];
        }) : Promise.resolve(fn.call.apply(fn, [
            this
        ].concat(args)));
        if (deferred) clearTimeout(timer);
        else deferred = $d8e8a274648ab511$var$defer();
        pendingArgs.push(args);
        timer = setTimeout(flush.bind(this), currentWait);
        if (options.accumulate) {
            var argsIndex = pendingArgs.length - 1;
            return deferred.promise.then(function(results) {
                return results[argsIndex];
            });
        }
        return deferred.promise;
    };
    function flush() {
        var thisDeferred = deferred;
        clearTimeout(timer);
        Promise.resolve(options.accumulate ? fn.call(this, pendingArgs) : fn.apply(this, pendingArgs[pendingArgs.length - 1])).then(thisDeferred.resolve, thisDeferred.reject);
        pendingArgs = [];
        deferred = null;
    }
};
function $d8e8a274648ab511$var$getWait(wait) {
    return typeof wait === 'function' ? wait() : wait;
}
function $d8e8a274648ab511$var$defer() {
    var deferred = {};
    deferred.promise = new Promise(function(resolve, reject) {
        deferred.resolve = resolve;
        deferred.reject = reject;
    });
    return deferred;
}

});

parcelRegister("i373d", function(module, exports) {

$parcel$export(module.exports, "Container", () => $2d07e649093b0e9a$export$42a852a2b6b56249);
$parcel$export(module.exports, "Instructions", () => $2d07e649093b0e9a$export$9e5bb8ba6c1f6b31);
$parcel$export(module.exports, "IconWrapper", () => $2d07e649093b0e9a$export$be58b4326e23250f);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $47bDC = parcelRequire("47bDC");
const $2d07e649093b0e9a$export$42a852a2b6b56249 = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "knf1vh-0"
})({
    margin: `${"var(--ds-space-100, 8px)"} 0 0`,
    display: 'flex',
    flexDirection: 'column'
});
const $2d07e649093b0e9a$export$9e5bb8ba6c1f6b31 = /*#__PURE__*/ (0, $47bDC.default).p.withConfig({
    componentId: "knf1vh-1"
})({
    margin: `0 0 ${"var(--ds-space-200, 16px)"}`
});
const $2d07e649093b0e9a$export$be58b4326e23250f = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "knf1vh-2"
})({
    marginRight: "var(--ds-space-100, 8px)"
});

});

parcelRegister("crB07", function(module, exports) {

$parcel$export(module.exports, "SpaceIcon", () => $d25d957bbbc82c9b$export$38ffce4a7986ba20);
$parcel$export(module.exports, "PageIcon", () => $d25d957bbbc82c9b$export$d1143dd23ca69d4e);
$parcel$export(module.exports, "LiveDocIcon", () => $d25d957bbbc82c9b$export$27ad0cb31a950e4c);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $47bDC = parcelRequire("47bDC");


var $liajA = parcelRequire("liajA");

var $4Atwu = parcelRequire("4Atwu");
const $d25d957bbbc82c9b$export$38ffce4a7986ba20 = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "b88vl8-0"
})((props)=>({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        backgroundImage: `url(${props.iconPath})`,
        backgroundColor: `var(--ds-skeleton, ${0, $829f609a65d26a98$export$8d43898f60b96a82})`,
        backgroundSize: 'contain',
        height: "var(--ds-space-200, 16px)",
        width: "var(--ds-space-200, 16px)",
        borderRadius: "var(--ds-border-radius-100, 3px)"
    }));
const $d25d957bbbc82c9b$export$d1143dd23ca69d4e = ()=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $liajA.default), {
        label: "Page Icon",
        testId: "project-pages-page-icon"
    });
const $d25d957bbbc82c9b$export$27ad0cb31a950e4c = ()=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $4Atwu.default), {
        label: "Live Doc Icon",
        testId: "project-pages-live-doc-icon"
    });
};

});
var $829f609a65d26a98$exports = {};

$parcel$export($829f609a65d26a98$exports, "R50", () => $829f609a65d26a98$export$4b84fd0e2c617bd);
$parcel$export($829f609a65d26a98$exports, "R75", () => $829f609a65d26a98$export$b34b069eff244586);
$parcel$export($829f609a65d26a98$exports, "R100", () => $829f609a65d26a98$export$be802dd0d8b57f35);
$parcel$export($829f609a65d26a98$exports, "R200", () => $829f609a65d26a98$export$60847d42f9da92a6);
$parcel$export($829f609a65d26a98$exports, "R300", () => $829f609a65d26a98$export$4a7404f376229999);
$parcel$export($829f609a65d26a98$exports, "R400", () => $829f609a65d26a98$export$2010d0fb4295b346);
$parcel$export($829f609a65d26a98$exports, "R500", () => $829f609a65d26a98$export$2837b5a1a71d5c02);
$parcel$export($829f609a65d26a98$exports, "Y50", () => $829f609a65d26a98$export$8d9596b529bbb9cf);
$parcel$export($829f609a65d26a98$exports, "Y75", () => $829f609a65d26a98$export$41060a744ab0b7ae);
$parcel$export($829f609a65d26a98$exports, "Y100", () => $829f609a65d26a98$export$1cc05bbbf340e559);
$parcel$export($829f609a65d26a98$exports, "Y200", () => $829f609a65d26a98$export$5aae31392d72caaa);
$parcel$export($829f609a65d26a98$exports, "Y300", () => $829f609a65d26a98$export$c6930421db9fa514);
$parcel$export($829f609a65d26a98$exports, "Y400", () => $829f609a65d26a98$export$59619663aa6500fb);
$parcel$export($829f609a65d26a98$exports, "Y500", () => $829f609a65d26a98$export$874739ea9e379ab6);
$parcel$export($829f609a65d26a98$exports, "G50", () => $829f609a65d26a98$export$8a6341c32b6a3ee6);
$parcel$export($829f609a65d26a98$exports, "G75", () => $829f609a65d26a98$export$69a3bf21b9686c2b);
$parcel$export($829f609a65d26a98$exports, "G100", () => $829f609a65d26a98$export$afbce1382ec95f73);
$parcel$export($829f609a65d26a98$exports, "G200", () => $829f609a65d26a98$export$747d86715d4175de);
$parcel$export($829f609a65d26a98$exports, "G300", () => $829f609a65d26a98$export$940e1f69e873f202);
$parcel$export($829f609a65d26a98$exports, "G400", () => $829f609a65d26a98$export$a49394138f7b8e85);
$parcel$export($829f609a65d26a98$exports, "G500", () => $829f609a65d26a98$export$6fa04827ac68a4fb);
$parcel$export($829f609a65d26a98$exports, "B50", () => $829f609a65d26a98$export$226de0355ed012f8);
$parcel$export($829f609a65d26a98$exports, "B75", () => $829f609a65d26a98$export$8c13c2ee36917869);
$parcel$export($829f609a65d26a98$exports, "B100", () => $829f609a65d26a98$export$ecfc1dff386a3e7a);
$parcel$export($829f609a65d26a98$exports, "B200", () => $829f609a65d26a98$export$215b7063051591f1);
$parcel$export($829f609a65d26a98$exports, "B300", () => $829f609a65d26a98$export$e62e8919cca44969);
$parcel$export($829f609a65d26a98$exports, "B400", () => $829f609a65d26a98$export$b3de0ae08da2ce64);
$parcel$export($829f609a65d26a98$exports, "B500", () => $829f609a65d26a98$export$a6ee3d71bc067634);
$parcel$export($829f609a65d26a98$exports, "B600", () => $829f609a65d26a98$export$67f15409e87642a1);
$parcel$export($829f609a65d26a98$exports, "B700", () => $829f609a65d26a98$export$f0539dbc42dbb067);
$parcel$export($829f609a65d26a98$exports, "P50", () => $829f609a65d26a98$export$363e4475840015bb);
$parcel$export($829f609a65d26a98$exports, "P75", () => $829f609a65d26a98$export$4b0a4417ed59760f);
$parcel$export($829f609a65d26a98$exports, "P100", () => $829f609a65d26a98$export$6011520a64d9a187);
$parcel$export($829f609a65d26a98$exports, "P200", () => $829f609a65d26a98$export$a7175d4e9206bc80);
$parcel$export($829f609a65d26a98$exports, "P300", () => $829f609a65d26a98$export$b48405b95304b5a1);
$parcel$export($829f609a65d26a98$exports, "P400", () => $829f609a65d26a98$export$c71e4279dd54a18d);
$parcel$export($829f609a65d26a98$exports, "P500", () => $829f609a65d26a98$export$147899de772240ec);
$parcel$export($829f609a65d26a98$exports, "T50", () => $829f609a65d26a98$export$2cf711fe14c66f06);
$parcel$export($829f609a65d26a98$exports, "T75", () => $829f609a65d26a98$export$7a8f4d33f6f9772c);
$parcel$export($829f609a65d26a98$exports, "T100", () => $829f609a65d26a98$export$776c9c497ef08533);
$parcel$export($829f609a65d26a98$exports, "T200", () => $829f609a65d26a98$export$69cb3ca10c1e330e);
$parcel$export($829f609a65d26a98$exports, "T300", () => $829f609a65d26a98$export$9dc1ef0f3f48059b);
$parcel$export($829f609a65d26a98$exports, "T400", () => $829f609a65d26a98$export$7c835c78b6fcdef8);
$parcel$export($829f609a65d26a98$exports, "T500", () => $829f609a65d26a98$export$6036577f95c3877e);
$parcel$export($829f609a65d26a98$exports, "N0", () => $829f609a65d26a98$export$29a4f05edc054374);
$parcel$export($829f609a65d26a98$exports, "N10", () => $829f609a65d26a98$export$e655ef011c4aa1a2);
$parcel$export($829f609a65d26a98$exports, "N20", () => $829f609a65d26a98$export$9fdfb749e33cdf97);
$parcel$export($829f609a65d26a98$exports, "N30", () => $829f609a65d26a98$export$3e51e8f1440314ba);
$parcel$export($829f609a65d26a98$exports, "N40", () => $829f609a65d26a98$export$1ce2d1575d444ceb);
$parcel$export($829f609a65d26a98$exports, "N50", () => $829f609a65d26a98$export$8754fc7e6d8b3000);
$parcel$export($829f609a65d26a98$exports, "N60", () => $829f609a65d26a98$export$c2e91cbeada39b8b);
$parcel$export($829f609a65d26a98$exports, "N70", () => $829f609a65d26a98$export$5f71e19f3a7ad9de);
$parcel$export($829f609a65d26a98$exports, "N80", () => $829f609a65d26a98$export$eaa8c8a70ac22806);
$parcel$export($829f609a65d26a98$exports, "N90", () => $829f609a65d26a98$export$7c87d337fb91a97d);
$parcel$export($829f609a65d26a98$exports, "N100", () => $829f609a65d26a98$export$d6447c357493214f);
$parcel$export($829f609a65d26a98$exports, "N200", () => $829f609a65d26a98$export$f563ee71e9ee74cd);
$parcel$export($829f609a65d26a98$exports, "N300", () => $829f609a65d26a98$export$e2ef2124cf4024b1);
$parcel$export($829f609a65d26a98$exports, "N400", () => $829f609a65d26a98$export$eece5f492e429f08);
$parcel$export($829f609a65d26a98$exports, "N500", () => $829f609a65d26a98$export$c39c0fe0f26207ae);
$parcel$export($829f609a65d26a98$exports, "N600", () => $829f609a65d26a98$export$7090862dc3038a9f);
$parcel$export($829f609a65d26a98$exports, "N700", () => $829f609a65d26a98$export$ad0bacf983b7ddaa);
$parcel$export($829f609a65d26a98$exports, "N800", () => $829f609a65d26a98$export$7d61b15e0da132af);
$parcel$export($829f609a65d26a98$exports, "N900", () => $829f609a65d26a98$export$fbda843f0a27fe96);
$parcel$export($829f609a65d26a98$exports, "N10A", () => $829f609a65d26a98$export$791e57b27ca738ef);
$parcel$export($829f609a65d26a98$exports, "N20A", () => $829f609a65d26a98$export$8d43898f60b96a82);
$parcel$export($829f609a65d26a98$exports, "N30A", () => $829f609a65d26a98$export$920c0d5c49070351);
$parcel$export($829f609a65d26a98$exports, "N40A", () => $829f609a65d26a98$export$46987b49aab6d1a8);
$parcel$export($829f609a65d26a98$exports, "N50A", () => $829f609a65d26a98$export$7d3359664e8bb0e5);
$parcel$export($829f609a65d26a98$exports, "N60A", () => $829f609a65d26a98$export$d2d3bedfb276cac0);
$parcel$export($829f609a65d26a98$exports, "N70A", () => $829f609a65d26a98$export$6e5e7499ff054f6d);
$parcel$export($829f609a65d26a98$exports, "N80A", () => $829f609a65d26a98$export$59264b346c877fa7);
$parcel$export($829f609a65d26a98$exports, "N90A", () => $829f609a65d26a98$export$d092757d7c64925c);
$parcel$export($829f609a65d26a98$exports, "N100A", () => $829f609a65d26a98$export$486ab785e4bac3c6);
$parcel$export($829f609a65d26a98$exports, "N200A", () => $829f609a65d26a98$export$fba592bbc6419fea);
$parcel$export($829f609a65d26a98$exports, "N300A", () => $829f609a65d26a98$export$13609db0e6812ab8);
$parcel$export($829f609a65d26a98$exports, "N400A", () => $829f609a65d26a98$export$fbae4efaa892d883);
$parcel$export($829f609a65d26a98$exports, "N500A", () => $829f609a65d26a98$export$f13946d26f440ce6);
$parcel$export($829f609a65d26a98$exports, "N600A", () => $829f609a65d26a98$export$19f58225ac52a306);
$parcel$export($829f609a65d26a98$exports, "N700A", () => $829f609a65d26a98$export$6384f09da70e7b62);
$parcel$export($829f609a65d26a98$exports, "N800A", () => $829f609a65d26a98$export$d0dccc730683edc2);
$parcel$export($829f609a65d26a98$exports, "DN900", () => $829f609a65d26a98$export$2f6319cf7d736c2a);
$parcel$export($829f609a65d26a98$exports, "DN800", () => $829f609a65d26a98$export$95126bc8884d6634);
$parcel$export($829f609a65d26a98$exports, "DN700", () => $829f609a65d26a98$export$8338d8c35d44ff1);
$parcel$export($829f609a65d26a98$exports, "DN600", () => $829f609a65d26a98$export$5368d76ae4fbbda7);
$parcel$export($829f609a65d26a98$exports, "DN500", () => $829f609a65d26a98$export$9f0a771d16ec8d36);
$parcel$export($829f609a65d26a98$exports, "DN400", () => $829f609a65d26a98$export$abcf8c38338b4aa5);
$parcel$export($829f609a65d26a98$exports, "DN300", () => $829f609a65d26a98$export$97e81faa16a182c7);
$parcel$export($829f609a65d26a98$exports, "DN200", () => $829f609a65d26a98$export$bfe21c59123ecf33);
$parcel$export($829f609a65d26a98$exports, "DN100", () => $829f609a65d26a98$export$ee82aa2ea6a1558);
$parcel$export($829f609a65d26a98$exports, "DN90", () => $829f609a65d26a98$export$682927c6ed76be02);
$parcel$export($829f609a65d26a98$exports, "DN80", () => $829f609a65d26a98$export$91fd9994c5be9757);
$parcel$export($829f609a65d26a98$exports, "DN70", () => $829f609a65d26a98$export$d281fbfe3cff2df6);
$parcel$export($829f609a65d26a98$exports, "DN60", () => $829f609a65d26a98$export$3902c91d8b98a753);
$parcel$export($829f609a65d26a98$exports, "DN50", () => $829f609a65d26a98$export$8e8133c1ba5845b5);
$parcel$export($829f609a65d26a98$exports, "DN40", () => $829f609a65d26a98$export$33ff357f6620b39);
$parcel$export($829f609a65d26a98$exports, "DN30", () => $829f609a65d26a98$export$633847cf062b69e0);
$parcel$export($829f609a65d26a98$exports, "DN20", () => $829f609a65d26a98$export$9776a6e503bdbf76);
$parcel$export($829f609a65d26a98$exports, "DN10", () => $829f609a65d26a98$export$6c813d5160dff5db);
$parcel$export($829f609a65d26a98$exports, "DN0", () => $829f609a65d26a98$export$3d4f271a500072a);
$parcel$export($829f609a65d26a98$exports, "DN800A", () => $829f609a65d26a98$export$fe151285c22759ec);
$parcel$export($829f609a65d26a98$exports, "DN700A", () => $829f609a65d26a98$export$a101c6190d0da34);
$parcel$export($829f609a65d26a98$exports, "DN600A", () => $829f609a65d26a98$export$4b16f52932fda51);
$parcel$export($829f609a65d26a98$exports, "DN500A", () => $829f609a65d26a98$export$a74bcd7b9845b0d8);
$parcel$export($829f609a65d26a98$exports, "DN400A", () => $829f609a65d26a98$export$9209c179316d1751);
$parcel$export($829f609a65d26a98$exports, "DN300A", () => $829f609a65d26a98$export$88f55133f636c8dd);
$parcel$export($829f609a65d26a98$exports, "DN200A", () => $829f609a65d26a98$export$51126f85d1009512);
$parcel$export($829f609a65d26a98$exports, "DN100A", () => $829f609a65d26a98$export$a069b547bd23af78);
$parcel$export($829f609a65d26a98$exports, "DN90A", () => $829f609a65d26a98$export$40cce05af3b2600a);
$parcel$export($829f609a65d26a98$exports, "DN80A", () => $829f609a65d26a98$export$b78942185925a0d);
$parcel$export($829f609a65d26a98$exports, "DN70A", () => $829f609a65d26a98$export$e058fb44b8eaafca);
$parcel$export($829f609a65d26a98$exports, "DN60A", () => $829f609a65d26a98$export$92b0b8de26920c18);
$parcel$export($829f609a65d26a98$exports, "DN50A", () => $829f609a65d26a98$export$67564f7459d3fc9e);
$parcel$export($829f609a65d26a98$exports, "DN40A", () => $829f609a65d26a98$export$77868e1ca884ffa3);
$parcel$export($829f609a65d26a98$exports, "DN30A", () => $829f609a65d26a98$export$2afd71d7d3ea2cd5);
$parcel$export($829f609a65d26a98$exports, "DN20A", () => $829f609a65d26a98$export$f2a0acaab9972c70);
$parcel$export($829f609a65d26a98$exports, "DN10A", () => $829f609a65d26a98$export$9ab70e67d6475361);
$parcel$export($829f609a65d26a98$exports, "T30", () => $829f609a65d26a98$export$d2adc5dedf09fced);
$parcel$export($829f609a65d26a98$exports, "L50", () => $829f609a65d26a98$export$f51762073d2bb381);
$parcel$export($829f609a65d26a98$exports, "L75", () => $829f609a65d26a98$export$95e26d54def96891);
// Reds
const $829f609a65d26a98$export$4b84fd0e2c617bd = '#FFEBE6';
const $829f609a65d26a98$export$b34b069eff244586 = '#FFBDAD';
const $829f609a65d26a98$export$be802dd0d8b57f35 = '#FF8F73';
const $829f609a65d26a98$export$60847d42f9da92a6 = '#FF7452';
const $829f609a65d26a98$export$4a7404f376229999 = '#FF5630';
const $829f609a65d26a98$export$2010d0fb4295b346 = '#DE350B';
const $829f609a65d26a98$export$2837b5a1a71d5c02 = '#BF2600';
const $829f609a65d26a98$export$8d9596b529bbb9cf = '#FFFAE6';
const $829f609a65d26a98$export$41060a744ab0b7ae = '#FFF0B3';
const $829f609a65d26a98$export$1cc05bbbf340e559 = '#FFE380';
const $829f609a65d26a98$export$5aae31392d72caaa = '#FFC400';
const $829f609a65d26a98$export$c6930421db9fa514 = '#FFAB00';
const $829f609a65d26a98$export$59619663aa6500fb = '#FF991F';
const $829f609a65d26a98$export$874739ea9e379ab6 = '#FF8B00';
const $829f609a65d26a98$export$8a6341c32b6a3ee6 = '#E3FCEF';
const $829f609a65d26a98$export$69a3bf21b9686c2b = '#ABF5D1';
const $829f609a65d26a98$export$afbce1382ec95f73 = '#79F2C0';
const $829f609a65d26a98$export$747d86715d4175de = '#57D9A3';
const $829f609a65d26a98$export$940e1f69e873f202 = '#36B37E';
const $829f609a65d26a98$export$a49394138f7b8e85 = '#00875A';
const $829f609a65d26a98$export$6fa04827ac68a4fb = '#006644';
const $829f609a65d26a98$export$226de0355ed012f8 = '#DEEBFF';
const $829f609a65d26a98$export$8c13c2ee36917869 = '#B3D4FF';
const $829f609a65d26a98$export$ecfc1dff386a3e7a = '#4C9AFF';
const $829f609a65d26a98$export$215b7063051591f1 = '#2684FF';
const $829f609a65d26a98$export$e62e8919cca44969 = '#0065FF';
const $829f609a65d26a98$export$b3de0ae08da2ce64 = '#0052CC';
const $829f609a65d26a98$export$a6ee3d71bc067634 = '#0747A6';
const $829f609a65d26a98$export$67f15409e87642a1 = '#669DF1';
const $829f609a65d26a98$export$f0539dbc42dbb067 = '#8FB8F6';
const $829f609a65d26a98$export$363e4475840015bb = '#EAE6FF';
const $829f609a65d26a98$export$4b0a4417ed59760f = '#C0B6F2';
const $829f609a65d26a98$export$6011520a64d9a187 = '#998DD9';
const $829f609a65d26a98$export$a7175d4e9206bc80 = '#8777D9';
const $829f609a65d26a98$export$b48405b95304b5a1 = '#6554C0';
const $829f609a65d26a98$export$c71e4279dd54a18d = '#5243AA';
const $829f609a65d26a98$export$147899de772240ec = '#403294';
const $829f609a65d26a98$export$2cf711fe14c66f06 = '#E6FCFF';
const $829f609a65d26a98$export$7a8f4d33f6f9772c = '#B3F5FF';
const $829f609a65d26a98$export$776c9c497ef08533 = '#79E2F2';
const $829f609a65d26a98$export$69cb3ca10c1e330e = '#00C7E6';
const $829f609a65d26a98$export$9dc1ef0f3f48059b = '#00B8D9';
const $829f609a65d26a98$export$7c835c78b6fcdef8 = '#00A3BF';
const $829f609a65d26a98$export$6036577f95c3877e = '#008DA6';
const $829f609a65d26a98$export$29a4f05edc054374 = '#FFFFFF';
const $829f609a65d26a98$export$e655ef011c4aa1a2 = '#FAFBFC';
const $829f609a65d26a98$export$9fdfb749e33cdf97 = '#F4F5F7';
const $829f609a65d26a98$export$3e51e8f1440314ba = '#EBECF0';
const $829f609a65d26a98$export$1ce2d1575d444ceb = '#DFE1E6';
const $829f609a65d26a98$export$8754fc7e6d8b3000 = '#C1C7D0';
const $829f609a65d26a98$export$c2e91cbeada39b8b = '#B3BAC5';
const $829f609a65d26a98$export$5f71e19f3a7ad9de = '#A5ADBA';
const $829f609a65d26a98$export$eaa8c8a70ac22806 = '#97A0AF';
const $829f609a65d26a98$export$7c87d337fb91a97d = '#8993A4';
const $829f609a65d26a98$export$d6447c357493214f = '#7A869A';
const $829f609a65d26a98$export$f563ee71e9ee74cd = '#6B778C';
const $829f609a65d26a98$export$e2ef2124cf4024b1 = '#5E6C84';
const $829f609a65d26a98$export$eece5f492e429f08 = '#505F79';
const $829f609a65d26a98$export$c39c0fe0f26207ae = '#42526E';
const $829f609a65d26a98$export$7090862dc3038a9f = '#344563';
const $829f609a65d26a98$export$ad0bacf983b7ddaa = '#253858';
const $829f609a65d26a98$export$7d61b15e0da132af = '#172B4D';
const $829f609a65d26a98$export$fbda843f0a27fe96 = '#091E42';
const $829f609a65d26a98$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
const $829f609a65d26a98$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
const $829f609a65d26a98$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
const $829f609a65d26a98$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
const $829f609a65d26a98$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
const $829f609a65d26a98$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
const $829f609a65d26a98$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
const $829f609a65d26a98$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
const $829f609a65d26a98$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
const $829f609a65d26a98$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
const $829f609a65d26a98$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
const $829f609a65d26a98$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
const $829f609a65d26a98$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
const $829f609a65d26a98$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
const $829f609a65d26a98$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
const $829f609a65d26a98$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
const $829f609a65d26a98$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
const $829f609a65d26a98$export$2f6319cf7d736c2a = '#E6EDFA';
const $829f609a65d26a98$export$95126bc8884d6634 = '#DCE5F5';
const $829f609a65d26a98$export$8338d8c35d44ff1 = '#CED9EB';
const $829f609a65d26a98$export$5368d76ae4fbbda7 = '#B8C7E0';
const $829f609a65d26a98$export$9f0a771d16ec8d36 = '#ABBBD6';
const $829f609a65d26a98$export$abcf8c38338b4aa5 = '#9FB0CC';
const $829f609a65d26a98$export$97e81faa16a182c7 = '#8C9CB8';
const $829f609a65d26a98$export$bfe21c59123ecf33 = '#7988A3';
const $829f609a65d26a98$export$ee82aa2ea6a1558 = '#67758F';
const $829f609a65d26a98$export$682927c6ed76be02 = '#56637A';
const $829f609a65d26a98$export$91fd9994c5be9757 = '#455166';
const $829f609a65d26a98$export$d281fbfe3cff2df6 = '#3B475C';
const $829f609a65d26a98$export$3902c91d8b98a753 = '#313D52';
const $829f609a65d26a98$export$8e8133c1ba5845b5 = '#283447';
const $829f609a65d26a98$export$33ff357f6620b39 = '#202B3D';
const $829f609a65d26a98$export$633847cf062b69e0 = '#1B2638';
const $829f609a65d26a98$export$9776a6e503bdbf76 = '#121A29';
const $829f609a65d26a98$export$6c813d5160dff5db = '#0E1624';
const $829f609a65d26a98$export$3d4f271a500072a = '#0D1424';
const $829f609a65d26a98$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
const $829f609a65d26a98$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
const $829f609a65d26a98$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
const $829f609a65d26a98$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
const $829f609a65d26a98$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
const $829f609a65d26a98$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
const $829f609a65d26a98$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
const $829f609a65d26a98$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
const $829f609a65d26a98$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
const $829f609a65d26a98$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
const $829f609a65d26a98$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
const $829f609a65d26a98$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
const $829f609a65d26a98$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
const $829f609a65d26a98$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
const $829f609a65d26a98$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
const $829f609a65d26a98$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
const $829f609a65d26a98$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';
const $829f609a65d26a98$export$d2adc5dedf09fced = '#292A2E';
const $829f609a65d26a98$export$f51762073d2bb381 = '#94C748';
const $829f609a65d26a98$export$95e26d54def96891 = '#B3DF72';

parcelRegister("liajA", function(module, exports) {

$parcel$export(module.exports, "default", () => $c41b90368f925c6c$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::79077d9339ad2083a3901f522ad14f6b>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $cwmS5 = parcelRequire("cwmS5");

var $kdfZa = parcelRequire("kdfZa");

var $VSDnB = parcelRequire("VSDnB");

var $kZjZ3 = parcelRequire("kZjZ3");
/**
 * __16px `page` icon object__
 *
 * - [Examples](https://atlassian.design/components/icon-object/examples)
 * - [Code](https://atlassian.design/components/icon-object/code)
 * - [Usage](https://atlassian.design/components/icon-object/usage)
 */ const $c41b90368f925c6c$var$Page16Icon = ({ label: label, testId: testId })=>{
    if ((0, $VSDnB.fg)('icon-object-migration')) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cwmS5.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($kdfZa))),
        appearance: "blueBold",
        size: "16",
        label: label,
        testId: testId,
        LEGACY_fallbackComponent: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $kZjZ3.default), {
            label: label,
            testId: testId
        })
    });
    else return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $kZjZ3.default), {
        label: label,
        testId: testId
    });
};
$c41b90368f925c6c$var$Page16Icon.displayName = 'Page16Icon';
var $c41b90368f925c6c$export$2e2bcd8739ae039 = $c41b90368f925c6c$var$Page16Icon;

});
parcelRegister("cwmS5", function(module, exports) {

$parcel$export(module.exports, "default", () => $a921419639fe8f6f$export$2e2bcd8739ae039);
/* icon-tile.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $VSDnB = parcelRequire("VSDnB");
const $a921419639fe8f6f$var$sizeMap = {
    '16': "_1bsb7vkz _4t3i7vkz",
    '24': "_1bsb1tcg _4t3i1tcg",
    '32': "_1bsbzwfg _4t3izwfg",
    '40': "_1bsb1ylp _4t3i1ylp",
    '48': "_1bsbckbl _4t3ickbl"
};
const $a921419639fe8f6f$var$appearanceMap = {
    grayBold: "_bfhk1t1b _syaz5w2r",
    limeBold: "_bfhktde4 _syaz5w2r",
    greenBold: "_bfhk1e5c _syaz5w2r",
    blueBold: "_bfhkc8cv _syaz5w2r",
    redBold: "_bfhkuibq _syaz5w2r",
    purpleBold: "_bfhkygwo _syaz5w2r",
    magentaBold: "_bfhkc3uk _syaz5w2r",
    tealBold: "_bfhk2c8p _syaz5w2r",
    orangeBold: "_bfhkjgng _syaz5w2r",
    yellowBold: "_bfhk1vop _syaz5w2r",
    gray: "_bfhk1v33 _syaz16ni",
    lime: "_bfhkz2ec _syaz8645",
    orange: "_bfhkf2vu _syaz7r97",
    magenta: "_bfhkv9ra _syazv8hk",
    green: "_bfhk1wnw _syaz17hp",
    blue: "_bfhk4v9p _syaz1ov1",
    red: "_bfhk1rtt _syaznbxb",
    purple: "_bfhk1jkz _syaz5yjc",
    teal: "_bfhk1a17 _syaz8uof",
    yellow: "_bfhk3fv2 _syaz1oqg"
};
const $a921419639fe8f6f$var$shapeMap = {
    square: "_2rkoiti9",
    circle: "_2rko14q2"
};
const $a921419639fe8f6f$var$iconTileStyles = null;
function $a921419639fe8f6f$export$2e2bcd8739ae039(props) {
    const { icon: Icon, label: label, appearance: appearance, size: size = '24', shape: shape = 'square', LEGACY_fallbackComponent: LEGACY_fallbackComponent, testId: testId } = props;
    const ExpandedIcon = Icon;
    // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
    if (LEGACY_fallbackComponent && !(0, $VSDnB.fg)('platform-visual-refresh-icons')) return LEGACY_fallbackComponent;
    else return /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        "data-testid": testId,
        className: (0, $bwpsq.default)([
            "_1e0c116y _vchhusvi _4cvr1h6o _1bah1h6o _1wybidpf",
            $a921419639fe8f6f$var$appearanceMap[appearance],
            $a921419639fe8f6f$var$sizeMap[size],
            $a921419639fe8f6f$var$shapeMap[shape]
        ]),
        children: /*#__PURE__*/ (0, $2OMIu.jsx)(ExpandedIcon, {
            color: "currentColor",
            label: label,
            spacing: "spacious",
            shouldScale: true
        })
    });
}

});

parcelRegister("kZjZ3", function(module, exports) {

$parcel$export(module.exports, "default", () => $fb586f8874bd1e95$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::8396146cc2fa60842aed7101fb3015b2>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $c7fbr = parcelRequire("c7fbr");
const $fb586f8874bd1e95$var$Page16Icon = (props)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $c7fbr.IconFacade), {
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#2684ff" fill-rule="evenodd" d="M2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m2 3a1 1 0 1 0 0 2h8a1 1 0 0 0 0-2zm0 4a1 1 0 1 0 0 2h8a1 1 0 0 0 0-2zm0 4a1 1 0 0 0 0 2h4a1 1 0 0 0 0-2z"/></svg>`,
        ...props,
        size: "small"
    });
$fb586f8874bd1e95$var$Page16Icon.displayName = 'Page16Icon';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$fb586f8874bd1e95$export$2e2bcd8739ae039 = $fb586f8874bd1e95$var$Page16Icon;

});


parcelRegister("4Atwu", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $67f5211f96bd858e$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c1228c9bdd9840505938b56c7ed44212>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $cwmS5 = parcelRequire("cwmS5");

var $2OgES = parcelRequire("2OgES");

var $VSDnB = parcelRequire("VSDnB");

var $i0wCi = parcelRequire("i0wCi");
/**
 * __16px `page-live-doc` icon object__
 *
 * - [Examples](https://atlassian.design/components/icon-object/examples)
 * - [Code](https://atlassian.design/components/icon-object/code)
 * - [Usage](https://atlassian.design/components/icon-object/usage)
 */ const $67f5211f96bd858e$var$PageLiveDoc16Icon = ({ label: label, testId: testId })=>{
    if ((0, $VSDnB.fg)('icon-object-migration')) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cwmS5.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($2OgES))),
        appearance: "magentaBold",
        size: "16",
        label: label,
        testId: testId,
        LEGACY_fallbackComponent: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $i0wCi.default), {
            label: label,
            testId: testId
        })
    });
    else return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $i0wCi.default), {
        label: label,
        testId: testId
    });
};
$67f5211f96bd858e$var$PageLiveDoc16Icon.displayName = 'PageLiveDoc16Icon';
var $67f5211f96bd858e$export$2e2bcd8739ae039 = $67f5211f96bd858e$var$PageLiveDoc16Icon;

});
parcelRegister("2OgES", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::692b62fec4c56cd82ae8d8d02e2d3f2e>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $20bd2c4c7f421719$var$_react = $20bd2c4c7f421719$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $20bd2c4c7f421719$var$_baseNew = $20bd2c4c7f421719$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $20bd2c4c7f421719$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "PageLiveDoc".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for Live Document content type.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $20bd2c4c7f421719$var$PageLiveDocIcon = (props)=>/*#__PURE__*/ $20bd2c4c7f421719$var$_react.default.createElement($20bd2c4c7f421719$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M15 3.5H1V2h14zm-9 5H1V7h5zM6 14H1v-1.5h5zm2.72-6.78a.75.75 0 0 1 .79-.17l6 2.25a.75.75 0 0 1-.08 1.43l-2.56.64-.64 2.56a.75.75 0 0 1-1.43.08l-2.25-6a.75.75 0 0 1 .17-.79" clip-rule="evenodd"/>`
    }, props));
$20bd2c4c7f421719$var$PageLiveDocIcon.displayName = 'PageLiveDocIcon';
var $20bd2c4c7f421719$var$_default = module.exports.default = $20bd2c4c7f421719$var$PageLiveDocIcon;

});

parcelRegister("i0wCi", function(module, exports) {

$parcel$export(module.exports, "default", () => $e01b6db3f29618ed$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::bbb561a99c36d24f949f1ade9ed1fa72>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $c7fbr = parcelRequire("c7fbr");
const $e01b6db3f29618ed$var$PageLiveDoc16Icon = (props)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $c7fbr.IconFacade), {
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#cd519d" fill-rule="evenodd" d="M2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m1.293 3.293A1 1 0 0 0 4 5h8a1 1 0 1 0 0-2H4a1 1 0 0 0-.707.293m0 4A1 1 0 0 0 4 9h2a1 1 0 0 0 0-2H4a1 1 0 0 0-.707.293m0 4A1 1 0 0 0 4 13h2a1 1 0 0 0 0-2H4a1 1 0 0 0-.707.293m6.703-4.161a1 1 0 0 0-1.466 1.11l1 4a1 1 0 0 0 1.94 0L11.78 11H13a1 1 0 0 0 .496-1.868z" clip-rule="evenodd"/></svg>`,
        ...props,
        size: "small"
    });
$e01b6db3f29618ed$var$PageLiveDoc16Icon.displayName = 'PageLiveDoc16Icon';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$e01b6db3f29618ed$export$2e2bcd8739ae039 = $e01b6db3f29618ed$var$PageLiveDoc16Icon;

});



parcelRegister("bBMvo", function(module, exports) {

$parcel$export(module.exports, "requestProductLicenceState$", () => $2a46e36f36283bba$export$e16d9fc1107f8c00);
$parcel$export(module.exports, "requestConfluenceSpaces$", () => $2a46e36f36283bba$export$836d55263fa85c87);
$parcel$export(module.exports, "requestCreateConfluenceSpace$", () => $2a46e36f36283bba$export$b699837851084807);
$parcel$export(module.exports, "checkConfluenceSpaceAvailability$", () => $2a46e36f36283bba$export$5fd40bd59aba14a0);
$parcel$export(module.exports, "putFirstSpaceCreatedFlag$", () => $2a46e36f36283bba$export$803b1898c3d83afd);
$parcel$export(module.exports, "createProjectSpaceLink$", () => $2a46e36f36283bba$export$e1967fc978903284);
$parcel$export(module.exports, "deleteProjectSpaceLink$", () => $2a46e36f36283bba$export$f93215d152c7ceac);
$parcel$export(module.exports, "deleteProjectSpaceLinkWithAri$", () => $2a46e36f36283bba$export$a98bae3747dee0b8);
$parcel$export(module.exports, "fetchProjectSpaceLink$", () => $2a46e36f36283bba$export$e1498d86ff7a5f7);
$parcel$export(module.exports, "fetchConnectedSpaceBlueprints$", () => $2a46e36f36283bba$export$a9bcdbdfc3a4c568);
$parcel$export(module.exports, "fetchConfluenceCurrentUser", () => $2a46e36f36283bba$export$dff559fe4d82b44d);
$parcel$export(module.exports, "searchConfluencePages", () => $2a46e36f36283bba$export$b7c915cfba7db283);
$parcel$export(module.exports, "searchConfluenceSpaces", () => $2a46e36f36283bba$export$dd2276d83e80b5ed);
$parcel$export(module.exports, "getConfluenceAccessRequestCapabilities$", () => $2a46e36f36283bba$export$3c28db22d8ae1b4f);
$parcel$export(module.exports, "getConfluencePageContent$", () => $2a46e36f36283bba$export$25561b7d64fb4325);
$parcel$export(module.exports, "getConfluenceSpace$", () => $2a46e36f36283bba$export$c2d8b9bcabaeb4d0);
$parcel$export(module.exports, "getJiraProjectPermissions$", () => $2a46e36f36283bba$export$2b5fae8bff1d96a8);
$parcel$export(module.exports, "requestPersonalizationSiteTraits$", () => $2a46e36f36283bba$export$554089415931795c);
$parcel$export(module.exports, "startConfluenceActivation$", () => $2a46e36f36283bba$export$197e5a1a1bedbe96);
$parcel$export(module.exports, "planConfluenceActivation$", () => $2a46e36f36283bba$export$1ac30eea14e5e902);
$parcel$export(module.exports, "checkConfluenceActivationStatus$", () => $2a46e36f36283bba$export$29c2be969084daf8);
parcelRequire("d0pqD");
parcelRequire("64ZAE");

var $bXPjr = parcelRequire("bXPjr");

var $aWcOP = parcelRequire("aWcOP");

var $8pwuw = parcelRequire("8pwuw");

const $2a46e36f36283bba$var$XFLOW_SERVICE_URL = '/gateway/api/xflow';
const $2a46e36f36283bba$var$BXP_SIGNUP_URL = '/gateway/api/bxp/signup/cloud';
const $2a46e36f36283bba$var$IGNORE_MAU_HEADER = 'x-atlassian-mau-ignore';
const $2a46e36f36283bba$var$EP_ENITITY_ID_HEADER = 'X-Atl-EmbeddablePage-EntityIDs';
const $2a46e36f36283bba$export$13309df55f6e6231 = '/wiki/rest/api/space';
const $2a46e36f36283bba$export$bc7d169343cd2cf6 = '/wiki/rest/create-dialog/1.0/spaces?promotedSpacesLimit=10&otherSpacesLimit=1000';
const $2a46e36f36283bba$export$2bf2ad2b61364815 = '/wiki/rest/onboarding/1/store/global';
const $2a46e36f36283bba$export$981b0f082b0d776b = `/gateway/api/xpsearch-aggregator/quicksearch/v1`;
const $2a46e36f36283bba$export$126be369638921c0 = (spaceKey)=>`/wiki/rest/create-dialog/1.0/blueprints/web-items?spaceKey=${spaceKey}&_=${Date.now()}`;
const $2a46e36f36283bba$export$7c44ff3083bd8b37 = ()=>`/wiki/rest/api/user/current?expand=operations`;
const $2a46e36f36283bba$export$256b0e8bff582010 = (cloudId)=>`${$2a46e36f36283bba$var$BXP_SIGNUP_URL}/${encodeURIComponent(cloudId)}/license-information`;
const $2a46e36f36283bba$export$6521d5279ac5589e = `${$2a46e36f36283bba$var$XFLOW_SERVICE_URL}/provision/cloud`;
const $2a46e36f36283bba$export$16b02e26b9083bd3 = (cloudId)=>`${$2a46e36f36283bba$export$6521d5279ac5589e}/${encodeURIComponent(cloudId)}/product/confluence.ondemand/job/project-pages`;
const $2a46e36f36283bba$export$711aa425c20c30b2 = ()=>'/gateway/api/graphql';
const $2a46e36f36283bba$export$fbb12358ff8c5995 = (spaceKey)=>`/wiki/rest/api/space/${spaceKey}/content?depth=root`;
const $2a46e36f36283bba$export$ad713ec1d3078265 = (key)=>`/wiki/ajax/spaceavailable.action?key=${key}`;
const $2a46e36f36283bba$export$b71c51cebe3b5358 = (cqlQuery)=>`/wiki/rest/api/content/search?${new URLSearchParams({
        cql: cqlQuery,
        expand: 'space,link'
    }).toString()}`;
const $2a46e36f36283bba$export$5c479b434f7669a6 = (pageId)=>`/wiki/rest/api/content/${pageId}`;
const $2a46e36f36283bba$export$2a3fa5b1d638ae51 = (cloudId)=>{
    const params = new URLSearchParams({
        resource: `ari:cloud:confluence::site/${cloudId}`
    });
    return `/gateway/api/invitations/v1/access-requests/capabilities?${params.toString()}`;
};
const $2a46e36f36283bba$export$35bc6862a72d40bd = (cloudId)=>`/gateway/api/tap-delivery/api/v3/personalization/site/${cloudId}`;
const $2a46e36f36283bba$export$8d2096151be97527 = (projectKey)=>{
    const params = new URLSearchParams({
        projectKey: projectKey,
        permissions: `${"CREATE_ISSUES"},${"EDIT_ISSUES"}`
    });
    return `/rest/api/2/mypermissions?${params.toString()}`;
};
const $2a46e36f36283bba$export$e16d9fc1107f8c00 = (cloudId)=>(0, $aWcOP.default)($2a46e36f36283bba$export$256b0e8bff582010(cloudId), {
        credentials: 'include'
    });
const $2a46e36f36283bba$export$836d55263fa85c87 = (projectId, projectType)=>(0, $aWcOP.default)($2a46e36f36283bba$export$bc7d169343cd2cf6, {
        method: 'GET',
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            [$2a46e36f36283bba$var$IGNORE_MAU_HEADER]: 'true',
            [$2a46e36f36283bba$var$EP_ENITITY_ID_HEADER]: JSON.stringify({
                projectId: projectId,
                projectType: projectType
            })
        }
    }).map((response)=>[
            ...new Set([
                ...response.promotedSpaces.spaces,
                ...response.otherSpaces.spaces
            ])
        ]);
const $2a46e36f36283bba$export$b699837851084807 = (confluenceSpaceName, confluenceSpaceKey, projectKey, projectId, projectType)=>(0, $aWcOP.default)($2a46e36f36283bba$export$13309df55f6e6231, {
        method: 'POST',
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            [$2a46e36f36283bba$var$IGNORE_MAU_HEADER]: 'true',
            [$2a46e36f36283bba$var$EP_ENITITY_ID_HEADER]: JSON.stringify({
                projectId: projectId,
                projectType: projectType
            })
        },
        body: JSON.stringify({
            key: confluenceSpaceKey,
            name: confluenceSpaceName,
            description: {
                plain: {
                    value: projectKey ? `Confluence Space created for Jira Project ${projectKey}` : '',
                    representation: 'plain'
                }
            }
        })
    }).map((response)=>({
            spaceKey: response.key,
            spaceId: response.id,
            spaceUrl: `${response._links?.base}${response._links?.webui}`,
            projectKey: projectKey
        }));
const $2a46e36f36283bba$export$5fd40bd59aba14a0 = (key, projectId, projectType)=>(0, $aWcOP.default)($2a46e36f36283bba$export$ad713ec1d3078265(key), {
        credentials: 'include',
        headers: {
            [$2a46e36f36283bba$var$IGNORE_MAU_HEADER]: 'true',
            [$2a46e36f36283bba$var$EP_ENITITY_ID_HEADER]: JSON.stringify({
                projectId: projectId,
                projectType: projectType
            })
        }
    }).map((response)=>({
            available: response.available,
            key: key
        }));
const $2a46e36f36283bba$export$95467f9327511805 = (spaceKey, projectId, projectType)=>(0, $aWcOP.default)($2a46e36f36283bba$export$fbb12358ff8c5995(spaceKey), {
        credentials: 'include',
        headers: {
            [$2a46e36f36283bba$var$IGNORE_MAU_HEADER]: 'true',
            [$2a46e36f36283bba$var$EP_ENITITY_ID_HEADER]: JSON.stringify({
                projectId: projectId,
                projectType: projectType
            })
        }
    }).map((response)=>{
        const firstRootPageFallback = response.page.results[0].id;
        const rootPageWithSlashOverview = response.page.results.filter((result)=>// find the page at the root level that is the space home
            result._links.webui.indexOf('/overview') >= 0).map((rootPage)=>rootPage.id);
        return rootPageWithSlashOverview.length ? rootPageWithSlashOverview[0] : firstRootPageFallback;
    });
const $2a46e36f36283bba$export$803b1898c3d83afd = (projectId, projectType)=>(0, $bXPjr.fromPromise)(fetch($2a46e36f36283bba$export$2bf2ad2b61364815, {
        method: 'PUT',
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            [$2a46e36f36283bba$var$IGNORE_MAU_HEADER]: 'true',
            [$2a46e36f36283bba$var$EP_ENITITY_ID_HEADER]: JSON.stringify({
                projectId: projectId,
                projectType: projectType
            })
        },
        body: JSON.stringify({
            key: 'is-first-space-created',
            value: 'true'
        })
    }).then((response)=>{
        if (!response.ok) {
            const { status: status } = response;
            return response.text().then((str)=>{
                throw new (0, $8pwuw.default)(status, str);
            });
        }
        return null;
    }));
const $2a46e36f36283bba$var$COMMON_AGG_REQUEST_CONFIG = {
    credentials: 'include',
    method: 'POST',
    headers: {
        'Content-Type': 'application/json',
        'X-ExperimentalApi': 'ariGraph,devOps'
    }
};
const $2a46e36f36283bba$var$throwGraphQLErrors = (errors)=>{
    const errStr = errors.map((err)=>err.message).join(', ');
    throw new Error(errStr);
};
const $2a46e36f36283bba$var$handleFetchResponse = (response)=>{
    if (!response.ok) {
        const { status: status } = response;
        return response.text().then((str)=>{
            throw new (0, $8pwuw.default)(status, str);
        });
    }
    return response.json();
};
const $2a46e36f36283bba$var$buildAris = ({ cloudId: cloudId, projectId: projectId, linkedPageId: linkedPageId, spaceId: spaceId })=>{
    const projectAri = `ari:cloud:jira:${cloudId}:project/${projectId}`;
    // Construct the Page ARI if there is a linkedPageId otherwise construct the Space ARI
    const pageOrSpaceAri = linkedPageId ? `ari:cloud:confluence:${cloudId}:page/${linkedPageId}` : `ari:cloud:confluence:${cloudId}:space/${spaceId}`;
    return {
        projectAri: projectAri,
        pageOrSpaceAri: pageOrSpaceAri
    };
};
const $2a46e36f36283bba$var$CREATE_CONFLUENCE_RELATIONSHIP_QUERY = `
  mutation createConfluenceRelationship($fromAri: ID!, $toAri: ID!) {
    devOps {
      ariGraph {
        createRelationships(
          input: {relationships: {type: "project-documentation-entity", from: $fromAri, to: $toAri}}
        ) {
          success
          errors {
            message
          }
        }
      }
    }
  }
`;
const $2a46e36f36283bba$export$e1967fc978903284 = ({ cloudId: cloudId, linkedPageId: linkedPageId, projectId: projectId, spaceId: spaceId })=>{
    const { projectAri: projectAri, pageOrSpaceAri: pageOrSpaceAri } = $2a46e36f36283bba$var$buildAris({
        cloudId: cloudId,
        linkedPageId: linkedPageId,
        projectId: projectId,
        spaceId: spaceId
    });
    return (0, $bXPjr.fromPromise)(fetch($2a46e36f36283bba$export$711aa425c20c30b2(), {
        ...$2a46e36f36283bba$var$COMMON_AGG_REQUEST_CONFIG,
        body: JSON.stringify({
            query: $2a46e36f36283bba$var$CREATE_CONFLUENCE_RELATIONSHIP_QUERY,
            variables: {
                fromAri: projectAri,
                toAri: pageOrSpaceAri
            }
        })
    }).then($2a46e36f36283bba$var$handleFetchResponse).then(({ data: data })=>{
        const { success: success, errors: errors } = data?.devOps?.ariGraph?.createRelationships;
        if (!success) $2a46e36f36283bba$var$throwGraphQLErrors(errors || []);
        return null;
    }));
};
const $2a46e36f36283bba$var$DELETE_CONFLUENCE_RELATIONSHIP_QUERY = `
  mutation deleteConfluenceRelationship($fromAri: ID!, $toAri: ID!) {
    devOps {
      ariGraph {
        deleteRelationships(
          input: {type: "project-documentation-entity", from: $fromAri, to: $toAri}
        ) {
          success
          errors {
            message
          }
        }
      }
    }
  }
`;
const $2a46e36f36283bba$export$f93215d152c7ceac = ({ cloudId: cloudId, linkedPageId: linkedPageId, projectId: projectId, spaceId: spaceId })=>{
    const { projectAri: projectAri, pageOrSpaceAri: pageOrSpaceAri } = $2a46e36f36283bba$var$buildAris({
        cloudId: cloudId,
        linkedPageId: linkedPageId,
        projectId: projectId,
        spaceId: spaceId
    });
    return $2a46e36f36283bba$export$a98bae3747dee0b8(projectAri, pageOrSpaceAri);
};
const $2a46e36f36283bba$export$a98bae3747dee0b8 = (projectAri, pageOrSpaceAri)=>{
    return (0, $bXPjr.fromPromise)(fetch($2a46e36f36283bba$export$711aa425c20c30b2(), {
        ...$2a46e36f36283bba$var$COMMON_AGG_REQUEST_CONFIG,
        body: JSON.stringify({
            query: $2a46e36f36283bba$var$DELETE_CONFLUENCE_RELATIONSHIP_QUERY,
            variables: {
                fromAri: projectAri,
                toAri: pageOrSpaceAri
            }
        })
    }).then($2a46e36f36283bba$var$handleFetchResponse).then(({ data: data })=>{
        const { success: success, errors: errors } = data?.devOps?.ariGraph?.deleteRelationships;
        if (!success) $2a46e36f36283bba$var$throwGraphQLErrors(errors || []);
        return null;
    }));
};
const $2a46e36f36283bba$var$GET_CONFLUENCE_RELATIONSHIP_QUERY = `
  query getConfluenceRelationship($projectAri: ID!) {
    devOps {
      ariGraph {
        relationships(
          filter: {
            from: $projectAri
            type: "project-documentation-entity"
          }
          sort: {
            lastUpdatedSortDirection: DESC
          }
        ) {
          nodes {
            to {
              id
              data {
                __typename
                ... on ConfluenceSpace {
                  key
                }
                ... on ConfluencePage {
                  pageId
                  space {
                    key
                  }
                }
              }
            }
          }
        }
      }
    }
  }
  `;
const $2a46e36f36283bba$export$e1498d86ff7a5f7 = (cloudId, projectId)=>{
    const projectAri = `ari:cloud:jira:${cloudId}:project/${projectId}`;
    return (0, $aWcOP.default)($2a46e36f36283bba$export$711aa425c20c30b2(), {
        credentials: 'include',
        method: 'POST',
        headers: {
            'X-ExperimentalApi': 'ariGraph,devOps'
        },
        body: JSON.stringify({
            query: $2a46e36f36283bba$var$GET_CONFLUENCE_RELATIONSHIP_QUERY,
            variables: {
                projectAri: projectAri
            }
        })
    }).map(({ data: data })=>{
        //If there are multiple relationships, we want to clear these out and let the user specify a single connected space or page for the feature to work as expected
        if (data.devOps.ariGraph.relationships.nodes.length > 1) {
            const arisOfRelationshipsToDelete = data.devOps.ariGraph.relationships.nodes.map((node)=>node.to.id);
            return {
                spaceKey: null,
                linkedPageId: null,
                arisOfRelationshipsToDelete: arisOfRelationshipsToDelete
            };
        }
        //If there is a corrupted space or page, we want to delete it and let the user specify a new space or page to connect to
        const corruptedSpacesAndPages = data.devOps.ariGraph.relationships.nodes.filter((node)=>node.to.data === null);
        if (corruptedSpacesAndPages.length) return {
            spaceKey: null,
            linkedPageId: null,
            arisOfRelationshipsToDelete: [
                corruptedSpacesAndPages[0].to.id
            ]
        };
        const spacesAndPages = data.devOps.ariGraph.relationships.nodes.filter((node)=>[
                'ConfluencePage',
                'ConfluenceSpace'
            ].includes(node.to.data.__typename));
        const [relationshipNode] = spacesAndPages;
        if (relationshipNode == null) return {
            spaceKey: null,
            linkedPageId: null,
            arisOfRelationshipsToDelete: null
        };
        const spaceKey = relationshipNode.to.data.__typename === 'ConfluencePage' ? relationshipNode.to.data.space.key : relationshipNode.to.data.key;
        const linkedPageId = relationshipNode.to.data.__typename === 'ConfluencePage' ? relationshipNode.to.data.pageId : null;
        return {
            spaceKey: spaceKey,
            linkedPageId: linkedPageId,
            arisOfRelationshipsToDelete: null
        };
    });
};
const $2a46e36f36283bba$export$a9bcdbdfc3a4c568 = (spaceKey, projectId, projectType)=>(0, $aWcOP.default)($2a46e36f36283bba$export$126be369638921c0(spaceKey), {
        credentials: 'include',
        headers: {
            [$2a46e36f36283bba$var$IGNORE_MAU_HEADER]: 'true',
            [$2a46e36f36283bba$var$EP_ENITITY_ID_HEADER]: JSON.stringify({
                projectId: projectId,
                projectType: projectType
            })
        }
    });
const $2a46e36f36283bba$export$dff559fe4d82b44d = (projectId, projectType)=>(0, $aWcOP.default)($2a46e36f36283bba$export$7c44ff3083bd8b37(), {
        credentials: 'include',
        headers: {
            [$2a46e36f36283bba$var$IGNORE_MAU_HEADER]: 'true',
            [$2a46e36f36283bba$var$EP_ENITITY_ID_HEADER]: JSON.stringify({
                projectId: projectId,
                projectType: projectType
            })
        }
    });
const $2a46e36f36283bba$var$sanitizeInput = (input = '')=>input.replace(/"|\*|~/g, '\\$&');
const $2a46e36f36283bba$export$b7c915cfba7db283 = (searchString, projectId, projectType)=>{
    let cqlQuery;
    if (searchString) cqlQuery = `type=page and title ~ "${$2a46e36f36283bba$var$sanitizeInput(searchString)}"`;
    else cqlQuery = `type=page`;
    return (0, $aWcOP.default)($2a46e36f36283bba$export$b71c51cebe3b5358(cqlQuery), {
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            [$2a46e36f36283bba$var$IGNORE_MAU_HEADER]: 'true',
            [$2a46e36f36283bba$var$EP_ENITITY_ID_HEADER]: JSON.stringify({
                projectId: projectId,
                projectType: projectType
            })
        }
    }).toPromise();
};
const $2a46e36f36283bba$export$dd2276d83e80b5ed = ({ searchString: searchString, cloudId: cloudId, limit: limit })=>{
    const query = searchString ? $2a46e36f36283bba$var$sanitizeInput(searchString) : '';
    return (0, $aWcOP.default)($2a46e36f36283bba$export$981b0f082b0d776b, {
        method: 'POST',
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            query: query,
            cloudId: cloudId,
            limit: limit,
            scopes: [
                'confluence.space'
            ],
            experience: 'jira.projectPages'
        })
    }).toPromise();
};
const $2a46e36f36283bba$export$3c28db22d8ae1b4f = (cloudId)=>(0, $aWcOP.default)($2a46e36f36283bba$export$2a3fa5b1d638ae51(cloudId), {
        credentials: 'include'
    });
const $2a46e36f36283bba$export$25561b7d64fb4325 = (pageId, projectId, projectType)=>(0, $aWcOP.default)($2a46e36f36283bba$export$5c479b434f7669a6(pageId), {
        credentials: 'include',
        headers: {
            [$2a46e36f36283bba$var$EP_ENITITY_ID_HEADER]: JSON.stringify({
                projectId: projectId,
                projectType: projectType
            })
        }
    });
const $2a46e36f36283bba$export$c2d8b9bcabaeb4d0 = (spaceKey, projectId, projectType)=>(0, $aWcOP.default)(`/wiki/rest/api/space/${spaceKey}?expand=icon,homepage`, {
        credentials: 'include',
        headers: {
            [$2a46e36f36283bba$var$EP_ENITITY_ID_HEADER]: JSON.stringify({
                projectId: projectId,
                projectType: projectType
            })
        }
    });
var $2a46e36f36283bba$export$5b73c005b9475dcb = /*#__PURE__*/ function(JiraProjectPermissionType) {
    JiraProjectPermissionType["EditIssues"] = "EDIT_ISSUES";
    JiraProjectPermissionType["CreateIssues"] = "CREATE_ISSUES";
    return JiraProjectPermissionType;
}({});
const $2a46e36f36283bba$export$2b5fae8bff1d96a8 = (projectKey)=>(0, $aWcOP.default)($2a46e36f36283bba$export$8d2096151be97527(projectKey), {
        credentials: 'include'
    });
const $2a46e36f36283bba$export$554089415931795c = (cloudId)=>(0, $aWcOP.default)($2a46e36f36283bba$export$35bc6862a72d40bd(cloudId), {
        method: 'GET',
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            [$2a46e36f36283bba$var$IGNORE_MAU_HEADER]: 'true'
        }
    }).map((response)=>response.attributes);
const $2a46e36f36283bba$export$4e1ad3f3c6e5680c = [
    'activate',
    'wait-for-activation',
    'wait-for-confluence',
    'create-space',
    'link-space'
];
const $2a46e36f36283bba$export$30557b1912f2c86a = [
    'PROVISIONING_IN_PROGRESS',
    'PROVISIONING_COMPLETED',
    'PROVISIONING_FAILED',
    'PROVISIONING_PROCESS_NOT_FOUND'
];
const $2a46e36f36283bba$export$197e5a1a1bedbe96 = (cloudId, body)=>(0, $aWcOP.default)(`${$2a46e36f36283bba$export$16b02e26b9083bd3(cloudId)}/start`, {
        method: 'POST',
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            [$2a46e36f36283bba$var$IGNORE_MAU_HEADER]: 'true'
        },
        body: JSON.stringify({
            ...body,
            sourceContext: (0, $9d339e91f7cbd39e$export$e776c72d9769c47a),
            sourceComponent: (0, $9d339e91f7cbd39e$export$400f359cf7604d7a),
            requestedEditionId: 'free'
        })
    });
const $2a46e36f36283bba$export$1ac30eea14e5e902 = (cloudId, body)=>(0, $aWcOP.default)(`${$2a46e36f36283bba$export$16b02e26b9083bd3(cloudId)}/plan`, {
        method: 'POST',
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            [$2a46e36f36283bba$var$IGNORE_MAU_HEADER]: 'true'
        },
        body: JSON.stringify({
            ...body,
            sourceContext: (0, $9d339e91f7cbd39e$export$e776c72d9769c47a),
            sourceComponent: (0, $9d339e91f7cbd39e$export$400f359cf7604d7a),
            requestedEditionId: 'free'
        })
    });
const $2a46e36f36283bba$export$29c2be969084daf8 = (cloudId)=>(0, $aWcOP.default)(`${$2a46e36f36283bba$export$16b02e26b9083bd3(cloudId)}/status`, {
        method: 'GET',
        credentials: 'include'
    });

});
parcelRegister("aWcOP", function(module, exports) {

$parcel$export(module.exports, "default", () => $43031292441c5a03$export$2e2bcd8739ae039);
parcelRequire("fp4O3");

var $kVLXA = parcelRequire("kVLXA");

var $7G07p = parcelRequire("7G07p");

var $8pwuw = parcelRequire("8pwuw");

const $43031292441c5a03$var$noContentStatus = (0, $98318a085d858628$export$3288b14b6745c572);
const $43031292441c5a03$var$defaultOptions = (0, $7G07p.freeze)({
    credentials: 'same-origin',
    headers: {
        'Content-Type': 'application/json',
        Accept: [
            'application/json',
            'text/javascript',
            '*/*'
        ]
    }
});
// This function returns a JSON stream which emits a single JSON value on success, and throws
// an error on failure
// Pass the headersProcessor in the options to provide a callback function which can respond on headers.
const $43031292441c5a03$var$fetchJson$ = (url, options = {})=>{
    const { headersProcessor: headersProcessor, ...opts } = options;
    return (0, $kVLXA.Observable).of(url).mergeMap(()=>fetch(url, (0, $7G07p.merge)($43031292441c5a03$var$defaultOptions, opts))).mergeMap((response)=>{
        if (!response.ok) {
            const { status: status } = response;
            return response.text().then((str)=>{
                throw new (0, $8pwuw.default)(status, str);
            });
        }
        if (typeof headersProcessor === 'function') headersProcessor(response.headers);
        if (response.status === $43031292441c5a03$var$noContentStatus) // We want it to return a `null` value.
        // Using `Observable.empty()` would just hang as `mergeMap`
        // will be waiting for values that would never come.
        return (0, $kVLXA.Observable).of(null);
        return response.json();
    });
};
var $43031292441c5a03$export$2e2bcd8739ae039 = $43031292441c5a03$var$fetchJson$;

});
parcelRegister("7G07p", function(module, exports) {
/**
 * This allows you to work with object hierarchies that have been frozen
 * with Object.freeze().  "get" operations can use the normal JS syntax,
 * but operations that modify the data will have to return partial copies of
 * the structure. The portions of the structure that did not change will
 * === their previous values.
 *
 * Inspired by clojure/mori and Immutable.js
 */ 'use strict';
const $596c8c2a35922d3c$var$i = module.exports;
const $596c8c2a35922d3c$var$identity = (coll)=>coll;
// we only care about objects or arrays for now
const $596c8c2a35922d3c$var$weCareAbout = (val)=>val !== null && (Array.isArray(val) || // This will skip objects created with `new Foo()`
    // and objects created with `Object.create(proto)`
    // The benefit is ignoring DOM elements and event emitters,
    // which are often circular.
    $596c8c2a35922d3c$var$isObjectLike(val));
const $596c8c2a35922d3c$var$isObjectLike = (val)=>typeof val === 'object' && val.constructor === Object && Object.getPrototypeOf(val) === Object.prototype;
const $596c8c2a35922d3c$var$forKeys = (obj, iter)=>{
    let idx, keys;
    if (Array.isArray(obj)) {
        idx = obj.length;
        while(idx--)iter(idx);
        return;
    }
    keys = Object.keys(obj);
    idx = keys.length;
    while(idx--)iter(keys[idx]);
};
const $596c8c2a35922d3c$var$cloneObj = (obj)=>{
    const newObj = {};
    const keys = Object.keys(obj);
    let idx = keys.length;
    let key;
    while(idx--){
        key = keys[idx];
        newObj[key] = obj[key];
    }
    return newObj;
};
const $596c8c2a35922d3c$var$clone = (coll)=>{
    if (Array.isArray(coll)) return coll.slice();
    else return $596c8c2a35922d3c$var$cloneObj(coll);
};
const $596c8c2a35922d3c$var$freezeIfNeeded = $596c8c2a35922d3c$var$identity;
const $596c8c2a35922d3c$var$_freeze = $596c8c2a35922d3c$var$identity;
const $596c8c2a35922d3c$var$prevNodes = [];
const $596c8c2a35922d3c$var$baseFreeze = (coll)=>{
    if ($596c8c2a35922d3c$var$prevNodes.some((val)=>val === coll)) throw new Error('object has a reference cycle');
    $596c8c2a35922d3c$var$prevNodes.push(coll);
    $596c8c2a35922d3c$var$forKeys(coll, (key)=>{
        const prop = coll[key];
        if ($596c8c2a35922d3c$var$weCareAbout(prop)) $596c8c2a35922d3c$var$baseFreeze(prop);
    });
    $596c8c2a35922d3c$var$prevNodes.pop();
    Object.freeze(coll);
    return coll;
};
/**
 * recrursively freeze an object and all its child objects
 * @param  {Object|Array} coll
 * @return {Object|Array}
 */ module.exports.freeze = $596c8c2a35922d3c$var$identity;
/**
 * recursively un-freeze an object, by cloning frozen collections
 * @param  {[type]} coll [description]
 * @return {[type]}      [description]
 */ module.exports.thaw = function thaw(coll) {
    if (!$596c8c2a35922d3c$var$weCareAbout(coll) || !Object.isFrozen(coll)) return coll;
    const newColl = Array.isArray(coll) ? new Array(coll.length) : {};
    $596c8c2a35922d3c$var$forKeys(coll, (key)=>{
        newColl[key] = thaw(coll[key]);
    });
    return newColl;
};
/**
 * set a value on an object or array
 * @param  {Object|Array}  coll
 * @param  {String|Number} key   Key or index
 * @param  {Object}        value
 * @return {Object|Array}        new object hierarchy with modifications
 */ module.exports.assoc = function assoc(coll, key, value) {
    if (coll[key] === value) return $596c8c2a35922d3c$var$_freeze(coll);
    const newObj = $596c8c2a35922d3c$var$clone(coll);
    newObj[key] = $596c8c2a35922d3c$var$freezeIfNeeded(value);
    return $596c8c2a35922d3c$var$_freeze(newObj);
};
module.exports.set = module.exports.assoc;
/**
 * un-set a value on an object or array
 * @param  {Object|Array}  coll
 * @param  {String|Number} key  Key or Index
 * @return {Object|Array}       New object or array
 */ module.exports.dissoc = function dissoc(coll, key) {
    const newObj = $596c8c2a35922d3c$var$clone(coll);
    delete newObj[key];
    return $596c8c2a35922d3c$var$_freeze(newObj);
};
module.exports.unset = module.exports.dissoc;
/**
 * set a value deep in a hierarchical structure
 * @param  {Object|Array} coll
 * @param  {Array}        path    A list of keys to traverse
 * @param  {Object}       value
 * @return {Object|Array}       new object hierarchy with modifications
 */ module.exports.assocIn = function assocIn(coll, path, value) {
    const key0 = path[0];
    if (path.length === 1) // simplest case is a 1-element array.  Just a simple assoc.
    return $596c8c2a35922d3c$var$i.assoc(coll, key0, value);
    else // break the problem down.  Assoc this object with the first key
    // and the result of assocIn with the rest of the keys
    return $596c8c2a35922d3c$var$i.assoc(coll, key0, assocIn(coll[key0] || {}, path.slice(1), value));
};
module.exports.setIn = module.exports.assocIn;
/**
 * un-set a value on an object or array
 * @param  {Object|Array}  coll
 * @param  {Array} path  A list of keys to traverse
 * @return {Object|Array}       New object or array
 */ module.exports.dissocIn = function dissocIn(coll, path) {
    const key0 = path[0];
    if (!coll.hasOwnProperty(key0)) return coll;
    if (path.length === 1) // simplest case is a 1-element array.  Just a simple dissoc.
    return $596c8c2a35922d3c$var$i.dissoc(coll, key0);
    else // break the problem down.  Assoc this object with the first key
    // and the result of dissocIn with the rest of the keys
    return $596c8c2a35922d3c$var$i.assoc(coll, key0, dissocIn(coll[key0], path.slice(1)));
};
module.exports.unsetIn = module.exports.dissocIn;
/**
 * get an object from a hierachy based on an array of keys
 * @param  {Object|Array} coll
 * @param  {Array}        path    list of keys
 * @return {Object}       value, or undefined
 */ function $596c8c2a35922d3c$var$baseGet(coll, path) {
    return (path || []).reduce((curr, key)=>{
        if (!curr) return;
        return curr[key];
    }, coll);
}
module.exports.getIn = $596c8c2a35922d3c$var$baseGet;
/**
 * Update a value in a hierarchy
 * @param  {Object|Array}   coll
 * @param  {Array}          path     list of keys
 * @param  {Function} callback The existing value with be passed to this.
 *                             Return the new value to set
 * @return {Object|Array}      new object hierarchy with modifications
 */ module.exports.updateIn = function updateIn(coll, path, callback) {
    const existingVal = $596c8c2a35922d3c$var$baseGet(coll, path);
    return $596c8c2a35922d3c$var$i.assocIn(coll, path, callback(existingVal));
};
// generate wrappers for the mutative array methods
[
    'push',
    'unshift',
    'pop',
    'shift',
    'reverse',
    'sort'
].forEach((methodName)=>{
    module.exports[methodName] = function(arr, val) {
        const newArr = [
            ...arr
        ];
        newArr[methodName]($596c8c2a35922d3c$var$freezeIfNeeded(val));
        return $596c8c2a35922d3c$var$_freeze(newArr);
    };
    module.exports[methodName].displayName = 'icepick.' + methodName;
});
// splice is special because it is variadic
module.exports.splice = function splice(arr, ..._args) {
    const newArr = [
        ...arr
    ];
    const args = _args.map($596c8c2a35922d3c$var$freezeIfNeeded);
    newArr.splice.apply(newArr, args);
    return $596c8c2a35922d3c$var$_freeze(newArr);
};
// slice is non-mutative
module.exports.slice = function slice(arr, arg1, arg2) {
    const newArr = arr.slice(arg1, arg2);
    return $596c8c2a35922d3c$var$_freeze(newArr);
};
[
    'map',
    'filter'
].forEach((methodName)=>{
    module.exports[methodName] = function(fn, arr) {
        const newArr = arr[methodName](fn);
        return $596c8c2a35922d3c$var$_freeze(newArr);
    };
    module.exports[methodName].displayName = 'icepick.' + methodName;
});
module.exports.extend = module.exports.assign = function assign(obj, ...objs) {
    const newObj = objs.reduce($596c8c2a35922d3c$var$singleAssign, obj);
    return $596c8c2a35922d3c$var$_freeze(newObj);
};
function $596c8c2a35922d3c$var$singleAssign(obj1, obj2) {
    return Object.keys(obj2).reduce((obj, key)=>{
        return $596c8c2a35922d3c$var$i.assoc(obj, key, obj2[key]);
    }, obj1);
}
module.exports.merge = $596c8c2a35922d3c$var$merge;
function $596c8c2a35922d3c$var$merge(target, source, resolver) {
    if (target == null || source == null) return target;
    return Object.keys(source).reduce((obj, key)=>{
        const sourceVal = source[key];
        const targetVal = obj[key];
        const resolvedSourceVal = resolver ? resolver(targetVal, sourceVal, key) : sourceVal;
        if ($596c8c2a35922d3c$var$weCareAbout(sourceVal) && $596c8c2a35922d3c$var$weCareAbout(targetVal)) {
            // if they are both frozen and reference equal, assume they are deep equal
            if (resolvedSourceVal === targetVal && true) return obj;
            if (Array.isArray(sourceVal)) return $596c8c2a35922d3c$var$i.assoc(obj, key, resolvedSourceVal);
            // recursively merge pairs of objects
            return $596c8c2a35922d3c$var$assocIfDifferent(obj, key, $596c8c2a35922d3c$var$merge(targetVal, resolvedSourceVal, resolver));
        }
        // primitive values, stuff with prototypes
        return $596c8c2a35922d3c$var$assocIfDifferent(obj, key, resolvedSourceVal);
    }, target);
}
function $596c8c2a35922d3c$var$assocIfDifferent(target, key, value) {
    if (target[key] === value) return target;
    return $596c8c2a35922d3c$var$i.assoc(target, key, value);
}
const $596c8c2a35922d3c$var$chainProto = {
    value: function value() {
        return this.val;
    },
    thru: function thru(fn) {
        this.val = $596c8c2a35922d3c$var$freezeIfNeeded(fn(this.val));
        return this;
    }
};
Object.keys(module.exports).forEach((methodName)=>{
    if (methodName.match(/^(map|filter)$/)) {
        $596c8c2a35922d3c$var$chainProto[methodName] = function(fn) {
            this.val = module.exports[methodName](fn, this.val);
            return this;
        };
        return;
    }
    $596c8c2a35922d3c$var$chainProto[methodName] = function(...args) {
        this.val = module.exports[methodName](this.val, ...args);
        return this;
    };
});
module.exports.chain = function chain(val) {
    const wrapped = Object.create($596c8c2a35922d3c$var$chainProto);
    wrapped.val = val;
    return wrapped;
};

});

parcelRegister("8pwuw", function(module, exports) {

$parcel$export(module.exports, "default", () => $d3b0bf5f9968d72a$export$2e2bcd8739ae039);
/**
 * One field validation error
 */ class $d3b0bf5f9968d72a$var$ExtensibleError extends Error {
    constructor(message){
        super(message);
        this.message = message;
        this.name = this.constructor.name;
        if (typeof Error.captureStackTrace === 'function') Error.captureStackTrace(this, this.constructor);
        else this.stack = new Error(message).stack;
    }
}
class $d3b0bf5f9968d72a$export$2191b9da168c6cf0 extends $d3b0bf5f9968d72a$var$ExtensibleError {
    constructor(message, errors = []){
        super(message);
        this.errors = errors;
    }
}
class $d3b0bf5f9968d72a$export$2e2bcd8739ae039 extends $d3b0bf5f9968d72a$var$ExtensibleError {
    constructor(statusCode, message){
        super(message || `Fetch call failed with status code: ${statusCode}`);
        this.statusCode = statusCode;
    }
}

});

const $98318a085d858628$export$ff39ebd4bb12b718 = 201;
const $98318a085d858628$export$3288b14b6745c572 = 204;
const $98318a085d858628$export$9de493bcd9b1d977 = 400;
const $98318a085d858628$export$67d19e9a991baa07 = 401;
const $98318a085d858628$export$a3269a3914b007e3 = 403;
const $98318a085d858628$export$8bca792d963eb0ef = 404;
const $98318a085d858628$export$e813cd7045fcc98d = 500;


const $9d339e91f7cbd39e$export$400f359cf7604d7a = 'project-pages';
const $9d339e91f7cbd39e$export$e776c72d9769c47a = 'project-pages';


parcelRegister("lCxMA", function(module, exports) {

$parcel$export(module.exports, "default", () => $63100476422309c5$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $63100476422309c5$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    description: {
        id: 'project-pages.connect-space-dialog.content.space-or-page-selector.description',
        defaultMessage: 'Choose a space or item to connect to your project.',
        description: 'Description of the modal dialog to link a Confluence space or item to a Jira project'
    },
    placeholder: {
        id: 'project-pages.connect-space-dialog.content.space-or-page-selector.placeholder',
        defaultMessage: 'Search Confluence',
        description: 'Placeholder to search a space or a item in Confluence to link to a Jira project'
    },
    'disconnected-templates-description': {
        id: 'project-pages.connect-space-dialog.content.space-selector.disconnected-templates-description',
        defaultMessage: 'This project needs to be connected to a space before you can create an item. Choose a space to connect to this project.',
        description: ''
    },
    searchLabel: {
        id: 'project-pages.connect-space-dialog.content.space-or-page-selector.search-label',
        defaultMessage: 'Search confluence space or page',
        description: 'Label to search a space or a item in Confluence to link to a Jira project'
    }
});

});

parcelRegister("gMHWX", function(module, exports) {

$parcel$export(module.exports, "AnalyticsEventToProps", () => $f2962728463d9ffe$export$3e9ef96ba97ea9dc);

var $dPSWJ = parcelRequire("dPSWJ");

var $cb25w = parcelRequire("cb25w");
const $f2962728463d9ffe$export$871de8747c9eaa88 = (callbacks, componentName)=>(0, (/*@__PURE__*/$parcel$interopDefault($dPSWJ)))(callbacks, (value)=>({
            action: value,
            actionSubject: componentName
        }));
const $f2962728463d9ffe$export$3e9ef96ba97ea9dc = (componentName, eventActions)=>(WrappedComponent)=>// @ts-ignore
        (0, $cb25w.default)($f2962728463d9ffe$export$871de8747c9eaa88(eventActions, componentName))(WrappedComponent);

});


parcelRegister("6L3iv", function(module, exports) {

$parcel$export(module.exports, "getProject", () => $42267cc7ded2b410$export$637b60a42bb03f06);
$parcel$export(module.exports, "getProjectKey", () => $42267cc7ded2b410$export$667f2a0f99c75faa);
$parcel$export(module.exports, "getProjectId", () => $42267cc7ded2b410$export$89040d072f281f85);
$parcel$export(module.exports, "getProjectType", () => $42267cc7ded2b410$export$3dd0da95519c1a33);
$parcel$export(module.exports, "getProjectName", () => $42267cc7ded2b410$export$2cd058184eb75757);
$parcel$export(module.exports, "getIsProjectMember", () => $42267cc7ded2b410$export$bf22b096835a2b37);
const $42267cc7ded2b410$export$637b60a42bb03f06 = (state)=>state.project;
const $42267cc7ded2b410$export$667f2a0f99c75faa = (state)=>state.project.key;
const $42267cc7ded2b410$export$89040d072f281f85 = (state)=>state.project.id;
const $42267cc7ded2b410$export$3dd0da95519c1a33 = (state)=>state.project.type;
const $42267cc7ded2b410$export$2cd058184eb75757 = (state)=>state.project.name;
const $42267cc7ded2b410$export$bf22b096835a2b37 = (state)=>state.project.isMember;

});


parcelRegister("6oKBx", function(module, exports) {

$parcel$export(module.exports, "default", () => $34653981fb7861af$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $h8yj2 = parcelRequire("h8yj2");
class $34653981fb7861af$var$Content extends (0, $5uXOq.PureComponent) {
    render() {
        const { SpacePicker: SpacePicker, CreateSpaceLink: CreateSpaceLink, onCreateSpace: onCreateSpace, onSpaceSelected: onSpaceSelected } = this.props;
        return /*#__PURE__*/ (0, $2OMIu.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0, $2OMIu.jsx)(SpacePicker, {
                    onSelected: (value, analyticsEvent)=>{
                        (0, $h8yj2.fireUIAnalytics)(analyticsEvent, 'spaceSelectedSpacePicker', {
                            isPageSelected: value.isPage
                        });
                        onSpaceSelected(value);
                    }
                }),
                /*#__PURE__*/ (0, $2OMIu.jsx)(CreateSpaceLink, {
                    onCreateSpace: (analyticsEvent)=>{
                        (0, $h8yj2.fireUIAnalytics)(analyticsEvent, 'createdSpaceButton');
                        onCreateSpace();
                    }
                })
            ]
        });
    }
}
var $34653981fb7861af$export$2e2bcd8739ae039 = $34653981fb7861af$var$Content;

});


parcelRegister("f5mRw", function(module, exports) {

$parcel$export(module.exports, "default", () => $785f9b6574904a29$export$2e2bcd8739ae039);

var $7Z8iG = parcelRequire("7Z8iG");

var $aPZf4 = parcelRequire("aPZf4");

var $2ja74 = parcelRequire("2ja74");

var $xQdRb = parcelRequire("xQdRb");
var $785f9b6574904a29$export$2e2bcd8739ae039 = (0, $7Z8iG.connect)((state)=>({
        errorState: (0, $2ja74.getConnectSpaceDialogErrorState)(state),
        isSubmitAllowed: (0, $2ja74.isSubmitAllowed)(state),
        isSubmitting: (0, $2ja74.isConnectingSpace)(state),
        selectedSpace: (0, $2ja74.getSelectedSpace)(state)
    }), (dispatch)=>({
        onFetch: ()=>dispatch((0, $aPZf4.fetchConfluenceSpaces)()),
        onConnect: ()=>dispatch((0, $aPZf4.connectConfluenceSpace)()),
        onCancel: ()=>dispatch((0, $aPZf4.hideConnectSpaceDialog)())
    }))((0, $xQdRb.default));

});
parcelRegister("xQdRb", function(module, exports) {

$parcel$export(module.exports, "default", () => $a0fa1784a96b8ee1$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $8RXs9 = parcelRequire("8RXs9");

var $ldJSL = parcelRequire("ldJSL");

var $fVnbM = parcelRequire("fVnbM");
var $2rqOp = parcelRequire("2rqOp");


var $hMVoD = parcelRequire("hMVoD");

var $7NFSF = parcelRequire("7NFSF");


var $h8yj2 = parcelRequire("h8yj2");

var $cvGlc = parcelRequire("cvGlc");
const $a0fa1784a96b8ee1$var$Footer = ({ isSubmitAllowed: isSubmitAllowed, isSubmitting: isSubmitting, errorState: errorState, selectedSpace: selectedSpace, onFetch: onFetch, onConnect: onConnect, onCancel: onCancel, intl: { formatMessage: formatMessage } })=>{
    const [hasError, setHasError] = (0, $5uXOq.useState)(false);
    (0, $5uXOq.useEffect)(()=>{
        const test = errorState === (0, $0a265941174d8dd0$export$f5569b14a81f6409) || errorState === (0, $0a265941174d8dd0$export$a71624947af1f122) || false;
        setHasError(test);
    }, [
        errorState
    ]);
    const handleSubmit = (analyticsEvent)=>{
        const isPageSelected = selectedSpace?.isPage;
        if (errorState === (0, $0a265941174d8dd0$export$f5569b14a81f6409)) {
            onConnect();
            (0, $h8yj2.fireUIAnalytics)(analyticsEvent, 'retryConnectButton', {
                isPageSelected: isPageSelected
            });
        } else if (errorState === (0, $0a265941174d8dd0$export$a71624947af1f122)) {
            onFetch();
            (0, $h8yj2.fireUIAnalytics)(analyticsEvent, 'retryFetchButton', {
                isPageSelected: isPageSelected
            });
        } else {
            onConnect();
            (0, $h8yj2.fireUIAnalytics)(analyticsEvent, 'connectButton', {
                isPageSelected: isPageSelected
            });
        }
    };
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $cvGlc.Container), {
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $cvGlc.WrappedError), {
                children: [
                    hasError && /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($hMVoD))), {
                        spacing: "spacious",
                        label: formatMessage((0, $7NFSF.default).error),
                        color: `var(--ds-icon-danger, ${(0, $829f609a65d26a98$export$2010d0fb4295b346)})`
                    }),
                    hasError && formatMessage((0, $7NFSF.default).connectionError)
                ]
            }),
            /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $ldJSL.default), {
                children: [
                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fVnbM.default), {
                        appearance: "link",
                        isDisabled: isSubmitting,
                        onClick: (_, analyticsEvent)=>{
                            onCancel();
                            (0, $h8yj2.fireUIAnalytics)(analyticsEvent, 'cancelButton');
                        },
                        children: formatMessage((0, $7NFSF.default).cancel)
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2rqOp.default), {
                        "data-test-id": "confluence-project-pages.post-expand.connect-or-update-space-modal.connect-button",
                        appearance: "primary",
                        isLoading: isSubmitting,
                        isDisabled: !isSubmitAllowed,
                        onClick: (_, analyticsEvent)=>handleSubmit(analyticsEvent),
                        children: hasError ? formatMessage((0, $7NFSF.default).retry) : formatMessage((0, $7NFSF.default).connectSpace)
                    })
                ]
            })
        ]
    });
};
var $a0fa1784a96b8ee1$export$2e2bcd8739ae039 = (0, $8RXs9.default)($a0fa1784a96b8ee1$var$Footer);

});
parcelRegister("7NFSF", function(module, exports) {

$parcel$export(module.exports, "default", () => $ec498d2b05b80fc6$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $ec498d2b05b80fc6$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    connectSpace: {
        id: 'project-pages.connect-space-dialog.footer.connect-space',
        defaultMessage: 'Connect',
        description: ''
    },
    cancel: {
        id: 'project-pages.connect-space-dialog.footer.cancel',
        defaultMessage: 'Cancel',
        description: ''
    },
    error: {
        id: 'project-pages.connect-space-dialog.error-icon',
        defaultMessage: 'Error:',
        description: ''
    },
    connectionError: {
        id: 'project-pages.connect-space-dialog.connection-error',
        defaultMessage: 'Connection failed.',
        description: ''
    },
    retry: {
        id: 'project-pages.connect-space-dialog.connection-retry',
        defaultMessage: 'Retry',
        description: ''
    }
});

});

const $0a265941174d8dd0$export$f5569b14a81f6409 = 'CONNECT_ERROR';
const $0a265941174d8dd0$export$a71624947af1f122 = 'FETCH_ERROR';
const $0a265941174d8dd0$export$2841857f996c7c26 = 'NO_ERROR';

parcelRegister("cvGlc", function(module, exports) {

$parcel$export(module.exports, "Container", () => $e33e3821018af8f4$export$42a852a2b6b56249);
$parcel$export(module.exports, "WrappedError", () => $e33e3821018af8f4$export$16ae3e28e3481b64);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $47bDC = parcelRequire("47bDC");

const $e33e3821018af8f4$export$42a852a2b6b56249 = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "sc-30h76f-0"
})({
    display: 'flex',
    justifyContent: 'space-between'
});
const $e33e3821018af8f4$export$16ae3e28e3481b64 = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "sc-30h76f-1"
})({
    display: 'flex',
    alignItems: 'center',
    color: `var(--ds-text-subtlest, ${(0, $829f609a65d26a98$export$f563ee71e9ee74cd)})`,
    font: "var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
});

});



parcelRegister("bTJtJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $a57b55b7d0690b0e$export$2e2bcd8739ae039);

var $6k863 = parcelRequire("6k863");
var $a57b55b7d0690b0e$export$2e2bcd8739ae039 = (0, $6k863.default);

});
parcelRegister("6k863", function(module, exports) {

$parcel$export(module.exports, "default", () => $c5c97685f012d366$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $8RXs9 = parcelRequire("8RXs9");

var $jyrn4 = parcelRequire("jyrn4");

var $l1N8i = parcelRequire("l1N8i");
const $c5c97685f012d366$var$Header = ({ intl: { formatMessage: formatMessage } })=>// eslint-disable-next-line @atlaskit/design-system/use-heading
    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $l1N8i.default), {
        size: "large",
        as: "h2",
        children: formatMessage((0, $jyrn4.default).title)
    });
var $c5c97685f012d366$export$2e2bcd8739ae039 = (0, $8RXs9.default)($c5c97685f012d366$var$Header);

});
parcelRegister("jyrn4", function(module, exports) {

$parcel$export(module.exports, "default", () => $249b55fc03b11060$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $249b55fc03b11060$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    title: {
        id: 'project-pages.connect-space-or-page-dialog.header.title',
        defaultMessage: 'Connect project to Confluence',
        description: 'Title to connect a Jira project to Confluence'
    }
});

});



parcelRegister("cMf5W", function(module, exports) {

$parcel$export(module.exports, "default", () => $95733538bd157714$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $7QSqG = parcelRequire("7QSqG");
var $juxqI = parcelRequire("juxqI");
var $jgVsb = parcelRequire("jgVsb");

var $47bDC = parcelRequire("47bDC");

var $16DSo = parcelRequire("16DSo");

var $RzR6m = parcelRequire("RzR6m");

var $jkADf = parcelRequire("jkADf");
var $h8yj2 = parcelRequire("h8yj2");
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $95733538bd157714$var$FullWidthContainer = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "sc-1ygglpx-0"
})({
    width: '100%'
});
class $95733538bd157714$var$ConnectSpaceDialog extends (0, $5uXOq.PureComponent) {
    static{
        this.defaultProps = {
            ModalDialog: null
        };
    }
    constructor(props){
        super(props), this.onDismissed = (_, analyticsEvent)=>{
            const { onCancel: onCancel } = this.props;
            onCancel && onCancel();
            (0, $h8yj2.fireUIAnalytics)(analyticsEvent, 'dismissedModalDialog');
        };
        const { ModalDialog: ModalDialog } = props;
        this.ModalDialogImpl = (0, $16DSo.default)('connectSpaceModal', ModalDialog);
    }
    render() {
        const { Header: Header, Content: Content, Footer: Footer, isOpen: isOpen } = this.props;
        // eslint-disable-next-line no-undef
        if (false) return null;
        return isOpen && /*#__PURE__*/ (0, $2OMIu.jsx)("form", {
            children: /*#__PURE__*/ (0, $2OMIu.jsxs)(this.ModalDialogImpl, {
                width: 'small',
                shouldCloseOnEscapePress: true,
                onClose: this.onDismissed,
                children: [
                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $jgVsb.default), {
                        children: /*#__PURE__*/ (0, $2OMIu.jsx)($95733538bd157714$var$FullWidthContainer, {
                            children: /*#__PURE__*/ (0, $2OMIu.jsx)(Header, {})
                        })
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7QSqG.default), {
                        children: /*#__PURE__*/ (0, $2OMIu.jsx)(Content, {})
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $juxqI.default), {
                        children: /*#__PURE__*/ (0, $2OMIu.jsx)($95733538bd157714$var$FullWidthContainer, {
                            children: /*#__PURE__*/ (0, $2OMIu.jsx)(Footer, {})
                        })
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $RzR6m.default), {})
                ]
            })
        });
    }
}
var $95733538bd157714$export$2e2bcd8739ae039 = (props)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $jkADf.ContextWrapper), {
        sourceName: "connectSpace",
        sourceType: (0, $6e65040b988c460f$export$1171103ea9083ffa),
        children: /*#__PURE__*/ (0, $2OMIu.jsx)($95733538bd157714$var$ConnectSpaceDialog, {
            ...props
        })
    });

});
parcelRegister("16DSo", function(module, exports) {

$parcel$export(module.exports, "default", () => $2d4b2e132679ac29$export$2e2bcd8739ae039);

var $994MI = parcelRequire("994MI");

var $1R1Ge = parcelRequire("1R1Ge");
var $2d4b2e132679ac29$export$2e2bcd8739ae039 = (name, Component)=>(0, $994MI.default)({
        componentName: name
    })(Component || (0, $1R1Ge.default));

});

parcelRegister("RzR6m", function(module, exports) {

$parcel$export(module.exports, "default", () => $9183aee3dda4dd97$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $h8yj2 = parcelRequire("h8yj2");
var $2qeLn = parcelRequire("2qeLn");
const $9183aee3dda4dd97$var$ViewTracker = ()=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $2qeLn.MountEvent), {
        onMount: (analyticsEvent)=>(0, $h8yj2.fireScreenAnalytics)(analyticsEvent)
    });
var $9183aee3dda4dd97$export$2e2bcd8739ae039 = $9183aee3dda4dd97$var$ViewTracker;

});
parcelRegister("2qeLn", function(module, exports) {

$parcel$export(module.exports, "MountEvent", () => $dd825bb1ea271f94$export$2c6963927dbc68f1);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $cb25w = parcelRequire("cb25w");
class $dd825bb1ea271f94$var$MountEventComponent extends (0, $5uXOq.Component) {
    componentDidMount() {
        const analyticsEvent = this.props.createAnalyticsEvent({
            action: 'mounted'
        });
        if (this.props.onMount) this.props.onMount(analyticsEvent);
    }
    render() {
        return null;
    }
}
const $dd825bb1ea271f94$var$MountEventComponentWithHOC = (0, $cb25w.default)()($dd825bb1ea271f94$var$MountEventComponent);
const $dd825bb1ea271f94$export$2c6963927dbc68f1 = (props)=>/*#__PURE__*/ (0, $2OMIu.jsx)($dd825bb1ea271f94$var$MountEventComponentWithHOC, {
        ...props
    });

});


parcelRegister("jkADf", function(module, exports) {

$parcel$export(module.exports, "ContextWrapper", () => $e64f0f96877c6709$export$34282a1f95511a11);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $cjFoH = parcelRequire("cjFoH");

var $9xWGk = parcelRequire("9xWGk");

var $daJ0i = parcelRequire("daJ0i");
const $e64f0f96877c6709$export$dc30f43798194b03 = (props)=>{
    const { children: children, sourceName: sourceName, sourceType: sourceType, ...rest } = props;
    const source = sourceName && sourceType ? `${sourceName}${sourceType}` : undefined;
    return (0, (/*@__PURE__*/$parcel$interopDefault($9xWGk)))({
        source: source,
        ...rest
    }, (0, (/*@__PURE__*/$parcel$interopDefault($cjFoH))));
};
const $e64f0f96877c6709$export$34282a1f95511a11 = (props)=>{
    const data = $e64f0f96877c6709$export$dc30f43798194b03(props);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $daJ0i.default), {
        data: data,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {
            children: props.children
        })
    });
};

});

const $6e65040b988c460f$export$f636b5b56f1d624a = 'Screen';
const $6e65040b988c460f$export$9d2de6eebf7462b5 = 'Drawer';
const $6e65040b988c460f$export$1171103ea9083ffa = 'Modal';
const $6e65040b988c460f$export$cae2783c9279926 = 'InlineDialog';
const $6e65040b988c460f$export$d1123261ca8831d2 = 'Dropdown';
const $6e65040b988c460f$export$a1562d08625f5d7e = 'UI';
const $6e65040b988c460f$export$947dac6c72b26f81 = 'TRACK';
const $6e65040b988c460f$export$f1d537d508d2945a = 'SCREEN';
const $6e65040b988c460f$export$12346a674644c156 = 'OPERATIONAL';
const $6e65040b988c460f$export$2ceccf177fae277c = 'analyticsBridge';



parcelRegister("4NQC3", function(module, exports) {

$parcel$export(module.exports, "default", () => $ad94e47b9a0a736d$export$2e2bcd8739ae039);

var $7Z8iG = parcelRequire("7Z8iG");

var $b7YHH = parcelRequire("b7YHH");

var $aunVv = parcelRequire("aunVv");

var $kP0ZM = parcelRequire("kP0ZM");

var $58x0x = parcelRequire("58x0x");

var $2xQQl = parcelRequire("2xQQl");
const $ad94e47b9a0a736d$var$mapStateToProps = (state)=>({
        Header: $58x0x.default,
        Content: $aunVv.default,
        Footer: $kP0ZM.default,
        isOpen: (0, $b7YHH.isCreateSpaceDialogOpen)(state)
    });
var $ad94e47b9a0a736d$export$2e2bcd8739ae039 = (0, $7Z8iG.connect)($ad94e47b9a0a736d$var$mapStateToProps)((0, $2xQQl.default));

});
parcelRegister("b7YHH", function(module, exports) {

$parcel$export(module.exports, "isCreateSpaceDialogOpen", () => $6c74faa566eaad0a$export$9e106e7a4197025c);
$parcel$export(module.exports, "getCreateSpaceDialogErrorState", () => $6c74faa566eaad0a$export$b9a0f0708810ac97);
$parcel$export(module.exports, "isCreatingSpace", () => $6c74faa566eaad0a$export$83088c344f79a64b);
$parcel$export(module.exports, "isGeneratingKey", () => $6c74faa566eaad0a$export$80d139ccc3bd3ca3);
$parcel$export(module.exports, "isUserEnteredSpaceNameInvalid", () => $6c74faa566eaad0a$export$d91e14355a533343);
$parcel$export(module.exports, "getUserEnteredSpaceName", () => $6c74faa566eaad0a$export$f3d7f5a7926550e9);
const $6c74faa566eaad0a$export$9e106e7a4197025c = (state)=>state.ui.createSpaceDialog.createSpaceDialogOpen;
const $6c74faa566eaad0a$export$b9a0f0708810ac97 = (state)=>state.ui.createSpaceDialog.createSpaceDialogErrorState;
const $6c74faa566eaad0a$export$83088c344f79a64b = (state)=>state.ui.createSpaceDialog.creatingSpace;
const $6c74faa566eaad0a$export$80d139ccc3bd3ca3 = (state)=>state.ui.createSpaceDialog.generatingKey;
const $6c74faa566eaad0a$export$d91e14355a533343 = (state)=>state.ui.createSpaceDialog.userEnteredSpaceNameInvalid;
const $6c74faa566eaad0a$export$f3d7f5a7926550e9 = (state)=>state.ui.createSpaceDialog.userEnteredSpaceName;

});

parcelRegister("aunVv", function(module, exports) {

$parcel$export(module.exports, "default", () => $e6dd8f24fc1d2dd7$export$2e2bcd8739ae039);

var $7Z8iG = parcelRequire("7Z8iG");

var $aPZf4 = parcelRequire("aPZf4");

var $kwnxt = parcelRequire("kwnxt");

var $b7YHH = parcelRequire("b7YHH");

var $1eQ32 = parcelRequire("1eQ32");
const $e6dd8f24fc1d2dd7$var$mapStateToProps = (state)=>({
        spaceNameInvalid: (0, $b7YHH.isUserEnteredSpaceNameInvalid)(state),
        userEnteredSpaceName: (0, $b7YHH.getUserEnteredSpaceName)(state),
        isCreatingSpace: (0, $b7YHH.isCreatingSpace)(state)
    });
const $e6dd8f24fc1d2dd7$var$mapDispatchToProps = (dispatch)=>({
        onSpaceNameChanged: (value)=>dispatch((0, $aPZf4.changeSpaceName)(value)),
        onCreate: ()=>dispatch((0, $kwnxt.createConfluenceSpace)())
    });
var $e6dd8f24fc1d2dd7$export$2e2bcd8739ae039 = (0, $7Z8iG.connect)($e6dd8f24fc1d2dd7$var$mapStateToProps, $e6dd8f24fc1d2dd7$var$mapDispatchToProps)((0, $1eQ32.default));

});
parcelRegister("kwnxt", function(module, exports) {

$parcel$export(module.exports, "CREATE_CONFLUENCE_SPACE", () => $54999c127757d4a1$export$cbaa153fef1dd1f1);
$parcel$export(module.exports, "createConfluenceSpace", () => $54999c127757d4a1$export$c9aee4801cf839af);
$parcel$export(module.exports, "CREATE_CONFLUENCE_SPACE_ERROR", () => $54999c127757d4a1$export$f2e869db106e2af3);
$parcel$export(module.exports, "createConfluenceSpaceError", () => $54999c127757d4a1$export$99a7810842156751);
const $54999c127757d4a1$export$cbaa153fef1dd1f1 = 'CREATE_CONFLUENCE_SPACE';
const $54999c127757d4a1$export$c9aee4801cf839af = (autoCreated)=>({
        type: $54999c127757d4a1$export$cbaa153fef1dd1f1,
        autoCreated: autoCreated
    });
const $54999c127757d4a1$export$f2e869db106e2af3 = 'CREATE_CONFLUENCE_SPACE_ERROR';
const $54999c127757d4a1$export$99a7810842156751 = ()=>({
        type: $54999c127757d4a1$export$f2e869db106e2af3
    });

});

parcelRegister("1eQ32", function(module, exports) {

$parcel$export(module.exports, "default", () => $4f4e4d70d6eaf28c$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $8RXs9 = parcelRequire("8RXs9");

var $47bDC = parcelRequire("47bDC");

var $kY99m = parcelRequire("kY99m");

var $qfj8c = parcelRequire("qfj8c");

var $dqtYz = parcelRequire("dqtYz");
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/design-system/no-styled-tagged-template-expression -- Ignored via go/DSP-18766
const $4f4e4d70d6eaf28c$var$Container = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "sc-1w2omun-0"
})`margin-top:${"var(--ds-space-100, 8px)"};`;
class $4f4e4d70d6eaf28c$var$Content extends (0, $5uXOq.PureComponent) {
    render() {
        const { intl: { formatMessage: formatMessage }, isCreatingSpace: isCreatingSpace, spaceNameInvalid: spaceNameInvalid, userEnteredSpaceName: userEnteredSpaceName, onSpaceNameChanged: onSpaceNameChanged } = this.props;
        return /*#__PURE__*/ (0, $2OMIu.jsx)($4f4e4d70d6eaf28c$var$Container, {
            children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $5uXOq.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $kY99m.default), {
                        autoFocus: true,
                        isDisabled: isCreatingSpace,
                        placeholder: formatMessage((0, $dqtYz.default).placeholder),
                        onChange: (input)=>onSpaceNameChanged(input.target.value),
                        onKeyPress: this.handleKeyPress,
                        isInvalid: spaceNameInvalid,
                        value: userEnteredSpaceName,
                        label: "",
                        maxLength: 80,
                        "data-test-id": "confluence-project-pages.post-expand.create-space-modal.name-entry"
                    }),
                    spaceNameInvalid && this.renderAppropriateInvalidMessage()
                ]
            })
        });
    }
    constructor(...args){
        super(...args), this.handleKeyPress = ({ key: key })=>{
            const { onCreate: onCreate, userEnteredSpaceName: userEnteredSpaceName } = this.props;
            const containsAtLeastTwoAlphanumericValues = (str)=>/[a-zA-Z0-9]{2,}/g.test(str);
            if (key === 'Enter' && containsAtLeastTwoAlphanumericValues(userEnteredSpaceName)) onCreate();
        }, this.renderAppropriateInvalidMessage = ()=>{
            const { intl: { formatMessage: formatMessage }, userEnteredSpaceName: userEnteredSpaceName } = this.props;
            return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $qfj8c.ErrorMessage), {
                children: formatMessage(userEnteredSpaceName.length < 1 ? (0, $dqtYz.default).emptyName : (0, $dqtYz.default).invalidName)
            });
        };
    }
}
var $4f4e4d70d6eaf28c$export$2e2bcd8739ae039 = (0, $8RXs9.default)($4f4e4d70d6eaf28c$var$Content);

});
parcelRegister("dqtYz", function(module, exports) {

$parcel$export(module.exports, "default", () => $c8c3ed5ca06b2f00$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $c8c3ed5ca06b2f00$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    placeholder: {
        id: 'project-pages.create-space-dialog.content.placeholder',
        defaultMessage: 'Enter a space name',
        description: ''
    },
    emptyName: {
        id: 'project-pages.create-space-dialog.content.empty-name',
        defaultMessage: 'Please give your space a name.',
        description: ''
    },
    invalidName: {
        id: 'project-pages.create-space-dialog.content.invalid-name',
        defaultMessage: 'Space names require at least one letter or number.',
        description: ''
    }
});

});



parcelRegister("kP0ZM", function(module, exports) {

$parcel$export(module.exports, "default", () => $9afd908dc2fd282f$export$2e2bcd8739ae039);

var $7Z8iG = parcelRequire("7Z8iG");

var $aPZf4 = parcelRequire("aPZf4");

var $kwnxt = parcelRequire("kwnxt");

var $9MB7L = parcelRequire("9MB7L");

var $b7YHH = parcelRequire("b7YHH");

var $wrbBU = parcelRequire("wrbBU");
const $9afd908dc2fd282f$export$c31df4bd766f9c35 = (state)=>({
        isCreatingSpace: (0, $b7YHH.isCreatingSpace)(state),
        isGeneratingKey: (0, $b7YHH.isGeneratingKey)(state),
        suggestedKey: (0, $9MB7L.getSuggestedKey)(state),
        userEnteredSpaceName: (0, $b7YHH.getUserEnteredSpaceName)(state),
        userEnteredSpaceNameInvalid: (0, $b7YHH.isUserEnteredSpaceNameInvalid)(state),
        errorState: (0, $b7YHH.getCreateSpaceDialogErrorState)(state)
    });
const $9afd908dc2fd282f$export$9e6a17cf56877796 = (dispatch)=>({
        onSpaceNameChanged: (value)=>dispatch((0, $aPZf4.changeSpaceName)(value)),
        onCreate: ()=>dispatch((0, $kwnxt.createConfluenceSpace)())
    });
var $9afd908dc2fd282f$export$2e2bcd8739ae039 = (0, $7Z8iG.connect)($9afd908dc2fd282f$export$c31df4bd766f9c35, $9afd908dc2fd282f$export$9e6a17cf56877796)((0, $wrbBU.default));

});
parcelRegister("wrbBU", function(module, exports) {

$parcel$export(module.exports, "default", () => $157010612024a30b$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $8RXs9 = parcelRequire("8RXs9");

var $47bDC = parcelRequire("47bDC");

var $ldJSL = parcelRequire("ldJSL");

var $fVnbM = parcelRequire("fVnbM");

var $hMVoD = parcelRequire("hMVoD");

var $eZJjh = parcelRequire("eZJjh");



var $h8yj2 = parcelRequire("h8yj2");

var $9GIh0 = parcelRequire("9GIh0");
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $157010612024a30b$var$Container = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "sc-1or2l73-0"
})({
    display: 'flex',
    justifyContent: 'flex-end'
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $157010612024a30b$var$WrappedErrorIcon = /*#__PURE__*/ (0, $47bDC.default)((0, (/*@__PURE__*/$parcel$interopDefault($hMVoD)))).withConfig({
    componentId: "sc-1or2l73-1"
})({
    marginRight: "var(--ds-space-100, 8px)"
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $157010612024a30b$var$ConnectionFailed = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "sc-1or2l73-2"
})({
    alignItems: 'center',
    color: `var(--ds-text-subtlest, ${(0, $829f609a65d26a98$export$f563ee71e9ee74cd)})`,
    display: 'flex',
    font: "var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
});
// eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $157010612024a30b$var$SpinnerDiv = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "sc-1or2l73-3"
})({
    display: 'inline-block',
    marginRight: "var(--ds-space-100, 8px)",
    position: 'relative',
    top: "var(--ds-space-075, 6px)"
});
class $157010612024a30b$var$Footer extends (0, $5uXOq.PureComponent) {
    static{
        this.defaultProps = {
            errorState: (0, $a96c0cdcf3ed13dc$export$2841857f996c7c26)
        };
    }
    render() {
        const { intl: { formatMessage: formatMessage } } = this.props;
        const { isCreatingSpace: isCreatingSpace, isGeneratingKey: isGeneratingKey, errorState: errorState, suggestedKey: suggestedKey, onSpaceNameChanged: onSpaceNameChanged, onCreate: onCreate, onCancel: onCancel, userEnteredSpaceName: userEnteredSpaceName, userEnteredSpaceNameInvalid: userEnteredSpaceNameInvalid } = this.props;
        return /*#__PURE__*/ (0, $2OMIu.jsxs)($157010612024a30b$var$Container, {
            children: [
                errorState === (0, $a96c0cdcf3ed13dc$export$d822474b2a7c6d59) && this.renderConnectionError((analyticsEvent)=>{
                    onSpaceNameChanged(userEnteredSpaceName);
                    (0, $h8yj2.fireUIAnalytics)(analyticsEvent, 'retrySpaceNameChangeButton');
                }),
                errorState === (0, $a96c0cdcf3ed13dc$export$58e5d3e30f50fa06) && this.renderConnectionError((analyticsEvent)=>{
                    onCreate();
                    (0, $h8yj2.fireUIAnalytics)(analyticsEvent, 'retrySpaceNameChangeButton');
                }),
                (isCreatingSpace || isGeneratingKey) && /*#__PURE__*/ (0, $2OMIu.jsx)($157010612024a30b$var$SpinnerDiv, {
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eZJjh.default), {
                        size: "small"
                    })
                }),
                /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $ldJSL.default), {
                    children: [
                        /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fVnbM.default), {
                            appearance: "link",
                            isDisabled: isCreatingSpace,
                            onClick: (_, analyticsEvent)=>{
                                (0, $h8yj2.fireUIAnalytics)(analyticsEvent, 'cancelButton');
                                onCancel();
                            },
                            children: formatMessage((0, $9GIh0.default).cancel)
                        }),
                        /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fVnbM.default), {
                            appearance: "primary",
                            isDisabled: userEnteredSpaceNameInvalid || !suggestedKey || isCreatingSpace || isGeneratingKey,
                            onClick: (_, analyticsEvent)=>{
                                (0, $h8yj2.fireUIAnalytics)(analyticsEvent, 'createButton');
                                onCreate();
                            },
                            "data-test-id": "confluence-project-pages.post-expand.create-space-modal.create-button",
                            children: formatMessage((0, $9GIh0.default).createSpace)
                        })
                    ]
                })
            ]
        });
    }
    constructor(...args){
        super(...args), this.renderConnectionError = (onRetry)=>{
            const { intl: { formatMessage: formatMessage } } = this.props;
            return /*#__PURE__*/ (0, $2OMIu.jsxs)($157010612024a30b$var$ConnectionFailed, {
                children: [
                    /*#__PURE__*/ (0, $2OMIu.jsx)($157010612024a30b$var$WrappedErrorIcon, {
                        label: formatMessage((0, $9GIh0.default).error),
                        color: `var(--ds-icon-danger, ${(0, $829f609a65d26a98$export$2010d0fb4295b346)})`
                    }),
                    formatMessage((0, $9GIh0.default).connectionError),
                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fVnbM.default), {
                        // TODO: (from codemod) "link" and "subtle-link" appearances are only available in LinkButton, please either provide a href prop then migrate to LinkButton, or remove the appearance from the default button.
                        appearance: "link",
                        onClick: (event, analyticsEvent)=>{
                            onRetry(analyticsEvent);
                        },
                        children: formatMessage((0, $9GIh0.default).retry)
                    })
                ]
            });
        };
    }
}
var $157010612024a30b$export$2e2bcd8739ae039 = (0, $8RXs9.default)($157010612024a30b$var$Footer);

});
const $a96c0cdcf3ed13dc$export$2841857f996c7c26 = 'NO_ERROR';
const $a96c0cdcf3ed13dc$export$d822474b2a7c6d59 = 'KEY_ERROR';
const $a96c0cdcf3ed13dc$export$58e5d3e30f50fa06 = 'CREATE_ERROR';

parcelRegister("9GIh0", function(module, exports) {

$parcel$export(module.exports, "default", () => $e13136417387e773$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $e13136417387e773$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    createSpace: {
        id: 'project-pages.create-space-dialog.footer.create-space',
        defaultMessage: 'Create',
        description: ''
    },
    cancel: {
        id: 'project-pages.create-space-dialog.footer.cancel',
        defaultMessage: 'Cancel',
        description: ''
    },
    error: {
        id: 'project-pages.create-space-dialog.error-icon',
        defaultMessage: 'Error:',
        description: ''
    },
    connectionError: {
        id: 'project-pages.create-space-dialog.connection-error',
        defaultMessage: 'Connection failed.',
        description: ''
    },
    creationError: {
        id: 'project-pages.create-space-dialog.creation-error',
        defaultMessage: 'Space creation failed.',
        description: ''
    },
    retry: {
        id: 'project-pages.create-space-dialog.connection-retry',
        defaultMessage: 'Retry',
        description: ''
    }
});

});



parcelRegister("58x0x", function(module, exports) {

$parcel$export(module.exports, "default", () => $bb6be636f9f4b588$export$2e2bcd8739ae039);

var $h5iJT = parcelRequire("h5iJT");
var $bb6be636f9f4b588$export$2e2bcd8739ae039 = (0, $h5iJT.default);

});
parcelRegister("h5iJT", function(module, exports) {

$parcel$export(module.exports, "default", () => $dc034fb7af78308b$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $8RXs9 = parcelRequire("8RXs9");

var $1hytF = parcelRequire("1hytF");
// eslint-disable-next-line @atlaskit/design-system/use-heading
const $dc034fb7af78308b$var$Header = ({ intl: { formatMessage: formatMessage } })=>/*#__PURE__*/ (0, $2OMIu.jsx)("h3", {
        children: formatMessage((0, $1hytF.default).title)
    });
var $dc034fb7af78308b$export$2e2bcd8739ae039 = (0, $8RXs9.default)($dc034fb7af78308b$var$Header);

});
parcelRegister("1hytF", function(module, exports) {

$parcel$export(module.exports, "default", () => $e1f95ce84f79dff2$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $e1f95ce84f79dff2$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    title: {
        id: 'project-pages.create-space-dialog.header.title',
        defaultMessage: 'Create new Confluence space',
        description: ''
    }
});

});



parcelRegister("2xQQl", function(module, exports) {

$parcel$export(module.exports, "default", () => $ec00823514e26953$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $7QSqG = parcelRequire("7QSqG");
var $juxqI = parcelRequire("juxqI");
var $jgVsb = parcelRequire("jgVsb");

var $47bDC = parcelRequire("47bDC");

var $16DSo = parcelRequire("16DSo");

var $jkADf = parcelRequire("jkADf");
var $h8yj2 = parcelRequire("h8yj2");

var $RzR6m = parcelRequire("RzR6m");
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $ec00823514e26953$var$FullWidthContainer = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "sc-1qf4r6s-0"
})({
    width: '100%'
});
class $ec00823514e26953$var$CreateSpaceDialog extends (0, $5uXOq.PureComponent) {
    static{
        this.defaultProps = {
            ModalDialog: null
        };
    }
    constructor(props){
        super(props), this.onDismissed = (_, analyticsEvent)=>{
            const { onCancel: onCancel } = this.props;
            onCancel && onCancel();
            (0, $h8yj2.fireUIAnalytics)(analyticsEvent, 'dismissedModalDialog');
        };
        const { ModalDialog: ModalDialog } = props;
        this.ModalDialogImpl = (0, $16DSo.default)('createSpaceModal', ModalDialog);
    }
    render() {
        const { Header: Header, Content: Content, Footer: Footer, isOpen: isOpen, onCancel: onCancel, onOpenComplete: onOpenComplete } = this.props;
        // eslint-disable-next-line no-undef
        if (false) return null;
        return isOpen && /*#__PURE__*/ (0, $2OMIu.jsxs)(this.ModalDialogImpl, {
            onOpenComplete: onOpenComplete,
            width: 'small',
            shouldCloseOnEscapePress: true,
            onClose: this.onDismissed,
            children: [
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $jgVsb.default), {
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)($ec00823514e26953$var$FullWidthContainer, {
                        children: /*#__PURE__*/ (0, $2OMIu.jsx)(Header, {})
                    })
                }),
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7QSqG.default), {
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)(Content, {})
                }),
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $juxqI.default), {
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)($ec00823514e26953$var$FullWidthContainer, {
                        children: /*#__PURE__*/ (0, $2OMIu.jsx)(Footer, {
                            onCancel: onCancel
                        })
                    })
                }),
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $RzR6m.default), {})
            ]
        });
    }
}
var $ec00823514e26953$export$2e2bcd8739ae039 = (props)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $jkADf.ContextWrapper), {
        sourceName: "createSpace",
        sourceType: (0, $6e65040b988c460f$export$1171103ea9083ffa),
        children: /*#__PURE__*/ (0, $2OMIu.jsx)($ec00823514e26953$var$CreateSpaceDialog, {
            ...props
        })
    });

});


parcelRegister("gCyAx", function(module, exports) {

$parcel$export(module.exports, "default", () => $d783612464fb72d4$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");
var $8RXs9 = parcelRequire("8RXs9");

var $hTEpF = parcelRequire("hTEpF");

var $bUELo = parcelRequire("bUELo");

var $7RQkA = parcelRequire("7RQkA");

var $duc1y = parcelRequire("duc1y");

var $3r3OR = parcelRequire("3r3OR");
const $d783612464fb72d4$var$MountTracker = (0, $duc1y.default)('confluenceActivatingEmptyState');
const $d783612464fb72d4$var$ConfluenceActivating = ({ intl: { formatMessage: formatMessage } })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $hTEpF.default), {
                width: "wide",
                imageUrl: (0, (/*@__PURE__*/$parcel$interopDefault($7RQkA))),
                maxImageWidth: 82,
                header: formatMessage((0, $bUELo.default).heading),
                description: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                    ...(0, $bUELo.default).description,
                    values: {
                        link: (chunks)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $3r3OR.default), {
                                label: chunks
                            })
                    }
                })
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)($d783612464fb72d4$var$MountTracker, {})
        ]
    });
};
var $d783612464fb72d4$export$2e2bcd8739ae039 = (0, $8RXs9.default)($d783612464fb72d4$var$ConfluenceActivating);

});
parcelRegister("bUELo", function(module, exports) {

$parcel$export(module.exports, "default", () => $43a085a4d685bd3c$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $43a085a4d685bd3c$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    heading: {
        id: 'project-pages.activating.heading',
        defaultMessage: 'Confluence is still loading',
        description: 'Heading when Confluence is active but not ready'
    },
    description: {
        id: 'project-pages.activating.description',
        defaultMessage: "The connected Confuence space isn\u2019t quite ready yet. {contactSupport} if refreshing doesn\u2019t fix things.",
        description: 'Description when Confluence is active but not ready'
    }
});

});

parcelRegister("7RQkA", function(module, exports) {
module.exports = new URL("gears.ffa28e68.svg", import.meta.url).toString();

});

parcelRegister("duc1y", function(module, exports) {

$parcel$export(module.exports, "default", () => $d1196a7fd849380c$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $h8yj2 = parcelRequire("h8yj2");
var $2qeLn = parcelRequire("2qeLn");
parcelRequire("5uXOq");
const $d1196a7fd849380c$var$COMPONENT_MOUNTED_EVENT_ACTION = 'mounted';
var $d1196a7fd849380c$export$2e2bcd8739ae039 = (componentName)=>(attributes)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $2qeLn.MountEvent), {
            onMount: (analyticsEvent)=>(0, $h8yj2.fireOperationalAnalytics)(analyticsEvent, `${componentName} ${$d1196a7fd849380c$var$COMPONENT_MOUNTED_EVENT_ACTION}`, {
                    attributes: attributes
                })
        });

});

parcelRegister("3r3OR", function(module, exports) {

$parcel$export(module.exports, "default", () => $502413b1b4ff3365$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $8KKxj = parcelRequire("8KKxj");

var $h8yj2 = parcelRequire("h8yj2");

var $e4yMr = parcelRequire("e4yMr");

var $koVbs = parcelRequire("koVbs");
const $502413b1b4ff3365$var$ContactSupport = ({ label: label })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const handleClick = (0, $5uXOq.useCallback)((_, analyticsEvent)=>{
        analyticsEvent.update({
            actionSubject: 'link'
        });
        (0, $h8yj2.fireUIAnalytics)(analyticsEvent, 'contactSupportLink');
    }, []);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $e4yMr.default), {
        href: "https://support.atlassian.com/contact/",
        target: "_blank",
        rel: "noopener",
        onClick: handleClick,
        children: label ?? formatMessage((0, $8KKxj.default).linkText)
    });
};
var $502413b1b4ff3365$export$2e2bcd8739ae039 = $502413b1b4ff3365$var$ContactSupport;

});
parcelRegister("8KKxj", function(module, exports) {

$parcel$export(module.exports, "default", () => $5ee9dbef6c391369$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $5ee9dbef6c391369$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    linkText: {
        id: 'project-pages.improvement.contact-support',
        defaultMessage: 'Contact support',
        description: 'Link text for contacting support'
    }
});

});



parcelRegister("4K3sB", function(module, exports) {

$parcel$export(module.exports, "default", () => $ec2de85bd5cfd356$export$2e2bcd8739ae039);

var $7Z8iG = parcelRequire("7Z8iG");

var $ji8Sv = parcelRequire("ji8Sv");

var $6L3iv = parcelRequire("6L3iv");
var $ec2de85bd5cfd356$export$2e2bcd8739ae039 = (0, $7Z8iG.connect)((state)=>({
        isProjectMember: (0, $6L3iv.getIsProjectMember)(state)
    }), {})((0, $ji8Sv.ConnectSpace));

});
parcelRegister("ji8Sv", function(module, exports) {

$parcel$export(module.exports, "ConnectSpace", () => $c78b5cf100ea2c70$export$741341fabd43a51f);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $lUeDs = parcelRequire("lUeDs");

var $imubd = parcelRequire("imubd");
const $c78b5cf100ea2c70$export$741341fabd43a51f = ({ isProjectMember: isProjectMember })=>{
    switch(isProjectMember){
        case true:
            return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $lUeDs.default), {});
        case false:
            return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $imubd.default), {});
        default:
            return null; // isProjectMember = undefined (still fetching), don't render anything yet
    }
};

});
parcelRegister("lUeDs", function(module, exports) {

$parcel$export(module.exports, "default", () => $45ff6568a824fea6$export$2e2bcd8739ae039);

var $7Z8iG = parcelRequire("7Z8iG");

var $aPZf4 = parcelRequire("aPZf4");

var $5aaPX = parcelRequire("5aaPX");
var $45ff6568a824fea6$export$2e2bcd8739ae039 = (0, $7Z8iG.connect)(null, (dispatch)=>({
        showConnectSpaceDialog: ()=>{
            dispatch((0, $aPZf4.showConnectSpaceDialog)());
            dispatch((0, $aPZf4.fetchConfluenceSpaces)());
        }
    }))((0, $5aaPX.default));

});
parcelRegister("5aaPX", function(module, exports) {

$parcel$export(module.exports, "default", () => $13a334e631945e40$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $8RXs9 = parcelRequire("8RXs9");

var $eCeGD = parcelRequire("eCeGD");

var $hTEpF = parcelRequire("hTEpF");

var $h8yj2 = parcelRequire("h8yj2");

var $9LfVn = parcelRequire("9LfVn");

var $75Kq0 = parcelRequire("75Kq0");

var $duc1y = parcelRequire("duc1y");
const $13a334e631945e40$var$MountTracker = (0, $duc1y.default)('connectSpaceEmptyState');
const $13a334e631945e40$var$CanConnect = ({ intl: { formatMessage: formatMessage }, showConnectSpaceDialog: showConnectSpaceDialog })=>{
    const handleConfirmClick = (_, analyticsEvent)=>{
        (0, $h8yj2.fireUIAnalytics)(analyticsEvent, 'connectSpaceButton');
        showConnectSpaceDialog();
    };
    return /*#__PURE__*/ (0, $2OMIu.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $hTEpF.default), {
                width: "wide",
                imageUrl: (0, (/*@__PURE__*/$parcel$interopDefault($75Kq0))),
                maxImageWidth: 101,
                header: formatMessage((0, $9LfVn.default).granularPagesConnectSpaceHeading),
                primaryAction: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eCeGD.default), {
                    onClick: handleConfirmClick,
                    children: formatMessage((0, $9LfVn.default).granularPagesConnectSpaceButton)
                })
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)($13a334e631945e40$var$MountTracker, {})
        ]
    });
};
var $13a334e631945e40$export$2e2bcd8739ae039 = (0, $8RXs9.default)($13a334e631945e40$var$CanConnect);

});
parcelRegister("9LfVn", function(module, exports) {

$parcel$export(module.exports, "default", () => $3b7022df684139b7$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $3b7022df684139b7$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    connectSpaceDescription: {
        id: 'project-pages.connect-space.description',
        defaultMessage: 'Spaces are like folders - you can use them to create, organize, and collaborate on all the content related to your project.',
        description: ''
    },
    granularPagesConnectSpaceHeading: {
        id: 'project-pages.granular-pages.connect-space.heading',
        defaultMessage: 'Connect this project to a Confluence space or item',
        description: 'Heading when a Confluence space or item is not connected to a Jira project'
    },
    granularPagesConnectSpaceButton: {
        id: 'project-pages.granular-pages.connect-space.button',
        defaultMessage: 'Connect to Confluence',
        description: 'Button to connect a Jira project to a Confluence space or item'
    }
});

});

parcelRegister("75Kq0", function(module, exports) {
module.exports = new URL("file-cabinet.6176e2f0.svg", import.meta.url).toString();

});



parcelRegister("imubd", function(module, exports) {

$parcel$export(module.exports, "default", () => $779795c746e9672f$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $8RXs9 = parcelRequire("8RXs9");

var $hTEpF = parcelRequire("hTEpF");

var $8CGFC = parcelRequire("8CGFC");

var $k7T3L = parcelRequire("k7T3L");

var $duc1y = parcelRequire("duc1y");
const $779795c746e9672f$var$MountTracker = (0, $duc1y.default)('connectSpaceNoPermissionEmptyState');
const $779795c746e9672f$var$NoPermission = ({ intl: { formatMessage: formatMessage } })=>/*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2OMIu.Fragment), {
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $hTEpF.default), {
                width: "wide",
                imageUrl: (0, (/*@__PURE__*/$parcel$interopDefault($k7T3L))),
                maxImageWidth: 201,
                header: formatMessage((0, $8CGFC.default).heading),
                description: formatMessage((0, $8CGFC.default).description)
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)($779795c746e9672f$var$MountTracker, {})
        ]
    });
var $779795c746e9672f$export$2e2bcd8739ae039 = (0, $8RXs9.default)($779795c746e9672f$var$NoPermission);

});
parcelRegister("8CGFC", function(module, exports) {

$parcel$export(module.exports, "default", () => $cbe285e5d0094573$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $cbe285e5d0094573$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    description: {
        id: 'project-pages.connect-space.not-connected.description',
        defaultMessage: 'To use project pages, contact your admin or team lead to connect Confluence to this project.',
        description: 'Page content when project pages is not connected to Confluence but the user does not have permission to connect it'
    },
    heading: {
        id: 'project-pages.connect-space.not-connected.heading',
        defaultMessage: 'Not connected to Confluence',
        description: 'Page headding when project pages is not connected to Confluence but the user does not have permission to connect it'
    }
});

});

parcelRegister("k7T3L", function(module, exports) {
module.exports = new URL("plug.96aead60.svg", import.meta.url).toString();

});




parcelRegister("5SIjY", function(module, exports) {

$parcel$export(module.exports, "default", () => $aae3fd25fd099847$export$2e2bcd8739ae039);

var $7Z8iG = parcelRequire("7Z8iG");

var $aPZf4 = parcelRequire("aPZf4");

var $cEp5g = parcelRequire("cEp5g");


var $9ucmj = parcelRequire("9ucmj");

var $6L3iv = parcelRequire("6L3iv");


var $02l0H = parcelRequire("02l0H");

var $jhbRM = parcelRequire("jhbRM");
const $aae3fd25fd099847$var$mapStateToProps = (state)=>({
        spaceKey: (0, $cEp5g.getProjectSpaceKey)(state),
        contentId: (0, $cEp5g.getProjectPageLinkedId)(state),
        permissionState: (0, $cEp5g.getBlueprintsState)(state),
        confluenceLisenseStatus: (0, $9ucmj.getConfluenceLicenseStatus)(state),
        projectSpacePageTitleHasBeenFetched: (0, $cEp5g.getProjectSpacePageTitleHasBeenFetched)(state),
        projectId: (0, $6L3iv.getProjectId)(state),
        projectType: (0, $6L3iv.getProjectType)(state),
        blueprints: (0, $cEp5g.getBlueprints)(state),
        isConfluenceActivationCompleteForPreselectedTemplate: (0, $jhbRM.isConfluenceActivationCompleteForPreselectedTemplate)(state)
    });
const $aae3fd25fd099847$var$mapDispatchToProps = (dispatch)=>({
        onError: ()=>dispatch((0, $aPZf4.showError)())
    });
var $aae3fd25fd099847$export$2e2bcd8739ae039 = (0, $7Z8iG.connect)($aae3fd25fd099847$var$mapStateToProps, $aae3fd25fd099847$var$mapDispatchToProps, ({ blueprints: blueprints, isConfluenceActivationCompleteForPreselectedTemplate: isConfluenceActivationCompleteForPreselectedTemplate, permissionState: permissionState, confluenceLisenseStatus: confluenceLisenseStatus, projectSpacePageTitleHasBeenFetched: projectSpacePageTitleHasBeenFetched, contentId: contentId, spaceKey: spaceKey, projectId: projectId, projectType: projectType }, dispatchProps, ownProps)=>{
    const shouldPopulateDataFields = ![
        (0, $0988c9725597fab5$export$52022723d6fe5666),
        (0, $0988c9725597fab5$export$bde25b564fc94248)
    ].includes(confluenceLisenseStatus) && projectSpacePageTitleHasBeenFetched;
    return {
        blueprints: blueprints,
        isConfluenceActivationCompleteForPreselectedTemplate: isConfluenceActivationCompleteForPreselectedTemplate,
        contentId: shouldPopulateDataFields ? contentId : null,
        spaceKey: shouldPopulateDataFields ? spaceKey : null,
        projectId: projectId,
        projectType: projectType,
        readOnly: permissionState !== (0, $49cd111a962d9af5$export$c6813a8d51f77eaf),
        ...dispatchProps,
        ...ownProps
    };
})((0, $02l0H.PageTree));

});
parcelRegister("02l0H", function(module, exports) {

$parcel$export(module.exports, "PageTree", () => $fdafd126d7b6adc7$export$73500bf5f2e2b0c4);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $kqclJ = parcelRequire("kqclJ");
var $2Pl3U = parcelRequire("2Pl3U");
var $lXzrh = parcelRequire("lXzrh");
var $NoEQs = parcelRequire("NoEQs");
var $3WIK2 = parcelRequire("3WIK2");

var $jkADf = parcelRequire("jkADf");

var $duc1y = parcelRequire("duc1y");

var $8rAPH = parcelRequire("8rAPH");

var $4h7rG = parcelRequire("4h7rG");

var $7HKya = parcelRequire("7HKya");

var $eNwjm = parcelRequire("eNwjm");

var $dNpfo = parcelRequire("dNpfo");

var $atdLB = parcelRequire("atdLB");
var $ce4pa = parcelRequire("ce4pa");
var $duUGa = parcelRequire("duUGa");
var $dnjeJ = parcelRequire("dnjeJ");

var $bKcHQ = parcelRequire("bKcHQ");

var $1jNdv = parcelRequire("1jNdv");

var $6k2gl = parcelRequire("6k2gl");
const $fdafd126d7b6adc7$var$ufoExperienceTracker = new (0, $duUGa.UFOExperience)('project-pages-embedded-page-tree', {
    performanceType: (0, $atdLB.ExperiencePerformanceTypes).PageSegmentLoad,
    type: (0, $atdLB.ExperienceTypes).Load,
    featureFlags: (0, $bKcHQ.getAllBooleanFeatureFlagKeys)()
});
const $fdafd126d7b6adc7$var$MountTracker = (0, $duc1y.default)('confluencePageTree');
const $fdafd126d7b6adc7$export$73500bf5f2e2b0c4 = ({ blueprints: blueprints, contentId: contentId, isConfluenceActivationCompleteForPreselectedTemplate: isConfluenceActivationCompleteForPreselectedTemplate, spaceKey: spaceKey, readOnly: readOnly, EmbeddedProductUpdater: EmbeddedProductUpdater, projectId: projectId, projectType: projectType, showDraftToggle: showDraftToggle = true })=>{
    (0, $dnjeJ.useUFOComponentExperience)($fdafd126d7b6adc7$var$ufoExperienceTracker);
    const { treeState: treeState, setContent: setContent, setProjectData: setProjectData } = (0, $3WIK2.useConfluencePageTree)();
    const { setEmbeddedPage: setEmbeddedPage } = (0, $eNwjm.useEmbeddedPage)();
    const showRealTree = treeState === (0, $NoEQs.TreeStates).RenderedChildren;
    const isTreeLoaded = treeState !== (0, $NoEQs.TreeStates).Loading && treeState !== null;
    const { cloudId: cloudId, locale: locale } = (0, $8rAPH.useProjectPages)();
    const { template: template } = (0, $6k2gl.useTemplate)();
    const handleEdit = (0, $5uXOq.useCallback)((page)=>{
        if (!page.hasEmbeddedEdit) window.open(page.editUrl, '_blank');
        else setEmbeddedPage({
            isOpen: true,
            isLoading: true,
            page: page,
            mode: page.isLive ? 'view' : 'edit'
        });
    }, [
        setEmbeddedPage
    ]);
    const handleView = (0, $5uXOq.useCallback)((page)=>{
        if (page.type !== (0, $2Pl3U.ContentType).PAGE) window.open(page.url, '_blank');
        else setEmbeddedPage({
            isOpen: true,
            isLoading: true,
            page: page,
            mode: 'view'
        });
    }, [
        setEmbeddedPage
    ]);
    const createEmbeddedPage = (0, $dNpfo.useCreateEmbeddedPage)({
        spaceKey: spaceKey,
        projectId: projectId,
        projectType: projectType
    });
    const handleAddChildPage = (0, $5uXOq.useCallback)(async (parentContentId)=>{
        await createEmbeddedPage(parentContentId, false, undefined, undefined, template?.key);
    }, [
        createEmbeddedPage,
        template
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (spaceKey) setContent(spaceKey, contentId || undefined);
        setProjectData(projectId, projectType);
    }, [
        contentId,
        setContent,
        spaceKey,
        setProjectData,
        projectId,
        projectType
    ]);
    const pageTree = /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2OMIu.Fragment), {
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $jkADf.ContextWrapper), {
                sourceType: (0, $6e65040b988c460f$export$f636b5b56f1d624a),
                sourceName: "projectPages",
                children: [
                    isTreeLoaded && showDraftToggle && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $lXzrh.default), {
                        locale: locale
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7HKya.DisplayWrapper), {
                        isShown: showRealTree,
                        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $kqclJ.ConfluencePageTree), {
                            cloudId: cloudId,
                            readOnly: readOnly,
                            onEdit: handleEdit,
                            onView: handleView,
                            onAddChildPage: handleAddChildPage,
                            locale: locale
                        }, `${spaceKey}${contentId}`)
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $4h7rG.PageTreePlaceholder), {
                        treeState: treeState
                    })
                ]
            }),
            showRealTree && /*#__PURE__*/ (0, $2OMIu.jsx)(EmbeddedProductUpdater, {
                embeddedProduct: "confluence"
            }),
            isTreeLoaded && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ce4pa.ExperienceSuccess), {
                experience: $fdafd126d7b6adc7$var$ufoExperienceTracker
            }),
            isTreeLoaded && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1jNdv.PreselectedTemplate), {
                blueprints: blueprints,
                createEmbeddedPage: createEmbeddedPage,
                contentId: contentId,
                isConfluenceActivationCompleteForPreselectedTemplate: isConfluenceActivationCompleteForPreselectedTemplate
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)($fdafd126d7b6adc7$var$MountTracker, {})
        ]
    });
    // ConfluencePageTreeProvider includes the AnalyticsProvider already
    return pageTree;
};

});
parcelRegister("kqclJ", function(module, exports) {

$parcel$export(module.exports, "ConfluencePageTree", () => $c059a848e1a86bd9$export$bb03c987203d806f);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $4OFbz = parcelRequire("4OFbz");

var $l3opI = parcelRequire("l3opI");
const $c059a848e1a86bd9$export$bb03c987203d806f = ({ locale: locale = (0, $l3opI.DEFAULT_LOCALE), ...props })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $l3opI.TranslationsProvider), {
        locale: locale,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $4OFbz.default), {
            ...props
        })
    });
};

});
parcelRegister("4OFbz", function(module, exports) {

$parcel$export(module.exports, "default", () => $ccf90f43fd744b42$export$2e2bcd8739ae039);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $2OMIu = parcelRequire("2OMIu");

var $7VHMR = parcelRequire("7VHMR");
var $koVbs = parcelRequire("koVbs");

var $5uXOq = parcelRequire("5uXOq");

var $2iqNv = parcelRequire("2iqNv");
var $6o3Pm = parcelRequire("6o3Pm");
var $bJ8bc = parcelRequire("bJ8bc");
var $ciNvy = parcelRequire("ciNvy");

var $eCeGD = parcelRequire("eCeGD");

var $3bDjY = parcelRequire("3bDjY");

var $3u0c5 = parcelRequire("3u0c5");

var $h8yj2 = parcelRequire("h8yj2");

var $2gQ83 = parcelRequire("2gQ83");

var $2CAPp = parcelRequire("2CAPp");

var $bL77t = parcelRequire("bL77t");

var $3WIK2 = parcelRequire("3WIK2");

var $gu3zV = parcelRequire("gu3zV");

var $33NuD = parcelRequire("33NuD");

var $9DDhv = parcelRequire("9DDhv");

var $9kpVr = parcelRequire("9kpVr");

var $iv5a0 = parcelRequire("iv5a0");

var $6prT7 = parcelRequire("6prT7");

var $ewakd = parcelRequire("ewakd");

var $8FiLt = parcelRequire("8FiLt");

var $VSDnB = parcelRequire("VSDnB");

var $bWGt6 = parcelRequire("bWGt6");
function $ccf90f43fd744b42$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $ccf90f43fd744b42$var$TooltipContainer = /*#__PURE__*/ (0, $bWGt6.default)("span", {
    target: "ernlrkp1"
})({
    name: "ajfry4",
    styles: "display:inline-block;padding-left:var(--ds-space-100, 8px);cursor:pointer;flex-shrink:0"
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $ccf90f43fd744b42$var$StyledLink = /*#__PURE__*/ (0, $bWGt6.default)((0, $iv5a0.default), {
    target: "ernlrkp0"
})({
    name: "thgwgc",
    styles: "overflow:hidden;white-space:nowrap;text-overflow:ellipsis;display:block"
});
const $ccf90f43fd744b42$var$i18n = (0, $7VHMR.defineMessages)({
    draftPageTooltip: {
        id: 'confluence-table-tree.draft.tooltip',
        defaultMessage: 'Drafts can only be seen by you.'
    },
    draftPageLozenge: {
        id: 'confluence-table-tree.draft.lozenge',
        defaultMessage: 'DRAFT'
    },
    defaultPageTitle: {
        id: 'confluence-table-tree.default.page.title',
        defaultMessage: 'Untitled'
    },
    showAllPagesButtonLabel: {
        id: 'confluence-table-tree.default.show-all-pages-button.label',
        defaultMessage: 'Show all pages'
    },
    showMorePagesButtonLabel: {
        id: 'confluence-table-tree.default.show-all-pages-button.label',
        defaultMessage: 'Show more pages'
    }
});
const $ccf90f43fd744b42$var$PageTreeBase = ({ readOnly: readOnly, cloudId: cloudId = null, onEdit: onEdit, onView: onView, onAddChildPage: onAddChildPage })=>{
    const { items: items, errorType: errorType, rootContentId: rootContentId, spaceKey: spaceKey, expandSubtree: expandSubtree, collapseSubtree: collapseSubtree, canShowMorePages: canShowMorePages, showMorePages: showMorePages } = (0, $3WIK2.useConfluencePageTreeContext)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [stickyRowContentId, setStickyRowContentId] = (0, $5uXOq.useState)(null);
    const [{ isDraftsShown: isDraftsShown }] = (0, $2CAPp.useDraftsToggle)();
    const [cellWidths, setCellWidths] = (0, $5uXOq.useState)({
        title: '55%',
        contributors: '10%',
        controls: '35%'
    });
    // Update cell widths based on zoom level.
    // For high zoom levels, give more space to contributors and controls
    (0, $5uXOq.useEffect)(()=>{
        const updateCellWidths = ()=>{
            const zoomLevel = window.outerWidth / window.innerWidth;
            if (zoomLevel >= 1.5) setCellWidths({
                title: '45%',
                contributors: '15%',
                controls: '40%'
            });
            else setCellWidths({
                title: '55%',
                contributors: '10%',
                controls: '35%'
            });
        };
        updateCellWidths();
        window.addEventListener('resize', updateCellWidths);
        return ()=>{
            window.removeEventListener('resize', updateCellWidths);
        };
    }, []);
    const handleRowExpand = (0, $5uXOq.useCallback)(async (rowData, analyticsEvent)=>{
        if (analyticsEvent) (0, $h8yj2.fireUIAnalytics)(analyticsEvent, 'confluencePageTree');
        await expandSubtree(rowData.id);
    }, [
        expandSubtree
    ]);
    const handleRowCollapse = (0, $5uXOq.useCallback)((rowData, analyticsEvent)=>{
        collapseSubtree(rowData.id);
        if (analyticsEvent) (0, $h8yj2.fireUIAnalytics)(analyticsEvent, 'confluencePageTree');
    }, [
        collapseSubtree
    ]);
    const handleClickOnPageLink = (0, $5uXOq.useCallback)((event, pageProperties, analyticsEvent, origin)=>{
        (0, $h8yj2.fireUIAnalytics)(analyticsEvent, 'confluencePageTreeLink', {
            ...origin.toAnalyticsAttributes({
                hasGeneratedId: true
            }),
            ...(0, $ewakd.pageAnalyticsAttributes)(pageProperties)
        });
        if (!(event.ctrlKey || event.metaKey || event.shiftKey)) {
            if (typeof onView === 'function' && !pageProperties.isDraft) {
                event.preventDefault();
                onView(pageProperties);
            } else if (typeof onEdit === 'function') {
                event.preventDefault();
                onEdit(pageProperties);
            }
        }
    }, [
        onView,
        onEdit
    ]);
    const handleShareToggle = (0, $5uXOq.useCallback)((pageId)=>{
        setStickyRowContentId(pageId);
    }, []);
    const getTableRow = (0, $5uXOq.useCallback)(({ error: error, children: children, ...page })=>{
        if (error) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $9DDhv.default), {});
        const { id: id, childTypes: childTypes, hasDraftChildren: hasDraftChildren, title: title, history: { contributors: contributors, lastUpdated: lastUpdated } = {}, isExpanded: isExpanded } = page;
        const origin = new (0, $2gQ83.default)({
            product: 'jira'
        });
        const pageItem = (0, $bL77t.getPageTreeItemProperties)(page);
        pageItem.url = origin.addToUrl(pageItem.url);
        pageItem.editUrl = origin.addToUrl(pageItem.editUrl);
        const pageTitle = title ? title : formatMessage($ccf90f43fd744b42$var$i18n.defaultPageTitle);
        // Replace spaces with hyphens in the titleId
        const titleId = `${pageTitle.replace(/\s+/g, '-')}-page`;
        return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $bJ8bc.default), {
            itemId: id,
            items: children,
            hasChildren: childTypes.page.value || !!(hasDraftChildren && isDraftsShown),
            isExpanded: isExpanded,
            onExpand: handleRowExpand,
            onCollapse: handleRowCollapse,
            children: [
                /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2iqNv.default), {
                    //  eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix, @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/design-system/no-unsafe-style-overrides -- Ignored via go/DSP-18766
                    width: (0, $VSDnB.fg)('project-pages-zoom-accessibility') ? cellWidths.title : '55%',
                    singleLine: true,
                    //  eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides, @atlaskit/ui-styling-standard/no-classname-prop
                    className: "cell x-start",
                    children: [
                        /*#__PURE__*/ (0, $2OMIu.jsx)($ccf90f43fd744b42$var$StyledLink, {
                            onClick: (event, analyticsEvent)=>handleClickOnPageLink(event, pageItem, analyticsEvent, origin),
                            href: pageItem.url,
                            target: "_blank",
                            rel: "noopener noreferrer",
                            testId: "confluence-project-pages.page-tree-row.page-title",
                            id: titleId,
                            children: pageTitle
                        }),
                        pageItem.isDraft && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3bDjY.default), {
                            content: formatMessage($ccf90f43fd744b42$var$i18n.draftPageTooltip),
                            position: "top",
                            children: /*#__PURE__*/ (0, $2OMIu.jsx)($ccf90f43fd744b42$var$TooltipContainer, {
                                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3u0c5.default), {
                                    appearance: "inprogress",
                                    children: formatMessage($ccf90f43fd744b42$var$i18n.draftPageLozenge)
                                })
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2iqNv.default), {
                    //  eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/design-system/no-unsafe-style-overrides -- Ignored via go/DSP-18766
                    width: (0, $VSDnB.fg)('project-pages-zoom-accessibility') ? cellWidths.contributors : '10%',
                    //  eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides, @atlaskit/ui-styling-standard/no-classname-prop
                    className: "cell",
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $gu3zV.Contributors), {
                        cloudId: cloudId,
                        contributors: contributors,
                        isAvatarTooltipDisabled: true,
                        // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
                        testId: "confluence-project-pages.page-tree-row.contributors",
                        url: pageItem.url
                    })
                }),
                /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2iqNv.default), {
                    // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix, @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                    width: (0, $VSDnB.fg)('project-pages-zoom-accessibility') ? cellWidths.controls : '35%',
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
                    className: "cell x-end",
                    children: [
                        stickyRowContentId !== id && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                        /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
                            className: "hoverHide",
                            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $9kpVr.default), {
                                lastUpdated: lastUpdated
                            })
                        }),
                        /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
                            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                            className: stickyRowContentId === id ? undefined : 'hoverShow',
                            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $8FiLt.default), {
                                page: pageItem,
                                onEditClick: onEdit,
                                onShareToggle: handleShareToggle,
                                onAddChildClick: onAddChildPage,
                                stickyRowContentId: stickyRowContentId,
                                readOnly: readOnly,
                                origin: origin,
                                titleId: titleId
                            })
                        })
                    ]
                })
            ]
        });
    }, [
        cloudId,
        formatMessage,
        handleClickOnPageLink,
        handleRowCollapse,
        handleRowExpand,
        handleShareToggle,
        isDraftsShown,
        onAddChildPage,
        onEdit,
        readOnly,
        stickyRowContentId,
        cellWidths
    ]);
    let tableBody;
    if (rootContentId === null && spaceKey === null) tableBody = null;
    else if (errorType) {
        if (spaceKey) tableBody = /*#__PURE__*/ (0, $2OMIu.jsx)((0, $33NuD.ErrorState), {
            type: errorType,
            spaceKey: spaceKey,
            readOnly: readOnly
        });
        else tableBody = /*#__PURE__*/ (0, $2OMIu.jsx)((0, $33NuD.ErrorState), {
            type: errorType,
            readOnly: readOnly
        });
    } else tableBody = /*#__PURE__*/ (0, $2OMIu.jsx)((0, $6prT7.HoverWrapper), {
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ciNvy.default), {
            items: items,
            render: getTableRow
        }, rootContentId)
    });
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $6prT7.TableTreeWrapper), {
        "data-testid": "confluence-project-pages.page-tree.container",
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $6o3Pm.default), {
                children: tableBody
            }),
            canShowMorePages && /*#__PURE__*/ (0, $2OMIu.jsx)($ccf90f43fd744b42$var$ShowMorePagesButton, {
                showMorePages: showMorePages
            })
        ]
    });
};
const $ccf90f43fd744b42$var$ShowMorePagesButton = ({ showMorePages: showMorePages })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [isLoading, setIsLoading] = (0, $5uXOq.useState)(false);
    const loadMore = async ()=>{
        setIsLoading(true);
        await showMorePages();
        setIsLoading(false);
    };
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $6prT7.ButtonWrapper), {
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eCeGD.default), {
            onClick: loadMore,
            isLoading: isLoading,
            children: formatMessage($ccf90f43fd744b42$var$i18n.showMorePagesButtonLabel)
        })
    });
};
var $ccf90f43fd744b42$export$2e2bcd8739ae039 = $ccf90f43fd744b42$var$PageTreeBase;

});
parcelRegister("2CAPp", function(module, exports) {

$parcel$export(module.exports, "useDraftsToggle", () => $8030202a7183357f$export$e77ae2c63da4e5a);

var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");

var $5kVn1 = parcelRequire("5kVn1");
const $8030202a7183357f$var$Store = (0, $iXqE5.createStore)({
    initialState: {
        isDraftsShown: false,
        isTreeUpdatedForDrafts: false
    },
    actions: $5kVn1
});
const $8030202a7183357f$export$e77ae2c63da4e5a = (0, $3sQ5x.createHook)($8030202a7183357f$var$Store);

});
parcelRegister("5kVn1", function(module, exports) {

$parcel$export(module.exports, "setIsDraftsShown", () => $e557fa7277a01ae6$export$a491c6a0b1d65edb);
$parcel$export(module.exports, "loadIsDraftsShownPreference", () => $e557fa7277a01ae6$export$c0acb5b0c57287a8);
$parcel$export(module.exports, "setIsTreeUpdatedForDrafts", () => $e557fa7277a01ae6$export$a3f13805269938c);

var $dsQbH = parcelRequire("dsQbH");
const $e557fa7277a01ae6$var$SHOW_DRAFTS_USER_PROPERTY = 'growth.project-pages.confluence-table-tree.show-drafts';
const $e557fa7277a01ae6$export$a491c6a0b1d65edb = (accountId, isDraftsShown)=>async ({ setState: setState })=>{
        setState({
            isDraftsShown: isDraftsShown,
            isTreeUpdatedForDrafts: false
        });
        // save the preference
        await (0, $dsQbH.putUserProperty)(accountId, $e557fa7277a01ae6$var$SHOW_DRAFTS_USER_PROPERTY, isDraftsShown);
    };
const $e557fa7277a01ae6$export$c0acb5b0c57287a8 = (accountId)=>async ({ setState: setState })=>{
        // default is to show drafts
        const isDraftsShown = await (0, $dsQbH.getUserProperty)(accountId, $e557fa7277a01ae6$var$SHOW_DRAFTS_USER_PROPERTY, true);
        setState({
            isDraftsShown: isDraftsShown,
            isTreeUpdatedForDrafts: false
        });
    };
const $e557fa7277a01ae6$export$a3f13805269938c = (isTreeUpdatedForDrafts)=>({ setState: setState })=>{
        setState({
            isTreeUpdatedForDrafts: isTreeUpdatedForDrafts
        });
    };

});
parcelRegister("dsQbH", function(module, exports) {

$parcel$export(module.exports, "getUserProperty", () => $298e932eba491fa3$export$b3126db2ef6e34ed);
$parcel$export(module.exports, "putUserProperty", () => $298e932eba491fa3$export$ab7d27b408d7b5b);
const $298e932eba491fa3$var$USER_PROPERTIES_URL = '/rest/api/3/user/properties';
const $298e932eba491fa3$export$b3126db2ef6e34ed = async (accountId, key, defaultValue)=>{
    const response = await fetch(`${$298e932eba491fa3$var$USER_PROPERTIES_URL}/${key}?${new URLSearchParams({
        accountId: accountId
    })}`, {
        credentials: 'same-origin'
    });
    if (response.status === 404 && defaultValue !== undefined) return defaultValue;
    if (!response.ok) throw new Error(`Failed to fetch user property ${key} ${response.status} ${response.statusText}`);
    return (await response.json()).value;
};
const $298e932eba491fa3$export$ab7d27b408d7b5b = async (accountId, key, value)=>{
    const response = await fetch(`${$298e932eba491fa3$var$USER_PROPERTIES_URL}/${key}?${new URLSearchParams({
        accountId: accountId
    })}`, {
        method: 'PUT',
        credentials: 'same-origin',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(value)
    });
    if (!response.ok) throw new Error(`Failed to set user property ${key} ${response.status} ${response.statusText}`);
    return;
};

});



parcelRegister("bL77t", function(module, exports) {

$parcel$export(module.exports, "ConfluenceTableTreeData", () => $58ff02789abe0016$export$34121f16d7c7ab27);
$parcel$export(module.exports, "getPageTreeItemProperties", () => $58ff02789abe0016$export$761824c0680778ff);
class $58ff02789abe0016$export$34121f16d7c7ab27 {
    constructor(){
        this.items = [];
        this.lookup = {};
        this.rootContentId = null;
    }
    getPage(id) {
        return this.lookup[id];
    }
    getRootPages() {
        return this.items;
    }
    /**
	 * Inject an error marker as the children of the given pageId
	 * @param parentId
	 * @returns the update page tree root items
	 */ markChildError(parentId) {
        const parent = this.getPage(parentId);
        if (!parent) throw new Error(`unknown parent id ${parentId}`);
        this.getDescendentIds(parent).forEach((id)=>delete this.lookup[id]);
        parent.children = [
            {
                error: true
            }
        ];
        return [
            ...this.items
        ];
    }
    // traverse the tree and return all descendents of the given parent (or root)
    getDescendentIds(parent) {
        return (parent ? parent.children || [] : this.items).reduce((descendents, child)=>[
                child.id,
                ...this.getDescendentIds(child),
                ...descendents
            ], []);
    }
    /**
	 * Remove all descendents from given parent and collapse the subtree
	 *
	 * @param parentId
	 * @returns the updated page tree root items
	 */ pruneSubtree(parentId) {
        const parent = this.getPage(parentId);
        if (!parent) return this.items;
        this.getDescendentIds(parent).forEach((id)=>delete this.lookup[id]);
        parent.childTypes.page.value = false;
        parent.children = undefined;
        parent.isExpanded = false;
        parent.hasDraftChildren = false;
        return [
            ...this.items
        ];
    }
    apppendChildPages(pages, parentId) {
        const parent = parentId ? this.getPage(parentId) : undefined;
        if (parentId !== undefined && !parent) throw new Error(`unknown parent id ${parentId}`);
        const origDescendentIds = this.getDescendentIds(parent);
        // populate the incoming page data with parent and any existing children information
        const newItems = pages.map((page)=>({
                ...page,
                parent: parent,
                children: this.getPage(page.id)?.children,
                isExpanded: this.getPage(page.id)?.isExpanded || false
            }));
        const items = parent ? parent.children : this.items;
        const published = items?.filter((item)=>item.status === 'current') ?? [];
        const drafts = items?.filter((item)=>item.status === 'draft') ?? [];
        published.push(...newItems);
        if (parent) {
            // modify parent to have the new children
            parent.children = [
                ...published,
                ...drafts
            ];
            parent.childTypes = {
                page: {
                    value: pages.length > 0
                }
            };
            // always expand the parent when fetching children for it
            parent.isExpanded = true;
        } else // update root pages
        this.items = [
            ...published,
            ...drafts
        ];
        this.cleanUpAndUpdateLookUp(newItems, parent, origDescendentIds);
        // always return copies to trigger re-renders
        return [
            ...this.items
        ];
    }
    /**
	 * Replace the root pages or child pages of a parent in the page tree
	 * @param pages
	 * @param parentId if specified, replaces the children of this parent with given pages. Otherwise replaces the root pages
	 * @returns the updated page tree root items
	 */ updateChildPages(pages, parentId) {
        const parent = parentId ? this.getPage(parentId) : undefined;
        if (parentId !== undefined && !parent) throw new Error(`unknown parent id ${parentId}`);
        const origDescendentIds = this.getDescendentIds(parent);
        // populate the incoming page data with parent and any existing children information
        const newItems = pages.map((page)=>({
                ...page,
                parent: parent,
                children: this.getPage(page.id)?.children,
                isExpanded: this.getPage(page.id)?.isExpanded || false
            }));
        if (parent) {
            // modify parent to have the new children
            parent.children = newItems.length > 0 ? newItems : undefined;
            parent.childTypes = {
                page: {
                    value: pages.length > 0
                }
            };
            // always expand the parent when fetching children for it
            parent.isExpanded = true;
        } else // update root pages
        this.items = newItems;
        this.cleanUpAndUpdateLookUp(newItems, parent, origDescendentIds);
        // always return copies to trigger re-renders
        return [
            ...this.items
        ];
    }
    cleanUpAndUpdateLookUp(newItems, parent, origDescendentIds) {
        // delete from lookup any original descendents of the parent that is no longer in the tree
        const newDescendentIds = new Set(this.getDescendentIds(parent));
        origDescendentIds.filter((origId)=>!newDescendentIds.has(origId)).forEach((id)=>delete this.lookup[id]);
        // update lookup for the new pages, and the .parent of the existing (grand)children
        newItems.forEach((page)=>{
            page.children?.forEach((child)=>{
                child.parent = page;
            });
            this.lookup[page.id] = page;
        });
    }
    setIsExpanded(id, isExpanded) {
        const page = this.getPage(id);
        if (page) {
            page.isExpanded = isExpanded;
            return [
                ...this.items
            ];
        }
        return this.items;
    }
    init(rootContentId) {
        this.items = [];
        this.lookup = {};
        this.rootContentId = rootContentId;
    }
    /**
	 * Remove the given page from the tree if it exists, and prune all descendants
	 *
	 * @param pageId
	 * @returns the updated page tree root items
	 */ removePage(pageId) {
        const page = this.getPage(pageId);
        if (!page) return this.items;
        if (page.parent) {
            // we can assume that the parent is currently expanded, as it has page as a child
            page.parent.children = page.parent.children ? page.parent.children.filter((p)=>p.id !== pageId) : undefined;
            // if there are no drafts remaining
            if (page.parent.children?.find((p)=>p.status === 'draft') === undefined) page.parent.hasDraftChildren = false;
            // if there are no published pages remaining
            if (page.parent.children?.find((p)=>p.status === 'current') === undefined) page.parent.childTypes.page.value = false;
            if (page.parent.children === undefined) page.parent.isExpanded = false;
        } else // remove root page
        this.items = this.items.filter((p)=>p.id !== pageId);
        // published pages can have children, delete all the lookups for them as well
        if (page.status === 'current') this.getDescendentIds(page).forEach((id)=>delete this.lookup[id]);
        delete this.lookup[pageId];
        return [
            ...this.items
        ];
    }
    static copyPageData(src, dst) {
        // manually copy relevant attributes into the existing item, so the object reference is preserved
        dst._links = src._links;
        dst.childTypes = src.childTypes;
        dst.metadata = src.metadata;
        dst.status = src.status;
        dst.title = src.title;
        dst.history = src.history;
        dst.extensions = src.extensions;
        return true;
    }
    /**
	 * Inject pages into the tree based on the current expansion state. Pages already in the tree
	 * will be replaced by any pages in the given list. Parent pages will gain the hasDraftChildren
	 * or childTypes.pages.value attribute and expanded parents will have pages inserted into children.
	 *
	 * @param pages an array of pages with ancestor information (via confluence::getPage or confluence::getDrafts)
	 * @returns the updated page tree root items
	 */ injectPages(pages) {
        pages.forEach((page)=>{
            // calculate the parent by looking at last element of ancestors
            const parentId = page.ancestors.length === 0 ? null : page.ancestors[page.ancestors.length - 1].id;
            // first consider if this draft can simply be replaced in place
            const existing = this.getPage(page.id);
            let replaced = false;
            if (existing) {
                // has this draft moved in the tree?
                if (existing.parent?.id === parentId || existing.parent === undefined && parentId === this.rootContentId) {
                    // if not, we can just replace in place
                    $58ff02789abe0016$export$34121f16d7c7ab27.copyPageData(page, existing);
                    replaced = true;
                } else // otherwise, remove it first before inserting
                this.removePage(page.id);
            }
            // then try to insert it into the tree
            const item = {
                ...page,
                isExpanded: false,
                children: undefined
            };
            // check if it is a "root" level draft
            if (!replaced && parentId === this.rootContentId) {
                this.items.push(item);
                this.lookup[page.id] = item;
                return;
            }
            if (parentId === null) // got a root draft but we have a non-null rootContentId... so discard it
            return;
            const parent = this.getPage(parentId);
            if (!parent) // parent is not in tree, discard this draft
            return;
            // mark the parent appropriately
            if (page.status === 'draft') parent.hasDraftChildren = true;
            else if (page.status === 'current') parent.childTypes.page.value = true;
            // if the parent is expanded, append this draft to the children
            if (!replaced && parent.isExpanded) {
                item.parent = parent;
                if (parent.children) parent.children.push(item);
                else parent.children = [
                    item
                ];
                this.lookup[page.id] = item;
            }
        });
        return [
            ...this.items
        ];
    }
    /**
	 * Remove all drafts from the page tree
	 * @returns the updated page tree root items
	 */ purgeDrafts() {
        const filterDrafts = (pages)=>pages.reduce((acc, page)=>{
                if (page.status === 'draft') {
                    delete this.lookup[page.id];
                    return acc;
                }
                const children = page.children ? filterDrafts(page.children) : undefined;
                const updatedPage = {
                    ...page,
                    children: children,
                    hasDraftChildren: false
                };
                this.lookup[page.id] = updatedPage;
                acc.push(updatedPage);
                return acc;
            }, []);
        this.items = filterDrafts(this.items);
        return this.items;
    }
}
const $58ff02789abe0016$export$761824c0680778ff = ({ id: id, status: status, _links: _links, metadata: metadata, type: type, subType: subType })=>({
        id: id,
        isDraft: status === 'draft',
        isLive: subType === 'live',
        url: `${_links.base}${_links.webui}`,
        editUrl: `${_links.base}${_links.editui}`,
        hasEmbeddedEdit: metadata.frontend?.collabService === 'ncs',
        type: type
    });

});

parcelRegister("3WIK2", function(module, exports) {

$parcel$export(module.exports, "ConfluencePageTreeContext", () => $63886cc17f668317$export$8f8931214163d67c);
$parcel$export(module.exports, "useConfluencePageTreeContext", () => $63886cc17f668317$export$6bdfd12fd9251472);
$parcel$export(module.exports, "useConfluencePageTree", () => $63886cc17f668317$export$98b66195d4a10d4a);

var $5uXOq = parcelRequire("5uXOq");

var $NoEQs = parcelRequire("NoEQs");
const $63886cc17f668317$var$noop = ()=>{};
const $63886cc17f668317$export$8f8931214163d67c = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createContext({
    treeState: (0, $NoEQs.TreeStates).Loading,
    spaceKey: null,
    rootContentId: null,
    items: null,
    errorType: null,
    accountId: '',
    setContent: $63886cc17f668317$var$noop,
    expandSubtree: ()=>Promise.reject(),
    collapseSubtree: $63886cc17f668317$var$noop,
    insertPage: ()=>Promise.reject(),
    updatePage: ()=>Promise.reject(),
    removePage: ()=>Promise.reject(),
    canShowMorePages: false,
    showMorePages: ()=>Promise.resolve(),
    setProjectData: $63886cc17f668317$var$noop
});
const $63886cc17f668317$export$6bdfd12fd9251472 = ()=>(0, $5uXOq.useContext)($63886cc17f668317$export$8f8931214163d67c);
const $63886cc17f668317$export$98b66195d4a10d4a = ()=>{
    const { treeState: treeState, setContent: setContent, insertPage: insertPage, updatePage: updatePage, removePage: removePage, setProjectData: setProjectData } = (0, $5uXOq.useContext)($63886cc17f668317$export$8f8931214163d67c);
    return {
        treeState: treeState,
        setContent: setContent,
        insertPage: insertPage,
        updatePage: updatePage,
        removePage: removePage,
        setProjectData: setProjectData
    };
};

});
parcelRegister("NoEQs", function(module, exports) {

$parcel$export(module.exports, "Errors", () => $cc393684780e59ac$export$b8e9cd941e8016ac);
$parcel$export(module.exports, "TreeStates", () => $cc393684780e59ac$export$4b8251500bedd042);
var $cc393684780e59ac$export$e2e108cbe2e4f865 = /*#__PURE__*/ function(ContentType) {
    ContentType["PAGE"] = "page";
    ContentType["WHITEBOARD"] = "whiteboard";
    return ContentType;
}({});
var $cc393684780e59ac$export$b8e9cd941e8016ac = /*#__PURE__*/ function(Errors) {
    Errors["Error"] = "error";
    Errors["Empty"] = "empty";
    return Errors;
}({});
var $cc393684780e59ac$export$4b8251500bedd042 = /*#__PURE__*/ function(TreeStates) {
    TreeStates["Loading"] = "loading";
    TreeStates["RenderedChildren"] = "rendered-children";
    TreeStates["Empty"] = "empty";
    TreeStates["Error"] = "error";
    return TreeStates;
}({});

});


parcelRegister("gu3zV", function(module, exports) {

$parcel$export(module.exports, "Contributors", () => $43027671fac60511$export$5360f064464e9211);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $bvUB1 = parcelRequire("bvUB1");
var $2NMNM = parcelRequire("2NMNM");
var $cb25w = parcelRequire("cb25w");

var $ujWmd = parcelRequire("ujWmd");

var $jnhNB = parcelRequire("jnhNB");

var $37PA3 = parcelRequire("37PA3");

var $blw2B = parcelRequire("blw2B");

var $3bDjY = parcelRequire("3bDjY");

var $h8yj2 = parcelRequire("h8yj2");

var $kgWq0 = parcelRequire("kgWq0");

var $aOxGW = parcelRequire("aOxGW");
const $43027671fac60511$var$openUserProfileWindow = (userId, url)=>{
    const baseUrl = new URL(url).origin;
    window.open(`${baseUrl}/wiki/display/~${userId}`, '_blank');
};
const $43027671fac60511$var$DIRECTORY_URL = '/gateway/api/directory/graphql';
const $43027671fac60511$export$2a1ba0e121ca02bd = (props)=>{
    const { url: url, userId: userId, cloudId: cloudId, createAnalyticsEvent: createAnalyticsEvent, name: name, size: size, src: src } = props;
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const profileClient = new (0, $blw2B.default)({
        url: $43027671fac60511$var$DIRECTORY_URL
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bvUB1.default), {
        onEvent: (analyticsEvent)=>{
            if (createAnalyticsEvent) {
                const { action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId } = analyticsEvent.payload;
                if (action === 'rendered' && actionSubject === 'profilecard' && actionSubjectId === 'content') (0, $h8yj2.fireOperationalAnalytics)(createAnalyticsEvent({}), 'confluencePageTreeAvatar profileCardView');
            }
        },
        channel: "peopleTeams",
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $37PA3.default), {
            cloudId: cloudId,
            userId: userId,
            resourceClient: profileClient,
            actions: [
                {
                    label: formatMessage((0, $aOxGW.default).viewProfile),
                    callback: ()=>{
                        $43027671fac60511$var$openUserProfileWindow(userId, url);
                    }
                }
            ],
            prepopulatedData: {
                fullName: props.username
            },
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ujWmd.default), {
                name: name,
                size: size,
                src: src
            })
        })
    });
};
const $43027671fac60511$export$291ed8247fe10969 = (0, $cb25w.default)()($43027671fac60511$export$2a1ba0e121ca02bd);
const $43027671fac60511$export$5360f064464e9211 = ({ cloudId: cloudId, contributors: contributors, testId: testId, isAvatarTooltipDisabled: isAvatarTooltipDisabled, url: url })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    if (!cloudId || !contributors || !contributors.publishers || !contributors.publishers.users) {
        if (createAnalyticsEvent) (0, $h8yj2.fireOperationalAnalytics)(createAnalyticsEvent({}), 'confluencePageTree unknownContributor');
        const couldNotLoadContMessage = formatMessage((0, $aOxGW.default).couldNotLoadContributors);
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $kgWq0.ContributorsContainer), {
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3bDjY.default), {
                content: couldNotLoadContMessage,
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ujWmd.default), {
                    size: "small",
                    name: couldNotLoadContMessage,
                    label: couldNotLoadContMessage
                })
            })
        });
    }
    const baseUrl = new URL(url).origin;
    const data = contributors.publishers.users.map((user)=>({
            name: user.displayName,
            size: 'medium',
            src: `${baseUrl}${user.profilePicture.path}`,
            userId: user.accountId
        }));
    const AvatarWithCloudId = (avatarProps)=>/*#__PURE__*/ (0, $2OMIu.jsx)($43027671fac60511$export$291ed8247fe10969, {
            ...avatarProps,
            cloudId: cloudId,
            url: url
        });
    const handleAvatarClicked = (_event, _analyticsEvent, index)=>{
        if (createAnalyticsEvent) {
            const event = createAnalyticsEvent({
                action: 'clicked',
                actionSubject: 'avatar'
            });
            (0, $h8yj2.fireUIAnalytics)(event, 'confluencePageTreeAvatar', {
                dropdown: true
            });
        }
        $43027671fac60511$var$openUserProfileWindow(data[index].userId, url);
    };
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $kgWq0.ContributorsContainer), {
        children: data.length === 1 ? /*#__PURE__*/ (0, $2OMIu.jsx)(AvatarWithCloudId, {
            ...data[0],
            size: "small",
            onClick: handleAvatarClicked,
            testId: testId && `${testId}--avatar`
        }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $jnhNB.default), {
            appearance: "stack",
            data: data,
            avatar: AvatarWithCloudId,
            size: "small",
            maxCount: 3,
            onAvatarClick: handleAvatarClicked,
            testId: testId && `${testId}--avatargroup`,
            isTooltipDisabled: isAvatarTooltipDisabled
        })
    });
};

});
parcelRegister("37PA3", function(module, exports) {

$parcel$export(module.exports, "default", () => $1f0fdc37b33e30ae$export$2e2bcd8739ae039);


var $dYuIx = parcelRequire("dYuIx");

var $264zF = parcelRequire("264zF");
var $1f0fdc37b33e30ae$export$2e2bcd8739ae039 = (0, $264zF.default);

});
parcelRegister("dYuIx", function(module, exports) {

$parcel$export(module.exports, "ProfileCardLazy", () => $78b4a66e55984f2d$export$403d297463f226af);

var $5uXOq = parcelRequire("5uXOq");

const $78b4a66e55984f2d$export$403d297463f226af = /*#__PURE__*/ (0, $5uXOq.lazy)(()=>(parcelRequire("l0Ydb")));

});
parcelRegister("l0Ydb", function(module, exports) {

let $f4c84dd928c83aa6$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $f4c84dd928c83aa6$var$load("ffQaD"),
    $f4c84dd928c83aa6$var$load("kvRbA"),
    $f4c84dd928c83aa6$var$load("1ehQl")
]).then(()=>parcelRequire('lrMir'));

});


parcelRegister("264zF", function(module, exports) {

$parcel$export(module.exports, "default", () => $74b3c02273951832$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $2NMNM = parcelRequire("2NMNM");

var $adIkV = parcelRequire("adIkV");
var $gH4E9 = parcelRequire("gH4E9");

var $VSDnB = parcelRequire("VSDnB");

var $1I7E8 = parcelRequire("1I7E8");

var $k5uoT = parcelRequire("k5uoT");

var $4sfdL = parcelRequire("4sfdL");

var $chprS = parcelRequire("chprS");

var $jnj6z = parcelRequire("jnj6z");

var $ivXTE = parcelRequire("ivXTE");


var $kDbj5 = parcelRequire("kDbj5");

var $dYuIx = parcelRequire("dYuIx");

var $ifxzB = parcelRequire("ifxzB");
function $74b3c02273951832$var$ProfileCardContent({ profilecardProps: profilecardProps, userId: userId, cloudId: cloudId, resourceClient: resourceClient, viewingUserId: viewingUserId, trigger: trigger, product: product, isAgent: isAgent, profileCardAction: profileCardAction, hasError: hasError, errorType: errorType, agentActions: agentActions, addFlag: addFlag }) {
    if (isAgent) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $kDbj5.AgentProfileCardResourced), {
        accountId: userId,
        cloudId: cloudId,
        resourceClient: resourceClient,
        viewingUserId: viewingUserId,
        trigger: trigger,
        product: product,
        onChatClick: agentActions?.onChatClick,
        onConversationStartersClick: agentActions?.onConversationStartersClick,
        addFlag: addFlag
    });
    else return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5uXOq.Suspense), {
        fallback: null,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dYuIx.ProfileCardLazy), {
            ...profilecardProps,
            actions: profileCardAction,
            hasError: hasError,
            errorType: errorType,
            withoutElevation: true
        })
    });
}
function $74b3c02273951832$export$2e2bcd8739ae039({ autoFocus: autoFocus, trigger: trigger = 'hover', userId: userId, cloudId: cloudId, resourceClient: resourceClient, actions: actions = [], position: position = 'bottom-start', children: children, testId: testId, addFlag: addFlag, onReportingLinesClick: onReportingLinesClick, ariaLabel: ariaLabel, ariaLabelledBy: ariaLabelledBy, prepopulatedData: prepopulatedData, disabledAriaAttributes: disabledAriaAttributes, onVisibilityChange: onVisibilityChange, offset: offset, viewingUserId: viewingUserId, product: product, agentActions: agentActions, ariaHideProfileTrigger: ariaHideProfileTrigger = false, isVisible: propsIsVisible }) {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const isMounted = (0, $5uXOq.useRef)(false);
    const showDelay = trigger === 'click' || propsIsVisible && (0, $VSDnB.fg)('fix_profilecard_trigger_isvisible') ? 0 : (0, $e41878b3b8cab0db$export$5b956b542f1bc1b3);
    const hideDelay = trigger === 'click' || propsIsVisible && (0, $VSDnB.fg)('fix_profilecard_trigger_isvisible') ? 0 : (0, $e41878b3b8cab0db$export$89a9f35a94d7f196);
    const showTimer = (0, $5uXOq.useRef)(0);
    const hideTimer = (0, $5uXOq.useRef)(0);
    const [visible, setVisible] = (0, $5uXOq.useState)(false);
    const [isLoading, setIsLoading] = (0, $5uXOq.useState)(undefined);
    const [hasError, setHasError] = (0, $5uXOq.useState)(false);
    const [error, setError] = (0, $5uXOq.useState)(null);
    const [data, setData] = (0, $5uXOq.useState)(null);
    const [reportingLinesData, setReportingLinesData] = (0, $5uXOq.useState)(undefined);
    const [shouldShowGiveKudos, setShouldShowGiveKudos] = (0, $5uXOq.useState)(false);
    const [teamCentralBaseUrl, setTeamCentralBaseUrl] = (0, $5uXOq.useState)(undefined);
    const [kudosDrawerOpen, setKudosDrawerOpen] = (0, $5uXOq.useState)(false);
    const [isTriggeredUsingKeyboard, setTriggeredUsingKeyboard] = (0, $5uXOq.useState)(false);
    const triggerRef = (0, $5uXOq.useRef)(null);
    (0, $5uXOq.useEffect)(()=>{
        isMounted.current = true;
        return ()=>{
            isMounted.current = false;
            clearTimeout(showTimer.current);
            clearTimeout(hideTimer.current);
        };
    }, []);
    (0, $5uXOq.useEffect)(()=>{
        // Reset state when the userId changes
        setIsLoading(undefined);
        setHasError(false);
        setError(null);
        setData(null);
        setReportingLinesData(undefined);
        setShouldShowGiveKudos(false);
        setTeamCentralBaseUrl(undefined);
    }, [
        userId
    ]);
    const fireAnalytics = (0, $5uXOq.useCallback)((payload)=>{
        // Don't fire any analytics if the component is unmounted
        if (!isMounted.current) return;
        (0, $ivXTE.fireEvent)(createAnalyticsEvent, payload);
    }, [
        createAnalyticsEvent
    ]);
    const hideProfilecard = (0, $5uXOq.useCallback)(()=>{
        clearTimeout(showTimer.current);
        clearTimeout(hideTimer.current);
        if (!isTriggeredUsingKeyboard) hideTimer.current = window.setTimeout(()=>{
            setVisible(false);
            onVisibilityChange && onVisibilityChange(false);
        }, hideDelay);
    }, [
        hideDelay,
        isTriggeredUsingKeyboard,
        onVisibilityChange
    ]);
    const handleKeyboardClose = (0, $5uXOq.useCallback)((event)=>{
        if (event.key && event.key !== 'Escape') return;
        if (triggerRef.current) triggerRef.current.focus();
        setTriggeredUsingKeyboard(false);
        setVisible(false);
        onVisibilityChange && onVisibilityChange(false);
    }, [
        setTriggeredUsingKeyboard,
        setVisible,
        onVisibilityChange
    ]);
    const handleClientSuccess = (0, $5uXOq.useCallback)((profileData, reportingLinesData, shouldShowGiveKudos, teamCentralBaseUrl)=>{
        if (!isMounted.current) return;
        setIsLoading(false);
        setHasError(false);
        setData(profileData);
        setReportingLinesData(reportingLinesData);
        setTeamCentralBaseUrl(teamCentralBaseUrl);
        setShouldShowGiveKudos(shouldShowGiveKudos);
    }, [
        setHasError,
        setIsLoading,
        setData,
        setReportingLinesData,
        setShouldShowGiveKudos
    ]);
    const handleClientError = (0, $5uXOq.useCallback)((err)=>{
        if (!isMounted.current) return;
        setIsLoading(false);
        setHasError(true);
        setError(err);
    }, [
        setHasError,
        setIsLoading,
        setError
    ]);
    const clientFetchProfile = (0, $5uXOq.useCallback)(async ()=>{
        if (isLoading === true) // don't fetch data when fetching is in process
        return;
        setIsLoading(true);
        setHasError(false);
        setError(null);
        setData(null);
        try {
            const requests = Promise.all([
                resourceClient.getProfile(cloudId || '', userId, fireAnalytics),
                resourceClient.getReportingLines(userId),
                resourceClient.shouldShowGiveKudos(),
                resourceClient.getTeamCentralBaseUrl({
                    withOrgContext: true,
                    withSiteContext: true
                })
            ]);
            const responses = await requests;
            handleClientSuccess(...responses);
        } catch (err) {
            handleClientError(err);
        }
    }, [
        cloudId,
        fireAnalytics,
        isLoading,
        resourceClient,
        userId,
        handleClientSuccess,
        handleClientError
    ]);
    const showProfilecard = (0, $5uXOq.useCallback)(()=>{
        clearTimeout(hideTimer.current);
        clearTimeout(showTimer.current);
        showTimer.current = window.setTimeout(()=>{
            if (!visible) {
                clientFetchProfile();
                setVisible(true);
                onVisibilityChange && onVisibilityChange(true);
            }
        }, showDelay);
    }, [
        showDelay,
        visible,
        clientFetchProfile,
        onVisibilityChange
    ]);
    const onClick = (0, $5uXOq.useCallback)((event)=>{
        // If the user clicks on the trigger then we don't want that click event to
        // propagate out to parent containers. For example when clicking a mention
        // lozenge in an inline-edit.
        event.stopPropagation();
        showProfilecard();
        if (!visible) fireAnalytics((0, $ivXTE.cardTriggered)('user', 'click'));
    }, [
        fireAnalytics,
        showProfilecard,
        visible
    ]);
    const onMouseEnter = (0, $5uXOq.useCallback)(()=>{
        showProfilecard();
        if (!visible) fireAnalytics((0, $ivXTE.cardTriggered)('user', 'hover'));
    }, [
        fireAnalytics,
        showProfilecard,
        visible
    ]);
    const onKeyPress = (0, $5uXOq.useCallback)((event)=>{
        if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            setTriggeredUsingKeyboard(true);
            showProfilecard();
            if (!visible) fireAnalytics((0, $ivXTE.cardTriggered)('user', 'click'));
        }
    }, [
        fireAnalytics,
        showProfilecard,
        visible
    ]);
    const onFocus = (0, $5uXOq.useCallback)(()=>{
        showProfilecard();
    }, [
        showProfilecard
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (!(0, $VSDnB.fg)('fix_profilecard_trigger_isvisible')) return;
        // If the prop isVisible is not defined, we don't want to do anything
        if (propsIsVisible === undefined) return;
        // If the prop isVisible is defined, we want to show or hide the profile card based on the value
        if (propsIsVisible) showProfilecard();
        else hideProfilecard();
    }, [
        hideProfilecard,
        propsIsVisible,
        showProfilecard
    ]);
    const containerListeners = (0, $5uXOq.useMemo)(()=>trigger === 'hover' ? {
            onMouseEnter: onMouseEnter,
            onMouseLeave: hideProfilecard,
            onBlur: hideProfilecard,
            onKeyPress: onKeyPress
        } : {
            onClick: onClick,
            onKeyPress: onKeyPress
        }, [
        hideProfilecard,
        onClick,
        onKeyPress,
        onMouseEnter,
        trigger
    ]);
    const filterActions = (0, $5uXOq.useCallback)(()=>{
        return (0, $4sfdL.default)(actions, data);
    }, [
        actions,
        data
    ]);
    const openKudosDrawer = ()=>{
        hideProfilecard();
        setKudosDrawerOpen(true);
    };
    const closeKudosDrawer = ()=>{
        setKudosDrawerOpen(false);
    };
    const showLoading = isLoading === true || isLoading === undefined;
    const wrapperProps = (0, $5uXOq.useMemo)(()=>trigger === 'hover' ? {
            onMouseEnter: onMouseEnter,
            onMouseLeave: hideProfilecard,
            onFocus: onFocus
        } : {}, [
        hideProfilecard,
        onFocus,
        onMouseEnter,
        trigger
    ]);
    const profilecardProps = {
        userId: userId,
        fullName: prepopulatedData?.fullName,
        isCurrentUser: userId === viewingUserId,
        clientFetchProfile: clientFetchProfile,
        ...data,
        reportingLines: reportingLinesData,
        onReportingLinesClick: onReportingLinesClick,
        isKudosEnabled: shouldShowGiveKudos,
        teamCentralBaseUrl: teamCentralBaseUrl,
        cloudId: cloudId,
        openKudosDrawer: openKudosDrawer,
        isTriggeredUsingKeyboard: isTriggeredUsingKeyboard,
        disabledAriaAttributes: disabledAriaAttributes
    };
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2OMIu.Fragment), {
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1I7E8.default), {
                isOpen: !!visible,
                onClose: (event)=>{
                    hideProfilecard();
                    handleKeyboardClose(event);
                },
                placement: position,
                offset: offset ?? [
                    0,
                    8
                ],
                content: ()=>/*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                        ...wrapperProps,
                        children: showLoading ? /*#__PURE__*/ (0, $2OMIu.jsx)($74b3c02273951832$var$LoadingView, {
                            fireAnalytics: fireAnalytics
                        }) : visible && /*#__PURE__*/ (0, $2OMIu.jsx)($74b3c02273951832$var$ProfileCardContent, {
                            profilecardProps: profilecardProps,
                            isAgent: !!data?.isAgent,
                            userId: userId,
                            cloudId: cloudId,
                            resourceClient: resourceClient,
                            viewingUserId: viewingUserId,
                            trigger: trigger,
                            product: product,
                            profileCardAction: filterActions(),
                            errorType: error,
                            hasError: hasError,
                            agentActions: agentActions,
                            addFlag: addFlag
                        })
                    }),
                trigger: (triggerProps)=>{
                    const { ref: callbackRef, ...innerProps } = triggerProps;
                    const ref = (element)=>{
                        triggerRef.current = element;
                        if (typeof callbackRef === 'function') callbackRef(element);
                    };
                    const { 'aria-expanded': _, 'aria-haspopup': __, ...restInnerProps } = innerProps;
                    return /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
                        ...disabledAriaAttributes ? restInnerProps : triggerProps,
                        ...containerListeners,
                        ref: ref,
                        "data-testid": testId,
                        ...!ariaHideProfileTrigger && {
                            'aria-labelledby': ariaLabelledBy
                        },
                        ...disabledAriaAttributes ? {} : {
                            role: 'button',
                            //  aria-hidden cannot contain focusable elements: https://dequeuniversity.com/rules/axe/3.5/aria-hidden-focus
                            tabIndex: ariaHideProfileTrigger ? -1 : 0,
                            'aria-label': ariaHideProfileTrigger ? undefined : (0, $chprS.default)(ariaLabel, profilecardProps.fullName, formatMessage)
                        },
                        ...ariaHideProfileTrigger && {
                            'aria-hidden': 'true'
                        },
                        children: children
                    });
                },
                zIndex: (0, $k5uoT.layers).modal(),
                shouldUseCaptureOnOutsideClick: true,
                autoFocus: autoFocus ?? trigger === 'click',
                // This feature gate is currently enabled only for Jira_Web to avoid UI issues in Confluence_Web.
                shouldRenderToParent: (0, $VSDnB.fg)('enable_appropriate_reading_order_in_profile_card')
            }),
            shouldShowGiveKudos && teamCentralBaseUrl && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5uXOq.Suspense), {
                fallback: null,
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $adIkV.GiveKudosLauncherLazy), {
                    isOpen: kudosDrawerOpen,
                    recipient: {
                        type: (0, $gH4E9.KudosType).INDIVIDUAL,
                        recipientId: userId
                    },
                    analyticsSource: "profile-card",
                    teamCentralBaseUrl: teamCentralBaseUrl,
                    cloudId: cloudId,
                    addFlag: addFlag,
                    onClose: closeKudosDrawer
                })
            })
        ]
    });
}
const $74b3c02273951832$var$LoadingView = ({ fireAnalytics: fireAnalytics })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $jnj6z.CardWrapper), {
        testId: "profilecard.profilecardtrigger.loading",
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ifxzB.default), {
            fireAnalytics: fireAnalytics
        })
    });

});
parcelRegister("adIkV", function(module, exports) {

$parcel$export(module.exports, "GiveKudosLauncherLazy", () => $c3877992df568d20$export$93fe397a02fe8b76);

var $5uXOq = parcelRequire("5uXOq");

const $c3877992df568d20$export$93fe397a02fe8b76 = /*#__PURE__*/ (0, $5uXOq.lazy)(()=>(parcelRequire("8yX7f")));

});
parcelRegister("8yX7f", function(module, exports) {

let $63bf5ae7f89f081a$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $63bf5ae7f89f081a$var$load("76n7a"),
    $63bf5ae7f89f081a$var$load("l253H"),
    $63bf5ae7f89f081a$var$load("ffQaD"),
    $63bf5ae7f89f081a$var$load("kvRbA"),
    $63bf5ae7f89f081a$var$load("4Z0s8")
]).then(()=>parcelRequire('iRLc5'));

});


parcelRegister("gH4E9", function(module, exports) {

$parcel$export(module.exports, "KudosType", () => $b9e3bff5640b4187$export$4fa2020056771264);
$parcel$export(module.exports, "FlagEventType", () => $b9e3bff5640b4187$export$d21f9befaa2961a);
$parcel$export(module.exports, "isFlagEventTypeValue", () => $b9e3bff5640b4187$export$7a1fc1a1b0477464);
var $b9e3bff5640b4187$export$4fa2020056771264 = /*#__PURE__*/ function(KudosType) {
    KudosType["INDIVIDUAL"] = "individual";
    KudosType["TEAM"] = "team";
    return KudosType;
}({});
var $b9e3bff5640b4187$export$d21f9befaa2961a = /*#__PURE__*/ function(FlagEventType) {
    FlagEventType["KUDOS_CREATED"] = "kudos-created";
    FlagEventType["KUDOS_FAILED"] = "kudos-failed";
    FlagEventType["JIRA_KUDOS_CREATED"] = "jira-kudos-created";
    FlagEventType["JIRA_KUDOS_FAILED"] = "jira-kudos-failed";
    FlagEventType["DIRTY"] = "dirty";
    FlagEventType["CLOSE"] = "close";
    return FlagEventType;
}({});
const $b9e3bff5640b4187$export$7a1fc1a1b0477464 = (value)=>{
    return Object.values($b9e3bff5640b4187$export$d21f9befaa2961a).includes(value);
};

});

parcelRegister("4sfdL", function(module, exports) {

$parcel$export(module.exports, "default", () => $ea1251cd76451c32$export$2e2bcd8739ae039);
const $ea1251cd76451c32$var$filterActions = (actions = [], data)=>{
    return actions.filter((action)=>{
        if (!action.shouldRender) return true;
        else if (typeof action.shouldRender !== 'function') return Boolean(action.shouldRender);
        return action.shouldRender(data);
    });
};
var $ea1251cd76451c32$export$2e2bcd8739ae039 = $ea1251cd76451c32$var$filterActions;

});

parcelRegister("chprS", function(module, exports) {

$parcel$export(module.exports, "default", () => $4b051cf4c3ebf799$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
const $4b051cf4c3ebf799$var$getLabelMessage = (ariaLabelProp, fullName, formatMessage)=>{
    if (ariaLabelProp) return ariaLabelProp;
    return fullName ? formatMessage($4b051cf4c3ebf799$var$messages.label, {
        fullName: fullName
    }) : formatMessage($4b051cf4c3ebf799$var$messages.fallbackLabel);
};
const $4b051cf4c3ebf799$var$messages = (0, $7VHMR.defineMessages)({
    fallbackLabel: {
        id: 'profilecard.user.trigger.fallback-aria-label',
        defaultMessage: 'More information about this user',
        description: 'Label for profile card trigger when we do not have user name'
    },
    label: {
        id: 'profilecard.user.trigger.aria-label',
        defaultMessage: 'More information about {fullName}',
        description: 'Label for profile card trigger'
    }
});
var $4b051cf4c3ebf799$export$2e2bcd8739ae039 = $4b051cf4c3ebf799$var$getLabelMessage;

});

parcelRegister("jnj6z", function(module, exports) {

$parcel$export(module.exports, "CardWrapper", () => $a03faa2abdc74ae6$export$6aa22a823032b784);
$parcel$export(module.exports, "ProfileImage", () => $a03faa2abdc74ae6$export$a7a74ab5cffd1455);
$parcel$export(module.exports, "ActionsFlexSpacer", () => $a03faa2abdc74ae6$export$d395c8d16f1e359d);
$parcel$export(module.exports, "KudosBlobAnimation", () => $a03faa2abdc74ae6$export$4a8a956251d4bf6f);
$parcel$export(module.exports, "AnimationWrapper", () => $a03faa2abdc74ae6$export$58517bb1b373a54c);
$parcel$export(module.exports, "AnimatedKudosButton", () => $a03faa2abdc74ae6$export$6196a3f52a6944fe);
$parcel$export(module.exports, "ActionButtonGroup", () => $a03faa2abdc74ae6$export$73d695ae27330056);
$parcel$export(module.exports, "OverflowActionButtonsWrapper", () => $a03faa2abdc74ae6$export$ff778e5b796745a6);
$parcel$export(module.exports, "CardContent", () => $a03faa2abdc74ae6$export$64ef9b8c11710c47);
$parcel$export(module.exports, "DetailsGroup", () => $a03faa2abdc74ae6$export$35cf684daac137ac);
$parcel$export(module.exports, "DisabledInfo", () => $a03faa2abdc74ae6$export$2062e7265a95a823);
$parcel$export(module.exports, "LozengeWrapper", () => $a03faa2abdc74ae6$export$75180efdd3f4d9c2);
$parcel$export(module.exports, "CustomLozengeContainer", () => $a03faa2abdc74ae6$export$6ebf103500ba5a45);
$parcel$export(module.exports, "JobTitleLabel", () => $a03faa2abdc74ae6$export$d6c0e5f211c8d617);
$parcel$export(module.exports, "AppTitleLabel", () => $a03faa2abdc74ae6$export$4865ffa72a4d5f9);
$parcel$export(module.exports, "SpinnerContainer", () => $a03faa2abdc74ae6$export$a5e06607a5ac6158);
$parcel$export(module.exports, "CardContainer", () => $a03faa2abdc74ae6$export$8a23e74e5cf3ca41);
$parcel$export(module.exports, "DetailsLabel", () => $a03faa2abdc74ae6$export$138a08882ebf7289);
$parcel$export(module.exports, "DetailsLabelIcon", () => $a03faa2abdc74ae6$export$79d7d9b2f6a70c70);
$parcel$export(module.exports, "DetailsLabelText", () => $a03faa2abdc74ae6$export$b0ec2c767a0e0eab);
/* Card.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlaskit/design-system/no-styled-tagged-template-expression -- needs manual remediation */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $3JT92 = parcelRequire("3JT92");

var $VSDnB = parcelRequire("VSDnB");

var $MHKc7 = parcelRequire("MHKc7");
var $dS3PR = parcelRequire("dS3PR");


var $k5uoT = parcelRequire("k5uoT");

var $huHkE = parcelRequire("huHkE");

var $bWGt6 = parcelRequire("bWGt6");
function $a03faa2abdc74ae6$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $a03faa2abdc74ae6$var$kudosButtonAnimationTransformationCompiled = null;
const $a03faa2abdc74ae6$var$styles = {
    cardWrapper: "_2rkoglpi _1bsb1gwv",
    profileImage: "_kqswstnw _154i1ejb _1ltv1ejb",
    actionsFlexSpacer: "_16jlkb7n _1o9zidpf _i0dl1wug",
    kudosBlobAnimationStyle: "_1e0cglyw _4t3i1w81 _1bsb1w81 _1pby1mrw _kqswstnw _154ixy5q",
    animationWrapper: "_mkrz1rip _kqswstnw _154ize3t _1ltvze3t _94n5ze3t _1xi2ze3t",
    animatedKudosButton: "_18u0u2gc",
    actionButtonGroup: "_zulp12x7 _uiztglyw _19pkpxbi _2hwxze3t _18u0ze3t _otyrze3t _y3gnusic _1bahesu3 _1e0c1txw",
    overflowActionButtonsWrapper: "_1e0c1o8l _1bsbzwfg _4t3izwfg",
    cardContent: "_1e0c1txw _2lx21bp4 _1tkebv7e",
    detailsGroup: "_1e0c1txw _2lx21bp4 _18u01epz _19bvxy5q _1bsb18pt",
    disabledInfo: "_11c81o8v _syaz1fxt _19pkutpp _2hwxze3t _18u0ze3t _otyrze3t",
    lozengeWrapper: "_19pkpxbi _1e0c1ule",
    customLozengeContainer: "_1e0c1txw _2lx2vrvc _1n261g80 _1bah1y6m _19pkutpp",
    spinnerContainer: "_4cvr1h6o _1e0c1txw _4t3i16xz _1bah1h6o _kqswh2mm",
    cardContainer: "_1reo15vq _18m915vq _kqswh2mm _12vemgnk _1lrw14bs _ca0q1ejb _19bv1ejb _u5f31ejb _n3td1ejb",
    cardContainerActiveUser: "_1itk1419",
    cardContainerDisabledUser: "_1itkkf3t",
    cardContainerWithElevation: "_2rkoglpi _16qs1cd0",
    detailsLabel: "_zulpu2gc _1e0c1txw _4cvr1h6o _1bah1y6m _19pkutpp _2hwxze3t _18u0ze3t _otyrze3t _o5721q9c",
    detailsLabelExtraTopSpace: "_19pkxy5q",
    detailsLabelIcon: "_1e0c1txw _1o9zidpf _syaz131l _1bsb7vkz _4t3i7vkz _s7n4jp4b _19pkze3t",
    detailsLabelText: "_1reo15vq _18m915vq _11c8dcr7 _1bto1l2s _syaz1fxt _19pkze3t _18u0ze3t",
    kudosBlobAnimation: "_1e0cglyw _4t3i1w81 _1bsb1w81 _1pby1mrw _kqswstnw _j7hq1q51 _tip8kb7n _5sagi11n _1itkiwwe",
    jobTitleLabel: "_19pkze3t _otyrze3t _18u0utpp _2hwxze3t",
    appTitleLabel: "_2rkoglpi _syaz1fxt _u5f312x7 _19bv12x7 _1bsb1ns9 _19pk1b66 _otyrze3t _18u0utpp _2hwxze3t"
};
const $a03faa2abdc74ae6$export$6aa22a823032b784 = ({ children: children, role: role, testId: testId, labelledBy: labelledBy })=>(0, $VSDnB.fg)('compiled-migration-profilecard') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
        xcss: (0, $3JT92.cx)($a03faa2abdc74ae6$var$styles.cardWrapper),
        backgroundColor: 'elevation.surface.overlay',
        role: role,
        testId: testId,
        "aria-labelledby": labelledBy,
        children: children
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)($a03faa2abdc74ae6$var$CardWrapperLegacy, {
        "data-testid": testId,
        role: role,
        "aria-labelledby": labelledBy,
        children: children
    }); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $a03faa2abdc74ae6$var$CardWrapperLegacy = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e1ebb2vo19"
})("background-color:", (0, $huHkE.bgColor), ";border-radius:var(--ds-border-radius, 3px);width:360px;");
const $a03faa2abdc74ae6$export$a7a74ab5cffd1455 = ({ children: children })=>(0, $VSDnB.fg)('compiled-migration-profilecard') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
        xcss: (0, $3JT92.cx)($a03faa2abdc74ae6$var$styles.profileImage),
        children: children
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)($a03faa2abdc74ae6$var$ProfileImageLegacy, {
        children: children
    }); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $a03faa2abdc74ae6$var$ProfileImageLegacy = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e1ebb2vo18"
})({
    name: "eukccz",
    styles: "position:absolute;top:var(--ds-space-300, 24px);left:var(--ds-space-300, 24px)"
});
const $a03faa2abdc74ae6$export$d395c8d16f1e359d = ()=>(0, $VSDnB.fg)('compiled-migration-profilecard') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
        xcss: (0, $3JT92.cx)($a03faa2abdc74ae6$var$styles.actionsFlexSpacer)
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)($a03faa2abdc74ae6$var$ActionsFlexSpacerLegacy, {}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $a03faa2abdc74ae6$var$ActionsFlexSpacerLegacy = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e1ebb2vo17"
})({
    name: "18pny36",
    styles: "flex:1 0 auto"
}); // eslint-disable-next-line @atlaskit/design-system/no-keyframes-tagged-template-expression -- needs manual remediation
const $a03faa2abdc74ae6$var$kudosButtonAnimationTransformation = (0, $f8Sb3.keyframes)`
  0%   { transform: translate(-80px, -50px); }
  100% { transform: translate(90px, -70px); }
`;
const $a03faa2abdc74ae6$export$b08abf2f97b92ea5 = ()=>(0, $VSDnB.fg)('compiled-migration-profilecard') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
        xcss: (0, $3JT92.cx)($a03faa2abdc74ae6$var$styles.kudosBlobAnimationStyle)
    }) : // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $2OMIu.jsx)($a03faa2abdc74ae6$var$KudosBlobAnimationStyleLegacy, {
        className: "kudos-blob-animation"
    }); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $a03faa2abdc74ae6$var$KudosBlobAnimationStyleLegacy = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e1ebb2vo16"
})("display:none;height:150px;width:150px;z-index:-1;position:absolute;top:", 32 / 14, "em;animation-name:", $a03faa2abdc74ae6$var$kudosButtonAnimationTransformation, ";animation-iteration-count:1;animation-duration:3s;background-image:radial-gradient(\n\t\tcircle,\n\t\tvar(--ds-background-information-pressed, #85B8FF) 0%,\n\t\tvar(--ds-background-discovery-pressed, #B8ACF6) 25%,\n\t\ttransparent 50%\n\t);overflow:hidden;");
const $a03faa2abdc74ae6$export$4a8a956251d4bf6f = ()=>(0, $VSDnB.fg)('compiled-migration-profilecard') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
        xcss: (0, $3JT92.cx)($a03faa2abdc74ae6$var$styles.kudosBlobAnimationStyle)
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)($a03faa2abdc74ae6$var$KudosBlobAnimationLegacy, {});
const $a03faa2abdc74ae6$var$KudosBlobAnimationLegacy = ()=>/*#__PURE__*/ (0, $2OMIu.jsx)($a03faa2abdc74ae6$export$b08abf2f97b92ea5, {});
const $a03faa2abdc74ae6$export$58517bb1b373a54c = ({ children: children })=>(0, $VSDnB.fg)('compiled-migration-profilecard') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
        xcss: (0, $3JT92.cx)($a03faa2abdc74ae6$var$styles.animationWrapper),
        children: children
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)($a03faa2abdc74ae6$var$AnimationWrapperLegacy, {
        children: children
    }); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $a03faa2abdc74ae6$var$AnimationWrapperLegacy = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e1ebb2vo15"
})("clip-path:inset(0px 0px 0px 0px round ", (0, $k5uoT.borderRadius)(), "px);position:absolute;top:0;left:0;bottom:0;right:0;");
const $a03faa2abdc74ae6$export$6196a3f52a6944fe = ({ children: children })=>(0, $VSDnB.fg)('compiled-migration-profilecard') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
        xcss: (0, $3JT92.cx)($a03faa2abdc74ae6$var$styles.animatedKudosButton),
        children: children
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)($a03faa2abdc74ae6$var$AnimatedKudosButtonLegacy, {
        children: children
    }); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $a03faa2abdc74ae6$var$AnimatedKudosButtonLegacy = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e1ebb2vo14"
})({
    name: "18xp5qc",
    styles: "margin-left:var(--ds-space-100, 8px);&:focus-within .kudos-blob-animation,&:focus .kudos-blob-animation,&:hover .kudos-blob-animation{display:block;}"
});
const $a03faa2abdc74ae6$export$73d695ae27330056 = ({ children: children, testId: testId })=>(0, $VSDnB.fg)('compiled-migration-profilecard') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
        testId: testId,
        xcss: (0, $3JT92.cx)($a03faa2abdc74ae6$var$styles.actionButtonGroup),
        children: children
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)($a03faa2abdc74ae6$var$ActionButtonGroupLegacy, {
        "data-testid": testId,
        children: children
    }); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $a03faa2abdc74ae6$var$ActionButtonGroupLegacy = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e1ebb2vo13"
})("user-select:none;margin:var(--ds-space-200, 16px) 0 0 0;text-align:right;display:flex;justify-content:flex-end;button,a{position:relative;}button,a,span{margin-left:var(--ds-space-100, 8px);&:first-child{margin-left:var(--ds-space-0, 0px);}}a,button{&:focus{outline-color:", `var(--ds-border-focused, ${(0, $829f609a65d26a98$export$215b7063051591f1)})`, ";outline-offset:var(--ds-border-width, 2px);outline-style:solid;outline-width:var(--ds-border-width, 2px);}}");
const $a03faa2abdc74ae6$export$ff778e5b796745a6 = ({ children: children, testId: testId })=>(0, $VSDnB.fg)('compiled-migration-profilecard') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
        testId: testId,
        xcss: (0, $3JT92.cx)($a03faa2abdc74ae6$var$styles.overflowActionButtonsWrapper),
        children: children
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)($a03faa2abdc74ae6$var$OverflowActionButtonsWrapperLegacy, {
        "data-testid": testId,
        children: children
    }); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $a03faa2abdc74ae6$var$OverflowActionButtonsWrapperLegacy = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e1ebb2vo12"
})("display:inline-block;width:var(--ds-space-400, 32px);height:var(--ds-space-400, 32px);margin-left:var(--ds-space-100, 8px);button{&:focus{outline-color:", `var(--ds-border-focused, ${(0, $829f609a65d26a98$export$215b7063051591f1)})`, ";outline-offset:var(--ds-border-width, 2px);outline-style:solid;outline-width:var(--ds-border-width, 2px);}}");
const $a03faa2abdc74ae6$export$64ef9b8c11710c47 = ({ children: children })=>(0, $VSDnB.fg)('compiled-migration-profilecard') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
        xcss: (0, $3JT92.cx)($a03faa2abdc74ae6$var$styles.cardContent),
        children: children
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)($a03faa2abdc74ae6$var$CardContentLegacy, {
        children: children
    }); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $a03faa2abdc74ae6$var$CardContentLegacy = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e1ebb2vo11"
})({
    name: "1jc6z0y",
    styles: "display:flex;flex-direction:column;min-height:136px"
});
const $a03faa2abdc74ae6$export$35cf684daac137ac = ({ children: children })=>(0, $VSDnB.fg)('compiled-migration-profilecard') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
        xcss: (0, $3JT92.cx)($a03faa2abdc74ae6$var$styles.detailsGroup),
        children: children
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)($a03faa2abdc74ae6$var$DetailsGroupLegacy, {
        children: children
    }); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $a03faa2abdc74ae6$var$DetailsGroupLegacy = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e1ebb2vo10"
})({
    name: "c8pdei",
    styles: "display:flex;flex-direction:column;margin-left:116px;width:196px"
});
const $a03faa2abdc74ae6$export$2062e7265a95a823 = ({ children: children })=>(0, $VSDnB.fg)('compiled-migration-profilecard') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
        xcss: (0, $3JT92.cx)($a03faa2abdc74ae6$var$styles.disabledInfo),
        children: children
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)($a03faa2abdc74ae6$var$DisabledInfoLegacy, {
        children: children
    }); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $a03faa2abdc74ae6$var$DisabledInfoLegacy = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e1ebb2vo9"
})("font:var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif);color:", (0, $huHkE.labelTextColor), ";margin:var(--ds-space-150, 12px) 0 0 0;line-height:16px;");
const $a03faa2abdc74ae6$export$75180efdd3f4d9c2 = ({ children: children })=>(0, $VSDnB.fg)('compiled-migration-profilecard') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
        xcss: (0, $3JT92.cx)($a03faa2abdc74ae6$var$styles.lozengeWrapper),
        children: children
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)($a03faa2abdc74ae6$var$LozengeWrapperLegacy, {
        children: children
    }); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $a03faa2abdc74ae6$var$LozengeWrapperLegacy = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e1ebb2vo8"
})({
    name: "m760b1",
    styles: "margin-top:var(--ds-space-200, 16px);text-transform:uppercase;display:block"
});
const $a03faa2abdc74ae6$export$6ebf103500ba5a45 = ({ children: children })=>(0, $VSDnB.fg)('compiled-migration-profilecard') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
        xcss: (0, $3JT92.cx)($a03faa2abdc74ae6$var$styles.customLozengeContainer),
        children: children
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)($a03faa2abdc74ae6$var$CustomLozengeContainerLegacy, {
        children: children
    }); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $a03faa2abdc74ae6$var$CustomLozengeContainerLegacy = /*#__PURE__*/ (0, $bWGt6.default)($a03faa2abdc74ae6$export$75180efdd3f4d9c2, {
    target: "e1ebb2vo7"
})({
    name: "15oqcei",
    styles: "display:flex;flex-direction:row;flex-wrap:wrap;justify-content:flex-start;margin-top:var(--ds-space-150, 12px);>*{margin-top:var(--ds-space-050, 4px);&:not(:last-child){margin-right:var(--ds-space-050, 4px);}}"
});
const $a03faa2abdc74ae6$export$d6c0e5f211c8d617 = ({ children: children })=>(0, $VSDnB.fg)('compiled-migration-profilecard') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
        xcss: (0, $3JT92.cx)($a03faa2abdc74ae6$var$styles.jobTitleLabel),
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dS3PR.default), {
            maxLines: 1,
            color: "color.text.inverse",
            children: children
        })
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)($a03faa2abdc74ae6$var$JobTitleLabelLegacy, {
        children: children
    }); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $a03faa2abdc74ae6$var$JobTitleLabelLegacy = /*#__PURE__*/ (0, $bWGt6.default)("span", {
    target: "e1ebb2vo6"
})("overflow:hidden;text-overflow:ellipsis;white-space:nowrap;font:var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif);color:", (0, $huHkE.headerTextColor), ";margin:0 0 var(--ds-space-150, 12px) 0;");
const $a03faa2abdc74ae6$export$4865ffa72a4d5f9 = ({ children: children })=>(0, $VSDnB.fg)('compiled-migration-profilecard') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
        xcss: (0, $3JT92.cx)($a03faa2abdc74ae6$var$styles.appTitleLabel),
        backgroundColor: "color.background.neutral",
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dS3PR.default), {
            color: "color.text",
            size: "UNSAFE_small",
            weight: "bold",
            children: children
        })
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)($a03faa2abdc74ae6$var$AppTitleLabelLegacy, {
        children: children
    }); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $a03faa2abdc74ae6$var$AppTitleLabelLegacy = /*#__PURE__*/ (0, $bWGt6.default)("span", {
    target: "e1ebb2vo5"
})("background:", (0, $huHkE.appLabelBgColor), ";color:", (0, $huHkE.appLabelTextColor), ";border-radius:", (0, $k5uoT.borderRadius)(), ";padding:0 var(--ds-space-075, 6px);width:fit-content;font-weight:var(--ds-font-weight-bold, 700);text-transform:uppercase;font:var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif);margin:var(--ds-space-050, 4px) 0 var(--ds-space-150, 12px) 0;");
const $a03faa2abdc74ae6$export$a5e06607a5ac6158 = ({ children: children, testId: testId })=>(0, $VSDnB.fg)('compiled-migration-profilecard') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
        testId: testId,
        xcss: (0, $3JT92.cx)($a03faa2abdc74ae6$var$styles.spinnerContainer),
        children: children
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)($a03faa2abdc74ae6$var$SpinnerContainerLegacy, {
        "data-testid": testId,
        children: children
    }); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $a03faa2abdc74ae6$var$SpinnerContainerLegacy = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e1ebb2vo4"
})({
    name: "1e8m6rx",
    styles: "align-items:center;display:flex;height:96px;justify-content:center;position:relative"
});
const $a03faa2abdc74ae6$export$8a23e74e5cf3ca41 = ({ children: children, isDisabledUser: isDisabledUser, withoutElevation: withoutElevation })=>(0, $VSDnB.fg)('compiled-migration-profilecard') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
        xcss: (0, $3JT92.cx)($a03faa2abdc74ae6$var$styles.cardContainer, isDisabledUser ? $a03faa2abdc74ae6$var$styles.cardContainerDisabledUser : $a03faa2abdc74ae6$var$styles.cardContainerActiveUser, !withoutElevation && $a03faa2abdc74ae6$var$styles.cardContainerWithElevation),
        children: children
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)($a03faa2abdc74ae6$var$CardContainerLegacy, {
        isDisabledUser: isDisabledUser,
        withoutElevation: withoutElevation,
        children: children
    }); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $a03faa2abdc74ae6$var$CardContainerLegacy = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e1ebb2vo3"
})("position:relative;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;background-image:linear-gradient(\n\t\tto bottom,\n\t\t", (props)=>props.isDisabledUser ? (0, $huHkE.headerBgColorDisabledUser) : (0, $huHkE.headerBgColor), "\n\t\t\t0%,\n\t\t", (props)=>props.isDisabledUser ? (0, $huHkE.headerBgColorDisabledUser) : (0, $huHkE.headerBgColor), " 100%\n\t);background-repeat:no-repeat;background-size:100% 96px;box-sizing:content-box;padding:var(--ds-space-300, 24px);box-shadow:", (props)=>props.withoutElevation ? '' : `${`var(--ds-shadow-overlay, ${`0 4px 8px -2px ${0, $829f609a65d26a98$export$7d3359664e8bb0e5}, 0 0 1px ${0, $829f609a65d26a98$export$d2d3bedfb276cac0}`})`}`, ";border-radius:", (props)=>props.withoutElevation ? '' : `${(0, $k5uoT.borderRadius)()}px`, ";overflow:hidden;");
const $a03faa2abdc74ae6$export$138a08882ebf7289 = ({ children: children, extraTopSpace: extraTopSpace = false })=>(0, $VSDnB.fg)('compiled-migration-profilecard') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
        xcss: (0, $3JT92.cx)($a03faa2abdc74ae6$var$styles.detailsLabel, extraTopSpace && $a03faa2abdc74ae6$var$styles.detailsLabelExtraTopSpace),
        children: children
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)($a03faa2abdc74ae6$var$DetailsLabelLegacy, {
        children: children
    }); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $a03faa2abdc74ae6$var$DetailsLabelLegacy = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e1ebb2vo2"
})({
    name: "vjwven",
    styles: "display:flex;align-items:center;margin:var(--ds-space-200, 16px) 0 0 0;white-space:nowrap;&+&{margin-top:var(--ds-space-025, 2px);}"
});
const $a03faa2abdc74ae6$export$79d7d9b2f6a70c70 = ({ children: children })=>(0, $VSDnB.fg)('compiled-migration-profilecard') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
        as: "dt",
        xcss: (0, $3JT92.cx)($a03faa2abdc74ae6$var$styles.detailsLabelIcon),
        children: children
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)($a03faa2abdc74ae6$var$DetailsLabelIconLegacy, {
        children: children
    }); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $a03faa2abdc74ae6$var$DetailsLabelIconLegacy = /*#__PURE__*/ (0, $bWGt6.default)("dt", {
    target: "e1ebb2vo1"
})("display:flex;flex-shrink:0;color:", (0, $huHkE.labelIconColor), ";width:var(--ds-space-200, 16px);height:var(--ds-space-200, 16px);padding:var(--ds-space-050, 4px);vertical-align:top;svg{width:100%;height:100%;}");
const $a03faa2abdc74ae6$export$b0ec2c767a0e0eab = ({ children: children })=>(0, $VSDnB.fg)('compiled-migration-profilecard') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
        as: "dd",
        xcss: (0, $3JT92.cx)($a03faa2abdc74ae6$var$styles.detailsLabelText),
        children: children
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)($a03faa2abdc74ae6$var$DetailsLabelTextLegacy, {
        children: children
    }); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $a03faa2abdc74ae6$var$DetailsLabelTextLegacy = /*#__PURE__*/ (0, $bWGt6.default)("dd", {
    target: "e1ebb2vo0"
})("overflow:hidden;text-overflow:ellipsis;color:", (0, $huHkE.labelTextColor), ";font:var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif);padding-block:var(--ds-space-050, 4px);padding-left:var(--ds-space-050, 4px);margin-inline-start:0;margin-top:0;");

});
parcelRegister("huHkE", function(module, exports) {

$parcel$export(module.exports, "bgColor", () => $61d9a2704bf54ca1$export$7dcbec377a25efc6);
$parcel$export(module.exports, "headerBgColor", () => $61d9a2704bf54ca1$export$d3ec0459d8f4bbed);
$parcel$export(module.exports, "teamHeaderBgColor", () => $61d9a2704bf54ca1$export$afc7ad7e78cf1c79);
$parcel$export(module.exports, "headerBgColorDisabledUser", () => $61d9a2704bf54ca1$export$ef73fded6fab455c);
$parcel$export(module.exports, "headerTextColor", () => $61d9a2704bf54ca1$export$5c2df128da90e8de);
$parcel$export(module.exports, "appLabelBgColor", () => $61d9a2704bf54ca1$export$6f79b778f6280d31);
$parcel$export(module.exports, "appLabelTextColor", () => $61d9a2704bf54ca1$export$3db47a978b9599f9);
$parcel$export(module.exports, "labelTextColor", () => $61d9a2704bf54ca1$export$dd73341f2a5541fa);
$parcel$export(module.exports, "labelIconColor", () => $61d9a2704bf54ca1$export$5a20f73e634c37e3);
$parcel$export(module.exports, "errorIconColor", () => $61d9a2704bf54ca1$export$85e73a744c5d1042);
$parcel$export(module.exports, "errorTitleColor", () => $61d9a2704bf54ca1$export$be3c814f7ed506ed);

const $61d9a2704bf54ca1$export$7dcbec377a25efc6 = `var(--ds-surface-overlay, ${(0, $829f609a65d26a98$export$29a4f05edc054374)})`;
const $61d9a2704bf54ca1$export$d3ec0459d8f4bbed = `var(--ds-background-brand-bold, ${(0, $829f609a65d26a98$export$a6ee3d71bc067634)})`;
const $61d9a2704bf54ca1$export$afc7ad7e78cf1c79 = `var(--ds-background-neutral, ${(0, $829f609a65d26a98$export$8754fc7e6d8b3000)})`;
const $61d9a2704bf54ca1$export$ef73fded6fab455c = `var(--ds-background-disabled, ${(0, $829f609a65d26a98$export$3e51e8f1440314ba)})`;
const $61d9a2704bf54ca1$export$5c2df128da90e8de = `var(--ds-text-inverse, ${(0, $829f609a65d26a98$export$29a4f05edc054374)})`;
const $61d9a2704bf54ca1$export$a882617dcf7f98a6 = `var(--ds-text, ${(0, $829f609a65d26a98$export$7d61b15e0da132af)})`;
const $61d9a2704bf54ca1$export$6f79b778f6280d31 = `var(--ds-background-neutral, ${(0, $829f609a65d26a98$export$9fdfb749e33cdf97)})`;
const $61d9a2704bf54ca1$export$3db47a978b9599f9 = `var(--ds-text, ${(0, $829f609a65d26a98$export$c39c0fe0f26207ae)})`;
const $61d9a2704bf54ca1$export$dd73341f2a5541fa = `var(--ds-text, ${(0, $829f609a65d26a98$export$7d61b15e0da132af)})`;
const $61d9a2704bf54ca1$export$5a20f73e634c37e3 = `var(--ds-text-subtlest, ${(0, $829f609a65d26a98$export$c2e91cbeada39b8b)})`;
const $61d9a2704bf54ca1$export$85e73a744c5d1042 = `var(--ds-text-disabled, ${(0, $829f609a65d26a98$export$7c87d337fb91a97d)})`;
const $61d9a2704bf54ca1$export$be3c814f7ed506ed = `var(--ds-text, ${(0, $829f609a65d26a98$export$7d61b15e0da132af)})`;
const $61d9a2704bf54ca1$export$ddf766d3bfcf965c = `var(--ds-text-subtlest, ${(0, $829f609a65d26a98$export$7c87d337fb91a97d)})`;

});


parcelRegister("ivXTE", function(module, exports) {

$parcel$export(module.exports, "fireEvent", () => $533bc31bb6af10e0$export$43835e9acf248a15);
$parcel$export(module.exports, "cardTriggered", () => $533bc31bb6af10e0$export$d50ab8a3b6975c);
$parcel$export(module.exports, "teamRequestAnalytics", () => $533bc31bb6af10e0$export$c9b0e37b229a297b);
$parcel$export(module.exports, "userRequestAnalytics", () => $533bc31bb6af10e0$export$12dae48763368ac9);
$parcel$export(module.exports, "profileCardRendered", () => $533bc31bb6af10e0$export$41816a317479160b);
$parcel$export(module.exports, "actionClicked", () => $533bc31bb6af10e0$export$fdcd134fbeb1f921);
$parcel$export(module.exports, "reportingLinesClicked", () => $533bc31bb6af10e0$export$93260987012593be);
$parcel$export(module.exports, "moreActionsClicked", () => $533bc31bb6af10e0$export$79befd155063a6a7);
$parcel$export(module.exports, "teamAvatarClicked", () => $533bc31bb6af10e0$export$2703289b35687fde);
$parcel$export(module.exports, "moreMembersClicked", () => $533bc31bb6af10e0$export$b4411a7661cf2d3f);
$parcel$export(module.exports, "errorRetryClicked", () => $533bc31bb6af10e0$export$c86679da702d560e);
$parcel$export(module.exports, "agentRequestAnalytics", () => $533bc31bb6af10e0$export$a9f8c9f412cf5664);

var $6TKEY = parcelRequire("6TKEY");
/** Below lines are copied from teams common analytics */ const $533bc31bb6af10e0$var$ANALYTICS_CHANNEL = 'peopleTeams';
const $533bc31bb6af10e0$var$runItLater = (cb)=>{
    const requestIdleCallback = window.requestIdleCallback;
    if (typeof requestIdleCallback === 'function') return requestIdleCallback(cb);
    if (typeof window.requestAnimationFrame === 'function') return window.requestAnimationFrame(cb);
    return ()=>setTimeout(cb);
};
const $533bc31bb6af10e0$export$43835e9acf248a15 = (createAnalyticsEvent, body)=>{
    if (!createAnalyticsEvent) return;
    $533bc31bb6af10e0$var$runItLater(()=>{
        createAnalyticsEvent(body).fire($533bc31bb6af10e0$var$ANALYTICS_CHANNEL);
    });
};
/** Above lines are copied from teams common analytics */ const $533bc31bb6af10e0$var$TEAM_SUBJECT = 'teamProfileCard';
const $533bc31bb6af10e0$var$USER_SUBJECT = 'profilecard';
const $533bc31bb6af10e0$var$AGENT_SUBJECT = 'rovoAgentProfilecard';
const $533bc31bb6af10e0$var$createEvent = (eventType, action, actionSubject, actionSubjectId, attributes = {})=>({
        eventType: eventType,
        action: action,
        actionSubject: actionSubject,
        actionSubjectId: actionSubjectId,
        attributes: {
            packageName: "platform-pkg",
            packageVersion: "0.0.0-use.local",
            ...attributes,
            firedAt: Math.round((0, $6TKEY.getPageTime)())
        }
    });
const $533bc31bb6af10e0$var$getActionSubject = (type)=>{
    switch(type){
        case 'user':
            return $533bc31bb6af10e0$var$USER_SUBJECT;
        case 'team':
            return $533bc31bb6af10e0$var$TEAM_SUBJECT;
        case 'agent':
            return $533bc31bb6af10e0$var$AGENT_SUBJECT;
        default:
            return 'user';
    }
};
const $533bc31bb6af10e0$export$d50ab8a3b6975c = (type, method, teamId)=>{
    return $533bc31bb6af10e0$var$createEvent('ui', 'triggered', $533bc31bb6af10e0$var$getActionSubject(type), undefined, {
        method: method,
        ...type === 'team' && teamId ? {
            teamId: teamId
        } : {}
    });
};
const $533bc31bb6af10e0$export$c9b0e37b229a297b = (action, attributes)=>$533bc31bb6af10e0$var$createEvent('operational', action, $533bc31bb6af10e0$var$TEAM_SUBJECT, 'request', attributes);
const $533bc31bb6af10e0$export$12dae48763368ac9 = (action, attributes)=>$533bc31bb6af10e0$var$createEvent('operational', action, $533bc31bb6af10e0$var$USER_SUBJECT, 'request', attributes);
const $533bc31bb6af10e0$export$41816a317479160b = (type, actionSubjectId, attributes)=>$533bc31bb6af10e0$var$createEvent('ui', 'rendered', $533bc31bb6af10e0$var$getActionSubject(type), actionSubjectId, attributes);
const $533bc31bb6af10e0$export$fdcd134fbeb1f921 = (type, attributes)=>$533bc31bb6af10e0$var$createEvent('ui', 'clicked', $533bc31bb6af10e0$var$getActionSubject(type), 'action', attributes);
const $533bc31bb6af10e0$export$93260987012593be = (attributes)=>$533bc31bb6af10e0$var$createEvent('ui', 'clicked', $533bc31bb6af10e0$var$USER_SUBJECT, 'reportingLines', attributes);
const $533bc31bb6af10e0$export$79befd155063a6a7 = (type, attributes)=>$533bc31bb6af10e0$var$createEvent('ui', 'clicked', $533bc31bb6af10e0$var$getActionSubject(type), 'moreActions', attributes);
const $533bc31bb6af10e0$export$2703289b35687fde = (attributes)=>$533bc31bb6af10e0$var$createEvent('ui', 'clicked', $533bc31bb6af10e0$var$TEAM_SUBJECT, 'avatar', attributes);
const $533bc31bb6af10e0$export$b4411a7661cf2d3f = (attributes)=>$533bc31bb6af10e0$var$createEvent('ui', 'clicked', $533bc31bb6af10e0$var$TEAM_SUBJECT, 'moreMembers', attributes);
const $533bc31bb6af10e0$export$c86679da702d560e = (attributes)=>$533bc31bb6af10e0$var$createEvent('ui', 'clicked', $533bc31bb6af10e0$var$TEAM_SUBJECT, 'errorRetry', attributes);
const $533bc31bb6af10e0$export$a9f8c9f412cf5664 = (action, actionSubjectId, attributes)=>$533bc31bb6af10e0$var$createEvent('operational', action, $533bc31bb6af10e0$var$AGENT_SUBJECT, actionSubjectId || 'request', attributes);

});
parcelRegister("6TKEY", function(module, exports) {

$parcel$export(module.exports, "getPageTime", () => $83ec369559ddc36d$export$e9faea7c41053334);
const $83ec369559ddc36d$var$isPerformanceAvailable = ()=>{
    return typeof window !== 'undefined' && 'performance' in window && !!performance.now;
};
const $83ec369559ddc36d$var$performanceAvailable = $83ec369559ddc36d$var$isPerformanceAvailable();
const $83ec369559ddc36d$var$initialPageTime = Date.now();
const $83ec369559ddc36d$export$e9faea7c41053334 = ()=>{
    if ($83ec369559ddc36d$var$performanceAvailable) return performance.now();
    return Date.now() - $83ec369559ddc36d$var$initialPageTime;
};

});


const $e41878b3b8cab0db$export$5b956b542f1bc1b3 = 800;
const $e41878b3b8cab0db$export$89a9f35a94d7f196 = 200;

parcelRegister("kDbj5", function(module, exports) {

$parcel$export(module.exports, "AgentProfileCardResourced", () => $9f87d208f89c63eb$export$4b013ffffcb40af8);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $2NMNM = parcelRequire("2NMNM");

var $ivXTE = parcelRequire("ivXTE");

var $dG58U = parcelRequire("dG58U");

var $cI0Td = parcelRequire("cI0Td");

var $a3FJs = parcelRequire("a3FJs");

var $iwWWV = parcelRequire("iwWWV");
const $9f87d208f89c63eb$export$4b013ffffcb40af8 = (props)=>{
    const [agentData, setAgentData] = (0, $5uXOq.useState)();
    const [isLoading, setIsLoading] = (0, $5uXOq.useState)(false);
    const [error, setError] = (0, $5uXOq.useState)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const fireAnalytics = (0, $5uXOq.useCallback)((payload)=>{
        if (createAnalyticsEvent) (0, $ivXTE.fireEvent)(createAnalyticsEvent, payload);
    }, [
        createAnalyticsEvent
    ]);
    const creatorUserId = (0, $5uXOq.useMemo)(()=>agentData?.creator_type === 'CUSTOMER' && agentData.creator ? (0, $dG58U.getAAIDFromARI)(agentData.creator) : '', [
        agentData?.creator_type,
        agentData?.creator
    ]);
    const getCreator = (0, $5uXOq.useCallback)(async (creator_type, creator)=>{
        if (!creator) return undefined;
        switch(creator_type){
            case 'SYSTEM':
                return {
                    type: 'SYSTEM'
                };
            case 'THIRD_PARTY':
                return {
                    type: 'THIRD_PARTY',
                    name: creator ?? ''
                };
            case 'CUSTOMER':
                try {
                    if (!creatorUserId || !props.cloudId) return undefined;
                    const creatorInfo = await props.resourceClient.getProfile(creatorUserId, props.cloudId, fireAnalytics);
                    return {
                        type: 'CUSTOMER',
                        name: creatorInfo.fullName,
                        profileLink: `/people/${creatorUserId}`,
                        id: creatorUserId
                    };
                } catch (error) {
                    return undefined;
                }
            default:
                return undefined;
        }
    }, [
        creatorUserId,
        fireAnalytics,
        props.cloudId,
        props.resourceClient
    ]);
    const fetchData = (0, $5uXOq.useCallback)(async ()=>{
        setIsLoading(true);
        try {
            const profileData = await props.resourceClient.getRovoAgentProfile({
                type: 'identity',
                value: props.accountId
            }, fireAnalytics);
            const agentCreatorInfo = await getCreator(profileData?.creator_type, profileData?.creator || undefined);
            setAgentData({
                ...profileData,
                creatorInfo: agentCreatorInfo
            });
        } catch (err) {
            setError(err);
        } finally{
            setIsLoading(false);
        }
    }, [
        fireAnalytics,
        getCreator,
        props.accountId,
        props.resourceClient
    ]);
    (0, $5uXOq.useEffect)(()=>{
        fetchData();
    }, [
        fetchData
    ]);
    if (error || !isLoading && !agentData) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $a3FJs.AgentProfileCardWrapper), {
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cI0Td.default), {
            reload: ()=>{
                fetchData();
            },
            errorType: error || null,
            fireAnalytics: ()=>{}
        })
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5uXOq.Suspense), {
        fallback: null,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $iwWWV.AgentProfileCardLazy), {
            agent: agentData,
            isLoading: isLoading,
            hasError: !!error,
            isCreatedByViewingUser: creatorUserId === props.viewingUserId,
            product: props.product,
            onConversationStartersClick: props.onConversationStartersClick,
            onChatClick: props.onChatClick,
            addFlag: props.addFlag,
            resourceClient: props.resourceClient,
            cloudId: props.cloudId
        })
    });
};

});
parcelRegister("dG58U", function(module, exports) {

$parcel$export(module.exports, "getAAIDFromARI", () => $dd4eeae2be471029$export$3761e66a04602cbd);
const $dd4eeae2be471029$export$470b0d72e4fdc43a = 'ari:cloud:identity::user/';
const $dd4eeae2be471029$export$3761e66a04602cbd = (ari)=>{
    return ari.replace($dd4eeae2be471029$export$470b0d72e4fdc43a, '');
};

});

parcelRegister("cI0Td", function(module, exports) {

$parcel$export(module.exports, "default", () => $f71e8c5b4eb5da96$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $fVnbM = parcelRequire("fVnbM");

var $eCeGD = parcelRequire("eCeGD");

var $hI6SY = parcelRequire("hI6SY");

var $d5Zn3 = parcelRequire("d5Zn3");

var $VSDnB = parcelRequire("VSDnB");

var $cgL5K = parcelRequire("cgL5K");

var $2uTKk = parcelRequire("2uTKk");

var $ivXTE = parcelRequire("ivXTE");
const $f71e8c5b4eb5da96$var$ErrorMessage = (props)=>{
    const errorType = props.errorType || {
        reason: 'default'
    };
    const errorReason = errorType.reason;
    const { fireAnalytics: fireAnalytics, reload: reload } = props;
    const hasRetry = !!reload;
    (0, $5uXOq.useEffect)(()=>{
        fireAnalytics((0, $ivXTE.profileCardRendered)('user', 'error', {
            hasRetry: hasRetry,
            errorType: errorReason
        }));
    }, [
        errorReason,
        fireAnalytics,
        hasRetry
    ]);
    const errorContent = ()=>{
        if (errorReason === 'NotFound') return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2uTKk.ErrorTitle), {
            children: "The user is no longer available for the site"
        });
        return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2uTKk.ErrorTitle), {
            children: [
                "Oops, looks like we\u2019re having issues",
                /*#__PURE__*/ (0, $2OMIu.jsx)("br", {}),
                reload && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cgL5K.default), {
                    color: "color.text.subtlest",
                    children: "Try again and we\u2019ll give it another shot"
                })
            ]
        });
    };
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2uTKk.ErrorWrapper), {
        testId: "profilecard-error",
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($hI6SY))), {
                label: "icon error",
                LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($d5Zn3))),
                LEGACY_size: "xlarge"
            }),
            errorContent(),
            reload && ((0, $VSDnB.fg)('ptc_migrate_buttons') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eCeGD.default), {
                onClick: reload,
                children: "Try again"
            }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fVnbM.default), {
                appearance: "link",
                onClick: reload,
                children: "Try again"
            }))
        ]
    });
};
var $f71e8c5b4eb5da96$export$2e2bcd8739ae039 = $f71e8c5b4eb5da96$var$ErrorMessage;

});
parcelRegister("2uTKk", function(module, exports) {

$parcel$export(module.exports, "ErrorWrapper", () => $0619b202cbb0de2c$export$bb27b7e39840238f);
$parcel$export(module.exports, "ErrorTitle", () => $0619b202cbb0de2c$export$b065fd053267ec81);
$parcel$export(module.exports, "TeamErrorText", () => $0619b202cbb0de2c$export$90d92ccfb27352c6);
/* Error.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $3JT92 = parcelRequire("3JT92");

var $VSDnB = parcelRequire("VSDnB");

var $MHKc7 = parcelRequire("MHKc7");


var $huHkE = parcelRequire("huHkE");

var $bWGt6 = parcelRequire("bWGt6");
const $0619b202cbb0de2c$var$styles = {
    errorWrapper: "_y3gn1h6o _ca0q1ejb _u5f31ejb _n3td1ejb _19bv1ejb",
    errorTitle: "_11c82smr _syaz1fxt _19pku2gc",
    teamErrorText: "_syaz1wmz _19pku2gc"
};
const $0619b202cbb0de2c$export$bb27b7e39840238f = (props)=>(0, $VSDnB.fg)('compiled-migration-profilecard') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
        xcss: (0, $3JT92.cx)($0619b202cbb0de2c$var$styles.errorWrapper),
        ...props
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)($0619b202cbb0de2c$var$ErrorWrapperLegacy, {
        "data-testId": props.testId,
        children: props.children
    }); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $0619b202cbb0de2c$var$ErrorWrapperLegacy = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e1gaqn292"
})({
    textAlign: 'center',
    padding: "var(--ds-space-300, 24px)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    color: (0, $huHkE.errorIconColor)
});
const $0619b202cbb0de2c$export$b065fd053267ec81 = (props)=>(0, $VSDnB.fg)('compiled-migration-profilecard') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
        xcss: (0, $3JT92.cx)($0619b202cbb0de2c$var$styles.errorTitle),
        children: props.children
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)($0619b202cbb0de2c$var$ErrorTitleLegacy, {
        children: props.children
    }); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $0619b202cbb0de2c$var$ErrorTitleLegacy = /*#__PURE__*/ (0, $bWGt6.default)("p", {
    target: "e1gaqn291"
})({
    font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    color: (0, $huHkE.errorTitleColor),
    margin: `${"var(--ds-space-100, 8px)"} 0`
});
const $0619b202cbb0de2c$export$90d92ccfb27352c6 = (props)=>(0, $VSDnB.fg)('compiled-migration-profilecard') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
        xcss: (0, $3JT92.cx)($0619b202cbb0de2c$var$styles.teamErrorText),
        children: props.children
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)($0619b202cbb0de2c$var$TeamErrorTextLegacy, {
        children: props.children
    }); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $0619b202cbb0de2c$var$TeamErrorTextLegacy = /*#__PURE__*/ (0, $bWGt6.default)("p", {
    target: "e1gaqn290"
})({
    color: `var(--ds-text-subtlest, ${(0, $829f609a65d26a98$export$f563ee71e9ee74cd)})`,
    marginTop: "var(--ds-space-100, 8px)"
});

});


parcelRegister("a3FJs", function(module, exports) {

$parcel$export(module.exports, "AgentProfileCardWrapper", () => $642b3278878bc39a$export$2c6604b50c274e6f);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");
const $642b3278878bc39a$var$styles = (0, $8CUq3.xcss)({
    width: '360px'
});
const $642b3278878bc39a$export$2c6604b50c274e6f = ({ children: children })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dC5iT.default), {
        xcss: $642b3278878bc39a$var$styles,
        children: children
    });
};

});

parcelRegister("iwWWV", function(module, exports) {

$parcel$export(module.exports, "AgentProfileCardLazy", () => $b487397875f853f0$export$ed0ca9c1d49ea0bf);

var $5uXOq = parcelRequire("5uXOq");

const $b487397875f853f0$export$ed0ca9c1d49ea0bf = /*#__PURE__*/ (0, $5uXOq.lazy)(()=>(parcelRequire("g3ERZ")));

});
parcelRegister("g3ERZ", function(module, exports) {

let $bb0ca10dcfe65ac0$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $bb0ca10dcfe65ac0$var$load("76n7a"),
    $bb0ca10dcfe65ac0$var$load("l253H"),
    $bb0ca10dcfe65ac0$var$load("ffQaD"),
    $bb0ca10dcfe65ac0$var$load("kvRbA"),
    $bb0ca10dcfe65ac0$var$load("juOk6")
]).then(()=>parcelRequire('9gV7o'));

});



parcelRegister("ifxzB", function(module, exports) {

$parcel$export(module.exports, "default", () => $44786ae639641a68$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $eZJjh = parcelRequire("eZJjh");

var $jnj6z = parcelRequire("jnj6z");

var $ivXTE = parcelRequire("ivXTE");
const $44786ae639641a68$var$UserLoadingState = ({ fireAnalytics: fireAnalytics })=>{
    (0, $5uXOq.useEffect)(()=>{
        fireAnalytics((0, $ivXTE.profileCardRendered)('user', 'spinner'));
    }, [
        fireAnalytics
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $jnj6z.SpinnerContainer), {
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eZJjh.default), {})
    });
};
var $44786ae639641a68$export$2e2bcd8739ae039 = $44786ae639641a68$var$UserLoadingState;

});



parcelRegister("blw2B", function(module, exports) {

$parcel$export(module.exports, "default", () => $2b628efa3a075dd4$export$2e2bcd8739ae039);


var $bp5g1 = parcelRequire("bp5g1");


var $dFLsP = parcelRequire("dFLsP");
var $2b628efa3a075dd4$export$2e2bcd8739ae039 = (0, $bp5g1.default);

});
parcelRegister("bp5g1", function(module, exports) {

$parcel$export(module.exports, "default", () => $35fb800f6bdcf84a$export$2e2bcd8739ae039);

var $kTK0a = parcelRequire("kTK0a");
var $aIZdc = parcelRequire("aIZdc");

var $4zh20 = parcelRequire("4zh20");

var $4mT2s = parcelRequire("4mT2s");

var $fjEAi = parcelRequire("fjEAi");

var $dFLsP = parcelRequire("dFLsP");
const $35fb800f6bdcf84a$var$defaultConfig = {
    gatewayGraphqlUrl: '/gateway/api/graphql'
};
class $35fb800f6bdcf84a$var$ProfileCardClient {
    constructor(config, clients){
        //This default can be removed once all the clients are updated to pass the gatewayGraphqlUrl
        const withDefaultConfig = {
            ...$35fb800f6bdcf84a$var$defaultConfig,
            ...config,
            gatewayGraphqlUrl: config.gatewayGraphqlUrl ?? $35fb800f6bdcf84a$var$defaultConfig.gatewayGraphqlUrl
        };
        this.userClient = clients?.userClient || new (0, $dFLsP.default)(withDefaultConfig);
        this.teamClient = clients?.teamClient || new (0, $fjEAi.default)(withDefaultConfig);
        this.rovoAgentClient = clients?.rovoAgentClient || new (0, $4zh20.default)(withDefaultConfig);
        this.tcClient = $35fb800f6bdcf84a$var$maybeCreateTeamCentralClient(withDefaultConfig, clients);
    }
    flushCache() {
        this.userClient.flushCache();
        this.teamClient.flushCache();
        this.tcClient?.flushCache();
        this.rovoAgentClient?.flushCache();
    }
    getProfile(cloudId, userId, analytics) {
        return this.userClient.getProfile(cloudId, userId, analytics);
    }
    getTeamProfile(teamId, orgId, analytics) {
        return this.teamClient.getProfile(teamId, orgId, analytics);
    }
    getReportingLines(userId) {
        return this.tcClient?.getReportingLines(userId) || Promise.resolve({
            managers: [],
            reports: []
        });
    }
    async getTeamCentralBaseUrl(teamCentralScopes) {
        if (this.tcClient === undefined) return Promise.resolve(undefined);
        const isGlobalExperienceWorkspace = await this.tcClient.getIsGlobalExperienceWorkspace();
        if (!isGlobalExperienceWorkspace) return Promise.resolve((0, $kTK0a.getATLContextUrl)('team'));
        let suffix = '';
        if (teamCentralScopes !== undefined) {
            const orgId = await this.tcClient.getOrgId();
            if (orgId === null) return Promise.resolve(undefined);
            suffix += `/o/${orgId}`;
            if (teamCentralScopes.withSiteContext) suffix += `/s/${this.tcClient.options.cloudId}`;
        }
        return Promise.resolve(`${(0, $kTK0a.getATLContextUrl)('home')}${suffix}`);
    }
    async shouldShowGiveKudos() {
        if (!this.tcClient || !await this.getTeamCentralBaseUrl()) return Promise.resolve(false);
        return this.tcClient.checkWorkspaceExists();
    }
    getRovoAgentProfile(id, analytics) {
        return this.rovoAgentClient?.getProfile(id, analytics);
    }
    getRovoAgentPermissions(id, fireAnalytics) {
        return this.rovoAgentClient?.getPermissions(id, fireAnalytics);
    }
    deleteAgent(id, analytics) {
        return this.rovoAgentClient?.deleteAgent(id, analytics);
    }
    setFavouriteAgent(id, isFavourite, analytics) {
        return this.rovoAgentClient?.setFavouriteAgent(id, isFavourite, analytics);
    }
}
function $35fb800f6bdcf84a$var$maybeCreateTeamCentralClient(config, clients) {
    if ((0, $aIZdc.isFedRamp)()) return undefined;
    if (clients?.teamCentralClient) return clients.teamCentralClient;
    const teamCentralEnabled = config.teamCentralDisabled !== true;
    return teamCentralEnabled ? new (0, $4mT2s.default)({
        ...config
    }) : undefined;
}
var $35fb800f6bdcf84a$export$2e2bcd8739ae039 = $35fb800f6bdcf84a$var$ProfileCardClient;

});
parcelRegister("4zh20", function(module, exports) {

$parcel$export(module.exports, "default", () => $23b1bd6752a000ab$export$2e2bcd8739ae039);

var $ivXTE = parcelRequire("ivXTE");

var $6TKEY = parcelRequire("6TKEY");

var $cZg4V = parcelRequire("cZg4V");

var $f3Zb8 = parcelRequire("f3Zb8");
const $23b1bd6752a000ab$var$createHeaders = (product, cloudId, isBodyJson)=>{
    const headers = new Headers({
        'X-Product': product,
        'X-Experience-Id': 'profile-card',
        'X-Cloudid': cloudId || ''
    });
    if (isBodyJson) headers.set('Content-Type', 'application/json');
    return headers;
};
class $23b1bd6752a000ab$export$2e2bcd8739ae039 extends (0, $cZg4V.default) {
    constructor(options){
        super(options);
        this.options = options;
    }
    makeRequest(id, cloudId) {
        const product = this.options.productIdentifier || 'rovo';
        const headers = $23b1bd6752a000ab$var$createHeaders(product, this.options.cloudId);
        if (id.type === 'identity') return fetch(new Request(`/gateway/api/assist/agents/v1/accountid/${id.value}`, {
            method: 'GET',
            credentials: 'include',
            mode: 'cors',
            headers: headers
        })).then((response)=>response.json());
        return fetch(new Request(`/gateway/api/assist/agents/v1/${id.value}`, {
            method: 'GET',
            credentials: 'include',
            mode: 'cors',
            headers: headers
        })).then((response)=>response.json());
    }
    getProfile(id, analytics) {
        if (!id.value) return Promise.reject(new Error('Id is missing'));
        if (!this.options.cloudId) return Promise.reject(new Error('cloudId is missing'));
        const cache = this.getCachedProfile(id.value);
        if (cache) return Promise.resolve(cache);
        return new Promise((resolve, reject)=>{
            const startTime = (0, $6TKEY.getPageTime)();
            if (analytics) analytics((0, $ivXTE.agentRequestAnalytics)('triggered'));
            this.makeRequest(id, this.options.cloudId || '').then((data)=>{
                if (this.cache) this.setCachedProfile(id.value, data);
                if (analytics) analytics((0, $ivXTE.agentRequestAnalytics)('succeeded', 'request', {
                    duration: (0, $6TKEY.getPageTime)() - startTime,
                    gateway: true
                }));
                resolve(data);
            }).catch((error)=>{
                if (analytics) analytics((0, $ivXTE.agentRequestAnalytics)('failed', 'request', {
                    duration: (0, $6TKEY.getPageTime)() - startTime,
                    ...(0, $f3Zb8.getErrorAttributes)(error),
                    gateway: true
                }));
                reject(error);
            });
        });
    }
    deleteAgent(agentId, analytics) {
        if (!this.options.cloudId) return Promise.reject(new Error('cloudId is missing'));
        return new Promise((resolve, reject)=>{
            const startTime = (0, $6TKEY.getPageTime)();
            const product = this.options.productIdentifier || 'rovo';
            if (analytics) analytics((0, $ivXTE.agentRequestAnalytics)('triggered'));
            const headers = $23b1bd6752a000ab$var$createHeaders(product, this.options.cloudId);
            fetch(new Request(`/gateway/api/assist/agents/v1/${agentId}`, {
                method: 'DELETE',
                credentials: 'include',
                mode: 'cors',
                headers: headers
            })).then(()=>{
                if (analytics) analytics((0, $ivXTE.agentRequestAnalytics)('succeeded', 'deleteAgent', {
                    duration: (0, $6TKEY.getPageTime)() - startTime,
                    gateway: true
                }));
                resolve();
            }).catch((error)=>{
                if (analytics) analytics((0, $ivXTE.agentRequestAnalytics)('failed', 'deleteAgent', {
                    duration: (0, $6TKEY.getPageTime)() - startTime,
                    ...(0, $f3Zb8.getErrorAttributes)(error),
                    gateway: true
                }));
                reject(error);
            });
        });
    }
    setFavouriteAgent(agentId, isFavourite, analytics) {
        if (!this.options.cloudId) return Promise.reject(new Error('cloudId is missing'));
        return new Promise(async (resolve, reject)=>{
            const startTime = (0, $6TKEY.getPageTime)();
            const product = this.options.productIdentifier || 'rovo';
            const actionSubjectId = isFavourite ? 'favourite' : 'unfavourite';
            const requestMethod = isFavourite ? 'POST' : 'DELETE';
            if (analytics) analytics((0, $ivXTE.agentRequestAnalytics)('triggered', 'actionSubjectId'));
            const headers = $23b1bd6752a000ab$var$createHeaders(product, this.options.cloudId);
            await fetch(new Request(`/gateway/api/assist/agents/v1/${agentId}/favourite`, {
                method: requestMethod,
                credentials: 'include',
                mode: 'cors',
                headers: headers
            })).then(()=>{
                if (analytics) analytics((0, $ivXTE.agentRequestAnalytics)('succeeded', actionSubjectId, {
                    duration: (0, $6TKEY.getPageTime)() - startTime,
                    gateway: true
                }));
                resolve();
            }).catch((error)=>{
                if (analytics) analytics((0, $ivXTE.agentRequestAnalytics)('failed', actionSubjectId, {
                    duration: (0, $6TKEY.getPageTime)() - startTime,
                    ...(0, $f3Zb8.getErrorAttributes)(error),
                    gateway: true
                }));
                reject(error);
            });
        });
    }
    getPermissions(id, fireAnalytics) {
        if (!this.options.cloudId) return Promise.reject(new Error('cloudId is missing'));
        return new Promise((resolve, reject)=>{
            const startTime = (0, $6TKEY.getPageTime)();
            const product = this.options.productIdentifier || 'rovo';
            if (fireAnalytics) fireAnalytics((0, $ivXTE.agentRequestAnalytics)('triggered'));
            const headers = $23b1bd6752a000ab$var$createHeaders(product, this.options.cloudId, true);
            fetch(new Request(`/gateway/api/assist/api/rovo/v2/permissions/agents/${id}`, {
                method: 'POST',
                credentials: 'include',
                mode: 'cors',
                headers: headers,
                body: JSON.stringify({
                    permission_ids: [
                        'AGENT_CREATE',
                        'AGENT_UPDATE',
                        'AGENT_DELETE',
                        'AGENT_DEACTIVATE',
                        'AGENT_READ'
                    ]
                })
            })).then((response)=>response.json()).then((data)=>{
                if (fireAnalytics) fireAnalytics((0, $ivXTE.agentRequestAnalytics)('succeeded', 'getAgentPermissions', {
                    duration: (0, $6TKEY.getPageTime)() - startTime,
                    gateway: true
                }));
                resolve(data);
            }).catch((error)=>{
                if (fireAnalytics) fireAnalytics((0, $ivXTE.agentRequestAnalytics)('failed', 'getAgentPermissions', {
                    duration: (0, $6TKEY.getPageTime)() - startTime,
                    ...(0, $f3Zb8.getErrorAttributes)(error),
                    gateway: true
                }));
                reject(error);
            });
        });
    }
}

});
parcelRegister("cZg4V", function(module, exports) {

$parcel$export(module.exports, "default", () => $e76084040147eae1$export$2e2bcd8739ae039);

var $iwKVT = parcelRequire("iwKVT");
class $e76084040147eae1$export$2e2bcd8739ae039 {
    constructor(config){
        const defaults = {
            cacheSize: 10,
            cacheMaxAge: 0
        };
        this.config = {
            ...defaults,
            ...config
        };
        // never set cacheSize or cacheMaxAge to negative numbers
        this.config.cacheSize = Math.max(this.config.cacheSize || 0, 0);
        this.config.cacheMaxAge = Math.max(this.config.cacheMaxAge || 0, 0);
        // DIR-474: cap cache at 30 days.
        if (this.config.cacheMaxAge) this.config.cacheMaxAge = Math.min(this.config.cacheMaxAge, 2592000000);
        // Only set cache if maxCacheAge and cacheSize are set
        this.cache = !this.config.cacheMaxAge || !this.config.cacheSize ? null : new (0, $iwKVT.LRUMap)(this.config.cacheSize);
    }
    setCachedProfile(cacheIdentifier, profile) {
        this.cache && this.cache.set(cacheIdentifier, {
            expire: Date.now() + this.config.cacheMaxAge,
            profile: profile
        });
    }
    getCachedProfile(cacheIdentifier) {
        if (!this.cache) return null;
        const cached = this.cache.get(cacheIdentifier);
        if (!cached) return null;
        if (cached.expire < Date.now()) {
            this.cache.delete(cacheIdentifier);
            return null;
        }
        // Extend expiry "date"
        this.setCachedProfile(cacheIdentifier, cached.profile);
        return cached.profile;
    }
    flushCache() {
        if (this.cache) this.cache.clear();
    }
}

});

parcelRegister("f3Zb8", function(module, exports) {

$parcel$export(module.exports, "getErrorAttributes", () => $b5fa858d1f1072ea$export$6ad9e7706a4ee0f8);
$parcel$export(module.exports, "handleDirectoryGraphQLErrors", () => $b5fa858d1f1072ea$export$7642af465ceb7f05);
$parcel$export(module.exports, "handleAGGErrors", () => $b5fa858d1f1072ea$export$d9ad65d422ee3f8c);

var $fcA5f = parcelRequire("fcA5f");
const $b5fa858d1f1072ea$var$IGNORED_ERROR_REASONS_DIRECTORY = [
    // Error categories from pf-directory
    'NotPermitted',
    'Gone',
    'IdentityUserNotFoundError'
];
const $b5fa858d1f1072ea$var$IGNORE_ERROR_TYPES_AGG = [
    'IdentityUserNotFoundError',
    'TEAMS_FORBIDDEN',
    'TEAMS_TEAM_DELETED'
];
const $b5fa858d1f1072ea$var$IGNORE_ERROR_CLASSIFICATIONS_AGG = [
    'Gone'
];
function $b5fa858d1f1072ea$var$isIgnoredError(error) {
    if (!error) return false;
    if (error instanceof (0, $fcA5f.DirectoryGraphQLError)) return !!error && $b5fa858d1f1072ea$var$IGNORED_ERROR_REASONS_DIRECTORY.includes(error.type);
    else if (error instanceof (0, $fcA5f.AGGError)) return !!error.errorType && $b5fa858d1f1072ea$var$IGNORE_ERROR_TYPES_AGG.includes(error.errorType) || !!error.classification && $b5fa858d1f1072ea$var$IGNORE_ERROR_CLASSIFICATIONS_AGG.includes(error.classification);
    return false;
}
const $b5fa858d1f1072ea$export$6ad9e7706a4ee0f8 = (error)=>{
    if (error instanceof (0, $fcA5f.DirectoryGraphQLErrors)) return {
        errorMessage: error.message,
        errorCount: error.errors.length,
        errorDetails: error.errors.map($b5fa858d1f1072ea$export$6ad9e7706a4ee0f8),
        isSLOFailure: !error.errors.every($b5fa858d1f1072ea$var$isIgnoredError),
        traceId: error.traceId
    };
    else if (error instanceof (0, $fcA5f.DirectoryGraphQLError)) return {
        errorMessage: error.message,
        errorCategory: error.category,
        errorType: error.type,
        errorPath: error.path,
        errorNumber: error.errorNumber,
        isSLOFailure: !$b5fa858d1f1072ea$var$isIgnoredError(error)
    };
    else if (error instanceof (0, $fcA5f.AGGErrors)) return {
        errorMessage: error.message,
        errorCount: error.errors.length,
        errorDetails: error.errors.map($b5fa858d1f1072ea$export$6ad9e7706a4ee0f8),
        isSLOFailure: !error.errors.every($b5fa858d1f1072ea$var$isIgnoredError),
        traceId: error.traceId
    };
    else if (error instanceof (0, $fcA5f.AGGError)) return {
        errorMessage: error.message,
        errorType: error.errorType,
        errorStatusCode: error.statusCode,
        isSLOFailure: !$b5fa858d1f1072ea$var$isIgnoredError(error),
        errorCategory: error.classification
    };
    else if (error instanceof Error) {
        // Jira custom profile card client error, they wrap the error & put the underlying error in the cause property
        if (error.message.startsWith('Unable to fetch user:')) {
            if (error.hasOwnProperty('cause')) {
                const causeError = error.cause;
                if (causeError instanceof (0, $fcA5f.DirectoryGraphQLErrors) || causeError instanceof (0, $fcA5f.AGGErrors)) return $b5fa858d1f1072ea$export$6ad9e7706a4ee0f8(causeError);
            }
            return {
                errorMessage: error.message,
                isSLOFailure: false
            };
        }
        return {
            errorMessage: error.message,
            isSLOFailure: true
        };
    }
    // Unknown
    return {
        errorMessage: 'Unknown error',
        isSLOFailure: true
    };
};
const $b5fa858d1f1072ea$export$7642af465ceb7f05 = (errors, traceId)=>{
    throw new (0, $fcA5f.DirectoryGraphQLErrors)(errors, traceId);
};
const $b5fa858d1f1072ea$export$d9ad65d422ee3f8c = (errors, traceId)=>{
    throw new (0, $fcA5f.AGGErrors)(errors, traceId);
};

});
parcelRegister("fcA5f", function(module, exports) {

$parcel$export(module.exports, "HttpError", () => $7db90b14dd6e48a6$export$65bd6083489bd8bb);
$parcel$export(module.exports, "DirectoryGraphQLError", () => $7db90b14dd6e48a6$export$c1e4d0de940c06a2);
$parcel$export(module.exports, "DirectoryGraphQLErrors", () => $7db90b14dd6e48a6$export$5a5fbfed34a590a1);
$parcel$export(module.exports, "AGGError", () => $7db90b14dd6e48a6$export$4a696f048dcc929);
$parcel$export(module.exports, "AGGErrors", () => $7db90b14dd6e48a6$export$60d8267243755b9c);
class $7db90b14dd6e48a6$export$65bd6083489bd8bb extends Error {
    constructor(code, reason, traceId){
        super(reason);
        this.code = code;
        this.traceId = traceId;
    }
}
class $7db90b14dd6e48a6$export$c1e4d0de940c06a2 extends Error {
    constructor(message, category, type, extensions = {}, path = []){
        super(message);
        this.category = category;
        this.type = type;
        this.path = path.join('.');
        const { errorNumber: errorNumber, ...unknownExtension } = extensions;
        this.errorNumber = extensions.errorNumber;
        this.extensions = unknownExtension;
    }
}
class $7db90b14dd6e48a6$export$5a5fbfed34a590a1 extends Error {
    constructor(errors, traceId){
        super('DirectoryGraphQLErrors');
        this.traceId = traceId;
        if (Array.isArray(errors)) this.errors = errors.map((error)=>new $7db90b14dd6e48a6$export$c1e4d0de940c06a2(error.message, error.category, error.type, error.extensions, error.path));
        else this.errors = [];
    }
}
class $7db90b14dd6e48a6$export$4a696f048dcc929 extends Error {
    constructor(message, extensions, path = []){
        super(message);
        this.path = path?.join('.');
        const { statusCode: statusCode, errorType: errorType, classification: classification, ...unknownExtension } = extensions;
        this.statusCode = statusCode;
        this.errorType = errorType;
        this.classification = classification;
        this.extensions = unknownExtension;
    }
}
class $7db90b14dd6e48a6$export$60d8267243755b9c extends Error {
    constructor(errors, traceId){
        super('AGGErrors');
        this.traceId = traceId;
        if (Array.isArray(errors)) this.errors = errors.map((error)=>new $7db90b14dd6e48a6$export$4a696f048dcc929(error.message, error.extensions, error.path));
        else this.errors = [];
    }
}

});



parcelRegister("4mT2s", function(module, exports) {

$parcel$export(module.exports, "default", () => $b8d68ade6ab7f448$export$2e2bcd8739ae039);

var $VSDnB = parcelRequire("VSDnB");

var $cZg4V = parcelRequire("cZg4V");

var $a6hGK = parcelRequire("a6hGK");

var $hnIbm = parcelRequire("hnIbm");
const $b8d68ade6ab7f448$var$UNSHARDED_PREFIX = '/gateway/api/watermelon';
const $b8d68ade6ab7f448$export$1862ef0c3880ca8d = (aaid)=>({
        query: `
    fragment ReportingLinesUserPII on UserPII {
      name
      picture
    }

    fragment ReportingLinesUserFragment on ReportingLinesUser {
      accountIdentifier
      identifierType
      pii {
        ...ReportingLinesUserPII
      }
    }

    query ReportingLines($aaid: String) {
      reportingLines(aaidOrHash: $aaid) {
        managers {
          ...ReportingLinesUserFragment
        }
        reports {
          ...ReportingLinesUserFragment
        }
      }
    }
  `,
        variables: {
            aaid: aaid
        }
    });
const $b8d68ade6ab7f448$var$orgContainsAnyWorkspacePromiseCache = new Map();
const $b8d68ade6ab7f448$var$orgIdPromiseCache = new Map();
const $b8d68ade6ab7f448$var$workspaceExistsWithTypePromiseCache = new Map();
class $b8d68ade6ab7f448$var$TeamCentralCardClient extends (0, $cZg4V.default) {
    constructor(options){
        super(options);
        this.options = options;
        this.bypassOnFailure = false;
        this.orgContainsAnyWorkspacePromise = this.createOrgContainsAnyWorkspacePromise(options);
        this.workspaceExistsWithTypePromise = this.preloadWorkspaceExistsWithType(options.cloudId);
        this.orgIdPromise = this.preloadOrgId(options.gatewayGraphqlUrl, options.cloudId, options.orgId);
    }
    createOrgContainsAnyWorkspacePromise(config) {
        if (config.cloudId) {
            let promise = $b8d68ade6ab7f448$var$orgContainsAnyWorkspacePromiseCache.get(config.cloudId);
            if (!promise) {
                promise = this.getOrgContainsAnyWorkspace(config.cloudId);
                $b8d68ade6ab7f448$var$orgContainsAnyWorkspacePromiseCache.set(config.cloudId, promise);
            }
            return promise;
        }
        return Promise.resolve(true);
    }
    getReportingLines(userId) {
        return this.orgContainsAnyWorkspacePromise.then((orgContainsAnyWorkspace)=>{
            if (orgContainsAnyWorkspace) {
                if (!userId) return Promise.reject(new Error('userId missing'));
                const cache = this.getCachedProfile(userId);
                if (cache) return Promise.resolve(cache);
                if (this.bypassOnFailure) return Promise.resolve({});
                return new Promise((resolve)=>{
                    this.makeRequest(userId).then((data)=>{
                        const enhancedData = {
                            managers: this.filterReportingLinesUser(data?.managers),
                            reports: this.filterReportingLinesUser(data?.reports)
                        };
                        if (this.cache) this.setCachedProfile(userId, enhancedData);
                        resolve(enhancedData);
                    }).catch((error)=>{
                        if (error?.status === 401 || error?.status === 403) // Trigger circuit breaker
                        this.bypassOnFailure = true;
                        /**
								 * Reporting lines aren't part of the critical path of profile card.
								 * Just resolve with empty values instead of bubbling up the error.
								 */ resolve({});
                    });
                });
            }
            return Promise.resolve({
                managers: [],
                reports: []
            });
        }, ()=>Promise.resolve({
                managers: [],
                reports: []
            }));
    }
    /**
	 * `public` so that mock client can override it; do not use it otherwise!
	 */ async makeRequest(userId) {
        if (this.options.teamCentralDisabled === true) throw new Error('makeRequest cannot be called when the client has been disabled');
        const query = $b8d68ade6ab7f448$export$1862ef0c3880ca8d(userId);
        const response = await (0, $hnIbm.directoryGraphqlQuery)('/gateway/api/watermelon/graphql?operationName=ReportingLines', query);
        return response.reportingLines;
    }
    async checkWorkspaceExists() {
        const workspaceExistsPromise = (0, $VSDnB.fg)('enable_ptc_townsquare_reporting_lines_unsharded') ? this.workspaceExistsWithTypePromise.then((workspaceExistsWithType)=>workspaceExistsWithType !== undefined) : this.orgContainsAnyWorkspacePromise;
        return workspaceExistsPromise.then((workspaceExistsWithType)=>{
            if (workspaceExistsWithType) return Promise.resolve(true);
            return Promise.resolve(false);
        }, ()=>Promise.resolve(false));
    }
    async getIsGlobalExperienceWorkspace() {
        return await this.workspaceExistsWithTypePromise === 'GLOBAL_EXPERIENCE';
    }
    getOrgId() {
        return this.orgIdPromise;
    }
    preloadWorkspaceExistsWithType(cloudId) {
        if (cloudId === undefined) return Promise.resolve(undefined);
        const maybeWorkspaceExistsWithTypePromise = $b8d68ade6ab7f448$var$workspaceExistsWithTypePromiseCache.get(cloudId);
        if (maybeWorkspaceExistsWithTypePromise !== undefined) return maybeWorkspaceExistsWithTypePromise;
        const workspaceExistsWithTypePromise = this.getWorkspaceExistsWithType(cloudId);
        $b8d68ade6ab7f448$var$workspaceExistsWithTypePromiseCache.set(cloudId, workspaceExistsWithTypePromise);
        return workspaceExistsWithTypePromise;
    }
    getOrgContainsAnyWorkspace(cloudId) {
        if (cloudId) return fetch(((0, $VSDnB.fg)('enable_ptc_townsquare_reporting_lines_unsharded') ? $b8d68ade6ab7f448$var$UNSHARDED_PREFIX : this.getShardedApiPath(cloudId)) + `/organization/containsAnyWorkspace?cloudId=${cloudId}`).then((res)=>{
            return !res || res && res.ok;
        });
        else return Promise.resolve(false);
    }
    async getWorkspaceExistsWithType(cloudId) {
        try {
            const response = await fetch(`${this.getShardedApiPath(cloudId)}/workspace/existsWithWorkspaceType?cloudId=${cloudId}`, {
                credentials: 'include'
            });
            if (response.ok) {
                const workspaceType = await response.text();
                return Promise.resolve(workspaceType);
            }
        } catch (err) {
            return Promise.resolve(undefined);
        }
    }
    preloadOrgId(gatewayGraphqlUrl, cloudId, orgId) {
        if (cloudId === undefined) return Promise.resolve(null);
        if (orgId !== undefined) return Promise.resolve(orgId);
        const maybeOrgIdForCloudIdPromise = $b8d68ade6ab7f448$var$orgIdPromiseCache.get(cloudId);
        if (maybeOrgIdForCloudIdPromise !== undefined) return maybeOrgIdForCloudIdPromise;
        const orgIdForCloudIdPromise = (0, $a6hGK.getOrgIdForCloudIdFromAGG)(gatewayGraphqlUrl, cloudId);
        $b8d68ade6ab7f448$var$orgIdPromiseCache.set(cloudId, orgIdForCloudIdPromise);
        return orgIdForCloudIdPromise;
    }
    getShardedApiPath(cloudId) {
        return `/gateway/api/townsquare/s/${cloudId}`;
    }
    filterReportingLinesUser(users = []) {
        return users.filter((user)=>user.identifierType === 'ATLASSIAN_ID');
    }
}
var $b8d68ade6ab7f448$export$2e2bcd8739ae039 = $b8d68ade6ab7f448$var$TeamCentralCardClient;

});
parcelRegister("a6hGK", function(module, exports) {

$parcel$export(module.exports, "getOrgIdForCloudIdFromAGG", () => $9b806d5a2251e5d5$export$d38a536fd806c68f);

var $hnIbm = parcelRequire("hnIbm");
const $9b806d5a2251e5d5$var$ORG_ID_FROM_CLOUD_ID_QUERY = `query OrgIdFromCloudId($cloudId: ID!) {
	tenantContexts(cloudIds: [$cloudId]) {
		orgId
	}
}`;
const $9b806d5a2251e5d5$var$addHeaders = (headers)=>{
    headers.append('atl-client-name', "platform-pkg");
    headers.append('atl-client-version', "0.0.0-use.local");
    return headers;
};
async function $9b806d5a2251e5d5$export$d38a536fd806c68f(url, cloudId) {
    const query = {
        query: $9b806d5a2251e5d5$var$ORG_ID_FROM_CLOUD_ID_QUERY,
        variables: {
            cloudId: cloudId
        }
    };
    try {
        const { tenantContexts: tenantContexts } = await (0, $hnIbm.AGGQuery)(url, query, $9b806d5a2251e5d5$var$addHeaders);
        if (!tenantContexts || tenantContexts.length === 0 || tenantContexts[0] === null) return null;
        return tenantContexts[0].orgId;
    } catch (err) {
        // don't bubble up the error, and let consumers handle it as if the cloud ID
        // doesn't resolve to an org ID
        return null;
    }
}

});
parcelRegister("hnIbm", function(module, exports) {

$parcel$export(module.exports, "directoryGraphqlQuery", () => $7fa677c30fceb004$export$a5b5995619d4fe36);
$parcel$export(module.exports, "AGGQuery", () => $7fa677c30fceb004$export$a14afb5f82fe705);

var $fcA5f = parcelRequire("fcA5f");

var $f3Zb8 = parcelRequire("f3Zb8");
const $7fa677c30fceb004$var$buildHeaders = ()=>{
    const headers = new Headers();
    headers.append('Content-Type', 'application/json');
    return headers;
};
const $7fa677c30fceb004$var$id = (headers)=>headers;
async function $7fa677c30fceb004$export$a5b5995619d4fe36(serviceUrl, query, processHeaders = $7fa677c30fceb004$var$id) {
    return $7fa677c30fceb004$var$graphQLQuery(serviceUrl, query, processHeaders, (0, $f3Zb8.handleDirectoryGraphQLErrors));
}
async function $7fa677c30fceb004$export$a14afb5f82fe705(serviceUrl, query, processHeaders = $7fa677c30fceb004$var$id) {
    return $7fa677c30fceb004$var$graphQLQuery(serviceUrl, query, processHeaders, (0, $f3Zb8.handleAGGErrors));
}
async function $7fa677c30fceb004$var$graphQLQuery(serviceUrl, query, processHeaders = $7fa677c30fceb004$var$id, handleErrors) {
    const headers = processHeaders($7fa677c30fceb004$var$buildHeaders());
    const response = await fetch(new Request(serviceUrl, {
        method: 'POST',
        credentials: 'include',
        mode: 'cors',
        headers: headers,
        body: JSON.stringify(query)
    }));
    const traceIdFromHeaders = response?.headers?.get('atl-traceid');
    if (!response.ok) throw new (0, $fcA5f.HttpError)(response.status, response.statusText, traceIdFromHeaders);
    const json = await response.json();
    if (json.errors) handleErrors(json.errors, json.extensions?.gateway?.request_id ?? traceIdFromHeaders);
    return json.data;
}

});



parcelRegister("fjEAi", function(module, exports) {

$parcel$export(module.exports, "default", () => $fb2f761841b49fec$export$2e2bcd8739ae039);

var $ivXTE = parcelRequire("ivXTE");

var $6TKEY = parcelRequire("6TKEY");

var $cZg4V = parcelRequire("cZg4V");

var $f3Zb8 = parcelRequire("f3Zb8");

var $5Uw6l = parcelRequire("5Uw6l");
class $fb2f761841b49fec$export$2e2bcd8739ae039 extends (0, $cZg4V.default) {
    constructor(options){
        super(options);
        this.options = options;
    }
    makeRequest(teamId, _orgId) {
        if (!this.options.gatewayGraphqlUrl) throw new Error('Trying to fetch via gateway with no specified config.gatewayGraphqlUrl');
        return (0, $5Uw6l.getTeamFromAGG)(this.options.gatewayGraphqlUrl, teamId, this.options.cloudId);
    }
    getProfile(teamId, orgId, analytics) {
        if (!teamId) return Promise.reject(new Error('teamId is missing'));
        const cache = this.getCachedProfile(teamId);
        if (cache) return Promise.resolve(cache);
        return new Promise((resolve, reject)=>{
            const startTime = (0, $6TKEY.getPageTime)();
            if (analytics) analytics((0, $ivXTE.teamRequestAnalytics)('triggered'));
            this.makeRequest(teamId, orgId).then((data)=>{
                if (this.cache) this.setCachedProfile(teamId, data);
                if (analytics) analytics((0, $ivXTE.teamRequestAnalytics)('succeeded', {
                    duration: (0, $6TKEY.getPageTime)() - startTime,
                    gateway: true
                }));
                resolve(data);
            }).catch((error)=>{
                if (analytics) analytics((0, $ivXTE.teamRequestAnalytics)('failed', {
                    duration: (0, $6TKEY.getPageTime)() - startTime,
                    ...(0, $f3Zb8.getErrorAttributes)(error),
                    gateway: true
                }));
                reject(error);
            });
        });
    }
}

});
parcelRegister("5Uw6l", function(module, exports) {

$parcel$export(module.exports, "extractIdFromAri", () => $c02eddc07333bc73$export$5816a09dbb711691);
$parcel$export(module.exports, "getTeamFromAGG", () => $c02eddc07333bc73$export$26a8aad0c7182dd6);

var $VSDnB = parcelRequire("VSDnB");

var $hnIbm = parcelRequire("hnIbm");
const $c02eddc07333bc73$var$ARI_PREFIX = 'ari:cloud:identity::team/';
const $c02eddc07333bc73$export$5816a09dbb711691 = (ari)=>{
    const slashPos = ari.indexOf('/');
    const id = ari.slice(slashPos + 1);
    return id;
};
const $c02eddc07333bc73$export$681597d03c8a0fd2 = (teamId)=>{
    return `ari:cloud:identity::team/${teamId}`;
};
const $c02eddc07333bc73$export$7878e28c136af76 = (teamIdOrTeamAri)=>teamIdOrTeamAri.startsWith($c02eddc07333bc73$var$ARI_PREFIX) ? teamIdOrTeamAri : $c02eddc07333bc73$export$681597d03c8a0fd2(teamIdOrTeamAri);
const $c02eddc07333bc73$export$fce1abb40bf8db94 = (result)=>{
    const { team: team } = result;
    return {
        ...team,
        id: $c02eddc07333bc73$export$5816a09dbb711691(team.id),
        members: team.members?.nodes.map(({ member: member })=>({
                id: member.accountId,
                fullName: member.name,
                avatarUrl: member.picture
            }))
    };
};
// indented so it's
const $c02eddc07333bc73$var$TEAM_FRAGMENT = `
      id
      displayName
      description
      smallHeaderImageUrl
      largeHeaderImageUrl
      smallAvatarImageUrl
      largeAvatarImageUrl
	  isVerified
      members {
        nodes {
          member {
            accountId
            name
            picture
          }
        }
      }
`;
const $c02eddc07333bc73$export$4968f4e0119a5d9c = `query TeamCard($teamId: ID!, $siteId: String!) {
  Team: team {
    team: teamV2(id: $teamId, siteId: $siteId) @optIn(to: "Team-v2") {
      ${$c02eddc07333bc73$var$TEAM_FRAGMENT}
    }
  }
}`;
const $c02eddc07333bc73$export$695d743d1401e038 = ({ teamId: teamId, siteId: siteId })=>({
        query: $c02eddc07333bc73$export$4968f4e0119a5d9c,
        variables: {
            teamId: (0, $VSDnB.fg)('team_id_to_ari_safe') ? $c02eddc07333bc73$export$7878e28c136af76(teamId) : $c02eddc07333bc73$export$681597d03c8a0fd2(teamId),
            siteId: siteId || 'None'
        }
    });
const $c02eddc07333bc73$export$1229c72526c01df2 = (headers)=>{
    headers.append('X-ExperimentalApi', 'teams-beta');
    headers.append('X-ExperimentalApi', 'team-members-beta');
    headers.append('atl-client-name', "platform-pkg");
    headers.append('atl-client-version', "0.0.0-use.local");
    return headers;
};
async function $c02eddc07333bc73$export$26a8aad0c7182dd6(url, teamId, siteId) {
    const query = $c02eddc07333bc73$export$695d743d1401e038({
        teamId: teamId,
        siteId: siteId
    });
    const { Team: Team } = await (0, $hnIbm.AGGQuery)(url, query, $c02eddc07333bc73$export$1229c72526c01df2);
    return $c02eddc07333bc73$export$fce1abb40bf8db94(Team);
}

});


parcelRegister("dFLsP", function(module, exports) {

$parcel$export(module.exports, "default", () => $eafd789fd4bdf3ff$export$2e2bcd8739ae039);

var $1c8Um = parcelRequire("1c8Um");

var $5cllN = parcelRequire("5cllN");

var $VSDnB = parcelRequire("VSDnB");

var $ivXTE = parcelRequire("ivXTE");

var $2qnn4 = parcelRequire("2qnn4");

var $6TKEY = parcelRequire("6TKEY");

var $cZg4V = parcelRequire("cZg4V");

var $f3Zb8 = parcelRequire("f3Zb8");

var $hnIbm = parcelRequire("hnIbm");
const $eafd789fd4bdf3ff$export$b26b7f9bcf400835 = (response)=>{
    const data = {
        ...response.User
    };
    const localWeekdayIndex = new Date().getDay().toString();
    if (data.remoteWeekdayIndex && data.remoteWeekdayIndex !== localWeekdayIndex) data.remoteTimeString = `${data.remoteWeekdayString} ${data.remoteTimeString}`;
    return {
        isBot: data.isBot,
        isCurrentUser: data.isCurrentUser,
        status: data.status,
        statusModifiedDate: data.statusModifiedDate || undefined,
        avatarUrl: data.avatarUrl || undefined,
        email: data.email || undefined,
        fullName: data.fullName || undefined,
        location: data.location || undefined,
        meta: data.meta || undefined,
        nickname: data.nickname || undefined,
        companyName: data.companyName || undefined,
        timestring: data.remoteTimeString || undefined,
        accountType: data.accountType || undefined
    };
};
const $eafd789fd4bdf3ff$var$aggUserQuery = (0, $5cllN.default)`
	query user($userId: ID!) {
		user(accountId: $userId) {
			id
			name
			picture
			accountStatus
			__typename
			... on AtlassianAccountUser {
				email
				nickname
				zoneinfo
				extendedProfile {
					jobTitle
					organization
					location
					closedDate
					inactiveDate
				}
			}
			... on CustomerUser {
				email
				zoneinfo
			}
			... on AppUser {
				appType
			}
		}
	}
`;
const $eafd789fd4bdf3ff$var$aggUserQueryString = `query user($userId: ID!) {
		user(accountId: $userId) {
			id
			name
			picture
			accountStatus
			__typename
			... on AtlassianAccountUser {
				email
				nickname
				zoneinfo
				extendedProfile {
					jobTitle
					organization
					location
					closedDate
					inactiveDate
				}
			}
			... on CustomerUser {
				email
				zoneinfo
			}
			... on AppUser {
      			appType
    		}
		}
	}`;
const $eafd789fd4bdf3ff$export$8230f28f7ae567ea = (userId)=>({
        query: (0, $VSDnB.fg)('platform_agg_user_query_doc_change') ? (0, $1c8Um.print)($eafd789fd4bdf3ff$var$aggUserQuery) : $eafd789fd4bdf3ff$var$aggUserQueryString,
        variables: {
            userId: userId
        }
    });
const $eafd789fd4bdf3ff$var$queryAGGUser = async (url, userId)=>{
    const query = $eafd789fd4bdf3ff$export$8230f28f7ae567ea(userId);
    const { user: user } = await (0, $hnIbm.AGGQuery)(url, query);
    return user;
};
class $eafd789fd4bdf3ff$export$2e2bcd8739ae039 extends (0, $cZg4V.default) {
    constructor(options){
        super(options);
        this.options = options;
    }
    async makeRequest(cloudId, userId) {
        const gatewayGraphqlUrl = this.options.gatewayGraphqlUrl || '/gateway/api/graphql';
        const urlWithOperationName = `${gatewayGraphqlUrl}?operationName=aggUserQuery`;
        const userQueryPromise = $eafd789fd4bdf3ff$var$queryAGGUser(urlWithOperationName, userId);
        const user = await userQueryPromise;
        let timestring;
        const localWeekdayIndex = new Date().getDay().toString();
        if (user.zoneinfo) {
            if ((0, $2qnn4.localTime)(user.zoneinfo, 'i') === localWeekdayIndex) timestring = (0, $2qnn4.localTime)(user.zoneinfo, 'h:mmbbb') || undefined;
            else timestring = (0, $2qnn4.localTime)(user.zoneinfo, 'eee h:mmbbb') || undefined;
        }
        return {
            ...user,
            isBot: user.__typename === 'AppUser',
            isAgent: user.appType === 'agent',
            status: user.accountStatus,
            statusModifiedDate: user.extendedProfile?.closedDate || user.extendedProfile?.inactiveDate,
            avatarUrl: user.picture,
            email: user.email,
            fullName: user.name,
            location: user.extendedProfile?.location,
            meta: user.extendedProfile?.jobTitle,
            nickname: user.nickname,
            companyName: user.extendedProfile?.organization,
            timestring: timestring
        };
    }
    getProfile(cloudId, userId, analytics) {
        if (!userId) return Promise.reject(new Error('userId missing'));
        const cacheIdentifier = `${cloudId}/${userId}`;
        const cache = this.getCachedProfile(cacheIdentifier);
        if (cache) return Promise.resolve(cache);
        return new Promise((resolve, reject)=>{
            const startTime = (0, $6TKEY.getPageTime)();
            if (analytics) analytics((0, $ivXTE.userRequestAnalytics)('triggered'));
            this.makeRequest(cloudId, userId).then((data)=>{
                if (this.cache) this.setCachedProfile(cacheIdentifier, data);
                if (analytics) analytics((0, $ivXTE.userRequestAnalytics)('succeeded', {
                    duration: (0, $6TKEY.getPageTime)() - startTime
                }));
                resolve(data);
            }).catch((error)=>{
                if (analytics) analytics((0, $ivXTE.userRequestAnalytics)('failed', {
                    duration: (0, $6TKEY.getPageTime)() - startTime,
                    ...(0, $f3Zb8.getErrorAttributes)(error)
                }));
                reject(error);
            });
        });
    }
}

});
parcelRegister("2qnn4", function(module, exports) {

$parcel$export(module.exports, "localTime", () => $de778707e3f7ab0e$export$f0dfd716e7b023cd);
parcelRequire("7UQ5i");
var $9uIbX = parcelRequire("9uIbX");
const $de778707e3f7ab0e$export$f0dfd716e7b023cd = (timezone, format)=>{
    if (!timezone) return null;
    try {
        return (0, $9uIbX.default)(new Date(), timezone, format);
    } catch (error) {
        return null;
    }
};

});
parcelRegister("7UQ5i", function(module, exports) {

$parcel$export(module.exports, "formatInTimeZone", () => (parcelRequire("9uIbX")).default);
// This file is generated automatically by `scripts/build/indices.js`. Please, don't change it.


var $9uIbX = parcelRequire("9uIbX");





});
parcelRegister("9uIbX", function(module, exports) {

$parcel$export(module.exports, "default", () => $6e9932008c468ee4$export$2e2bcd8739ae039);

var $fwbX5 = parcelRequire("fwbX5");

var $cmObS = parcelRequire("cmObS");

var $2b4cP = parcelRequire("2b4cP");
function $6e9932008c468ee4$export$2e2bcd8739ae039(date, timeZone, formatStr, options) {
    var extendedOptions = (0, (/*@__PURE__*/$parcel$interopDefault($fwbX5)))(options);
    extendedOptions.timeZone = timeZone;
    extendedOptions.originalDate = date;
    return (0, $cmObS.default)((0, $2b4cP.default)(date, timeZone), formatStr, extendedOptions);
}

});
parcelRegister("cmObS", function(module, exports) {

$parcel$export(module.exports, "default", () => $900e78e49c474eed$export$2e2bcd8739ae039);

var $aR9Qf = parcelRequire("aR9Qf");

var $920RE = parcelRequire("920RE");

var $2q3K8 = parcelRequire("2q3K8");
var $900e78e49c474eed$var$tzFormattingTokensRegExp = /([xXOz]+)|''|'(''|[^'])+('|$)/g;
function $900e78e49c474eed$export$2e2bcd8739ae039(dirtyDate, dirtyFormatStr, dirtyOptions) {
    var formatStr = String(dirtyFormatStr);
    var options = dirtyOptions || {};
    var matches = formatStr.match($900e78e49c474eed$var$tzFormattingTokensRegExp);
    if (matches) {
        var date = (0, $2q3K8.default)(options.originalDate || dirtyDate, options);
        // Work through each match and replace the tz token in the format string with the quoted
        // formatted time zone so the remaining tokens can be filled in by date-fns#format.
        formatStr = matches.reduce(function(result, token) {
            if (token[0] === "'") return result // This is a quoted portion, matched only to ensure we don't match inside it
            ;
            var pos = result.indexOf(token);
            var precededByQuotedSection = result[pos - 1] === "'";
            var replaced = result.replace(token, "'" + (0, $920RE.default)[token[0]](date, token, null, options) + "'");
            // If the replacement results in two adjoining quoted strings, the back to back quotes
            // are removed, so it doesn't look like an escaped quote.
            return precededByQuotedSection ? replaced.substring(0, pos - 1) + replaced.substring(pos + 1) : replaced;
        }, formatStr);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($aR9Qf)))(dirtyDate, formatStr, options);
}

});
parcelRegister("920RE", function(module, exports) {

$parcel$export(module.exports, "default", () => $6934f899b8aefb37$export$2e2bcd8739ae039);

var $927cR = parcelRequire("927cR");

var $6JaJ1 = parcelRequire("6JaJ1");
var $6934f899b8aefb37$var$MILLISECONDS_IN_MINUTE = 60000;
var $6934f899b8aefb37$var$formatters = {
    // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
    X: function(date, token, localize, options) {
        var timezoneOffset = $6934f899b8aefb37$var$getTimeZoneOffset(options.timeZone, date);
        if (timezoneOffset === 0) return 'Z';
        switch(token){
            // Hours and optional minutes
            case 'X':
                return $6934f899b8aefb37$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimeter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XX`
            case 'XXXX':
            case 'XX':
                return $6934f899b8aefb37$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimeter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XXX`
            case 'XXXXX':
            case 'XXX':
            default:
                return $6934f899b8aefb37$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
    x: function(date, token, localize, options) {
        var timezoneOffset = $6934f899b8aefb37$var$getTimeZoneOffset(options.timeZone, date);
        switch(token){
            // Hours and optional minutes
            case 'x':
                return $6934f899b8aefb37$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimeter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xx`
            case 'xxxx':
            case 'xx':
                return $6934f899b8aefb37$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimeter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xxx`
            case 'xxxxx':
            case 'xxx':
            default:
                return $6934f899b8aefb37$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (GMT)
    O: function(date, token, localize, options) {
        var timezoneOffset = $6934f899b8aefb37$var$getTimeZoneOffset(options.timeZone, date);
        switch(token){
            // Short
            case 'O':
            case 'OO':
            case 'OOO':
                return 'GMT' + $6934f899b8aefb37$var$formatTimezoneShort(timezoneOffset, ':');
            // Long
            case 'OOOO':
            default:
                return 'GMT' + $6934f899b8aefb37$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (specific non-location)
    z: function(date, token, localize, options) {
        switch(token){
            // Short
            case 'z':
            case 'zz':
            case 'zzz':
                return (0, $927cR.default)('short', date, options);
            // Long
            case 'zzzz':
            default:
                return (0, $927cR.default)('long', date, options);
        }
    }
};
function $6934f899b8aefb37$var$getTimeZoneOffset(timeZone, originalDate) {
    var timeZoneOffset = timeZone ? (0, $6JaJ1.default)(timeZone, originalDate, true) / $6934f899b8aefb37$var$MILLISECONDS_IN_MINUTE : originalDate.getTimezoneOffset();
    if (Number.isNaN(timeZoneOffset)) throw new RangeError('Invalid time zone specified: ' + timeZone);
    return timeZoneOffset;
}
function $6934f899b8aefb37$var$addLeadingZeros(number, targetLength) {
    var sign = number < 0 ? '-' : '';
    var output = Math.abs(number).toString();
    while(output.length < targetLength)output = '0' + output;
    return sign + output;
}
function $6934f899b8aefb37$var$formatTimezone(offset, dirtyDelimeter) {
    var delimeter = dirtyDelimeter || '';
    var sign = offset > 0 ? '-' : '+';
    var absOffset = Math.abs(offset);
    var hours = $6934f899b8aefb37$var$addLeadingZeros(Math.floor(absOffset / 60), 2);
    var minutes = $6934f899b8aefb37$var$addLeadingZeros(Math.floor(absOffset % 60), 2);
    return sign + hours + delimeter + minutes;
}
function $6934f899b8aefb37$var$formatTimezoneWithOptionalMinutes(offset, dirtyDelimeter) {
    if (offset % 60 === 0) {
        var sign = offset > 0 ? '-' : '+';
        return sign + $6934f899b8aefb37$var$addLeadingZeros(Math.abs(offset) / 60, 2);
    }
    return $6934f899b8aefb37$var$formatTimezone(offset, dirtyDelimeter);
}
function $6934f899b8aefb37$var$formatTimezoneShort(offset, dirtyDelimiter) {
    var sign = offset > 0 ? '-' : '+';
    var absOffset = Math.abs(offset);
    var hours = Math.floor(absOffset / 60);
    var minutes = absOffset % 60;
    if (minutes === 0) return sign + String(hours);
    var delimiter = dirtyDelimiter || '';
    return sign + String(hours) + delimiter + $6934f899b8aefb37$var$addLeadingZeros(minutes, 2);
}
var $6934f899b8aefb37$export$2e2bcd8739ae039 = $6934f899b8aefb37$var$formatters;

});
parcelRegister("927cR", function(module, exports) {

$parcel$export(module.exports, "default", () => $6939e400b4f30595$export$2e2bcd8739ae039);
/**
 * Returns the formatted time zone name of the provided `timeZone` or the current
 * system time zone if omitted, accounting for DST according to the UTC value of
 * the date.
 */ function $6939e400b4f30595$export$2e2bcd8739ae039(length, date, options) {
    var dtf = $6939e400b4f30595$var$getDTF(length, options.timeZone, options.locale);
    return dtf.formatToParts ? $6939e400b4f30595$var$partsTimeZone(dtf, date) : $6939e400b4f30595$var$hackyTimeZone(dtf, date);
}
function $6939e400b4f30595$var$partsTimeZone(dtf, date) {
    var formatted = dtf.formatToParts(date);
    for(var i = formatted.length - 1; i >= 0; --i){
        if (formatted[i].type === 'timeZoneName') return formatted[i].value;
    }
}
function $6939e400b4f30595$var$hackyTimeZone(dtf, date) {
    var formatted = dtf.format(date).replace(/\u200E/g, '');
    var tzNameMatch = / [\w-+ ]+$/.exec(formatted);
    return tzNameMatch ? tzNameMatch[0].substr(1) : '';
}
// If a locale has been provided `en-US` is used as a fallback in case it is an
// invalid locale, otherwise the locale is left undefined to use the system locale.
function $6939e400b4f30595$var$getDTF(length, timeZone, locale) {
    if (locale && !locale.code) throw new Error("date-fns-tz error: Please set a language code on the locale object imported from date-fns, e.g. `locale.code = 'en-US'`");
    return new Intl.DateTimeFormat(locale ? [
        locale.code,
        'en-US'
    ] : undefined, {
        timeZone: timeZone,
        timeZoneName: length
    });
}

});

parcelRegister("6JaJ1", function(module, exports) {

$parcel$export(module.exports, "default", () => $4e5f43d4fc19099f$export$2e2bcd8739ae039);

var $gTcao = parcelRequire("gTcao");

var $6Bk9v = parcelRequire("6Bk9v");
var $4e5f43d4fc19099f$var$MILLISECONDS_IN_HOUR = 3600000;
var $4e5f43d4fc19099f$var$MILLISECONDS_IN_MINUTE = 60000;
var $4e5f43d4fc19099f$var$patterns = {
    timezone: /([Z+-].*)$/,
    timezoneZ: /^(Z)$/,
    timezoneHH: /^([+-]\d{2})$/,
    timezoneHHMM: /^([+-])(\d{2}):?(\d{2})$/
};
function $4e5f43d4fc19099f$export$2e2bcd8739ae039(timezoneString, date, isUtcDate) {
    var token;
    var absoluteOffset;
    // Empty string
    if (!timezoneString) return 0;
    // Z
    token = $4e5f43d4fc19099f$var$patterns.timezoneZ.exec(timezoneString);
    if (token) return 0;
    var hours;
    // ±hh
    token = $4e5f43d4fc19099f$var$patterns.timezoneHH.exec(timezoneString);
    if (token) {
        hours = parseInt(token[1], 10);
        if (!$4e5f43d4fc19099f$var$validateTimezone(hours)) return NaN;
        return -(hours * $4e5f43d4fc19099f$var$MILLISECONDS_IN_HOUR);
    }
    // ±hh:mm or ±hhmm
    token = $4e5f43d4fc19099f$var$patterns.timezoneHHMM.exec(timezoneString);
    if (token) {
        hours = parseInt(token[2], 10);
        var minutes = parseInt(token[3], 10);
        if (!$4e5f43d4fc19099f$var$validateTimezone(hours, minutes)) return NaN;
        absoluteOffset = Math.abs(hours) * $4e5f43d4fc19099f$var$MILLISECONDS_IN_HOUR + minutes * $4e5f43d4fc19099f$var$MILLISECONDS_IN_MINUTE;
        return token[1] === '+' ? -absoluteOffset : absoluteOffset;
    }
    // IANA time zone
    if ($4e5f43d4fc19099f$var$isValidTimezoneIANAString(timezoneString)) {
        date = new Date(date || Date.now());
        var utcDate = isUtcDate ? date : $4e5f43d4fc19099f$var$toUtcDate(date);
        var offset = $4e5f43d4fc19099f$var$calcOffset(utcDate, timezoneString);
        var fixedOffset = isUtcDate ? offset : $4e5f43d4fc19099f$var$fixOffset(date, offset, timezoneString);
        return -fixedOffset;
    }
    return NaN;
}
function $4e5f43d4fc19099f$var$toUtcDate(date) {
    return (0, $6Bk9v.default)(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds());
}
function $4e5f43d4fc19099f$var$calcOffset(date, timezoneString) {
    var tokens = (0, $gTcao.default)(date, timezoneString);
    // ms dropped because it's not provided by tzTokenizeDate
    var asUTC = (0, $6Bk9v.default)(tokens[0], tokens[1] - 1, tokens[2], tokens[3] % 24, tokens[4], tokens[5], 0).getTime();
    var asTS = date.getTime();
    var over = asTS % 1000;
    asTS -= over >= 0 ? over : 1000 + over;
    return asUTC - asTS;
}
function $4e5f43d4fc19099f$var$fixOffset(date, offset, timezoneString) {
    var localTS = date.getTime();
    // Our UTC time is just a guess because our offset is just a guess
    var utcGuess = localTS - offset;
    // Test whether the zone matches the offset for this ts
    var o2 = $4e5f43d4fc19099f$var$calcOffset(new Date(utcGuess), timezoneString);
    // If so, offset didn't change, and we're done
    if (offset === o2) return offset;
    // If not, change the ts by the difference in the offset
    utcGuess -= o2 - offset;
    // If that gives us the local time we want, we're done
    var o3 = $4e5f43d4fc19099f$var$calcOffset(new Date(utcGuess), timezoneString);
    if (o2 === o3) return o2;
    // If it's different, we're in a hole time. The offset has changed, but we don't adjust the time
    return Math.max(o2, o3);
}
function $4e5f43d4fc19099f$var$validateTimezone(hours, minutes) {
    return -23 <= hours && hours <= 23 && (minutes == null || 0 <= minutes && minutes <= 59);
}
var $4e5f43d4fc19099f$var$validIANATimezoneCache = {};
function $4e5f43d4fc19099f$var$isValidTimezoneIANAString(timeZoneString) {
    if ($4e5f43d4fc19099f$var$validIANATimezoneCache[timeZoneString]) return true;
    try {
        new Intl.DateTimeFormat(undefined, {
            timeZone: timeZoneString
        });
        $4e5f43d4fc19099f$var$validIANATimezoneCache[timeZoneString] = true;
        return true;
    } catch (error) {
        return false;
    }
}

});
parcelRegister("gTcao", function(module, exports) {

$parcel$export(module.exports, "default", () => $c4bb38695b1c145f$export$2e2bcd8739ae039);
/**
 * Returns the [year, month, day, hour, minute, seconds] tokens of the provided
 * `date` as it will be rendered in the `timeZone`.
 */ function $c4bb38695b1c145f$export$2e2bcd8739ae039(date, timeZone) {
    var dtf = $c4bb38695b1c145f$var$getDateTimeFormat(timeZone);
    return dtf.formatToParts ? $c4bb38695b1c145f$var$partsOffset(dtf, date) : $c4bb38695b1c145f$var$hackyOffset(dtf, date);
}
var $c4bb38695b1c145f$var$typeToPos = {
    year: 0,
    month: 1,
    day: 2,
    hour: 3,
    minute: 4,
    second: 5
};
function $c4bb38695b1c145f$var$partsOffset(dtf, date) {
    try {
        var formatted = dtf.formatToParts(date);
        var filled = [];
        for(var i = 0; i < formatted.length; i++){
            var pos = $c4bb38695b1c145f$var$typeToPos[formatted[i].type];
            if (pos >= 0) filled[pos] = parseInt(formatted[i].value, 10);
        }
        return filled;
    } catch (error) {
        if (error instanceof RangeError) return [
            NaN
        ];
        throw error;
    }
}
function $c4bb38695b1c145f$var$hackyOffset(dtf, date) {
    var formatted = dtf.format(date);
    var parsed = /(\d+)\/(\d+)\/(\d+),? (\d+):(\d+):(\d+)/.exec(formatted);
    // var [, fMonth, fDay, fYear, fHour, fMinute, fSecond] = parsed
    // return [fYear, fMonth, fDay, fHour, fMinute, fSecond]
    return [
        parsed[3],
        parsed[1],
        parsed[2],
        parsed[4],
        parsed[5],
        parsed[6]
    ];
}
// Get a cached Intl.DateTimeFormat instance for the IANA `timeZone`. This can be used
// to get deterministic local date/time output according to the `en-US` locale which
// can be used to extract local time parts as necessary.
var $c4bb38695b1c145f$var$dtfCache = {};
function $c4bb38695b1c145f$var$getDateTimeFormat(timeZone) {
    if (!$c4bb38695b1c145f$var$dtfCache[timeZone]) {
        // New browsers use `hourCycle`, IE and Chrome <73 does not support it and uses `hour12`
        var testDateFormatted = new Intl.DateTimeFormat('en-US', {
            hourCycle: 'h23',
            timeZone: 'America/New_York',
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit'
        }).format(new Date('2014-06-25T04:00:00.123Z'));
        var hourCycleSupported = testDateFormatted === '06/25/2014, 00:00:00' || testDateFormatted === "\u200E06\u200E/\u200E25\u200E/\u200E2014\u200E \u200E00\u200E:\u200E00\u200E:\u200E00";
        $c4bb38695b1c145f$var$dtfCache[timeZone] = hourCycleSupported ? new Intl.DateTimeFormat('en-US', {
            hourCycle: 'h23',
            timeZone: timeZone,
            year: 'numeric',
            month: 'numeric',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit'
        }) : new Intl.DateTimeFormat('en-US', {
            hour12: false,
            timeZone: timeZone,
            year: 'numeric',
            month: 'numeric',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit'
        });
    }
    return $c4bb38695b1c145f$var$dtfCache[timeZone];
}

});

parcelRegister("6Bk9v", function(module, exports) {

$parcel$export(module.exports, "default", () => $4ce5d4976aa71227$export$2e2bcd8739ae039);
/**
 * Use instead of `new Date(Date.UTC(...))` to support years below 100 which doesn't work
 * otherwise due to the nature of the
 * [`Date` constructor](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date#interpretation_of_two-digit_years.
 *
 * For `Date.UTC(...)`, use `newDateUTC(...).getTime()`.
 */ function $4ce5d4976aa71227$export$2e2bcd8739ae039(fullYear, month, day, hour, minute, second, millisecond) {
    var utcDate = new Date(0);
    utcDate.setUTCFullYear(fullYear, month, day);
    utcDate.setUTCHours(hour, minute, second, millisecond);
    return utcDate;
}

});



parcelRegister("2q3K8", function(module, exports) {

$parcel$export(module.exports, "default", () => $1c30e9c4205eee83$export$2e2bcd8739ae039);

var $aSksP = parcelRequire("aSksP");

var $jGQTC = parcelRequire("jGQTC");

var $6JaJ1 = parcelRequire("6JaJ1");

var $jxCgc = parcelRequire("jxCgc");
var $1c30e9c4205eee83$var$MILLISECONDS_IN_HOUR = 3600000;
var $1c30e9c4205eee83$var$MILLISECONDS_IN_MINUTE = 60000;
var $1c30e9c4205eee83$var$DEFAULT_ADDITIONAL_DIGITS = 2;
var $1c30e9c4205eee83$var$patterns = {
    dateTimePattern: /^([0-9W+-]+)(T| )(.*)/,
    datePattern: /^([0-9W+-]+)(.*)/,
    plainTime: /:/,
    // year tokens
    YY: /^(\d{2})$/,
    YYY: [
        /^([+-]\d{2})$/,
        /^([+-]\d{3})$/,
        /^([+-]\d{4})$/
    ],
    YYYY: /^(\d{4})/,
    YYYYY: [
        /^([+-]\d{4})/,
        /^([+-]\d{5})/,
        /^([+-]\d{6})/
    ],
    // date tokens
    MM: /^-(\d{2})$/,
    DDD: /^-?(\d{3})$/,
    MMDD: /^-?(\d{2})-?(\d{2})$/,
    Www: /^-?W(\d{2})$/,
    WwwD: /^-?W(\d{2})-?(\d{1})$/,
    HH: /^(\d{2}([.,]\d*)?)$/,
    HHMM: /^(\d{2}):?(\d{2}([.,]\d*)?)$/,
    HHMMSS: /^(\d{2}):?(\d{2}):?(\d{2}([.,]\d*)?)$/,
    // time zone tokens (to identify the presence of a tz)
    timeZone: (0, $jxCgc.default)
};
function $1c30e9c4205eee83$export$2e2bcd8739ae039(argument, dirtyOptions) {
    if (arguments.length < 1) throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
    if (argument === null) return new Date(NaN);
    var options = dirtyOptions || {};
    var additionalDigits = options.additionalDigits == null ? $1c30e9c4205eee83$var$DEFAULT_ADDITIONAL_DIGITS : (0, (/*@__PURE__*/$parcel$interopDefault($aSksP)))(options.additionalDigits);
    if (additionalDigits !== 2 && additionalDigits !== 1 && additionalDigits !== 0) throw new RangeError('additionalDigits must be 0, 1 or 2');
    // Clone the date
    if (argument instanceof Date || typeof argument === 'object' && Object.prototype.toString.call(argument) === '[object Date]') // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new Date(argument.getTime());
    else if (typeof argument === 'number' || Object.prototype.toString.call(argument) === '[object Number]') return new Date(argument);
    else if (!(typeof argument === 'string' || Object.prototype.toString.call(argument) === '[object String]')) return new Date(NaN);
    var dateStrings = $1c30e9c4205eee83$var$splitDateString(argument);
    var parseYearResult = $1c30e9c4205eee83$var$parseYear(dateStrings.date, additionalDigits);
    var year = parseYearResult.year;
    var restDateString = parseYearResult.restDateString;
    var date = $1c30e9c4205eee83$var$parseDate(restDateString, year);
    if (isNaN(date)) return new Date(NaN);
    if (date) {
        var timestamp = date.getTime();
        var time = 0;
        var offset;
        if (dateStrings.time) {
            time = $1c30e9c4205eee83$var$parseTime(dateStrings.time);
            if (isNaN(time)) return new Date(NaN);
        }
        if (dateStrings.timeZone || options.timeZone) {
            offset = (0, $6JaJ1.default)(dateStrings.timeZone || options.timeZone, new Date(timestamp + time));
            if (isNaN(offset)) return new Date(NaN);
        } else {
            // get offset accurate to hour in time zones that change offset
            offset = (0, (/*@__PURE__*/$parcel$interopDefault($jGQTC)))(new Date(timestamp + time));
            offset = (0, (/*@__PURE__*/$parcel$interopDefault($jGQTC)))(new Date(timestamp + time + offset));
        }
        return new Date(timestamp + time + offset);
    } else return new Date(NaN);
}
function $1c30e9c4205eee83$var$splitDateString(dateString) {
    var dateStrings = {};
    var parts = $1c30e9c4205eee83$var$patterns.dateTimePattern.exec(dateString);
    var timeString;
    if (!parts) {
        parts = $1c30e9c4205eee83$var$patterns.datePattern.exec(dateString);
        if (parts) {
            dateStrings.date = parts[1];
            timeString = parts[2];
        } else {
            dateStrings.date = null;
            timeString = dateString;
        }
    } else {
        dateStrings.date = parts[1];
        timeString = parts[3];
    }
    if (timeString) {
        var token = $1c30e9c4205eee83$var$patterns.timeZone.exec(timeString);
        if (token) {
            dateStrings.time = timeString.replace(token[1], '');
            dateStrings.timeZone = token[1].trim();
        } else dateStrings.time = timeString;
    }
    return dateStrings;
}
function $1c30e9c4205eee83$var$parseYear(dateString, additionalDigits) {
    var patternYYY = $1c30e9c4205eee83$var$patterns.YYY[additionalDigits];
    var patternYYYYY = $1c30e9c4205eee83$var$patterns.YYYYY[additionalDigits];
    var token;
    // YYYY or ±YYYYY
    token = $1c30e9c4205eee83$var$patterns.YYYY.exec(dateString) || patternYYYYY.exec(dateString);
    if (token) {
        var yearString = token[1];
        return {
            year: parseInt(yearString, 10),
            restDateString: dateString.slice(yearString.length)
        };
    }
    // YY or ±YYY
    token = $1c30e9c4205eee83$var$patterns.YY.exec(dateString) || patternYYY.exec(dateString);
    if (token) {
        var centuryString = token[1];
        return {
            year: parseInt(centuryString, 10) * 100,
            restDateString: dateString.slice(centuryString.length)
        };
    }
    // Invalid ISO-formatted year
    return {
        year: null
    };
}
function $1c30e9c4205eee83$var$parseDate(dateString, year) {
    // Invalid ISO-formatted year
    if (year === null) return null;
    var token;
    var date;
    var month;
    var week;
    // YYYY
    if (dateString.length === 0) {
        date = new Date(0);
        date.setUTCFullYear(year);
        return date;
    }
    // YYYY-MM
    token = $1c30e9c4205eee83$var$patterns.MM.exec(dateString);
    if (token) {
        date = new Date(0);
        month = parseInt(token[1], 10) - 1;
        if (!$1c30e9c4205eee83$var$validateDate(year, month)) return new Date(NaN);
        date.setUTCFullYear(year, month);
        return date;
    }
    // YYYY-DDD or YYYYDDD
    token = $1c30e9c4205eee83$var$patterns.DDD.exec(dateString);
    if (token) {
        date = new Date(0);
        var dayOfYear = parseInt(token[1], 10);
        if (!$1c30e9c4205eee83$var$validateDayOfYearDate(year, dayOfYear)) return new Date(NaN);
        date.setUTCFullYear(year, 0, dayOfYear);
        return date;
    }
    // yyyy-MM-dd or YYYYMMDD
    token = $1c30e9c4205eee83$var$patterns.MMDD.exec(dateString);
    if (token) {
        date = new Date(0);
        month = parseInt(token[1], 10) - 1;
        var day = parseInt(token[2], 10);
        if (!$1c30e9c4205eee83$var$validateDate(year, month, day)) return new Date(NaN);
        date.setUTCFullYear(year, month, day);
        return date;
    }
    // YYYY-Www or YYYYWww
    token = $1c30e9c4205eee83$var$patterns.Www.exec(dateString);
    if (token) {
        week = parseInt(token[1], 10) - 1;
        if (!$1c30e9c4205eee83$var$validateWeekDate(year, week)) return new Date(NaN);
        return $1c30e9c4205eee83$var$dayOfISOWeekYear(year, week);
    }
    // YYYY-Www-D or YYYYWwwD
    token = $1c30e9c4205eee83$var$patterns.WwwD.exec(dateString);
    if (token) {
        week = parseInt(token[1], 10) - 1;
        var dayOfWeek = parseInt(token[2], 10) - 1;
        if (!$1c30e9c4205eee83$var$validateWeekDate(year, week, dayOfWeek)) return new Date(NaN);
        return $1c30e9c4205eee83$var$dayOfISOWeekYear(year, week, dayOfWeek);
    }
    // Invalid ISO-formatted date
    return null;
}
function $1c30e9c4205eee83$var$parseTime(timeString) {
    var token;
    var hours;
    var minutes;
    // hh
    token = $1c30e9c4205eee83$var$patterns.HH.exec(timeString);
    if (token) {
        hours = parseFloat(token[1].replace(',', '.'));
        if (!$1c30e9c4205eee83$var$validateTime(hours)) return NaN;
        return hours % 24 * $1c30e9c4205eee83$var$MILLISECONDS_IN_HOUR;
    }
    // hh:mm or hhmm
    token = $1c30e9c4205eee83$var$patterns.HHMM.exec(timeString);
    if (token) {
        hours = parseInt(token[1], 10);
        minutes = parseFloat(token[2].replace(',', '.'));
        if (!$1c30e9c4205eee83$var$validateTime(hours, minutes)) return NaN;
        return hours % 24 * $1c30e9c4205eee83$var$MILLISECONDS_IN_HOUR + minutes * $1c30e9c4205eee83$var$MILLISECONDS_IN_MINUTE;
    }
    // hh:mm:ss or hhmmss
    token = $1c30e9c4205eee83$var$patterns.HHMMSS.exec(timeString);
    if (token) {
        hours = parseInt(token[1], 10);
        minutes = parseInt(token[2], 10);
        var seconds = parseFloat(token[3].replace(',', '.'));
        if (!$1c30e9c4205eee83$var$validateTime(hours, minutes, seconds)) return NaN;
        return hours % 24 * $1c30e9c4205eee83$var$MILLISECONDS_IN_HOUR + minutes * $1c30e9c4205eee83$var$MILLISECONDS_IN_MINUTE + seconds * 1000;
    }
    // Invalid ISO-formatted time
    return null;
}
function $1c30e9c4205eee83$var$dayOfISOWeekYear(isoWeekYear, week, day) {
    week = week || 0;
    day = day || 0;
    var date = new Date(0);
    date.setUTCFullYear(isoWeekYear, 0, 4);
    var fourthOfJanuaryDay = date.getUTCDay() || 7;
    var diff = week * 7 + day + 1 - fourthOfJanuaryDay;
    date.setUTCDate(date.getUTCDate() + diff);
    return date;
}
// Validation functions
var $1c30e9c4205eee83$var$DAYS_IN_MONTH = [
    31,
    28,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
var $1c30e9c4205eee83$var$DAYS_IN_MONTH_LEAP_YEAR = [
    31,
    29,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
function $1c30e9c4205eee83$var$isLeapYearIndex(year) {
    return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}
function $1c30e9c4205eee83$var$validateDate(year, month, date) {
    if (month < 0 || month > 11) return false;
    if (date != null) {
        if (date < 1) return false;
        var isLeapYear = $1c30e9c4205eee83$var$isLeapYearIndex(year);
        if (isLeapYear && date > $1c30e9c4205eee83$var$DAYS_IN_MONTH_LEAP_YEAR[month]) return false;
        if (!isLeapYear && date > $1c30e9c4205eee83$var$DAYS_IN_MONTH[month]) return false;
    }
    return true;
}
function $1c30e9c4205eee83$var$validateDayOfYearDate(year, dayOfYear) {
    if (dayOfYear < 1) return false;
    var isLeapYear = $1c30e9c4205eee83$var$isLeapYearIndex(year);
    if (isLeapYear && dayOfYear > 366) return false;
    if (!isLeapYear && dayOfYear > 365) return false;
    return true;
}
function $1c30e9c4205eee83$var$validateWeekDate(year, week, day) {
    if (week < 0 || week > 52) return false;
    if (day != null && (day < 0 || day > 6)) return false;
    return true;
}
function $1c30e9c4205eee83$var$validateTime(hours, minutes, seconds) {
    if (hours != null && (hours < 0 || hours >= 25)) return false;
    if (minutes != null && (minutes < 0 || minutes >= 60)) return false;
    if (seconds != null && (seconds < 0 || seconds >= 60)) return false;
    return true;
}

});
parcelRegister("jxCgc", function(module, exports) {

$parcel$export(module.exports, "default", () => $e39ec715b89452b2$export$2e2bcd8739ae039);
/** Regex to identify the presence of a time zone specifier in a date string */ var $e39ec715b89452b2$var$tzPattern = /(Z|[+-]\d{2}(?::?\d{2})?| UTC| [a-zA-Z]+\/[a-zA-Z_]+(?:\/[a-zA-Z_]+)?)$/;
var $e39ec715b89452b2$export$2e2bcd8739ae039 = $e39ec715b89452b2$var$tzPattern;

});



parcelRegister("2b4cP", function(module, exports) {

$parcel$export(module.exports, "default", () => $195fdf0d1f4870c0$export$2e2bcd8739ae039);

var $6JaJ1 = parcelRequire("6JaJ1");

var $2q3K8 = parcelRequire("2q3K8");
function $195fdf0d1f4870c0$export$2e2bcd8739ae039(dirtyDate, timeZone, options) {
    var date = (0, $2q3K8.default)(dirtyDate, options);
    var offsetMilliseconds = (0, $6JaJ1.default)(timeZone, date, true);
    var d = new Date(date.getTime() - offsetMilliseconds);
    var resultDate = new Date(0);
    resultDate.setFullYear(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate());
    resultDate.setHours(d.getUTCHours(), d.getUTCMinutes(), d.getUTCSeconds(), d.getUTCMilliseconds());
    return resultDate;
}

});







parcelRegister("kgWq0", function(module, exports) {

$parcel$export(module.exports, "ErrorStateContainer", () => $15b20d5e2cd88d6b$export$3c552bcab5076086);
$parcel$export(module.exports, "DescriptionContainer", () => $15b20d5e2cd88d6b$export$31dea26885d599bc);
$parcel$export(module.exports, "ContributorsContainer", () => $15b20d5e2cd88d6b$export$99a01e3168077336);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
// AFP-2532 TODO: Fix automatic suppressions below
// eslint-disable-next-line @atlassian/tangerine/import/entry-points


var $bWGt6 = parcelRequire("bWGt6");
function $15b20d5e2cd88d6b$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $15b20d5e2cd88d6b$export$32f78bffcd82ff28 = `var(--ds-text, ${(0, $829f609a65d26a98$exports).N800})`;
const $15b20d5e2cd88d6b$export$3c552bcab5076086 = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e14gx3xq4"
})({
    margin: `${"var(--ds-space-1000, 80px)"} auto 0px auto`,
    textAlign: 'center',
    width: '30%',
    color: $15b20d5e2cd88d6b$export$32f78bffcd82ff28
});
const $15b20d5e2cd88d6b$export$31dea26885d599bc = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e14gx3xq3"
})({
    margin: `${"var(--ds-space-150, 12px)"} ${"var(--ds-space-0, 0px)"}`
});
const $15b20d5e2cd88d6b$export$99a01e3168077336 = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e14gx3xq2"
})({
    margin: `${"var(--ds-space-negative-025, -2px)"} 0px`
});
const $15b20d5e2cd88d6b$export$6edec4986bb81a80 = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e14gx3xq1"
})({
    name: "0",
    styles: ""
});
const $15b20d5e2cd88d6b$export$402a96ca7c4b4618 = /*#__PURE__*/ (0, $bWGt6.default)("small", {
    target: "e14gx3xq0"
})({
    name: "0",
    styles: ""
});

});

parcelRegister("aOxGW", function(module, exports) {

$parcel$export(module.exports, "default", () => $f32ce2abb0bab141$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $f32ce2abb0bab141$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    errorTitle: {
        id: 'confluence-table-tree.error.title',
        defaultMessage: 'Well, this is awkward...'
    },
    errorDescription: {
        id: 'confluence-table-tree.error.description',
        defaultMessage: "We can't show you these pages. Please try again later."
    },
    errorRow: {
        id: 'confluence-table-tree.error.row',
        defaultMessage: 'Unable to load pages.'
    },
    emptyTitle: {
        id: 'confluence-table-tree.empty.title',
        defaultMessage: "There's nothing here but potential"
    },
    emptyDescription: {
        id: 'confluence-table-tree.empty.description',
        defaultMessage: 'Create some meeting notes, product requirements, decisions, or other content to see this space fill up.'
    },
    create: {
        id: 'confluence-table-tree.create-page',
        defaultMessage: 'Create page'
    },
    title: {
        id: 'confluence-table-tree.column.title',
        defaultMessage: 'Name'
    },
    contributors: {
        id: 'confluence-table-tree.column.contributors',
        defaultMessage: 'Contributors'
    },
    lastModified: {
        id: 'confluence-table-tree.column.last-modified',
        defaultMessage: 'Last modified'
    },
    viewProfile: {
        id: 'confluence-table-tree.view-profile',
        defaultMessage: 'View profile'
    },
    couldNotLoad: {
        id: 'confluence-table-tree.could-not-load',
        defaultMessage: "Couldn't load",
        description: 'Message shown when unable to fetch last update time of a page'
    },
    couldNotLoadContributors: {
        id: 'confluence-table-tree.could-not-load-contributors',
        defaultMessage: "Couldn't load contributors",
        description: 'Tooltip shown when unable to fetch contributors of a page'
    },
    editInConfluence: {
        id: 'confluence-table-tree.edit-in-confluence',
        defaultMessage: 'Edit in Confluence'
    },
    edit: {
        id: 'confluence-table-tree.edit',
        defaultMessage: 'Edit'
    },
    createChildPage: {
        id: 'confluence-table-tree.create-child-page',
        defaultMessage: 'Create a child page',
        description: 'Tooltip for button to create a child page in the Project Pages page tree'
    }
});

});


parcelRegister("33NuD", function(module, exports) {

$parcel$export(module.exports, "ErrorState", () => $23e9894ebfb0454a$export$c1ed4f415b9e7023);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");
var $8RXs9 = parcelRequire("8RXs9");

var $1GGwS = parcelRequire("1GGwS");

var $h8yj2 = parcelRequire("h8yj2");

var $cb25w = parcelRequire("cb25w");

var $l1N8i = parcelRequire("l1N8i");

var $kgWq0 = parcelRequire("kgWq0");

var $NoEQs = parcelRequire("NoEQs");

var $aOxGW = parcelRequire("aOxGW");

var $flDhD = parcelRequire("flDhD");

var $7KlvJ = parcelRequire("7KlvJ");
const $23e9894ebfb0454a$var$errorTypeToMessages = (type)=>{
    if (type === 'error') return {
        title: (0, $aOxGW.default).errorTitle,
        description: (0, $aOxGW.default).errorDescription
    };
    return {
        title: (0, $aOxGW.default).emptyTitle,
        description: (0, $aOxGW.default).emptyDescription
    };
};
class $23e9894ebfb0454a$export$156af8fdc16e5770 extends (0, $5uXOq.Component) {
    static{
        this.defaultProps = {
            readOnly: false
        };
    }
    componentDidMount() {
        const { createAnalyticsEvent: createAnalyticsEvent, type: type, readOnly: readOnly } = this.props;
        if (createAnalyticsEvent) {
            if (type === (0, $NoEQs.Errors).Error) (0, $h8yj2.fireOperationalAnalytics)(createAnalyticsEvent({}), 'confluencePageTree errorStateShown');
            else if (type === (0, $NoEQs.Errors).Empty) (0, $h8yj2.fireOperationalAnalytics)(createAnalyticsEvent({}), 'confluencePageTree emptyStateShown', {
                readOnly: readOnly
            });
        }
    }
    render() {
        const { type: type, readOnly: readOnly, spaceKey: spaceKey } = this.props;
        const { title: title, description: description } = $23e9894ebfb0454a$var$errorTypeToMessages(type);
        const imgMap = {
            error: (0, (/*@__PURE__*/$parcel$interopDefault($7KlvJ))),
            empty: (0, (/*@__PURE__*/$parcel$interopDefault($flDhD)))
        };
        let createPageHref = '';
        if (spaceKey) createPageHref = `/wiki/spaces/${spaceKey}/overview?createDialog=true&createDialogSpaceKey=${spaceKey}`;
        return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $kgWq0.ErrorStateContainer), {
            children: [
                /*#__PURE__*/ (0, $2OMIu.jsx)("img", {
                    src: imgMap[type],
                    alt: ""
                }),
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $l1N8i.default), {
                    as: "h3",
                    size: "medium",
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                        ...title
                    })
                }),
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $kgWq0.DescriptionContainer), {
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                        ...description
                    })
                }),
                type === (0, $NoEQs.Errors).Empty ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1GGwS.default), {
                    appearance: "primary",
                    isDisabled: readOnly,
                    href: createPageHref,
                    target: "_blank",
                    onClick: (_, analyticsEvent)=>{
                        (0, $h8yj2.fireUIAnalytics)(analyticsEvent, 'confluencePageTreeEmptyStateCreateButton');
                    },
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                        ...(0, $aOxGW.default).create
                    })
                }) : null
            ]
        });
    }
}
const $23e9894ebfb0454a$export$c1ed4f415b9e7023 = (0, $cb25w.default)()((0, $8RXs9.default)($23e9894ebfb0454a$export$156af8fdc16e5770));

});
parcelRegister("flDhD", function(module, exports) {
module.exports = new URL("empty.620028f9.png", import.meta.url).toString();

});

parcelRegister("7KlvJ", function(module, exports) {
module.exports = new URL("error.a33ba530.png", import.meta.url).toString();

});


parcelRegister("9DDhv", function(module, exports) {

$parcel$export(module.exports, "default", () => $794595a2c1f7cf65$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");

var $2iqNv = parcelRequire("2iqNv");
var $bJ8bc = parcelRequire("bJ8bc");

var $aOxGW = parcelRequire("aOxGW");
const $794595a2c1f7cf65$var$ErrorRowBase = ()=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bJ8bc.default), {
        itemId: "error",
        hasChildren: false,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2iqNv.default), {
            children: /*#__PURE__*/ (0, $2OMIu.jsx)("small", {
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                    ...(0, $aOxGW.default).errorRow
                })
            })
        })
    });
};
var $794595a2c1f7cf65$export$2e2bcd8739ae039 = $794595a2c1f7cf65$var$ErrorRowBase;

});

parcelRegister("9kpVr", function(module, exports) {

$parcel$export(module.exports, "default", () => $7677072aebe1754c$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $7VHMR = parcelRequire("7VHMR");
var $ousew = parcelRequire("ousew");
var $koVbs = parcelRequire("koVbs");

var $h8yj2 = parcelRequire("h8yj2");

var $2NMNM = parcelRequire("2NMNM");

var $dS3PR = parcelRequire("dS3PR");

var $aOxGW = parcelRequire("aOxGW");
const $7677072aebe1754c$var$lastUpdatedMessages = (0, $7VHMR.defineMessages)({
    created: {
        id: 'confluence-table-tree.friendly-when-created',
        defaultMessage: 'Created',
        description: 'Displayed next to a timestamp to indicate when a page was first created'
    },
    updated: {
        id: 'confluence-table-tree.friendly-when-updated',
        defaultMessage: 'Updated',
        description: 'Displayed next to a timestamp to indicate when a page was last updated'
    }
});
const $7677072aebe1754c$export$94198873dffecd09 = ({ lastUpdated: lastUpdated })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    if (!lastUpdated) {
        (0, $h8yj2.fireOperationalAnalytics)(createAnalyticsEvent({}), 'confluencePageTree unknownContributor');
        return /*#__PURE__*/ (0, $2OMIu.jsx)("small", {
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                ...(0, $aOxGW.default).couldNotLoad
            })
        });
    }
    const { friendlyWhen: friendlyWhen, number: number } = lastUpdated;
    const prefix = number === 1 ? $7677072aebe1754c$var$lastUpdatedMessages.created : $7677072aebe1754c$var$lastUpdatedMessages.updated;
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $dS3PR.default), {
        size: "small",
        children: [
            formatMessage(prefix),
            " ",
            friendlyWhen
        ]
    });
};
var $7677072aebe1754c$export$2e2bcd8739ae039 = $7677072aebe1754c$export$94198873dffecd09;

});

parcelRegister("iv5a0", function(module, exports) {

$parcel$export(module.exports, "default", () => $09bf2ac778668579$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $gB4mS = parcelRequire("gB4mS");
var $cb25w = parcelRequire("cb25w");

var $e4yMr = parcelRequire("e4yMr");
const $09bf2ac778668579$var$createAndFireEventOnAtlaskit = (0, $gB4mS.default)('atlaskit');
const $09bf2ac778668579$var$ButtonBase = (props)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $e4yMr.default), {
        ...props
    });
var $09bf2ac778668579$export$2e2bcd8739ae039 = (0, $cb25w.default)({
    onClick: $09bf2ac778668579$var$createAndFireEventOnAtlaskit({
        action: 'clicked',
        actionSubject: 'link'
    })
})($09bf2ac778668579$var$ButtonBase);

});

parcelRegister("6prT7", function(module, exports) {

$parcel$export(module.exports, "ButtonWrapper", () => $0a4d5c9dd8972063$export$d53c836cccbb0d90);
$parcel$export(module.exports, "TableTreeWrapper", () => $0a4d5c9dd8972063$export$360f7407dc4b3879);
$parcel$export(module.exports, "HoverWrapper", () => $0a4d5c9dd8972063$export$ca23f4c021898078);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766


var $bWGt6 = parcelRequire("bWGt6");
function $0a4d5c9dd8972063$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $0a4d5c9dd8972063$export$d53c836cccbb0d90 = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e4t0e7h2"
})({
    name: "1kra095",
    styles: "display:flex;justify-content:center;padding-top:var(--ds-space-100, 8px)"
});
const $0a4d5c9dd8972063$export$360f7407dc4b3879 = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e4t0e7h1"
})({
    borderTop: `1px solid ${`var(--ds-border, ${(0, $829f609a65d26a98$export$1ce2d1575d444ceb)})`}`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    "[role='row']": {
        borderBottom: `1px solid ${`var(--ds-border, ${(0, $829f609a65d26a98$export$1ce2d1575d444ceb)})`}`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        ':hover': {
            backgroundColor: `var(--ds-background-neutral-subtle-hovered, ${(0, $829f609a65d26a98$export$791e57b27ca738ef)})`
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.cell': {
        alignItems: 'center'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.x-end': {
        justifyContent: 'flex-end'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.x-start > *': {
        display: 'flex',
        width: '100%',
        overflow: 'visible'
    }
});
const $0a4d5c9dd8972063$export$ca23f4c021898078 = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e4t0e7h0"
})({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    "[role='row']": {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        ':hover, :focus-within': {
            backgroundColor: `var(--ds-background-neutral-subtle-hovered, ${(0, $829f609a65d26a98$export$791e57b27ca738ef)})`,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
            '.hoverShow': {
                position: 'static',
                opacity: 1,
                zIndex: 0
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
            '.hoverHide': {
                position: 'fixed',
                opacity: 0,
                zIndex: -1
            }
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '.hoverShow': {
            position: 'fixed',
            opacity: 0,
            zIndex: -1
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.x-end': {
        padding: `${"var(--ds-space-0, 0px)"} ${"var(--ds-space-300, 24px)"}`
    }
});

});

parcelRegister("ewakd", function(module, exports) {

$parcel$export(module.exports, "pageAnalyticsAttributes", () => $f40e99305d3ec404$export$2e416653733068a8);
const $f40e99305d3ec404$export$2e416653733068a8 = (page)=>({
        hasEmbeddedEditing: page.hasEmbeddedEdit,
        pageType: page.isDraft ? 'draft' : 'page'
    });

});

parcelRegister("8FiLt", function(module, exports) {

$parcel$export(module.exports, "default", () => $e71e04c691ee4502$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $5nRKm = parcelRequire("5nRKm");

var $dZbEw = parcelRequire("dZbEw");

var $42CjB = parcelRequire("42CjB");

var $ldJSL = parcelRequire("ldJSL");

var $3bDjY = parcelRequire("3bDjY");

var $h8yj2 = parcelRequire("h8yj2");

var $daJ0i = parcelRequire("daJ0i");

var $aOxGW = parcelRequire("aOxGW");

var $ewakd = parcelRequire("ewakd");

var $hrEmu = parcelRequire("hrEmu");
const $e71e04c691ee4502$var$PageControls = ({ page: page, readOnly: readOnly, onEditClick: onEditClick, onShareToggle: onShareToggle, onAddChildClick: onAddChildClick, stickyRowContentId: stickyRowContentId, titleId: titleId, origin: origin })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const handleEditClick = (0, $5uXOq.useCallback)((_, analyticsEvent)=>{
        onEditClick?.(page);
        (0, $h8yj2.fireUIAnalytics)(analyticsEvent, 'editPageButton', origin.toAnalyticsAttributes({
            hasGeneratedId: true
        }));
    }, [
        onEditClick,
        origin,
        page
    ]);
    const handleAddChildClick = (0, $5uXOq.useCallback)((_, analyticsEvent)=>{
        onAddChildClick?.(page.id);
        (0, $h8yj2.fireUIAnalytics)(analyticsEvent, 'createChildPageButton', origin.toAnalyticsAttributes({
            hasGeneratedId: true
        }));
    }, [
        onAddChildClick,
        origin,
        page.id
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $ldJSL.default), {
        children: [
            !readOnly && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3bDjY.default), {
                content: formatMessage(page.hasEmbeddedEdit ? (0, $aOxGW.default).edit : (0, $aOxGW.default).editInConfluence),
                position: "top",
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $42CjB.default), {
                    appearance: "subtle",
                    icon: (0, (/*@__PURE__*/$parcel$interopDefault($5nRKm))),
                    onClick: handleEditClick,
                    testId: "confluence-project-pages.page-tree.page-controls.edit-button",
                    label: "edit",
                    id: "edit-button",
                    "aria-labelledby": `edit-button ${titleId}`,
                    spacing: "compact"
                })
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $hrEmu.default), {
                page: page,
                onToggle: onShareToggle,
                stickyRowContentId: stickyRowContentId,
                titleId: titleId
            }),
            !page.isDraft && !readOnly && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3bDjY.default), {
                content: formatMessage((0, $aOxGW.default).createChildPage),
                position: "top",
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $42CjB.default), {
                    appearance: "subtle",
                    icon: (0, (/*@__PURE__*/$parcel$interopDefault($dZbEw))),
                    onClick: handleAddChildClick,
                    testId: "confluence-project-pages.page-tree.page-controls.create-child-page-button",
                    label: "create child page",
                    id: "create-child-page-button",
                    "aria-labelledby": `create-child-page-button ${titleId}`,
                    spacing: "compact"
                })
            })
        ]
    });
};
var $e71e04c691ee4502$export$2e2bcd8739ae039 = (props)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $daJ0i.default), {
        data: {
            attributes: (0, $ewakd.pageAnalyticsAttributes)(props.page)
        },
        children: /*#__PURE__*/ (0, $2OMIu.jsx)($e71e04c691ee4502$var$PageControls, {
            ...props
        })
    });

});
parcelRegister("hrEmu", function(module, exports) {

$parcel$export(module.exports, "default", () => $9ba16fc0a378da80$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $eCeGD = parcelRequire("eCeGD");
var $42CjB = parcelRequire("42CjB");

var $l1N8i = parcelRequire("l1N8i");

var $KhPb4 = parcelRequire("KhPb4");

var $empdx = parcelRequire("empdx");

var $ctg8C = parcelRequire("ctg8C");

var $kY99m = parcelRequire("kY99m");


var $3bDjY = parcelRequire("3bDjY");

var $dC5iT = parcelRequire("dC5iT");

var $jkADf = parcelRequire("jkADf");
var $agcXw = parcelRequire("agcXw");
var $h8yj2 = parcelRequire("h8yj2");

var $2gQ83 = parcelRequire("2gQ83");

var $l9RpX = parcelRequire("l9RpX");

var $hhHt3 = parcelRequire("hhHt3");
const $9ba16fc0a378da80$var$styles = {
    subtitle: "_11c81o8v _k48p1igg",
    textField: "_bfhkmag2"
};
const $9ba16fc0a378da80$var$ShareButton = ({ page: page, onToggle: onToggle, stickyRowContentId: stickyRowContentId, titleId: titleId })=>{
    const [isCopied, setIsCopied] = (0, $5uXOq.useState)(false);
    const isOpen = stickyRowContentId === page.id;
    const buttonId = 'share-button';
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    // the page-tree gets re-rendered every time a share is clicked so we have to create a new origin here,
    // otherwise the actual generated ID would be behind by 1 render
    const origin = (0, $5uXOq.useMemo)(()=>new (0, $2gQ83.default)({
            product: 'jira'
        }), []);
    const handleCopy = (0, $5uXOq.useCallback)((_, analyticsEvent)=>{
        navigator.clipboard.writeText(origin.addToUrl(page.url)).then(()=>{
            setIsCopied(true);
            (0, $h8yj2.fireUIAnalytics)(analyticsEvent, 'copyPageLinkButton', origin.toAnalyticsAttributes());
        });
    }, [
        origin,
        page.url
    ]);
    const handleShareClick = (0, $5uXOq.useCallback)((_, analyticsEvent)=>{
        (0, $h8yj2.fireUIAnalytics)(analyticsEvent, 'sharePageButton', {
            // we negate isOpen since state in parent hasn't been updated yet
            isOpen: !isOpen,
            ...origin.toAnalyticsAttributes({
                hasGeneratedId: !isOpen
            }) // start an origin trace when the share toggle is opened
        });
        onToggle?.(isOpen ? null : page.id);
        if (isOpen) setIsCopied(false);
    }, [
        page,
        isOpen,
        origin,
        onToggle
    ]);
    // need to use different callback as we don't get the same props from inline dialog as we do from button
    const handleShareClose = (0, $5uXOq.useCallback)(()=>{
        onToggle?.(null);
        setIsCopied(false);
    }, [
        onToggle
    ]);
    const dialogContent = /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $jkADf.ContextWrapper), {
            sourceName: "sharePage",
            sourceType: (0, $6e65040b988c460f$export$d1123261ca8831d2),
            children: [
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $l1N8i.default), {
                    size: "large",
                    as: "h2",
                    children: formatMessage((0, $l9RpX.default).title)
                }),
                /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                    className: (0, $bwpsq.default)([
                        $9ba16fc0a378da80$var$styles.subtitle
                    ]),
                    children: formatMessage((0, $l9RpX.default).subtitle)
                }),
                /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $hhHt3.Content), {
                    children: [
                        /*#__PURE__*/ (0, $2OMIu.jsx)((0, $kY99m.default), {
                            isCompact: true,
                            name: "link",
                            isReadOnly: true,
                            value: origin.addToUrl(page.url),
                            appearance: "subtle",
                            // eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides
                            className: (0, $bwpsq.default)([
                                $9ba16fc0a378da80$var$styles.textField
                            ])
                        }),
                        /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eCeGD.default), {
                            onClick: handleCopy,
                            children: formatMessage((0, $l9RpX.default).copyButton)
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $hhHt3.InlineMessage), {
                    children: [
                        isCopied && /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($KhPb4))), {
                            color: `var(--ds-icon-success, ${(0, $829f609a65d26a98$export$a49394138f7b8e85)})`,
                            label: "copied"
                        }),
                        /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dC5iT.default), {
                            as: "span",
                            "aria-live": "polite",
                            "aria-atomic": "true",
                            children: isCopied ? formatMessage((0, $l9RpX.default).copied) : ''
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $agcXw.FireScreenAnalytics), {
                    attributes: origin.toAnalyticsAttributes()
                })
            ]
        })
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3bDjY.default), {
        content: formatMessage((0, $l9RpX.default).tooltip),
        position: "top",
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ctg8C.default), {
            content: dialogContent,
            isOpen: isOpen,
            placement: "bottom-end",
            onClose: handleShareClose,
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $42CjB.default), {
                appearance: "subtle",
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($empdx))),
                isSelected: isOpen,
                onClick: handleShareClick,
                testId: "confluence-project-pages.page-tree.page-controls.share-button",
                label: "share",
                "aria-expanded": isOpen,
                id: buttonId,
                "aria-labelledby": `${buttonId} ${titleId}`,
                spacing: "compact"
            })
        })
    });
};
var $9ba16fc0a378da80$export$2e2bcd8739ae039 = $9ba16fc0a378da80$var$ShareButton;

});
parcelRegister("KhPb4", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::71700ecaa42770a612a02b8b70cd2bee>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $08b21f8e4cb7f21d$var$_react = $08b21f8e4cb7f21d$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $08b21f8e4cb7f21d$var$_baseNew = $08b21f8e4cb7f21d$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $08b21f8e4cb7f21d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "CheckCircle".
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: 📦 @atlaskit/icon/utility/check-circle
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $08b21f8e4cb7f21d$var$CheckCircleIcon = (props)=>/*#__PURE__*/ $08b21f8e4cb7f21d$var$_react.default.createElement($08b21f8e4cb7f21d$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 6a6 6 0 1 1 12 0A6 6 0 0 1 0 6m6-4.5a4.5 4.5 0 1 0 0 9 4.5 4.5 0 0 0 0-9m3.292 2.808L5.67 8.653a.75.75 0 0 1-1.152 0L2.709 6.48l1.152-.96L5.095 7l3.044-3.653z" clip-rule="evenodd"/>`,
        type: 'utility'
    }, props));
$08b21f8e4cb7f21d$var$CheckCircleIcon.displayName = 'CheckCircleIcon';
var $08b21f8e4cb7f21d$var$_default = module.exports.default = $08b21f8e4cb7f21d$var$CheckCircleIcon;

});

parcelRegister("empdx", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ccb1509d7e2270e6a953aebace8cfd49>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a746ae65a0e1944c$var$_react = $a746ae65a0e1944c$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $a746ae65a0e1944c$var$_baseNew = $a746ae65a0e1944c$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $a746ae65a0e1944c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Share".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for sharing an object.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a746ae65a0e1944c$var$ShareIcon = (props)=>/*#__PURE__*/ $a746ae65a0e1944c$var$_react.default.createElement($a746ae65a0e1944c$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M12 2.5a1 1 0 1 0 0 2 1 1 0 0 0 0-2m-2.5 1a2.5 2.5 0 1 1 .73 1.765L6.212 7.567a2.5 2.5 0 0 1 0 .866l4.016 2.302a2.5 2.5 0 1 1-.692 1.332L5.521 9.766a2.5 2.5 0 1 1 0-3.53l4.016-2.302A2.5 2.5 0 0 1 9.5 3.5M3.75 7a1 1 0 1 0 0 2 1 1 0 0 0 0-2M12 11.5a1 1 0 1 0 0 2 1 1 0 0 0 0-2" clip-rule="evenodd"/>`
    }, props));
$a746ae65a0e1944c$var$ShareIcon.displayName = 'ShareIcon';
var $a746ae65a0e1944c$var$_default = module.exports.default = $a746ae65a0e1944c$var$ShareIcon;

});

parcelRegister("agcXw", function(module, exports) {

$parcel$export(module.exports, "FireUIAnalytics", () => $5625c4255a3b29d6$export$1f3555c9be6c5e08);
$parcel$export(module.exports, "FireTrackAnalytics", () => $5625c4255a3b29d6$export$5f0d7aae8dfa8b86);
$parcel$export(module.exports, "FireOperationalAnalytics", () => $5625c4255a3b29d6$export$b71c3ada5d4ec5da);
$parcel$export(module.exports, "FireScreenAnalytics", () => $5625c4255a3b29d6$export$2ccf161b817b43b);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $cb25w = parcelRequire("cb25w");


var $h8yj2 = parcelRequire("h8yj2");
const $5625c4255a3b29d6$var$getFixedActionAndActionSubject = (props)=>{
    const { eventName: eventName, action: action, actionSubject: actionSubject } = props;
    if (eventName && (action || actionSubject)) throw new Error('eventName is an alias for action & actionSubject, provide only one of those');
    const eventNameSplit = eventName ? eventName.split(' ') : [];
    const fixedAction = action || eventNameSplit[1];
    const fixedActionSubject = actionSubject || eventNameSplit[0];
    if (!fixedAction || !fixedActionSubject) throw new Error('eventName should exist and be in the format "subject action", i.e. "button clicked", "menu opened", "issue created", etc');
    return {
        action: fixedAction,
        actionSubject: fixedActionSubject
    };
};
const $5625c4255a3b29d6$var$getFixedActionSubjectId = (props)=>{
    const { componentName: componentName, actionSubjectId: actionSubjectId } = props;
    if (componentName && actionSubjectId) throw new Error('componentName is an alias for actionSubjectId, provide only one of those');
    const fixedActionSubjectId = actionSubjectId || componentName;
    return {
        actionSubjectId: fixedActionSubjectId
    };
};
class $5625c4255a3b29d6$var$FireComponent extends (0, $5uXOq.Component) {
    componentDidMount() {
        const { type: type, attributes: attributes } = this.props;
        if (!this.props.createAnalyticsEvent) throw new Error('Invalid use of component; must be wrapped by withAnalyticsEvents HOC');
        const { action: action, actionSubject: actionSubject } = $5625c4255a3b29d6$var$getFixedActionAndActionSubject(this.props);
        const { actionSubjectId: actionSubjectId } = $5625c4255a3b29d6$var$getFixedActionSubjectId(this.props);
        const analyticsEvent = this.props.createAnalyticsEvent({
            action: action
        });
        (0, $h8yj2.fireAnalytics)(analyticsEvent, type, {
            action: action,
            actionSubject: actionSubject,
            actionSubjectId: actionSubjectId,
            attributes: attributes
        });
    }
    render() {
        return null;
    }
}
const $5625c4255a3b29d6$var$WithAnalytics = (0, $cb25w.default)()($5625c4255a3b29d6$var$FireComponent);
const $5625c4255a3b29d6$export$1f3555c9be6c5e08 = (props)=>/*#__PURE__*/ (0, $2OMIu.jsx)($5625c4255a3b29d6$var$WithAnalytics, {
        ...props,
        type: (0, $6e65040b988c460f$export$a1562d08625f5d7e)
    });
const $5625c4255a3b29d6$export$5f0d7aae8dfa8b86 = (props)=>/*#__PURE__*/ (0, $2OMIu.jsx)($5625c4255a3b29d6$var$WithAnalytics, {
        ...props,
        type: (0, $6e65040b988c460f$export$947dac6c72b26f81)
    });
const $5625c4255a3b29d6$export$b71c3ada5d4ec5da = (props)=>/*#__PURE__*/ (0, $2OMIu.jsx)($5625c4255a3b29d6$var$WithAnalytics, {
        ...props,
        type: (0, $6e65040b988c460f$export$12346a674644c156)
    });
const $5625c4255a3b29d6$export$2ccf161b817b43b = (props)=>/*#__PURE__*/ (0, $2OMIu.jsx)($5625c4255a3b29d6$var$WithAnalytics, {
        ...props,
        type: (0, $6e65040b988c460f$export$f1d537d508d2945a),
        eventName: "screen viewed"
    });

});

parcelRegister("l9RpX", function(module, exports) {

$parcel$export(module.exports, "default", () => $76b5aab22593db93$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $76b5aab22593db93$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    title: {
        id: 'confluence-table-tree.share.title',
        defaultMessage: 'Share page',
        description: 'Title of the inline dialog that allows users to copy a page link'
    },
    subtitle: {
        id: 'confluence-table-tree.share.subtitle',
        defaultMessage: 'Share this link',
        description: 'Subtitle of the inline dialog that allows users to copy a page link'
    },
    copyButton: {
        id: 'confluence-table-tree.share.copy-button',
        defaultMessage: 'Copy',
        description: 'Label of the button that copies a page link'
    },
    copied: {
        id: 'confluence-table-tree.share.copied',
        defaultMessage: 'Copied to clipboard',
        description: 'Small inline message letting users know that a page link has been copied'
    },
    tooltip: {
        id: 'confluence-table-tree.share.tooltip',
        defaultMessage: 'Share',
        description: 'Tooltip when users hover over the button that allows them to share a page link'
    }
});

});

parcelRegister("hhHt3", function(module, exports) {

$parcel$export(module.exports, "Content", () => $7cd8f2d6655e45e7$export$7c6e2c02157bb7d2);
$parcel$export(module.exports, "InlineMessage", () => $7cd8f2d6655e45e7$export$9eebc872739f8128);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766


var $bWGt6 = parcelRequire("bWGt6");
function $7cd8f2d6655e45e7$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $7cd8f2d6655e45e7$export$7c6e2c02157bb7d2 = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "esfzs1f1"
})({
    name: "o9998f",
    styles: "display:flex;gap:var(--ds-space-200, 16px);margin-top:var(--ds-space-050, 4px)"
});
const $7cd8f2d6655e45e7$export$9eebc872739f8128 = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "esfzs1f0"
})({
    display: 'flex',
    alignItems: 'center',
    color: `var(--ds-text, ${(0, $829f609a65d26a98$export$7d61b15e0da132af)})`,
    font: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    gap: "var(--ds-space-050, 4px)",
    marginTop: "var(--ds-space-100, 8px)"
});

});




parcelRegister("l3opI", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_LOCALE", () => $8f5a4cd669b7cf9d$export$1af4c7e47ad72f44);
$parcel$export(module.exports, "TranslationsProvider", () => $8f5a4cd669b7cf9d$export$7df75b8194cf0ae5);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $i5FdW = parcelRequire("i5FdW");

var $fZ9hM = parcelRequire("fZ9hM");
const $8f5a4cd669b7cf9d$var$i18n = $fZ9hM;
const $8f5a4cd669b7cf9d$export$1af4c7e47ad72f44 = 'en_US';
const $8f5a4cd669b7cf9d$export$7df75b8194cf0ae5 = ({ locale: locale, children: children })=>{
    const { language: language, country: country } = (0, $5uXOq.useMemo)(()=>{
        const match = /([a-z]*)[_-]?([A-Z]*)/i.exec(locale || '');
        if (!match) throw Error('Unable to get language and country from invalid Locale');
        const [, language, country] = match;
        return {
            language: language.toLowerCase(),
            country: country.toUpperCase()
        };
    }, [
        locale
    ]);
    const translatedMessages = $8f5a4cd669b7cf9d$var$i18n[`${language}_${country}`] || $8f5a4cd669b7cf9d$var$i18n[language];
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $i5FdW.default), {
        locale: language,
        messages: translatedMessages,
        children: children
    });
};

});
parcelRegister("fZ9hM", function(module, exports) {

$parcel$export(module.exports, "zh", () => (parcelRequire("aFhJH")).default);
$parcel$export(module.exports, "zh_TW", () => (parcelRequire("dycRb")).default);
$parcel$export(module.exports, "cs", () => (parcelRequire("3UtLe")).default);
$parcel$export(module.exports, "da", () => (parcelRequire("2XTeD")).default);
$parcel$export(module.exports, "nl", () => (parcelRequire("dV37z")).default);
$parcel$export(module.exports, "et", () => (parcelRequire("9ixCi")).default);
$parcel$export(module.exports, "fi", () => (parcelRequire("iXYIa")).default);
$parcel$export(module.exports, "fr", () => (parcelRequire("jZAjO")).default);
$parcel$export(module.exports, "de", () => (parcelRequire("lTvRA")).default);
$parcel$export(module.exports, "hu", () => (parcelRequire("aD7AT")).default);
$parcel$export(module.exports, "it", () => (parcelRequire("2SHqM")).default);
$parcel$export(module.exports, "ja", () => (parcelRequire("ftnHt")).default);
$parcel$export(module.exports, "ko", () => (parcelRequire("2gYch")).default);
$parcel$export(module.exports, "nb", () => (parcelRequire("f1dzU")).default);
$parcel$export(module.exports, "pl", () => (parcelRequire("8v0O3")).default);
$parcel$export(module.exports, "pt_BR", () => (parcelRequire("6XsL4")).default);
$parcel$export(module.exports, "pt_PT", () => (parcelRequire("1ZzFt")).default);
$parcel$export(module.exports, "ru", () => (parcelRequire("kZeeW")).default);
$parcel$export(module.exports, "sk", () => (parcelRequire("5vNuR")).default);
$parcel$export(module.exports, "es", () => (parcelRequire("bvrre")).default);
$parcel$export(module.exports, "sv", () => (parcelRequire("d7Nly")).default);
$parcel$export(module.exports, "th", () => (parcelRequire("hP8pZ")).default);
$parcel$export(module.exports, "tr", () => (parcelRequire("ijF2a")).default);
$parcel$export(module.exports, "uk", () => (parcelRequire("auuVI")).default);
$parcel$export(module.exports, "vi", () => (parcelRequire("fPDtS")).default);
$parcel$export(module.exports, "en", () => (parcelRequire("6sJcA")).default);
$parcel$export(module.exports, "en_GB", () => (parcelRequire("EP5Dd")).default);
$parcel$export(module.exports, "en_ZZ", () => (parcelRequire("7Z2D7")).default);
/**
 * NOTE:
 *
 * This file was automatically generated by i18n-tools
 * but it has been deprecated and now must be manually
 * updated.
 */ 
var $aFhJH = parcelRequire("aFhJH");

var $dycRb = parcelRequire("dycRb");

var $3UtLe = parcelRequire("3UtLe");

var $2XTeD = parcelRequire("2XTeD");

var $dV37z = parcelRequire("dV37z");

var $9ixCi = parcelRequire("9ixCi");

var $iXYIa = parcelRequire("iXYIa");

var $jZAjO = parcelRequire("jZAjO");

var $lTvRA = parcelRequire("lTvRA");

var $aD7AT = parcelRequire("aD7AT");

var $2SHqM = parcelRequire("2SHqM");

var $ftnHt = parcelRequire("ftnHt");

var $2gYch = parcelRequire("2gYch");

var $f1dzU = parcelRequire("f1dzU");

var $8v0O3 = parcelRequire("8v0O3");

var $6XsL4 = parcelRequire("6XsL4");

var $1ZzFt = parcelRequire("1ZzFt");

var $kZeeW = parcelRequire("kZeeW");

var $5vNuR = parcelRequire("5vNuR");

var $bvrre = parcelRequire("bvrre");

var $d7Nly = parcelRequire("d7Nly");

var $hP8pZ = parcelRequire("hP8pZ");

var $ijF2a = parcelRequire("ijF2a");

var $auuVI = parcelRequire("auuVI");

var $fPDtS = parcelRequire("fPDtS");

var $6sJcA = parcelRequire("6sJcA");

var $EP5Dd = parcelRequire("EP5Dd");

var $7Z2D7 = parcelRequire("7Z2D7");

});
parcelRegister("aFhJH", function(module, exports) {

$parcel$export(module.exports, "default", () => $bca2a7dcfc1b184a$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Chinese (Simplified)
var $bca2a7dcfc1b184a$export$2e2bcd8739ae039 = {
    'confluence-table-tree.column.contributors': "\u53C2\u4E0E\u8005",
    'confluence-table-tree.column.last-modified': "\u4E0A\u6B21\u4FEE\u6539\u65F6\u95F4",
    'confluence-table-tree.column.title': "\u540D\u79F0",
    'confluence-table-tree.could-not-load': "\u65E0\u6CD5\u52A0\u8F7D",
    'confluence-table-tree.could-not-load-contributors': "\u65E0\u6CD5\u52A0\u8F7D\u8D21\u732E\u8005",
    'confluence-table-tree.create-child-page': "\u521B\u5EFA\u5B50\u9875\u9762",
    'confluence-table-tree.create-page': "\u521B\u5EFA\u9875\u9762",
    'confluence-table-tree.default.page.title': "\u672A\u547D\u540D",
    'confluence-table-tree.default.show-all-pages-button.label': "\u663E\u793A\u66F4\u591A\u9875\u9762",
    'confluence-table-tree.draft.lozenge': "\u8349\u7A3F",
    'confluence-table-tree.draft.tooltip': "\u53EA\u6709\u60A8\u53EF\u4EE5\u770B\u5230\u8349\u7A3F\u3002",
    'confluence-table-tree.drafts-toggle.label': "\u663E\u793A\u8349\u7A3F",
    'confluence-table-tree.edit': "\u7F16\u8F91",
    'confluence-table-tree.edit-in-confluence': "\u5728 Confluence \u4E2D\u7F16\u8F91",
    'confluence-table-tree.empty.description': "\u521B\u5EFA\u4E00\u4E9B\u4F1A\u8BAE\u8BB0\u5F55\u3001\u4EA7\u54C1\u9700\u6C42\u3001\u51B3\u5B9A\u6216\u5176\u4ED6\u5185\u5BB9\u6765\u5145\u5B9E\u8BE5\u7A7A\u95F4\u3002",
    'confluence-table-tree.empty.title': "\u65E0\u9650\u6F5C\u529B\uFF0C\u5C3D\u5F85\u6316\u6398",
    'confluence-table-tree.error.description': "\u65E0\u6CD5\u663E\u793A\u8FD9\u4E9B\u9875\u9762\u3002\u8BF7\u7A0D\u540E\u91CD\u8BD5\u3002",
    'confluence-table-tree.error.row': "\u65E0\u6CD5\u52A0\u8F7D\u9875\u9762\u3002",
    'confluence-table-tree.error.title': "\u62B1\u6B49...",
    'confluence-table-tree.friendly-when-created': "\u521B\u5EFA\u65E5\u671F",
    'confluence-table-tree.friendly-when-updated': "\u4E0A\u6B21\u66F4\u65B0\u65F6\u95F4",
    'confluence-table-tree.share.copied': "\u5DF2\u590D\u5236\u5230\u526A\u8D34\u677F",
    'confluence-table-tree.share.copy-button': "\u590D\u5236",
    'confluence-table-tree.share.subtitle': "\u5206\u4EAB\u6B64\u94FE\u63A5",
    'confluence-table-tree.share.title': "\u5206\u4EAB\u9875\u9762",
    'confluence-table-tree.share.tooltip': "\u5171\u4EAB",
    'confluence-table-tree.view-profile': "\u67E5\u770B\u4E2A\u4EBA\u8D44\u6599"
};

});

parcelRegister("dycRb", function(module, exports) {

$parcel$export(module.exports, "default", () => $e03e062830931725$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Chinese (Traditional)
var $e03e062830931725$export$2e2bcd8739ae039 = {
    'confluence-table-tree.column.contributors': "\u53C3\u8207\u8005",
    'confluence-table-tree.column.last-modified': "\u4E0A\u6B21\u4FEE\u6539",
    'confluence-table-tree.column.title': "\u540D\u7A31",
    'confluence-table-tree.could-not-load': "\u7121\u6CD5\u8F09\u5165",
    'confluence-table-tree.could-not-load-contributors': "\u7121\u6CD5\u8F09\u5165\u53C3\u8207\u8005",
    'confluence-table-tree.create-child-page': "\u5EFA\u7ACB\u5B50\u7CFB\u9801\u9762",
    'confluence-table-tree.create-page': "\u5EFA\u7ACB\u9801\u9762",
    'confluence-table-tree.default.page.title': "\u672A\u547D\u540D",
    'confluence-table-tree.default.show-all-pages-button.label': "\u986F\u793A\u66F4\u591A\u9801\u9762",
    'confluence-table-tree.draft.lozenge': "\u8349\u7A3F",
    'confluence-table-tree.draft.tooltip': "\u53EA\u6709\u60A8\u770B\u5F97\u5230\u8349\u7A3F\u3002",
    'confluence-table-tree.drafts-toggle.label': "\u986F\u793A\u8349\u7A3F",
    'confluence-table-tree.edit': "\u7DE8\u8F2F",
    'confluence-table-tree.edit-in-confluence': "\u5728 Confluence \u4E2D\u7DE8\u8F2F",
    'confluence-table-tree.empty.description': "\u5EFA\u7ACB\u4E00\u4E9B\u6703\u8B70\u7B46\u8A18\u3001\u7522\u54C1\u8981\u6C42\u3001\u6C7A\u7B56\u6216\u5176\u4ED6\u5167\u5BB9\uFF0C\u4EE5\u67E5\u770B\u6B64\u7A7A\u9593\u662F\u5426\u5DF2\u586B\u6EFF\u3002",
    'confluence-table-tree.empty.title': "\u9019\u88E1\u76EE\u524D\u4EC0\u9EBC\u90FD\u6C92\u6709\uFF0C\u53EA\u6709\u6F5B\u529B\u7121\u9650",
    'confluence-table-tree.error.description': "\u6211\u5011\u7121\u6CD5\u5411\u60A8\u986F\u793A\u9801\u9762\u3002\u8ACB\u7A0D\u5F8C\u518D\u8A66\u4E00\u6B21\u3002",
    'confluence-table-tree.error.row': "\u7121\u6CD5\u8F09\u5165\u9801\u9762\u3002",
    'confluence-table-tree.error.title': "\u55EF\uFF0C\u9019\u6709\u9EDE\u5947\u602A...",
    'confluence-table-tree.friendly-when-created': "\u5DF2\u5EFA\u7ACB",
    'confluence-table-tree.friendly-when-updated': "\u5DF2\u66F4\u65B0",
    'confluence-table-tree.share.copied': "\u5DF2\u8907\u88FD\u5230\u526A\u8CBC\u7C3F",
    'confluence-table-tree.share.copy-button': "\u8907\u88FD",
    'confluence-table-tree.share.subtitle': "\u5206\u4EAB\u6B64\u9023\u7D50",
    'confluence-table-tree.share.title': "\u5206\u4EAB\u9801\u9762",
    'confluence-table-tree.share.tooltip': "\u5206\u4EAB",
    'confluence-table-tree.view-profile': "\u6AA2\u8996\u8A2D\u5B9A\u6A94"
};

});

parcelRegister("3UtLe", function(module, exports) {

$parcel$export(module.exports, "default", () => $1abf29a577f792b8$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Czech
var $1abf29a577f792b8$export$2e2bcd8739ae039 = {
    'confluence-table-tree.column.contributors': "P\u0159isp\u011Bvatel\xe9",
    'confluence-table-tree.column.last-modified': "Naposledy zm\u011Bn\u011Bno",
    'confluence-table-tree.column.title': "N\xe1zev",
    'confluence-table-tree.could-not-load': "Nelze na\u010D\xedst",
    'confluence-table-tree.could-not-load-contributors': "Na\u010Dten\xed p\u0159isp\u011Bvatel\u016F se nezda\u0159ilo.",
    'confluence-table-tree.create-child-page': "Vytvo\u0159it pod\u0159azenou str\xe1nku",
    'confluence-table-tree.create-page': "Vytvo\u0159it str\xe1nku",
    'confluence-table-tree.default.page.title': "Bez n\xe1zvu",
    'confluence-table-tree.default.show-all-pages-button.label': "Zobrazit v\xedce str\xe1nek",
    'confluence-table-tree.draft.lozenge': 'KONCEPT',
    'confluence-table-tree.draft.tooltip': "Koncepty uvid\xedte pouze vy.",
    'confluence-table-tree.drafts-toggle.label': 'Zobrazit koncepty',
    'confluence-table-tree.edit': 'Upravit',
    'confluence-table-tree.edit-in-confluence': "Upravit v\xa0Confluence",
    'confluence-table-tree.empty.description': "Tento prostor se zapln\xed, a\u017E za\u010Dnete vytv\xe1\u0159et z\xe1pisy ze sch\u016Fzek, produktov\xe9 po\u017Eadavky, rozhodnut\xed a\xa0dal\u0161\xed obsah.",
    'confluence-table-tree.empty.title': "Nic zde nen\xed, ale m\u016F\u017Ee b\xfdt",
    'confluence-table-tree.error.description': "Tyto str\xe1nky v\xe1m nem\u016F\u017Eeme zobrazit. Zkuste to znovu pozd\u011Bji.",
    'confluence-table-tree.error.row': "Na\u010Dten\xed str\xe1nek se nezda\u0159ilo.",
    'confluence-table-tree.error.title': "Hmm, toto je zvl\xe1\u0161tn\xed\u2026",
    'confluence-table-tree.friendly-when-created': "Vytvo\u0159eno",
    'confluence-table-tree.friendly-when-updated': "Aktualizov\xe1no",
    'confluence-table-tree.share.copied': "Zkop\xedrov\xe1no do schr\xe1nky",
    'confluence-table-tree.share.copy-button': "Kop\xedrovat",
    'confluence-table-tree.share.subtitle': "Sd\xedlejte tento odkaz",
    'confluence-table-tree.share.title': "Sd\xedlet str\xe1nku",
    'confluence-table-tree.share.tooltip': "Sd\xedlet",
    'confluence-table-tree.view-profile': 'Zobrazit profil'
};

});

parcelRegister("2XTeD", function(module, exports) {

$parcel$export(module.exports, "default", () => $3c937cbe07a4ba5f$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Danish (Denmark)
var $3c937cbe07a4ba5f$export$2e2bcd8739ae039 = {
    'confluence-table-tree.column.contributors': 'Bidragydere',
    'confluence-table-tree.column.last-modified': "Sidst \xe6ndret",
    'confluence-table-tree.column.title': 'Navn',
    'confluence-table-tree.could-not-load': "Kunne ikke indl\xe6ses",
    'confluence-table-tree.could-not-load-contributors': "Bidragsydere kunne ikke indl\xe6ses",
    'confluence-table-tree.create-child-page': 'Opret en underordnet side',
    'confluence-table-tree.create-page': 'Opret side',
    'confluence-table-tree.default.page.title': 'Uden titel',
    'confluence-table-tree.default.show-all-pages-button.label': 'Vis flere sider',
    'confluence-table-tree.draft.lozenge': 'UDKAST',
    'confluence-table-tree.draft.tooltip': 'Udkast kan kun ses af dig.',
    'confluence-table-tree.drafts-toggle.label': 'Vis udkast',
    'confluence-table-tree.edit': 'Rediger',
    'confluence-table-tree.edit-in-confluence': 'Rediger i Confluence',
    'confluence-table-tree.empty.description': "Opret m\xf8denoter, produktkrav, beslutninger eller andet indhold for at se omr\xe5det blive fyldt ud.",
    'confluence-table-tree.empty.title': 'Der er ikke andet end potentiale her',
    'confluence-table-tree.error.description': "Vi kan ikke vise dig disse sider. Pr\xf8v igen senere.",
    'confluence-table-tree.error.row': "Sider kan ikke indl\xe6ses.",
    'confluence-table-tree.error.title': 'Ups, det var pinligt ...',
    'confluence-table-tree.friendly-when-created': 'Oprettet',
    'confluence-table-tree.friendly-when-updated': 'Opdateret',
    'confluence-table-tree.share.copied': 'Kopieret til udklipsholderen',
    'confluence-table-tree.share.copy-button': "Kopi\xe9r",
    'confluence-table-tree.share.subtitle': 'Del dette link',
    'confluence-table-tree.share.title': 'Del side',
    'confluence-table-tree.share.tooltip': 'Del',
    'confluence-table-tree.view-profile': 'Se profil'
};

});

parcelRegister("dV37z", function(module, exports) {

$parcel$export(module.exports, "default", () => $bd6bf321c8dc2dd8$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Dutch (Netherlands)
var $bd6bf321c8dc2dd8$export$2e2bcd8739ae039 = {
    'confluence-table-tree.column.contributors': 'Bijdragers',
    'confluence-table-tree.column.last-modified': 'Laatst aangepast',
    'confluence-table-tree.column.title': 'Naam',
    'confluence-table-tree.could-not-load': 'Kon niet worden geladen',
    'confluence-table-tree.could-not-load-contributors': 'Bijdragers konden niet worden geladen',
    'confluence-table-tree.create-child-page': 'Maak een onderliggende pagina aan',
    'confluence-table-tree.create-page': 'Pagina aanmaken',
    'confluence-table-tree.default.page.title': 'Ongetiteld',
    'confluence-table-tree.default.show-all-pages-button.label': "Meer pagina's tonen",
    'confluence-table-tree.draft.lozenge': 'CONCEPT',
    'confluence-table-tree.draft.tooltip': 'Concepten zijn alleen zichtbaar voor jou.',
    'confluence-table-tree.drafts-toggle.label': 'Concepten weergeven',
    'confluence-table-tree.edit': 'Bewerken',
    'confluence-table-tree.edit-in-confluence': 'Bewerken in Confluence',
    'confluence-table-tree.empty.description': 'Maak vergadernotulen, stel productvereisten op, neem beslissingen of maak andere content aan, om deze space op te vullen.',
    'confluence-table-tree.empty.title': 'Hier zijn alleen maar mogelijkheden',
    'confluence-table-tree.error.description': "We kunnen je deze pagina's niet laten zien. Probeer het later opnieuw.",
    'confluence-table-tree.error.row': "Kan pagina's niet laden.",
    'confluence-table-tree.error.title': 'Hmm, dit is niet zo handig...',
    'confluence-table-tree.friendly-when-created': 'Aangemaakt',
    'confluence-table-tree.friendly-when-updated': 'Bijgewerkt',
    'confluence-table-tree.share.copied': 'Gekopieerd naar klembord',
    'confluence-table-tree.share.copy-button': "Kopi\xebren",
    'confluence-table-tree.share.subtitle': 'Deel deze link',
    'confluence-table-tree.share.title': 'Pagina delen',
    'confluence-table-tree.share.tooltip': 'Delen',
    'confluence-table-tree.view-profile': 'Profiel bekijken'
};

});

parcelRegister("9ixCi", function(module, exports) {

$parcel$export(module.exports, "default", () => $e70bccd43fb012df$export$2e2bcd8739ae039);
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Estonian
var $e70bccd43fb012df$export$2e2bcd8739ae039 = {};

});

parcelRegister("iXYIa", function(module, exports) {

$parcel$export(module.exports, "default", () => $c7c865b9fdd82716$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Finnish
var $c7c865b9fdd82716$export$2e2bcd8739ae039 = {
    'confluence-table-tree.column.contributors': 'Osallistujat',
    'confluence-table-tree.column.last-modified': 'Viimeksi muokattu',
    'confluence-table-tree.column.title': 'Nimi',
    'confluence-table-tree.could-not-load': 'Ei voitu ladata',
    'confluence-table-tree.could-not-load-contributors': 'Osallistujia ei voitu ladata',
    'confluence-table-tree.create-child-page': 'Luo alasivu',
    'confluence-table-tree.create-page': 'Luo sivu',
    'confluence-table-tree.default.page.title': "Nime\xe4m\xe4t\xf6n",
    'confluence-table-tree.default.show-all-pages-button.label': "N\xe4yt\xe4 enemm\xe4n sivuja",
    'confluence-table-tree.draft.lozenge': 'LUONNOS',
    'confluence-table-tree.draft.tooltip': "Luonnokset n\xe4kyv\xe4t vain sinulle.",
    'confluence-table-tree.drafts-toggle.label': "N\xe4yt\xe4 luonnokset",
    'confluence-table-tree.edit': 'Muokkaa',
    'confluence-table-tree.edit-in-confluence': 'Muokkaa Confluencessa',
    'confluence-table-tree.empty.description': "T\xe4yt\xe4 t\xe4m\xe4 ty\xf6tila luomalla kokousmuistioita, tuotevaatimuksia, p\xe4\xe4t\xf6ksi\xe4 tai muuta sis\xe4lt\xf6\xe4.",
    'confluence-table-tree.empty.title': "T\xe4\xe4ll\xe4 on pelkk\xe4\xe4 potentiaalia",
    'confluence-table-tree.error.description': "N\xe4it\xe4 sivuja ei voi n\xe4ytt\xe4\xe4. Yrit\xe4 my\xf6hemmin uudelleen.",
    'confluence-table-tree.error.row': 'Sivujen lataus ei onnistu.',
    'confluence-table-tree.error.title': "Nyt k\xe4vi nolosti.",
    'confluence-table-tree.friendly-when-created': 'Luotu',
    'confluence-table-tree.friendly-when-updated': "P\xe4ivitetty",
    'confluence-table-tree.share.copied': "Kopioitu leikep\xf6yd\xe4lle",
    'confluence-table-tree.share.copy-button': 'Kopioi',
    'confluence-table-tree.share.subtitle': "Jaa t\xe4m\xe4 linkki",
    'confluence-table-tree.share.title': 'Jaa sivu',
    'confluence-table-tree.share.tooltip': 'Jaa',
    'confluence-table-tree.view-profile': "N\xe4yt\xe4 profiili"
};

});

parcelRegister("jZAjO", function(module, exports) {

$parcel$export(module.exports, "default", () => $ce7f4f38d7f18462$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //French (France)
var $ce7f4f38d7f18462$export$2e2bcd8739ae039 = {
    'confluence-table-tree.column.contributors': 'Contributeurs',
    'confluence-table-tree.column.last-modified': "Derni\xe8re modification",
    'confluence-table-tree.column.title': 'Nom',
    'confluence-table-tree.could-not-load': 'Chargement impossible',
    'confluence-table-tree.could-not-load-contributors': 'Impossible de charger les contributeurs',
    'confluence-table-tree.create-child-page': "Cr\xe9er une page enfant",
    'confluence-table-tree.create-page': "Cr\xe9er une page",
    'confluence-table-tree.default.page.title': 'Sans titre',
    'confluence-table-tree.default.show-all-pages-button.label': 'Afficher plus de pages',
    'confluence-table-tree.draft.lozenge': 'BROUILLON',
    'confluence-table-tree.draft.tooltip': "Les brouillons ne peuvent \xeatre vus que par vous.",
    'confluence-table-tree.drafts-toggle.label': 'Afficher les brouillons',
    'confluence-table-tree.edit': 'Modifier',
    'confluence-table-tree.edit-in-confluence': 'Modifier dans Confluence',
    'confluence-table-tree.empty.description': "Cr\xe9ez des notes de r\xe9union, des exigences produit, des d\xe9cisions, ou tout autre contenu pour voir cet espace se remplir.",
    'confluence-table-tree.empty.title': "Il n'y a rien ici hormis du potentiel",
    'confluence-table-tree.error.description': "Impossible d'afficher ces pages. Veuillez r\xe9essayer ult\xe9rieurement.",
    'confluence-table-tree.error.row': 'Impossible de charger les pages.',
    'confluence-table-tree.error.title': "Ah, c'est bizarre\u2026",
    'confluence-table-tree.friendly-when-created': "Cr\xe9ation",
    'confluence-table-tree.friendly-when-updated': "Mise \xe0 jour",
    'confluence-table-tree.share.copied': "Copi\xe9 dans le presse-papiers",
    'confluence-table-tree.share.copy-button': 'Copier',
    'confluence-table-tree.share.subtitle': 'Partager ce lien',
    'confluence-table-tree.share.title': 'Partager la page',
    'confluence-table-tree.share.tooltip': 'Partager',
    'confluence-table-tree.view-profile': 'Afficher le profil'
};

});

parcelRegister("lTvRA", function(module, exports) {

$parcel$export(module.exports, "default", () => $c693e4889aee01e1$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //German (Germany)
var $c693e4889aee01e1$export$2e2bcd8739ae039 = {
    'confluence-table-tree.column.contributors': 'Beitragende',
    'confluence-table-tree.column.last-modified': "Letzte \xc4nderung",
    'confluence-table-tree.column.title': 'Name',
    'confluence-table-tree.could-not-load': 'Konnte nicht geladen werden',
    'confluence-table-tree.could-not-load-contributors': 'Beitragende konnten nicht geladen werden',
    'confluence-table-tree.create-child-page': 'Untergeordnete Seite erstellen',
    'confluence-table-tree.create-page': 'Seite erstellen',
    'confluence-table-tree.default.page.title': 'Ohne Namen',
    'confluence-table-tree.default.show-all-pages-button.label': 'Weitere Seiten anzeigen',
    'confluence-table-tree.draft.lozenge': 'ENTWURF',
    'confluence-table-tree.draft.tooltip': "Entw\xfcrfe k\xf6nnen nur von Ihnen gesehen werden.",
    'confluence-table-tree.drafts-toggle.label': "Entw\xfcrfe anzeigen",
    'confluence-table-tree.edit': 'Bearbeiten',
    'confluence-table-tree.edit-in-confluence': 'In Confluence bearbeiten',
    'confluence-table-tree.empty.description': "Erstellen Sie Besprechungsnotizen, Produktanforderungen, Entscheidungen und andere Inhalte, damit dieser Bereich sich f\xfcllt.",
    'confluence-table-tree.empty.title': "Es gibt hier nichts, au\xdfer Potenzial",
    'confluence-table-tree.error.description': "Wir k\xf6nnen diese Seiten nicht anzeigen. Bitte versuchen Sie es sp\xe4ter erneut.",
    'confluence-table-tree.error.row': 'Seiten konnten nicht geladen werden.',
    'confluence-table-tree.error.title': "Das ist seltsam\xa0\u2026",
    'confluence-table-tree.friendly-when-created': 'Erstellt',
    'confluence-table-tree.friendly-when-updated': 'Aktualisiert',
    'confluence-table-tree.share.copied': 'In Zwischenablage kopiert',
    'confluence-table-tree.share.copy-button': 'Kopieren',
    'confluence-table-tree.share.subtitle': 'Link teilen',
    'confluence-table-tree.share.title': 'Seite teilen',
    'confluence-table-tree.share.tooltip': 'Teilen',
    'confluence-table-tree.view-profile': 'Profil anzeigen'
};

});

parcelRegister("aD7AT", function(module, exports) {

$parcel$export(module.exports, "default", () => $147057492b0e106f$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Hungarian
var $147057492b0e106f$export$2e2bcd8739ae039 = {
    'confluence-table-tree.column.contributors': "K\xf6zrem\u0171k\xf6d\u0151k",
    'confluence-table-tree.column.last-modified': "Utols\xf3 m\xf3dos\xedt\xe1s",
    'confluence-table-tree.column.title': "N\xe9v",
    'confluence-table-tree.could-not-load': "Nem siker\xfclt bet\xf6lteni",
    'confluence-table-tree.could-not-load-contributors': "Nem siker\xfclt bet\xf6lteni a k\xf6zrem\u0171k\xf6d\u0151ket",
    'confluence-table-tree.create-child-page': "Al\xe1rendelt oldal l\xe9trehoz\xe1sa",
    'confluence-table-tree.create-page': "Oldal l\xe9trehoz\xe1sa",
    'confluence-table-tree.default.page.title': "N\xe9vtelen",
    'confluence-table-tree.default.show-all-pages-button.label': "T\xf6bb oldal megjelen\xedt\xe9se",
    'confluence-table-tree.draft.lozenge': 'PISZKOZAT',
    'confluence-table-tree.draft.tooltip': "Csak te l\xe1thatod a piszkozatokat",
    'confluence-table-tree.drafts-toggle.label': "Piszkozatok megjelen\xedt\xe9se",
    'confluence-table-tree.edit': "Szerkeszt\xe9s",
    'confluence-table-tree.edit-in-confluence': "Szerkeszt\xe9s Confluence-ben",
    'confluence-table-tree.empty.description': "Hozz l\xe9tre megbesz\xe9l\xe9sfeljegyz\xe9seket, term\xe9kk\xf6vetelm\xe9nyeket, d\xf6nt\xe9seket vagy m\xe1s tartalmakat, amelyekkel megt\xf6ltheted ezt a munkateret.",
    'confluence-table-tree.empty.title': "Ez a hely tele van lehet\u0151s\xe9ggel",
    'confluence-table-tree.error.description': "Ezek az oldalak nem jelen\xedthet\u0151k meg. Pr\xf3b\xe1ld meg \xfajra k\xe9s\u0151bb.",
    'confluence-table-tree.error.row': "Nem lehet bet\xf6lteni az oldalakat.",
    'confluence-table-tree.error.title': "Eln\xe9z\xe9st k\xe9r\xfcnk!",
    'confluence-table-tree.friendly-when-created': "L\xe9trehozva",
    'confluence-table-tree.friendly-when-updated': "Friss\xedtve",
    'confluence-table-tree.share.copied': "V\xe1g\xf3lapra m\xe1solva",
    'confluence-table-tree.share.copy-button': "M\xe1sol\xe1s",
    'confluence-table-tree.share.subtitle': "Link megoszt\xe1sa",
    'confluence-table-tree.share.title': "Oldal megoszt\xe1sa",
    'confluence-table-tree.share.tooltip': "Megoszt\xe1s",
    'confluence-table-tree.view-profile': "Profil megtekint\xe9se"
};

});

parcelRegister("2SHqM", function(module, exports) {

$parcel$export(module.exports, "default", () => $a54d2df15d1d4d02$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Italian (Italy)
var $a54d2df15d1d4d02$export$2e2bcd8739ae039 = {
    'confluence-table-tree.column.contributors': 'Collaboratori',
    'confluence-table-tree.column.last-modified': 'Ultima modifica',
    'confluence-table-tree.column.title': 'Nome',
    'confluence-table-tree.could-not-load': 'Impossibile caricare',
    'confluence-table-tree.could-not-load-contributors': 'Impossibile caricare i collaboratori',
    'confluence-table-tree.create-child-page': 'Crea una pagina subordinata',
    'confluence-table-tree.create-page': 'Crea pagina',
    'confluence-table-tree.default.page.title': 'Senza titolo',
    'confluence-table-tree.default.show-all-pages-button.label': 'Mostra altre pagine',
    'confluence-table-tree.draft.lozenge': 'BOZZA',
    'confluence-table-tree.draft.tooltip': 'Solo tu puoi vedere le bozze.',
    'confluence-table-tree.drafts-toggle.label': 'Mostra bozze',
    'confluence-table-tree.edit': 'Modifica',
    'confluence-table-tree.edit-in-confluence': 'Modifica in Confluence',
    'confluence-table-tree.empty.description': 'Crea note della riunione, requisiti di prodotto, decisioni e altri contenuti per riempire questo spazio.',
    'confluence-table-tree.empty.title': "Non c\u2019\xe8 niente qui, solo possibilit\xe0",
    'confluence-table-tree.error.description': "Al momento non possiamo mostrarti queste pagine. Riprova pi\xf9 tardi.",
    'confluence-table-tree.error.row': 'Impossibile caricare le pagine.',
    'confluence-table-tree.error.title': "\xc8 imbarazzante...",
    'confluence-table-tree.friendly-when-created': 'Creati',
    'confluence-table-tree.friendly-when-updated': 'Aggiornato',
    'confluence-table-tree.share.copied': 'Copiato negli appunti',
    'confluence-table-tree.share.copy-button': 'Copia',
    'confluence-table-tree.share.subtitle': 'Condividi questo link',
    'confluence-table-tree.share.title': 'Condividi pagina',
    'confluence-table-tree.share.tooltip': 'Condividi',
    'confluence-table-tree.view-profile': 'Visualizza profilo'
};

});

parcelRegister("ftnHt", function(module, exports) {

$parcel$export(module.exports, "default", () => $89a75f8de6bf4541$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Japanese
var $89a75f8de6bf4541$export$2e2bcd8739ae039 = {
    'confluence-table-tree.column.contributors': "\u6295\u7A3F\u8005",
    'confluence-table-tree.column.last-modified': "\u6700\u7D42\u66F4\u65B0\u65E5",
    'confluence-table-tree.column.title': "\u540D\u524D",
    'confluence-table-tree.could-not-load': "\u8AAD\u307F\u8FBC\u3081\u307E\u305B\u3093\u3067\u3057\u305F\u3002",
    'confluence-table-tree.could-not-load-contributors': "\u6295\u7A3F\u8005\u3092\u8AAD\u307F\u8FBC\u3081\u307E\u305B\u3093\u3067\u3057\u305F\u3002",
    'confluence-table-tree.create-child-page': "\u5B50\u30DA\u30FC\u30B8\u3092\u4F5C\u6210",
    'confluence-table-tree.create-page': "\u30DA\u30FC\u30B8\u3092\u4F5C\u6210",
    'confluence-table-tree.default.page.title': "\u7121\u984C",
    'confluence-table-tree.default.show-all-pages-button.label': "\u3055\u3089\u306B\u30DA\u30FC\u30B8\u3092\u8868\u793A",
    'confluence-table-tree.draft.lozenge': "\u30C9\u30E9\u30D5\u30C8",
    'confluence-table-tree.draft.tooltip': "\u30C9\u30E9\u30D5\u30C8\u306F\u4ED6\u306E\u30E6\u30FC\u30B6\u30FC\u306B\u306F\u8868\u793A\u3055\u308C\u307E\u305B\u3093\u3002",
    'confluence-table-tree.drafts-toggle.label': "\u4E0B\u66F8\u304D\u3092\u8868\u793A",
    'confluence-table-tree.edit': "\u7DE8\u96C6",
    'confluence-table-tree.edit-in-confluence': "Confluence \u3067\u7DE8\u96C6",
    'confluence-table-tree.empty.description': "\u30DF\u30FC\u30C6\u30A3\u30F3\u30B0\u8B70\u4E8B\u9332\u3001\u88FD\u54C1\u8981\u4EF6\u3001\u6C7A\u5B9A\u4E8B\u9805\u3084\u305D\u306E\u4ED6\u306E\u30B3\u30F3\u30C6\u30F3\u30C4\u3092\u4F5C\u6210\u3057\u3066\u3001\u3053\u306E\u30B9\u30DA\u30FC\u30B9\u3092\u57CB\u3081\u307E\u3057\u3087\u3046\u3002",
    'confluence-table-tree.empty.title': "\u73FE\u5728\u306F\u4F55\u3082\u542B\u307E\u308C\u3066\u3044\u307E\u305B\u3093\u3002",
    'confluence-table-tree.error.description': "\u30DA\u30FC\u30B8\u3092\u8868\u793A\u3067\u304D\u307E\u305B\u3093\u3002\u3057\u3070\u3089\u304F\u3057\u3066\u304B\u3089\u3082\u3046\u4E00\u5EA6\u304A\u8A66\u3057\u304F\u3060\u3055\u3044\u3002",
    'confluence-table-tree.error.row': "\u30DA\u30FC\u30B8\u3092\u8AAD\u307F\u8FBC\u3081\u307E\u305B\u3093\u3002",
    'confluence-table-tree.error.title': "\u6B63\u5E38\u306B\u6A5F\u80FD\u3057\u3066\u3044\u307E\u305B\u3093\u3002",
    'confluence-table-tree.friendly-when-created': "\u4F5C\u6210\u65E5",
    'confluence-table-tree.friendly-when-updated': "\u6700\u7D42\u66F4\u65B0",
    'confluence-table-tree.share.copied': "\u30AF\u30EA\u30C3\u30D7\u30DC\u30FC\u30C9\u306B\u30B3\u30D4\u30FC\u3055\u308C\u307E\u3057\u305F",
    'confluence-table-tree.share.copy-button': "\u30B3\u30D4\u30FC",
    'confluence-table-tree.share.subtitle': "\u3053\u306E\u30EA\u30F3\u30AF\u3092\u5171\u6709",
    'confluence-table-tree.share.title': "\u30DA\u30FC\u30B8\u306E\u5171\u6709",
    'confluence-table-tree.share.tooltip': "\u5171\u6709",
    'confluence-table-tree.view-profile': "\u30D7\u30ED\u30D5\u30A1\u30A4\u30EB\u3092\u8868\u793A"
};

});

parcelRegister("2gYch", function(module, exports) {

$parcel$export(module.exports, "default", () => $3ef7680e358f98ed$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Korean
var $3ef7680e358f98ed$export$2e2bcd8739ae039 = {
    'confluence-table-tree.column.contributors': "\uAE30\uC5EC\uC790",
    'confluence-table-tree.column.last-modified': "\uCD5C\uADFC \uC218\uC815",
    'confluence-table-tree.column.title': "\uC774\uB984",
    'confluence-table-tree.could-not-load': "\uB85C\uB4DC\uD560 \uC218 \uC5C6\uC2B5\uB2C8\uB2E4",
    'confluence-table-tree.could-not-load-contributors': "\uAE30\uC5EC\uC790\uB97C \uB85C\uB4DC\uD560 \uC218 \uC5C6\uC2B5\uB2C8\uB2E4",
    'confluence-table-tree.create-child-page': "\uD558\uC704 \uD398\uC774\uC9C0 \uB9CC\uB4E4\uAE30",
    'confluence-table-tree.create-page': "\uD398\uC774\uC9C0 \uB9CC\uB4E4\uAE30",
    'confluence-table-tree.default.page.title': "\uC81C\uBAA9 \uC5C6\uC74C",
    'confluence-table-tree.default.show-all-pages-button.label': "\uD398\uC774\uC9C0 \uB354 \uBCF4\uAE30",
    'confluence-table-tree.draft.lozenge': "\uCD08\uC548",
    'confluence-table-tree.draft.tooltip': "\uCD08\uC548\uC740 \uC790\uC2E0\uB9CC \uBCFC \uC218 \uC788\uC2B5\uB2C8\uB2E4.",
    'confluence-table-tree.drafts-toggle.label': "\uCD08\uC548 \uBCF4\uAE30",
    'confluence-table-tree.edit': "\uD3B8\uC9D1",
    'confluence-table-tree.edit-in-confluence': "Confluence\uC5D0\uC11C \uD3B8\uC9D1",
    'confluence-table-tree.empty.description': "\uBBF8\uD305 \uBA54\uBAA8, \uC81C\uD488 \uC694\uAD6C \uC0AC\uD56D, \uACB0\uC815 \uC0AC\uD56D \uB610\uB294 \uAE30\uD0C0 \uCF58\uD150\uCE20\uB97C \uB9CC\uB4E4\uC5B4 \uC774 \uC2A4\uD398\uC774\uC2A4\uB97C \uCC44\uC6CC\uBCF4\uC138\uC694.",
    'confluence-table-tree.empty.title': "\uC774\uACF3\uC740 \uBE44\uC5B4 \uC788\uC9C0\uB9CC \uC7A0\uC7AC\uB825\uC73C\uB85C ",
    'confluence-table-tree.error.description': "\uD398\uC774\uC9C0\uB97C \uD45C\uC2DC\uD560 \uC218 \uC5C6\uC2B5\uB2C8\uB2E4. \uB098\uC911\uC5D0 \uB2E4\uC2DC \uC2DC\uB3C4\uD558\uC138\uC694.",
    'confluence-table-tree.error.row': "\uD398\uC774\uC9C0\uB97C \uB85C\uB4DC\uD560 \uC218 \uC5C6\uC2B5\uB2C8\uB2E4.",
    'confluence-table-tree.error.title': "\uC8C4\uC1A1\uD569\uB2C8\uB2E4.",
    'confluence-table-tree.friendly-when-created': "\uB9CC\uB4E6",
    'confluence-table-tree.friendly-when-updated': "\uC5C5\uB370\uC774\uD2B8",
    'confluence-table-tree.share.copied': "\uD074\uB9BD\uBCF4\uB4DC\uC5D0 \uBCF5\uC0AC\uB428",
    'confluence-table-tree.share.copy-button': "\uBCF5\uC0AC",
    'confluence-table-tree.share.subtitle': "\uC774 \uB9C1\uD06C \uACF5\uC720",
    'confluence-table-tree.share.title': "\uD398\uC774\uC9C0 \uACF5\uC720",
    'confluence-table-tree.share.tooltip': "\uACF5\uC720",
    'confluence-table-tree.view-profile': "\uD504\uB85C\uD544 \uBCF4\uAE30"
};

});

parcelRegister("f1dzU", function(module, exports) {

$parcel$export(module.exports, "default", () => $7230d4ab186dd66d$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Norwegian (Bokmål)
var $7230d4ab186dd66d$export$2e2bcd8739ae039 = {
    'confluence-table-tree.column.contributors': 'Bidragsytere',
    'confluence-table-tree.column.last-modified': 'Sist endret',
    'confluence-table-tree.column.title': 'Navn',
    'confluence-table-tree.could-not-load': 'Kan ikke laste inn',
    'confluence-table-tree.could-not-load-contributors': 'Kan ikke laste inn bidragsytere',
    'confluence-table-tree.create-child-page': 'Opprett en underordnet side',
    'confluence-table-tree.create-page': 'Opprett side',
    'confluence-table-tree.default.page.title': 'Uten navn',
    'confluence-table-tree.default.show-all-pages-button.label': 'Vis flere sider',
    'confluence-table-tree.draft.lozenge': 'UTKAST',
    'confluence-table-tree.draft.tooltip': 'Utkast kan kun ses av deg.',
    'confluence-table-tree.drafts-toggle.label': 'Vis utkast',
    'confluence-table-tree.edit': 'Rediger',
    'confluence-table-tree.edit-in-confluence': 'Rediger i Confluence',
    'confluence-table-tree.empty.description': "Opprett m\xf8tenotater, produktkrav, beslutninger eller annet innhold for \xe5 fylle opp dette omr\xe5det.",
    'confluence-table-tree.empty.title': 'Her finnes det ingenting annet enn potensial',
    'confluence-table-tree.error.description': "Vi kan ikke vise deg disse sidene. Pr\xf8v igjen senere.",
    'confluence-table-tree.error.row': 'Kan ikke laste inn sider.',
    'confluence-table-tree.error.title': "Vel, dette er pinlig\xa0\u2026",
    'confluence-table-tree.friendly-when-created': 'Opprettet',
    'confluence-table-tree.friendly-when-updated': 'Oppdatert',
    'confluence-table-tree.share.copied': 'Kopiert til utklippstavlen',
    'confluence-table-tree.share.copy-button': 'Kopier',
    'confluence-table-tree.share.subtitle': 'Del denne koblingen',
    'confluence-table-tree.share.title': 'Del side',
    'confluence-table-tree.share.tooltip': 'Del',
    'confluence-table-tree.view-profile': 'Se profil'
};

});

parcelRegister("8v0O3", function(module, exports) {

$parcel$export(module.exports, "default", () => $adada9ab2f0e4505$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Polish (Poland)
var $adada9ab2f0e4505$export$2e2bcd8739ae039 = {
    'confluence-table-tree.column.contributors': "Wsp\xf3\u0142autorzy",
    'confluence-table-tree.column.last-modified': 'Ostatnia modyfikacja',
    'confluence-table-tree.column.title': 'Nazwa',
    'confluence-table-tree.could-not-load': "Nie mo\u017Cna za\u0142adowa\u0107",
    'confluence-table-tree.could-not-load-contributors': "Nie mo\u017Cna za\u0142adowa\u0107 wsp\xf3\u0142autor\xf3w",
    'confluence-table-tree.create-child-page': "Utw\xf3rz stron\u0119 podrz\u0119dn\u0105",
    'confluence-table-tree.create-page': "Utw\xf3rz stron\u0119",
    'confluence-table-tree.default.page.title': "Bez tytu\u0142u",
    'confluence-table-tree.default.show-all-pages-button.label': "Poka\u017C wi\u0119cej stron",
    'confluence-table-tree.draft.lozenge': 'SZKIC',
    'confluence-table-tree.draft.tooltip': 'Tylko Ty widzisz wersje robocze',
    'confluence-table-tree.drafts-toggle.label': "Poka\u017C wersje robocze",
    'confluence-table-tree.edit': 'Edytuj',
    'confluence-table-tree.edit-in-confluence': 'Edytuj w Confluence',
    'confluence-table-tree.empty.description': "Utw\xf3rz notatki ze spotka\u0144, wymagania produktowe, decyzje lub inne tre\u015Bci, aby wype\u0142ni\u0107 t\u0119 przestrze\u0144.",
    'confluence-table-tree.empty.title': "Nie ma tu nic opr\xf3cz potencja\u0142u",
    'confluence-table-tree.error.description': "Nie mo\u017Cemy wy\u015Bwietli\u0107 tych stron. Spr\xf3buj ponownie p\xf3\u017Aniej.",
    'confluence-table-tree.error.row': "Nie mo\u017Cna za\u0142adowa\u0107 stron.",
    'confluence-table-tree.error.title': "To dziwne\u2026",
    'confluence-table-tree.friendly-when-created': 'Utworzono',
    'confluence-table-tree.friendly-when-updated': 'Zaktualizowano',
    'confluence-table-tree.share.copied': 'Skopiowano do schowka',
    'confluence-table-tree.share.copy-button': 'Kopiuj',
    'confluence-table-tree.share.subtitle': "Udost\u0119pnij to \u0142\u0105cze",
    'confluence-table-tree.share.title': "Udost\u0119pnij stron\u0119",
    'confluence-table-tree.share.tooltip': "Udost\u0119pnij",
    'confluence-table-tree.view-profile': "Wy\u015Bwietl profil"
};

});

parcelRegister("6XsL4", function(module, exports) {

$parcel$export(module.exports, "default", () => $47969850263a1dba$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Portuguese (Brazil)
var $47969850263a1dba$export$2e2bcd8739ae039 = {
    'confluence-table-tree.column.contributors': 'Contribuidores',
    'confluence-table-tree.column.last-modified': "\xdaltima modifica\xe7\xe3o",
    'confluence-table-tree.column.title': 'Nome',
    'confluence-table-tree.could-not-load': "N\xe3o foi poss\xedvel carregar",
    'confluence-table-tree.could-not-load-contributors': "N\xe3o foi poss\xedvel carregar os colaboradores",
    'confluence-table-tree.create-child-page': "Criar uma p\xe1gina filho",
    'confluence-table-tree.create-page': "Criar p\xe1gina",
    'confluence-table-tree.default.page.title': "Sem t\xedtulo",
    'confluence-table-tree.default.show-all-pages-button.label': "Mostrar mais p\xe1ginas",
    'confluence-table-tree.draft.lozenge': 'RASCUNHO',
    'confluence-table-tree.draft.tooltip': "S\xf3 voc\xea pode ver os rascunhos.",
    'confluence-table-tree.drafts-toggle.label': 'Mostrar rascunhos',
    'confluence-table-tree.edit': 'Editar',
    'confluence-table-tree.edit-in-confluence': 'Editar no Confluence',
    'confluence-table-tree.empty.description': "Crie algumas anota\xe7\xf5es de reuni\xe3o, requisitos de produtos, decis\xf5es ou outros assuntos para ver este espa\xe7o ser preenchido.",
    'confluence-table-tree.empty.title': "N\xe3o h\xe1 nada aqui al\xe9m de potencial",
    'confluence-table-tree.error.description': "N\xe3o podemos mostrar estas p\xe1ginas para voc\xea. Tente de novo mais tarde.",
    'confluence-table-tree.error.row': "N\xe3o \xe9 poss\xedvel carregar p\xe1ginas.",
    'confluence-table-tree.error.title': "Poxa, isso est\xe1 estranho...",
    'confluence-table-tree.friendly-when-created': 'Criado',
    'confluence-table-tree.friendly-when-updated': 'Atualizado',
    'confluence-table-tree.share.copied': "Copiado para a \xe1rea de transfer\xeancia",
    'confluence-table-tree.share.copy-button': 'Copiar',
    'confluence-table-tree.share.subtitle': 'Compartilhar este link',
    'confluence-table-tree.share.title': "Compartilhar p\xe1gina",
    'confluence-table-tree.share.tooltip': 'Compartilhar',
    'confluence-table-tree.view-profile': 'Visualizar perfil'
};

});

parcelRegister("1ZzFt", function(module, exports) {

$parcel$export(module.exports, "default", () => $97d04d76cbaabf62$export$2e2bcd8739ae039);
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Portuguese (Portugal)
var $97d04d76cbaabf62$export$2e2bcd8739ae039 = {};

});

parcelRegister("kZeeW", function(module, exports) {

$parcel$export(module.exports, "default", () => $9405f7e2607d45d6$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Russian
var $9405f7e2607d45d6$export$2e2bcd8739ae039 = {
    'confluence-table-tree.column.contributors': "\u0423\u0447\u0430\u0441\u0442\u043D\u0438\u043A\u0438",
    'confluence-table-tree.column.last-modified': "\u041F\u043E\u0441\u043B\u0435\u0434\u043D\u0435\u0435 \u0438\u0437\u043C\u0435\u043D\u0435\u043D\u0438\u0435",
    'confluence-table-tree.column.title': "\u041D\u0430\u0437\u0432\u0430\u043D\u0438\u0435",
    'confluence-table-tree.could-not-load': "\u041E\u0448\u0438\u0431\u043A\u0430 \u043F\u0440\u0438 \u0437\u0430\u0433\u0440\u0443\u0437\u043A\u0435",
    'confluence-table-tree.could-not-load-contributors': "\u041D\u0435 \u0443\u0434\u0430\u043B\u043E\u0441\u044C \u0437\u0430\u0433\u0440\u0443\u0437\u0438\u0442\u044C \u0443\u0447\u0430\u0441\u0442\u043D\u0438\u043A\u043E\u0432",
    'confluence-table-tree.create-child-page': "\u0421\u043E\u0437\u0434\u0430\u0442\u044C \u0434\u043E\u0447\u0435\u0440\u043D\u044E\u044E \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0443",
    'confluence-table-tree.create-page': "\u0421\u043E\u0437\u0434\u0430\u0442\u044C \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0443",
    'confluence-table-tree.default.page.title': "\u0411\u0435\u0437 \u043D\u0430\u0437\u0432\u0430\u043D\u0438\u044F",
    'confluence-table-tree.default.show-all-pages-button.label': "\u041F\u043E\u043A\u0430\u0437\u0430\u0442\u044C \u0431\u043E\u043B\u044C\u0448\u0435 \u0441\u0442\u0440\u0430\u043D\u0438\u0446",
    'confluence-table-tree.draft.lozenge': "\u0427\u0415\u0420\u041D\u041E\u0412\u0418\u041A",
    'confluence-table-tree.draft.tooltip': "\u0427\u0435\u0440\u043D\u043E\u0432\u0438\u043A\u0438 \u043C\u043E\u0436\u0435\u0442\u0435 \u043F\u0440\u043E\u0441\u043C\u0430\u0442\u0440\u0438\u0432\u0430\u0442\u044C \u0442\u043E\u043B\u044C\u043A\u043E \u0432\u044B.",
    'confluence-table-tree.drafts-toggle.label': "\u041F\u043E\u043A\u0430\u0437\u0430\u0442\u044C \u0447\u0435\u0440\u043D\u043E\u0432\u0438\u043A\u0438",
    'confluence-table-tree.edit': "\u0418\u0437\u043C\u0435\u043D\u0438\u0442\u044C",
    'confluence-table-tree.edit-in-confluence': "\u0420\u0435\u0434\u0430\u043A\u0442\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u0432 Confluence",
    'confluence-table-tree.empty.description': "\u0421\u043E\u0437\u0434\u0430\u0432\u0430\u0439\u0442\u0435 \u043F\u0440\u043E\u0442\u043E\u043A\u043E\u043B\u044B \u0441\u043E\u0431\u0440\u0430\u043D\u0438\u0439, \u0442\u0440\u0435\u0431\u043E\u0432\u0430\u043D\u0438\u044F \u043A \u043F\u0440\u043E\u0434\u0443\u043A\u0442\u0443, \u0440\u0435\u0448\u0435\u043D\u0438\u044F \u0438\u043B\u0438 \u0434\u0440\u0443\u0433\u043E\u0439 \u043A\u043E\u043D\u0442\u0435\u043D\u0442, \u0447\u0442\u043E\u0431\u044B \u043D\u0430\u043F\u043E\u043B\u043D\u0438\u0442\u044C \u044D\u0442\u043E\u0442 \u0440\u0430\u0437\u0434\u0435\u043B.",
    'confluence-table-tree.empty.title': "\u0417\u0434\u0435\u0441\u044C \u043D\u0435\u0442 \u043D\u0438\u0447\u0435\u0433\u043E, \u043A\u0440\u043E\u043C\u0435 \u043F\u043E\u0442\u0435\u043D\u0446\u0438\u0430\u043B\u0430",
    'confluence-table-tree.error.description': "\u041D\u0435\u0432\u043E\u0437\u043C\u043E\u0436\u043D\u043E \u043F\u043E\u043A\u0430\u0437\u0430\u0442\u044C \u044D\u0442\u0438 \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u044B. \u041F\u043E\u0432\u0442\u043E\u0440\u0438\u0442\u0435 \u043F\u043E\u043F\u044B\u0442\u043A\u0443 \u043F\u043E\u0437\u0436\u0435.",
    'confluence-table-tree.error.row': "\u041D\u0435 \u0443\u0434\u0430\u043B\u043E\u0441\u044C \u0437\u0430\u0433\u0440\u0443\u0437\u0438\u0442\u044C \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u044B.",
    'confluence-table-tree.error.title': "\u041D\u0430\u043C \u0442\u0430\u043A \u043D\u0435\u043B\u043E\u0432\u043A\u043E...",
    'confluence-table-tree.friendly-when-created': "\u0421\u043E\u0437\u0434\u0430\u043D\u043E",
    'confluence-table-tree.friendly-when-updated': "\u0414\u0430\u0442\u0430 \u043E\u0431\u043D\u043E\u0432\u043B\u0435\u043D\u0438\u044F",
    'confluence-table-tree.share.copied': "\u0421\u043A\u043E\u043F\u0438\u0440\u043E\u0432\u0430\u043D\u043E \u0432 \u0431\u0443\u0444\u0435\u0440 \u043E\u0431\u043C\u0435\u043D\u0430",
    'confluence-table-tree.share.copy-button': "\u0421\u043A\u043E\u043F\u0438\u0440\u043E\u0432\u0430\u0442\u044C",
    'confluence-table-tree.share.subtitle': "\u041F\u043E\u0434\u0435\u043B\u0438\u0442\u044C\u0441\u044F \u044D\u0442\u043E\u0439 \u0441\u0441\u044B\u043B\u043A\u043E\u0439",
    'confluence-table-tree.share.title': "\u041F\u043E\u0434\u0435\u043B\u0438\u0442\u044C\u0441\u044F \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0435\u0439",
    'confluence-table-tree.share.tooltip': "\u041F\u043E\u0434\u0435\u043B\u0438\u0442\u044C\u0441\u044F",
    'confluence-table-tree.view-profile': "\u041F\u043E\u0441\u043C\u043E\u0442\u0440\u0435\u0442\u044C \u043F\u0440\u043E\u0444\u0438\u043B\u044C"
};

});

parcelRegister("5vNuR", function(module, exports) {

$parcel$export(module.exports, "default", () => $7c04760d0749199a$export$2e2bcd8739ae039);
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Slovak
var $7c04760d0749199a$export$2e2bcd8739ae039 = {};

});

parcelRegister("bvrre", function(module, exports) {

$parcel$export(module.exports, "default", () => $d15919a7617f5834$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Spanish (International)
var $d15919a7617f5834$export$2e2bcd8739ae039 = {
    'confluence-table-tree.column.contributors': 'Colaboradores',
    'confluence-table-tree.column.last-modified': "\xdaltima modificaci\xf3n",
    'confluence-table-tree.column.title': 'Nombre',
    'confluence-table-tree.could-not-load': 'No se ha podido cargar',
    'confluence-table-tree.could-not-load-contributors': 'No se han podido cargar los colaboradores',
    'confluence-table-tree.create-child-page': "Crear una p\xe1gina secundaria",
    'confluence-table-tree.create-page': "Crear p\xe1gina",
    'confluence-table-tree.default.page.title': "Sin t\xedtulo",
    'confluence-table-tree.default.show-all-pages-button.label': "Mostrar m\xe1s p\xe1ginas",
    'confluence-table-tree.draft.lozenge': 'BORRADOR',
    'confluence-table-tree.draft.tooltip': "Solo t\xfa puedes ver los borradores.",
    'confluence-table-tree.drafts-toggle.label': 'Mostrar borradores',
    'confluence-table-tree.edit': 'Editar',
    'confluence-table-tree.edit-in-confluence': 'Editar en Confluence',
    'confluence-table-tree.empty.description': 'Crea notas, requisitos de productos, decisiones u otros contenidos para llenar este espacio.',
    'confluence-table-tree.empty.title': "Aqu\xed no hay sino potencial",
    'confluence-table-tree.error.description': "No podemos mostrarte estas p\xe1ginas. Int\xe9ntalo de nuevo m\xe1s tarde.",
    'confluence-table-tree.error.row': "No se pueden cargar p\xe1ginas.",
    'confluence-table-tree.error.title': 'Bueno, esto es un poco embarazoso...',
    'confluence-table-tree.friendly-when-created': "Creaci\xf3n",
    'confluence-table-tree.friendly-when-updated': 'Actualizado',
    'confluence-table-tree.share.copied': 'Copiado en el portapapeles',
    'confluence-table-tree.share.copy-button': 'Copiar',
    'confluence-table-tree.share.subtitle': 'Compartir este enlace',
    'confluence-table-tree.share.title': "Compartir p\xe1gina",
    'confluence-table-tree.share.tooltip': 'Compartir',
    'confluence-table-tree.view-profile': 'Ver perfil'
};

});

parcelRegister("d7Nly", function(module, exports) {

$parcel$export(module.exports, "default", () => $6a1b6519885a85c9$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Swedish
var $6a1b6519885a85c9$export$2e2bcd8739ae039 = {
    'confluence-table-tree.column.contributors': 'Medarbetare',
    'confluence-table-tree.column.last-modified': "Senast \xe4ndrad",
    'confluence-table-tree.column.title': 'Namn',
    'confluence-table-tree.could-not-load': "Det gick inte att l\xe4sa in",
    'confluence-table-tree.could-not-load-contributors': "Det gick inte att l\xe4sa in medarbetare",
    'confluence-table-tree.create-child-page': 'Skapa en underordnad sida',
    'confluence-table-tree.create-page': 'Skapa sida',
    'confluence-table-tree.default.page.title': 'Utan rubrik',
    'confluence-table-tree.default.show-all-pages-button.label': 'Visa fler sidor',
    'confluence-table-tree.draft.lozenge': 'UTKAST',
    'confluence-table-tree.draft.tooltip': 'Endast du kan se utkast.',
    'confluence-table-tree.drafts-toggle.label': 'Visa utkast',
    'confluence-table-tree.edit': 'Redigera',
    'confluence-table-tree.edit-in-confluence': 'Redigera i Confluence',
    'confluence-table-tree.empty.description': "Skapa m\xf6tesanteckningar, produktkrav, beslut eller annat inneh\xe5ll f\xf6r att fylla utrymmet.",
    'confluence-table-tree.empty.title': "H\xe4r finns inget annat \xe4n potential",
    'confluence-table-tree.error.description': "Vi kan inte visa de h\xe4r sidorna. F\xf6rs\xf6k igen senare.",
    'confluence-table-tree.error.row': "Det gick inte att l\xe4sa in sidor.",
    'confluence-table-tree.error.title': 'Det var konstigt ...',
    'confluence-table-tree.friendly-when-created': 'Skapad',
    'confluence-table-tree.friendly-when-updated': 'Uppdaterad',
    'confluence-table-tree.share.copied': 'Kopierad till urklipp',
    'confluence-table-tree.share.copy-button': 'Kopiera',
    'confluence-table-tree.share.subtitle': "Dela denna l\xe4nk",
    'confluence-table-tree.share.title': 'Dela sida',
    'confluence-table-tree.share.tooltip': 'Dela',
    'confluence-table-tree.view-profile': 'Visa profil'
};

});

parcelRegister("hP8pZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $95592bd905e305ab$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Thai (Thailand)
var $95592bd905e305ab$export$2e2bcd8739ae039 = {
    'confluence-table-tree.column.contributors': "\u0E1C\u0E39\u0E49\u0E2A\u0E19\u0E31\u0E1A\u0E2A\u0E19\u0E38\u0E19",
    'confluence-table-tree.column.last-modified': "\u0E41\u0E01\u0E49\u0E44\u0E02\u0E04\u0E23\u0E31\u0E49\u0E07\u0E25\u0E48\u0E32\u0E2A\u0E38\u0E14",
    'confluence-table-tree.column.title': "\u0E0A\u0E37\u0E48\u0E2D",
    'confluence-table-tree.could-not-load': "\u0E44\u0E21\u0E48\u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E42\u0E2B\u0E25\u0E14\u0E44\u0E14\u0E49",
    'confluence-table-tree.could-not-load-contributors': "\u0E44\u0E21\u0E48\u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E42\u0E2B\u0E25\u0E14\u0E1C\u0E39\u0E49\u0E2A\u0E19\u0E31\u0E1A\u0E2A\u0E19\u0E38\u0E19\u0E44\u0E14\u0E49",
    'confluence-table-tree.create-child-page': "\u0E08\u0E31\u0E14\u0E17\u0E33\u0E2B\u0E19\u0E49\u0E32\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E23\u0E2D\u0E07",
    'confluence-table-tree.create-page': "\u0E2A\u0E23\u0E49\u0E32\u0E07\u0E2B\u0E19\u0E49\u0E32\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25",
    'confluence-table-tree.default.page.title': "\u0E44\u0E21\u0E48\u0E21\u0E35\u0E0A\u0E37\u0E48\u0E2D",
    'confluence-table-tree.default.show-all-pages-button.label': "\u0E41\u0E2A\u0E14\u0E07\u0E2B\u0E19\u0E49\u0E32\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E40\u0E15\u0E34\u0E21",
    'confluence-table-tree.draft.lozenge': "\u0E41\u0E1A\u0E1A\u0E23\u0E48\u0E32\u0E07",
    'confluence-table-tree.draft.tooltip': "\u0E04\u0E38\u0E13\u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E14\u0E39\u0E41\u0E1A\u0E1A\u0E23\u0E48\u0E32\u0E07\u0E44\u0E14\u0E49\u0E40\u0E1E\u0E35\u0E22\u0E07\u0E04\u0E19\u0E40\u0E14\u0E35\u0E22\u0E27",
    'confluence-table-tree.drafts-toggle.label': "\u0E41\u0E2A\u0E14\u0E07\u0E41\u0E1A\u0E1A\u0E23\u0E48\u0E32\u0E07",
    'confluence-table-tree.edit': "\u0E41\u0E01\u0E49\u0E44\u0E02",
    'confluence-table-tree.edit-in-confluence': "\u0E41\u0E01\u0E49\u0E44\u0E02\u0E43\u0E19 Confluence",
    'confluence-table-tree.empty.description': "\u0E2A\u0E23\u0E49\u0E32\u0E07\u0E1A\u0E31\u0E19\u0E17\u0E36\u0E01\u0E01\u0E32\u0E23\u0E1B\u0E23\u0E30\u0E0A\u0E38\u0E21 \u0E04\u0E27\u0E32\u0E21\u0E15\u0E49\u0E2D\u0E07\u0E01\u0E32\u0E23\u0E14\u0E49\u0E32\u0E19\u0E1C\u0E25\u0E34\u0E15\u0E20\u0E31\u0E13\u0E11\u0E4C \u0E01\u0E32\u0E23\u0E15\u0E31\u0E14\u0E2A\u0E34\u0E19\u0E43\u0E08 \u0E2B\u0E23\u0E37\u0E2D\u0E40\u0E19\u0E37\u0E49\u0E2D\u0E2B\u0E32\u0E2D\u0E37\u0E48\u0E19 \u0E46 \u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E14\u0E39\u0E01\u0E32\u0E23\u0E40\u0E15\u0E34\u0E21\u0E40\u0E15\u0E47\u0E21\u0E40\u0E19\u0E37\u0E49\u0E2D\u0E2B\u0E32\u0E43\u0E19\u0E1E\u0E37\u0E49\u0E19\u0E17\u0E35\u0E48\u0E19\u0E35\u0E49",
    'confluence-table-tree.empty.title': "\u0E17\u0E38\u0E01\u0E2A\u0E34\u0E48\u0E07\u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E40\u0E1B\u0E47\u0E19\u0E44\u0E1B\u0E44\u0E14\u0E49\u0E17\u0E35\u0E48\u0E19\u0E35\u0E48",
    'confluence-table-tree.error.description': "\u0E40\u0E23\u0E32\u0E44\u0E21\u0E48\u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E41\u0E2A\u0E14\u0E07\u0E2B\u0E19\u0E49\u0E32\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E40\u0E2B\u0E25\u0E48\u0E32\u0E19\u0E35\u0E49\u0E43\u0E2B\u0E49\u0E04\u0E38\u0E13\u0E44\u0E14\u0E49 \u0E42\u0E1B\u0E23\u0E14\u0E25\u0E2D\u0E07\u0E2D\u0E35\u0E01\u0E04\u0E23\u0E31\u0E49\u0E07\u0E43\u0E19\u0E20\u0E32\u0E22\u0E2B\u0E25\u0E31\u0E07",
    'confluence-table-tree.error.row': "\u0E44\u0E21\u0E48\u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E42\u0E2B\u0E25\u0E14\u0E2B\u0E19\u0E49\u0E32\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E44\u0E14\u0E49",
    'confluence-table-tree.error.title': "\u0E41\u0E22\u0E48\u0E08\u0E31\u0E07",
    'confluence-table-tree.friendly-when-created': "\u0E2A\u0E23\u0E49\u0E32\u0E07\u0E41\u0E25\u0E49\u0E27",
    'confluence-table-tree.friendly-when-updated': "\u0E2D\u0E31\u0E1B\u0E40\u0E14\u0E15\u0E41\u0E25\u0E49\u0E27",
    'confluence-table-tree.share.copied': "\u0E04\u0E31\u0E14\u0E25\u0E2D\u0E01\u0E25\u0E07\u0E04\u0E25\u0E34\u0E1B\u0E1A\u0E2D\u0E23\u0E4C\u0E14\u0E41\u0E25\u0E49\u0E27",
    'confluence-table-tree.share.copy-button': "\u0E04\u0E31\u0E14\u0E25\u0E2D\u0E01",
    'confluence-table-tree.share.subtitle': "\u0E41\u0E0A\u0E23\u0E4C\u0E25\u0E34\u0E07\u0E01\u0E4C\u0E19\u0E35\u0E49",
    'confluence-table-tree.share.title': "\u0E41\u0E0A\u0E23\u0E4C\u0E2B\u0E19\u0E49\u0E32\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25",
    'confluence-table-tree.share.tooltip': "\u0E41\u0E0A\u0E23\u0E4C",
    'confluence-table-tree.view-profile': "\u0E14\u0E39\u0E42\u0E1B\u0E23\u0E44\u0E1F\u0E25\u0E4C"
};

});

parcelRegister("ijF2a", function(module, exports) {

$parcel$export(module.exports, "default", () => $8847b66924a1f7f6$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Turkish (Turkey)
var $8847b66924a1f7f6$export$2e2bcd8739ae039 = {
    'confluence-table-tree.column.contributors': "Katk\u0131da bulunanlar",
    'confluence-table-tree.column.last-modified': "Son de\u011Fi\u015Fiklik",
    'confluence-table-tree.column.title': "Ad\u0131",
    'confluence-table-tree.could-not-load': "Y\xfcklenemedi",
    'confluence-table-tree.could-not-load-contributors': "Katk\u0131da bulunanlar y\xfcklenemedi",
    'confluence-table-tree.create-child-page': "Alt sayfa olu\u015Ftur",
    'confluence-table-tree.create-page': "Sayfa olu\u015Ftur",
    'confluence-table-tree.default.page.title': "Ba\u015Fl\u0131ks\u0131z",
    'confluence-table-tree.default.show-all-pages-button.label': "Daha fazla sayfa g\xf6ster",
    'confluence-table-tree.draft.lozenge': 'TASLAK',
    'confluence-table-tree.draft.tooltip': "Taslaklar yaln\u0131zca sizin taraf\u0131n\u0131zdan g\xf6r\xfclebilir.",
    'confluence-table-tree.drafts-toggle.label': "Taslaklar\u0131 g\xf6ster",
    'confluence-table-tree.edit': "D\xfczenle",
    'confluence-table-tree.edit-in-confluence': "Confluence'ta d\xfczenleyin",
    'confluence-table-tree.empty.description': "Bu alan\u0131 doldurmak i\xe7in toplant\u0131 notlar\u0131, \xfcr\xfcn gereklilikleri, kararlar veya ba\u015Fka i\xe7erikler olu\u015Fturun.",
    'confluence-table-tree.empty.title': "Bu sayfada hen\xfcz i\xe7erik yok",
    'confluence-table-tree.error.description': "Size bu sayfalar\u0131 g\xf6steremiyoruz. L\xfctfen daha sonra yeniden deneyin.",
    'confluence-table-tree.error.row': "Sayfalar y\xfcklenemedi.",
    'confluence-table-tree.error.title': 'Bir sorun var...',
    'confluence-table-tree.friendly-when-created': "Olu\u015Fturulma",
    'confluence-table-tree.friendly-when-updated': "G\xfcncellenme",
    'confluence-table-tree.share.copied': "Panoya kopyaland\u0131",
    'confluence-table-tree.share.copy-button': 'Kopyala',
    'confluence-table-tree.share.subtitle': "Bu ba\u011Flant\u0131y\u0131 payla\u015F\u0131n",
    'confluence-table-tree.share.title': "Sayfay\u0131 payla\u015F\u0131n",
    'confluence-table-tree.share.tooltip': "Payla\u015F",
    'confluence-table-tree.view-profile': "Profili g\xf6r\xfcnt\xfcle"
};

});

parcelRegister("auuVI", function(module, exports) {

$parcel$export(module.exports, "default", () => $1e1af66b1915cf11$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Ukrainian (Ukraine)
var $1e1af66b1915cf11$export$2e2bcd8739ae039 = {
    'confluence-table-tree.column.contributors': "\u0423\u0447\u0430\u0441\u043D\u0438\u043A\u0438",
    'confluence-table-tree.column.last-modified': "\u041E\u0441\u0442\u0430\u043D\u043D\u044F \u0437\u043C\u0456\u043D\u0430",
    'confluence-table-tree.column.title': "\u0406\u043C\u2019\u044F",
    'confluence-table-tree.could-not-load': "\u041D\u0435 \u0432\u0434\u0430\u043B\u043E\u0441\u044F \u0437\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0438\u0442\u0438",
    'confluence-table-tree.could-not-load-contributors': "\u041D\u0435 \u0432\u0434\u0430\u043B\u043E\u0441\u044F \u0437\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0438\u0442\u0438 \u0430\u0432\u0442\u043E\u0440\u0456\u0432",
    'confluence-table-tree.create-child-page': "\u0421\u0442\u0432\u043E\u0440\u0438\u0442\u0438 \u0434\u043E\u0447\u0456\u0440\u043D\u044E \u0441\u0442\u043E\u0440\u0456\u043D\u043A\u0443",
    'confluence-table-tree.create-page': "\u0421\u0442\u0432\u043E\u0440\u0438\u0442\u0438 \u0441\u0442\u043E\u0440\u0456\u043D\u043A\u0443",
    'confluence-table-tree.default.page.title': "\u0411\u0435\u0437 \u043D\u0430\u0437\u0432\u0438",
    'confluence-table-tree.default.show-all-pages-button.label': "\u041F\u043E\u043A\u0430\u0437\u0430\u0442\u0438 \u0431\u0456\u043B\u044C\u0448\u0435 \u0441\u0442\u043E\u0440\u0456\u043D\u043E\u043A",
    'confluence-table-tree.draft.lozenge': "\u0427\u0415\u0420\u041D\u0415\u0422\u041A\u0410",
    'confluence-table-tree.draft.tooltip': "\u0427\u0435\u0440\u043D\u0435\u0442\u043A\u0438 \u043C\u043E\u0436\u0435\u0442\u0435 \u0431\u0430\u0447\u0438\u0442\u0438 \u0442\u0456\u043B\u044C\u043A\u0438 \u0432\u0438.",
    'confluence-table-tree.drafts-toggle.label': "\u041F\u043E\u043A\u0430\u0437\u0430\u0442\u0438 \u0447\u0435\u0440\u043D\u0435\u0442\u043A\u0438",
    'confluence-table-tree.edit': "\u0420\u0435\u0434\u0430\u0433\u0443\u0432\u0430\u0442\u0438",
    'confluence-table-tree.edit-in-confluence': "\u0420\u0435\u0434\u0430\u0433\u0443\u0432\u0430\u0442\u0438 \u0432 Confluence",
    'confluence-table-tree.empty.description': "\u0429\u043E\u0431 \u0437\u0430\u043F\u043E\u0432\u043D\u0438\u0442\u0438 \u0446\u0435\u0439 \u0440\u043E\u0437\u0434\u0456\u043B, \u0434\u043E\u0434\u0430\u0439\u0442\u0435 \u0432 \u043D\u044C\u043E\u0433\u043E \u043F\u0440\u0438\u043C\u0456\u0442\u043A\u0438 \u0434\u043E \u043D\u0430\u0440\u0430\u0434\u0438, \u0432\u0438\u043C\u043E\u0433\u0438 \u0434\u043E \u043F\u0440\u043E\u0434\u0443\u043A\u0442\u0443, \u0440\u0456\u0448\u0435\u043D\u043D\u044F \u0447\u0438 \u0456\u043D\u0448\u0438\u0439 \u0432\u043C\u0456\u0441\u0442.",
    'confluence-table-tree.empty.title': "\u0422\u0443\u0442 \u0431\u0430\u0433\u0430\u0442\u043E \u043C\u043E\u0436\u043B\u0438\u0432\u043E\u0441\u0442\u0435\u0439",
    'confluence-table-tree.error.description': "\u041D\u0435 \u043C\u043E\u0436\u043D\u0430 \u0432\u0456\u0434\u043E\u0431\u0440\u0430\u0437\u0438\u0442\u0438 \u0446\u0456 \u0441\u0442\u043E\u0440\u0456\u043D\u043A\u0438. \u041F\u043E\u0432\u0442\u043E\u0440\u0456\u0442\u044C \u0441\u043F\u0440\u043E\u0431\u0443 \u043F\u0456\u0437\u043D\u0456\u0448\u0435.",
    'confluence-table-tree.error.row': "\u041D\u0435 \u0432\u0434\u0430\u043B\u043E\u0441\u044F \u0437\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0438\u0442\u0438 \u0441\u0442\u043E\u0440\u0456\u043D\u043A\u0438.",
    'confluence-table-tree.error.title': "\u0429\u043E\u0441\u044C \u043F\u0456\u0448\u043B\u043E \u043D\u0435 \u0437\u0430 \u043F\u043B\u0430\u043D\u043E\u043C...",
    'confluence-table-tree.friendly-when-created': "\u0421\u0442\u0432\u043E\u0440\u0435\u043D\u043E",
    'confluence-table-tree.friendly-when-updated': "\u0417\u043C\u0456\u043D\u0435\u043D\u043E",
    'confluence-table-tree.share.copied': "\u0421\u043A\u043E\u043F\u0456\u0439\u043E\u0432\u0430\u043D\u043E \u0432 \u0431\u0443\u0444\u0435\u0440 \u043E\u0431\u043C\u0456\u043D\u0443",
    'confluence-table-tree.share.copy-button': "\u041A\u043E\u043F\u0456\u044E\u0432\u0430\u0442\u0438",
    'confluence-table-tree.share.subtitle': "\u041F\u043E\u0434\u0456\u043B\u0438\u0442\u0438\u0441\u044F \u0446\u0438\u043C \u043F\u043E\u0441\u0438\u043B\u0430\u043D\u043D\u044F\u043C",
    'confluence-table-tree.share.title': "\u041F\u043E\u0434\u0456\u043B\u0438\u0442\u0438\u0441\u044F \u0441\u0442\u043E\u0440\u0456\u043D\u043A\u043E\u044E",
    'confluence-table-tree.share.tooltip': "\u041F\u043E\u0434\u0456\u043B\u0438\u0442\u0438\u0441\u044F",
    'confluence-table-tree.view-profile': "\u041F\u0435\u0440\u0435\u0433\u043B\u044F\u043D\u0443\u0442\u0438 \u043F\u0440\u043E\u0444\u0456\u043B\u044C"
};

});

parcelRegister("fPDtS", function(module, exports) {

$parcel$export(module.exports, "default", () => $4912604be7e1268d$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Vietnamese (Vietnam)
var $4912604be7e1268d$export$2e2bcd8739ae039 = {
    'confluence-table-tree.column.contributors': "Ng\u01B0\u1EDDi \u0111\xf3ng g\xf3p",
    'confluence-table-tree.column.last-modified': "S\u1EEDa \u0111\u1ED5i g\u1EA7n \u0111\xe2y nh\u1EA5t",
    'confluence-table-tree.column.title': "T\xean",
    'confluence-table-tree.could-not-load': "Kh\xf4ng t\u1EA3i \u0111\u01B0\u1EE3c",
    'confluence-table-tree.could-not-load-contributors': "Kh\xf4ng t\u1EA3i \u0111\u01B0\u1EE3c th\xf4ng tin v\u1EC1 nh\u1EEFng ng\u01B0\u1EDDi \u0111\xf3ng g\xf3p",
    'confluence-table-tree.create-child-page': "T\u1EA1o trang con",
    'confluence-table-tree.create-page': "T\u1EA1o trang",
    'confluence-table-tree.default.page.title': "Ch\u01B0a c\xf3 ti\xeau \u0111\u1EC1",
    'confluence-table-tree.default.show-all-pages-button.label': "Hi\u1EC3n th\u1ECB nhi\u1EC1u trang h\u01A1n",
    'confluence-table-tree.draft.lozenge': "B\u1EA2N NH\xc1P",
    'confluence-table-tree.draft.tooltip': "Ch\u1EC9 b\u1EA1n m\u1EDBi c\xf3 th\u1EC3 th\u1EA5y b\u1EA3n nh\xe1p.",
    'confluence-table-tree.drafts-toggle.label': "Hi\u1EC3n th\u1ECB b\u1EA3n nh\xe1p",
    'confluence-table-tree.edit': "Ch\u1EC9nh s\u1EEDa",
    'confluence-table-tree.edit-in-confluence': "S\u1EEDa trong Confluence",
    'confluence-table-tree.empty.description': "T\u1EA1o v\xe0i ghi ch\xfa cu\u1ED9c h\u1ECDp, y\xeau c\u1EA7u s\u1EA3n ph\u1EA9m, quy\u1EBFt \u0111\u1ECBnh ho\u1EB7c n\u1ED9i dung kh\xe1c \u0111\u1EC3 th\u1EA5y v\xf9ng n\xe0y l\u1EA5p \u0111\u1EA7y.",
    'confluence-table-tree.empty.title': "Kh\xf4ng c\xf3 g\xec \u1EDF \u0111\xe2y ngo\xe0i ti\u1EC1m n\u0103ng",
    'confluence-table-tree.error.description': "Ch\xfang t\xf4i kh\xf4ng th\u1EC3 hi\u1EC3n th\u1ECB cho b\u1EA1n nh\u1EEFng trang n\xe0y. Vui l\xf2ng th\u1EED l\u1EA1i sau.",
    'confluence-table-tree.error.row': "Kh\xf4ng th\u1EC3 t\u1EA3i trang.",
    'confluence-table-tree.error.title': "Ch\xe0, th\u1EADt l\xe0 l\u1EA1...",
    'confluence-table-tree.friendly-when-created': "\u0110\xe3 t\u1EA1o",
    'confluence-table-tree.friendly-when-updated': "\u0110\xe3 c\u1EADp nh\u1EADt",
    'confluence-table-tree.share.copied': "\u0110\xe3 sao ch\xe9p v\xe0o b\u1EA3ng nh\u1EDB t\u1EA1m",
    'confluence-table-tree.share.copy-button': "Sao ch\xe9p",
    'confluence-table-tree.share.subtitle': "Chia s\u1EBB li\xean k\u1EBFt n\xe0y",
    'confluence-table-tree.share.title': "Chia s\u1EBB trang",
    'confluence-table-tree.share.tooltip': "Chia s\u1EBB",
    'confluence-table-tree.view-profile': "Xem h\u1ED3 s\u01A1"
};

});

parcelRegister("6sJcA", function(module, exports) {

$parcel$export(module.exports, "default", () => $12cbbd35cc113333$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //
var $12cbbd35cc113333$export$2e2bcd8739ae039 = {
    'confluence-table-tree.column.contributors': 'Contributors',
    'confluence-table-tree.column.last-modified': 'Last modified',
    'confluence-table-tree.column.title': 'Name',
    'confluence-table-tree.could-not-load': "Couldn't load",
    'confluence-table-tree.could-not-load-contributors': "Couldn't load contributors",
    'confluence-table-tree.create-child-page': 'Create a child page',
    'confluence-table-tree.create-page': 'Create page',
    'confluence-table-tree.default.page.title': 'Untitled',
    'confluence-table-tree.default.show-all-pages-button.label': 'Show more pages',
    'confluence-table-tree.draft.lozenge': 'DRAFT',
    'confluence-table-tree.draft.tooltip': 'Drafts can only be seen by you.',
    'confluence-table-tree.drafts-toggle.label': 'Show drafts',
    'confluence-table-tree.edit': 'Edit',
    'confluence-table-tree.edit-in-confluence': 'Edit in Confluence',
    'confluence-table-tree.empty.description': 'Create some meeting notes, product requirements, decisions, or other content to see this space fill up.',
    'confluence-table-tree.empty.title': "There's nothing here but potential",
    'confluence-table-tree.error.description': "We can't show you these pages. Please try again later.",
    'confluence-table-tree.error.row': 'Unable to load pages.',
    'confluence-table-tree.error.title': 'Well, this is awkward...',
    'confluence-table-tree.friendly-when-created': 'Created',
    'confluence-table-tree.friendly-when-updated': 'Updated',
    'confluence-table-tree.share.copied': 'Copied to clipboard',
    'confluence-table-tree.share.copy-button': 'Copy',
    'confluence-table-tree.share.subtitle': 'Share this link',
    'confluence-table-tree.share.title': 'Share page',
    'confluence-table-tree.share.tooltip': 'Share',
    'confluence-table-tree.view-profile': 'View profile'
};

});

parcelRegister("EP5Dd", function(module, exports) {

$parcel$export(module.exports, "default", () => $327ffe19fc2e8ce8$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //English (United Kingdom)
var $327ffe19fc2e8ce8$export$2e2bcd8739ae039 = {
    'confluence-table-tree.column.contributors': 'Contributors',
    'confluence-table-tree.column.last-modified': 'Last modified',
    'confluence-table-tree.column.title': 'Name',
    'confluence-table-tree.could-not-load': "Couldn't load",
    'confluence-table-tree.could-not-load-contributors': "Couldn't load contributors",
    'confluence-table-tree.create-child-page': 'Create a child page',
    'confluence-table-tree.create-page': 'Create page',
    'confluence-table-tree.default.page.title': 'Untitled',
    'confluence-table-tree.default.show-all-pages-button.label': 'Show more pages',
    'confluence-table-tree.draft.lozenge': 'DRAFT',
    'confluence-table-tree.draft.tooltip': 'Drafts can only be seen by you.',
    'confluence-table-tree.drafts-toggle.label': 'Show drafts',
    'confluence-table-tree.edit': 'Edit',
    'confluence-table-tree.edit-in-confluence': 'Edit in Confluence',
    'confluence-table-tree.empty.description': 'Create some meeting notes, product requirements, decisions, or other content to see this space fill up.',
    'confluence-table-tree.empty.title': "There's nothing here but potential",
    'confluence-table-tree.error.description': "We can't show you these pages. Please try again later.",
    'confluence-table-tree.error.row': 'Unable to load pages.',
    'confluence-table-tree.error.title': 'Well, this is awkward...',
    'confluence-table-tree.friendly-when-created': 'Created',
    'confluence-table-tree.friendly-when-updated': 'Updated',
    'confluence-table-tree.share.copied': 'Copied to clipboard',
    'confluence-table-tree.share.copy-button': 'Copy',
    'confluence-table-tree.share.subtitle': 'Share this link',
    'confluence-table-tree.share.title': 'Share page',
    'confluence-table-tree.share.tooltip': 'Share',
    'confluence-table-tree.view-profile': 'View profile'
};

});

parcelRegister("7Z2D7", function(module, exports) {

$parcel$export(module.exports, "default", () => $7822b694471207e1$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //
var $7822b694471207e1$export$2e2bcd8739ae039 = {
    'confluence-table-tree.column.contributors': "\u2063\u2062Contributors\u2060\x8d\x8d\x81\x9d\u206B\u206F\u061C\u2061\u2060\u200D\u200C\u206F\u200C\u206A\x9d\u2061\x9d\u200D\u206B\x81\u200D\x9d\u2060\u206D\u206A\u206C\u2061\u061C\u200D\u206C\x81\u2063\u2064",
    'confluence-table-tree.column.last-modified': "\u2063\u2062Last modified\u200D\u206F\u2060\x9d\u206F\u206A\u206D\u206A\u200C\u200D\u206C\u206B\u200C\u2060\u206D\u2061\u206A\u206E\u2061\u206A\u206A\u206A\u206B\u206C\x9d\u206E\u200D\u206A\u200D\u206B\x9d\x81\u2063\u2064",
    'confluence-table-tree.column.title': "\u2063\u2062Name\u206C\x8f\u206F\x8d\u2060\u2060\u206F\u200C\u2061\u206F\u206C\u200C\u2061\u206D\u2060\u206A\u200D\u206E\x8f\u206E\u200C\u206C\u206D\u2060\u2060\x9d\u206D\u206F\u206E\x9d\u2061\u206F\u2063\u2064",
    'confluence-table-tree.could-not-load': "\u2063\u2062Couldn't load\u200D\u206F\u206E\u206D\u206B\u200C\u200C\u2061\u061C\x81\x8f\u206F\u206F\u206F\u2061\u206E\u206C\x8f\u206C\u2060\u206D\u2060\x90\u2061\u206F\u206B\u206A\u200C\u200C\x90\u2060\u200C\u2063\u2064",
    'confluence-table-tree.could-not-load-contributors': "\u2063\u2062Couldn't load contributors\u206E\u2060\x9d\u2061\x9d\u206D\u206C\x8f\u2060\u2061\x9d\u206F\x81\u206C\x8d\x8f\x9d\u206F\x90\x8d\u206B\x8f\u2060\x9d\u206A\u2060\x8d\u200D\x81\x9d\x9d\u206B\u2063\u2064",
    'confluence-table-tree.create-child-page': "\u2063\u2062Create a child page\u2061\u206D\x8f\x81\u061C\x81\u206C\u206B\u061C\u206F\u061C\u206D\u206C\u206F\u206E\x90\x8f\u206D\u061C\x8d\x8d\x9d\u2061\x90\u206F\x81\u206F\u200C\u200C\u200D\u206B\x9d\u2063\u2064",
    'confluence-table-tree.create-page': "\u2063\u2062Create page\u206C\x81\u061C\u206A\u2060\u206F\u206E\u200D\u2060\u2060\u200C\u2061\x90\x8f\x81\u2060\u206C\u061C\u206B\x90\u061C\u200C\u200C\u200D\x81\u200C\u2060\u206B\u200C\u206E\u200D\x81\u2063\u2064",
    'confluence-table-tree.default.page.title': "\u2063\u2062Untitled\u206B\x90\x9d\x8f\u206B\u206F\u061C\u206C\x8f\x90\u061C\x81\u061C\x9d\x81\u206C\u206D\u061C\u206B\u2060\x90\x81\u200C\u206F\u206F\u206E\u206D\u206D\u2061\u206F\x9d\x81\u2063\u2064",
    'confluence-table-tree.default.show-all-pages-button.label': "\u2063\u2062Show more pages\u206C\u206A\u206C\u200D\x8d\u206F\u206E\u206F\u206F\x8f\u2060\u206D\x90\x8d\u206A\x90\u206F\u206D\u206D\x8d\u200C\u200D\u200C\u200D\x81\u206A\u061C\x8d\u2061\x90\u206E\x8d\u2063\u2064",
    'confluence-table-tree.draft.lozenge': "\u2063\u2062DRAFT\u206E\x81\u2061\u206A\x90\x81\u2060\x8d\x8d\u2060\x8d\u206F\x8f\x81\x81\u061C\x81\x8d\u200D\u200C\u2060\u206F\u2060\x90\u200D\x81\u206C\u206E\u206B\u2061\u200C\u2061\u2063\u2064",
    'confluence-table-tree.draft.tooltip': "\u2063\u2062Drafts can only be seen by you.\u206F\u2061\x9d\u206D\u206A\u200D\u061C\x9d\x9d\u206E\u206B\x8f\u200D\x90\x8f\x90\u206E\x81\x8f\u206A\u206A\u2060\u206F\x90\u206E\u200C\u206B\u2061\u206F\u200C\u206F\x81\u2063\u2064",
    'confluence-table-tree.drafts-toggle.label': "\u2063\u2062Show drafts\u206F\x9d\x8d\u200C\u061C\x9d\x9d\u2060\x90\u2061\u200D\x90\u206C\x90\u206F\x8f\u206A\u206D\u206E\x81\u206C\u2061\x90\u206C\u206D\u061C\u200D\u061C\x8f\x81\u206F\x9d\u2063\u2064",
    'confluence-table-tree.edit': "\u2063\u2062Edit\u2061\u2061\x9d\u206D\x8f\x8d\x9d\u206C\u206F\u206C\u206E\u200C\x8f\u206C\u206F\u206B\u206A\u206F\u061C\x90\x81\u206E\u206E\x8f\u200C\u206F\u206C\x8d\u200D\x90\u200C\x8d\u2063\u2064",
    'confluence-table-tree.edit-in-confluence': "\u2063\u2062Edit in Confluence\u206F\u2061\u206B\u206B\u206D\u2060\u2061\x8d\x90\u200D\x8f\u206B\x8d\u200C\u206D\x9d\u2061\u200D\u206B\u206C\u206A\x90\u206A\x8f\u206B\u206D\u206E\u206F\u200D\x9d\u206D\u061C\u2063\u2064",
    'confluence-table-tree.empty.description': "\u2063\u2062Create some meeting notes, product requirements, decisions, or other content to see this space fill up.\u206D\u200C\u206C\x90\x8d\u206F\u206B\u200D\x90\u206F\u206C\x8d\x90\u2060\x9d\x8d\x9d\u2061\u206B\x90\u200D\u206B\u2061\x8f\x9d\x81\u206A\x8f\u2060\u206B\u206E\u206B\u2063\u2064",
    'confluence-table-tree.empty.title': "\u2063\u2062There's nothing here but potential\u206C\u206D\u206C\u2061\x8f\u200C\x8f\u206C\x90\u206D\x9d\x8f\x9d\u2060\u206F\u200C\u206C\u200D\u061C\x81\x90\u200C\u206A\x8f\x8d\u2061\u061C\u2060\u206B\u206A\u061C\u200C\u2063\u2064",
    'confluence-table-tree.error.description': "\u2063\u2062We can't show you these pages. Please try again later.\u2060\x90\u200C\u2060\u2061\u206C\u206E\x8d\x81\x8d\x8f\u206D\x8d\x8d\x8f\u206F\x8f\u206F\u200D\u206E\x8f\u206B\x81\u206C\u206F\u206C\x90\x8f\u200D\u206E\x9d\x81\u2063\u2064",
    'confluence-table-tree.error.row': "\u2063\u2062Unable to load pages.\x8f\u206E\u206C\u2060\x8d\u061C\x9d\u200D\u206D\u2060\x90\u2060\u206D\u206A\u206D\x81\u206A\u206F\u2060\x9d\u206D\u206F\u200C\u206B\u206A\u206A\u206E\x8f\u200C\u200D\x90\u206B\u2063\u2064",
    'confluence-table-tree.error.title': "\u2063\u2062Well, this is awkward...\u200D\x8d\x8d\u061C\u206C\u206C\x8d\u2060\x8d\u061C\u200C\x81\u206D\u206D\u206A\x81\u2061\u200D\u206D\x81\x9d\u2061\u206B\u2060\u206B\u206B\u2061\u200D\u2061\u2060\u206A\u206A\u2063\u2064",
    'confluence-table-tree.friendly-when-created': "\u2063\u2062Created\x90\x90\u061C\x8d\u206F\u206D\x8f\x81\u2061\u206E\u206A\u2061\x8f\u206C\u206C\u200C\x9d\u206E\u206F\x9d\u206D\u2060\x81\x8f\x8f\u2061\u206C\u206F\x8f\u200D\u200C\u2061\u2063\u2064",
    'confluence-table-tree.friendly-when-updated': "\u2063\u2062Updated\u206A\u206C\x8d\u2060\x9d\u206B\u200D\u206E\u2060\x8d\u206A\x8d\u061C\u2060\u2060\u206B\u061C\u200C\u206C\u2061\u206A\u200D\u206F\u200D\x81\u061C\u206C\u061C\u200C\x90\u206D\u206B\u2063\u2064",
    'confluence-table-tree.share.copied': "\u2063\u2062Copied to clipboard\u2061\u206B\u200D\x8d\u200C\u206E\x9d\u200D\x8f\u206D\u200D\u206C\u206F\u061C\u061C\u2060\u206D\u206F\x9d\u2061\u200C\x81\u206C\x8d\u061C\u206D\u061C\u206A\x8f\u200C\x90\u206C\u2063\u2064",
    'confluence-table-tree.share.copy-button': "\u2063\u2062Copy\x8f\x90\x8f\u206D\u206A\u206C\x9d\u2061\u200C\u206A\x90\u061C\x81\u206A\x90\u206A\u206E\u206E\u206E\u200D\x8d\u206C\u2060\u206E\u206A\x8f\x9d\u200D\u206C\u206B\x9d\u206C\u2063\u2064",
    'confluence-table-tree.share.subtitle': "\u2063\u2062Share this link\u200C\u2060\u2061\u206B\u206A\x81\u2060\x9d\u2060\x8f\u206E\u200D\u206D\u2061\x90\u206A\x90\x8f\x81\u206E\u200D\u206B\x9d\u206A\u206E\x90\u2061\x9d\u206B\u206F\u200D\x8f\u2063\u2064",
    'confluence-table-tree.share.title': "\u2063\u2062Share page\u200D\u206A\u061C\u206C\u206A\u206F\u206A\x8f\x90\u206B\x8f\u206C\u200D\u206A\u206E\u061C\u206D\u206B\x8f\x9d\u061C\u206A\u206F\u206E\u206F\u061C\u206C\u061C\u206F\x8f\u2061\u206C\u2063\u2064",
    'confluence-table-tree.share.tooltip': "\u2063\u2062Share\u061C\x9d\x8f\x8f\u206E\u206F\u206A\u061C\u200C\x90\u200D\x8f\u206A\u200C\x9d\x8f\u200D\u200D\u206D\u2061\u206F\x90\u206B\u2060\u061C\u206A\u206D\u200C\u061C\u200C\u206E\x8f\u2063\u2064",
    'confluence-table-tree.view-profile': "\u2063\u2062View profile\u206B\x8f\u2060\u2061\u061C\u206F\u200C\u206F\x8d\u206B\u206A\u206E\u206F\u206E\u206F\u2060\u200D\u206A\u061C\u206C\u206F\x90\u206A\u2060\u206A\u200C\x81\x8f\x8f\u206F\u200D\x9d\u2063\u2064"
};

});




parcelRegister("2Pl3U", function(module, exports) {

$parcel$export(module.exports, "ContentType", () => $84f4f9439fcce7a3$export$e2e108cbe2e4f865);
var $84f4f9439fcce7a3$export$e2e108cbe2e4f865 = /*#__PURE__*/ function(ContentType) {
    ContentType["PAGE"] = "page";
    ContentType["WHITEBOARD"] = "whiteboard";
    return ContentType;
}({});

});

parcelRegister("lXzrh", function(module, exports) {

$parcel$export(module.exports, "default", () => $b04f5f9434b281a6$export$2e2bcd8739ae039);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $7VHMR = parcelRequire("7VHMR");
var $koVbs = parcelRequire("koVbs");

var $dTlW6 = parcelRequire("dTlW6");

var $h8yj2 = parcelRequire("h8yj2");

var $2CAPp = parcelRequire("2CAPp");

var $3WIK2 = parcelRequire("3WIK2");

var $l3opI = parcelRequire("l3opI");

var $bWGt6 = parcelRequire("bWGt6");
function $b04f5f9434b281a6$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $b04f5f9434b281a6$var$messages = (0, $7VHMR.defineMessages)({
    label: {
        id: 'confluence-table-tree.drafts-toggle.label',
        defaultMessage: 'Show drafts',
        description: 'Label for the toggle that turns on or off showing drafts in the page tree'
    }
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b04f5f9434b281a6$var$Wrapper = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "ecvq3120"
})({
    name: "4jyrxv",
    styles: "display:flex;align-items:center;justify-content:flex-end;margin-bottom:var(--ds-space-100, 8px)"
});
const $b04f5f9434b281a6$var$DraftsToggle = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [{ isDraftsShown: isDraftsShown, isTreeUpdatedForDrafts: isTreeUpdatedForDrafts }, { setIsDraftsShown: setIsDraftsShown }] = (0, $2CAPp.useDraftsToggle)();
    const { accountId: accountId } = (0, $3WIK2.useConfluencePageTreeContext)();
    const handleChange = (0, $5uXOq.useCallback)((_, analyticsEvent)=>{
        setIsDraftsShown(accountId, !isDraftsShown);
        (0, $h8yj2.fireUIAnalytics)(analyticsEvent, 'showDraftsToggle', {
            isDraftsShown: !isDraftsShown
        });
    }, [
        accountId,
        isDraftsShown,
        setIsDraftsShown
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsxs)($b04f5f9434b281a6$var$Wrapper, {
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dTlW6.default), {
                id: "show-drafts",
                testId: "show-drafts-toggle",
                isChecked: isDraftsShown || false,
                isDisabled: isDraftsShown === null || !isTreeUpdatedForDrafts,
                onChange: handleChange
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("label", {
                htmlFor: "show-drafts",
                children: formatMessage($b04f5f9434b281a6$var$messages.label)
            })
        ]
    });
};
var $b04f5f9434b281a6$export$2e2bcd8739ae039 = ({ locale: locale })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $l3opI.TranslationsProvider), {
        locale: locale,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)($b04f5f9434b281a6$var$DraftsToggle, {})
    });

});
parcelRegister("dTlW6", function(module, exports) {

$parcel$export(module.exports, "default", () => $3db77843cf29c460$export$2e2bcd8739ae039);
/* toggle.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $cBeZP = parcelRequire("cBeZP");

var $6QvkM = parcelRequire("6QvkM");

var $eGmKJ = parcelRequire("eGmKJ");

var $9KnKW = parcelRequire("9KnKW");

var $7fA4P = parcelRequire("7fA4P");

var $aFYTH = parcelRequire("aFYTH");

var $VSDnB = parcelRequire("VSDnB");

var $lahQ6 = parcelRequire("lahQ6");
const $3db77843cf29c460$var$basicStyles = null;
const $3db77843cf29c460$var$borderStyles = null;
const $3db77843cf29c460$var$iconStyles = null;
const $3db77843cf29c460$var$sizeStyles = {
    regular: "_2rkopxbi _4t3ipxbi _1bsbxy5q _kfgtutpp _1mp41crf _p9c41fbe",
    large: "_2rkov47k _4t3iv47k _1bsb1jfw _kfgtpxbi _1mp47vkz _p9c4w12q"
};
const $3db77843cf29c460$var$noop = (0, $eGmKJ.default);
const $3db77843cf29c460$var$analyticsAttributes = {
    componentName: 'toggle',
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local"
};
const $3db77843cf29c460$var$iconSizeMap = {
    regular: 'small',
    large: 'medium'
}; /**
    * __Toggle__
    *
    * A toggle is used to view or switch between enabled or disabled states.
    *
    * - [Examples](https://atlassian.design/components/toggle/examples)
    * - [Code](https://atlassian.design/components/toggle/code)
    * - [Usage](https://atlassian.design/components/toggle/usage)
    */ 
const $3db77843cf29c460$var$Toggle = /*#__PURE__*/ (0, $5uXOq.memo)(/*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>{
    const { defaultChecked: defaultChecked = false, isDisabled: isDisabled = false, onBlur: providedOnBlur = $3db77843cf29c460$var$noop, onChange: providedChange = $3db77843cf29c460$var$noop, onFocus: providedFocus = $3db77843cf29c460$var$noop, size: size = 'regular', name: name = '', value: value = '', isChecked: isChecked, analyticsContext: analyticsContext, id: id, testId: testId, label: label, descriptionId: descriptionId } = props;
    const isControlled = typeof isChecked === 'undefined';
    const [checked, setChecked] = (0, $5uXOq.useState)(defaultChecked);
    const [isKeyboardUsed, setIsKeyboardUsed] = (0, $5uXOq.useState)(true);
    const wrapperRef = (0, $5uXOq.useRef)(null);
    (0, $5uXOq.useEffect)(()=>{
        if (id && wrapperRef.current && wrapperRef.current.parentElement) {
            /*
      	DSP-21524 Handling the click on <label> that is linked via "for" attribute.
      	By default click on the label fires absolutely same onclick event as click on the input element.
      	To differentiate keyboard click from mouse we need this additional listener.
      */ const linkedLabel = wrapperRef.current.parentElement.querySelector(`label[for="${id}"]`);
            if (linkedLabel) {
                const unbind = (0, $cBeZP.bindAll)(linkedLabel, [
                    {
                        type: 'click',
                        listener: (event)=>{
                            setIsKeyboardUsed(false);
                            if (event?.detail > 1) /*
              DSP-21524 double or triple click on label initiating the text selection for label text and adds additional step to tab order.
              So here we set the isKeyboardUsed to true, to display focus ring on next Tab press
              */ setIsKeyboardUsed(true);
                        }
                    }
                ]);
                return unbind;
            }
        }
    }, [
        id,
        wrapperRef,
        isKeyboardUsed
    ]);
    const handleBlur = (0, $6QvkM.usePlatformLeafEventHandler)({
        fn: (event, analyticsEvent)=>{
            if (!isKeyboardUsed) setIsKeyboardUsed(true);
            providedOnBlur(event, analyticsEvent);
        },
        action: 'blur',
        analyticsData: analyticsContext,
        ...$3db77843cf29c460$var$analyticsAttributes
    });
    const handleFocus = (0, $6QvkM.usePlatformLeafEventHandler)({
        fn: providedFocus,
        action: 'focus',
        analyticsData: analyticsContext,
        ...$3db77843cf29c460$var$analyticsAttributes
    });
    const handleChange = (0, $6QvkM.usePlatformLeafEventHandler)({
        fn: (event, analyticsEvent)=>{
            if (isControlled) setChecked((checked)=>!checked);
            return providedChange(event, analyticsEvent);
        },
        action: 'change',
        analyticsData: analyticsContext,
        ...$3db77843cf29c460$var$analyticsAttributes
    });
    const onLabelKeyDown = (event)=>{
        if ([
            ' ',
            'Tab',
            'Space'
        ].includes(event.key)) setIsKeyboardUsed(true);
    };
    const shouldChecked = isControlled ? checked : isChecked;
    const controlProps = {
        'data-checked': shouldChecked ? shouldChecked : undefined,
        'data-disabled': isDisabled ? isDisabled : undefined,
        'data-size': size,
        'data-testid': testId ? testId : undefined,
        // DSP-21524 Because label gets focus ring via focus-within and focus-within also triggers by mouse click we have to manually control the ring appearance.
        onKeyDown: onLabelKeyDown,
        onMouseDown: ()=>{
            setIsKeyboardUsed(false);
        }
    };
    const legacyIconSize = $3db77843cf29c460$var$iconSizeMap[size];
    const labelId = (0, $9KnKW.useId)();
    return /*#__PURE__*/ (0, $2OMIu.jsxs)("label", {
        ...controlProps,
        ref: wrapperRef,
        className: (0, $bwpsq.default)([
            "_v564kete _1h6d3acm _1dqonqa1 _189eyh40 _1e0c1o8l _vchh18uv _kqswh2mm _1y1m1ntv _bfhk76s1 _syaz5w2r _6rthv77o _1pfhv77o _12l2v77o _ahbqv77o _85i5v77o _1q51v77o _y4tiv77o _bozgv77o _1i2uidpf _1i3tidpf _se28idpf _3tunidpf _1423idpf _1hrtidpf _1bz2idpf _rqfvidpf _1yc0glyw _onsr1snc _1vgmagmp _1av610yn _1ulhidpf _rfx31q5u _pdykkete _1cs8stnw _1rus5w2r _1kt9b3bt _1fkr1y44 _z5wt1y44 _7dwzglyw _1bki1y1w _1flt1y1w _3xv21y1w _9471g4a2 _ucab5w2r _mqf815t7 _3dj215t7 _1dl915t7 _1div5w2r _1il8kb7n _y54d5w2r _irr353wy _d0altlke _19ja13gf _8muf13gf _1k1q13gf _1plud4ly _1uo853wy _178c1y1w _16rslghj _ogf41r31 _1rtbnqa1 _5gg9t94y",
            isKeyboardUsed && "_jyzf194a _1r4mnqa1 _1t9pyh40",
            size === 'large' && !(0, $VSDnB.fg)('platform-visual-refresh-icons') && "_1n82gktf _19vpgktf",
            $3db77843cf29c460$var$sizeStyles[size]
        ]),
        children: [
            label ? /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
                id: labelId,
                hidden: true,
                children: label
            }) : null,
            /*#__PURE__*/ (0, $2OMIu.jsx)("input", {
                ref: ref,
                checked: shouldChecked,
                disabled: isDisabled,
                id: id,
                name: name,
                onBlur: handleBlur,
                onChange: handleChange,
                onFocus: handleFocus,
                type: "checkbox",
                value: value,
                "data-testid": testId && `${testId}--input`,
                "aria-labelledby": label ? labelId : undefined,
                "aria-describedby": descriptionId
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $lahQ6.default), {
                size: size,
                isHidden: !shouldChecked,
                position: "left",
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($7fA4P))), {
                    label: "",
                    color: "currentColor",
                    LEGACY_size: legacyIconSize,
                    testId: testId && `${testId}--toggle-check-icon`
                })
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $lahQ6.default), {
                size: size,
                isHidden: shouldChecked,
                position: "right",
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($aFYTH))), {
                    label: "",
                    color: "currentColor",
                    LEGACY_size: legacyIconSize,
                    testId: testId && `${testId}--toggle-cross-icon`
                })
            })
        ]
    });
}));
$3db77843cf29c460$var$Toggle.displayName = 'Toggle';
var $3db77843cf29c460$export$2e2bcd8739ae039 = $3db77843cf29c460$var$Toggle;

});
parcelRegister("7fA4P", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::90a6c328ce4531920c578790d71561aa>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5475eb3f94e0b044$var$_react = $5475eb3f94e0b044$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $5475eb3f94e0b044$var$_checkMark = $5475eb3f94e0b044$var$_interopRequireDefault((parcelRequire("f22iM")));

var $5475eb3f94e0b044$var$_done = $5475eb3f94e0b044$var$_interopRequireDefault((parcelRequire("4DXCl")));
function $5475eb3f94e0b044$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for CheckMarkIcon.
 * This component is CheckMarkIcon, with `UNSAFE_fallbackIcon` set to "EditorDoneIcon".
 *
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: 📦 @atlaskit/icon/utility/check-mark
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $5475eb3f94e0b044$var$CheckMarkIcon = (props)=>/*#__PURE__*/ $5475eb3f94e0b044$var$_react.default.createElement($5475eb3f94e0b044$var$_checkMark.default, Object.assign({
        LEGACY_fallbackIcon: $5475eb3f94e0b044$var$_done.default
    }, props));
$5475eb3f94e0b044$var$CheckMarkIcon.Name = 'CheckMarkIconMigration';
var $5475eb3f94e0b044$var$_default = module.exports.default = $5475eb3f94e0b044$var$CheckMarkIcon;

});
parcelRegister("f22iM", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4f681ccdbe722d68d6bd374c0928f0bd>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $af18d40ba5b744b4$var$_react = $af18d40ba5b744b4$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $af18d40ba5b744b4$var$_baseNew = $af18d40ba5b744b4$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $af18d40ba5b744b4$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "CheckMark".
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: 📦 @atlaskit/icon/utility/check-mark
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $af18d40ba5b744b4$var$CheckMarkIcon = (props)=>/*#__PURE__*/ $af18d40ba5b744b4$var$_react.default.createElement($af18d40ba5b744b4$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="m11.06 3-6.25 7a.75.75 0 0 1-1.15-.037l-2.75-3.5 1.18-.926 2.197 2.796L9.94 2z" clip-rule="evenodd"/>`,
        type: 'utility'
    }, props));
$af18d40ba5b744b4$var$CheckMarkIcon.displayName = 'CheckMarkIcon';
var $af18d40ba5b744b4$var$_default = module.exports.default = $af18d40ba5b744b4$var$CheckMarkIcon;

});

parcelRegister("4DXCl", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $36190cbd288fec69$var$_react = $36190cbd288fec69$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $36190cbd288fec69$var$_checkMark = $36190cbd288fec69$var$_interopRequireDefault((parcelRequire("bjo8S")));
function $36190cbd288fec69$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $36190cbd288fec69$var$EditorDoneIcon = (props)=>/*#__PURE__*/ $36190cbd288fec69$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M7.356 10.942a.497.497 0 0 0-.713 0l-.7.701a.5.5 0 0 0-.003.71l3.706 3.707a.5.5 0 0 0 .705.003l7.712-7.712a.493.493 0 0 0-.006-.708l-.7-.7a.504.504 0 0 0-.714 0l-6.286 6.286a.506.506 0 0 1-.713 0z"/></svg>`
    }, props, {
        newIcon: $36190cbd288fec69$var$_checkMark.default
    }));
$36190cbd288fec69$var$EditorDoneIcon.displayName = 'EditorDoneIcon';
var $36190cbd288fec69$var$_default = module.exports.default = $36190cbd288fec69$var$EditorDoneIcon;

});
parcelRegister("bjo8S", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a3e71f4112aeb66b16fbd284cc49bbc6>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $83c43234bc70a485$var$_react = $83c43234bc70a485$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $83c43234bc70a485$var$_baseNew = $83c43234bc70a485$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $83c43234bc70a485$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "CheckMark".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: table cells, checkboxes.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $83c43234bc70a485$var$CheckMarkIcon = (props)=>/*#__PURE__*/ $83c43234bc70a485$var$_react.default.createElement($83c43234bc70a485$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="m15.076 3.23-8.75 10.5a.75.75 0 0 1-1.159-.008l-4.25-5.25 1.166-.944 3.675 4.54 8.166-9.798z" clip-rule="evenodd"/>`
    }, props));
$83c43234bc70a485$var$CheckMarkIcon.displayName = 'CheckMarkIcon';
var $83c43234bc70a485$var$_default = module.exports.default = $83c43234bc70a485$var$CheckMarkIcon;

});



parcelRegister("lahQ6", function(module, exports) {

$parcel$export(module.exports, "default", () => $ca1cdaa1eb34599d$export$2e2bcd8739ae039);
/* icon-container.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $3JT92 = parcelRequire("3JT92");

var $VSDnB = parcelRequire("VSDnB");

var $MHKc7 = parcelRequire("MHKc7");
const $ca1cdaa1eb34599d$var$styles = {
    iconContainer: "_v5641hrg _1e0c116y _4cvr1h6o _1bah1h6o _kqswstnw _152tv77o",
    iconContainerRegular: "_1bsb7vkz _4t3i7vkz",
    iconContainerLarge: "_1bsbgktf _4t3igktf",
    hidden: "_tzy4idpf",
    left: "_1e021l7b",
    right: "_rjxp1l7b"
};
/**
 * __Icon container__
 *
 * Positions a toggle's check and close icons.
 */ const $ca1cdaa1eb34599d$var$IconContainer = ({ children: children, size: size, isHidden: isHidden, position: position })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
        as: "span",
        xcss: (0, $3JT92.cx)($ca1cdaa1eb34599d$var$styles.iconContainer, isHidden && (0, $VSDnB.fg)('platform-visual-refresh-icons') && $ca1cdaa1eb34599d$var$styles.hidden, size === 'regular' && $ca1cdaa1eb34599d$var$styles.iconContainerRegular, size === 'large' && $ca1cdaa1eb34599d$var$styles.iconContainerLarge, position === 'left' && $ca1cdaa1eb34599d$var$styles.left, position === 'right' && $ca1cdaa1eb34599d$var$styles.right),
        children: children
    });
};
var $ca1cdaa1eb34599d$export$2e2bcd8739ae039 = $ca1cdaa1eb34599d$var$IconContainer;

});



parcelRegister("8rAPH", function(module, exports) {

$parcel$export(module.exports, "useProjectPages", () => $11568c37f0744ba6$export$bb347a8713b896e6);
$parcel$export(module.exports, "ProjectPagesProvider", () => $11568c37f0744ba6$export$8582af416d6f689b);

var $5uXOq = parcelRequire("5uXOq");


const $11568c37f0744ba6$var$ProjectPagesContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createContext({
    accountId: '',
    locale: (0, $7efad8a17c767c3a$export$d7f512c98c859244),
    cloudId: '',
    parentProduct: (0, $d29b7f051950917c$export$ae07618062047a87),
    environment: 'dev'
});
const $11568c37f0744ba6$export$bb347a8713b896e6 = ()=>(0, $5uXOq.useContext)($11568c37f0744ba6$var$ProjectPagesContext);
const $11568c37f0744ba6$export$8582af416d6f689b = $11568c37f0744ba6$var$ProjectPagesContext.Provider;

});
const $d29b7f051950917c$export$ae07618062047a87 = 'JSW';
const $d29b7f051950917c$export$2c5916240ec6ec9e = 'JWM';

const $7efad8a17c767c3a$export$d7f512c98c859244 = 'en_US';


parcelRegister("4h7rG", function(module, exports) {

$parcel$export(module.exports, "PageTreePlaceholder", () => $bc5b749042f05099$export$a31f8fba1571ae1c);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $NoEQs = parcelRequire("NoEQs");

var $au9nJ = parcelRequire("au9nJ");

var $gAIgm = parcelRequire("gAIgm");

var $8aAQl = parcelRequire("8aAQl");
const $bc5b749042f05099$export$a31f8fba1571ae1c = ({ treeState: treeState })=>{
    switch(treeState){
        case (0, $NoEQs.TreeStates).Empty:
            return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $au9nJ.default), {});
        case (0, $NoEQs.TreeStates).Error:
            return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $gAIgm.default), {});
        case (0, $NoEQs.TreeStates).Loading:
            return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $8aAQl.PageTreeSkeleton), {});
        default:
            return null;
    }
};

});
parcelRegister("au9nJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $3a78448c148f068c$export$2e2bcd8739ae039);

var $7Z8iG = parcelRequire("7Z8iG");

var $6dOwT = parcelRequire("6dOwT");

var $cEp5g = parcelRequire("cEp5g");

var $hFWlI = parcelRequire("hFWlI");

var $6L3iv = parcelRequire("6L3iv");
const $3a78448c148f068c$var$mapStateToProps = (state)=>({
        spaceKey: (0, $cEp5g.getProjectSpaceKey)(state),
        contentId: (0, $cEp5g.getProjectPageLinkedId)(state),
        isConfluenceAutoProvisioned: (0, $hFWlI.isConfluenceAutoProvisioned)(state),
        projectId: (0, $6L3iv.getProjectId)(state),
        projectType: (0, $6L3iv.getProjectType)(state)
    });
var $3a78448c148f068c$export$2e2bcd8739ae039 = (0, $7Z8iG.connect)($3a78448c148f068c$var$mapStateToProps)((0, $6dOwT.default));

});
parcelRegister("6dOwT", function(module, exports) {

$parcel$export(module.exports, "default", () => $6af6b0a3b2b740cc$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $8RXs9 = parcelRequire("8RXs9");

var $aU4MP = parcelRequire("aU4MP");

var $2HYu5 = parcelRequire("2HYu5");

var $8eO0S = parcelRequire("8eO0S");
const $6af6b0a3b2b740cc$var$EmptyState = ({ intl: intl, spaceKey: spaceKey, contentId: contentId, isConfluenceAutoProvisioned: isConfluenceAutoProvisioned = false })=>isConfluenceAutoProvisioned ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $aU4MP.default), {
        intl: intl,
        spaceKey: spaceKey,
        contentId: contentId
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2HYu5.default), {
        intl: intl,
        spaceKey: spaceKey,
        contentId: contentId,
        description: (0, $8eO0S.default).description,
        primaryActionMessage: (0, $8eO0S.default).createFirstPageButton
    });
var $6af6b0a3b2b740cc$export$2e2bcd8739ae039 = (0, $8RXs9.default)($6af6b0a3b2b740cc$var$EmptyState);

});
parcelRegister("aU4MP", function(module, exports) {

$parcel$export(module.exports, "default", () => $ac42f94465307547$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $8eO0S = parcelRequire("8eO0S");

var $1GGwS = parcelRequire("1GGwS");


var $2HYu5 = parcelRequire("2HYu5");

var $2b05O = parcelRequire("2b05O");

var $h8yj2 = parcelRequire("h8yj2");

var $2NMNM = parcelRequire("2NMNM");
const $ac42f94465307547$var$AutoProvisionedConfluenceEmptyState = ({ intl: intl, spaceKey: spaceKey, contentId: contentId, isProjectPagesSporkRebrandingEnabled: isProjectPagesSporkRebrandingEnabled })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    (0, $5uXOq.useEffect)(()=>{
        (0, $h8yj2.fireScreenAnalytics)(createAnalyticsEvent({
            action: 'viewed',
            actionSubjectId: 'autoProvisionedConfluenceEmptyState'
        }));
    }, [
        createAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2HYu5.default), {
        intl: intl,
        spaceKey: spaceKey,
        contentId: contentId,
        description: (0, $8eO0S.default).confluenceAutoProvisionedDescription,
        primaryActionMessage: (0, $8eO0S.default).createPageButton,
        pageContent: {
            title: intl.formatMessage((0, $8eO0S.default).tutorialPageName),
            body: (0, $2b05O.getTutorialContent)(intl, isProjectPagesSporkRebrandingEnabled)
        },
        secondaryAction: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1GGwS.default), {
            appearance: "subtle",
            target: "_blank",
            href: (0, $60fd1b8cfb009820$export$eebcff9497e6f75c),
            testId: "confluence-project-pages.empty-state.learn-more-button",
            onClick: ()=>{
                (0, $h8yj2.fireUIAnalytics)(createAnalyticsEvent({
                    action: 'clicked',
                    actionSubject: 'link',
                    source: 'confluencePageTreeEmptyStateLearnMoreButton',
                    actionSubjectId: 'howToUseConfluenceDocumentationLink'
                }));
            },
            children: intl.formatMessage((0, $8eO0S.default).learnMoreButton)
        })
    });
};
var $ac42f94465307547$export$2e2bcd8739ae039 = $ac42f94465307547$var$AutoProvisionedConfluenceEmptyState;

});
parcelRegister("8eO0S", function(module, exports) {

$parcel$export(module.exports, "default", () => $d1a0df8d20c96913$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $d1a0df8d20c96913$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    title: {
        id: 'project-pages.improvement.transient-states.empty-state.title',
        defaultMessage: "There\u2019s nothing here but potential",
        description: 'Title of message letting users know there are no pages'
    },
    description: {
        id: 'project-pages.improvement.transient-states.empty-state.description',
        defaultMessage: 'Create some meeting notes, product requirements, decisions, or other content to see this space fill up.',
        description: 'Description text letting users know there are no pages'
    },
    confluenceAutoProvisionedDescription: {
        id: 'project-pages.improvement.transient-states.empty-state.auto-provisioned-description',
        defaultMessage: "We\u2019ve added Confluence so you can start creating and linking all your project documents. It\u2019s free for up to 10 users.",
        description: 'Description text letting users know Confluence has been auto provisioned'
    },
    createFirstPageButton: {
        id: 'project-pages.improvement.transient-states.empty-state.create-page-button',
        defaultMessage: 'Create your first page',
        description: 'Button label for creating a new first page'
    },
    createPageButton: {
        id: 'project-pages.improvement.transient-states.empty-state.auto-provisioned-create-page-button',
        defaultMessage: 'Create page',
        description: 'Button label for creating a new page'
    },
    learnMoreButton: {
        id: 'project-pages.improvement.transient-states.empty-state.auto-provisioned-learn-more-button',
        defaultMessage: 'Learn more',
        description: 'Label for link to Confluence guides, tutorials and demos'
    },
    tutorialPageName: {
        id: 'project-pages.improvement.templates.tutorial.name',
        defaultMessage: 'Welcome to Project Pages!',
        description: 'Title of the tutorial page'
    }
});

});

const $60fd1b8cfb009820$export$eebcff9497e6f75c = 'https://www.atlassian.com/software/confluence/guides';

parcelRegister("2HYu5", function(module, exports) {

$parcel$export(module.exports, "default", () => $7f15d83bcd7c4413$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $hTEpF = parcelRequire("hTEpF");

var $8eO0S = parcelRequire("8eO0S");

var $jGY7q = parcelRequire("jGY7q");

var $eCeGD = parcelRequire("eCeGD");

var $dNpfo = parcelRequire("dNpfo");

var $h8yj2 = parcelRequire("h8yj2");
const $7f15d83bcd7c4413$var$BaseEmptyState = ({ intl: { formatMessage: formatMessage }, spaceKey: spaceKey, contentId: contentId, description: description, primaryActionMessage: primaryActionMessage, pageContent: pageContent, secondaryAction: secondaryAction = null, projectId: projectId, projectType: projectType })=>{
    const createEmbeddedPage = (0, $dNpfo.useCreateEmbeddedPage)({
        spaceKey: spaceKey,
        projectId: projectId,
        projectType: projectType
    });
    const handleClick = (0, $5uXOq.useCallback)(async (_, analyticsEvent)=>{
        (0, $h8yj2.fireUIAnalytics)(analyticsEvent, 'confluencePageTreeEmptyStateCreateButton');
        await createEmbeddedPage(contentId || undefined, true, undefined, pageContent);
    }, [
        contentId,
        pageContent,
        createEmbeddedPage
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $hTEpF.default), {
        imageUrl: (0, (/*@__PURE__*/$parcel$interopDefault($jGY7q))),
        imageWidth: 160,
        description: formatMessage(description),
        header: formatMessage((0, $8eO0S.default).title),
        primaryAction: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eCeGD.default), {
            appearance: "primary",
            onClick: handleClick,
            testId: "confluence-project-pages.empty-state.create-page-button",
            children: formatMessage(primaryActionMessage)
        }),
        secondaryAction: secondaryAction
    });
};
var $7f15d83bcd7c4413$export$2e2bcd8739ae039 = $7f15d83bcd7c4413$var$BaseEmptyState;

});
parcelRegister("jGY7q", function(module, exports) {
module.exports = new URL("play-button-pages.233781be.svg", import.meta.url).toString();

});

parcelRegister("dNpfo", function(module, exports) {

$parcel$export(module.exports, "useCreateEmbeddedPage", () => $73642eaf4734f939$export$e578e124f061619f);

var $2NMNM = parcelRequire("2NMNM");

var $h8yj2 = parcelRequire("h8yj2");

var $dTS1V = parcelRequire("dTS1V");

var $2Pl3U = parcelRequire("2Pl3U");
var $3WIK2 = parcelRequire("3WIK2");

var $5uXOq = parcelRequire("5uXOq");

var $eNwjm = parcelRequire("eNwjm");

var $inlrL = parcelRequire("inlrL");

var $huL1C = parcelRequire("huL1C");

var $cuwyS = parcelRequire("cuwyS");
const $73642eaf4734f939$export$e578e124f061619f = ({ spaceKey: spaceKey, projectId: projectId, projectType: projectType })=>{
    const { setEmbeddedPage: setEmbeddedPage } = (0, $eNwjm.useEmbeddedPage)();
    const { insertPage: insertPage } = (0, $3WIK2.useConfluencePageTree)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    return (0, $5uXOq.useCallback)(async (parentContentId, isRoot, blueprint, content, templateKey)=>{
        if (spaceKey) {
            const isUserInInlineOnboardingABVariant = (0, $huL1C.getInlineOnboardingABCohort)() === 'variation';
            setEmbeddedPage({
                mode: 'edit',
                isOpen: true,
                isLoading: true,
                page: null,
                pageCreate: {
                    error: null,
                    parentContentId: parentContentId,
                    isRoot: isRoot,
                    blueprint: blueprint
                }
            });
            try {
                let contentId;
                let isLive = false;
                let status;
                if (blueprint?.contentBlueprintId) {
                    // Create content with panel and checkboxes
                    const response = await (0, $inlrL.createConfluenceDraft)({
                        templateId: blueprint.contentBlueprintId,
                        projectSpaceKey: spaceKey,
                        projectPageLinkedId: parentContentId || null,
                        isEmbeddedPage: true,
                        projectId: projectId,
                        projectType: projectType,
                        pageTitle: content?.title,
                        initialContent: isUserInInlineOnboardingABVariant ? (0, $cuwyS.inlineOnboardingTemplateJson) : undefined
                    });
                    contentId = response.content.id;
                    isLive = response.content.subType === 'live';
                    status = response.content.status;
                } else {
                    // blank page
                    let body;
                    if (isUserInInlineOnboardingABVariant) body = {
                        ...(0, $cuwyS.inlineOnboardingTemplateJson),
                        atlas_doc_format: {
                            value: JSON.stringify((0, $cuwyS.inlineOnboardingTemplateJson).atlas_doc_format.value),
                            representation: 'atlas_doc_format'
                        }
                    };
                    else if (content?.body) body = {
                        storage: {
                            value: content.body,
                            representation: 'storage'
                        }
                    };
                    // Use the Atlas doc format for the content
                    const response = await (0, $dTS1V.createContent)({
                        spaceKey: spaceKey,
                        parentPageId: parentContentId,
                        parentProduct: projectType,
                        parentProductContentContainerId: projectId?.toString(),
                        body: body,
                        title: content?.title
                    });
                    contentId = response.contentId;
                    isLive = response.subType === 'live';
                    status = response.status;
                }
                if (contentId) {
                    setEmbeddedPage({
                        mode: isLive ? 'view' : 'edit',
                        page: {
                            id: contentId,
                            url: `/wiki/spaces/${spaceKey}/pages/${contentId}`,
                            editUrl: '',
                            hasEmbeddedEdit: true,
                            isDraft: status === 'draft',
                            isLive: isLive,
                            type: (0, $2Pl3U.ContentType).PAGE
                        }
                    });
                    (0, $h8yj2.fireTrackAnalytics)(createAnalyticsEvent({}), 'embeddedPageDraft created', {
                        template: blueprint?.name || 'blank',
                        embeddedPageAction: true,
                        hasContent: Boolean(content),
                        templateKey: templateKey || 'unknown template key',
                        inlineOnboardingExperimentEnabled: isUserInInlineOnboardingABVariant
                    });
                    try {
                        await insertPage(contentId, parentContentId);
                    } catch  {
                    // ignore error
                    }
                } else throw new Error('createContent returned undefined contentId');
            } catch (error) {
                setEmbeddedPage({
                    page: null,
                    isLoading: false,
                    pageCreate: {
                        error: error instanceof Error ? error : null,
                        parentContentId: parentContentId,
                        isRoot: isRoot,
                        blueprint: blueprint
                    }
                });
                (0, $h8yj2.fireOperationalAnalytics)(createAnalyticsEvent({}), 'createEmbeddedPageDraft failed', {
                    template: blueprint?.name || 'blank',
                    embeddedPageAction: true,
                    errorMessage: String(error) || 'Unknown error',
                    hasContent: Boolean(content),
                    templateKey: templateKey || 'Unknown template key',
                    inlineOnboardingExperimentEnabled: isUserInInlineOnboardingABVariant
                });
                return;
            }
        }
    }, [
        createAnalyticsEvent,
        insertPage,
        setEmbeddedPage,
        spaceKey,
        projectId,
        projectType
    ]);
};

});
parcelRegister("dTS1V", function(module, exports) {

$parcel$export(module.exports, "createContent", () => $2144a235c2b8fe30$export$41c7a4cacf5bab80);
/**
 * This function would be used by Embedding product to create Confluence Content. Content created by this function will be tagged with "embedded" flag.
 * At the moment we only support creating a blank page and does not support cross domain request (Parent Product must be in same domain as Confluence)
 * To enable unlicensed user to create a page, parentProduct & parentProductContentContainerId are required.
 */ 
var $eeFBS = parcelRequire("eeFBS");
const $2144a235c2b8fe30$var$REQUIRED_UNLICENSED_ACCESS_HEADER_KEYS = [
    'parentProduct',
    'parentProductContentContainerId',
    'spaceKey'
];
const $2144a235c2b8fe30$export$4de094b68e927f31 = 'X-Atl-EmbeddablePage-EntityIDs';
const $2144a235c2b8fe30$export$41c7a4cacf5bab80 = async ({ spaceKey: spaceKey, parentPageId: parentPageId, parentProduct: parentProduct, parentProductContentContainerId: parentProductContentContainerId, domain: domain = '', title: title, body: body })=>{
    const payload = {
        type: 'page',
        status: 'draft',
        metadata: {
            properties: {
                editor: {
                    value: 'v2'
                }
            },
            frontend: {
                embedded: true
            }
        },
        space: {
            key: spaceKey
        },
        title: title,
        body: body
    };
    if (parentPageId) payload.ancestors = [
        {
            id: parentPageId
        }
    ];
    const baseurl = domain ? `https://${domain}` : domain;
    const unlicensedAccessHeader = $2144a235c2b8fe30$var$getUnlicensedAccessHeader({
        parentProduct: parentProduct,
        parentProductContentContainerId: parentProductContentContainerId,
        spaceKey: spaceKey
    });
    let response;
    try {
        response = await fetch(`${baseurl}/wiki/rest/api/content`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                credentials: 'include',
                ...unlicensedAccessHeader
            },
            body: JSON.stringify(payload)
        });
    } catch (e) {
        // https://developer.mozilla.org/en-US/docs/Web/API/Fetch_API/Using_Fetch
        // Promise will reject with a TypeError when a network error is encountered or CORS is misconfigured on the server-side else resolve
        throw new Error(`Network failure ${e}`);
    }
    const responseJson = await response.json();
    if (!response.ok) throw new (0, $eeFBS.CreateError)(`Status: ${responseJson.statusCode} Message: ${responseJson.message}`, responseJson.statusCode);
    return {
        draftShareId: $2144a235c2b8fe30$var$getDraftShareId(responseJson),
        spaceKey: responseJson?.space?.key,
        contentId: responseJson?.id,
        status: responseJson?.status,
        subType: responseJson?.subType
    };
};
const $2144a235c2b8fe30$var$getDraftShareId = (data)=>(data?._links?.editui || '').match(/draftShareId=(.*?)(#|&|$)/)?.[1] || undefined;
const $2144a235c2b8fe30$var$getUnlicensedAccessHeader = ({ parentProduct: parentProduct, parentProductContentContainerId: parentProductContentContainerId, spaceKey: spaceKey })=>{
    const headerValue = {
        parentProduct: parentProduct,
        parentProductContentContainerId: parentProductContentContainerId,
        spaceKey: spaceKey
    };
    const isValidHeader = $2144a235c2b8fe30$var$REQUIRED_UNLICENSED_ACCESS_HEADER_KEYS.every((key)=>Boolean(headerValue[key]));
    return isValidHeader ? {
        [$2144a235c2b8fe30$export$4de094b68e927f31]: JSON.stringify(headerValue)
    } : undefined;
};

});
parcelRegister("eeFBS", function(module, exports) {

$parcel$export(module.exports, "CreateError", () => $5ee25365aafd3194$export$91ee1703d5a5ab8b);
class $5ee25365aafd3194$export$91ee1703d5a5ab8b extends Error {
    constructor(message, statusCode){
        super(message);
        this.statusCode = statusCode;
    }
}

});


parcelRegister("eNwjm", function(module, exports) {

$parcel$export(module.exports, "useEmbeddedPage", () => $e3aa2ba7f1608d49$export$723f81cacfb30bb4);
$parcel$export(module.exports, "EmbeddedPageProvider", () => $e3aa2ba7f1608d49$export$db7a10e5d0439504);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");
const $e3aa2ba7f1608d49$var$EmbeddedPageContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createContext({
    mode: 'view',
    page: null,
    isOpen: false,
    isLoading: false,
    pageCreate: null,
    setEmbeddedPage: ()=>{}
});
const $e3aa2ba7f1608d49$export$723f81cacfb30bb4 = ()=>(0, $5uXOq.useContext)($e3aa2ba7f1608d49$var$EmbeddedPageContext);
const $e3aa2ba7f1608d49$var$reducer = (prevState, action)=>({
        ...prevState,
        ...action
    });
const $e3aa2ba7f1608d49$export$db7a10e5d0439504 = ({ children: children })=>{
    const [pageState, setEmbeddedPage] = (0, $5uXOq.useReducer)($e3aa2ba7f1608d49$var$reducer, {
        mode: 'view',
        page: null,
        isOpen: false,
        isLoading: false,
        pageCreate: null
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)($e3aa2ba7f1608d49$var$EmbeddedPageContext.Provider, {
        value: {
            ...pageState,
            setEmbeddedPage: setEmbeddedPage
        },
        children: children
    });
};

});

parcelRegister("inlrL", function(module, exports) {

$parcel$export(module.exports, "IGNORE_MAU_HEADER", () => $7def18ce75346fba$export$aa795a555a03919d);
$parcel$export(module.exports, "EP_ENITITY_ID_HEADER", () => $7def18ce75346fba$export$3174683b26cfd436);
$parcel$export(module.exports, "createConfluenceDraft", () => $7def18ce75346fba$export$35a28ef15d43eade);

var $huL1C = parcelRequire("huL1C");

var $bsQw8 = parcelRequire("bsQw8");
const $7def18ce75346fba$export$aa795a555a03919d = 'x-atlassian-mau-ignore';
const $7def18ce75346fba$export$3174683b26cfd436 = 'X-Atl-EmbeddablePage-EntityIDs';
const $7def18ce75346fba$export$35a28ef15d43eade = async ({ templateId: templateId, projectSpaceKey: projectSpaceKey, projectPageLinkedId: projectPageLinkedId, isEmbeddedPage: isEmbeddedPage, pageTitle: pageTitle, projectId: projectId, projectType: projectType, initialContent: initialContent })=>{
    const requestBody = {
        content: {
            type: 'page',
            status: 'draft',
            space: {
                key: projectSpaceKey
            },
            ...projectPageLinkedId && {
                ancestors: [
                    {
                        id: projectPageLinkedId
                    }
                ]
            },
            title: pageTitle,
            ...isEmbeddedPage && {
                metadata: {
                    frontend: {
                        embedded: true
                    }
                }
            }
        },
        contentBlueprintSpec: {
            context: {},
            blueprintId: templateId
        }
    };
    // First create the blueprint page
    const response = await (0, $bsQw8.fetchJson)(`/wiki/rest/create-dialog/1.0/content/blueprint/${templateId}/instance`, {
        method: 'POST',
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            [$7def18ce75346fba$export$aa795a555a03919d]: 'true',
            [$7def18ce75346fba$export$3174683b26cfd436]: JSON.stringify({
                projectId: projectId,
                projectType: projectType
            })
        },
        body: JSON.stringify(requestBody)
    });
    // If we have initial content, update the page with it
    if (initialContent && response.content.id) (0, $huL1C.updateExistingPageWithInlineOnboardingTemplate)({
        pageId: response.content.id,
        template: initialContent,
        projectId: projectId,
        projectType: projectType,
        pageTitle: pageTitle
    });
    return response;
};

});
parcelRegister("huL1C", function(module, exports) {

$parcel$export(module.exports, "flagUserAsXflowedFromProjectPages", () => $c72a66a374a07808$export$48ea3a76fb4aea2a);
$parcel$export(module.exports, "getInlineOnboardingABCohort", () => $c72a66a374a07808$export$32afae4bb6c25fc0);
$parcel$export(module.exports, "updateExistingPageWithInlineOnboardingTemplate", () => $c72a66a374a07808$export$620a301867c85ed1);

var $1nF7O = parcelRequire("1nF7O");

var $jXVTV = parcelRequire("jXVTV");

var $inlrL = parcelRequire("inlrL");

var $bsQw8 = parcelRequire("bsQw8");
const $c72a66a374a07808$export$f9b47c00474b1ee6 = 'PROJECT_PAGES_XFLOW_INLINE_ONBOARDING';
const $c72a66a374a07808$export$935509a10e03fc7d = 'grw-1519_jira_project_pages_inline_onboarding';
const $c72a66a374a07808$export$3945573224535ebb = 'grw-1519_jira_project_pages_inline_onboarding_gate';
const $c72a66a374a07808$export$48ea3a76fb4aea2a = ()=>{
    try {
        (0, $jXVTV.getTargetingGate)($c72a66a374a07808$export$3945573224535ebb) && window.localStorage.setItem($c72a66a374a07808$export$f9b47c00474b1ee6, 'true');
    } catch (error) {
        (0, $1nF7O.fireErrorAnalytics)({
            error: new Error(`Error setting inline onboarding flag`),
            meta: {
                id: 'project-pages-set-inline-onboarding-flag-error',
                packageName: '@atlassiansox/project-pages',
                teamName: 'starburst'
            }
        });
    }
};
const $c72a66a374a07808$export$32afae4bb6c25fc0 = ()=>{
    try {
        if ((0, $jXVTV.getTargetingGate)($c72a66a374a07808$export$3945573224535ebb) && window.localStorage.getItem($c72a66a374a07808$export$f9b47c00474b1ee6) === 'true') {
            window.localStorage.removeItem($c72a66a374a07808$export$f9b47c00474b1ee6);
            return (0, $jXVTV.getExperimentValue)($c72a66a374a07808$export$935509a10e03fc7d, 'not-enrolled', true);
        }
    } catch (error) {
        (0, $1nF7O.fireErrorAnalytics)({
            error: new Error(`Error checking inline onboarding cohort`),
            meta: {
                id: 'project-pages-check-inline-onboarding-cohort-error',
                packageName: '@atlassiansox/project-pages',
                teamName: 'starburst'
            }
        });
    }
};
const $c72a66a374a07808$export$620a301867c85ed1 = async ({ pageId: pageId, template: template, projectId: projectId, projectType: projectType, pageTitle: pageTitle })=>{
    try {
        // First get the existing content
        const existingPage = await (0, $bsQw8.fetchJson)(`/wiki/api/v2/pages/${pageId}?body-format=atlas_doc_format`, {
            method: 'GET',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json',
                [(0, $inlrL.IGNORE_MAU_HEADER)]: 'true',
                [(0, $inlrL.EP_ENITITY_ID_HEADER)]: JSON.stringify({
                    projectId: projectId,
                    projectType: projectType
                })
            }
        });
        // Put initial content first, then the blueprint content
        const originalContent = JSON.parse(existingPage.body.atlas_doc_format.value);
        const combinedContent = {
            ...originalContent,
            content: [
                ...template?.atlas_doc_format.value.content || [],
                ...originalContent.content
            ]
        };
        const updateRequestBody = {
            id: pageId,
            status: 'draft',
            title: pageTitle,
            body: {
                value: JSON.stringify(combinedContent),
                representation: 'atlas_doc_format'
            },
            version: {
                number: 1,
                message: 'Initial content update'
            }
        };
        await (0, $bsQw8.fetchJson)(`/wiki/api/v2/pages/${pageId}`, {
            method: 'PUT',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json',
                [(0, $inlrL.IGNORE_MAU_HEADER)]: 'true',
                [(0, $inlrL.EP_ENITITY_ID_HEADER)]: JSON.stringify({
                    projectId: projectId,
                    projectType: projectType
                })
            },
            body: JSON.stringify(updateRequestBody)
        });
    } catch (error) {
        (0, $1nF7O.fireErrorAnalytics)({
            error: new Error('Failed to update page with inline onboarding template'),
            meta: {
                id: 'project-pages-update-inline-onboarding-template-error',
                packageName: '@atlassiansox/project-pages',
                teamName: 'starburst'
            }
        });
    }
};

});
parcelRegister("jXVTV", function(module, exports) {

$parcel$export(module.exports, "getExperimentValue", () => $2788073de28dcd7e$export$df4f69f663fe2d96);
$parcel$export(module.exports, "getTargetingGate", () => $2788073de28dcd7e$export$c123608fb702e1aa);

var $iEN9D = parcelRequire("iEN9D");
const $2788073de28dcd7e$export$df4f69f663fe2d96 = (experimentKey, defaultCohort, fireExperimentExposure)=>{
    if ((0, $iEN9D.default).initializeCalled()) return (0, $iEN9D.default).getExperimentValue(experimentKey, 'cohort', defaultCohort, {
        fireExperimentExposure: fireExperimentExposure
    });
    return defaultCohort;
};
const $2788073de28dcd7e$export$c123608fb702e1aa = (experimentKey)=>(0, $iEN9D.default).initializeCompleted() && (0, $iEN9D.default).checkGate(experimentKey);

});

parcelRegister("bsQw8", function(module, exports) {

$parcel$export(module.exports, "fetchJson", () => $c543e7c86b5d088f$export$6d71b655afe1638d);
const $c543e7c86b5d088f$export$6d71b655afe1638d = (url, init)=>fetch(url, {
        credentials: 'include',
        ...init
    }).then((response)=>{
        if (response.ok) return response.json();
        throw new Error(`Unable to fetch ${url} ${response.status} ${response.statusText}`);
    });

});



parcelRegister("cuwyS", function(module, exports) {

$parcel$export(module.exports, "inlineOnboardingTemplateJson", () => $1ebeaf947823abcb$export$44e03a5b76d2f3f0);

var $o8lUB = parcelRequire("o8lUB");

var $bFtEE = parcelRequire("bFtEE");
const $1ebeaf947823abcb$export$44e03a5b76d2f3f0 = {
    atlas_doc_format: {
        value: {
            type: 'doc',
            content: [
                {
                    type: 'panel',
                    attrs: {
                        panelIconId: '1f44b',
                        panelIcon: ':wave:',
                        panelIconText: "\uD83D\uDC4B",
                        panelColor: '#DEEBFF',
                        panelType: (0, $bFtEE.PanelType).CUSTOM
                    },
                    content: [
                        {
                            type: 'paragraph',
                            content: [
                                {
                                    text: (0, $o8lUB.inlineOnboardingMessages).howToUseThesePagesWithinJira.defaultMessage,
                                    type: 'text',
                                    marks: [
                                        {
                                            type: 'strong'
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            type: 'taskList',
                            attrs: {
                                localId: ''
                            },
                            content: [
                                {
                                    type: 'taskItem',
                                    attrs: {
                                        state: 'TODO',
                                        localId: '19'
                                    },
                                    content: [
                                        {
                                            text: (0, $o8lUB.inlineOnboardingMessages).type.defaultMessage + ' ',
                                            type: 'text'
                                        },
                                        {
                                            text: '/' + (0, $o8lUB.inlineOnboardingMessages).jira.defaultMessage,
                                            type: 'text',
                                            marks: [
                                                {
                                                    type: 'code'
                                                }
                                            ]
                                        },
                                        {
                                            text: ' ' + (0, $o8lUB.inlineOnboardingMessages).task1.defaultMessage,
                                            type: 'text'
                                        }
                                    ]
                                },
                                {
                                    type: 'taskItem',
                                    attrs: {
                                        state: 'TODO',
                                        localId: '20'
                                    },
                                    content: [
                                        {
                                            text: (0, $o8lUB.inlineOnboardingMessages).task2.defaultMessage,
                                            type: 'text'
                                        }
                                    ]
                                },
                                {
                                    type: 'taskItem',
                                    attrs: {
                                        state: 'TODO',
                                        localId: '21'
                                    },
                                    content: [
                                        {
                                            text: (0, $o8lUB.inlineOnboardingMessages).type.defaultMessage + ' ',
                                            type: 'text'
                                        },
                                        {
                                            text: '/',
                                            type: 'text',
                                            marks: [
                                                {
                                                    type: 'code'
                                                }
                                            ]
                                        },
                                        {
                                            text: ' ' + (0, $o8lUB.inlineOnboardingMessages).task3.defaultMessage,
                                            type: 'text'
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            version: 1
        },
        representation: 'atlas_doc_format'
    }
};

});
parcelRegister("o8lUB", function(module, exports) {

$parcel$export(module.exports, "inlineOnboardingMessages", () => $8963f631b100daec$export$6768d9899cb6784a);

var $7VHMR = parcelRequire("7VHMR");
const $8963f631b100daec$export$6768d9899cb6784a = (0, $7VHMR.defineMessages)({
    howToUseThesePagesWithinJira: {
        id: 'project-pages.inline-onboarding.how-to-use-these-pages-within-jira',
        defaultMessage: 'How to use these pages with Jira',
        description: 'How to use these pages with Jira'
    },
    task1: {
        id: 'project-pages.inline-onboarding.task1',
        defaultMessage: 'to view a list of ways you can display Jira work on this page',
        description: 'description of how to use Jira with confluence'
    },
    task2: {
        id: 'project-pages.inline-onboarding.task2',
        defaultMessage: 'Paste a Jira task or project link - the updates you make in Jira will automatically show',
        description: 'description of how jira updates will show in confluence'
    },
    task3: {
        id: 'project-pages.inline-onboarding.task3',
        defaultMessage: 'to open a list of cool things to add, like a table to contents, dates, roadmaps, and more',
        description: 'description of how to add cool things to the page'
    },
    type: {
        id: 'project-pages.inline-onboarding.type',
        defaultMessage: 'Type',
        description: 'Type'
    },
    jira: {
        id: 'project-pages.inline-onboarding.jira',
        defaultMessage: 'Jira',
        description: 'Jira'
    }
});

});

parcelRegister("bFtEE", function(module, exports) {

$parcel$export(module.exports, "PanelType", () => $87ea86de426496d8$export$969277cf61e5a7aa);
$parcel$export(module.exports, "extendedPanel", () => $87ea86de426496d8$export$ce20b13564211141);
$parcel$export(module.exports, "panelWithoutNestedNonBodiedMacros", () => $87ea86de426496d8$export$220c665c23b9541b);

var $gthjq = parcelRequire("gthjq");
let $87ea86de426496d8$export$969277cf61e5a7aa = /*#__PURE__*/ function(PanelType) {
    PanelType["INFO"] = "info";
    PanelType["NOTE"] = "note";
    PanelType["TIP"] = "tip";
    PanelType["WARNING"] = "warning";
    PanelType["ERROR"] = "error";
    PanelType["SUCCESS"] = "success";
    PanelType["CUSTOM"] = "custom";
    return PanelType;
}({});
/**
 * @name panel_node
 */ const $87ea86de426496d8$var$getDomAttrs = (nodeAttrs)=>{
    const attrs = {
        'data-panel-type': nodeAttrs.panelType,
        'data-panel-icon': nodeAttrs.panelIcon,
        'data-panel-icon-id': nodeAttrs.panelIconId,
        'data-panel-icon-text': nodeAttrs.panelIconText,
        'data-panel-color': nodeAttrs.panelColor
    };
    return attrs;
};
const $87ea86de426496d8$var$getParseDOMAttrs = (allowCustomPanel, dom)=>{
    let parseDOMAttrs = {
        panelType: dom.getAttribute('data-panel-type')
    };
    if (allowCustomPanel) parseDOMAttrs = {
        ...parseDOMAttrs,
        panelIcon: dom.getAttribute('data-panel-icon'),
        panelIconId: dom.getAttribute('data-panel-icon-id'),
        panelIconText: dom.getAttribute('data-panel-icon-text'),
        panelColor: dom.getAttribute('data-panel-color')
    };
    else parseDOMAttrs.panelType = parseDOMAttrs.panelType === $87ea86de426496d8$export$969277cf61e5a7aa.CUSTOM ? $87ea86de426496d8$export$969277cf61e5a7aa.INFO : parseDOMAttrs.panelType;
    return parseDOMAttrs;
};
const $87ea86de426496d8$var$createPanelNodeSpecOptions = (allowCustomPanel)=>({
        parseDOM: [
            {
                tag: 'div[data-panel-type]',
                getAttrs: (dom)=>$87ea86de426496d8$var$getParseDOMAttrs(allowCustomPanel, dom)
            }
        ],
        toDOM (node) {
            const attrs = $87ea86de426496d8$var$getDomAttrs(node.attrs);
            const contentAttrs = {
                'data-panel-content': 'true'
            };
            return [
                'div',
                attrs,
                [
                    'div',
                    contentAttrs,
                    0
                ]
            ];
        }
    });
const $87ea86de426496d8$export$ce20b13564211141 = (allowCustomPanel)=>(0, $gthjq.panel)($87ea86de426496d8$var$createPanelNodeSpecOptions(allowCustomPanel));
const $87ea86de426496d8$export$220c665c23b9541b = (allowCustomPanel)=>(0, $gthjq.panelWithoutNestedNonBodiedMacros)($87ea86de426496d8$var$createPanelNodeSpecOptions(allowCustomPanel));

});
parcelRegister("gthjq", function(module, exports) {

$parcel$export(module.exports, "blockCard", () => $bfdcc8a4590754dc$export$c4c2f833baaebdb8);
$parcel$export(module.exports, "blockquote", () => $bfdcc8a4590754dc$export$67dc04e652a298ca);
$parcel$export(module.exports, "blockquoteLegacy", () => $bfdcc8a4590754dc$export$199922e5af8e9a6);
$parcel$export(module.exports, "blockquoteWithoutNestedCodeblockOrMedia", () => $bfdcc8a4590754dc$export$a91509d1c739c16f);
$parcel$export(module.exports, "blockquoteWithoutNonBodiedMacros", () => $bfdcc8a4590754dc$export$32b1dde15f5fe85b);
$parcel$export(module.exports, "bodiedExtension", () => $bfdcc8a4590754dc$export$27903d543b563e39);
$parcel$export(module.exports, "bulletList", () => $bfdcc8a4590754dc$export$a140c94e5ea26bee);
$parcel$export(module.exports, "caption", () => $bfdcc8a4590754dc$export$8e3c2dfdc4f0453d);
$parcel$export(module.exports, "codeBlock", () => $bfdcc8a4590754dc$export$7bb0d5c671655cc4);
$parcel$export(module.exports, "confluenceJiraIssue", () => $bfdcc8a4590754dc$export$daf889beb5092f95);
$parcel$export(module.exports, "confluenceUnsupportedBlock", () => $bfdcc8a4590754dc$export$e6e4878f43c27cab);
$parcel$export(module.exports, "confluenceUnsupportedInline", () => $bfdcc8a4590754dc$export$3e6d667072febc87);
$parcel$export(module.exports, "date", () => $bfdcc8a4590754dc$export$324d90190a8b822a);
$parcel$export(module.exports, "decisionItem", () => $bfdcc8a4590754dc$export$6959e16eeff859b4);
$parcel$export(module.exports, "decisionList", () => $bfdcc8a4590754dc$export$62d45a65fb43d95e);
$parcel$export(module.exports, "doc", () => $bfdcc8a4590754dc$export$2a111da947c407d2);
$parcel$export(module.exports, "embedCard", () => $bfdcc8a4590754dc$export$be4283d9a1cb1ff6);
$parcel$export(module.exports, "emoji", () => $bfdcc8a4590754dc$export$a19185d1233fc4b2);
$parcel$export(module.exports, "expand", () => $bfdcc8a4590754dc$export$9f77e0932fb78f72);
$parcel$export(module.exports, "expandWithoutNestedExpand", () => $bfdcc8a4590754dc$export$63c0f3992661097b);
$parcel$export(module.exports, "extension", () => $bfdcc8a4590754dc$export$1b45514b112dd749);
$parcel$export(module.exports, "extensionFrameStage0", () => $bfdcc8a4590754dc$export$b555be60c7703afb);
$parcel$export(module.exports, "hardBreak", () => $bfdcc8a4590754dc$export$371da9dd35aba193);
$parcel$export(module.exports, "heading", () => $bfdcc8a4590754dc$export$46e4a324ac90507f);
$parcel$export(module.exports, "image", () => $bfdcc8a4590754dc$export$5c452ff88e35e47d);
$parcel$export(module.exports, "inlineCard", () => $bfdcc8a4590754dc$export$cbf8224b64e0d942);
$parcel$export(module.exports, "inlineExtensionWithMarks", () => $bfdcc8a4590754dc$export$b3b1e36c2105006d);
$parcel$export(module.exports, "layoutColumn", () => $bfdcc8a4590754dc$export$ab76e7c03cd6f650);
$parcel$export(module.exports, "layoutSection", () => $bfdcc8a4590754dc$export$b3b6a70a7fa4a5be);
$parcel$export(module.exports, "layoutSectionFull", () => $bfdcc8a4590754dc$export$cdae19acb0a520fd);
$parcel$export(module.exports, "layoutSectionWithSingleColumnStage0", () => $bfdcc8a4590754dc$export$206007566ca0aca5);
$parcel$export(module.exports, "listItem", () => $bfdcc8a4590754dc$export$76c7e83ecc9cdf05);
$parcel$export(module.exports, "listItemWithNestedDecisionStage0", () => $bfdcc8a4590754dc$export$df876f0305235056);
$parcel$export(module.exports, "listItemWithoutNonBodiedMacros", () => $bfdcc8a4590754dc$export$171e9ff2be159af7);
$parcel$export(module.exports, "media", () => $bfdcc8a4590754dc$export$987d49ffe1b0900f);
$parcel$export(module.exports, "mediaGroup", () => $bfdcc8a4590754dc$export$2855e964765eac9);
$parcel$export(module.exports, "mediaInline", () => $bfdcc8a4590754dc$export$38bab695e3f720f1);
$parcel$export(module.exports, "mediaSingle", () => $bfdcc8a4590754dc$export$969fe3781ca15058);
$parcel$export(module.exports, "mediaSingleCaption", () => $bfdcc8a4590754dc$export$8d067f22dc2d1254);
$parcel$export(module.exports, "mediaSingleFull", () => $bfdcc8a4590754dc$export$7e767666f2ce108a);
$parcel$export(module.exports, "mediaSingleWidthType", () => $bfdcc8a4590754dc$export$4bd9a38995f6bf50);
$parcel$export(module.exports, "mention", () => $bfdcc8a4590754dc$export$db83999c14438df4);
$parcel$export(module.exports, "multiBodiedExtensionStage0", () => $bfdcc8a4590754dc$export$750e45819f66d9d0);
$parcel$export(module.exports, "nestedExpand", () => $bfdcc8a4590754dc$export$63cadbf5f4296627);
$parcel$export(module.exports, "nestedExpandWithoutNonBodiedMacros", () => $bfdcc8a4590754dc$export$15ebf236772fa336);
$parcel$export(module.exports, "orderedList", () => $bfdcc8a4590754dc$export$a5dc81035676e7a);
$parcel$export(module.exports, "panel", () => $bfdcc8a4590754dc$export$21f42ab9b6679f44);
$parcel$export(module.exports, "panelWithoutNestedNonBodiedMacros", () => $bfdcc8a4590754dc$export$220c665c23b9541b);
$parcel$export(module.exports, "paragraph", () => $bfdcc8a4590754dc$export$9c206ddddb32a9b);
$parcel$export(module.exports, "placeholder", () => $bfdcc8a4590754dc$export$c7187bbd1a7a9244);
$parcel$export(module.exports, "rule", () => $bfdcc8a4590754dc$export$fbeb3a3956e8a3c7);
$parcel$export(module.exports, "status", () => $bfdcc8a4590754dc$export$471f7ae5c4103ae1);
$parcel$export(module.exports, "table", () => $bfdcc8a4590754dc$export$9852986a3ec5f6a0);
$parcel$export(module.exports, "tableWithNestedTable", () => $bfdcc8a4590754dc$export$ce086a560a1d05f5);
$parcel$export(module.exports, "tableCell", () => $bfdcc8a4590754dc$export$e1e720e5f4603e6a);
$parcel$export(module.exports, "tableCellWithNestedTable", () => $bfdcc8a4590754dc$export$abf39ca178940ff3);
$parcel$export(module.exports, "tableHeader", () => $bfdcc8a4590754dc$export$48884d2a5190dc73);
$parcel$export(module.exports, "tableHeaderWithNestedTable", () => $bfdcc8a4590754dc$export$2a5a518232fa1a97);
$parcel$export(module.exports, "tableRow", () => $bfdcc8a4590754dc$export$ce666bf02318c957);
$parcel$export(module.exports, "tableRowWithNestedTable", () => $bfdcc8a4590754dc$export$7d657479499397);
$parcel$export(module.exports, "taskItem", () => $bfdcc8a4590754dc$export$6d8b0ef52e2e6390);
$parcel$export(module.exports, "taskList", () => $bfdcc8a4590754dc$export$375b6afcc5f4d291);
$parcel$export(module.exports, "text", () => $bfdcc8a4590754dc$export$6f093cfa640b7166);
$parcel$export(module.exports, "unsupportedBlock", () => $bfdcc8a4590754dc$export$44b79b0979d0f0f7);
$parcel$export(module.exports, "unsupportedInline", () => $bfdcc8a4590754dc$export$310ebe0d80122e9b);
/**
 * This file was automatically generated by @atlaskit/adf-schema-generator
 * DO NOT MODIFY IT BY HAND. Instead, modify the source files in "packages/adf-schema/src/next-schema" ,
 * and run "yarn workspace @atlaskit/adf-schema build:schema:all" to regenerate this file.
 */ 
var $f0ccE = parcelRequire("f0ccE");
const $bfdcc8a4590754dc$export$c4c2f833baaebdb8 = (0, $f0ccE.createPMNodeSpecFactory)({
    group: 'block',
    attrs: {
        url: {
            default: null
        },
        datasource: {
            default: null
        },
        width: {
            default: null
        },
        layout: {
            default: null
        },
        data: {
            default: null
        }
    },
    selectable: true,
    draggable: true
});
const $bfdcc8a4590754dc$export$67dc04e652a298ca = (0, $f0ccE.createPMNodeSpecFactory)({
    content: '(paragraph | orderedList | bulletList | unsupportedBlock | codeBlock | mediaSingle | mediaGroup | extension)+',
    marks: 'unsupportedMark unsupportedNodeAttribute dataConsumer fragment',
    group: 'block',
    selectable: true,
    defining: true
});
const $bfdcc8a4590754dc$export$199922e5af8e9a6 = (0, $f0ccE.createPMNodeSpecFactory)({
    content: '(paragraph | unsupportedBlock)+',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    selectable: true,
    defining: true
});
const $bfdcc8a4590754dc$export$a91509d1c739c16f = (0, $f0ccE.createPMNodeSpecFactory)({
    content: '(paragraph | orderedList | bulletList | unsupportedBlock)+',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    selectable: true,
    defining: true
});
const $bfdcc8a4590754dc$export$32b1dde15f5fe85b = (0, $f0ccE.createPMNodeSpecFactory)({
    content: '(paragraph | orderedList | bulletList | unsupportedBlock | codeBlock | mediaSingle | mediaGroup)+',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    selectable: true,
    defining: true
});
const $bfdcc8a4590754dc$export$27903d543b563e39 = (0, $f0ccE.createPMNodeSpecFactory)({
    content: '(paragraph | panel | blockquote | orderedList | bulletList | rule | heading | codeBlock | mediaGroup | mediaSingle | decisionList | taskList | table | blockCard | embedCard | extension | unsupportedBlock)+',
    marks: 'dataConsumer fragment unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    attrs: {
        extensionKey: {
            default: ''
        },
        extensionType: {
            default: ''
        },
        parameters: {
            default: null
        },
        text: {
            default: null
        },
        layout: {
            default: 'default'
        },
        localId: {
            default: null
        }
    },
    selectable: true,
    defining: true,
    isolating: true
});
const $bfdcc8a4590754dc$export$e7320d153c538837 = (0, $f0ccE.createPMNodeSpecFactory)({
    marks: 'dataConsumer fragment unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    attrs: {
        extensionKey: {
            default: ''
        },
        extensionType: {
            default: ''
        },
        parameters: {
            default: null
        },
        text: {
            default: null
        },
        layout: {
            default: 'default'
        },
        localId: {
            default: null
        }
    },
    selectable: true,
    defining: true,
    isolating: true
});
const $bfdcc8a4590754dc$export$a140c94e5ea26bee = (0, $f0ccE.createPMNodeSpecFactory)({
    content: 'listItem+',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    selectable: false
});
const $bfdcc8a4590754dc$export$8e3c2dfdc4f0453d = (0, $f0ccE.createPMNodeSpecFactory)({
    content: '(hardBreak | mention | emoji | date | placeholder | inlineCard | status | text | unsupportedInline)*',
    marks: '_',
    selectable: false,
    isolating: true
});
const $bfdcc8a4590754dc$export$7bb0d5c671655cc4 = (0, $f0ccE.createPMNodeSpecFactory)({
    content: '(text | unsupportedInline)*',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    attrs: {
        language: {
            default: null
        },
        uniqueId: {
            default: null
        }
    },
    code: true,
    defining: true
});
const $bfdcc8a4590754dc$export$e4f1c66d84049f8b = (0, $f0ccE.createPMNodeSpecFactory)({
    content: '(text | unsupportedInline)*',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    attrs: {
        language: {
            default: null
        },
        uniqueId: {
            default: null
        }
    },
    code: true,
    defining: true
});
const $bfdcc8a4590754dc$export$daf889beb5092f95 = (0, $f0ccE.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    atom: true,
    attrs: {
        issueKey: {
            default: ''
        },
        macroId: {
            default: null
        },
        schemaVersion: {
            default: null
        },
        server: {
            default: null
        },
        serverId: {
            default: null
        }
    }
});
const $bfdcc8a4590754dc$export$e6e4878f43c27cab = (0, $f0ccE.createPMNodeSpecFactory)({
    group: 'block',
    attrs: {
        cxhtml: {
            default: null
        }
    }
});
const $bfdcc8a4590754dc$export$3e6d667072febc87 = (0, $f0ccE.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    atom: true,
    attrs: {
        cxhtml: {
            default: null
        }
    }
});
const $bfdcc8a4590754dc$export$324d90190a8b822a = (0, $f0ccE.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        timestamp: {
            default: ''
        }
    },
    selectable: true
});
const $bfdcc8a4590754dc$export$47988d68fe575725 = (0, $f0ccE.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        timestamp: {
            default: ''
        }
    },
    selectable: true
});
const $bfdcc8a4590754dc$export$6959e16eeff859b4 = (0, $f0ccE.createPMNodeSpecFactory)({
    content: 'inline*',
    marks: '_',
    attrs: {
        localId: {
            default: ''
        },
        state: {
            default: 'DECIDED'
        }
    },
    defining: true
});
const $bfdcc8a4590754dc$export$62d45a65fb43d95e = (0, $f0ccE.createPMNodeSpecFactory)({
    content: '(decisionItem | unsupportedBlock)+',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    attrs: {
        localId: {
            default: ''
        }
    },
    selectable: false,
    defining: true
});
const $bfdcc8a4590754dc$export$2a111da947c407d2 = (0, $f0ccE.createPMNodeSpecFactory)({
    content: '(block | codeBlock | layoutSection | blockRootOnly | expand)+',
    marks: 'unsupportedMark unsupportedNodeAttribute alignment indentation dataConsumer fragment breakout'
});
const $bfdcc8a4590754dc$export$be4283d9a1cb1ff6 = (0, $f0ccE.createPMNodeSpecFactory)({
    group: 'block',
    attrs: {
        url: {
            default: ''
        },
        layout: {
            default: 'center'
        },
        width: {
            default: 100
        },
        originalHeight: {
            default: null
        },
        originalWidth: {
            default: null
        }
    },
    selectable: true
});
const $bfdcc8a4590754dc$export$a19185d1233fc4b2 = (0, $f0ccE.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        shortName: {
            default: ''
        },
        id: {
            default: ''
        },
        text: {
            default: ''
        }
    },
    selectable: true
});
const $bfdcc8a4590754dc$export$f5574b5d45fc2112 = (0, $f0ccE.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        shortName: {
            default: ''
        },
        id: {
            default: ''
        },
        text: {
            default: ''
        }
    },
    selectable: true
});
const $bfdcc8a4590754dc$export$9f77e0932fb78f72 = (0, $f0ccE.createPMNodeSpecFactory)({
    content: '(paragraph | panel | blockquote | orderedList | bulletList | rule | heading | codeBlock | mediaGroup | mediaSingle | decisionList | taskList | table | blockCard | embedCard | extension | unsupportedBlock | nestedExpand)+',
    marks: 'unsupportedMark unsupportedNodeAttribute fragment dataConsumer',
    group: 'block',
    attrs: {
        title: {
            default: ''
        },
        __expanded: {
            default: true
        }
    },
    selectable: true,
    isolating: true
});
const $bfdcc8a4590754dc$export$7e3788972005cc72 = (0, $f0ccE.createPMNodeSpecFactory)({
    content: '(paragraph | panel | blockquote | orderedList | bulletList | rule | heading | codeBlock | mediaGroup | mediaSingle | decisionList | taskList | table | blockCard | embedCard | extension | unsupportedBlock | nestedExpand)+',
    marks: 'unsupportedMark unsupportedNodeAttribute fragment dataConsumer',
    attrs: {
        title: {
            default: ''
        },
        __expanded: {
            default: true
        }
    },
    selectable: true,
    isolating: true
});
const $bfdcc8a4590754dc$export$63c0f3992661097b = (0, $f0ccE.createPMNodeSpecFactory)({
    content: '(paragraph | panel | blockquote | orderedList | bulletList | rule | heading | codeBlock | mediaGroup | mediaSingle | decisionList | taskList | table | blockCard | embedCard | extension | unsupportedBlock)+',
    marks: 'unsupportedMark unsupportedNodeAttribute fragment dataConsumer',
    group: 'block',
    attrs: {
        title: {
            default: ''
        },
        __expanded: {
            default: true
        }
    },
    selectable: true,
    isolating: true
});
const $bfdcc8a4590754dc$export$1b45514b112dd749 = (0, $f0ccE.createPMNodeSpecFactory)({
    group: 'block',
    atom: true,
    attrs: {
        extensionKey: {
            default: ''
        },
        extensionType: {
            default: ''
        },
        parameters: {
            default: null
        },
        text: {
            default: null
        },
        layout: {
            default: 'default'
        },
        localId: {
            default: null
        }
    },
    selectable: true
});
const $bfdcc8a4590754dc$export$a8baf338431a691 = (0, $f0ccE.createPMNodeSpecFactory)({
    group: 'block',
    atom: true,
    attrs: {
        extensionKey: {
            default: ''
        },
        extensionType: {
            default: ''
        },
        parameters: {
            default: null
        },
        text: {
            default: null
        },
        layout: {
            default: 'default'
        },
        localId: {
            default: null
        }
    },
    selectable: true
});
const $bfdcc8a4590754dc$export$b555be60c7703afb = (0, $f0ccE.createPMNodeSpecFactory)({
    content: '(paragraph | panel | blockquote | orderedList | bulletList | rule | heading | codeBlock | mediaGroup | mediaSingle | decisionList | taskList | table | extension | bodiedExtension | unsupportedBlock | blockCard | embedCard)+',
    marks: 'dataConsumer fragment unsupportedMark unsupportedNodeAttribute',
    attrs: {},
    selectable: false,
    definingAsContext: false,
    definingForContent: true,
    isolating: true
});
const $bfdcc8a4590754dc$export$371da9dd35aba193 = (0, $f0ccE.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        text: {
            default: '\n'
        }
    },
    selectable: false,
    linebreakReplacement: true
});
const $bfdcc8a4590754dc$export$46e4a324ac90507f = (0, $f0ccE.createPMNodeSpecFactory)({
    content: 'inline*',
    marks: 'link em strong strike subsup underline textColor annotation backgroundColor typeAheadQuery confluenceInlineComment unsupportedNodeAttribute unsupportedMark code dataConsumer fragment border',
    group: 'block',
    attrs: {
        level: {
            default: 1
        },
        localId: {
            default: null
        }
    },
    selectable: false,
    defining: true
});
const $bfdcc8a4590754dc$export$1b0c1557b234fa00 = (0, $f0ccE.createPMNodeSpecFactory)({
    group: 'block',
    attrs: {
        level: {
            default: 1
        },
        localId: {
            default: null
        }
    },
    selectable: false,
    defining: true
});
const $bfdcc8a4590754dc$export$85461f751c457cc2 = (0, $f0ccE.createPMNodeSpecFactory)({
    group: 'block',
    attrs: {
        level: {
            default: 1
        },
        localId: {
            default: null
        }
    },
    selectable: false,
    defining: true
});
const $bfdcc8a4590754dc$export$2b380a0f7e250af1 = (0, $f0ccE.createPMNodeSpecFactory)({
    group: 'block',
    attrs: {
        level: {
            default: 1
        },
        localId: {
            default: null
        }
    },
    selectable: false,
    defining: true
});
const $bfdcc8a4590754dc$export$5c452ff88e35e47d = (0, $f0ccE.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        src: {
            default: ''
        },
        alt: {
            default: ''
        },
        title: {
            default: null
        }
    },
    draggable: true
});
const $bfdcc8a4590754dc$export$cbf8224b64e0d942 = (0, $f0ccE.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        url: {
            default: null
        },
        data: {
            default: null
        }
    },
    selectable: true,
    draggable: true
});
const $bfdcc8a4590754dc$export$2f4e72b9459914ad = (0, $f0ccE.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        url: {
            default: null
        },
        data: {
            default: null
        }
    },
    selectable: true,
    draggable: true
});
const $bfdcc8a4590754dc$export$16b353b2649bd8d9 = (0, $f0ccE.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        extensionKey: {
            default: ''
        },
        extensionType: {
            default: ''
        },
        parameters: {
            default: null
        },
        text: {
            default: null
        },
        localId: {
            default: null
        }
    },
    selectable: true
});
const $bfdcc8a4590754dc$export$b3b1e36c2105006d = (0, $f0ccE.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        extensionKey: {
            default: ''
        },
        extensionType: {
            default: ''
        },
        parameters: {
            default: null
        },
        text: {
            default: null
        },
        localId: {
            default: null
        }
    },
    selectable: true
});
const $bfdcc8a4590754dc$export$ab76e7c03cd6f650 = (0, $f0ccE.createPMNodeSpecFactory)({
    content: '(block | unsupportedBlock)+',
    marks: 'unsupportedMark unsupportedNodeAttribute alignment indentation dataConsumer fragment',
    attrs: {
        width: {
            default: undefined
        }
    },
    selectable: false,
    isolating: true
});
const $bfdcc8a4590754dc$export$b3b6a70a7fa4a5be = (0, $f0ccE.createPMNodeSpecFactory)({
    content: '(layoutColumn | unsupportedBlock){1,3} unsupportedBlock*',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    isolating: true
});
const $bfdcc8a4590754dc$export$cdae19acb0a520fd = (0, $f0ccE.createPMNodeSpecFactory)({
    content: '(layoutColumn | unsupportedBlock){2,3}',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    isolating: true
});
const $bfdcc8a4590754dc$export$206007566ca0aca5 = (0, $f0ccE.createPMNodeSpecFactory)({
    content: '(layoutColumn | unsupportedBlock){1,5} unsupportedBlock*',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    attrs: {
        columnRuleStyle: {
            default: null
        }
    },
    isolating: true
});
const $bfdcc8a4590754dc$export$76c7e83ecc9cdf05 = (0, $f0ccE.createPMNodeSpecFactory)({
    content: '(paragraph | mediaSingle | codeBlock | unsupportedBlock | extension) (paragraph | bulletList | orderedList | taskList | mediaSingle | codeBlock | unsupportedBlock | extension)*',
    marks: 'dataConsumer fragment unsupportedMark unsupportedNodeAttribute',
    selectable: false,
    defining: true
});
const $bfdcc8a4590754dc$export$df876f0305235056 = (0, $f0ccE.createPMNodeSpecFactory)({
    content: '(paragraph | mediaSingle | codeBlock | unsupportedBlock | decisionList | extension) (paragraph | bulletList | orderedList | taskList | mediaSingle | codeBlock | unsupportedBlock | decisionList | extension)*',
    marks: 'unsupportedMark unsupportedNodeAttribute dataConsumer fragment',
    selectable: false,
    defining: true
});
const $bfdcc8a4590754dc$export$171e9ff2be159af7 = (0, $f0ccE.createPMNodeSpecFactory)({
    content: '(paragraph | mediaSingle | codeBlock | unsupportedBlock) (paragraph | bulletList | orderedList | taskList | mediaSingle | codeBlock | unsupportedBlock)*',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    selectable: false,
    defining: true
});
const $bfdcc8a4590754dc$export$987d49ffe1b0900f = (0, $f0ccE.createPMNodeSpecFactory)({
    attrs: {
        type: {
            default: 'file'
        },
        id: {
            default: ''
        },
        alt: {
            default: ''
        },
        collection: {
            default: ''
        },
        height: {
            default: null
        },
        occurrenceKey: {
            default: null
        },
        width: {
            default: null
        },
        __contextId: {
            default: null
        },
        __displayType: {
            default: null
        },
        __external: {
            default: false
        },
        __fileMimeType: {
            default: null
        },
        __fileName: {
            default: null
        },
        __fileSize: {
            default: null
        },
        __mediaTraceId: {
            default: null
        },
        url: {
            default: null
        }
    },
    selectable: true
});
const $bfdcc8a4590754dc$export$2855e964765eac9 = (0, $f0ccE.createPMNodeSpecFactory)({
    content: '(media | unsupportedBlock)+',
    marks: 'link annotation border unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    attrs: {},
    selectable: false
});
const $bfdcc8a4590754dc$export$38bab695e3f720f1 = (0, $f0ccE.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        type: {
            default: 'file'
        },
        url: {
            default: null
        },
        id: {
            default: ''
        },
        alt: {
            default: ''
        },
        collection: {
            default: ''
        },
        occurrenceKey: {
            default: null
        },
        width: {
            default: null
        },
        height: {
            default: null
        },
        __fileName: {
            default: null
        },
        __fileSize: {
            default: null
        },
        __fileMimeType: {
            default: null
        },
        __displayType: {
            default: null
        },
        __contextId: {
            default: null
        },
        __mediaTraceId: {
            default: null
        },
        __external: {
            default: false
        }
    },
    selectable: true
});
const $bfdcc8a4590754dc$export$969fe3781ca15058 = (0, $f0ccE.createPMNodeSpecFactory)({
    group: 'block',
    atom: true,
    attrs: {
        layout: {
            default: 'center'
        },
        width: {
            default: null
        }
    },
    selectable: true,
    content: 'media|unsupportedBlock+|media unsupportedBlock+',
    marks: 'annotation border link unsupportedMark unsupportedNodeAttribute'
});
const $bfdcc8a4590754dc$export$8d067f22dc2d1254 = (0, $f0ccE.createPMNodeSpecFactory)({
    content: 'media|unsupportedBlock+|media (caption|unsupportedBlock) unsupportedBlock*',
    marks: 'link annotation border unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    atom: false,
    attrs: {
        layout: {
            default: 'center'
        },
        width: {
            default: null
        }
    },
    selectable: true
});
const $bfdcc8a4590754dc$export$7e767666f2ce108a = (0, $f0ccE.createPMNodeSpecFactory)({
    content: 'media|unsupportedBlock+|media (caption|unsupportedBlock) unsupportedBlock*',
    marks: 'link annotation border unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    atom: false,
    attrs: {
        width: {
            default: null
        },
        layout: {
            default: 'center'
        },
        widthType: {
            default: null
        }
    },
    selectable: true
});
const $bfdcc8a4590754dc$export$4bd9a38995f6bf50 = (0, $f0ccE.createPMNodeSpecFactory)({
    content: 'media|unsupportedBlock+|media unsupportedBlock+',
    marks: 'link annotation border unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    atom: true,
    attrs: {
        width: {
            default: null
        },
        layout: {
            default: 'center'
        },
        widthType: {
            default: null
        }
    },
    selectable: true
});
const $bfdcc8a4590754dc$export$db83999c14438df4 = (0, $f0ccE.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        id: {
            default: ''
        },
        localId: {
            default: null
        },
        text: {
            default: ''
        },
        accessLevel: {
            default: ''
        },
        userType: {
            default: null
        }
    },
    selectable: true
});
const $bfdcc8a4590754dc$export$46f790bd65f760d0 = (0, $f0ccE.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        id: {
            default: ''
        },
        localId: {
            default: null
        },
        text: {
            default: ''
        },
        accessLevel: {
            default: ''
        },
        userType: {
            default: null
        }
    },
    selectable: true
});
const $bfdcc8a4590754dc$export$750e45819f66d9d0 = (0, $f0ccE.createPMNodeSpecFactory)({
    content: 'extensionFrame+',
    marks: 'unsupportedNodeAttribute unsupportedMark',
    group: 'blockRootOnly',
    attrs: {
        extensionKey: {
            default: ''
        },
        extensionType: {
            default: ''
        },
        parameters: {
            default: null
        },
        text: {
            default: null
        },
        layout: {
            default: 'default'
        },
        localId: {
            default: null
        }
    },
    selectable: true,
    definingAsContext: true
});
const $bfdcc8a4590754dc$export$63cadbf5f4296627 = (0, $f0ccE.createPMNodeSpecFactory)({
    content: '(paragraph | heading | mediaSingle | mediaGroup | codeBlock | bulletList | orderedList | taskList | decisionList | rule | panel | blockquote | unsupportedBlock | extension)+',
    marks: 'unsupportedMark unsupportedNodeAttribute dataConsumer fragment',
    attrs: {
        title: {
            default: ''
        },
        __expanded: {
            default: true
        }
    },
    selectable: true,
    isolating: true
});
const $bfdcc8a4590754dc$export$f03786aa6312d1e4 = (0, $f0ccE.createPMNodeSpecFactory)({
    attrs: {
        title: {
            default: ''
        },
        __expanded: {
            default: true
        }
    },
    selectable: true,
    isolating: true
});
const $bfdcc8a4590754dc$export$15ebf236772fa336 = (0, $f0ccE.createPMNodeSpecFactory)({
    content: '(paragraph | heading | mediaSingle | mediaGroup | codeBlock | bulletList | orderedList | taskList | decisionList | rule | panel | blockquote | unsupportedBlock)+',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    attrs: {
        title: {
            default: ''
        },
        __expanded: {
            default: true
        }
    },
    selectable: true,
    isolating: true
});
const $bfdcc8a4590754dc$export$a5dc81035676e7a = (0, $f0ccE.createPMNodeSpecFactory)({
    content: 'listItem+',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    attrs: {
        order: {
            default: 1
        }
    },
    selectable: false
});
const $bfdcc8a4590754dc$export$21f42ab9b6679f44 = (0, $f0ccE.createPMNodeSpecFactory)({
    content: '(paragraph | heading | bulletList | orderedList | blockCard | mediaGroup | mediaSingle | codeBlock | taskList | rule | decisionList | unsupportedBlock | extension)+',
    marks: 'unsupportedMark unsupportedNodeAttribute dataConsumer fragment',
    group: 'block',
    attrs: {
        panelType: {
            default: 'info'
        },
        panelIcon: {
            default: null
        },
        panelIconId: {
            default: null
        },
        panelIconText: {
            default: null
        },
        panelColor: {
            default: null
        }
    },
    selectable: true
});
const $bfdcc8a4590754dc$export$220c665c23b9541b = (0, $f0ccE.createPMNodeSpecFactory)({
    content: '(paragraph | heading | bulletList | orderedList | blockCard | mediaGroup | mediaSingle | codeBlock | taskList | rule | decisionList | unsupportedBlock)+',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    attrs: {
        panelType: {
            default: 'info'
        },
        panelIcon: {
            default: null
        },
        panelIconId: {
            default: null
        },
        panelIconText: {
            default: null
        },
        panelColor: {
            default: null
        }
    },
    selectable: true
});
const $bfdcc8a4590754dc$export$9c206ddddb32a9b = (0, $f0ccE.createPMNodeSpecFactory)({
    content: 'inline*',
    marks: 'link em strong strike subsup underline textColor annotation backgroundColor typeAheadQuery confluenceInlineComment unsupportedNodeAttribute unsupportedMark code dataConsumer fragment border',
    group: 'block',
    attrs: {
        localId: {
            default: null
        }
    },
    selectable: false
});
const $bfdcc8a4590754dc$export$4f98472e6dc14293 = (0, $f0ccE.createPMNodeSpecFactory)({
    group: 'block',
    attrs: {
        localId: {
            default: null
        }
    },
    selectable: false
});
const $bfdcc8a4590754dc$export$ea332b61641b0588 = (0, $f0ccE.createPMNodeSpecFactory)({
    group: 'block',
    attrs: {
        localId: {
            default: null
        }
    },
    selectable: false
});
const $bfdcc8a4590754dc$export$a1f41dc4901771f8 = (0, $f0ccE.createPMNodeSpecFactory)({
    group: 'block',
    attrs: {
        localId: {
            default: null
        }
    },
    selectable: false
});
const $bfdcc8a4590754dc$export$c7187bbd1a7a9244 = (0, $f0ccE.createPMNodeSpecFactory)({
    marks: '',
    group: 'inline',
    inline: true,
    attrs: {
        text: {
            default: ''
        }
    },
    selectable: false
});
const $bfdcc8a4590754dc$export$fbeb3a3956e8a3c7 = (0, $f0ccE.createPMNodeSpecFactory)({
    group: 'block'
});
const $bfdcc8a4590754dc$export$471f7ae5c4103ae1 = (0, $f0ccE.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        text: {
            default: ''
        },
        color: {
            default: ''
        },
        localId: {
            default: ''
        },
        style: {
            default: ''
        }
    },
    selectable: true
});
const $bfdcc8a4590754dc$export$b6ce52be8d7a261 = (0, $f0ccE.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        text: {
            default: ''
        },
        color: {
            default: ''
        },
        localId: {
            default: ''
        },
        style: {
            default: ''
        }
    },
    selectable: true
});
const $bfdcc8a4590754dc$export$9852986a3ec5f6a0 = (0, $f0ccE.createPMNodeSpecFactory)({
    content: 'tableRow+',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    attrs: {
        displayMode: {
            default: null
        },
        isNumberColumnEnabled: {
            default: false
        },
        layout: {
            default: 'default'
        },
        localId: {
            default: ''
        },
        width: {
            default: null
        },
        __autoSize: {
            default: false
        }
    },
    selectable: true,
    isolating: true,
    tableRole: 'table'
});
const $bfdcc8a4590754dc$export$ce086a560a1d05f5 = (0, $f0ccE.createPMNodeSpecFactory)({
    content: 'tableRow+',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    attrs: {
        displayMode: {
            default: null
        },
        isNumberColumnEnabled: {
            default: false
        },
        layout: {
            default: 'default'
        },
        localId: {
            default: ''
        },
        width: {
            default: null
        },
        __autoSize: {
            default: false
        }
    },
    selectable: true,
    isolating: true,
    tableRole: 'table'
});
const $bfdcc8a4590754dc$export$e1e720e5f4603e6a = (0, $f0ccE.createPMNodeSpecFactory)({
    content: '(paragraph | panel | blockquote | orderedList | bulletList | rule | heading | codeBlock | mediaSingle | mediaGroup | decisionList | taskList | blockCard | embedCard | extension | nestedExpand | unsupportedBlock)+',
    marks: 'alignment unsupportedMark unsupportedNodeAttribute dataConsumer fragment',
    attrs: {
        colspan: {
            default: 1
        },
        rowspan: {
            default: 1
        },
        colwidth: {
            default: null
        },
        background: {
            default: null
        }
    },
    selectable: false,
    isolating: true,
    tableRole: 'cell'
});
const $bfdcc8a4590754dc$export$abf39ca178940ff3 = (0, $f0ccE.createPMNodeSpecFactory)({
    content: '(paragraph | panel | blockquote | orderedList | bulletList | rule | heading | codeBlock | mediaSingle | mediaGroup | decisionList | taskList | blockCard | embedCard | extension | nestedExpand | unsupportedBlock | table)+',
    marks: 'alignment unsupportedMark unsupportedNodeAttribute dataConsumer fragment',
    attrs: {
        colspan: {
            default: 1
        },
        rowspan: {
            default: 1
        },
        colwidth: {
            default: null
        },
        background: {
            default: null
        }
    },
    selectable: false,
    isolating: true,
    tableRole: 'cell'
});
const $bfdcc8a4590754dc$export$48884d2a5190dc73 = (0, $f0ccE.createPMNodeSpecFactory)({
    content: '(paragraph | panel | blockquote | orderedList | bulletList | rule | heading | codeBlock | mediaSingle | mediaGroup | decisionList | taskList | blockCard | embedCard | extension | nestedExpand)+',
    marks: 'alignment unsupportedMark unsupportedNodeAttribute dataConsumer fragment',
    attrs: {
        colspan: {
            default: 1
        },
        rowspan: {
            default: 1
        },
        colwidth: {
            default: null
        },
        background: {
            default: null
        }
    },
    selectable: false,
    isolating: true,
    tableRole: 'header_cell'
});
const $bfdcc8a4590754dc$export$2a5a518232fa1a97 = (0, $f0ccE.createPMNodeSpecFactory)({
    content: '(paragraph | panel | blockquote | orderedList | bulletList | rule | heading | codeBlock | mediaSingle | mediaGroup | decisionList | taskList | blockCard | embedCard | extension | nestedExpand | table)+',
    marks: 'alignment unsupportedMark unsupportedNodeAttribute dataConsumer fragment',
    attrs: {
        colspan: {
            default: 1
        },
        rowspan: {
            default: 1
        },
        colwidth: {
            default: null
        },
        background: {
            default: null
        }
    },
    selectable: false,
    isolating: true,
    tableRole: 'header_cell'
});
const $bfdcc8a4590754dc$export$ce666bf02318c957 = (0, $f0ccE.createPMNodeSpecFactory)({
    content: '(tableCell | tableHeader)+',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    selectable: false,
    tableRole: 'row'
});
const $bfdcc8a4590754dc$export$7d657479499397 = (0, $f0ccE.createPMNodeSpecFactory)({
    content: '(tableCell | tableHeader)+',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    selectable: false,
    tableRole: 'row'
});
const $bfdcc8a4590754dc$export$6d8b0ef52e2e6390 = (0, $f0ccE.createPMNodeSpecFactory)({
    content: 'inline*',
    marks: '_',
    attrs: {
        localId: {
            default: ''
        },
        state: {
            default: 'TODO'
        }
    },
    selectable: false,
    defining: true
});
const $bfdcc8a4590754dc$export$375b6afcc5f4d291 = (0, $f0ccE.createPMNodeSpecFactory)({
    content: '(taskItem | unsupportedBlock)+ (taskItem | taskList | unsupportedBlock)*',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    attrs: {
        localId: {
            default: ''
        }
    },
    selectable: false,
    defining: true
});
const $bfdcc8a4590754dc$export$6f093cfa640b7166 = (0, $f0ccE.createPMNodeSpecFactory)({
    group: 'inline'
});
const $bfdcc8a4590754dc$export$5ea06bc686c59dc2 = (0, $f0ccE.createPMNodeSpecFactory)({
    group: 'inline'
});
const $bfdcc8a4590754dc$export$93256a4c17b33a82 = (0, $f0ccE.createPMNodeSpecFactory)({
    group: 'inline'
});
const $bfdcc8a4590754dc$export$a12828d0f14a2762 = (0, $f0ccE.createPMNodeSpecFactory)({});
const $bfdcc8a4590754dc$export$44b79b0979d0f0f7 = (0, $f0ccE.createPMNodeSpecFactory)({
    group: 'block',
    atom: true,
    attrs: {
        originalValue: {
            default: {}
        }
    },
    selectable: true
});
const $bfdcc8a4590754dc$export$310ebe0d80122e9b = (0, $f0ccE.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        originalValue: {
            default: {}
        }
    },
    selectable: true
});

});
parcelRegister("f0ccE", function(module, exports) {

$parcel$export(module.exports, "createPMNodeSpecFactory", () => $aec0525c0df12bb9$export$bf0a80f00e2b8ff6);
$parcel$export(module.exports, "createPMMarkSpecFactory", () => $aec0525c0df12bb9$export$cf5823ed4e9f4c6f);
/**
 * Factory method to attach custom parseDOM and/or toDOM for nodeSpec
 *
 * @example
 * createPMNodeSpecFactory<SomeNode>(node)({parseDOM: {}, toDOM: (node) => {} });
 *
 * @param nodeSpec - NodeSpec without toDom and parseDom
 * @returns A function for a node which allows the consumer to define toDom and parseDom
 */ const $aec0525c0df12bb9$export$bf0a80f00e2b8ff6 = (nodeSpec)=>({ parseDOM: parseDOM, toDOM: toDOM, toDebugString: toDebugString })=>{
        return {
            ...nodeSpec,
            ...parseDOM && {
                parseDOM: parseDOM
            },
            ...toDOM && {
                toDOM: toDOM
            },
            ...toDebugString && {
                toDebugString: toDebugString
            }
        };
    };
const $aec0525c0df12bb9$export$cf5823ed4e9f4c6f = (markSpec)=>({ parseDOM: parseDOM, toDOM: toDOM, toDebugString: toDebugString })=>{
        return {
            ...markSpec,
            ...parseDOM && {
                parseDOM: parseDOM
            },
            ...toDOM && {
                toDOM: toDOM
            },
            ...toDebugString && {
                toDebugString: toDebugString
            }
        };
    };

});






parcelRegister("2b05O", function(module, exports) {

$parcel$export(module.exports, "getTutorialContent", () => $b2ef5b4d8194d96b$export$24a8368452d5530a);

var $VSDnB = parcelRequire("VSDnB");

var $1Cyxi = parcelRequire("1Cyxi");
const $b2ef5b4d8194d96b$export$24a8368452d5530a = (intl, isProjectPagesSporkRebrandingEnabled = false)=>{
    const tutorialContentShippingSpeedStatistic = intl.formatMessage((0, $1Cyxi.default).tutorialContentShippingSpeedStatistic);
    const tutorialContentShippingSpeedStatisticSporkRebranding = intl.formatMessage((0, $1Cyxi.default).tutorialContentShippingSpeedStatisticSporkRebranding);
    const tutorialContentGettingStatedTips = intl.formatMessage((0, $1Cyxi.default).tutorialContentGettingStatedTips);
    const tutorialContentConfluenceTemplates = intl.formatMessage((0, $1Cyxi.default).tutorialContentConfluenceTemplates, {
        a: (...chunks)=>`<a href="https://www.atlassian.com/software/confluence/templates">${chunks}</a>`,
        b: (...chunks)=>`<strong>${chunks}</strong>`
    });
    const tutorialContentEditAndFormat = intl.formatMessage((0, $1Cyxi.default).tutorialContentEditAndFormat, {
        b: (...chunks)=>`<strong>${chunks}</strong>`,
        c: (...chunks)=>`<code>${chunks}</code>`
    });
    const tutorialContentSpacesAndPages = intl.formatMessage((0, $1Cyxi.default).tutorialContentSpacesAndPages, {
        a: (...chunks)=>`<a href="https://www.atlassian.com/software/confluence/guides/get-started/set-up">${chunks}</a>`,
        b: (...chunks)=>`<strong>${chunks}</strong>`
    });
    const tutorialContentJiraAndConfluence = intl.formatMessage((0, $1Cyxi.default).tutorialContentJiraAndConfluence);
    const tutorialContentJiraLinks = intl.formatMessage(// eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
    (0, $VSDnB.fg)('confluence-issue-terminology-refresh') ? (0, $1Cyxi.default).tutorialContentJiraLinksIssueTermRefresh : (0, $1Cyxi.default).tutorialContentJiraLinks, {
        c: (...chunks)=>`<code>${chunks}</code>`
    });
    const tutorialContentJiraTimeline = intl.formatMessage((0, $1Cyxi.default).tutorialContentJiraTimeline, {
        c: (...chunks)=>`<code>${chunks}</code>`
    });
    const tutorialContentJiraCharts = intl.formatMessage((0, $1Cyxi.default).tutorialContentJiraCharts, {
        c: (...chunks)=>`<code>${chunks}</code>`
    });
    const tutorialContentTryItNow = intl.formatMessage((0, $1Cyxi.default).tutorialContentTryItNow);
    const tutorialContentForwardSlashPrompt = intl.formatMessage((0, $1Cyxi.default).tutorialContentForwardSlashPrompt);
    const tutorialContentHandyLinks = intl.formatMessage((0, $1Cyxi.default).tutorialContentHandyLinks);
    const content = `<h4><ac:emoticon ac:name="blue-star" ac:emoji-shortname=":rocket:" ac:emoji-id="1f680" ac:emoji-fallback="\u{1F680}" /><strong>${isProjectPagesSporkRebrandingEnabled ? tutorialContentShippingSpeedStatisticSporkRebranding : tutorialContentShippingSpeedStatistic}</strong></h4><p>${tutorialContentGettingStatedTips}</p><ul><li><p>${tutorialContentConfluenceTemplates}</p></li><li><p>${tutorialContentEditAndFormat}</p></li><li><p>${tutorialContentSpacesAndPages}</p></li></ul><h3><ac:emoticon ac:name="blue-star" ac:emoji-shortname=":palms_up_together:" ac:emoji-id="1f932" ac:emoji-fallback="\u{1F932}" />${tutorialContentJiraAndConfluence}</h3><ul><li><p>${tutorialContentJiraLinks}</p></li><li><p>${tutorialContentJiraTimeline}</p></li><li><p>${tutorialContentJiraCharts}</p></li></ul>${isProjectPagesSporkRebrandingEnabled ? '' : '<a href="https://www.youtube.com/watch?v=ohtDFXNAUns&amp;t=1s" data-layout="center" data-original-height="480.00" data-width="66.67" data-original-width="853.34" data-card-appearance="embed">https://www.youtube.com/watch?v=ohtDFXNAUns&amp;t=1s</a>'}<ac:structured-macro ac:name="tip" ac:schema-version="1" ac:macro-id="45fcf348-9a07-42f8-b131-b48f9b1e50b3"><ac:rich-text-body><h3><strong><span style="color: rgb(54,179,126);">${tutorialContentTryItNow}</span></strong><ac:emoticon ac:name="blue-star" ac:emoji-shortname=":point_down:" ac:emoji-id="1f447" ac:emoji-fallback="\u{1F447}" /></h3></ac:rich-text-body></ac:structured-macro><table data-layout="default" ac:local-id="3b898e26-4024-4420-9593-3646c925e48b"><colgroup><col style="width: 680.0px;" /></colgroup><tbody><tr><th data-highlight-colour="#ffffff"><p><span style="color: rgb(151,160,175);">${tutorialContentForwardSlashPrompt}</span></p><p> </p></th></tr></tbody></table><p /><p> <ac:emoticon ac:name="blue-star" ac:emoji-shortname=":ok_hand:" ac:emoji-id="1f44c" ac:emoji-fallback="\u{1F44C}" />${tutorialContentHandyLinks}</p><p><a href="https://www.atlassian.com/software/confluence/jira-integration" data-card-appearance="inline">https://www.atlassian.com/software/confluence/jira-integration</a> </p><p><a href="https://www.youtube.com/watch?v=ybQIV15BO44" data-card-appearance="inline">https://www.youtube.com/watch?v=ybQIV15BO44</a> </p><p><a href="https://www.atlassian.com/software/confluence/guides" data-card-appearance="inline">https://www.atlassian.com/software/confluence/guides</a> </p><hr role="presentation" /><p />`;
    return content;
};

});
parcelRegister("1Cyxi", function(module, exports) {

$parcel$export(module.exports, "default", () => $858f4fa38faed59c$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $858f4fa38faed59c$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    tutorialContentShippingSpeedStatistic: {
        id: 'project-pages.improvement.templates.tutorial.content.shipping-speed-statistic',
        defaultMessage: ' 76% of Jira Software customers said they shipped projects faster after adding Confluence',
        description: 'Customers statistic on development speed improvement when using Confluence'
    },
    tutorialContentShippingSpeedStatisticSporkRebranding: {
        id: 'project-pages.improvement.templates.tutorial.content.shipping-speed-statistic.spork-rebranding',
        defaultMessage: ' 76% of Jira customers said they shipped projects faster after adding Confluence',
        description: 'Customers statistic on development speed improvement when using Confluence'
    },
    tutorialContentGettingStatedTips: {
        id: 'project-pages.improvement.templates.tutorial.content.getting-started-tips',
        defaultMessage: 'Here are a couple of tips to get you started:',
        description: 'Intro text for Confluence tips list'
    },
    tutorialContentConfluenceTemplates: {
        id: 'project-pages.improvement.templates.tutorial.content.confluence-templates',
        defaultMessage: '<b>Save time and reduce manual tasks</b>. Confluence has lots of page <a>templates</a>, so you never have to start from scratch. Think technical documents, troubleshooting guides, project plans, product requirements, and more.',
        description: 'Hint on advantages of using Confluence templates'
    },
    tutorialContentEditAndFormat: {
        id: 'project-pages.improvement.templates.tutorial.content.edit-and-format',
        defaultMessage: '<b>Easily edit and format.</b> Use the top editing menu for standard word formatting, and by typing <b>/</b> you can easily insert lots of handy integrations. Insert a table by typing <c>/table</c> or an image with <c>/image</c>. You can also insert Dropbox links <c>/dropbox</c>, Microsoft office tools <c>/microsoft</c>, or Trello boards and cards <c>/trello</c>.',
        description: 'Hint for info on editing and formatting Confluence documents'
    },
    tutorialContentSpacesAndPages: {
        id: 'project-pages.improvement.templates.tutorial.content.spaces-and-pages',
        defaultMessage: '<b>Using spaces and pages</b>. Spaces are part of every Confluence site and are a way of organizing pages into categories. Think of spaces as different folders or projects, and pages are the documents that belong in those folders or projects. <a>Learn more about how to use spaces</a>',
        description: 'Hint for info on Confluence spaces'
    },
    tutorialContentJiraAndConfluence: {
        id: 'project-pages.improvement.templates.tutorial.content.jira-and-confluence',
        defaultMessage: ' Use Jira and Confluence together',
        description: 'Title of Jira and Confluence integrations section'
    },
    tutorialContentJiraLinks: {
        id: 'project-pages.improvement.templates.tutorial.content.jira-links',
        defaultMessage: 'Link a Jira issue anywhere on your page. The link on the page will update in real-time, as you update the Jira issue. Type <c>/Jira</c>.',
        description: 'Description of links to Jira in Confluence'
    },
    tutorialContentJiraRoadmaps: {
        id: 'project-pages.improvement.templates.tutorial.content.jira-roadmaps',
        defaultMessage: 'Embed interactive roadmaps and timelines for your page using your Jira Projects. Type <c>/jira roadmap</c>.',
        description: 'Description of Jira roadmaps slash command'
    },
    tutorialContentJiraTimeline: {
        id: 'project-pages.improvement.templates.tutorial.content.jira-timeline',
        defaultMessage: 'Embed interactive timelines for your page using your Jira Projects. Type <c>/jira timeline</c>.',
        description: 'Description of Jira timeline slash command'
    },
    tutorialContentJiraCharts: {
        id: 'project-pages.improvement.templates.tutorial.content.jira-charts',
        defaultMessage: 'Create charts on your pages using real Jira data. Type <c>/Jira charts</c>.',
        description: 'Description of Jira charts slash command'
    },
    tutorialContentTryItNow: {
        id: 'project-pages.improvement.templates.tutorial.content.try-it-now',
        defaultMessage: 'Try it now ',
        description: 'Call to action at the bottom the tutorial template'
    },
    tutorialContentForwardSlashPrompt: {
        id: 'project-pages.improvement.templates.tutorial.content.forward-slash-prompt',
        defaultMessage: "Type / followed by \u2018table\u2019 or \u2018image\u2019",
        description: 'Placeholder text detailing how to use Confluence slash commands'
    },
    tutorialContentHandyLinks: {
        id: 'project-pages.improvement.templates.tutorial.content.handy-links',
        defaultMessage: ' Handy links',
        description: 'Title of section with links to guides and videos'
    },
    tutorialContentJiraLinksIssueTermRefresh: {
        id: 'project-pages.improvement.templates.tutorial.content.jira-links-issue-term-refresh',
        defaultMessage: 'Link a Jira work item anywhere on your page. The link on the page will update in real-time, as you update the work item. Type <c>/Jira</c>.',
        description: 'Description of links to Jira in Confluence'
    }
});

});




parcelRegister("hFWlI", function(module, exports) {

$parcel$export(module.exports, "getSiteTraits", () => $d2fa1c537d47b357$export$847d02aadbf9f5f8);
$parcel$export(module.exports, "isConfluenceAutoProvisioned", () => $d2fa1c537d47b357$export$fe56838272897f8f);
$parcel$export(module.exports, "shouldCreateSpaceForAutoProvisionedConfluence", () => $d2fa1c537d47b357$export$36c363b78a521200);

var $yKIn9 = parcelRequire("yKIn9");

var $cEp5g = parcelRequire("cEp5g");

var $cIDcy = parcelRequire("cIDcy");
const $d2fa1c537d47b357$export$665dc32a4d0473f7 = 'confluence.auto-provision.activationDate';
const $d2fa1c537d47b357$export$847d02aadbf9f5f8 = (state)=>state.personalization.siteTraits;
const $d2fa1c537d47b357$export$fe56838272897f8f = (state)=>{
    try {
        const siteTraits = $d2fa1c537d47b357$export$847d02aadbf9f5f8(state);
        if (siteTraits.length < 1) return false;
        const autoProvisionDateTrait = siteTraits.find((trait)=>trait.name === $d2fa1c537d47b357$export$665dc32a4d0473f7);
        if (!autoProvisionDateTrait || !autoProvisionDateTrait.value) return false;
        return !!autoProvisionDateTrait.value;
    } catch (error) {
        (0, $yKIn9.sendOperationalAnalyticsEvent)({
            source: 'projectPages',
            action: 'failed',
            actionSubject: 'autoProvisionedConfluenceEligibilityCheck',
            attributes: {
                errorMessage: error ? error.message : 'Unknown error when determining the eligibilty of auto-provisioned Confluence site trait in isConfluenceAutoProvisioned selector'
            }
        });
        return false;
    }
};
const $d2fa1c537d47b357$export$36c363b78a521200 = (state)=>{
    const hasConnectedSpace = (0, $cEp5g.isSpaceConnected)(state);
    const hasAvailableSpaces = (0, $cIDcy.getAvailableSpaces)(state).length > 0;
    const hasAutoProvisionedConfluenceTrait = $d2fa1c537d47b357$export$fe56838272897f8f(state);
    const areAvailableSpacesLoaded = (0, $cIDcy.areSpacesLoaded)(state);
    return hasAutoProvisionedConfluenceTrait && areAvailableSpacesLoaded && !hasConnectedSpace && !hasAvailableSpaces;
};

});
parcelRegister("cIDcy", function(module, exports) {

$parcel$export(module.exports, "getAvailableSpaces", () => $ad38ed45423cd962$export$d093ba54969384ed);
$parcel$export(module.exports, "areSpacesLoaded", () => $ad38ed45423cd962$export$4439d288066fed0f);
const $ad38ed45423cd962$export$c747993fa9b91546 = (state)=>state.confluence.spaces;
const $ad38ed45423cd962$export$d093ba54969384ed = (state)=>state.confluence.spaces.availableSpaces;
const $ad38ed45423cd962$export$4439d288066fed0f = (state)=>state.confluence.spaces.spacesLoaded;

});



parcelRegister("gAIgm", function(module, exports) {

$parcel$export(module.exports, "default", () => $6509b4a8e5287900$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $kRfm7 = parcelRequire("kRfm7");

var $duc1y = parcelRequire("duc1y");

var $kbCXK = parcelRequire("kbCXK");
const $6509b4a8e5287900$var$MountTracker = (0, $duc1y.default)('PageTreeUnknownError');
const $6509b4a8e5287900$var$PageTreeUnknownError = ()=>/*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2OMIu.Fragment), {
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $kbCXK.default), {
                messages: (0, $kRfm7.default)
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)($6509b4a8e5287900$var$MountTracker, {})
        ]
    });
var $6509b4a8e5287900$export$2e2bcd8739ae039 = $6509b4a8e5287900$var$PageTreeUnknownError;

});
parcelRegister("kRfm7", function(module, exports) {

$parcel$export(module.exports, "default", () => $5ca1f223e37a83b3$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $5ca1f223e37a83b3$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    title: {
        id: 'project-pages.improvement.errors.page-tree-unknown-error.title',
        defaultMessage: "We\u2019re having trouble displaying project pages",
        description: 'Title when an unknown error occurred while fetching Confluence pages'
    },
    description: {
        id: 'project-pages.improvement.errors.page-tree-unknown-error.description',
        defaultMessage: "Something went wrong while trying to display pages from your connected Confluence space. {contactSupport} if refreshing doesn\u2019t fix things.",
        description: 'Description when an unknown error occurred while fetching Confluence pages'
    }
});

});

parcelRegister("kbCXK", function(module, exports) {

$parcel$export(module.exports, "default", () => $397707d2ea8c7b86$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $hTEpF = parcelRequire("hTEpF");

var $ousew = parcelRequire("ousew");
var $8RXs9 = parcelRequire("8RXs9");

var $4cuc7 = parcelRequire("4cuc7");

var $3r3OR = parcelRequire("3r3OR");
const $397707d2ea8c7b86$var$BaseUnknownError = ({ intl: { formatMessage: formatMessage }, messages: messages })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $hTEpF.default), {
        imageUrl: (0, (/*@__PURE__*/$parcel$interopDefault($4cuc7))),
        imageWidth: 71,
        header: formatMessage(messages.title),
        description: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
            ...messages.description,
            values: {
                link: (chunks)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $3r3OR.default), {
                        label: chunks
                    })
            }
        }),
        testId: "confluence-project-pages.unknown-error"
    });
var $397707d2ea8c7b86$export$2e2bcd8739ae039 = (0, $8RXs9.default)($397707d2ea8c7b86$var$BaseUnknownError);

});
parcelRegister("4cuc7", function(module, exports) {
module.exports = new URL("error.f961de0c.svg", import.meta.url).toString();

});



parcelRegister("8aAQl", function(module, exports) {

$parcel$export(module.exports, "PageTreeSkeleton", () => $dff2a539151aeb09$export$985ab6661ca3f4dc);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $47bDC = parcelRequire("47bDC");

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $dff2a539151aeb09$var$Rectangle = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "rkiqr1-0"
})({
    width: '100%',
    height: `calc(100% - ${"var(--ds-space-200, 16px)"})`,
    borderRadius: "var(--ds-border-radius-100, 3px)",
    backgroundColor: `var(--ds-skeleton, ${(0, $829f609a65d26a98$export$9fdfb749e33cdf97)})`
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $dff2a539151aeb09$var$Circle = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "rkiqr1-1"
})({
    height: "var(--ds-space-400, 32px)",
    width: "var(--ds-space-400, 32px)",
    borderRadius: '50%',
    backgroundColor: `var(--ds-skeleton, ${(0, $829f609a65d26a98$export$9fdfb749e33cdf97)})`
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $dff2a539151aeb09$var$Wrapper = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "rkiqr1-2"
})({
    display: 'flex',
    flexWrap: 'wrap'
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $dff2a539151aeb09$var$Row = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "rkiqr1-3"
})({
    display: 'grid',
    gridTemplateColumns: '40% auto 20%',
    width: '100%',
    borderTop: `1px solid ${`var(--ds-border, ${(0, $829f609a65d26a98$export$1ce2d1575d444ceb)})`}`,
    padding: `${"var(--ds-space-100, 8px)"} 0`,
    justifyContent: 'space-between',
    alignItems: 'center'
});
const $dff2a539151aeb09$export$985ab6661ca3f4dc = ()=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)($dff2a539151aeb09$var$Wrapper, {
        "data-testid": "confluence-project-pages.page-tree-skeleton",
        children: Array.from(Array(6), (_, index)=>/*#__PURE__*/ (0, $2OMIu.jsxs)($dff2a539151aeb09$var$Row, {
                children: [
                    /*#__PURE__*/ (0, $2OMIu.jsx)($dff2a539151aeb09$var$Rectangle, {}),
                    /*#__PURE__*/ (0, $2OMIu.jsx)($dff2a539151aeb09$var$Circle, {}),
                    /*#__PURE__*/ (0, $2OMIu.jsx)($dff2a539151aeb09$var$Rectangle, {})
                ]
            }, index))
    });
};

});


parcelRegister("7HKya", function(module, exports) {

$parcel$export(module.exports, "DisplayWrapper", () => $3b675780758dbc01$export$6833d6d22987ee7f);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $47bDC = parcelRequire("47bDC");
const $3b675780758dbc01$export$6833d6d22987ee7f = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "jgbp2w-0"
})((props)=>({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        display: props.isShown ? 'initial' : 'none'
    }));

});

parcelRegister("dnjeJ", function(module, exports) {

$parcel$export(module.exports, "useUFOComponentExperience", () => $44448c24118cb590$export$30ab340faaed55d4);

var $5uXOq = parcelRequire("5uXOq");
const $44448c24118cb590$var$useConstructor = (callback)=>{
    const hasBeenFired = (0, $5uXOq.useRef)(false);
    if (!hasBeenFired.current) {
        callback();
        hasBeenFired.current = true;
    }
    return null;
};
const $44448c24118cb590$export$30ab340faaed55d4 = (experience)=>{
    (0, $5uXOq.useEffect)(()=>{
        return ()=>{
            experience.abort();
        };
    // we want this cleanup to only happen on unmount so this is a legit use of empty array
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    $44448c24118cb590$var$useConstructor(()=>experience.start());
    return null;
};

});

parcelRegister("bKcHQ", function(module, exports) {

$parcel$export(module.exports, "getAllBooleanFeatureFlags", () => $56c51fd9421e9c8d$export$bb21a292576d06fe);
$parcel$export(module.exports, "getAllBooleanFeatureFlagKeys", () => $56c51fd9421e9c8d$export$bce38ec35444ea8b);

var $c6ram = parcelRequire("c6ram");
const $56c51fd9421e9c8d$export$bb21a292576d06fe = ()=>{
    try {
        const generatedFeatureFlags = (0, $c6ram.getGeneratedBooleanFeatureFlags)() || {};
        return generatedFeatureFlags;
    } catch (error) {
        return {};
    }
};
const $56c51fd9421e9c8d$export$bce38ec35444ea8b = ()=>{
    if (typeof (0, $c6ram.generatedBooleanFeatureFlagKeys) === 'object') return 0, $c6ram.generatedBooleanFeatureFlagKeys;
    return [];
};

});
parcelRegister("c6ram", function(module, exports) {

$parcel$export(module.exports, "getGeneratedBooleanFeatureFlags", () => $ab281335d40a01a0$export$5d8fc734b5305558);
$parcel$export(module.exports, "generatedBooleanFeatureFlagKeys", () => $ab281335d40a01a0$export$ba3accfade8b4417);
/**
 * This file is auto-generated. Run yarn workspace @atlassiansox/project-pages generate:feature-flags to re-generate.
 */ 
var $VSDnB = parcelRequire("VSDnB");
const $ab281335d40a01a0$export$5d8fc734b5305558 = ()=>{
    try {
        const flags = {
            'platform.google-drive-in-project-pages': (0, $VSDnB.fg)('platform.google-drive-in-project-pages'),
            'platform-component-visual-refresh': (0, $VSDnB.fg)('platform-component-visual-refresh'),
            'confluence-issue-terminology-refresh': (0, $VSDnB.fg)('confluence-issue-terminology-refresh'),
            'confluence_live_pages_enabled_in_jira': (0, $VSDnB.fg)('confluence_live_pages_enabled_in_jira'),
            'project-pages-zoom-accessibility': (0, $VSDnB.fg)('project-pages-zoom-accessibility'),
            'project_pages_delete_corrupt_relationships': (0, $VSDnB.fg)('project_pages_delete_corrupt_relationships')
        };
        return flags;
    } catch (error) {
        return {};
    }
};
const $ab281335d40a01a0$export$ba3accfade8b4417 = [
    'platform.google-drive-in-project-pages',
    'platform-component-visual-refresh',
    'confluence-issue-terminology-refresh',
    'confluence_live_pages_enabled_in_jira',
    'project-pages-zoom-accessibility',
    'project_pages_delete_corrupt_relationships'
];

});


parcelRegister("1jNdv", function(module, exports) {

$parcel$export(module.exports, "PreselectedTemplate", () => $3aa74ce00b1450e0$export$5ca5de9c736f3af);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $1nF7O = parcelRequire("1nF7O");

var $f4cXA = parcelRequire("f4cXA");

var $3njdl = parcelRequire("3njdl");
const $3aa74ce00b1450e0$var$SelectedTemplatePreview = (props)=>{
    (0, $3njdl.useSelectedTemplatePreview)(props);
    return null;
};
const $3aa74ce00b1450e0$export$5ca5de9c736f3af = ({ contentId: contentId, isConfluenceActivationCompleteForPreselectedTemplate: isConfluenceActivationCompleteForPreselectedTemplate, blueprints: blueprints, createEmbeddedPage: createEmbeddedPage })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $f4cXA.ErrorBoundary), {
        FallbackComponent: ()=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {}),
        onError: (error)=>{
            (0, $1nF7O.fireErrorAnalytics)({
                meta: {
                    id: 'project-pages-embedded-confluence-error',
                    packageName: '@atlassiansox/project-pages'
                },
                error: error
            });
        },
        children: /*#__PURE__*/ (0, $2OMIu.jsx)($3aa74ce00b1450e0$var$SelectedTemplatePreview, {
            contentId: contentId,
            isConfluenceActivationCompleteForPreselectedTemplate: isConfluenceActivationCompleteForPreselectedTemplate,
            blueprints: blueprints,
            createEmbeddedPage: createEmbeddedPage
        })
    });
};

});
parcelRegister("3njdl", function(module, exports) {

$parcel$export(module.exports, "useSelectedTemplatePreview", () => $4b84a768424f24a1$export$7e050682cd57b6e1);

var $5uXOq = parcelRequire("5uXOq");


var $1nF7O = parcelRequire("1nF7O");

var $jFY9b = parcelRequire("jFY9b");

var $l0cmm = parcelRequire("l0cmm");

var $6k2gl = parcelRequire("6k2gl");
const $4b84a768424f24a1$export$7e050682cd57b6e1 = ({ contentId: contentId, blueprints: blueprints, isConfluenceActivationCompleteForPreselectedTemplate: isConfluenceActivationCompleteForPreselectedTemplate, createEmbeddedPage: createEmbeddedPage })=>{
    const [hasShownEmbeddedConfluence, setHasShown] = (0, $5uXOq.useState)(false);
    const { template: template } = (0, $6k2gl.useTemplate)();
    const showEmbeddedConfluencePage = (0, $5uXOq.useCallback)((template)=>{
        try {
            if (template.key === (0, $d532930fcd5ef274$export$947879e664d1885a) || template.itemModuleCompleteKey === (0, $jFY9b.ItemModuleCompleteKeys).BLANK_PAGE) createEmbeddedPage(contentId || undefined, true, undefined, undefined);
            else {
                const blueprint = blueprints.find((blueprint)=>blueprint.itemModuleCompleteKey === template.blueprintModuleCompleteKey || blueprint.blueprintModuleCompleteKey === template.blueprintModuleCompleteKey);
                if (blueprint) createEmbeddedPage(contentId || undefined, true, blueprint);
                else (0, $1nF7O.fireErrorAnalytics)({
                    error: new Error(`Embedded page was not showing due to blueprint with id: ${template.blueprintModuleCompleteKey} not found.`),
                    meta: {
                        id: 'project-pages-embedded-confluence-error',
                        packageName: '@atlassiansox/project-pages'
                    }
                });
            }
            return true;
        } catch (error) {
            (0, $1nF7O.fireErrorAnalytics)({
                error: new Error(`Unknown error when calling createEmbeddedPage for template: ${template.blueprintModuleCompleteKey}`),
                attributes: {
                    cause: error instanceof Error ? error.message : 'Not known'
                },
                meta: {
                    id: 'project-pages-embedded-confluence-error',
                    packageName: '@atlassiansox/project-pages'
                }
            });
            return true;
        }
    }, [
        contentId,
        createEmbeddedPage,
        blueprints
    ]);
    const onShouldShowEmbeddedConfluence = (0, $5uXOq.useCallback)((template)=>{
        return showEmbeddedConfluencePage(template);
    }, [
        showEmbeddedConfluencePage
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (!hasShownEmbeddedConfluence && isConfluenceActivationCompleteForPreselectedTemplate && template?.type === (0, $l0cmm.TemplateType).Confluence) {
            const didShow = onShouldShowEmbeddedConfluence(template);
            setHasShown(didShow);
        }
    }, [
        hasShownEmbeddedConfluence,
        isConfluenceActivationCompleteForPreselectedTemplate,
        template,
        onShouldShowEmbeddedConfluence
    ]);
    return hasShownEmbeddedConfluence;
};

});
const $d532930fcd5ef274$export$947879e664d1885a = 'blankPage';

parcelRegister("jFY9b", function(module, exports) {

$parcel$export(module.exports, "ItemModuleCompleteKeys", () => $a5bfd361b1b4d735$export$2ae1f6a9458e9684);
$parcel$export(module.exports, "BlueprintModuleCompleteKeys", () => $a5bfd361b1b4d735$export$3159bae21226cb8d);
var $a5bfd361b1b4d735$export$2ae1f6a9458e9684 = /*#__PURE__*/ function(ItemModuleCompleteKeys) {
    ItemModuleCompleteKeys["BLANK_PAGE"] = "com.atlassian.confluence.plugins.confluence-create-content-plugin:create-blank-page";
    ItemModuleCompleteKeys["PRODUCT_REQUIREMENTS"] = "com.atlassian.confluence.plugins.confluence-software-blueprints:requirements-item";
    ItemModuleCompleteKeys["DECISION"] = "com.atlassian.confluence.plugins.confluence-business-blueprints:decisions-blueprint-item";
    ItemModuleCompleteKeys["MEETING_NOTES"] = "com.atlassian.confluence.plugins.confluence-business-blueprints:meeting-notes-item";
    ItemModuleCompleteKeys["RESTROSPECTIVE"] = "com.atlassian.confluence.plugins.confluence-software-blueprints:retrospectives-item";
    // added for MSR experiment
    ItemModuleCompleteKeys["PROJECT_PLAN"] = "com.atlassian.confluence.plugins.confluence-business-blueprints:projectplan-item";
    ItemModuleCompleteKeys["ONE_ON_ONE_MEETING"] = "com.atlassian.confluence.plugins.confluence-business-blueprints:1-on-1-meeting-item";
    ItemModuleCompleteKeys["NINETY_DAY_PLAN"] = "com.atlassian.confluence.plugins.confluence-business-blueprints:90-day-plan-item";
    ItemModuleCompleteKeys["FIVE_WHYS_ANALYSIS"] = "com.atlassian.confluence.plugins.confluence-business-blueprints:5-whys-analysis-item";
    ItemModuleCompleteKeys["HOW_TO_ARTICLE"] = "com.atlassian.confluence.plugins.confluence-knowledge-base:kb-how-to-item";
    ItemModuleCompleteKeys["PRODUCT_ROADMAP"] = "com.atlassian.confluence.plugins.confluence-business-blueprints:product-roadmap-item";
    ItemModuleCompleteKeys["BRAINSTORMING"] = "com.atlassian.confluence.plugins.confluence-business-blueprints:brainstorming-with-remote-teams-item";
    ItemModuleCompleteKeys["AWS_ARCHITECTURE_DIAGRAM"] = "com.atlassian.confluence.plugins.confluence-business-blueprints:aws-architecture-diagram-item";
    ItemModuleCompleteKeys["MASTER_PROJECT_DOCUMENT"] = "com.atlassian.confluence.plugins.confluence-business-blueprints:master-project-document-item";
    ItemModuleCompleteKeys["SOFTWARE_ARCHITECTURE_REVIEW"] = "com.atlassian.confluence.plugins.confluence-business-blueprints:software-architecture-review-item";
    ItemModuleCompleteKeys["COMPETITIVE_ANALYSIS"] = "com.atlassian.confluence.plugins.confluence-business-blueprints:competitive-analysis-item";
    ItemModuleCompleteKeys["BUSINESS_PLAN_ONE_PAGER"] = "com.atlassian.confluence.plugins.confluence-business-blueprints:business-plan-one-pager-item";
    ItemModuleCompleteKeys["BUSINESS_PROPOSAL"] = "com.atlassian.confluence.plugins.confluence-business-blueprints:business-proposal-item";
    ItemModuleCompleteKeys["TO_DO_LIST"] = "com.atlassian.confluence.plugins.confluence-business-blueprints:to-do-list-item";
    return ItemModuleCompleteKeys;
}({});
var $a5bfd361b1b4d735$export$3159bae21226cb8d = /*#__PURE__*/ function(BlueprintModuleCompleteKeys) {
    BlueprintModuleCompleteKeys["PRODUCT_REQUIREMENTS"] = "com.atlassian.confluence.plugins.confluence-software-blueprints:requirements-blueprint";
    BlueprintModuleCompleteKeys["DECISION"] = "com.atlassian.confluence.plugins.confluence-business-blueprints:decisions-blueprint";
    BlueprintModuleCompleteKeys["MEETING_NOTES"] = "com.atlassian.confluence.plugins.confluence-business-blueprints:meeting-notes-blueprint";
    BlueprintModuleCompleteKeys["RESTROSPECTIVE"] = "com.atlassian.confluence.plugins.confluence-software-blueprints:retrospectives-blueprint";
    // added for MSR experiment
    BlueprintModuleCompleteKeys["PROJECT_PLAN"] = "com.atlassian.confluence.plugins.confluence-business-blueprints:projectplan-blueprint";
    BlueprintModuleCompleteKeys["ONE_ON_ONE_MEETING"] = "com.atlassian.confluence.plugins.confluence-business-blueprints:1-on-1-meeting-blueprint";
    BlueprintModuleCompleteKeys["NINETY_DAY_PLAN"] = "com.atlassian.confluence.plugins.confluence-business-blueprints:90-day-plan-blueprint";
    BlueprintModuleCompleteKeys["FIVE_WHYS_ANALYSIS"] = "com.atlassian.confluence.plugins.confluence-business-blueprints:5-whys-analysis-blueprint";
    BlueprintModuleCompleteKeys["HOW_TO_ARTICLE"] = "com.atlassian.confluence.plugins.confluence-knowledge-base:kb-how-to-article-blueprint";
    BlueprintModuleCompleteKeys["PRODUCT_ROADMAP"] = "com.atlassian.confluence.plugins.confluence-business-blueprints:product-roadmap-blueprint";
    BlueprintModuleCompleteKeys["BRAINSTORMING"] = "com.atlassian.confluence.plugins.confluence-business-blueprints:brainstorming-with-remote-teams-blueprint";
    BlueprintModuleCompleteKeys["AWS_ARCHITECTURE_DIAGRAM"] = "com.atlassian.confluence.plugins.confluence-business-blueprints:aws-architecture-diagram-blueprint";
    BlueprintModuleCompleteKeys["MASTER_PROJECT_DOCUMENT"] = "com.atlassian.confluence.plugins.confluence-business-blueprints:master-project-document-blueprint";
    BlueprintModuleCompleteKeys["SOFTWARE_ARCHITECTURE_REVIEW"] = "com.atlassian.confluence.plugins.confluence-business-blueprints:software-architecture-review-blueprint";
    BlueprintModuleCompleteKeys["COMPETITIVE_ANALYSIS"] = "com.atlassian.confluence.plugins.confluence-business-blueprints:competitive-analysis-blueprint";
    BlueprintModuleCompleteKeys["BUSINESS_PLAN_ONE_PAGER"] = "com.atlassian.confluence.plugins.confluence-business-blueprints:business-plan-one-pager-blueprint";
    BlueprintModuleCompleteKeys["BUSINESS_PROPOSAL"] = "com.atlassian.confluence.plugins.confluence-business-blueprints:business-proposal-blueprint";
    BlueprintModuleCompleteKeys["TO_DO_LIST"] = "com.atlassian.confluence.plugins.confluence-business-blueprints:to-do-list-blueprint";
    return BlueprintModuleCompleteKeys;
}({});

});

parcelRegister("l0cmm", function(module, exports) {

$parcel$export(module.exports, "TemplateType", () => $6360b4cbb85c6682$export$fd0446c06165ed92);
var $6360b4cbb85c6682$export$fd0446c06165ed92 = /*#__PURE__*/ function(TemplateType) {
    TemplateType[TemplateType["Confluence"] = 0] = "Confluence";
    TemplateType[TemplateType["Link"] = 1] = "Link";
    return TemplateType;
}({});

});

parcelRegister("6k2gl", function(module, exports) {

$parcel$export(module.exports, "useTemplate", () => $1053752b37d2b9a3$export$5c3a5f48c762cb34);
$parcel$export(module.exports, "TemplateProvider", () => $1053752b37d2b9a3$export$5abfb1150fa6da6a);
$parcel$export(module.exports, "usePreloadPreviews", () => $1053752b37d2b9a3$export$1700393387b8743b);

var $5uXOq = parcelRequire("5uXOq");

var $7shOz = parcelRequire("7shOz");
const $1053752b37d2b9a3$var$TemplateContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createContext({
    template: undefined,
    setActiveTemplatePreview: ()=>{},
    projectSpaceId: null
});
const $1053752b37d2b9a3$export$5c3a5f48c762cb34 = ()=>(0, $5uXOq.useContext)($1053752b37d2b9a3$var$TemplateContext);
const $1053752b37d2b9a3$export$5abfb1150fa6da6a = $1053752b37d2b9a3$var$TemplateContext.Provider;
const $1053752b37d2b9a3$export$1700393387b8743b = (templates, isPostExpand)=>{
    (0, $5uXOq.useEffect)(()=>{
        templates.filter((0, $7shOz.isConfluenceTemplate)).forEach((t)=>{
            const img = new Image();
            img.src = isPostExpand ? t.preview.postExpand.default : t.preview.preExpand.default;
        });
    }, [
        isPostExpand,
        templates
    ]);
};

});
parcelRegister("7shOz", function(module, exports) {

$parcel$export(module.exports, "isConfluenceTemplate", () => $dd87896fdaf140fd$export$edbc62ee780712e3);
$parcel$export(module.exports, "isMoreTemplates", () => $dd87896fdaf140fd$export$19b46866d305b8e4);

var $l0cmm = parcelRequire("l0cmm");
const $dd87896fdaf140fd$export$edbc62ee780712e3 = (template)=>template?.type === (0, $l0cmm.TemplateType).Confluence;
const $dd87896fdaf140fd$export$19b46866d305b8e4 = (template)=>template?.type === (0, $l0cmm.TemplateType).Link;

});






parcelRegister("2WCIv", function(module, exports) {

$parcel$export(module.exports, "default", () => $65f1b219748bbae4$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");
var $8RXs9 = parcelRequire("8RXs9");

var $hTEpF = parcelRequire("hTEpF");

var $21P12 = parcelRequire("21P12");

var $4cuc7 = parcelRequire("4cuc7");


var $jXVTV = parcelRequire("jXVTV");

var $duc1y = parcelRequire("duc1y");

var $3r3OR = parcelRequire("3r3OR");

var $bpUVq = parcelRequire("bpUVq");
const $65f1b219748bbae4$var$MountTracker = (0, $duc1y.default)('serverErrorEmptySpace');
const $65f1b219748bbae4$var$ServerError = ({ type: type = 'server', intl: { formatMessage: formatMessage } })=>{
    const isCrossJoinProjectExperimentEnabled = (0, $jXVTV.getTargetingGate)((0, $dbbde2ee9bc78c02$export$7d578ef8316f5d8b));
    // Feature exposed event has been fired when users view lozenge & spotlight, so we disable this one
    const crossJoinNudgeExperimentCohort = isCrossJoinProjectExperimentEnabled ? (0, $jXVTV.getExperimentValue)((0, $dbbde2ee9bc78c02$export$616a7764e9436f13), 'not-enrolled', false) : 'not-enrolled';
    if (type === 'access') return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2OMIu.Fragment), {
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bpUVq.default), {
                parentPageId: null,
                spaceKey: null,
                isCrossJoinProjectExperimentEnabled: isCrossJoinProjectExperimentEnabled,
                crossJoinProjectExperimentCohort: crossJoinNudgeExperimentCohort
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)($65f1b219748bbae4$var$MountTracker, {
                type: type
            })
        ]
    });
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2OMIu.Fragment), {
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $hTEpF.default), {
                width: "wide",
                imageUrl: (0, (/*@__PURE__*/$parcel$interopDefault($4cuc7))),
                maxImageWidth: 82,
                header: formatMessage((0, $21P12.default).heading),
                description: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                    ...(0, $21P12.default).description,
                    values: {
                        link: (chunks)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $3r3OR.default), {
                                label: chunks
                            })
                    }
                })
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)($65f1b219748bbae4$var$MountTracker, {
                type: type
            })
        ]
    });
};
var $65f1b219748bbae4$export$2e2bcd8739ae039 = (0, $8RXs9.default)($65f1b219748bbae4$var$ServerError);

});
parcelRegister("21P12", function(module, exports) {

$parcel$export(module.exports, "default", () => $5ac2dda8131a6707$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $5ac2dda8131a6707$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    heading: {
        id: 'project-pages.unknown-error.heading',
        defaultMessage: "We can\u2019t display project pages right now",
        description: 'Heading when an unknown error occurs'
    },
    description: {
        id: 'project-pages.unknown-error.description',
        defaultMessage: "{contactSupport} if refreshing doesn\u2019t fix things.",
        description: 'Description when an unknown error occurs'
    }
});

});

const $dbbde2ee9bc78c02$export$7d578ef8316f5d8b = 'cjn_project_pages_gate';
const $dbbde2ee9bc78c02$export$616a7764e9436f13 = 'cjn_project_pages_on_userid';

parcelRegister("bpUVq", function(module, exports) {

$parcel$export(module.exports, "default", () => $d9bd6b7d34094126$export$2e2bcd8739ae039);

var $7Z8iG = parcelRequire("7Z8iG");

var $glS5B = parcelRequire("glS5B");

var $aPZf4 = parcelRequire("aPZf4");

var $kSBKe = parcelRequire("kSBKe");

var $cEp5g = parcelRequire("cEp5g");

var $9MB7L = parcelRequire("9MB7L");

var $dk2bH = parcelRequire("dk2bH");
const $d9bd6b7d34094126$var$mapStateToProps = (state)=>({
        connectedSpace: (0, $cEp5g.getConnectedSpace)(state),
        accessRequestCapability: (0, $kSBKe.getAccessRequestCapability)(state),
        origin: (0, $9MB7L.getOrigin)(state),
        collaborators: (0, $dk2bH.getCollaborators)(state),
        cloudId: (0, $9MB7L.getCloudId)(state)
    });
const $d9bd6b7d34094126$var$mapDispatchToProps = (dispatch)=>({
        triggerConfluenceAccessRequestCheck: ()=>dispatch((0, $aPZf4.fetchConfluenceAccessRequestCapabilities)()),
        triggerFetchConfluenceCollaborators: ()=>dispatch((0, $aPZf4.fetchConfluenceCollaborators)())
    });
var $d9bd6b7d34094126$export$2e2bcd8739ae039 = (0, $7Z8iG.connect)($d9bd6b7d34094126$var$mapStateToProps, $d9bd6b7d34094126$var$mapDispatchToProps)((0, $glS5B.default));

});
parcelRegister("glS5B", function(module, exports) {

$parcel$export(module.exports, "default", () => $82143864618c4228$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $8c8di = parcelRequire("8c8di");

var $d4oNI = parcelRequire("d4oNI");
const $82143864618c4228$var$CrossJoin = ({ connectedSpace: connectedSpace, accessRequestCapability: accessRequestCapability, origin: origin, collaborators: collaborators, triggerConfluenceAccessRequestCheck: triggerConfluenceAccessRequestCheck, triggerFetchConfluenceCollaborators: triggerFetchConfluenceCollaborators, cloudId: cloudId, isCrossJoinProjectExperimentEnabled: isCrossJoinProjectExperimentEnabled = false, crossJoinProjectExperimentCohort: crossJoinProjectExperimentCohort = 'not-enrolled' })=>{
    (0, $5uXOq.useEffect)(()=>{
        triggerConfluenceAccessRequestCheck();
    }, [
        triggerConfluenceAccessRequestCheck
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (accessRequestCapability && [
            (0, $8c8di.AccessRequestCapabilityType).REQUEST_ACCESS,
            (0, $8c8di.AccessRequestCapabilityType).DIRECT_ACCESS
        ].includes(accessRequestCapability)) // fetch collaborators only for the RA / join product scenario
        triggerFetchConfluenceCollaborators();
    }, [
        accessRequestCapability,
        triggerFetchConfluenceCollaborators
    ]);
    // still loading
    if (!accessRequestCapability) return null;
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $d4oNI.default), {
        accessRequestCapability: accessRequestCapability,
        connectedSpace: connectedSpace,
        origin: origin,
        collaborators: collaborators,
        cloudId: cloudId,
        spaceKey: connectedSpace.projectSpaceKey,
        parentPageId: connectedSpace.projectPageLinkedId,
        isCrossJoinProjectExperimentEnabled: isCrossJoinProjectExperimentEnabled,
        crossJoinProjectExperimentCohort: crossJoinProjectExperimentCohort
    });
};
var $82143864618c4228$export$2e2bcd8739ae039 = $82143864618c4228$var$CrossJoin;

});
parcelRegister("8c8di", function(module, exports) {

$parcel$export(module.exports, "AccessRequestCapabilityType", () => $9eec3ac8c32c2aaa$export$a4cf803cc5ad528);
// https://stash.atlassian.com/projects/IPS/repos/id-invitations-service/browse/src/main/java/com/atlassian/identity/invitations/model/access/AccessRequestCapability.java
var $9eec3ac8c32c2aaa$export$a4cf803cc5ad528 = /*#__PURE__*/ function(AccessRequestCapabilityType) {
    // only the ones we care about, if we get anything else, treat it as ERROR
    AccessRequestCapabilityType["DIRECT_ACCESS"] = "DIRECT_ACCESS";
    AccessRequestCapabilityType["REQUEST_ACCESS"] = "REQUEST_ACCESS";
    AccessRequestCapabilityType["ACCESS_EXISTS"] = "ACCESS_EXISTS";
    AccessRequestCapabilityType["ACCESS_GRANTED"] = "ACCESS_GRANTED";
    AccessRequestCapabilityType["PENDING_REQUEST_EXISTS"] = "PENDING_REQUEST_EXISTS";
    AccessRequestCapabilityType["PENDING_REQUEST_CREATED"] = "PENDING_REQUEST_CREATED";
    AccessRequestCapabilityType["DENIED_REQUEST_EXISTS"] = "DENIED_REQUEST_EXISTS";
    AccessRequestCapabilityType["APPROVED_REQUEST_EXISTS"] = "APPROVED_REQUEST_EXISTS";
    AccessRequestCapabilityType["ERROR"] = "ERROR";
    return AccessRequestCapabilityType;
}({});

});

parcelRegister("d4oNI", function(module, exports) {

$parcel$export(module.exports, "default", () => $a7c762e0fe06e477$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $e79h5 = parcelRequire("e79h5");

var $8c8di = parcelRequire("8c8di");

var $1mg4V = parcelRequire("1mg4V");

var $47bDC = parcelRequire("47bDC");

var $8LWHH = parcelRequire("8LWHH");

var $2rv62 = parcelRequire("2rv62");

var $3SjrN = parcelRequire("3SjrN");

var $cVoy7 = parcelRequire("cVoy7");

var $cg24l = parcelRequire("cg24l");

var $fkaak = parcelRequire("fkaak");

var $h8yj2 = parcelRequire("h8yj2");
// eslint-disable-next-line @atlaskit/design-system/use-primitives, @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
const $a7c762e0fe06e477$var$HeroImageWrapper = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "sc-1d80gtt-0"
})({
    marginBottom: "var(--ds-space-200, 16px)"
});
const $a7c762e0fe06e477$var$CrossJoinView = ({ accessRequestCapability: accessRequestCapability, origin: origin, collaborators: collaborators, cloudId: cloudId, spaceKey: spaceKey, parentPageId: parentPageId, crossJoinProjectExperimentCohort: crossJoinProjectExperimentCohort, isCrossJoinProjectExperimentEnabled: isCrossJoinProjectExperimentEnabled })=>{
    // enrich analytics event with origin and then fire the event via supplied handler
    const createClickHandlerForAnalytics = (0, $5uXOq.useCallback)((eventName)=>(_, analyticsEvent)=>{
            const originAttributes = origin?.toAnalyticsAttributes({
                hasGeneratedId: true
            });
            (0, $h8yj2.fireUIAnalytics)(analyticsEvent, `${eventName}Button`, {
                numberOfCollaborators: collaborators?.length,
                crossJoinProjectExperimentCohort: crossJoinProjectExperimentCohort,
                isCrossJoinProjectExperimentEnabled: isCrossJoinProjectExperimentEnabled,
                ...originAttributes
            });
        }, [
        collaborators,
        origin,
        crossJoinProjectExperimentCohort,
        isCrossJoinProjectExperimentEnabled
    ]);
    const renderHeroImage = (0, $5uXOq.useCallback)(()=>/*#__PURE__*/ (0, $2OMIu.jsx)($a7c762e0fe06e477$var$HeroImageWrapper, {
            children: collaborators && collaborators.length > 0 ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $e79h5.default), {
                collaborators: collaborators,
                cloudId: cloudId
            }) : /*#__PURE__*/ (0, $2OMIu.jsx)("img", {
                src: (0, (/*@__PURE__*/$parcel$interopDefault($1mg4V))),
                height: 80,
                width: 99.56,
                alt: ""
            })
        }), [
        collaborators,
        cloudId
    ]);
    // for scenarios where collaborators are shown (RA/join), wait until collaborators are retrieved
    if (accessRequestCapability && [
        (0, $8c8di.AccessRequestCapabilityType).REQUEST_ACCESS,
        (0, $8c8di.AccessRequestCapabilityType).DIRECT_ACCESS
    ].includes(accessRequestCapability) && !collaborators) return null;
    if (isCrossJoinProjectExperimentEnabled && crossJoinProjectExperimentCohort === 'variation') {
        if (accessRequestCapability === (0, $8c8di.AccessRequestCapabilityType).REQUEST_ACCESS || accessRequestCapability === (0, $8c8di.AccessRequestCapabilityType).DIRECT_ACCESS) {
            const analyticsAction = accessRequestCapability === (0, $8c8di.AccessRequestCapabilityType).REQUEST_ACCESS ? 'requestAccess' : 'joinProduct';
            return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $8LWHH.default), {
                renderHeroImage: renderHeroImage,
                onClick: createClickHandlerForAnalytics(analyticsAction),
                origin: origin,
                spaceKey: spaceKey,
                parentPageId: parentPageId,
                crossJoinProjectExperimentCohort: crossJoinProjectExperimentCohort,
                accessRequestCapability: accessRequestCapability
            });
        }
    }
    switch(accessRequestCapability){
        case (0, $8c8di.AccessRequestCapabilityType).REQUEST_ACCESS:
            return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $8LWHH.default), {
                renderHeroImage: renderHeroImage,
                onClick: createClickHandlerForAnalytics('requestAccess'),
                origin: origin,
                spaceKey: spaceKey,
                parentPageId: parentPageId
            });
        case (0, $8c8di.AccessRequestCapabilityType).PENDING_REQUEST_EXISTS:
            return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2rv62.default), {
                crossJoinProjectExperimentCohort: crossJoinProjectExperimentCohort
            });
        case (0, $8c8di.AccessRequestCapabilityType).DENIED_REQUEST_EXISTS:
            return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cVoy7.default), {});
        case (0, $8c8di.AccessRequestCapabilityType).APPROVED_REQUEST_EXISTS:
            return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cg24l.default), {});
        case (0, $8c8di.AccessRequestCapabilityType).DIRECT_ACCESS:
            return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3SjrN.default), {
                onClick: createClickHandlerForAnalytics('joinProduct'),
                renderHeroImage: renderHeroImage
            });
        default:
            return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fkaak.default), {});
    }
};
var $a7c762e0fe06e477$export$2e2bcd8739ae039 = $a7c762e0fe06e477$var$CrossJoinView;

});
parcelRegister("e79h5", function(module, exports) {

$parcel$export(module.exports, "default", () => $9e5e3535ad6d44dc$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $jnhNB = parcelRequire("jnhNB");

var $47bDC = parcelRequire("47bDC");

var $j1n9G = parcelRequire("j1n9G");

var $7CZqP = parcelRequire("7CZqP");

var $acLLs = parcelRequire("acLLs");

var $bKYtt = parcelRequire("bKYtt");

var $3LDms = parcelRequire("3LDms");

var $37PA3 = parcelRequire("37PA3");

var $blw2B = parcelRequire("blw2B");

var $ujWmd = parcelRequire("ujWmd");

var $8RXs9 = parcelRequire("8RXs9");

var $3oc6s = parcelRequire("3oc6s");
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $9e5e3535ad6d44dc$var$Wrapper = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "sc-1q2960e-0"
})({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: '36px'
});
const $9e5e3535ad6d44dc$var$DIRECTORY_URL = '/gateway/api/directory/graphql';
const $9e5e3535ad6d44dc$var$fallback = [
    [
        'vania',
        (0, (/*@__PURE__*/$parcel$interopDefault($3LDms)))
    ],
    [
        'alvin',
        (0, (/*@__PURE__*/$parcel$interopDefault($j1n9G)))
    ],
    [
        'katina',
        (0, (/*@__PURE__*/$parcel$interopDefault($acLLs)))
    ],
    [
        'eliot',
        (0, (/*@__PURE__*/$parcel$interopDefault($7CZqP)))
    ],
    [
        'norah',
        (0, (/*@__PURE__*/$parcel$interopDefault($bKYtt)))
    ]
].map(([name, src])=>({
        name: name,
        src: src,
        id: ''
    }));
const $9e5e3535ad6d44dc$var$openUserProfileWindow = (userId)=>window.open($9e5e3535ad6d44dc$var$getUserProfileUrl(userId), '_blank');
const $9e5e3535ad6d44dc$var$getUserProfileUrl = (userId)=>`/jira/people/${userId}`;
const $9e5e3535ad6d44dc$var$PopupAvatar = (props)=>{
    const profileClient = new (0, $blw2B.default)({
        url: $9e5e3535ad6d44dc$var$DIRECTORY_URL
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $37PA3.default), {
        trigger: "hover",
        userId: props.id,
        resourceClient: profileClient,
        cloudId: props.cloudId,
        actions: [
            {
                label: props.intl.formatMessage((0, $3oc6s.default).viewProfile),
                callback: ()=>{
                    $9e5e3535ad6d44dc$var$openUserProfileWindow(props.id);
                }
            }
        ],
        prepopulatedData: {
            fullName: props.name
        },
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ujWmd.default), {
            ...props,
            onClick: ()=>{}
        })
    });
};
const $9e5e3535ad6d44dc$var$PopupAvatarWithIntl = (0, $8RXs9.default)($9e5e3535ad6d44dc$var$PopupAvatar);
const $9e5e3535ad6d44dc$var$CollaboratorsAvatarGroup = ({ collaborators: collaborators, cloudId: cloudId })=>{
    const { data: data, hasCollaborators: hasCollaborators } = (0, $5uXOq.useMemo)(()=>({
            data: !collaborators || !Boolean(collaborators?.length) ? $9e5e3535ad6d44dc$var$fallback : collaborators.map((c)=>({
                    id: c.id,
                    key: c.id,
                    name: c.name,
                    src: c.avatarUrl
                })),
            hasCollaborators: !Boolean(collaborators?.length) // Do not show tooltips for fallback avatar icons
        }), [
        collaborators
    ]);
    const handleAvatarClicked = (_event, _analyticsEvent, index)=>{
        if (!hasCollaborators) $9e5e3535ad6d44dc$var$openUserProfileWindow(data[index].id); // Do not try and open a profile on click if there are no collaborators (fallback to placeholder profile images)
    };
    const PopupAvatarWithCloudId = (props)=>/*#__PURE__*/ (0, $2OMIu.jsx)($9e5e3535ad6d44dc$var$PopupAvatarWithIntl, {
            ...props,
            cloudId: cloudId
        });
    return /*#__PURE__*/ (0, $2OMIu.jsx)($9e5e3535ad6d44dc$var$Wrapper, {
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $jnhNB.default), {
            appearance: "stack",
            data: data,
            // @ts-ignore the AvatarGroup typing says it won't accept this type..
            avatar: hasCollaborators ? (0, $ujWmd.default) : PopupAvatarWithCloudId,
            size: "medium",
            isTooltipDisabled: hasCollaborators,
            onAvatarClick: handleAvatarClicked
        })
    });
};
var $9e5e3535ad6d44dc$export$2e2bcd8739ae039 = $9e5e3535ad6d44dc$var$CollaboratorsAvatarGroup;

});
parcelRegister("j1n9G", function(module, exports) {
module.exports = new URL("Alvin.617c22ff.svg", import.meta.url).toString();

});

parcelRegister("7CZqP", function(module, exports) {
module.exports = new URL("Eliot.b55e69ea.svg", import.meta.url).toString();

});

parcelRegister("acLLs", function(module, exports) {
module.exports = new URL("Katina.38e0ef7e.svg", import.meta.url).toString();

});

parcelRegister("bKYtt", function(module, exports) {
module.exports = new URL("Norah.a590f774.svg", import.meta.url).toString();

});

parcelRegister("3LDms", function(module, exports) {
module.exports = new URL("Vania.8579933b.svg", import.meta.url).toString();

});

parcelRegister("3oc6s", function(module, exports) {

$parcel$export(module.exports, "default", () => $50d0748c980e9fc2$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $50d0748c980e9fc2$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    requestAccessTitle: {
        id: 'project-pages.cross-join.request-access.title',
        defaultMessage: 'Project pages require access to Confluence',
        description: 'Title for the request access view'
    },
    requestAccessTitleExp: {
        id: 'project-pages.cross-join.request-access.title.experiment',
        defaultMessage: 'Create a single source of truth for your team',
        description: 'Title for the unified request access & direct join view in project page for cross join nudge experiment'
    },
    requestAccessWithoutBetterTogetherDescription: {
        id: 'project-pages.cross-join.request-access-without-better-together.connected.description',
        defaultMessage: 'View, edit and create project documentation with your team',
        description: 'Description for request access view when there is a Confluence space connected'
    },
    requestAccessDescriptionExp: {
        id: 'project-pages.cross-join.request-access.connected.description.experimental',
        defaultMessage: "Your team is using Project Pages to comment, edit, and collaborate on project documentation without leaving Jira. Join Confluence to access your team\u2019s Project Pages.",
        description: 'Description for request access view when there is a Confluence space connected for new cross join nudge experiment'
    },
    requestAccessButton: {
        id: 'project-pages.cross-join.request-access.button',
        defaultMessage: 'Request access',
        description: 'Button label for request access CTA'
    },
    requestAccessButtonExp: {
        id: 'project-pages.cross-join.request-access.button.experimental',
        defaultMessage: 'Join your team',
        description: 'Button label for request access & direct join CTA for new cross join nudge experiment'
    },
    requestAccessButtonSubtitleExp: {
        id: 'project-pages.cross-join.request-access.button-subtitle.experimental',
        defaultMessage: "When you select 'Join Your Team', you're asking to join Confluence and agree to share your Atlassian profile with your admin.",
        description: 'Subtitle under Join Your Team button for request access scenario for new cross join nudge experiment'
    },
    joinProductButtonDescriptionExp: {
        id: 'project-pages.cross-join.direct-access.button-subtitle.experimental',
        defaultMessage: "You'll get access to Confluence. Your site admin has already approved you.",
        description: 'Subtitle under Join Your Team button for direct join scenario for new cross join nudge experiment'
    },
    requestAccessPendingRequestTitle: {
        id: 'project-pages.cross-join.pending-request.templates.title',
        defaultMessage: "You've requested access to Confluence",
        description: 'Title shown when user has requested access to Confluence but the request is pending'
    },
    requestAccessPendingRequestExp: {
        id: 'project-pages.cross-join.pending-request.templates.title.experiment',
        defaultMessage: 'Access request sent to Admin',
        description: 'Title shown when user has requested access to Confluence but the request is pending for new cross join nudge experiment'
    },
    requestAccessPendingRequestSubtitle: {
        id: 'project-pages.cross-join.pending-request.templates.subtitle',
        defaultMessage: "The site admin has received your request to join Confluence. If you're approved to join, project pages will start working and we'll send you a confirmation email.",
        description: 'Long description shown when user has requested access to Confluence but the request is pending'
    },
    requestAccessPendingRequestSubtitleExp: {
        id: 'project-pages.cross-join.pending-request.templates.subtitle.experiment',
        defaultMessage: "You'll get an email with access to Project Pages once you\u2019re approved.",
        description: 'Long description shown when user has requested access to Confluence but the request is pending for new cross join experiment'
    },
    requestDeniedAccessRequestTitle: {
        id: 'project-pages.cross-join.denied-request.templates.title',
        defaultMessage: 'Your admin has denied you access',
        description: 'Title shown when user has requested access to Confluence but the request is denied'
    },
    requestDeniedAccessRequestSubtitle: {
        id: 'project-pages.cross-join.denied-request.templates.subtitle',
        defaultMessage: "You can't use project pages because the site admin denied your request to join Confluence.",
        description: 'Subtitle shown when user has requested access to Confluence but the request is denied'
    },
    requestAccessRevokedTitle: {
        id: 'project-pages.cross-join.access-revoked.templates.title',
        defaultMessage: "You don't have permissions to use project pages",
        description: 'Title shown when user has requested access to Confluence but the request has since been revoked'
    },
    requestAccessRevokedSubtitle: {
        id: 'project-pages.cross-join.access-revoked.templates.subtitle',
        defaultMessage: 'You cannot use project pages because the admin has denied you access to Confluence. Contact your site admin to request access.',
        description: 'Subtitle shown when user has requested access to Confluence but the request has since been revoked'
    },
    viewProfile: {
        id: 'project-pages.cross-join.avatar.view-profile',
        defaultMessage: 'View profile'
    }
});

});


parcelRegister("1mg4V", function(module, exports) {
module.exports = new URL("cross-join-folder.39b6d302.svg", import.meta.url).toString();

});

parcelRegister("8LWHH", function(module, exports) {

$parcel$export(module.exports, "default", () => $8a9b1262ef256f37$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ /** @jsxfrag */ 
var $2OMIu = parcelRequire("2OMIu");

var $bwpsq = parcelRequire("bwpsq");

var $1GGwS = parcelRequire("1GGwS");

var $hTEpF = parcelRequire("hTEpF");

var $5uXOq = parcelRequire("5uXOq");

var $8RXs9 = parcelRequire("8RXs9");

var $3oc6s = parcelRequire("3oc6s");

var $8F18k = parcelRequire("8F18k");

var $171H0 = parcelRequire("171H0");

var $RzR6m = parcelRequire("RzR6m");

var $jkADf = parcelRequire("jkADf");

var $8c8di = parcelRequire("8c8di");
const $8a9b1262ef256f37$var$subtitleStyle = null;
const $8a9b1262ef256f37$var$RequestAccess = (0, $8RXs9.default)(({ intl: { formatMessage: formatMessage }, onClick: onClick, origin: origin, renderHeroImage: renderHeroImage, spaceKey: spaceKey, parentPageId: parentPageId, crossJoinProjectExperimentCohort: crossJoinProjectExperimentCohort = 'not-enrolled', accessRequestCapability: accessRequestCapability })=>{
    const requestAccessUrl = (0, $5uXOq.useMemo)(()=>(0, $8F18k.getCrossJoinConfluenceEditorUrl)(origin, spaceKey, parentPageId), [
        origin,
        spaceKey,
        parentPageId
    ]);
    const inCrossJoinVariation = crossJoinProjectExperimentCohort === 'variation';
    const getSubtitle = ()=>{
        if (!(crossJoinProjectExperimentCohort === 'variation') || !accessRequestCapability) return null;
        if (accessRequestCapability === (0, $8c8di.AccessRequestCapabilityType).REQUEST_ACCESS) // eslint-disable-next-line @atlaskit/design-system/use-primitives-text
        return /*#__PURE__*/ (0, $2OMIu.jsx)("p", {
            className: (0, $bwpsq.default)([
                "_syaz1rc1 _y3gn1h6o _19pk10v4"
            ]),
            children: formatMessage((0, $3oc6s.default).requestAccessButtonSubtitleExp)
        });
        if (accessRequestCapability === (0, $8c8di.AccessRequestCapabilityType).DIRECT_ACCESS) // eslint-disable-next-line @atlaskit/design-system/use-primitives-text
        return /*#__PURE__*/ (0, $2OMIu.jsx)("p", {
            className: (0, $bwpsq.default)([
                "_syaz1rc1 _y3gn1h6o _19pk10v4"
            ]),
            children: formatMessage((0, $3oc6s.default).joinProductButtonDescriptionExp)
        });
    };
    const getPrimaryAction = ()=>{
        if (!(crossJoinProjectExperimentCohort === 'variation') || !accessRequestCapability) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1GGwS.default), {
            appearance: "primary",
            href: requestAccessUrl,
            target: "_blank",
            onClick: onClick,
            children: formatMessage((0, $3oc6s.default).requestAccessButton)
        });
        // Note that InlineJoinButton has ability to do RA as well
        // Inline join button will fire RA or DA API call to identity and refreshes accessRequestCapability state
        // Successfull RA / DA will go to PendingRequest screen
        if (accessRequestCapability === (0, $8c8di.AccessRequestCapabilityType).REQUEST_ACCESS || accessRequestCapability === (0, $8c8di.AccessRequestCapabilityType).DIRECT_ACCESS) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $171H0.default), {
            onClick: onClick,
            children: formatMessage((0, $3oc6s.default).requestAccessButtonExp)
        });
    };
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2OMIu.Fragment), {
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $hTEpF.default), {
                renderImage: renderHeroImage,
                header: formatMessage(inCrossJoinVariation ? (0, $3oc6s.default).requestAccessTitleExp : (0, $3oc6s.default).requestAccessTitle),
                description: formatMessage(inCrossJoinVariation ? (0, $3oc6s.default).requestAccessDescriptionExp : (0, $3oc6s.default).requestAccessWithoutBetterTogetherDescription),
                primaryAction: getPrimaryAction(),
                testId: "confluence-project-pages.cross-join.request-access"
            }),
            getSubtitle(),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $RzR6m.default), {})
        ]
    });
});
var $8a9b1262ef256f37$export$2e2bcd8739ae039 = (props)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $jkADf.ContextWrapper), {
        sourceName: "projectPagesRequestAccess",
        sourceType: (0, $6e65040b988c460f$export$f636b5b56f1d624a),
        children: /*#__PURE__*/ (0, $2OMIu.jsx)($8a9b1262ef256f37$var$RequestAccess, {
            ...props
        })
    });

});
parcelRegister("8F18k", function(module, exports) {

$parcel$export(module.exports, "getCrossJoinConfluenceEditorUrl", () => $cdca8b6a79429ec1$export$be8d5a1a55011585);
const $cdca8b6a79429ec1$var$getConfluenceEditorUrl = (spaceKey, parentPageId)=>{
    if (spaceKey !== null && typeof spaceKey !== 'undefined') {
        const parentPageSection = parentPageId !== null && typeof parentPageId !== 'undefined' ? '/pages/' + parentPageId : '';
        return `/wiki/spaces/${spaceKey}${parentPageSection}`;
    } else return '/wiki';
};
const $cdca8b6a79429ec1$export$be8d5a1a55011585 = (origin, spaceKey, parentPageId)=>{
    const destUrl = $cdca8b6a79429ec1$var$getConfluenceEditorUrl(spaceKey, parentPageId);
    const identityParams = new URLSearchParams({
        'dest-url': origin ? origin.addToUrl(destUrl) : destUrl,
        application: 'confluence',
        'permission-violation': 'true'
    });
    return `/login?${identityParams.toString()}`;
};

});

parcelRegister("171H0", function(module, exports) {

$parcel$export(module.exports, "default", () => $133fa3d50b4128c4$export$2e2bcd8739ae039);

var $7Z8iG = parcelRequire("7Z8iG");

var $fp6yF = parcelRequire("fp6yF");

var $aPZf4 = parcelRequire("aPZf4");

var $4JVEL = parcelRequire("4JVEL");
const $133fa3d50b4128c4$var$mapStateToProps = (state)=>({
        isInlineJoinPending: (0, $4JVEL.getIsInlineJoinPending)(state)
    });
const $133fa3d50b4128c4$var$mapDispatchToProps = (dispatch)=>({
        triggerInlineJoin: ()=>dispatch((0, $aPZf4.inlineJoinConfluence)())
    });
var $133fa3d50b4128c4$export$2e2bcd8739ae039 = (0, $7Z8iG.connect)($133fa3d50b4128c4$var$mapStateToProps, $133fa3d50b4128c4$var$mapDispatchToProps)((0, $fp6yF.InlineJoinButton));

});
parcelRegister("fp6yF", function(module, exports) {

$parcel$export(module.exports, "InlineJoinButton", () => $1510a05c5cc38150$export$e4c2be29b76a28b9);

var $2OMIu = parcelRequire("2OMIu");

var $eCeGD = parcelRequire("eCeGD");

var $5uXOq = parcelRequire("5uXOq");
const $1510a05c5cc38150$export$e4c2be29b76a28b9 = ({ children: children, onClick: onClick, triggerInlineJoin: triggerInlineJoin, isInlineJoinPending: isInlineJoinPending })=>{
    const onClickHandler = (0, $5uXOq.useCallback)((e, analyticsEvent)=>{
        // do the inline-join
        triggerInlineJoin();
        onClick(e, analyticsEvent);
    }, [
        triggerInlineJoin,
        onClick
    ]);
    const buttonProps = isInlineJoinPending ? {
        isLoading: true
    } : {
        onClick: onClickHandler
    };
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eCeGD.default), {
        appearance: "primary",
        ...buttonProps,
        children: children
    });
};

});

parcelRegister("4JVEL", function(module, exports) {

$parcel$export(module.exports, "getIsInlineJoinPending", () => $bd03eedfd1c6a7ba$export$481f1783eddeff04);
const $bd03eedfd1c6a7ba$export$481f1783eddeff04 = (state)=>state.ui.inlineJoin.isJoinPending;

});



parcelRegister("2rv62", function(module, exports) {

$parcel$export(module.exports, "default", () => $6d2783466d464ac6$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $7iF6M = parcelRequire("7iF6M");

var $hTEpF = parcelRequire("hTEpF");

var $3oc6s = parcelRequire("3oc6s");

var $8RXs9 = parcelRequire("8RXs9");

var $RzR6m = parcelRequire("RzR6m");

var $jkADf = parcelRequire("jkADf");
const $6d2783466d464ac6$var$PendingRequest = (0, $8RXs9.default)(({ intl: { formatMessage: formatMessage }, crossJoinProjectExperimentCohort: crossJoinProjectExperimentCohort = 'not-enrolled' })=>{
    const inCrossJoinVariation = crossJoinProjectExperimentCohort === 'variation';
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2OMIu.Fragment), {
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $hTEpF.default), {
                imageUrl: (0, (/*@__PURE__*/$parcel$interopDefault($7iF6M))),
                imageHeight: 95,
                imageWidth: 124,
                header: formatMessage((0, $3oc6s.default).requestAccessPendingRequestTitle),
                description: formatMessage(inCrossJoinVariation ? (0, $3oc6s.default).requestAccessPendingRequestSubtitleExp : (0, $3oc6s.default).requestAccessPendingRequestSubtitle),
                testId: "confluence-project-pages.cross-join.pending-request"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $RzR6m.default), {})
        ]
    });
});
var $6d2783466d464ac6$export$2e2bcd8739ae039 = (props)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $jkADf.ContextWrapper), {
        sourceName: "projectPagesPendingRequest",
        sourceType: (0, $6e65040b988c460f$export$f636b5b56f1d624a),
        children: /*#__PURE__*/ (0, $2OMIu.jsx)($6d2783466d464ac6$var$PendingRequest, {
            ...props
        })
    });

});
parcelRegister("7iF6M", function(module, exports) {
module.exports = new URL("paper-aeroplane.83d00122.svg", import.meta.url).toString();

});


parcelRegister("3SjrN", function(module, exports) {

$parcel$export(module.exports, "default", () => $93b20e03f7efbf92$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $hTEpF = parcelRequire("hTEpF");
parcelRequire("5uXOq");

var $8RXs9 = parcelRequire("8RXs9");

var $hpiCU = parcelRequire("hpiCU");

var $RzR6m = parcelRequire("RzR6m");

var $jkADf = parcelRequire("jkADf");

var $171H0 = parcelRequire("171H0");

var $47bDC = parcelRequire("47bDC");

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $93b20e03f7efbf92$var$Subtitle = /*#__PURE__*/ (0, $47bDC.default).p.withConfig({
    componentId: "sc-1kmrlg4-0"
})({
    color: `var(--ds-text-subtlest, ${(0, $829f609a65d26a98$export$e2ef2124cf4024b1)})`,
    textAlign: 'center',
    marginTop: "var(--ds-space-negative-300, -24px)"
});
const $93b20e03f7efbf92$var$InlineJoinProduct = (0, $8RXs9.default)(({ intl: { formatMessage: formatMessage }, onClick: onClick, renderHeroImage: renderHeroImage })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2OMIu.Fragment), {
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $hTEpF.default), {
                renderImage: renderHeroImage,
                header: formatMessage((0, $hpiCU.default).joinProductTitle),
                description: formatMessage((0, $hpiCU.default).joinProductDescription),
                primaryAction: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $171H0.default), {
                    onClick: onClick,
                    children: formatMessage((0, $hpiCU.default).joinProductButton)
                }),
                testId: "confluence-project-pages.cross-join.join-product"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)($93b20e03f7efbf92$var$Subtitle, {
                children: /*#__PURE__*/ (0, $2OMIu.jsx)("small", {
                    children: formatMessage((0, $hpiCU.default).joinProductButtonDescription)
                })
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $RzR6m.default), {})
        ]
    });
});
var $93b20e03f7efbf92$export$2e2bcd8739ae039 = (props)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $jkADf.ContextWrapper), {
        sourceName: "projectPagesJoin",
        sourceType: (0, $6e65040b988c460f$export$f636b5b56f1d624a),
        children: /*#__PURE__*/ (0, $2OMIu.jsx)($93b20e03f7efbf92$var$InlineJoinProduct, {
            ...props
        })
    });

});
parcelRegister("hpiCU", function(module, exports) {

$parcel$export(module.exports, "default", () => $9336d2444ced2eb9$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $9336d2444ced2eb9$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    joinProductTitle: {
        id: 'project-pages.cross-join.inline-join-product.connected.title',
        defaultMessage: 'Collaborate on project pages with your team',
        description: 'Title encouraging users to join Confluence when there is a connected Confluence space'
    },
    joinProductDescription: {
        id: 'project-pages.cross-join.inline-join-product.connected.description',
        defaultMessage: 'View, edit and create documentation from a single place',
        description: 'Value prop for joining Confluence when there is a connected Confluence space'
    },
    joinProductButton: {
        id: 'project-pages.cross-join.inline-join-product.button',
        defaultMessage: 'Join',
        description: 'Button label for joining Confluence CTA'
    },
    joinProductButtonDescription: {
        id: 'project-pages.cross-join.inline-join-product.button',
        defaultMessage: "You\u2019ll get access to Confluence. Your site admin has already approved you.",
        description: 'Button label for joining Confluence CTA'
    }
});

});


parcelRegister("cVoy7", function(module, exports) {

$parcel$export(module.exports, "default", () => $f89628bba486dca3$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $eCw7i = parcelRequire("eCw7i");

var $hTEpF = parcelRequire("hTEpF");

var $3oc6s = parcelRequire("3oc6s");

var $8RXs9 = parcelRequire("8RXs9");

var $RzR6m = parcelRequire("RzR6m");

var $jkADf = parcelRequire("jkADf");
const $f89628bba486dca3$var$DeniedAccess = (0, $8RXs9.default)(({ intl: { formatMessage: formatMessage } })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2OMIu.Fragment), {
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $hTEpF.default), {
                imageUrl: (0, (/*@__PURE__*/$parcel$interopDefault($eCw7i))),
                imageHeight: 126,
                imageWidth: 96,
                header: formatMessage((0, $3oc6s.default).requestDeniedAccessRequestTitle),
                description: formatMessage((0, $3oc6s.default).requestDeniedAccessRequestSubtitle),
                testId: "confluence-project-pages.cross-join.denied-access"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $RzR6m.default), {})
        ]
    });
});
var $f89628bba486dca3$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $jkADf.ContextWrapper), {
        sourceName: "projectPagesAccessDenied",
        sourceType: (0, $6e65040b988c460f$export$f636b5b56f1d624a),
        children: /*#__PURE__*/ (0, $2OMIu.jsx)($f89628bba486dca3$var$DeniedAccess, {})
    });

});
parcelRegister("eCw7i", function(module, exports) {
module.exports = new URL("lock-red.d0e5588b.svg", import.meta.url).toString();

});


parcelRegister("cg24l", function(module, exports) {

$parcel$export(module.exports, "default", () => $bb542a4e4bacf1a1$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $eCw7i = parcelRequire("eCw7i");

var $hTEpF = parcelRequire("hTEpF");

var $3oc6s = parcelRequire("3oc6s");

var $8RXs9 = parcelRequire("8RXs9");

var $RzR6m = parcelRequire("RzR6m");

var $jkADf = parcelRequire("jkADf");
const $bb542a4e4bacf1a1$var$AccessRevoked = (0, $8RXs9.default)(({ intl: { formatMessage: formatMessage } })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2OMIu.Fragment), {
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $hTEpF.default), {
                imageUrl: (0, (/*@__PURE__*/$parcel$interopDefault($eCw7i))),
                imageHeight: 126,
                imageWidth: 96,
                header: formatMessage((0, $3oc6s.default).requestAccessRevokedTitle),
                description: formatMessage((0, $3oc6s.default).requestAccessRevokedSubtitle),
                testId: "confluence-project-pages.cross-join.access-revoked"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $RzR6m.default), {})
        ]
    });
});
var $bb542a4e4bacf1a1$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $jkADf.ContextWrapper), {
        sourceName: "projectPagesAccessRevoked",
        sourceType: (0, $6e65040b988c460f$export$f636b5b56f1d624a),
        children: /*#__PURE__*/ (0, $2OMIu.jsx)($bb542a4e4bacf1a1$var$AccessRevoked, {})
    });

});

parcelRegister("fkaak", function(module, exports) {

$parcel$export(module.exports, "default", () => $36d1131b3dc82ac4$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $kbCXK = parcelRequire("kbCXK");
parcelRequire("5uXOq");

var $RzR6m = parcelRequire("RzR6m");

var $iG3my = parcelRequire("iG3my");

var $jkADf = parcelRequire("jkADf");
const $36d1131b3dc82ac4$var$UnknownError = ()=>{
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2OMIu.Fragment), {
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $kbCXK.default), {
                messages: (0, $iG3my.default)
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $RzR6m.default), {})
        ]
    });
};
var $36d1131b3dc82ac4$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $jkADf.ContextWrapper), {
        sourceName: "projectPagesUnknownError",
        sourceType: (0, $6e65040b988c460f$export$f636b5b56f1d624a),
        children: /*#__PURE__*/ (0, $2OMIu.jsx)($36d1131b3dc82ac4$var$UnknownError, {})
    });

});
parcelRegister("iG3my", function(module, exports) {

$parcel$export(module.exports, "default", () => $bd23eff7c1c60473$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $bd23eff7c1c60473$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    title: {
        id: 'project-pages.cross-join.errors.unknown-error.title',
        defaultMessage: "We can't display project pages right now",
        description: 'Generic / unknown error message title'
    },
    description: {
        id: 'project-pages.cross-join.errors.unknown-error.description',
        defaultMessage: "{contactSupport} if refreshing doesn't fix things.",
        description: 'Generic / unknown error message description'
    }
});

});




parcelRegister("kSBKe", function(module, exports) {

$parcel$export(module.exports, "getAccessRequestCapability", () => $6219594b1502aee8$export$33030a40c54ad600);
const $6219594b1502aee8$export$33030a40c54ad600 = (state)=>state.confluence.accessRequestCapabilities.loaded ? state.confluence.accessRequestCapabilities.capability : undefined;

});

parcelRegister("dk2bH", function(module, exports) {

$parcel$export(module.exports, "getCollaborators", () => $62577a55b456626e$export$985b350648b09ad8);
const $62577a55b456626e$export$985b350648b09ad8 = (state)=>state.confluence.collaborators.loaded ? state.confluence.collaborators.users : undefined;

});



parcelRegister("eSbRM", function(module, exports) {

$parcel$export(module.exports, "default", () => $a456fe3a2c76299a$export$2e2bcd8739ae039);

var $7Z8iG = parcelRequire("7Z8iG");

var $aPZf4 = parcelRequire("aPZf4");

var $8RoFk = parcelRequire("8RoFk");

var $f1CtP = parcelRequire("f1CtP");
const $a456fe3a2c76299a$var$mapStateToProps = (state)=>({
        hasErrors: (0, $8RoFk.isThereAnError)(state),
        showSuccessFlag: (0, $8RoFk.successfullyConnectedSpace)(state),
        connectedSpaceOrPageName: (0, $8RoFk.getConnectedSpaceName)(state),
        isConnectedToPage: (0, $8RoFk.getIsConnectedToPage)(state),
        isConnectedToLiveDoc: (0, $8RoFk.getIsConnectedToLiveDoc)(state),
        title: (0, $8RoFk.getCustomFlagTitle)(state),
        description: (0, $8RoFk.getCustomFlagDescription)(state),
        showActivationErrorFlag: (0, $8RoFk.isActivationError)(state)
    });
const $a456fe3a2c76299a$var$mapDispatchToProps = (dispatch)=>({
        onErrorDismiss: ()=>dispatch((0, $aPZf4.dismissError)()),
        onSuccessDismiss: ()=>dispatch((0, $aPZf4.dismissSuccessFlag)()),
        onActivationErrorDismiss: ()=>dispatch((0, $aPZf4.dismissActivationErrorFlag)())
    });
var $a456fe3a2c76299a$export$2e2bcd8739ae039 = (0, $7Z8iG.connect)($a456fe3a2c76299a$var$mapStateToProps, $a456fe3a2c76299a$var$mapDispatchToProps)((0, $f1CtP.default));

});
parcelRegister("8RoFk", function(module, exports) {

$parcel$export(module.exports, "isThereAnError", () => $591293508e1fed4a$export$6caae3e4f5ab892d);
$parcel$export(module.exports, "successfullyConnectedSpace", () => $591293508e1fed4a$export$5fe667e6e7e6ce92);
$parcel$export(module.exports, "getConnectedSpaceName", () => $591293508e1fed4a$export$152b6e4dd8acd600);
$parcel$export(module.exports, "getIsConnectedToPage", () => $591293508e1fed4a$export$8062d4f2391d5856);
$parcel$export(module.exports, "getIsConnectedToLiveDoc", () => $591293508e1fed4a$export$bf500071ffebcb1f);
$parcel$export(module.exports, "getCustomFlagTitle", () => $591293508e1fed4a$export$d2b91d70eb29beed);
$parcel$export(module.exports, "getCustomFlagDescription", () => $591293508e1fed4a$export$743a9c2d20ab6d0e);
$parcel$export(module.exports, "isActivationError", () => $591293508e1fed4a$export$23e2ff39033650b7);
const $591293508e1fed4a$export$6caae3e4f5ab892d = (state)=>state.flags.hasErrors;
const $591293508e1fed4a$export$5fe667e6e7e6ce92 = (state)=>state.flags.showSuccessFlag;
const $591293508e1fed4a$export$152b6e4dd8acd600 = (state)=>state.flags.connectedSpaceName;
const $591293508e1fed4a$export$8062d4f2391d5856 = (state)=>state.flags.isConnectedToPage;
const $591293508e1fed4a$export$bf500071ffebcb1f = (state)=>state.flags.isConnectedToLiveDoc;
const $591293508e1fed4a$export$d2b91d70eb29beed = (state)=>state.flags.title;
const $591293508e1fed4a$export$743a9c2d20ab6d0e = (state)=>state.flags.description;
const $591293508e1fed4a$export$23e2ff39033650b7 = (state)=>state.flags.showActivationErrorFlag;

});

parcelRegister("f1CtP", function(module, exports) {

$parcel$export(module.exports, "messages", () => $81b3f6b7c675679e$export$defe85febe8b728c);
$parcel$export(module.exports, "default", () => $81b3f6b7c675679e$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $7VHMR = parcelRequire("7VHMR");
var $8RXs9 = parcelRequire("8RXs9");

var $fWXJB = parcelRequire("fWXJB");
var $epfFv = parcelRequire("epfFv");
var $6ARj7 = parcelRequire("6ARj7");

var $b0JGA = parcelRequire("b0JGA");

var $2Yv61 = parcelRequire("2Yv61");

var $34Rrn = parcelRequire("34Rrn");


var $RzR6m = parcelRequire("RzR6m");

var $jkADf = parcelRequire("jkADf");

var $VSDnB = parcelRequire("VSDnB");
const $81b3f6b7c675679e$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    'generic-error-heading': {
        id: 'project-pages.generic-error.heading',
        defaultMessage: 'Well, this is awkward...',
        description: ''
    },
    'generic-error-description': {
        id: 'project-pages.generic-error.description',
        defaultMessage: 'Something went wrong. Please try again later.',
        description: ''
    },
    'generic-error-reload-button': {
        id: 'project-pages.generic-error.button.reload',
        defaultMessage: 'Reload page',
        description: ''
    },
    'generic-success-flag-heading-space': {
        id: 'project-pages.generic-success-flag.heading.space',
        defaultMessage: 'Space connected',
        description: ''
    },
    'generic-success-flag-heading-page': {
        id: 'project-pages.generic-success-flag.heading.page',
        defaultMessage: 'Page connected',
        description: ''
    },
    'generic-success-flag-heading-live-doc': {
        id: 'project-pages.generic-success-flag.heading.live-doc',
        defaultMessage: 'Live doc connected',
        description: 'Heading to show on success flag when connected to a live doc'
    },
    'generic-success-flag-description-space': {
        id: 'project-pages.generic-success-flag.description.space',
        defaultMessage: 'Successfully connected with {connectedSpaceOrPageName} space.',
        description: ''
    },
    'generic-success-flag-description-page': {
        id: 'project-pages.generic-success-flag.description.page',
        defaultMessage: 'Successfully connected with {connectedSpaceOrPageName} page.',
        description: ''
    },
    'generic-success-flag-description-live-doc': {
        id: 'project-pages.generic-success-flag.description.live-doc',
        defaultMessage: 'Successfully connected with {connectedSpaceOrPageName} live doc.',
        description: 'Description to show on success flag when connected to a live doc'
    },
    'generic-activation-error-flag-description': {
        id: 'project-pages.generic-info-flag.description',
        defaultMessage: 'Something went wrong. Please try again or contact support if the issue persists',
        description: 'Description in an informative flag, prompting users to try again or contact support if the issue persists'
    }
});
class $81b3f6b7c675679e$var$Flags extends (0, $5uXOq.Component) {
    render() {
        const { intl: intl, hasErrors: hasErrors, onErrorDismiss: onErrorDismiss, onSuccessDismiss: onSuccessDismiss, onActivationErrorDismiss: onActivationErrorDismiss, onReload: onReload, showSuccessFlag: showSuccessFlag, connectedSpaceOrPageName: connectedSpaceOrPageName, title: title, description: description, showActivationErrorFlag: showActivationErrorFlag } = this.props;
        // eslint-disable-next-line no-undef
        if (false) return null;
        const SUCCESS_FLAG_ID = 'success';
        const ERROR_FLAG_ID = 'error';
        const INFO_FLAG_ID = 'info';
        const handleDismiss = (id)=>{
            if (id === SUCCESS_FLAG_ID) onSuccessDismiss();
            if (id === ERROR_FLAG_ID) onErrorDismiss();
            if (id === INFO_FLAG_ID) onActivationErrorDismiss();
        };
        const flags = [];
        if (hasErrors) {
            const primaryColor = `var(--ds-icon-warning, ${(0, $829f609a65d26a98$exports).Y300})`;
            const actions = [
                {
                    content: intl.formatMessage($81b3f6b7c675679e$export$defe85febe8b728c['generic-error-reload-button']),
                    onClick: ()=>onReload && onReload()
                }
            ];
            flags.push(/*#__PURE__*/ (0, $2OMIu.jsx)((0, $epfFv.default), {
                icon: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $5uXOq.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($34Rrn))), {
                            label: "Warning",
                            color: primaryColor
                        }),
                        /*#__PURE__*/ (0, $2OMIu.jsx)((0, $jkADf.ContextWrapper), {
                            sourceName: "errorFlag",
                            sourceType: (0, $6e65040b988c460f$export$1171103ea9083ffa),
                            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $RzR6m.default), {})
                        })
                    ]
                }),
                id: ERROR_FLAG_ID,
                actions: actions,
                title: intl.formatMessage($81b3f6b7c675679e$export$defe85febe8b728c['generic-error-heading']),
                description: intl.formatMessage($81b3f6b7c675679e$export$defe85febe8b728c['generic-error-description'])
            }, ERROR_FLAG_ID));
        }
        if (showActivationErrorFlag) flags.push(/*#__PURE__*/ (0, $2OMIu.jsx)((0, $fWXJB.default), {
            testId: "confluence-project-pages.info-flag",
            icon: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $5uXOq.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2Yv61))), {
                        label: "info",
                        color: "currentColor"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $jkADf.ContextWrapper), {
                        sourceName: "infoFlag",
                        sourceType: (0, $6e65040b988c460f$export$1171103ea9083ffa),
                        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $RzR6m.default), {})
                    })
                ]
            }),
            id: INFO_FLAG_ID,
            title: intl.formatMessage($81b3f6b7c675679e$export$defe85febe8b728c['generic-error-heading']),
            description: intl.formatMessage($81b3f6b7c675679e$export$defe85febe8b728c['generic-activation-error-flag-description'])
        }, INFO_FLAG_ID));
        if (showSuccessFlag) {
            const primaryColor = `var(--ds-icon-success, ${(0, $829f609a65d26a98$exports).G300})`;
            flags.push(/*#__PURE__*/ (0, $2OMIu.jsx)((0, $fWXJB.default), {
                testId: "confluence-project-pages.success-flag",
                icon: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $5uXOq.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($b0JGA))), {
                            label: "Success",
                            color: primaryColor
                        }),
                        /*#__PURE__*/ (0, $2OMIu.jsx)((0, $jkADf.ContextWrapper), {
                            sourceName: "successFlag",
                            sourceType: (0, $6e65040b988c460f$export$1171103ea9083ffa),
                            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $RzR6m.default), {})
                        })
                    ]
                }),
                id: SUCCESS_FLAG_ID,
                title: title || intl.formatMessage(this.getSuccessFlagHeading(), {
                    connectedSpaceOrPageName: connectedSpaceOrPageName
                }),
                description: description || intl.formatMessage(this.getSuccessFlagDescription(), {
                    connectedSpaceOrPageName: connectedSpaceOrPageName
                })
            }, SUCCESS_FLAG_ID));
        }
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $6ARj7.default), {
            onDismissed: handleDismiss,
            children: flags
        });
    }
    constructor(...args){
        super(...args), this.getSuccessFlagHeading = ()=>{
            const { isConnectedToPage: isConnectedToPage, isConnectedToLiveDoc: isConnectedToLiveDoc } = this.props;
            if (isConnectedToPage) {
                if (isConnectedToLiveDoc && (0, $VSDnB.fg)('confluence_live_pages_enabled_in_jira')) return $81b3f6b7c675679e$export$defe85febe8b728c['generic-success-flag-heading-live-doc'];
                return $81b3f6b7c675679e$export$defe85febe8b728c['generic-success-flag-heading-page'];
            }
            return $81b3f6b7c675679e$export$defe85febe8b728c['generic-success-flag-heading-space'];
        }, this.getSuccessFlagDescription = ()=>{
            const { isConnectedToPage: isConnectedToPage, isConnectedToLiveDoc: isConnectedToLiveDoc } = this.props;
            if (isConnectedToPage) {
                if (isConnectedToLiveDoc && (0, $VSDnB.fg)('confluence_live_pages_enabled_in_jira')) return $81b3f6b7c675679e$export$defe85febe8b728c['generic-success-flag-description-live-doc'];
                return $81b3f6b7c675679e$export$defe85febe8b728c['generic-success-flag-description-page'];
            }
            return $81b3f6b7c675679e$export$defe85febe8b728c['generic-success-flag-description-space'];
        };
    }
}
var $81b3f6b7c675679e$export$2e2bcd8739ae039 = (0, $8RXs9.default)($81b3f6b7c675679e$var$Flags);

});


parcelRegister("dYeSR", function(module, exports) {

$parcel$export(module.exports, "default", () => $075b0862c54e9ba0$export$2e2bcd8739ae039);

var $7Z8iG = parcelRequire("7Z8iG");

var $cEp5g = parcelRequire("cEp5g");

var $aPZf4 = parcelRequire("aPZf4");

var $jWzAp = parcelRequire("jWzAp");

var $6L3iv = parcelRequire("6L3iv");
const $075b0862c54e9ba0$var$mapStateToProps = (state)=>({
        isSpaceConnected: (0, $cEp5g.isSpaceConnected)(state),
        spaceOrPageId: (0, $cEp5g.getProjectPageLinkedId)(state),
        spaceOrPageTitle: (0, $cEp5g.getConnectedSpaceOrPageTitle)(state),
        spaceOrPageLink: (0, $cEp5g.getConnectedSpaceOrPageUrl)(state),
        isConnectedToPage: (0, $cEp5g.getIsConnectedToPage)(state),
        isConnectedToLiveDoc: (0, $cEp5g.getIsConnectedToLiveDoc)(state),
        spaceIcon: (0, $cEp5g.getProjectSpaceIcon)(state),
        isProjectMember: (0, $6L3iv.getIsProjectMember)(state)
    });
const $075b0862c54e9ba0$var$mapDispatchToProps = (dispatch)=>({
        triggerShowConnectSpaceDialog: ()=>{
            dispatch((0, $aPZf4.showConnectSpaceDialog)());
        },
        triggerFetchConnectedSpacePageTitle: ()=>dispatch((0, $aPZf4.fetchConnectedSpaceOrPageTitle)())
    });
var $075b0862c54e9ba0$export$2e2bcd8739ae039 = (0, $7Z8iG.connect)($075b0862c54e9ba0$var$mapStateToProps, $075b0862c54e9ba0$var$mapDispatchToProps)((0, $jWzAp.default));

});
parcelRegister("jWzAp", function(module, exports) {

$parcel$export(module.exports, "default", () => $093495842d9a2b7f$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $8RXs9 = parcelRequire("8RXs9");

var $3bDjY = parcelRequire("3bDjY");

var $fVnbM = parcelRequire("fVnbM");

var $42CjB = parcelRequire("42CjB");

var $1hCXn = parcelRequire("1hCXn");

var $1DFlG = parcelRequire("1DFlG");

var $cRyWV = parcelRequire("cRyWV");

var $crB07 = parcelRequire("crB07");

var $jkADf = parcelRequire("jkADf");
var $h8yj2 = parcelRequire("h8yj2");

var $escMm = parcelRequire("escMm");

var $VSDnB = parcelRequire("VSDnB");

var $c0aEF = parcelRequire("c0aEF");
var $414Wj = parcelRequire("414Wj");
const $093495842d9a2b7f$var$MoreMenuComponent = (0, $8RXs9.default)(({ triggerShowConnectSpaceDialog: triggerShowConnectSpaceDialog, triggerFetchConnectedSpacePageTitle: triggerFetchConnectedSpacePageTitle, isSpaceConnected: isSpaceConnected, spaceOrPageTitle: spaceOrPageTitle, spaceOrPageLink: spaceOrPageLink, isConnectedToPage: isConnectedToPage, isConnectedToLiveDoc: isConnectedToLiveDoc, spaceIcon: spaceIcon, isProjectMember: isProjectMember, intl: { formatMessage: formatMessage } })=>{
    const handleUpdateSpaceOrPageClick = (0, $5uXOq.useCallback)((analyticsEvent)=>{
        triggerShowConnectSpaceDialog();
        (0, $h8yj2.fireUIAnalytics)(analyticsEvent, 'updateSpaceOrPageButton', {
            isConnectedToPage: isConnectedToPage
        });
    }, [
        isConnectedToPage,
        triggerShowConnectSpaceDialog
    ]);
    const handleNavigateToConnectedSpaceOrPageClick = (analyticsEvent)=>{
        (0, $h8yj2.fireUIAnalytics)(analyticsEvent, 'navigateToConnectedSpaceOrPageButton', {
            isConnectedToPage: isConnectedToPage
        });
    };
    const getConnectedContentTooltipMessage = ()=>{
        if (isConnectedToPage) {
            if (isConnectedToLiveDoc && (0, $VSDnB.fg)('confluence_live_pages_enabled_in_jira')) return (0, $1DFlG.default).goToConnectedLiveDocTooltip;
            return (0, $1DFlG.default).goToConnectedPageTooltip;
        }
        return (0, $1DFlG.default).goToConnectedSpaceTooltip;
    };
    (0, $5uXOq.useEffect)(()=>{
        if (isSpaceConnected) triggerFetchConnectedSpacePageTitle();
    }, [
        triggerFetchConnectedSpacePageTitle,
        isSpaceConnected
    ]);
    const { maxWidth: maxWidth, appearance: appearance } = {
        maxWidth: '208px',
        appearance: 'default'
    };
    const connectionIcon = (0, $5uXOq.useMemo)(()=>{
        if (isConnectedToPage) {
            const PageTypeIcon = isConnectedToLiveDoc && (0, $VSDnB.fg)('confluence_live_pages_enabled_in_jira') ? (0, $crB07.LiveDocIcon) : (0, $crB07.PageIcon);
            return /*#__PURE__*/ (0, $2OMIu.jsx)(PageTypeIcon, {});
        }
        if (spaceIcon) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cRyWV.PaddedIcon), {
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $crB07.SpaceIcon), {
                iconPath: spaceIcon
            })
        });
        return undefined;
    }, [
        isConnectedToPage,
        isConnectedToLiveDoc,
        spaceIcon
    ]);
    const theme = (0, $escMm.useThemeContext)();
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $cRyWV.Wrapper), {
        children: [
            spaceOrPageTitle && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3bDjY.default), {
                content: formatMessage(getConnectedContentTooltipMessage()),
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fVnbM.default), {
                    appearance: "subtle-link",
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                    style: {
                        maxWidth: maxWidth
                    },
                    href: spaceOrPageLink || undefined,
                    onClick: (_, analyticsEvent)=>handleNavigateToConnectedSpaceOrPageClick(analyticsEvent),
                    target: "_blank",
                    spacing: isProjectMember ? 'default' : 'none',
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $414Wj.default), {
                        alignInline: "center",
                        children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $c0aEF.default), {
                            alignBlock: "center",
                            space: "space.075",
                            grow: "fill",
                            children: [
                                connectionIcon,
                                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cRyWV.SpaceOrPageTitleWrapper), {
                                    theme: theme,
                                    children: spaceOrPageTitle
                                })
                            ]
                        })
                    })
                })
            }),
            isProjectMember && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3bDjY.default), {
                content: spaceOrPageTitle ? formatMessage((0, $1DFlG.default).updateConnectedSpaceOrPageTooltip) : formatMessage((0, $1DFlG.default).connectedSpaceOrPageTooltip),
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $42CjB.default), {
                    label: formatMessage((0, $1DFlG.default).label),
                    appearance: appearance,
                    onClick: (_, analyticsEvent)=>handleUpdateSpaceOrPageClick(analyticsEvent),
                    icon: (iconProps)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1hCXn))), {
                            ...iconProps
                        }),
                    "data-test-id": "confluence-project-pages.post-expand.connect-or-update-space-button"
                })
            })
        ]
    });
});
var $093495842d9a2b7f$export$2e2bcd8739ae039 = (props)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $jkADf.ContextWrapper), {
        sourceName: "moreMenu",
        sourceType: (0, $6e65040b988c460f$export$d1123261ca8831d2),
        children: /*#__PURE__*/ (0, $2OMIu.jsx)($093495842d9a2b7f$var$MoreMenuComponent, {
            ...props
        })
    });

});
parcelRegister("1hCXn", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::398607da20751a97774109d098b7c919>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0ef598f8e2d0d537$var$_react = $0ef598f8e2d0d537$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $0ef598f8e2d0d537$var$_baseNew = $0ef598f8e2d0d537$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $0ef598f8e2d0d537$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ArrowsDiagonalUpRightDownLeft".
 * Category: multi-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Used within Jira Pages to connect or switch to a Space or page.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $0ef598f8e2d0d537$var$ArrowsDiagonalUpRightDownLeftIcon = (props)=>/*#__PURE__*/ $0ef598f8e2d0d537$var$_react.default.createElement($0ef598f8e2d0d537$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M4 1h5.25a.75.75 0 0 1 .75.75V7H8.5V3.56l-6.47 6.47L.97 8.97 7.44 2.5H4zm3.5 11.44 6.47-6.47 1.06 1.06-6.47 6.47H12V15H6.75a.75.75 0 0 1-.75-.75V9h1.5z" clip-rule="evenodd"/>`
    }, props));
$0ef598f8e2d0d537$var$ArrowsDiagonalUpRightDownLeftIcon.displayName = 'ArrowsDiagonalUpRightDownLeftIcon';
var $0ef598f8e2d0d537$var$_default = module.exports.default = $0ef598f8e2d0d537$var$ArrowsDiagonalUpRightDownLeftIcon;

});

parcelRegister("1DFlG", function(module, exports) {

$parcel$export(module.exports, "default", () => $07db99b24e5b3392$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $07db99b24e5b3392$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    label: {
        id: 'project-pages.button.connect-different-space-or-page.label',
        defaultMessage: 'Update space or page icon',
        description: 'Label for update space or page icon'
    },
    goToConnectedSpaceTooltip: {
        id: 'project-pages.button.go-to-connected-space.tooltip',
        defaultMessage: 'Open space in Confluence',
        description: 'Tooltip displayed on hover over the button to connect to a different Confluence space'
    },
    goToConnectedPageTooltip: {
        id: 'project-pages.button.go-to-connected-page.tooltip',
        defaultMessage: 'Open page in Confluence',
        description: 'Tooltip displayed on hover over the button to connect to a different Confluence page'
    },
    goToConnectedLiveDocTooltip: {
        id: 'project-pages.button.go-to-connected-live-doc.tooltip',
        defaultMessage: 'Open live doc in Confluence',
        description: 'Tooltip displayed on hover over the button to connect to a different Confluence live doc'
    },
    updateConnectedSpaceOrPageTooltip: {
        id: 'project-pages.button.connect-different-space-or-page.tooltip',
        defaultMessage: 'Connect different space or item',
        description: 'Tooltip displayed on hover over the button to connect to a different Confluence space or page'
    },
    connectedSpaceOrPageTooltip: {
        id: 'project-pages.button.connect-space-or-page.tooltip',
        defaultMessage: 'Connect to Confluence',
        description: 'Tooltip displayed on hover over the button to connect to a Confluence space or page'
    }
});

});

parcelRegister("cRyWV", function(module, exports) {

$parcel$export(module.exports, "Wrapper", () => $e024cf33dcd9146f$export$e6dfd72ab29f8598);
$parcel$export(module.exports, "PaddedIcon", () => $e024cf33dcd9146f$export$e2c1843c9369c070);
$parcel$export(module.exports, "SpaceOrPageTitleWrapper", () => $e024cf33dcd9146f$export$b7d1851404721f6c);
/* eslint-disable @atlaskit/platform/ensure-feature-flag-prefix */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $47bDC = parcelRequire("47bDC");
const $e024cf33dcd9146f$export$e6dfd72ab29f8598 = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "sc-1k42rnn-0"
})({
    display: 'flex',
    alignItems: 'center',
    minHeight: "var(--ds-space-400, 32px)"
});
const $e024cf33dcd9146f$export$e2c1843c9369c070 = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "sc-1k42rnn-1"
})({
    marginRight: "var(--ds-space-050, 4px)"
});
const $e024cf33dcd9146f$export$b7d1851404721f6c = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "sc-1k42rnn-2"
})`${({ theme: theme })=>`color: ${theme.color.primary} ;`}`;

});

parcelRegister("escMm", function(module, exports) {

$parcel$export(module.exports, "whiteTheme", () => $f6462452f56e93d5$export$d50851c3d0154c0a);
$parcel$export(module.exports, "ThemeContext", () => $f6462452f56e93d5$export$2c657da244d00bd6);
$parcel$export(module.exports, "useThemeContext", () => $f6462452f56e93d5$export$c4281ec44b929e6);


var $5uXOq = parcelRequire("5uXOq");
const $f6462452f56e93d5$export$d50851c3d0154c0a = {
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
    name: 'white',
    type: 'light',
    background: {
        color: `var(--ds-surface, ${(0, $829f609a65d26a98$export$29a4f05edc054374)})`
    },
    color: {
        primary: `var(--ds-text, ${(0, $829f609a65d26a98$export$7d61b15e0da132af)})`,
        secondary: `var(--ds-text, ${(0, $829f609a65d26a98$export$7d61b15e0da132af)})`
    },
    navigation: {
        icon: {
            textColor: `var(--ds-text-subtle, ${(0, $829f609a65d26a98$export$eece5f492e429f08)})`,
            color: `var(--ds-icon, ${(0, $829f609a65d26a98$export$d6447c357493214f)})`,
            gradientStart: `var(--ds-icon, ${(0, $829f609a65d26a98$export$7090862dc3038a9f)})`,
            gradientStop: `var(--ds-icon-accent-gray, ${(0, $829f609a65d26a98$export$d6447c357493214f)})`
        }
    }
};
const $f6462452f56e93d5$export$2c657da244d00bd6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createContext($f6462452f56e93d5$export$d50851c3d0154c0a);
const $f6462452f56e93d5$export$c4281ec44b929e6 = ()=>(0, $5uXOq.useContext)($f6462452f56e93d5$export$2c657da244d00bd6);

});



parcelRegister("dwh31", function(module, exports) {

$parcel$export(module.exports, "default", () => $e2747642dc9749ce$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $8RXs9 = parcelRequire("8RXs9");

var $6kC3z = parcelRequire("6kC3z");
const $e2747642dc9749ce$var$PagesHeading = ({ intl: intl, isPreExpand: isPreExpand })=>{
    return isPreExpand ? // eslint-disable-next-line @atlaskit/design-system/use-primitives-text
    /*#__PURE__*/ (0, $2OMIu.jsx)("p", {
        "data-testid": "confluence.project-pages.pre-expand.heading",
        children: intl.formatMessage((0, $6kC3z.default).headingInfo)
    }) : null;
};
var $e2747642dc9749ce$export$2e2bcd8739ae039 = (0, $8RXs9.default)($e2747642dc9749ce$var$PagesHeading);

});
parcelRegister("6kC3z", function(module, exports) {

$parcel$export(module.exports, "default", () => $470c3b49504790bd$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $470c3b49504790bd$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    title: {
        id: 'project-pages.improvement.title',
        defaultMessage: 'Project pages',
        description: 'Page title for the Project pages feature'
    },
    headingInfo: {
        id: 'project-pages.improvement.heading-info',
        defaultMessage: "Capture your team's knowledge and improve the way you get work done.",
        description: 'Information about the value of the Project pages feature'
    },
    headingInfoV2: {
        id: 'project-pages.improvement.heading-info-v2',
        defaultMessage: "Create one place for all your team's project documents",
        description: 'Information about the value of the Project pages feature'
    },
    feature1: {
        id: 'project-pages.improvement.feature1',
        defaultMessage: 'Access and create documents without leaving Jira',
        description: 'First bulleted feature that explains the value of using Confluence alongside Jira'
    },
    feature2: {
        id: 'project-pages.improvement.feature2',
        defaultMessage: 'Templates for meetings, sprint plans, and more',
        description: 'Second bulleted feature that explains the value of using Confluence alongside Jira'
    },
    feature3: {
        id: 'project-pages.improvement.feature3',
        defaultMessage: 'Sync documents to Jira for automatic updates',
        description: 'Third bulleted feature that explains the value of using Confluence alongside Jira'
    },
    termsAndConditionsV2: {
        id: 'project-pages.improvement.terms-and-conditions-v2',
        defaultMessage: "By selecting 'Try it now' you acknowledge you will be enrolled in Confluence and agree to the Atlassian <termsLink>Cloud Terms of Service</termsLink> and <privacyLink>Privacy Policy</privacyLink>.",
        description: 'Links to the Terms and Conditions and Privacy Policy that the user must agree to before starting their Confluence trial'
    },
    tryItNow: {
        id: 'project-pages.improvement.try-it-now',
        defaultMessage: 'Try it now',
        description: 'Call to action for the user to start their Confluence trial'
    },
    poweredBy: {
        id: 'project-pages.improvement.powered-by',
        defaultMessage: 'Powered by',
        description: 'Prefix to the footer indicating the Project pages feature is powered by Confluence'
    },
    poweredByTooltip: {
        id: 'project-pages.improvement.powered-by.tooltip',
        defaultMessage: 'Open Confluence in a new tab',
        description: 'Tooltip on the Confluence logo in the powered by footer to indicate that clicking will open Confluence in a new tab'
    },
    previewTeaser: {
        id: 'project-pages.improvement.preview-teaser',
        defaultMessage: 'Unlock templates, project pages, and more.',
        description: 'Teaser for Confluence touchpoint'
    },
    learnMoreButton: {
        id: 'project-pages.improvement.learn-more-button',
        defaultMessage: 'Learn more',
        description: 'Button label for Confluence touchpoint'
    },
    tryLozenge: {
        id: 'project-pages.improvement.try-lozenge',
        defaultMessage: 'try',
        description: 'This text appears as a way to encourage the user to try Confluence'
    },
    tryButton: {
        id: 'project-pages.improvement.try-button',
        defaultMessage: 'Try this template in Confluence',
        description: 'Button label for Confluence touchpoint'
    },
    tryOnDemandButton: {
        id: 'project-pages.improvement.try-on-demand-button',
        defaultMessage: 'Try it free',
        description: 'Button label for Confluence touchpoint when users can activate Confluence for free'
    },
    templatesPreExpandTitle: {
        id: 'project-pages.improvement.templates.pre-expand.title',
        defaultMessage: 'Preview templates',
        description: 'Title for list of page templates'
    },
    templatesPreExpandSubtitle: {
        id: 'project-pages.improvement.templates.pre-expand.subtitle',
        defaultMessage: 'Popular with teams like yours',
        description: 'Information for list of page templates'
    },
    templatesPreExpandMore: {
        id: 'project-pages.improvement.templates.pre-expand.more',
        defaultMessage: 'Explore more templates',
        description: 'Link to documentation about Confluence templates'
    },
    templatesPostExpandTitle: {
        id: 'project-pages.improvement.templates.post-expand.title',
        defaultMessage: 'Create a page',
        description: 'Title for list of page templates'
    },
    templatesPostExpandSubtitle: {
        id: 'project-pages.improvement.templates.post-expand.subtitle',
        defaultMessage: 'Popular templates',
        description: 'Information for list of page templates'
    },
    templatesPostExpandMore: {
        id: 'project-pages.improvement.templates.post-expand.more',
        defaultMessage: 'More templates',
        description: 'Link to browse templates'
    },
    templatesPostExpandMoreTooltip: {
        id: 'project-pages.improvement.templates.post-expand.more.tooltip',
        defaultMessage: 'View all templates in Confluence',
        description: 'Tooltip for link to browse templates'
    },
    connectSpaceTooltip: {
        id: 'project-pages.improvement.templates.template.disabled-tooltip',
        defaultMessage: 'Connect a Confluence space first',
        description: 'Tooltip informing user that template creation is disabled until they connect a space'
    },
    blankPageTemplateName: {
        id: 'project-pages.improvement.templates.blank-page.name',
        defaultMessage: 'Blank page',
        description: 'Title of a blank template'
    },
    blankPageTemplateDescription: {
        id: 'project-pages.improvement.templates.blank-page.description',
        defaultMessage: 'Start a page from scratch.',
        description: 'Description of a blank template'
    },
    productRequirementsTemplateName: {
        id: 'project-pages.improvement.templates.product-requirements.name',
        defaultMessage: 'Product requirements',
        description: 'Title of a template'
    },
    productRequirementsTemplateDescription: {
        id: 'project-pages.improvement.templates.product-requirements.description',
        defaultMessage: 'Define, track and scope requirements for your product or feature.',
        description: 'Description for a template'
    },
    decisionTemplateName: {
        id: 'project-pages.improvement.templates.decision.name',
        defaultMessage: 'Decision',
        description: 'Title of a template'
    },
    decisionTemplateDescription: {
        id: 'project-pages.improvement.templates.decision.description',
        defaultMessage: 'Record important project decisions and communicate them with your team.',
        description: 'Description for a template'
    },
    meetingNotesTemplateName: {
        id: 'project-pages.improvement.templates.meeting-notes.name',
        defaultMessage: 'Meeting notes',
        description: 'Title of a template'
    },
    meetingNotesTemplateDescription: {
        id: 'project-pages.improvement.templates.meeting-notes.description',
        defaultMessage: 'Set meeting agendas, take notes, and share action items with your team.',
        description: 'Description for a template'
    },
    retrospectiveTemplateName: {
        id: 'project-pages.improvement.templates.retrospective.name',
        defaultMessage: 'Retrospective',
        description: 'Title of a template'
    },
    retrospectiveTemplateDescription: {
        id: 'project-pages.improvement.templates.retrospective.description',
        defaultMessage: 'What went well? What could have gone better? Crowdsource improvements with your team.',
        description: 'Description for a template'
    },
    tutorialPageDescription: {
        id: 'project-pages.improvement.templates.tutorial.description',
        defaultMessage: 'Learn how to edit a page.',
        description: 'Description for the tutorial page'
    },
    tutorialPageName: {
        id: 'project-pages.improvement.templates.tutorial.name',
        defaultMessage: 'Welcome to Project Pages!',
        description: 'Title of the tutorial page'
    }
});

});


parcelRegister("hdZcc", function(module, exports) {

$parcel$export(module.exports, "EmbeddedConfluenceDialog", () => $3a57b2224886f3b6$export$7e517a57a72534f5);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $ha42n = parcelRequire("ha42n");
var $bSOOm = parcelRequire("bSOOm");

var $i8Qvm = parcelRequire("i8Qvm");

var $jEzJT = parcelRequire("jEzJT");

var $hxoiH = parcelRequire("hxoiH");

var $gxTpK = parcelRequire("gxTpK");

var $3J3nd = parcelRequire("3J3nd");

var $eTdH7 = parcelRequire("eTdH7");

var $eNwjm = parcelRequire("eNwjm");

var $ewakd = parcelRequire("ewakd");
var $3WIK2 = parcelRequire("3WIK2");

var $1PpDv = parcelRequire("1PpDv");

var $21AEa = parcelRequire("21AEa");

var $jkADf = parcelRequire("jkADf");
var $h8yj2 = parcelRequire("h8yj2");

var $RzR6m = parcelRequire("RzR6m");

var $2NMNM = parcelRequire("2NMNM");

var $8rAPH = parcelRequire("8rAPH");
// a list of experience tracker events that we're interested in to monitor
const $3a57b2224886f3b6$var$MONITORED_EXPERIENCE_TRACKER_EVENT_NAMES = [
    // these first 3 are child experiences of a view page
    'edit-page/load',
    'edit-page/publish',
    'view-content',
    'view-page/edit'
];
const $3a57b2224886f3b6$var$EmbeddedConfluenceDialogView = ({ spaceKey: spaceKey })=>{
    const { accountId: accountId, parentProduct: parentProduct } = (0, $8rAPH.useProjectPages)();
    const themeState = (0, $hxoiH.default)();
    const { showPagePublishedFlag: showPagePublishedFlag, showPageDeletedFlag: showPageDeletedFlag, showDraftSavedFlag: showDraftSavedFlag, showErrorFlag: showErrorFlag } = (0, $jEzJT.useEmbeddedPagesFlags)();
    const experienceTracker = (0, $5uXOq.useMemo)(()=>new (0, $ha42n.ExperienceTracker)(), []);
    const { mode: mode, page: page, isOpen: isOpen, isLoading: isLoading, pageCreate: pageCreate, setEmbeddedPage: setEmbeddedPage } = (0, $eNwjm.useEmbeddedPage)();
    const { updatePage: updatePage, removePage: removePage } = (0, $3WIK2.useConfluencePageTree)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const sendTrackEvent = (0, $5uXOq.useCallback)((actionSubject, action, attributes)=>{
        (0, $h8yj2.fireTrackAnalytics)(createAnalyticsEvent({}), `${actionSubject} ${action}`, {
            embeddedPageAction: true,
            ...attributes
        });
    }, [
        createAnalyticsEvent
    ]);
    const isFailEvent = (event)=>event.action === 'taskFail';
    // fires an operational event for an experience tracker event
    const sendExperienceTrackerEvent = (0, $5uXOq.useCallback)((event)=>{
        const { action: action, name: name, attributes: attributes, id: id, startTime: startTime } = event;
        const eventAttributes = {
            ...attributes,
            ...isFailEvent(event) && {
                errorMessage: event.error.message,
                errorName: event.error.name,
                errorTime: window.performance.now()
            }
        };
        (0, $h8yj2.fireOperationalAnalytics)(createAnalyticsEvent({}), `embeddedPage ${action}`, {
            task: name,
            taskId: id,
            startTime: startTime,
            attributes: eventAttributes
        });
    }, [
        createAnalyticsEvent
    ]);
    // When showing a modal inside the embedded component, we stitch some shaded blankets around it make it look seamless
    const [isInnerModalOpen, setIsInnerModalOpen] = (0, $5uXOq.useState)(false);
    const navigationPolicy = (0, $5uXOq.useMemo)(()=>({
            navigate (url, modifiers, defaultNavigate) {
                // When in edit mode, ignore defaultNavigate and delegate user actions to the experienceTracker
                if (mode === 'edit') return;
                // Note1: When in view mode, and when the edit button is clicked, and if the page supports
                // embedded editing, toggle the edit mode. defaultNavigate() is called for other cases (eg. synchrony pages)
                // Note2: deleting a comment triggers a navigation event with its target set to '_self'
                // other navigation events, like editing or deleting a page, have their target set to '_blank'
                if (mode === 'view' && page && page.hasEmbeddedEdit && (modifiers.routeName === 'EDIT_PAGE_EMBED' || url.includes('/edit-embed/') // FIXME modifiers.routeName does not appear to be populated properly yet, remove this when it is
                )) {
                    setEmbeddedPage({
                        mode: 'edit',
                        isLoading: true
                    });
                    sendTrackEvent('embeddedPage', 'edit');
                    return;
                }
                return defaultNavigate(url, modifiers);
            }
        }), [
        mode,
        page,
        sendTrackEvent,
        setEmbeddedPage
    ]);
    const PageDialog = (0, $5uXOq.useMemo)(()=>{
        return mode === 'edit' ? (0, $3J3nd.EditPageDialog) : (0, $gxTpK.ViewPageDialog);
    }, [
        mode
    ]);
    const handleOnPublish = (0, $5uXOq.useCallback)(async ()=>{
        if (page) {
            setEmbeddedPage({
                mode: 'view',
                isLoading: true,
                page: {
                    ...page,
                    isDraft: false
                }
            });
            const publishedPage = await updatePage(page.id, 'current');
            // update the view URL now that the page is published
            if (publishedPage) setEmbeddedPage({
                page: publishedPage
            });
        }
        showPagePublishedFlag();
        sendTrackEvent('embeddedPage', 'updated');
    }, [
        page,
        sendTrackEvent,
        setEmbeddedPage,
        showPagePublishedFlag,
        updatePage
    ]);
    const handleOnClose = (0, $5uXOq.useCallback)(async ()=>{
        if (page && page.isDraft) {
            const { id: id } = page;
            try {
                await updatePage(id, 'draft');
                showDraftSavedFlag();
            } catch (e) {
                showErrorFlag();
            }
        }
        setEmbeddedPage({
            page: null,
            isOpen: false,
            isLoading: false,
            pageCreate: null
        });
        sendTrackEvent('embeddedPageDialog', 'closed');
    }, [
        page,
        setEmbeddedPage,
        sendTrackEvent,
        updatePage,
        showDraftSavedFlag,
        showErrorFlag
    ]);
    const handleOpenInnerModal = (0, $5uXOq.useCallback)(()=>{
        setIsInnerModalOpen(true);
    }, []);
    const handleCloseInnerModal = (0, $5uXOq.useCallback)(({ closeOuterModal: closeOuterModal, updatePageTree: updatePageTree })=>{
        setIsInnerModalOpen(false);
        if (closeOuterModal) {
            handleOnClose();
            showPageDeletedFlag();
        }
        if (updatePageTree && page) removePage(page.id);
    }, [
        handleOnClose,
        page,
        removePage,
        showPageDeletedFlag
    ]);
    (0, $5uXOq.useEffect)(()=>experienceTracker.subscribe((event)=>{
            const { name: name, action: action } = event;
            if ($3a57b2224886f3b6$var$MONITORED_EXPERIENCE_TRACKER_EVENT_NAMES.includes(name)) sendExperienceTrackerEvent(event);
            if ((name === 'view-page' || name === 'edit-page/load') && action !== 'taskStart' // abort/fail/success
            ) // turn off the Loading screen only when there is something to show in the iframe
            setEmbeddedPage({
                isLoading: false
            });
            if (name === 'edit-page/close' && action === 'taskSuccess') {
                if (page && page.isDraft) handleOnClose();
                else // just switch back to view mode
                setEmbeddedPage({
                    mode: 'view',
                    isLoading: true
                });
                // fires for both drafts and published close clicks
                sendTrackEvent('embeddedPage', 'closed');
            }
            if (name === 'edit-page/publish' && action === 'taskSuccess') handleOnPublish();
            if (name === 'delete-page') {
                if (action === 'taskStart') handleOpenInnerModal();
                else {
                    const success = action === 'taskSuccess';
                    handleCloseInnerModal({
                        closeOuterModal: success,
                        updatePageTree: success
                    });
                    if (success) sendTrackEvent('embeddedPage', 'deleted', {
                        actionType: 'delete'
                    });
                }
            }
            if (name === 'archiving/archive-pages') {
                if (action === 'taskStart') handleOpenInnerModal();
                else {
                    const success = action === 'taskSuccess';
                    handleCloseInnerModal({
                        closeOuterModal: false,
                        // unlike delete, archiving a page should not close the modal
                        updatePageTree: success
                    });
                    if (success) sendTrackEvent('embeddedPage', 'deleted', {
                        actionType: 'archive'
                    });
                }
            }
            if (name === 'archiving/restore-pages') {
                if (action === 'taskStart') handleOpenInnerModal();
                else handleCloseInnerModal({
                    closeOuterModal: false,
                    // FIXME the problem is you can restore the page to a different parent...
                    // also there seems to be a delay/race condition around this even if restored to same parent
                    updatePageTree: action === 'taskSuccess'
                });
            }
            if (name === 'add-page-comment' && action === 'taskSuccess') sendTrackEvent('embeddedPageComment', 'created');
            if (name === 'delete-page-comment' && action === 'taskSuccess') sendTrackEvent('embeddedPageComment', 'deleted');
        }), [
        experienceTracker,
        handleOnClose,
        handleOnPublish,
        handleOpenInnerModal,
        handleCloseInnerModal,
        page,
        setEmbeddedPage,
        showDraftSavedFlag,
        pageCreate,
        sendTrackEvent,
        sendExperienceTrackerEvent
    ]);
    const content = (0, $5uXOq.useMemo)(()=>{
        if (!isOpen) return null;
        if (pageCreate && pageCreate.error) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $21AEa.default), {
            spaceKey: spaceKey,
            onCloseModal: handleOnClose
        });
        if (page && spaceKey) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1PpDv.LoadingContainer), {
            isLoading: isLoading,
            children: /*#__PURE__*/ (0, $2OMIu.jsx)(PageDialog, {
                parentProduct: parentProduct,
                spaceKey: spaceKey,
                contentId: page.id,
                navigationPolicy: navigationPolicy,
                accountId: accountId,
                themeState: themeState
            })
        });
        if (isLoading) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1PpDv.LoadingContainer), {
            isLoading: true
        });
        return null;
    }, [
        PageDialog,
        handleOnClose,
        isLoading,
        isOpen,
        navigationPolicy,
        page,
        pageCreate,
        parentProduct,
        spaceKey,
        accountId,
        themeState
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bSOOm.ExperienceTrackerContext).Provider, {
        value: experienceTracker,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $i8Qvm.default), {
            children: isOpen && /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $eTdH7.default), {
                "data-testid": "embedded-confluence-embedded-page-modal",
                mode: mode,
                headerBtnHref: page?.url,
                onClose: handleOnClose,
                isInnerModalOpen: isInnerModalOpen,
                children: [
                    content,
                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $RzR6m.default), {})
                ]
            })
        })
    });
};
const $3a57b2224886f3b6$export$7e517a57a72534f5 = (props)=>{
    const { page: page, mode: mode, pageCreate: pageCreate } = (0, $eNwjm.useEmbeddedPage)();
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $jkADf.ContextWrapper), {
        sourceName: "embeddedPage",
        sourceType: (0, $6e65040b988c460f$export$1171103ea9083ffa),
        attributes: {
            ...page && (0, $ewakd.pageAnalyticsAttributes)(page),
            embeddedPageMode: mode,
            ...pageCreate ? {
                embeddedPageMode: 'create',
                createRootPage: pageCreate.isRoot
            } : {}
        },
        children: /*#__PURE__*/ (0, $2OMIu.jsx)($3a57b2224886f3b6$var$EmbeddedConfluenceDialogView, {
            ...props
        })
    });
};

});
parcelRegister("jEzJT", function(module, exports) {

$parcel$export(module.exports, "useEmbeddedPagesFlags", () => $35c0c3dacad9a9fe$export$fc3e883640d66552);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");

var $bKCvK = parcelRequire("bKCvK");


var $jGlB6 = parcelRequire("jGlB6");

var $2NMNM = parcelRequire("2NMNM");

var $h8yj2 = parcelRequire("h8yj2");

var $b0JGA = parcelRequire("b0JGA");

var $34Rrn = parcelRequire("34Rrn");

var $f1CtP = parcelRequire("f1CtP");
const $35c0c3dacad9a9fe$var$withAutoDismissFlagArgs = {
    isAutoDismiss: true
};
const $35c0c3dacad9a9fe$var$baseSuccessFlagArgs = {
    ...$35c0c3dacad9a9fe$var$withAutoDismissFlagArgs,
    icon: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($b0JGA))), {
        label: "Success",
        spacing: "spacious",
        color: `var(--ds-icon, ${(0, $829f609a65d26a98$export$940e1f69e873f202)})`
    })
};
const $35c0c3dacad9a9fe$var$baseErrorFlagArgs = {
    ...$35c0c3dacad9a9fe$var$withAutoDismissFlagArgs,
    icon: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($34Rrn))), {
        label: "Warning",
        spacing: "spacious",
        color: `var(--ds-icon, ${(0, $829f609a65d26a98$export$c6930421db9fa514)})`
    })
};
const $35c0c3dacad9a9fe$export$fc3e883640d66552 = ()=>{
    const { showFlag: showFlag } = (0, $bKCvK.useFlags)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const showPagePublishedFlag = (0, $5uXOq.useCallback)(()=>{
        const analyticsEventFlag = createAnalyticsEvent({
            action: 'viewed',
            actionSubject: 'flag'
        });
        (0, $h8yj2.fireUIAnalytics)(analyticsEventFlag, 'embeddedPagePublishSuccessFlag');
        showFlag({
            ...$35c0c3dacad9a9fe$var$baseSuccessFlagArgs,
            id: 'pagePublishedFlag',
            title: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                ...(0, $jGlB6.default).pagePublishedFlagTitle
            }),
            analyticsContext: {},
            testId: 'confluence-project-pages.flag.page-published'
        });
    }, [
        createAnalyticsEvent,
        showFlag
    ]);
    const showDraftSavedFlag = (0, $5uXOq.useCallback)((onOpenDraft)=>{
        const actions = onOpenDraft ? [
            {
                content: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                    ...(0, $jGlB6.default).draftSavedFlagOpenDraft
                }),
                onClick: onOpenDraft
            }
        ] : [];
        return showFlag({
            ...$35c0c3dacad9a9fe$var$baseSuccessFlagArgs,
            id: 'draftSavedFlag',
            title: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                ...(0, $jGlB6.default).draftSavedFlagTitle
            }),
            description: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                ...(0, $jGlB6.default).draftSavedFlagDescription
            }),
            actions: actions,
            testId: 'confluence-project-pages.flag.draft-saved'
        });
    }, [
        showFlag
    ]);
    const showPageDeletedFlag = (0, $5uXOq.useCallback)(()=>showFlag({
            ...$35c0c3dacad9a9fe$var$baseSuccessFlagArgs,
            id: 'pageDeletedFlag',
            title: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                ...(0, $jGlB6.default).pageDeletedFlagTitle
            }),
            testId: 'confluence-project-pages.flag.page-deleted'
        }), [
        showFlag
    ]);
    const showErrorFlag = (0, $5uXOq.useCallback)(()=>showFlag({
            ...$35c0c3dacad9a9fe$var$baseErrorFlagArgs,
            id: 'pageErrorFlag',
            title: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                ...(0, $f1CtP.messages)['generic-error-heading']
            }),
            description: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                ...(0, $f1CtP.messages)['generic-error-description']
            }),
            testId: 'confluence-project-pages.flag.error'
        }), [
        showFlag
    ]);
    return {
        showPagePublishedFlag: showPagePublishedFlag,
        showDraftSavedFlag: showDraftSavedFlag,
        showPageDeletedFlag: showPageDeletedFlag,
        showErrorFlag: showErrorFlag
    };
};

});
parcelRegister("jGlB6", function(module, exports) {

$parcel$export(module.exports, "default", () => $b07379908ce6cd18$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
const $b07379908ce6cd18$var$messages = (0, $7VHMR.defineMessages)({
    pagePublishedFlagTitle: {
        id: 'project-pages.page-published-flag.title',
        defaultMessage: 'Your page has been published.',
        description: 'Notification title when a Confluence page is published'
    },
    draftSavedFlagTitle: {
        id: 'project-pages.draft-saved-flag.title',
        defaultMessage: 'Draft saved',
        description: 'Notification title when a Confluence draft is saved'
    },
    draftSavedFlagDescription: {
        id: 'project-pages.draft-saved-flag.description',
        defaultMessage: 'Your draft is only visible to you until you publish it.',
        description: 'Notification body when a Confluence draft is saved.'
    },
    draftSavedFlagOpenDraft: {
        id: 'project-pages.draft-saved-flag.action',
        defaultMessage: 'Open draft',
        description: 'Notification link to open the Confluence saved draft'
    },
    pageDeletedFlagTitle: {
        id: 'project-pages.page-deleted-flag.title',
        defaultMessage: 'Page deleted.',
        description: 'Notification title when a Confluence page is deleted'
    }
});
var $b07379908ce6cd18$export$2e2bcd8739ae039 = $b07379908ce6cd18$var$messages;

});


parcelRegister("gxTpK", function(module, exports) {

$parcel$export(module.exports, "ViewPageDialog", () => $07217ebeb6a6d47e$export$5691cfa937ca280a);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $pf8Kz = parcelRequire("pf8Kz");

var $koVbs = parcelRequire("koVbs");
const $07217ebeb6a6d47e$export$5691cfa937ca280a = ({ contentId: contentId, spaceKey: spaceKey, parentProduct: parentProduct, navigationPolicy: navigationPolicy, accountId: accountId, themeState: themeState })=>{
    const { locale: locale } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $pf8Kz.ViewPage), {
        locale: locale,
        "data-testid": "embedded-confluence-view-page-dialog",
        contentId: contentId,
        parentProduct: parentProduct,
        spaceKey: spaceKey,
        navigationPolicy: navigationPolicy,
        allowedFeatures: [
            'byline-contributors',
            'byline-extensions',
            'page-comments',
            'edit',
            'delete',
            'page-reactions',
            'inline-comments',
            'non-licensed-share'
        ],
        hasFooterLogo: false,
        userInfo: {
            userId: accountId,
            userIdType: 'atlassianAccount'
        },
        themeState: themeState,
        isFullScreenEmbedView: true
    });
};

});
parcelRegister("pf8Kz", function(module, exports) {

$parcel$export(module.exports, "ViewPage", () => $242f5dff0675cac8$export$767e3006bdbb424a);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $MHKc7 = parcelRequire("MHKc7");

var $kc9vJ = parcelRequire("kc9vJ");

var $kMusA = parcelRequire("kMusA");
var $iMKGq = parcelRequire("iMKGq");

var $aDZtw = parcelRequire("aDZtw");
const $242f5dff0675cac8$var$styles = {
    fallback: "_1bsb1osq _4t3i1osq"
};

const $242f5dff0675cac8$var$LazyViewPage = (0, $kc9vJ.lazyForPaint)(()=>(parcelRequire("h6VU7")));
const $242f5dff0675cac8$export$767e3006bdbb424a = (props)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $kMusA.I18nProvider), {
        locale: props.locale,
        fetchTranslations: (0, $aDZtw.default),
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $iMKGq.PerformanceMetricsProvider), {
            contentType: "viewPage",
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $kc9vJ.LazySuspense), {
                fallback: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
                    xcss: $242f5dff0675cac8$var$styles.fallback
                }),
                children: /*#__PURE__*/ (0, $2OMIu.jsx)($242f5dff0675cac8$var$LazyViewPage, {
                    ...props
                })
            })
        })
    });

});
parcelRegister("kMusA", function(module, exports) {

$parcel$export(module.exports, "I18nProvider", () => $f904dd1e90d25852$export$a54013f0d02a8f82);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $i5FdW = parcelRequire("i5FdW");

var $jmOm3 = parcelRequire("jmOm3");
const $f904dd1e90d25852$export$a54013f0d02a8f82 = ({ children: children, locale: incomingLocale = (0, $jmOm3.DEFAULT_LOCALE), fetchTranslations: fetchTranslations })=>{
    const [messages, setMessages] = (0, $5uXOq.useState)();
    const locale = (0, $5uXOq.useMemo)(()=>(0, $jmOm3.normalizeLocale)(incomingLocale), [
        incomingLocale
    ]);
    (0, $5uXOq.useEffect)(()=>{
        const loadTranslations = async ()=>{
            const localeMessages = await fetchTranslations(locale);
            setMessages(localeMessages);
        };
        loadTranslations();
    }, [
        fetchTranslations,
        locale
    ]);
    if (!messages) return null;
    // Do not place formatMessage / FormattedMessage / useIntl calls here outside of the I18nProvider.
    // They will not function correctly due to a lack of I18n context.
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $i5FdW.default), {
        locale: locale,
        messages: messages,
        defaultLocale: (0, $jmOm3.DEFAULT_LOCALE),
        children: children
    });
};

});
parcelRegister("jmOm3", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_LOCALE", () => $60196e800e53edb0$export$1af4c7e47ad72f44);
$parcel$export(module.exports, "normalizeLocale", () => $60196e800e53edb0$export$dca0327c9b9c6498);
const $60196e800e53edb0$var$DEFAULT_LANGUAGE = 'en';
const $60196e800e53edb0$var$DEFAULT_REGION = 'US';
const $60196e800e53edb0$export$1af4c7e47ad72f44 = `${$60196e800e53edb0$var$DEFAULT_LANGUAGE}-${$60196e800e53edb0$var$DEFAULT_REGION}`;
const $60196e800e53edb0$var$languageToLongLocaleCode = {
    cs: 'cs-CZ',
    da: 'da-DK',
    de: 'de-DE',
    en: 'en-US',
    es: 'es-ES',
    fi: 'fi-FI',
    fr: 'fr-FR',
    hu: 'hu-HU',
    it: 'it-IT',
    ja: 'ja-JP',
    ko: 'ko-KR',
    // Both `no` and `nb` language codes refer to Norwegian. Refer both to long locale code as `no-NO`
    no: 'no-NO',
    nb: 'no-NO',
    nl: 'nl-NL',
    pl: 'pl-PL',
    ru: 'ru-RU',
    sv: 'sv-SE',
    th: 'th-TH',
    tr: 'tr-TR',
    uk: 'uk-UA',
    vi: 'vi-VN',
    zh: 'zh-CN'
};
const $60196e800e53edb0$export$dca0327c9b9c6498 = (locale)=>{
    if (!locale) return $60196e800e53edb0$export$1af4c7e47ad72f44;
    const match = /([a-z]*)[_-]?([A-Z]*)/i.exec(locale);
    if (!match) throw Error('Unable to get language and country from the supplied locale.');
    const [, language, region] = match;
    const normalizedLanguage = (language ?? '').toLowerCase();
    const normalizedRegion = (region ?? '').toUpperCase();
    if (normalizedLanguage && normalizedRegion) return [
        normalizedLanguage,
        normalizedRegion
    ].join('-');
    const longLocaleCode = $60196e800e53edb0$var$languageToLongLocaleCode[normalizedLanguage];
    return longLocaleCode ?? $60196e800e53edb0$export$1af4c7e47ad72f44;
};

});


parcelRegister("iMKGq", function(module, exports) {

$parcel$export(module.exports, "usePerformanceMetrics", () => $09e44177b1162191$export$865423e6f8e2e839);
$parcel$export(module.exports, "PerformanceMetricsProvider", () => $09e44177b1162191$export$c6f19d9afc6c86c8);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $4fLRx = parcelRequire("4fLRx");


var $VSDnB = parcelRequire("VSDnB");
// PerformanceMetricsProvider is only applied to internal EP
// Methods provided by PerformanceMetricsContext are defined by default as () => {}
// This allows instances not wrapped in provider (ie embedded-confluence public) to opperate without errors
const $09e44177b1162191$var$PerformanceMetricsContext = /*#__PURE__*/ (0, $5uXOq.createContext)({
    isInitialized: false,
    stopIframeOnloadTimer: ()=>{},
    cancelIframeLoadMetrics: ()=>{},
    // markTimeToIframeOnLoadEnd: () => {},
    setContentType: ()=>{}
});
// calculate timestamp from iframe's performance metric post message
// relative to parent's window.performance.now() adjusted for post message latency
const $09e44177b1162191$var$adjustedPerformanceTimestamp = (timestamp)=>typeof timestamp === 'number' ? window.performance.now() - (Date.now() - timestamp) : undefined;
const $09e44177b1162191$var$Provider = ({ children: children, contentType: contentType })=>{
    const iframeOnloadTimer = (0, $5uXOq.useRef)((0, $4fLRx.iframeOnloadMetric)());
    const [currentContentType, setCurrentContentType] = (0, $5uXOq.useState)(contentType);
    const isInitialized = (0, $5uXOq.useRef)(true);
    const iframeLoadMetrics = (0, $5uXOq.useRef)();
    const embeddedViewToEditTransitionTimer = (0, $5uXOq.useRef)((0, $4fLRx.embeddedViewToEditTransitionMetric)());
    (0, $5uXOq.useLayoutEffect)(()=>{
        // TODO: Currently EP does not work with more that one instance per parent window
        // When this limitation is fixed we will also need to find a way to serialize post messages
        // this is because post message listeners will pick up on all messages coming to the parent window
        // triggering any callback listening to a given data.type message
        // therefore messages will need to be scoped to the particular instance they are intended for
        // Setup iframe post message handling
        const handler = (e)=>{
            switch(e.data.type){
                case (0, $4ea313a1cb7f9f75$export$ad3f29048eb3061) + (0, $4ea313a1cb7f9f75$export$e5b04c2a3cc97ddc):
                    iframeLoadMetrics.current?.stop({
                        stopTime: $09e44177b1162191$var$adjustedPerformanceTimestamp(e.data.payload?.timestamp)
                    });
                    break;
                case (0, $4ea313a1cb7f9f75$export$ad3f29048eb3061) + (0, $4ea313a1cb7f9f75$export$9f8bbf62fac57d48):
                    iframeLoadMetrics.current?.stop({
                        stopTime: $09e44177b1162191$var$adjustedPerformanceTimestamp(e.data.payload?.timestamp)
                    });
                    embeddedViewToEditTransitionTimer.current.stop({
                        stopTime: $09e44177b1162191$var$adjustedPerformanceTimestamp(e.data.payload?.timestamp)
                    });
                    break;
                case (0, $4ea313a1cb7f9f75$export$ad3f29048eb3061) + (0, $4ea313a1cb7f9f75$export$e08d2ab8ef653595):
                    embeddedViewToEditTransitionTimer.current.start({
                        startTime: $09e44177b1162191$var$adjustedPerformanceTimestamp(e.data.payload?.timestamp)
                    });
                    break;
            }
        };
        window.addEventListener('message', handler);
        const currentTransitionTimer = embeddedViewToEditTransitionTimer.current;
        const currentIframeOnloadTimer = iframeOnloadTimer.current;
        return ()=>{
            window.removeEventListener('message', handler);
            currentIframeOnloadTimer.cancel();
            currentTransitionTimer.cancel();
        };
    }, []);
    // Set load metric based on content type
    (0, $5uXOq.useLayoutEffect)(()=>{
        if (currentContentType) {
            // start Embedded Confluence iframe load metric
            iframeOnloadTimer.current.start();
            // cancel current Embedded Confluence iframe load metric if necessary
            iframeLoadMetrics.current?.cancel();
            iframeLoadMetrics.current = (0, $4fLRx.embeddedConfluenceIframeLoadMetrics)(currentContentType);
            // start Embedded Confluence iframe load metric
            iframeLoadMetrics.current.start();
        // iframeLoadMetrics.current.mark('tt-onload-start');
        }
        return ()=>{
            iframeLoadMetrics.current?.cancel();
        };
    }, [
        currentContentType
    ]);
    const stopIframeOnloadTimer = (0, $5uXOq.useCallback)(()=>iframeOnloadTimer.current.stop(), []);
    const cancelIframeLoadMetrics = (0, $5uXOq.useCallback)(()=>{
        iframeLoadMetrics.current?.cancel();
    }, []);
    return /*#__PURE__*/ (0, $2OMIu.jsx)($09e44177b1162191$var$PerformanceMetricsContext.Provider, {
        value: {
            stopIframeOnloadTimer: stopIframeOnloadTimer,
            cancelIframeLoadMetrics: cancelIframeLoadMetrics,
            isInitialized: isInitialized.current,
            setContentType: setCurrentContentType
        },
        children: children
    });
};
const $09e44177b1162191$export$865423e6f8e2e839 = ()=>{
    return (0, $5uXOq.useContext)($09e44177b1162191$var$PerformanceMetricsContext);
};
const $09e44177b1162191$export$2ba0c6357609a3dd = ({ children: children, contentType: contentType })=>{
    const { isInitialized: isInitialized, setContentType: setContentType } = $09e44177b1162191$export$865423e6f8e2e839();
    (0, $5uXOq.useLayoutEffect)(()=>{
        // Update contentType when Page component replaces ViewPage with EditPage or vice versa
        isInitialized && contentType && setContentType(contentType);
    }, [
        isInitialized,
        contentType,
        setContentType
    ]);
    return !isInitialized ? /*#__PURE__*/ (0, $2OMIu.jsx)($09e44177b1162191$var$Provider, {
        contentType: contentType,
        children: children
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {
        children: children
    });
};
const $09e44177b1162191$export$c6f19d9afc6c86c8 = ({ children: children, contentType: contentType })=>(0, $VSDnB.fg)('embedded-confluence-performance-markers') ? /*#__PURE__*/ (0, $2OMIu.jsx)($09e44177b1162191$export$2ba0c6357609a3dd, {
        contentType: contentType,
        children: children
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {
        children: children
    });

});
parcelRegister("4fLRx", function(module, exports) {

$parcel$export(module.exports, "iframeOnloadMetric", () => $9fee6411d325eb4e$export$af3d27819c1d6290);
$parcel$export(module.exports, "embeddedViewToEditTransitionMetric", () => $9fee6411d325eb4e$export$4de078c3b9971f9b);
$parcel$export(module.exports, "embeddedConfluenceIframeLoadMetrics", () => $9fee6411d325eb4e$export$a23245993532c751);

var $dGrdR = parcelRequire("dGrdR");

var $2OjhD = parcelRequire("2OjhD");
const $9fee6411d325eb4e$export$af3d27819c1d6290 = ()=>(0, $dGrdR.metrics).interaction({
        key: 'embedded-confluence-time-to-iframe-onload'
    });
const $9fee6411d325eb4e$export$4de078c3b9971f9b = ()=>(0, $dGrdR.metrics).interaction({
        key: 'embedded-confluence-view-to-edit-transition'
    });
const $9fee6411d325eb4e$var$loadingMetricsConfig = {
    viewPage: {
        key: 'embedded-confluence-view-page-iframe',
        type: (0, $2OjhD.BMEventsType).PAGE_SEGMENT_LOAD
    },
    editPage: {
        key: 'embedded-confluence-edit-page-iframe',
        type: (0, $2OjhD.BMEventsType).PAGE_SEGMENT_LOAD
    }
};
const $9fee6411d325eb4e$export$a23245993532c751 = (contentType)=>(0, $dGrdR.metrics).pageSegmentLoad($9fee6411d325eb4e$var$loadingMetricsConfig[contentType]);

});

const $4ea313a1cb7f9f75$export$ad3f29048eb3061 = 'embedded-confluence-metrics.';
const $4ea313a1cb7f9f75$export$e5b04c2a3cc97ddc = 'embedded-view-tti';
const $4ea313a1cb7f9f75$export$9f8bbf62fac57d48 = 'embedded-editor-tti';
const $4ea313a1cb7f9f75$export$e08d2ab8ef653595 = 'embedded-edit-click';


parcelRegister("aDZtw", function(module, exports) {

$parcel$export(module.exports, "default", () => $9df194a880c612c7$export$2e2bcd8739ae039);

























const $9df194a880c612c7$var$importTranslations = async (locale)=>{
    switch(locale){
        case 'cs-CZ':
            return (parcelRequire("dg22d"));
        case 'da-DK':
            return (parcelRequire("bHgVw"));
        case 'de-DE':
            return (parcelRequire("ihMKU"));
        case 'en-US':
            return (parcelRequire("1DYRh"));
        case 'en-GB':
            return (parcelRequire("2H7Gl"));
        case 'en-ZZ':
            return (parcelRequire("7pXPV"));
        case 'es-ES':
            return (parcelRequire("6QGn3"));
        case 'fi-FI':
            return (parcelRequire("bG8Q5"));
        case 'fr-FR':
            return (parcelRequire("6kJnj"));
        case 'hu-HU':
            return (parcelRequire("3byzg"));
        case 'it-IT':
            return (parcelRequire("8HzvA"));
        case 'ja-JP':
            return (parcelRequire("lW5zK"));
        case 'ko-KR':
            return (parcelRequire("gsskd"));
        case 'no-NO':
            return (parcelRequire("1xkmr"));
        case 'nl-NL':
            return (parcelRequire("bKNzm"));
        case 'pl-PL':
            return (parcelRequire("elYav"));
        case 'pt-BR':
            return (parcelRequire("4DQe5"));
        case 'ru-RU':
            return (parcelRequire("dQdjA"));
        case 'sv-SE':
            return (parcelRequire("9GOL7"));
        case 'tr-TR':
            return (parcelRequire("bz7l1"));
        case 'th-TH':
            return (parcelRequire("j0dOH"));
        case 'uk-UA':
            return (parcelRequire("8uVTY"));
        case 'vi-VN':
            return (parcelRequire("fzTXV"));
        case 'zh-TW':
            return (parcelRequire("LM9aa"));
        case 'zh-CN':
            return (parcelRequire("3tjgd"));
        default:
            return Promise.resolve({
                default: {}
            });
    }
};
const $9df194a880c612c7$var$fetchTranslations = async (locale)=>{
    const module = await $9df194a880c612c7$var$importTranslations(locale);
    return module.default;
};
var $9df194a880c612c7$export$2e2bcd8739ae039 = $9df194a880c612c7$var$fetchTranslations;

});
parcelRegister("dg22d", function(module, exports) {

let $9a6e59061e21fb69$var$load = (parcelRequire("28QjX"))(4);
module.exports = $9a6e59061e21fb69$var$load("MVP2S").then(()=>parcelRequire('6pfpU'));

});

parcelRegister("bHgVw", function(module, exports) {

let $8840d72d0918bd5e$var$load = (parcelRequire("28QjX"))(4);
module.exports = $8840d72d0918bd5e$var$load("2Gvqx").then(()=>parcelRequire('7w5UY'));

});

parcelRegister("ihMKU", function(module, exports) {

let $d4ffa25bf58636a8$var$load = (parcelRequire("28QjX"))(4);
module.exports = $d4ffa25bf58636a8$var$load("2tnEA").then(()=>parcelRequire('aWztu'));

});

parcelRegister("1DYRh", function(module, exports) {

let $1328a423dd0dedd6$var$load = (parcelRequire("28QjX"))(4);
module.exports = $1328a423dd0dedd6$var$load("6hrKt").then(()=>parcelRequire('jHFq0'));

});

parcelRegister("2H7Gl", function(module, exports) {

let $1f658e6d8d192a6e$var$load = (parcelRequire("28QjX"))(4);
module.exports = $1f658e6d8d192a6e$var$load("fwsdB").then(()=>parcelRequire('1PCsF'));

});

parcelRegister("7pXPV", function(module, exports) {

let $5669487e2a90de16$var$load = (parcelRequire("28QjX"))(4);
module.exports = $5669487e2a90de16$var$load("lpZwC").then(()=>parcelRequire('dICEU'));

});

parcelRegister("6QGn3", function(module, exports) {

let $4fc8775e18c8d40f$var$load = (parcelRequire("28QjX"))(4);
module.exports = $4fc8775e18c8d40f$var$load("a9tWn").then(()=>parcelRequire('f9W42'));

});

parcelRegister("bG8Q5", function(module, exports) {

let $880a79387c29f8f3$var$load = (parcelRequire("28QjX"))(4);
module.exports = $880a79387c29f8f3$var$load("aF8lD").then(()=>parcelRequire('g7kLj'));

});

parcelRegister("6kJnj", function(module, exports) {

let $49c7cee3e7d1f505$var$load = (parcelRequire("28QjX"))(4);
module.exports = $49c7cee3e7d1f505$var$load("gO8zT").then(()=>parcelRequire('c7UhG'));

});

parcelRegister("3byzg", function(module, exports) {

let $251d36a1adf4242c$var$load = (parcelRequire("28QjX"))(4);
module.exports = $251d36a1adf4242c$var$load("bS0f1").then(()=>parcelRequire('bP2JM'));

});

parcelRegister("8HzvA", function(module, exports) {

let $655de2203731b5a7$var$load = (parcelRequire("28QjX"))(4);
module.exports = $655de2203731b5a7$var$load("3OeEY").then(()=>parcelRequire('e4t9o'));

});

parcelRegister("lW5zK", function(module, exports) {

let $ff8356f5664ee742$var$load = (parcelRequire("28QjX"))(4);
module.exports = $ff8356f5664ee742$var$load("5tcgU").then(()=>parcelRequire('9BGDf'));

});

parcelRegister("gsskd", function(module, exports) {

let $bfb53b9dcfb6ce87$var$load = (parcelRequire("28QjX"))(4);
module.exports = $bfb53b9dcfb6ce87$var$load("cpcby").then(()=>parcelRequire('6GBqB'));

});

parcelRegister("1xkmr", function(module, exports) {

let $11e8aac5af0e7585$var$load = (parcelRequire("28QjX"))(4);
module.exports = $11e8aac5af0e7585$var$load("i2VuZ").then(()=>parcelRequire('jfYJF'));

});

parcelRegister("bKNzm", function(module, exports) {

let $88ea7103d886f0ef$var$load = (parcelRequire("28QjX"))(4);
module.exports = $88ea7103d886f0ef$var$load("3FOGk").then(()=>parcelRequire('ka9xb'));

});

parcelRegister("elYav", function(module, exports) {

let $a731b311eb5551c5$var$load = (parcelRequire("28QjX"))(4);
module.exports = $a731b311eb5551c5$var$load("iWfkE").then(()=>parcelRequire('hurod'));

});

parcelRegister("4DQe5", function(module, exports) {

let $361350f8ebbaf5a4$var$load = (parcelRequire("28QjX"))(4);
module.exports = $361350f8ebbaf5a4$var$load("18X4a").then(()=>parcelRequire('eTC68'));

});

parcelRegister("dQdjA", function(module, exports) {

let $a13a75c570cad600$var$load = (parcelRequire("28QjX"))(4);
module.exports = $a13a75c570cad600$var$load("8718U").then(()=>parcelRequire('gdlzK'));

});

parcelRegister("9GOL7", function(module, exports) {

let $70df68fc6cc0941e$var$load = (parcelRequire("28QjX"))(4);
module.exports = $70df68fc6cc0941e$var$load("1u56X").then(()=>parcelRequire('aNceL'));

});

parcelRegister("bz7l1", function(module, exports) {

let $86b8a7cdcd9b8004$var$load = (parcelRequire("28QjX"))(4);
module.exports = $86b8a7cdcd9b8004$var$load("igDkQ").then(()=>parcelRequire('lTlB8'));

});

parcelRegister("j0dOH", function(module, exports) {

let $dd58bc24459c7eb4$var$load = (parcelRequire("28QjX"))(4);
module.exports = $dd58bc24459c7eb4$var$load("g5qwL").then(()=>parcelRequire('ghLdK'));

});

parcelRegister("8uVTY", function(module, exports) {

let $62fe0a2503db2594$var$load = (parcelRequire("28QjX"))(4);
module.exports = $62fe0a2503db2594$var$load("jjDfe").then(()=>parcelRequire('4f25c'));

});

parcelRegister("fzTXV", function(module, exports) {

let $b575898132ee2bea$var$load = (parcelRequire("28QjX"))(4);
module.exports = $b575898132ee2bea$var$load("jkutT").then(()=>parcelRequire('awmIb'));

});

parcelRegister("LM9aa", function(module, exports) {

let $08f9bcd9bc27dd32$var$load = (parcelRequire("28QjX"))(4);
module.exports = $08f9bcd9bc27dd32$var$load("buBEe").then(()=>parcelRequire('gvwZP'));

});

parcelRegister("3tjgd", function(module, exports) {

let $28730542bf3b348c$var$load = (parcelRequire("28QjX"))(4);
module.exports = $28730542bf3b348c$var$load("8lCtf").then(()=>parcelRequire('coNGC'));

});


parcelRegister("h6VU7", function(module, exports) {

let $c74fe9c0a7770bb1$var$load = (parcelRequire("28QjX"))(4);
module.exports = $c74fe9c0a7770bb1$var$load("kIJpj").then(()=>parcelRequire('2xla2'));

});



parcelRegister("3J3nd", function(module, exports) {

$parcel$export(module.exports, "EditPageDialog", () => $00be01316609b9f3$export$e10ae5ccd4f0f9de);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $eKGqG = parcelRequire("eKGqG");

var $koVbs = parcelRequire("koVbs");
const $00be01316609b9f3$export$e10ae5ccd4f0f9de = ({ contentId: contentId, spaceKey: spaceKey, parentProduct: parentProduct, navigationPolicy: navigationPolicy, accountId: accountId, themeState: themeState })=>{
    const { locale: locale } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eKGqG.EditPage), {
        locale: locale,
        "data-testid": "embedded-confluence-edit-page-dialog",
        contentId: contentId,
        spaceKey: spaceKey,
        parentProduct: parentProduct,
        navigationPolicy: navigationPolicy,
        userInfo: {
            userId: accountId,
            userIdType: 'atlassianAccount'
        },
        themeState: themeState,
        isFullScreenEmbedView: true
    });
};

});
parcelRegister("eKGqG", function(module, exports) {

$parcel$export(module.exports, "EditPage", () => $6f3170e5661e7ec7$export$1fea75498367c4ac);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $MHKc7 = parcelRequire("MHKc7");

var $kc9vJ = parcelRequire("kc9vJ");

var $kMusA = parcelRequire("kMusA");
var $iMKGq = parcelRequire("iMKGq");

var $aDZtw = parcelRequire("aDZtw");
const $6f3170e5661e7ec7$var$styles = {
    fallback: "_1bsb1osq _4t3i1osq"
};

const $6f3170e5661e7ec7$var$LazyEditPage = (0, $kc9vJ.lazyForPaint)(()=>(parcelRequire("jfjMR")));
const $6f3170e5661e7ec7$export$1fea75498367c4ac = (props)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $kMusA.I18nProvider), {
        locale: props.locale,
        fetchTranslations: (0, $aDZtw.default),
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $iMKGq.PerformanceMetricsProvider), {
            contentType: "editPage",
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $kc9vJ.LazySuspense), {
                fallback: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
                    xcss: $6f3170e5661e7ec7$var$styles.fallback
                }),
                children: /*#__PURE__*/ (0, $2OMIu.jsx)($6f3170e5661e7ec7$var$LazyEditPage, {
                    ...props
                })
            })
        })
    });

});
parcelRegister("jfjMR", function(module, exports) {

let $e02ec458c72477c6$var$load = (parcelRequire("28QjX"))(4);
module.exports = $e02ec458c72477c6$var$load("dzyfJ").then(()=>parcelRequire('7Rw7h'));

});



parcelRegister("eTdH7", function(module, exports) {

$parcel$export(module.exports, "default", () => $fbcb893eba6b8022$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $8RXs9 = parcelRequire("8RXs9");

var $1R1Ge = parcelRequire("1R1Ge");

var $eCeGD = parcelRequire("eCeGD");
var $42CjB = parcelRequire("42CjB");
var $1GGwS = parcelRequire("1GGwS");

var $ggICg = parcelRequire("ggICg");

var $i28qQ = parcelRequire("i28qQ");

var $3bDjY = parcelRequire("3bDjY");

var $2eVba = parcelRequire("2eVba");

var $3KONo = parcelRequire("3KONo");

var $2gQ83 = parcelRequire("2gQ83");

var $h8yj2 = parcelRequire("h8yj2");
const $fbcb893eba6b8022$var$EmbeddedPageModal = ({ mode: mode, headerBtnHref: headerBtnHref, onClose: onClose, children: children, isInnerModalOpen: isInnerModalOpen, intl: { formatMessage: formatMessage } })=>{
    const Header = ()=>{
        const origin = (0, $5uXOq.useMemo)(()=>new (0, $2gQ83.default)({
                product: 'jira'
            }), []);
        const handleOpenInConfluence = (0, $5uXOq.useCallback)((_, analyticsEvent)=>{
            const originAttributes = origin?.toAnalyticsAttributes({
                hasGeneratedId: true
            });
            (0, $h8yj2.fireUIAnalytics)(analyticsEvent, 'openEmbeddedViewPageInConfluenceButton', originAttributes);
        }, [
            origin
        ]);
        return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $3KONo.CustomModalHeader), {
            children: [
                headerBtnHref ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1GGwS.default), {
                    iconAfter: (0, (/*@__PURE__*/$parcel$interopDefault($ggICg))),
                    // technically href already has an origin generated by confluence-table-tree, but we clobber it
                    // since we are firing the click event with a new generated id
                    href: headerBtnHref,
                    target: "_blank",
                    onClick: handleOpenInConfluence,
                    testId: "confluence-project-pages.embedded-confluence-dialog.open-in-confluence-button",
                    children: formatMessage((0, $2eVba.default).titleButton)
                }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eCeGD.default), {
                    iconAfter: (0, (/*@__PURE__*/$parcel$interopDefault($ggICg))),
                    onClick: handleOpenInConfluence,
                    testId: "confluence-project-pages.embedded-confluence-dialog.open-in-confluence-button",
                    children: formatMessage((0, $2eVba.default).titleButton)
                }),
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3bDjY.default), {
                    content: formatMessage((0, $2eVba.default).closeHint),
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $42CjB.default), {
                        onClick: onClose,
                        appearance: "subtle",
                        icon: (0, (/*@__PURE__*/$parcel$interopDefault($i28qQ))),
                        label: formatMessage((0, $2eVba.default).closeHint),
                        testId: "confluence-project-pages.embedded-confluence-dialog.close-button"
                    })
                })
            ]
        });
    };
    const modalBodyWrapperTestId = mode === 'view' ? 'confluence-project-pages.embedded-confluence-dialog.modal-body-view-wrapper' : 'confluence-project-pages.embedded-confluence-dialog.modal-body-edit-wrapper';
    const ModalBodyWrapper = mode === 'view' ? (0, $3KONo.ModalBodyViewWrapper) : (0, $3KONo.ModalBodyEditWrapper);
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2OMIu.Fragment), {
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1R1Ge.default), {
                autoFocus: false,
                onClose: onClose,
                width: '100%',
                height: '100%',
                children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $3KONo.ModalContainer), {
                    children: [
                        mode === 'view' && /*#__PURE__*/ (0, $2OMIu.jsx)(Header, {}),
                        /*#__PURE__*/ (0, $2OMIu.jsxs)(ModalBodyWrapper, {
                            "data-testid": modalBodyWrapperTestId,
                            children: [
                                children,
                                isInnerModalOpen && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3KONo.ModalInnerBlanket), {
                                    "data-testid": "confluence-project-pages.embedded-confluence-dialog.modal-inner-blanket"
                                })
                            ]
                        })
                    ]
                })
            }),
            isInnerModalOpen && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3KONo.ModalOuterBlanket), {
                "data-testid": "confluence-project-pages.embedded-confluence-dialog.modal-outer-blanket"
            })
        ]
    });
};
var $fbcb893eba6b8022$export$2e2bcd8739ae039 = (0, $8RXs9.default)($fbcb893eba6b8022$var$EmbeddedPageModal);

});
parcelRegister("2eVba", function(module, exports) {

$parcel$export(module.exports, "default", () => $f86ca1de88b69556$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $f86ca1de88b69556$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    titleButton: {
        id: 'project-pages.embedded-pages.modal.title.button',
        defaultMessage: 'Open in Confluence',
        description: 'Button title for the embedded page modal that opens the current page in Confluence'
    },
    openInANewTabHint: {
        id: 'project-pages.embedded-pages.modal.title.button.hint',
        defaultMessage: 'Open in a new tab',
        description: 'Button icon hint for the embedded page modal that opens the current page in Confluence'
    },
    closeHint: {
        id: 'project-pages.embedded-pages.modal.close.button.hint',
        defaultMessage: 'Close',
        description: 'Button icon hint for the embedded page modal that closes the modal'
    }
});

});

parcelRegister("3KONo", function(module, exports) {

$parcel$export(module.exports, "CustomModalHeader", () => $6df2bc6cac5904d9$export$317cc87ecc16a2d3);
$parcel$export(module.exports, "ModalBodyViewWrapper", () => $6df2bc6cac5904d9$export$d8491371e5906f72);
$parcel$export(module.exports, "ModalBodyEditWrapper", () => $6df2bc6cac5904d9$export$16fb1c3667f7fb66);
$parcel$export(module.exports, "ModalContainer", () => $6df2bc6cac5904d9$export$c9554889b3e706cd);
$parcel$export(module.exports, "ModalOuterBlanket", () => $6df2bc6cac5904d9$export$283b6f7b7aeabb83);
$parcel$export(module.exports, "ModalInnerBlanket", () => $6df2bc6cac5904d9$export$5d882c4a695c0ed6);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $47bDC = parcelRequire("47bDC");


var $k5uoT = parcelRequire("k5uoT");
const $6df2bc6cac5904d9$export$317cc87ecc16a2d3 = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "b0hh3i-0"
})({
    display: 'flex',
    position: 'relative',
    padding: `${"var(--ds-space-150, 12px)"} ${"var(--ds-space-250, 20px)"}`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    marginBottom: `${(0, $k5uoT.gridSize)() * 1.25}px`,
    borderBottom: `1px solid ${`var(--ds-border, ${(0, $829f609a65d26a98$export$3e51e8f1440314ba)})`}`,
    justifyContent: 'space-between'
});
const $6df2bc6cac5904d9$export$d8491371e5906f72 = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "b0hh3i-1"
})({
    flexGrow: 1,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&&': {
        padding: `${"var(--ds-space-0, 0px)"} ${"var(--ds-space-250, 20px)"}`
    }
});
const $6df2bc6cac5904d9$export$16fb1c3667f7fb66 = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "b0hh3i-2"
})({
    flexGrow: 1,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&&': {
        padding: "var(--ds-space-0, 0px)",
        overflowY: 'hidden'
    }
});
const $6df2bc6cac5904d9$export$c9554889b3e706cd = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "b0hh3i-3"
})({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&&': {
        width: 'calc(100vw - 120px)',
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
        padding: '1px' // needed to display border-radius in edit mode
    },
    height: '100%',
    display: 'flex',
    flexDirection: 'column'
});
const $6df2bc6cac5904d9$export$283b6f7b7aeabb83 = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "b0hh3i-4"
})({
    height: '100vh',
    width: '100vw',
    position: 'fixed',
    top: "var(--ds-space-0, 0px)",
    left: "var(--ds-space-0, 0px)",
    zIndex: (0, $k5uoT.layers).modal(),
    backgroundColor: `var(--ds-blanket, ${(0, $829f609a65d26a98$export$486ab785e4bac3c6)})`
});
const $6df2bc6cac5904d9$export$5d882c4a695c0ed6 = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "b0hh3i-5"
})({
    height: '100%',
    width: '100%',
    position: 'absolute',
    top: "var(--ds-space-0, 0px)",
    left: "var(--ds-space-0, 0px)",
    zIndex: 0,
    backgroundColor: `var(--ds-blanket, ${(0, $829f609a65d26a98$export$486ab785e4bac3c6)})`
});

});


parcelRegister("1PpDv", function(module, exports) {

$parcel$export(module.exports, "LoadingContainer", () => $82b18143af72e745$export$5e3f251c730829);
// this component replicates the Confluence loading screen in the iframe as close to pixel-perfect
// as possible, so that we can transition between loading the iframe and rendering the iframe once
// it's ready as seamlessly as possible

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $47bDC = parcelRequire("47bDC");

var $7anl7 = parcelRequire("7anl7");

var $k5uoT = parcelRequire("k5uoT");
// eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $82b18143af72e745$var$Blanket = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "sc-714cn4-0"
})({
    zIndex: (0, $k5uoT.layers).blanket(),
    position: 'absolute',
    width: '100%',
    height: '100%',
    top: 0,
    left: 0,
    backgroundColor: "var(--ds-surface, white)",
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '> span': {
        height: '56px',
        margin: '181px 14px 13px 11px',
        animation: 'pulse 2s infinite',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '@keyframes pulse': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
            '0%': {
                opacity: 0.7
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
            '50%': {
                opacity: 1
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
            '100%': {
                opacity: 0.7
            }
        }
    }
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $82b18143af72e745$var$Container = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "sc-714cn4-1"
})({
    position: 'relative',
    height: '100%',
    zIndex: 1,
    // make sure this is on top of the inner modal blanket when it is shown
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    iframe: {
        backgroundColor: "var(--ds-surface, white)"
    } // ensure the iframe is not transparent so we won't see the modal blanket under it even if the content is short
});
const $82b18143af72e745$export$5e3f251c730829 = ({ isLoading: isLoading, children: children })=>/*#__PURE__*/ (0, $2OMIu.jsxs)($82b18143af72e745$var$Container, {
        "data-testid": "embedded-confluence-loading-container",
        children: [
            children,
            isLoading && /*#__PURE__*/ (0, $2OMIu.jsx)($82b18143af72e745$var$Blanket, {
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7anl7.ConfluenceIcon), {
                    appearance: "neutral"
                })
            })
        ]
    });

});

parcelRegister("21AEa", function(module, exports) {

$parcel$export(module.exports, "default", () => $e9c717975ae4e710$export$2e2bcd8739ae039);

var $7Z8iG = parcelRequire("7Z8iG");

var $e7LTy = parcelRequire("e7LTy");

var $6L3iv = parcelRequire("6L3iv");
const $e9c717975ae4e710$var$mapStateToProps = (state)=>({
        projectId: (0, $6L3iv.getProjectId)(state),
        projectType: (0, $6L3iv.getProjectType)(state)
    });
var $e9c717975ae4e710$export$2e2bcd8739ae039 = (0, $7Z8iG.connect)($e9c717975ae4e710$var$mapStateToProps)((0, $e7LTy.default));

});
parcelRegister("e7LTy", function(module, exports) {

$parcel$export(module.exports, "default", () => $6eee7f82311f131b$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $eCeGD = parcelRequire("eCeGD");

var $hTEpF = parcelRequire("hTEpF");

var $ousew = parcelRequire("ousew");
var $koVbs = parcelRequire("koVbs");

var $47bDC = parcelRequire("47bDC");

var $eNwjm = parcelRequire("eNwjm");

var $4cuc7 = parcelRequire("4cuc7");

var $dNpfo = parcelRequire("dNpfo");

var $fIHVu = parcelRequire("fIHVu");

var $h8yj2 = parcelRequire("h8yj2");
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $6eee7f82311f131b$var$Wrapper = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "sc-13iwcac-0"
})({
    display: 'flex',
    height: '100%',
    alignItems: 'center'
});
const $6eee7f82311f131b$var$CreatePageError = ({ spaceKey: spaceKey, onCloseModal: onCloseModal, projectId: projectId, projectType: projectType })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { pageCreate: pageCreate } = (0, $eNwjm.useEmbeddedPage)();
    const handleClose = (0, $5uXOq.useCallback)((_, analyticsEvent)=>{
        onCloseModal();
        (0, $h8yj2.fireUIAnalytics)(analyticsEvent, 'createEmbeddedPageErrorCloseButton', {
            embeddedPageAction: true
        });
    }, [
        onCloseModal
    ]);
    const createEmbeddedPage = (0, $dNpfo.useCreateEmbeddedPage)({
        spaceKey: spaceKey,
        projectId: projectId,
        projectType: projectType
    });
    const handleTryAgain = (0, $5uXOq.useCallback)(async (_, analyticsEvent)=>{
        if (pageCreate) await createEmbeddedPage(pageCreate.parentContentId, pageCreate.isRoot, pageCreate.blueprint);
        (0, $h8yj2.fireUIAnalytics)(analyticsEvent, 'createEmbeddedPageErrorTryAgainButton', {
            embeddedPageAction: true
        });
    }, [
        createEmbeddedPage,
        pageCreate
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)($6eee7f82311f131b$var$Wrapper, {
        "data-testid": "embedded-confluence-error-page",
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $hTEpF.default), {
            imageUrl: (0, (/*@__PURE__*/$parcel$interopDefault($4cuc7))),
            imageWidth: 71,
            header: formatMessage((0, $fIHVu.default).title),
            description: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                ...(0, $fIHVu.default).description
            }),
            primaryAction: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eCeGD.default), {
                appearance: "primary",
                onClick: handleTryAgain,
                children: formatMessage((0, $fIHVu.default).tryAgain)
            }),
            secondaryAction: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eCeGD.default), {
                onClick: handleClose,
                children: formatMessage((0, $fIHVu.default).close)
            })
        })
    });
};
var $6eee7f82311f131b$export$2e2bcd8739ae039 = $6eee7f82311f131b$var$CreatePageError;

});
parcelRegister("fIHVu", function(module, exports) {

$parcel$export(module.exports, "default", () => $32f397e8ddf2a462$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $32f397e8ddf2a462$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    title: {
        id: 'project-pages.embedded-pages.create-page-error.title',
        defaultMessage: "We couldn\u2019t create a page",
        description: 'Title of create page error modal'
    },
    description: {
        id: 'project-pages.embedded-pages.create-page-error.description',
        defaultMessage: "There was a problem and we couldn\u2019t create a page for you.",
        description: 'Description of create page error modal'
    },
    tryAgain: {
        id: 'project-pages.embedded-pages.create-page-error.try-again-button',
        defaultMessage: 'Try again',
        description: 'Try again button label for the create page error modal'
    },
    close: {
        id: 'project-pages.embedded-pages.create-page-error.close-button',
        defaultMessage: 'Close',
        description: 'Button label for closing the create page error modal'
    }
});

});




parcelRegister("7cesL", function(module, exports) {

$parcel$export(module.exports, "default", () => $ef907c623965cfab$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $daJ0i = parcelRequire("daJ0i");

var $VSDnB = parcelRequire("VSDnB");

var $8RXs9 = parcelRequire("8RXs9");

var $fTJXm = parcelRequire("fTJXm");


var $RzR6m = parcelRequire("RzR6m");

var $eq85L = parcelRequire("eq85L");

var $6k2gl = parcelRequire("6k2gl");

var $be4Gm = parcelRequire("be4Gm");

var $eNwjm = parcelRequire("eNwjm");

var $8sqcd = parcelRequire("8sqcd");

var $yKIn9 = parcelRequire("yKIn9");

var $escMm = parcelRequire("escMm");

var $5WLkL = parcelRequire("5WLkL");

var $3RFoz = parcelRequire("3RFoz");

var $knvke = parcelRequire("knvke");

var $jk2T6 = parcelRequire("jk2T6");

var $bfizW = parcelRequire("bfizW");

var $5FGgp = parcelRequire("5FGgp");

var $lWy1J = parcelRequire("lWy1J");

var $calNI = parcelRequire("calNI");

var $2mZpt = parcelRequire("2mZpt");

var $hnRK8 = parcelRequire("hnRK8");
const $ef907c623965cfab$var$View = (props)=>{
    const { CreateSpaceDialog: CreateSpaceDialog, ConnectSpaceDialog: ConnectSpaceDialog, MoreMenu: MoreMenu, PagesHeading: PagesHeading, Flags: Flags, breadcrumbs: breadcrumbs, EmbeddedConfluenceDialog: EmbeddedConfluenceDialog, triggerShowConnectSpaceDialog: triggerShowConnectSpaceDialog, triggerHideConnectSpaceDialog: triggerHideConnectSpaceDialog, confluenceLicenseStatus: confluenceLicenseStatus, confluenceState: confluenceState, hasActivatedConfluenceWithinSevenDays: hasActivatedConfluenceWithinSevenDays, hasConfluence: hasConfluence, renderFullHeader: renderFullHeader = true, projectSpaceKey: projectSpaceKey, hasAccessToConfluence: hasAccessToConfluence } = props;
    /*const { msrTemplatesExperimentCohort, isMSRTemplatesExperimentEnabled } = */ (0, $hnRK8.getIsMSRTemplatesExperimentEnabled)(hasActivatedConfluenceWithinSevenDays, hasAccessToConfluence);
    const isErrorState = (0, $5uXOq.useMemo)(()=>{
        return [
            (0, $0988c9725597fab5$export$65d0a606bcce00e6),
            (0, $0988c9725597fab5$export$52022723d6fe5666)
        ].includes(confluenceLicenseStatus);
    }, [
        confluenceLicenseStatus
    ]);
    const containerRef = (0, $5uXOq.useRef)(null);
    const dataTestId = hasAccessToConfluence ? 'post-expand' : 'pre-expand';
    const handleReload = (0, $5uXOq.useCallback)(()=>window.location.reload(), []);
    const isCrossSell = confluenceLicenseStatus === (0, $0988c9725597fab5$export$beb27109f0387267);
    const theme = (0, $escMm.useThemeContext)();
    const shouldShowMeatballMenu = !isErrorState && confluenceState === (0, $fTJXm.CONFLUENCE_ACTIVE);
    return /*#__PURE__*/ (0, $2OMIu.jsx)($5WLkL.ProjectPagesContentWrapper, {
        "data-testid": `confluence-project-pages.${dataTestId}`,
        theme: theme,
        innerRef: containerRef,
        children: /*#__PURE__*/ (0, $2OMIu.jsxs)($5WLkL.ViewContainer, {
            id: "project-pages-view-container",
            theme: theme,
            children: [
                /*#__PURE__*/ (0, $2OMIu.jsxs)($5WLkL.ViewSpacer, {
                    hasHeader: renderFullHeader,
                    isVisualRefreshEnabled: (0, $VSDnB.fg)('platform-component-visual-refresh'),
                    children: [
                        renderFullHeader ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $jk2T6.default), {
                            breadcrumbs: breadcrumbs,
                            isCrossSell: isCrossSell,
                            MoreMenu: MoreMenu,
                            shouldShowMeatballMenu: shouldShowMeatballMenu
                        }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2mZpt.CompactHeader), {
                            MoreMenu: MoreMenu,
                            shouldShowMeatballMenu: shouldShowMeatballMenu
                        }),
                        /*#__PURE__*/ (0, $2OMIu.jsxs)($5WLkL.MainContainer, {
                            id: "project-pages-main-container",
                            theme: theme,
                            children: [
                                /*#__PURE__*/ (0, $2OMIu.jsx)(PagesHeading, {
                                    isPreExpand: isCrossSell
                                }, "PagesHeading"),
                                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bfizW.ActivePage), {
                                    ...props
                                }),
                                /*#__PURE__*/ (0, $2OMIu.jsx)(ConnectSpaceDialog, {
                                    onCancel: triggerHideConnectSpaceDialog
                                }, "ConnectSpaceDialog"),
                                /*#__PURE__*/ (0, $2OMIu.jsx)(CreateSpaceDialog, {
                                    onCancel: triggerShowConnectSpaceDialog
                                }, "CreateSpaceDialog"),
                                /*#__PURE__*/ (0, $2OMIu.jsx)(EmbeddedConfluenceDialog, {
                                    spaceKey: projectSpaceKey
                                }),
                                confluenceState !== (0, $fTJXm.CONFLUENCE_LOADING) && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $RzR6m.default), {}),
                                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eq85L.default), {}),
                                /*#__PURE__*/ (0, $2OMIu.jsx)(Flags, {
                                    onReload: handleReload
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3RFoz.default), {
                            hasAccessToConfluence: hasAccessToConfluence
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $lWy1J.PageDecorators), {
                    hasConfluence: hasConfluence,
                    containerRef: containerRef
                })
            ]
        })
    });
};
const $ef907c623965cfab$var$withProviders = (Component)=>(props)=>{
        const { triggerErrorFlag: triggerErrorFlag, accountId: accountId, confluenceState: confluenceState, triggerInitializeView: triggerInitializeView, confluenceLicenseStatus: confluenceLicenseStatus, projectSpaceId: projectSpaceId } = props;
        const [activeTemplatePreview, setActiveTemplatePreview] = (0, $5uXOq.useState)((0, $knvke.getBasePreExpandTemplates)()[0]);
        const analyticsClient = (0, $5uXOq.useMemo)((0, $yKIn9.getAnalyticsWebClient), []);
        (0, $5uXOq.useEffect)(()=>{
            triggerInitializeView();
        }, [
            triggerInitializeView
        ]);
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $be4Gm.default), {
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eNwjm.EmbeddedPageProvider), {
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $8sqcd.ConfluencePageTreeProvider), {
                    onError: triggerErrorFlag,
                    // @ts-expect-error -  Type 'import("platform/packages/atlassian-analytics-pipeline/analytics-web-client/dist/types/analyticsWebClient").default' is not assignable to type 'import("platform/packages/confluence/confluence-table-tree/dist/types/types").AnalyticsWebClient'.
                    analyticsClient: analyticsClient,
                    accountId: accountId,
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $daJ0i.default), {
                        data: {
                            attributes: {
                                hasConfluence: confluenceState === (0, $fTJXm.CONFLUENCE_ACTIVE),
                                isCrossSell: confluenceLicenseStatus === (0, $0988c9725597fab5$export$beb27109f0387267)
                            }
                        },
                        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $6k2gl.TemplateProvider), {
                            value: {
                                template: activeTemplatePreview,
                                setActiveTemplatePreview: setActiveTemplatePreview,
                                projectSpaceId: projectSpaceId
                            },
                            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $calNI.default), {
                                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5FGgp.RouteProvider), {
                                    ...props,
                                    children: /*#__PURE__*/ (0, $2OMIu.jsx)(Component, {
                                        ...props
                                    })
                                })
                            })
                        })
                    })
                })
            })
        });
    };
var $ef907c623965cfab$export$2e2bcd8739ae039 = (0, $8RXs9.default)($ef907c623965cfab$var$withProviders($ef907c623965cfab$var$View));

});
parcelRegister("eq85L", function(module, exports) {

$parcel$export(module.exports, "default", () => $59e5a4f3c5bacc5f$export$2e2bcd8739ae039);

var $7Z8iG = parcelRequire("7Z8iG");

var $cEp5g = parcelRequire("cEp5g");

var $fahvP = parcelRequire("fahvP");
const $59e5a4f3c5bacc5f$var$mapStateToProps = (state)=>({
        connectionState: (0, $cEp5g.getConnectionState)(state)
    });
var $59e5a4f3c5bacc5f$export$2e2bcd8739ae039 = (0, $7Z8iG.connect)($59e5a4f3c5bacc5f$var$mapStateToProps)((0, $fahvP.default));

});
parcelRegister("fahvP", function(module, exports) {

$parcel$export(module.exports, "default", () => $edbe5d0ff448adfd$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $yKIn9 = parcelRequire("yKIn9");
const $edbe5d0ff448adfd$var$SpaceConnectionTracker = ({ connectionState: connectionState })=>{
    (0, $5uXOq.useEffect)(()=>{
        if (![
            'CONNECTED',
            'NOT_CONNECTED',
            'ERROR'
        ].includes(connectionState)) return;
        (0, $yKIn9.sendTrackAnalyticsEvent)({
            source: 'space.tracker',
            action: 'retrieved',
            actionSubject: 'fetchSpaceConnectionStatus',
            attributes: {
                status: connectionState
            }
        });
    }, [
        connectionState
    ]);
    return null;
};
var $edbe5d0ff448adfd$export$2e2bcd8739ae039 = $edbe5d0ff448adfd$var$SpaceConnectionTracker;

});


parcelRegister("be4Gm", function(module, exports) {

$parcel$export(module.exports, "default", () => $18268c5191713642$export$2e2bcd8739ae039);

var $7Z8iG = parcelRequire("7Z8iG");

var $kSBKe = parcelRequire("kSBKe");

var $cEp5g = parcelRequire("cEp5g");

var $hN0gf = parcelRequire("hN0gf");
const $18268c5191713642$var$mapStateToProps = (state)=>({
        accessRequestCapability: (0, $kSBKe.getAccessRequestCapability)(state),
        isSpaceConnected: (0, $cEp5g.isSpaceConnected)(state),
        confluenceEdition: (0, $cEp5g.getConfluenceEdition)(state),
        jswEdition: (0, $cEp5g.getJswEdition)(state)
    });
var $18268c5191713642$export$2e2bcd8739ae039 = (0, $7Z8iG.connect)($18268c5191713642$var$mapStateToProps)((0, $hN0gf.default));

});
parcelRegister("hN0gf", function(module, exports) {

$parcel$export(module.exports, "default", () => $93a61929e0f63a84$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $daJ0i = parcelRequire("daJ0i");


var $jXVTV = parcelRequire("jXVTV");

var $8c8di = parcelRequire("8c8di");
const $93a61929e0f63a84$var$CROSS_JOIN_SCENARIOS = [
    {
        type: (0, $8c8di.AccessRequestCapabilityType).DIRECT_ACCESS,
        analyticsName: 'join-product'
    },
    {
        type: (0, $8c8di.AccessRequestCapabilityType).REQUEST_ACCESS,
        analyticsName: 'request-access'
    },
    {
        type: (0, $8c8di.AccessRequestCapabilityType).PENDING_REQUEST_EXISTS,
        analyticsName: 'access-requested'
    },
    {
        type: (0, $8c8di.AccessRequestCapabilityType).DENIED_REQUEST_EXISTS,
        analyticsName: 'access-denied'
    },
    {
        type: (0, $8c8di.AccessRequestCapabilityType).APPROVED_REQUEST_EXISTS,
        analyticsName: 'access-revoked'
    },
    {
        type: (0, $8c8di.AccessRequestCapabilityType).ERROR,
        analyticsName: 'error'
    }
];
const $93a61929e0f63a84$var$View = ({ isSpaceConnected: isSpaceConnected, confluenceEdition: confluenceEdition, jswEdition: jswEdition, accessRequestCapability: accessRequestCapability, children: children })=>{
    const crossJoinScenario = $93a61929e0f63a84$var$CROSS_JOIN_SCENARIOS.find(({ type: type })=>type === accessRequestCapability)?.analyticsName;
    const isCrossJoinProjectExperimentEnabled = (0, $jXVTV.getTargetingGate)((0, $dbbde2ee9bc78c02$export$7d578ef8316f5d8b));
    const crossJoinNudgeExperimentCohort = isCrossJoinProjectExperimentEnabled ? (0, $jXVTV.getExperimentValue)((0, $dbbde2ee9bc78c02$export$616a7764e9436f13), 'not-enrolled', false) : 'not-enrolled';
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $daJ0i.default), {
        data: {
            attributes: {
                isSpaceConnected: isSpaceConnected,
                isCrossJoinProjectExperimentEnabled: isCrossJoinProjectExperimentEnabled,
                crossJoinNudgeExperimentCohort: crossJoinNudgeExperimentCohort,
                crossJoinScenario: crossJoinScenario,
                confluenceEdition: confluenceEdition,
                jswEdition: jswEdition
            }
        },
        children: children
    });
};
var $93a61929e0f63a84$export$2e2bcd8739ae039 = $93a61929e0f63a84$var$View;

});


parcelRegister("8sqcd", function(module, exports) {

$parcel$export(module.exports, "ConfluencePageTreeProvider", () => $9b19406f25444a9d$export$bc80c2f90a0a10c6);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $2NMNM = parcelRequire("2NMNM");

var $cUtjW = parcelRequire("cUtjW");

var $2bl9s = parcelRequire("2bl9s");

var $NoEQs = parcelRequire("NoEQs");

var $2CAPp = parcelRequire("2CAPp");

var $4F5Tr = parcelRequire("4F5Tr");

var $bL77t = parcelRequire("bL77t");

var $3WIK2 = parcelRequire("3WIK2");

var $l90rH = parcelRequire("l90rH");
const $9b19406f25444a9d$export$33eadec77c3a34cd = new (0, $bL77t.ConfluenceTableTreeData)();
const $9b19406f25444a9d$export$274a9a2a3c6432ca = ({ onError: onError, accountId: accountId, children: children })=>{
    const [items, setItems] = (0, $5uXOq.useState)(null);
    const [errorType, setErrorType] = (0, $5uXOq.useState)(null);
    const [spaceKey, setSpaceKey] = (0, $5uXOq.useState)(null);
    const [rootContentId, setRootContentId] = (0, $5uXOq.useState)(null);
    const [canShowMorePages, setCanShowMorePages] = (0, $5uXOq.useState)(false);
    const [currentLoadMoreCursor, setCurrentLoadMoreCursor] = (0, $5uXOq.useState)(0);
    const [projectId, setProjectId] = (0, $5uXOq.useState)(0);
    const [projectType, setProjectType] = (0, $5uXOq.useState)('');
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const [{ isDraftsShown: isDraftsShown, isTreeUpdatedForDrafts: isTreeUpdatedForDrafts }, { loadIsDraftsShownPreference: loadIsDraftsShownPreference, setIsTreeUpdatedForDrafts: setIsTreeUpdatedForDrafts }] = (0, $2CAPp.useDraftsToggle)();
    const setContent = (0, $5uXOq.useCallback)((spaceKey, rootContentId)=>{
        setSpaceKey(spaceKey);
        setRootContentId(rootContentId || null);
    }, []);
    const setProjectData = (0, $5uXOq.useCallback)((projectId, projectType)=>{
        setProjectId(projectId);
        setProjectType(projectType);
    }, []);
    // use this instead of setItems() that may affect root items to ensure Empty state is updated appropriately
    const updateTree = (0, $5uXOq.useCallback)((items, isRoot)=>{
        if (isRoot) setErrorType(items.length > 0 ? null : (0, $NoEQs.Errors).Empty);
        setItems(items);
    }, []);
    const fetchPublishedPagesAndUpdateSubtree = (0, $5uXOq.useCallback)(async (parentContentId, start)=>{
        const isRoot = parentContentId === rootContentId;
        const response = await (0, $l90rH.fetchPublishedPageTreeItems)(spaceKey, parentContentId, isRoot, start, $9b19406f25444a9d$export$33eadec77c3a34cd, projectId, projectType);
        let treeItems = response.pageTreeItems;
        if (isDraftsShown) // Inject drafts page tree into the current page tree
        treeItems = await (0, $l90rH.fetchDraftsPageTreeItems)(spaceKey, parentContentId, $9b19406f25444a9d$export$33eadec77c3a34cd, projectId, projectType);
        setCanShowMorePages(Boolean(response.next));
        updateTree(treeItems, isRoot);
        (0, $l90rH.firePageTreeOperationalEvents)({
            eventName: (0, $4F5Tr.EventName).SHOWN,
            analyticsAttributes: {
                pageCount: treeItems.length,
                isRoot: isRoot
            },
            createAnalyticsEvent: createAnalyticsEvent
        });
    }, [
        rootContentId,
        spaceKey,
        isDraftsShown,
        updateTree,
        createAnalyticsEvent,
        projectId,
        projectType
    ]);
    const updatePublishedPagesAndSubtree = (0, $5uXOq.useCallback)(async ({ parentContentId: parentContentId, start: start, maxPages: maxPages })=>{
        const isRoot = parentContentId === rootContentId;
        let treeItems = await (0, $l90rH.updatePublishedPageTreeItems)(spaceKey, parentContentId, isRoot, start, $9b19406f25444a9d$export$33eadec77c3a34cd, maxPages, projectId, projectType);
        if (isDraftsShown) // Inject drafts page tree into the current page tree
        treeItems = await (0, $l90rH.fetchDraftsPageTreeItems)(spaceKey, parentContentId, $9b19406f25444a9d$export$33eadec77c3a34cd, projectId, projectType);
        updateTree(treeItems, isRoot);
        (0, $l90rH.firePageTreeOperationalEvents)({
            eventName: (0, $4F5Tr.EventName).SHOWN,
            analyticsAttributes: {
                pageCount: treeItems.length,
                isRoot: isRoot
            },
            createAnalyticsEvent: createAnalyticsEvent
        });
    }, [
        rootContentId,
        isDraftsShown,
        spaceKey,
        updateTree,
        createAnalyticsEvent,
        projectId,
        projectType
    ]);
    const fetchRootTree = (0, $5uXOq.useCallback)(async ()=>{
        if (rootContentId === null && spaceKey === null) return;
        try {
            await fetchPublishedPagesAndUpdateSubtree(rootContentId, 0);
            setIsTreeUpdatedForDrafts(true);
        } catch (err) {
            const message = err instanceof Error ? err.message : String(err);
            const newErrorState = message.includes('404') ? (0, $NoEQs.Errors).Empty : (0, $NoEQs.Errors).Error;
            const error = err;
            (0, $l90rH.firePageTreeOperationalEvents)({
                eventName: (0, $4F5Tr.EventName).FAILED,
                analyticsAttributes: {
                    error: typeof error === 'string' ? 'Failed to fetch' : String(error.message),
                    isRoot: true
                },
                createAnalyticsEvent: createAnalyticsEvent
            });
            setErrorType(newErrorState);
        }
    }, [
        rootContentId,
        fetchPublishedPagesAndUpdateSubtree,
        setIsTreeUpdatedForDrafts,
        spaceKey,
        createAnalyticsEvent
    ]);
    const expandSubtree = (0, $5uXOq.useCallback)(async (parentContentId)=>{
        // expand the subtree from the start to reveal the spinner row first
        setItems($9b19406f25444a9d$export$33eadec77c3a34cd.setIsExpanded(parentContentId, true));
        try {
            await updatePublishedPagesAndSubtree({
                parentContentId: parentContentId,
                start: 0
            });
        } catch (error) {
            (0, $l90rH.firePageTreeOperationalEvents)({
                eventName: (0, $4F5Tr.EventName).FAILED,
                analyticsAttributes: {
                    error: typeof error === 'string' ? 'Failed to fetch' : String(error.message),
                    isRoot: false
                },
                createAnalyticsEvent: createAnalyticsEvent
            });
            setItems($9b19406f25444a9d$export$33eadec77c3a34cd.markChildError(parentContentId));
            onError?.(error);
        }
        // collapse & prune the subtree if in the end we found no children
        if ($9b19406f25444a9d$export$33eadec77c3a34cd.getPage(parentContentId)?.children === undefined) setItems($9b19406f25444a9d$export$33eadec77c3a34cd.pruneSubtree(parentContentId));
    }, [
        updatePublishedPagesAndSubtree,
        onError,
        createAnalyticsEvent
    ]);
    const collapseSubtree = (0, $5uXOq.useCallback)((parentContentId)=>{
        setItems($9b19406f25444a9d$export$33eadec77c3a34cd.setIsExpanded(parentContentId, false));
    }, []);
    const updatePage = (0, $5uXOq.useCallback)(async (contentId, status)=>{
        try {
            const page = await (0, $2bl9s.getPage)(contentId, status, projectId, projectType);
            if (page.status === 'current' || page.status === 'draft' && isDraftsShown) setItems($9b19406f25444a9d$export$33eadec77c3a34cd.injectPages([
                page
            ]));
            return (0, $bL77t.getPageTreeItemProperties)(page);
        } catch (error) {
            (0, $l90rH.firePageTreeOperationalEvents)({
                eventName: (0, $4F5Tr.EventName).FAILED,
                analyticsAttributes: {
                    error: typeof error === 'string' ? 'Failed to fetch' : String(error.message),
                    isRoot: false
                },
                createAnalyticsEvent: createAnalyticsEvent
            });
            onError?.(error);
        }
    }, [
        isDraftsShown,
        onError,
        createAnalyticsEvent,
        projectId,
        projectType
    ]);
    const insertPage = (0, $5uXOq.useCallback)(async (contentId, parentContentId)=>{
        try {
            const isRoot = parentContentId === undefined || parentContentId === rootContentId;
            // when inserting a page, we first try to fetch the latest tree
            await updatePublishedPagesAndSubtree({
                parentContentId: parentContentId || rootContentId,
                start: 0,
                // With "show more", we only want to fetch the pages til reaching the ones shown currently
                // We want to add this max cap only if "show more" FF enabled and the fetching is targeting on root level
                maxPages: isRoot ? currentLoadMoreCursor + (0, $2bl9s.PAGE_SIZE_LIMIT) : undefined
            });
            // this subtree may not yet contain the new page, so we fetch it directly as well
            const page = await (0, $2bl9s.getPage)(contentId, 'draft', projectId, projectType);
            // and inject it into the tree
            if (isDraftsShown) updateTree($9b19406f25444a9d$export$33eadec77c3a34cd.injectPages([
                page
            ]), isRoot);
            return (0, $bL77t.getPageTreeItemProperties)(page);
        } catch (error) {
            (0, $l90rH.firePageTreeOperationalEvents)({
                eventName: (0, $4F5Tr.EventName).FAILED,
                analyticsAttributes: {
                    error: typeof error === 'string' ? 'Failed to fetch' : String(error.message),
                    isRoot: parentContentId === undefined
                },
                createAnalyticsEvent: createAnalyticsEvent
            });
            onError?.(error);
        }
    }, [
        updatePublishedPagesAndSubtree,
        isDraftsShown,
        onError,
        rootContentId,
        updateTree,
        currentLoadMoreCursor,
        createAnalyticsEvent,
        projectId,
        projectType
    ]);
    const removePage = (0, $5uXOq.useCallback)(async (contentId)=>{
        const page = $9b19406f25444a9d$export$33eadec77c3a34cd.getPage(contentId);
        const isRoot = page?.parent === undefined;
        try {
            // try to update the tree, which may reflect the latest changes like child pages shifting up to parent
            await updatePublishedPagesAndSubtree({
                parentContentId: page?.parent?.id || rootContentId,
                start: 0,
                // With "show more", we only want to fetch the pages til reaching the ones shown currently
                // We want to add this max cap only if "show more" FF enabled and the fetching is targeting on root level
                maxPages: isRoot ? currentLoadMoreCursor + (0, $2bl9s.PAGE_SIZE_LIMIT) : undefined
            });
            // forcibly remove page from tree if for some reason it is still in the tree
            updateTree($9b19406f25444a9d$export$33eadec77c3a34cd.removePage(contentId), page?.parent === undefined);
            // collapse & prune the subtree if this was the last child page
            if (page?.parent && page?.parent.children === undefined) setItems($9b19406f25444a9d$export$33eadec77c3a34cd.pruneSubtree(page.parent.id));
        } catch (error) {
            (0, $l90rH.firePageTreeOperationalEvents)({
                eventName: (0, $4F5Tr.EventName).FAILED,
                analyticsAttributes: {
                    error: typeof error === 'string' ? 'Failed to fetch' : String(error.message),
                    isRoot: page?.parent === undefined
                },
                createAnalyticsEvent: createAnalyticsEvent
            });
            onError?.(error);
        }
    }, [
        updatePublishedPagesAndSubtree,
        onError,
        rootContentId,
        updateTree,
        currentLoadMoreCursor,
        createAnalyticsEvent
    ]);
    const fetchAndShowDraftsPage = (0, $5uXOq.useCallback)(()=>{
        (0, $l90rH.fetchDraftsPageTreeItems)(spaceKey, rootContentId, $9b19406f25444a9d$export$33eadec77c3a34cd, projectId, projectType).then((draftsPageTreeItems)=>{
            updateTree(draftsPageTreeItems, true);
            setIsTreeUpdatedForDrafts(true);
        });
    }, [
        spaceKey,
        rootContentId,
        updateTree,
        setIsTreeUpdatedForDrafts,
        projectId,
        projectType
    ]);
    // initialise the drafts toggle preference on mount
    (0, $5uXOq.useEffect)(()=>{
        loadIsDraftsShownPreference(accountId);
    }, [
        loadIsDraftsShownPreference,
        accountId
    ]);
    // initial load: load the page tree when we don't have a page tree
    (0, $5uXOq.useEffect)(()=>{
        if (isDraftsShown === null) // don't start fetching until draft setting is loaded
        return;
        if (items === null) fetchRootTree();
    }, [
        isDraftsShown,
        items,
        setIsTreeUpdatedForDrafts,
        fetchRootTree,
        projectId,
        projectType
    ]);
    // handle fetching/purging drafts in page tree when the toggle setting changes
    (0, $5uXOq.useEffect)(()=>{
        if (items === null) return;
        if (isTreeUpdatedForDrafts === false) {
            setIsTreeUpdatedForDrafts(null); // put it in a loading state so we don't retrigger it
            if (isDraftsShown) fetchAndShowDraftsPage();
            else {
                const updatedTree = $9b19406f25444a9d$export$33eadec77c3a34cd.purgeDrafts();
                if (updatedTree.length === 0) setErrorType((0, $NoEQs.Errors).Empty);
                updateTree(updatedTree, true);
                setIsTreeUpdatedForDrafts(true);
            }
        }
    }, [
        isDraftsShown,
        items,
        isTreeUpdatedForDrafts,
        setIsTreeUpdatedForDrafts,
        updateTree,
        fetchAndShowDraftsPage,
        fetchRootTree
    ]);
    // if spaceKey or contentId changes, reload
    (0, $5uXOq.useEffect)(()=>{
        setErrorType(null);
        setItems(null);
        $9b19406f25444a9d$export$33eadec77c3a34cd.init(rootContentId);
    }, [
        spaceKey,
        rootContentId
    ]);
    // tree state is an entirely derived var
    let treeState = (0, $NoEQs.TreeStates).Loading;
    if (errorType === (0, $NoEQs.Errors).Empty) treeState = (0, $NoEQs.TreeStates).Empty;
    else if (errorType === (0, $NoEQs.Errors).Error) treeState = (0, $NoEQs.TreeStates).Error;
    else if (items && items.length > 0) treeState = (0, $NoEQs.TreeStates).RenderedChildren;
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3WIK2.ConfluencePageTreeContext).Provider, {
        value: {
            treeState: treeState,
            spaceKey: spaceKey,
            errorType: errorType,
            rootContentId: rootContentId,
            accountId: accountId,
            items: items,
            setContent: setContent,
            expandSubtree: expandSubtree,
            collapseSubtree: collapseSubtree,
            insertPage: insertPage,
            updatePage: updatePage,
            removePage: removePage,
            canShowMorePages: canShowMorePages,
            showMorePages: async ()=>{
                await fetchPublishedPagesAndUpdateSubtree(rootContentId, currentLoadMoreCursor + (0, $2bl9s.PAGE_SIZE_LIMIT));
                setCurrentLoadMoreCursor((prev)=>prev + (0, $2bl9s.PAGE_SIZE_LIMIT));
            },
            setProjectData: setProjectData,
            projectId: projectId,
            projectType: projectType
        },
        children: children
    });
};
const $9b19406f25444a9d$export$bc80c2f90a0a10c6 = ({ analyticsClient: analyticsClient, ...props })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $cUtjW.AnalyticsProvider), {
        // @ts-expect-error - Type 'AnalyticsWebClient' is missing the following properties from type 'AnalyticsWebClient': _apdexEvent, _context, eventDelayQueue, _historyReplaceFn, and 61 more
        analyticsClient: analyticsClient,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)($9b19406f25444a9d$export$274a9a2a3c6432ca, {
            ...props
        })
    });

});
parcelRegister("cUtjW", function(module, exports) {

$parcel$export(module.exports, "AnalyticsProvider", () => $13bf713410edbad7$export$1b581a2ec13e37f1);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bvUB1 = parcelRequire("bvUB1");

var $kCVub = parcelRequire("kCVub");
const $13bf713410edbad7$export$1b581a2ec13e37f1 = ({ children: children, analyticsClient: analyticsClient })=>{
    const sendEvent = (0, $5uXOq.useCallback)((event)=>{
        const { type: type, payload: payload } = event;
        switch(type){
            case 0, $6e65040b988c460f$export$a1562d08625f5d7e:
                // @ts-expect-error - Argument of type 'Record<string, any>' is not assignable to parameter of type 'UITrackAndOperationalEventPayload'
                analyticsClient.sendUIEvent(payload);
                break;
            case 0, $6e65040b988c460f$export$947dac6c72b26f81:
                // @ts-expect-error - Argument of type 'Record<string, any>' is not assignable to parameter of type 'UITrackAndOperationalEventPayload'
                analyticsClient.sendTrackEvent(payload);
                break;
            case 0, $6e65040b988c460f$export$12346a674644c156:
                // @ts-expect-error - Argument of type 'Record<string, any>' is not assignable to parameter of type 'UITrackAndOperationalEventPayload'
                analyticsClient.sendOperationalEvent(payload);
                break;
            case 0, $6e65040b988c460f$export$f1d537d508d2945a:
                analyticsClient.sendScreenEvent(payload.name, null, payload.attributes);
                break;
            default:
                break;
        }
    }, [
        analyticsClient
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bvUB1.default), {
        channel: (0, $6e65040b988c460f$export$2ceccf177fae277c),
        onEvent: (event)=>sendEvent((0, $kCVub.extractAWCDataFromEvent)(event)),
        children: children
    });
};

});

parcelRegister("2bl9s", function(module, exports) {

$parcel$export(module.exports, "getPage", () => $8aec54f92d25f810$export$c2a6433281518c91);
$parcel$export(module.exports, "getDrafts", () => $8aec54f92d25f810$export$d705ef743e424c06);
$parcel$export(module.exports, "PAGE_SIZE_LIMIT", () => $8aec54f92d25f810$export$43637df0ace5ee44);
$parcel$export(module.exports, "getChildrenWithNextUrl", () => $8aec54f92d25f810$export$6a3613429c451655);
$parcel$export(module.exports, "getChildren", () => $8aec54f92d25f810$export$f8cf48ee793b41be);
const $8aec54f92d25f810$var$fetchOptions = (projectId, projectType)=>({
        headers: {
            'Content-Type': 'application/json',
            'x-atlassian-mau-ignore': 'true',
            'X-Atl-EmbeddablePage-EntityIDs': JSON.stringify({
                projectId: projectId,
                projectType: projectType
            })
        },
        credentials: 'same-origin'
    });
const $8aec54f92d25f810$export$8f665cf65eb666bb = [
    'childTypes.page',
    'history.contributors.publishers.users',
    'history.lastUpdated',
    'metadata.frontend.collabService'
];
const $8aec54f92d25f810$export$83c877457e95cd21 = [
    'childTypes.page',
    'metadata.frontend.collabService',
    'version',
    'version.collaborators.users',
    'extensions',
    'ancestors'
];
const $8aec54f92d25f810$var$SEARCH_API_URL = '/wiki/rest/api/content/search';
const $8aec54f92d25f810$var$ANCESTOR = 'ancestor';
const $8aec54f92d25f810$var$SPACE = 'space';
const $8aec54f92d25f810$var$draftSearchParams = (primaryType, primaryId, limit, start)=>new URLSearchParams({
        cql: `${primaryType}="${primaryId}" AND type in (page)`,
        cqlcontext: '{"contentStatuses":["draft"]}',
        limit: `${limit}`,
        start: `${start}`,
        expand: $8aec54f92d25f810$export$83c877457e95cd21.join(',')
    }).toString();
const $8aec54f92d25f810$var$constructChildPagesResponseFromSpaceContentResponse = ({ page: page, _links: _links })=>({
        ...page,
        _links: _links
    });
const $8aec54f92d25f810$var$injectLinksBase = (page, base)=>({
        ...page,
        _links: {
            ...page._links,
            base: base
        }
    });
const $8aec54f92d25f810$var$normaliseSearchResult = (page)=>{
    const { version: { friendlyWhen: friendlyWhen, number: number, collaborators: { users: users } } } = page;
    return {
        ...page,
        history: {
            contributors: {
                publishers: {
                    users: users
                }
            },
            lastUpdated: {
                friendlyWhen: friendlyWhen,
                number: number
            }
        }
    };
};
const $8aec54f92d25f810$var$injectLinksBaseToChildPagesResponse = ({ results: results, _links: { base: base } })=>results.map((page)=>$8aec54f92d25f810$var$injectLinksBase(page, base));
const $8aec54f92d25f810$var$statusSortValues = {
    current: 0,
    draft: 1
};
const $8aec54f92d25f810$var$typeSortValues = {
    number: 0,
    string: 1
};
const $8aec54f92d25f810$var$compareByIdStatusAndPosition = ({ id: idA, status: statusA, extensions: { position: positionA } }, { id: idB, status: statusB, extensions: { position: positionB } })=>{
    // If they have the same id, they are the same page
    if (idA === idB) return 0;
    const statusSort = $8aec54f92d25f810$var$statusSortValues[statusA] - $8aec54f92d25f810$var$statusSortValues[statusB];
    // We show drafts after published pages
    if (statusSort !== 0) return statusSort;
    const typeSort = $8aec54f92d25f810$var$typeSortValues[typeof positionA] - $8aec54f92d25f810$var$typeSortValues[typeof positionB];
    // We get the string "none" in the position field, which should be sorted under the numerical values
    if (typeSort !== 0) return typeSort;
    //
    if (typeof positionA === 'number' && typeof positionB === 'number') return positionA - positionB;
    // Try to parse the id's to numbers and compare them, other wise keep the original sort order
    return parseInt(idA) - parseInt(idB) || 1;
};
const $8aec54f92d25f810$var$getChildrenForTypeWithDrafts = async (primaryType, primaryId, limit, projectId, projectType)=>primaryId !== null && await $8aec54f92d25f810$var$recursivelyFetchPages(limit, (start, limit)=>$8aec54f92d25f810$var$searchChildPagesWithDrafts(primaryType, primaryId, start, limit, projectId, projectType), ({ results: results, _links: { base: base } })=>results.filter((page)=>page.status === 'draft').map((page)=>$8aec54f92d25f810$var$injectLinksBase($8aec54f92d25f810$var$normaliseSearchResult(page), base)).sort($8aec54f92d25f810$var$compareByIdStatusAndPosition), 0);
const $8aec54f92d25f810$var$recursiveFetch = ({ currentFetch: currentFetch, terminatingFn: terminatingFn, getNextFetch: getNextFetch, getResults: getResults, accumulator: accumulator = [], maxCap: maxCap })=>currentFetch.then((response)=>{
        const results = getResults(response);
        const mergedResult = [
            ...accumulator,
            ...results
        ];
        const hasReachedMaxCap = maxCap === undefined ? false : mergedResult.length >= maxCap;
        return terminatingFn(response) || hasReachedMaxCap ? Promise.resolve(mergedResult) : $8aec54f92d25f810$var$recursiveFetch({
            currentFetch: getNextFetch(response),
            terminatingFn: terminatingFn,
            getNextFetch: getNextFetch,
            getResults: getResults,
            accumulator: mergedResult,
            maxCap: maxCap
        });
    });
const $8aec54f92d25f810$var$handleFetchResponse = (response)=>{
    if (response.ok) return response.json();
    throw new Error(`API responded with failure HTTP code: ${response.status}`);
};
const $8aec54f92d25f810$var$fetchPages = async (url, projectId, projectType)=>{
    const response = await fetch(url, $8aec54f92d25f810$var$fetchOptions(projectId, projectType));
    return $8aec54f92d25f810$var$handleFetchResponse(response);
};
const $8aec54f92d25f810$export$c2a6433281518c91 = async (contentId, status, projectId, projectType)=>{
    const page = await $8aec54f92d25f810$var$fetchPages(`/wiki/rest/api/content/${contentId}?${new URLSearchParams({
        status: status,
        expand: $8aec54f92d25f810$export$83c877457e95cd21.join(',')
    }).toString()}`, projectId, projectType);
    return $8aec54f92d25f810$var$normaliseSearchResult(page);
};
const $8aec54f92d25f810$var$searchChildPagesWithDrafts = async (primaryType, primaryId, start, limit, projectId, projectType)=>{
    return $8aec54f92d25f810$var$fetchPages(`${$8aec54f92d25f810$var$SEARCH_API_URL}?${$8aec54f92d25f810$var$draftSearchParams(primaryType, primaryId, limit, start)}`, projectId, projectType);
};
const $8aec54f92d25f810$var$fetchChildPages = async (contentId, start, limit, projectId, projectType)=>{
    const path = `/wiki/rest/api/content/${contentId}/child/page`;
    const params = `limit=${limit}&start=${start}&expand=${$8aec54f92d25f810$export$8f665cf65eb666bb.join(',')}`;
    return $8aec54f92d25f810$var$fetchPages(`${path}?${params}`, projectId, projectType);
};
const $8aec54f92d25f810$var$fetchRootPages = async (spaceKey, start, limit, projectId, projectType)=>{
    const path = `/wiki/rest/api/space/${spaceKey}/content`;
    const params = `limit=${limit}&start=${start}&expand=${$8aec54f92d25f810$export$8f665cf65eb666bb.join(',')}&depth=root`;
    const pages = await $8aec54f92d25f810$var$fetchPages(`${path}?${params}`, projectId, projectType);
    return $8aec54f92d25f810$var$constructChildPagesResponseFromSpaceContentResponse(pages);
};
const $8aec54f92d25f810$var$recursivelyFetchPages = (limit, fetchFunction, resultTransformations, start, maxCap)=>$8aec54f92d25f810$var$recursiveFetch({
        currentFetch: fetchFunction(start, limit),
        terminatingFn: ({ size: size, limit: returnedLimit })=>{
            // although we specify a limit, the service may have a lower limit than our specified one and we should use that as source of truth
            // calls to /wiki/rest/api/space/:spaceKey/content and /wiki/rest/api/content/:contentId/child/page do support 200 results (our default limit)
            // but /wiki/rest/api/content/search only supports up to 100 results even if we specify a higher limit
            return size < returnedLimit;
        },
        getNextFetch: ({ start: start, limit: returnedLimit })=>fetchFunction(start + returnedLimit, returnedLimit),
        getResults: resultTransformations,
        maxCap: maxCap
    });
const $8aec54f92d25f810$var$getChildrenForSpace = async (spaceKey, limit, start, maxCap, projectId, projectType)=>spaceKey !== null && await $8aec54f92d25f810$var$recursivelyFetchPages(limit, (start, limit)=>$8aec54f92d25f810$var$fetchRootPages(spaceKey, start, limit, projectId, projectType), $8aec54f92d25f810$var$injectLinksBaseToChildPagesResponse, start, maxCap);
const $8aec54f92d25f810$var$getChildrenForPage = async (contentId, limit, start, maxCap, projectId, projectType)=>contentId !== null && await $8aec54f92d25f810$var$recursivelyFetchPages(limit, (start, limit)=>$8aec54f92d25f810$var$fetchChildPages(contentId, start, limit, projectId, projectType), $8aec54f92d25f810$var$injectLinksBaseToChildPagesResponse, start, maxCap);
const $8aec54f92d25f810$export$d705ef743e424c06 = async (spaceKey, contentId, projectId, projectType)=>{
    const limit = 200;
    // either fetch child pages of a given page, or fetch all root pages of the space
    const childPages = await $8aec54f92d25f810$var$getChildrenForTypeWithDrafts($8aec54f92d25f810$var$ANCESTOR, contentId, limit, projectId, projectType) || await $8aec54f92d25f810$var$getChildrenForTypeWithDrafts($8aec54f92d25f810$var$SPACE, spaceKey, limit, projectId, projectType) || [];
    if (childPages.length === 0) return [];
    return childPages;
};
const $8aec54f92d25f810$export$43637df0ace5ee44 = 200;
const $8aec54f92d25f810$export$6a3613429c451655 = async (spaceKey, contentId, start, projectId, projectType)=>{
    const response = await $8aec54f92d25f810$var$getChildrenForPageWithNextUrl(contentId, $8aec54f92d25f810$export$43637df0ace5ee44, start, projectId, projectType) || await $8aec54f92d25f810$var$getChildrenForSpaceWithNextUrl(spaceKey, $8aec54f92d25f810$export$43637df0ace5ee44, start, projectId, projectType);
    if (!response || response.pages?.length === 0) return {};
    return {
        pages: response.pages.filter((childPage)=>childPage.status === 'current'),
        next: response.next
    };
};
const $8aec54f92d25f810$var$getChildrenForSpaceWithNextUrl = async (spaceKey, limit, start, projectId, projectType)=>spaceKey !== null && $8aec54f92d25f810$var$transformResponseWithNextUrl(await $8aec54f92d25f810$var$fetchRootPages(spaceKey, start, limit, projectId, projectType));
const $8aec54f92d25f810$var$getChildrenForPageWithNextUrl = async (contentId, limit, start, projectId, projectType)=>contentId !== null && $8aec54f92d25f810$var$transformResponseWithNextUrl(await $8aec54f92d25f810$var$fetchChildPages(contentId, start, limit, projectId, projectType));
const $8aec54f92d25f810$var$transformResponseWithNextUrl = ({ results: results, _links: { base: base, next: next } })=>({
        pages: results.map((page)=>$8aec54f92d25f810$var$injectLinksBase(page, base)),
        next: next
    });
const $8aec54f92d25f810$export$f8cf48ee793b41be = async (spaceKey, contentId, limit, start, maxCap, projectId, projectType)=>{
    // either fetch child pages of a given page, or fetch all root pages of the space
    const childPages = await $8aec54f92d25f810$var$getChildrenForPage(contentId, limit, start, maxCap, projectId, projectType) || await $8aec54f92d25f810$var$getChildrenForSpace(spaceKey, limit, start, maxCap, projectId, projectType) || [];
    if (childPages.length === 0) return [];
    return childPages.filter((childPage)=>childPage.status === 'current');
};

});

parcelRegister("4F5Tr", function(module, exports) {

$parcel$export(module.exports, "EventName", () => $2039662d37575246$export$8e49444f78fbbdb8);
var $2039662d37575246$export$8e49444f78fbbdb8 = /*#__PURE__*/ function(EventName) {
    EventName["SHOWN"] = "shown";
    EventName["FAILED"] = "failed";
    return EventName;
}({});

});

parcelRegister("l90rH", function(module, exports) {

$parcel$export(module.exports, "firePageTreeOperationalEvents", () => $a48360f4acbe73df$export$65824eb1735a8662);
$parcel$export(module.exports, "updatePublishedPageTreeItems", () => $a48360f4acbe73df$export$811ad7ec06276acb);
$parcel$export(module.exports, "fetchPublishedPageTreeItems", () => $a48360f4acbe73df$export$4f93abb356bf34d2);
$parcel$export(module.exports, "fetchDraftsPageTreeItems", () => $a48360f4acbe73df$export$2c036ac8969eb3b0);

var $2bl9s = parcelRequire("2bl9s");

var $h8yj2 = parcelRequire("h8yj2");
const $a48360f4acbe73df$export$65824eb1735a8662 = ({ eventName: eventName, analyticsAttributes: analyticsAttributes, createAnalyticsEvent: createAnalyticsEvent })=>{
    if (createAnalyticsEvent) (0, $h8yj2.fireOperationalAnalytics)(createAnalyticsEvent({}), `confluencePageTree ${eventName}`, analyticsAttributes);
};
const $a48360f4acbe73df$export$811ad7ec06276acb = async (spaceKey, parentContentId, isRoot, start, tableTreeData, maxPages, projectId, projectType)=>{
    const publishedPages = await (0, $2bl9s.getChildren)(spaceKey, parentContentId, (0, $2bl9s.PAGE_SIZE_LIMIT), start, maxPages, projectId, projectType);
    const pageTreeItems = tableTreeData.updateChildPages(publishedPages, isRoot ? undefined : parentContentId || undefined);
    return pageTreeItems;
};
const $a48360f4acbe73df$export$4f93abb356bf34d2 = async (spaceKey, parentContentId, isRoot, start, tableTreeData, projectId, projectType)=>{
    const { pages: publishedPages, next: next } = await (0, $2bl9s.getChildrenWithNextUrl)(spaceKey, parentContentId, start, projectId, projectType);
    const pageTreeItems = tableTreeData.apppendChildPages(publishedPages ?? [], isRoot ? undefined : parentContentId || undefined);
    return {
        pageTreeItems: pageTreeItems,
        next: next
    };
};
const $a48360f4acbe73df$export$2c036ac8969eb3b0 = async (spaceKey, parentContentId, tableTreeData, projectId, projectType)=>{
    const drafts = await (0, $2bl9s.getDrafts)(spaceKey, parentContentId, projectId, projectType);
    return tableTreeData.injectPages(drafts);
};

});


parcelRegister("5WLkL", function(module, exports) {

$parcel$export(module.exports, "ProjectPagesContentWrapper", () => $682c34ad195253d6$export$942cb012bbd94748);
$parcel$export(module.exports, "ViewContainer", () => $682c34ad195253d6$export$19fb617b96998849);
$parcel$export(module.exports, "ViewSpacer", () => $682c34ad195253d6$export$9525d58b36c82c4e);
$parcel$export(module.exports, "MainContainer", () => $682c34ad195253d6$export$d653589df987fd93);
$parcel$export(module.exports, "PageTitleStyleWrapper", () => $682c34ad195253d6$export$bd8006fee20a6b76);
$parcel$export(module.exports, "PageHeaderStyleWrapper", () => $682c34ad195253d6$export$380dde9e77692cbd);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $47bDC = parcelRequire("47bDC");
const $682c34ad195253d6$export$942cb012bbd94748 = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "sc-1bpsg6h-0"
})`height:100%;${({ theme: theme })=>theme?.overrideStyles?.contentWrapper ? `padding: ${theme?.overrideStyles.contentWrapper.padding}` : `padding: 0`};`;
const $682c34ad195253d6$export$19fb617b96998849 = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "sc-1bpsg6h-1"
})`width:100%;${({ theme: theme })=>theme?.overrideStyles?.viewContainer ? `padding: ${theme?.overrideStyles.viewContainer.padding}` : `padding-bottom: ${"var(--ds-space-300, 24px)"}`};display:flex;flex-direction:row;height:100%;`;
const $682c34ad195253d6$export$9525d58b36c82c4e = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "sc-1bpsg6h-2"
})`flex:1 1 auto;overflow-x:auto;margin-right:${"var(--ds-space-500, 40px)"};position:relative;display:flex;flex-direction:column;${({ hasHeader: hasHeader })=>!hasHeader && `padding-top: ${"var(--ds-space-300, 24px)"};`} ${({ isVisualRefreshEnabled: isVisualRefreshEnabled })=>isVisualRefreshEnabled && `padding-top: ${"var(--ds-space-250, 20px)"};`}`;
const $682c34ad195253d6$export$d653589df987fd93 = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "sc-1bpsg6h-3"
})`${({ theme: theme })=>theme.overrideStyles?.mainContainer && `background-color: ${theme.overrideStyles.mainContainer.backgroundColor};
  color: ${theme.overrideStyles.mainContainer.color};
  border-radius: ${theme.overrideStyles.mainContainer.borderRadius};
  padding: ${theme.overrideStyles.mainContainer.padding};`}`;
const $682c34ad195253d6$export$bd8006fee20a6b76 = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "sc-1bpsg6h-4"
})`${({ theme: theme })=>theme.overrideStyles?.pageTitleStyleWrapper && `color: ${theme.overrideStyles.pageTitleStyleWrapper.color};
  margin-top: ${theme.overrideStyles.pageTitleStyleWrapper.marginTop}px;
  line-height: ${theme.overrideStyles.pageTitleStyleWrapper.lineHeight};
  outline: ${theme.overrideStyles.pageTitleStyleWrapper.outline};
  font-size: ${theme.overrideStyles.pageTitleStyleWrapper.fontSize};`}`;
const $682c34ad195253d6$export$380dde9e77692cbd = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "sc-1bpsg6h-5"
})`${({ theme: theme, isCompactHeader: isCompactHeader })=>theme.overrideStyles?.pageHeader?.wrapper && `background-color: ${theme.overrideStyles.pageHeader.wrapper.backgroundColor};
  padding: ${theme.overrideStyles.pageHeader.wrapper.padding};
  margin: ${isCompactHeader ? `0 0 ${"var(--ds-space-150, 12px)"} 0` : theme.overrideStyles.pageHeader.wrapper.margin};
  border-radius: ${theme.overrideStyles.pageHeader.wrapper.borderRadius};`}`;

});

parcelRegister("3RFoz", function(module, exports) {

$parcel$export(module.exports, "default", () => $8063d8a8b707603e$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $8RXs9 = parcelRequire("8RXs9");

var $8ByVM = parcelRequire("8ByVM");

var $jhmo0 = parcelRequire("jhmo0");
var $8CUq3 = parcelRequire("8CUq3");

var $3bDjY = parcelRequire("3bDjY");

var $2gQ83 = parcelRequire("2gQ83");

var $h8yj2 = parcelRequire("h8yj2");

var $6zbnq = parcelRequire("6zbnq");

var $escMm = parcelRequire("escMm");

var $d4rwM = parcelRequire("d4rwM");
const $8063d8a8b707603e$var$buttonStyles = (0, $8CUq3.xcss)({
    marginInlineStart: 'space.050',
    paddingInline: 'space.100',
    paddingBlock: 'space.050',
    height: 'size.200',
    display: 'inline-flex',
    alignItems: 'center',
    borderRadius: 'border.radius',
    backgroundColor: 'color.background.neutral.subtle',
    color: 'color.text',
    ':hover': {
        backgroundColor: 'color.background.neutral.subtle.hovered'
    },
    ':active': {
        backgroundColor: 'color.background.neutral.subtle.pressed'
    }
});
const $8063d8a8b707603e$var$PoweredByConfluenceFooter = ({ intl: intl, hasAccessToConfluence: hasAccessToConfluence })=>{
    const origin = (0, $5uXOq.useMemo)(()=>new (0, $2gQ83.default)({
            product: 'jira'
        }), []);
    const theme = (0, $escMm.useThemeContext)();
    const handlePoweredByClick = (0, $5uXOq.useCallback)((_, analyticsEvent)=>{
        const originAttributes = origin.toAnalyticsAttributes({
            hasGeneratedId: true
        });
        (0, $h8yj2.fireUIAnalytics)(analyticsEvent, 'poweredByConfluenceButton', originAttributes);
    }, [
        origin
    ]);
    return hasAccessToConfluence ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $6zbnq.StyledFooter), {
        children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $6zbnq.PoweredBy), {
            theme: theme,
            children: [
                intl.formatMessage((0, $d4rwM.default).poweredBy),
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3bDjY.default), {
                    content: intl.formatMessage((0, $d4rwM.default).poweredByTooltip),
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $jhmo0.default), {
                        onClick: handlePoweredByClick,
                        href: origin.addToUrl('/wiki'),
                        target: "_blank",
                        xcss: $8063d8a8b707603e$var$buttonStyles,
                        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $8ByVM.ConfluenceLogo), {
                            size: "xsmall",
                            appearance: "neutral"
                        })
                    })
                })
            ]
        })
    }) : null;
};
var $8063d8a8b707603e$export$2e2bcd8739ae039 = (0, $8RXs9.default)($8063d8a8b707603e$var$PoweredByConfluenceFooter);

});
parcelRegister("8ByVM", function(module, exports) {

$parcel$export(module.exports, "ConfluenceLogo", () => $768e0f951a70bda8$export$1b2e4fe6ef471556);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $hxoiH = parcelRequire("hxoiH");

var $lEsIP = parcelRequire("lEsIP");

var $6PPEt = parcelRequire("6PPEt");

var $iVs6J = parcelRequire("iVs6J");
const $768e0f951a70bda8$var$svg = ({ appearance: appearance, iconColor: iconColor, textColor: textColor }, colorMode)=>{
    let colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $6PPEt.getColorsFromAppearance)(appearance, colorMode);
    return `<svg fill="none" height="32" viewBox="0 0 180 32" focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">
      <path fill="${colors.iconColor}" d="M20.602 20.234c-6.584-3.183-8.507-3.66-11.281-3.66-3.255 0-6.03 1.355-8.507 5.16l-.407.622c-.333.513-.407.696-.407.915s.111.403.518.659l4.18 2.598c.221.146.406.22.591.22.222 0 .37-.11.592-.44l.666-1.024c1.035-1.574 1.96-2.086 3.144-2.086 1.035 0 2.256.293 3.772 1.025l4.365 2.049c.444.22.925.11 1.146-.403l2.072-4.537c.222-.512.074-.842-.444-1.098M1.406 12.22c6.583 3.184 8.507 3.66 11.28 3.66 3.256 0 6.03-1.354 8.508-5.16l.407-.622c.332-.512.406-.695.406-.915s-.11-.402-.518-.658L17.31 5.927c-.222-.147-.407-.22-.592-.22-.222 0-.37.11-.592.44l-.665 1.024c-1.036 1.573-1.96 2.086-3.144 2.086-1.036 0-2.257-.293-3.773-1.025L4.18 6.183c-.444-.22-.925-.11-1.147.402L.962 11.123c-.222.512-.074.841.444 1.098"/>
      <path fill="${colors.textColor}" d="M172.49 12.293c-2.791 0-4.201 1.809-4.477 4.477h8.556c-.154-2.852-1.442-4.477-4.079-4.477m5.888 12.634c-1.257.675-3.189.92-4.753.92-5.735 0-8.25-3.312-8.25-8.004 0-4.63 2.576-7.942 7.238-7.942 4.722 0 6.624 3.281 6.624 7.942v1.196h-11.194c.368 2.607 2.055 4.294 5.674 4.294 1.778 0 3.281-.338 4.661-.828zm-15.093-2.147v2.362c-.92.49-2.331.705-3.742.705-5.458 0-8.004-3.312-8.004-8.004 0-4.63 2.546-7.942 8.004-7.942 1.38 0 2.454.184 3.65.736v2.453c-.982-.46-2.024-.736-3.466-.736-3.986 0-5.612 2.515-5.612 5.49s1.656 5.489 5.674 5.489c1.564 0 2.545-.215 3.496-.552m-14.503-6.226v8.986h-2.637v-9.262c0-2.76-1.104-3.986-3.619-3.986-2.453 0-4.14 1.625-4.14 4.722v8.526h-2.637V10.207h2.637v2.515c.981-1.81 2.791-2.821 4.845-2.821 3.527 0 5.551 2.422 5.551 6.654m-22.921-4.262c-2.79 0-4.201 1.809-4.477 4.477h8.556c-.154-2.852-1.441-4.477-4.079-4.477m5.888 12.634c-1.257.675-3.189.92-4.753.92-5.735 0-8.249-3.312-8.249-8.004 0-4.63 2.576-7.942 7.237-7.942 4.723 0 6.624 3.281 6.624 7.942v1.196h-11.193c.368 2.607 2.054 4.294 5.673 4.294 1.778 0 3.281-.338 4.661-.828zm-29.1-5.734v-8.986h2.637v9.262c0 2.76 1.104 3.986 3.619 3.986 2.453 0 4.14-1.625 4.14-4.722v-8.526h2.637v15.334h-2.637v-2.515c-.981 1.81-2.791 2.821-4.845 2.821-3.527 0-5.551-2.422-5.551-6.654m-2.231 6.317c-.215.061-.674.122-1.35.122-2.514 0-4.108-1.196-4.108-4.017V3.798h2.637v17.51c0 1.38.92 1.871 2.055 1.871.275 0 .459 0 .766-.03zM88.157 8.582v1.625h3.956v2.454h-3.956v12.88h-2.576V12.66h-2.484v-2.454h2.484V8.521c0-2.852 1.595-4.784 4.876-4.784a6.3 6.3 0 0 1 1.779.245v2.423a8.7 8.7 0 0 0-1.656-.154c-1.626 0-2.423.95-2.423 2.33m-7.327 7.974v8.986h-2.637v-9.262c0-2.76-1.104-3.986-3.619-3.986-2.453 0-4.14 1.625-4.14 4.722v8.526h-2.637V10.207h2.637v2.515c.981-1.81 2.79-2.821 4.845-2.821 3.527 0 5.551 2.422 5.551 6.654m-23.336 9.292c-4.6 0-7.298-3.404-7.298-8.004s2.698-7.942 7.298-7.942c4.57 0 7.238 3.342 7.238 7.942s-2.668 8.004-7.238 8.004m0-13.493c-3.28 0-4.722 2.576-4.722 5.49s1.441 5.55 4.722 5.55c3.251 0 4.662-2.637 4.662-5.55s-1.41-5.49-4.662-5.49m-9.233 9.629v2.668c-1.257.828-3.25 1.196-5.336 1.196-6.624 0-10.365-3.986-10.365-10.334 0-6.134 3.741-10.427 10.304-10.427 1.963 0 3.925.368 5.367 1.41v2.669c-1.442-.92-3.036-1.411-5.367-1.411-4.723 0-7.544 3.128-7.544 7.759s2.913 7.697 7.697 7.697c2.116 0 3.772-.49 5.244-1.227"/>
    </svg>
    `;
};
const $768e0f951a70bda8$export$1b2e4fe6ef471556 = ({ appearance: appearance, label: label = 'Confluence', size: size = (0, $lEsIP.defaultLogoParams).size, testId: testId, iconColor: iconColor = (0, $lEsIP.defaultLogoParams).iconColor, textColor: textColor = (0, $lEsIP.defaultLogoParams).textColor })=>{
    const { colorMode: colorMode } = (0, $hxoiH.default)();
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $iVs6J.default), {
        appearance: appearance,
        label: label,
        iconColor: iconColor,
        size: size,
        svg: $768e0f951a70bda8$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("6zbnq", function(module, exports) {

$parcel$export(module.exports, "StyledFooter", () => $a6419874f237e98f$export$61905ae62c7860fb);
$parcel$export(module.exports, "PoweredBy", () => $a6419874f237e98f$export$3dbb5766eaeb5b24);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $47bDC = parcelRequire("47bDC");

const $a6419874f237e98f$export$61905ae62c7860fb = /*#__PURE__*/ (0, $47bDC.default).footer.withConfig({
    componentId: "rgz360-0"
})({
    textAlign: 'center',
    marginTop: 'auto',
    padding: `${"var(--ds-space-200, 16px)"} 0`
});
const $a6419874f237e98f$export$3dbb5766eaeb5b24 = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "rgz360-1"
})({
    font: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    display: 'inline-flex',
    alignItems: 'center'
}, // eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
({ theme: theme })=>`color: ${theme.overrideStyles?.poweredBy?.color || `var(--ds-text-subtlest, ${0, $829f609a65d26a98$export$e2ef2124cf4024b1})`} ;`);

});

parcelRegister("d4rwM", function(module, exports) {

$parcel$export(module.exports, "default", () => $c626b285590150d8$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $c626b285590150d8$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    poweredBy: {
        id: 'project-pages.improvement.powered-by',
        defaultMessage: 'Powered by',
        description: 'Prefix to the footer indicating the Project pages feature is powered by Confluence'
    },
    poweredByTooltip: {
        id: 'project-pages.improvement.powered-by.tooltip',
        defaultMessage: 'Open Confluence in a new tab',
        description: 'Tooltip on the Confluence logo in the powered by footer to indicate that clicking will open Confluence in a new tab'
    }
});

});


parcelRegister("knvke", function(module, exports) {

$parcel$export(module.exports, "defaultTemplates", () => $f10630ec3b9c2dd8$export$952bbd6b1defadc7);
$parcel$export(module.exports, "moreTemplatesBase", () => $f10630ec3b9c2dd8$export$511a74d9b2114743);
$parcel$export(module.exports, "getBasePreExpandTemplates", () => $f10630ec3b9c2dd8$export$4286cc6e4b577f02);
$parcel$export(module.exports, "getTutorialTemplate", () => $f10630ec3b9c2dd8$export$2fcaa2667dafd1ee);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bEjt9 = parcelRequire("bEjt9");

var $8HSNL = parcelRequire("8HSNL");

var $7ftyG = parcelRequire("7ftyG");

var $e78BF = parcelRequire("e78BF");

var $kdfZa = parcelRequire("kdfZa");

var $fptva = parcelRequire("fptva");


var $8mG85 = parcelRequire("8mG85");

var $6kC3z = parcelRequire("6kC3z");

var $88W24 = parcelRequire("88W24");

var $l0cmm = parcelRequire("l0cmm");

var $jFY9b = parcelRequire("jFY9b");

var $hnRK8 = parcelRequire("hnRK8");

var $2b05O = parcelRequire("2b05O");

var $6MkMA = parcelRequire("6MkMA");

var $cEiMj = parcelRequire("cEiMj");

var $idvCB = parcelRequire("idvCB");

var $akzp7 = parcelRequire("akzp7");

var $7XXRg = parcelRequire("7XXRg");

var $cAh4w = parcelRequire("cAh4w");

var $lHc7f = parcelRequire("lHc7f");

var $gXz2V = parcelRequire("gXz2V");

var $6kk3Z = parcelRequire("6kk3Z");

var $bA9IZ = parcelRequire("bA9IZ");

var $eX0bx = parcelRequire("eX0bx");

var $xuzKo = parcelRequire("xuzKo");

var $53eOI = parcelRequire("53eOI");

var $7xfif = parcelRequire("7xfif");

var $fvWwp = parcelRequire("fvWwp");

var $jG84J = parcelRequire("jG84J");

var $h8b02 = parcelRequire("h8b02");

var $jcZl9 = parcelRequire("jcZl9");

var $kqzWv = parcelRequire("kqzWv");

var $3CEZI = parcelRequire("3CEZI");

var $6H9hn = parcelRequire("6H9hn");

var $8RlEz = parcelRequire("8RlEz");

var $gFTpC = parcelRequire("gFTpC");

var $3t6Q7 = parcelRequire("3t6Q7");

var $aThnY = parcelRequire("aThnY");

var $hpkGg = parcelRequire("hpkGg");

var $9SJGb = parcelRequire("9SJGb");

var $5ibRN = parcelRequire("5ibRN");
const $f10630ec3b9c2dd8$var$blank = {
    type: (0, $l0cmm.TemplateType).Confluence,
    key: 'blankPage',
    name: (0, $6kC3z.default).blankPageTemplateName,
    description: (0, $6kC3z.default).blankPageTemplateDescription,
    blueprintModuleCompleteKey: null,
    itemModuleCompleteKey: (0, $jFY9b.ItemModuleCompleteKeys).BLANK_PAGE,
    iconRender: ({ size: size, color: color })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $88W24.TemplateIcon), {
            size: size,
            backgroundColor: color,
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($kdfZa))), {
                label: "",
                color: "var(--ds-icon-inverse, #fff)"
            })
        }),
    defaultIconColor: `var(--ds-background-accent-blue-bolder, ${(0, $829f609a65d26a98$export$e62e8919cca44969)})`,
    preview: {
        preExpand: {
            default: (0, (/*@__PURE__*/$parcel$interopDefault($6MkMA))),
            dark: (0, (/*@__PURE__*/$parcel$interopDefault($jG84J)))
        },
        postExpand: {
            default: (0, (/*@__PURE__*/$parcel$interopDefault($cEiMj))),
            dark: (0, (/*@__PURE__*/$parcel$interopDefault($fvWwp)))
        }
    }
};
const $f10630ec3b9c2dd8$var$productRequirements = {
    type: (0, $l0cmm.TemplateType).Confluence,
    key: 'productRequirements',
    name: (0, $6kC3z.default).productRequirementsTemplateName,
    description: (0, $6kC3z.default).productRequirementsTemplateDescription,
    blueprintModuleCompleteKey: (0, $jFY9b.BlueprintModuleCompleteKeys).PRODUCT_REQUIREMENTS,
    itemModuleCompleteKey: (0, $jFY9b.ItemModuleCompleteKeys).PRODUCT_REQUIREMENTS,
    iconRender: ({ size: size, color: color })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $88W24.TemplateIcon), {
            size: size,
            backgroundColor: color,
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bEjt9))), {
                label: "",
                color: "var(--ds-icon-inverse, #fff)"
            })
        }),
    defaultIconColor: `var(--ds-background-accent-purple-bolder, ${(0, $829f609a65d26a98$export$b48405b95304b5a1)})`,
    preview: {
        preExpand: {
            default: (0, (/*@__PURE__*/$parcel$interopDefault($gXz2V))),
            dark: (0, (/*@__PURE__*/$parcel$interopDefault($8RlEz)))
        },
        postExpand: {
            dark: (0, (/*@__PURE__*/$parcel$interopDefault($6H9hn))),
            default: (0, (/*@__PURE__*/$parcel$interopDefault($akzp7)))
        }
    },
    getTitle: ()=>`${(0, $hnRK8.getDateString)()} Product requirements`
};
const $f10630ec3b9c2dd8$var$decision = {
    type: (0, $l0cmm.TemplateType).Confluence,
    key: 'decision',
    name: (0, $6kC3z.default).decisionTemplateName,
    description: (0, $6kC3z.default).decisionTemplateDescription,
    blueprintModuleCompleteKey: (0, $jFY9b.BlueprintModuleCompleteKeys).DECISION,
    itemModuleCompleteKey: (0, $jFY9b.ItemModuleCompleteKeys).DECISION,
    iconRender: ({ size: size, color: color })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $88W24.TemplateIcon), {
            size: size,
            backgroundColor: color,
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8HSNL))), {
                label: "",
                color: "var(--ds-icon-inverse, #fff)"
            })
        }),
    defaultIconColor: `var(--ds-background-accent-green-bolder, ${(0, $829f609a65d26a98$export$940e1f69e873f202)})`,
    preview: {
        preExpand: {
            default: (0, (/*@__PURE__*/$parcel$interopDefault($7XXRg))),
            dark: (0, (/*@__PURE__*/$parcel$interopDefault($jcZl9)))
        },
        postExpand: {
            dark: (0, (/*@__PURE__*/$parcel$interopDefault($h8b02))),
            default: (0, (/*@__PURE__*/$parcel$interopDefault($idvCB)))
        }
    },
    getTitle: ()=>`${(0, $hnRK8.getDateString)()} Decision`
};
const $f10630ec3b9c2dd8$var$meetingNotes = {
    type: (0, $l0cmm.TemplateType).Confluence,
    key: 'meetingNotes',
    name: (0, $6kC3z.default).meetingNotesTemplateName,
    description: (0, $6kC3z.default).meetingNotesTemplateDescription,
    blueprintModuleCompleteKey: (0, $jFY9b.BlueprintModuleCompleteKeys).MEETING_NOTES,
    itemModuleCompleteKey: (0, $jFY9b.ItemModuleCompleteKeys).MEETING_NOTES,
    iconRender: ({ size: size, color: color })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $88W24.TemplateIcon), {
            size: size,
            backgroundColor: color,
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($fptva))), {
                label: "",
                color: "var(--ds-icon-inverse, #fff)"
            })
        }),
    defaultIconColor: `var(--ds-background-accent-teal-bolder, ${(0, $829f609a65d26a98$export$9dc1ef0f3f48059b)})`,
    preview: {
        preExpand: {
            default: (0, (/*@__PURE__*/$parcel$interopDefault($cAh4w))),
            dark: (0, (/*@__PURE__*/$parcel$interopDefault($3CEZI)))
        },
        postExpand: {
            dark: (0, (/*@__PURE__*/$parcel$interopDefault($kqzWv))),
            default: (0, (/*@__PURE__*/$parcel$interopDefault($lHc7f)))
        }
    }
};
const $f10630ec3b9c2dd8$var$retro = {
    type: (0, $l0cmm.TemplateType).Confluence,
    key: 'retrospective',
    name: (0, $6kC3z.default).retrospectiveTemplateName,
    description: (0, $6kC3z.default).retrospectiveTemplateDescription,
    blueprintModuleCompleteKey: (0, $jFY9b.BlueprintModuleCompleteKeys).RESTROSPECTIVE,
    itemModuleCompleteKey: (0, $jFY9b.ItemModuleCompleteKeys).RESTROSPECTIVE,
    iconRender: ({ size: size, color: color })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $88W24.TemplateIcon), {
            size: size,
            backgroundColor: color,
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8mG85))), {
                label: "",
                color: "var(--ds-icon-inverse, #fff)"
            })
        }),
    defaultIconColor: `var(--ds-background-accent-yellow-bolder, ${(0, $829f609a65d26a98$export$c6930421db9fa514)})`,
    preview: {
        preExpand: {
            default: (0, (/*@__PURE__*/$parcel$interopDefault($6kk3Z))),
            dark: (0, (/*@__PURE__*/$parcel$interopDefault($3t6Q7)))
        },
        postExpand: {
            dark: (0, (/*@__PURE__*/$parcel$interopDefault($gFTpC))),
            default: (0, (/*@__PURE__*/$parcel$interopDefault($bA9IZ)))
        }
    },
    getTitle: ()=>`${(0, $hnRK8.getDateString)()} Retrospective`
};
const $f10630ec3b9c2dd8$export$952bbd6b1defadc7 = [
    $f10630ec3b9c2dd8$var$blank,
    $f10630ec3b9c2dd8$var$productRequirements,
    $f10630ec3b9c2dd8$var$decision,
    $f10630ec3b9c2dd8$var$meetingNotes,
    $f10630ec3b9c2dd8$var$retro
];
const $f10630ec3b9c2dd8$export$511a74d9b2114743 = {
    key: 'more',
    iconRender: ({ size: size, color: color })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $88W24.TemplateIcon), {
            size: size,
            backgroundColor: color,
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($7ftyG))), {
                label: "more",
                color: "var(--ds-icon, #000)"
            })
        }),
    defaultIconColor: `var(--ds-background-neutral, ${(0, $829f609a65d26a98$export$9fdfb749e33cdf97)})`
};
const $f10630ec3b9c2dd8$export$4286cc6e4b577f02 = ()=>[
        ...$f10630ec3b9c2dd8$export$952bbd6b1defadc7,
        {
            ...$f10630ec3b9c2dd8$export$511a74d9b2114743,
            type: (0, $l0cmm.TemplateType).Link,
            name: (0, $6kC3z.default).templatesPreExpandMore,
            url: 'https://www.atlassian.com/software/confluence/templates',
            renderShortcutIcon: false
        }
    ];
const $f10630ec3b9c2dd8$export$2fcaa2667dafd1ee = (intl, isProjectPagesSporkRebrandingEnabled = false)=>{
    const tutorialContent = (0, $2b05O.getTutorialContent)(intl, isProjectPagesSporkRebrandingEnabled);
    return {
        type: (0, $l0cmm.TemplateType).Confluence,
        key: 'tutorial',
        name: (0, $6kC3z.default).tutorialPageName,
        title: (0, $6kC3z.default).tutorialPageName,
        description: (0, $6kC3z.default).tutorialPageDescription,
        blueprintModuleCompleteKey: null,
        itemModuleCompleteKey: null,
        iconRender: ({ size: size, color: color })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $88W24.TemplateIcon), {
                size: size,
                backgroundColor: color,
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($e78BF))), {
                    label: "blank",
                    color: "var(--ds-icon-inverse, #fff)"
                })
            }),
        defaultIconColor: `var(--ds-background-accent-purple-bolder, ${0, $829f609a65d26a98$export$b48405b95304b5a1})`,
        preview: {
            preExpand: {
                default: isProjectPagesSporkRebrandingEnabled ? (0, (/*@__PURE__*/$parcel$interopDefault($53eOI))) : (0, (/*@__PURE__*/$parcel$interopDefault($eX0bx))),
                dark: isProjectPagesSporkRebrandingEnabled ? (0, (/*@__PURE__*/$parcel$interopDefault($9SJGb))) : (0, (/*@__PURE__*/$parcel$interopDefault($hpkGg)))
            },
            postExpand: {
                default: isProjectPagesSporkRebrandingEnabled ? (0, (/*@__PURE__*/$parcel$interopDefault($7xfif))) : (0, (/*@__PURE__*/$parcel$interopDefault($xuzKo))),
                dark: isProjectPagesSporkRebrandingEnabled ? (0, (/*@__PURE__*/$parcel$interopDefault($5ibRN))) : (0, (/*@__PURE__*/$parcel$interopDefault($aThnY)))
            }
        },
        content: tutorialContent
    };
};

});
parcelRegister("8HSNL", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::be0b9c9537e0b69b1d3c8d2587861fe5>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $656cd9546d343d79$var$_react = $656cd9546d343d79$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $656cd9546d343d79$var$_baseNew = $656cd9546d343d79$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $656cd9546d343d79$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Decision".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for decisions.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $656cd9546d343d79$var$DecisionIcon = (props)=>/*#__PURE__*/ $656cd9546d343d79$var$_react.default.createElement($656cd9546d343d79$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="m13.97.97-4.5 4.5 1.06 1.06 4.5-4.5zM3.56 2.5H8V1H1.75a.75.75 0 0 0-.75.75V8h1.5V3.56l4.604 4.604a.5.5 0 0 1 .146.354V15h1.5V8.518a2 2 0 0 0-.586-1.414z" clip-rule="evenodd"/>`
    }, props));
$656cd9546d343d79$var$DecisionIcon.displayName = 'DecisionIcon';
var $656cd9546d343d79$var$_default = module.exports.default = $656cd9546d343d79$var$DecisionIcon;

});

parcelRegister("7ftyG", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::149b2cd6a95881a63bc7d331a2f52240>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5470dcd3a4786f26$var$_react = $5470dcd3a4786f26$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $5470dcd3a4786f26$var$_baseNew = $5470dcd3a4786f26$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $5470dcd3a4786f26$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Compass".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: templates.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $5470dcd3a4786f26$var$CompassIcon = (props)=>/*#__PURE__*/ $5470dcd3a4786f26$var$_react.default.createElement($5470dcd3a4786f26$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1.5a6.5 6.5 0 1 0 0 13 6.5 6.5 0 0 0 0-13M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8m11.78-3.78a.75.75 0 0 1 .155.834l-2 4.5a.75.75 0 0 1-.38.381l-4.5 2a.75.75 0 0 1-.99-.99l2-4.5a.75.75 0 0 1 .38-.38l4.5-2a.75.75 0 0 1 .835.154M6.992 8.051l.955.956-1.72.764zm2.016-.105-.956-.955 1.72-.765z" clip-rule="evenodd"/>`
    }, props));
$5470dcd3a4786f26$var$CompassIcon.displayName = 'CompassIcon';
var $5470dcd3a4786f26$var$_default = module.exports.default = $5470dcd3a4786f26$var$CompassIcon;

});

parcelRegister("88W24", function(module, exports) {

$parcel$export(module.exports, "TemplateIcon", () => $ad608866a5ef8495$export$17f8b5fdc0dde895);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $47bDC = parcelRequire("47bDC");


var $hnRK8 = parcelRequire("hnRK8");
const $ad608866a5ef8495$export$17f8b5fdc0dde895 = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "sc-1adz7o9-0"
})((props)=>({
        boxSizing: 'border-box',
        alignSelf: 'flex-start',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        minHeight: `${(0, $hnRK8.getIconSize)(props.size)}px`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        minWidth: `${(0, $hnRK8.getIconSize)(props.size)}px`,
        borderRadius: '4px',
        textAlign: 'center',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        backgroundColor: props.backgroundColor ? props.backgroundColor : `var(--ds-background-neutral-bold, ${0, $829f609a65d26a98$export$9fdfb749e33cdf97})`,
        border: `1px solid ${"var(--ds-border, rgba(0, 0, 0, 0.1))"}`
    }));

});
parcelRegister("hnRK8", function(module, exports) {

$parcel$export(module.exports, "getIconSize", () => $465ad9361756eb18$export$3eb7d6130acfda37);
$parcel$export(module.exports, "getDateString", () => $465ad9361756eb18$export$60248f42f43df209);
$parcel$export(module.exports, "getPostExpandTemplates", () => $465ad9361756eb18$export$726f90dcc8a488d7);
$parcel$export(module.exports, "getPreExpandTemplates", () => $465ad9361756eb18$export$112c8b3cc38ec332);
$parcel$export(module.exports, "getIsMSRTemplatesExperimentEnabled", () => $465ad9361756eb18$export$ea54dfd6f537fe17);

var $k5uoT = parcelRequire("k5uoT");


var $l0cmm = parcelRequire("l0cmm");

var $knvke = parcelRequire("knvke");

var $7shOz = parcelRequire("7shOz");

var $6kC3z = parcelRequire("6kC3z");

var $jXVTV = parcelRequire("jXVTV");
const $465ad9361756eb18$export$3eb7d6130acfda37 = (size)=>(0, $k5uoT.gridSize)() * (size === 'small' ? 3 : 4);
const $465ad9361756eb18$export$dca25b2cf2908df8 = (size)=>size === 'small' ? 14 : 18;
const $465ad9361756eb18$export$60248f42f43df209 = ()=>{
    const dt = new Date();
    const month = (dt.getMonth() + 1).toString().padStart(2, '0');
    const day = dt.getDate().toString().padStart(2, '0');
    return `${dt.getFullYear()}-${month}-${day}`;
};
const $465ad9361756eb18$export$726f90dcc8a488d7 = (spaceKey, areTemplatesEnabled, confluenceLicenseStatus, blueprints, intl, isConfluenceAutoProvisioned, isProjectPagesSporkRebrandingEnabled)=>{
    const moreTemplates = {
        ...(0, $knvke.moreTemplatesBase),
        type: (0, $l0cmm.TemplateType).Link,
        name: (0, $6kC3z.default).templatesPostExpandMore,
        url: `/wiki/templates?space=${spaceKey}`,
        renderShortcutIcon: true
    };
    // Verify that we should only obtain templates from defaultTemplates that also exist in the blueprints api
    const enabledTemplates = (0, $knvke.defaultTemplates).filter((template)=>blueprints.find((blueprint)=>blueprint.itemModuleCompleteKey && blueprint.itemModuleCompleteKey === template.itemModuleCompleteKey));
    const allTemplates = [
        ...enabledTemplates,
        moreTemplates
    ];
    if (isConfluenceAutoProvisioned) allTemplates.unshift((0, $knvke.getTutorialTemplate)(intl, isProjectPagesSporkRebrandingEnabled));
    return allTemplates.map((tmpl)=>({
            ...tmpl,
            tooltip: $465ad9361756eb18$var$getTooltip(tmpl, areTemplatesEnabled, confluenceLicenseStatus)
        }));
};
const $465ad9361756eb18$export$112c8b3cc38ec332 = (intl, isConfluenceAutoProvisioned, isProjectPagesSporkRebrandingEnabled)=>{
    if (isConfluenceAutoProvisioned) return [
        (0, $knvke.getTutorialTemplate)(intl, isProjectPagesSporkRebrandingEnabled),
        ...(0, $knvke.getBasePreExpandTemplates)()
    ];
    return (0, $knvke.getBasePreExpandTemplates)();
};
const $465ad9361756eb18$var$getTooltip = (tmpl, areTemplatesEnabled, confluenceLicenseStatus)=>{
    if (confluenceLicenseStatus === (0, $0988c9725597fab5$export$e74e627186613bef)) return (0, $6kC3z.default).connectSpaceTooltip;
    else if (!areTemplatesEnabled) return undefined;
    else if ((0, $7shOz.isMoreTemplates)(tmpl)) return (0, $6kC3z.default).templatesPostExpandMoreTooltip;
    else return undefined;
};
const $465ad9361756eb18$export$ea54dfd6f537fe17 = (hasActivatedConfluenceWithinSevenDays, hasAccessToConfluence)=>{
    // Either the user doesn't have access to Confluence (cross-flow) or they have activated it within 7 days (co-use)
    if (!hasAccessToConfluence || hasActivatedConfluenceWithinSevenDays) {
        const msrTemplatesExperimentCohort = (0, $jXVTV.getExperimentValue)('gpz-356-jira-project-pages-msr-templates-aa', 'not-enrolled');
        return {
            isMSRTemplatesExperimentEnabled: msrTemplatesExperimentCohort === 'variation',
            msrTemplatesExperimentCohort: msrTemplatesExperimentCohort
        };
    }
    return {
        isMSRTemplatesExperimentEnabled: false,
        msrTemplatesExperimentCohort: 'not-enrolled'
    };
};

});


parcelRegister("6MkMA", function(module, exports) {
module.exports = new URL("blank.0c2912ca.svg", import.meta.url).toString();

});

parcelRegister("cEiMj", function(module, exports) {
module.exports = new URL("blank.322437c4.png", import.meta.url).toString();

});

parcelRegister("idvCB", function(module, exports) {
module.exports = new URL("decision.5244d9b2.png", import.meta.url).toString();

});

parcelRegister("akzp7", function(module, exports) {
module.exports = new URL("product-requirements.d1bb667a.png", import.meta.url).toString();

});

parcelRegister("7XXRg", function(module, exports) {
module.exports = new URL("decision.5f3ba352.svg", import.meta.url).toString();

});

parcelRegister("cAh4w", function(module, exports) {
module.exports = new URL("meeting-notes.45a2e0c0.svg", import.meta.url).toString();

});

parcelRegister("lHc7f", function(module, exports) {
module.exports = new URL("meeting-notes.7a25198d.png", import.meta.url).toString();

});

parcelRegister("gXz2V", function(module, exports) {
module.exports = new URL("product-requirements.64ca7b12.svg", import.meta.url).toString();

});

parcelRegister("6kk3Z", function(module, exports) {
module.exports = new URL("retrospective.1a3389a9.svg", import.meta.url).toString();

});

parcelRegister("bA9IZ", function(module, exports) {
module.exports = new URL("retrospective.1b1ee868.png", import.meta.url).toString();

});

parcelRegister("eX0bx", function(module, exports) {
module.exports = new URL("welcome-to-project-pages.5dd7820d.svg", import.meta.url).toString();

});

parcelRegister("xuzKo", function(module, exports) {
module.exports = new URL("welcome-to-project-pages.873c33f5.png", import.meta.url).toString();

});

parcelRegister("53eOI", function(module, exports) {
module.exports = new URL("welcome-to-project-pages-spork-rebranding.dd069d6d.svg", import.meta.url).toString();

});

parcelRegister("7xfif", function(module, exports) {
module.exports = new URL("welcome-to-project-pages-spork-rebranding.b02d9616.png", import.meta.url).toString();

});

parcelRegister("fvWwp", function(module, exports) {
module.exports = new URL("blank-dark.eac9084a.png", import.meta.url).toString();

});

parcelRegister("jG84J", function(module, exports) {
module.exports = new URL("blank-dark.0d5d0868.svg", import.meta.url).toString();

});

parcelRegister("h8b02", function(module, exports) {
module.exports = new URL("decision-dark.73f4b063.png", import.meta.url).toString();

});

parcelRegister("jcZl9", function(module, exports) {
module.exports = new URL("decision-dark.3127b35c.svg", import.meta.url).toString();

});

parcelRegister("kqzWv", function(module, exports) {
module.exports = new URL("meeting-notes-dark.2f330e4c.png", import.meta.url).toString();

});

parcelRegister("3CEZI", function(module, exports) {
module.exports = new URL("meeting-notes-dark.d7bb00c4.svg", import.meta.url).toString();

});

parcelRegister("6H9hn", function(module, exports) {
module.exports = new URL("product-requirements-dark.8928717b.png", import.meta.url).toString();

});

parcelRegister("8RlEz", function(module, exports) {
module.exports = new URL("product-requirements-dark.ac25b817.svg", import.meta.url).toString();

});

parcelRegister("gFTpC", function(module, exports) {
module.exports = new URL("retrospective-dark.79188072.png", import.meta.url).toString();

});

parcelRegister("3t6Q7", function(module, exports) {
module.exports = new URL("retrospective-dark.1bf3d64c.svg", import.meta.url).toString();

});

parcelRegister("aThnY", function(module, exports) {
module.exports = new URL("welcome-to-project-pages-dark.99e9fdbd.png", import.meta.url).toString();

});

parcelRegister("hpkGg", function(module, exports) {
module.exports = new URL("welcome-to-project-pages-dark.fa778104.svg", import.meta.url).toString();

});

parcelRegister("9SJGb", function(module, exports) {
module.exports = new URL("welcome-to-project-pages-spork-rebranding-dark.a7e189fa.svg", import.meta.url).toString();

});

parcelRegister("5ibRN", function(module, exports) {
module.exports = new URL("welcome-to-project-pages-spork-rebranding-dark.1a4ad80a.png", import.meta.url).toString();

});


parcelRegister("jk2T6", function(module, exports) {

$parcel$export(module.exports, "default", () => $ec8099f6ba763a4e$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $57MwZ = parcelRequire("57MwZ");

var $cEylJ = parcelRequire("cEylJ");

var $escMm = parcelRequire("escMm");

var $5WLkL = parcelRequire("5WLkL");
// eslint-disable-next-line @typescript-eslint/ban-types
const $ec8099f6ba763a4e$var$Header = ({ breadcrumbs: breadcrumbs, isCrossSell: isCrossSell, MoreMenu: MoreMenu, shouldShowMeatballMenu: shouldShowMeatballMenu })=>{
    const theme = (0, $escMm.useThemeContext)();
    const actions = shouldShowMeatballMenu ? /*#__PURE__*/ (0, $2OMIu.jsx)(MoreMenu, {}) : undefined;
    return /*#__PURE__*/ (0, $2OMIu.jsx)($5WLkL.PageHeaderStyleWrapper, {
        theme: theme,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $57MwZ.default), {
            breadcrumbs: breadcrumbs,
            actions: actions,
            children: /*#__PURE__*/ (0, $2OMIu.jsx)($5WLkL.PageTitleStyleWrapper, {
                theme: theme,
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cEylJ.default), {
                    isPreExpand: isCrossSell
                })
            })
        })
    });
};
var $ec8099f6ba763a4e$export$2e2bcd8739ae039 = $ec8099f6ba763a4e$var$Header;

});
parcelRegister("cEylJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $1c5186a4bf2302cd$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $8RXs9 = parcelRequire("8RXs9");

var $3u0c5 = parcelRequire("3u0c5");

var $6kC3z = parcelRequire("6kC3z");

var $1VPPE = parcelRequire("1VPPE");
const $1c5186a4bf2302cd$var$ProjectPagesImprovementTitle = ({ intl: intl, isPreExpand: isPreExpand })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $1VPPE.TitleWrapper), {
        children: [
            intl.formatMessage((0, $6kC3z.default).title),
            isPreExpand && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1VPPE.TryLozenge), {
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3u0c5.default), {
                    appearance: "inprogress",
                    children: intl.formatMessage((0, $6kC3z.default).tryLozenge)
                })
            })
        ]
    });
};
var $1c5186a4bf2302cd$export$2e2bcd8739ae039 = (0, $8RXs9.default)($1c5186a4bf2302cd$var$ProjectPagesImprovementTitle);

});
parcelRegister("1VPPE", function(module, exports) {

$parcel$export(module.exports, "TryLozenge", () => $c781100c0138a99f$export$ff5672c4664546a);
$parcel$export(module.exports, "TitleWrapper", () => $c781100c0138a99f$export$585a3b23e887288b);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $47bDC = parcelRequire("47bDC");
const $c781100c0138a99f$export$ff5672c4664546a = /*#__PURE__*/ (0, $47bDC.default).span.withConfig({
    componentId: "vrezu7-0"
})({
    display: 'flex',
    paddingTop: "var(--ds-space-050, 4px)",
    paddingLeft: "var(--ds-space-100, 8px)"
});
const $c781100c0138a99f$export$585a3b23e887288b = /*#__PURE__*/ (0, $47bDC.default).span.withConfig({
    componentId: "vrezu7-1"
})({
    display: 'flex',
    alignItems: 'center',
    /* prevent legacy batch.css in JFE from overriding these styles */ // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    fontSize: 'inherit',
    fontWeight: "var(--ds-font-weight-medium, 500)"
});

});



parcelRegister("bfizW", function(module, exports) {

$parcel$export(module.exports, "ActivePage", () => $ef093874a3f0437d$export$416e47b9c84721a);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $SrFZY = parcelRequire("SrFZY");

var $6Sezp = parcelRequire("6Sezp");

var $dqtLq = parcelRequire("dqtLq");

var $5FGgp = parcelRequire("5FGgp");

var $jBUUS = parcelRequire("jBUUS");

var $2NMNM = parcelRequire("2NMNM");

var $h8yj2 = parcelRequire("h8yj2");
const $ef093874a3f0437d$export$416e47b9c84721a = ({ EmbeddedProductUpdater: EmbeddedProductUpdater, ConfluenceTree: ConfluenceTree, ConfluenceActivating: ConfluenceActivating, ConnectSpace: ConnectSpace, ServerError: ServerError, renderFullHeader: renderFullHeader })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const { activeRoute: activeRoute } = (0, $5FGgp.useRouter)();
    (0, $5uXOq.useEffect)(()=>{
        (0, $h8yj2.fireUIAnalytics)(createAnalyticsEvent({}), 'activePage viewed', {
            route: activeRoute
        });
    }, [
        activeRoute,
        createAnalyticsEvent
    ]);
    switch(activeRoute){
        case (0, $jBUUS.Routes).TemplatePreview:
            return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $SrFZY.default), {});
        case (0, $jBUUS.Routes).ConfluenceActivating:
            return /*#__PURE__*/ (0, $2OMIu.jsx)(ConfluenceActivating, {});
        case (0, $jBUUS.Routes).ConfluenceActivatingOnDemand:
            return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dqtLq.default), {});
        case (0, $jBUUS.Routes).ConnectSpace:
            return /*#__PURE__*/ (0, $2OMIu.jsx)(ConnectSpace, {}, "ConnectSpace");
        case (0, $jBUUS.Routes).ServerError:
            return /*#__PURE__*/ (0, $2OMIu.jsx)(ServerError, {});
        case (0, $jBUUS.Routes).ServerErrorAccess:
            return /*#__PURE__*/ (0, $2OMIu.jsx)(ServerError, {
                type: "access"
            });
        case (0, $jBUUS.Routes).SpaceOrPageNotFound:
            return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $6Sezp.default), {});
        default:
            return /*#__PURE__*/ (0, $2OMIu.jsx)(ConfluenceTree, {
                EmbeddedProductUpdater: EmbeddedProductUpdater,
                showDraftToggle: renderFullHeader ?? true
            });
    }
};

});
parcelRegister("SrFZY", function(module, exports) {

$parcel$export(module.exports, "default", () => $eea49115cb620c2a$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $haA2z = parcelRequire("haA2z");

var $3aZkJ = parcelRequire("3aZkJ");
const $eea49115cb620c2a$var$TemplatePreviewContainer = ()=>{
    const getConfluenceViewContext = (0, $3aZkJ.useGetConfluenceViewContext)();
    if (!getConfluenceViewContext) throw new Error('PreprovisionLandingContainer must be used within GetConfluenceViewProvider');
    const { onViewed: onViewed, primaryAction: primaryAction, secondaryAction: secondaryAction, shouldDisplayTermsAndConditions: shouldDisplayTermsAndConditions } = getConfluenceViewContext;
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $haA2z.default), {
        shouldDisplayTermsAndConditions: shouldDisplayTermsAndConditions,
        primaryAction: primaryAction,
        secondaryAction: secondaryAction,
        onViewed: onViewed
    });
};
var $eea49115cb620c2a$export$2e2bcd8739ae039 = $eea49115cb620c2a$var$TemplatePreviewContainer;

});
parcelRegister("haA2z", function(module, exports) {

$parcel$export(module.exports, "default", () => $32522a498f13ea0c$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");
var $8RXs9 = parcelRequire("8RXs9");

var $2qeLn = parcelRequire("2qeLn");

var $5qRwM = parcelRequire("5qRwM");

var $ldJSL = parcelRequire("ldJSL");

var $eCeGD = parcelRequire("eCeGD");

var $6kC3z = parcelRequire("6kC3z");

var $93A4M = parcelRequire("93A4M");

var $6k2gl = parcelRequire("6k2gl");

var $l0cmm = parcelRequire("l0cmm");

var $lo8H1 = parcelRequire("lo8H1");
const $32522a498f13ea0c$var$TemplatePreviewView = ({ intl: intl, shouldDisplayTermsAndConditions: shouldDisplayTermsAndConditions = false, primaryAction: primaryAction, secondaryAction: secondaryAction, onViewed: onViewed })=>{
    const { template: template } = (0, $6k2gl.useTemplate)();
    // eslint-disable-next-line no-undef
    const shouldDisplayPreview = !false && template && template.type === (0, $l0cmm.TemplateType).Confluence;
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2OMIu.Fragment), {
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $93A4M.PreviewWrapper), {
                children: [
                    /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $93A4M.TopBar), {
                        children: [
                            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $93A4M.TopBarDot), {}),
                            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $93A4M.TopBarDot), {}),
                            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $93A4M.TopBarDot), {})
                        ]
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $93A4M.Content), {
                        shouldDisplayTermsAndConditions: shouldDisplayTermsAndConditions,
                        children: shouldDisplayPreview ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5qRwM.default), {
                            src: template.preview.preExpand.default,
                            srcDark: template.preview.preExpand.dark,
                            width: "100%",
                            alt: `${template.name.description} Confluence Template`
                        }) : null
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $93A4M.BottomBar), {
                        children: [
                            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $93A4M.PreviewTeaser), {
                                children: intl.formatMessage((0, $6kC3z.default).previewTeaser)
                            }),
                            /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $ldJSL.default), {
                                children: [
                                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eCeGD.default), {
                                        appearance: "subtle",
                                        onClick: secondaryAction.onClick,
                                        isLoading: secondaryAction.isLoading,
                                        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                                            ...secondaryAction.text
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $eCeGD.default), {
                                        appearance: "primary",
                                        onClick: primaryAction.onClick,
                                        isLoading: primaryAction.isLoading,
                                        children: [
                                            !primaryAction.isLoading && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2qeLn.MountEvent), {
                                                onMount: primaryAction.onReady || (()=>void 0)
                                            }),
                                            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                                                ...primaryAction.text
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2qeLn.MountEvent), {
                                        onMount: onViewed
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            shouldDisplayTermsAndConditions && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $lo8H1.default), {})
        ]
    });
};
var $32522a498f13ea0c$export$2e2bcd8739ae039 = (0, $8RXs9.default)($32522a498f13ea0c$var$TemplatePreviewView);

});
parcelRegister("93A4M", function(module, exports) {

$parcel$export(module.exports, "PreviewWrapper", () => $04fa5c5bffea6139$export$700087f99bb44ee4);
$parcel$export(module.exports, "TopBar", () => $04fa5c5bffea6139$export$c4e96258f3b6511);
$parcel$export(module.exports, "TopBarDot", () => $04fa5c5bffea6139$export$6049a79b5f0a9d6e);
$parcel$export(module.exports, "Content", () => $04fa5c5bffea6139$export$7c6e2c02157bb7d2);
$parcel$export(module.exports, "BottomBar", () => $04fa5c5bffea6139$export$baad9f01dbfd9b39);
$parcel$export(module.exports, "PreviewTeaser", () => $04fa5c5bffea6139$export$b7c5ef56a55afe97);
$parcel$export(module.exports, "TermsAndPrivacyWrapper", () => $04fa5c5bffea6139$export$b306c2f5d4db1b52);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $47bDC = parcelRequire("47bDC");

const $04fa5c5bffea6139$export$700087f99bb44ee4 = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "sc-18hgx24-0"
})({
    minWidth: '320px',
    marginTop: "var(--ds-space-200, 16px)",
    boxShadow: `var(--ds-shadow-overlay, ${`0px 3px 5px rgba(9, 30, 66, 0.2),
    0px 0px 1px rgba(9, 30, 66, 0.31)`})`,
    borderRadius: '4px'
});
const $04fa5c5bffea6139$export$c4e96258f3b6511 = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "sc-18hgx24-1"
})({
    display: 'flex',
    padding: "var(--ds-space-100, 8px)",
    borderRadius: '4px 4px 0 0',
    backgroundColor: `var(--ds-background-neutral-bold, ${(0, $829f609a65d26a98$export$7d61b15e0da132af)})`
});
const $04fa5c5bffea6139$export$6049a79b5f0a9d6e = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "sc-18hgx24-2"
})({
    backgroundColor: "var(--ds-icon-inverse, #fff)",
    marginRight: "var(--ds-space-050, 4px)",
    width: '6px',
    height: '6px',
    borderRadius: '50%'
});
const $04fa5c5bffea6139$var$TERMS_AND_CONDITIONS_ALLOWANCE = '123px';
const $04fa5c5bffea6139$export$7c6e2c02157bb7d2 = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "sc-18hgx24-3"
})({
    minHeight: '346px',
    overflowY: 'scroll',
    height: `calc( 100vh - 297px - ${$04fa5c5bffea6139$var$TERMS_AND_CONDITIONS_ALLOWANCE} )`,
    maxHeight: '800px',
    backgroundColor: "var(--ds-surface, #FFFFFF)"
});
const $04fa5c5bffea6139$export$baad9f01dbfd9b39 = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "sc-18hgx24-4"
})({
    padding: `${"var(--ds-space-100, 8px)"} ${"var(--ds-space-150, 12px)"}`,
    borderTop: `1px solid ${`var(--ds-border, ${(0, $829f609a65d26a98$export$3e51e8f1440314ba)})`}`,
    borderRadius: '0 0 4px 4px',
    backgroundColor: `var(--ds-background-neutral, ${(0, $829f609a65d26a98$export$9fdfb749e33cdf97)})`,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between'
});
const $04fa5c5bffea6139$export$b7c5ef56a55afe97 = /*#__PURE__*/ (0, $47bDC.default).p.withConfig({
    componentId: "sc-18hgx24-5"
})({
    font: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
});
const $04fa5c5bffea6139$export$4827d26eeaf255c9 = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "sc-18hgx24-6"
})({
    flex: '1 1 auto'
});
const $04fa5c5bffea6139$export$b306c2f5d4db1b52 = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "sc-18hgx24-7"
})({
    paddingTop: "var(--ds-space-300, 24px)",
    paddingBottom: "var(--ds-space-300, 24px)",
    textAlign: 'center'
});

});

parcelRegister("lo8H1", function(module, exports) {

$parcel$export(module.exports, "default", () => $f9dec5a88a9c34cb$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $e4yMr = parcelRequire("e4yMr");

var $93A4M = parcelRequire("93A4M");

var $ousew = parcelRequire("ousew");
const $f9dec5a88a9c34cb$var$TermsAndPrivacyPolicy = ()=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)($93A4M.TermsAndPrivacyWrapper, {
        children: /*#__PURE__*/ (0, $2OMIu.jsx)($f9dec5a88a9c34cb$var$TermsAndPrivacyPolicyTryNow, {})
    });
};
const $f9dec5a88a9c34cb$var$terms = (chunks)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $e4yMr.default), {
        target: "_blank",
        href: "https://www.atlassian.com/legal/cloud-terms-of-service",
        children: chunks
    });
const $f9dec5a88a9c34cb$var$privacyPolicy = (chunks)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $e4yMr.default), {
        target: "_blank",
        href: "https://www.atlassian.com/legal/privacy-policy",
        children: chunks
    });
const $f9dec5a88a9c34cb$var$TermsAndPrivacyPolicyTryNow = ()=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
        defaultMessage: 'By clicking "Try it now", you will be enrolled in Confluence and agree to the Atlassian <termsLink>Cloud Terms of Service</termsLink> and <privacyLink>Privacy Policy</privacyLink>.',
        id: "project-pages.improvement.terms-and-conditions-v2",
        values: {
            termsLink: $f9dec5a88a9c34cb$var$terms,
            privacyLink: $f9dec5a88a9c34cb$var$privacyPolicy
        }
    });
var $f9dec5a88a9c34cb$export$2e2bcd8739ae039 = $f9dec5a88a9c34cb$var$TermsAndPrivacyPolicy;

});


parcelRegister("3aZkJ", function(module, exports) {

$parcel$export(module.exports, "useGetConfluenceViewContext", () => $d8308b176441d402$export$6d89ff2605ccb549);
$parcel$export(module.exports, "default", () => $d8308b176441d402$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");
parcelRequire("l1d2F");
var $bHpB9 = parcelRequire("bHpB9");
var $jWY5k = parcelRequire("jWY5k");

var $9aGFq = parcelRequire("9aGFq");

var $8rAPH = parcelRequire("8rAPH");

var $6k2gl = parcelRequire("6k2gl");

var $7shOz = parcelRequire("7shOz");


var $6kC3z = parcelRequire("6kC3z");

var $atdLB = parcelRequire("atdLB");
var $duUGa = parcelRequire("duUGa");
var $dnjeJ = parcelRequire("dnjeJ");

var $2NMNM = parcelRequire("2NMNM");

var $h8yj2 = parcelRequire("h8yj2");

var $huL1C = parcelRequire("huL1C");
const $d8308b176441d402$var$GetConfluenceViewContext = /*#__PURE__*/ (0, $5uXOq.createContext)({
    onViewed: ()=>{},
    shouldDisplayTermsAndConditions: false,
    primaryAction: {
        onClick: ()=>{},
        isLoading: false,
        text: (0, $6kC3z.default).tryButton
    },
    secondaryAction: {
        onClick: ()=>{},
        isLoading: false,
        text: (0, $6kC3z.default).learnMoreButton
    }
});
const $d8308b176441d402$var$primaryActionOptionsPerMethod = {
    integrated: {
        text: (0, $6kC3z.default).tryItNow
    },
    modal: {
        text: (0, $6kC3z.default).tryItNow
    },
    loading: {
        text: (0, $6kC3z.default).tryOnDemandButton
    }
};
const $d8308b176441d402$var$ufoPrimaryActionLoadTracker = new (0, $duUGa.UFOExperience)('get-confluence-primary-action', {
    performanceType: (0, $atdLB.ExperiencePerformanceTypes).PageSegmentLoad,
    type: (0, $atdLB.ExperienceTypes).Load,
    platform: {
        component: 'project-pages'
    }
});
const $d8308b176441d402$var$ufoViewComponentLoadTracker = new (0, $duUGa.UFOExperience)('get-confluence-page', {
    performanceType: (0, $atdLB.ExperiencePerformanceTypes).PageSegmentLoad,
    type: (0, $atdLB.ExperienceTypes).Load,
    platform: {
        component: 'project-pages'
    }
});
const $d8308b176441d402$var$GetConfluenceViewProvider = ({ onOpenCrossFlowError: onOpenCrossFlowError, onSuccessfulCrossFlowExpansion: onSuccessfulCrossFlowExpansion, activationMethod: activationMethod, triggerOnDemandActivation: triggerOnDemandActivation, children: children })=>{
    (0, $dnjeJ.useUFOComponentExperience)($d8308b176441d402$var$ufoViewComponentLoadTracker);
    const crossFlow = (0, $bHpB9.useCrossFlow)();
    const { projectKey: jiraProjectKey } = (0, $8rAPH.useProjectPages)();
    const { template: template } = (0, $6k2gl.useTemplate)();
    const { fireViewedEvent: fireViewedEvent, fireClickedEvent: fireClickedEvent } = (0, $9aGFq.useFireCrossFlowAnalyticsEvents)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    (0, $5uXOq.useEffect)(()=>{
        (0, $h8yj2.fireOperationalAnalytics)(createAnalyticsEvent({}), 'activationMethod set', {
            activationMethod: activationMethod
        });
    }, [
        activationMethod,
        createAnalyticsEvent
    ]);
    const onViewed = (0, $5uXOq.useCallback)(()=>{
        fireViewedEvent();
        $d8308b176441d402$var$ufoViewComponentLoadTracker.success();
        $d8308b176441d402$var$ufoPrimaryActionLoadTracker.start();
    }, [
        fireViewedEvent
    ]);
    const openCrossFlowOrDisplayError = (0, $5uXOq.useCallback)(async (journey)=>{
        if (crossFlow.isEnabled && jiraProjectKey && (0, $7shOz.isConfluenceTemplate)(template)) {
            const crossFlowCompletionStatus = await crossFlow.api.open({
                sourceComponent: (0, $9d339e91f7cbd39e$export$400f359cf7604d7a),
                sourceContext: (0, $9d339e91f7cbd39e$export$e776c72d9769c47a),
                targetProduct: (0, $jWY5k.Targets).CONFLUENCE,
                journey: journey,
                experimentalOptions: {
                    isCrossSell: true,
                    jiraProjectKey: jiraProjectKey,
                    confluenceBlueprintModuleCompleteKey: template.blueprintModuleCompleteKey
                }
            });
            if (crossFlowCompletionStatus.success) onSuccessfulCrossFlowExpansion();
        } else onOpenCrossFlowError();
    }, [
        crossFlow,
        jiraProjectKey,
        template,
        onSuccessfulCrossFlowExpansion,
        onOpenCrossFlowError
    ]);
    const onSecondaryActionClick = (0, $5uXOq.useCallback)(()=>{
        fireClickedEvent('learnMoreButton', {
            activationMethod: activationMethod
        });
        openCrossFlowOrDisplayError((0, $bHpB9.Journeys).DECIDE);
    }, [
        fireClickedEvent,
        openCrossFlowOrDisplayError,
        activationMethod
    ]);
    const onPrimaryActionClick = (0, $5uXOq.useCallback)(()=>{
        fireClickedEvent('tryThisTemplateButton', {
            activationMethod: activationMethod
        });
        if (activationMethod === 'integrated') {
            triggerOnDemandActivation();
            (0, $huL1C.flagUserAsXflowedFromProjectPages)();
        } else openCrossFlowOrDisplayError((0, $bHpB9.Journeys).GET_STARTED);
    }, [
        fireClickedEvent,
        activationMethod,
        triggerOnDemandActivation,
        openCrossFlowOrDisplayError
    ]);
    const onPrimaryActionReady = (0, $5uXOq.useCallback)(()=>{
        $d8308b176441d402$var$ufoPrimaryActionLoadTracker.success();
        (0, $h8yj2.fireUIAnalytics)(createAnalyticsEvent({}), 'tryButton viewed', {
            activationMethod: activationMethod
        });
    }, [
        activationMethod,
        createAnalyticsEvent
    ]);
    const primaryAction = (0, $5uXOq.useMemo)(()=>({
            isLoading: activationMethod === 'loading',
            onClick: onPrimaryActionClick,
            onReady: onPrimaryActionReady,
            ...$d8308b176441d402$var$primaryActionOptionsPerMethod[activationMethod]
        }), [
        activationMethod,
        onPrimaryActionClick,
        onPrimaryActionReady
    ]);
    const secondaryAction = (0, $5uXOq.useMemo)(()=>({
            isLoading: false,
            onClick: onSecondaryActionClick,
            text: (0, $6kC3z.default).learnMoreButton
        }), [
        onSecondaryActionClick
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)($d8308b176441d402$var$GetConfluenceViewContext.Provider, {
        value: {
            onViewed: onViewed,
            primaryAction: primaryAction,
            secondaryAction: secondaryAction,
            shouldDisplayTermsAndConditions: activationMethod === 'integrated'
        },
        children: children
    });
};
const $d8308b176441d402$export$6d89ff2605ccb549 = ()=>(0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useContext($d8308b176441d402$var$GetConfluenceViewContext);
var $d8308b176441d402$export$2e2bcd8739ae039 = $d8308b176441d402$var$GetConfluenceViewProvider;

});
parcelRegister("9aGFq", function(module, exports) {

$parcel$export(module.exports, "useFireCrossFlowAnalyticsEvents", () => $f52baa8da894a414$export$c2095165ae2bdcda);

var $iDfVE = parcelRequire("iDfVE");
var $cmVQ7 = parcelRequire("cmVQ7");

var $8rAPH = parcelRequire("8rAPH");
const $f52baa8da894a414$export$c2095165ae2bdcda = ()=>{
    const { fireViewedScreenEvent: fireViewedScreenEvent, fireInteractedUIEvent: fireInteractedUIEvent } = (0, $cmVQ7.useFireCrossFlowAnalyticsEvents)();
    const { environment: environment } = (0, $8rAPH.useProjectPages)();
    const env = environment === 'prod' ? 'prod' : 'staging';
    const confluenceCloudCCPProductID = (0, $iDfVE.FIRST_PARTY_CCP_PRODUCT_IDS)[env].confluence_cloud;
    return {
        fireViewedEvent: ()=>{
            fireViewedScreenEvent('projectPagesScreen', {
                recommendedProductIds: [
                    confluenceCloudCCPProductID
                ]
            });
        },
        fireClickedEvent: (buttonId, attributes = {})=>{
            fireInteractedUIEvent({
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: buttonId
            }, {
                recommendedProductIds: [
                    confluenceCloudCCPProductID
                ],
                targetProductId: confluenceCloudCCPProductID,
                source: 'projectPagesScreen'
            }, attributes);
        }
    };
};

});



parcelRegister("6Sezp", function(module, exports) {

$parcel$export(module.exports, "default", () => $ef9ad94f2b9c0194$export$2e2bcd8739ae039);

var $7Z8iG = parcelRequire("7Z8iG");

var $aPZf4 = parcelRequire("aPZf4");

var $bcKDb = parcelRequire("bcKDb");
const $ef9ad94f2b9c0194$var$mapDispatchToProps = (dispatch)=>({
        showConnectSpaceDialog: ()=>{
            dispatch((0, $aPZf4.showConnectSpaceDialog)());
            dispatch((0, $aPZf4.fetchConfluenceSpaces)());
        }
    });
var $ef9ad94f2b9c0194$export$2e2bcd8739ae039 = (0, $7Z8iG.connect)(null, $ef9ad94f2b9c0194$var$mapDispatchToProps)((0, $bcKDb.default));

});
parcelRegister("bcKDb", function(module, exports) {

$parcel$export(module.exports, "default", () => $8990de091d2a383d$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $hTEpF = parcelRequire("hTEpF");

var $eCeGD = parcelRequire("eCeGD");

var $ousew = parcelRequire("ousew");
var $koVbs = parcelRequire("koVbs");

var $6Ue56 = parcelRequire("6Ue56");

var $h8yj2 = parcelRequire("h8yj2");

var $4cuc7 = parcelRequire("4cuc7");

var $duc1y = parcelRequire("duc1y");

var $3r3OR = parcelRequire("3r3OR");
const $8990de091d2a383d$var$MountTracker = (0, $duc1y.default)('SpaceOrPageNotFound');
const $8990de091d2a383d$var$SpaceOrPageNotFound = ({ showConnectSpaceDialog: showConnectSpaceDialog })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const handleClick = (_, analyticsEvent)=>{
        (0, $h8yj2.fireUIAnalytics)(analyticsEvent, 'spaceOrPageNotFoundCreateButton');
        showConnectSpaceDialog();
    };
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2OMIu.Fragment), {
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $hTEpF.default), {
                imageUrl: (0, (/*@__PURE__*/$parcel$interopDefault($4cuc7))),
                imageWidth: 71,
                header: formatMessage((0, $6Ue56.default).title),
                description: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                    ...(0, $6Ue56.default).description,
                    values: {
                        link: (chunks)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $3r3OR.default), {
                                label: chunks
                            })
                    }
                }),
                primaryAction: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eCeGD.default), {
                    appearance: "default",
                    onClick: handleClick,
                    children: formatMessage((0, $6Ue56.default).connectSpaceButton)
                })
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)($8990de091d2a383d$var$MountTracker, {})
        ]
    });
};
var $8990de091d2a383d$export$2e2bcd8739ae039 = $8990de091d2a383d$var$SpaceOrPageNotFound;

});
parcelRegister("6Ue56", function(module, exports) {

$parcel$export(module.exports, "default", () => $00582f41448c6fd3$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $00582f41448c6fd3$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    title: {
        id: 'project-pages.improvement.errors.space-or-page-not-found.title',
        defaultMessage: 'Space or page not found',
        description: 'Title when the Confluence space or page linked to a Jira project cannot be found due to an error'
    },
    description: {
        id: 'project-pages.improvement.errors.space-or-page-not-found.description',
        defaultMessage: "The Confluence space or page that was connected has been moved, archived, or deleted. <link>Contact support</link> if re-connecting doesn't fix things",
        description: 'Information about potential reasons why the space or page cannot be found'
    },
    connectSpaceButton: {
        id: 'project-pages.connection-error.space-or-page-not-found.button',
        defaultMessage: 'Connect to a different space or page',
        description: 'Button to connect to a different Confluence space or page'
    }
});

});



parcelRegister("dqtLq", function(module, exports) {

$parcel$export(module.exports, "default", () => $2dc555f99a294863$export$2e2bcd8739ae039);

var $7Z8iG = parcelRequire("7Z8iG");

var $6GM1k = parcelRequire("6GM1k");

var $jhbRM = parcelRequire("jhbRM");

var $41TjW = parcelRequire("41TjW");

var $6y3t5 = parcelRequire("6y3t5");
const $2dc555f99a294863$var$mapStateToProps = (state)=>({
        status: (0, $jhbRM.getActivationStatus)(state)
    });
const $2dc555f99a294863$var$mapDispatchToProps = (dispatch)=>({
        startStatusCheck: ()=>{
            dispatch((0, $6y3t5.checkConfluenceActivationStatus)());
        },
        changeModalState: (modalState)=>{
            dispatch((0, $41TjW.updateOnDemandActivationModalState)({
                modalState: modalState
            }));
        }
    });
var $2dc555f99a294863$export$2e2bcd8739ae039 = (0, $7Z8iG.connect)($2dc555f99a294863$var$mapStateToProps, $2dc555f99a294863$var$mapDispatchToProps)((0, $6GM1k.default));

});
parcelRegister("6GM1k", function(module, exports) {

$parcel$export(module.exports, "default", () => $17bcfc6fbd25c42a$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $9U4qZ = parcelRequire("9U4qZ");

var $atdLB = parcelRequire("atdLB");
var $duUGa = parcelRequire("duUGa");
var $dnjeJ = parcelRequire("dnjeJ");
const $17bcfc6fbd25c42a$var$ufoExperienceTracker = new (0, $duUGa.UFOExperience)('on-demand-activation-in-progress', {
    performanceType: (0, $atdLB.ExperiencePerformanceTypes).PageSegmentLoad,
    type: (0, $atdLB.ExperienceTypes).Load,
    platform: {
        component: 'project-pages'
    }
});
const $17bcfc6fbd25c42a$var$activationStatusToProgress = {
    activating: 'in-progress',
    completed: 'completed',
    'not-started': 'not-started',
    allowed: 'not-started',
    error: 'error',
    'not-allowed': 'error'
};
const $17bcfc6fbd25c42a$var$OnDemandActivationInProgress = ({ startStatusCheck: startStatusCheck, changeModalState: changeModalState, status: status })=>{
    (0, $dnjeJ.useUFOComponentExperience)($17bcfc6fbd25c42a$var$ufoExperienceTracker);
    (0, $5uXOq.useEffect)(()=>{
        startStatusCheck();
    }, [
        startStatusCheck
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (status === 'completed') $17bcfc6fbd25c42a$var$ufoExperienceTracker.success();
        if (status === 'error') $17bcfc6fbd25c42a$var$ufoExperienceTracker.failure();
    }, [
        status
    ]);
    const handleDismissModal = ()=>{
        changeModalState('closed');
    };
    const handleOpenModal = ()=>{
        changeModalState('open');
    };
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $9U4qZ.default), {
        status: $17bcfc6fbd25c42a$var$activationStatusToProgress[status],
        onDismiss: handleDismissModal,
        onOpen: handleOpenModal
    });
};
var $17bcfc6fbd25c42a$export$2e2bcd8739ae039 = $17bcfc6fbd25c42a$var$OnDemandActivationInProgress;

});
parcelRegister("9U4qZ", function(module, exports) {

$parcel$export(module.exports, "ModalState", () => $2719e940bf735731$export$bb4219a9afe59f51);
$parcel$export(module.exports, "ActivationInProgressContext", () => $2719e940bf735731$export$c4018f4c76290b47);
$parcel$export(module.exports, "default", () => $2719e940bf735731$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $JL2cn = parcelRequire("JL2cn");

var $jWIWB = parcelRequire("jWIWB");
var $2719e940bf735731$export$bb4219a9afe59f51 = /*#__PURE__*/ function(ModalState) {
    ModalState["OPEN"] = "open";
    ModalState["CLOSED"] = "closed";
    return ModalState;
}({});
const $2719e940bf735731$export$c4018f4c76290b47 = /*#__PURE__*/ (0, $5uXOq.createContext)({
    modalState: "closed",
    onOpen: ()=>void 0,
    onDismiss: ()=>void 0
});
const $2719e940bf735731$var$ActivationInProgressPage = ({ onDismiss: onDismiss, onOpen: onOpen, status: status })=>{
    const [modalState, setModalState] = (0, $5uXOq.useState)("open");
    const changeModalState = (state)=>{
        setModalState(state);
    };
    const handleDismiss = (0, $5uXOq.useCallback)(()=>{
        changeModalState("closed");
        onDismiss();
    }, [
        onDismiss
    ]);
    const handleOpen = (0, $5uXOq.useCallback)(()=>{
        changeModalState("open");
        onOpen();
    }, [
        onOpen
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsxs)($2719e940bf735731$export$c4018f4c76290b47.Provider, {
        value: {
            modalState: modalState,
            onOpen: handleOpen,
            onDismiss: handleDismiss
        },
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $jWIWB.default), {
                status: status
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $JL2cn.default), {})
        ]
    });
};
var $2719e940bf735731$export$2e2bcd8739ae039 = $2719e940bf735731$var$ActivationInProgressPage;

});
parcelRegister("JL2cn", function(module, exports) {

$parcel$export(module.exports, "default", () => $82f1559c275d3e74$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $1R1Ge = parcelRequire("1R1Ge");
var $i8Qvm = parcelRequire("i8Qvm");

var $2eeog = parcelRequire("2eeog");

var $gfarD = parcelRequire("gfarD");

var $9U4qZ = parcelRequire("9U4qZ");

var $6Q7WV = parcelRequire("6Q7WV");

const $82f1559c275d3e74$var$ActivationInProgressModal = ()=>{
    const { modalState: modalState } = (0, $5uXOq.useContext)((0, $9U4qZ.ActivationInProgressContext) || (0, $9U4qZ.ModalState).OPEN);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $i8Qvm.default), {
        children: modalState === (0, $9U4qZ.ModalState).OPEN && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1R1Ge.default), {
            height: (0, $5b49d174adb7e4ee$export$1dd7793cb602b5ab),
            shouldScrollInViewport: true,
            children: /*#__PURE__*/ (0, $2OMIu.jsxs)($2eeog.ModalBody, {
                children: [
                    /*#__PURE__*/ (0, $2OMIu.jsx)($2eeog.Backdrop, {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($gfarD))),
                        alt: "Blue backdrop"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $6Q7WV.default), {})
                ]
            })
        })
    });
};
var $82f1559c275d3e74$export$2e2bcd8739ae039 = $82f1559c275d3e74$var$ActivationInProgressModal;

});
parcelRegister("2eeog", function(module, exports) {

$parcel$export(module.exports, "ModalBody", () => $27dad7ba2aaf198b$export$cb540d8b0ef7906c);
$parcel$export(module.exports, "Backdrop", () => $27dad7ba2aaf198b$export$698223c589197ab7);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $47bDC = parcelRequire("47bDC");

const $27dad7ba2aaf198b$export$cb540d8b0ef7906c = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "sc-1o2fyg2-0"
})({
    position: 'relative',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    width: `${(0, $5b49d174adb7e4ee$export$3d931b64f46140b3)}px`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    height: `${(0, $5b49d174adb7e4ee$export$1dd7793cb602b5ab)}px`,
    textAlign: 'center',
    display: 'grid',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    gridTemplateRows: `[image] ${(0, $5b49d174adb7e4ee$export$11c28e35a0c89402) - (0, $5b49d174adb7e4ee$export$a97597a250e1e38d)}px [content] 1fr [controls] 72px [footer] 36px`,
    paddingBottom: "var(--ds-space-300, 24px)",
    justifyItems: 'center'
});
const $27dad7ba2aaf198b$export$698223c589197ab7 = /*#__PURE__*/ (0, $47bDC.default).img.withConfig({
    componentId: "sc-1o2fyg2-1"
})({
    width: '100%',
    objectFit: 'cover',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    height: `${(0, $5b49d174adb7e4ee$export$11c28e35a0c89402)}px`,
    userSelect: 'none'
});

});
const $5b49d174adb7e4ee$export$11c28e35a0c89402 = 200;
const $5b49d174adb7e4ee$export$1dd7793cb602b5ab = 600;
const $5b49d174adb7e4ee$export$a97597a250e1e38d = 150;
const $5b49d174adb7e4ee$export$3d931b64f46140b3 = 600;


parcelRegister("gfarD", function(module, exports) {
module.exports = new URL("info-background.8530c64d.png", import.meta.url).toString();

});

parcelRegister("6Q7WV", function(module, exports) {

$parcel$export(module.exports, "default", () => $9644ce4b6d391812$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $6O77j = parcelRequire("6O77j");

var $Imliu = parcelRequire("Imliu");

var $9U4qZ = parcelRequire("9U4qZ");

var $hOU2d = parcelRequire("hOU2d");

var $lYqhm = parcelRequire("lYqhm");
const $9644ce4b6d391812$var$CAROUSEL_ITEM_COUNT = 3;
const $9644ce4b6d391812$export$7bf2b67922fe03be = ()=>{
    const { onDismiss: onDismiss } = (0, $5uXOq.useContext)((0, $9U4qZ.ActivationInProgressContext));
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $6O77j.default), {
        slideRange: [
            1,
            $9644ce4b6d391812$var$CAROUSEL_ITEM_COUNT
        ],
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $6O77j.default).Slide, {
                children: [
                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $6O77j.default).Item, {
                        position: 1,
                        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $lYqhm.YourProjectPagesInJira), {})
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $6O77j.default).Item, {
                        position: 2,
                        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $lYqhm.SeamlesslyUpdateStakeholders), {})
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $6O77j.default).Item, {
                        position: 3,
                        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $lYqhm.UnifyDocumentation), {})
                    })
                ]
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $6O77j.default).Control, {
                children: ({ onPrevious: onPrevious, isStart: isStart })=>!isStart && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $Imliu.default).Chevron, {
                        direction: (0, $hOU2d.ChevronDirection).LEFT,
                        onPrevious: onPrevious
                    })
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $6O77j.default).Control, {
                children: ({ onNext: onNext, isEnd: isEnd })=>!isEnd && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $Imliu.default).Chevron, {
                        direction: (0, $hOU2d.ChevronDirection).RIGHT,
                        onNext: onNext
                    })
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $6O77j.default).Control, {
                children: ({ onNext: onNext, onChangePosition: onChangePosition, visiblePosition: visiblePosition, isEnd: isEnd })=>/*#__PURE__*/ (0, $2OMIu.jsxs)((0, $Imliu.default).Container, {
                        children: [
                            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $Imliu.default).Button, {
                                buttonActionType: (0, $hOU2d.ButtonActionType).DISMISS,
                                onClick: onDismiss
                            }),
                            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $Imliu.default).NavigationBulletGroup, {
                                count: $9644ce4b6d391812$var$CAROUSEL_ITEM_COUNT,
                                activePosition: visiblePosition,
                                onNavigationBulletClick: onChangePosition
                            }),
                            isEnd ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $Imliu.default).Button, {
                                buttonActionType: (0, $hOU2d.ButtonActionType).DONE,
                                onClick: onDismiss
                            }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $Imliu.default).Button, {
                                buttonActionType: (0, $hOU2d.ButtonActionType).NEXT,
                                onClick: onNext
                            })
                        ]
                    })
            })
        ]
    });
};
var $9644ce4b6d391812$export$2e2bcd8739ae039 = $9644ce4b6d391812$export$7bf2b67922fe03be;

});
parcelRegister("6O77j", function(module, exports) {

$parcel$export(module.exports, "CarouselConsumer", () => $b90516560a8fd0d4$export$4552b2d5a7ba5038);
$parcel$export(module.exports, "default", () => $b90516560a8fd0d4$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $ef1Yb = parcelRequire("ef1Yb");

var $lcZys = parcelRequire("lcZys");

var $9oIcf = parcelRequire("9oIcf");
const $b90516560a8fd0d4$export$b9f5e42d7424d064 = {
    visiblePosition: 1,
    onNext: ()=>void 0,
    onPrevious: ()=>void 0,
    onChangePosition: ()=>void 0,
    isStart: true,
    isEnd: false
};
const $b90516560a8fd0d4$export$762b25d1c14c81e4 = /*#__PURE__*/ (0, $5uXOq.createContext)($b90516560a8fd0d4$export$b9f5e42d7424d064);
const $b90516560a8fd0d4$export$4552b2d5a7ba5038 = ({ children: children })=>/*#__PURE__*/ (0, $2OMIu.jsx)($b90516560a8fd0d4$export$762b25d1c14c81e4.Consumer, {
        children: (context)=>{
            if (!context) throw new Error('Please pass the necessary context');
            if (!children) throw new Error('Please add at least one child component');
            return children(context);
        }
    });
const $b90516560a8fd0d4$export$144901db2ea8e967 = (props)=>{
    const { slideRange: slideRange, children: children, loop: loop } = props;
    const [slideStart, slideEnd] = slideRange;
    const [visiblePosition, setVisiblePosition] = (0, $5uXOq.useState)(slideStart);
    const isFirstItemVisible = visiblePosition === slideStart;
    const isLastItemVisible = visiblePosition === slideEnd;
    const handleChangePosition = (position)=>{
        setVisiblePosition(position);
    };
    const showNextItem = (0, $5uXOq.useCallback)(()=>{
        if (isLastItemVisible && !loop) return;
        const shouldResetToStart = isLastItemVisible && loop;
        const nextItemPosition = visiblePosition + 1;
        const newPosition = shouldResetToStart ? slideStart : nextItemPosition;
        handleChangePosition(newPosition);
    }, [
        isLastItemVisible,
        loop,
        slideStart,
        visiblePosition
    ]);
    const showPreviousItem = (0, $5uXOq.useCallback)(()=>{
        if (isFirstItemVisible && !loop) return;
        const shouldJumpToEnd = loop && isFirstItemVisible;
        const previousItemPosition = visiblePosition - 1;
        const newPosition = shouldJumpToEnd ? slideEnd : previousItemPosition;
        handleChangePosition(newPosition);
    }, [
        isFirstItemVisible,
        loop,
        slideEnd,
        visiblePosition
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)($b90516560a8fd0d4$export$762b25d1c14c81e4.Provider, {
        value: {
            visiblePosition: visiblePosition,
            onNext: showNextItem,
            onPrevious: showPreviousItem,
            onChangePosition: handleChangePosition,
            isStart: isFirstItemVisible,
            isEnd: isLastItemVisible
        },
        children: children
    });
};
$b90516560a8fd0d4$export$144901db2ea8e967.Control = (0, $ef1Yb.Control);
$b90516560a8fd0d4$export$144901db2ea8e967.Item = (0, $lcZys.Item);
$b90516560a8fd0d4$export$144901db2ea8e967.Slide = (0, $9oIcf.Slide);
var $b90516560a8fd0d4$export$2e2bcd8739ae039 = $b90516560a8fd0d4$export$144901db2ea8e967;

});
parcelRegister("ef1Yb", function(module, exports) {

$parcel$export(module.exports, "Control", () => $d56221c548994bfd$export$7a7fa4424cb20976);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $6O77j = parcelRequire("6O77j");
const $d56221c548994bfd$export$7a7fa4424cb20976 = ({ children: children })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $6O77j.CarouselConsumer), {
        children: children
    });

});

parcelRegister("lcZys", function(module, exports) {

$parcel$export(module.exports, "Item", () => $1072c3ea4a098c9a$export$6d08773d2e66f8f2);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $6O77j = parcelRequire("6O77j");

var $9El8R = parcelRequire("9El8R");
const $1072c3ea4a098c9a$export$6d08773d2e66f8f2 = ({ children: children, position: position, ...rest })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $6O77j.CarouselConsumer), {
        children: ({ visiblePosition: visiblePosition })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $9El8R.StyledCarouselItem), {
                visiblePosition: visiblePosition,
                currentPosition: position,
                ...rest,
                children: children
            })
    });
};

});
parcelRegister("9El8R", function(module, exports) {

$parcel$export(module.exports, "StyledCarouselSlide", () => $7b2dda7068ab51e3$export$da5dc1115c18b364);
$parcel$export(module.exports, "StyledCarouselItem", () => $7b2dda7068ab51e3$export$365b3aec472df75b);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $47bDC = parcelRequire("47bDC");
const $7b2dda7068ab51e3$var$getCurrentCardPosition = ({ visiblePosition: visiblePosition, currentPosition: currentPosition })=>{
    // If the item is at the visible position, it should be at 0
    if (visiblePosition === currentPosition) return '0';
    // If the item is after the visible position, it should be at 100% (to the right)
    if (currentPosition > visiblePosition) return '100%';
    // If the item is before the visible position, it should be at -100% (to the left)
    return '-100%';
};
const $7b2dda7068ab51e3$export$da5dc1115c18b364 = /*#__PURE__*/ (0, $47bDC.default).ul.withConfig({
    componentId: "g3b0j7-0"
})({
    position: 'relative',
    listStyle: 'none',
    margin: 0,
    padding: 0,
    display: 'flex',
    width: '100%',
    height: '100%',
    overflow: 'hidden'
});
const $7b2dda7068ab51e3$export$365b3aec472df75b = /*#__PURE__*/ (0, $47bDC.default).li.withConfig({
    componentId: "g3b0j7-1"
})`position:absolute;top:0;bottom:0;padding:0;margin:0;width:100%;${(props)=>{
    const cardPosition = $7b2dda7068ab51e3$var$getCurrentCardPosition(props);
    const isVisible = props.visiblePosition === props.currentPosition;
    return `
				transition: all 0.365s ease-in-out;
			    height: 100%;
            	transform: translateX(${cardPosition});
            	visibility: ${isVisible ? 'visible' : 'hidden'};
            	z-index: ${isVisible ? 1 : 0};
            	pointer-events: ${isVisible ? 'auto' : 'none'};
			`;
}}`;

});


parcelRegister("9oIcf", function(module, exports) {

$parcel$export(module.exports, "Slide", () => $957d0a2dc1494f89$export$d8dc01b5c85a37b9);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $6O77j = parcelRequire("6O77j");

var $9El8R = parcelRequire("9El8R");
const $957d0a2dc1494f89$export$d8dc01b5c85a37b9 = ({ children: children })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $6O77j.CarouselConsumer), {
        children: ()=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $9El8R.StyledCarouselSlide), {
                children: children
            })
    });

});


parcelRegister("Imliu", function(module, exports) {

$parcel$export(module.exports, "default", () => $07e1bc9470a7866f$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $fVnbM = parcelRequire("fVnbM");

var $k6ANO = parcelRequire("k6ANO");

var $ousew = parcelRequire("ousew");

var $8oJ2G = parcelRequire("8oJ2G");

var $2NMNM = parcelRequire("2NMNM");

var $h8yj2 = parcelRequire("h8yj2");

var $hOU2d = parcelRequire("hOU2d");

var $lRheX = parcelRequire("lRheX");

var $3dGN0 = parcelRequire("3dGN0");

var $5ILhZ = parcelRequire("5ILhZ");
var $8CUq3 = parcelRequire("8CUq3");
const $07e1bc9470a7866f$var$NavigationBullet = ({ position: position, activePosition: activePosition, onNavigationBulletClick: onNavigationBulletClick })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const handleNavigationBulletClick = ()=>{
        const event = createAnalyticsEvent({
            actionSubject: 'provisioningModalNavigationBullet',
            action: 'clicked',
            attributes: {
                position: position
            }
        });
        (0, $h8yj2.fireUIAnalytics)(event);
        onNavigationBulletClick(position);
    };
    return /*#__PURE__*/ (0, $2OMIu.jsx)($k6ANO.NavigationBullet, {
        onClick: handleNavigationBulletClick,
        isActive: activePosition === position
    });
};
const $07e1bc9470a7866f$var$NavigationBulletGroup = ({ count: count, activePosition: activePosition, onNavigationBulletClick: onNavigationBulletClick })=>{
    if (count < 2) return null;
    const navigationBullets = Array(count).fill(0);
    return /*#__PURE__*/ (0, $2OMIu.jsx)($k6ANO.NavigationBulletsWrapper, {
        children: navigationBullets.map((_, index)=>/*#__PURE__*/ (0, $2OMIu.jsx)($07e1bc9470a7866f$var$NavigationBullet, {
                activePosition: activePosition,
                position: index + 1,
                onNavigationBulletClick: onNavigationBulletClick
            }))
    });
};
const $07e1bc9470a7866f$var$buttonAppearance = {
    [(0, $hOU2d.ButtonActionType).DISMISS]: 'subtle',
    [(0, $hOU2d.ButtonActionType).NEXT]: 'primary',
    [(0, $hOU2d.ButtonActionType).DONE]: 'primary'
};
const $07e1bc9470a7866f$var$Button = ({ onClick: onClick, buttonActionType: buttonActionType })=>{
    const handleClick = (_, analyticsEvent)=>{
        (0, $h8yj2.fireUIAnalytics)(analyticsEvent, 'provisioningModalControl', {
            buttonActionType: buttonActionType
        });
        onClick();
    };
    return /*#__PURE__*/ (0, $2OMIu.jsx)($k6ANO.ButtonWrapper, {
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fVnbM.default), {
            appearance: $07e1bc9470a7866f$var$buttonAppearance[buttonActionType],
            onClick: handleClick,
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                ...(0, $8oJ2G.default)[buttonActionType]
            })
        })
    });
};
const $07e1bc9470a7866f$var$Container = ({ children: children })=>/*#__PURE__*/ (0, $2OMIu.jsx)($k6ANO.ControlsWrapper, {
        children: children
    });
const $07e1bc9470a7866f$var$wrapperStyles = (0, $8CUq3.xcss)({
    width: '26px',
    height: '26px',
    borderRadius: '100%',
    padding: 'space.0',
    backgroundColor: 'color.background.accent.gray.bolder.pressed',
    color: 'color.text.inverse',
    boxSizing: 'border-box',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
});
const $07e1bc9470a7866f$var$withIconWrapper = (Component)=>{
    return ({ label: label })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $5ILhZ.default), {
            xcss: $07e1bc9470a7866f$var$wrapperStyles,
            children: /*#__PURE__*/ (0, $2OMIu.jsx)(Component, {
                label: label,
                LEGACY_size: "large",
                // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
                LEGACY_primaryColor: "#172B4D",
                // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
                LEGACY_secondaryColor: "#FFFFFF",
                color: "currentColor"
            })
        });
};
const $07e1bc9470a7866f$var$ChevronIconTypes = {
    [(0, $hOU2d.ChevronDirection).RIGHT]: $07e1bc9470a7866f$var$withIconWrapper((0, (/*@__PURE__*/$parcel$interopDefault($3dGN0)))),
    [(0, $hOU2d.ChevronDirection).LEFT]: $07e1bc9470a7866f$var$withIconWrapper((0, (/*@__PURE__*/$parcel$interopDefault($lRheX))))
};
const $07e1bc9470a7866f$var$Chevron = ({ onPrevious: onPrevious, direction: direction, onNext: onNext })=>{
    const handleClick = ()=>{
        if (direction === (0, $hOU2d.ChevronDirection).LEFT && onPrevious) onPrevious();
        if (direction === (0, $hOU2d.ChevronDirection).RIGHT && onNext) onNext();
    };
    const ChevronIcon = $07e1bc9470a7866f$var$ChevronIconTypes[direction];
    return /*#__PURE__*/ (0, $2OMIu.jsx)($k6ANO.ChevronWrapper, {
        direction: direction,
        onClick: handleClick,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)(ChevronIcon, {
            label: direction
        })
    });
};
var $07e1bc9470a7866f$export$2e2bcd8739ae039 = {
    Button: $07e1bc9470a7866f$var$Button,
    NavigationBulletGroup: $07e1bc9470a7866f$var$NavigationBulletGroup,
    Container: $07e1bc9470a7866f$var$Container,
    Chevron: $07e1bc9470a7866f$var$Chevron
};

});
parcelRegister("k6ANO", function(module, exports) {

$parcel$export(module.exports, "ControlsWrapper", () => $c073df725c71327e$export$5ba2725878d48f40);
$parcel$export(module.exports, "ButtonWrapper", () => $c073df725c71327e$export$d53c836cccbb0d90);
$parcel$export(module.exports, "NavigationBulletsWrapper", () => $c073df725c71327e$export$5da873e643f6e8be);
$parcel$export(module.exports, "NavigationBullet", () => $c073df725c71327e$export$c79585d7177d0a0);
$parcel$export(module.exports, "ChevronWrapper", () => $c073df725c71327e$export$175b3820ff858b37);


var $47bDC = parcelRequire("47bDC");

var $hOU2d = parcelRequire("hOU2d");
const $c073df725c71327e$export$5ba2725878d48f40 = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "sc-1fnsr4s-0"
})({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%'
});
const $c073df725c71327e$export$d53c836cccbb0d90 = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "sc-1fnsr4s-1"
})({
    width: '120px',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    button: {
        userSelect: 'none'
    }
});
const $c073df725c71327e$export$5da873e643f6e8be = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "sc-1fnsr4s-2"
})({
    display: 'inherit',
    alignItems: 'inherit',
    justifyContent: 'center',
    maxWidth: '120px'
});
const $c073df725c71327e$export$c79585d7177d0a0 = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "sc-1fnsr4s-3"
})(({ isActive: isActive })=>({
        width: '8px',
        height: '8px',
        backgroundColor: `var(--ds-background-brand-bold, ${0, $829f609a65d26a98$export$a6ee3d71bc067634})`,
        borderRadius: '50%',
        cursor: 'pointer',
        margin: `0 ${"var(--ds-space-050, 4px)"}`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        opacity: isActive ? '1' : '0.4',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        ':hover': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            opacity: isActive ? '1' : '0.6'
        }
    }));
const $c073df725c71327e$export$175b3820ff858b37 = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "sc-1fnsr4s-4"
})`position:absolute;left:${({ direction: direction })=>direction === (0, $hOU2d.ChevronDirection).LEFT ? '27px' : 'auto'};right:${({ direction: direction })=>direction === (0, $hOU2d.ChevronDirection).RIGHT ? '27px' : 'auto'};top:153px;opacity:0.6;:hover{opacity:1;}cursor:pointer;z-index:1;`;

});
parcelRegister("hOU2d", function(module, exports) {

$parcel$export(module.exports, "ButtonActionType", () => $418f58803e95a282$export$e3bd8c5021ad764b);
$parcel$export(module.exports, "ChevronDirection", () => $418f58803e95a282$export$28cad1695513a229);
var $418f58803e95a282$export$e3bd8c5021ad764b = /*#__PURE__*/ function(ButtonActionType) {
    ButtonActionType["DISMISS"] = "dismiss";
    ButtonActionType["NEXT"] = "next";
    ButtonActionType["DONE"] = "done";
    return ButtonActionType;
}({});
var $418f58803e95a282$export$28cad1695513a229 = /*#__PURE__*/ function(ChevronDirection) {
    ChevronDirection["RIGHT"] = "right";
    ChevronDirection["LEFT"] = "left";
    return ChevronDirection;
}({});

});


parcelRegister("8oJ2G", function(module, exports) {

$parcel$export(module.exports, "default", () => $55d1996ea78ed34e$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
const $55d1996ea78ed34e$var$messages = (0, $7VHMR.defineMessages)({
    dismiss: {
        id: 'confluence.project-pages.improvement.provisioning-modal-carousel.controls.dismiss',
        defaultMessage: 'Dismiss',
        description: 'Label of a button to allow users to dismiss the info modal'
    },
    next: {
        id: 'confluence.project-pages.improvement.provisioning-modal-carousel.controls.next',
        defaultMessage: 'Next',
        description: 'Label of a button to allow users to go to the next screen within the info modal'
    },
    done: {
        id: 'confluence.project-pages.improvement.provisioning-modal-carousel.controls.done',
        defaultMessage: 'Done',
        description: 'Label of a button indicating that Jira provisioning is completed and users can dismiss the modal by clicking Done'
    }
});
var $55d1996ea78ed34e$export$2e2bcd8739ae039 = $55d1996ea78ed34e$var$messages;

});

parcelRegister("lRheX", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::29f3eb59553566fe46c3ae42f5cce545>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $fe9bebc953515e63$var$_react = $fe9bebc953515e63$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $fe9bebc953515e63$var$_baseNew = $fe9bebc953515e63$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $fe9bebc953515e63$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ChevronLeft".
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for collapse side nav and to indicate previous in dates.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $fe9bebc953515e63$var$ChevronLeftIcon = (props)=>/*#__PURE__*/ $fe9bebc953515e63$var$_react.default.createElement($fe9bebc953515e63$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="m4.06 6 3.97-3.97L6.97.97l-4.5 4.5a.75.75 0 0 0 0 1.06l4.5 4.5 1.06-1.06z" clip-rule="evenodd"/>`,
        type: 'utility'
    }, props));
$fe9bebc953515e63$var$ChevronLeftIcon.displayName = 'ChevronLeftIcon';
var $fe9bebc953515e63$var$_default = module.exports.default = $fe9bebc953515e63$var$ChevronLeftIcon;

});


parcelRegister("lYqhm", function(module, exports) {

$parcel$export(module.exports, "YourProjectPagesInJira", () => $eb5a64ca4528cb05$export$41899e7e2672fb19);
$parcel$export(module.exports, "SeamlesslyUpdateStakeholders", () => $eb5a64ca4528cb05$export$2654a507013898c6);
$parcel$export(module.exports, "UnifyDocumentation", () => $eb5a64ca4528cb05$export$dd39790e2f9c8f14);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $iTBEr = parcelRequire("iTBEr");

var $cFnbs = parcelRequire("cFnbs");

var $8KR9j = parcelRequire("8KR9j");

var $ousew = parcelRequire("ousew");

var $4SiBD = parcelRequire("4SiBD");

var $2tl9q = parcelRequire("2tl9q");
const $eb5a64ca4528cb05$export$41899e7e2672fb19 = ()=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $2tl9q.Card), {
        image: (0, (/*@__PURE__*/$parcel$interopDefault($iTBEr))),
        heading: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
            ...(0, $4SiBD.default).yourProjectPagesInJiraTitle
        }),
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
            ...(0, $4SiBD.default).yourProjectPagesInJiraDescription
        })
    });
const $eb5a64ca4528cb05$export$2654a507013898c6 = ()=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $2tl9q.Card), {
        image: (0, (/*@__PURE__*/$parcel$interopDefault($cFnbs))),
        heading: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
            ...(0, $4SiBD.default).seamlesslyUpdateStakeholdersTitle
        }),
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
            ...(0, $4SiBD.default).seamlesslyUpdateStakeholdersDescription
        })
    });
const $eb5a64ca4528cb05$export$dd39790e2f9c8f14 = ()=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2tl9q.Card), {
        image: (0, (/*@__PURE__*/$parcel$interopDefault($8KR9j))),
        heading: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
            ...(0, $4SiBD.default).unifyDocumentationTitle
        }),
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
            ...(0, $4SiBD.default).unifyDocumentationDescription
        })
    });
};

});
parcelRegister("iTBEr", function(module, exports) {
module.exports = new URL("browser1.6557a92d.png", import.meta.url).toString();

});

parcelRegister("cFnbs", function(module, exports) {
module.exports = new URL("browser2.dc1ee20b.png", import.meta.url).toString();

});

parcelRegister("8KR9j", function(module, exports) {
module.exports = new URL("browser3.b317f175.png", import.meta.url).toString();

});

parcelRegister("4SiBD", function(module, exports) {

$parcel$export(module.exports, "default", () => $12e66d74c8fc70f2$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");

var $d4JtJ = parcelRequire("d4JtJ");
const $12e66d74c8fc70f2$var$values = {
    a: (0, $d4JtJ.anchorConstructor),
    p: (0, $d4JtJ.paragraphConstructor)
};
const $12e66d74c8fc70f2$var$messages = (0, $7VHMR.defineMessages)({
    yourProjectPagesInJiraTitle: {
        id: 'project-pages.improvement.provisioning-info-modal.your-project-pages-in-jira.title',
        defaultMessage: 'Your project pages, directly in Jira',
        description: '',
        values: $12e66d74c8fc70f2$var$values
    },
    yourProjectPagesInJiraDescription: {
        id: 'project-pages.improvement.provisioning-info-modal.your-project-pages-in-jira.description',
        defaultMessage: `
        <p>Create a single source of truth for important information by creating and managing documentation from the project pages tab in Jira.</p>
        <p>Did you know project pages runs on Confluence? It's free for up to 10 users. Invite the rest of your team in admin settings.</p>
    `,
        description: '',
        values: $12e66d74c8fc70f2$var$values
    },
    seamlesslyUpdateStakeholdersTitle: {
        id: 'project-pages.improvement.provisioning-info-modal.seamlessly-update-stakeholders.title',
        defaultMessage: 'Seamlessly update your stakeholders',
        description: '',
        values: $12e66d74c8fc70f2$var$values
    },
    seamlesslyUpdateStakeholdersDescription: {
        id: 'project-pages.improvement.provisioning-info-modal.seamlessly-update-stakeholders.description',
        defaultMessage: `
        <p>Keep your project reports up-to-date with auto-updating status labels.</p>
        <p>Simply link a Jira ticket in a doc and it will automatically display a status label that updates in sync with the ticket, so you don't have to spend your time creating manual reports.</p>
    `,
        description: '',
        values: $12e66d74c8fc70f2$var$values
    },
    unifyDocumentationTitle: {
        id: 'project-pages.improvement.provisioning-info-modal.unify-documentation-standards.title',
        defaultMessage: 'Unify your documentation standards',
        description: '',
        values: $12e66d74c8fc70f2$var$values
    },
    unifyDocumentationDescription: {
        id: 'project-pages.improvement.provisioning-info-modal.unify-documentation-standards.description',
        defaultMessage: `
        <p>Create consistent documentation by using our built-in templates. They are simple to use and customizable for your needs.</p>
        <p>You can use templates directly from project pages, so you never have to leave what you're working on. Browse all templates <a>here</a>.</p>
    `,
        description: '',
        values: $12e66d74c8fc70f2$var$values
    }
});
var $12e66d74c8fc70f2$export$2e2bcd8739ae039 = $12e66d74c8fc70f2$var$messages;

});
parcelRegister("d4JtJ", function(module, exports) {

$parcel$export(module.exports, "paragraphConstructor", () => $39d84c0889bff5bc$export$c9e5fc37b88cf735);
$parcel$export(module.exports, "anchorConstructor", () => $39d84c0889bff5bc$export$59032c4ec43430cf);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");
const $39d84c0889bff5bc$var$TEMPLATES_URL = 'https://www.atlassian.com/software/confluence/templates/categories/project-planning';
const $39d84c0889bff5bc$export$c9e5fc37b88cf735 = (intlStr)=>/*#__PURE__*/ (0, $2OMIu.jsx)("p", {
        children: intlStr
    });
const $39d84c0889bff5bc$export$59032c4ec43430cf = (intlStr)=>/*#__PURE__*/ (0, $2OMIu.jsx)("a", {
        href: $39d84c0889bff5bc$var$TEMPLATES_URL,
        target: "_blank",
        children: intlStr
    });

});


parcelRegister("2tl9q", function(module, exports) {

$parcel$export(module.exports, "Card", () => $5e98cec901fc366d$export$60332b2344f7fe41);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $kmsR4 = parcelRequire("kmsR4");
const $5e98cec901fc366d$export$60332b2344f7fe41 = ({ heading: heading, children: children, image: image })=>/*#__PURE__*/ (0, $2OMIu.jsxs)($kmsR4.CardWrapper, {
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)($kmsR4.CardImage, {
                src: image,
                alt: ""
            }),
            /*#__PURE__*/ (0, $2OMIu.jsxs)($kmsR4.CardText, {
                children: [
                    /*#__PURE__*/ (0, $2OMIu.jsx)("h2", {
                        children: heading
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("br", {}),
                    children
                ]
            })
        ]
    });

});
parcelRegister("kmsR4", function(module, exports) {

$parcel$export(module.exports, "CardWrapper", () => $a1812bcc92d4c43b$export$6aa22a823032b784);
$parcel$export(module.exports, "CardText", () => $a1812bcc92d4c43b$export$c6336bc933e0ce5f);
$parcel$export(module.exports, "CardImage", () => $a1812bcc92d4c43b$export$8a8c015277a3d77a);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $47bDC = parcelRequire("47bDC");
const $a1812bcc92d4c43b$var$IMAGE_HEIGHT = 180;
const $a1812bcc92d4c43b$export$6aa22a823032b784 = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "gdinkh-0"
})({
    display: 'grid',
    gridTemplateColumns: '100%',
    gridTemplateRows: '50% 50%',
    height: '100%',
    width: '80%',
    margin: '0 auto',
    overflowY: 'auto',
    justifyItems: 'center',
    alignItems: 'center'
});
const $a1812bcc92d4c43b$export$64ef9b8c11710c47 = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "gdinkh-1"
})({
    display: 'flex',
    alignItems: 'flex-start',
    width: '100%'
});
const $a1812bcc92d4c43b$export$c6336bc933e0ce5f = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "gdinkh-2"
})({
    width: '100%'
});
const $a1812bcc92d4c43b$export$8a8c015277a3d77a = /*#__PURE__*/ (0, $47bDC.default).img.withConfig({
    componentId: "gdinkh-3"
})({
    position: 'relative',
    height: `${$a1812bcc92d4c43b$var$IMAGE_HEIGHT}px`,
    objectFit: 'cover',
    userSelect: 'none'
});

});





parcelRegister("jWIWB", function(module, exports) {

$parcel$export(module.exports, "default", () => $5143fa7e102552a5$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $32MQk = parcelRequire("32MQk");
var $iv7UW = parcelRequire("iv7UW");

var $ivvtS = parcelRequire("ivvtS");

var $alPAX = parcelRequire("alPAX");

var $ousew = parcelRequire("ousew");

var $hzixm = parcelRequire("hzixm");

var $5qRwM = parcelRequire("5qRwM");
const $5143fa7e102552a5$var$ProvisioningProgressBar = ({ status: status })=>{
    if (status === 'completed') return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $iv7UW.default), {
        value: 1
    });
    if (status === 'in-progress') return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $iv7UW.default), {
        value: 0.8
    });
    if (status === 'error') return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $32MQk.default), {
        value: 1,
        appearance: "inverse"
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $iv7UW.default), {
        isIndeterminate: true
    });
};
const $5143fa7e102552a5$var$ActivationInProgressBackground = ({ status: status = 'not-started' })=>/*#__PURE__*/ (0, $2OMIu.jsxs)($alPAX.Wrapper, {
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5qRwM.default), {
                height: 144,
                width: 144,
                src: (0, (/*@__PURE__*/$parcel$interopDefault($ivvtS)))
            }),
            /*#__PURE__*/ (0, $2OMIu.jsxs)($alPAX.ContentWrapper, {
                children: [
                    /*#__PURE__*/ (0, $2OMIu.jsx)($5143fa7e102552a5$var$ProvisioningProgressBar, {
                        status: status
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                        tagName: "h3",
                        ...(0, $hzixm.default).provisioningBackgroundTitle
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                        tagName: "p",
                        ...(0, $hzixm.default).provisioningBackgroundText
                    })
                ]
            })
        ]
    });
var $5143fa7e102552a5$export$2e2bcd8739ae039 = $5143fa7e102552a5$var$ActivationInProgressBackground;

});
parcelRegister("32MQk", function(module, exports) {

$parcel$export(module.exports, "default", () => $baa3bacea9c957c9$export$2e2bcd8739ae039);
/* progress-bar.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");
const $baa3bacea9c957c9$var$MIN_VALUE = 0;
const $baa3bacea9c957c9$var$MAX_VALUE = 1;
const $baa3bacea9c957c9$var$increasingBarAnimation = null;
const $baa3bacea9c957c9$var$decreasingBarAnimation = null;
const $baa3bacea9c957c9$var$containerStyles = null;
const $baa3bacea9c957c9$var$containerAppearance = {
    default: "_bfhk1t45",
    success: "_bfhk1t45",
    inverse: "_bfhklgn7"
};
const $baa3bacea9c957c9$var$barAppearance = {
    default: "_bfhk1wby",
    success: "_bfhk1bh5",
    inverse: "_bfhkvuon"
};
const $baa3bacea9c957c9$var$barStyles = null;
const $baa3bacea9c957c9$var$determinateBarStyles = null;
const $baa3bacea9c957c9$var$increasingBarStyles = null;
const $baa3bacea9c957c9$var$decreasingBarStyles = null;
/**
 * __Progress bar__
 *
 * A progress bar displays the status of a given process.
 *
 * - [Examples](https://atlassian.design/components/progress-bar/examples)
 * - [Code](https://atlassian.design/components/progress-bar/code)
 * - [Usage](https://atlassian.design/components/progress-bar/usage)
 */ const $baa3bacea9c957c9$var$ProgressBar = ({ appearance: appearance = 'default', ariaLabel: ariaLabel, isIndeterminate: isIndeterminate = false, testId: testId = 'progress-bar', value: value = 0 })=>{
    const valueParsed = isIndeterminate ? $baa3bacea9c957c9$var$MIN_VALUE : Math.max($baa3bacea9c957c9$var$MIN_VALUE, Math.min(value, $baa3bacea9c957c9$var$MAX_VALUE));
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        role: "progressbar",
        "aria-label": ariaLabel,
        "aria-valuemin": $baa3bacea9c957c9$var$MIN_VALUE,
        "aria-valuenow": valueParsed,
        "aria-valuemax": $baa3bacea9c957c9$var$MAX_VALUE,
        "data-testid": testId,
        className: (0, $bwpsq.default)([
            "_2rko1sit _1reo15vq _18m915vq _1bsb1osq _4t3ii2wt _kqswh2mm _bfhk1t45",
            $baa3bacea9c957c9$var$containerAppearance[appearance]
        ]),
        children: isIndeterminate ? /*#__PURE__*/ (0, $2OMIu.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, {
            children: [
                /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
                    className: (0, $bwpsq.default)([
                        "_2rko1sit _1e0c1ule _4t3ii2wt _kqswstnw",
                        $baa3bacea9c957c9$var$barAppearance[appearance],
                        "_5sagymdr _tip812c5 _j7hq7g40"
                    ])
                }),
                /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
                    className: (0, $bwpsq.default)([
                        "_2rko1sit _1e0c1ule _4t3ii2wt _kqswstnw",
                        $baa3bacea9c957c9$var$barAppearance[appearance],
                        "_ju251bs3 _5sagymdr _tip812c5 _j7hqio0v"
                    ])
                })
            ]
        }) : /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
            style: {
                width: `${Number(value) * 100}%`
            },
            className: (0, $bwpsq.default)([
                "_2rko1sit _1e0c1ule _4t3ii2wt _kqswstnw",
                $baa3bacea9c957c9$var$barAppearance[appearance],
                "_v564calv"
            ])
        })
    });
};
var $baa3bacea9c957c9$export$2e2bcd8739ae039 = $baa3bacea9c957c9$var$ProgressBar;

});

parcelRegister("iv7UW", function(module, exports) {

$parcel$export(module.exports, "default", () => $7dbb37c218399ecb$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $32MQk = parcelRequire("32MQk");
/**
 * __Success progress bar__
 *
 * A success progress bar indicates the completion of a process.
 *
 * - [Examples](https://atlassian.design/components/progress-bar/success-progress-bar/examples)
 * - [Code](https://atlassian.design/components/progress-bar/success-progress-bar/code)
 */ const $7dbb37c218399ecb$var$SuccessProgressBar = ({ ariaLabel: ariaLabel, isIndeterminate: isIndeterminate = false, testId: testId, value: value = 0 })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $32MQk.default), {
        appearance: value < 1 || isIndeterminate ? 'default' : 'success',
        value: value,
        isIndeterminate: isIndeterminate,
        ariaLabel: ariaLabel,
        testId: testId
    });
};
var $7dbb37c218399ecb$export$2e2bcd8739ae039 = $7dbb37c218399ecb$var$SuccessProgressBar;

});

parcelRegister("ivvtS", function(module, exports) {
module.exports = new URL("cog-illustration.e5af7243.png", import.meta.url).toString();

});

parcelRegister("alPAX", function(module, exports) {

$parcel$export(module.exports, "Wrapper", () => $c2a7a3df976f2276$export$e6dfd72ab29f8598);
$parcel$export(module.exports, "ContentWrapper", () => $c2a7a3df976f2276$export$6ce170286acaa8d3);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $47bDC = parcelRequire("47bDC");
const $c2a7a3df976f2276$export$e6dfd72ab29f8598 = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "sc-15tbicu-0"
})({
    position: 'relative',
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: "var(--ds-space-400, 32px)",
    marginTop: "var(--ds-space-400, 32px)"
});
const $c2a7a3df976f2276$export$6ce170286acaa8d3 = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "sc-15tbicu-1"
})({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    marginTop: "var(--ds-space-300, 24px)"
});
const $c2a7a3df976f2276$export$d4467089dab4970d = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "sc-15tbicu-2"
})({
    width: '100%',
    margin: '0 auto'
});
const $c2a7a3df976f2276$export$a06f1c675e846f6f = /*#__PURE__*/ (0, $47bDC.default).footer.withConfig({
    componentId: "sc-15tbicu-3"
})({
    position: 'fixed',
    bottom: "var(--ds-space-400, 32px)",
    left: 0,
    right: 0,
    textAlign: 'center'
});

});

parcelRegister("hzixm", function(module, exports) {

$parcel$export(module.exports, "default", () => $d56fb6c0c29daee3$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
const $d56fb6c0c29daee3$var$messages = (0, $7VHMR.defineMessages)({
    provisioningBackgroundTitle: {
        id: 'confluence.project-pages.improvement.provisioning-background.title',
        defaultMessage: 'Setting up your Project Pages',
        description: 'Heading in provisioning in progress screen, informing users that Project Pages is currently being set up.'
    },
    provisioningBackgroundText: {
        id: 'confluence.project-pages.improvement.provisioning-background.text',
        defaultMessage: 'This should take less than a minute',
        description: 'Sentence informing users that provisioning will be done in no time'
    }
});
var $d56fb6c0c29daee3$export$2e2bcd8739ae039 = $d56fb6c0c29daee3$var$messages;

});




parcelRegister("41TjW", function(module, exports) {

$parcel$export(module.exports, "SET", () => $54bcb931c00bb1b1$export$5e8f180ef0142226);
$parcel$export(module.exports, "UPDATE_ONDEMAND_ACTIVATION_MODAL_STATE", () => $54bcb931c00bb1b1$export$afbcfbc1c3b0dcf4);
$parcel$export(module.exports, "updateOnDemandActivationModalState", () => $54bcb931c00bb1b1$export$1308542fa5d9be2d);
const $54bcb931c00bb1b1$export$5e8f180ef0142226 = 'ui.onDemandActivation.SET';
const $54bcb931c00bb1b1$export$adaa4cf7ef1b65be = (payload)=>({
        type: $54bcb931c00bb1b1$export$5e8f180ef0142226,
        payload: payload
    });
const $54bcb931c00bb1b1$export$afbcfbc1c3b0dcf4 = 'UPDATE_ONDEMAND_ACTIVATION_MODAL_STATE';
const $54bcb931c00bb1b1$export$1308542fa5d9be2d = ({ modalState: modalState })=>({
        type: $54bcb931c00bb1b1$export$afbcfbc1c3b0dcf4,
        payload: {
            modalState: modalState
        }
    });

});

parcelRegister("6y3t5", function(module, exports) {

$parcel$export(module.exports, "PLAN_ACTIVATION", () => $0477b4944d8a2e6b$export$693f82e6d15e2001);
$parcel$export(module.exports, "planConfluenceActivation", () => $0477b4944d8a2e6b$export$719a6d82e18d7952);
$parcel$export(module.exports, "START_ACTIVATION", () => $0477b4944d8a2e6b$export$df745e370b4d7554);
$parcel$export(module.exports, "startConfluenceActivation", () => $0477b4944d8a2e6b$export$5eb8bc3af0b02481);
$parcel$export(module.exports, "CHECK_ACTIVATION_STATUS", () => $0477b4944d8a2e6b$export$96d1ac5936a813d0);
$parcel$export(module.exports, "checkConfluenceActivationStatus", () => $0477b4944d8a2e6b$export$6b9af70858c06776);
$parcel$export(module.exports, "CHECK_ACTIVATION_STATUS_SUCCESS", () => $0477b4944d8a2e6b$export$5627e8b0363a4224);
$parcel$export(module.exports, "checkConfluenceActivationStatusSuccess", () => $0477b4944d8a2e6b$export$bd1e98dfc3279e5e);
$parcel$export(module.exports, "CHECK_ACTIVATION_STATUS_ERROR", () => $0477b4944d8a2e6b$export$974eca385726fba3);
$parcel$export(module.exports, "checkConfluenceActivationStatusFailed", () => $0477b4944d8a2e6b$export$c59b45e8667ba1b5);
$parcel$export(module.exports, "UPDATE_ACTIVATION_STATUS", () => $0477b4944d8a2e6b$export$10ad70d4ba1d6fd3);
$parcel$export(module.exports, "updateConfluenceActivationStatus", () => $0477b4944d8a2e6b$export$15e97fc2ce13e356);
$parcel$export(module.exports, "MARK_ACTIVATION_COMPLETED", () => $0477b4944d8a2e6b$export$6a79429e78cccf1c);
$parcel$export(module.exports, "markActivationCompleted", () => $0477b4944d8a2e6b$export$72135711c378954c);
$parcel$export(module.exports, "MARK_ACTIVATION_ERROR", () => $0477b4944d8a2e6b$export$6eb749a3d854f4cd);
$parcel$export(module.exports, "markActivationFailed", () => $0477b4944d8a2e6b$export$1a1fa78555603743);

var $gweiK = parcelRequire("gweiK");
function $0477b4944d8a2e6b$var$createAction(type, identifier) {
    const actionType = `ACTIVATE_CONFLUENCE_${type}_${identifier}`;
    const actionCreator = (0, $gweiK.genericActionCreator)(actionType);
    return [
        actionType,
        actionCreator
    ];
}
const [$0477b4944d8a2e6b$export$693f82e6d15e2001, $0477b4944d8a2e6b$export$719a6d82e18d7952] = $0477b4944d8a2e6b$var$createAction('PLAN', 'BASE');
const [$0477b4944d8a2e6b$export$df745e370b4d7554, $0477b4944d8a2e6b$export$5eb8bc3af0b02481] = $0477b4944d8a2e6b$var$createAction('START', 'BASE');
const [$0477b4944d8a2e6b$export$96d1ac5936a813d0, $0477b4944d8a2e6b$export$6b9af70858c06776] = $0477b4944d8a2e6b$var$createAction('CHECK_STATUS', 'BASE');
const [$0477b4944d8a2e6b$export$5627e8b0363a4224, $0477b4944d8a2e6b$export$bd1e98dfc3279e5e] = $0477b4944d8a2e6b$var$createAction('CHECK_STATUS', 'SUCCESS');
const [$0477b4944d8a2e6b$export$974eca385726fba3, $0477b4944d8a2e6b$export$c59b45e8667ba1b5] = $0477b4944d8a2e6b$var$createAction('CHECK_STATUS', 'ERROR');
const [$0477b4944d8a2e6b$export$10ad70d4ba1d6fd3, $0477b4944d8a2e6b$export$15e97fc2ce13e356] = $0477b4944d8a2e6b$var$createAction('UPDATE_STATUS', 'BASE');
const [$0477b4944d8a2e6b$export$6a79429e78cccf1c, $0477b4944d8a2e6b$export$72135711c378954c] = $0477b4944d8a2e6b$var$createAction('MARK_COMPLETED', 'BASE');
const [$0477b4944d8a2e6b$export$6eb749a3d854f4cd, $0477b4944d8a2e6b$export$1a1fa78555603743] = $0477b4944d8a2e6b$var$createAction('MARK_ERROR', 'BASE');

});
parcelRegister("gweiK", function(module, exports) {

$parcel$export(module.exports, "genericActionCreator", () => $e20d2c7c54e590bc$export$1c79bd8e318e0de0);
function $e20d2c7c54e590bc$export$1c79bd8e318e0de0(type) {
    return (payload)=>({
            type: type,
            payload: payload
        });
}

});



parcelRegister("5FGgp", function(module, exports) {

$parcel$export(module.exports, "useRouter", () => $93663e4e49d350f8$export$9a302a45f65d0572);
$parcel$export(module.exports, "RouteProvider", () => $93663e4e49d350f8$export$56484b1710c65ae5);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");


var $jBUUS = parcelRequire("jBUUS");
const $93663e4e49d350f8$export$9c38b177931e3e5c = {
    [(0, $0988c9725597fab5$export$beb27109f0387267)]: (0, $jBUUS.Routes).TemplatePreview,
    [(0, $0988c9725597fab5$export$22ad4d38ecffca72)]: (0, $jBUUS.Routes).ConfluenceActivating,
    [(0, $0988c9725597fab5$export$ed9dbaba8445f424)]: (0, $jBUUS.Routes).ConfluenceActivatingOnDemand,
    [(0, $0988c9725597fab5$export$e74e627186613bef)]: (0, $jBUUS.Routes).ConnectSpace,
    [(0, $0988c9725597fab5$export$65d0a606bcce00e6)]: (0, $jBUUS.Routes).ServerError,
    [(0, $0988c9725597fab5$export$52022723d6fe5666)]: (0, $jBUUS.Routes).ServerErrorAccess,
    [(0, $0988c9725597fab5$export$f603e10769c22ef6)]: (0, $jBUUS.Routes).SpaceOrPageNotFound,
    [(0, $0988c9725597fab5$export$396960dbbf8fe6e1)]: (0, $jBUUS.Routes).SpaceOrPageNotFound,
    [(0, $0988c9725597fab5$export$98cc058279f6e82f)]: (0, $jBUUS.Routes).SpaceOrPageNotFound,
    [(0, $0988c9725597fab5$export$2f82131be5023f37)]: (0, $jBUUS.Routes).ConfluenceTree,
    [(0, $0988c9725597fab5$export$5a0e72a8258542bd)]: (0, $jBUUS.Routes).ConfluenceTree,
    [(0, $0988c9725597fab5$export$bde25b564fc94248)]: (0, $jBUUS.Routes).ConfluenceTree
};
const $93663e4e49d350f8$var$RouteContext = /*#__PURE__*/ (0, $5uXOq.createContext)({
    navigate: ()=>void 0
});
const $93663e4e49d350f8$export$9a302a45f65d0572 = ()=>(0, $5uXOq.useContext)($93663e4e49d350f8$var$RouteContext);
const $93663e4e49d350f8$export$56484b1710c65ae5 = ({ children: children, confluenceLicenseStatus: confluenceLicenseStatus })=>{
    const [activeRoute, setActiveRoute] = (0, $5uXOq.useState)();
    (0, $5uXOq.useEffect)(()=>{
        setActiveRoute($93663e4e49d350f8$export$9c38b177931e3e5c[confluenceLicenseStatus]);
    }, [
        confluenceLicenseStatus
    ]);
    const navigate = (route)=>{
        setActiveRoute(route);
    };
    return /*#__PURE__*/ (0, $2OMIu.jsx)($93663e4e49d350f8$var$RouteContext.Provider, {
        value: {
            navigate: navigate,
            activeRoute: activeRoute
        },
        children: children
    });
};

});
parcelRegister("jBUUS", function(module, exports) {

$parcel$export(module.exports, "Routes", () => $c191f7800c98c848$export$3565eb3d00ca5a74);
var $c191f7800c98c848$export$3565eb3d00ca5a74 = /*#__PURE__*/ function(Routes) {
    Routes["TemplatePreview"] = "TEMPLATE_PREVIEW";
    Routes["ConfluenceActivating"] = "CONFLUENCE_ACTIVATING";
    Routes["ConfluenceActivatingOnDemand"] = "CONFLUENCE_ACTIVATING_ONDEMAND";
    Routes["ConnectSpace"] = "CONNECT_SPACE";
    Routes["ServerError"] = "SERVER_ERROR";
    Routes["ServerErrorAccess"] = "SERVER_ERROR_ACCESS";
    Routes["SpaceOrPageNotFound"] = "SPACE_OR_PAGE_NOT_FOUND";
    Routes["ConfluenceTree"] = "CONFLUENCE_TREE";
    return Routes;
}({});

});



parcelRegister("lWy1J", function(module, exports) {

$parcel$export(module.exports, "PageDecorators", () => $bebac3616d7150dc$export$2fdd42cedb1d9e1);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $2AwN4 = parcelRequire("2AwN4");

var $5FGgp = parcelRequire("5FGgp");

var $jBUUS = parcelRequire("jBUUS");
const $bebac3616d7150dc$export$2fdd42cedb1d9e1 = ({ hasConfluence: hasConfluence, containerRef: containerRef })=>{
    const { activeRoute: activeRoute } = (0, $5FGgp.useRouter)();
    if (activeRoute === (0, $jBUUS.Routes).ConfluenceActivatingOnDemand) return null;
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2AwN4.default), {
        hasConfluence: hasConfluence,
        containerRef: containerRef
    });
};

});
parcelRegister("2AwN4", function(module, exports) {

$parcel$export(module.exports, "default", () => $19d928d744ab7d60$export$2e2bcd8739ae039);

var $7Z8iG = parcelRequire("7Z8iG");

var $aPZf4 = parcelRequire("aPZf4");

var $9MB7L = parcelRequire("9MB7L");

var $9ucmj = parcelRequire("9ucmj");

var $cEp5g = parcelRequire("cEp5g");

var $2dj29 = parcelRequire("2dj29");

var $5KP7I = parcelRequire("5KP7I");

var $kSBKe = parcelRequire("kSBKe");

var $hlqmZ = parcelRequire("hlqmZ");

var $hFWlI = parcelRequire("hFWlI");

var $6L3iv = parcelRequire("6L3iv");
const $19d928d744ab7d60$var$mapStateToProps = (state, { hasConfluence: hasConfluence })=>({
        accessRequestCapability: (0, $kSBKe.getAccessRequestCapability)(state),
        areTemplatesEnabled: (0, $hlqmZ.areTemplatesEnabled)(state) && !((0, $9ucmj.isSpaceHomePageNull)(state) || (0, $9ucmj.isPageHomePageNull)(state)),
        blueprints: (0, $cEp5g.getBlueprints)(state),
        isProjectPagesSporkRebrandingEnabled: (0, $2dj29.getIsProjectPagesSporkRebrandingEnabled)(state),
        isConfluenceAutoProvisioned: (0, $hFWlI.isConfluenceAutoProvisioned)(state),
        confluenceLicenseStatus: (0, $9ucmj.getConfluenceLicenseStatus)(state),
        hasAccessToConfluence: (0, $9ucmj.getIsPostExpand)(state, hasConfluence),
        origin: (0, $9MB7L.getOrigin)(state),
        contentId: (0, $cEp5g.getProjectPageLinkedId)(state),
        spaceKey: (0, $cEp5g.getProjectSpaceKey)(state),
        projectId: (0, $6L3iv.getProjectId)(state),
        projectType: (0, $6L3iv.getProjectType)(state)
    });
const $19d928d744ab7d60$var$mapDispatchToProps = (dispatch)=>({
        showError: ()=>dispatch((0, $aPZf4.showError)())
    });
var $19d928d744ab7d60$export$2e2bcd8739ae039 = (0, $7Z8iG.connect)($19d928d744ab7d60$var$mapStateToProps, $19d928d744ab7d60$var$mapDispatchToProps)((0, $5KP7I.default));

});
parcelRegister("2dj29", function(module, exports) {

$parcel$export(module.exports, "getIsProjectPagesSporkRebrandingEnabled", () => $fa9752278a886479$export$ec2ec602bc0ecd73);
const $fa9752278a886479$export$ec2ec602bc0ecd73 = (state)=>state.featureFlags.isProjectPagesSporkRebrandingEnabled;

});

parcelRegister("5KP7I", function(module, exports) {

$parcel$export(module.exports, "default", () => $8482345ca6db8e37$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $8RXs9 = parcelRequire("8RXs9");

var $bCZYT = parcelRequire("bCZYT");

var $d3fdA = parcelRequire("d3fdA");

var $doHnV = parcelRequire("doHnV");

var $bzPTa = parcelRequire("bzPTa");

var $6k2gl = parcelRequire("6k2gl");

const $8482345ca6db8e37$export$f5a02fa7d7af52b8 = ({ accessRequestCapability: accessRequestCapability, areTemplatesEnabled: areTemplatesEnabled, blueprints: blueprints, contentId: contentId, containerRef: containerRef, isConfluenceAutoProvisioned: isConfluenceAutoProvisioned, intl: intl, hasAccessToConfluence: hasAccessToConfluence, origin: origin, confluenceLicenseStatus: confluenceLicenseStatus, showError: showError, spaceKey: spaceKey, projectId: projectId, projectType: projectType, isProjectPagesSporkRebrandingEnabled: isProjectPagesSporkRebrandingEnabled })=>{
    const { getTemplates: getTemplates, props: props, hoverPreviewProps: hoverPreviewProps } = (0, $bCZYT.useTemplatesPanelControls)({
        accessRequestCapability: accessRequestCapability,
        areTemplatesEnabled: areTemplatesEnabled,
        blueprints: blueprints,
        contentId: contentId,
        intl: intl,
        hasAccessToConfluence: hasAccessToConfluence,
        origin: origin,
        spaceKey: spaceKey,
        showError: showError,
        projectId: projectId,
        projectType: projectType
    });
    const templates = (0, $5uXOq.useMemo)(()=>getTemplates({
            intl: intl,
            isConfluenceAutoProvisioned: isConfluenceAutoProvisioned,
            isProjectPagesSporkRebrandingEnabled: isProjectPagesSporkRebrandingEnabled,
            confluenceLicenseStatus: confluenceLicenseStatus
        }), [
        intl,
        isConfluenceAutoProvisioned,
        isProjectPagesSporkRebrandingEnabled,
        confluenceLicenseStatus,
        getTemplates
    ]);
    (0, $6k2gl.usePreloadPreviews)(templates, hasAccessToConfluence);
    if (confluenceLicenseStatus === (0, $0988c9725597fab5$export$bde25b564fc94248)) return null;
    return hasAccessToConfluence ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $d3fdA.TemplatesPanelHoverPreview), {
        containerRef: containerRef,
        templates: templates,
        hoverPreviewProps: hoverPreviewProps,
        origin: origin,
        ...props
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $doHnV.default), {
        templates: templates,
        ...props,
        title: (0, $bzPTa.default).noConfluenceLicenseTitle,
        subtitle: (0, $bzPTa.default).noConfluenceLicenseSubTitle
    });
};
var $8482345ca6db8e37$export$2e2bcd8739ae039 = (0, $8RXs9.default)($8482345ca6db8e37$export$f5a02fa7d7af52b8);

});
parcelRegister("bCZYT", function(module, exports) {

$parcel$export(module.exports, "useTemplatesPanelControls", () => $86e312ca03641bd4$export$3a47ec68a82733fa);

var $hnRK8 = parcelRequire("hnRK8");

var $ljHpV = parcelRequire("ljHpV");

var $fQtAR = parcelRequire("fQtAR");
const $86e312ca03641bd4$export$3a47ec68a82733fa = ({ accessRequestCapability: accessRequestCapability, areTemplatesEnabled: areTemplatesEnabled, blueprints: blueprints, contentId: contentId, hasAccessToConfluence: hasAccessToConfluence, intl: intl, origin: origin, spaceKey: spaceKey, showError: showError, projectId: projectId, projectType: projectType })=>{
    const { props: hasLicenseProps, hoverPreviewProps: hoverPreviewProps } = (0, $ljHpV.useTemplatesPanelControlsWithLicense)({
        accessRequestCapability: accessRequestCapability,
        areTemplatesEnabled: areTemplatesEnabled,
        blueprints: blueprints,
        contentId: contentId,
        intl: intl,
        origin: origin,
        spaceKey: spaceKey,
        showError: showError,
        projectId: projectId,
        projectType: projectType
    });
    const { props: hasNoLicenseProps } = (0, $fQtAR.useTemplatesControlsWithoutLicense)({});
    const getTemplates = ({ isConfluenceAutoProvisioned: isConfluenceAutoProvisioned, isProjectPagesSporkRebrandingEnabled: isProjectPagesSporkRebrandingEnabled, confluenceLicenseStatus: confluenceLicenseStatus })=>hasAccessToConfluence ? (0, $hnRK8.getPostExpandTemplates)(spaceKey, areTemplatesEnabled, confluenceLicenseStatus, blueprints, intl, isConfluenceAutoProvisioned, isProjectPagesSporkRebrandingEnabled) : (0, $hnRK8.getPreExpandTemplates)(intl, isConfluenceAutoProvisioned, isProjectPagesSporkRebrandingEnabled);
    return {
        getTemplates: getTemplates,
        props: hasAccessToConfluence ? hasLicenseProps : hasNoLicenseProps,
        hoverPreviewProps: hasAccessToConfluence ? hoverPreviewProps : undefined
    };
};

});
parcelRegister("ljHpV", function(module, exports) {

$parcel$export(module.exports, "useTemplatesPanelControlsWithLicense", () => $2070111c661eb90e$export$35ee4df5a8ec1bd8);

var $5uXOq = parcelRequire("5uXOq");

var $l0cmm = parcelRequire("l0cmm");

var $8c8di = parcelRequire("8c8di");

var $dNpfo = parcelRequire("dNpfo");
const $2070111c661eb90e$var$HIDE_DELAY_MS = 250;
const $2070111c661eb90e$export$a787a847e7bc1b42 = (areTemplatesEnabled, accessRequestCapability)=>{
    if (areTemplatesEnabled) return areTemplatesEnabled;
    if (accessRequestCapability === (0, $8c8di.AccessRequestCapabilityType).DIRECT_ACCESS || accessRequestCapability === (0, $8c8di.AccessRequestCapabilityType).REQUEST_ACCESS) return false;
};
const $2070111c661eb90e$export$35ee4df5a8ec1bd8 = ({ accessRequestCapability: accessRequestCapability, areTemplatesEnabled: areTemplatesEnabled, blueprints: blueprints, contentId: contentId, intl: intl, origin: origin, spaceKey: spaceKey, showError: showError, projectId: projectId, projectType: projectType })=>{
    const createEmbeddedPage = (0, $dNpfo.useCreateEmbeddedPage)({
        spaceKey: spaceKey,
        projectId: projectId,
        projectType: projectType
    });
    const [activeTemplate, setActiveTemplate] = (0, $5uXOq.useState)(undefined);
    const hidePreviewTimer = (0, $5uXOq.useRef)(null);
    const cancelHidePreview = (0, $5uXOq.useCallback)(()=>{
        if (hidePreviewTimer.current) {
            clearTimeout(hidePreviewTimer.current);
            hidePreviewTimer.current = null;
        }
    }, []);
    const startHidePreview = (0, $5uXOq.useCallback)(()=>{
        if (hidePreviewTimer.current) return;
        hidePreviewTimer.current = window.setTimeout(()=>{
            hidePreviewTimer.current = null;
            setActiveTemplate(undefined);
        }, $2070111c661eb90e$var$HIDE_DELAY_MS);
    }, []);
    const showPreview = (0, $5uXOq.useCallback)((tmpl)=>{
        if (tmpl.type !== (0, $l0cmm.TemplateType).Confluence) {
            startHidePreview();
            return;
        }
        cancelHidePreview();
        setActiveTemplate(tmpl);
    }, [
        cancelHidePreview,
        startHidePreview
    ]);
    const onTemplateClick = (template)=>{
        if (accessRequestCapability === (0, $8c8di.AccessRequestCapabilityType).REQUEST_ACCESS || accessRequestCapability === (0, $8c8di.AccessRequestCapabilityType).DIRECT_ACCESS || !areTemplatesEnabled) return;
        if (template.type === (0, $l0cmm.TemplateType).Link) {
            window.open(origin ? origin.addToUrl(template.url) : template.url, '_blank');
            return;
        } else {
            // TemplateType here must be of type Confluence, in which case we bring up the template in an embedded page
            if (!template.blueprintModuleCompleteKey) {
                // create blank with or without prepopulated content
                createEmbeddedPage(contentId || undefined, true, undefined, intl && template.title && template.content ? {
                    title: intl.formatMessage(template.title),
                    body: template.content
                } : undefined, template.key);
                return;
            }
            const blueprint = blueprints.find((blueprint)=>blueprint.blueprintModuleCompleteKey === template.blueprintModuleCompleteKey);
            if (!blueprint) {
                // site probably has this template turned off, we need to show an error
                showError && showError();
                return;
            }
            createEmbeddedPage(contentId || undefined, true, blueprint);
        }
    };
    const sidebarEnabled = $2070111c661eb90e$export$a787a847e7bc1b42(areTemplatesEnabled, accessRequestCapability);
    // on unmount, clear any pending timers to prevent operations on unmounted components
    (0, $5uXOq.useEffect)(()=>()=>{
            if (hidePreviewTimer.current) clearTimeout(hidePreviewTimer.current);
        }, []);
    return {
        props: {
            onTemplateClick: onTemplateClick,
            onMouseLeave: startHidePreview,
            onTemplateMouseEnter: showPreview,
            isDisabled: !sidebarEnabled
        },
        hoverPreviewProps: {
            onMouseEnter: cancelHidePreview,
            onMouseLeave: startHidePreview,
            template: activeTemplate
        }
    };
};

});

parcelRegister("fQtAR", function(module, exports) {

$parcel$export(module.exports, "useTemplatesControlsWithoutLicense", () => $1a4ba94930922057$export$e76165d0765dc8a0);

var $l0cmm = parcelRequire("l0cmm");

var $6k2gl = parcelRequire("6k2gl");
const $1a4ba94930922057$export$e76165d0765dc8a0 = ({})=>{
    const { template: activeTemplate, setActiveTemplatePreview: setActiveTemplatePreview } = (0, $6k2gl.useTemplate)();
    const onTemplateClick = (template)=>{
        if (template.type === (0, $l0cmm.TemplateType).Link) window.open(template.url, '_blank');
        else setActiveTemplatePreview(template);
    };
    return {
        props: {
            activeTemplate: activeTemplate,
            onTemplateClick: onTemplateClick,
            isDisabled: false
        }
    };
};

});


parcelRegister("d3fdA", function(module, exports) {

$parcel$export(module.exports, "TemplatesPanelHoverPreview", () => $548af95f0d0a5efb$export$699c1c3678c2eea5);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $gkD4s = parcelRequire("gkD4s");
var $1V7PR = parcelRequire("1V7PR");

var $jXmHC = parcelRequire("jXmHC");

var $doHnV = parcelRequire("doHnV");

var $35aiK = parcelRequire("35aiK");
// If hover preview props are undefined, send noop functions for the mouse events
// so no unexpected errors are thrown
const $548af95f0d0a5efb$var$noopHoverProps = {
    onMouseEnter: (event)=>{},
    onMouseLeave: (event)=>{}
};
const $548af95f0d0a5efb$export$699c1c3678c2eea5 = ({ containerRef: containerRef, templates: templates, onTemplateClick: onTemplateClick, onTemplateMouseEnter: onTemplateMouseEnter, onMouseLeave: onMouseLeave, isDisabled: isDisabled, origin: origin, hoverPreviewProps: hoverPreviewProps = $548af95f0d0a5efb$var$noopHoverProps })=>/*#__PURE__*/ (0, $2OMIu.jsxs)((0, $gkD4s.Manager), {
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1V7PR.Reference), {
                children: ({ ref: ref })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $doHnV.default), {
                        hoverRef: ref,
                        onTemplateClick: onTemplateClick,
                        onTemplateMouseEnter: onTemplateMouseEnter,
                        onMouseLeave: onMouseLeave,
                        isDisabled: isDisabled,
                        origin: origin,
                        templates: templates,
                        title: (0, $35aiK.default).hasConfluenceLicenseTitle,
                        subtitle: (0, $35aiK.default).hasConfluenceLicenseSubTitle
                    })
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $jXmHC.default), {
                boundaryRef: containerRef,
                ...hoverPreviewProps
            })
        ]
    });

});
parcelRegister("jXmHC", function(module, exports) {

$parcel$export(module.exports, "default", () => $3a445d92b365739a$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $5qRwM = parcelRequire("5qRwM");

var $4oNEb = parcelRequire("4oNEb");

var $8RXs9 = parcelRequire("8RXs9");

var $l0cmm = parcelRequire("l0cmm");

var $fTftp = parcelRequire("fTftp");
const $3a445d92b365739a$var$HoverPreview = ({ template: template, boundaryRef: boundaryRef, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, intl: intl })=>{
    if (!template || template.type !== (0, $l0cmm.TemplateType).Confluence) return null;
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $4oNEb.Popper), {
        placement: "left",
        modifiers: [
            {
                name: 'offset',
                options: {
                    offset: [
                        0,
                        32
                    ]
                }
            },
            {
                name: 'preventOverflow',
                options: {
                    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview
                    padding: 16,
                    boundary: boundaryRef.current || undefined
                }
            }
        ],
        strategy: "absolute",
        children: ({ ref: ref, style: style })=>/*#__PURE__*/ (0, $2OMIu.jsxs)((0, $fTftp.HoverPreviewContainer), {
                innerRef: ref || undefined,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                style: style,
                onMouseEnter: onMouseEnter,
                onMouseLeave: onMouseLeave,
                children: [
                    /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $fTftp.TemplateInfo), {
                        children: [
                            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fTftp.Icon), {
                                children: template.iconRender({
                                    size: 'small',
                                    color: template.defaultIconColor
                                })
                            }),
                            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fTftp.TemplateName), {
                                children: intl.formatMessage(template.name)
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fTftp.Preview), {
                        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5qRwM.default), {
                            src: template.preview.postExpand.default,
                            srcDark: template.preview.postExpand.dark,
                            width: "100%",
                            alt: `${template.name} Confluence Template`
                        })
                    })
                ]
            })
    });
};
var $3a445d92b365739a$export$2e2bcd8739ae039 = (0, $8RXs9.default)($3a445d92b365739a$var$HoverPreview);

});
parcelRegister("fTftp", function(module, exports) {

$parcel$export(module.exports, "HoverPreviewContainer", () => $12215e255419f5f9$export$f8a404b45d23b116);
$parcel$export(module.exports, "TemplateInfo", () => $12215e255419f5f9$export$d606b414323c8d76);
$parcel$export(module.exports, "TemplateName", () => $12215e255419f5f9$export$5c554e59c1d4b9ae);
$parcel$export(module.exports, "Icon", () => $12215e255419f5f9$export$f04a61298a47a40f);
$parcel$export(module.exports, "Preview", () => $12215e255419f5f9$export$133773870222880f);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $47bDC = parcelRequire("47bDC");

var $k5uoT = parcelRequire("k5uoT");

// taken from https://stash.atlassian.com/projects/confcloud/repos/confluence-frontend/browse/next/packages/template-preview/src/PreviewFrame.tsx
const $12215e255419f5f9$var$PREVIEW_MIN_WIDTH = 480;
const $12215e255419f5f9$var$TEMPLATE_PANEL_WIDTH = 320;
const $12215e255419f5f9$var$DISTANCE_FROM_ITEM = 32;
const $12215e255419f5f9$export$f8a404b45d23b116 = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "suk59g-0"
})({
    display: 'flex',
    flexDirection: 'column',
    zIndex: (0, $k5uoT.layers).tooltip(),
    background: "var(--ds-surface, white)",
    border: `1px solid ${`var(--ds-border, ${(0, $829f609a65d26a98$export$9fdfb749e33cdf97)})`}`,
    borderRadius: '3px',
    boxShadow: "var(--ds-shadow-overlay, 0px 0px 1px rgba(9, 30, 66, 0.31), 0px 3px 5px rgba(9, 30, 66, 0.2))",
    width: '40vw',
    maxWidth: '600px',
    minWidth: `${$12215e255419f5f9$var$PREVIEW_MIN_WIDTH}px`,
    maxHeight: '85%',
    backgroundColor: "var(--ds-surface, #FFFFFF)",
    // do not show preview on very narrow devices
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [`@media screen and (max-width: ${$12215e255419f5f9$var$TEMPLATE_PANEL_WIDTH + $12215e255419f5f9$var$DISTANCE_FROM_ITEM + $12215e255419f5f9$var$PREVIEW_MIN_WIDTH}px)`]: {
        display: 'none'
    }
});
const $12215e255419f5f9$export$d606b414323c8d76 = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "suk59g-1"
})({
    height: '53px',
    padding: `14px ${"var(--ds-space-300, 24px)"}`,
    boxSizing: 'border-box',
    display: 'flex',
    alignItems: 'center',
    borderBottom: `1px solid ${`var(--ds-border, ${(0, $829f609a65d26a98$export$1ce2d1575d444ceb)})`}`
});
const $12215e255419f5f9$export$5c554e59c1d4b9ae = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "suk59g-2"
})`font:${"var(--ds-font-heading-small, normal 600 16px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"};margin:0 0 0 ${"var(--ds-space-100, 8px)"};overflow:hidden;text-overflow:ellipsis;white-space:nowrap;`;
const $12215e255419f5f9$export$f04a61298a47a40f = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "suk59g-3"
})({
    alignSelf: 'center'
});
const $12215e255419f5f9$export$133773870222880f = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "suk59g-4"
})({
    overflowY: 'auto'
});

});


parcelRegister("doHnV", function(module, exports) {

$parcel$export(module.exports, "default", () => $5ddeb91675b2018b$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $8RXs9 = parcelRequire("8RXs9");

var $lfOFX = parcelRequire("lfOFX");

var $b0eNB = parcelRequire("b0eNB");

var $escMm = parcelRequire("escMm");
const $5ddeb91675b2018b$var$TemplatesSidebar = ({ intl: intl, templates: templates, onTemplateClick: onTemplateClick, onTemplateMouseEnter: onTemplateMouseEnter, onMouseLeave: onMouseLeave, hoverRef: hoverRef, isDisabled: isDisabled, activeTemplate: activeTemplate, origin: origin, title: title, subtitle: subtitle })=>{
    const theme = (0, $escMm.useThemeContext)();
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $b0eNB.SidebarWrapper), {
        "data-test-id": "confluence-project-pages.template-sidebar",
        theme: theme,
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $b0eNB.HeaderContainer), {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                className: isDisabled ? 'is-disabled' : '',
                "data-testid": "confluence-project-pages.template-sidebar-header",
                children: [
                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $b0eNB.Title), {
                        children: intl.formatMessage(title)
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $b0eNB.Subtitle), {
                        children: intl.formatMessage(subtitle)
                    })
                ]
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $lfOFX.default), {
                templates: templates,
                activeTemplate: activeTemplate,
                onTemplateClick: onTemplateClick,
                onTemplateMouseEnter: onTemplateMouseEnter,
                onMouseLeave: onMouseLeave,
                hoverRef: hoverRef,
                isDisabled: isDisabled,
                origin: origin
            })
        ]
    });
};
var $5ddeb91675b2018b$export$2e2bcd8739ae039 = (0, $8RXs9.default)($5ddeb91675b2018b$var$TemplatesSidebar);

});
parcelRegister("lfOFX", function(module, exports) {

$parcel$export(module.exports, "default", () => $91f5aa7589c0d6ac$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $47bDC = parcelRequire("47bDC");

var $l0cmm = parcelRequire("l0cmm");

var $2UkTd = parcelRequire("2UkTd");

var $h8yj2 = parcelRequire("h8yj2");
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $91f5aa7589c0d6ac$var$Wrapper = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "sc-1n2t7hx-0"
})({
    marginTop: "var(--ds-space-200, 16px)"
});
const $91f5aa7589c0d6ac$var$TemplateList = ({ onTemplateClick: onTemplateClick, onTemplateMouseEnter: onTemplateMouseEnter, onMouseLeave: onMouseLeave, hoverRef: hoverRef, templates: templates, activeTemplate: activeTemplate, isDisabled: isDisabled, origin: origin })=>{
    const [hoveredTemplate, setHoveredTemplate] = (0, $5uXOq.useState)(null);
    const handleClick = (template)=>(_, analyticsEvent)=>{
            const originAttributes = origin?.toAnalyticsAttributes({
                hasGeneratedId: true
            });
            if (analyticsEvent) (0, $h8yj2.fireUIAnalytics)(analyticsEvent, `${template.key}TemplateButton`, originAttributes ?? {});
            onTemplateClick && onTemplateClick(template);
        };
    const handleMouseEnter = (template)=>()=>{
            onTemplateMouseEnter && onTemplateMouseEnter(template);
            setHoveredTemplate(template);
        };
    return /*#__PURE__*/ (0, $2OMIu.jsx)($91f5aa7589c0d6ac$var$Wrapper, {
        onMouseLeave: onMouseLeave,
        children: templates.map((tmpl)=>/*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                ref: hoveredTemplate && hoveredTemplate.type === (0, $l0cmm.TemplateType).Confluence && hoveredTemplate.key === tmpl.key ? hoverRef : undefined,
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2UkTd.default), {
                    name: tmpl.name,
                    description: tmpl.description,
                    icon: tmpl.iconRender({
                        size: 'medium',
                        color: tmpl.defaultIconColor
                    }),
                    onClick: handleClick(tmpl),
                    onMouseEnter: handleMouseEnter(tmpl),
                    tooltip: tmpl.tooltip,
                    isDisabled: isDisabled,
                    isActive: tmpl.key === activeTemplate?.key,
                    renderShortcutIcon: tmpl.type === (0, $l0cmm.TemplateType).Link && tmpl.renderShortcutIcon,
                    templateKey: tmpl.key
                })
            }, tmpl.key))
    });
};
var $91f5aa7589c0d6ac$export$2e2bcd8739ae039 = $91f5aa7589c0d6ac$var$TemplateList;

});
parcelRegister("2UkTd", function(module, exports) {

$parcel$export(module.exports, "default", () => $6ac06b772b74cd86$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $7sUFC = parcelRequire("7sUFC");

var $8RXs9 = parcelRequire("8RXs9");

var $KIQgW = parcelRequire("KIQgW");

var $3bDjY = parcelRequire("3bDjY");

var $ggICg = parcelRequire("ggICg");

var $gMHWX = parcelRequire("gMHWX");
const $6ac06b772b74cd86$var$TemplateCard = ({ name: name, description: description, icon: icon, intl: intl, onClick: onClick, onMouseEnter: onMouseEnter, tooltip: tooltip, isDisabled: isDisabled, isActive: isActive, renderShortcutIcon: renderShortcutIcon, templateKey: templateKey })=>{
    const primaryText = /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $KIQgW.PrimaryTextWrapper), {
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $KIQgW.Title), {
                children: intl.formatMessage(name)
            }),
            renderShortcutIcon && /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ggICg))), {
                color: "currentColor",
                label: "open in tab"
            })
        ]
    });
    const card = /*#__PURE__*/ (0, $2OMIu.jsx)((0, $KIQgW.CardWrapper), {
        onMouseEnter: isDisabled ? undefined : onMouseEnter,
        isActive: isActive,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: isDisabled ? 'is-disabled' : '',
        hasTooltip: !!tooltip,
        "data-testid": `confluence-project-pages.template-sidebar-card.${templateKey}`,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7sUFC.default), {
            avatar: icon,
            primaryText: primaryText,
            secondaryText: description ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $KIQgW.Description), {
                children: intl.formatMessage(description)
            }) : undefined,
            onClick: onClick,
            testId: "confluence-project-pages.templates-sidebar.template-card"
        })
    });
    if (tooltip) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3bDjY.default), {
        content: intl.formatMessage(tooltip),
        children: card
    });
    else return card;
};
var $6ac06b772b74cd86$export$2e2bcd8739ae039 = (0, $gMHWX.AnalyticsEventToProps)('templateButton', {
    onClick: 'clicked'
})((0, $8RXs9.default)($6ac06b772b74cd86$var$TemplateCard));

});
parcelRegister("7sUFC", function(module, exports) {

$parcel$export(module.exports, "default", () => $0fee6a3655f9d2d5$export$2e2bcd8739ae039);
/* avatar-item.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $VSDnB = parcelRequire("VSDnB");

var $dS3PR = parcelRequire("dS3PR");

var $kyyq3 = parcelRequire("kyyq3");
const $0fee6a3655f9d2d5$var$bgColorCssVar = '--avatar-item-bg-color';
const $0fee6a3655f9d2d5$var$styles = {
    root: "_2rko1l7b _12ji1r31 _1qu2glyw _12y31o36 _4bfu18uv _1hmsglyw _ajmmnqa1 _1h6d3acm _1dqonqa1 _189e1bk5 _1e0c1txw _vchhusvi _1bsb1osq _4cvr1h6o _bfhk1g13 _syaz1kw7 _1wyb1kw7 _zg8l4jg8 _k48pi7a9 _vwz4kb7n _6rthze3t _1pfhze3t _12l2ze3t _ahbqze3t _85i51b66 _1q511b66 _y4ti1b66 _bozg1b66 _y3gn1e5h",
    rootDisabled: "_80om13gf _tzy41e4z _lcxvglyw",
    rootInteractive: "_nt751r31 _49pcglyw _1hvw1o36 _858u194a _9oik18uv _1bnxglyw _jf4cnqa1 _irr314ae _d0altlke _1di61l7b",
    avatarItem: "_16jlkb7n _1o9zkb7n _i0dl1osq _1ul9idpf _p12f1osq _vwz419ii _bozgu2gc",
    baseText: "_1e0c1ule _syaz1fxt",
    truncation: "_1reo15vq _1bto1l2s _o5721q9c",
    secondaryTextLegacy: "_syaz131l _1wyb181o"
};
/**
 * __Avatar item__
 *
 * An avatar item is a wrapper that goes around an avatar when it's displayed alongside text, such as a name or status.
 *
 * - [Examples](https://atlassian.design/components/avatar/avatar-item/examples)
 * - [Code](https://atlassian.design/components/avatar/avatar-item/code)
 */ const $0fee6a3655f9d2d5$var$AvatarItem = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ avatar: avatar, backgroundColor: backgroundColor = 'transparent', isTruncationDisabled: isTruncationDisabled, href: href, isDisabled: isDisabled, onClick: onClick, primaryText: primaryText, secondaryText: secondaryText, target: target, testId: testId, label: label }, ref)=>{
    const Container = (0, $kyyq3.getCustomElement)(isDisabled, href, onClick);
    const isInteractive = Boolean(onClick || href);
    return /*#__PURE__*/ (0, $2OMIu.jsxs)(Container, {
        style: {
            [$0fee6a3655f9d2d5$var$bgColorCssVar]: backgroundColor
        },
        ref: ref,
        "aria-label": isInteractive ? label : undefined,
        onClick: onClick,
        disabled: isDisabled,
        "data-testid": testId ? `${testId}--itemInner` : undefined,
        type: Container === 'button' ? 'button' : undefined,
        ...href && {
            href: href,
            target: target,
            rel: target === '_blank' ? 'noopener noreferrer' : undefined
        },
        className: (0, $bwpsq.default)([
            $0fee6a3655f9d2d5$var$styles.root,
            isInteractive && $0fee6a3655f9d2d5$var$styles.rootInteractive,
            isDisabled && $0fee6a3655f9d2d5$var$styles.rootDisabled
        ]),
        children: [
            avatar,
            /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                className: (0, $bwpsq.default)([
                    $0fee6a3655f9d2d5$var$styles.avatarItem
                ]),
                children: (0, $VSDnB.fg)('platform.design-system-team.avatar-item-font-size_830x6') ? /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $5uXOq.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dS3PR.default), {
                            maxLines: isTruncationDisabled ? undefined : 1,
                            children: primaryText
                        }),
                        /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dS3PR.default), {
                            color: "color.text.subtlest",
                            maxLines: isTruncationDisabled ? undefined : 1,
                            size: "UNSAFE_small",
                            children: secondaryText
                        })
                    ]
                }) : /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $5uXOq.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
                            className: (0, $bwpsq.default)([
                                $0fee6a3655f9d2d5$var$styles.baseText,
                                !isTruncationDisabled && $0fee6a3655f9d2d5$var$styles.truncation
                            ]),
                            children: primaryText
                        }),
                        /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
                            className: (0, $bwpsq.default)([
                                $0fee6a3655f9d2d5$var$styles.baseText,
                                $0fee6a3655f9d2d5$var$styles.secondaryTextLegacy,
                                !isTruncationDisabled && $0fee6a3655f9d2d5$var$styles.truncation
                            ]),
                            children: secondaryText
                        })
                    ]
                })
            })
        ]
    });
});
$0fee6a3655f9d2d5$var$AvatarItem.displayName = 'AvatarItem';
var $0fee6a3655f9d2d5$export$2e2bcd8739ae039 = $0fee6a3655f9d2d5$var$AvatarItem;

});

parcelRegister("KIQgW", function(module, exports) {

$parcel$export(module.exports, "Title", () => $804d21bf6c57c0e0$export$f99233281efd08a0);
$parcel$export(module.exports, "PrimaryTextWrapper", () => $804d21bf6c57c0e0$export$3174221b6a744abb);
$parcel$export(module.exports, "Description", () => $804d21bf6c57c0e0$export$393edc798c47379d);
$parcel$export(module.exports, "CardWrapper", () => $804d21bf6c57c0e0$export$6aa22a823032b784);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $47bDC = parcelRequire("47bDC");

const $804d21bf6c57c0e0$export$f99233281efd08a0 = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "sc-11b8yaf-0"
})({
    marginTop: "var(--ds-space-negative-050, -4px)",
    display: '-webkit-box',
    WebkitLineClamp: 2,
    WebkitBoxOrient: 'vertical'
});
const $804d21bf6c57c0e0$export$3174221b6a744abb = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "sc-11b8yaf-1"
})({
    display: 'flex',
    alignItems: 'center',
    gap: "var(--ds-space-050, 4px)"
});
const $804d21bf6c57c0e0$export$393edc798c47379d = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "sc-11b8yaf-2"
})({
    marginTop: "var(--ds-space-050, 4px)",
    display: '-webkit-box',
    WebkitLineClamp: 4,
    WebkitBoxOrient: 'vertical',
    whiteSpace: 'normal'
});
const $804d21bf6c57c0e0$export$6aa22a823032b784 = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "sc-11b8yaf-3"
})((props)=>({
        position: 'relative',
        marginBottom: "var(--ds-space-100, 8px)",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '& > button': {
            padding: "var(--ds-space-150, 12px)",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            backgroundColor: props.isActive ? `var(--ds-background-selected, ${0, $829f609a65d26a98$export$226de0355ed012f8})` : 'initial',
            '&:focus': {
                boxShadow: 'none' /* legacy batch.css in JFE ends up adding additional box shadow around this, which we don't want */ 
            }
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '&.is-disabled': {
            color: "var(--ds-text-disabled, #091E42)",
            opacity: "var(--ds-opacity-disabled, 0.5)",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            cursor: props.hasTooltip ? 'pointer' : 'auto',
            pointerEvents: 'none'
        }
    }));

});



parcelRegister("b0eNB", function(module, exports) {

$parcel$export(module.exports, "SidebarWrapper", () => $e9c804d635b90035$export$d9b764b921677bb1);
$parcel$export(module.exports, "Title", () => $e9c804d635b90035$export$f99233281efd08a0);
$parcel$export(module.exports, "Subtitle", () => $e9c804d635b90035$export$cf345ef34cd72655);
$parcel$export(module.exports, "HeaderContainer", () => $e9c804d635b90035$export$1e86fd0e1db89578);
/* eslint-disable @atlaskit/platform/no-module-level-eval, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values  */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $47bDC = parcelRequire("47bDC");


var $VSDnB = parcelRequire("VSDnB");
const $e9c804d635b90035$export$d9b764b921677bb1 = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "sc-1tnkdm-0"
})({
    minWidth: (0, $VSDnB.fg)('project-pages-zoom-accessibility') ? '10%' : '320px',
    maxWidth: (0, $VSDnB.fg)('project-pages-zoom-accessibility') ? '35%' : 'none',
    width: '320px',
    position: 'relative',
    overflowY: 'auto',
    zIndex: 10
}, // eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
({ theme: theme })=>theme?.overrideStyles?.sidebarWrapper ? `background-color: ${theme.overrideStyles.sidebarWrapper.backgroundColor};
  border: ${theme.overrideStyles.sidebarWrapper.border};
  border-radius: ${theme.overrideStyles.sidebarWrapper.borderRadius};
  box-shadow: ${theme.overrideStyles.sidebarWrapper.boxShadow};
  height: ${theme.overrideStyles.sidebarWrapper.height};
  margin: ${theme.overrideStyles.sidebarWrapper.margin};
  padding: ${theme.overrideStyles.sidebarWrapper.padding};` : `height: 100%;
  padding: 0 0 0 ${"var(--ds-space-200, 16px)"};
  ${''}
  border-left: 1px solid ${`var(--ds-border, ${(0, $829f609a65d26a98$exports).N30})`};
  background-color: ${"var(--ds-surface, #fff)"};`);
const $e9c804d635b90035$export$f99233281efd08a0 = /*#__PURE__*/ (0, $47bDC.default).h2.withConfig({
    componentId: "sc-1tnkdm-1"
})`font:${"var(--ds-font-heading-small, normal 600 16px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"};margin:0;padding-top:${"var(--ds-space-300, 24px)"};padding-left:${"var(--ds-space-200, 16px)"};color:${"var(--ds-text, #172B4D)"};`;
const $e9c804d635b90035$export$cf345ef34cd72655 = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "sc-1tnkdm-2"
})`font:${"var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"};font-weight:${"var(--ds-font-weight-bold, 700)"};margin-top:${"var(--ds-space-050, 4px)"};margin-left:${"var(--ds-space-200, 16px)"};color:${`var(--ds-text-subtle, ${(0, $829f609a65d26a98$exports).N60})`};text-transform:uppercase;`;
const $e9c804d635b90035$export$1e86fd0e1db89578 = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "sc-1tnkdm-3"
})({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.is-disabled': {
        color: "var(--ds-text-disabled, #091E42)",
        opacity: "var(--ds-opacity-disabled, 0.5)"
    }
});

});


parcelRegister("35aiK", function(module, exports) {

$parcel$export(module.exports, "default", () => $a1fa6ed7b4dfd660$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $a1fa6ed7b4dfd660$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    hasConfluenceLicenseTitle: {
        id: 'project-pages.improvement.templates.post-expand.title',
        defaultMessage: 'Create a page',
        description: 'Title for list of page templates'
    },
    hasConfluenceLicenseSubTitle: {
        id: 'project-pages.improvement.templates.post-expand.subtitle',
        defaultMessage: 'Popular templates',
        description: 'Information for list of page templates'
    }
});

});


parcelRegister("bzPTa", function(module, exports) {

$parcel$export(module.exports, "default", () => $67e3d636810e247a$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $67e3d636810e247a$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    noConfluenceLicenseTitle: {
        id: 'project-pages.improvement.templates.pre-expand.title',
        defaultMessage: 'Preview templates',
        description: 'Title for list of page templates'
    },
    noConfluenceLicenseSubTitle: {
        id: 'project-pages.improvement.templates.pre-expand.subtitle',
        defaultMessage: 'Popular with teams like yours',
        description: 'Information for list of page templates'
    }
});

});




parcelRegister("calNI", function(module, exports) {

$parcel$export(module.exports, "default", () => $2d2d6f68083883e6$export$2e2bcd8739ae039);

var $7Z8iG = parcelRequire("7Z8iG");

var $4iqmv = parcelRequire("4iqmv");

var $aPZf4 = parcelRequire("aPZf4");

var $3aZkJ = parcelRequire("3aZkJ");

var $jhbRM = parcelRequire("jhbRM");

var $6y3t5 = parcelRequire("6y3t5");
const $2d2d6f68083883e6$var$mapStateToProps = (state)=>({
        activationMethod: (0, $jhbRM.getActivationMethod)(state)
    });
const $2d2d6f68083883e6$var$mapDispatchToProps = (dispatch)=>({
        onOpenCrossFlowError: ()=>dispatch((0, $aPZf4.showXflowDialogError)()),
        onSuccessfulCrossFlowExpansion: ()=>{
            dispatch((0, $aPZf4.checkProductsLicenceState)());
            dispatch((0, $4iqmv.fetchPersonalizationSiteTraits)());
        },
        triggerOnDemandActivation: ()=>{
            dispatch((0, $6y3t5.startConfluenceActivation)());
        }
    });
var $2d2d6f68083883e6$export$2e2bcd8739ae039 = (0, $7Z8iG.connect)($2d2d6f68083883e6$var$mapStateToProps, $2d2d6f68083883e6$var$mapDispatchToProps)((0, $3aZkJ.default));

});
parcelRegister("4iqmv", function(module, exports) {

$parcel$export(module.exports, "FETCH_PERSONALIZATION_SITE_TRAITS", () => $5457021042efa652$export$19dc55439c44d6e5);
$parcel$export(module.exports, "fetchPersonalizationSiteTraits", () => $5457021042efa652$export$f3f6bb53f650126e);
$parcel$export(module.exports, "fetchPersonalizationSiteTraitsFailed", () => $5457021042efa652$export$789016de78154b40);
$parcel$export(module.exports, "UPDATE_PERSONALIZATION_SITE_TRAITS", () => $5457021042efa652$export$b031700ffe873b04);
$parcel$export(module.exports, "updatePersonalizationSiteTraits", () => $5457021042efa652$export$ba79c9388a936022);
const $5457021042efa652$export$19dc55439c44d6e5 = 'FETCH_PERSONALIZATION_SITE_TRAITS';
const $5457021042efa652$export$f3f6bb53f650126e = ()=>({
        type: $5457021042efa652$export$19dc55439c44d6e5
    });
const $5457021042efa652$export$6aae235fee267e07 = 'FETCH_PERSONALIZATION_SITE_TRAITS_FAILED';
const $5457021042efa652$export$789016de78154b40 = ()=>({
        type: $5457021042efa652$export$6aae235fee267e07
    });
const $5457021042efa652$export$b031700ffe873b04 = 'UPDATE_PERSONALIZATION_SITE_TRAITS';
const $5457021042efa652$export$ba79c9388a936022 = (traits)=>({
        type: $5457021042efa652$export$b031700ffe873b04,
        traits: traits
    });

});


parcelRegister("2mZpt", function(module, exports) {

$parcel$export(module.exports, "CompactHeader", () => $7d3b0acaeec3bec3$export$1b93308da7cb4060);
/**
 * Alternative header component that doesn't render breadcrumbs or a heading
 * It also renders the DraftsToggle next to the MoreMenu
 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $lXzrh = parcelRequire("lXzrh");
var $NoEQs = parcelRequire("NoEQs");
var $3WIK2 = parcelRequire("3WIK2");

var $f5TWP = parcelRequire("f5TWP");
var $8CUq3 = parcelRequire("8CUq3");

var $8rAPH = parcelRequire("8rAPH");

var $5FGgp = parcelRequire("5FGgp");

var $jBUUS = parcelRequire("jBUUS");

var $escMm = parcelRequire("escMm");

var $5WLkL = parcelRequire("5WLkL");
const $7d3b0acaeec3bec3$export$1b93308da7cb4060 = ({ shouldShowMeatballMenu: shouldShowMeatballMenu, MoreMenu: MoreMenu })=>{
    const { activeRoute: activeRoute } = (0, $5FGgp.useRouter)();
    const { locale: locale } = (0, $8rAPH.useProjectPages)();
    const { treeState: treeState } = (0, $3WIK2.useConfluencePageTree)();
    const theme = (0, $escMm.useThemeContext)();
    const isTreeLoaded = treeState && treeState !== (0, $NoEQs.TreeStates).Loading;
    // only show the drafts toggle if the PageTree would be loaded (see ActivePage component)
    const shouldShowDraftsToggle = isTreeLoaded && (!activeRoute || ![
        (0, $jBUUS.Routes).TemplatePreview,
        (0, $jBUUS.Routes).ConfluenceActivating,
        (0, $jBUUS.Routes).ConfluenceActivatingOnDemand,
        (0, $jBUUS.Routes).ConnectSpace,
        (0, $jBUUS.Routes).ServerError,
        (0, $jBUUS.Routes).ServerErrorAccess,
        (0, $jBUUS.Routes).SpaceOrPageNotFound
    ].includes(activeRoute));
    return /*#__PURE__*/ (0, $2OMIu.jsx)($5WLkL.PageHeaderStyleWrapper, {
        theme: theme,
        isCompactHeader: true,
        children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $f5TWP.default), {
            alignInline: "end",
            space: "space.100",
            xcss: $7d3b0acaeec3bec3$var$compactHeaderStyles,
            children: [
                shouldShowMeatballMenu && /*#__PURE__*/ (0, $2OMIu.jsx)(MoreMenu, {}),
                shouldShowDraftsToggle && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $lXzrh.default), {
                    locale: locale
                })
            ]
        })
    });
};
const $7d3b0acaeec3bec3$var$compactHeaderStyles = (0, $8CUq3.xcss)({
    marginTop: 'space.200',
    marginBottom: 'space.200'
});

});



parcelRegister("aIyBL", function(module, exports) {

$parcel$export(module.exports, "initialProjectState", () => $5d414cc9c559112b$export$e98b04a545b093d7);
$parcel$export(module.exports, "default", () => $5d414cc9c559112b$export$2e2bcd8739ae039);

var $7G07p = parcelRequire("7G07p");

var $2Vlv3 = parcelRequire("2Vlv3");
const $5d414cc9c559112b$export$e98b04a545b093d7 = {
    key: '',
    id: -1,
    type: '',
    name: ''
};
var $5d414cc9c559112b$export$2e2bcd8739ae039 = (state = $5d414cc9c559112b$export$e98b04a545b093d7, action)=>{
    switch(action.type){
        case 0, $2Vlv3.SET:
            return (0, $7G07p.freeze)(action.payload);
        case 0, $2Vlv3.SET_IS_MEMBER:
            return (0, $7G07p.merge)(state, {
                isMember: action.isMember
            });
        default:
            return state;
    }
};

});
parcelRegister("2Vlv3", function(module, exports) {

$parcel$export(module.exports, "SET", () => $4546d7f6b2445b76$export$5e8f180ef0142226);
$parcel$export(module.exports, "set", () => $4546d7f6b2445b76$export$adaa4cf7ef1b65be);
$parcel$export(module.exports, "SET_IS_MEMBER", () => $4546d7f6b2445b76$export$681057d0004eb9a8);
$parcel$export(module.exports, "setIsMember", () => $4546d7f6b2445b76$export$94760d89229d957);
const $4546d7f6b2445b76$export$5e8f180ef0142226 = 'project.SET';
const $4546d7f6b2445b76$export$adaa4cf7ef1b65be = (payload)=>({
        type: $4546d7f6b2445b76$export$5e8f180ef0142226,
        payload: payload
    });
const $4546d7f6b2445b76$export$681057d0004eb9a8 = 'project.SET_IS_MEMBER';
const $4546d7f6b2445b76$export$94760d89229d957 = (isMember)=>({
        type: $4546d7f6b2445b76$export$681057d0004eb9a8,
        isMember: isMember
    });

});


parcelRegister("bDvnP", function(module, exports) {

$parcel$export(module.exports, "initialContextState", () => $c999fcd24bce308b$export$ce2ca3f2bd913448);
$parcel$export(module.exports, "default", () => $c999fcd24bce308b$export$2e2bcd8739ae039);

var $7G07p = parcelRequire("7G07p");


var $aPZf4 = parcelRequire("aPZf4");

var $dam7O = parcelRequire("dam7O");

var $fTJXm = parcelRequire("fTJXm");

var $g5yS7 = parcelRequire("g5yS7");

const $c999fcd24bce308b$export$ce2ca3f2bd913448 = (0, $7G07p.freeze)({
    baseUrl: '',
    isAdmin: false,
    isSiteAdmin: false,
    locale: (0, $7efad8a17c767c3a$export$d7f512c98c859244),
    cloudId: '',
    accountId: '',
    confluenceState: (0, $fTJXm.CONFLUENCE_LOADING),
    suggestedKey: null,
    origin: null,
    environment: 'dev',
    licenseInformation: undefined,
    parentProduct: (0, $d29b7f051950917c$export$ae07618062047a87)
});
var $c999fcd24bce308b$export$2e2bcd8739ae039 = (state = $c999fcd24bce308b$export$ce2ca3f2bd913448, action)=>{
    switch(action.type){
        case 0, $dam7O.SET:
            return (0, $7G07p.freeze)(action.payload);
        case 0, $aPZf4.NO_VALID_KEY:
            return (0, $7G07p.merge)(state, {
                suggestedKey: null
            });
        case 0, $aPZf4.NO_VALID_KEY_FAILURE:
            return (0, $7G07p.merge)(state, {
                suggestedKey: null
            });
        case 0, $aPZf4.UPDATE_CONFLUENCE_STATE:
            return (0, $7G07p.merge)(state, {
                confluenceState: action.payload
            });
        case 0, $g5yS7.UPDATE_LICENSE_INFORMATION:
            return (0, $7G07p.merge)(state, {
                licenseInformation: action.payload
            });
        case 0, $aPZf4.UPDATE_CONFLUENCE_EDITION:
            return (0, $7G07p.merge)(state, {
                confluenceEdition: action.payload
            });
        case 0, $aPZf4.UPDATE_JSW_EDITION:
            return (0, $7G07p.merge)(state, {
                jswEdition: action.payload
            });
        case 0, $aPZf4.UPDATE_SUGGESTED_KEY:
            return (0, $7G07p.merge)(state, {
                suggestedKey: action.key
            });
        default:
            return state;
    }
};

});
parcelRegister("dam7O", function(module, exports) {

$parcel$export(module.exports, "SET", () => $a38504762e7d740b$export$5e8f180ef0142226);
$parcel$export(module.exports, "set", () => $a38504762e7d740b$export$adaa4cf7ef1b65be);
const $a38504762e7d740b$export$5e8f180ef0142226 = 'context.SET';
const $a38504762e7d740b$export$adaa4cf7ef1b65be = (payload)=>({
        type: $a38504762e7d740b$export$5e8f180ef0142226,
        payload: payload
    });

});

parcelRegister("g5yS7", function(module, exports) {

$parcel$export(module.exports, "UPDATE_LICENSE_INFORMATION", () => $cd749e00936156db$export$482eb5280a7b12af);
$parcel$export(module.exports, "updateProductLicenses", () => $cd749e00936156db$export$a6afaeb75db595fa);
const $cd749e00936156db$export$482eb5280a7b12af = 'UPDATE_LICENSE_INFORMATION';
const $cd749e00936156db$export$a6afaeb75db595fa = (payload)=>({
        type: $cd749e00936156db$export$482eb5280a7b12af,
        payload: payload
    });

});


parcelRegister("hp80v", function(module, exports) {

$parcel$export(module.exports, "createStore", () => $43b8f44cc2ca80cc$export$f51a9068ac82ea43);

var $3f2cs = parcelRequire("3f2cs");

var $e1AU2 = parcelRequire("e1AU2");

var $fPwP9 = parcelRequire("fPwP9");

var $9Vh9Q = parcelRequire("9Vh9Q");

var $lav4p = parcelRequire("lav4p");
const $43b8f44cc2ca80cc$export$f51a9068ac82ea43 = (initialState, middlewares = [])=>{
    // @ts-ignore - Expected 4 type arguments, but got 1
    // This was added when enrolling `@atlassiansox/project-pages` into JFE local consumption
    const store = (0, $3f2cs.createStore)((0, $lav4p.default), initialState, // @ts-ignore - Expected 1-2 arguments, but got 3
    // This was added when enrolling `@atlassiansox/project-pages` into JFE local consumption
    (0, $fPwP9.composeWithDevtools)({
        name: 'Project Pages'
    })((0, $3f2cs.applyMiddleware)(...middlewares, (0, $e1AU2.createEpicMiddleware)((0, $9Vh9Q.default)))));
    return store;
};

});
parcelRegister("fPwP9", function(module, exports) {

$parcel$export(module.exports, "composeWithDevtools", () => $4625e934cf443fc0$export$635593bd946c7364);

var $3f2cs = parcelRequire("3f2cs");
const $4625e934cf443fc0$export$635593bd946c7364 = (devtoolsConfig = {})=>{
    const devtoolsEnhancer = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__;
    return devtoolsEnhancer ? devtoolsEnhancer(devtoolsConfig) : (0, $3f2cs.compose);
};

});

parcelRegister("9Vh9Q", function(module, exports) {

$parcel$export(module.exports, "default", () => $cb11eb5d83a85969$export$2e2bcd8739ae039);

var $yKIn9 = parcelRequire("yKIn9");

var $f4eqG = parcelRequire("f4eqG");

var $88LiJ = parcelRequire("88LiJ");

var $7aoUd = parcelRequire("7aoUd");

var $jla05 = parcelRequire("jla05");

var $2RpaT = parcelRequire("2RpaT");

var $iyMjO = parcelRequire("iyMjO");

var $elt2z = parcelRequire("elt2z");

var $krIH5 = parcelRequire("krIH5");

var $6mnU2 = parcelRequire("6mnU2");

var $fMwg8 = parcelRequire("fMwg8");

var $4OylY = parcelRequire("4OylY");

var $1BdfT = parcelRequire("1BdfT");

var $auLvV = parcelRequire("auLvV");

var $42LbU = parcelRequire("42LbU");

var $24HnK = parcelRequire("24HnK");

var $4OTlM = parcelRequire("4OTlM");

var $aFTec = parcelRequire("aFTec");

var $kyhTh = parcelRequire("kyhTh");

var $9CWy4 = parcelRequire("9CWy4");

var $1velZ = parcelRequire("1velZ");

var $4WgBW = parcelRequire("4WgBW");

var $k7Gxn = parcelRequire("k7Gxn");

var $5DAOv = parcelRequire("5DAOv");

var $8rOwk = parcelRequire("8rOwk");

var $7Cgsr = parcelRequire("7Cgsr");

var $EEbHD = parcelRequire("EEbHD");

var $jXVi3 = parcelRequire("jXVi3");

var $5vrLd = parcelRequire("5vrLd");

var $c2Qnq = parcelRequire("c2Qnq");

var $jRqux = parcelRequire("jRqux");

var $5JVZm = parcelRequire("5JVZm");

var $9i2ja = parcelRequire("9i2ja");

var $a9kap = parcelRequire("a9kap");
const $cb11eb5d83a85969$var$onError = (error, epicName)=>{
    // Bubble the error all the way to the top.
    setTimeout(()=>{
        throw error;
    }, 0);
    // Fire an analytics event to signal the error in the epic.
    (0, $yKIn9.sendTrackAnalyticsEvent)({
        source: 'epic',
        action: 'error',
        actionSubject: epicName,
        attributes: {
            reason: String(error) || 'Unknown error'
        }
    });
};
const $cb11eb5d83a85969$export$aaa76db017874a43 = ()=>({
        changeSpaceName: $88LiJ.default,
        checkProductsLicence: $7aoUd.default,
        checkConfluenceUserPermissions: $jla05.default,
        connectConfluenceSpace: $2RpaT.default,
        createConfluenceSpace: $iyMjO.default,
        fetchConnectedSpaceBlueprints: $elt2z.default,
        generateSpaceKey: $6mnU2.default,
        noValidKeyEpic: $fMwg8.default,
        projectSpaceLink: $4OylY.default,
        retrieveConfluenceSpaces: $1BdfT.default,
        setFirstSpaceCreatedFlag: $auLvV.default,
        showXflowDialog: $42LbU.default,
        updateProjectSpaceLink: $24HnK.default,
        confluenceAccessRequestCapabilities: $4OTlM.default,
        confluenceCollaborators: $aFTec.default,
        fetchConnectedSpaceOrPageTitle: $kyhTh.default,
        fetchConnectedSpace: $9CWy4.default,
        jiraProjectPermissions: $1velZ.default,
        confluenceInlineJoin: $4WgBW.default,
        checkConfluenceAccessWithRetry: $krIH5.default,
        fetchPersonalizationSiteTraits: $k7Gxn.default,
        checkConfluenceSpacesForAutoProvisionedUsers: $5DAOv.default,
        initializeView: $8rOwk.default,
        autoCreateSpace: $EEbHD.default,
        autoCreateSpaceKey: $7Cgsr.default,
        activateConfluencePlan: $jXVi3.default,
        activateConfluenceStart: $5vrLd.default,
        activateConfluenceStatusCheck: $c2Qnq.default,
        activateConfluenceStatusCheckSuccess: $jRqux.default,
        activateConfluenceStatusCheckFailed: $5JVZm.default,
        activateConfluenceCompleted: $9i2ja.default,
        activateConfluenceFailed: $a9kap.default
    });
var $cb11eb5d83a85969$export$2e2bcd8739ae039 = (0, $f4eqG.default)($cb11eb5d83a85969$export$aaa76db017874a43(), $cb11eb5d83a85969$var$onError);

});
parcelRegister("f4eqG", function(module, exports) {

$parcel$export(module.exports, "default", () => $c8f00fb367b7012b$export$2e2bcd8739ae039);

var $e1AU2 = parcelRequire("e1AU2");
const $c8f00fb367b7012b$var$defaultOnErrorHandler = (error)=>{
    throw error;
};
/**
 * Wrap the specified epic so that any errors invoke an error handler and return the original
 * source stream.
 *
 * By default, the onError handler will bubble errors to the top, so they can be displayed
 * in the console, or captured by error reporting.
 *
 * Note: The onError handler is deferred, to ensure that it can no longer cause further errors
 * in the epic.
 *
 * @param onError - an optional handler which will be called if an epic encounters an error
 */ const $c8f00fb367b7012b$var$wrapEpic = (epic, epicName, onError = $c8f00fb367b7012b$var$defaultOnErrorHandler)=>(...args)=>epic(...args).catch((error, source)=>{
            setTimeout(()=>onError(error, epicName), 0);
            return source;
        });
var /**
 * Combine and wrap all epics, so that errors do not kill the entire action stream.
 *
 * @param epicObject - values are epics and keys are their identifiers
 * @param onError - an optional handler which will be called if any epic encounters an error
 */ $c8f00fb367b7012b$export$2e2bcd8739ae039 = (epicObject, onError)=>(0, $e1AU2.combineEpics)(...Object.entries(epicObject).map(([name, epic])=>$c8f00fb367b7012b$var$wrapEpic(epic, name, onError)));

});

parcelRegister("88LiJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $82613bc539261044$export$2e2bcd8739ae039);
parcelRequire("fPS7b");

var $gI62y = parcelRequire("gI62y");

var $aPZf4 = parcelRequire("aPZf4");
const $82613bc539261044$var$isWhitespace = (str)=>/^\s+$/.test(str);
const $82613bc539261044$var$containsAlphanumeric = (str)=>/[a-zA-Z0-9]/g.test(str);
var $82613bc539261044$export$2e2bcd8739ae039 = (action$)=>action$.ofType((0, $aPZf4.CHANGE_SPACE_NAME)).mergeMap(({ name: name })=>(0, $gI62y.from)([
            (0, $aPZf4.updateSuggestedKey)(null),
            (0, $aPZf4.updateSpaceName)(name),
            (0, $aPZf4.toggleSpaceNameInvalid)($82613bc539261044$var$isWhitespace(name)),
            ...$82613bc539261044$var$containsAlphanumeric(name) ? [
                (0, $aPZf4.generateSpaceKey)(name)
            ] : [
                (0, $aPZf4.noValidKey)()
            ]
        ]));

});

parcelRegister("7aoUd", function(module, exports) {

$parcel$export(module.exports, "default", () => $c8ed72c29c8310e0$export$2e2bcd8739ae039);
parcelRequire("6cbqE");
parcelRequire("fPS7b");
parcelRequire("c66Ur");

var $gI62y = parcelRequire("gI62y");

var $aq199 = parcelRequire("aq199");

var $d8Nxe = parcelRequire("d8Nxe");

var $aPZf4 = parcelRequire("aPZf4");

var $9MB7L = parcelRequire("9MB7L");

var $fTJXm = parcelRequire("fTJXm");

var $6L3iv = parcelRequire("6L3iv");

var $bBMvo = parcelRequire("bBMvo");

var $g5yS7 = parcelRequire("g5yS7");
const $c8ed72c29c8310e0$var$confluenceStateMap = {
    LOADING: (0, $fTJXm.CONFLUENCE_LOADING),
    INACTIVE: (0, $fTJXm.CONFLUENCE_INACTIVE),
    DEACTIVATED: (0, $fTJXm.CONFLUENCE_DEACTIVATED),
    ACTIVE: (0, $fTJXm.CONFLUENCE_ACTIVE),
    ACTIVATING: (0, $fTJXm.CONFLUENCE_ACTIVATING),
    EXPIRED: (0, $fTJXm.CONFLUENCE_EXPIRED),
    ERROR: (0, $fTJXm.CONFLUENCE_ERROR)
};
var $c8ed72c29c8310e0$export$2e2bcd8739ae039 = (action$, store)=>action$.ofType((0, $aPZf4.CHECK_PRODUCTS_LICENCE_STATE)).switchMap(()=>{
        const state = store.getState();
        const projectId = (0, $6L3iv.getProjectId)(state);
        const cloudId = (0, $9MB7L.getCloudId)(state);
        if (!projectId) {
            (0, $d8Nxe.fetchFailed)('confluence.license', new Error('missing projectId in project-pages state'));
            return (0, $aq199.of)((0, $aPZf4.updateConfluenceState)((0, $fTJXm.CONFLUENCE_ERROR)));
        }
        if (!cloudId) {
            (0, $d8Nxe.fetchFailed)('confluence.license', new Error('missing cloudId in project-pages state'));
            return (0, $aq199.of)((0, $aPZf4.updateConfluenceState)((0, $fTJXm.CONFLUENCE_ERROR)));
        }
        return (0, $bBMvo.requestProductLicenceState$)(cloudId).mergeMap((values)=>{
            (0, $d8Nxe.fetchSuccess)('confluence.license');
            const confluence = values.products?.[(0, $fTJXm.ProductKeys).CONFLUENCE];
            let confluenceState = confluence ? $c8ed72c29c8310e0$var$confluenceStateMap[confluence.state] : (0, $fTJXm.CONFLUENCE_INACTIVE);
            if (confluence && confluence.isSuspended) confluenceState = (0, $fTJXm.CONFLUENCE_DEACTIVATED);
            const jswEdition = values.products?.[(0, $fTJXm.ProductKeys).JIRA_SOFTWARE]?.edition;
            return (0, $gI62y.from)([
                (0, $g5yS7.updateProductLicenses)(values),
                (0, $aPZf4.updateConfluenceState)(confluenceState),
                (0, $aPZf4.updateConfluenceEdition)(confluence?.edition),
                (0, $aPZf4.updateJswEdition)(jswEdition),
                ...confluenceState === (0, $fTJXm.CONFLUENCE_ACTIVE) ? [
                    (0, $aPZf4.checkConfluenceUserPermissions)(),
                    (0, $aPZf4.fetchJiraProjectPermissions)(),
                    (0, $aPZf4.getProjectSpaceLink)(projectId)
                ] : []
            ]);
        }).catch((err)=>{
            (0, $d8Nxe.fetchFailed)('confluence.license', err);
            return (0, $aq199.of)((0, $aPZf4.updateConfluenceState)((0, $fTJXm.CONFLUENCE_ERROR)));
        });
    });

});
parcelRegister("d8Nxe", function(module, exports) {

$parcel$export(module.exports, "fetchFailed", () => $7a1bc9578475a2bd$export$b6fac9536a9cb64e);
$parcel$export(module.exports, "fetchSuccess", () => $7a1bc9578475a2bd$export$56c204dda9cb636c);

var $yKIn9 = parcelRequire("yKIn9");
const $7a1bc9578475a2bd$export$b6fac9536a9cb64e = (source, err, data)=>{
    (0, $yKIn9.sendOperationalAnalyticsEvent)({
        source: source,
        action: 'failed',
        actionSubject: 'fetch',
        attributes: {
            errorMessage: err.message || 'Unknown error',
            ...data
        }
    });
};
const $7a1bc9578475a2bd$export$56c204dda9cb636c = (source, data = {})=>{
    const { spaceKey: spaceKey, projectKey: projectKey, autoCreated: autoCreated } = data;
    (0, $yKIn9.sendOperationalAnalyticsEvent)({
        source: source,
        action: 'success',
        actionSubject: 'fetch',
        attributes: {
            spaceKey: spaceKey,
            projectKey: projectKey,
            autoCreated: autoCreated
        }
    });
};

});


parcelRegister("jla05", function(module, exports) {

$parcel$export(module.exports, "default", () => $b9dfdf624929bd37$export$2e2bcd8739ae039);
/* eslint-disable no-console */ 
var $aq199 = parcelRequire("aq199");

var $8B7Oi = parcelRequire("8B7Oi");

var $9XE6b = parcelRequire("9XE6b");

var $d8Nxe = parcelRequire("d8Nxe");

var $aPZf4 = parcelRequire("aPZf4");


var $bBMvo = parcelRequire("bBMvo");

var $6L3iv = parcelRequire("6L3iv");
var $b9dfdf624929bd37$export$2e2bcd8739ae039 = (action$, store)=>{
    return action$.ofType((0, $aPZf4.CHECK_CONFLUENCE_USER_PERMISSIONS)).switchMap(()=>{
        return (0, $bBMvo.fetchConfluenceCurrentUser)((0, $6L3iv.getProjectId)(store.getState()), (0, $6L3iv.getProjectType)(store.getState())).mergeMap((value)=>{
            (0, $d8Nxe.fetchSuccess)('confluence.user');
            if ((0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(value, 'operations.length')) return (0, $aq199.of)((0, $aPZf4.updateConfluenceUserAccess)((0, $4af2e72ebaa388c6$export$c6813a8d51f77eaf)));
            return (0, $aq199.of)((0, $aPZf4.updateConfluenceUserAccess)((0, $4af2e72ebaa388c6$export$a3269a3914b007e3)));
        }).catch((err)=>{
            if (err.statusCode === 403) return (0, $aq199.of)((0, $aPZf4.updateConfluenceUserAccess)((0, $4af2e72ebaa388c6$export$a3269a3914b007e3)));
            (0, $d8Nxe.fetchFailed)('confluence.user', err);
            return (0, $8B7Oi.empty)();
        });
    });
};

});

parcelRegister("2RpaT", function(module, exports) {

$parcel$export(module.exports, "default", () => $321a6114efcb3610$export$2e2bcd8739ae039);
parcelRequire("d0pqD");
parcelRequire("fPS7b");
parcelRequire("c66Ur");

var $d8Nxe = parcelRequire("d8Nxe");

var $aPZf4 = parcelRequire("aPZf4");

var $6L3iv = parcelRequire("6L3iv");

var $2ja74 = parcelRequire("2ja74");

var $cEp5g = parcelRequire("cEp5g");
var $321a6114efcb3610$export$2e2bcd8739ae039 = (action$, store)=>action$.ofType((0, $aPZf4.CONNECT_CONFLUENCE_SPACE)).map(()=>{
        const state = store.getState();
        const projectKey = (0, $6L3iv.getProjectKey)(state);
        const projectId = (0, $6L3iv.getProjectId)(state);
        const connectedPageId = (0, $cEp5g.getProjectPageLinkedId)(state);
        const connectedSpaceId = (0, $cEp5g.getProjectSpaceId)(state);
        const selectedSpace = (0, $2ja74.getSelectedSpace)(state);
        if (!projectKey) {
            (0, $d8Nxe.fetchFailed)('connect.confluence.space', new Error('missing projectKey'));
            return (0, $aPZf4.putProjectSpaceLinkError)();
        }
        if (!projectId) {
            (0, $d8Nxe.fetchFailed)('connect.confluence.space', new Error('missing projectId'));
            return (0, $aPZf4.putProjectSpaceLinkError)();
        }
        if (!selectedSpace || !selectedSpace.spaceKey) {
            (0, $d8Nxe.fetchFailed)('connect.confluence.space', new Error('missing selected space spaceKey'));
            return (0, $aPZf4.putProjectSpaceLinkError)();
        }
        if (!selectedSpace || !selectedSpace.spaceId) {
            (0, $d8Nxe.fetchFailed)('connect.confluence.space', new Error('missing selected space spaceId'));
            return (0, $aPZf4.putProjectSpaceLinkError)();
        }
        const { spaceKey: spaceKey, spaceUrl: spaceUrl, spaceId: spaceId } = selectedSpace;
        (0, $d8Nxe.fetchSuccess)('connect.confluence.space');
        return (0, $aPZf4.putProjectSpaceLink)({
            projectKey: projectKey,
            projectId: projectId,
            spaceKey: spaceKey,
            spaceUrl: spaceUrl,
            spaceId: spaceId,
            connectedSpaceId: connectedSpaceId,
            connectedPageId: connectedPageId
        });
    });

});

parcelRegister("iyMjO", function(module, exports) {

$parcel$export(module.exports, "default", () => $53562f1bc15730f0$export$2e2bcd8739ae039);
parcelRequire("6cbqE");
parcelRequire("c66Ur");

var $aq199 = parcelRequire("aq199");

var $gI62y = parcelRequire("gI62y");

var $d8Nxe = parcelRequire("d8Nxe");

var $aPZf4 = parcelRequire("aPZf4");

var $kwnxt = parcelRequire("kwnxt");

var $cIDcy = parcelRequire("cIDcy");

var $9MB7L = parcelRequire("9MB7L");

var $6L3iv = parcelRequire("6L3iv");

var $b7YHH = parcelRequire("b7YHH");

var $cEp5g = parcelRequire("cEp5g");

var $bBMvo = parcelRequire("bBMvo");
var $53562f1bc15730f0$export$2e2bcd8739ae039 = (action$, store)=>action$.ofType((0, $kwnxt.CREATE_CONFLUENCE_SPACE)).switchMap(({ autoCreated: autoCreated = false })=>{
        const state = store.getState();
        const availableSpaces = (0, $cIDcy.getAvailableSpaces)(state);
        const userEnteredSpaceName = (0, $b7YHH.getUserEnteredSpaceName)(state);
        const connectedPageId = (0, $cEp5g.getProjectPageLinkedId)(state);
        const connectedSpaceId = (0, $cEp5g.getProjectSpaceId)(state);
        const confluenceSpaceKey = (0, $9MB7L.getSuggestedKey)(state);
        const projectName = (0, $6L3iv.getProjectName)(state);
        const projectKey = (0, $6L3iv.getProjectKey)(state);
        const projectId = (0, $6L3iv.getProjectId)(state);
        const projectType = (0, $6L3iv.getProjectType)(state);
        const confluenceSpaceName = autoCreated ? projectName : userEnteredSpaceName;
        if (confluenceSpaceKey === null || confluenceSpaceKey === undefined || confluenceSpaceKey === '') return (0, $aq199.of)((0, $kwnxt.createConfluenceSpaceError)());
        return (0, $bBMvo.requestCreateConfluenceSpace$)(confluenceSpaceName, confluenceSpaceKey, projectKey, projectId, projectType).switchMap(({ spaceKey: spaceKey, spaceUrl: spaceUrl, spaceId: spaceId })=>{
            (0, $d8Nxe.fetchSuccess)('confluence.space.create', {
                autoCreated: autoCreated
            });
            return (0, $gI62y.from)([
                (0, $aPZf4.putProjectSpaceLink)({
                    spaceId: spaceId,
                    spaceKey: spaceKey,
                    spaceUrl: spaceUrl,
                    projectKey: projectKey,
                    projectId: projectId,
                    autoCreated: autoCreated,
                    connectedPageId: connectedPageId,
                    connectedSpaceId: connectedSpaceId
                }),
                ...availableSpaces.length === 0 ? [
                    (0, $aPZf4.setFirstSpaceCreatedFlag)()
                ] : []
            ]);
        }).catch((err)=>{
            (0, $d8Nxe.fetchFailed)('confluence.space.create', err, {
                autoCreated: autoCreated
            });
            return (0, $aq199.of)((0, $kwnxt.createConfluenceSpaceError)());
        });
    });

});

parcelRegister("elt2z", function(module, exports) {

$parcel$export(module.exports, "default", () => $1e302ba3c4df925c$export$2e2bcd8739ae039);
parcelRequire("d0pqD");
parcelRequire("6cbqE");
parcelRequire("c66Ur");

var $aq199 = parcelRequire("aq199");

var $d8Nxe = parcelRequire("d8Nxe");

var $aPZf4 = parcelRequire("aPZf4");

var $cEp5g = parcelRequire("cEp5g");

var $bBMvo = parcelRequire("bBMvo");

var $6L3iv = parcelRequire("6L3iv");
var $1e302ba3c4df925c$export$2e2bcd8739ae039 = (action$, store)=>action$.ofType((0, $aPZf4.FETCH_CONNECTED_SPACE_BLUEPRINTS)).switchMap(()=>{
        const state = store.getState();
        const projectSpaceKey = (0, $cEp5g.getProjectSpaceKey)(state);
        if (!projectSpaceKey) {
            (0, $d8Nxe.fetchFailed)('connected.space.blueprints', new Error('missing projectSpaceKey in project-pages state'));
            return (0, $aq199.of)((0, $aPZf4.fetchConnectedSpaceBlueprintsError)());
        }
        return (0, $bBMvo.fetchConnectedSpaceBlueprints$)(projectSpaceKey, (0, $6L3iv.getProjectId)(store.getState()), (0, $6L3iv.getProjectType)(store.getState())).map((value)=>{
            (0, $d8Nxe.fetchSuccess)('connected.space.blueprints');
            return (0, $aPZf4.updateConnectedSpaceBlueprints)(value.map(({ name: name, itemModuleCompleteKey: itemModuleCompleteKey, blueprintModuleCompleteKey: blueprintModuleCompleteKey, contentBlueprintId: contentBlueprintId, skipHowToUse: skipHowToUse })=>({
                    name: name,
                    itemModuleCompleteKey: itemModuleCompleteKey,
                    blueprintModuleCompleteKey: blueprintModuleCompleteKey,
                    contentBlueprintId: contentBlueprintId,
                    skipHowToUse: skipHowToUse
                })));
        }).catch((err)=>{
            (0, $d8Nxe.fetchFailed)('connected.space.blueprints', err);
            return (0, $aq199.of)((0, $aPZf4.fetchConnectedSpaceBlueprintsError)());
        });
    });

});

parcelRegister("krIH5", function(module, exports) {

$parcel$export(module.exports, "default", () => $e23cc0db87d18bb7$export$2e2bcd8739ae039);
parcelRequire("6cbqE");

var $aq199 = parcelRequire("aq199");

var $d8Nxe = parcelRequire("d8Nxe");

var $aPZf4 = parcelRequire("aPZf4");

var $4iqmv = parcelRequire("4iqmv");

var $bBMvo = parcelRequire("bBMvo");

var $80gxR = parcelRequire("80gxR");

var $e6C7w = parcelRequire("e6C7w");

var $5v6N2 = parcelRequire("5v6N2");

var $dqok3 = parcelRequire("dqok3");

var $8EnuM = parcelRequire("8EnuM");


var $9XE6b = parcelRequire("9XE6b");

var $gI62y = parcelRequire("gI62y");

var $1cUoq = parcelRequire("1cUoq");
var $e23cc0db87d18bb7$export$2e2bcd8739ae039 = (action$)=>action$.ofType((0, $aPZf4.CHECK_CONFLUENCE_ACCESS_WITH_RETRY)).switchMap(()=>{
        // In staging this takes roughly 10 seconds to resolve, 15 adds some overhead to 10 retries without making it too long
        // for users.
        const maxTries = 15;
        let retries = maxTries - 1;
        return (0, $bBMvo.fetchConfluenceCurrentUser)().pipe((0, $80gxR.mergeMap)((value)=>{
            (0, $d8Nxe.fetchSuccess)('confluence.user.retry');
            if ((0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(value, 'operations.length')) return (0, $gI62y.from)([
                (0, $aPZf4.updateConfluenceUserAccess)((0, $4af2e72ebaa388c6$export$78244dbb77cfa6b6)),
                (0, $aPZf4.resetConnectedSpace)(),
                /* 
							The most important observables to trigger when we got access to Confluence are:
								- checkProductsLicenceState
								- fetchPersonalizationSiteTraits
							without them the screen is going to be stuck in connectedSpace.connectionState === "LOADING"
						*/ (0, $aPZf4.checkProductsLicenceState)(),
                (0, $4iqmv.fetchPersonalizationSiteTraits)(),
                (0, $aPZf4.fetchConfluenceAccessRequestCapabilities)()
            ]);
            throw new Error((0, $1cUoq.NO_ACCESS_ERROR_MESSAGE));
        }), (0, $5v6N2.retryWhen)((errors)=>{
            return errors.pipe((0, $dqok3.takeWhile)((error)=>{
                if (error.statusCode !== 403) throw error;
                if (retries <= 0) throw new Error((0, $1cUoq.NO_ACCESS_ERROR_MESSAGE) + ` after ${maxTries} tries`);
                retries -= 1;
                return true;
            }), (0, $8EnuM.delay)(1000));
        }), (0, $e6C7w.catchError)((err)=>{
            if (err.message !== (0, $1cUoq.NO_ACCESS_ERROR_MESSAGE) + ` after ${maxTries} tries`) (0, $d8Nxe.fetchFailed)('confluence.user.retry', err);
            return (0, $aq199.of)((0, $aPZf4.inlineJoinConfluenceFailed)());
        }));
    });

});
parcelRegister("1cUoq", function(module, exports) {

$parcel$export(module.exports, "NO_ACCESS_ERROR_MESSAGE", () => $82597ec3137bc7bf$export$cdfa7869a106ec85);
$parcel$export(module.exports, "inlineJoin$", () => $82597ec3137bc7bf$export$b44ff9074cf5d07f);

var $cVFxd = parcelRequire("cVFxd");

var $aWcOP = parcelRequire("aWcOP");

var $8c8di = parcelRequire("8c8di");
const $82597ec3137bc7bf$var$INLINE_JOIN_URL = '/gateway/api/invitations/v1/access-requests/request';
const $82597ec3137bc7bf$export$cdfa7869a106ec85 = 'No confluence access';
const $82597ec3137bc7bf$export$b44ff9074cf5d07f = (product, cloudId)=>(0, $aWcOP.default)($82597ec3137bc7bf$var$INLINE_JOIN_URL, {
        method: 'POST',
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            resource: `ari:cloud:${product}::site/${cloudId}`
        })
    }).pipe((0, $cVFxd.map)((response)=>{
        const results = response.results;
        const result = results[`ari:cloud:${product}::site/${cloudId}`];
        if (result === (0, $8c8di.AccessRequestCapabilityType).ACCESS_GRANTED || result === (0, $8c8di.AccessRequestCapabilityType).ACCESS_EXISTS || result === (0, $8c8di.AccessRequestCapabilityType).PENDING_REQUEST_CREATED) return {
            status: true,
            result: result
        };
        throw new Error($82597ec3137bc7bf$export$cdfa7869a106ec85);
    }));

});


parcelRegister("6mnU2", function(module, exports) {

$parcel$export(module.exports, "default", () => $523c3cd92742c004$export$2e2bcd8739ae039);
parcelRequire("d0pqD");
parcelRequire("fPS7b");
parcelRequire("eSGL3");
parcelRequire("c66Ur");

var $aq199 = parcelRequire("aq199");

var $faGMz = parcelRequire("faGMz");

var $kGsr8 = parcelRequire("kGsr8");

var $eM0a2 = parcelRequire("eM0a2");

var $yKIn9 = parcelRequire("yKIn9");

var $aPZf4 = parcelRequire("aPZf4");

var $bBMvo = parcelRequire("bBMvo");

var $6L3iv = parcelRequire("6L3iv");
const $523c3cd92742c004$var$generateKey = (name)=>{
    // Create a list of suggestions
    let keySuggestions = [];
    // Restrict length of the final key
    const minKeyLength = 1;
    const maxKeyLength = 10;
    // These words will not be used in key generation for acronyms.
    const IGNORED_WORDS = [
        'THE',
        'A',
        'AN',
        'AS',
        'AND',
        'OF',
        'OR'
    ];
    const getTotalLength = (words)=>words.join('').length;
    const removeIgnoredWords = (words)=>words.filter((word)=>!IGNORED_WORDS.includes(word));
    const createAcronym = (words)=>words.map((word)=>word.charAt(0)).join('');
    const getFirstSyllable = (word)=>{
        // Best guess at getting the first syllable
        // Returns the substring up to and including the first consonant to appear after a vowel
        const vowelIndex = word.search(/[AEIOUYaeiouy]/);
        return vowelIndex ? word.substr(0, vowelIndex + 1) : word;
    };
    const trimmedName = (0, (/*@__PURE__*/$parcel$interopDefault($eM0a2))).clean(name.trim());
    if (!trimmedName) return [];
    // Split into words
    let nameAsArray = trimmedName.replace(/[^a-zA-Z0-9' ']/g, '').toUpperCase().split(' ');
    // Remove ignored words
    nameAsArray = nameAsArray > getTotalLength(nameAsArray) ? removeIgnoredWords(nameAsArray) : nameAsArray;
    if (nameAsArray.length === 0) // No words were worthy!
    keySuggestions = [];
    else {
        // Get the first syllable
        const word = nameAsArray[0];
        if (getFirstSyllable(word)) keySuggestions.push(getFirstSyllable(word));
        // The first word as a key
        keySuggestions.push(word);
        // The first letter from each
        keySuggestions.push(createAcronym(nameAsArray));
    }
    // Limit the length of the key suggestions
    const results = keySuggestions.map((keyOption)=>keyOption.length > maxKeyLength ? keyOption.substr(0, maxKeyLength).toUpperCase() : keyOption.toUpperCase()).filter((keyOption)=>keyOption.length >= minKeyLength).sort();
    return (0, (/*@__PURE__*/$parcel$interopDefault($kGsr8)))(results);
};
const $523c3cd92742c004$var$failureAnalytics = ()=>{
    (0, $yKIn9.sendTrackAnalyticsEvent)({
        source: 'space.key',
        action: 'error',
        actionSubject: 'generate'
    });
};
const $523c3cd92742c004$var$successAnalytics = ()=>{
    (0, $yKIn9.sendTrackAnalyticsEvent)({
        source: 'space.key',
        action: 'success',
        actionSubject: 'generate'
    });
};
const $523c3cd92742c004$var$noValidKeyAnalytics = ()=>{
    (0, $yKIn9.sendTrackAnalyticsEvent)({
        source: 'space.key',
        action: 'no.valid',
        actionSubject: 'generate'
    });
};
const $523c3cd92742c004$export$d8394ba24e88fd87 = 1000;
var $523c3cd92742c004$export$2e2bcd8739ae039 = (action$, store)=>action$.ofType((0, $aPZf4.GENERATE_SPACE_KEY)).debounceTime($523c3cd92742c004$export$d8394ba24e88fd87).mergeMap(({ name: name })=>(0, $faGMz.forkJoin)(...$523c3cd92742c004$var$generateKey(name).map((key)=>(0, $bBMvo.checkConfluenceSpaceAvailability$)(key, (0, $6L3iv.getProjectId)(store.getState()), (0, $6L3iv.getProjectType)(store.getState())).catch((err)=>(0, $aq199.of)(err)))).map((payloads)=>{
            const someSucceeded = payloads.some((payload)=>!(payload instanceof Error));
            if (someSucceeded) {
                const availablePayload = payloads.find((payload)=>payload.available);
                if (availablePayload) {
                    $523c3cd92742c004$var$successAnalytics();
                    return (0, $aPZf4.updateSuggestedKey)(availablePayload.key);
                }
                $523c3cd92742c004$var$noValidKeyAnalytics();
                return (0, $aPZf4.noValidKey)();
            }
            $523c3cd92742c004$var$failureAnalytics();
            return (0, $aPZf4.noValidKeyFailure)();
        }).catch(()=>{
            $523c3cd92742c004$var$failureAnalytics();
            return (0, $aq199.of)((0, $aPZf4.noValidKeyFailure)());
        }));

});
parcelRegister("eM0a2", function(module, exports) {
// Diacritics.js
// 
// Started as something to be an equivalent of the Google Java Library diacritics library for JavaScript.
// Found this: http://jsperf.com/diacritics/6 and converted it into a reusable module.
// 
// @author Nijiko Yonskai
// @license MIT
// @copyright Nijikokun 2013 <nijikokun@gmail.com>
(function(name, definition) {
    if (0, module.exports) module.exports = definition();
    else if (typeof define == 'function' && define.amd) define(definition);
    else this[name] = definition();
})('Diacritics', function() {
    // Create public object
    var output = {
        map: {}
    };
    // Create private reference map.
    var reference = [
        {
            'base': ' ',
            'letters': '\u00A0'
        },
        {
            'base': 'A',
            'letters': '\u0041\u24B6\uFF21\u00C0\u00C1\u00C2\u1EA6\u1EA4\u1EAA\u1EA8\u00C3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\u00C4\u01DE\u1EA2\u00C5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F'
        },
        {
            'base': 'AA',
            'letters': '\uA732'
        },
        {
            'base': 'AE',
            'letters': '\u00C6\u01FC\u01E2'
        },
        {
            'base': 'AO',
            'letters': '\uA734'
        },
        {
            'base': 'AU',
            'letters': '\uA736'
        },
        {
            'base': 'AV',
            'letters': '\uA738\uA73A'
        },
        {
            'base': 'AY',
            'letters': '\uA73C'
        },
        {
            'base': 'B',
            'letters': '\u0042\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181'
        },
        {
            'base': 'C',
            'letters': '\u0043\u24B8\uFF23\u0106\u0108\u010A\u010C\u00C7\u1E08\u0187\u023B\uA73E'
        },
        {
            'base': 'D',
            'letters': '\u0044\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779'
        },
        {
            'base': 'DZ',
            'letters': '\u01F1\u01C4'
        },
        {
            'base': 'Dz',
            'letters': '\u01F2\u01C5'
        },
        {
            'base': 'E',
            'letters': '\u0045\u24BA\uFF25\u00C8\u00C9\u00CA\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\u00CB\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E'
        },
        {
            'base': 'F',
            'letters': '\u0046\u24BB\uFF26\u1E1E\u0191\uA77B'
        },
        {
            'base': 'G',
            'letters': '\u0047\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E'
        },
        {
            'base': 'H',
            'letters': '\u0048\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D'
        },
        {
            'base': 'I',
            'letters': '\u0049\u24BE\uFF29\u00CC\u00CD\u00CE\u0128\u012A\u012C\u0130\u00CF\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197'
        },
        {
            'base': 'J',
            'letters': '\u004A\u24BF\uFF2A\u0134\u0248'
        },
        {
            'base': 'K',
            'letters': '\u004B\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2'
        },
        {
            'base': 'L',
            'letters': '\u004C\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780'
        },
        {
            'base': 'LJ',
            'letters': '\u01C7'
        },
        {
            'base': 'Lj',
            'letters': '\u01C8'
        },
        {
            'base': 'M',
            'letters': '\u004D\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C'
        },
        {
            'base': 'N',
            'letters': '\u004E\u24C3\uFF2E\u01F8\u0143\u00D1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4'
        },
        {
            'base': 'NJ',
            'letters': '\u01CA'
        },
        {
            'base': 'Nj',
            'letters': '\u01CB'
        },
        {
            'base': 'O',
            'letters': '\u004F\u24C4\uFF2F\u00D2\u00D3\u00D4\u1ED2\u1ED0\u1ED6\u1ED4\u00D5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\u00D6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\u00D8\u01FE\u0186\u019F\uA74A\uA74C'
        },
        {
            'base': 'OI',
            'letters': '\u01A2'
        },
        {
            'base': 'OO',
            'letters': '\uA74E'
        },
        {
            'base': 'OU',
            'letters': '\u0222'
        },
        {
            'base': 'P',
            'letters': '\u0050\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754'
        },
        {
            'base': 'Q',
            'letters': '\u0051\u24C6\uFF31\uA756\uA758\u024A'
        },
        {
            'base': 'R',
            'letters': '\u0052\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782'
        },
        {
            'base': 'S',
            'letters': '\u0053\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784'
        },
        {
            'base': 'T',
            'letters': '\u0054\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786'
        },
        {
            'base': 'Th',
            'letters': '\u00DE'
        },
        {
            'base': 'TZ',
            'letters': '\uA728'
        },
        {
            'base': 'U',
            'letters': '\u0055\u24CA\uFF35\u00D9\u00DA\u00DB\u0168\u1E78\u016A\u1E7A\u016C\u00DC\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244'
        },
        {
            'base': 'V',
            'letters': '\u0056\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245'
        },
        {
            'base': 'VY',
            'letters': '\uA760'
        },
        {
            'base': 'W',
            'letters': '\u0057\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72'
        },
        {
            'base': 'X',
            'letters': '\u0058\u24CD\uFF38\u1E8A\u1E8C'
        },
        {
            'base': 'Y',
            'letters': '\u0059\u24CE\uFF39\u1EF2\u00DD\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE'
        },
        {
            'base': 'Z',
            'letters': '\u005A\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762'
        },
        {
            'base': 'a',
            'letters': '\u0061\u24D0\uFF41\u1E9A\u00E0\u00E1\u00E2\u1EA7\u1EA5\u1EAB\u1EA9\u00E3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\u00E4\u01DF\u1EA3\u00E5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250\u0251'
        },
        {
            'base': 'aa',
            'letters': '\uA733'
        },
        {
            'base': 'ae',
            'letters': '\u00E6\u01FD\u01E3'
        },
        {
            'base': 'ao',
            'letters': '\uA735'
        },
        {
            'base': 'au',
            'letters': '\uA737'
        },
        {
            'base': 'av',
            'letters': '\uA739\uA73B'
        },
        {
            'base': 'ay',
            'letters': '\uA73D'
        },
        {
            'base': 'b',
            'letters': '\u0062\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253'
        },
        {
            'base': 'c',
            'letters': '\u0063\u24D2\uFF43\u0107\u0109\u010B\u010D\u00E7\u1E09\u0188\u023C\uA73F\u2184'
        },
        {
            'base': 'd',
            'letters': '\u0064\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A'
        },
        {
            'base': 'dz',
            'letters': '\u01F3\u01C6'
        },
        {
            'base': 'e',
            'letters': '\u0065\u24D4\uFF45\u00E8\u00E9\u00EA\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\u00EB\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD'
        },
        {
            'base': 'f',
            'letters': '\u0066\u24D5\uFF46\u1E1F\u0192\uA77C'
        },
        {
            'base': 'ff',
            'letters': '\uFB00'
        },
        {
            'base': 'fi',
            'letters': '\uFB01'
        },
        {
            'base': 'fl',
            'letters': '\uFB02'
        },
        {
            'base': 'ffi',
            'letters': '\uFB03'
        },
        {
            'base': 'ffl',
            'letters': '\uFB04'
        },
        {
            'base': 'g',
            'letters': '\u0067\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F'
        },
        {
            'base': 'h',
            'letters': '\u0068\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265'
        },
        {
            'base': 'hv',
            'letters': '\u0195'
        },
        {
            'base': 'i',
            'letters': '\u0069\u24D8\uFF49\u00EC\u00ED\u00EE\u0129\u012B\u012D\u00EF\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131'
        },
        {
            'base': 'j',
            'letters': '\u006A\u24D9\uFF4A\u0135\u01F0\u0249'
        },
        {
            'base': 'k',
            'letters': '\u006B\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3'
        },
        {
            'base': 'l',
            'letters': '\u006C\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747'
        },
        {
            'base': 'lj',
            'letters': '\u01C9'
        },
        {
            'base': 'm',
            'letters': '\u006D\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F'
        },
        {
            'base': 'n',
            'letters': '\x6E\xF1\u006E\u24DD\uFF4E\u01F9\u0144\u00F1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5\u043B\u0509'
        },
        {
            'base': 'nj',
            'letters': '\u01CC'
        },
        {
            'base': 'o',
            'letters': '\u07C0\u006F\u24DE\uFF4F\u00F2\u00F3\u00F4\u1ED3\u1ED1\u1ED7\u1ED5\u00F5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\u00F6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\u00F8\u01FF\u0254\uA74B\uA74D\u0275'
        },
        {
            'base': 'oe',
            'letters': '\u0152\u0153'
        },
        {
            'base': 'oi',
            'letters': '\u01A3'
        },
        {
            'base': 'ou',
            'letters': '\u0223'
        },
        {
            'base': 'oo',
            'letters': '\uA74F'
        },
        {
            'base': 'p',
            'letters': '\u0070\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755'
        },
        {
            'base': 'q',
            'letters': '\u0071\u24E0\uFF51\u024B\uA757\uA759'
        },
        {
            'base': 'r',
            'letters': '\u0072\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783'
        },
        {
            'base': 's',
            'letters': '\u0073\u24E2\uFF53\u00DF\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B'
        },
        {
            'base': 'ss',
            'letters': '\xDF'
        },
        {
            'base': 't',
            'letters': '\u0074\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787'
        },
        {
            'base': 'th',
            'letters': '\u00FE'
        },
        {
            'base': 'tz',
            'letters': '\uA729'
        },
        {
            'base': 'u',
            'letters': '\u0075\u24E4\uFF55\u00F9\u00FA\u00FB\u0169\u1E79\u016B\u1E7B\u016D\u00FC\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289'
        },
        {
            'base': 'v',
            'letters': '\u0076\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C'
        },
        {
            'base': 'vy',
            'letters': '\uA761'
        },
        {
            'base': 'w',
            'letters': '\u0077\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73'
        },
        {
            'base': 'x',
            'letters': '\u0078\u24E7\uFF58\u1E8B\u1E8D'
        },
        {
            'base': 'y',
            'letters': '\u0079\u24E8\uFF59\u1EF3\u00FD\u0177\u1EF9\u0233\u1E8F\u00FF\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF'
        },
        {
            'base': 'z',
            'letters': '\u007A\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763'
        }
    ];
    // Generate reference mapping
    for(var i = 0, refLength = reference.length; i < refLength; i++){
        var letters = reference[i].letters.split("");
        for(var j = 0, letLength = letters.length; j < letLength; j++)output.map[letters[j]] = reference[i].base;
    }
    /**
   * Clean accents (diacritics) from string.
   * 
   * @param  {String} input String to be cleaned of diacritics.
   * @return {String}
   */ output.clean = function(input) {
        if (!input || !input.length || input.length < 1) return "";
        var string = "";
        var letters = input.split("");
        var index = 0;
        var length = letters.length;
        var letter;
        for(; index < length; index++){
            letter = letters[index];
            string += letter in output.map ? output.map[letter] : letter;
        }
        return string;
    };
    return output;
});

});


parcelRegister("fMwg8", function(module, exports) {

$parcel$export(module.exports, "default", () => $c16c8b251f81de6a$export$2e2bcd8739ae039);
parcelRequire("fPS7b");
parcelRequire("c66Ur");
parcelRequire("bO7qL");
parcelRequire("d0pqD");

var $aq199 = parcelRequire("aq199");

var $aPZf4 = parcelRequire("aPZf4");

var $bBMvo = parcelRequire("bBMvo");

var $yKIn9 = parcelRequire("yKIn9");

var $6L3iv = parcelRequire("6L3iv");
const $c16c8b251f81de6a$export$95395d1f872e0bb5 = ()=>Math.random().toString(36).replace(/[^a-z]+/g, '').substr(0, 5).toUpperCase();
const $c16c8b251f81de6a$var$failureAnalytics = ({ message: message })=>{
    (0, $yKIn9.sendTrackAnalyticsEvent)({
        source: 'space.key',
        action: 'error',
        actionSubject: 'randomly.generate',
        attributes: {
            errorMessage: message
        }
    });
};
const $c16c8b251f81de6a$var$successAnalytics = ()=>{
    (0, $yKIn9.sendTrackAnalyticsEvent)({
        source: 'space.key',
        action: 'success',
        actionSubject: 'randomly.generate'
    });
};
const $c16c8b251f81de6a$var$RETRY_ATTEMPTS = 3;
var $c16c8b251f81de6a$export$2e2bcd8739ae039 = (action$, store)=>action$.ofType((0, $aPZf4.NO_VALID_KEY)).mergeMap(()=>(0, $aq199.of)(null).mergeMap(()=>{
            const generatedKey = $c16c8b251f81de6a$export$95395d1f872e0bb5();
            return (0, $bBMvo.checkConfluenceSpaceAvailability$)(generatedKey, (0, $6L3iv.getProjectId)(store.getState()), (0, $6L3iv.getProjectType)(store.getState())).map(({ available: available, key: key })=>{
                if (available) {
                    $c16c8b251f81de6a$var$successAnalytics();
                    return (0, $aPZf4.updateSuggestedKey)(key);
                }
                throw new Error('Random key not available');
            });
        }).retry($c16c8b251f81de6a$var$RETRY_ATTEMPTS).catch((error)=>{
            $c16c8b251f81de6a$var$failureAnalytics(error);
            return (0, $aq199.of)((0, $aPZf4.noValidKeyFailure)());
        }));

});

parcelRegister("4OylY", function(module, exports) {

$parcel$export(module.exports, "default", () => $2acb4277a615a920$export$2e2bcd8739ae039);
parcelRequire("6cbqE");
parcelRequire("d0pqD");
parcelRequire("c66Ur");
parcelRequire("7mHDu");
parcelRequire("1oQta");

var $faGMz = parcelRequire("faGMz");

var $aq199 = parcelRequire("aq199");

var $e1AU2 = parcelRequire("e1AU2");

var $2nAWZ = parcelRequire("2nAWZ");

var $yKIn9 = parcelRequire("yKIn9");


var $d8Nxe = parcelRequire("d8Nxe");

var $aPZf4 = parcelRequire("aPZf4");

var $2ja74 = parcelRequire("2ja74");

var $b7YHH = parcelRequire("b7YHH");

var $bBMvo = parcelRequire("bBMvo");

var $9MB7L = parcelRequire("9MB7L");


var $hFWlI = parcelRequire("hFWlI");

var $dAzMx = parcelRequire("dAzMx");

var $4iqmv = parcelRequire("4iqmv");

var $VSDnB = parcelRequire("VSDnB");
const $2acb4277a615a920$var$missingCloudId = ()=>{
    (0, $yKIn9.sendTrackAnalyticsEvent)({
        source: 'space.create',
        action: 'missing',
        actionSubject: 'cloudId',
        attributes: {
            errorMessage: 'Missing cloudId in tenant context'
        }
    });
};
const $2acb4277a615a920$var$updateProjectSpaceAnalytics = ()=>{
    (0, $yKIn9.sendTrackAnalyticsEvent)({
        source: 'project.space',
        action: 'update',
        actionSubject: 'link'
    });
};
/**
 * Finds the root page of the space intended to be linked to the project and
 * sends a PUT request to xflow to store the project + space link
 * @param action$
 */ const $2acb4277a615a920$var$putProjectSpaceLink = (action$, store)=>action$.ofType((0, $aPZf4.PUT_PROJECT_SPACE_LINK)).switchMap((action)=>{
        const state = store.getState();
        const { spaceKey: spaceKey, spaceUrl: spaceUrl, projectKey: projectKey, projectId: projectId, autoCreated: autoCreated = false, spaceId: spaceId, connectedSpaceId: connectedSpaceId, connectedPageId: connectedPageId } = action;
        const selectedSpace = (0, $2ja74.getSelectedSpace)(state);
        const userEnteredSpaceName = (0, $b7YHH.getUserEnteredSpaceName)(state);
        const connectedSpaceOrPageTitle = selectedSpace?.linkedPageTitle || selectedSpace?.spaceName || userEnteredSpaceName;
        const connectedSpaceOrPageUrl = selectedSpace?.linkedPageUrl || selectedSpace?.spaceUrl || spaceUrl;
        const isConnectedToPage = Boolean(selectedSpace?.linkedPageTitle);
        const isConnectedToLiveDoc = Boolean(selectedSpace?.isLiveDoc);
        const cloudId = (0, $9MB7L.getCloudId)(state);
        if (!cloudId) {
            $2acb4277a615a920$var$missingCloudId();
            return (0, $aPZf4.putProjectSpaceLinkError)();
        }
        const dispatchOnSuccessActions = ()=>{
            const updateLinkAction = isConnectedToPage ? (0, $aPZf4.updateConnectedSpaceOrPageContent)({
                title: connectedSpaceOrPageTitle,
                url: connectedSpaceOrPageUrl,
                projectSpacePageTitleHasBeenFetched: true,
                isConnectedToPage: isConnectedToPage,
                iconUrl: null,
                pageId: null
            }) : (0, $aPZf4.fetchConnectedSpace)(spaceKey);
            return (0, $2nAWZ.concat)((0, $aq199.of)((0, $aPZf4.successfullyConnectedSpace)(connectedSpaceOrPageTitle, isConnectedToPage, isConnectedToLiveDoc)), (0, $aq199.of)((0, $aPZf4.updateProjectSpaceLink)(spaceKey, selectedSpace?.linkedPageId ? selectedSpace.linkedPageId : null)), (0, $aq199.of)(updateLinkAction), (0, $aq199.of)((0, $aPZf4.updateConfluenceSpaceConnectionState)(spaceKey ? (0, $49cd111a962d9af5$export$1a9cf3a686991f62) : (0, $49cd111a962d9af5$export$4c83162cd5864fb8))));
        };
        // First create the new project -> space/page association
        return (0, $bBMvo.createProjectSpaceLink$)({
            linkedPageId: selectedSpace?.linkedPageId ? selectedSpace?.linkedPageId : null,
            cloudId: cloudId,
            projectId: projectId,
            spaceId: spaceId
        }).switchMap(()=>{
            (0, $d8Nxe.fetchSuccess)('put.project.space', {
                spaceKey: spaceKey,
                projectKey: projectKey,
                autoCreated: autoCreated
            });
            // If new project -> space/page association succeeds, delete the old project -> space/page association
            return (0, $bBMvo.deleteProjectSpaceLink$)({
                linkedPageId: connectedPageId ?? null,
                cloudId: cloudId,
                projectId: projectId,
                spaceId: connectedSpaceId
            }).switchMap(()=>{
                (0, $d8Nxe.fetchSuccess)('delete.project.space', {
                    spaceKey: spaceKey,
                    projectKey: projectKey
                });
                return dispatchOnSuccessActions();
            }).catch((err)=>{
                (0, $d8Nxe.fetchFailed)('delete.project.space', err);
                /**
						 * If this catch block is hit it means the previous association was unable to be deleted, but the new association was still created.
						 * Therefore we dispatch success actions here to ensure the UI is updated to show the newly associated space/page.
						 * This is an edge case and should be quite rare, it is tied to the reliability of AGG / AGS.
						 */ return dispatchOnSuccessActions();
            });
        }).catch((err)=>{
            (0, $d8Nxe.fetchFailed)('put.project.space', err, {
                autoCreated: autoCreated
            });
            return (0, $2nAWZ.concat)((0, $aq199.of)((0, $aPZf4.putProjectSpaceLinkError)()), (0, $aq199.of)((0, $aPZf4.updateConfluenceSpaceConnectionState)((0, $49cd111a962d9af5$export$103bedf43ba882db))));
        });
    });
/**
 * Sends a GET request to xflow to retrieve the project + space link
 * Note: returned space may have been deleted already. Another issue should handle this.
 * @param action$
 */ const $2acb4277a615a920$var$getProjectSpaceLink = (action$, store)=>(0, $dAzMx.combineLatest)(action$.ofType((0, $4iqmv.UPDATE_PERSONALIZATION_SITE_TRAITS)), action$.ofType((0, $aPZf4.UPDATE_CONFLUENCE_SPACES)), action$.ofType((0, $aPZf4.GET_PROJECT_SPACE_LINK))).take(1).switchMap(([traits, spaces, action])=>{
        const state = store.getState();
        const { projectId: projectId } = action;
        const cloudId = (0, $9MB7L.getCloudId)(state);
        if (!cloudId) throw new Error('Error fetching project space link: missing cloudId in tenant context');
        return (0, $bBMvo.fetchProjectSpaceLink$)(cloudId, projectId).switchMap(({ spaceKey: spaceKey, linkedPageId: linkedPageId, arisOfRelationshipsToDelete: arisOfRelationshipsToDelete })=>{
            // If there is a corrupt existing relationship to a page or space, delete the relationship and display the "not connected" state to allow the user to conenct a new space
            if (arisOfRelationshipsToDelete && (0, $VSDnB.fg)('project_pages_delete_corrupt_relationships')) {
                const projectAri = $2acb4277a615a920$var$buildProjectAri(cloudId, projectId).projectAri;
                const deleteOperations = arisOfRelationshipsToDelete.map((ari)=>(0, $bBMvo.deleteProjectSpaceLinkWithAri$)(projectAri, ari).catch((err)=>{
                        (0, $d8Nxe.fetchFailed)('delete.project.space', err);
                        return (0, $aq199.of)(null);
                    }));
                return (0, $faGMz.forkJoin)(deleteOperations).switchMap(()=>{
                    (0, $d8Nxe.fetchSuccess)('delete.project.space');
                    return (0, $2nAWZ.concat)((0, $aq199.of)((0, $aPZf4.updateProjectSpaceLink)(null, null)), (0, $aq199.of)((0, $aPZf4.updateConfluenceSpaceConnectionState)((0, $49cd111a962d9af5$export$4c83162cd5864fb8))));
                });
            }
            (0, $d8Nxe.fetchSuccess)('fetch.project.space');
            $2acb4277a615a920$var$updateProjectSpaceAnalytics();
            return (0, $2nAWZ.concat)([
                (0, $aPZf4.updateProjectSpaceLink)(spaceKey || null, linkedPageId || null),
                (0, $aPZf4.updateConfluenceSpaceConnectionState)(spaceKey ? (0, $49cd111a962d9af5$export$1a9cf3a686991f62) : (0, $49cd111a962d9af5$export$4c83162cd5864fb8))
            ]);
        }).catch((err)=>{
            if (err.statusCode === (0, $98318a085d858628$export$8bca792d963eb0ef)) {
                // no project space stored previously. Treat as success and clear confluence space link
                (0, $d8Nxe.fetchSuccess)('updated.previously.empty.project.space');
                const isAutoProvisionFlow = (0, $hFWlI.shouldCreateSpaceForAutoProvisionedConfluence)(state);
                return (0, $2nAWZ.concat)([
                    (0, $aPZf4.updateProjectSpaceLink)(null, null),
                    ...!isAutoProvisionFlow ? [
                        (0, $aPZf4.updateConfluenceSpaceConnectionState)((0, $49cd111a962d9af5$export$4c83162cd5864fb8))
                    ] : []
                ]);
            }
            (0, $d8Nxe.fetchFailed)('fetch.project.space', err);
            return (0, $aq199.of)((0, $aPZf4.getProjectSpaceLinkError)());
        });
    });
const $2acb4277a615a920$var$buildProjectAri = (cloudId, projectId)=>{
    const projectAri = `ari:cloud:jira:${cloudId}:project/${projectId}`;
    return {
        projectAri: projectAri
    };
};
var $2acb4277a615a920$export$2e2bcd8739ae039 = (0, $e1AU2.combineEpics)($2acb4277a615a920$var$putProjectSpaceLink, $2acb4277a615a920$var$getProjectSpaceLink);

});

parcelRegister("1BdfT", function(module, exports) {

$parcel$export(module.exports, "default", () => $17aa8501d2212c42$export$2e2bcd8739ae039);
parcelRequire("d0pqD");
parcelRequire("6cbqE");
parcelRequire("c66Ur");

var $aq199 = parcelRequire("aq199");

var $d8Nxe = parcelRequire("d8Nxe");

var $aPZf4 = parcelRequire("aPZf4");

var $bBMvo = parcelRequire("bBMvo");

var $6L3iv = parcelRequire("6L3iv");
const $17aa8501d2212c42$var$decodeHtml = (html)=>{
    const txt = document.createElement('textarea');
    txt.innerHTML = html;
    return txt.value;
};
var $17aa8501d2212c42$export$2e2bcd8739ae039 = (action$, store)=>action$.ofType((0, $aPZf4.FETCH_CONFLUENCE_SPACES)).switchMap(()=>(0, $bBMvo.requestConfluenceSpaces$)((0, $6L3iv.getProjectId)(store.getState()), (0, $6L3iv.getProjectType)(store.getState())).map((value)=>{
            (0, $d8Nxe.fetchSuccess)('confluence.spaces');
            return (0, $aPZf4.updateConfluenceSpaces)(value.map((space)=>({
                    spaceKey: space.id,
                    spaceName: $17aa8501d2212c42$var$decodeHtml(space.text)
                })));
        }).catch((err)=>{
            (0, $d8Nxe.fetchFailed)('confluence.spaces', err);
            return (0, $aq199.of)((0, $aPZf4.fetchConfluenceSpacesError)());
        }));

});

parcelRegister("auLvV", function(module, exports) {

$parcel$export(module.exports, "default", () => $6a9a9caf71cf2657$export$2e2bcd8739ae039);
parcelRequire("6cbqE");
parcelRequire("c66Ur");

var $8B7Oi = parcelRequire("8B7Oi");

var $d8Nxe = parcelRequire("d8Nxe");

var $aPZf4 = parcelRequire("aPZf4");

var $bBMvo = parcelRequire("bBMvo");

var $6L3iv = parcelRequire("6L3iv");
var $6a9a9caf71cf2657$export$2e2bcd8739ae039 = (action$, store)=>action$.ofType((0, $aPZf4.SET_FIRST_SPACE_CREATED_FLAG)).switchMap(()=>(0, $bBMvo.putFirstSpaceCreatedFlag$)((0, $6L3iv.getProjectId)(store.getState()), (0, $6L3iv.getProjectType)(store.getState())).switchMap(()=>{
            (0, $d8Nxe.fetchSuccess)('confluence.first.space.created.flag');
            return (0, $8B7Oi.empty)();
        }).catch((err)=>{
            (0, $d8Nxe.fetchFailed)('confluence.first.space.created.flag', err);
            return (0, $8B7Oi.empty)();
        }));

});

parcelRegister("42LbU", function(module, exports) {

$parcel$export(module.exports, "default", () => $f5ef78c237027a53$export$2e2bcd8739ae039);
parcelRequire("fPS7b");
parcelRequire("ihPQR");
parcelRequire("c66Ur");

var $aq199 = parcelRequire("aq199");

var $bXPjr = parcelRequire("bXPjr");

var $8B7Oi = parcelRequire("8B7Oi");
parcelRequire("l1d2F");
var $bHpB9 = parcelRequire("bHpB9");
var $jWY5k = parcelRequire("jWY5k");

var $aPZf4 = parcelRequire("aPZf4");

var $5qiRH = parcelRequire("5qiRH");

var $yKIn9 = parcelRequire("yKIn9");

const $f5ef78c237027a53$var$IS_CROSS_SELL = true;
var $f5ef78c237027a53$export$2e2bcd8739ae039 = (action$, store)=>action$.ofType((0, $aPZf4.INVOKE_CROSS_FLOW)).mergeMap((action)=>{
        const state = store.getState();
        const crossFlow = (0, $5qiRH.getCrossFlowApi)(state);
        if (crossFlow.isEnabled) return (0, $bXPjr.fromPromise)(crossFlow.api.open({
            journey: action.contextInfo ? (0, $bHpB9.Journeys).GET_STARTED : (0, $bHpB9.Journeys).DECIDE,
            targetProduct: (0, $jWY5k.Targets).CONFLUENCE,
            sourceComponent: (0, $9d339e91f7cbd39e$export$400f359cf7604d7a),
            sourceContext: (0, $9d339e91f7cbd39e$export$e776c72d9769c47a),
            experimentalOptions: {
                isCrossSell: $f5ef78c237027a53$var$IS_CROSS_SELL,
                contextInfo: action.contextInfo
            }
        })).mergeMap(()=>(0, $8B7Oi.empty)()).catch((_)=>{
            return (0, $aq199.of)((0, $aPZf4.showXflowDialogError)());
        });
        (0, $yKIn9.sendOperationalAnalyticsEvent)({
            source: 'projectPages',
            action: 'failed',
            actionSubject: 'invokeCrossFlowEpic',
            attributes: {
                reason: crossFlow.reason
            }
        });
        return (0, $aq199.of)((0, $aPZf4.showXflowDialogError)());
    });

});
parcelRegister("5qiRH", function(module, exports) {

$parcel$export(module.exports, "getCrossFlowApi", () => $590525d8468e0743$export$a38e110f7441e437);
const $590525d8468e0743$export$a38e110f7441e437 = (state)=>state.external.crossFlow;
const $590525d8468e0743$export$2b73c7b4d0c976b4 = (state)=>state.external.onFireExposureEvent;

});


parcelRegister("24HnK", function(module, exports) {

$parcel$export(module.exports, "default", () => $b0a2b7fd5f6e3c7a$export$2e2bcd8739ae039);
parcelRequire("6cbqE");

var $8B7Oi = parcelRequire("8B7Oi");

var $aq199 = parcelRequire("aq199");

var $aPZf4 = parcelRequire("aPZf4");
var $b0a2b7fd5f6e3c7a$export$2e2bcd8739ae039 = (action$)=>action$.ofType((0, $aPZf4.UPDATE_PROJECT_SPACE_LINK)).switchMap(({ spaceKey: spaceKey })=>spaceKey !== null ? (0, $aq199.of)((0, $aPZf4.fetchConnectedSpaceBlueprints)()) : (0, $8B7Oi.empty)());

});

parcelRegister("4OTlM", function(module, exports) {

$parcel$export(module.exports, "default", () => $b14d1dec2acbcfb8$export$2e2bcd8739ae039);
parcelRequire("6cbqE");
parcelRequire("fPS7b");
parcelRequire("c66Ur");

var $aq199 = parcelRequire("aq199");

var $aPZf4 = parcelRequire("aPZf4");

var $9MB7L = parcelRequire("9MB7L");

var $bBMvo = parcelRequire("bBMvo");

var $d8Nxe = parcelRequire("d8Nxe");

var $8c8di = parcelRequire("8c8di");
const $b14d1dec2acbcfb8$var$LICENCE_EXCEEDED_ERROR_CODE = 'licence-exceeded';
const $b14d1dec2acbcfb8$var$confluenceAccessRequestCapabilitiesEpic = (action$, store)=>action$.ofType((0, $aPZf4.FETCH_CONFLUENCE_ACCESS_REQUEST_CAPABILITIES)).switchMap(()=>{
        const state = store.getState();
        const cloudId = (0, $9MB7L.getCloudId)(state);
        return (0, $bBMvo.getConfluenceAccessRequestCapabilities$)(cloudId).mergeMap((response)=>{
            (0, $d8Nxe.fetchSuccess)('confluence.access-request-capabilities');
            const results = Object.values(response.results);
            // check we got exactly 1 result and the result is known, otherwise error
            if (results.length !== 1 || !Object.values((0, $8c8di.AccessRequestCapabilityType)).includes(results[0])) return (0, $aq199.of)((0, $aPZf4.updateConfluenceAccessRequestCapabilities)((0, $8c8di.AccessRequestCapabilityType).ERROR));
            return (0, $aq199.of)((0, $aPZf4.updateConfluenceAccessRequestCapabilities)(results[0]));
        }).catch((err)=>{
            let shouldFireOperationalEvent = true;
            try {
                const errorMessageObject = JSON.parse(err?.message);
                // do not fire failure event if it's a 'licence-exceeded' error
                if (errorMessageObject?.code === $b14d1dec2acbcfb8$var$LICENCE_EXCEEDED_ERROR_CODE) shouldFireOperationalEvent = false;
            } catch (e) {
                //Not a valid JSON, should fire failure event
                shouldFireOperationalEvent = true;
            }
            shouldFireOperationalEvent && (0, $d8Nxe.fetchFailed)('confluence.access-request-capabilities', err);
            return (0, $aq199.of)((0, $aPZf4.updateConfluenceAccessRequestCapabilities)((0, $8c8di.AccessRequestCapabilityType).ERROR));
        });
    });
var $b14d1dec2acbcfb8$export$2e2bcd8739ae039 = $b14d1dec2acbcfb8$var$confluenceAccessRequestCapabilitiesEpic;

});

parcelRegister("aFTec", function(module, exports) {

$parcel$export(module.exports, "default", () => $aa2cbc184238aa8b$export$2e2bcd8739ae039);
parcelRequire("6cbqE");
parcelRequire("fPS7b");
parcelRequire("c66Ur");

var $aq199 = parcelRequire("aq199");

var $aPZf4 = parcelRequire("aPZf4");

var $9MB7L = parcelRequire("9MB7L");

var $d8Nxe = parcelRequire("d8Nxe");

var $1ain7 = parcelRequire("1ain7");

var $6L3iv = parcelRequire("6L3iv");
const $aa2cbc184238aa8b$var$confluenceCollaboratorsEpic = (action$, store)=>action$.ofType((0, $aPZf4.FETCH_CONFLUENCE_COLLABORATORS)).switchMap(()=>{
        const state = store.getState();
        const cloudId = (0, $9MB7L.getCloudId)(state);
        const userId = (0, $9MB7L.getAccountId)(state);
        const projectId = (0, $6L3iv.getProjectId)(state);
        return (0, $1ain7.getSuggestedPeople$)(cloudId, userId, projectId).mergeMap((collaborators)=>{
            (0, $d8Nxe.fetchSuccess)('site.collaborators');
            return (0, $aq199.of)((0, $aPZf4.updateConfluenceCollaborators)(collaborators));
        }).catch((err)=>{
            (0, $d8Nxe.fetchFailed)('site.collaborators', err);
            return (0, $aq199.of)((0, $aPZf4.updateConfluenceCollaborators)([]));
        });
    });
var $aa2cbc184238aa8b$export$2e2bcd8739ae039 = $aa2cbc184238aa8b$var$confluenceCollaboratorsEpic;

});
parcelRegister("1ain7", function(module, exports) {

$parcel$export(module.exports, "getSuggestedPeople$", () => $12cdd777720dc265$export$b976047653fe5487);
parcelRequire("d0pqD");

var $aWcOP = parcelRequire("aWcOP");
const $12cdd777720dc265$var$SUGGESTED_PEOPLE_URL = '/gateway/api/v1/recommendations';
const $12cdd777720dc265$export$b976047653fe5487 = (cloudId, userId, projectId)=>(0, $aWcOP.default)($12cdd777720dc265$var$SUGGESTED_PEOPLE_URL, {
        credentials: 'include',
        method: 'POST',
        body: JSON.stringify({
            context: {
                contextType: 'Mentions, Assignee, Generic, <BYO>',
                principalId: userId,
                siteId: cloudId,
                productKey: 'jira',
                containerId: projectId
            },
            searchQuery: {
                queryString: ''
            },
            maxNumberOfResults: 10,
            filter: '(NOT not_mentionable:true) AND (account_status:active)'
        })
    }).map((response)=>{
        return response.recommendedUsers.filter((account)=>account.id !== userId).map((account)=>({
                id: account.id,
                name: account.name,
                avatarUrl: account.avatarUrl
            }));
    });

});


parcelRegister("kyhTh", function(module, exports) {

$parcel$export(module.exports, "default", () => $bc74aec175ebc8cd$export$2e2bcd8739ae039);
parcelRequire("6cbqE");
parcelRequire("fPS7b");
parcelRequire("c66Ur");

var $aq199 = parcelRequire("aq199");

var $8B7Oi = parcelRequire("8B7Oi");

var $aPZf4 = parcelRequire("aPZf4");

var $cEp5g = parcelRequire("cEp5g");

var $bBMvo = parcelRequire("bBMvo");

var $d8Nxe = parcelRequire("d8Nxe");

var $6L3iv = parcelRequire("6L3iv");
const $bc74aec175ebc8cd$var$fetchConnectedSpaceOrPageTitleEpic = (action$, store)=>action$.ofType((0, $aPZf4.FETCH_CONNECTED_SPACE_OR_PAGE_TITLE)).switchMap(()=>{
        const state = store.getState();
        const pageId = (0, $cEp5g.getProjectPageLinkedId)(state);
        const isConnectedToPage = Boolean((0, $cEp5g.getProjectPageLinkedId)(state));
        const spaceKey = (0, $cEp5g.getProjectSpaceKey)(state);
        // if we are connected to a space, use the fetchConnectedSpace to update the state
        if (spaceKey && !isConnectedToPage) return (0, $aq199.of)((0, $aPZf4.fetchConnectedSpace)(spaceKey));
        if (!pageId) return (0, $8B7Oi.empty)();
        // otherwise fetch page content and update page title etc
        return (0, $bBMvo.getConfluencePageContent$)(pageId, (0, $6L3iv.getProjectId)(state), (0, $6L3iv.getProjectType)(state)).mergeMap(({ title: title, _links: { webui: webui, base: base }, subType: subType })=>{
            const url = `${base}${webui}`;
            (0, $d8Nxe.fetchSuccess)('confluence.content');
            return (0, $aq199.of)((0, $aPZf4.updateConnectedSpaceOrPageContent)({
                title: title,
                url: url,
                isConnectedToPage: isConnectedToPage,
                isConnectedToLiveDoc: subType === 'live',
                projectSpacePageTitleHasBeenFetched: true,
                iconUrl: null,
                pageId: pageId
            }));
        }).catch((err)=>{
            (0, $d8Nxe.fetchFailed)('confluence.content', err);
            return (0, $aq199.of)((0, $aPZf4.updateConnectedSpaceOrPageContent)({
                title: null,
                iconUrl: null,
                projectSpacePageTitleHasBeenFetched: true,
                pageId: pageId
            }));
        });
    });
var $bc74aec175ebc8cd$export$2e2bcd8739ae039 = $bc74aec175ebc8cd$var$fetchConnectedSpaceOrPageTitleEpic;

});

parcelRegister("9CWy4", function(module, exports) {

$parcel$export(module.exports, "default", () => $aac8b8a114c794ef$export$2e2bcd8739ae039);
parcelRequire("6cbqE");
parcelRequire("fPS7b");
parcelRequire("c66Ur");

var $aq199 = parcelRequire("aq199");

var $aPZf4 = parcelRequire("aPZf4");

var $bBMvo = parcelRequire("bBMvo");

var $d8Nxe = parcelRequire("d8Nxe");

var $6L3iv = parcelRequire("6L3iv");
const $aac8b8a114c794ef$var$fetchConnectedSpaceEpic = (action$, store)=>action$.ofType((0, $aPZf4.FETCH_CONNECTED_SPACE)).switchMap(({ spaceKey: spaceKey })=>{
        return (0, $bBMvo.getConfluenceSpace$)(spaceKey, (0, $6L3iv.getProjectId)(store.getState()), (0, $6L3iv.getProjectType)(store.getState())).mergeMap(({ id: id, name: name, homepage: homepage, icon: { path: iconPath }, _links: { base: base, webui: webui } })=>{
            (0, $d8Nxe.fetchSuccess)('confluence.space');
            return (0, $aq199.of)((0, $aPZf4.updateConnectedSpaceOrPageContent)({
                spaceId: id,
                title: name,
                isConnectedToPage: false,
                projectSpacePageTitleHasBeenFetched: true,
                url: `${base}${webui}`,
                iconUrl: `${base}${iconPath}`,
                pageId: homepage?.id || null
            }));
        }).catch((err)=>{
            (0, $d8Nxe.fetchFailed)('confluence.space', err);
            return (0, $aq199.of)((0, $aPZf4.updateConnectedSpaceOrPageContent)({
                spaceId: null,
                title: null,
                iconUrl: null,
                projectSpacePageTitleHasBeenFetched: true,
                pageId: null
            }));
        });
    });
var $aac8b8a114c794ef$export$2e2bcd8739ae039 = $aac8b8a114c794ef$var$fetchConnectedSpaceEpic;

});

parcelRegister("1velZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $4015dc91fde322f0$export$2e2bcd8739ae039);
parcelRequire("6cbqE");
parcelRequire("fPS7b");
parcelRequire("c66Ur");

var $aq199 = parcelRequire("aq199");

var $aPZf4 = parcelRequire("aPZf4");

var $2Vlv3 = parcelRequire("2Vlv3");

var $bBMvo = parcelRequire("bBMvo");

var $d8Nxe = parcelRequire("d8Nxe");

var $6L3iv = parcelRequire("6L3iv");
const $4015dc91fde322f0$var$jiraProjectPermissions = (action$, store)=>action$.ofType((0, $aPZf4.FETCH_JIRA_PROJECT_PERMISSIONS)).switchMap(()=>{
        const state = store.getState();
        const projectKey = (0, $6L3iv.getProjectKey)(state);
        return (0, $bBMvo.getJiraProjectPermissions$)(projectKey).mergeMap((response)=>{
            (0, $d8Nxe.fetchSuccess)('jira.permissions');
            const isMember = response.permissions.CREATE_ISSUES.havePermission && response.permissions.EDIT_ISSUES.havePermission;
            return (0, $aq199.of)((0, $2Vlv3.setIsMember)(isMember));
        }).catch((err)=>{
            (0, $d8Nxe.fetchFailed)('jira.permissions', err);
            // just gracefully fallback to user not being a project member if unable to fetch perms for some reason
            return (0, $aq199.of)((0, $2Vlv3.setIsMember)(false));
        });
    });
var $4015dc91fde322f0$export$2e2bcd8739ae039 = $4015dc91fde322f0$var$jiraProjectPermissions;

});

parcelRegister("4WgBW", function(module, exports) {

$parcel$export(module.exports, "default", () => $ce86d888ec0bb23b$export$2e2bcd8739ae039);
parcelRequire("6cbqE");
parcelRequire("fPS7b");
parcelRequire("c66Ur");

var $aq199 = parcelRequire("aq199");

var $gI62y = parcelRequire("gI62y");

var $aPZf4 = parcelRequire("aPZf4");

var $9MB7L = parcelRequire("9MB7L");

var $8c8di = parcelRequire("8c8di");

var $d8Nxe = parcelRequire("d8Nxe");

var $1cUoq = parcelRequire("1cUoq");

var $80gxR = parcelRequire("80gxR");

var $e6C7w = parcelRequire("e6C7w");
const $ce86d888ec0bb23b$var$confluenceInlineJoin = (action$, store)=>action$.ofType((0, $aPZf4.INLINE_JOIN_CONFLUENCE)).switchMap(()=>{
        const state = store.getState();
        const cloudId = (0, $9MB7L.getCloudId)(state);
        return (0, $1cUoq.inlineJoin$)('confluence', cloudId).pipe((0, $80gxR.mergeMap)(({ status: status, result: result })=>{
            const isRaFlow = result === (0, $8c8di.AccessRequestCapabilityType).PENDING_REQUEST_CREATED;
            /*
					For RA flow we just need to fetch access request capabilities from identity as it'll refresh the main screen 
					to show pending RA. We must not checkConfluenceAccessWithRetry as it'll send requests to Confluence
					whereby the user is still pending admin approval. All requests to Confluence endpoint will result in 403
					as expected because they don't have Confluence permission yet. 
				*/ if (isRaFlow) (0, $d8Nxe.fetchSuccess)('auto.ra.confluence');
            else (0, $d8Nxe.fetchSuccess)('inline.join.confluence');
            return (0, $gI62y.from)([
                isRaFlow ? (0, $aPZf4.fetchConfluenceAccessRequestCapabilities)() : (0, $aPZf4.checkConfluenceAccessWithRetry)()
            ]);
        }), (0, $e6C7w.catchError)((err)=>{
            (0, $d8Nxe.fetchFailed)('inline.join.confluence', err);
            return (0, $aq199.of)((0, $aPZf4.inlineJoinConfluenceFailed)());
        }));
    });
var $ce86d888ec0bb23b$export$2e2bcd8739ae039 = $ce86d888ec0bb23b$var$confluenceInlineJoin;

});

parcelRegister("k7Gxn", function(module, exports) {

$parcel$export(module.exports, "default", () => $c94e297624093f8b$export$2e2bcd8739ae039);
parcelRequire("d0pqD");
parcelRequire("6cbqE");
parcelRequire("c66Ur");

var $aq199 = parcelRequire("aq199");

var $d8Nxe = parcelRequire("d8Nxe");

var $4iqmv = parcelRequire("4iqmv");

var $bBMvo = parcelRequire("bBMvo");

var $9MB7L = parcelRequire("9MB7L");
var $c94e297624093f8b$export$2e2bcd8739ae039 = (action$, store)=>action$.ofType((0, $4iqmv.FETCH_PERSONALIZATION_SITE_TRAITS)).switchMap(()=>{
        const cloudId = (0, $9MB7L.getCloudId)(store.getState());
        return (0, $bBMvo.requestPersonalizationSiteTraits$)(cloudId).map((traits)=>{
            (0, $d8Nxe.fetchSuccess)('personalization.site.traits');
            return (0, $4iqmv.updatePersonalizationSiteTraits)(traits);
        }).catch((err)=>{
            (0, $d8Nxe.fetchFailed)('personalization.site.traits', err);
            return (0, $aq199.of)((0, $4iqmv.fetchPersonalizationSiteTraitsFailed)());
        });
    });

});

parcelRegister("5DAOv", function(module, exports) {

$parcel$export(module.exports, "default", () => $39e687596ab286f7$export$2e2bcd8739ae039);
parcelRequire("d0pqD");
parcelRequire("6cbqE");
parcelRequire("c66Ur");
parcelRequire("1oQta");

var $aq199 = parcelRequire("aq199");

var $aPZf4 = parcelRequire("aPZf4");

var $4iqmv = parcelRequire("4iqmv");
var $39e687596ab286f7$export$2e2bcd8739ae039 = (action$, store)=>action$.ofType((0, $4iqmv.UPDATE_PERSONALIZATION_SITE_TRAITS)).switchMap(()=>(0, $aq199.of)((0, $aPZf4.fetchConfluenceSpaces)()));

});

parcelRegister("8rOwk", function(module, exports) {

$parcel$export(module.exports, "default", () => $4d3d39d489d8a069$export$2e2bcd8739ae039);
parcelRequire("6cbqE");
parcelRequire("fPS7b");
parcelRequire("c66Ur");

var $aPZf4 = parcelRequire("aPZf4");

var $eg01Z = parcelRequire("eg01Z");

var $4iqmv = parcelRequire("4iqmv");

var $7a5fK = parcelRequire("7a5fK");

var $jhbRM = parcelRequire("jhbRM");

var $6y3t5 = parcelRequire("6y3t5");
var $4d3d39d489d8a069$export$2e2bcd8739ae039 = (action$, store)=>action$.ofType((0, $eg01Z.INITIALIZE_VIEW)).switchMap(()=>{
        const state = store.getState();
        const baseObservables = [
            (0, $aPZf4.checkProductsLicenceState)(),
            (0, $4iqmv.fetchPersonalizationSiteTraits)()
        ];
        if ((0, $jhbRM.isActivationMethodDetermined)(state)) return (0, $7a5fK.merge)(baseObservables);
        return (0, $7a5fK.merge)([
            ...baseObservables,
            (0, $6y3t5.planConfluenceActivation)()
        ]);
    });

});

parcelRegister("7Cgsr", function(module, exports) {

$parcel$export(module.exports, "default", () => $178a53169e3f37a0$export$2e2bcd8739ae039);
parcelRequire("6cbqE");
parcelRequire("1oQta");
parcelRequire("9zzQn");

var $aPZf4 = parcelRequire("aPZf4");

var $4iqmv = parcelRequire("4iqmv");

var $dAzMx = parcelRequire("dAzMx");

var $aq199 = parcelRequire("aq199");

var $hFWlI = parcelRequire("hFWlI");

var $6L3iv = parcelRequire("6L3iv");
var $178a53169e3f37a0$export$2e2bcd8739ae039 = (action$, store)=>(0, $dAzMx.combineLatest)(action$.ofType((0, $4iqmv.UPDATE_PERSONALIZATION_SITE_TRAITS)), action$.ofType((0, $aPZf4.UPDATE_CONFLUENCE_SPACES))).filter(()=>(0, $hFWlI.shouldCreateSpaceForAutoProvisionedConfluence)(store.getState()) === true).switchMap(()=>(0, $aq199.of)((0, $aPZf4.generateSpaceKey)((0, $6L3iv.getProjectName)(store.getState()))));

});
parcelRegister("9zzQn", function(module, exports) {
"use strict";

var $kVLXA = parcelRequire("kVLXA");

var $7kiWO = parcelRequire("7kiWO");
$kVLXA.Observable.prototype.combineLatest = $7kiWO.combineLatest;

});
parcelRegister("7kiWO", function(module, exports) {

$parcel$export(module.exports, "combineLatest", () => $016067a205d388d0$export$77fa7d86f5204e8a, (v) => $016067a205d388d0$export$77fa7d86f5204e8a = v);
var $016067a205d388d0$export$77fa7d86f5204e8a;
"use strict";

var $cuNVo = parcelRequire("cuNVo");
/* tslint:enable:max-line-length */ /**
 * Combines multiple Observables to create an Observable whose values are
 * calculated from the latest values of each of its input Observables.
 *
 * <span class="informal">Whenever any input Observable emits a value, it
 * computes a formula using the latest values from all the inputs, then emits
 * the output of that formula.</span>
 *
 * <img src="./img/combineLatest.png" width="100%">
 *
 * `combineLatest` combines the values from this Observable with values from
 * Observables passed as arguments. This is done by subscribing to each
 * Observable, in order, and collecting an array of each of the most recent
 * values any time any of the input Observables emits, then either taking that
 * array and passing it as arguments to an optional `project` function and
 * emitting the return value of that, or just emitting the array of recent
 * values directly if there is no `project` function.
 *
 * @example <caption>Dynamically calculate the Body-Mass Index from an Observable of weight and one for height</caption>
 * var weight = Rx.Observable.of(70, 72, 76, 79, 75);
 * var height = Rx.Observable.of(1.76, 1.77, 1.78);
 * var bmi = weight.combineLatest(height, (w, h) => w / (h * h));
 * bmi.subscribe(x => console.log('BMI is ' + x));
 *
 * // With output to console:
 * // BMI is 24.212293388429753
 * // BMI is 23.93948099205209
 * // BMI is 23.671253629592222
 *
 * @see {@link combineAll}
 * @see {@link merge}
 * @see {@link withLatestFrom}
 *
 * @param {ObservableInput} other An input Observable to combine with the source
 * Observable. More than one input Observables may be given as argument.
 * @param {function} [project] An optional function to project the values from
 * the combined latest values into a new value on the output Observable.
 * @return {Observable} An Observable of projected values from the most recent
 * values from each input Observable, or an array of the most recent values from
 * each input Observable.
 * @method combineLatest
 * @owner Observable
 */ function $016067a205d388d0$var$combineLatest() {
    var observables = [];
    for(var _i = 0; _i < arguments.length; _i++)observables[_i - 0] = arguments[_i];
    return $cuNVo.combineLatest.apply(void 0, observables)(this);
}
$016067a205d388d0$export$77fa7d86f5204e8a = $016067a205d388d0$var$combineLatest;

});



parcelRegister("EEbHD", function(module, exports) {

$parcel$export(module.exports, "default", () => $eb1c1e77f5faed8e$export$2e2bcd8739ae039);
parcelRequire("6cbqE");
parcelRequire("1oQta");
parcelRequire("9zzQn");

var $aPZf4 = parcelRequire("aPZf4");

var $kwnxt = parcelRequire("kwnxt");

var $4iqmv = parcelRequire("4iqmv");

var $dAzMx = parcelRequire("dAzMx");

var $aq199 = parcelRequire("aq199");

var $hFWlI = parcelRequire("hFWlI");
var $eb1c1e77f5faed8e$export$2e2bcd8739ae039 = (action$, store)=>(0, $dAzMx.combineLatest)(action$.ofType((0, $4iqmv.UPDATE_PERSONALIZATION_SITE_TRAITS)), action$.ofType((0, $aPZf4.UPDATE_SUGGESTED_KEY))).filter(()=>(0, $hFWlI.shouldCreateSpaceForAutoProvisionedConfluence)(store.getState()) === true).switchMap(()=>(0, $aq199.of)((0, $kwnxt.createConfluenceSpace)(true)));

});

parcelRegister("jXVi3", function(module, exports) {

$parcel$export(module.exports, "default", () => $6191d078ae639157$export$2e2bcd8739ae039);
parcelRequire("6cbqE");
parcelRequire("fPS7b");
parcelRequire("c66Ur");

var $aq199 = parcelRequire("aq199");

var $d8Nxe = parcelRequire("d8Nxe");

var $9MB7L = parcelRequire("9MB7L");

var $6L3iv = parcelRequire("6L3iv");

var $bBMvo = parcelRequire("bBMvo");

var $6y3t5 = parcelRequire("6y3t5");

var $jhbRM = parcelRequire("jhbRM");

var $jXVTV = parcelRequire("jXVTV");

var $aPZf4 = parcelRequire("aPZf4");

var $fTJXm = parcelRequire("fTJXm");


var $yKIn9 = parcelRequire("yKIn9");
const $6191d078ae639157$var$provisioningStatusToActivationStatusMap = {
    PROVISIONING_IN_PROGRESS: 'activating',
    PROVISIONING_FAILED: 'error',
    PROVISIONING_COMPLETED: 'completed',
    PROVISIONING_PROCESS_NOT_FOUND: 'not-allowed'
};
var $6191d078ae639157$export$2e2bcd8739ae039 = (action$, store)=>action$.ofType((0, $6y3t5.PLAN_ACTIVATION), (0, $aPZf4.UPDATE_CONFLUENCE_STATE)).filter(()=>{
        const state = store.getState();
        const activationStatus = (0, $jhbRM.getActivationStatus)(state);
        const project = (0, $6L3iv.getProject)(state);
        const cloudId = (0, $9MB7L.getCloudId)(state);
        const confluenceState = (0, $9MB7L.getConfluenceState)(state);
        return !!project && !!cloudId && confluenceState !== (0, $fTJXm.CONFLUENCE_LOADING) && activationStatus === 'not-started';
    }).switchMap(()=>{
        const state = store.getState();
        const confluenceState = (0, $9MB7L.getConfluenceState)(state);
        if (!(0, $jXVTV.getTargetingGate)('jsw_project_pages_on_demand_provisioning') || [
            (0, $fTJXm.CONFLUENCE_ACTIVE),
            (0, $fTJXm.CONFLUENCE_ACTIVATING),
            (0, $fTJXm.CONFLUENCE_ERROR)
        ].includes(confluenceState)) return (0, $aq199.of)((0, $6y3t5.updateConfluenceActivationStatus)({
            status: 'not-allowed'
        }));
        const isAdmin = (0, $9MB7L.isSiteAdmin)(state);
        if (!(0, $jXVTV.getTargetingGate)('project-pages-on-demand-tel-gate') && !isAdmin) return (0, $aq199.of)((0, $6y3t5.updateConfluenceActivationStatus)({
            status: 'not-allowed'
        }));
        const project = (0, $6L3iv.getProject)(state);
        const cloudId = (0, $9MB7L.getCloudId)(state);
        return (0, $bBMvo.planConfluenceActivation$)(cloudId, {
            projectId: project.id
        }).mergeMap((response)=>{
            (0, $d8Nxe.fetchSuccess)('confluence.activate.plan');
            if (response.allowed) {
                // For attribution of Project Pages On Demand Biz experiment: https://hello.atlassian.net/wiki/spaces/Growth/pages/4247292714/Project+Pages+on-demand+provisioning+for+admins+in+biz+projects
                if ((0, $9MB7L.getParentProduct)(state) !== (0, $d29b7f051950917c$export$ae07618062047a87) && isAdmin) (0, $yKIn9.sendTrackAnalyticsEvent)({
                    source: '-activate-confluence-plan',
                    action: 'exposed',
                    actionSubject: 'feature',
                    attributes: {
                        experiment: 'jsw_project_pages_on_demand_biz'
                    }
                });
                if ((0, $jXVTV.getTargetingGate)('project-pages-on-demand-tel-gate-aa') && !isAdmin) (0, $jXVTV.getExperimentValue)('project-pages-on-demand-tel-aa', 'not-enrolled', true);
                if ((0, $jXVTV.getTargetingGate)('project-pages-on-demand-tel-gate') && !isAdmin) {
                    const cohort = (0, $jXVTV.getExperimentValue)('project-pages-on-demand-tel', 'not-enrolled', true);
                    if (cohort === 'variation') return (0, $aq199.of)((0, $6y3t5.updateConfluenceActivationStatus)({
                        status: 'allowed'
                    }));
                    else return (0, $aq199.of)((0, $6y3t5.updateConfluenceActivationStatus)({
                        status: 'not-allowed'
                    }));
                }
                return (0, $aq199.of)((0, $6y3t5.updateConfluenceActivationStatus)({
                    status: 'allowed'
                }));
            }
            return (0, $aq199.of)((0, $6y3t5.updateConfluenceActivationStatus)({
                status: $6191d078ae639157$var$provisioningStatusToActivationStatusMap[response.context?.status || 'PROVISIONING_PROCESS_NOT_FOUND']
            }));
        }).catch((error)=>{
            (0, $d8Nxe.fetchFailed)('confluence.activate.plan', error);
            return (0, $aq199.of)((0, $6y3t5.updateConfluenceActivationStatus)({
                status: 'not-allowed'
            }));
        });
    });

});

parcelRegister("5vrLd", function(module, exports) {

$parcel$export(module.exports, "default", () => $0e92dd6de06c7f94$export$2e2bcd8739ae039);
parcelRequire("6cbqE");
parcelRequire("fPS7b");
parcelRequire("c66Ur");

var $aq199 = parcelRequire("aq199");

var $2nAWZ = parcelRequire("2nAWZ");

var $d8Nxe = parcelRequire("d8Nxe");

var $9MB7L = parcelRequire("9MB7L");

var $6L3iv = parcelRequire("6L3iv");

var $bBMvo = parcelRequire("bBMvo");

var $6y3t5 = parcelRequire("6y3t5");

var $aPZf4 = parcelRequire("aPZf4");
var $0e92dd6de06c7f94$export$2e2bcd8739ae039 = (action$, store)=>action$.ofType((0, $6y3t5.START_ACTIVATION)).switchMap(()=>{
        const state = store.getState();
        const projectId = (0, $6L3iv.getProjectId)(state);
        const cloudId = (0, $9MB7L.getCloudId)(state);
        return (0, $bBMvo.startConfluenceActivation$)(cloudId, {
            projectId: projectId
        }).mergeMap((response)=>{
            if (!response?.started) throw new Error('Could not start confluence activation.');
            (0, $d8Nxe.fetchSuccess)('confluence.activate.start');
            return (0, $aq199.of)((0, $6y3t5.updateConfluenceActivationStatus)({
                status: 'activating'
            }));
        }).catch((error)=>{
            (0, $d8Nxe.fetchFailed)('confluence.activate.start', error);
            return (0, $2nAWZ.concat)([
                (0, $aPZf4.showActivationErrorFlag)(),
                (0, $6y3t5.updateConfluenceActivationStatus)({
                    status: 'not-allowed'
                })
            ]);
        });
    });

});

parcelRegister("c2Qnq", function(module, exports) {

$parcel$export(module.exports, "default", () => $a84cb98d6d2d8d06$export$2e2bcd8739ae039);
parcelRequire("8YUK0");
parcelRequire("cNv5j");
parcelRequire("fPS7b");
parcelRequire("6cbqE");
parcelRequire("7qVV7");

var $aq199 = parcelRequire("aq199");

var $jKX30 = parcelRequire("jKX30");

var $6y3t5 = parcelRequire("6y3t5");

var $jhbRM = parcelRequire("jhbRM");

var $bBMvo = parcelRequire("bBMvo");

var $d8Nxe = parcelRequire("d8Nxe");

var $9MB7L = parcelRequire("9MB7L");
const $a84cb98d6d2d8d06$var$MAX_RETRIES = 50;
const $a84cb98d6d2d8d06$var$POLL_INTERVAL = 3000;
const $a84cb98d6d2d8d06$var$INITIAL_DELAY = 6000;
var $a84cb98d6d2d8d06$export$2e2bcd8739ae039 = (action$, store)=>action$.ofType((0, $6y3t5.CHECK_ACTIVATION_STATUS)).takeUntil(action$.ofType((0, $6y3t5.CHECK_ACTIVATION_STATUS_ERROR)) || action$.ofType((0, $6y3t5.CHECK_ACTIVATION_STATUS_SUCCESS))).delayWhen(()=>{
        const state = store.getState();
        const retryCount = (0, $jhbRM.activationStatusRetryCount)(state);
        if (retryCount === 0) return (0, $jKX30.timer)($a84cb98d6d2d8d06$var$INITIAL_DELAY);
        if (retryCount % 2 === 0) return (0, $jKX30.timer)($a84cb98d6d2d8d06$var$POLL_INTERVAL * 2);
        return (0, $jKX30.timer)($a84cb98d6d2d8d06$var$POLL_INTERVAL);
    }).switchMap(()=>{
        const state = store.getState();
        const cloudId = (0, $9MB7L.getCloudId)(state);
        const retryCount = (0, $jhbRM.activationStatusRetryCount)(state);
        if (retryCount > $a84cb98d6d2d8d06$var$MAX_RETRIES) return (0, $aq199.of)((0, $6y3t5.checkConfluenceActivationStatusFailed)());
        return (0, $bBMvo.checkConfluenceActivationStatus$)(cloudId).mergeMap((response)=>{
            (0, $d8Nxe.fetchSuccess)('confluence.activate.status');
            switch(response.status){
                case 'PROVISIONING_COMPLETED':
                    return (0, $aq199.of)((0, $6y3t5.checkConfluenceActivationStatusSuccess)());
                case 'PROVISIONING_FAILED':
                    return (0, $aq199.of)((0, $6y3t5.checkConfluenceActivationStatusFailed)());
                case 'PROVISIONING_IN_PROGRESS':
                default:
                    return (0, $aq199.of)((0, $6y3t5.checkConfluenceActivationStatus)());
            }
        }).catch((error)=>{
            (0, $d8Nxe.fetchFailed)('confluence.activate.status', error);
            return (0, $aq199.of)((0, $6y3t5.checkConfluenceActivationStatusFailed)());
        });
    });

});
parcelRegister("8YUK0", function(module, exports) {
"use strict";

var $kVLXA = parcelRequire("kVLXA");

var $dth4K = parcelRequire("dth4K");
$kVLXA.Observable.prototype.delayWhen = $dth4K.delayWhen;

});
parcelRegister("dth4K", function(module, exports) {

$parcel$export(module.exports, "delayWhen", () => $9ceb3aa8c9a79e4c$export$286ca829307725c9, (v) => $9ceb3aa8c9a79e4c$export$286ca829307725c9 = v);
var $9ceb3aa8c9a79e4c$export$286ca829307725c9;
"use strict";

var $2cpnk = parcelRequire("2cpnk");
/**
 * Delays the emission of items from the source Observable by a given time span
 * determined by the emissions of another Observable.
 *
 * <span class="informal">It's like {@link delay}, but the time span of the
 * delay duration is determined by a second Observable.</span>
 *
 * <img src="./img/delayWhen.png" width="100%">
 *
 * `delayWhen` time shifts each emitted value from the source Observable by a
 * time span determined by another Observable. When the source emits a value,
 * the `delayDurationSelector` function is called with the source value as
 * argument, and should return an Observable, called the "duration" Observable.
 * The source value is emitted on the output Observable only when the duration
 * Observable emits a value or completes.
 *
 * Optionally, `delayWhen` takes a second argument, `subscriptionDelay`, which
 * is an Observable. When `subscriptionDelay` emits its first value or
 * completes, the source Observable is subscribed to and starts behaving like
 * described in the previous paragraph. If `subscriptionDelay` is not provided,
 * `delayWhen` will subscribe to the source Observable as soon as the output
 * Observable is subscribed.
 *
 * @example <caption>Delay each click by a random amount of time, between 0 and 5 seconds</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var delayedClicks = clicks.delayWhen(event =>
 *   Rx.Observable.interval(Math.random() * 5000)
 * );
 * delayedClicks.subscribe(x => console.log(x));
 *
 * @see {@link debounce}
 * @see {@link delay}
 *
 * @param {function(value: T): Observable} delayDurationSelector A function that
 * returns an Observable for each value emitted by the source Observable, which
 * is then used to delay the emission of that item on the output Observable
 * until the Observable returned from this function emits a value.
 * @param {Observable} subscriptionDelay An Observable that triggers the
 * subscription to the source Observable once it emits any value.
 * @return {Observable} An Observable that delays the emissions of the source
 * Observable by an amount of time specified by the Observable returned by
 * `delayDurationSelector`.
 * @method delayWhen
 * @owner Observable
 */ function $9ceb3aa8c9a79e4c$var$delayWhen(delayDurationSelector, subscriptionDelay) {
    return $2cpnk.delayWhen(delayDurationSelector, subscriptionDelay)(this);
}
$9ceb3aa8c9a79e4c$export$286ca829307725c9 = $9ceb3aa8c9a79e4c$var$delayWhen;

});
parcelRegister("2cpnk", function(module, exports) {
"use strict";
var $19a062c4cc2da585$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $ggvKU = parcelRequire("ggvKU");

var $kVLXA = parcelRequire("kVLXA");

var $RlQRN = parcelRequire("RlQRN");

var $558qb = parcelRequire("558qb");
/**
 * Delays the emission of items from the source Observable by a given time span
 * determined by the emissions of another Observable.
 *
 * <span class="informal">It's like {@link delay}, but the time span of the
 * delay duration is determined by a second Observable.</span>
 *
 * <img src="./img/delayWhen.png" width="100%">
 *
 * `delayWhen` time shifts each emitted value from the source Observable by a
 * time span determined by another Observable. When the source emits a value,
 * the `delayDurationSelector` function is called with the source value as
 * argument, and should return an Observable, called the "duration" Observable.
 * The source value is emitted on the output Observable only when the duration
 * Observable emits a value or completes.
 *
 * Optionally, `delayWhen` takes a second argument, `subscriptionDelay`, which
 * is an Observable. When `subscriptionDelay` emits its first value or
 * completes, the source Observable is subscribed to and starts behaving like
 * described in the previous paragraph. If `subscriptionDelay` is not provided,
 * `delayWhen` will subscribe to the source Observable as soon as the output
 * Observable is subscribed.
 *
 * @example <caption>Delay each click by a random amount of time, between 0 and 5 seconds</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var delayedClicks = clicks.delayWhen(event =>
 *   Rx.Observable.interval(Math.random() * 5000)
 * );
 * delayedClicks.subscribe(x => console.log(x));
 *
 * @see {@link debounce}
 * @see {@link delay}
 *
 * @param {function(value: T): Observable} delayDurationSelector A function that
 * returns an Observable for each value emitted by the source Observable, which
 * is then used to delay the emission of that item on the output Observable
 * until the Observable returned from this function emits a value.
 * @param {Observable} subscriptionDelay An Observable that triggers the
 * subscription to the source Observable once it emits any value.
 * @return {Observable} An Observable that delays the emissions of the source
 * Observable by an amount of time specified by the Observable returned by
 * `delayDurationSelector`.
 * @method delayWhen
 * @owner Observable
 */ function $19a062c4cc2da585$var$delayWhen(delayDurationSelector, subscriptionDelay) {
    if (subscriptionDelay) return function(source) {
        return new $19a062c4cc2da585$var$SubscriptionDelayObservable(source, subscriptionDelay).lift(new $19a062c4cc2da585$var$DelayWhenOperator(delayDurationSelector));
    };
    return function(source) {
        return source.lift(new $19a062c4cc2da585$var$DelayWhenOperator(delayDurationSelector));
    };
}
module.exports.delayWhen = $19a062c4cc2da585$var$delayWhen;
var $19a062c4cc2da585$var$DelayWhenOperator = function() {
    function DelayWhenOperator(delayDurationSelector) {
        this.delayDurationSelector = delayDurationSelector;
    }
    DelayWhenOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $19a062c4cc2da585$var$DelayWhenSubscriber(subscriber, this.delayDurationSelector));
    };
    return DelayWhenOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $19a062c4cc2da585$var$DelayWhenSubscriber = function(_super) {
    $19a062c4cc2da585$var$__extends(DelayWhenSubscriber, _super);
    function DelayWhenSubscriber(destination, delayDurationSelector) {
        _super.call(this, destination);
        this.delayDurationSelector = delayDurationSelector;
        this.completed = false;
        this.delayNotifierSubscriptions = [];
        this.values = [];
    }
    DelayWhenSubscriber.prototype.notifyNext = function(outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        this.destination.next(outerValue);
        this.removeSubscription(innerSub);
        this.tryComplete();
    };
    DelayWhenSubscriber.prototype.notifyError = function(error, innerSub) {
        this._error(error);
    };
    DelayWhenSubscriber.prototype.notifyComplete = function(innerSub) {
        var value = this.removeSubscription(innerSub);
        if (value) this.destination.next(value);
        this.tryComplete();
    };
    DelayWhenSubscriber.prototype._next = function(value) {
        try {
            var delayNotifier = this.delayDurationSelector(value);
            if (delayNotifier) this.tryDelay(delayNotifier, value);
        } catch (err) {
            this.destination.error(err);
        }
    };
    DelayWhenSubscriber.prototype._complete = function() {
        this.completed = true;
        this.tryComplete();
    };
    DelayWhenSubscriber.prototype.removeSubscription = function(subscription) {
        subscription.unsubscribe();
        var subscriptionIdx = this.delayNotifierSubscriptions.indexOf(subscription);
        var value = null;
        if (subscriptionIdx !== -1) {
            value = this.values[subscriptionIdx];
            this.delayNotifierSubscriptions.splice(subscriptionIdx, 1);
            this.values.splice(subscriptionIdx, 1);
        }
        return value;
    };
    DelayWhenSubscriber.prototype.tryDelay = function(delayNotifier, value) {
        var notifierSubscription = $558qb.subscribeToResult(this, delayNotifier, value);
        if (notifierSubscription && !notifierSubscription.closed) {
            this.add(notifierSubscription);
            this.delayNotifierSubscriptions.push(notifierSubscription);
        }
        this.values.push(value);
    };
    DelayWhenSubscriber.prototype.tryComplete = function() {
        if (this.completed && this.delayNotifierSubscriptions.length === 0) this.destination.complete();
    };
    return DelayWhenSubscriber;
}($RlQRN.OuterSubscriber);
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $19a062c4cc2da585$var$SubscriptionDelayObservable = function(_super) {
    $19a062c4cc2da585$var$__extends(SubscriptionDelayObservable, _super);
    function SubscriptionDelayObservable(/** @deprecated internal use only */ source, subscriptionDelay) {
        _super.call(this);
        this.source = source;
        this.subscriptionDelay = subscriptionDelay;
    }
    /** @deprecated internal use only */ SubscriptionDelayObservable.prototype._subscribe = function(subscriber) {
        this.subscriptionDelay.subscribe(new $19a062c4cc2da585$var$SubscriptionDelaySubscriber(subscriber, this.source));
    };
    return SubscriptionDelayObservable;
}($kVLXA.Observable);
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $19a062c4cc2da585$var$SubscriptionDelaySubscriber = function(_super) {
    $19a062c4cc2da585$var$__extends(SubscriptionDelaySubscriber, _super);
    function SubscriptionDelaySubscriber(parent, source) {
        _super.call(this);
        this.parent = parent;
        this.source = source;
        this.sourceSubscribed = false;
    }
    SubscriptionDelaySubscriber.prototype._next = function(unused) {
        this.subscribeToSource();
    };
    SubscriptionDelaySubscriber.prototype._error = function(err) {
        this.unsubscribe();
        this.parent.error(err);
    };
    SubscriptionDelaySubscriber.prototype._complete = function() {
        this.subscribeToSource();
    };
    SubscriptionDelaySubscriber.prototype.subscribeToSource = function() {
        if (!this.sourceSubscribed) {
            this.sourceSubscribed = true;
            this.unsubscribe();
            this.source.subscribe(this.parent);
        }
    };
    return SubscriptionDelaySubscriber;
}($ggvKU.Subscriber);

});




parcelRegister("jRqux", function(module, exports) {

$parcel$export(module.exports, "default", () => $df6a61fd3a853994$export$2e2bcd8739ae039);
parcelRequire("6cbqE");

var $aq199 = parcelRequire("aq199");

var $6y3t5 = parcelRequire("6y3t5");
var $df6a61fd3a853994$export$2e2bcd8739ae039 = (action$)=>action$.ofType((0, $6y3t5.CHECK_ACTIVATION_STATUS_SUCCESS)).switchMap(()=>{
        return (0, $aq199.of)((0, $6y3t5.markActivationCompleted)());
    });

});

parcelRegister("5JVZm", function(module, exports) {

$parcel$export(module.exports, "default", () => $0645620402ae3d7f$export$2e2bcd8739ae039);
parcelRequire("eV0gs");
parcelRequire("6cbqE");

var $2nAWZ = parcelRequire("2nAWZ");

var $6y3t5 = parcelRequire("6y3t5");

var $aPZf4 = parcelRequire("aPZf4");
var $0645620402ae3d7f$export$2e2bcd8739ae039 = (action$)=>action$.ofType((0, $6y3t5.CHECK_ACTIVATION_STATUS_ERROR)).switchMap(()=>{
        return (0, $2nAWZ.concat)([
            (0, $6y3t5.markActivationFailed)(),
            (0, $aPZf4.showActivationErrorFlag)()
        ]);
    });

});

parcelRegister("9i2ja", function(module, exports) {

$parcel$export(module.exports, "default", () => $c173daa9ef155f6a$export$2e2bcd8739ae039);
parcelRequire("6cbqE");
parcelRequire("c66Ur");

var $2nAWZ = parcelRequire("2nAWZ");

var $dAzMx = parcelRequire("dAzMx");

var $41TjW = parcelRequire("41TjW");

var $jhbRM = parcelRequire("jhbRM");

var $eg01Z = parcelRequire("eg01Z");

var $aPZf4 = parcelRequire("aPZf4");

var $6y3t5 = parcelRequire("6y3t5");
function $c173daa9ef155f6a$var$getObservables(action$) {
    return (0, $dAzMx.combineLatest)(action$.ofType((0, $6y3t5.MARK_ACTIVATION_COMPLETED)));
}
var $c173daa9ef155f6a$export$2e2bcd8739ae039 = (action$, store)=>{
    return $c173daa9ef155f6a$var$getObservables(action$).filter(()=>{
        return (0, $jhbRM.getActivationStatus)(store.getState()) === 'activating';
    }).switchMap(()=>{
        return (0, $2nAWZ.concat)([
            (0, $41TjW.updateOnDemandActivationModalState)({
                modalState: 'closed'
            }),
            (0, $aPZf4.updateConfluenceState)('CONFLUENCE_LOADING'),
            (0, $6y3t5.updateConfluenceActivationStatus)({
                status: 'completed'
            }),
            (0, $eg01Z.initializeView)()
        ]);
    });
};

});

parcelRegister("a9kap", function(module, exports) {

$parcel$export(module.exports, "default", () => $bc2f35c6ddeb8ca6$export$2e2bcd8739ae039);
parcelRequire("6cbqE");
parcelRequire("c66Ur");

var $2nAWZ = parcelRequire("2nAWZ");

var $dAzMx = parcelRequire("dAzMx");

var $41TjW = parcelRequire("41TjW");

var $jhbRM = parcelRequire("jhbRM");

var $eg01Z = parcelRequire("eg01Z");

var $aPZf4 = parcelRequire("aPZf4");

var $6y3t5 = parcelRequire("6y3t5");
var $bc2f35c6ddeb8ca6$export$2e2bcd8739ae039 = (action$, store)=>(0, $dAzMx.combineLatest)(action$.ofType((0, $41TjW.UPDATE_ONDEMAND_ACTIVATION_MODAL_STATE)), action$.ofType((0, $6y3t5.MARK_ACTIVATION_ERROR))).filter(([modalStateAction])=>modalStateAction.payload?.modalState === 'closed' && (0, $jhbRM.getActivationStatus)(store.getState()) === 'activating').delay(1000).switchMap(()=>(0, $2nAWZ.concat)([
            (0, $aPZf4.updateConfluenceState)('CONFLUENCE_LOADING'),
            (0, $6y3t5.updateConfluenceActivationStatus)({
                status: 'error'
            }),
            (0, $eg01Z.initializeView)()
        ]));

});


parcelRegister("lav4p", function(module, exports) {

$parcel$export(module.exports, "default", () => $9f5ef3b8370a8bdd$export$2e2bcd8739ae039);

var $3f2cs = parcelRequire("3f2cs");

var $cUelT = parcelRequire("cUelT");

var $bDvnP = parcelRequire("bDvnP");

var $jnnRy = parcelRequire("jnnRy");

var $lgoT7 = parcelRequire("lgoT7");

var $kqdec = parcelRequire("kqdec");

var $aIyBL = parcelRequire("aIyBL");

var $1n6hP = parcelRequire("1n6hP");

var $jo8Dq = parcelRequire("jo8Dq");

var $ebduj = parcelRequire("ebduj");
var $9f5ef3b8370a8bdd$export$2e2bcd8739ae039 = (0, $3f2cs.combineReducers)({
    confluence: $cUelT.default,
    context: $bDvnP.default,
    external: $jnnRy.default,
    project: $aIyBL.default,
    ui: $1n6hP.default,
    flags: $kqdec.default,
    featureFlags: $lgoT7.default,
    personalization: $jo8Dq.default,
    activation: $ebduj.default
});

});
parcelRegister("cUelT", function(module, exports) {

$parcel$export(module.exports, "default", () => $3ec0f3d16fa10b41$export$2e2bcd8739ae039);

var $3f2cs = parcelRequire("3f2cs");

var $dl0hq = parcelRequire("dl0hq");

var $lvIGV = parcelRequire("lvIGV");

var $cdIjF = parcelRequire("cdIjF");

var $30tNG = parcelRequire("30tNG");

var $ig5J7 = parcelRequire("ig5J7");
var $3ec0f3d16fa10b41$export$2e2bcd8739ae039 = (0, $3f2cs.combineReducers)({
    connectedSpace: $dl0hq.default,
    spaces: $lvIGV.default,
    user: $cdIjF.default,
    accessRequestCapabilities: $30tNG.default,
    collaborators: $ig5J7.default
});

});
parcelRegister("dl0hq", function(module, exports) {

$parcel$export(module.exports, "default", () => $0eb276fb5212db02$export$2e2bcd8739ae039);

var $7G07p = parcelRequire("7G07p");

var $aPZf4 = parcelRequire("aPZf4");

var $bxvVo = parcelRequire("bxvVo");

const $0eb276fb5212db02$var$initialState = {
    blueprintsState: (0, $49cd111a962d9af5$export$78244dbb77cfa6b6),
    blueprints: null,
    connectionState: (0, $49cd111a962d9af5$export$78244dbb77cfa6b6),
    projectSpaceKey: null,
    projectPageLinkedId: null,
    projectSpacePageTitle: null,
    projectSpacePageUrl: null,
    projectIsConnectedToPage: false,
    projectIsConnectedToLiveDoc: false,
    projectSpacePageTitleHasBeenFetched: false,
    projectSpaceIcon: null,
    projectSpaceId: null
};
var $0eb276fb5212db02$export$2e2bcd8739ae039 = (state = $0eb276fb5212db02$var$initialState, action)=>{
    switch(action.type){
        case 0, $bxvVo.SET:
            return (0, $7G07p.freeze)(action.payload);
        case 0, $aPZf4.RESET_CONNECTED_SPACE:
            return $0eb276fb5212db02$var$initialState;
        case 0, $aPZf4.GET_PROJECT_SPACE_LINK:
            return (0, $7G07p.merge)(state, {
                connectionState: (0, $49cd111a962d9af5$export$26d55645375ca9a)
            });
        case 0, $aPZf4.PUT_PROJECT_SPACE_LINK:
            // reset to initial state whenever a new space link is being made
            return (0, $7G07p.freeze)($0eb276fb5212db02$var$initialState);
        case 0, $aPZf4.GET_PROJECT_SPACE_LINK_ERROR:
            return (0, $7G07p.merge)(state, {
                projectSpaceKey: null,
                connectionState: (0, $49cd111a962d9af5$export$103bedf43ba882db)
            });
        case 0, $aPZf4.FETCH_CONNECTED_SPACE_BLUEPRINTS:
            return (0, $7G07p.merge)(state, {
                blueprintsState: (0, $49cd111a962d9af5$export$26d55645375ca9a),
                blueprints: null
            });
        case 0, $aPZf4.FETCH_CONNECTED_SPACE_BLUEPRINTS_ERROR:
            return (0, $7G07p.merge)(state, {
                blueprintsState: (0, $49cd111a962d9af5$export$103bedf43ba882db),
                blueprints: null
            });
        case 0, $aPZf4.UPDATE_CONNECTED_SPACE_BLUEPRINTS:
            return (0, $7G07p.merge)(state, {
                blueprintsState: (0, $49cd111a962d9af5$export$c6813a8d51f77eaf),
                blueprints: action.payload
            });
        case 0, $aPZf4.UPDATE_PROJECT_SPACE_LINK:
            return (0, $7G07p.merge)(state, {
                projectSpaceKey: action.spaceKey,
                projectPageLinkedId: action.linkedPageId
            });
        case 0, $aPZf4.UPDATE_CONNECTED_SPACE_OR_PAGE_CONTENT:
            return (0, $7G07p.merge)(state, {
                projectSpaceId: action.spaceId,
                projectSpacePageTitle: action.title,
                projectSpacePageUrl: action.url,
                projectIsConnectedToPage: action.isConnectedToPage,
                projectIsConnectedToLiveDoc: action.isConnectedToLiveDoc,
                projectSpacePageTitleHasBeenFetched: action.projectSpacePageTitleHasBeenFetched,
                projectSpaceIcon: action.iconUrl
            });
        case 0, $aPZf4.UPDATE_CONFLUENCE_SPACE_CONNECTION_STATE:
            return (0, $7G07p.merge)(state, {
                connectionState: action.connectionState
            });
        default:
            return state;
    }
};

});
parcelRegister("bxvVo", function(module, exports) {

$parcel$export(module.exports, "SET", () => $8e0f3781bb0cc681$export$5e8f180ef0142226);
const $8e0f3781bb0cc681$export$5e8f180ef0142226 = 'confluence.connectedSpace.SET';
const $8e0f3781bb0cc681$export$adaa4cf7ef1b65be = (payload)=>({
        type: $8e0f3781bb0cc681$export$5e8f180ef0142226,
        payload: payload
    });

});


parcelRegister("lvIGV", function(module, exports) {

$parcel$export(module.exports, "default", () => $9851094faba0cde2$export$2e2bcd8739ae039);

var $7G07p = parcelRequire("7G07p");

var $aPZf4 = parcelRequire("aPZf4");

var $cV8cq = parcelRequire("cV8cq");
const $9851094faba0cde2$var$initialState = (0, $7G07p.freeze)({
    availableSpaces: [],
    spacesLoaded: false
});
var $9851094faba0cde2$export$2e2bcd8739ae039 = (state = $9851094faba0cde2$var$initialState, action)=>{
    switch(action.type){
        case 0, $cV8cq.SET:
            return (0, $7G07p.freeze)(action.payload);
        case 0, $aPZf4.UPDATE_CONFLUENCE_SPACES:
            return (0, $7G07p.merge)(state, {
                availableSpaces: action.payload,
                spacesLoaded: true
            });
        default:
            return state;
    }
};

});
parcelRegister("cV8cq", function(module, exports) {

$parcel$export(module.exports, "SET", () => $d860855b96efcd29$export$5e8f180ef0142226);
const $d860855b96efcd29$export$5e8f180ef0142226 = 'confluence.spaces.SET';
const $d860855b96efcd29$export$adaa4cf7ef1b65be = (payload)=>({
        type: $d860855b96efcd29$export$5e8f180ef0142226,
        payload: payload
    });

});


parcelRegister("cdIjF", function(module, exports) {

$parcel$export(module.exports, "default", () => $c883994df9711e07$export$2e2bcd8739ae039);

var $7G07p = parcelRequire("7G07p");

var $aPZf4 = parcelRequire("aPZf4");

var $btSr5 = parcelRequire("btSr5");

const $c883994df9711e07$var$initialState = {
    access: (0, $4af2e72ebaa388c6$export$78244dbb77cfa6b6)
};
var $c883994df9711e07$export$2e2bcd8739ae039 = (state = $c883994df9711e07$var$initialState, action)=>{
    switch(action.type){
        case 0, $btSr5.SET:
            return (0, $7G07p.freeze)(action.payload);
        case 0, $aPZf4.UPDATE_CONFLUENCE_USER_ACCESS:
            return (0, $7G07p.merge)(state, {
                access: action.access
            });
        default:
            return state;
    }
};

});
parcelRegister("btSr5", function(module, exports) {

$parcel$export(module.exports, "SET", () => $1903c33d1a3cbd96$export$5e8f180ef0142226);
const $1903c33d1a3cbd96$export$5e8f180ef0142226 = 'confluence.user.SET';
const $1903c33d1a3cbd96$export$adaa4cf7ef1b65be = (payload)=>({
        type: $1903c33d1a3cbd96$export$5e8f180ef0142226,
        payload: payload
    });

});


parcelRegister("30tNG", function(module, exports) {

$parcel$export(module.exports, "default", () => $33fd3a810480ac24$export$2e2bcd8739ae039);

var $7G07p = parcelRequire("7G07p");

var $aPZf4 = parcelRequire("aPZf4");

var $8c8di = parcelRequire("8c8di");
const $33fd3a810480ac24$var$initialState = (0, $7G07p.freeze)({
    capability: (0, $8c8di.AccessRequestCapabilityType).ERROR,
    loaded: false
});
var $33fd3a810480ac24$export$2e2bcd8739ae039 = (state = $33fd3a810480ac24$var$initialState, action)=>{
    switch(action.type){
        case 0, $aPZf4.UPDATE_CONFLUENCE_ACCESS_REQUEST_CAPABILITIES:
            return (0, $7G07p.merge)(state, {
                capability: action.capability,
                loaded: true
            });
        default:
            return state;
    }
};

});

parcelRegister("ig5J7", function(module, exports) {

$parcel$export(module.exports, "default", () => $2133b566b75dbfd4$export$2e2bcd8739ae039);

var $7G07p = parcelRequire("7G07p");

var $aPZf4 = parcelRequire("aPZf4");
const $2133b566b75dbfd4$var$initialState = (0, $7G07p.freeze)({
    users: [],
    loaded: false
});
var $2133b566b75dbfd4$export$2e2bcd8739ae039 = (state = $2133b566b75dbfd4$var$initialState, action)=>{
    switch(action.type){
        case 0, $aPZf4.UPDATE_CONFLUENCE_COLLABORATORS:
            const { users: users } = action;
            return (0, $7G07p.merge)(state, {
                users: users,
                loaded: true
            });
        default:
            return state;
    }
};

});


parcelRegister("jnnRy", function(module, exports) {

$parcel$export(module.exports, "default", () => $187027527d622438$export$2e2bcd8739ae039);

var $7G07p = parcelRequire("7G07p");

var $1zXyj = parcelRequire("1zXyj");
parcelRequire("l1d2F");
var $bHpB9 = parcelRequire("bHpB9");
const $187027527d622438$export$7408552c6b1b4938 = (0, $7G07p.freeze)({
    onGetFeatureFlagValue: ()=>({
        }),
    onFireExposureEvent: (flagKey)=>({
        }),
    onFireErrorEvent: (error, info, meta)=>({
        }),
    crossFlow: {
        isEnabled: false,
        reason: (0, $bHpB9.Reasons).NO_PROVIDER
    }
});
var $187027527d622438$export$2e2bcd8739ae039 = (state = $187027527d622438$export$7408552c6b1b4938, action)=>{
    switch(action.type){
        case 0, $1zXyj.SET:
            return (0, $7G07p.freeze)(action.payload);
        default:
            return state;
    }
};

});
parcelRegister("1zXyj", function(module, exports) {

$parcel$export(module.exports, "SET", () => $6661a978a948f3e4$export$5e8f180ef0142226);
$parcel$export(module.exports, "set", () => $6661a978a948f3e4$export$adaa4cf7ef1b65be);
const $6661a978a948f3e4$export$5e8f180ef0142226 = 'external.SET';
const $6661a978a948f3e4$export$adaa4cf7ef1b65be = (payload)=>({
        type: $6661a978a948f3e4$export$5e8f180ef0142226,
        payload: payload
    });

});


parcelRegister("lgoT7", function(module, exports) {

$parcel$export(module.exports, "default", () => $5c7d599e8a088c17$export$2e2bcd8739ae039);

var $7G07p = parcelRequire("7G07p");

var $gz5Zh = parcelRequire("gz5Zh");
const $5c7d599e8a088c17$export$cb7e03ffc687d619 = (0, $7G07p.freeze)({
    isProjectPagesSporkRebrandingEnabled: false
});
var $5c7d599e8a088c17$export$2e2bcd8739ae039 = (state = $5c7d599e8a088c17$export$cb7e03ffc687d619, action)=>{
    switch(action.type){
        case 0, $gz5Zh.SET:
            return (0, $7G07p.freeze)(action.payload);
        default:
            return state;
    }
};

});
parcelRegister("gz5Zh", function(module, exports) {

$parcel$export(module.exports, "SET", () => $52216b09657e4e68$export$5e8f180ef0142226);
$parcel$export(module.exports, "set", () => $52216b09657e4e68$export$adaa4cf7ef1b65be);
const $52216b09657e4e68$export$5e8f180ef0142226 = 'feature-flags.SET';
const $52216b09657e4e68$export$adaa4cf7ef1b65be = (payload)=>({
        type: $52216b09657e4e68$export$5e8f180ef0142226,
        payload: payload
    });

});


parcelRegister("kqdec", function(module, exports) {

$parcel$export(module.exports, "default", () => $a6f88fd7e2a211ad$export$2e2bcd8739ae039);

var $7G07p = parcelRequire("7G07p");

var $aPZf4 = parcelRequire("aPZf4");

var $3N08D = parcelRequire("3N08D");
const $a6f88fd7e2a211ad$export$75c4ebf4e42e8dda = {
    hasErrors: false,
    showSuccessFlag: false,
    connectedSpaceName: '',
    isConnectedToPage: false,
    isConnectedToLiveDoc: false,
    title: '',
    description: '',
    showActivationErrorFlag: false
};
var $a6f88fd7e2a211ad$export$2e2bcd8739ae039 = (state = $a6f88fd7e2a211ad$export$75c4ebf4e42e8dda, action)=>{
    switch(action.type){
        case 0, $3N08D.SET:
            return (0, $7G07p.freeze)(action.payload);
        case 0, $aPZf4.REDIRECT_TO_CONFLUENCE_CREATE_ERROR:
        case 0, $aPZf4.SHOW_XFLOW_DIALOG_ERROR:
        case 0, $aPZf4.INLINE_JOIN_FAILED:
        case 0, $aPZf4.SHOW_ERROR:
            return (0, $7G07p.merge)(state, {
                hasErrors: true
            });
        case 0, $aPZf4.DISMISS_ERROR:
            return (0, $7G07p.merge)(state, {
                hasErrors: false
            });
        case 0, $aPZf4.SUCCESSFULLY_CONNECTED_SPACE:
            return (0, $7G07p.merge)(state, {
                showSuccessFlag: true,
                connectedSpaceName: action.connectedSpaceName,
                isConnectedToPage: action.isConnectedToPage,
                isConnectedToLiveDoc: action.isConnectedToLiveDoc,
                title: '',
                description: ''
            });
        case 0, $aPZf4.SUCCESSFULLY_REQUESTED_ACCESS:
            return (0, $7G07p.merge)(state, {
                hasErrors: false,
                showSuccessFlag: true,
                connectedSpaceName: '',
                title: action.payload.title,
                description: action.payload.description
            });
        case 0, $aPZf4.DISMISS_SUCCESS_FLAG:
            return (0, $7G07p.merge)(state, {
                showSuccessFlag: false
            });
        case 0, $aPZf4.SHOW_ACTIVATION_ERROR_FLAG:
            return (0, $7G07p.merge)(state, {
                showActivationErrorFlag: true,
                title: action.payload?.title || state.title,
                description: action.payload?.description || state.description
            });
        case 0, $aPZf4.DISMISS_ACTIVATION_ERROR_FLAG:
            return (0, $7G07p.merge)(state, {
                showActivationErrorFlag: false
            });
        default:
            return state;
    }
};

});
parcelRegister("3N08D", function(module, exports) {

$parcel$export(module.exports, "SET", () => $642462d3f89f5855$export$5e8f180ef0142226);
const $642462d3f89f5855$export$5e8f180ef0142226 = 'flags.SET';
const $642462d3f89f5855$export$adaa4cf7ef1b65be = (payload)=>({
        type: $642462d3f89f5855$export$5e8f180ef0142226,
        payload: payload
    });

});


parcelRegister("1n6hP", function(module, exports) {

$parcel$export(module.exports, "default", () => $3ddaff9588a82a87$export$2e2bcd8739ae039);

var $3f2cs = parcelRequire("3f2cs");

var $3UTFm = parcelRequire("3UTFm");

var $5yQax = parcelRequire("5yQax");

var $hdqvV = parcelRequire("hdqvV");

var $ewtqV = parcelRequire("ewtqV");

var $jl0px = parcelRequire("jl0px");
var $3ddaff9588a82a87$export$2e2bcd8739ae039 = (0, $3f2cs.combineReducers)({
    blueprints: $3UTFm.default,
    connectSpaceDialog: $5yQax.default,
    createSpaceDialog: $hdqvV.default,
    inlineJoin: $ewtqV.default,
    onDemandActivation: $jl0px.default
});

});
parcelRegister("3UTFm", function(module, exports) {

$parcel$export(module.exports, "default", () => $8291bbbff8952680$export$2e2bcd8739ae039);

var $7G07p = parcelRequire("7G07p");

var $3siki = parcelRequire("3siki");

var $jFY9b = parcelRequire("jFY9b");
const $8291bbbff8952680$var$initialState = {
    defaultBlueprints: [
        {
            name: 'Blank page',
            itemModuleCompleteKey: (0, $jFY9b.ItemModuleCompleteKeys).BLANK_PAGE,
            contentBlueprintId: '00000000-0000-0000-0000-000000000000',
            skipHowToUse: false
        },
        {
            name: 'Decision',
            itemModuleCompleteKey: (0, $jFY9b.ItemModuleCompleteKeys).DECISION,
            contentBlueprintId: '5f4151a9-31cb-4466-8b9a-4d2797da3d0c',
            skipHowToUse: false
        },
        {
            name: 'Meeting notes',
            itemModuleCompleteKey: (0, $jFY9b.ItemModuleCompleteKeys).MEETING_NOTES,
            contentBlueprintId: '8b2245c5-60eb-4ba4-9139-563a4f0a8d9e',
            skipHowToUse: false
        },
        {
            name: 'Product requirements',
            itemModuleCompleteKey: (0, $jFY9b.ItemModuleCompleteKeys).PRODUCT_REQUIREMENTS,
            contentBlueprintId: 'd436e36c-2779-455b-ad86-adb6398d1a99',
            skipHowToUse: false
        },
        {
            name: 'Retrospective',
            itemModuleCompleteKey: (0, $jFY9b.ItemModuleCompleteKeys).RESTROSPECTIVE,
            contentBlueprintId: '5e76e3f2-8835-4568-8848-5b87e0bea05e',
            skipHowToUse: false
        }
    ]
};
for(let i = 0; i < 7; i += 1){
    const fillerTemplate = {
        name: 'Filler Template',
        itemModuleCompleteKey: null,
        contentBlueprintId: `filler${i}`
    };
    $8291bbbff8952680$var$initialState.defaultBlueprints.push(fillerTemplate);
}
var $8291bbbff8952680$export$2e2bcd8739ae039 = (state = $8291bbbff8952680$var$initialState, action)=>{
    switch(action.type){
        case 0, $3siki.SET:
            return (0, $7G07p.freeze)(action.payload);
        default:
            return state;
    }
};

});
parcelRegister("3siki", function(module, exports) {

$parcel$export(module.exports, "SET", () => $817f3a31254c61f9$export$5e8f180ef0142226);
const $817f3a31254c61f9$export$5e8f180ef0142226 = 'ui.blueprints.SET';
const $817f3a31254c61f9$export$adaa4cf7ef1b65be = (payload)=>({
        type: $817f3a31254c61f9$export$5e8f180ef0142226,
        payload: payload
    });

});


parcelRegister("5yQax", function(module, exports) {

$parcel$export(module.exports, "default", () => $3be528901d329f10$export$2e2bcd8739ae039);

var $7G07p = parcelRequire("7G07p");

var $aPZf4 = parcelRequire("aPZf4");

var $hUEAB = parcelRequire("hUEAB");

const $3be528901d329f10$var$initialState = (0, $7G07p.freeze)({
    selectedSpace: null,
    connectingSpace: false,
    connectSpaceDialogErrorState: (0, $0a265941174d8dd0$export$2841857f996c7c26),
    connectSpaceDialogOpen: false,
    disconnectedTemplatesClick: false
});
var $3be528901d329f10$export$2e2bcd8739ae039 = (state = $3be528901d329f10$var$initialState, action)=>{
    switch(action.type){
        case 0, $hUEAB.SET:
            return (0, $7G07p.freeze)(action.payload);
        case 0, $aPZf4.CONNECT_CONFLUENCE_SPACE:
            return (0, $7G07p.merge)(state, {
                connectingSpace: true,
                connectSpaceDialogErrorState: (0, $0a265941174d8dd0$export$2841857f996c7c26)
            });
        case 0, $aPZf4.UPDATE_CONFLUENCE_SPACES:
            return (0, $7G07p.merge)(state, {
                connectSpaceDialogErrorState: (0, $0a265941174d8dd0$export$2841857f996c7c26)
            });
        case 0, $aPZf4.FETCH_CONFLUENCE_SPACES_ERROR:
            return (0, $7G07p.merge)(state, {
                connectingSpace: false,
                connectSpaceDialogErrorState: (0, $0a265941174d8dd0$export$a71624947af1f122)
            });
        case 0, $aPZf4.HIDE_CONNECT_SPACE_DIALOG:
            return (0, $7G07p.merge)(state, {
                selectedSpace: null,
                connectingSpace: false,
                connectSpaceDialogOpen: false,
                connectSpaceDialogErrorState: (0, $0a265941174d8dd0$export$2841857f996c7c26)
            });
        case 0, $aPZf4.PUT_PROJECT_SPACE_LINK_ERROR:
            return (0, $7G07p.merge)(state, {
                connectingSpace: false,
                connectSpaceDialogErrorState: (0, $0a265941174d8dd0$export$f5569b14a81f6409)
            });
        case 0, $aPZf4.SET_SELECTED_SPACE:
            return (0, $7G07p.merge)(state, {
                selectedSpace: action.payload
            });
        case 0, $aPZf4.SHOW_CONNECT_SPACE_DIALOG:
            return (0, $7G07p.merge)(state, {
                ...$3be528901d329f10$var$initialState,
                connectSpaceDialogOpen: true,
                disconnectedTemplatesClick: action.disconnectedTemplatesClick
            });
        case 0, $aPZf4.SHOW_CREATE_SPACE_DIALOG:
            return (0, $7G07p.merge)(state, {
                connectSpaceDialogOpen: false
            });
        case 0, $aPZf4.UPDATE_PROJECT_SPACE_LINK:
            return (0, $7G07p.merge)(state, {
                selectedSpace: null,
                connectingSpace: false,
                connectSpaceDialogOpen: false
            });
        default:
            return state;
    }
};

});
parcelRegister("hUEAB", function(module, exports) {

$parcel$export(module.exports, "SET", () => $8c48647fc5505291$export$5e8f180ef0142226);
const $8c48647fc5505291$export$5e8f180ef0142226 = 'ui.connectSpaceDialog.SET';
const $8c48647fc5505291$export$adaa4cf7ef1b65be = (payload)=>({
        type: $8c48647fc5505291$export$5e8f180ef0142226,
        payload: payload
    });

});


parcelRegister("hdqvV", function(module, exports) {

$parcel$export(module.exports, "default", () => $6e1e871e31b7e0ae$export$2e2bcd8739ae039);

var $7G07p = parcelRequire("7G07p");

var $aPZf4 = parcelRequire("aPZf4");

var $kwnxt = parcelRequire("kwnxt");

var $lejsi = parcelRequire("lejsi");

const $6e1e871e31b7e0ae$var$initialState = (0, $7G07p.freeze)({
    createSpaceDialogOpen: false,
    createSpaceDialogErrorState: (0, $a96c0cdcf3ed13dc$export$2841857f996c7c26),
    creatingSpace: false,
    generatingKey: false,
    userEnteredSpaceNameInvalid: false,
    userEnteredSpaceName: ''
});
var $6e1e871e31b7e0ae$export$2e2bcd8739ae039 = (state = $6e1e871e31b7e0ae$var$initialState, action)=>{
    switch(action.type){
        case 0, $lejsi.SET:
            return (0, $7G07p.freeze)(action.payload);
        case 0, $kwnxt.CREATE_CONFLUENCE_SPACE:
            return (0, $7G07p.merge)(state, {
                creatingSpace: true,
                createSpaceDialogErrorState: (0, $a96c0cdcf3ed13dc$export$2841857f996c7c26)
            });
        case 0, $kwnxt.CREATE_CONFLUENCE_SPACE_ERROR:
            return (0, $7G07p.merge)(state, {
                creatingSpace: false,
                createSpaceDialogErrorState: (0, $a96c0cdcf3ed13dc$export$58e5d3e30f50fa06)
            });
        case 0, $aPZf4.GENERATE_SPACE_KEY:
            return (0, $7G07p.merge)(state, {
                generatingKey: true,
                createSpaceDialogErrorState: (0, $a96c0cdcf3ed13dc$export$2841857f996c7c26)
            });
        case 0, $aPZf4.HIDE_CREATE_SPACE_DIALOG:
            return (0, $7G07p.merge)(state, {
                createSpaceDialogOpen: false
            });
        case 0, $aPZf4.NO_VALID_KEY_FAILURE:
            return (0, $7G07p.merge)(state, {
                generatingKey: false,
                createSpaceDialogErrorState: (0, $a96c0cdcf3ed13dc$export$d822474b2a7c6d59)
            });
        case 0, $aPZf4.SHOW_CONNECT_SPACE_DIALOG:
            return (0, $7G07p.merge)(state, {
                createSpaceDialogOpen: false
            });
        case 0, $aPZf4.SHOW_CREATE_SPACE_DIALOG:
            return (0, $7G07p.merge)(state, {
                ...$6e1e871e31b7e0ae$var$initialState,
                createSpaceDialogOpen: true
            });
        case 0, $aPZf4.TOGGLE_SPACE_NAME_INVALID:
            return (0, $7G07p.merge)(state, {
                userEnteredSpaceNameInvalid: action.userEnteredSpaceNameInvalid
            });
        case 0, $aPZf4.UPDATE_PROJECT_SPACE_LINK:
            return (0, $7G07p.merge)(state, {
                creatingSpace: false,
                createSpaceDialogOpen: false,
                userEnteredSpaceName: ''
            });
        case 0, $aPZf4.UPDATE_SPACE_NAME:
            return (0, $7G07p.merge)(state, {
                userEnteredSpaceName: action.userEnteredSpaceName
            });
        case 0, $aPZf4.UPDATE_SUGGESTED_KEY:
            return (0, $7G07p.merge)(state, {
                generatingKey: false,
                createSpaceDialogErrorState: (0, $a96c0cdcf3ed13dc$export$2841857f996c7c26)
            });
        default:
            return state;
    }
};

});
parcelRegister("lejsi", function(module, exports) {

$parcel$export(module.exports, "SET", () => $ebd4055d48c130d3$export$5e8f180ef0142226);
const $ebd4055d48c130d3$export$5e8f180ef0142226 = 'ui.createSpaceDialog.SET';
const $ebd4055d48c130d3$export$adaa4cf7ef1b65be = (payload)=>({
        type: $ebd4055d48c130d3$export$5e8f180ef0142226,
        payload: payload
    });

});


parcelRegister("ewtqV", function(module, exports) {

$parcel$export(module.exports, "default", () => $c30d405f2f36d1c5$export$2e2bcd8739ae039);

var $7G07p = parcelRequire("7G07p");

var $lejsi = parcelRequire("lejsi");

var $aPZf4 = parcelRequire("aPZf4");
const $c30d405f2f36d1c5$var$initialState = (0, $7G07p.freeze)({
    isJoinPending: false
});
var $c30d405f2f36d1c5$export$2e2bcd8739ae039 = (state = $c30d405f2f36d1c5$var$initialState, action)=>{
    switch(action.type){
        case 0, $lejsi.SET:
            return (0, $7G07p.freeze)(action.payload);
        case 0, $aPZf4.INLINE_JOIN_CONFLUENCE:
            return (0, $7G07p.merge)(state, {
                isJoinPending: true
            });
        case 0, $aPZf4.INLINE_JOIN_FAILED:
            return (0, $7G07p.merge)(state, {
                isJoinPending: false
            });
        default:
            return state;
    }
};

});

parcelRegister("jl0px", function(module, exports) {

$parcel$export(module.exports, "default", () => $b50e6c3e50e51a33$export$2e2bcd8739ae039);

var $7G07p = parcelRequire("7G07p");

var $41TjW = parcelRequire("41TjW");
const $b50e6c3e50e51a33$var$initialState = {
    modalState: 'open'
};
var $b50e6c3e50e51a33$export$2e2bcd8739ae039 = (state = $b50e6c3e50e51a33$var$initialState, action)=>{
    switch(action.type){
        case 0, $41TjW.SET:
            return (0, $7G07p.freeze)(action.payload);
        case 0, $41TjW.UPDATE_ONDEMAND_ACTIVATION_MODAL_STATE:
            return (0, $7G07p.merge)(state, {
                modalState: action.payload.modalState
            });
        default:
            return state;
    }
};

});


parcelRegister("jo8Dq", function(module, exports) {

$parcel$export(module.exports, "default", () => $f60376eaa9ba89ad$export$2e2bcd8739ae039);

var $7G07p = parcelRequire("7G07p");

var $4iqmv = parcelRequire("4iqmv");
const $f60376eaa9ba89ad$export$eec01d9730781097 = {
    siteTraits: []
};
var $f60376eaa9ba89ad$export$2e2bcd8739ae039 = (state = $f60376eaa9ba89ad$export$eec01d9730781097, action)=>{
    switch(action.type){
        case 0, $4iqmv.UPDATE_PERSONALIZATION_SITE_TRAITS:
            return (0, $7G07p.merge)(state, {
                siteTraits: action.traits
            });
        default:
            return state;
    }
};

});

parcelRegister("ebduj", function(module, exports) {

$parcel$export(module.exports, "default", () => $7203cb9768b19780$export$2e2bcd8739ae039);

var $7G07p = parcelRequire("7G07p");

var $51pmJ = parcelRequire("51pmJ");

var $6y3t5 = parcelRequire("6y3t5");
const $7203cb9768b19780$export$ce2ca3f2bd913448 = (0, $7G07p.freeze)({
    status: 'not-started',
    retryCount: 0,
    userInitiated: false
});
var $7203cb9768b19780$export$2e2bcd8739ae039 = (state = $7203cb9768b19780$export$ce2ca3f2bd913448, action)=>{
    switch(action.type){
        case 0, $51pmJ.SET:
            return (0, $7G07p.freeze)(action.payload);
        case 0, $6y3t5.UPDATE_ACTIVATION_STATUS:
            return (0, $7G07p.merge)(state, {
                status: action.payload.status
            });
        case 0, $6y3t5.START_ACTIVATION:
            return (0, $7G07p.merge)(state, {
                status: 'activating',
                userInitiated: true
            });
        case 0, $6y3t5.CHECK_ACTIVATION_STATUS:
            return (0, $7G07p.merge)(state, {
                retryCount: state.retryCount + 1
            });
        default:
            return state;
    }
};

});
parcelRegister("51pmJ", function(module, exports) {

$parcel$export(module.exports, "SET", () => $bdc393dd77a11159$export$5e8f180ef0142226);
const $bdc393dd77a11159$export$5e8f180ef0142226 = 'activation.SET';
const $bdc393dd77a11159$export$adaa4cf7ef1b65be = (payload)=>({
        type: $bdc393dd77a11159$export$5e8f180ef0142226,
        payload: payload
    });

});




parcelRegister("lHMfu", function(module, exports) {

$parcel$export(module.exports, "FeatureFlagsProvider", () => $8b26e48665aa1cf9$export$6d7e43f2d6e1c7c6);

var $5uXOq = parcelRequire("5uXOq");
const $8b26e48665aa1cf9$var$FeatureFlagsContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createContext({
    fireFeatureExposed: ()=>{}
});
const $8b26e48665aa1cf9$export$90335b3ff08f335 = ()=>(0, $5uXOq.useContext)($8b26e48665aa1cf9$var$FeatureFlagsContext);
const $8b26e48665aa1cf9$export$6d7e43f2d6e1c7c6 = $8b26e48665aa1cf9$var$FeatureFlagsContext.Provider;

});


parcelRegister("jKL06", function(module, exports) {

$parcel$export(module.exports, "default", () => $1592c614284434f1$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $8wYzC = parcelRequire("8wYzC");
class $1592c614284434f1$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
    componentDidMount() {
        (0, $8wYzC.set)(this.props.embeddedProduct).catch((0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))));
    }
    componentWillUnmount() {
        (0, $8wYzC.clear)().catch((0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))));
    }
    render() {
        return null;
    }
}

});
parcelRegister("8wYzC", function(module, exports) {

$parcel$export(module.exports, "set", () => $49f86daa66e50eb0$export$adaa4cf7ef1b65be);
$parcel$export(module.exports, "clear", () => $49f86daa66e50eb0$export$42ffd38884aecdac);
// eslint-disable-next-line jira/wrm/no-load-bridge

var $6BZYo = parcelRequire("6BZYo");

var $2YZCu = parcelRequire("2YZCu");

var $g9E9n = parcelRequire("g9E9n");
const $49f86daa66e50eb0$export$7271276960377470 = 'jira.analytics.embedded-product';
let $49f86daa66e50eb0$var$cachedResolver;
const $49f86daa66e50eb0$export$5a1ebbbe9b82546e = ()=>{
    if ($49f86daa66e50eb0$var$cachedResolver) return $49f86daa66e50eb0$var$cachedResolver;
    const wrmKeys = [
        'wrc!jira.webresources:top-same-origin-window',
        'wrc!com.atlassian.jira.jira-client-analytics-plugin:analytics-web-client'
    ];
    // eslint-disable-next-line jira/wrm/no-load-bridge
    $49f86daa66e50eb0$var$cachedResolver = (0, $6BZYo.loadBridge)({
        name: 'jira/analytics/embedded-product-resolver',
        wrmKeys: wrmKeys,
        shouldLogError: false
    }).then((embeddedProductResolver)=>{
        const updateValue = (embeddedProduct)=>{
            // Set embedded product fn to reset the "track" interval (check analytics-web-client sources for more details).
            // User has to be at least active for 2 seconds before we can submit the track event.
            embeddedProduct ? (0, $g9E9n.getAnalyticsWebClient)().setEmbeddedProduct(embeddedProduct) : (0, $g9E9n.getAnalyticsWebClient)().clearEmbeddedProduct();
        };
        updateValue(embeddedProductResolver.get());
        embeddedProductResolver.onChange(updateValue);
        return embeddedProductResolver;
    }).catch((e)=>{
        (0, $2YZCu.default).safeErrorWithoutCustomerData($49f86daa66e50eb0$export$7271276960377470, 'Cannot get embedded product resolver via bridge', e);
        throw e;
    });
    return $49f86daa66e50eb0$var$cachedResolver;
};
const $49f86daa66e50eb0$export$adaa4cf7ef1b65be = (embeddedProduct)=>$49f86daa66e50eb0$export$5a1ebbbe9b82546e().then((resolver)=>resolver.set(embeddedProduct));
const $49f86daa66e50eb0$export$42ffd38884aecdac = ()=>$49f86daa66e50eb0$export$5a1ebbbe9b82546e().then((resolver)=>resolver.clear());
const $49f86daa66e50eb0$export$5428ebc594af9d04 = (value)=>{
    $49f86daa66e50eb0$var$cachedResolver = value;
};

});


parcelRegister("id7K0", function(module, exports) {

$parcel$export(module.exports, "DocumentTitle", () => $938046587fdeeb52$export$dd5ad0b65cf665da);

var $5uXOq = parcelRequire("5uXOq");

var $cSD7y = parcelRequire("cSD7y");

var $4CAXd = parcelRequire("4CAXd");
// eslint-disable-next-line jira/react/no-class-components
class $938046587fdeeb52$var$DocumentTitleOld extends (0, $5uXOq.Component) {
    static{
        this.defaultProps = {
            TitleSubscriber: (0, $4CAXd.DocumentTitleSubscriber)
        };
    }
    shouldComponentUpdate(nextProps) {
        return nextProps.title !== this.props.title;
    }
    render() {
        const { title: title, TitleSubscriber: TitleSubscriber = (0, $4CAXd.DocumentTitleSubscriber) } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(TitleSubscriber, null, ({ contextArray: contextArray }, { setTitle: setTitle, addDocumentTitle: addDocumentTitle, removeDocumentTitle: removeDocumentTitle })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4CAXd.DocumentTitleHelperOld), {
                title: title,
                setTitle: setTitle,
                addDocumentTitle: addDocumentTitle,
                contextArray: contextArray,
                removeDocumentTitle: removeDocumentTitle,
                TitleSubscriber: TitleSubscriber
            }));
    }
}
const $938046587fdeeb52$export$dd5ad0b65cf665da = (0, $cSD7y.componentWithFG)('jira-concurrent-document-title', (0, $4CAXd.DocumentTitleHelper), $938046587fdeeb52$var$DocumentTitleOld);

});

// Session storage constants used between going through initial onboarding screens
// and landing in JIRA
// Note this key used to be 'should-show-scrum-modal' but was changed to prevent a bug where experienced users
// Could see the modal if they were previously enrolled into ISO
const $6784cbc7d62e5d7c$export$67abe0a3b8dfe03f = 'should-show-scrum-modal-v2';
const $6784cbc7d62e5d7c$export$4e1360a3e7785935 = 'should-show-kanban-modal';
const $6784cbc7d62e5d7c$export$e3884212029f7bef = 'should-show-welcome-modal';
const $6784cbc7d62e5d7c$export$c45d2ea50af63a85 = 'showed-welcome-modal-during-signup';
const $6784cbc7d62e5d7c$export$c9dc4cb209930823 = 'can-enroll-in-config-wizard-view';
const $6784cbc7d62e5d7c$export$891ca65264b256bb = 'should-show-personlized-sample-data-for-kanban';
const $6784cbc7d62e5d7c$export$f47dca9dda77d157 = 'should-hide-quickstart-for-personalized-sample-data';
const $6784cbc7d62e5d7c$export$16588d2012f3f89b = 'should-show-business-sample-data-nudge';
const $6784cbc7d62e5d7c$export$928ffae10e4c0006 = 'template-key-to-show-onboarding-modal';
const $6784cbc7d62e5d7c$export$6e69f8dc03075ef8 = 'team-type';
const $6784cbc7d62e5d7c$export$c06666264cd35603 = 'team-type-shorthand';
const $6784cbc7d62e5d7c$export$8a00ecf6498ee2fe = 'onboarding-selected-project-template-type';
const $6784cbc7d62e5d7c$export$6973064a898f5989 = 'should-show-list-view-type-cell-spotlight';
const $6784cbc7d62e5d7c$export$115fac1f1144bda1 = 'should-show-list-view-fields-dropdown-spotlight';
const $6784cbc7d62e5d7c$export$69fe8832c4f79a32 = 'onboarding_started_timestamp';
const $6784cbc7d62e5d7c$export$a8d62e500b59f31e = 'boardCreateColumnButtonNudge';
const $6784cbc7d62e5d7c$export$92c7f0eacc8d8d98 = 'assigneeFilterAddPeopleButtonNudge';
const $6784cbc7d62e5d7c$export$dd63d0099d95ba4f = 'navigationAppsNavItemNudge';
const $6784cbc7d62e5d7c$export$aba87e019f5ccb8d = 'navigationCreateIssueButtonNudge';
const $6784cbc7d62e5d7c$export$46d9a3d441dfd22b = 'navigationPlansNavItemNudge';
const $6784cbc7d62e5d7c$export$e20072f7d0c5357f = 'roadmapCreateEpicButtonNudge';
const $6784cbc7d62e5d7c$export$1e39959907a7f359 = 'roadmapCreateEpicChildIssueButtonNudge';
const $6784cbc7d62e5d7c$export$b74a8fdb2c75b869 = 'navigationPeopleNavItemNudge';
const $6784cbc7d62e5d7c$export$b1a6ab17737f33e = 'backlogAccordionNudge';
const $6784cbc7d62e5d7c$export$eb64d5f1a091478b = 'backlogCreateSprintIssueNudge';
const $6784cbc7d62e5d7c$export$64d75060ee6ba425 = 'backlogCreateIssueNudge';
const $6784cbc7d62e5d7c$export$3366ddefe77d5112 = 'boardCreateColumnNudge';
const $6784cbc7d62e5d7c$export$9d9e95a66a2c6abe = 'addItemsCalendarNudge';
const $6784cbc7d62e5d7c$export$69aca8ebee0d34c8 = 'trelloCrossflowAddItemsCalendarNudge';
const $6784cbc7d62e5d7c$export$7aa8bceae32c7862 = 'navigationAppsProfileItemNudge';
const $6784cbc7d62e5d7c$export$c6df9a2c7447e12d = 'getStartedListNudge';
const $6784cbc7d62e5d7c$export$468488291ccd988 = 'timelineAddItemNudge';
const $6784cbc7d62e5d7c$export$7a33548109ac931d = 'createFormNudge';
const $6784cbc7d62e5d7c$export$b65ba9ea0c0ced43 = 'jsw-onboarding-checklist.open';
const $6784cbc7d62e5d7c$export$3b5d230b66f60471 = 'jsw-onboarding-checklist.visibility';
const $6784cbc7d62e5d7c$export$594d3436316492be = 'summaryViewNudge';
const $6784cbc7d62e5d7c$export$f93b83d735f01fa3 = 'pagesCreatePageNudge';
const $6784cbc7d62e5d7c$export$77bc79debbf5c069 = 'inviteTeamNudge';
const $6784cbc7d62e5d7c$export$6ffa29e74c0304c4 = 'tailorBoardColumnsNudge';
const $6784cbc7d62e5d7c$export$699265ec8ad9a740 = 'Software Development';
const $6784cbc7d62e5d7c$export$e07d1fa2da8ed874 = 'Customer Service';
const $6784cbc7d62e5d7c$export$76dcec3f438d9e56 = 'IT Support';
const $6784cbc7d62e5d7c$export$9a574c301f67ba30 = 'Human Resources';
const $6784cbc7d62e5d7c$export$363ec144a94029c8 = 'Finance';
const $6784cbc7d62e5d7c$export$df0fb32d68ae1e78 = 'Legal';
const $6784cbc7d62e5d7c$export$d9c0e3e59442fb4 = 'Marketing';
const $6784cbc7d62e5d7c$export$27dbc7d7ce66e6e3 = 'Operations';
const $6784cbc7d62e5d7c$export$a5dce388adf922bd = 'Sales';
const $6784cbc7d62e5d7c$export$e1473b31a257caff = 'Data Science';
const $6784cbc7d62e5d7c$export$85657457db93c2c2 = 'Product Management';
const $6784cbc7d62e5d7c$export$c0c2d1dfaeba89dd = 'Project Management';
const $6784cbc7d62e5d7c$export$2e6a7ad3ab9c82a3 = 'Design';
const $6784cbc7d62e5d7c$export$7b60378c3b4372e9 = 'Other or Personal';
const $6784cbc7d62e5d7c$export$572242e58bd07594 = 'CS';
const $6784cbc7d62e5d7c$export$d7de553940261eba = 'ITS';
const $6784cbc7d62e5d7c$export$4c29d0d04c15e55d = 'HR';
const $6784cbc7d62e5d7c$export$3950f7f841bf94b6 = 'FNC';
const $6784cbc7d62e5d7c$export$881249b988b6030f = 'LGL';
const $6784cbc7d62e5d7c$export$e4824f74b9879164 = 'MKT';
const $6784cbc7d62e5d7c$export$4f3cb0844009af52 = 'OPS';
const $6784cbc7d62e5d7c$export$1a65d50c4a641bb4 = 'SAL';
const $6784cbc7d62e5d7c$export$9ee64e8fbd8b03a2 = 'DS';
const $6784cbc7d62e5d7c$export$b8b1ac856ba1434b = 'DEV';
const $6784cbc7d62e5d7c$export$4f54a09a24fd1d74 = 'PDM';
const $6784cbc7d62e5d7c$export$79685802e8ff1098 = 'PJM';
const $6784cbc7d62e5d7c$export$e5c438b7501b5a24 = 'DES';
const $6784cbc7d62e5d7c$export$cbc0e551d91a692d = 'OTR';

parcelRegister("eGqyh", function(module, exports) {

$parcel$export(module.exports, "PagesCreatePageNudge", () => $986b8b973ad46bdb$export$e5e036f05947ec9e);

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");


var $8Bc5A = parcelRequire("8Bc5A");

var $cZ5k3 = parcelRequire("cZ5k3");

var $4C8El = parcelRequire("4C8El");

var $7CMCs = parcelRequire("7CMCs");

var $iGBUU = parcelRequire("iGBUU");

var $ekp2A = parcelRequire("ekp2A");

var $d9AJG = parcelRequire("d9AJG");
const $986b8b973ad46bdb$export$e5e036f05947ec9e = ()=>{
    (0, $4C8El.useTrackMountedNudgesController)((0, $6784cbc7d62e5d7c$export$f93b83d735f01fa3));
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const pageViewNudgeTourProps = (0, $ekp2A.usePageNudgeTour)((0, $6784cbc7d62e5d7c$export$f93b83d735f01fa3));
    const position = (0, $cZ5k3.POSITION_TOP_START);
    const nudgeSpotlightProps = {
        content: formatMessage((0, $d9AJG.default).pagesViewNudgeContent),
        width: (0, $8Bc5A.DEFAULT_NUDGE_WIDTH),
        position: position,
        scrollToNudge: (0, $cZ5k3.DEFAULT_SCROLL_TO_NUDGE)
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "pagesCreatePageNudge",
        packageName: (0, $8Bc5A.PACKAGE_NAME),
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iGBUU.PortalledNudge), {
        nudgeIdForAnalytics: (0, $6784cbc7d62e5d7c$export$f93b83d735f01fa3),
        nudgeTargetId: (0, $6784cbc7d62e5d7c$export$f93b83d735f01fa3),
        nudgeBlinkId: (0, $6784cbc7d62e5d7c$export$f93b83d735f01fa3),
        hideNudgeOnClick: true,
        hideSpotlightCardOnOutsideClick: true,
        ...nudgeSpotlightProps,
        ...pageViewNudgeTourProps
    }));
};

});
parcelRegister("cZ5k3", function(module, exports) {

$parcel$export(module.exports, "POSITION_RIGHT", () => $450da094f06efa02$export$4ed9c122bcc20157);
$parcel$export(module.exports, "POSITION_BOTTOM", () => $450da094f06efa02$export$cec9b06edc71d96c);
$parcel$export(module.exports, "POSITION_TOP_START", () => $450da094f06efa02$export$3409cd2decbff80c);
$parcel$export(module.exports, "POSITION_TOP_END", () => $450da094f06efa02$export$1a430e6e8a1cbf17);
$parcel$export(module.exports, "POSITION_BOTTOM_START", () => $450da094f06efa02$export$663d1c5ad4215eb0);
$parcel$export(module.exports, "POSITION_BOTTOM_END", () => $450da094f06efa02$export$9c417155181792ae);
$parcel$export(module.exports, "POSITION_RIGHT_START", () => $450da094f06efa02$export$84a134a88de18270);
$parcel$export(module.exports, "POSITION_LEFT_START", () => $450da094f06efa02$export$b67243f02ceac890);
$parcel$export(module.exports, "POSITION_LEFT_END", () => $450da094f06efa02$export$9ed28c4aa79d6398);
$parcel$export(module.exports, "DEFAULT_SCROLL_TO_NUDGE", () => $450da094f06efa02$export$27ce92ea48cacd56);
const $450da094f06efa02$export$b0758137ee643e7 = 'left';
const $450da094f06efa02$export$4ed9c122bcc20157 = 'right';
const $450da094f06efa02$export$cec9b06edc71d96c = 'bottom';
const $450da094f06efa02$export$4fb34bdcd97adf85 = 'top';
const $450da094f06efa02$export$3409cd2decbff80c = 'top-start';
const $450da094f06efa02$export$1a430e6e8a1cbf17 = 'top-end';
const $450da094f06efa02$export$663d1c5ad4215eb0 = 'bottom-start';
const $450da094f06efa02$export$9c417155181792ae = 'bottom-end';
const $450da094f06efa02$export$84a134a88de18270 = 'right-start';
const $450da094f06efa02$export$b71f6a080452c5e8 = 'right-end';
const $450da094f06efa02$export$b67243f02ceac890 = 'left-start';
const $450da094f06efa02$export$9ed28c4aa79d6398 = 'left-end';
const $450da094f06efa02$export$27ce92ea48cacd56 = {
    scrollIntoViewOptions: {
        inline: 'end',
        behavior: 'smooth'
    }
};

});

parcelRegister("4C8El", function(module, exports) {

$parcel$export(module.exports, "useTrackMountedNudgesController", () => $8f1de547694da4ce$export$b759b5124fe0d138);

var $5uXOq = parcelRequire("5uXOq");

var $cE2Qr = parcelRequire("cE2Qr");
const $8f1de547694da4ce$export$b759b5124fe0d138 = (nudgeId)=>{
    const [, { addMountedNudge: addMountedNudge, removeMountedNudge: removeMountedNudge }] = (0, $cE2Qr.useQuickstartActions)();
    (0, $5uXOq.useEffect)(()=>{
        addMountedNudge(nudgeId);
        return ()=>{
            removeMountedNudge(nudgeId);
        };
    }, [
        addMountedNudge,
        nudgeId,
        removeMountedNudge
    ]);
};

});

parcelRegister("iGBUU", function(module, exports) {

$parcel$export(module.exports, "PortalledNudge", () => $12474d131146ee43$export$74f8d45d75dfda4f);

var $5uXOq = parcelRequire("5uXOq");

var $eX4sQ = parcelRequire("eX4sQ");

var $k5uoT = parcelRequire("k5uoT");

var $10xFf = parcelRequire("10xFf");

var $cSWNW = parcelRequire("cSWNW");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");
const $12474d131146ee43$var$PortalledNudgeInternal = ({ onRender: onRender, nudgeTargetId: nudgeTargetId, nudgeIdForAnalytics: nudgeIdForAnalytics, analyticsAttributes: analyticsAttributes = {}, ...props })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const onRenderNudge = (0, $5uXOq.useCallback)(()=>{
        const event = createAnalyticsEvent({});
        (0, $8zOmE.fireUIAnalytics)(event, 'nudgeSpotlightCard viewed', nudgeIdForAnalytics ?? nudgeTargetId, analyticsAttributes);
        if (onRender) onRender();
    }, [
        createAnalyticsEvent,
        nudgeIdForAnalytics,
        nudgeTargetId,
        analyticsAttributes,
        onRender
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eX4sQ.PortalledNudge), {
        onRender: onRenderNudge,
        nudgeTargetId: nudgeTargetId,
        zIndex: (0, $k5uoT.layers).dialog(),
        ...props
    });
};
const $12474d131146ee43$var$PortalledNudgeWithChoreograph = (0, $cSWNW.withChoreographedRender)($12474d131146ee43$var$PortalledNudgeInternal);
const $12474d131146ee43$export$74f8d45d75dfda4f = (props)=>{
    const { messageType: messageType, ...restProps } = props;
    const { nudgeTargetId: nudgeTargetId } = restProps;
    if ((0, $10xFf.shouldBeChoreographed)({
        messageType: messageType
    })) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($12474d131146ee43$var$PortalledNudgeWithChoreograph, {
        messageId: nudgeTargetId,
        ...props
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($12474d131146ee43$var$PortalledNudgeInternal, restProps);
};

});
parcelRegister("eX4sQ", function(module, exports) {

$parcel$export(module.exports, "PortalledNudge", () => $b324ff99d51fd3d9$export$74f8d45d75dfda4f);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $7nsd3 = parcelRequire("7nsd3");

var $fqbGj = parcelRequire("fqbGj");

var $9dZ1c = parcelRequire("9dZ1c");
/**
 * Creates a subscription into this component, that will return a boolean stating if
 * the HTML DOM node is associated with a given target ID.
 */ const $b324ff99d51fd3d9$var$useHasNudgeTargetNode = (id)=>{
    const controller = (0, $9dZ1c.useNudgeController)();
    const [hasRefValue, setHasRefValue] = (0, $5uXOq.useState)(!!controller.nudgeTargetsMap.get(id)?.current);
    (0, $5uXOq.useLayoutEffect)(()=>{
        setHasRefValue(!!controller.nudgeTargetsMap.get(id)?.current);
        const unsubscribe = controller.subscribe(id, ()=>{
            setHasRefValue(!!controller.nudgeTargetsMap.get(id)?.current);
        });
        return ()=>{
            unsubscribe();
        };
    }, [
        controller,
        id
    ]);
    return hasRefValue;
};
/**
 * When the nudge is shown, get and track the rectangle of the target element.
 */ const $b324ff99d51fd3d9$var$useNudgeRectangle = (isShown, id, nudgeContainer)=>{
    const [innerRectangle, setInnerRectangle] = (0, $5uXOq.useState)(null);
    const frameId = (0, $5uXOq.useRef)(null);
    const controller = (0, $9dZ1c.useNudgeController)();
    const nudgeTarget = controller.nudgeTargetsMap.get(id)?.current;
    (0, $5uXOq.useLayoutEffect)(()=>{
        if (!isShown || !nudgeTarget || !nudgeContainer.current) {
            // Reset rectangle to eliminate risk of Spotlight rendering at
            // old position when nudge is e.g. hidden then shown in a different place.
            if (innerRectangle !== null) setInnerRectangle(null);
            return undefined;
        }
        // This is one approach to tracking the elements moving. See https://hello.atlassian.net/wiki/spaces/JST/pages/1759637849/Rendering+performance+Async+component+wrappers
        // for other options.
        const loop = ()=>{
            const targetRectangle = controller.nudgeTargetsMap.get(id)?.current?.getBoundingClientRect();
            if (!targetRectangle) return undefined;
            const newRectangle = {
                top: targetRectangle.top,
                left: targetRectangle.left,
                width: targetRectangle.width,
                height: targetRectangle.height
            };
            if (innerRectangle == null || innerRectangle.top !== newRectangle.top || innerRectangle.left !== newRectangle.left || innerRectangle.width !== newRectangle.width || innerRectangle.height !== newRectangle.height) setInnerRectangle(newRectangle);
            else frameId.current = requestAnimationFrame(loop);
        };
        frameId.current = requestAnimationFrame(loop);
        return ()=>{
            if (frameId.current != null) cancelAnimationFrame(frameId.current);
        };
    }, [
        isShown,
        nudgeContainer,
        innerRectangle,
        nudgeTarget,
        controller.nudgeTargetsMap,
        id
    ]);
    return innerRectangle;
};
/**
 * Create and append a DOM node to use for the nudge. This is on a separate root to the rest of the app.
 */ const $b324ff99d51fd3d9$var$usePortalContainer = ()=>{
    const nudgeContainer = (0, $5uXOq.useRef)(null);
    (0, $5uXOq.useLayoutEffect)(()=>{
        if (!nudgeContainer.current) {
            nudgeContainer.current = document.createElement('div');
            document.body.appendChild(nudgeContainer.current);
        }
        return ()=>{
            if (nudgeContainer.current) document.body.removeChild(nudgeContainer.current);
        };
    }, []);
    return nudgeContainer;
};
const $b324ff99d51fd3d9$export$74f8d45d75dfda4f = (props)=>{
    const nudgeContainer = $b324ff99d51fd3d9$var$usePortalContainer();
    const hasRefValue = $b324ff99d51fd3d9$var$useHasNudgeTargetNode(props.nudgeTargetId);
    const innerRectangle = $b324ff99d51fd3d9$var$useNudgeRectangle(!props.hidden, props.nudgeTargetId, nudgeContainer);
    const innerRectanglePrevious = (0, $5uXOq.useRef)(innerRectangle);
    const spotlightRef = (0, $5uXOq.useRef)(null);
    // Force update the Popper spotlight when the innerRectangle (nudge position) changes
    (0, $5uXOq.useEffect)(()=>{
        if (innerRectangle !== null && innerRectanglePrevious.current !== innerRectangle && spotlightRef.current !== null) {
            innerRectanglePrevious.current = innerRectangle;
            if (spotlightRef.current.forceUpdateCardPosition) spotlightRef.current.forceUpdateCardPosition();
        }
    }, [
        innerRectangle
    ]);
    const hasNudgeTarget = hasRefValue;
    if (!nudgeContainer.current || !hasNudgeTarget || !innerRectangle) return null;
    return /*#__PURE__*/ (0, $7nsd3.createPortal)(/*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            position: 'fixed',
            top: innerRectangle.top,
            left: innerRectangle.left,
            height: innerRectangle.height,
            width: innerRectangle.width,
            zIndex: props.zIndex
        },
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fqbGj.NudgeSpotlight), {
            ...props,
            ref: spotlightRef,
            children: /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                style: {
                    height: innerRectangle.height,
                    width: innerRectangle.width
                }
            })
        })
    }), nudgeContainer.current);
};

});
parcelRegister("fqbGj", function(module, exports) {

$parcel$export(module.exports, "NudgeSpotlight", () => $8ea39cee960047f1$export$eebbda33f5d4d735);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $jC4R5 = parcelRequire("jC4R5");

var $k8nZq = parcelRequire("k8nZq");

var $4oNEb = parcelRequire("4oNEb");

var $cBeZP = parcelRequire("cBeZP");

var $4AhK0 = parcelRequire("4AhK0");

var $4aeUu = parcelRequire("4aeUu");

var $ao4Ml = parcelRequire("ao4Ml");
const $8ea39cee960047f1$var$blinkNudge = (nudgeBlinkId, eventTarget, setAnimateIn)=>{
    const nudgeBlinkTriggers = Array.from(document.querySelectorAll(`[data-nudge-blink='${nudgeBlinkId}']`));
    const clickIsInsideTrigger = nudgeBlinkTriggers?.some((triggerElement)=>{
        return triggerElement && triggerElement.contains(eventTarget);
    });
    if (clickIsInsideTrigger) {
        // Blink the nudge
        setAnimateIn(true);
        return true;
    }
    return false;
};
const $8ea39cee960047f1$export$eebbda33f5d4d735 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ hidden: externalHidden, setHidden: setHidden, hideNudgeOnClick: hideNudgeOnClick = true, hideSpotlightCardOnOutsideClick: hideSpotlightCardOnOutsideClick = true, concealSpotlightOnReferenceHidden: concealSpotlightOnReferenceHidden = false, showSpotlightCardOnFirstRender: showSpotlightCardOnFirstRender = true, children: children, spotlightCard: Spotlight = (0, $4AhK0.default), nudge: Nudge = (0, $jC4R5.DefaultNudge), position: position = 'bottom', offset: offset, zIndex: zIndex = 800, onRender: onRender, onShow: onShow, onHide: onHide, onClick: onClick, onOutsideClick: onOutsideClick, pulseColor: pulseColor, pulseShadowColor: pulseShadowColor, pulseBorderRadius: pulseBorderRadius, nudgeBlinkId: nudgeBlinkId, nudgeTestId: nudgeTestId, nudgeTag: nudgeTag, headingId: headingId, ...spotlightCardProps }, nudgeSpotlightRef)=>{
    // Put all listeners inside a ref to avoid misfiring events
    // When the listener functions themselves change.
    const handlers = (0, $5uXOq.useRef)();
    handlers.current = {
        onRender: onRender,
        onHide: onHide,
        onShow: onShow,
        onClick: onClick,
        onOutsideClick: onOutsideClick
    };
    const nudgeRef = (0, $5uXOq.useRef)(null);
    const spotlightCardRef = (0, $5uXOq.useRef)(null);
    const showNudge = !externalHidden;
    const [canShowSpotlight, setCanShowSpotlight] = (0, $5uXOq.useState)(showSpotlightCardOnFirstRender);
    const [showSpotlight, setShowSpotlight] = (0, $5uXOq.useState)(false);
    const [shouldBlink, setShouldBlink] = (0, $5uXOq.useState)(false);
    const stopBlink = (0, $5uXOq.useCallback)(()=>setShouldBlink(false), []);
    const forceUpdateFnRef = (0, $5uXOq.useRef)({
        fn: ()=>{}
    });
    (0, $5uXOq.useImperativeHandle)(nudgeSpotlightRef, ()=>({
            toggleCardVisibility: setCanShowSpotlight,
            forceUpdateCardPosition: ()=>forceUpdateFnRef.current.fn()
        }), [
        setCanShowSpotlight
    ]);
    const markReadyToShow = (0, $5uXOq.useCallback)(()=>showNudge && setCanShowSpotlight(true), [
        showNudge
    ]);
    const onTargetClick = (0, $5uXOq.useCallback)((event)=>{
        if (!externalHidden) {
            if (hideNudgeOnClick) setHidden(event);
            handlers.current?.onClick?.();
        }
    }, [
        externalHidden,
        hideNudgeOnClick,
        setHidden,
        handlers
    ]);
    // Effect for show/hide the spotlight
    (0, $5uXOq.useEffect)(()=>{
        setShowSpotlight(showNudge && canShowSpotlight);
    }, [
        showNudge,
        canShowSpotlight
    ]);
    // Effect for onRender and onHide
    (0, $5uXOq.useEffect)(()=>{
        if (!externalHidden) {
            handlers.current?.onRender?.();
            return ()=>handlers.current?.onHide?.();
        }
    }, [
        externalHidden,
        handlers
    ]);
    // Effect for onShow
    (0, $5uXOq.useEffect)(()=>{
        if (showSpotlight) handlers.current?.onShow?.();
    }, [
        showSpotlight,
        handlers
    ]);
    // Effect to reset showSpotlightCardOnFirstRender when hidden
    (0, $5uXOq.useEffect)(()=>{
        if (externalHidden) setCanShowSpotlight(showSpotlightCardOnFirstRender);
    }, [
        externalHidden,
        showSpotlightCardOnFirstRender
    ]);
    // Effect to hide spotlight on outside click
    (0, $5uXOq.useEffect)(()=>{
        let unbind;
        let timeout;
        if (showSpotlight && hideSpotlightCardOnOutsideClick) timeout = window.setTimeout(()=>{
            unbind = (0, $cBeZP.bind)(window, {
                type: 'click',
                listener: (event)=>{
                    const eventTarget = event.target;
                    if (nudgeRef.current && spotlightCardRef.current && eventTarget instanceof Node && !nudgeRef.current.contains(eventTarget) && !spotlightCardRef.current.contains(eventTarget)) {
                        if (nudgeBlinkId) {
                            const didBlink = $8ea39cee960047f1$var$blinkNudge(nudgeBlinkId, eventTarget, setShouldBlink);
                            if (didBlink) return;
                        }
                        setCanShowSpotlight(false);
                        handlers.current?.onOutsideClick?.();
                        unbind?.();
                    }
                },
                options: {
                    capture: true,
                    passive: true
                }
            });
        });
        return ()=>{
            unbind?.();
            window.clearTimeout(timeout);
        };
    }, [
        showSpotlight,
        hideSpotlightCardOnOutsideClick,
        setHidden,
        handlers,
        nudgeBlinkId
    ]);
    const concealSpotlightOnScrollStyles = (isReferenceHidden)=>concealSpotlightOnReferenceHidden && isReferenceHidden ? {
            display: 'none'
        } : {};
    const cardConfig = (0, $5uXOq.useMemo)(()=>Spotlight === (0, $4AhK0.default) ? {
            ...spotlightCardProps,
            id: nudgeBlinkId
        } : {
            cardTestId: spotlightCardProps.cardTestId
        }, [
        Spotlight,
        spotlightCardProps,
        nudgeBlinkId
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $5uXOq.Fragment), {
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)(Nudge, {
                ref: nudgeRef,
                hasPulse: showNudge,
                onClickCapture: onTargetClick,
                onMouseEnter: markReadyToShow,
                pulseColor: pulseColor,
                pulseShadowColor: pulseShadowColor,
                pulseBorderRadius: pulseBorderRadius,
                nudgeTestId: nudgeTestId,
                tag: nudgeTag,
                children: children
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $k8nZq.default), {
                zIndex: zIndex,
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $4oNEb.Popper), {
                    placement: position,
                    referenceElement: nudgeRef.current || undefined,
                    offset: offset,
                    children: ({ ref: ref, style: popperStyles, forceUpdate: forceUpdate, isReferenceHidden: isReferenceHidden })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $4aeUu.SpotlightContainer), {
                            showSpotlight: showSpotlight,
                            shouldBlink: shouldBlink,
                            stopBlink: stopBlink,
                            zIndex: zIndex,
                            ref: ref,
                            containerStyles: {
                                ...popperStyles,
                                ...concealSpotlightOnScrollStyles(isReferenceHidden)
                            },
                            role: "dialog",
                            ariaLabelledBy: headingId || 'nudge-spot-light-card-heading',
                            children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $ao4Ml.default), {
                                children: [
                                    (forceUpdateFnRef.current.fn = forceUpdate) && null,
                                    /*#__PURE__*/ (0, $2OMIu.jsx)(Spotlight, {
                                        ...cardConfig,
                                        ref: spotlightCardRef
                                    })
                                ]
                            })
                        })
                })
            })
        ]
    });
});
var $8ea39cee960047f1$export$2e2bcd8739ae039 = $8ea39cee960047f1$export$eebbda33f5d4d735;

});
parcelRegister("jC4R5", function(module, exports) {

$parcel$export(module.exports, "DefaultNudge", () => $d88355bc6c5eb74c$export$b7d614104f4a4a7c);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $5XLZB = parcelRequire("5XLZB");
const $d88355bc6c5eb74c$export$b7d614104f4a4a7c = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ children: children, nudgeTestId: nudgeTestId, ...rest }, ref)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $5XLZB.NudgeTooltipPulse), {
        ...rest,
        ref: ref,
        "data-testid": nudgeTestId,
        children: children
    }));

});
parcelRegister("5XLZB", function(module, exports) {

$parcel$export(module.exports, "NudgeTooltipPulse", () => $589071e97cffed79$export$2d11151259bb3b10);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $k5uoT = parcelRequire("k5uoT");

var $VSDnB = parcelRequire("VSDnB");
function $589071e97cffed79$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $589071e97cffed79$var$baseShadow = '0 0 0 3px';
const $589071e97cffed79$var$basePulseColor = `var(--ds-border-accent-purple, ${(0, $829f609a65d26a98$exports).P75})`;
const $589071e97cffed79$var$basePulseShadowColor = "var(--ds-border-accent-purple, rgba(101, 84, 192, 1))";
const $589071e97cffed79$var$easing = 'cubic-bezier(0.55, 0.055, 0.675, 0.19)';
const $589071e97cffed79$var$pulseAnimation = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '@keyframes pulseKeyframes': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '0%': {
            opacity: 0
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '50%': {
            opacity: 1
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '100%': {
            opacity: 0
        }
    },
    animationName: 'pulseKeyframes',
    animationDuration: '3000ms',
    animationTimingFunction: $589071e97cffed79$var$easing,
    animationIterationCount: 'infinite'
});
const $589071e97cffed79$var$pseudoStyle = {
    name: "24nntw",
    styles: "content:'';position:absolute;top:0;left:0;width:100%;height:100%"
};
const $589071e97cffed79$export$814d9bf8c56ac913 = ({ hasPulse: hasPulse, pulseBorderRadius: pulseBorderRadius, pulseColor: pulseColor, pulseShadowColor: pulseShadowColor })=>/*#__PURE__*/ (0, $f8Sb3.css)({
        display: 'block',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '> *': {
            position: 'relative',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            '&::before': [
                $589071e97cffed79$var$pseudoStyle,
                {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                    borderRadius: `${pulseBorderRadius}px`,
                    boxShadow: `${$589071e97cffed79$var$baseShadow} ${pulseColor}`,
                    opacity: hasPulse ? 1 : 0,
                    transition: 'opacity 0.1s ease-in-out',
                    pointerEvents: 'none'
                }
            ],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            '&::after': [
                $589071e97cffed79$var$pseudoStyle,
                {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                    borderRadius: `${pulseBorderRadius}px`,
                    boxShadow: `${$589071e97cffed79$var$baseShadow} ${pulseColor}, 0 0 11px ${pulseShadowColor}`,
                    opacity: 0,
                    pointerEvents: 'none'
                },
                hasPulse && $589071e97cffed79$var$pulseAnimation
            ]
        }
    });
const $589071e97cffed79$export$2d11151259bb3b10 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ hasPulse: hasPulse, pulseBorderRadius: pulseBorderRadius = (0, $k5uoT.borderRadius)(), pulseColor: pulseColor = $589071e97cffed79$var$basePulseColor, pulseShadowColor: pulseShadowColor = $589071e97cffed79$var$basePulseShadowColor, tag: TargetContainer = 'span', ...rest }, ref)=>{
    // Doing a cast because typescript is struggling to narrow the type
    const CastTargetContainer = TargetContainer;
    return /*#__PURE__*/ (0, $f8Sb3.jsx)(CastTargetContainer, {
        css: [
            $589071e97cffed79$export$814d9bf8c56ac913({
                hasPulse: hasPulse,
                pulseBorderRadius: pulseBorderRadius,
                pulseColor: pulseColor,
                pulseShadowColor: pulseShadowColor
            }),
            (0, $VSDnB.fg)('jira_onboarding_experiences_a11y_fixes') && $589071e97cffed79$var$inHeritWidthStyles
        ],
        ref: ref,
        ...rest
    });
});
const $589071e97cffed79$var$inHeritWidthStyles = {
    name: "6n1ert",
    styles: "width:inherit"
};

});


parcelRegister("4AhK0", function(module, exports) {

$parcel$export(module.exports, "default", () => $b690ab706aa80c88$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");


var $f8Sb3 = parcelRequire("f8Sb3");
function $b690ab706aa80c88$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $b690ab706aa80c88$var$borderRadius = 3;
const $b690ab706aa80c88$var$containerStyles = {
    color: `var(--ds-text-inverse, ${(0, $829f609a65d26a98$export$29a4f05edc054374)})`,
    boxShadow: `var(--ds-shadow-overlay, ${`0 4px 8px -2px ${(0, $829f609a65d26a98$export$7d3359664e8bb0e5)}, 0 0 1px ${(0, $829f609a65d26a98$export$d2d3bedfb276cac0)}`})`,
    backgroundColor: `var(--ds-background-discovery-bold, ${(0, $829f609a65d26a98$export$b48405b95304b5a1)})`,
    borderRadius: `${$b690ab706aa80c88$var$borderRadius}px`,
    overflow: 'auto'
};
const $b690ab706aa80c88$var$bodyStyles = {
    display: 'flex',
    flexDirection: 'column',
    padding: `${"var(--ds-space-200, 16px)"} ${"var(--ds-space-250, 20px)"}`
};
// eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
const $b690ab706aa80c88$var$headingStyles = {
    name: "1m05p0r",
    styles: "font-size:1.42857em;font-style:inherit;line-height:1.2;font-weight:var(--ds-font-weight-medium, 500);margin-top:28px;color:inherit;&:first-child{margin-top:0;}"
};
const $b690ab706aa80c88$var$headerStyles = {
    display: 'flex',
    paddingBottom: "var(--ds-space-100, 8px)",
    alignItems: `baseline`,
    justifyContent: `space-between`
};
const $b690ab706aa80c88$var$footerStyles = {
    display: 'flex',
    paddingTop: "var(--ds-space-100, 8px)",
    alignItems: 'center',
    justifyContent: 'space-between'
};
// eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
const $b690ab706aa80c88$var$actionItemStyles = (index)=>/*#__PURE__*/ (0, $f8Sb3.css)({
        margin: `0 ${"var(--ds-space-050, 4px)"}`,
        cursor: 'pointer',
        alignItems: 'baseline',
        borderWidth: '0px',
        borderRadius: '3px',
        boxSizing: 'border-box',
        display: 'inline-flex',
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography -- TODO: https://product-fabric.atlassian.net/browse/PYX-881
        fontSize: 'inherit',
        fontStyle: 'normal',
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        fontFamily: 'inherit',
        fontWeight: "var(--ds-font-weight-medium, 500)",
        maxWidth: '100%',
        position: 'relative',
        textAlign: 'center',
        textDecoration: 'none',
        transition: 'background 0.1s ease-out 0s, box-shadow 0.15s cubic-bezier(0.47, 0.03, 0.49, 1.38) 0s',
        whiteSpace: 'nowrap',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        background: index ? `var(--ds-background-discovery-bold, ${0, $829f609a65d26a98$export$b48405b95304b5a1})` : `var(--ds-background-inverse-subtle, ${0, $829f609a65d26a98$export$c71e4279dd54a18d})`,
        height: '2.28571em',
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        lineHeight: '2.28571em',
        padding: '0px 10px',
        verticalAlign: 'middle',
        width: 'auto',
        justifyContent: 'center',
        color: `var(--ds-text-inverse, ${(0, $829f609a65d26a98$export$29a4f05edc054374)})`,
        '&:hover': {
            backgroundColor: `var(--ds-interaction-hovered, ${(0, $829f609a65d26a98$export$a7175d4e9206bc80)})`
        },
        '&:active': {
            backgroundColor: `var(--ds-interaction-pressed, ${(0, $829f609a65d26a98$export$a7175d4e9206bc80)})`
        }
    });
const $b690ab706aa80c88$var$ActionItem = ({ index: index, ...rest })=>/*#__PURE__*/ (0, $f8Sb3.jsx)("button", {
        css: $b690ab706aa80c88$var$actionItemStyles(index),
        ...rest
    });
const $b690ab706aa80c88$var$actionItemContainerStyles = {
    display: 'flex',
    margin: `${"var(--ds-space-negative-050, -4px)"}`,
    flexDirection: 'row-reverse'
};
const $b690ab706aa80c88$export$b3ae98194e057550 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ image: image, heading: heading, actions: actions, actionsBeforeElement: actionsBeforeElement, width: width = 300, cardTestId: cardTestId, content: content, id: id }, ref)=>{
    const renderedActions = (0, $5uXOq.useMemo)(()=>actions?.map(({ text: text, onClick: onClick }, index)=>/*#__PURE__*/ (0, $f8Sb3.jsx)($b690ab706aa80c88$var$ActionItem, {
                index: index,
                onClick: onClick,
                key: `${text}-${index}`
            }, text)), [
        actions
    ]);
    const renderHeader = !!heading;
    const renderFooter = !!actionsBeforeElement || !!actions;
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        ref: ref,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            ...$b690ab706aa80c88$var$containerStyles,
            width: `${width}px`
        },
        "data-testid": cardTestId
    }, typeof image === 'string' ? /*#__PURE__*/ (0, $f8Sb3.jsx)("img", {
        src: image,
        alt: ""
    }) : image, /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        style: $b690ab706aa80c88$var$bodyStyles,
        id: id
    }, renderHeader && // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        style: $b690ab706aa80c88$var$headerStyles
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        id: "nudge-spot-light-card-heading",
        css: $b690ab706aa80c88$var$headingStyles
    }, heading)), content, renderFooter && // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        style: $b690ab706aa80c88$var$footerStyles
    }, actionsBeforeElement || /*#__PURE__*/ (0, $f8Sb3.jsx)("span", null), /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        style: $b690ab706aa80c88$var$actionItemContainerStyles
    }, renderedActions))));
});
var $b690ab706aa80c88$export$2e2bcd8739ae039 = $b690ab706aa80c88$export$b3ae98194e057550;

});

parcelRegister("4aeUu", function(module, exports) {

$parcel$export(module.exports, "SpotlightContainer", () => $99a240fc01f7ca0b$export$d0f55839b708c0a0);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $ahdj0 = parcelRequire("ahdj0");

var $k8nZq = parcelRequire("k8nZq");
const $99a240fc01f7ca0b$export$474e8ee88cc7cd8f = 200;
const $99a240fc01f7ca0b$export$3d6f334bf7dc4597 = 120;
const $99a240fc01f7ca0b$var$defaultTransitionStyles = {
    opacity: 0,
    transitionProperty: 'opacity',
    transitionTimingFunction: 'ease-in-out',
    transitionDuration: `${$99a240fc01f7ca0b$export$474e8ee88cc7cd8f}ms`
};
const $99a240fc01f7ca0b$var$statefulTransitionStyles = {
    entering: {},
    entered: {
        opacity: 1
    },
    exiting: {
        transitionDuration: `${$99a240fc01f7ca0b$export$3d6f334bf7dc4597}ms`,
        opacity: 0
    },
    exited: {},
    unmounted: {}
};
const $99a240fc01f7ca0b$var$timeoutDurations = {
    enter: 0,
    exit: $99a240fc01f7ca0b$export$3d6f334bf7dc4597
};
const $99a240fc01f7ca0b$export$d0f55839b708c0a0 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ containerStyles: containerStyles, showSpotlight: showSpotlight, shouldBlink: shouldBlink, zIndex: zIndex, stopBlink: stopBlink, ariaLabelledBy: ariaLabelledBy, ...rest }, ref)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $ahdj0.default), {
        appear: true,
        in: showSpotlight && !shouldBlink,
        timeout: $99a240fc01f7ca0b$var$timeoutDurations,
        onExited: stopBlink,
        unmountOnExit: !shouldBlink,
        children: (state)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $k8nZq.default), {
                zIndex: zIndex,
                children: /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                    style: {
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                        ...containerStyles,
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                        ...$99a240fc01f7ca0b$var$defaultTransitionStyles,
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                        ...$99a240fc01f7ca0b$var$statefulTransitionStyles[state]
                    },
                    ref: ref,
                    "aria-labelledby": ariaLabelledBy,
                    ...rest
                })
            })
    }));

});




parcelRegister("ekp2A", function(module, exports) {

$parcel$export(module.exports, "usePageNudgeTour", () => $b70d681dd8d9b9c2$export$298a8af448edb714);


var $8Bc5A = parcelRequire("8Bc5A");

var $eEmPr = parcelRequire("eEmPr");

var $gTv2y = parcelRequire("gTv2y");

var $TAHUR = parcelRequire("TAHUR");
const $b70d681dd8d9b9c2$export$1ba493d6c0af7d62 = 'pageViewOnboardingTour';
const $b70d681dd8d9b9c2$export$298a8af448edb714 = (nudgeId)=>(0, $TAHUR.useNudgeTour)(nudgeId, {
        tourId: $b70d681dd8d9b9c2$export$1ba493d6c0af7d62,
        steps: (0, $TAHUR.useNudgeTourSteps)(nudgeId, [
            (0, $6784cbc7d62e5d7c$export$f93b83d735f01fa3)
        ]),
        hideStepCountForSingleNudge: true,
        doneMessage: (0, $gTv2y.default).nudgeCtaGotIt,
        onTourComplete: (0, $eEmPr.useMarkOpenTaskFromEligibleTasksAsCompleteAndExpand)([
            (0, $8Bc5A.TAILORED_ONBOARDING_PAGES)
        ])
    });

});
parcelRegister("eEmPr", function(module, exports) {

$parcel$export(module.exports, "useMarkOpenTaskFromEligibleTasksAsCompleteAndExpand", () => $866442142ef80f87$export$f25445ae528b2ca4);

var $5uXOq = parcelRequire("5uXOq");

var $cE2Qr = parcelRequire("cE2Qr");

var $jh7Cg = parcelRequire("jh7Cg");
const $866442142ef80f87$export$f25445ae528b2ca4 = (eligibleTasks)=>{
    const markComplete = (0, $jh7Cg.useMarkAsCompleteAndExpand)();
    const [openTask] = (0, $cE2Qr.useOpenTask)();
    return (0, $5uXOq.useCallback)(()=>{
        if (openTask === null || eligibleTasks.includes(openTask) === false) return;
        markComplete(openTask);
    }, [
        eligibleTasks,
        markComplete,
        openTask
    ]);
};

});
parcelRegister("jh7Cg", function(module, exports) {

$parcel$export(module.exports, "useMarkAsCompleteAndExpand", () => $7c50ede22a760353$export$5894bc689b58a859);

var $2NMNM = parcelRequire("2NMNM");

var $cE2Qr = parcelRequire("cE2Qr");

var $52Vcw = parcelRequire("52Vcw");
const $7c50ede22a760353$export$5894bc689b58a859 = ()=>{
    const [completedTaskList, { nextMarkAsCompletedTask: nextMarkAsCompletedTask, nextAutoExpand: nextAutoExpand }] = (0, $cE2Qr.useCompletedTaskList)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    return (taskId)=>{
        const taskAlreadyCompleted = completedTaskList.includes(taskId);
        if (taskAlreadyCompleted) return;
        nextMarkAsCompletedTask(taskId);
        (0, $52Vcw.fireAnalyticsOnChecklistItemCompleted)(createAnalyticsEvent, taskId);
        nextAutoExpand();
    };
};

});


parcelRegister("gTv2y", function(module, exports) {

$parcel$export(module.exports, "default", () => $78d68c823da9c3f5$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $78d68c823da9c3f5$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    nudgeCtaBack: {
        "id": "software-onboarding-nudges--next.common.nudge-cta-back",
        "defaultMessage": "Back"
    },
    nudgeCtaNext: {
        "id": "software-onboarding-nudges--next.common.nudge-cta-next",
        "defaultMessage": "Next"
    },
    nudgeCtaDone: {
        "id": "software-onboarding-nudges--next.common.nudge-cta-done",
        "defaultMessage": "Done"
    },
    nudgeCtaCancel: {
        "id": "software-onboarding-nudges--next.common.nudge-cta-cancel",
        "defaultMessage": "Cancel"
    },
    nudgeCtaLearnMore: {
        "id": "software-onboarding-nudges--next.common.nudge-cta-learn-more",
        "defaultMessage": "Learn more"
    },
    nudgeCtaFinish: {
        "id": "software-onboarding-nudges--next.common.nudge-cta-finish",
        "defaultMessage": "Finish"
    },
    nudgeCtaGotIt: {
        "id": "software-onboarding-nudges--next.common.nudge-cta-got-it",
        "defaultMessage": "Got it"
    }
});

});

parcelRegister("TAHUR", function(module, exports) {

$parcel$export(module.exports, "useNudgeTour", () => $7315c8d7584ccb41$export$bf9ef218ac0d02e9);
$parcel$export(module.exports, "useNudgeTourSteps", () => $7315c8d7584ccb41$export$80e0fec20b2a10fc);

var $koVbs = parcelRequire("koVbs");

var $cE2Qr = parcelRequire("cE2Qr");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");


var $gTv2y = parcelRequire("gTv2y");

var $im7iu = parcelRequire("im7iu");
const $7315c8d7584ccb41$export$bf9ef218ac0d02e9 = (nudgeId, { tourId: tourId, steps: steps, backMessage: backMessage, nextMessage: nextMessage = (0, $gTv2y.default).nudgeCtaNext, doneMessage: doneMessage = (0, $gTv2y.default).nudgeCtaDone, hideStepCountForSingleNudge: hideStepCountForSingleNudge, onTourComplete: onTourComplete, onOutsideClick: onOutsideClick }, isSpotlightTour = false)=>{
    const [nudgeStep, { setNudgeStep: setNudgeStep }] = (0, $cE2Qr.useNudgeStep)();
    const [hasNudgeActive, { setHasNudgeActive: setHasNudgeActive }] = (0, $cE2Qr.useHasNudgeActive)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    // Check that the nudge should be active, and that the current nudge is the active one.
    if (nudgeStep === '' || hasNudgeActive === false || nudgeId !== nudgeStep) return 0, $im7iu.hiddenNudgeProps;
    // Check that the nudge is even in the steps of the tour config.
    const nudgeIndexInTour = steps.indexOf(nudgeStep);
    if (nudgeIndexInTour === -1) return 0, $im7iu.hiddenNudgeProps;
    const hidden = false;
    const hideStepCount = hideStepCountForSingleNudge && steps.length === 1;
    const nudgeStepCountDisplay = hideStepCount ? '' : `${nudgeIndexInTour + 1}/${steps.length}`;
    const hideNudge = ()=>{
        setNudgeStep('');
        setHasNudgeActive(false);
    };
    // @ts-expect-error - TS2304 - Cannot find name 'Action'.
    const actions = [];
    const spotlightActions = [];
    // tourId and tourSteps are common analytic attributes that make their way into the button events of the tour nudges (next / back / done) + the common nudge events  (viewed / clicked / outsideClicked).
    // Note that they do not make their way into the hidden event since the tour steps are not computed and there is an early return for hiddenNudgeProps.
    const analyticsAttributes = {
        tourId: tourId,
        tourSteps: steps
    };
    if (backMessage && nudgeIndexInTour > 0) {
        // If a back action is necessary
        if (isSpotlightTour) {
            const backAction = {
                content: formatMessage(backMessage),
                onClick: ()=>{
                    (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), (0, $dbbf68c32d8c4308$export$f8bf435a6066832c), `${nudgeStep}BackButton`, analyticsAttributes);
                    setNudgeStep(steps[nudgeIndexInTour - 1]);
                },
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                appearance: 'subtle'
            };
            spotlightActions.push(backAction);
        } else {
            const backAction = {
                text: formatMessage(backMessage),
                onClick: ()=>{
                    (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), (0, $dbbf68c32d8c4308$export$f8bf435a6066832c), `${nudgeStep}BackButton`, analyticsAttributes);
                    setNudgeStep(steps[nudgeIndexInTour - 1]);
                }
            };
            actions.unshift(backAction);
        }
    }
    if (nudgeIndexInTour === steps.length - 1) {
        // Last nudge in the tour: needs done action
        const hideNudgeAndCompleteTour = ()=>{
            hideNudge();
            onTourComplete && onTourComplete();
        };
        const outsideClick = ()=>{
            hideNudgeAndCompleteTour();
            onOutsideClick && onOutsideClick();
        };
        if (isSpotlightTour) {
            const doneAction = {
                content: formatMessage(doneMessage),
                onClick: ()=>{
                    (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), (0, $dbbf68c32d8c4308$export$f8bf435a6066832c), `${nudgeStep}DoneButton`, analyticsAttributes);
                    hideNudgeAndCompleteTour();
                },
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                appearance: 'default'
            };
            spotlightActions.push(doneAction);
        } else {
            const doneAction = {
                text: formatMessage(doneMessage),
                onClick: ()=>{
                    (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), (0, $dbbf68c32d8c4308$export$f8bf435a6066832c), `${nudgeStep}DoneButton`, analyticsAttributes);
                    hideNudgeAndCompleteTour();
                }
            };
            actions.unshift(doneAction);
        }
        return {
            hidden: hidden,
            actions: actions,
            spotlightActions: spotlightActions,
            // adjusted actions for spotlight
            actionsBeforeElement: nudgeStepCountDisplay,
            onOutsideClick: outsideClick,
            setHidden: hideNudgeAndCompleteTour,
            analyticsAttributes: analyticsAttributes
        };
    }
    const showNextNudge = ()=>{
        if (nudgeIndexInTour < steps.length - 1) setNudgeStep(steps[nudgeIndexInTour + 1]);
    };
    // First or middle nudges in tour: needs next action
    if (isSpotlightTour) {
        const nextAction = {
            content: formatMessage(nextMessage),
            onClick: ()=>{
                (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), (0, $dbbf68c32d8c4308$export$f8bf435a6066832c), `${nudgeStep}NextButton`, analyticsAttributes);
                showNextNudge();
            },
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            appearance: 'default'
        };
        spotlightActions.push(nextAction);
    } else {
        const nextAction = {
            text: formatMessage(nextMessage),
            onClick: ()=>{
                (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), (0, $dbbf68c32d8c4308$export$f8bf435a6066832c), `${nudgeStep}NextButton`, analyticsAttributes);
                showNextNudge();
            }
        };
        actions.unshift(nextAction);
    }
    const hideNudgeAndOutsideClick = ()=>{
        hideNudge();
        onOutsideClick && onOutsideClick();
    };
    return {
        hidden: hidden,
        actions: actions,
        spotlightActions: spotlightActions,
        // adjusted actions for spotlight
        actionsBeforeElement: nudgeStepCountDisplay,
        onOutsideClick: hideNudgeAndOutsideClick,
        setHidden: (event)=>{
            // This stops the click to the underlying nudge target.
            // This was done since clicking some nudge targets change the UI of the page, which can affect what's being presented in the tour.
            event.stopPropagation();
            showNextNudge();
        },
        analyticsAttributes: analyticsAttributes
    };
};
const $7315c8d7584ccb41$export$80e0fec20b2a10fc = (nudgeId, steps)=>{
    const [nudgeStep] = (0, $cE2Qr.useNudgeStep)();
    const [mountedNudges] = (0, $cE2Qr.useMountedNudges)();
    // If this nudge is not the active one, avoid the computation of checking desired nudges and the mounting nudge overlap.
    if (nudgeId !== nudgeStep) return [];
    return steps.filter((tourNudge)=>mountedNudges.includes(tourNudge));
};

});
const $dbbf68c32d8c4308$export$e0197e09cccd4e50 = 'backlogCreateSprintNudge';
const $dbbf68c32d8c4308$export$6770a2081a63fc15 = 'backlogStartSprintNudge';
const $dbbf68c32d8c4308$export$63b61f654ce3da3d = 'backlogCompleteSprintNudge';
const $dbbf68c32d8c4308$export$1c7a80b00ad9619 = 'backlogInsightsNudge';
const $dbbf68c32d8c4308$export$b8b9d90f9e5bd72b = 'jiraSoftwareOnboardingNudges';
const $dbbf68c32d8c4308$export$65fb0c4e534f03fc = 'asyncScrumTourNudge';
const $dbbf68c32d8c4308$export$f2fe211acb4aa81a = 'asyncKanbanTourNudge';
const $dbbf68c32d8c4308$export$fb9c6e63a7490968 = 'asyncJWMCalendarTourNudge';
const $dbbf68c32d8c4308$export$df53a339af97f102 = 'asyncJWMCalendarAndTimelineTourNudge';
const $dbbf68c32d8c4308$export$573d4bf1da6d2bc6 = 'asyncJWMBoardTourNudge';
const $dbbf68c32d8c4308$export$501e36925fa10eef = 'asyncJWMListTourNudge';
const $dbbf68c32d8c4308$export$2f06a16c987cc1a2 = 'asyncJWMTimelineTourNudge';
const $dbbf68c32d8c4308$export$226bdcb034c75951 = 'asyncJWMFormTourNudge';
const $dbbf68c32d8c4308$export$b72fce9f4cf11b5c = 'asyncJWMTrelloKeyDifferencesTourNudge';
const $dbbf68c32d8c4308$export$306510c7b1760652 = 'asyncJWMSummaryAndReportsTabNudge';
const $dbbf68c32d8c4308$export$cf1943561be3a3c2 = 'asyncJWMSummaryViewNudge';
const $dbbf68c32d8c4308$export$f8bf435a6066832c = 'button clicked';
const $dbbf68c32d8c4308$export$3bc551fe07069f89 = 'asyncJWMInviteTeamNudge';
const $dbbf68c32d8c4308$export$d99767a37baddfc = 'sampleProjectDataNudge';
const $dbbf68c32d8c4308$export$2ef41782ca91324c = 'businessSampleDataNudge';
const $dbbf68c32d8c4308$export$4db327e1949c2108 = 'boardInProgressColumnNudge';
const $dbbf68c32d8c4308$export$a402f2c11da96cd7 = 'boardCreateIssueNudge';
const $dbbf68c32d8c4308$export$1e174cd1e0212f3a = 'navigateCalendarNudge';
const $dbbf68c32d8c4308$export$a1398a6ef9526001 = 'inlineEditListNudge';
const $dbbf68c32d8c4308$export$5908fa8acd2c0739 = 'filterListNudge';
const $dbbf68c32d8c4308$export$50192b0fdc9bdacf = 'moreDropdownListNudge';
const $dbbf68c32d8c4308$export$e34e81ed4f255f6e = 'timelineAddDateNudge';
const $dbbf68c32d8c4308$export$aac6e5779d47ef37 = 'timelineAddChildItemNudge';
const $dbbf68c32d8c4308$export$dd4b359b5a58cdc0 = 'trelloCrossflowTimelineTabNudge';
const $dbbf68c32d8c4308$export$1e0e647cc08bb4d8 = 'trelloKeyDifferencesIssueNudge';
const $dbbf68c32d8c4308$export$762576896c225bd6 = 'trelloKeyDifferencesSummaryNudge';
const $dbbf68c32d8c4308$export$5a96f813312dc7fa = 'trelloKeyDifferencesBoardNudge';
const $dbbf68c32d8c4308$export$ae8eeb04e0b1e9af = 'availableFieldsFormNudge';
const $dbbf68c32d8c4308$export$a54d77300f1dddea = 'changeIssueTypeFormNudge';
const $dbbf68c32d8c4308$export$6afdc7e5f6d2e915 = 'previewSaveFormNudge';
const $dbbf68c32d8c4308$export$eb0b199de90a7ec2 = 'backgroundColorNudge';
const $dbbf68c32d8c4308$export$e9e47a7ad42e71f5 = 'feedbackNudge';
const $dbbf68c32d8c4308$export$791f56b3d78403cc = 'calendarReleasesNudge';
const $dbbf68c32d8c4308$export$a1be34032ee24f78 = 'shareProjectNudge';
const $dbbf68c32d8c4308$export$29fe6611cc093756 = 'summaryTabNudge';
const $dbbf68c32d8c4308$export$f107c06c0830f09d = 'reportsTabNudge';
const $dbbf68c32d8c4308$export$9749a972a54ad7ba = 'boardContainerNudge';
const $dbbf68c32d8c4308$export$fb4f98ca3ff0420 = 'businessSampleDataNudge';
const $dbbf68c32d8c4308$export$b7fd448c62b5fb97 = 'listview';
const $dbbf68c32d8c4308$export$10c63dc5c09466d2 = 'boardview';
const $dbbf68c32d8c4308$export$75b8d65228d517e9 = 'sampleProjectScrumTourNudge';
const $dbbf68c32d8c4308$export$59a47f76d45b99 = 'sampleProjectScrumSprintNudge';
const $dbbf68c32d8c4308$export$513a9459cd6c3f96 = 'sampleProjectScrumBacklogNudge';
const $dbbf68c32d8c4308$export$657cdc4d7e8d9e5f = 'sampleProjectScrumBoardNudge';
const $dbbf68c32d8c4308$export$e16b25a220be9f3b = 'sampleProjectBoardNudge';
const $dbbf68c32d8c4308$export$c2f124710ac3a3ab = 'sampleProjectListNudge';
const $dbbf68c32d8c4308$export$b1c1e2ff4cbedbe = 'sampleProjectScrumSprintNudgeErrorBoundary';
const $dbbf68c32d8c4308$export$b230ed22c9a186d5 = 'sampleProjectScrumBacklogNudgeErrorBoundary';
const $dbbf68c32d8c4308$export$a321b777cf077071 = 'sampleProjectScrumBoardNudgeErrorBoundary';
const $dbbf68c32d8c4308$export$b51b409cb5508624 = 'sampleProjectBoardNudgeErrorBoundary';
const $dbbf68c32d8c4308$export$9757a1f68dc7a9b = 'sampleProjectListNudgeErrorBoundary';

parcelRegister("im7iu", function(module, exports) {

$parcel$export(module.exports, "hiddenNudgeProps", () => $3c9b37d9cc53bfd4$export$4a6164681c9b0ef6);
const $3c9b37d9cc53bfd4$export$4a6164681c9b0ef6 = {
    hidden: true,
    // Replace with lodash/noop
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    setHidden: ()=>{}
};

});



parcelRegister("d9AJG", function(module, exports) {

$parcel$export(module.exports, "default", () => $3a1e03920f45d92d$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $3a1e03920f45d92d$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    pagesViewNudgeContent: {
        "id": "software-onboarding-nudges--next.pages-create-page.pages-view-nudge-content",
        "defaultMessage": "Create your first page or start from a template."
    }
});

});


parcelRegister("1LKmH", function(module, exports) {

$parcel$export(module.exports, "useHasConfluenceActivatedWithinDays", () => $010e56e1da8fbe7d$export$a8e866cfd97a8d82);

var $5uXOq = parcelRequire("5uXOq");

var $70Rr2 = parcelRequire("70Rr2");
var $lb7qa = parcelRequire("lb7qa");
var $eZDAP = parcelRequire("eZDAP");
var $it1wb = parcelRequire("it1wb");
var $pyK8a = parcelRequire("pyK8a");

var $koeKL = parcelRequire("koeKL");

var $ljzKf = parcelRequire("ljzKf");

var $blGYw = parcelRequire("blGYw");
// TODO : Add a prefix to identify each app and also make sure you update the same in test
const $010e56e1da8fbe7d$var$CONFLUENCE_ACTIVATION_DATE_TAP_TRAIT = 'confluence.ondemand.activationDate';
const $010e56e1da8fbe7d$export$a8e866cfd97a8d82 = (numDays = 14, hasActivatedConfluenceWithinDays)=>{
    const cloudId = (0, $koeKL.useCloudId)();
    const { getLocalStorage: getLocalStorage, setLocalStorage: setLocalStorage } = (0, $blGYw.localStorageManager)('hasActivatedConfluenceWithinDays', 'confluenceContentPlaceholderTemplate', cloudId);
    const cachedhasActivatedConfluenceWithinDays = getLocalStorage();
    const [isActivatedWithinDays, setIsActivatedWithinDays] = (0, $5uXOq.useState)(false);
    const checkIfConfluenceActivatedWithinDays = (0, $5uXOq.useCallback)(async ()=>{
        const traits = await (0, $ljzKf.fetchPersonalizationSiteTraits)(cloudId);
        if (traits) {
            const confluenceActivationDateTrait = traits.find((tapTrait)=>tapTrait.name === $010e56e1da8fbe7d$var$CONFLUENCE_ACTIVATION_DATE_TAP_TRAIT);
            if (confluenceActivationDateTrait && typeof confluenceActivationDateTrait.value === 'string') {
                const today = (0, $70Rr2.default)(new Date());
                const daysAgo = (0, $it1wb.default)((0, $pyK8a.default)(today, numDays));
                const dateToCheck = (0, $eZDAP.default)(confluenceActivationDateTrait.value);
                const isDateWithinInterval = (0, $lb7qa.default)(dateToCheck, {
                    start: daysAgo,
                    end: today
                });
                setIsActivatedWithinDays(isDateWithinInterval);
                setLocalStorage(isDateWithinInterval);
            }
        }
    }, [
        cloudId,
        numDays,
        setLocalStorage
    ]);
    (0, $5uXOq.useEffect)(()=>{
        // Don't need to check if we already know the site has activated confluence within the past numDays days
        if (hasActivatedConfluenceWithinDays === undefined && cachedhasActivatedConfluenceWithinDays === undefined) checkIfConfluenceActivatedWithinDays();
        else if (hasActivatedConfluenceWithinDays) {
            setIsActivatedWithinDays(hasActivatedConfluenceWithinDays);
            setLocalStorage(hasActivatedConfluenceWithinDays);
        } else setIsActivatedWithinDays(cachedhasActivatedConfluenceWithinDays);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        cloudId,
        cachedhasActivatedConfluenceWithinDays,
        hasActivatedConfluenceWithinDays
    ]);
    return isActivatedWithinDays;
};

});
parcelRegister("ljzKf", function(module, exports) {

$parcel$export(module.exports, "fetchPersonalizationSiteTraits", () => $b0ade3054a5b3639$export$f3f6bb53f650126e);

var $7f4tk = parcelRequire("7f4tk");

var $jcw0u = parcelRequire("jcw0u");

var $jJZqs = parcelRequire("jJZqs");
const $b0ade3054a5b3639$var$PERSONALIZATION_BASE_URL = '/gateway/api/tap-delivery/api/v3/personalization';
const $b0ade3054a5b3639$var$SITE_QUERY_PARAM = '/site/';
const $b0ade3054a5b3639$var$LOG_LOCATION = 'confluence-content-placeholder-template-fetch-personalization-site-user-traits';
function $b0ade3054a5b3639$var$getUserPersonalizationUrl(cloudId) {
    return `${$b0ade3054a5b3639$var$PERSONALIZATION_BASE_URL}${$b0ade3054a5b3639$var$SITE_QUERY_PARAM}${cloudId}`;
}
const $b0ade3054a5b3639$export$f3f6bb53f650126e = async (cloudId)=>{
    try {
        const response = await (0, $7f4tk.default)($b0ade3054a5b3639$var$getUserPersonalizationUrl(cloudId));
        return response.attributes;
    } catch (error) {
        (0, $jcw0u.default)({
            meta: {
                id: $b0ade3054a5b3639$var$LOG_LOCATION,
                packageName: '@atlassian/jira-issue-content-placeholder-template',
                teamName: 'starburst'
            },
            attributes: {
                errorCode: error instanceof (0, $jJZqs.default) ? error.statusCode : null
            },
            error: {
                name: 'error',
                message: `Failed to fetch TAP traits via the personalization api for cloudId : ${cloudId}`
            }
        });
        return null;
    }
};

});

parcelRegister("blGYw", function(module, exports) {

$parcel$export(module.exports, "localStorageManager", () => $1ec416d7964f5def$export$8e35886de8a54f45);

var $bSSG7 = parcelRequire("bSSG7");
const $1ec416d7964f5def$export$8e35886de8a54f45 = (propertyKey, storageKey, segmentId)=>{
    const localStorageProvider = (0, $bSSG7.createLocalExpirableStorageProvider)(storageKey);
    const STORAGE_KEY = segmentId ? `${propertyKey}_${segmentId}` : propertyKey;
    const getLocalStorage = ()=>localStorageProvider.get(STORAGE_KEY);
    const LOCAL_STORAGE_EXPIRY_MS = 86400000; // one day
    const setLocalStorage = (value)=>localStorageProvider.set(STORAGE_KEY, value, Date.now() + LOCAL_STORAGE_EXPIRY_MS);
    return {
        getLocalStorage: getLocalStorage,
        setLocalStorage: setLocalStorage
    };
};

});


parcelRegister("8JoAa", function(module, exports) {

$parcel$export(module.exports, "usePagesFeatureState", () => $6edf75d09a6f2e8f$export$521163b675f0ea59);

var $5uXOq = parcelRequire("5uXOq");

var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");

var $6IKvj = parcelRequire("6IKvj");

var $h73KU = parcelRequire("h73KU");

var $7WLlg = parcelRequire("7WLlg");
const $6edf75d09a6f2e8f$var$actions = {
    setFeatureState: $h73KU.setFeatureState
};
const $6edf75d09a6f2e8f$var$initialState = {
    state: (0, $7WLlg.pagesFeatureStates).LOADING
};
const $6edf75d09a6f2e8f$export$390f32400eaf98c9 = (0, $iXqE5.createStore)({
    name: 'pagesFeatureStateStore',
    initialState: $6edf75d09a6f2e8f$var$initialState,
    actions: $6edf75d09a6f2e8f$var$actions
});
const $6edf75d09a6f2e8f$var$usePagesFeatureHook = (0, $3sQ5x.createHook)($6edf75d09a6f2e8f$export$390f32400eaf98c9);
const $6edf75d09a6f2e8f$export$521163b675f0ea59 = (projectId)=>{
    const [featureState, featureActions] = $6edf75d09a6f2e8f$var$usePagesFeatureHook();
    const [error, setError] = (0, $5uXOq.useState)(undefined);
    if (error) {
        setError(undefined);
        throw error;
    }
    (0, $5uXOq.useEffect)(()=>{
        const fetchData = async ()=>{
            try {
                const { value: isEnabled } = await (0, $6IKvj.getPagesFeatureState)(projectId);
                featureActions.setFeatureState(isEnabled);
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (thrownError) {
                setError(thrownError);
            }
        };
        fetchData();
    }, [
        featureActions,
        projectId
    ]);
    return featureState.state;
};

});
parcelRegister("6IKvj", function(module, exports) {

$parcel$export(module.exports, "getPagesFeatureState", () => $4fb01bd28e7303ef$export$90bc82d3b826ba38);

var $eusud = parcelRequire("eusud");
const $4fb01bd28e7303ef$export$90bc82d3b826ba38 = (projectId)=>(0, $eusud.performGetRequest)(`/rest/api/2/project/${projectId}/properties/project-pages-link-enabled`).catch((thrownError)=>{
        /** If feature has never been set before 404 is returned. But default state of feature is enabled. */ if (thrownError.statusCode === 404) return Promise.resolve({
            value: true
        });
        return Promise.reject(thrownError);
    });

});

parcelRegister("h73KU", function(module, exports) {

$parcel$export(module.exports, "setFeatureState", () => $e883a7b0d3052cee$export$bed5a5469370c50d);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $7WLlg = parcelRequire("7WLlg");
const $e883a7b0d3052cee$export$bed5a5469370c50d = (isEnabled)=>({ getState: getState, setState: setState })=>{
        const currentState = getState();
        const newState = isEnabled ? (0, $7WLlg.pagesFeatureStates).ENABLED : (0, $7WLlg.pagesFeatureStates).DISABLED;
        if (currentState.state !== newState) setState({
            state: newState
        });
    };

});
parcelRegister("7WLlg", function(module, exports) {

$parcel$export(module.exports, "pagesFeatureStates", () => $0d801c874e213497$export$9c7e040262f6af5c);
const $0d801c874e213497$export$9c7e040262f6af5c = {
    LOADING: 'LOADING',
    DISABLED: 'DISABLED',
    ENABLED: 'ENABLED'
};

});



parcelRegister("3EsqC", function(module, exports) {

$parcel$export(module.exports, "default", () => $f731945f6358f8f3$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $f731945f6358f8f3$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    pageTitlePages: {
        "id": "project-pages.page-title-pages",
        "defaultMessage": "Pages"
    }
});

});

parcelRegister("hzuuI", function(module, exports) {

$parcel$export(module.exports, "onFireErrorEvent", () => $8d40c68c5e551df4$export$8279421a5ba6bd14);

var $jcw0u = parcelRequire("jcw0u");
const $8d40c68c5e551df4$export$8279421a5ba6bd14 = (error, info, meta)=>(0, $jcw0u.default)({
        error: error,
        sendToPrivacyUnsafeSplunk: true,
        meta: meta || {
            id: 'unhandled',
            packageName: 'jiraProjectPagesErrorEventUtil',
            teamName: 'confluence-better-together'
        }
    });

});



parcelRegister("9dbF6", function(module, exports) {

$parcel$export(module.exports, "SubProductUpdater", () => $5979c081afa32bfa$export$eb40d3df56aa5c53);

var $5uXOq = parcelRequire("5uXOq");

var $5h5Fg = parcelRequire("5h5Fg");

var $3iTiR = parcelRequire("3iTiR");

var $ero6m = parcelRequire("ero6m");

var $54I24 = parcelRequire("54I24");

var $8OHH4 = parcelRequire("8OHH4");
const $5979c081afa32bfa$export$eb40d3df56aa5c53 = ({ allowMonolithDeferral: allowMonolithDeferral = false, ...props })=>{
    const subProduct = (0, $8OHH4.isSubProductProps)(props) ? props.subProduct : (0, $ero6m.getSubProductFromProjectType)(props.projectType);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5h5Fg.default), {
        op: (0, $54I24.default),
        args: [
            subProduct,
            allowMonolithDeferral
        ]
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3iTiR.default), {
        subProduct: subProduct
    }));
};

});
parcelRegister("3iTiR", function(module, exports) {

$parcel$export(module.exports, "default", () => $1214b0731559b377$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $01Rn4 = parcelRequire("01Rn4");

var $hFChZ = parcelRequire("hFChZ");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$1214b0731559b377$export$2e2bcd8739ae039 = ({ subProduct: subProduct })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $01Rn4.default), {
        op: (0, $hFChZ.default),
        args: [
            subProduct
        ]
    });

});
parcelRegister("hFChZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $0e606430ead76cd8$export$2e2bcd8739ae039);

var $2YZCu = parcelRequire("2YZCu");

var $eusud = parcelRequire("eusud");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$0e606430ead76cd8$export$2e2bcd8739ae039 = (subProduct)=>{
    (0, $eusud.performGetRequest)(`/rest/internal/2/mauTag/${subProduct}`).catch((err)=>{
        (0, $2YZCu.default).safeErrorWithoutCustomerData('common.tag-mau.tag-mau-event', 'Error connecting to monolith mau tag endpoint', err);
    });
};

});


parcelRegister("ero6m", function(module, exports) {

$parcel$export(module.exports, "getSubProductFromProjectType", () => $0997694844c8a9e7$export$b1fe420ed15dff7b);

var $16v4H = parcelRequire("16v4H");
const $0997694844c8a9e7$export$b1fe420ed15dff7b = (projectType)=>{
    // for Analytics only 'product_discovery' is mapped to 'polaris'. In other cases it is mapped to 'software'
    if (projectType === 'product_discovery') return 'polaris';
    return (0, $16v4H.subProductFromProjectType)(projectType);
};

});

parcelRegister("54I24", function(module, exports) {

$parcel$export(module.exports, "default", () => $bcbbcd48ca398ed4$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/wrm/no-load-bridge

var $7T84i = parcelRequire("7T84i");
var $9B86Q = parcelRequire("9B86Q");
var $cQZXC = parcelRequire("cQZXC");


var $2YZCu = parcelRequire("2YZCu");

var $fjcgS = parcelRequire("fjcgS");
const $bcbbcd48ca398ed4$var$maybeDelayAndRace = (// @ts-expect-error - TS2304 - Cannot find name 'Deferred'.
maybeWaitPromise, getDefaultPromise, getRacePromise)=>maybeWaitPromise ? Promise.race([
        maybeWaitPromise.then(getDefaultPromise),
        getRacePromise()
    ]) : getDefaultPromise();
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$bcbbcd48ca398ed4$export$2e2bcd8739ae039 = async (subProduct, allowMonolithDeferral)=>{
    (0, $fjcgS.getAnalyticsWebClientPromise)().then((client)=>{
        client.setSubProduct(subProduct);
        if (subProduct === 'serviceDesk') client.setUIViewedAttributes({
            solutions: [
                (0, $86344d58e71e925a$export$c8b406ad8ee0dab9)
            ]
        });
        else client.removeUIViewedAttribute('solutions');
    });
    // IMPORTANT -
    // Until such time as all pre-TTI WRM loads are removed we find that waitForHeritage() then
    // loadBridgeStrict() is too slow, resulting in `subproduct:unknown` for analytics events.
    // In that same case however, profiling shows us that polling in loadBridgeWeak() somehow
    // resolves the same AMD code faster.
    // This is not well understood, but it does allow us to work around the issue by racing these
    // two techniques.
    // Once there is no pre-TTI WRM loads we the waitForHeritage() then loadBridgeStrict() does seem
    // to be faster such that we can remove the `Promise.race()`.
    /* eslint-disable jira/wrm/no-load-bridge */ $bcbbcd48ca398ed4$var$maybeDelayAndRace(allowMonolithDeferral ? (0, $cQZXC.waitForHeritage)() : null, ()=>(0, $7T84i.loadBridgeStrict)({
            name: 'jira/analytics/sub-product-resolver',
            wrmKeys: [
                'wrc!com.atlassian.jira.jira-client-analytics-plugin:analytics-web-client'
            ]
        }), ()=>(0, $9B86Q.loadBridgeWeak)({
            name: 'jira/analytics/sub-product-resolver'
        })).then((subProductResolver)=>{
        subProductResolver.setSubProduct(subProduct);
    }).catch((e)=>(0, $2YZCu.default).safeErrorWithoutCustomerData('common.analytics-sub-product.sub-product-updater', 'Error connecting to monolith sub product resolver', e));
/* eslint-enable jira/wrm/no-load-bridge */ };

});
const $86344d58e71e925a$export$c8b406ad8ee0dab9 = 'jiraServiceManagement';


parcelRegister("8OHH4", function(module, exports) {

$parcel$export(module.exports, "isSubProductProps", () => $701d07b56c3e3574$export$c3063d6d7a8c075f);
const $701d07b56c3e3574$export$c3063d6d7a8c075f = (props)=>'subProduct' in props && typeof props.subProduct === 'string';

});


parcelRegister("eekRi", function(module, exports) {

$parcel$export(module.exports, "default", () => $472ea9fce057177b$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $jzjy1 = parcelRequire("jzjy1");

var $jS4lj = parcelRequire("jS4lj");

var $7iJwP = parcelRequire("7iJwP");


var $8PRuf = parcelRequire("8PRuf");

var $5rqex = parcelRequire("5rqex");

var $7DbgJ = parcelRequire("7DbgJ");

var $4dRjY = parcelRequire("4dRjY");

var $dZw8H = parcelRequire("dZw8H");

var $lmBAt = parcelRequire("lmBAt");

var $5pkMH = parcelRequire("5pkMH");

var $4BJ24 = parcelRequire("4BJ24");
const $472ea9fce057177b$var$pageLayoutStyles = null;
function $472ea9fce057177b$var$ProjectPages(props) {
    const { Updater: Updater, ProjectPagesApp: ProjectPagesApp, tenantContext: tenantContext, projectContext: projectContext } = props;
    if (!(projectContext && projectContext.data && projectContext.data.projectKey)) return null;
    const { isAdmin: isAdmin, isSiteAdmin: isSiteAdmin, baseUrl: baseUrl, locale: locale, cloudId: cloudId, atlassianAccountId: atlassianAccountId, environment: environment } = tenantContext;
    const { projectId: projectId, projectKey: projectKey, projectName: projectName, projectType: projectType } = projectContext.data;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        className: (0, $bwpsq.default)([
            "_4t3i1osq _19pkidpf _2hwx1jfw _otyridpf _18u01jfw"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7iJwP.default), {
        id: "unhandled",
        packageName: "jiraSpaAppsProjectPages",
        teamName: "confluence-better-together"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4dRjY.MarkProductStart), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Updater, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(ProjectPagesApp, {
        baseUrl: baseUrl,
        locale: locale,
        isAdmin: isAdmin,
        isSiteAdmin: isSiteAdmin,
        cloudId: cloudId,
        accountId: atlassianAccountId,
        projectId: projectId,
        projectKey: projectKey,
        projectName: projectName,
        projectType: projectType,
        environment: environment,
        breadcrumbs: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jS4lj.default), null),
        ...(0, $lmBAt.getIsSoftwareThemingM2Enabled)() && {
            theme: (0, $5pkMH.pagesOverrideStyles)({
                name: 'projectPages',
                type: 'projectPages'
            })
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5rqex.default), {
        metricKey: "jira.project.pages",
        metric: (0, $4BJ24.projectPagesPageLoad),
        isExpectedToHaveSsr: true,
        withMarks: [
            (0, $8PRuf.appBundleReadyMark),
            (0, $8PRuf.prefetchApiReadyMark)
        ]
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7DbgJ.default), {
        baseUrl: baseUrl,
        projectKey: projectKey
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dZw8H.SpaStatePageReady), null)));
}
var $472ea9fce057177b$export$2e2bcd8739ae039 = (0, $jzjy1.AnalyticsSource)('project-pages', (0, $4d5e0871c06cee03$export$f636b5b56f1d624a))($472ea9fce057177b$var$ProjectPages);

});
// SCREENS
const $4d5e0871c06cee03$export$f636b5b56f1d624a = 'Screen';
const $4d5e0871c06cee03$export$9d2de6eebf7462b5 = 'Drawer';
const $4d5e0871c06cee03$export$1171103ea9083ffa = 'Modal';
const $4d5e0871c06cee03$export$cae2783c9279926 = 'InlineDialog';
const $4d5e0871c06cee03$export$d1123261ca8831d2 = 'Dropdown';
const $4d5e0871c06cee03$export$238d30785c4bca84 = 'Banner';
const $4d5e0871c06cee03$export$a1562d08625f5d7e = 'UI';
const $4d5e0871c06cee03$export$947dac6c72b26f81 = 'TRACK';
const $4d5e0871c06cee03$export$f1d537d508d2945a = 'SCREEN';
const $4d5e0871c06cee03$export$12346a674644c156 = 'OPERATIONAL';

parcelRegister("5rqex", function(module, exports) {

$parcel$export(module.exports, "checkAndEmitApdexSignal", () => $ab527e70454bab7e$export$3082c88b693a5230);
$parcel$export(module.exports, "default", () => $ab527e70454bab7e$export$2e2bcd8739ae039);
$parcel$export(module.exports, "baseDefaultProps", () => $ab527e70454bab7e$export$9b3029ee6188a41f);

var $5uXOq = parcelRequire("5uXOq");

var $99gkn = parcelRequire("99gkn");

var $aOr3t = parcelRequire("aOr3t");

var $1u4q7 = parcelRequire("1u4q7");

var $1AZST = parcelRequire("1AZST");

var $6G6w0 = parcelRequire("6G6w0");

var $3wLoG = parcelRequire("3wLoG");

var $gtdbK = parcelRequire("gtdbK");

var $zbAs4 = parcelRequire("zbAs4");

var $3B7oW = parcelRequire("3B7oW");
const $ab527e70454bab7e$export$3082c88b693a5230 = (appName, metricKey)=>{
    var emitSignal;
};
class $ab527e70454bab7e$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
    static{
        this.defaultProps = {
            isExpectedToHaveSsr: false,
            withMarks: [],
            extra: {},
            emitOnAnimationFrame: false
        };
    }
    render() {
        const { appName: appName, metricKey: metricKey, extra: extra, metric: metric, emitOnAnimationFrame: emitOnAnimationFrame } = this.props;
        $ab527e70454bab7e$export$3082c88b693a5230(appName, metricKey);
        const isUFODefined = (0, $1AZST.GlobalPageLoadExperience).loadingPageLoadId !== 'UNKNOWN';
        if (isUFODefined) (0, $zbAs4.addUFOSSRDoneAsFMPToInteraction)();
        if (metric) {
            // https://product-fabric.atlassian.net/browse/UFO-323
            (0, $gtdbK.addBM3SSRDoneAsFMPToInteraction)(metric);
            (0, $3B7oW.trackBM3FeatureFlagsAccessed)(metric);
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $99gkn.default), {
            data: extra
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aOr3t.UFOBM3TimingsToUFO), {
            marks: metric?.getData()?.marks,
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            timings: metric?.getData()?.config?.timings
        }), isUFODefined ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3wLoG.StopUfo), {
            appName: appName,
            customData: extra,
            key: (0, $1u4q7.getInteractionId)().current
        }) : metric && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6G6w0.StopBrowserMetrics3), {
            metric: metric,
            customData: extra,
            emitOnAnimationFrame: emitOnAnimationFrame
        }));
    }
}
const $ab527e70454bab7e$export$9b3029ee6188a41f = $ab527e70454bab7e$export$2e2bcd8739ae039.defaultProps;

});
parcelRegister("aOr3t", function(module, exports) {

$parcel$export(module.exports, "getBm3Timings", () => $a3e67858f0c2f8da$export$f02972da195a43bb);
$parcel$export(module.exports, "UFOBM3TimingsToUFO", () => $a3e67858f0c2f8da$export$30f0b5e5acd268bf);
$parcel$export(module.exports, "addBM3TimingsToUFO", () => $a3e67858f0c2f8da$export$d93d677ef2f33c5c);

var $5uXOq = parcelRequire("5uXOq");

var $1tcYS = parcelRequire("1tcYS");

var $1u4q7 = parcelRequire("1u4q7");

var $bFU4G = parcelRequire("bFU4G");
function $a3e67858f0c2f8da$export$f02972da195a43bb(marks, timingConfigs) {
    const bm3Timings = {};
    if (!marks || !timingConfigs) return bm3Timings;
    timingConfigs.forEach((item)=>{
        if (!item.startMark || !item.endMark) return;
        const startTime = marks[item.startMark];
        if (!startTime) return;
        const endTime = marks[item.endMark];
        if (!endTime) return;
        bm3Timings[item.key] = {
            startTime: startTime,
            endTime: endTime
        };
    });
    return bm3Timings;
}
function $a3e67858f0c2f8da$export$30f0b5e5acd268bf({ marks: marks, timings: timings }) {
    const interactionContext = (0, $5uXOq.useContext)((0, $1tcYS.default));
    const interactionId = (0, $1u4q7.getInteractionId)().current;
    (0, $5uXOq.useMemo)(()=>{
        if (interactionContext != null && interactionId != null && marks != null && timings != null) {
            const interactionType = (0, $bFU4G.getCurrentInteractionType)(interactionId);
            if (interactionType === 'press') return;
            const bm3Timings = $a3e67858f0c2f8da$export$f02972da195a43bb(marks, timings);
            interactionContext.addCustomTimings(bm3Timings);
        }
    }, [
        interactionContext,
        interactionId,
        marks,
        timings
    ]);
    return null;
}
function $a3e67858f0c2f8da$export$d93d677ef2f33c5c(marks, timingsConfig) {
    const interactionId = (0, $1u4q7.getInteractionId)().current;
    if (interactionId) {
        const interactionType = (0, $bFU4G.getCurrentInteractionType)(interactionId);
        if (interactionType === 'press') return;
        const bm3Timings = $a3e67858f0c2f8da$export$f02972da195a43bb(marks, timingsConfig);
        (0, $bFU4G.addCustomTiming)(interactionId, [], bm3Timings);
    }
}

});

parcelRegister("6G6w0", function(module, exports) {

$parcel$export(module.exports, "StopBrowserMetrics3", () => $84d0d168ebb35c8a$export$575e93c0f9905999);

var $5uXOq = parcelRequire("5uXOq");

var $1tcYS = parcelRequire("1tcYS");

var $21pfT = parcelRequire("21pfT");

var $x9xyg = parcelRequire("x9xyg");

var $7N30e = parcelRequire("7N30e");

var $4dRjY = parcelRequire("4dRjY");

var $2SVPM = parcelRequire("2SVPM");

var $6b6Tk = parcelRequire("6b6Tk");

const $84d0d168ebb35c8a$var$emitMetrics = (metric, customData, stopTime)=>{
    (0, $2SVPM.setInitialPageLoadTimingFromPerformanceMarks)('batch-js-heritage.eval', 'jira.heritage_batch_file_eval:start', 'jira.heritage_batch_file_eval:end');
    if (stopTime !== undefined) metric.stop({
        customData: customData,
        stopTime: stopTime
    });
    else metric.stop({
        customData: customData
    });
    if ((0, $6b6Tk.isAutomaticExposureCollectionEnabled)()) (0, $7N30e.stopLowPriorityEventDelay)();
};
class $84d0d168ebb35c8a$export$575e93c0f9905999 extends (0, $5uXOq.Component) {
    componentDidMount() {
        const { metric: metric, customData: customData, emitOnAnimationFrame: emitOnAnimationFrame } = this.props;
        if (!metric) return;
        const start = (0, $21pfT.browserMetrics).getPageLoadMetric()?.getData()?.start || 0;
        (0, $x9xyg.setMark)('BROWSER_METRICS_TTI_START', {
            startTime: start
        });
        (0, $x9xyg.setMark)('BROWSER_METRICS_TTI_END');
        (0, $x9xyg.setMeasure)('BROWSER_METRICS_TTI', 'BROWSER_METRICS_TTI_START', 'BROWSER_METRICS_TTI_END');
        const bm3Data = metric.getData();
        if (emitOnAnimationFrame) {
            const stopTime = performance.now();
            (0, $2SVPM.stopInitialPageLoadTimingFromPerformanceMarkStart)('product', (0, $4dRjY.PRODUCT_START_MARK), true);
            if (bm3Data) this.context?.addApdex({
                key: bm3Data.key,
                startTime: bm3Data.start,
                stopTime: stopTime
            });
            if (typeof queueMicrotask !== 'undefined') queueMicrotask(()=>{
                (0, $x9xyg.setMark)('BROWSER_METRICS_TTI_TASK_END');
                (0, $x9xyg.setMeasure)('BROWSER_METRICS_TTI_TASK', 'BROWSER_METRICS_TTI_START', 'BROWSER_METRICS_TTI_TASK_END');
            });
            requestAnimationFrame(()=>{
                metric.mark((0, $ce556f125dee8174$export$99c08ec92759c71c));
                (0, $x9xyg.setMark)((0, $ce556f125dee8174$export$99c08ec92759c71c));
                (0, $x9xyg.setMeasure)('BROWSER_METRICS_TTI_RAF', 'BROWSER_METRICS_TTI_START', (0, $ce556f125dee8174$export$99c08ec92759c71c));
                setTimeout(()=>{
                    $84d0d168ebb35c8a$var$emitMetrics(metric, customData, stopTime);
                }, 500);
            });
        } else {
            if (bm3Data) this.context?.addApdex({
                key: bm3Data.key,
                startTime: bm3Data.start,
                stopTime: performance.now()
            });
            (0, $2SVPM.stopInitialPageLoadTimingFromPerformanceMarkStart)('product', (0, $4dRjY.PRODUCT_START_MARK), true);
            $84d0d168ebb35c8a$var$emitMetrics(metric, customData);
        }
    }
    static{
        this.contextType = (0, $1tcYS.default);
    }
    render() {
        return null;
    }
}

});
parcelRegister("4dRjY", function(module, exports) {

$parcel$export(module.exports, "PRODUCT_START_MARK", () => $9953c23a4f71adac$export$8e54fca0a680fdfd);
$parcel$export(module.exports, "MarkProductStart", () => $9953c23a4f71adac$export$2a999c5f84501025);

var $x9xyg = parcelRequire("x9xyg");
const $9953c23a4f71adac$export$8e54fca0a680fdfd = 'PRODUCT_START';
const $9953c23a4f71adac$export$2a999c5f84501025 = ()=>{
    if (!false) {
        performance.clearMarks($9953c23a4f71adac$export$8e54fca0a680fdfd);
        (0, $x9xyg.setMark)($9953c23a4f71adac$export$8e54fca0a680fdfd);
    }
    return null;
};

});

const $ce556f125dee8174$export$56940a9488e85199 = 'jira.fe.spa-';
const $ce556f125dee8174$export$45c4b6bf7935c69a = `${$ce556f125dee8174$export$56940a9488e85199}start`;
const $ce556f125dee8174$export$135c96ab5afee429 = 'ssr.spa.rendered';
const $ce556f125dee8174$export$ff834eccc35b9089 = 'appBundleReady';
const $ce556f125dee8174$export$86b05e34d462ead8 = 'prefetchApiReady';
const $ce556f125dee8174$export$d6a604a7d9a390fb = 'prefetchApiStart';
const $ce556f125dee8174$export$3ae43cc1782d058f = 'jswRenderStart';
const $ce556f125dee8174$export$363f6703ffa600be = 'jswCreateReduxStoreStart';
const $ce556f125dee8174$export$e87b74567b79c8 = 'jswCreateReduxStoreEnd';
const $ce556f125dee8174$export$99fe642459a8b02 = 'jswTransformCriticalDataStart';
const $ce556f125dee8174$export$ab1f5705fc8e0571 = 'jswTransformCriticalDataEnd';
const $ce556f125dee8174$export$8c3a9046da692c35 = 'jswReduxSoftwareAppLoadedStart';
const $ce556f125dee8174$export$5aa497d1efdcc5bf = 'jswReduxSoftwareAppLoadedEnd';
const $ce556f125dee8174$export$99c08ec92759c71c = 'tti-raf-mark';
const $ce556f125dee8174$export$48552baa9db8ce1d = 'tti-raf';


parcelRegister("3wLoG", function(module, exports) {

$parcel$export(module.exports, "StopUfo", () => $bc9c50f4292c4530$export$d91154f099475c5);

var $5uXOq = parcelRequire("5uXOq");

var $1tcYS = parcelRequire("1tcYS");

var $1AZST = parcelRequire("1AZST");
class $bc9c50f4292c4530$export$d91154f099475c5 extends (0, $5uXOq.Component) {
    componentDidMount() {
        const { customData: customData, appName: appName } = this.props;
        (0, $1AZST.GlobalPageLoadExperience).success({
            force: true,
            metadata: customData
        });
        const name = appName || (0, $1AZST.GlobalPageLoadExperience).loadingPageLoadId;
        if (name) this.context?.addApdex({
            key: name,
            stopTime: performance.now()
        });
    }
    static{
        this.contextType = (0, $1tcYS.default);
    }
    render() {
        return null;
    }
}

});

parcelRegister("gtdbK", function(module, exports) {

$parcel$export(module.exports, "addBM3SSRDoneAsFMPToInteraction", () => $9088c71f7c9189f4$export$bf239ac2bfb04967);

var $1u4q7 = parcelRequire("1u4q7");

var $bFU4G = parcelRequire("bFU4G");
function $9088c71f7c9189f4$export$bf239ac2bfb04967(metric) {
    const interactionId = (0, $1u4q7.getInteractionId)();
    const currentInteractionId = interactionId.current;
    if (!currentInteractionId) return;
    const data = metric.getData();
    // Use BM3 SSR mark as FMP config for UFO if it exists, temporarily.
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const config = data?.config;
    if (config && data?.isInitial) (0, $bFU4G.addMetadata)(currentInteractionId, {
        __legacy__bm3ConfigSSRDoneAsFmp: config.ssr?.doneAsFmp || false
    });
}

});

parcelRegister("zbAs4", function(module, exports) {

$parcel$export(module.exports, "addUFOSSRDoneAsFMPToInteraction", () => $30d390cd1767d57f$export$e63862cd888fe05a);

var $1u4q7 = parcelRequire("1u4q7");

var $bFU4G = parcelRequire("bFU4G");

var $1AZST = parcelRequire("1AZST");
var $49z18 = parcelRequire("49z18");
async function $30d390cd1767d57f$export$e63862cd888fe05a() {
    const interactionId = (0, $1u4q7.getInteractionId)();
    const currentInteractionId = interactionId.current;
    if (!currentInteractionId) return;
    // Use UFO SSR mark as FMP config for rUFO if it exists, temporarily.
    const data = await (0, $1AZST.GlobalPageLoadExperience).exportData();
    const fmpMark = data.metrics.marks.find((mark)=>mark.name === 'fmp') || (0, $49z18.payloadPublisher).ssr?.getDoneMark();
    if (data.initial && fmpMark) (0, $bFU4G.addMetadata)(currentInteractionId, {
        __legacy__ufoConfigSSRDoneAsFmp: true
    });
}

});

parcelRegister("3B7oW", function(module, exports) {

$parcel$export(module.exports, "trackBM3FeatureFlagsAccessed", () => $afa764d83f81f55e$export$f00f1e874ce869e9);

var $1u4q7 = parcelRequire("1u4q7");

var $y7eb2 = parcelRequire("y7eb2");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $afa764d83f81f55e$var$startsAsObject = (value)=>{
    try {
        if (value.charAt(0) === '{') return true;
    } catch (e) {
        return false;
    }
    return false;
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $afa764d83f81f55e$var$isObject = (value)=>value && typeof value === 'object' && value.constructor === Object;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $afa764d83f81f55e$var$isString = (input)=>{
    let result;
    try {
        result = typeof input === 'string' || input instanceof String;
    } catch (err) {
        // swallow any errors
        result = false;
    }
    return result;
};
const $afa764d83f81f55e$export$7b4abba432e57989 = (value)=>$afa764d83f81f55e$var$isString(value) && $afa764d83f81f55e$var$startsAsObject(value) || $afa764d83f81f55e$var$isObject(value);
const $afa764d83f81f55e$export$fcc03ee4c944962f = (featureFlagValue)=>$afa764d83f81f55e$export$7b4abba432e57989(featureFlagValue) ? 'non_boolean' : featureFlagValue;
const $afa764d83f81f55e$export$d2818866b4acbea4 = new Map();
const $afa764d83f81f55e$export$f00f1e874ce869e9 = (metric)=>{
    const interactionId = (0, $1u4q7.getInteractionId)();
    const currentInteractionId = interactionId.current;
    if (!currentInteractionId) return;
    const data = metric.getData();
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const config = data?.config;
    if (config && config?.featureFlags?.length) {
        const allFeatureFlags = (0, $y7eb2.default)();
        config.featureFlags.forEach((featureFlagName)=>{
            const value = allFeatureFlags[featureFlagName];
            if (value === undefined) return;
            const featureFlagValue = $afa764d83f81f55e$export$fcc03ee4c944962f(value);
            $afa764d83f81f55e$export$d2818866b4acbea4.set(featureFlagName, featureFlagValue);
        });
    }
};

});


parcelRegister("7DbgJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $709f870a3eb06979$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $2YZCu = parcelRequire("2YZCu");

var $01Rn4 = parcelRequire("01Rn4");

var $eusud = parcelRequire("eusud");
const $709f870a3eb06979$export$fa156a01818e3239 = (baseUrl, projectKey)=>(0, $eusud.performPostRequest)(`${baseUrl}/rest/internal/2/project/${projectKey}/recent`).catch((e)=>{
        (0, $2YZCu.default).safeErrorWithoutCustomerData('spa-apps.common.src.add-project-to-history', 'Cannot set recent project', e);
    });
const $709f870a3eb06979$var$AddProjectToHistory = ({ baseUrl: baseUrl, projectKey: projectKey })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $01Rn4.default), {
        op: ()=>$709f870a3eb06979$export$fa156a01818e3239(baseUrl, projectKey)
    });
var $709f870a3eb06979$export$2e2bcd8739ae039 = $709f870a3eb06979$var$AddProjectToHistory;

});

parcelRegister("5pkMH", function(module, exports) {

$parcel$export(module.exports, "pagesOverrideStyles", () => $843234ea267432ba$export$2111df1c5b105054);

var $6cG4N = parcelRequire("6cG4N");

var $dCm1o = parcelRequire("dCm1o");
const $843234ea267432ba$export$2111df1c5b105054 = ({ name: name, type: type })=>({
        name: name,
        type: type,
        background: {
            color: 'inherit'
        },
        color: {
            primary: (0, $6cG4N.Tokens).COLOR_TEXT
        },
        navigation: {
            icon: {
                textColor: (0, $6cG4N.Tokens).COLOR_TEXT,
                color: (0, $6cG4N.Tokens).COLOR_TEXT,
                gradientStart: (0, $6cG4N.Tokens).COLOR_TEXT,
                gradientStop: (0, $6cG4N.Tokens).COLOR_TEXT_SUBTLE
            }
        },
        overrideStyles: {
            mainContainer: {
                backgroundColor: "var(--ds-surface, #FFFFFF)",
                color: "var(--ds-text, #172B4D)",
                borderRadius: '8px',
                padding: "var(--ds-space-150, 12px)"
            },
            pageHeader: {
                wrapper: {
                    backgroundColor: (0, $6cG4N.Tokens).ELEVATION_SURFACE_CONTRAST,
                    padding: `0 ${"var(--ds-space-200, 16px)"}`,
                    margin: `${"var(--ds-space-300, 24px)"} 0 ${"var(--ds-space-150, 12px)"} 0`,
                    borderRadius: "var(--ds-border-radius-200, 8px)"
                }
            },
            pageTitleStyleWrapper: {
                color: (0, $6cG4N.Tokens).COLOR_TEXT,
                // The API expects a number here
                marginTop: 2,
                outline: 'none',
                font: "var(--ds-font-heading-large, normal 500 24px/28px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
            },
            tableTreeWrapper: {
                borderRadius: "var(--ds-border-radius-200, 8px)"
            },
            poweredBy: {
                color: (0, $6cG4N.Tokens).COLOR_TEXT
            },
            contentWrapper: {
                padding: '0'
            },
            sidebarWrapper: {
                backgroundColor: "var(--ds-surface, #FFFFFF)",
                border: 'none',
                borderRadius: `${// eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage -- The token value "4px" and fallback "6px" do not match and can't be replaced automatically.
                "var(--ds-border-radius-100, 6px)"} ${"var(--ds-border-radius-200, 8px)"} 0 0`,
                boxShadow: "var(--ds-shadow-overlay, 0px 8px 12px #091E4226, 0px 0px 1px #091E424f)",
                height: 'auto',
                margin: `${(0, $dCm1o.isVisualRefreshEnabled)() ? `${"var(--ds-space-250, 20px)"} 0 0` : `${"var(--ds-space-200, 16px)"} 0 0`} `,
                padding: `${"var(--ds-space-100, 8px)"} ${"var(--ds-space-250, 20px)"}`
            },
            viewContainer: {
                padding: '0'
            }
        }
    });

});

parcelRegister("4BJ24", function(module, exports) {

$parcel$export(module.exports, "projectPagesPageLoad", () => $81ca6e5116ae4a8d$export$1874d1120998dfa4);

var $dGrdR = parcelRequire("dGrdR");
const $81ca6e5116ae4a8d$export$1874d1120998dfa4 = (0, $dGrdR.metrics).pageLoad({
    key: 'project-pages',
    ssr: {
        doneAsFmp: true
    }
});

});





//# sourceMappingURL=async-project-pages.1c5483d4.js.map
